/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 87287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ dateServiceAdapter)
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77689);
/* harmony import */ var _yandex_langly_shared_src_timezones_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30332);




const dateServiceAdapter = {
  formatDateForBackend(date) {
    const dateInUTC = (0,_yandex_langly_shared_src_timezones_utils__WEBPACK_IMPORTED_MODULE_0__/* .convertLocalToUTC */ .K0)(date);
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(dateInUTC, "yyyy-MM-dd HH:mm:ss");
  }
};

/***/ }),

/***/ 13162:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ syllabusApi)
/* harmony export */ });
/* harmony import */ var _api_events_events_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53536);
/* harmony import */ var _api_student_student_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91514);
/* harmony import */ var _api_student_syllabus_syllabus_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19905);





const syllabusApi = {
  getSyllabus: _api_student_syllabus_syllabus_api__WEBPACK_IMPORTED_MODULE_2__/* .getStudentSyllabus */ .S9,
  sendEvent: _api_events_events_api__WEBPACK_IMPORTED_MODULE_0__/* .postSyllabusEvent */ .R3,
  getSyllabusNodeAttributes: _api_student_syllabus_syllabus_api__WEBPACK_IMPORTED_MODULE_2__/* .getSyllabusNode */ .l_,
  setSyllabusNodeAttributes: _ref => {
    let {
      syllabusNodeId,
      isFavorite
    } = _ref;
    return (0,_api_student_student_api__WEBPACK_IMPORTED_MODULE_1__/* .setSyllabusNodeAttributes */ .ej)(syllabusNodeId, isFavorite);
  }
};

/***/ }),

/***/ 77137:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: () => (/* binding */ useUserStorage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_model_product_product_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55681);
/* harmony import */ var _hooks_user_useUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87029);





const useUserStorage = () => {
  const user = (0,_hooks_user_useUser__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    onboardingFSM: user.data?.product?.onboarding?.fsm?.states ?? null,
    currentProductId: user.data?.product?.id ? (0,_yandex_langly_shared_src_model_product_product_model__WEBPACK_IMPORTED_MODULE_1__/* .makeProductId */ .Hd)(user.data.product.id) : null,
    user: user.data?.me.user,
    weekSchedule: user.data?.attributes.weekSchedule ?? [],
    currentBusinessProductId: user.data?.product?.businessId ?? null,
    speakingTypeId: user.data?.product?.speakingTypeId ?? null
  }), [user.data?.attributes.weekSchedule, user.data?.me.user, user.data?.product?.businessId, user.data?.product?.id, user.data?.product?.onboarding?.fsm?.states, user.data?.product?.speakingTypeId]);
};

/***/ }),

/***/ 11568:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ http),
/* harmony export */   h: () => (/* binding */ enumCodec)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87412);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87830);
/* harmony import */ var _yandex_langly_shared_src_utils_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9091);
/* harmony import */ var _utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64866);







const http = async function (url) {
  let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
  let requestBody = arguments.length > 2 ? arguments[2] : undefined;
  const result = await (0,_yandex_langly_shared_src_utils_http__WEBPACK_IMPORTED_MODULE_1__/* .makeRequest */ .$f)(url, {
    method,
    responseType: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_2__/* .asType */ .fr)(),
    body: requestBody
  });
  if ((0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__.isLeft)(result)) {
    throw new Error("httpAdapter isLeft");
  }
  return result.right;
};
const enumCodec = e => new io_ts__WEBPACK_IMPORTED_MODULE_4__.Type("enum", input => Object.values(e).includes(input), (input, context) => Object.values(e).includes(input) ? io_ts__WEBPACK_IMPORTED_MODULE_4__.success(input) : io_ts__WEBPACK_IMPORTED_MODULE_4__.failure(input, context), io_ts__WEBPACK_IMPORTED_MODULE_4__.identity);

/***/ }),

/***/ 43168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Aq: () => (/* binding */ getAboutChapter),
  Q5: () => (/* binding */ getAppRevisionVersion),
  x_: () => (/* binding */ getAutoTutorChangePopupContent),
  j_: () => (/* binding */ getBusinessProductsFeatureFlags),
  Nb: () => (/* binding */ getConversionLevelsMatch),
  QE: () => (/* binding */ getConversionTrialIdsTemp),
  xe: () => (/* binding */ getCourseMap),
  k0: () => (/* binding */ getCustDevTrainerData),
  Sj: () => (/* binding */ getExternalUrls),
  WN: () => (/* binding */ getGeneralEnglish),
  l4: () => (/* binding */ getGeneralInGus),
  Ey: () => (/* binding */ getGiftProducts),
  O: () => (/* binding */ getGrammarGuides),
  Zw: () => (/* binding */ getGrammarReferences),
  Yv: () => (/* binding */ getOnboardingChapterState),
  W0: () => (/* binding */ getPaymentLanding),
  r: () => (/* binding */ getPrementorChapterState),
  Xc: () => (/* binding */ getPrespeakingChapterState),
  J1: () => (/* binding */ getPromoTrainerData),
  gm: () => (/* binding */ getReferralProgramContent),
  ob: () => (/* binding */ getStudentRescheduleLessonSurvey)
});

// UNUSED EXPORTS: getBeginnerOnboardingQuestions, getBeginnersMarkup, getCuratorFunnel, getOnboardingLevels, getPaymentPageData

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/immutable/dist/immutable.es.js
var immutable_es = __webpack_require__(27623);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../../node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(37164);
// EXTERNAL MODULE: ../shared/src/api/bunker/bunker.raw-model.ts
var bunker_raw_model = __webpack_require__(22554);
// EXTERNAL MODULE: ../shared/src/domain/domain.ts
var domain = __webpack_require__(72765);
// EXTERNAL MODULE: ../shared/src/entities/product/index.ts + 2 modules
var product = __webpack_require__(12888);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var utils_http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/api/api.utils.ts
var api_utils = __webpack_require__(11568);
// EXTERNAL MODULE: ./src/api/trainer/trainer.model.ts
var trainer_model = __webpack_require__(98938);
// EXTERNAL MODULE: ./src/api/bunker/bunker.model.ts
var bunker_model = __webpack_require__(71223);
;// CONCATENATED MODULE: ./src/api/bunker/bunker.raw-model.ts



const bunker_raw_model_RawGetBeginnerMarkup = es6.type({
  tutor: es6.union([es6["null"], es6.type({
    avatar: es6.union([es6["null"], es6.string]),
    firstName: es6.string,
    lastName: es6.string
  })]),
  available_content: es6.array(es6.string),
  speaking_session_link: es6.union([es6["null"], es6.string])
});
const RawCourses = es6.array(es6.type({
  id: es6.string,
  title: es6.string,
  order_priority: es6.union([es6["null"], es6.number])
}));
const RawRevisionVersion = es6.type({
  version: es6.string,
  build: es6.number
});
const RawCourseMapModule = es6.type({
  title: es6.string,
  description: es6.string,
  grammar: es6.array(es6.string),
  lexis: es6.array(es6.string)
});
const RawCourseMap = es6.type({
  id: es6.string,
  title: es6.string,
  description: es6.string,
  color: es6.string,
  modules: es6.array(RawCourseMapModule)
});
const RawStudentRescheduleLessonSurvey = es6.type({
  title: es6.string,
  variants: es6.array(es6.string)
});
const RawStudentRescheduleLessonSurveys = es6.type({
  reschedule: RawStudentRescheduleLessonSurvey,
  remove: RawStudentRescheduleLessonSurvey
});
const RawExternalUrlsResponse = es6.type({
  default: es6.record(es6.string, es6.string),
  kz: es6.record(es6.string, es6.string)
});
const RawSubreason = es6.type({
  id: es6.string,
  text: es6.string
});
const RawSubreasons = es6.array(RawSubreason);
const RawAutoTutorChangePopupContent = es6.type({
  title: es6.string,
  reasons: RawSubreasons,
  comment: es6.string
});
const RawTariffContent = es6.type({
  pageTitle: es6.string,
  steps: es6.array(es6.string),
  sharingMessage: es6.string
});
const RawReferralProgramContent = es6.record(es6.string, RawTariffContent);
// EXTERNAL MODULE: ./src/api/bunker/bunker.urls.ts
var bunker_urls = __webpack_require__(63608);
;// CONCATENATED MODULE: ./src/api/bunker/bunker.api.ts
























const getOnboardingChapterState = () => (0,api_utils/* http */.d)(bunker_urls/* GET_ONBOARDING */.Et, "GET");
const getPaymentPageData = () => http(GET_PAYMENT_PAGE_DATA, "GET");
const getConversionLevelsMatch = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_CONVERSION_LEVELS_MATCH */.Dr, {
  responseType: bunker_model/* ConversionLevelsMatch */.MW
});
const getPromoTrainerData = id => (0,utils_http/* makeRequest */.$f)((0,bunker_urls/* GET_PROMO_TRAINER */.NQ)(id), {
  responseType: trainer_model/* Activity */.cS
});
const getCustDevTrainerData = (levelId, chapterId) => (0,utils_http/* makeRequest */.$f)((0,bunker_urls/* GET_CUSTDEV_TRAINER_DATA */.SB)(levelId, chapterId), {
  responseType: es6.array(trainer_model/* Activity */.cS),
  resultMapper(rawResponse) {
    return {
      activities: rawResponse.map(activity => ({
        ...activity,
        activity_id: activity?.activity_id || activity?.id || (0,index_browser/* nanoid */.x0)(),
        blocks: activity.blocks.map(b => ({
          ...b,
          id: b.id ? b.id : (0,index_browser/* nanoid */.x0)()
        }))
      })),
      settings: {
        showSkipButton: rawResponse.some(activity => activity.meta?.["show-skip-button"])
      },
      chapterStudentEvents: {},
      completeBlocksIdSet: immutable_es/* Set */.l4(),
      isSpeakingUnscheduled: false,
      isFinalEventExist: false,
      title: ""
    };
  }
});
const getPrespeakingChapterState = () => (0,api_utils/* http */.d)(bunker_urls/* GET_PRE_SPEAKING */.cG, "GET");
const getPrementorChapterState = () => (0,api_utils/* http */.d)(bunker_urls/* GET_PRE_MENTOR */.dO, "GET");
const getAboutChapter = () => (0,api_utils/* http */.d)(bunker_urls/* GET_ABOUT */.D9, "GET");
const getOnboardingLevels = async redefineLevels => {
  const response = await http(GET_ONBOARDING_LEVELS, "GET");
  response.levels.forEach(level => {
    const redefined = redefineLevels.get(level.id);
    if (redefined !== void 0) {
      level.id = redefined;
    }
  });
  return response;
};
const getConversionTrialIdsTemp = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_CONVERSION_TRIAL_IDS_TEMP */.Pr, {
  responseType: bunker_model/* GetConversionTrialIdsTempResponse */.cH
});
const getGrammarReferences = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_GRAMMAR_REFERENCES */.EY, {
  responseType: bunker_model/* GetGrammarReferencesResponseRaw */.cz
});
const getPaymentLanding = id => (0,utils_http/* makeRequest */.$f)((0,bunker_urls/* GET_PAYMENT_LANDING */.VI)(id), {
  responseType: bunker_model/* GetPaymentLandingResponseRaw */.v$,
  resultMapper(rawResponse) {
    return {
      tabs: rawResponse.tabs,
      settings: {
        isCloseButton: rawResponse.settings?.isCloseButton ?? true,
        isAvatar: rawResponse.settings?.isAvatar ?? false,
        isSupportChat: rawResponse.settings?.isSupportChat ?? false,
        isCourseSelectButton: rawResponse.settings?.isCourseSelectButton ?? false
      }
    };
  }
});
const getBeginnersMarkup = studentId => makeRequest(GET_BEGINNER_MARKUP(studentId), {
  responseType: RawGetBeginnerMarkup,
  resultMapper(rawResponse) {
    return {
      tutor: rawResponse.tutor ? {
        firstName: rawResponse.tutor.firstName,
        lastName: rawResponse.tutor.lastName,
        avatar: rawResponse.tutor.avatar ?? ""
      } : void 0,
      speakingSessionLink: rawResponse.speaking_session_link ?? void 0,
      availableContent: rawResponse.available_content
    };
  }
});
const getGrammarGuides = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_GRAMMAR_GUIDES */.YB, {
  responseType: bunker_model/* GetGrammarGuidesResponseRaw */.gO
});
const getGiftProducts = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GIFT_PRODUCTS */.Ws, {
  responseType: bunker_model/* GiftProducts */.hh
});
const getCuratorFunnel = () => makeRequest(GET_CURATOR_FUNNEL, {
  responseType: CuratorFunnel
});
const getBeginnerOnboardingQuestions = () => makeRequest(GET_BEGINNER_ONBOARDING_QUESTIONS, {
  responseType: BeginnerOnboardingQuestions,
  resultMapper(rawResponse) {
    return rawResponse.map(item => ({
      title: item.title,
      description: kz(item.description)
    }));
  }
});
const getGeneralEnglish = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_GENERAL_ENGLISH */.G2, {
  responseType: RawCourses
});
const getGeneralInGus = (0,un_either/* unEither */.K)(() => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_GENERAL_IN_GUS */.Iu, {
  responseType: RawCourses
}));
const getAppRevisionVersion = (0,un_either/* unEither */.K)(() => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_APP_REVISION_VERSION */.WJ, {
  responseType: RawRevisionVersion
}));
const getCourseMap = (0,un_either/* unEither */.K)(level => (0,utils_http/* makeRequest */.$f)((0,bunker_urls/* GET_COURSE_MAP */.qA)(level), {
  responseType: RawCourseMap
}));
const getStudentRescheduleLessonSurvey = (0,un_either/* unEither */.K)(async () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_STUDENT_RESCHEDULE_LESSON_SURVEY */.mE, {
  responseType: RawStudentRescheduleLessonSurveys
}));
const getBusinessProductsFeatureFlags = () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_BUSINESS_PRODUCTS_FEATURE_FLAGS */.qB, {
  responseType: bunker_raw_model/* businessProductsFeatureFlagsResponse */.ar,
  resultMapper: response => Object.keys(response).reduce((acc, businessId) => {
    const businessProduct = (0,product/* mapRawBusinessId */.r)(businessId);
    acc[businessProduct] = response[businessId];
    return acc;
  }, {})
});
const getExternalUrls = (0,un_either/* unEither */.K)(() => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_EXTERNAL_URLS */.b_, {
  responseType: RawExternalUrlsResponse
}));
const getAutoTutorChangePopupContent = (0,un_either/* unEither */.K)(async () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_AUTO_TUTOR_CHANGE_POPUP_CONTENT */.lB, {
  responseType: RawAutoTutorChangePopupContent
}));
const getReferralProgramContent = (0,un_either/* unEither */.K)(async () => (0,utils_http/* makeRequest */.$f)(bunker_urls/* GET_REFERRAL_PROGRAM_CONTENT */.GK, {
  responseType: RawReferralProgramContent
}));

/***/ }),

/***/ 71223:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Fd: () => (/* binding */ LandingBlocksType),
/* harmony export */   MW: () => (/* binding */ ConversionLevelsMatch),
/* harmony export */   b6: () => (/* binding */ LandingBlockConditionTypes),
/* harmony export */   cH: () => (/* binding */ GetConversionTrialIdsTempResponse),
/* harmony export */   cz: () => (/* binding */ GetGrammarReferencesResponseRaw),
/* harmony export */   gO: () => (/* binding */ GetGrammarGuidesResponseRaw),
/* harmony export */   hh: () => (/* binding */ GiftProducts),
/* harmony export */   ps: () => (/* binding */ BgColors),
/* harmony export */   v$: () => (/* binding */ GetPaymentLandingResponseRaw)
/* harmony export */ });
/* unused harmony exports priceBlocks, infoBlocks, advantagesBlocks, faqQuestions, CourseIntro, PackageIntro, ImageBlock, AboutBlock, AboutExtraBlock, TextBlock, AdvantagesBlock, FaqBlock, YandexFormBlock, LandingBlockConditions, LandingBlocks, LandingTab, CuratorFunnel, BeginnerOnboardingQuestion, BeginnerOnboardingQuestions */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87830);
/* harmony import */ var _utils_conversionsMetrics_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46760);
/* harmony import */ var _utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64866);
/* harmony import */ var _student_student_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85715);






const ConversionLevelsMatch = io_ts__WEBPACK_IMPORTED_MODULE_3__.record(io_ts__WEBPACK_IMPORTED_MODULE_3__.string, (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .stringEnum */ .b)(_utils_conversionsMetrics_model__WEBPACK_IMPORTED_MODULE_0__/* .ConversionMetricsLevels */ .M));
const GetConversionTrialIdsTempResponse = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  trialChapters: io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.string),
  trialSpeakingsToLevel: io_ts__WEBPACK_IMPORTED_MODULE_3__.record(io_ts__WEBPACK_IMPORTED_MODULE_3__.string, io_ts__WEBPACK_IMPORTED_MODULE_3__.string)
});
const RawGrammarReference = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  text: io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.string)
});
const GetGrammarReferencesResponseRaw = io_ts__WEBPACK_IMPORTED_MODULE_3__.record(io_ts__WEBPACK_IMPORTED_MODULE_3__.string, RawGrammarReference);
var LandingBlocksType = /* @__PURE__ */(LandingBlocksType2 => {
  LandingBlocksType2["CourseIntro"] = "course-intro";
  LandingBlocksType2["PackageIntro"] = "package-intro";
  LandingBlocksType2["ImageBlock"] = "image-block";
  LandingBlocksType2["AboutBlock"] = "about-block";
  LandingBlocksType2["AboutExtraBlock"] = "about-extra-block";
  LandingBlocksType2["TextBlock"] = "text-block";
  LandingBlocksType2["AdvantagesBlock"] = "advantages-block";
  LandingBlocksType2["FaqBlock"] = "faq-block";
  LandingBlocksType2["YandexForm"] = "yandex-form";
  return LandingBlocksType2;
})(LandingBlocksType || {});
var BgColors = /* @__PURE__ */(BgColors2 => {
  BgColors2["White"] = "white";
  BgColors2["LightGrey"] = "lightGray";
  BgColors2["MediumGrey"] = "mediumGray";
  return BgColors2;
})(BgColors || {});
var LandingBlockConditionTypes = /* @__PURE__ */(LandingBlockConditionTypes2 => {
  LandingBlockConditionTypes2["Experiment"] = "experiment";
  return LandingBlockConditionTypes2;
})(LandingBlockConditionTypes || {});
const PriceBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  price: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  discountPrice: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
}), io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
  blockType: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  buttonText: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  buttonSrc: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  calculatePrice: io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
    productId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
    plusDiscount: io_ts__WEBPACK_IMPORTED_MODULE_3__.number,
    price: io_ts__WEBPACK_IMPORTED_MODULE_3__.number
  }),
  postfix: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  text: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  productId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  parentProductId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
})]);
const priceBlocks = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(PriceBlock);
const stringOrArrayOfString = io_ts__WEBPACK_IMPORTED_MODULE_3__.union([io_ts__WEBPACK_IMPORTED_MODULE_3__.string, io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.string)]);
const infoBlocks = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  content: stringOrArrayOfString,
  description: stringOrArrayOfString
}));
const advantagesBlocks = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  advantage: stringOrArrayOfString,
  description: stringOrArrayOfString
}));
const faqQuestions = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  question: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  answer: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
}));
const CourseIntro = io_ts__WEBPACK_IMPORTED_MODULE_3__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("course-intro" /* CourseIntro */),
  title: stringOrArrayOfString,
  subtitle: stringOrArrayOfString,
  text: stringOrArrayOfString,
  priceBlocks
}), io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
  bgColor: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .stringEnum */ .b)(BgColors)
})]);
const PackageIntro = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("package-intro" /* PackageIntro */),
  introText: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  title: stringOrArrayOfString,
  text1: stringOrArrayOfString,
  subtitle: stringOrArrayOfString,
  text2: stringOrArrayOfString,
  imageSrc: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  priceBlocks
});
const ImageBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("image-block" /* ImageBlock */),
  title: stringOrArrayOfString,
  subtitle: stringOrArrayOfString,
  imageSrc: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
});
const AboutBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("about-block" /* AboutBlock */),
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  titlePink: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  imageSrc: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  subtitle: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  infoBlocks
}), io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
  bgColor: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .stringEnum */ .b)(BgColors)
})]);
const AboutExtraBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("about-extra-block" /* AboutExtraBlock */),
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  imageSrc: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  additionText: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  content: io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.string)
});
const TextBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("text-block" /* TextBlock */),
  title: stringOrArrayOfString,
  text1: stringOrArrayOfString,
  text2: stringOrArrayOfString,
  bgColor: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .stringEnum */ .b)(BgColors),
  isBottomSeparator: io_ts__WEBPACK_IMPORTED_MODULE_3__.boolean
});
const AdvantagesBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("advantages-block" /* AdvantagesBlock */),
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  advantagesBlocks
});
const FaqBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("faq-block" /* FaqBlock */),
  faqQuestions
});
const YandexFormBlock = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("yandex-form" /* YandexForm */),
  yandexFormId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  width: io_ts__WEBPACK_IMPORTED_MODULE_3__.number,
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  subtitle: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  textDirection: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
});
const LandingBlockConditions = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_3__.literal("experiment" /* Experiment */),
  experimentId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
}));
const LandingBlocks = io_ts__WEBPACK_IMPORTED_MODULE_3__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_3__.union([CourseIntro, PackageIntro, ImageBlock, AboutBlock, AboutExtraBlock, TextBlock, AdvantagesBlock, FaqBlock, YandexFormBlock]), io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
  conditions: LandingBlockConditions
})]);
const LandingTab = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  blocks: io_ts__WEBPACK_IMPORTED_MODULE_3__.array(LandingBlocks)
});
const GetPaymentLandingResponseRaw = io_ts__WEBPACK_IMPORTED_MODULE_3__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  tabs: io_ts__WEBPACK_IMPORTED_MODULE_3__.array(LandingTab)
}), io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
  settings: io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
    isCloseButton: io_ts__WEBPACK_IMPORTED_MODULE_3__.boolean,
    isAvatar: io_ts__WEBPACK_IMPORTED_MODULE_3__.boolean,
    isSupportChat: io_ts__WEBPACK_IMPORTED_MODULE_3__.boolean,
    isCourseSelectButton: io_ts__WEBPACK_IMPORTED_MODULE_3__.boolean
  })
})]);
const GrammarGuide = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  productId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  chapterId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
});
const GetGrammarGuidesResponseRaw = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(GrammarGuide);
const GiftProduct = io_ts__WEBPACK_IMPORTED_MODULE_3__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_3__.union([io_ts__WEBPACK_IMPORTED_MODULE_3__.string, io_ts__WEBPACK_IMPORTED_MODULE_3__["null"]]),
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  price: io_ts__WEBPACK_IMPORTED_MODULE_3__.number,
  description: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  productType: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .stringEnum */ .b)(_student_student_model__WEBPACK_IMPORTED_MODULE_2__/* .ProductType */ .kv),
  plusDiscountPercent: io_ts__WEBPACK_IMPORTED_MODULE_3__.number
}), io_ts__WEBPACK_IMPORTED_MODULE_3__.partial({
  courseUrlName: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
})]);
const GiftProducts = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(GiftProduct);
const CuratorFunnel = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  speakingId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  currentProductId: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
});
const BeginnerOnboardingQuestion = io_ts__WEBPACK_IMPORTED_MODULE_3__.type({
  title: io_ts__WEBPACK_IMPORTED_MODULE_3__.string,
  description: io_ts__WEBPACK_IMPORTED_MODULE_3__.string
});
const BeginnerOnboardingQuestions = io_ts__WEBPACK_IMPORTED_MODULE_3__.array(BeginnerOnboardingQuestion);

/***/ }),

/***/ 63608:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D9: () => (/* binding */ GET_ABOUT),
/* harmony export */   DR: () => (/* binding */ GET_FEATURE_FLAGS),
/* harmony export */   Dr: () => (/* binding */ GET_CONVERSION_LEVELS_MATCH),
/* harmony export */   EY: () => (/* binding */ GET_GRAMMAR_REFERENCES),
/* harmony export */   Et: () => (/* binding */ GET_ONBOARDING),
/* harmony export */   Ex: () => (/* binding */ GET_FOOTER_LAYOUT),
/* harmony export */   G2: () => (/* binding */ GET_GENERAL_ENGLISH),
/* harmony export */   GK: () => (/* binding */ GET_REFERRAL_PROGRAM_CONTENT),
/* harmony export */   Iu: () => (/* binding */ GET_GENERAL_IN_GUS),
/* harmony export */   NQ: () => (/* binding */ GET_PROMO_TRAINER),
/* harmony export */   Pr: () => (/* binding */ GET_CONVERSION_TRIAL_IDS_TEMP),
/* harmony export */   SB: () => (/* binding */ GET_CUSTDEV_TRAINER_DATA),
/* harmony export */   VI: () => (/* binding */ GET_PAYMENT_LANDING),
/* harmony export */   WJ: () => (/* binding */ GET_APP_REVISION_VERSION),
/* harmony export */   Ws: () => (/* binding */ GIFT_PRODUCTS),
/* harmony export */   YB: () => (/* binding */ GET_GRAMMAR_GUIDES),
/* harmony export */   b_: () => (/* binding */ GET_EXTERNAL_URLS),
/* harmony export */   cG: () => (/* binding */ GET_PRE_SPEAKING),
/* harmony export */   dO: () => (/* binding */ GET_PRE_MENTOR),
/* harmony export */   du: () => (/* binding */ GET_EDUCATION_GOALS),
/* harmony export */   lB: () => (/* binding */ GET_AUTO_TUTOR_CHANGE_POPUP_CONTENT),
/* harmony export */   mE: () => (/* binding */ GET_STUDENT_RESCHEDULE_LESSON_SURVEY),
/* harmony export */   qA: () => (/* binding */ GET_COURSE_MAP),
/* harmony export */   qB: () => (/* binding */ GET_BUSINESS_PRODUCTS_FEATURE_FLAGS),
/* harmony export */   yr: () => (/* binding */ GET_SOCIAL)
/* harmony export */ });
/* unused harmony exports GET_PAYMENT_PAGE_DATA, GET_ONBOARDING_LEVELS, GET_BEGINNER_MARKUP, GET_CURATOR_FUNNEL, GET_BEGINNER_ONBOARDING_QUESTIONS */
/* harmony import */ var _yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24610);



const GET_FEATURE_FLAGS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/features/${"production"}&version=latest`;
const GET_EXTERNAL_URLS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/external-urls/${"production"}&version=latest`;
const GET_ONBOARDING = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/onboarding2`;
const GET_PRE_SPEAKING = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/prespeaking/${ true ? "production" : 0}`;
const GET_PRE_MENTOR = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/prementor/${ true ? "production" : 0}`;
const GET_PAYMENT_PAGE_DATA = (/* unused pure expression or super */ null && (`${getBunkerNodePath()}/flow/payment-landing`));
const GET_CONVERSION_LEVELS_MATCH = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/conversion-levels-match`;
const GET_PROMO_TRAINER = id => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/promo-trainer/${id}`;
const GET_ABOUT = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/about`;
const GET_ONBOARDING_LEVELS = (/* unused pure expression or super */ null && (`${getBunkerNodePath()}/flow/onboarding-levels`));
const GET_CUSTDEV_TRAINER_DATA = (levelId, chapterId) => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/custdev/${levelId}/${chapterId}`;
const GET_CONVERSION_TRIAL_IDS_TEMP = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/conversion-trial-ids-temp`;
const GET_GRAMMAR_REFERENCES = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/grammar-references`;
const GET_PAYMENT_LANDING = id => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/payment-landing-constructor/${id}`;
const GET_BEGINNER_MARKUP = beginnerId => `${getBunkerNodePath()}/flow/beginner-students/${beginnerId}`;
const GET_GRAMMAR_GUIDES = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/grammar-guides`;
const GET_CURATOR_FUNNEL = (/* unused pure expression or super */ null && (`${getBunkerNodePath()}/flow/curator-funnel`));
const GIFT_PRODUCTS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/gift-products`;
const GET_BEGINNER_ONBOARDING_QUESTIONS = (/* unused pure expression or super */ null && (`${getBunkerNodePath()}/flow/beginner-text-constants/onboarding-questions`));
const GET_FOOTER_LAYOUT = isRevisionVersion => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/layout/footer/${isRevisionVersion ? "app-store-revision" : "production"}`;
const GET_SOCIAL = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/layout/social/${"production"}`;
const GET_GENERAL_ENGLISH = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/general-english/${"production"}`;
const GET_GENERAL_IN_GUS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/general-in-gus`;
const GET_APP_REVISION_VERSION = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/app-revision-version`;
const GET_BUSINESS_PRODUCTS_FEATURE_FLAGS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/business-products-feature-flags/${"production"}`;
const GET_COURSE_MAP = level => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/course-map/${"production"}/${level}`;
const GET_STUDENT_RESCHEDULE_LESSON_SURVEY = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/student-reschedule-lesson-survey`;
const GET_AUTO_TUTOR_CHANGE_POPUP_CONTENT = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/auto-tutor-change-popup-content`;
const GET_REFERRAL_PROGRAM_CONTENT = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/referral-program`;
const GET_EDUCATION_GOALS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBunkerNodePath */ .Xv)()}/flow/curator-request-landing-form/education-goals`;

/***/ }),

/***/ 67527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ mapRawStudentNote),
/* harmony export */   s: () => (/* binding */ mapRawStudentNotes)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95790);
/* harmony import */ var _yandex_langly_shared_src_model_student_note__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49155);
/* harmony import */ var _yandex_langly_shared_src_model_student_student_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54938);
/* harmony import */ var _yandex_langly_shared_src_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97953);








const mapRawStudentNote = rawResponse => ({
  id: (0,_yandex_langly_shared_src_model_student_note__WEBPACK_IMPORTED_MODULE_2__/* .makeStudentNoteId */ .K7)(rawResponse.id),
  studentId: (0,_yandex_langly_shared_src_model_student_student_model__WEBPACK_IMPORTED_MODULE_3__/* .makeStudentId */ .Ox)(rawResponse.student_id),
  tutorId: (0,_yandex_langly_shared_src_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_4__/* .makeTutorId */ .Nr)(rawResponse.tutor_id),
  text: rawResponse.text,
  attachments: rawResponse.attachments.map(rawAttachment => ({
    id: (0,_yandex_langly_shared_src_model_student_note__WEBPACK_IMPORTED_MODULE_2__/* .makeStudentNoteAttachmentId */ .S4)(rawAttachment.id),
    src: rawAttachment.src
  })),
  type: rawResponse.type,
  createdAt: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* .parseISO */ .D)(rawResponse.created_at)
});
const mapRawStudentNotes = rawResponse => ({
  publicNotes: rawResponse.data.public.map(mapRawStudentNote),
  privateNotes: rawResponse.data.private.map(mapRawStudentNote)
});

/***/ }),

/***/ 18284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ RawStudentNote),
/* harmony export */   n: () => (/* binding */ RawStudentNotesResponse)
/* harmony export */ });
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87830);
/* harmony import */ var _yandex_langly_shared_src_model_student_note__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49155);




const RawStudentNote = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  type: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__.literal(_yandex_langly_shared_src_model_student_note__WEBPACK_IMPORTED_MODULE_0__/* .StudentNoteType */ .iC.Private), io_ts__WEBPACK_IMPORTED_MODULE_1__.literal(_yandex_langly_shared_src_model_student_note__WEBPACK_IMPORTED_MODULE_0__/* .StudentNoteType */ .iC.Public)]),
  student_id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  tutor_id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  text: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  created_at: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  attachments: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
    src: io_ts__WEBPACK_IMPORTED_MODULE_1__.string
  }))
});
const RawStudentNotesResponse = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    public: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(RawStudentNote),
    private: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(RawStudentNote)
  })
});

/***/ }),

/***/ 72401:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ ProductStatusRaw)
/* harmony export */ });
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87830);



const ProductStatusRaw = io_ts__WEBPACK_IMPORTED_MODULE_0__.keyof({
  new: null,
  payment_in_progress: null,
  paid: null,
  payment_declined: null,
  paid_manual: null,
  paid_oplaty: null,
  paid_contract: null,
  paid_migration: null,
  paid_free: null,
  paid_manually_cancelled: null
});

/***/ }),

/***/ 53536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  bQ: () => (/* binding */ eventPost),
  ed: () => (/* binding */ postSpeakingSessionEvent),
  R3: () => (/* binding */ postSyllabusEvent)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/fp-ts/es6/Either.js + 1 modules
var Either = __webpack_require__(18984);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
;// CONCATENATED MODULE: ../shared/src/api/events/events.mappers.ts




const mapTutorCancelEvent = event => ({
  type: "cancel_tutor",
  payload: {
    student_id: event.studentId,
    tutor_id: event.tutorId,
    speaking_type_id: event.speakingTypeId
  }
});
const mapToRawEvent = event => {
  switch (event) {
    case speakingSession_model/* SpeakingSessionFSMEvent */.jO.Start:
      return "start";
    case speakingSession_model/* SpeakingSessionFSMEvent */.jO.Stop:
      return "stop";
    case speakingSession_model/* SpeakingSessionFSMEvent */.jO.Cancel:
      return "cancel";
    case speakingSession_model/* SpeakingSessionFSMEvent */.jO.Unknown:
      return "unknown";
    case speakingSession_model/* SpeakingSessionFSMEvent */.jO.ScheduleCancelledLesson:
      return "schedule_cancelled_lesson";
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(event);
  }
};
const mapCancelReasonToRaw = cancelReason => {
  if (!cancelReason) {
    return void 0;
  }
  switch (cancelReason) {
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.TechIssues:
      return "tech_issues";
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.LateCancellation:
      return "late_cancel";
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.StudentNoShow:
      return "student_no_show";
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.StudentTutorScheduleChange:
      return "student_tutor_schedule_change";
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.ByStudent:
      return "student";
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.ByCurator:
      return "curator";
    case speakingSession_model/* SpeakingSessionCancelReason */.Ph.Empty:
    default:
      return void 0;
  }
};
const mapSpeakingSessionEvent = event => ({
  type: "speaking_session_change_state",
  payload: {
    subtype: mapToRawEvent(event.event),
    speaking_session_id: event.speakingSessionId ?? "",
    student_id: event.studentId,
    start_at: event.startAt,
    tutor_id: event.tutorId,
    syllabus_id: event.syllabusId,
    business_product_id: event.businessProductId,
    cancel_reason: mapCancelReasonToRaw(event.cancelReason),
    student_cancel_reason: event.studentCancelReason
  }
});
// EXTERNAL MODULE: ../shared/src/api/events/events.urls.ts
var events_urls = __webpack_require__(88620);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ./src/models/syllabus/syllabus.model.ts
var syllabus_model = __webpack_require__(71562);
;// CONCATENATED MODULE: ./src/api/events/events.mappers.ts




const mapSyllabusEventTypeToRaw = eventType => {
  switch (eventType) {
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Close:
      return "close_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Finish:
      return "finish_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Open:
      return "open_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Progress:
      return "progress_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Skip:
      return "skip_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.UnSkip:
      return "unskip_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Assign:
      return "assign_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Remove:
      return "unassign_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.AddInLesson:
      return "add_in_lesson_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Reset:
      return "reset_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.RemoveFromLesson:
      return "remove_from_lesson_node";
    case syllabus_model/* SyllabusNodeFSMEvent */.Sx.Unknown:
      return "unknown_event";
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(eventType);
  }
};
const mapSyllabusEvent = event => ({
  type: "syllabus_change_node_state",
  payload: {
    subtype: mapSyllabusEventTypeToRaw(event.event),
    node_id: event.nodeId,
    student_id: event.studentId,
    tutor_id: event.tutorId,
    attributes: {
      assigned_at: event.attributes?.assignedAt,
      mother_task_id: event.attributes?.motherTaskId,
      speaking_session_id: event.attributes?.speakingSessionId
    }
  }
});
;// CONCATENATED MODULE: ./src/api/events/events.api.ts









const eventPost = body => (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
  method: "POST",
  body,
  responseType: es6.type({})
});
const postSyllabusEvent = body => {
  const rawBody = mapSyllabusEvent(body);
  return (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
    method: "POST",
    body: rawBody,
    responseType: es6.type({})
  });
};
const postSpeakingSessionEvent = async body => {
  const rawBody = mapSpeakingSessionEvent(body);
  const result = await (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
    method: "POST",
    body: rawBody,
    responseType: es6.type({})
  });
  if ((0,Either/* isLeft */.nM)(result)) {
    throw new Error();
  }
};

/***/ }),

/***/ 77525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: () => (/* binding */ useSpeakingSessionQuery),
/* harmony export */   y: () => (/* binding */ useSpeakingSessionExperimentsQuery)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42180);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67145);





const useSpeakingSessionExperimentsQuery = _ref => {
  let {
    speakingSessionId
  } = _ref;
  const queryKey = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ["speakingSessionExperiments", speakingSessionId], [speakingSessionId]);
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
    enabled: Boolean(speakingSessionId),
    queryKey,
    queryFn: () => (0,_yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchSpeakingSessionExperiments */ .bR)(speakingSessionId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
const useSpeakingSessionQuery = _ref2 => {
  let {
    speakingSessionId,
    fetchSpeakingSession
  } = _ref2;
  const queryKey = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ["speakingSession", speakingSessionId], [speakingSessionId]);
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)({
    enabled: Boolean(speakingSessionId),
    queryKey,
    queryFn: () => fetchSpeakingSession(),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};

/***/ }),

/***/ 83331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  z: () => (/* binding */ getSpeakingSession),
  E: () => (/* binding */ getSpeakingSessionInitialStates)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/utils/io-ts-tools.ts
var io_ts_tools = __webpack_require__(64866);
// EXTERNAL MODULE: ./src/api/student/speaking/speaking.mappers.ts
var speaking_mappers = __webpack_require__(49968);
// EXTERNAL MODULE: ../shared/src/errors/models/forbidden.ts
var forbidden = __webpack_require__(83734);
// EXTERNAL MODULE: ../shared/src/errors/models/not-found-object-error.ts
var not_found_object_error = __webpack_require__(71134);
;// CONCATENATED MODULE: ./src/api/speaking-session/speaking-session.model.ts




var SpeakingSessionResponseError;
(SpeakingSessionResponseError2 => {
  SpeakingSessionResponseError2.SessionNotFound = new not_found_object_error/* NotFoundObjectError */.m("speaking session");
  SpeakingSessionResponseError2.Forbidden = new forbidden/* ForbiddenError */.l();
})(SpeakingSessionResponseError || (SpeakingSessionResponseError = {}));
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/speaking-session/speaking-session.urls.ts



const GET_SPEAKING_SESSION = sessionId => `${(0,site_utils/* getAPIPath */.NZ)()}/speaking-sessions/${sessionId}`;
const GETTING_SPEAKING_SESSIONS_INITIAL_STATES_URL = `${(0,site_utils/* getAPIPath */.NZ)()}/speaking-sessions/initial-states`;
;// CONCATENATED MODULE: ./src/api/speaking-session/speaking-session.api.ts












const getSpeakingSession = (0,un_either/* unEither */.K)(speakingId => (0,http/* makeRequest */.$f)(GET_SPEAKING_SESSION(speakingId), {
  responseType: (0,io_ts_tools/* asType */.fr)(),
  resultMapper(rawResponse) {
    return (0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(rawResponse.data);
  },
  errorMapper: error => {
    switch (error.code) {
      case "speaking_session_not_found":
        return SpeakingSessionResponseError.SessionNotFound;
      case "forbidden_operation":
        return SpeakingSessionResponseError.Forbidden;
      default:
        return api_model/* unexpectedError */.g;
    }
  }
}));
const getSpeakingSessionInitialStates = (0,un_either/* unEither */.K)(async speakingSessionsIds => (0,http/* makeRequest */.$f)(GETTING_SPEAKING_SESSIONS_INITIAL_STATES_URL, {
  method: "POST",
  body: {
    speaking_sessions: speakingSessionsIds
  },
  responseType: (0,io_ts_tools/* asType */.fr)(),
  resultMapper(rawResponse) {
    return rawResponse.data.reduce((result, item) => {
      result[item.id] = item;
      return result;
    }, {});
  }
}));

/***/ }),

/***/ 50919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  k: () => (/* binding */ placeUserIntoLevel)
});

// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/student/placement/placement.raw-model.ts



const PostPlacementRawResponse = es6.type({});
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/student/placement/placement.urls.ts



const PLACEMENT = `${(0,site_utils/* getAPIPath */.NZ)()}/student/placement`;
;// CONCATENATED MODULE: ./src/api/student/placement/placement.api.ts





const placeUserIntoLevel = levelId => (0,http/* makeRequest */.$f)(PLACEMENT, {
  method: "POST",
  body: {
    level_id: levelId
  },
  responseType: PostPlacementRawResponse
});

/***/ }),

/***/ 19857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  J: () => (/* binding */ getRevisionChapterState)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/immutable/dist/immutable.es.js
var immutable_es = __webpack_require__(27623);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.model.ts
var trainer_model = __webpack_require__(92601);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/student/revision/revision.urls.ts



const studentRevisionUrlPrefix = `${(0,site_utils/* getAPIPath */.NZ)()}/student/revision`;
const GET_REVISION_CHAPTER_STATE = (chapterId, activityType) => {
  const activityTypeParam = activityType ? `?activity_type=${activityType}` : "";
  return `${studentRevisionUrlPrefix}/chapter/${chapterId}${activityTypeParam}`;
};
;// CONCATENATED MODULE: ./src/api/student/revision/revision.api.ts









const getRevisionChapterState = (chapterId, activityType) => (0,http/* makeRequest */.$f)(GET_REVISION_CHAPTER_STATE(chapterId, activityType), {
  responseType: trainer_model/* GetChapterStateResponse */.Nf,
  resultMapper(rawResponse) {
    const {
      activities
    } = rawResponse.chapter_structure;
    const chapterStudentEvents = {};
    const showSkipButton = activities.some(activity => activity.meta?.["show-skip-button"]);
    return {
      title: "",
      activities,
      settings: {
        showSkipButton
      },
      chapterStudentEvents,
      isSpeakingUnscheduled: rawResponse.chapter_speaking_is_unscheduled,
      isFinalEventExist: false,
      lastEvent: void 0,
      completeBlocksIdSet: immutable_es/* Set */.l4()
    };
  }
});

/***/ }),

/***/ 68393:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Ec: () => (/* binding */ createSpeakingSession),
  sF: () => (/* binding */ deleteSpeakingSession),
  RI: () => (/* binding */ getRescheduleDates),
  jR: () => (/* binding */ getSpeakingSessionNotes),
  Zt: () => (/* binding */ getStudentSpeakingSessions),
  u9: () => (/* binding */ rescheduleLesson)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/date-fns/getUnixTime.mjs
var getUnixTime = __webpack_require__(23568);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../shared/src/date.utils.ts + 1 modules
var date_utils = __webpack_require__(35468);
// EXTERNAL MODULE: ../shared/src/errors/models/unknown.ts
var unknown = __webpack_require__(99615);
// EXTERNAL MODULE: ../shared/src/model/student/student.model.ts
var student_model = __webpack_require__(54938);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/widgets/reschedule-lesson-popup/service/errors.ts
var errors = __webpack_require__(8490);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ./src/api/common/notes/notes.map.ts
var notes_map = __webpack_require__(67527);
// EXTERNAL MODULE: ./src/api/common/notes/notes.model-raw.ts
var notes_model_raw = __webpack_require__(18284);
;// CONCATENATED MODULE: ./src/api/student/notes/notes.api.ts






const getStudentNotes = studentId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/${studentId}/notes`, {
  responseType: notes_model_raw/* RawStudentNotesResponse */.n,
  resultMapper: notes_map/* mapRawStudentNotes */.s
});
// EXTERNAL MODULE: ./src/api/student/speaking/speaking.mappers.ts
var speaking_mappers = __webpack_require__(49968);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/date-fns/fromUnixTime.mjs
var fromUnixTime = __webpack_require__(34925);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../shared/src/api/student/onboarding/tutors.mappers.ts
var tutors_mappers = __webpack_require__(10400);
// EXTERNAL MODULE: ./src/api/student/speaking-session/speaking-session.raw-model.ts
var speaking_session_raw_model = __webpack_require__(21804);
;// CONCATENATED MODULE: ./src/api/student/speaking-session/speaking-session.mappers.ts





























const speakingWithFollowUp = (0,speaking_session_raw_model/* RawSpeakingSession */.HP)(speaking_session_raw_model/* RawSpeakingSessionsFollowUp */.M);
const mapRawFollowUp = rawSpeakingSession => ({
  id: rawSpeakingSession.followup.id,
  createdAt: (0,fromUnixTime/* fromUnixTime */.K)(rawSpeakingSession.followup.sent_at),
  content: rawSpeakingSession.followup.public_content,
  speakingSessionId: rawSpeakingSession.id,
  attachments: []
});
const groupNotesByMonthAndDay = notes => notes.reduce((result, note) => {
  const monthKey = (0,format/* format */.WU)(new Date(note.createdAt), "MM/yyyy");
  const dayKey = (0,format/* format */.WU)(new Date(note.createdAt), "dd");
  if (!result.has(monthKey)) {
    result.set(monthKey, /* @__PURE__ */new Map());
  }
  const month = result.get(monthKey);
  if (!month.has(dayKey)) {
    month.set(dayKey, []);
  }
  const day = month.get(dayKey);
  day.push(note);
  return result;
}, /* @__PURE__ */new Map());
const mapRawSpeakingSessionsNotes = (response, studentConfigNotes) => {
  const mappedNotes = response.data.speaking_sessions.filter(speaking => speaking.followup !== null && speaking.followup.public_content.length > 0).map(mapRawFollowUp);
  const notes = mappedNotes.concat(studentConfigNotes).sort((a, b) => Number(b.createdAt) - Number(a.createdAt));
  return groupNotesByMonthAndDay(notes);
};
const mapReschedulingTutorResponseRaw = response => {
  const {
    tutor: tutorRaw
  } = response.data;
  const {
    availabilitySlots,
    availability5MinSlots
  } = (0,tutors_mappers/* mapRawTutorAvailableSlots */.Zc)(response.data);
  const {
    availabilitySlotsMap: by30MinGap,
    availability5MinSlotsMap: by5MinGap
  } = (0,tutors_mappers/* mapTutorAvailableSlotsToMap */.ZS)({
    availabilitySlots,
    availability5MinSlots
  });
  const v2Response = speaking_session_raw_model/* ReschedulingTutorResponseV2Raw */.A4.decode(response);
  return {
    tutor: (0,tutors_mappers/* mapRawTutor */.Sw)(tutorRaw),
    by5MinGap,
    by30MinGap,
    availabilitySlots,
    availability5MinSlots,
    ...((0,Either.isRight)(v2Response) ? {
      isLateReschedule: v2Response.right.data.is_late_reschedule,
      isMultipleReschedule: v2Response.right.data.is_multiple_reschedule,
      version: "2"
    } : {
      version: "1"
    })
  };
};
const mapRawStudentSpeakingSessions = rawResponse => ({
  speakingSessions: rawResponse.data.speaking_sessions.reduce((acc, speakingSession) => {
    acc[speakingSession.id] = (0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(speakingSession);
    return acc;
  }, {}),
  pendingSessionsExist: rawResponse.data.pending_sessions_exist ?? false
});
// EXTERNAL MODULE: ./src/api/student/speaking-session/speaking-session.model.ts
var speaking_session_model = __webpack_require__(55127);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
;// CONCATENATED MODULE: ./src/api/student/speaking-session/speaking-session.urls.ts






const speakingUrlPrefix = `${(0,site_utils/* getAPIPath */.NZ)()}/student/speaking-sessions`;
const CREATE_SPEAKING_SESSION = `${speakingUrlPrefix}`;
const DELETE_SPEAKING_SESSION = speakingSessionId => `${speakingUrlPrefix}/${speakingSessionId}`;
const GET_SPEAKING_SESSIONS = (from, to, order) => {
  const params = new URLSearchParams();
  params.set("from", String(from));
  params.set("to", String(to));
  if (order) {
    params.set("order", order);
  }
  return `${speakingUrlPrefix}?${params}`;
};
const GET_TUTOR_SPEAKING_SESSIONS = (tutorId, speakingTypeId, disallowSpeakingSessionMultipleReschedule, speakingSessionId) => `${(0,site_utils/* getAPIPath */.NZ)()}/student/tutor/${tutorId}/session-reschedule${disallowSpeakingSessionMultipleReschedule ? `-v2?speaking_session_id=${speakingSessionId}` : `?speaking_type_id=${speakingTypeId}`}`;
const RESCHEDULE_SPEAKING_SESSIONS = speakingSessionId => `${(0,site_utils/* getAPIPath */.NZ)()}/student/speaking-sessions/${speakingSessionId}/reschedule`;
;// CONCATENATED MODULE: ./src/api/student/speaking-session/speaking-session.api.ts



















const createSpeakingSession = (speakingId, currentProductId, startAt, tutorId) => {
  const body = {
    speaking_id: speakingId
  };
  if (tutorId !== null) {
    body.tutor_id = tutorId;
  }
  if (startAt !== null) {
    body.start_at = (0,getUnixTime/* getUnixTime */.Q)(startAt);
  }
  if (currentProductId !== null) {
    body.current_product_id = currentProductId;
  }
  return (0,http/* makeRequest */.$f)(CREATE_SPEAKING_SESSION, {
    method: "POST",
    body,
    responseType: speaking_session_raw_model/* RawCreateSpeakingSessionResult */.Fb,
    resultMapper(result) {
      return {
        speakingSession: (0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(result.data.speaking_session)
      };
    },
    errorMapper(error) {
      switch (error.code) {
        case "urgent_speaking_session_unmatched":
        case "tutor_not_available":
        case "invalid_start_time":
          return {
            type: speaking_session_model/* CreateSpeakingSessionErrorType */.H.TimeIsNotAvailable
          };
        case "not_enough_minutes":
          return {
            type: speaking_session_model/* CreateSpeakingSessionErrorType */.H.NotEnoughMinutes
          };
        default:
          return {
            type: speaking_session_model/* CreateSpeakingSessionErrorType */.H.Other
          };
      }
    }
  });
};
const deleteSpeakingSession = async speakingSessionId => {
  const response = await (0,http/* makeRequest */.$f)(DELETE_SPEAKING_SESSION(speakingSessionId), {
    method: "DELETE",
    responseType: speaking_session_raw_model/* RawCreateSpeakingSessionResult */.Fb
  });
  if ((0,Either.isLeft)(response)) {
    throw new Error();
  }
  return response.right;
};
const speaking_session_api_getStudentNotes = async studentId => {
  const studentNotesResponse = await getStudentNotes((0,student_model/* makeStudentId */.Ox)(studentId));
  if ((0,Either.isLeft)(studentNotesResponse)) {
    return [];
  }
  return studentNotesResponse.right.publicNotes.map(note => ({
    id: note.id,
    speakingSessionId: `speakingSession_${note.id}`,
    attachments: note.attachments.map(attachment => ({
      url: attachment.src
    })),
    content: note.text,
    createdAt: note.createdAt
  }));
};
const getSpeakingSessionNotes = async studentId => {
  const [speakingResponse, studentNotesResponse] = await Promise.all([(0,http/* makeRequest */.$f)(GET_SPEAKING_SESSIONS((0,getUnixTime/* getUnixTime */.Q)( /* @__PURE__ */new Date("2019-01-01")), (0,getUnixTime/* getUnixTime */.Q)( /* @__PURE__ */new Date())), {
    method: "GET",
    responseType: speaking_session_raw_model/* RawGetSpeakingSessionsSuccess */.Ni
  }), speaking_session_api_getStudentNotes(studentId)]);
  if ((0,Either.isLeft)(speakingResponse)) {
    return (0,Either.left)({
      type: speaking_session_model/* GetStudentNotesError */.C.Unknown
    });
  }
  return (0,Either.right)(mapRawSpeakingSessionsNotes(speakingResponse.right, studentNotesResponse));
};
const getStudentSpeakingSessions = (0,un_either/* unEither */.K)(_ref => {
  let {
    order = "DESC",
    from,
    to
  } = _ref;
  return (0,http/* makeRequest */.$f)(GET_SPEAKING_SESSIONS((0,getUnixTime/* getUnixTime */.Q)(from), (0,getUnixTime/* getUnixTime */.Q)(to), order), {
    responseType: speaking_session_raw_model/* RawStudentSpeakingSessionsResponse */.CS,
    resultMapper: mapRawStudentSpeakingSessions
  });
});
const getRescheduleDates = props => {
  const {
    speakingTypeId,
    tutorId,
    disallowSpeakingSessionMultipleReschedule,
    speakingSessionId
  } = props;
  return (0,http/* makeRequest */.$f)(GET_TUTOR_SPEAKING_SESSIONS(tutorId, speakingTypeId, disallowSpeakingSessionMultipleReschedule, speakingSessionId), {
    responseType: disallowSpeakingSessionMultipleReschedule ? speaking_session_raw_model/* ReschedulingTutorResponseV2Raw */.A4 : speaking_session_raw_model/* ReschedulingTutorResponseV1Raw */.wP,
    resultMapper: mapReschedulingTutorResponseRaw
  });
};
const rescheduleLesson = props => {
  const {
    date,
    speakingSessionId,
    reason,
    isFreeReschedule
  } = props;
  return (0,http/* makeRequest */.$f)(RESCHEDULE_SPEAKING_SESSIONS(speakingSessionId), {
    method: "PUT",
    responseType: speaking_session_raw_model/* RawRescheduleSpeakingSessionResult */.zA,
    body: {
      start_at: (0,date_utils/* getDefaultBackendDateFormat */.Uw)(date),
      student_reschedule_reason: reason,
      is_free: isFreeReschedule
    },
    resultMapper: _ref2 => {
      let {
        data: {
          speaking_session: speakingSession
        }
      } = _ref2;
      return (0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(speakingSession);
    },
    errorMapper: error => {
      switch (error.code) {
        case "tutor_not_available":
          return new errors/* RescheduleTutorIsNotAvailableError */.QY(speakingSessionId, date);
        case "speaking_session_already_in_past":
          return new errors/* RescheduleAlreadyInThePastError */.h0(speakingSessionId, date);
        case "speaking_session_reschedule_not_free":
          return new errors/* SpeakingSessionRescheduleIsNotFree */.sK(speakingSessionId, date);
        default:
          return new unknown/* UnknownError */.K();
      }
    }
  });
};

/***/ }),

/***/ 55127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ GetStudentNotesError),
/* harmony export */   H: () => (/* binding */ CreateSpeakingSessionErrorType)
/* harmony export */ });


var CreateSpeakingSessionErrorType = /* @__PURE__ */(CreateSpeakingSessionErrorType2 => {
  CreateSpeakingSessionErrorType2[CreateSpeakingSessionErrorType2["TimeIsNotAvailable"] = 0] = "TimeIsNotAvailable";
  CreateSpeakingSessionErrorType2[CreateSpeakingSessionErrorType2["NotEnoughMinutes"] = 1] = "NotEnoughMinutes";
  CreateSpeakingSessionErrorType2[CreateSpeakingSessionErrorType2["Other"] = 2] = "Other";
  return CreateSpeakingSessionErrorType2;
})(CreateSpeakingSessionErrorType || {});
var GetStudentNotesError = /* @__PURE__ */(GetStudentNotesError2 => {
  GetStudentNotesError2["Unknown"] = "unknown";
  return GetStudentNotesError2;
})(GetStudentNotesError || {});

/***/ }),

/***/ 21804:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A4: () => (/* binding */ ReschedulingTutorResponseV2Raw),
/* harmony export */   CS: () => (/* binding */ RawStudentSpeakingSessionsResponse),
/* harmony export */   Fb: () => (/* binding */ RawCreateSpeakingSessionResult),
/* harmony export */   HP: () => (/* binding */ RawSpeakingSession),
/* harmony export */   M: () => (/* binding */ RawSpeakingSessionsFollowUp),
/* harmony export */   Ni: () => (/* binding */ RawGetSpeakingSessionsSuccess),
/* harmony export */   wP: () => (/* binding */ ReschedulingTutorResponseV1Raw),
/* harmony export */   zA: () => (/* binding */ RawRescheduleSpeakingSessionResult)
/* harmony export */ });
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var _yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55847);
/* harmony import */ var _yandex_langly_shared_src_api_student_onboarding_tutors_raw_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96536);





const RawSpeakingSessionsFollowUp = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  public_content: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  sent_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number
});
const RawSpeakingSession = followup => io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  followup
});
const RawGetSpeakingSessionsSuccess = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    speaking_sessions: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(RawSpeakingSession(io_ts__WEBPACK_IMPORTED_MODULE_2__.union([RawSpeakingSessionsFollowUp, io_ts__WEBPACK_IMPORTED_MODULE_2__["null"]])))
  })
});
const RawCreateSpeakingSessionResult = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    speaking_session: _yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionItemRaw */ .Xj
  })
});
const ReschedulingTutorRawV1 = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  tutor: _yandex_langly_shared_src_api_student_onboarding_tutors_raw_model__WEBPACK_IMPORTED_MODULE_1__/* .RawTutor */ .SX,
  available_intervals: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(_yandex_langly_shared_src_api_student_onboarding_tutors_raw_model__WEBPACK_IMPORTED_MODULE_1__/* .rawTutorInterval */ .$D),
  speaking_session_duration: io_ts__WEBPACK_IMPORTED_MODULE_2__.number
});
const ReschedulingTutorRawV2 = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([ReschedulingTutorRawV1, io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  is_multiple_reschedule: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  is_late_reschedule: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
})]);
const ReschedulingTutorResponseV1Raw = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: ReschedulingTutorRawV1
});
const ReschedulingTutorResponseV2Raw = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: ReschedulingTutorRawV2
});
const RawRescheduleSpeakingSessionResult = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    speaking_session: _yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionItemRaw */ .Xj
  })
});
const RawStudentSpeakingSessionsResponse = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    speaking_sessions: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(_yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionItemRaw */ .Xj),
    pending_sessions_exist: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean, io_ts__WEBPACK_IMPORTED_MODULE_2__["null"]]),
    count: io_ts__WEBPACK_IMPORTED_MODULE_2__.number
  })
});

/***/ }),

/***/ 93096:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  II: () => (/* binding */ addTutorToBlacklist),
  lb: () => (/* binding */ deleteTutorFromBlacklist),
  KN: () => (/* binding */ getChapterSpeakingId),
  Ao: () => (/* binding */ getMentorSpeakingId),
  bs: () => (/* binding */ getSpeakingAvailableTime),
  Hv: () => (/* binding */ getSpeakingTutors)
});

// UNUSED EXPORTS: getSpeakingSessions

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/date-fns/getUnixTime.mjs
var getUnixTime = __webpack_require__(23568);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ./src/api/api.utils.ts
var api_utils = __webpack_require__(11568);
// EXTERNAL MODULE: ./src/api/student/speaking/speaking.mappers.ts
var speaking_mappers = __webpack_require__(49968);
;// CONCATENATED MODULE: ./src/api/student/speaking/speaking.raw-model.ts



var SpeakingType = /* @__PURE__ */(SpeakingType2 => {
  SpeakingType2["mentor"] = "mentor";
  SpeakingType2["chapter"] = "chapter";
  return SpeakingType2;
})(SpeakingType || {});
const RawTutorDescription = es6.intersection([es6.type({
  id: es6.string,
  public_name: es6.string,
  avatar: es6.union([es6["null"], es6.string])
}), es6.partial({
  timezone: es6.string,
  is_blacklisted: es6.boolean
})]);
const RawSpeakingTutorsResponse = es6.type({
  data: es6.type({
    suggest_random_tutor_first: es6.boolean,
    last_tutor: es6.union([RawTutorDescription, es6["null"]]),
    previous_tutors: es6.array(RawTutorDescription)
  })
});
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/student/speaking/speaking.urls.ts



const speakingUrlPrefix = `${(0,site_utils/* getAPIPath */.NZ)()}/student/speakings`;
const SPEAKING_AVAILABLE_TIME = (speakingId, from, to, tutorId, options) => {
  const tutorIdParam = tutorId === null ? "" : `&tutor_id=${tutorId}`;
  let queryParams = `?from=${from}&to=${to}${tutorIdParam}`;
  if (options?.skipQueryParams) {
    queryParams = "";
  }
  return `${speakingUrlPrefix}/${speakingId}/available-time${queryParams}`;
};
const STUDENT_SPEAKINGS = `${speakingUrlPrefix}`;
const SPEAKING_TUTORS = speakingId => `${speakingUrlPrefix}/${speakingId}/tutors`;
const TUTORS_BLACKLIST = `${(0,site_utils/* getAPIPath */.NZ)()}/student/tutors-blacklist`;
;// CONCATENATED MODULE: ./src/api/student/speaking/speaking.api.ts














const getSpeakingTutors = speakingId => (0,http/* makeRequest */.$f)(SPEAKING_TUTORS(speakingId), {
  responseType: RawSpeakingTutorsResponse,
  resultMapper: speaking_mappers/* mapRawSpeakingTutorsResponse */.xq
});
const addTutorToBlacklist = tutorId => (0,http/* makeRequest */.$f)(TUTORS_BLACKLIST, {
  method: "PUT",
  body: {
    tutor_id: tutorId
  },
  responseType: es6.unknown
});
const deleteTutorFromBlacklist = tutorId => (0,http/* makeRequest */.$f)(TUTORS_BLACKLIST, {
  method: "DELETE",
  body: {
    tutor_id: tutorId
  },
  responseType: es6.unknown
});
const getSpeakingAvailableTime = async (speakingId, from, to, tutorId) => {
  const response = await (0,api_utils/* http */.d)(SPEAKING_AVAILABLE_TIME(speakingId, (0,getUnixTime/* getUnixTime */.Q)(from), (0,getUnixTime/* getUnixTime */.Q)(to), tutorId), "GET");
  return (0,speaking_mappers/* mapRawSpeakingAvailableTimeResponse */.Bd)(response);
};
const getSpeakingSessions = async function (speakingId) {
  let daysOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
  const {
    availableTime
  } = await getSpeakingAvailableTime(speakingId, addMinutes( /* @__PURE__ */new Date(), 1),
  // Даём лаг в 1 минуту, чтобы юзер успел зашедулиться.
  addDays( /* @__PURE__ */new Date(), daysOffset), null);
  if (!availableTime) {
    return left(unexpectedError);
  }
  return right(availableTime);
};
const getChapterSpeakingId = async chapterId => {
  const response = await (0,api_utils/* http */.d)(STUDENT_SPEAKINGS, "GET");
  const speakingData = response.data.available_speakings.find(s => s.speaking.chapter_id === chapterId);
  return speakingData?.speaking.id;
};
const getMentorSpeakingId = async () => {
  const response = await (0,api_utils/* http */.d)(STUDENT_SPEAKINGS, "GET");
  const speakingData = response.data.available_speakings.find(s => s.speaking.type === "mentor");
  return speakingData?.speaking.id;
};

/***/ }),

/***/ 49968:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bd: () => (/* binding */ mapRawSpeakingAvailableTimeResponse),
/* harmony export */   bH: () => (/* binding */ mapRawSpeakingSessionResponse),
/* harmony export */   xq: () => (/* binding */ mapRawSpeakingTutorsResponse)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34925);
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27623);
/* harmony import */ var _yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69848);
/* harmony import */ var _yandex_langly_shared_src_entities_product__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12888);
/* harmony import */ var _yandex_langly_shared_src_entities_student_attributes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14325);
/* harmony import */ var _yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43055);
/* harmony import */ var _yandex_langly_shared_src_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97953);
/* harmony import */ var _yandex_langly_shared_src_utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63419);
















const mapRawSpeakingAvailableTimeResponse = input => ({
  availableTime: input.data.available_time.map(time => ({
    startAt: (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* .fromUnixTime */ .K)(time.start_at),
    tutorsCount: time.tutors_count
  }))
});
const mapRawTutorDescription = _ref => {
  let {
    id,
    public_name: publicName,
    is_blacklisted: isBlacklisted,
    avatar,
    ...input
  } = _ref;
  const avatarValue = avatar === null ? _yandex_langly_shared_src_utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_12__/* .DEFAULT_AVATAR_URL */ .jz : avatar;
  return {
    id: (0,_yandex_langly_shared_src_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_11__/* .makeTutorId */ .Nr)(id),
    publicName,
    isBlacklisted,
    avatar: avatarValue,
    ...input
  };
};
const mapRawSpeakingTutorsResponse = input => {
  const blacklistedItems = input.data.previous_tutors.filter(tutor => tutor.is_blacklisted).map(tutor => tutor.id);
  if (input.data.last_tutor && input.data.last_tutor.is_blacklisted) {
    blacklistedItems.push(input.data.last_tutor.id);
  }
  return {
    suggestRandomTutorFirst: input.data.suggest_random_tutor_first,
    lastTutor: input.data.last_tutor === null ? null : mapRawTutorDescription(input.data.last_tutor),
    previousTutors: input.data.previous_tutors.map(mapRawTutorDescription),
    blacklistedSet: immutable__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Set */ .ZP.Set(blacklistedItems)
  };
};
const mapStudent = _ref2 => {
  let {
    current_level_title: currentLevelTitle,
    default_email: defaultEmail,
    ...rawStudent
  } = _ref2;
  const publicName = rawStudent.first_name && rawStudent.last_name ? `${rawStudent.first_name} ${rawStudent.last_name}` : rawStudent.public_name;
  return {
    ...(currentLevelTitle && {
      currentLevelTitle
    }),
    publicName,
    defaultEmail,
    ...rawStudent
  };
};
const mapRawChapter = input => {
  if (input === null) {
    return null;
  }
  const {
    level_title: levelTitle,
    ...other
  } = input;
  return {
    levelTitle,
    ...other
  };
};
const mapSpeaking = _ref3 => {
  let {
    duration_minutes: durationMinutes,
    type,
    chapter,
    description,
    properties,
    ...speaking
  } = _ref3;
  return {
    type: (0,_yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_7__/* .mapRawSpeakingType */ .u7)(type),
    typeId: (0,_yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_10__/* .makeSpeakingTypeId */ .TG)(speaking.type_id),
    durationMinutes,
    chapter: chapter ? mapRawChapter(chapter) : null,
    ...(description && {
      description
    }),
    properties: properties ? {
      businessProductId: (0,_yandex_langly_shared_src_entities_product__WEBPACK_IMPORTED_MODULE_8__/* .mapRawBusinessId */ .r)(properties.business_product_id),
      schedulingStrategy: (0,_yandex_langly_shared_src_entities_student_attributes__WEBPACK_IMPORTED_MODULE_9__/* .mapSchedulingStrategy */ .Yy)(properties.scheduling_strategy)
    } : void 0,
    ...speaking
  };
};
const mapRawSpeakingSessionResponse = _ref4 => {
  let {
    student,
    tutor,
    start_at,
    created_at,
    updated_at,
    state,
    speaking,
    cancel_reason,
    ...speakingSession
  } = _ref4;
  return {
    ...(student && {
      student: mapStudent(student)
    }),
    speaking: mapSpeaking(speaking),
    state: (0,_yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_7__/* .mapRawSpeakingSessionState */ .M7)(state),
    startAt: (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* .fromUnixTime */ .K)(start_at),
    syllabusId: speakingSession.syllabus_id,
    createdAt: (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* .fromUnixTime */ .K)(created_at),
    updatedAt: (0,date_fns__WEBPACK_IMPORTED_MODULE_13__/* .fromUnixTime */ .K)(updated_at),
    cancelReason: (0,_yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_7__/* .mapRawSpeakingSessionCancelReason */ .EH)(cancel_reason),
    approvalStatus: (0,_yandex_langly_shared_src_api_speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_7__/* .mapRawSpeakingSessionApprovalStatus */ .z7)(speakingSession.approval_status),
    ...(tutor && {
      tutor: mapRawTutorDescription({
        ...tutor,
        is_blacklisted: false,
        timezone: tutor.timezone ?? ""
      })
    }),
    ...speakingSession
  };
};

/***/ }),

/***/ 91514:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  mL: () => (/* binding */ applyGift),
  gs: () => (/* binding */ applyPromoCode),
  kr: () => (/* binding */ applyTelegramCode),
  VP: () => (/* binding */ createGiftDraft),
  EH: () => (/* binding */ fetchBusinessProductsFeatureFlags),
  A4: () => (/* binding */ getAvailableContent),
  wK: () => (/* binding */ getForeignerSpeakings),
  zr: () => (/* binding */ getGiftDraft),
  $O: () => (/* binding */ getOneActiveSurvey),
  Cn: () => (/* binding */ getProductInfo),
  s6: () => (/* binding */ getProductsCards),
  aC: () => (/* binding */ mapBusinessProductFeatureFlags),
  Wv: () => (/* binding */ setNotificationType),
  ej: () => (/* binding */ setSyllabusNodeAttributes),
  Rj: () => (/* binding */ updateSpeakingSessionApprovalStatus)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/entities/onboarding/index.ts + 6 modules
var onboarding = __webpack_require__(13083);
// EXTERNAL MODULE: ../shared/src/entities/product/index.ts + 2 modules
var product = __webpack_require__(12888);
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/index.ts + 7 modules
var student_attributes = __webpack_require__(14325);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
;// CONCATENATED MODULE: ../shared/src/fsm.utils.ts




















function mapRawFSM(rawEventMapper, rawStateMapper, rawFsm) {
  return (0,object_utils/* getObjectKeys */.Z)(rawFsm).reduce((acc, rawEvent) => {
    const rawEventTransitions = rawFsm[rawEvent];
    const transitionKeys = (0,object_utils/* getObjectKeys */.Z)(rawEventTransitions);
    const transitions = transitionKeys.reduce((acc2, rawState) => {
      const from = rawStateMapper(rawState);
      const to = rawStateMapper(rawEventTransitions[rawState]);
      acc2.set(from, to);
      return acc2;
    }, /* @__PURE__ */new Map());
    acc.set(rawEventMapper(rawEvent), transitions);
    return acc;
  }, /* @__PURE__ */new Map());
}
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
// EXTERNAL MODULE: ../../node_modules/date-fns/fromUnixTime.mjs
var fromUnixTime = __webpack_require__(34925);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMinutes.mjs
var addMinutes = __webpack_require__(7300);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(95790);
// EXTERNAL MODULE: ../shared/src/api/speaking-sessions/speaking-sessions.mapper.ts
var speaking_sessions_mapper = __webpack_require__(69848);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/timezones.utils.ts
var timezones_utils = __webpack_require__(30332);
// EXTERNAL MODULE: ../shared/src/utils/avatar/avatar.utils.ts
var avatar_utils = __webpack_require__(63419);
// EXTERNAL MODULE: ./src/utils/io-ts-tools.ts
var io_ts_tools = __webpack_require__(64866);
// EXTERNAL MODULE: ./src/api/student/student.model.ts
var student_model = __webpack_require__(85715);
;// CONCATENATED MODULE: ./src/api/student/student.mappers.ts

































































const isBoughtStatus = (rawStatus, isRevisionAppVersion) => {
  if (isRevisionAppVersion) {
    return true;
  }
  return rawStatus === "paid" || rawStatus === "payment_in_progress" || rawStatus === "paid_manual" || rawStatus === "paid_oplaty" || rawStatus === "paid_contract" || rawStatus === "paid_free" || rawStatus === "paid_migration";
};
const parseContentElementCommonRaw = element => ({
  description: (0,io_ts_tools/* required */.C1)(element.description, "", `Description required for element with id: ${element.id}`),
  imageUrl: (0,io_ts_tools/* required */.C1)(element.image_url, "", `image_url required for element with id: ${element.id}`),
  historyDurationMin: element.history_duration_min ?? null,
  contentDescription: (0,io_ts_tools/* required */.C1)(element.content_description, {}, `content_description required for element with id: ${element.id}`)
});
const SpeakingSessionProcessor = rawSpeakingSessions => {
  const speakingSessionsBySpeakingId = /* @__PURE__ */new Map();
  let state;
  rawSpeakingSessions.forEach(speakingSession => {
    switch (speakingSession.state) {
      case "complete":
        state = speakingSession_model/* SpeakingSessionState */.Z.Completed;
        break;
      case "scheduled":
        state = speakingSession_model/* SpeakingSessionState */.Z.Scheduled;
        break;
      case "cancelled_billed":
      case "cancelled_unbilled":
      case "cancelled_automatically":
      default:
        return;
    }
    const startAt = (0,fromUnixTime/* fromUnixTime */.K)(speakingSession.start_at);
    const lastItem = speakingSessionsBySpeakingId.get(speakingSession.speaking.id);
    if (lastItem === void 0 || lastItem.state === speakingSession_model/* SpeakingSessionState */.Z.Completed && state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled || lastItem.startAt < startAt) {
      speakingSessionsBySpeakingId.set(speakingSession.speaking.id, {
        state,
        id: speakingSession.id,
        startAt,
        tutor: speakingSession.tutor ? {
          avatar: speakingSession.tutor.avatar ?? "",
          name: speakingSession.tutor.public_name,
          id: speakingSession.tutor.id
        } : null
      });
    }
  });
  return {
    getSpeakingSession: speakingId => speakingSessionsBySpeakingId.get(speakingId) ?? null
  };
};
const ChapterProgressProcessor = progressItemRaw => {
  const chapterEventsMap = progressItemRaw.reduce((acc, item) => {
    const existingChapterEvents = acc.get(item.chapter_id);
    if (!existingChapterEvents) {
      acc.set(item.chapter_id, [item]);
    } else {
      acc.set(item.chapter_id, [...existingChapterEvents, item]);
    }
    return acc;
  }, /* @__PURE__ */new Map());
  return {
    getChapterState: chapterId => {
      const events = chapterEventsMap.get(chapterId);
      if (events === void 0) {
        return {
          type: student_model/* ChapterStateType */.n_.NotStarted,
          updatedAt: null
        };
      }
      const finalEvent = events.find(e => e.event_type === "trainer_progress_final");
      const initEvent = events.find(e => e.event_type === "trainer_progress_init");
      const progressEvent = events.find(e => e.event_type === "trainer_progress");
      if (finalEvent !== void 0) {
        return {
          type: student_model/* ChapterStateType */.n_.Ended,
          updatedAt: new Date(finalEvent.created_at)
        };
      }
      if (progressEvent !== void 0) {
        return {
          type: student_model/* ChapterStateType */.n_.Started,
          progressPercent: progressEvent.data.progress,
          updatedAt: new Date(progressEvent.created_at)
        };
      }
      if (initEvent !== void 0) {
        return {
          type: student_model/* ChapterStateType */.n_.NotStarted,
          updatedAt: new Date(initEvent.created_at)
        };
      }
      return {
        type: student_model/* ChapterStateType */.n_.NotStarted,
        updatedAt: null
      };
    }
  };
};
const mapPacketData = (element, isRevisionAppVersion) => ({
  subtitle: element.subtitle ?? "",
  title: element.title,
  description: element.description ?? "",
  imageSrc: element.image_src,
  id: element.id,
  price: element.price,
  isBought: isBoughtStatus(element.status, isRevisionAppVersion),
  plusDiscountPercent: element.plus_discount_percent ?? 0
});
const lowLevelPacketsTypeSet = new Set(Object.values(student_model/* ChapterItemType */.a));
const getPaidPackets = (chapters, isRevisionAppVersion) => {
  const currentContent = chapters.find(chapter => chapter.is_current);
  if (!currentContent) {
    return /* @__PURE__ */new Set();
  }
  const boughtPacketIds = currentContent.markup.content.filter(el => el.type === student_model/* ProductType */.kv.Packet && el.price !== 0 && isBoughtStatus(el.status, isRevisionAppVersion)).map(content => content.id);
  return new Set(boughtPacketIds);
};
const mapCourseSelect = raw => ({
  imageUrl: raw.image_url ?? null,
  description: raw.description ?? null,
  additionalText: raw.additional_text ?? null,
  onboardingYmGoal: raw.onboarding_ym_goal ?? null
});
const mapRawAvailableContent = (data, isRevisionAppVersion) => {
  const {
    getSpeakingSession
  } = SpeakingSessionProcessor(data.speaking_sessions);
  const {
    getChapterState
  } = ChapterProgressProcessor(data.progress);
  const parseChapter = function (productId, element) {
    let allowSpeakingBeforeChapter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return {
      type: student_model/* ChapterItemType */.a.Chapter,
      productId,
      title: element.title,
      chapterId: element.id,
      state: student_model/* ChapterItemState */.vj.Active,
      speaking: element.speaking === null ? null : {
        id: element.speaking.id,
        session: getSpeakingSession(element.speaking.id),
        durationMin: element.speaking.duration_minutes
      },
      chapterState: getChapterState(element.id),
      revisionTypes: {
        test: element.revision_types.includes("test"),
        lexis: element.revision_types.includes("lexis"),
        grammar: element.revision_types.includes("grammar"),
        story: element.revision_types.includes("story")
      },
      allowSpeakingBeforeChapter,
      ...parseContentElementCommonRaw(element)
    };
  };
  const parseMentor = (productId, element) => ({
    type: student_model/* ChapterItemType */.a.Mentor,
    productId,
    title: element.title,
    state: student_model/* ChapterItemState */.vj.Active,
    speaking: {
      id: element.id,
      session: getSpeakingSession(element.id),
      durationMin: element.duration_minutes
    },
    ...parseContentElementCommonRaw(element)
  });
  let firstMentorSpeaking = null;
  const chapterIdSet = /* @__PURE__ */new Set();
  const mentorsIdSet = /* @__PURE__ */new Set();
  const currentChapters = [];
  let productInfo = null;
  const processItemForCurrentChapters = (element, productId, isAvailable, allowSpeakingBeforeChapter) => {
    switch (element.type) {
      case student_model/* ChapterItemType */.a.Chapter:
        {
          if (chapterIdSet.has(element.id) || !isAvailable) {
            return;
          }
          chapterIdSet.add(element.id);
          currentChapters.push({
            type: student_model/* ChapterItemType */.a.Chapter,
            productId,
            title: element.title,
            chapterId: element.id,
            state: student_model/* ChapterItemState */.vj.Active,
            speaking: element.speaking === null ? null : {
              id: element.speaking.id,
              session: getSpeakingSession(element.speaking.id),
              durationMin: element.speaking.duration_minutes
            },
            chapterState: getChapterState(element.id),
            revisionTypes: {
              test: element.revision_types.includes("test"),
              lexis: element.revision_types.includes("lexis"),
              grammar: element.revision_types.includes("grammar"),
              story: element.revision_types.includes("story")
            },
            allowSpeakingBeforeChapter: allowSpeakingBeforeChapter ?? true,
            ...parseContentElementCommonRaw(element)
          });
          break;
        }
      case student_model/* ChapterItemType */.a.Mentor:
        {
          if (mentorsIdSet.has(element.id) || !isAvailable) {
            return;
          }
          mentorsIdSet.add(element.id);
          const session = getSpeakingSession(element.id);
          if (element.first_mentor_speaking) {
            if (firstMentorSpeaking === null) {
              firstMentorSpeaking = {
                id: element.id,
                endAt: session === null ? null : (0,addMinutes/* addMinutes */.m)(session.startAt, element.duration_minutes)
              };
            } else {
              logger/* Logger */.Yd.captureException(new Error("Only one first mentor speaking available"), {
                productId,
                speaking1: firstMentorSpeaking.id,
                speaking2: element.id
              });
            }
          }
          currentChapters.push(parseMentor(productId, element));
          break;
        }
      case student_model/* ProductType */.kv.Packet:
      case student_model/* ProductType */.kv.Level:
      case student_model/* ProductType */.kv.Course:
        {
          element.content.forEach(el => {
            processItemForCurrentChapters(el, productId, isAvailable || isBoughtStatus(element.status, isRevisionAppVersion), element.allow_speaking_before_chapter);
          });
          break;
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(element);
    }
  };
  let isRepetitionAvailable = false;
  data.chapters.forEach(purchase => {
    if (purchase.is_current) {
      processItemForCurrentChapters(purchase.markup, purchase.product_id, false, isRevisionAppVersion);
      if (purchase.markup.type === student_model/* ProductType */.kv.Course || purchase.markup.type === student_model/* ProductType */.kv.Level) {
        productInfo = {
          id: purchase.markup.id,
          hours: purchase.markup.duration_hours,
          description: purchase.markup.description,
          price: purchase.markup.price,
          notForSale: Boolean(purchase.markup.not_for_sale),
          isBought: isBoughtStatus(purchase.markup.status, isRevisionAppVersion),
          plusDiscountPercent: purchase.markup.plus_discount_percent ?? 0,
          title: purchase.markup.title,
          courseSelect: mapCourseSelect(purchase.markup.course_select ?? {}),
          paymentLandingId: purchase.markup.payment_landing_id ?? null
        };
      }
      if (purchase.repetition_available) {
        isRepetitionAvailable = true;
      }
    }
  });
  const currentPackets = [];
  const processChaptersForPacket = (element, productId, chapters2, allowSpeakingBeforeChapter) => {
    if (element.type === student_model/* ProductType */.kv.Packet || element.type === student_model/* ProductType */.kv.Level || element.type === student_model/* ProductType */.kv.Course) {
      element.content.forEach(el => {
        processChaptersForPacket(el, productId, chapters2, allowSpeakingBeforeChapter);
      });
    } else if (element.type === student_model/* ChapterItemType */.a.Chapter) {
      chapters2.push(parseChapter(productId, element, allowSpeakingBeforeChapter));
    } else if (element.type === student_model/* ChapterItemType */.a.Mentor) {
      chapters2.push(parseMentor(productId, element));
    }
  };
  const processItemForPackets = (element, productId) => {
    if (element.type === student_model/* ProductType */.kv.Packet || element.type === student_model/* ProductType */.kv.Level || element.type === student_model/* ProductType */.kv.Course) {
      const lowLevelPacket = element.content.some(element2 => lowLevelPacketsTypeSet.has(element2.type));
      if (lowLevelPacket) {
        const chapters2 = [];
        processChaptersForPacket(element, productId, chapters2, element.allow_speaking_before_chapter);
        currentPackets.push({
          ...mapPacketData(element, isRevisionAppVersion),
          chapters: chapters2
        });
      } else {
        element.content.forEach(item => {
          processItemForPackets(item, productId);
        });
      }
    }
  };
  data.chapters.forEach(purchase => {
    if (purchase.is_current) {
      processItemForPackets(purchase.markup, purchase.product_id);
    }
  });
  const chapters = /* @__PURE__ */new Map();
  const processItemForChapters = element => {
    if (element.type === student_model/* ProductType */.kv.Packet || element.type === student_model/* ProductType */.kv.Level || element.type === student_model/* ProductType */.kv.Course) {
      element.content.forEach(el => {
        processItemForChapters(el);
      });
    } else if (element.type === student_model/* ChapterItemType */.a.Chapter) {
      chapters.set(element.id, {
        title: element.title,
        imageUrl: element.image_url ?? null
      });
    } else if (element.type === student_model/* ChapterItemType */.a.Mentor) {
      return;
    }
  };
  data.chapters.forEach(purchase => {
    processItemForChapters(purchase.markup);
  });
  const availableSpeakingSessions = [];
  const speakings = /* @__PURE__ */new Map();
  const speakingsArraysMap = /* @__PURE__ */new Map();
  const tutors = /* @__PURE__ */new Map();
  data.speaking_sessions.forEach(session => {
    let title = session.speaking.title;
    let imageUrl = session.speaking.image_url;
    if (title === null && session.speaking.chapter !== null) {
      title = session.speaking.chapter.chapter_title;
      imageUrl = session.speaking.chapter.image_url;
    }
    if (title === null) {
      title = "";
      logger/* Logger */.Yd.captureWarning("getAvailableContent() speaking_sessions haven't title");
    }
    if (imageUrl === null) {
      imageUrl = "";
    }
    const speakingInfo = {
      imageUrl,
      title,
      state: (0,speaking_sessions_mapper/* mapRawSpeakingSessionState */.M7)(session.state)
    };
    if (speakingsArraysMap.has(session.speaking.id)) {
      const existionSpeakingsInfoArray = speakingsArraysMap.get(session.speaking.id) ?? [];
      speakingsArraysMap.set(session.speaking.id, existionSpeakingsInfoArray.concat([speakingInfo]));
    } else {
      speakingsArraysMap.set(session.speaking.id, [speakingInfo]);
    }
    speakings.set(session.speaking.id, speakingInfo);
    if (session.tutor) {
      tutors.set(session.tutor.id, {
        avatar: session.tutor.avatar ?? "",
        name: session.tutor.public_name
      });
    }
    if (session.state !== "scheduled") {
      return;
    }
    availableSpeakingSessions.push({
      id: session.id,
      title,
      imageUrl,
      speakingType: (0,speaking_sessions_mapper/* mapRawSpeakingType */.u7)(session.speaking.type),
      durationMin: session.speaking.duration_minutes,
      startAt: (0,fromUnixTime/* fromUnixTime */.K)(session.start_at),
      tutor: session.tutor ? {
        avatar: session.tutor.avatar ?? "",
        name: session.tutor.public_name,
        id: session.tutor.id
      } : null
    });
  });
  currentPackets.forEach(packet => {
    const chapters2 = packet.chapters.map(chapter => {
      if (chapter.type === student_model/* ChapterItemType */.a.Mentor) {
        if (chapter.speaking?.session === null) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.NotStarted;
        }
        if (chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.Scheduled;
        }
        if (chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Completed) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.Ended;
        }
      } else if (chapter.type === student_model/* ChapterItemType */.a.Chapter) {
        if (chapter.chapterState.type === student_model/* ChapterStateType */.n_.NotStarted && (chapter.speaking?.session === null || chapter.speaking === null)) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.NotStarted;
        }
        if (chapter.chapterState.type !== student_model/* ChapterStateType */.n_.NotStarted && (chapter.speaking?.session === null || chapter.speaking === null)) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.Started;
        }
        if (chapter.speaking !== null && chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.Scheduled;
        }
        if (chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Completed || chapter.speaking === null && chapter.chapterState.type === student_model/* ChapterStateType */.n_.Ended) {
          chapter.progress = student_model/* PacketChapterProgress */.h0.Ended;
        }
      }
      return chapter;
    });
    const isAllChaptersNotStarted = chapters2.every(chapter => chapter.progress === student_model/* PacketChapterProgress */.h0.NotStarted);
    if (isAllChaptersNotStarted) {
      packet.progress = student_model/* PacketChapterProgress */.h0.NotStarted;
    }
    const isSomeChapterStarted = chapters2.some(chapter => chapter.progress !== student_model/* PacketChapterProgress */.h0.NotStarted);
    if (isSomeChapterStarted) {
      packet.progress = student_model/* PacketChapterProgress */.h0.Started;
    }
    const isSomeChapterScheduled = chapters2.some(chapter => chapter.progress === student_model/* PacketChapterProgress */.h0.Scheduled);
    if (isSomeChapterScheduled) {
      packet.progress = student_model/* PacketChapterProgress */.h0.Scheduled;
    }
    const isAllChaptersEnded = chapters2.every(chapter => chapter.progress === student_model/* PacketChapterProgress */.h0.Ended);
    if (isAllChaptersEnded) {
      packet.progress = student_model/* PacketChapterProgress */.h0.Ended;
    }
    return packet;
  });
  return {
    currentChapters,
    currentPackets,
    isRepetitionAvailable,
    isFirstSpeaking: data.speaking_sessions.length === 0,
    availableSpeakingSessions,
    firstMentorSpeaking,
    boughtLevelIds: new Set(data.chapters.filter(c => isBoughtStatus(c.markup.status, isRevisionAppVersion)).map(c => c.product_id)),
    boughtCurrentLevelPacketIds: getPaidPackets(data.chapters, isRevisionAppVersion),
    speakings,
    tutors,
    chapters,
    productInfo,
    speakingsArraysMap
  };
};
const productCardsMapper = productCards => productCards.map(card => ({
  id: card.id,
  title: card.title,
  description: card.description,
  imageUrl: card.image_url,
  additionalText: card.additional_text
}));
const foreignerSpeakingsMapper = data => data.data.foreigner_speakings.map(item => {
  const {
    speaking,
    speaking_session: speakingSession,
    tutor
  } = item;
  if (speakingSession === null) {
    return {
      id: speaking.id,
      state: student_model/* ForeignerSpeakingState */.Em.Initial,
      theme: speaking.title,
      durationMin: speaking.duration_minutes,
      tutorAvatar: avatar_utils/* DEFAULT_AVATAR_URL */.jz
    };
  }
  if (speakingSession !== null && speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled) {
    return {
      id: speaking.id,
      sessionId: speakingSession.id,
      state: student_model/* ForeignerSpeakingState */.Em.Scheduled,
      tutorName: tutor?.public_name ?? "",
      tutorAvatar: tutor?.avatar ?? avatar_utils/* DEFAULT_AVATAR_URL */.jz,
      startAt: (0,timezones_utils/* convertUTCToLocal */.v$)((0,parseISO/* parseISO */.D)(speakingSession.start_at)),
      theme: speaking.title,
      durationMin: speaking.duration_minutes
    };
  }
  return {
    id: speaking.id,
    state: student_model/* ForeignerSpeakingState */.Em.Complete
  };
});
// EXTERNAL MODULE: ../shared/src/api/speaking-sessions/speaking-sessions.raw-models.ts
var speaking_sessions_raw_models = __webpack_require__(55847);
// EXTERNAL MODULE: ../shared/src/api/surveys/surveys.raw-models.ts
var surveys_raw_models = __webpack_require__(89438);
;// CONCATENATED MODULE: ./src/components/feedback-popup-steps/feedback-popup-steps.model.ts




const GoToTarget = es6.union([es6.string, es6["null"]]);
const RateStepContent = es6.intersection([es6.type({
  type: es6.literal("rate")
}), es6.partial({
  items: es6.record(es6.string, es6.type({
    goToId: GoToTarget
  }))
  // [1; 5]
})]);
const RadioStepContent = es6.type({
  type: es6.literal("radio"),
  items: es6.array(es6.intersection([es6.type({
    id: es6.string,
    text: es6.string
  }), es6.partial({
    goToId: GoToTarget
  })]))
});
const TextStepContent = es6.type({
  type: es6.literal("text"),
  placeholder: es6.string
});
const CheckboxStepContent = es6.intersection([es6.type({
  type: es6.literal("checkbox"),
  items: es6.array(es6.type({
    id: es6.string,
    text: es6.string
  }))
}), es6.partial({
  answersMaxCount: es6.number
})]);
const MarkdownStepContent = es6.type({
  type: es6.literal("markdown"),
  markdown: es6.string
});
const FeedbackStepContent = es6.union([RateStepContent, RadioStepContent, TextStepContent, CheckboxStepContent, MarkdownStepContent]);
const FeedbackStep = es6.intersection([es6.type({
  id: es6.string,
  content: FeedbackStepContent
}), es6.partial({
  text: es6.string,
  goToId: GoToTarget,
  additionalText: es6.string
})]);
const FeedbackStepsDescription = es6.intersection([es6.type({
  steps: es6.array(FeedbackStep)
}), es6.partial({
  header: es6.string
})]);
const FeedbackStepsAnswers = es6.type({
  answers: es6.record(es6.string, surveys_raw_models/* StepAnswer */.p)
});
const AnswersRecord = es6.record(es6.string, surveys_raw_models/* StepAnswer */.p);
const AfterChapterContext = es6.type({
  type: es6.literal("after-chapter"),
  chapter_id: es6.string
});
const AfterSpeakingContext = es6.type({
  type: es6.literal("after-speaking"),
  speaking_id: es6.string
});
const AfterMentorSpeakingContext = es6.type({
  type: es6.literal("after-mentor-speaking"),
  speaking_id: es6.string,
  tutor_id: es6.string
});
const EmptyContext = es6.partial({
  type: es6.undefined
});
const FeedbackPopupContext = es6.union([AfterChapterContext, AfterSpeakingContext, AfterMentorSpeakingContext, EmptyContext]);
// EXTERNAL MODULE: ./src/api/common/product-status-raw.ts
var product_status_raw = __webpack_require__(72401);
;// CONCATENATED MODULE: ./src/api/student/student.raw-model.ts












const ContentElementCommonRaw = es6.intersection([es6.type({
  id: es6.string,
  title: es6.string
}), es6.partial({
  description: es6.string,
  image_url: es6.string,
  history_duration_min: es6.number,
  content_description: es6.partial({
    grammar: es6.string,
    vocabulary: es6.string,
    speaking: es6.string
  })
})]);
const ChapterElementRaw = es6.intersection([ContentElementCommonRaw, es6.type({
  revision_types: es6.array(es6.keyof({
    lexis: null,
    grammar: null,
    story: null,
    test: null
  })),
  speaking: es6.union([es6.type({
    id: es6.string,
    duration_minutes: es6.number
  }), es6["null"]]),
  type: es6.literal(student_model/* ChapterItemType */.a.Chapter)
})]);
const MentorElementRaw = es6.intersection([ContentElementCommonRaw, es6.type({
  duration_minutes: es6.number,
  type: es6.literal(student_model/* ChapterItemType */.a.Mentor)
}), es6.partial({
  first_mentor_speaking: es6.boolean
})]);
const CourseSelectRaw = es6.partial({
  image_url: es6.string,
  description: es6.string,
  additional_text: es6.string,
  onboarding_ym_goal: es6.string
});
const ProductMainMarkupRaw = es6.partial({
  type: es6.keyof({
    beginners: null,
    kids: null,
    bus: null
  })
});
const ActionAfterPlacementRaw = es6.union([es6.type({
  type: es6.keyof({
    openChapter: null
  }),
  chapterId: es6.string
}), es6.type({
  type: es6.keyof({
    openDashboard: null
  })
}), es6.type({
  type: es6.keyof({
    openPaymentPage: null
  })
})]);
const RawOnboardingFSM = es6.record(onboarding/* RawOnboardingEvent */.Kd, es6.record(student_attributes/* RawOnboardingState */.db, student_attributes/* RawOnboardingState */.db));
const ProductOnboardingMarkupRaw = es6.partial({
  actionAfterPlacement: ActionAfterPlacementRaw,
  statuses: es6.type({
    fsm: RawOnboardingFSM,
    initial_state: student_attributes/* RawOnboardingState */.db,
    final_state: student_attributes/* RawOnboardingState */.db
  })
});
const RawProductLayoutFeaturesMarkup = es6.partial({
  disable_mentor_notes: es6.boolean,
  disabled_grammar_and_lexis_in_trainer: es6.boolean,
  start_with_speaking_session: es6.boolean,
  open_story_after_speaking: es6.boolean,
  grammar_and_lexis_after_speaking: es6.boolean,
  show_grammar_guide_button_in_menu: es6.boolean,
  hide_add_to_wordbank_button: es6.boolean,
  hide_chapter_duration: es6.boolean
});
const RawPaymentStrategy = es6.keyof({
  full_payment: es6["null"],
  partial_payment: es6["null"],
  subscription: es6["null"]
});
const ProductCardRaw = es6.type({
  id: es6.string,
  title: es6.string,
  description: es6.string,
  additional_text: es6.string,
  image_url: es6.string
});
const ProductsCardsResponseRaw = es6.array(ProductCardRaw);
const SubProductRaw = es6.recursion("SubProduct", () => es6.intersection([es6.type({
  id: es6.string,
  title: es6.string,
  type: (0,io_ts_tools/* stringEnum */.b)(student_model/* ProductType */.kv),
  content: es6.array(es6.union([MentorElementRaw, ChapterElementRaw, SubProductRaw])),
  price: es6.number,
  status: product_status_raw/* ProductStatusRaw */.H
}), es6.partial({
  duration_hours: es6.number,
  description: es6.string,
  subtitle: es6.string,
  not_for_sale: es6.boolean,
  grammar_info_short: es6.string,
  grammar_info: es6.string,
  lexis_info_short: es6.string,
  lexis_info: es6.string,
  plus_discount_percent: es6.number,
  course_select: CourseSelectRaw,
  payment_landing_id: es6.string,
  allow_speaking_before_chapter: es6.boolean,
  allow_random_payment_order: es6.boolean,
  main: ProductMainMarkupRaw,
  layout_features: RawProductLayoutFeaturesMarkup,
  onboarding: ProductOnboardingMarkupRaw,
  payment_strategy: RawPaymentStrategy,
  discount_policy: es6.type({
    product_limited_tariffs_only: es6.boolean
  }),
  syllabus_id: es6.string,
  business: product/* BusinessId */.W,
  speaking_type_id: es6.string
})]));
const ChaptersPurchaseRaw = es6.intersection([es6.type({
  product_id: es6.string,
  markup: SubProductRaw
}), es6.union([es6.type({
  is_current: es6.literal(false)
}), es6.type({
  is_current: es6.literal(true),
  repetition_available: es6.boolean
})])]);
const EventMeta = es6.type({
  chapter_id: es6.string,
  created_at: es6.string
});
const ProgressEvent = es6.intersection([EventMeta, es6.type({
  event_type: es6.literal("trainer_progress"),
  data: es6.type({
    progress: es6.number
  })
})]);
const FinalEvent = es6.intersection([EventMeta, es6.type({
  event_type: es6.literal("trainer_progress_final")
})]);
const InitEvent = es6.intersection([EventMeta, es6.type({
  event_type: es6.literal("trainer_progress_init")
})]);
const ProgressItemRaw = es6.union([ProgressEvent, FinalEvent, InitEvent]);
const AvailableContentRaw = es6.type({
  chapters: es6.array(ChaptersPurchaseRaw),
  progress: es6.array(ProgressItemRaw),
  speaking_sessions: es6.array(speaking_sessions_raw_models/* SpeakingSessionItemRaw */.Xj)
});
const ApplyPromoCodeResponseRaw = es6.type({
  data: es6.type({
    tariffs: es6.array(es6.type({
      tariff: es6.union([es6.type({
        discount_percent: es6.number
      }), es6.type({
        price: es6.number
      }), es6.type({
        partial_price: es6.number
      })])
    }))
  })
});
const GiftDraftCreatedRaw = es6.type({
  id: es6.string,
  product_id: es6.string
});
const GiftDraftGetResponse = es6.partial({
  email: es6.string,
  message: es6.string,
  signature: es6.string
});
const GetSurveysResponse = es6.type({
  data: es6.type({
    user_surveys: es6.array(es6.type({
      id: es6.number,
      survey: es6.type({
        markup: FeedbackStepsDescription
      }),
      answers: es6.array(surveys_raw_models/* StepAnswerRaw */.y),
      context: FeedbackPopupContext
    }))
  })
});
const SyllabusNodeAttributesRaw = es6.type({
  data: es6.type({
    attributes: es6.partial({
      is_favorite: es6.boolean
    })
  })
});
const ProductRaw = es6.type({
  id: es6.string,
  title: es6.string,
  type: (0,io_ts_tools/* stringEnum */.b)(student_model/* ProductType */.kv),
  price: es6.number,
  syllabus_id: es6.union([es6.string, es6["null"]]),
  business_id: es6.union([product/* BusinessId */.W, es6["null"]]),
  speaking_type_id: es6.union([es6.string, es6["null"]]),
  disable_trainer_outro_actions: es6.union([es6.boolean, es6["null"]]),
  not_for_sale: es6.union([es6.boolean, es6["null"]]),
  course_select: es6.union([CourseSelectRaw, es6["null"]]),
  layout_features: es6.union([RawProductLayoutFeaturesMarkup, es6["null"]]),
  onboarding: es6.union([ProductOnboardingMarkupRaw, es6["null"]]),
  plus_discount_percent: es6.number,
  payment_landing_id: es6.union([es6.string, es6["null"]]),
  main: es6.union([ProductMainMarkupRaw, es6["null"]]),
  payment_strategy: es6.union([RawPaymentStrategy, es6["null"]]),
  discount_policy: es6.union([es6.type({
    product_limited_tariffs_only: es6.boolean
  }), es6["null"]])
});
const ForeignerSpeakingsProductRaw = es6.type({
  data: es6.type({
    foreigner_speakings: es6.array(es6.type({
      speaking: es6.type({
        id: es6.string,
        duration_minutes: es6.number,
        title: es6.string
      }),
      tutor: es6.union([es6.type({
        id: es6.string,
        avatar: es6.string,
        public_name: es6.string
      }), es6["null"]]),
      speaking_session: es6.union([es6.type({
        id: es6.string,
        start_at: es6.string,
        state: es6.string
      }), es6["null"]])
    }))
  })
});
// EXTERNAL MODULE: ./src/api/student/student.urls.ts
var student_urls = __webpack_require__(44328);
;// CONCATENATED MODULE: ./src/api/student/student.api.ts
























const getAvailableContent = function () {
  let orderOfSpeakingSessions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "DESC";
  let isRevisionAppVersion = arguments.length > 1 ? arguments[1] : undefined;
  const queryParams = new URLSearchParams();
  queryParams.set("order", orderOfSpeakingSessions);
  if (isRevisionAppVersion) {
    queryParams.set("no_disable", "true");
  }
  return (0,http/* makeRequest */.$f)(`${student_urls/* AVAILABLE_CONTENT */.P1}?${queryParams}`, {
    method: "GET",
    responseType: AvailableContentRaw,
    resultMapper: data => mapRawAvailableContent(data, isRevisionAppVersion)
  });
};
const mapMainMarkup = markup => ({
  type: markup.type
});
const mapOnboardinActionAfterPlacement = action => {
  switch (action.type) {
    case "openChapter":
      return {
        type: student_model/* ActionAfterPlacementType */.gS.OpenChapter,
        chapterId: action.chapterId
      };
    case "openPaymentPage":
      return {
        type: student_model/* ActionAfterPlacementType */.gS.OpenPaymentPage
      };
    case "openDashboard":
    default:
      return {
        type: student_model/* ActionAfterPlacementType */.gS.OpenDashboard
      };
  }
};
const mapRawOnboardingFsmEvent = rawEvent => {
  switch (rawEvent) {
    case "progress":
      return onboarding/* OnboardingFSMEvent */.Sb.Progress;
    case "reverse":
      return onboarding/* OnboardingFSMEvent */.Sb.Reverse;
    case "pause":
      return onboarding/* OnboardingFSMEvent */.Sb.Pause;
    case "unpause":
      return onboarding/* OnboardingFSMEvent */.Sb.Unpause;
    case "select_tutor":
      return onboarding/* OnboardingFSMEvent */.Sb.SelectTutor;
    case "cancel":
      return onboarding/* OnboardingFSMEvent */.Sb.Cancel;
    default:
      return onboarding/* OnboardingFSMEvent */.Sb.Unknown;
  }
};
const mapMarkupOnboarding = markup => ({
  actionAfterPlacement: markup.actionAfterPlacement ? mapOnboardinActionAfterPlacement(markup.actionAfterPlacement) : void 0,
  fsm: markup.statuses ? {
    states: mapRawFSM(mapRawOnboardingFsmEvent, student_attributes/* mapRawStudentOnboardingState */.VW, markup.statuses.fsm),
    initialState: (0,student_attributes/* mapRawStudentOnboardingState */.VW)(markup.statuses.initial_state),
    finalState: (0,student_attributes/* mapRawStudentOnboardingState */.VW)(markup.statuses.initial_state)
  } : void 0
});
const mapRawPaymentStrategy = rawPaymentStrategy => {
  if (rawPaymentStrategy === null) {
    throw new Error();
  }
  const paymentStrategy = rawPaymentStrategy.toLocaleLowerCase();
  switch (paymentStrategy) {
    case "full_payment":
      return student_model/* PaymentStrategy */.Xu.FullPayment;
    case "partial_payment":
      return student_model/* PaymentStrategy */.Xu.PartialPayment;
    case "subscription":
      return student_model/* PaymentStrategy */.Xu.Subscription;
    default:
      throw new Error();
  }
};
const mapLayoutFeaturesMarkup = rawMarkup => {
  if (!rawMarkup) {
    return;
  }
  return {
    disableMentorNotes: rawMarkup.disable_mentor_notes,
    disabledGrammarAndLexisInTrainer: rawMarkup.disabled_grammar_and_lexis_in_trainer,
    startWithSpeakingSession: rawMarkup.start_with_speaking_session,
    openStoryAfterSpeaking: rawMarkup.open_story_after_speaking,
    grammarAndLexisAfterSpeaking: rawMarkup.grammar_and_lexis_after_speaking,
    showGrammarGuideButtonInMenu: rawMarkup.show_grammar_guide_button_in_menu,
    hideAddToWordbankButton: rawMarkup.hide_add_to_wordbank_button,
    hideChapterDuration: rawMarkup.hide_chapter_duration
  };
};
const mapBusinessProductFeatureFlags = _ref => {
  let {
    businessProductId,
    businessProductsFeatureFlagsConfig
  } = _ref;
  if (!businessProductId || !businessProductsFeatureFlagsConfig) {
    return null;
  }
  return businessProductsFeatureFlagsConfig[businessProductId];
};
const mapProductMarkup = _ref2 => {
  let {
    markup
  } = _ref2;
  return {
    id: markup.id,
    type: markup.type,
    price: markup.price,
    notForSale: Boolean(markup.not_for_sale),
    plusDiscountPercent: markup.plus_discount_percent ?? 0,
    title: markup.title,
    courseSelect: mapCourseSelect(markup.course_select ?? {}),
    paymentLandingId: markup.payment_landing_id ?? null,
    main: markup.main ? mapMainMarkup(markup.main) : void 0,
    onboarding: markup.onboarding ? mapMarkupOnboarding(markup.onboarding) : void 0,
    disableTrainerOutroActions: markup.disable_trainer_outro_actions ?? void 0,
    paymentStrategy: mapRawPaymentStrategy(markup.payment_strategy),
    discountPolicy: {
      productLimitedTariffsOnly: markup.discount_policy?.product_limited_tariffs_only ?? false
    },
    layoutFeatures: markup.layout_features ? mapLayoutFeaturesMarkup(markup.layout_features) : void 0,
    syllabusId: markup.syllabus_id ?? void 0,
    speakingTypeId: markup.speaking_type_id ? (0,speakingSession_model/* makeSpeakingTypeId */.TG)(markup.speaking_type_id) : void 0,
    businessId: (0,product/* mapRawBusinessId */.r)(markup.business_id ?? void 0),
    businessProductFeatureFlags: null
  };
};
const fetchBusinessProductsFeatureFlags = async () => {
  const businessProductsFeatureFlags = await (0,bunker_api/* getBusinessProductsFeatureFlags */.j_)();
  if ((0,Either.isLeft)(businessProductsFeatureFlags)) {
    return null;
  }
  return businessProductsFeatureFlags.right;
};
const getProductInfo = async id => (0,http/* makeRequest */.$f)((0,student_urls/* PRODUCT_INFO_V2 */.PV)(id), {
  responseType: ProductRaw,
  resultMapper(markup) {
    return mapProductMarkup({
      markup
    });
  }
});
const getProductsCards = productIds => (0,http/* makeRequest */.$f)(student_urls/* GET_PRODUCTS_CARDS */.h8, {
  method: "POST",
  body: {
    product_ids: productIds
  },
  responseType: ProductsCardsResponseRaw,
  resultMapper: productCardsMapper
});
const getForeignerSpeakings = (0,un_either/* unEither */.K)(businessProductId => (0,http/* makeRequest */.$f)((0,student_urls/* GET_FOREIGNER_SPEAKINGS */.Ct)(businessProductId), {
  responseType: ForeignerSpeakingsProductRaw,
  resultMapper: foreignerSpeakingsMapper
}));
const applyPromoCode = (code, region) => (0,http/* makeRequest */.$f)(student_urls/* ACTIVATE_PROMO_CODE */.nf + `?region=${region}`, {
  method: "POST",
  body: {
    promo_code: code
  },
  responseType: ApplyPromoCodeResponseRaw,
  resultMapper(result) {
    if (result.data.tariffs.length > 0) {
      const bestTariff = result.data.tariffs[0].tariff;
      if ("discount_percent" in bestTariff) {
        return {
          type: student_model/* ApplyPromoCodeType */.gv.Percent,
          discountPercent: bestTariff.discount_percent
        };
      }
      if ("price" in bestTariff) {
        return {
          type: student_model/* ApplyPromoCodeType */.gv.Absolute,
          price: bestTariff.price
        };
      }
      if ("partial_price" in bestTariff) {
        return {
          type: student_model/* ApplyPromoCodeType */.gv.Absolute,
          price: bestTariff.partial_price
        };
      }
    }
    return {
      type: student_model/* ApplyPromoCodeType */.gv.None
    };
  },
  errorMapper(rawError) {
    const errorCodeMap = {
      unknown_promo_code: student_model/* ApplyPromoCodeError */.Hi.UnknownPromoCode,
      promo_code_already_used: student_model/* ApplyPromoCodeError */.Hi.PromoCodeAlreadyUsed,
      promo_code_not_suitable_for_restrictions: student_model/* ApplyPromoCodeError */.Hi.PromoCodeNotSuitableForRestrictions,
      region_doesnt_match: student_model/* ApplyPromoCodeError */.Hi.RegionDoesntMatch,
      promocode_expired: student_model/* ApplyPromoCodeError */.Hi.PromocodeExpired
    };
    return errorCodeMap[rawError.code] ?? api_model/* unexpectedError */.g;
  }
});
const applyGift = code => (0,http/* makeRequest */.$f)(student_urls/* ACTIVATE_GIFT */.Hu, {
  method: "PUT",
  body: {
    promo_code: code
  },
  responseType: es6.unknown,
  errorMapper(rawError) {
    if (rawError.code === "gift_promo_code_applying_error") {
      return student_model/* ApplyGiftError */.U6.GiftPromoCodeApplyingError;
    }
    return api_model/* unexpectedError */.g;
  }
});
const createGiftDraft = async params => {
  const {
    email,
    message,
    signature,
    productId,
    phoneNumber,
    offerId
  } = params;
  return (0,http/* makeRequest */.$f)(student_urls/* CREATE_GIFT_DRAFT */.T_, {
    method: "POST",
    responseType: GiftDraftCreatedRaw,
    body: {
      email,
      message,
      signature,
      product_id: productId === null ? void 0 : productId,
      phone_number: phoneNumber ? phoneNumber : void 0,
      offer_id: offerId === null ? void 0 : offerId
    },
    resultMapper(data) {
      return {
        id: data.id,
        productId: data.product_id
      };
    }
  });
};
const getGiftDraft = async offerId => (0,http/* makeRequest */.$f)((0,student_urls/* GET_GIFT_DRAFT */.u6)(offerId), {
  responseType: GiftDraftGetResponse
});
const getOneActiveSurvey = async () => (0,http/* makeRequest */.$f)(student_urls/* GET_SURVEYS */.ZC, {
  responseType: GetSurveysResponse,
  resultMapper(rawResult) {
    const userSurveys = rawResult.data.user_surveys;
    if (userSurveys.length === 0) {
      return null;
    }
    const survey = userSurveys.reduce((res, survey2) => survey2.answers.length > res.answers.length ? survey2 : res);
    return {
      id: survey.id,
      answers: survey.answers.reduce((acc, answer) => {
        if (answer.is_final === false) {
          acc[answer.step_id] = answer;
        }
        return acc;
      }, {}),
      markup: survey.survey.markup,
      context: survey.context
    };
  }
});
const setSyllabusNodeAttributes = (nodeId, isFavorite, assignedAt) => {
  const body = {
    attributes: {
      is_favorite: isFavorite
    }
  };
  if (assignedAt) {
    body.attributes.assigned_at = assignedAt;
  }
  return (0,http/* makeRequest */.$f)((0,student_urls/* SET_SYLLABUS_NODE_ATTRIBUTES */.kX)(nodeId), {
    method: "POST",
    body,
    responseType: SyllabusNodeAttributesRaw
  });
};
const updateSpeakingSessionApprovalStatus = (speakingSessionId, approvalStatus) => (0,http/* makeRequest */.$f)(student_urls/* UPDATE_SPEAKING_SESSION_APPROVAL_STATUS */.HG, {
  method: "PUT",
  responseType: es6["void"],
  body: {
    approval_status: approvalStatus,
    speaking_session_id: speakingSessionId
  }
});
const setNotificationType = (0,un_either/* unEither */.K)(type => (0,http/* makeRequest */.$f)(student_urls/* SET_NOTIFICATION_TYPE */.ff, {
  method: "PUT",
  responseType: es6["void"],
  body: {
    type
  }
}));
const applyTelegramCode = (0,un_either/* unEither */.K)(code => (0,http/* makeRequest */.$f)(student_urls/* APPLY_TELEGRAM_CODE */.nq, {
  method: "POST",
  responseType: es6["void"],
  body: {
    code
  }
}));

/***/ }),

/***/ 85715:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Em: () => (/* binding */ ForeignerSpeakingState),
/* harmony export */   Hi: () => (/* binding */ ApplyPromoCodeError),
/* harmony export */   U6: () => (/* binding */ ApplyGiftError),
/* harmony export */   Xu: () => (/* binding */ PaymentStrategy),
/* harmony export */   a: () => (/* binding */ ChapterItemType),
/* harmony export */   de: () => (/* binding */ MainPageType),
/* harmony export */   gS: () => (/* binding */ ActionAfterPlacementType),
/* harmony export */   gv: () => (/* binding */ ApplyPromoCodeType),
/* harmony export */   h0: () => (/* binding */ PacketChapterProgress),
/* harmony export */   kv: () => (/* binding */ ProductType),
/* harmony export */   n_: () => (/* binding */ ChapterStateType),
/* harmony export */   vj: () => (/* binding */ ChapterItemState)
/* harmony export */ });


var ChapterItemType = /* @__PURE__ */(ChapterItemType2 => {
  ChapterItemType2["Chapter"] = "CHAPTER";
  ChapterItemType2["Mentor"] = "MENTOR";
  return ChapterItemType2;
})(ChapterItemType || {});
var ProductType = /* @__PURE__ */(ProductType2 => {
  ProductType2["Level"] = "LEVEL";
  ProductType2["Packet"] = "PACKET";
  ProductType2["Course"] = "COURSE";
  return ProductType2;
})(ProductType || {});
var PacketChapterProgress = /* @__PURE__ */(PacketChapterProgress2 => {
  PacketChapterProgress2["NotStarted"] = "NotStarted";
  PacketChapterProgress2["Started"] = "Started";
  PacketChapterProgress2["Scheduled"] = "Scheduled";
  PacketChapterProgress2["Disabled"] = "Disabled";
  PacketChapterProgress2["Ended"] = "Ended";
  return PacketChapterProgress2;
})(PacketChapterProgress || {});
var ChapterStateType = /* @__PURE__ */(ChapterStateType2 => {
  ChapterStateType2[ChapterStateType2["NotStarted"] = 0] = "NotStarted";
  ChapterStateType2[ChapterStateType2["Started"] = 1] = "Started";
  ChapterStateType2[ChapterStateType2["Ended"] = 2] = "Ended";
  return ChapterStateType2;
})(ChapterStateType || {});
var ChapterItemState = /* @__PURE__ */(ChapterItemState2 => {
  ChapterItemState2["Active"] = "active";
  ChapterItemState2["Disabled"] = "disabled";
  return ChapterItemState2;
})(ChapterItemState || {});
var ApplyPromoCodeType = /* @__PURE__ */(ApplyPromoCodeType2 => {
  ApplyPromoCodeType2[ApplyPromoCodeType2["Percent"] = 0] = "Percent";
  ApplyPromoCodeType2[ApplyPromoCodeType2["Absolute"] = 1] = "Absolute";
  ApplyPromoCodeType2[ApplyPromoCodeType2["None"] = 2] = "None";
  return ApplyPromoCodeType2;
})(ApplyPromoCodeType || {});
var ApplyPromoCodeError = /* @__PURE__ */(ApplyPromoCodeError2 => {
  ApplyPromoCodeError2["UnknownPromoCode"] = "UnknownPromoCode";
  ApplyPromoCodeError2["PromoCodeAlreadyUsed"] = "PromoCodeAlreadyUsed";
  ApplyPromoCodeError2["PromoCodeNotSuitableForRestrictions"] = "PromoCodeNotSuitableForRestrictions";
  ApplyPromoCodeError2["RegionDoesntMatch"] = "RegionDoesntMatch";
  ApplyPromoCodeError2["PromocodeExpired"] = "PromocodeExpired";
  return ApplyPromoCodeError2;
})(ApplyPromoCodeError || {});
var MainPageType = /* @__PURE__ */(MainPageType2 => {
  MainPageType2["Beginners"] = "beginners";
  MainPageType2["Kids"] = "kids";
  MainPageType2["Bus"] = "bus";
  return MainPageType2;
})(MainPageType || {});
var ActionAfterPlacementType = /* @__PURE__ */(ActionAfterPlacementType2 => {
  ActionAfterPlacementType2["OpenChapter"] = "openChapter";
  ActionAfterPlacementType2["OpenDashboard"] = "openDashboard";
  ActionAfterPlacementType2["OpenPaymentPage"] = "openPaymentPage";
  return ActionAfterPlacementType2;
})(ActionAfterPlacementType || {});
var PaymentStrategy = /* @__PURE__ */(PaymentStrategy2 => {
  PaymentStrategy2["FullPayment"] = "fullPayment";
  PaymentStrategy2["PartialPayment"] = "partialPayment";
  PaymentStrategy2["Subscription"] = "subscription";
  return PaymentStrategy2;
})(PaymentStrategy || {});
var ApplyGiftError = /* @__PURE__ */(ApplyGiftError2 => {
  ApplyGiftError2["GiftPromoCodeApplyingError"] = "GiftPromoCodeApplyingError";
  return ApplyGiftError2;
})(ApplyGiftError || {});
var ForeignerSpeakingState = /* @__PURE__ */(ForeignerSpeakingState2 => {
  ForeignerSpeakingState2["Initial"] = "initial";
  ForeignerSpeakingState2["Scheduled"] = "scheduled";
  ForeignerSpeakingState2["Complete"] = "complete";
  return ForeignerSpeakingState2;
})(ForeignerSpeakingState || {});

/***/ }),

/***/ 44328:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ct: () => (/* binding */ GET_FOREIGNER_SPEAKINGS),
/* harmony export */   F7: () => (/* binding */ GET_TEST_RESULT),
/* harmony export */   HG: () => (/* binding */ UPDATE_SPEAKING_SESSION_APPROVAL_STATUS),
/* harmony export */   Hu: () => (/* binding */ ACTIVATE_GIFT),
/* harmony export */   MR: () => (/* binding */ GET_TEST_RESULTS),
/* harmony export */   N0: () => (/* binding */ ATTRIBUTES),
/* harmony export */   P1: () => (/* binding */ AVAILABLE_CONTENT),
/* harmony export */   PV: () => (/* binding */ PRODUCT_INFO_V2),
/* harmony export */   T_: () => (/* binding */ CREATE_GIFT_DRAFT),
/* harmony export */   ZC: () => (/* binding */ GET_SURVEYS),
/* harmony export */   ff: () => (/* binding */ SET_NOTIFICATION_TYPE),
/* harmony export */   h8: () => (/* binding */ GET_PRODUCTS_CARDS),
/* harmony export */   kX: () => (/* binding */ SET_SYLLABUS_NODE_ATTRIBUTES),
/* harmony export */   nf: () => (/* binding */ ACTIVATE_PROMO_CODE),
/* harmony export */   nq: () => (/* binding */ APPLY_TELEGRAM_CODE),
/* harmony export */   u6: () => (/* binding */ GET_GIFT_DRAFT)
/* harmony export */ });
/* unused harmony export studentUrlPrefix */
/* harmony import */ var _yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24610);



const studentUrlPrefix = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/student`;
const AVAILABLE_CONTENT = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/available-content`;
const PRODUCT_INFO_V2 = id => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/product_v2/${id}`;
const GET_PRODUCTS_CARDS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/get-product-cards`;
const CREATE_GIFT_DRAFT = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/gift/draft`;
const GET_GIFT_DRAFT = offerId => `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/gift/draft/${offerId}`;
const GET_SURVEYS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/student/surveys`;
const ATTRIBUTES = `${studentUrlPrefix}/attributes`;
const ACTIVATE_PROMO_CODE = `${studentUrlPrefix}/promo_code`;
const ACTIVATE_GIFT = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/gift/activate`;
const SET_SYLLABUS_NODE_ATTRIBUTES = nodeId => `${studentUrlPrefix}/node/${nodeId}/attributes`;
const GET_FOREIGNER_SPEAKINGS = businessProductId => `${studentUrlPrefix}/foreigner-speakings/${businessProductId}`;
const GET_TEST_RESULT = testId => `${studentUrlPrefix}/test-result/${testId}`;
const GET_TEST_RESULTS = businessProductId => `${studentUrlPrefix}/test-results/${businessProductId}`;
const UPDATE_SPEAKING_SESSION_APPROVAL_STATUS = `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/student/reassign`;
const SET_NOTIFICATION_TYPE = `${studentUrlPrefix}/set-notification-type`;
const APPLY_TELEGRAM_CODE = `${studentUrlPrefix}/apply-telegram-code`;

/***/ }),

/***/ 19905:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  bi: () => (/* binding */ getSelfStudy),
  S9: () => (/* binding */ getStudentSyllabus),
  FZ: () => (/* binding */ getSyllabus),
  l_: () => (/* binding */ getSyllabusNode)
});

// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(95790);
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
// EXTERNAL MODULE: ../ui-kit/src/beginners-main/__task-card/task-card.component.tsx + 1 modules
var task_card_component = __webpack_require__(25874);
// EXTERNAL MODULE: ./src/models/syllabus/syllabus.model.ts
var syllabus_model = __webpack_require__(71562);
// EXTERNAL MODULE: ./src/api/student/syllabus/syllabus.constants.ts
var syllabus_constants = __webpack_require__(48216);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
;// CONCATENATED MODULE: ./src/api/student/syllabus/utils.ts



const logTaskGuideWarning = (description, method, data) => {
  logger/* Logger */.Yd.captureWarning(`Task Guide Error`, {
    description,
    data
  }, {
    block: "TaskGuide",
    method
  });
};
;// CONCATENATED MODULE: ./src/api/student/syllabus/syllabus.mappers.ts




































const mapRawModule = rawModule => {
  const rawMotherTasks = rawModule?.content?.MOTHER_TASK || {};
  const motherTasks = Object.values(rawMotherTasks).map(_ref => {
    let {
      id
    } = _ref;
    return {
      id
    };
  });
  return {
    id: rawModule.id,
    title: rawModule.node_params.name,
    isStartNode: rawModule.start_node,
    motherTasks
  };
};
const mapRawTaskType = (type, data) => {
  switch (type) {
    case "SPEAKING_TASK":
      return syllabus_model/* SyllabusTaskType */.vG.Speaking;
    case "IN_CLASS_TASK":
      return syllabus_model/* SyllabusTaskType */.vG.InClass;
    case "SELF_STUDY_TASK":
      return syllabus_model/* SyllabusTaskType */.vG.SelfStudy;
    default:
      {
        logTaskGuideWarning(`Unknown task type: ${type}`, "mapRawTaskType", data);
        return syllabus_model/* SyllabusTaskType */.vG.Unknown;
      }
  }
};
const mapRawTaskStatus = (status, data) => {
  switch (status) {
    case "active":
      return syllabus_model/* SyllabusTaskStatus */.p7.Active;
    case "archived":
      return syllabus_model/* SyllabusTaskStatus */.p7.Archived;
    case "deleted":
      return syllabus_model/* SyllabusTaskStatus */.p7.Deleted;
    default:
      {
        logTaskGuideWarning(`Unknown status: ${status}`, "mapRawTaskStatus", data);
        return syllabus_model/* SyllabusTaskStatus */.p7.Unknown;
      }
  }
};
const mapRawSubtaskStatus = (params, rawMotherTask) => {
  if (params.motherTaskStatus === syllabus_model/* SyllabusTaskStatus */.p7.Deleted) {
    return syllabus_model/* SyllabusTaskStatus */.p7.Deleted;
  }
  return mapRawTaskStatus(params.taskStatus, rawMotherTask);
};
const mapRawFSMEvent = (rawFSMEvent, data) => {
  switch (rawFSMEvent) {
    case "close_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Close;
    case "finish_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Finish;
    case "open_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Open;
    case "progress_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Progress;
    case "skip_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Skip;
    case "unskip_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.UnSkip;
    case "assign_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Assign;
    case "unassign_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Remove;
    case "reset_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Reset;
    case "add_in_lesson_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.AddInLesson;
    case "remove_from_lesson_node":
      return syllabus_model/* SyllabusNodeFSMEvent */.Sx.RemoveFromLesson;
    case "unknown_event":
    default:
      {
        logTaskGuideWarning(`Unknown FSMEvent: ${rawFSMEvent}`, "mapRawFSMEvent", data);
        return syllabus_model/* SyllabusNodeFSMEvent */.Sx.Unknown;
      }
  }
};
const mapRawFSMStateToMotherTaskState = (rawFSMState, rawMotherTaskContent) => {
  switch (rawFSMState) {
    case "available":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.Initial;
    case "in_progress":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.InProgress;
    case "finished":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.Done;
    case "not_available":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.Disabled;
    case "skipped":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.Skipped;
    case "in_lesson":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.InLesson;
    case "null":
      return syllabus_model/* SyllabusMotherTaskState */.CZ.Unknown;
    default:
      {
        logTaskGuideWarning(`Unknown FSMState: ${rawFSMState}`, "mapRawFSMStateToMotherTaskState", rawMotherTaskContent);
        return syllabus_model/* SyllabusMotherTaskState */.CZ.Unknown;
      }
  }
};
const mapRawFSMStateToTaskState = rawFSMState => {
  switch (rawFSMState) {
    case "available":
      return syllabus_model/* SyllabusTaskState */.YE.Initial;
    case "in_progress":
      return syllabus_model/* SyllabusTaskState */.YE.InProgress;
    case "finished":
      return syllabus_model/* SyllabusTaskState */.YE.Done;
    case "not_available":
      return syllabus_model/* SyllabusTaskState */.YE.NotAvailable;
    default:
      return syllabus_model/* SyllabusTaskState */.YE.Unknown;
  }
};
const mapRawFSMStateToSelfStudyState = rawFSMState => {
  switch (rawFSMState) {
    case "not_assigned":
      return syllabus_model/* SyllabusTaskState */.YE.NotAdded;
    case "in_progress":
      return syllabus_model/* SyllabusTaskState */.YE.InProgress;
    case "finished":
      return syllabus_model/* SyllabusTaskState */.YE.DoneWithProgress;
    case "assigned":
      return syllabus_model/* SyllabusTaskState */.YE.Added;
    default:
      return syllabus_model/* SyllabusTaskState */.YE.Unknown;
  }
};
const getMotherTaskType = (speakingTaskIds, speakingTasksMap) => {
  const motherTaskSpeakingTasks = speakingTasksMap;
  if (!motherTaskSpeakingTasks) {
    return syllabus_model/* SyllabusMotherTaskType */.wU.Default;
  }
  const haveMilestoneSpeakingTask = Object.values(motherTaskSpeakingTasks).some(task => task.node_params.subtype === "speaking: milestone");
  const haveForeignerSpeakingTask = Object.values(motherTaskSpeakingTasks).some(task => task.node_params.subtype === "speaking: foreigner preparation");
  if (haveMilestoneSpeakingTask) {
    return syllabus_model/* SyllabusMotherTaskType */.wU.Milestone;
  }
  if (haveForeignerSpeakingTask) {
    return syllabus_model/* SyllabusMotherTaskType */.wU.Foreigner;
  }
  return syllabus_model/* SyllabusMotherTaskType */.wU.Default;
};
const mapRawMotherTask = (rawMotherTaskContent, rawStateData) => {
  const tasks = rawMotherTaskContent.content ? (0,object_utils/* getObjectKeys */.Z)(rawMotherTaskContent.content).reduce((acc, taskTypeKey) => {
    if (!rawMotherTaskContent.content) {
      return acc;
    }
    const taskTypeRecord = rawMotherTaskContent.content[taskTypeKey];
    if (!taskTypeRecord) {
      return acc;
    }
    const taskTypeIds = (0,object_utils/* getObjectKeys */.Z)(taskTypeRecord).reduce((acc2, id) => {
      const type = mapRawTaskType(taskTypeKey, rawMotherTaskContent);
      if (type === syllabus_model/* SyllabusTaskType */.vG.Unknown) {
        return acc2;
      }
      if (type === syllabus_model/* SyllabusTaskType */.vG.SelfStudy) {
        acc2.push({
          id,
          type
        });
      } else {
        if (!taskTypeRecord) {
          return acc2;
        }
        const task = taskTypeRecord[id];
        if (!task.content) {
          return acc2;
        }
        acc2.push(...Object.keys(task.content.SUBTASK).map(id2 => ({
          id: id2,
          type
        })));
      }
      return acc2;
    }, []);
    return acc.concat(taskTypeIds);
  }, []) : [];
  const inClassTasks = tasks.filter(t => t.type === syllabus_model/* SyllabusTaskType */.vG.InClass);
  const selfStudyTasks = tasks.filter(t => t.type === syllabus_model/* SyllabusTaskType */.vG.SelfStudy);
  const speakingTasks = tasks.filter(t => t.type === syllabus_model/* SyllabusTaskType */.vG.Speaking);
  const motherTaskType = getMotherTaskType(speakingTasks, rawMotherTaskContent.content?.SPEAKING_TASK ?? null);
  return {
    id: rawMotherTaskContent.id,
    state: mapRawFSMStateToMotherTaskState(rawStateData.state, rawMotherTaskContent),
    title: rawMotherTaskContent.node_params.name,
    isStartNode: rawMotherTaskContent.start_node,
    inClassTasks,
    selfStudyTasks,
    type: motherTaskType,
    updatedAt: rawStateData.updated_at ? new Date(rawStateData.updated_at) : /* @__PURE__ */new Date(),
    speakingTasks,
    status: mapRawTaskStatus(rawMotherTaskContent.status, rawMotherTaskContent)
  };
};
const getTaskInstructions = rawInstructions => {
  if (!rawInstructions) {
    return [];
  }
  const orderedTitles = ["Aim", "TL", "Procedure", "Say", "Tip", "Time"];
  return orderedTitles.reduce((acc, title) => {
    if (!rawInstructions[title] || !Array.isArray(rawInstructions[title])) {
      return acc;
    }
    const instruction = {
      title: title + ":",
      text: rawInstructions[title].join("\n")
    };
    acc.push(instruction);
    return acc;
  }, []);
};
const mapSelfStudyType = type => {
  if (syllabus_constants/* SYLLABUS_SELF_STUDY_TYPES */.cg[type]) {
    return syllabus_constants/* SYLLABUS_SELF_STUDY_TYPES */.cg[type].nameKey;
  }
  return syllabus_constants/* DEFAULT_SELF_STUDY_TYPE_NAME_KEY */.jc;
};
const mapRawTaskDuration = type => {
  if (syllabus_constants/* SYLLABUS_SELF_STUDY_TYPES */.cg[type]) {
    return syllabus_constants/* SYLLABUS_SELF_STUDY_TYPES */.cg[type].duration;
  }
  return syllabus_constants/* DEFAULT_SELF_STUDY_TYPE_DURATION */.MA;
};
const formatLessonDate = date => date ? (0,parseISO/* parseISO */.D)(date).toISOString() : ( /* @__PURE__ */new Date()).toISOString();
const mapSelfStudy = (rawTask, rawStateRecord, rawMotherTask, rawInitialState) => {
  const rawState = rawStateRecord[rawTask.id] ?? {
    state: rawInitialState
  };
  return {
    type: syllabus_model/* SyllabusTaskType */.vG.SelfStudy,
    subtype: rawTask.node_params.subtype,
    description: rawTask.node_params?.description ?? "",
    taskId: rawTask.node_params.notion_id,
    id: rawTask.id,
    nodeId: rawState.node_id,
    chapterId: rawTask.chapter_id,
    state: mapRawFSMStateToSelfStudyState(rawState.state),
    isStartNode: rawTask.start_node,
    text: rawTask.type === "SELF_STUDY_TASK" ? rawTask.node_params.name : "Task without content",
    isFavorite: rawState.attributes?.is_favorite ?? false,
    lessonDate: formatLessonDate(rawState.attributes?.assigned_at ?? rawState.created_at),
    lessonTheme: rawMotherTask?.node_params.name ?? "",
    lessonDurationMin: mapRawTaskDuration(rawTask.node_params.subtype),
    speakingSessionId: rawState.attributes?.speaking_session_id,
    orderIndex: rawTask.node_params.index,
    status: mapRawSubtaskStatus({
      motherTaskStatus: rawMotherTask?.status,
      taskStatus: rawTask.status
    }, rawTask)
  };
};
const mapInClassAndSpeakingTask = (rawTask, rawStateRecord, rawMotherTask, rawInitialState) => {
  const rawType = rawTask.type;
  if (!rawTask.content || rawType === "SELF_STUDY_TASK") {
    return {};
  }
  const subtasks = Object.values(rawTask.content.SUBTASK);
  return subtasks.reduce((acc, subtask) => {
    const type = mapRawTaskType(rawType, rawMotherTask);
    if (type === syllabus_model/* SyllabusTaskType */.vG.Unknown) {
      return acc;
    }
    if (type === syllabus_model/* SyllabusTaskType */.vG.SelfStudy) {
      return acc;
    }
    const rawInstructionsMap = subtask.node_params["Teacher's Instructions"];
    const instruction = getTaskInstructions(rawInstructionsMap);
    const id = subtask.id;
    const rawState = rawStateRecord[id] ?? {
      state: rawInitialState
    };
    acc[id] = {
      type,
      taskId: subtask.node_params["nanochapter id"],
      chapterId: subtask.chapter_id,
      instruction,
      id,
      state: mapRawFSMStateToTaskState(rawState.state),
      isStartNode: rawTask.start_node,
      text: subtask.node_params.Header,
      orderIndex: subtask.node_params.index,
      status: mapRawSubtaskStatus({
        motherTaskStatus: rawMotherTask?.status,
        taskStatus: subtask.status
      }, subtask)
    };
    return acc;
  }, {});
};
const mapRawTask = (rawTask, rawStateRecord, rawMotherTask, rawInitialState) => {
  if (rawTask.type === "SELF_STUDY_TASK" || !rawTask.content) {
    return {
      [rawTask.id]: mapSelfStudy(rawTask, rawStateRecord, rawMotherTask, rawInitialState)
    };
  }
  switch (rawTask.type) {
    case "IN_CLASS_TASK":
    case "SPEAKING_TASK":
      return mapInClassAndSpeakingTask(rawTask, rawStateRecord, rawMotherTask, rawInitialState);
    default:
      return {};
  }
};
const getOrderedArrayOfIds = (startNodeId, relationsRecord, allowedNodeIds) => {
  const currentNode = relationsRecord[startNodeId];
  if (!currentNode) {
    return [startNodeId];
  }
  const nextNodeIds = currentNode.map(n => n.next_node_id).filter(n => n !== null && allowedNodeIds.includes(n));
  if (nextNodeIds.length === 0) {
    return [startNodeId];
  }
  return nextNodeIds.reduce((acc, n) => acc.concat(getOrderedArrayOfIds(n, relationsRecord, allowedNodeIds)), [startNodeId]);
};
const mapRawFSMStateToModuleState = rawFSMState => {
  switch (rawFSMState) {
    case "available":
      return syllabus_model/* SyllabusModuleNodeFSMState */.vg.Available;
    case "in_progress":
      return syllabus_model/* SyllabusModuleNodeFSMState */.vg.InProgress;
    case "finished":
      return syllabus_model/* SyllabusModuleNodeFSMState */.vg.Finished;
    case "not_available":
      return syllabus_model/* SyllabusModuleNodeFSMState */.vg.NoteAvailable;
    default:
      return syllabus_model/* SyllabusModuleNodeFSMState */.vg.Available;
  }
};
function mapRawFSM(rawStatuses, rawStateMapper, task) {
  return (0,object_utils/* getObjectKeys */.Z)(rawStatuses).reduce((acc, rawEvent) => {
    const rawEventTransitions = rawStatuses[rawEvent];
    const transitionKeys = (0,object_utils/* getObjectKeys */.Z)(rawEventTransitions);
    const transitions = transitionKeys.reduce((acc2, rawState) => {
      const from = rawStateMapper(rawState);
      const to = rawStateMapper(rawEventTransitions[rawState]);
      acc2.set(from, to);
      return acc2;
    }, /* @__PURE__ */new Map());
    acc.set(mapRawFSMEvent(rawEvent, task), transitions);
    return acc;
  }, /* @__PURE__ */new Map());
}
const getFirstTask = (tasks, tasksMap) => {
  if (tasks.length === 0) {
    return null;
  }
  return tasks.find(_ref2 => {
    let {
      id
    } = _ref2;
    const currentTask = tasksMap[id];
    return currentTask.isStartNode;
  }) || tasks[0];
};
const mapRawSyllabusAttributes = responseRaw => {
  const response = responseRaw.data.syllabus_node_state;
  return {
    id: response.node_id,
    state: mapRawFSMStateToTaskState(response.state),
    attributes: {
      isFavorite: response.attributes?.is_favorite || false,
      assignedAt: response.attributes?.assigned_at,
      motherTaskId: response.attributes?.mother_task_id
    },
    createdAt: response.created_at,
    updatesAt: response.updated_at
  };
};
var ButtonText = /* @__PURE__ */(ButtonText2 => {
  ButtonText2["START"] = "beginerTasksPage.start";
  ButtonText2["CONTINUE"] = "beginerTasksPage.continue";
  ButtonText2["REPEAT"] = "beginerTasksPage.repeat";
  return ButtonText2;
})(ButtonText || {});
const getButtonText = state => {
  switch (state) {
    case syllabus_model/* SyllabusTaskState */.YE.Initial:
      return "beginerTasksPage.start" /* START */;
    case syllabus_model/* SyllabusTaskState */.YE.InProgress:
      return "beginerTasksPage.continue" /* CONTINUE */;
    case syllabus_model/* SyllabusTaskState */.YE.DoneWithProgress:
    case syllabus_model/* SyllabusTaskState */.YE.Done:
      return "beginerTasksPage.repeat" /* REPEAT */;
    default:
      return "beginerTasksPage.start" /* START */;
  }
};
const mapSelfStudyState = state => {
  switch (state) {
    case syllabus_model/* SyllabusTaskState */.YE.Initial:
      return task_card_component/* TaskCardState */.ab.Available;
    case syllabus_model/* SyllabusTaskState */.YE.InProgress:
      return task_card_component/* TaskCardState */.ab.InProgress;
    case syllabus_model/* SyllabusTaskState */.YE.DoneWithProgress:
    case syllabus_model/* SyllabusTaskState */.YE.Done:
      return task_card_component/* TaskCardState */.ab.Done;
    default:
      return task_card_component/* TaskCardState */.ab.Available;
  }
};
const mapRawSelfStudy = response => Object.entries(response.data.self_study).map(_ref3 => {
  let [nodeId, node] = _ref3;
  const state = mapRawFSMStateToSelfStudyState(node.state);
  return {
    id: node.chapter_id ?? void 0,
    chapterId: node.chapter_id ?? "",
    nodeId,
    state: mapSelfStudyState(state),
    type: task_card_component/* TaskCardType */.Fj.Default,
    title: node.params.name,
    subtitle: "",
    description: node.params.description ?? "",
    buttonText: getButtonText(state),
    lessonType: mapSelfStudyType(node.params.subtype),
    date: formatLessonDate(node.attributes?.assigned_at ?? node.created_at),
    theme: node.parent_node_name ?? "",
    moduleName: node.module_name ?? "",
    isFavorite: node.attributes?.is_favorite ?? false,
    durationMin: mapRawTaskDuration(node.params.subtype) ?? void 0
  };
});
const mapRawSyllabus = response => {
  const rawModulesMap = response.syllabus.content.MODULE;
  const module = {};
  const motherTask = {};
  let task = {};
  const rawMotherTasksRecord = {};
  const rawTasksRecord = {};
  const contentTypes = response.syllabus.content_types;
  (0,object_utils/* getObjectKeys */.Z)(rawModulesMap).forEach(k => {
    const rawModule = rawModulesMap[k];
    Object.assign(rawMotherTasksRecord, rawModule?.content?.MOTHER_TASK);
    module[k] = mapRawModule(rawModule);
  }, {});
  (0,object_utils/* getObjectKeys */.Z)(rawMotherTasksRecord).forEach(k => {
    const rawMotherTask = rawMotherTasksRecord[k];
    const rawInClassTasks = rawMotherTask.content?.IN_CLASS_TASK;
    const rawSelfStudyTasks = rawMotherTask.content?.SELF_STUDY_TASK;
    const rawSpeakingTasks = rawMotherTask.content?.SPEAKING_TASK;
    const inClassTasks = rawInClassTasks ? (0,object_utils/* getObjectKeys */.Z)(rawInClassTasks).reduce((acc, taskId) => {
      const rawTask = rawInClassTasks[taskId];
      acc[taskId] = {
        ...rawTask,
        type: "IN_CLASS_TASK"
      };
      return acc;
    }, {}) : void 0;
    const selfStudyTasks = rawSelfStudyTasks ? (0,object_utils/* getObjectKeys */.Z)(rawSelfStudyTasks).reduce((acc, taskId) => {
      const rawTask = rawSelfStudyTasks[taskId];
      acc[taskId] = {
        ...rawTask,
        type: "SELF_STUDY_TASK",
        motherTaskId: rawMotherTask.id
      };
      return acc;
    }, {}) : void 0;
    const speakingTasks = rawSpeakingTasks ? (0,object_utils/* getObjectKeys */.Z)(rawSpeakingTasks).reduce((acc, taskId) => {
      const rawTask = rawSpeakingTasks[taskId];
      acc[taskId] = {
        ...rawTask,
        type: "SPEAKING_TASK"
      };
      return acc;
    }, {}) : void 0;
    Object.assign(rawTasksRecord, inClassTasks, selfStudyTasks, speakingTasks);
    const stateData = response.syllabus_state[rawMotherTask.id] ?? {
      state: contentTypes.MOTHER_TASK.params.statuses.initial_state
    };
    motherTask[k] = mapRawMotherTask(rawMotherTask, stateData);
  });
  (0,object_utils/* getObjectKeys */.Z)(rawTasksRecord).forEach(k => {
    const rawTask = rawTasksRecord[k];
    const stateData = response.syllabus_state[rawTask.id] ?? {
      state: contentTypes[rawTask.type].params.statuses.initial_state
    };
    let rawMotherTask = null;
    if (stateData?.attributes?.mother_task_id) {
      rawMotherTask = rawMotherTasksRecord[stateData.attributes.mother_task_id];
    }
    task = {
      ...task,
      ...mapRawTask(rawTask, response.syllabus_state, rawMotherTask, contentTypes[rawTask.type].params.statuses.initial_state)
    };
  }, {});
  const startModuleId = (0,object_utils/* getObjectKeys */.Z)(module).find(k => {
    const m = module[k];
    return m.isStartNode;
  }) || (0,object_utils/* getObjectKeys */.Z)(module)[0];
  const orderedModules = getOrderedArrayOfIds(startModuleId, response.syllabus.relations, (0,object_utils/* getObjectKeys */.Z)(module));
  const modules = orderedModules.map(k => {
    const m = module[k];
    const startMotherTask = getFirstTask(m.motherTasks, motherTask);
    const orderedMotherTasks = startMotherTask !== null ? getOrderedArrayOfIds(startMotherTask.id, response.syllabus.relations, m.motherTasks.map(_ref4 => {
      let {
        id
      } = _ref4;
      return id;
    })) : [];
    return {
      id: m.id,
      title: m.title,
      motherTasks: orderedMotherTasks.map(id => {
        const currentMotherTask = motherTask[id];
        const orderedActiveSpeakingTasks = currentMotherTask.speakingTasks.sort((t1, t2) => task[t1.id].orderIndex - task[t2.id].orderIndex).filter(t => task[t.id].status !== syllabus_model/* SyllabusTaskStatus */.p7.Deleted && (task[t.id].status === syllabus_model/* SyllabusTaskStatus */.p7.Active || task[t.id].state !== syllabus_model/* SyllabusTaskState */.YE.Initial));
        const orderedActiveSelfStudyTasks = currentMotherTask.selfStudyTasks.sort((t1, t2) => task[t1.id].orderIndex - task[t2.id].orderIndex).filter(t => task[t.id].status !== syllabus_model/* SyllabusTaskStatus */.p7.Deleted && (task[t.id].status === syllabus_model/* SyllabusTaskStatus */.p7.Active || task[t.id].state !== syllabus_model/* SyllabusTaskState */.YE.NotAdded));
        const orderedActiveInClassTasks = currentMotherTask.inClassTasks.sort((t1, t2) => task[t1.id].orderIndex - task[t2.id].orderIndex).filter(t => task[t.id].status !== syllabus_model/* SyllabusTaskStatus */.p7.Deleted && (task[t.id].status === syllabus_model/* SyllabusTaskStatus */.p7.Active || task[t.id].state !== syllabus_model/* SyllabusTaskState */.YE.Initial));
        const selfStudyTasks = orderedActiveSelfStudyTasks.map(_ref5 => {
          let {
            id: taskId
          } = _ref5;
          return {
            id: taskId,
            type: syllabus_model/* SyllabusTaskType */.vG.SelfStudy
          };
        });
        return {
          id: currentMotherTask.id,
          title: currentMotherTask.title,
          selfStudyTasks,
          inClassTasks: orderedActiveInClassTasks.map(_ref6 => {
            let {
              id: taskId
            } = _ref6;
            return {
              id: taskId,
              type: syllabus_model/* SyllabusTaskType */.vG.InClass
            };
          }),
          tasks: orderedActiveSpeakingTasks.map(_ref7 => {
            let {
              id: taskId
            } = _ref7;
            return {
              id: taskId,
              type: syllabus_model/* SyllabusTaskType */.vG.Speaking
            };
          })
        };
      }).filter(mt => {
        const currentMotherTask = motherTask[mt.id];
        const hasNoProgress = ![syllabus_model/* SyllabusMotherTaskState */.CZ.Initial, syllabus_model/* SyllabusMotherTaskState */.CZ.Skipped].includes(currentMotherTask.state);
        const deleted = currentMotherTask.status === syllabus_model/* SyllabusTaskStatus */.p7.Deleted;
        const archived = currentMotherTask.status === syllabus_model/* SyllabusTaskStatus */.p7.Archived;
        return !deleted && (!archived || hasNoProgress);
      })
    };
  });
  const fsmStates = {
    module: mapRawFSM(response.syllabus.content_types.MODULE.params.statuses.fsm, mapRawFSMStateToModuleState, response.syllabus.content_types.MODULE),
    motherTask: mapRawFSM(response.syllabus.content_types.MOTHER_TASK.params.statuses.fsm, mapRawFSMStateToMotherTaskState, response.syllabus.content_types.MOTHER_TASK),
    selfStudyTask: mapRawFSM(response.syllabus.content_types.SELF_STUDY_TASK.params.statuses.fsm, mapRawFSMStateToSelfStudyState, response.syllabus.content_types.SELF_STUDY_TASK),
    inClassTask: mapRawFSM(response.syllabus.content_types.IN_CLASS_TASK.params.statuses.fsm, mapRawFSMStateToTaskState, response.syllabus.content_types.IN_CLASS_TASK),
    speakingTask: mapRawFSM(response.syllabus.content_types.SPEAKING_TASK.params.statuses.fsm, mapRawFSMStateToTaskState, response.syllabus.content_types.SPEAKING_TASK)
  };
  return {
    module,
    motherTask,
    task,
    modules,
    fsmStates
  };
};
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/api/events/events.raw-model.ts



const RawSyllabusNodeEvents = es6.keyof({
  open_node: es6["null"],
  close_node: es6["null"],
  finish_node: es6["null"],
  progress_node: es6["null"],
  skip_node: es6["null"],
  unskip_node: es6["null"],
  assign_node: es6["null"],
  unassign_node: es6["null"],
  reset_node: es6["null"],
  add_in_lesson_node: es6["null"],
  remove_from_lesson_node: es6["null"],
  unknown_event: es6["null"]
});
const RawSpeakingSessionEvents = es6.keyof({
  start: es6["null"],
  stop: es6["null"],
  unknown: es6["null"],
  cancel: es6["null"],
  schedule_cancelled_lesson: es6["null"]
});
;// CONCATENATED MODULE: ./src/api/student/syllabus/syllabus.raw-model.ts




const RawSyllabusName = es6.keyof({
  beginners: es6["null"]
});
const RawSyllabusState = es6.keyof({
  active: es6["null"]
});
const RawSyllabusParams = es6.type({});
const RawSyllabusNodeStatus = es6.keyof({
  active: es6["null"],
  archived: es6["null"],
  deleted: es6["null"]
});
const BaseRawContent = es6.type({
  id: es6.string,
  chapter_id: es6.union([es6.string, es6["null"]]),
  parent_node_id: es6.string,
  syllabus_id: es6.string,
  start_node: es6.boolean,
  status: RawSyllabusNodeStatus
});
const MotherTaskNodeParams = es6.type({
  name: es6.string,
  grammar: es6.union([es6.undefined, es6.array(es6.string)]),
  reading: es6.union([es6.undefined, es6.array(es6.string)]),
  core_lexis: es6.union([es6.undefined, es6.array(es6.string)]),
  description: es6.union([es6.undefined, es6.string]),
  funky_language: es6.union([es6.undefined, es6.array(es6.string)]),
  target_language: es6.union([es6.undefined, es6.array(es6.string)]),
  additional_lexis: es6.union([es6.undefined, es6.array(es6.string)])
});
const RawSyllabusNodeState = es6.keyof({
  available: es6["null"],
  not_available: es6["null"],
  finished: es6["null"],
  in_lesson: es6["null"],
  in_progress: es6["null"],
  skipped: es6["null"],
  assigned: es6["null"],
  not_assigned: es6["null"],
  null: es6["null"]
});
const RawSyllabusNodeAttributes = es6.partial({
  is_favorite: es6.boolean,
  assigned_at: es6.string,
  mother_task_id: es6.string,
  speaking_session_id: es6.string
});
const RawSyllabusNodeStateData = es6.intersection([es6.type({
  state: RawSyllabusNodeState
}), es6.partial({
  attributes: RawSyllabusNodeAttributes,
  node_id: es6.string,
  created_at: es6.string,
  updated_at: es6.string
})]);
const RawSyllabusNodeAttributesData = es6.type({
  data: es6.type({
    syllabus_node_state: es6.type({
      node_id: es6.string,
      state: RawSyllabusNodeState,
      attributes: RawSyllabusNodeAttributes,
      created_at: es6.string,
      updated_at: es6.string
    })
  })
});
const SubtaskType = es6.keyof({
  speaking_task: es6["null"],
  speaking_revision: es6["null"],
  speaking_extension: es6["null"],
  in_class_stage: es6["null"],
  self_study: es6["null"]
});
const InstructionTitles = es6.keyof({
  Aim: es6["null"],
  TL: es6["null"],
  Procedure: es6["null"],
  Say: es6["null"],
  Tip: es6["null"],
  Time: es6["null"]
});
const RawTaskInstruction = es6.record(InstructionTitles, es6.array(es6.string));
const Subtask = es6.type({
  id: es6.string,
  chapter_id: es6.union([es6.string, es6["null"]]),
  node_params: es6.intersection([es6.partial({
    "Teacher's Instructions": RawTaskInstruction
  }), es6.type({
    Header: es6.string,
    type: SubtaskType,
    "nanochapter id": es6.string,
    speaking_id: es6.string,
    index: es6.number
  })]),
  status: RawSyllabusNodeStatus
});
const RawBaseTaskContent = es6.partial({
  content: es6.type({
    SUBTASK: es6.record(es6.string, Subtask)
  })
});
const BaseTaskNodeParams = es6.type({
  fl: es6.union([es6.undefined, es6.array(es6.string)]),
  name: es6.string,
  lexis: es6.union([es6.undefined, es6.array(es6.string)]),
  grammar: es6.union([es6.undefined, es6.array(es6.string)]),
  description: es6.union([es6.undefined, es6.string]),
  notion_id: es6.string,
  subtype: es6.string,
  index: es6.number
});
const SpeakingTaskTypes = es6.keyof({
  task: es6["null"],
  diagnostic: es6["null"],
  milestone: es6["null"],
  foreigner_preparation: es6["null"],
  revision: es6["null"]
});
const SpeakingTaskSubtype = es6.keyof({
  "speaking: milestone": es6["null"],
  "speaking: foreigner preparation": es6["null"]
});
const SpeakingTaskContent = es6.intersection([BaseRawContent, RawBaseTaskContent, es6.type({
  node_params: es6.intersection([BaseTaskNodeParams, es6.type({
    type: SpeakingTaskTypes,
    subtype: SpeakingTaskSubtype,
    is_favorite: es6.boolean,
    lesson_date: es6.string,
    lesson_theme: es6.string,
    lesson_duration_min: es6.number
  })])
})]);
const InClassTaskContent = es6.intersection([BaseRawContent, RawBaseTaskContent, es6.type({
  node_params: BaseTaskNodeParams
})]);
const SelfStudyTypes = es6.keyof({
  grammar: es6["null"],
  lexis: es6["null"],
  phrases: es6["null"],
  story: es6["null"],
  model_dialogue: es6["null"],
  reading: es6["null"],
  other: es6["null"]
});
const SelfStudyTaskContent = es6.intersection([BaseRawContent, RawBaseTaskContent, es6.type({
  node_params: es6.intersection([es6.type({
    type: SelfStudyTypes,
    notion_id: es6.string,
    subtype: es6.string
  }), BaseTaskNodeParams])
})]);
const RawSpeakingTaskRecord = es6.record(es6.string, SpeakingTaskContent);
const MotherTaskContent = es6.intersection([BaseRawContent, es6.partial({
  content: es6.partial({
    SPEAKING_TASK: RawSpeakingTaskRecord,
    IN_CLASS_TASK: es6.record(es6.string, InClassTaskContent),
    SELF_STUDY_TASK: es6.record(es6.string, SelfStudyTaskContent)
  })
}), es6.type({
  type_name: es6.keyof({
    MOTHER_TASK: es6.string
  }),
  node_params: MotherTaskNodeParams
})]);
const MotherTaskContentType = es6.keyof({
  SPEAKING_TASK: null,
  IN_CLASS_TASK: null,
  SELF_STUDY_TASK: null
});
const RawTask = es6.union([SpeakingTaskContent, InClassTaskContent, SelfStudyTaskContent]);
const MotherTaskContentRecord = es6.record(es6.string, MotherTaskContent);
const ModuleNodeParams = es6.type({
  name: es6.string,
  grammar: es6.union([es6.undefined, es6.array(es6.string)]),
  core_lexis: es6.union([es6.undefined, es6.array(es6.string)]),
  description: es6.union([es6.undefined, es6.array(es6.string)]),
  funky_language: es6.union([es6.undefined, es6.array(es6.string)]),
  extension_lexis: es6.union([es6.undefined, es6.array(es6.string)])
});
const RawModuleContent = es6.intersection([BaseRawContent, es6.type({
  type_name: es6.keyof({
    MODULE: es6.string
  }),
  node_params: ModuleNodeParams,
  content: es6.union([es6.type({
    MOTHER_TASK: MotherTaskContentRecord
  }), es6.undefined])
})]);
const ModuleContentRecord = es6.record(es6.string, RawModuleContent);
const RawNodeStatusesRecord = es6.record(RawSyllabusNodeEvents, es6.record(RawSyllabusNodeState, RawSyllabusNodeState));
const ContentTypeParams = es6.type({
  statuses: es6.type({
    fsm: RawNodeStatusesRecord,
    initial_state: RawSyllabusNodeState
  }),
  allowed_parents: es6.array(es6.string)
});
const RawSyllabusRelation = es6.array(es6.type({
  next_node_id: es6.union([es6.string, es6["null"]]),
  params: es6.type({
    id: es6.number,
    parent_node_id: es6.union([es6.string, es6["null"]]),
    lhs_node_id: es6.string,
    rhs_node_id: es6.string,
    criterion_id: es6.union([es6.string, es6["null"]]),
    criterion_descrtiption: es6.union([es6.string, es6["null"]]),
    criterion_formula: es6["null"]
  })
}));
const RawRelationsRecord = es6.record(es6.string, RawSyllabusRelation);
const RawSyllabus = es6.type({
  id: es6.string,
  name: RawSyllabusName,
  state: RawSyllabusState,
  params: RawSyllabusParams,
  content_types: es6.type({
    MODULE: es6.type({
      params: ContentTypeParams
    }),
    MOTHER_TASK: es6.type({
      params: ContentTypeParams
    }),
    SPEAKING_TASK: es6.type({
      params: ContentTypeParams
    }),
    IN_CLASS_TASK: es6.type({
      params: ContentTypeParams
    }),
    SELF_STUDY_TASK: es6.type({
      params: ContentTypeParams
    }),
    SUBTASK: es6.type({
      params: ContentTypeParams
    })
  }),
  created_at: es6.string,
  updated_at: es6.string,
  content: es6.type({
    MODULE: ModuleContentRecord
  }),
  relations: es6.record(es6.string, RawSyllabusRelation)
});
const RawSyllabusNodesStateRecord = es6.record(es6.string, RawSyllabusNodeStateData);
const SyllabusRawModel = es6.type({
  syllabus: RawSyllabus,
  syllabus_state: RawSyllabusNodesStateRecord
});
const SelfStudyRawModel = es6.type({
  data: es6.type({
    self_study: es6.record(es6.string, es6.type({
      state: RawSyllabusNodeState,
      attributes: RawSyllabusNodeAttributes,
      params: BaseTaskNodeParams,
      status: RawSyllabusNodeStatus,
      chapter_id: es6.union([es6.string, es6["null"]]),
      syllabus_id: es6.string,
      parent_node_name: es6.union([es6.string, es6["null"]]),
      module_name: es6.union([es6.string, es6["null"]]),
      created_at: es6.string
    }))
  })
});
;// CONCATENATED MODULE: ./src/api/student/syllabus/syllabus.api.ts







const getSyllabus = params => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/syllabus/${params.syllabusId}`, {
  responseType: SyllabusRawModel,
  resultMapper: mapRawSyllabus
});
const getSelfStudy = (0,un_either/* unEither */.K)(params => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/self-study-v2/${params.businessProductId}`, {
  responseType: SelfStudyRawModel,
  resultMapper: mapRawSelfStudy
}));
const getStudentSyllabus = params => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student/${params.studentId}/syllabus/${params.syllabusId}`, {
  responseType: SyllabusRawModel,
  resultMapper: mapRawSyllabus
});
const getSyllabusNode = params => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/syllabus-node-state/${params.syllabusNodeId}`, {
  responseType: RawSyllabusNodeAttributesData,
  resultMapper: mapRawSyllabusAttributes
});

/***/ }),

/***/ 48216:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MA: () => (/* binding */ DEFAULT_SELF_STUDY_TYPE_DURATION),
/* harmony export */   cg: () => (/* binding */ SYLLABUS_SELF_STUDY_TYPES),
/* harmony export */   jc: () => (/* binding */ DEFAULT_SELF_STUDY_TYPE_NAME_KEY)
/* harmony export */ });


const SYLLABUS_SELF_STUDY_TYPES = {
  ["self: lexis"]: {
    duration: 4,
    nameKey: "beginerTasksPage.lexis"
  },
  ["self: reading"]: {
    duration: 3,
    nameKey: "beginerTasksPage.reading"
  },
  ["self: story"]: {
    duration: 10,
    nameKey: "beginerTasksPage.story"
  },
  ["self: grammar practice"]: {
    duration: 5,
    nameKey: "beginerTasksPage.grammarPractice"
  },
  ["self: functional language"]: {
    duration: 5,
    nameKey: "beginerTasksPage.functionalLanguage"
  },
  ["self: model dialogue"]: {
    duration: 3,
    nameKey: "beginerTasksPage.modelDialogue"
  },
  ["self: listening"]: {
    duration: 6,
    nameKey: "beginerTasksPage.listening"
  },
  ["self: literacy"]: {
    duration: 6,
    nameKey: "beginerTasksPage.literacy"
  },
  ["self: grammar reference"]: {
    duration: 7,
    nameKey: "beginerTasksPage.grammarReference"
  },
  ["self: learner training"]: {
    duration: 3,
    nameKey: "beginerTasksPage.learnerTraining"
  },
  ["self: foreigner preparation"]: {
    duration: 3,
    nameKey: "beginerTasksPage.foreignerPreparation"
  },
  ["self: revision"]: {
    duration: 4,
    nameKey: "beginerTasksPage.revision"
  },
  ["self: task"]: {
    duration: 15,
    nameKey: "beginerTasksPage.task"
  },
  ["self: words"]: {
    duration: 5,
    nameKey: "beginerTasksPage.words"
  },
  ["self: rules"]: {
    duration: 5,
    nameKey: "beginerTasksPage.rules"
  },
  ["self: writing"]: {
    duration: 10,
    nameKey: "beginerTasksPage.writing"
  },
  ["self: oral test"]: {
    duration: 15,
    nameKey: "beginerTasksPage.oralTest"
  },
  ["self: oral midcourse test"]: {
    duration: 15,
    nameKey: "beginerTasksPage.oralMidcourseTest"
  },
  ["self: oral exam"]: {
    duration: 20,
    nameKey: "beginerTasksPage.oralExam"
  },
  ["self: written test"]: {
    duration: 20,
    nameKey: "beginerTasksPage.writtenTest"
  },
  ["self: written midcourse test"]: {
    duration: 30,
    nameKey: "beginerTasksPage.writtenMidcourseTest"
  },
  ["self: written exam"]: {
    duration: 45,
    nameKey: "beginerTasksPage.writtenExam"
  },
  ["self: bus grammar"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busGrammar"
  },
  ["self: bus soft skills"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busSoftSkills"
  },
  ["self: bus lexis"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busLexis"
  },
  ["self: bus reading"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busReading"
  },
  ["self: bus listening"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busListening"
  },
  ["self: bus combined"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busCombined"
  },
  ["self: bus foreigner preparation"]: {
    duration: 45,
    nameKey: "beginerTasksPage.busForeignerPreparation"
  },
  ["self: bus analyst functions"]: {
    duration: 40,
    nameKey: "beginerTasksPage.busAnalystFunctions"
  },
  ["self: bus analyst vocabulary"]: {
    duration: 40,
    nameKey: "beginerTasksPage.busAnalystVocabulary"
  },
  ["self: bus analyst cards"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busAnalystCards"
  },
  ["self: bus analyst extra mile"]: {
    duration: 40,
    nameKey: "beginerTasksPage.busAnalystExtraMile"
  },
  ["self: bus analyst soft skills"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busAnalystSoftSkills"
  },
  ["self: bus analyst takeaway"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busAnalystTakeaway"
  },
  ["self: bus analyst useful language"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busAnalystUsefulLanguage"
  },
  ["self: bus analyst revision"]: {
    duration: 45,
    nameKey: "beginerTasksPage.busAnalystRevision"
  },
  ["self: bus analyst simulation"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busAnalystSimulation"
  },
  ["self: bus analyst preparation for simulation"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busAnalystPrepForSimulation"
  },
  ["self: bus analyst evaluation"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busAnalystEvaluation"
  },
  ["self: bus analyst final revision"]: {
    duration: 90,
    nameKey: "beginerTasksPage.busAnalystFinalRevision"
  },
  ["self: bus pm onboarding"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busPmOnboarding"
  },
  ["self: bus pm evaluation"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busPmEvaluation"
  },
  ["self: bus pm lesson preview"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busPmLessonPreview"
  },
  ["self: bus pm soft skills"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busPmSoftSkills"
  },
  ["self: bus pm grammar"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busPmGrammar"
  },
  ["self: bus pm lexical cards"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busPmCards"
  },
  ["self: bus pm takeaway"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busPmTakeaway"
  },
  ["self: bus pm lexis"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busPmLexis"
  },
  ["self: bus pm combined"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busPmCombined"
  },
  ["self: bus pm useful language"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busPmUsefulLanguage"
  },
  ["self: bus pm simulation"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busPmSimulation"
  },
  ["self: bus pm preparation for simulation"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busPmPrepForSimulation"
  },
  ["self: bus pm revision"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busPmRevision"
  },
  ["self: bus pm final revision"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busPmFinalRevision"
  },
  ["self: bus pm final module overview"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busPmFinalOverview"
  },
  ["self: bus pm course completion"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busPmCourseCompletion"
  },
  ["self: bus b1 onboarding"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busB1Onboarding"
  },
  ["self: bus b1 evaluation"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busB1Evaluation"
  },
  ["self: bus b1 lesson preview"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busB1LessonPreview"
  },
  ["self: bus b1 preparation for simulation"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busB1PrepForSimulation"
  },
  ["self: bus b1 simulation"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busB1Simulation"
  },
  ["self: bus b1 useful language"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busB1UsefulLanguage"
  },
  ["self: bus b1 takeaway"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busB1Takeaway"
  },
  ["self: bus b1 course completion"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busB1CourseCompletion"
  },
  ["self: bus b1 soft skills"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busB1SoftSkills"
  },
  ["self: bus b1 combined"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busB1Combined"
  },
  ["self: bus b1 grammar"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busB1Grammar"
  },
  ["self: bus b1 lexis"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busB1Lexis"
  },
  ["self: bus b1 listening"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busB1Listening"
  },
  ["self: bus b1 reading"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busB1Reading"
  },
  ["self: bus b1 writing"]: {
    duration: 20,
    nameKey: "beginerTasksPage.busB1Writing"
  },
  ["self: bus b1 pronunciation"]: {
    duration: 15,
    nameKey: "beginerTasksPage.busB1Pronunciation"
  },
  ["self: bus b1 lexical cards"]: {
    duration: 10,
    nameKey: "beginerTasksPage.busB1Cards"
  },
  ["self: bus b1 revision"]: {
    duration: 30,
    nameKey: "beginerTasksPage.busB1Revision"
  },
  ["self: bus b1 final module overview"]: {
    duration: 5,
    nameKey: "beginerTasksPage.busB1FinalOverview"
  },
  ["self: bus b1 survey"]: {
    duration: 7,
    nameKey: "beginerTasksPage.busB1Survey"
  }
};
const DEFAULT_SELF_STUDY_TYPE_DURATION = null;
const DEFAULT_SELF_STUDY_TYPE_NAME_KEY = "beginerTasksPage.other";

/***/ }),

/***/ 40116:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  mb: () => (/* binding */ createProductProgress),
  gy: () => (/* binding */ createProgress),
  mL: () => (/* binding */ getChapterState),
  VI: () => (/* binding */ getProductChapterState),
  Dx: () => (/* binding */ getRepetitionAvailability),
  b_: () => (/* binding */ getRepetitionState)
});

// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/api/api.utils.ts
var api_utils = __webpack_require__(11568);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.model.ts
var trainer_model = __webpack_require__(92601);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.raw-mapper.ts
var trainer_raw_mapper = __webpack_require__(49647);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/student/trainer/trainer.urls.ts



const studentTrainerUrlPrefix = `${(0,site_utils/* getAPIPath */.NZ)()}/student/trainer`;
const CREATE_PROGRESS = studentTrainerUrlPrefix;
const GET_CHAPTER_STATE = chapterId => `${studentTrainerUrlPrefix}/chapter/${chapterId}`;
const GET_PRODUCT_CHAPTER_STATE = (productId, chapterId) => `${(0,site_utils/* getAPIPath */.NZ)()}/v2/student/trainer/chapter/${productId}/${chapterId}`;
const CREATE_PRODUCT_PROGRESS = `${(0,site_utils/* getAPIPath */.NZ)()}/v2/student/trainer`;
const GET_REPETITION = `${studentTrainerUrlPrefix}/repetition`;
const GET_REPETITION_V2 = `${studentTrainerUrlPrefix}/repetition-v2`;
const GET_REPETITION_AVAILABILITY = `${studentTrainerUrlPrefix}/repetition-availability`;
const GET_REPETITION_AVAILABILITY_V2 = `${studentTrainerUrlPrefix}/repetition-availability-v2`;
;// CONCATENATED MODULE: ./src/api/student/trainer/trainer.api.ts











const createProgress = requestBody => (0,api_utils/* http */.d)(CREATE_PROGRESS, "POST", requestBody);
const createProductProgress = requestBody => (0,http/* makeRequest */.$f)(CREATE_PRODUCT_PROGRESS, {
  method: "POST",
  responseType: trainer_model/* CreateProductProgressResponse */.rJ,
  body: requestBody
});
function errorMapper(error) {
  if (error.code === "invalid_sprint_state") {
    return trainer_model/* ChapterStateError */.CU.InvalidSprintState;
  }
  return api_model/* unexpectedError */.g;
}
const getChapterState = chapterId => (0,http/* makeRequest */.$f)(GET_CHAPTER_STATE(chapterId), {
  responseType: trainer_model/* GetChapterStateResponse */.Nf,
  errorMapper
});
const getProductChapterState = async (productId, chapterId, hideGrammarAndLexis) => {
  const conversionTrialIdsTempPromise = (0,bunker_api/* getConversionTrialIdsTemp */.QE)();
  const result = await (0,http/* makeRequest */.$f)(GET_PRODUCT_CHAPTER_STATE(productId, chapterId), {
    responseType: trainer_model/* GetProductChapterStateResponseRaw */.Cx,
    resultMapper: response => (0,trainer_raw_mapper/* mapRawChapterState */.x)(response, hideGrammarAndLexis),
    errorMapper
  });
  if ((0,Either.isLeft)(result)) {
    return result;
  }
  const conversionTrialIdsTemp = await conversionTrialIdsTempPromise;
  const isTrialChapter = (0,Either.isLeft)(conversionTrialIdsTemp) ? false : conversionTrialIdsTemp.right.trialChapters.includes(chapterId);
  return (0,Either.right)({
    isTrialChapter,
    ...result.right
  });
};
const getRepetitionState = async isV2 => (0,api_utils/* http */.d)(isV2 ? GET_REPETITION_V2 : GET_REPETITION);
const getRepetitionAvailability = (0,un_either/* unEither */.K)(isV2 => (0,http/* makeRequest */.$f)(isV2 ? GET_REPETITION_AVAILABILITY_V2 : GET_REPETITION_AVAILABILITY, {
  responseType: trainer_model/* RawRepetitionAvailabilityResponse */.k6,
  resultMapper: res => res.data.mastering_is_available
}));

/***/ }),

/***/ 92601:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CU: () => (/* binding */ ChapterStateError),
/* harmony export */   Cx: () => (/* binding */ GetProductChapterStateResponseRaw),
/* harmony export */   Gi: () => (/* binding */ makeParagraphId),
/* harmony export */   Nf: () => (/* binding */ GetChapterStateResponse),
/* harmony export */   bD: () => (/* binding */ makeTitleId),
/* harmony export */   k6: () => (/* binding */ RawRepetitionAvailabilityResponse),
/* harmony export */   rJ: () => (/* binding */ CreateProductProgressResponse)
/* harmony export */ });
/* unused harmony exports EventType, ChapterStudentEvent */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44352);
/* harmony import */ var _trainer_trainer_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98938);





const StudentData = io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  answer: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  correct: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  progress: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  mastering_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  typo: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean, io_ts__WEBPACK_IMPORTED_MODULE_2__["null"]]),
  maxPossibleScore: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  rightAnswersScore: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  skill: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  optionDescription: io_ts__WEBPACK_IMPORTED_MODULE_2__.record(io_ts__WEBPACK_IMPORTED_MODULE_2__.number, io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    isRight: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
    answer: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
  }))
});
const CreateProductProgressResponse = io_ts__WEBPACK_IMPORTED_MODULE_2__.record(io_ts__WEBPACK_IMPORTED_MODULE_2__.string, io_ts__WEBPACK_IMPORTED_MODULE_2__.unknown);
const EventType = io_ts__WEBPACK_IMPORTED_MODULE_2__.keyof({
  trainer_progress: null,
  trainer_progress_final: null,
  trainer_result: null,
  trainer_progress_init: null,
  revision_progress_init: null,
  revision_progress: null,
  revision_progress_final: null,
  revision_result: null,
  onboarding_result: null,
  onboarding_progress: null,
  placement_result: null,
  placement_progress: null,
  class_change_block_state: null,
  tutor_onboarding_result: null,
  tutor_onboarding_progress: null,
  repetition_result: null,
  repetition_progress: null,
  repetition_progress_final: null,
  class_mentor_init: null,
  class_disconnect: null,
  class_exit: null,
  class_result: null,
  class_progress: null,
  class_change_chat_state: null,
  class_ondemand_change_block_state: null,
  class_ondemand_change_chat_state: null,
  class_ondemand_result: null,
  class_ondemand_progress: null,
  tutor_onboarding_progress_final: null,
  class_connect: null,
  class_log: null,
  class_webrtc_log: null,
  class_webrtc_error_log: null,
  __internal_promo_result: null,
  cust_dev_progress_init: null,
  cust_dev_result: null,
  cust_dev_progress: null,
  cust_dev_progress_final: null
});
const ChapterStudentEvent = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  activity_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  block_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  attempt_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  chapter_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  course_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  created_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  level_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  revision_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  student_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  topic_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  data: StudentData,
  event_type: EventType
})]);
const GetChapterStateResponse = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  chapter_structure: io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
    title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
    activities: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_1__/* .Activity */ .cS)
  }), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
    is_active: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
  })]),
  chapter_info: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    course_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
    level_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
    topic_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
  }),
  chapter_student_data: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(ChapterStudentEvent),
  chapter_is_last_in_sprint: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  chapter_speaking_is_unscheduled: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
});
const GetProductChapterStateResponseRaw = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  chapter_structure: io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
    title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
    activities: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_1__/* .Activity */ .cS)
  }), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
    is_active: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
  })]),
  chapter_student_data: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(ChapterStudentEvent),
  chapter_is_last_in_sprint: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  chapter_speaking_is_unscheduled: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
});
var ChapterStateError = /* @__PURE__ */(ChapterStateError2 => {
  ChapterStateError2["InvalidSprintState"] = "InvalidSprintState";
  return ChapterStateError2;
})(ChapterStateError || {});
var TitleTag = /* @__PURE__ */(TitleTag2 => {})(TitleTag || {});
var ParagraphTag = /* @__PURE__ */(ParagraphTag2 => {})(ParagraphTag || {});
const makeTitleId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();
const makeParagraphId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();
const RawRepetitionAvailabilityResponse = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    mastering_is_available: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
  })
});

/***/ }),

/***/ 49647:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: () => (/* binding */ mapRawChapterState)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_has_own_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20110);
/* harmony import */ var core_js_modules_es_object_has_own_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_has_own_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26540);
/* harmony import */ var core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17863);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var immutable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27623);
/* harmony import */ var _utils_trainer_trainer_event_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99543);















const mapRawChapterState = (rawResponse, hideGrammarAndLexis) => {
  const {
    activities,
    title
  } = rawResponse.chapter_structure;
  const chapterStudentEvents = {};
  const studentData = rawResponse.chapter_student_data;
  studentData.forEach(event => {
    if (Object.hasOwn(chapterStudentEvents, event.block_id)) {
      chapterStudentEvents[event.block_id].push(event);
    } else {
      chapterStudentEvents[event.block_id] = [event];
    }
  });
  const isFinalEventExist = studentData.some(event => event.event_type === _utils_trainer_trainer_event_types__WEBPACK_IMPORTED_MODULE_12__/* .trainerEventType */ .z.progressFinal);
  const completeBlocksIdSet = immutable__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Set */ .ZP.Set(studentData.filter(event => event.event_type === _utils_trainer_trainer_event_types__WEBPACK_IMPORTED_MODULE_12__/* .trainerEventType */ .z.progress).map(event => event.block_id));
  const productTrainerEvents = studentData.filter(d => d.event_type && _utils_trainer_trainer_event_types__WEBPACK_IMPORTED_MODULE_12__/* .trainerEventTypes */ .s.includes(d.event_type));
  const lastEvent = productTrainerEvents.sort((e1, e2) => new Date(e2.created_at || "").getTime() - new Date(e1.created_at || "").getTime())[0];
  const showSkipButton = activities.some(activity => activity.meta?.["show-skip-button"]);
  return {
    activities: hideGrammarAndLexis ? activities.filter(a => !["lexis", "grammar"].includes(a.type)) : activities,
    settings: {
      showSkipButton
    },
    chapterStudentEvents,
    completeBlocksIdSet,
    isSpeakingUnscheduled: rawResponse.chapter_speaking_is_unscheduled,
    isFinalEventExist,
    lastEvent,
    title
  };
};

/***/ }),

/***/ 49357:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ DEFAULT_TERMS_PER_WORDBANK_PAGE)
/* harmony export */ });


const DEFAULT_TERMS_PER_WORDBANK_PAGE = 20;

/***/ }),

/***/ 23643:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  zb: () => (/* binding */ deleteWordBankTerm),
  s9: () => (/* binding */ getLearnedWordbankTerms),
  jP: () => (/* binding */ getWordBankTooltip),
  Gk: () => (/* binding */ getWordbankTerms),
  Is: () => (/* binding */ postTermInWordBank),
  r6: () => (/* binding */ postWordBankTooltip),
  pd: () => (/* binding */ setTermLearnedStatus),
  nP: () => (/* binding */ translateTermInContext)
});

// UNUSED EXPORTS: getTranslations

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ./src/api/student/wordbank/constants.ts
var constants = __webpack_require__(49357);
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
;// CONCATENATED MODULE: ./src/api/student/wordbank/wordbank.mappers.ts





const mapPartOfSpeechToTankerKey = rawPartOfSpeech => {
  switch (rawPartOfSpeech) {
    case "ADJ":
      return "wordTranslations.adj";
    case "ADV":
      return "wordTranslations.adv";
    case "CONJ":
      return "wordTranslations.conj";
    case "DET":
      return "wordTranslations.det";
    case "INTJ":
      return "wordTranslations.interj";
    case "NUM":
      return "wordTranslations.num";
    case "PART":
      return "wordTranslations.particle";
    case "ADP":
      return "wordTranslations.prep";
    case "PRON":
      return "wordTranslations.pron";
    case "VERB":
      return "wordTranslations.v";
    case "NOUN":
      return "wordTranslations.n";
    case "AUX":
      return "wordTranslations.aux";
    case "PROPN":
      return "wordTranslations.propn";
    case "SCONJ":
      return "wordTranslations.sconj";
    case "CCONJ":
      return "wordTranslations.sconj";
    default:
      return "wordTranslations.unknown";
  }
};
const mapRawTermTranslationInContextResponse = response => {
  const {
    term: {
      id,
      definitions,
      part_of_speech: partOfSpeech
    },
    tokens,
    is_in_wordbank
  } = response.data;
  const word = tokens.map((t, index) => {
    if (index !== 0 && tokens[index].start !== tokens[index - 1].end) {
      return " " + t.token;
    }
    return t.token;
  }).join("");
  const translations = definitions.slice(0, 3).map(d => d.translations[0].translation);
  return {
    id,
    word,
    addedInWordbank: is_in_wordbank,
    partOfSpeech: mapPartOfSpeechToTankerKey(partOfSpeech),
    translations
  };
};
const mapRawTerms = _ref => {
  let {
    data,
    data: {
      count,
      total_count: totalCount
    }
  } = _ref;
  const terms = data.student_wordbank_terms.map(t => ({
    id: t.term.id,
    term: t.term.term,
    termType: t.term.term_type,
    translations: t.term.definitions.map(definition => definition.translations[0]?.translation),
    reference: t.chapter !== null && t.product !== null ? {
      title: t.chapter.title,
      link: t.product.id && t.chapter.id ? `${studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(t.product.id, t.chapter.id, t?.activity_id)}#${t.block_id}` : null
    } : void 0,
    learned: t.marked_as_learned,
    partOfSpeech: mapPartOfSpeechToTankerKey(t.term.part_of_speech),
    context: t.contexts.length !== 0 ? t.contexts[0].context : "",
    repetitionDate: t.last_practice_at,
    updateDate: t.added_at * 1e3
  }));
  return {
    terms,
    count,
    totalCount
  };
};
;// CONCATENATED MODULE: ./src/api/student/wordbank/wordbank.model.ts


var PostTermError = /* @__PURE__ */(PostTermError2 => {
  PostTermError2["TermAlreadyAdded"] = "termAlreadyAdded";
  return PostTermError2;
})(PostTermError || {});
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/student/wordbank/wordbank.raw-model.ts



const RawPartOfSpeech = es6.keyof({
  ADJ: null,
  ADV: null,
  CONJ: null,
  DET: null,
  INTJ: null,
  NUM: null,
  PART: null,
  ADP: null,
  PRON: null,
  VERB: null,
  NOUN: null,
  AUX: null,
  PROPN: null,
  SCONJ: null,
  CCONJ: null,
  PHRASE: null
});
const TermType = es6.union([es6.literal("word"), es6.literal("highlight"), es6.literal("tooltip")]);
const RawTerm = es6.intersection([es6.type({
  id: es6.string,
  term: es6.string,
  part_of_speech: RawPartOfSpeech,
  definitions: es6.array(es6.type({
    term: es6.string,
    transcription: es6.string,
    translations: es6.array(es6.type({
      translation: es6.string,
      part_of_speech: es6.string,
      synonyms: es6.array(es6.string),
      examples: es6.array(es6.type({
        text: es6.string,
        translation: es6.string
      }))
    }))
  })),
  is_tooltip: es6.boolean
}), es6.partial({
  term_type: TermType
})]);
const RawWordbankTerm = es6.type({
  term: RawTerm,
  added_at: es6.number,
  last_practice_at: es6.union([es6["null"], es6.number]),
  marked_as_learned: es6.boolean,
  chapter: es6.type({
    id: es6.string,
    title: es6.string
  }),
  product: es6.type({
    id: es6.string,
    title: es6.string
  }),
  activity_id: es6.string,
  block_id: es6.string,
  contexts: es6.array(es6.type({
    id: es6.string,
    context: es6.string,
    translation: es6.string
  }))
});
const RawGetTermTranslationInContextResponse = es6.type({
  data: es6.type({
    context_translation: es6.string,
    term_translation: es6.string,
    is_in_wordbank: es6.boolean,
    tokens: es6.array(es6.type({
      start: es6.number,
      end: es6.number,
      token: es6.string
    })),
    term: RawTerm
  })
});
const RawTermInWordbankResponse = es6.type({
  data: es6.type({
    count: es6.number,
    student_wordbank_terms: es6.array(RawWordbankTerm),
    total_count: es6.number
  })
});
const RawDeleteTermResponse = es6.type({});
const RawPUTTermResponse = es6.type({
  data: es6.type({
    student_wordbank_term: RawWordbankTerm
  })
});
const RawGetTooltipResponse = es6.type({
  data: es6.type({
    context_translation: es6.string,
    term: RawTerm,
    is_in_wordbank: es6.boolean
  })
});
const RawPostTooltipResponse = es6.type({
  data: es6.type({
    student_wordbank_term: RawWordbankTerm
  })
});
const wordbank_raw_model_RawGetTranslationsResponse = es6.type({
  data: es6.type({
    terms: es6.array(RawTerm)
  })
});
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/student/wordbank/wordbank.urls.ts






const urlPrefix = `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank`;
const GET_TERM_IN_CONTEXT = (context, tokenIndex) => {
  const params = new URLSearchParams();
  params.append("token_index", String(tokenIndex));
  params.append("context", context);
  return `${urlPrefix}/translate-term-in-context?${params}`;
};
const wordbank_urls_GET_TRANSLATIONS = query => {
  const params = new URLSearchParams();
  params.append("query", query);
  return `${urlPrefix}/translate?${params}`;
};
const POST_WORDBANK_TERMS = () => `${urlPrefix}/terms`;
const WORDBANK_TERMS = (_ref, isV2) => {
  let {
    learned,
    sortBy,
    perPage = 999,
    page = 1
  } = _ref;
  const params = new URLSearchParams();
  params.append("page", String(page));
  params.append("per_page", String(perPage));
  if (learned) {
    params.append("filter_marked_as_learned", learned ? "true" : "false");
  }
  if (sortBy) {
    params.append("sort", sortBy);
  }
  if (!isV2) {
    return `${urlPrefix}/terms?${params}`;
  }
  return `${urlPrefix}/translate-v2/dictionary?${params}`;
};
const CHANGE_WORDBANK_TERM = (id, termType) => !termType ? `${urlPrefix}/terms/${id}` : `${urlPrefix}/student-dictionary/${id}`;
const GET_TOOLTIP = (context, term, translation, blockKey) => {
  const params = new URLSearchParams();
  params.append("context", context);
  params.append("term", String(term));
  params.append("translation", String(translation));
  params.append("chapter_id", String(blockKey?.chapterId));
  params.append("activity_id", String(blockKey?.activityId));
  params.append("block_id", String(blockKey?.blockId));
  return `${urlPrefix}/tooltip?${params}`;
};
const POST_TOOLTIPS = () => `${urlPrefix}/tooltips`;
;// CONCATENATED MODULE: ./src/api/student/wordbank/wordbank.api.ts











const translateTermInContext = (context, tokenIndex) => (0,http/* makeRequest */.$f)(GET_TERM_IN_CONTEXT(context, tokenIndex), {
  method: "GET",
  responseType: RawGetTermTranslationInContextResponse,
  resultMapper: response => ({
    ...mapRawTermTranslationInContextResponse(response),
    context
  })
});
const postTermInWordBank = _ref => {
  let {
    blockKey,
    termId,
    context
  } = _ref;
  return (0,http/* makeRequest */.$f)(POST_WORDBANK_TERMS(), {
    method: "POST",
    body: {
      product_id: blockKey?.productId,
      activity_id: blockKey?.activityId,
      block_id: blockKey?.blockId,
      term_id: termId,
      chapter_id: blockKey?.chapterId,
      context
    },
    responseType: RawTermInWordbankResponse,
    errorMapper: rawErrorContent => {
      if (rawErrorContent.code === "term_already_added") {
        return PostTermError.TermAlreadyAdded;
      }
      return api_model/* unexpectedError */.g;
    }
  });
};
const getWordbankTerms = (_ref2, isV2) => {
  let {
    page,
    sortBy = "term",
    perPage = constants/* DEFAULT_TERMS_PER_WORDBANK_PAGE */.n
  } = _ref2;
  return (0,http/* makeRequest */.$f)(WORDBANK_TERMS({
    sortBy,
    page,
    perPage
  }, isV2), {
    responseType: RawTermInWordbankResponse,
    resultMapper: mapRawTerms
  });
};
const getLearnedWordbankTerms = (_ref3, isV2) => {
  let {
    page,
    perPage = constants/* DEFAULT_TERMS_PER_WORDBANK_PAGE */.n
  } = _ref3;
  return (0,http/* makeRequest */.$f)(WORDBANK_TERMS({
    sortBy: "term",
    learned: true,
    page,
    perPage
  }, isV2), {
    responseType: RawTermInWordbankResponse,
    resultMapper: mapRawTerms
  });
};
const deleteWordBankTerm = (termId, termType) => (0,http/* makeRequest */.$f)(CHANGE_WORDBANK_TERM(termId, termType), {
  method: "DELETE",
  body: {
    term_type: termType
  },
  responseType: RawDeleteTermResponse
});
const setTermLearnedStatus = (termId, learned, termType) => (0,http/* makeRequest */.$f)(CHANGE_WORDBANK_TERM(termId, termType), {
  method: "PUT",
  responseType: RawPUTTermResponse,
  body: {
    term_type: termType,
    marked_as_learned: learned
  }
});
const getWordBankTooltip = (context, term, translation, blockKey) => (0,http/* makeRequest */.$f)(GET_TOOLTIP(context, term, translation, blockKey), {
  method: "GET",
  responseType: RawGetTooltipResponse,
  resultMapper: response => ({
    id: response.data.term.id,
    word: term,
    partOfSpeech: "",
    addedInWordbank: response.data.is_in_wordbank,
    translations: [translation],
    context
  })
});
const postWordBankTooltip = _ref4 => {
  let {
    blockKey,
    termId
  } = _ref4;
  return (0,http/* makeRequest */.$f)(POST_TOOLTIPS(), {
    method: "POST",
    body: {
      term_id: termId,
      product_id: blockKey?.productId
    },
    responseType: RawPostTooltipResponse,
    errorMapper: () => api_model/* unexpectedError */.g
  });
};
const getTranslations = query => makeRequest(GET_TRANSLATIONS(query), {
  method: "GET",
  responseType: RawGetTranslationsResponse,
  resultMapper: response => {
    const responseTerm = response.data.terms[0].definitions[0];
    return {
      term: responseTerm.term,
      transcription: responseTerm.transcription,
      translations: responseTerm.translations.map(t => ({
        translation: t.translation,
        partOfSpeech: t.part_of_speech,
        example: t.examples[0]?.text ?? ""
      }))
    };
  }
});

/***/ }),

/***/ 98938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   cS: () => (/* binding */ Activity)
/* harmony export */ });
/* unused harmony exports MechanicHint, Context, MechanicFeedback */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97703);
/* harmony import */ var _utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64866);





const ActivityType = io_ts__WEBPACK_IMPORTED_MODULE_2__.keyof({
  story: null,
  grammar: null,
  lexis: null,
  test: null
});
const mechanicIdsKey = "mechanic-ids";
const MechanicHint = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  target: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  source: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
})]);
const MechanicClueButton = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  text: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  button: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  "action-button": io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  "grammar-reference-id": io_ts__WEBPACK_IMPORTED_MODULE_2__.string
})]);
const Context = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  context: _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_0__/* .ArrayOfString */ .IA,
  translation: _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_0__/* .ArrayOfString */ .IA
});
const MechanicFeedback = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  "on-success": _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_0__/* .ArrayOfString */ .IA,
  "on-error": _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_0__/* .ArrayOfString */ .IA
});
const Mechanic = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  output: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .asType */ .fr)()
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  name: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  hint: MechanicHint,
  clue: MechanicClueButton,
  input: (0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .asType */ .fr)(),
  feedback: MechanicFeedback,
  skill: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
})]);
const Lexis = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  term: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  translations: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(io_ts__WEBPACK_IMPORTED_MODULE_2__.string),
  contexts: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(Context)
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  synonyms: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(io_ts__WEBPACK_IMPORTED_MODULE_2__.string),
  image: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  goal: io_ts__WEBPACK_IMPORTED_MODULE_2__.keyof({
    production: null,
    reception: null
  }),
  "custom-mechanics": io_ts__WEBPACK_IMPORTED_MODULE_2__.array(io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([Mechanic, io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
  })])),
  "part-of-speech": io_ts__WEBPACK_IMPORTED_MODULE_2__.keyof({
    noun: null,
    verb: null,
    adjective: null,
    adverb: null,
    pronoun: null,
    quantifier: null,
    determiner: null,
    preposition: null,
    conjunction: null,
    interjection: null,
    phrase: null,
    idiom: null,
    "noun phrase": null,
    "functional phrase": null,
    "verb phrase": null,
    sentence: null
  })
})]);
const Activity = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  activity_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  type: ActivityType,
  blocks: io_ts__WEBPACK_IMPORTED_MODULE_2__.array((0,_utils_io_ts_tools__WEBPACK_IMPORTED_MODULE_1__/* .asType */ .fr)())
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  is_active: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  "custom-mechanics": io_ts__WEBPACK_IMPORTED_MODULE_2__.array(Mechanic),
  contexts: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(Context),
  lexis: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(Lexis),
  "chat-bot": io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  "mentor-speaking-with-trainer": io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  meta: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
    "show-skip-button": io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean
  }), io_ts__WEBPACK_IMPORTED_MODULE_2__["null"]])
})]);

/***/ }),

/***/ 47160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ GET_TEXT_TO_SPEECH_URL)
/* harmony export */ });
/* harmony import */ var _yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24610);



const GET_TEXT_TO_SPEECH_URL = (text, voice) => {
  const voiceParam = voice ? `&voice=${voice}` : "";
  return `${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/text-to-speech?text=${encodeURIComponent(text)}${voiceParam}`;
};

/***/ }),

/***/ 48509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Y: () => (/* binding */ getTutorAttributes)
});

// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/index.ts + 7 modules
var student_attributes = __webpack_require__(14325);
;// CONCATENATED MODULE: ../shared/src/api/tutor/attributes/attributes-model.raw.ts




const RawMentorSkills = es6.partial({
  first_session: es6.boolean,
  subsequent_sessions: es6.boolean
});
const RawOnboardingExplanation = es6.partial({
  reason: es6.string,
  busy_time: es6.number,
  free_time: es6.number,
  week_schedule: student_attributes/* RawWeekSchedule */.u1,
  available_time: es6.number,
  session_durations: es6.array(es6.number),
  active_student_count: es6.number,
  min_time_between_sessions: es6.union([es6["null"], es6.number]),
  max_student_count_by_tutor: es6.union([es6["null"], es6.number]),
  max_student_count_by_service: es6.union([es6["null"], es6.number])
});
const RawTutorOnboarding = es6.partial({
  k0: es6.partial({
    0: es6.number
  }),
  k1: es6.partial({
    0: es6.number
  }),
  explanation: RawOnboardingExplanation
});
const AttributesModelRaw = es6.type({
  data: es6.partial({
    syllabus_id: es6.string,
    max_students_limit: es6.number,
    week_schedule: student_attributes/* RawWeekSchedule */.u1,
    min_assignment_time_before_session_minutes: es6.number,
    min_time_between_sessions_minutes: es6.number,
    slack_id: es6.union([es6["null"], es6.string]),
    is_native: es6.boolean,
    zoom_link: es6.union([es6["null"], es6.string]),
    onboarding: RawTutorOnboarding,
    mentor_skills: RawMentorSkills,
    can_give_first_speaking: es6.boolean,
    max_students_limit_trial: es6.union([es6["null"], es6.number]),
    default_archiving_enabled: es6.boolean,
    double_speaking_session_allowed: es6.boolean
  })
});
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.group-by.js
var es_object_group_by = __webpack_require__(96357);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(71502);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInMinutes.mjs
var differenceInMinutes = __webpack_require__(34002);
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(51461);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var date_fns_parseISO = __webpack_require__(95790);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameDay.mjs
var date_fns_isSameDay = __webpack_require__(51418);
// EXTERNAL MODULE: ../../node_modules/date-fns/endOfDay.mjs
var date_fns_endOfDay = __webpack_require__(64597);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfDay.mjs
var date_fns_startOfDay = __webpack_require__(8106);
// EXTERNAL MODULE: ../shared/src/date.utils.ts + 1 modules
var date_utils = __webpack_require__(35468);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
;// CONCATENATED MODULE: ../shared/src/model/tutor/tutor-attributes.model.ts


const makeTutorWeekScheduleTimeSlot = (from, to) => {
  const id = `${from.getTime()}_${to.getTime()}`;
  return {
    id,
    from,
    to
  };
};
// EXTERNAL MODULE: ../shared/src/timezones.utils.ts
var timezones_utils = __webpack_require__(30332);
;// CONCATENATED MODULE: ../shared/src/api/tutor/attributes/attributes.mappers.ts















const getWeekDayFromTimeSlot = slot => (0,format/* format */.WU)(slot.from, "EEEE");
const groupTutorAvailabilityByWeekDay = slots => Object.groupBy(slots, getWeekDayFromTimeSlot);
const mergeDayTimeSlots = timeSlots => {
  const sortedSlots = timeSlots.sort((a, b) => (0,isBefore/* isBefore */.R)(a.from, b.from) ? -1 : 1);
  if (sortedSlots.length === 1) {
    return [sortedSlots[0]];
  }
  const result = [];
  let from = sortedSlots[0].from;
  let to = sortedSlots[0].to;
  for (let i = 1; i < sortedSlots.length; i++) {
    const currentSchedule = sortedSlots[i];
    if ((0,differenceInMinutes/* differenceInMinutes */.X)(currentSchedule.from, to) >= 5) {
      result.push(makeTutorWeekScheduleTimeSlot(from, to));
      from = currentSchedule.from;
      to = currentSchedule.to;
      if (i === sortedSlots.length - 1) {
        result.push(makeTutorWeekScheduleTimeSlot(from, to));
        continue;
      } else {
        continue;
      }
    }
    if ((0,differenceInMinutes/* differenceInMinutes */.X)(currentSchedule.from, to) < 5) {
      if ((0,isAfter/* isAfter */.A)(currentSchedule.to, to)) {
        to = currentSchedule.to;
      }
      if (i === sortedSlots.length - 1) {
        result.push(makeTutorWeekScheduleTimeSlot(from, to));
      }
    }
  }
  return result;
};
const mapRawTutorWeekSchedule = rawWeekSchedule => {
  const mappedRawWeekSchedule = rawWeekSchedule.map(schedule => {
    const actualFrom = (0,timezones_utils/* convertUTCToLocal */.v$)((0,date_fns_parseISO/* parseISO */.D)(schedule[0]));
    const actualTo = (0,timezones_utils/* convertUTCToLocal */.v$)((0,date_fns_parseISO/* parseISO */.D)(schedule[1]));
    const from = (0,date_utils/* moveDateOnCurrentWeek */.CT)(actualFrom);
    const to = (0,date_utils/* moveDateOnCurrentWeek */.CT)(actualTo);
    return makeTutorWeekScheduleTimeSlot(from, to);
  });
  const splitedByDaysSlots = mappedRawWeekSchedule.reduce((acc, schedule) => {
    if ((0,date_fns_isSameDay/* isSameDay */.K)(schedule.from, schedule.to)) {
      acc.push(schedule);
    } else {
      const from1 = schedule.from;
      const to1 = (0,date_fns_endOfDay/* endOfDay */.i)(schedule.from);
      const from2 = (0,date_fns_startOfDay/* startOfDay */.b)(schedule.to);
      const to2 = schedule.to;
      acc.push(makeTutorWeekScheduleTimeSlot(from1, to1));
      acc.push(makeTutorWeekScheduleTimeSlot(from2, to2));
    }
    return acc;
  }, []);
  const groupedByWeekDay = groupTutorAvailabilityByWeekDay(splitedByDaysSlots);
  for (const key of Object.keys(groupedByWeekDay)) {
    const currentWeekDaySlots = groupedByWeekDay[key];
    groupedByWeekDay[key] = mergeDayTimeSlots(currentWeekDaySlots);
  }
  return Object.values(groupedByWeekDay).reduce((acc, schedule) => {
    acc = acc.concat(schedule);
    return acc;
  }, []);
};
const mapTutorWeekScheduleToRaw = weekSchedule => weekSchedule.reduce((acc, schedule) => {
  const from = formatSchedulingDate(schedule.from, makeWeekDayId(String(getDay(schedule.from))));
  const to = formatSchedulingDate(schedule.to, makeWeekDayId(String(getDay(schedule.to))));
  const fromDate = parseISO(from);
  const toDate = parseISO(to);
  if (isSameDay(fromDate, toDate)) {
    acc.push([from, to]);
    return acc;
  }
  const from1 = formatISO9075(fromDate);
  const to1 = formatISO9075(endOfDay(fromDate));
  const from2 = formatISO9075(startOfDay(toDate));
  const to2 = formatISO9075(toDate);
  acc.push([from1, to1]);
  acc.push([from2, to2]);
  return acc;
}, []);
const mapRawAttributes = rawAttributes => {
  const syllabusId = rawAttributes.data.syllabus_id;
  return {
    syllabusId: syllabusId === "" ? void 0 : syllabusId,
    minTimeBetweenSessions: rawAttributes.data.min_time_between_sessions_minutes,
    minAssignmentTimeBeforeSession: rawAttributes.data.min_assignment_time_before_session_minutes,
    maxStudents: rawAttributes.data.max_students_limit,
    weekSchedule: rawAttributes.data.week_schedule && mapRawTutorWeekSchedule(rawAttributes.data.week_schedule),
    zoomLink: rawAttributes.data.zoom_link
  };
};
const mapTutorAttributesToRaw = attributes => ({
  syllabus_id: attributes.syllabusId,
  max_students_limit: attributes.maxStudents,
  min_time_between_sessions_minutes: attributes.minTimeBetweenSessions,
  min_assignment_time_before_session_minutes: attributes.minAssignmentTimeBeforeSession,
  week_schedule: attributes.weekSchedule && mapTutorWeekScheduleToRaw(attributes.weekSchedule)
});
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
;// CONCATENATED MODULE: ./src/api/tutor/attributes/attributes.api.ts






const getTutorAttributes = () => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/attributes`, {
  responseType: AttributesModelRaw,
  resultMapper: mapRawAttributes
});

/***/ }),

/***/ 50847:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  lS: () => (/* binding */ getOralTestResult),
  I0: () => (/* binding */ getPlacementTestResult),
  jv: () => (/* binding */ getWrittenTestResult),
  sG: () => (/* binding */ setTestResultIsRead)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.model.ts
var trainer_model = __webpack_require__(92601);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.raw-mapper.ts
var trainer_raw_mapper = __webpack_require__(49647);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/tutor/test-restult/test-result.urls.ts



const GET_PLACEMENT_TEST_RESULT = testResultId => `${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student-assessment-test-result/${testResultId}`;
const GET_ORAL_TEST_RESULT = testResultId => `${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student-test-result/${testResultId}`;
const GET_WRITTEN_TEST_RESULT = (studentId, chapterId) => `${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student/${studentId}/trainer/chapter/${chapterId}`;
const SET_TEST_RESULT_IS_READ = () => `${(0,site_utils/* getAPIPath */.NZ)()}/tutor/set-student-test-result-is-read`;
;// CONCATENATED MODULE: ./src/api/tutor/test-restult/test-result.api.ts










const getPlacementTestResult = (0,un_either/* unEither */.K)(testResultId => (0,http/* makeRequest */.$f)(GET_PLACEMENT_TEST_RESULT(testResultId), {
  responseType: es6.type({
    data: es6.type({
      id: es6.string,
      course_level: es6.string,
      blocks: es6.array(es6.type({
        type: es6.string,
        skipped_themes: es6.array(es6.string),
        revision_themes: es6.array(es6.string)
      }))
    })
  }),
  resultMapper: response => ({
    id: response.data.id,
    courseLevel: response.data.course_level,
    blocks: response.data.blocks.map(block => ({
      type: block.type,
      skippedThemes: block.skipped_themes,
      revisionThemes: block.revision_themes
    }))
  })
}));
const getOralTestResult = (0,un_either/* unEither */.K)(testResultId => (0,http/* makeRequest */.$f)(GET_ORAL_TEST_RESULT(testResultId), {
  responseType: es6.type({
    data: es6.type({
      id: es6.string,
      blocks: es6.array(es6.type({
        title: es6.string,
        score: es6.string,
        recommendation: es6.string
      }))
    })
  }),
  resultMapper: response => response.data
}));
const getWrittenTestResult = (0,un_either/* unEither */.K)((studentId, chapterId) => (0,http/* makeRequest */.$f)(GET_WRITTEN_TEST_RESULT(studentId, chapterId), {
  responseType: trainer_model/* GetProductChapterStateResponseRaw */.Cx,
  resultMapper: response => (0,trainer_raw_mapper/* mapRawChapterState */.x)(response, false)
}));
const setTestResultIsRead = testResultId => (0,http/* makeRequest */.$f)(SET_TEST_RESULT_IS_READ(), {
  method: "POST",
  responseType: es6.type({}),
  body: {
    test_result_id: testResultId
  }
});

/***/ }),

/***/ 13925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  IC: () => (/* binding */ getStudentTestResults),
  Wt: () => (/* binding */ getTutorInfo),
  y7: () => (/* binding */ getTutorStudentAmoCRMAttributes)
});

// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
;// CONCATENATED MODULE: ./src/api/tutor/tutor.mapper.ts







const mapRawTutorInfo = response => ({
  photo: response.avatar_link,
  name: response.name,
  description: response.description
});
const mapRawStudentAmoCRMAttributes = response => ({
  level: response.data.attributes.level?.[0],
  id: response.data.attributes.user_id?.[0],
  age: response.data.attributes.age?.[0],
  occupation: [response.data.attributes.profession_ge?.[0], response.data.attributes.profession_bus?.[0]].filter(Boolean).join(", "),
  englishLearningExperience: response.data.attributes.experience?.[0],
  purposeOfTraining: response.data.attributes.purpose_training?.join(", "),
  courseInterest: response.data.attributes.course_interest,
  learningExperience: response.data.attributes.learning_experience,
  wantPractice: response.data.attributes.want_practice,
  teacherAndStudySuggestions: response.data.attributes.teacher_and_study_suggestions
});
const mapPlacementTest = studentTestRaw => ({
  id: studentTestRaw.id,
  assignedDate: new Date(studentTestRaw.assigned_date),
  finishedDate: studentTestRaw.finished_date ? new Date(studentTestRaw.finished_date) : null,
  scoreResult: studentTestRaw.score_result,
  maxResult: studentTestRaw.max_result,
  needNotifyTutor: studentTestRaw.need_notify_tutor
});
const mapStudentTests = tests => tests.map(test => ({
  ...mapPlacementTest(test),
  name: test.name,
  chapterId: test.chapter_id,
  type: test.type
}));
const mapRawStudentTestResults = response => ({
  placementTest: response.data.placement_test ? {
    ...mapPlacementTest(response.data.placement_test),
    type: "placement"
  } : void 0,
  tests: mapStudentTests(response.data.tests)
});
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/tutor/tutor.raw-model.ts



const TutorInfoRaw = es6.type({
  id: es6.string,
  name: es6.string,
  avatar_link: es6.string,
  description: es6.string
});
const AmoCRMAttribute = es6.array(es6.string);
const StudentAmoCRMAttributesModelRaw = es6.type({
  data: es6.type({
    attributes: es6.partial({
      user_id: AmoCRMAttribute,
      comments: AmoCRMAttribute,
      timezone: AmoCRMAttribute,
      wishes_tutor: AmoCRMAttribute,
      level: AmoCRMAttribute,
      age: AmoCRMAttribute,
      experience: AmoCRMAttribute,
      profession_ge: AmoCRMAttribute,
      profession_bus: AmoCRMAttribute,
      purpose_training: AmoCRMAttribute,
      telegram: AmoCRMAttribute,
      course_interest: AmoCRMAttribute,
      learning_experience: AmoCRMAttribute,
      want_practice: AmoCRMAttribute,
      teacher_and_study_suggestions: AmoCRMAttribute
    })
  })
});
const TestScoreRaw = es6.type({
  lexis: es6.number,
  grammar: es6.number,
  phrases: es6.number,
  reading: es6.number,
  speaking: es6.number,
  listening: es6.number
});
const PlacementTestRaw = es6.type({
  id: es6.string,
  assigned_date: es6.string,
  finished_date: es6.union([es6.string, es6["null"]]),
  score_result: es6.union([TestScoreRaw, es6["null"]]),
  max_result: TestScoreRaw,
  need_notify_tutor: es6.boolean
});
const StudentTestRaw = es6.intersection([PlacementTestRaw, es6.type({
  chapter_id: es6.string,
  name: es6.string,
  type: es6.string
})]);
const StudentTestResultsRaw = es6.type({
  data: es6.type({
    placement_test: es6.union([PlacementTestRaw, es6.undefined]),
    tests: es6.array(StudentTestRaw)
  })
});
;// CONCATENATED MODULE: ./src/api/tutor/tutor.urls.ts



const tutorPrefix = `${(0,site_utils/* getAPIPath */.NZ)()}/tutor`;
const GET_TUTOR_INFO = id => `${tutorPrefix}/${id}`;
;// CONCATENATED MODULE: ./src/api/tutor/tutor.api.ts








const getTutorInfo = async id => (0,http/* makeRequest */.$f)(GET_TUTOR_INFO(id), {
  responseType: TutorInfoRaw,
  resultMapper: mapRawTutorInfo
});
const getTutorStudentAmoCRMAttributes = (0,un_either/* unEither */.K)(studentId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student/${studentId}/get-crm-attributes`, {
  responseType: StudentAmoCRMAttributesModelRaw,
  resultMapper: mapRawStudentAmoCRMAttributes
}));
const getStudentTestResults = (0,un_either/* unEither */.K)(studentId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student-test-results/${studentId}`, {
  responseType: StudentTestResultsRaw,
  resultMapper: mapRawStudentTestResults
}));

/***/ }),

/***/ 26630:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  j: () => (/* binding */ getMe),
  V: () => (/* binding */ updateUserAttributes)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../../node_modules/query-string/index.js
var query_string = __webpack_require__(34126);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ./src/utils/io-ts-tools.ts
var io_ts_tools = __webpack_require__(64866);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/user/authorization/urls.ts



const ME_URL = `${(0,site_utils/* getAPIPath */.NZ)()}/me`;
const USER_ATTRIBUTES = `${(0,site_utils/* getAPIPath */.NZ)()}/user/agreements`;
;// CONCATENATED MODULE: ./src/api/user/authorization/api.ts










const getMe = async (searchParamsObject, options) => {
  const searchQuery = query_string.stringify(searchParamsObject);
  const query = searchQuery && `?${searchQuery}`;
  const result = await (0,http/* makeRequest */.$f)(`${ME_URL}${query}`, {
    method: "GET",
    responseType: (0,io_ts_tools/* asType */.fr)(),
    unauthorizedHandler: options?.unauthorizedHandler
  });
  if ((0,Either.isLeft)(result)) {
    throw new Error("httpAdapter isLeft");
  }
  return result.right;
};
const updateUserAttributes = (0,un_either/* unEither */.K)(body => (0,http/* makeRequest */.$f)(USER_ATTRIBUTES, {
  method: "PUT",
  body,
  responseType: es6["void"]
}));

/***/ }),

/***/ 11775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  X: () => (/* binding */ getCurrentTime)
});

// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/utils/utils.model.ts



const CurrentTimeResponse = es6.type({
  data: es6.number
});
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/utils/utils.urls.ts



const TIME = `${(0,site_utils/* getAPIPath */.NZ)()}/time`;
;// CONCATENATED MODULE: ./src/api/utils/utils.api.ts





const getCurrentTime = () => (0,http/* makeRequest */.$f)(TIME, {
  responseType: CurrentTimeResponse,
  resultMapper: response => new Date(response.data * 1e3)
});

/***/ }),

/***/ 94506:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NB: () => (/* binding */ buyGiftCertificatePaths),
/* harmony export */   X4: () => (/* binding */ BuyGiftParams),
/* harmony export */   lQ: () => (/* binding */ baseRoutePaths)
/* harmony export */ });


const BUY_GIFT_CERTIFICATE = `/buy-gift-certificate`;
const baseRoutePaths = {
  INDEX: "/",
  SETTINGS: `/settings`,
  UNSUBSCRIBE: `/unsubscribe`,
  BUY_GIFT_CERTIFICATE,
  BUY_GIFT_CERTIFICATE_PAYMENT: (productId, giftId, parentProductId) => {
    if (parentProductId === null) {
      return `${BUY_GIFT_CERTIFICATE}/${productId}/${giftId}`;
    }
    return `${BUY_GIFT_CERTIFICATE}/${productId}/${giftId}/${parentProductId}`;
  },
  TASK_GUIDE: (syllabusId, chapterId) => {
    if (!chapterId) {
      return `/task-guide/${syllabusId}`;
    }
    return `/task-guide/${syllabusId}/${chapterId}`;
  }
};
var BuyGiftParams = /* @__PURE__ */(BuyGiftParams2 => {
  BuyGiftParams2["BuyPacketProductId"] = "buyPacketProductId";
  BuyGiftParams2["BuyPacketGiftId"] = "buyPacketGiftId";
  BuyGiftParams2["BuyParentProductId"] = "buyParentProductId";
  return BuyGiftParams2;
})(BuyGiftParams || {});
const buyGiftCertificatePaths = [baseRoutePaths.BUY_GIFT_CERTIFICATE, baseRoutePaths.BUY_GIFT_CERTIFICATE_PAYMENT(`:${"buyPacketProductId" /* BuyPacketProductId */}`, `:${"buyPacketGiftId" /* BuyPacketGiftId */}`, `:${"buyParentProductId" /* BuyParentProductId */}?`)];

/***/ }),

/***/ 80575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   KG: () => (/* binding */ ProductTrainerParams),
/* harmony export */   QU: () => (/* binding */ StudentIndexParams),
/* harmony export */   Wl: () => (/* binding */ StudentRoutesPaymentLandingParams),
/* harmony export */   dR: () => (/* binding */ studentRoutePaths),
/* harmony export */   zB: () => (/* binding */ BuyCourseParams)
/* harmony export */ });


const studentPrefix = "/student";
const BUY_PRODUCT = id => {
  const base = `${studentPrefix}/buy-product`;
  if (id === void 0) {
    return base;
  }
  return `${base}/${id}`;
};
const INDEX_PACKET = packetId => `${studentPrefix}/packet/${packetId}`;
const CURATOR_FUNNEL_INDEX = `${studentPrefix}/curator-request`;
const studentRoutePaths = {
  INDEX: studentPrefix,
  INDEX_PACKET,
  INDEX_PACKET_CHAPTER: (packetId, chapterIndex) => `${INDEX_PACKET(packetId)}/chapter/${chapterIndex}`,
  CHAPTERS: `${studentPrefix}/chapters`,
  SPEAKING_INFO: speakingSessionId => `${studentPrefix}/speaking-info/${speakingSessionId}`,
  SPEAKING_SCHEDULED: speakingSessionId => `${studentPrefix}/speaking-scheduled/${speakingSessionId}`,
  BUY_PAYMENT: (courseId, packetId) => `${BUY_PRODUCT(courseId)}/payment/${packetId}`,
  BUY_PRODUCT,
  PLACE_IN_PRODUCT: productId => `${studentPrefix}/place-in-product/${productId}`,
  PRODUCT_TRAINER: (productId, chapterId, activityId, blockId) => {
    if (blockId) {
      return `${studentPrefix}/product-trainer/${productId}/${chapterId}/${activityId}/${blockId}`;
    }
    if (activityId) {
      return `${studentPrefix}/product-trainer/${productId}/${chapterId}/${activityId}`;
    }
    return `${studentPrefix}/product-trainer/${productId}/${chapterId}`;
  },
  PRODUCT_REVISION: (productId, chapterId, revisionType) => {
    const revisionPrefix = revisionType ? `/${revisionType}` : "";
    return `${studentPrefix}/product-revision/${productId}/${chapterId}${revisionPrefix}`;
  },
  PRODUCT_REPETITION: productId => `${studentPrefix}/product-repetition/${productId}`,
  SPEAKING_CHECKUP: speakingSessionId => `${studentPrefix}/speaking-checkup/${speakingSessionId}`,
  SPEAKING: speakingSessionId => `${studentPrefix}/speaking/${speakingSessionId}`,
  PRE_SPEAKING: speakingSessionId => `${studentPrefix}/pre-speaking/${speakingSessionId}`,
  REPETITION: `${studentPrefix}/repetition`,
  ONBOARDING: `${studentPrefix}/onboarding`,
  COURSE_SELECT: `${studentPrefix}/course-select`,
  ABOUT: `${studentPrefix}/about`,
  NOTES: params => {
    if (!params.speakingId) {
      return `${studentPrefix}/notes`;
    }
    return `${studentPrefix}/notes/${params.speakingId}`;
  },
  PAYMENT_LANDING: landingId => `${studentPrefix}/payment-landing/${landingId}`,
  PAYMENT_LANDING_PROMO_CODE: landingId => `${studentPrefix}/payment-landing/${landingId}/promo-code`,
  // Curator funnel
  CURATOR_FUNNEL_INDEX,
  CURATOR_FUNNEL_INSTANT: `${CURATOR_FUNNEL_INDEX}/instant`,
  CURATOR_FUNNEL_SCHEDULE: `${CURATOR_FUNNEL_INDEX}/schedule`,
  CURATOR_FUNNEL_SOMETHING_WRONG: `${CURATOR_FUNNEL_INDEX}/something-wrong`,
  CURATOR_FUNNEL_WAIT_FOR_SPEAKING: `${CURATOR_FUNNEL_INDEX}/wait-for-speaking`,
  CURATOR_FUNNEL_SPEAKING: `${CURATOR_FUNNEL_INDEX}/speaking`,
  INDEX_VISIBLE_ALL: `${studentPrefix}/visible-all`,
  INDEX_VISIBLE_DONE: `${studentPrefix}/visible-done`,
  BEGINNER: {
    SCHEDULE: `${studentPrefix}/beginner-schedule`,
    SCHEDULE_LIST: `${studentPrefix}/beginner/schedule/list`,
    TASKS: `${studentPrefix}/beginner-tasks`,
    EDUCATION_MATERIALS: `${studentPrefix}/beginner-education-materials`
  },
  BUS: {
    SCHEDULE: `${studentPrefix}/bus-schedule`,
    SCHEDULE_LIST: `${studentPrefix}/bus/schedule/list`,
    TASKS: `${studentPrefix}/bus-tasks`,
    EDUCATION_MATERIALS: `${studentPrefix}/bus-education-materials`
  },
  BUS_ANALYST: {
    SCHEDULE: `${studentPrefix}/bus-analyst-schedule`,
    SCHEDULE_LIST: `${studentPrefix}/bus-analyst/schedule/list`,
    TASKS: `${studentPrefix}/bus-analyst-tasks`,
    EDUCATION_MATERIALS: `${studentPrefix}/bus-analyst-education-materials`
  },
  BUS_PRODUCT_MANAGER: {
    SCHEDULE: `${studentPrefix}/bus-product-manager-schedule`,
    SCHEDULE_LIST: `${studentPrefix}/bus-product-manager/schedule/list`,
    TASKS: `${studentPrefix}/bus-product-manager-tasks`,
    EDUCATION_MATERIALS: `${studentPrefix}/bus-product-manager-education-materials`
  },
  ACCOUNT: {
    SCHEDULE: `${studentPrefix}/schedule`,
    SCHEDULE_LIST: `${studentPrefix}/schedule-list`,
    TASKS: `${studentPrefix}/tasks`,
    EDUCATION_MATERIALS: `${studentPrefix}/education-materials`,
    RESOURCES: `${studentPrefix}/resources`,
    PROGRESS: {
      INDEX: `${studentPrefix}/progress`,
      SKILLS: `${studentPrefix}/progress/skills`,
      TESTS: `${studentPrefix}/progress/tests`,
      TEST_RESULT: testId => `${studentPrefix}/progress/test-result/${testId}`,
      PROGRAM: `${studentPrefix}/progress/program`
    }
  },
  AUTO_ONBOARDING: `${studentPrefix}/onboarding`,
  FOREIGNER_SESSIONS: `${studentPrefix}/foreigner-sessions`,
  REFERRAL_PROGRAM: `${studentPrefix}/referral-program`,
  RESOURCES: `${studentPrefix}/resources`
};
var StudentIndexParams = /* @__PURE__ */(StudentIndexParams2 => {
  StudentIndexParams2["InfoSpeakingSessionId"] = "infoSpeakingSessionId";
  StudentIndexParams2["ScheduledSpeakingSessionId"] = "scheduledSpeakingSessionId";
  StudentIndexParams2["PlacementProductId"] = "placementProductId";
  return StudentIndexParams2;
})(StudentIndexParams || {});
var BuyCourseParams = /* @__PURE__ */(BuyCourseParams2 => {
  BuyCourseParams2["CourseId"] = "courseId";
  BuyCourseParams2["BuyPacketProductId"] = "buyPacketProductId";
  return BuyCourseParams2;
})(BuyCourseParams || {});
var ProductTrainerParams = /* @__PURE__ */(ProductTrainerParams2 => {
  ProductTrainerParams2["ProductId"] = "productId";
  ProductTrainerParams2["ChapterId"] = "chapterId";
  ProductTrainerParams2["ActivityId"] = "activityId";
  ProductTrainerParams2["BlockId"] = "blockId";
  return ProductTrainerParams2;
})(ProductTrainerParams || {});
var StudentRoutesPaymentLandingParams = /* @__PURE__ */(StudentRoutesPaymentLandingParams2 => {
  StudentRoutesPaymentLandingParams2["LandingId"] = "landingId";
  return StudentRoutesPaymentLandingParams2;
})(StudentRoutesPaymentLandingParams || {});

/***/ }),

/***/ 59602:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  m: () => (/* binding */ AddToCalendarButton)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/calendar.utils.ts
var calendar_utils = __webpack_require__(3654);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../shared/src/hooks/useWebcalInstruction.ts
var useWebcalInstruction = __webpack_require__(20967);
// EXTERNAL MODULE: ../shared/src/widgets/webcal-instruction-popup/webcal-instruction-popup.component.tsx + 1 modules
var webcal_instruction_popup_component = __webpack_require__(88675);
// EXTERNAL MODULE: ./src/hooks/useCalendarItems.ts
var useCalendarItems = __webpack_require__(62878);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/dropdown/dropdown.component.tsx + 1 modules
var dropdown_component = __webpack_require__(34504);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/components/add-to-calendar-button/components/add-to-calendar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const add_to_calendar_module = ({"root":"add-to-calendar-module__root--EhXCQ","button-content":"add-to-calendar-module__button-content--ofNAS","buttonContent":"add-to-calendar-module__button-content--ofNAS","button-icon":"add-to-calendar-module__button-icon--ukG8i","buttonIcon":"add-to-calendar-module__button-icon--ukG8i","dropdown-icon":"add-to-calendar-module__dropdown-icon--kaPBX","dropdownIcon":"add-to-calendar-module__dropdown-icon--kaPBX","item":"add-to-calendar-module__item--uiaSY","dropdown":"add-to-calendar-module__dropdown--fy1Qf","inverse-colors":"add-to-calendar-module__inverse-colors--GIv8A","inverseColors":"add-to-calendar-module__inverse-colors--GIv8A","item-content":"add-to-calendar-module__item-content--CXG2Y","itemContent":"add-to-calendar-module__item-content--CXG2Y","tablet-dialog-buttons-wrapper":"add-to-calendar-module__tablet-dialog-buttons-wrapper--B22oA","tabletDialogButtonsWrapper":"add-to-calendar-module__tablet-dialog-buttons-wrapper--B22oA"});
;// CONCATENATED MODULE: ./src/components/add-to-calendar-button/components/icon-button.tsx









const IconButton = _ref => {
  let {
    isCalendarSelectDialogVisible,
    onButtonClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isCalendarTooltipVisible, setIsCalendarTooltipVisible] = (0,react.useState)(false);
  const {
    isDesktop,
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const canTooltipBeShown = !isCalendarSelectDialogVisible && isDesktop;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    autoWidth: true,
    overlay: intl.formatMessage({
      id: "BeginnerScheduleList.addToCalendarLabel"
    }),
    placement: "left",
    visible: isCalendarTooltipVisible && canTooltipBeShown,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      size: isMobile ? "small" : "medium",
      appearance: isCalendarSelectDialogVisible ? "floating" : "primaryFloating",
      iconName: isCalendarSelectDialogVisible ? "cross" : "calendar",
      className: add_to_calendar_module.buttonIcon,
      onMouseOver: () => {
        setIsCalendarTooltipVisible(canTooltipBeShown);
      },
      onMouseOut: () => {
        setIsCalendarTooltipVisible(false);
      },
      onClick: onButtonClick,
      "aria-label": intl.formatMessage({
        id: "BeginnerScheduleList.addToCalendarLabel"
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ./src/components/add-to-calendar-button/components/text-button.tsx







const TextButton = _ref => {
  let {
    isCalendarSelectDialogVisible,
    onButtonClick
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    appearance: "primary",
    onClick: onButtonClick,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: add_to_calendar_module.buttonContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "addToCalendarButton.buttonText"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: add_to_calendar_module.dropdownIcon,
        name: isCalendarSelectDialogVisible ? "chevron-up" : "chevron-down",
        size: "medium"
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/add-to-calendar-button/components/add-to-calendar-dropdown.tsx












const AddToCalendarDropdown = _ref => {
  let {
    buttonStyle,
    inverseColors,
    calendarItems
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const renderSelector = (0,react.useCallback)((isDropdownActive, onDropdownClick) => {
    if (buttonStyle === "text") {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TextButton, {
        isCalendarSelectDialogVisible: isDropdownActive,
        onButtonClick: onDropdownClick
      });
    }
    if (buttonStyle === "icon") {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(IconButton, {
        isCalendarSelectDialogVisible: isDropdownActive,
        onButtonClick: onDropdownClick
      });
    }
  }, [buttonStyle]);
  const renderDropdown = (0,react.useCallback)(handleDropdownClose => /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()(add_to_calendar_module.dropdown, {
      [add_to_calendar_module.inverseColors]: inverseColors
    }),
    children: calendarItems.map((item, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
        type: "button",
        className: add_to_calendar_module.item,
        onClick: item.onClick(handleDropdownClose),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: add_to_calendar_module.itemContent,
          children: item.label
        })
      })
    }, index))
  }), [calendarItems, inverseColors]);
  let theme = dropdown_component/* DropdownListTheme */.w.Rounded | dropdown_component/* DropdownListTheme */.w.NoPadding;
  if (buttonStyle === "text") {
    theme = theme | dropdown_component/* DropdownListTheme */.w.Left12;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_component/* Dropdown */.L, {
    renderSelector,
    renderDropdown,
    listTheme: theme,
    placement: isMobile ? "top" : "bottom"
  });
};
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/components/add-to-calendar-button/components/add-to-calendar-modal.tsx















const AddToCalendarModal = _ref => {
  let {
    buttonStyle,
    calendarItems
  } = _ref;
  const [isCalendarSelectDialogVisible, setIsCalendarSelectDialogVisible] = (0,react.useState)(false);
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile,
    isTabletOrDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const handleDropdownClick = () => setIsCalendarSelectDialogVisible(currentDropdownVisibility => !currentDropdownVisibility);
  let button = null;
  if (buttonStyle === "text") {
    button = /* @__PURE__ */(0,jsx_runtime.jsx)(TextButton, {
      isCalendarSelectDialogVisible,
      onButtonClick: handleDropdownClick
    });
  } else if (buttonStyle === "icon") {
    button = /* @__PURE__ */(0,jsx_runtime.jsx)(IconButton, {
      isCalendarSelectDialogVisible,
      onButtonClick: handleDropdownClick
    });
  }
  const handleCalendarSelectDialogClose = () => setIsCalendarSelectDialogVisible(false);
  const dialogButtons = (0,react.useMemo)(() => calendarItems.map(calendarItemType => ({
    appearance: "secondary",
    text: calendarItemType.label,
    onClick: calendarItemType.onClick(handleCalendarSelectDialogClose)
  })), [calendarItems]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [button, /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      isVisible: isCalendarSelectDialogVisible,
      onClose: handleCalendarSelectDialogClose,
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      title: /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent),
        children: intl.formatMessage({
          id: "BeginnerScheduleList.addToCalendarHint"
        })
      }),
      buttons: isMobile ? dialogButtons : [],
      subtitle: "",
      showCloseButton: true,
      size: modal/* ModalSize */.Cg.Small,
      buttonsBlockStretch: true,
      children: isTabletOrDesktop ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: add_to_calendar_module.tabletDialogButtonsWrapper,
        children: dialogButtons.map(_ref2 => {
          let {
            appearance,
            onClick,
            text
          } = _ref2;
          return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance,
            onClick,
            children: text
          }, text);
        })
      }) : null
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/add-to-calendar-button/add-to-calendar-button.component.tsx














const AddToCalendarButton = _ref => {
  let {
    buttonStyle,
    inverseColors,
    desktopDialogType = "dropdown",
    ...props
  } = _ref;
  const user = (0,useUser/* useUser */.aF)();
  const userId = user.data?.me.user?.id;
  const calendarToken = user.data?.me.user?.calendarToken;
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    openWebcalInstruction,
    closeWebcalInstruction,
    webcalInstructionProvider
  } = (0,useWebcalInstruction/* useWebcalInstruction */.S)();
  const calendarItems = (0,useCalendarItems/* useCalendarItems */.Q)(props, openWebcalInstruction);
  const items = (0,react.useMemo)(() => calendarItems.map(item => ({
    label: item.label,
    onClick: handleDialogClose => () => {
      item.action();
      handleDialogClose();
    }
  })), [calendarItems]);
  if (!userId || !calendarToken) {
    return null;
  }
  const webcalUrl = (0,calendar_utils/* generateWebcalCalendarLink */.D$)(userId, calendarToken);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [webcalInstructionProvider && /* @__PURE__ */(0,jsx_runtime.jsx)(webcal_instruction_popup_component/* WebcalInstructionPopup */.$, {
      provider: webcalInstructionProvider,
      onClose: closeWebcalInstruction,
      webcalUrl
    }), isDesktop && desktopDialogType === "dropdown" ? /* @__PURE__ */(0,jsx_runtime.jsx)(AddToCalendarDropdown, {
      buttonStyle,
      calendarItems: items,
      inverseColors
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(AddToCalendarModal, {
      buttonStyle,
      calendarItems: items
    })]
  });
};

/***/ }),

/***/ 56215:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Y: () => (/* binding */ AppHelp)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ./src/hooks/layout/useSocial.ts + 3 modules
var useSocial = __webpack_require__(61046);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ./src/components/app-help/support-chat-help-item/support-chat-help-item.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const support_chat_help_item_module = ({"help-item":"support-chat-help-item-module__help-item--tRCO1","helpItem":"support-chat-help-item-module__help-item--tRCO1","help-item-content":"support-chat-help-item-module__help-item-content--b5VjH","helpItemContent":"support-chat-help-item-module__help-item-content--b5VjH","icon":"support-chat-help-item-module__icon--Uucky","text":"support-chat-help-item-module__text--X0WP1","help-item-with-action":"support-chat-help-item-module__help-item-with-action--V9RnZ","helpItemWithAction":"support-chat-help-item-module__help-item-with-action--V9RnZ","help-item-action":"support-chat-help-item-module__help-item-action--zsREx","helpItemAction":"support-chat-help-item-module__help-item-action--zsREx","help-item-icon":"support-chat-help-item-module__help-item-icon--aPCqA","helpItemIcon":"support-chat-help-item-module__help-item-icon--aPCqA"});
;// CONCATENATED MODULE: ./src/components/app-help/support-chat-help-item/support-chat-help-item.component.tsx







const SupportChatHelpItem = _ref => {
  let {
    label,
    icon,
    link,
    actionItem
  } = _ref;
  const handleClick = (0,react.useCallback)(() => {
    window.open(link, "", "noopener, noreferrer");
  }, [link]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(support_chat_help_item_module.helpItem, {
      [support_chat_help_item_module.helpItemWithAction]: actionItem !== void 0
    }),
    onClick: handleClick,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: support_chat_help_item_module.icon,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: icon,
        size: "medium"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: support_chat_help_item_module.text,
      children: label
    }), actionItem && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: support_chat_help_item_module.helpItemAction,
      children: actionItem
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/app-help/support-chat-help/support-chat-help.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const support_chat_help_module = ({"help":"support-chat-help-module__help--cFL3q","help-copy":"support-chat-help-module__help-copy--QHH6b","helpCopy":"support-chat-help-module__help-copy--QHH6b","loader-wrapper":"support-chat-help-module__loader-wrapper--waccN","loaderWrapper":"support-chat-help-module__loader-wrapper--waccN"});
;// CONCATENATED MODULE: ./src/components/app-help/support-chat-help/support-chat-help.component.tsx










const SupportChatHelp = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    data,
    isLoading,
    isError
  } = (0,useSocial/* useSocialQuery */.z)();
  if (isError) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: support_chat_help_module.help,
    children: isLoading || !data ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: support_chat_help_module.loaderWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    }) : data.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)(SupportChatHelpItem, {
      icon: item.icon,
      label: intl.formatMessage({
        id: item.labelKey
      }),
      link: item.link
    }, item.link))
  });
};
;// CONCATENATED MODULE: ./src/components/app-help/popup-help/constants.ts


var PopupBaselinePosition = /* @__PURE__ */(PopupBaselinePosition2 => {
  PopupBaselinePosition2["Right"] = "right";
  PopupBaselinePosition2["Left"] = "left";
  return PopupBaselinePosition2;
})(PopupBaselinePosition || {});
;// CONCATENATED MODULE: ./src/components/app-help/popup-help/popup-help.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const popup_help_module = ({"root":"popup-help-module__root--nOTAL","with-bottom-menu":"popup-help-module__with-bottom-menu--iZbyn","withBottomMenu":"popup-help-module__with-bottom-menu--iZbyn","root-grey":"popup-help-module__root-grey--KK9up","rootGrey":"popup-help-module__root-grey--KK9up","all-screen-height":"popup-help-module__all-screen-height--RGC7L","allScreenHeight":"popup-help-module__all-screen-height--RGC7L","space":"popup-help-module__space--fiLEQ","floated-buttons":"popup-help-module__floated-buttons--Rj0zU","floatedButtons":"popup-help-module__floated-buttons--Rj0zU","popup-help":"popup-help-module__popup-help--y9SSm","popupHelp":"popup-help-module__popup-help--y9SSm","chat-wrapper":"popup-help-module__chat-wrapper--fMrSC","chatWrapper":"popup-help-module__chat-wrapper--fMrSC","chat-wrapper-right":"popup-help-module__chat-wrapper-right--Lv298","chatWrapperRight":"popup-help-module__chat-wrapper-right--Lv298","chat-wrapper-left":"popup-help-module__chat-wrapper-left--FllCW","chatWrapperLeft":"popup-help-module__chat-wrapper-left--FllCW","chat-content":"popup-help-module__chat-content--mbq6x","chatContent":"popup-help-module__chat-content--mbq6x","chat-heading":"popup-help-module__chat-heading--jnVBP","chatHeading":"popup-help-module__chat-heading--jnVBP","chat-paragraph":"popup-help-module__chat-paragraph--exyBi","chatParagraph":"popup-help-module__chat-paragraph--exyBi","chat-wrapper-hidden":"popup-help-module__chat-wrapper-hidden--u3Zzo","chatWrapperHidden":"popup-help-module__chat-wrapper-hidden--u3Zzo","button":"popup-help-module__button--zOBGa","button-with-badge":"popup-help-module__button-with-badge--yRbRL","buttonWithBadge":"popup-help-module__button-with-badge--yRbRL","button-hidden":"popup-help-module__button-hidden--EgUEN","buttonHidden":"popup-help-module__button-hidden--EgUEN","with-margin-left":"popup-help-module__with-margin-left--VhLI6","withMarginLeft":"popup-help-module__with-margin-left--VhLI6"});
;// CONCATENATED MODULE: ./src/components/app-help/popup-help/popup-help.component.tsx















const PopupHelp = _ref => {
  let {
    customMessage,
    withMarginLeft,
    popupOpened,
    onPopupOpenedChange,
    hideButton,
    popupBaselinePosition = PopupBaselinePosition.Right,
    onClick
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  (0,useSocial/* useSocialQuery */.z)();
  const renderChatText = (0,react.useCallback)(() => {
    if (customMessage) {
      const sentences = customMessage.split(/(?:\r?\n)+/);
      return sentences.map((sentence, index) => {
        if (index === 0) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("h5", {
            className: classnames_default()(popup_help_module.chatHeading, typography_module/* default */.Z.body2Accent),
            children: sentence
          }, sentence);
        }
        if (!sentence) {
          return null;
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: popup_help_module.chatParagraph,
          children: sentence
        }, sentence);
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h5", {
        className: classnames_default()(popup_help_module.chatHeading, typography_module/* default */.Z.body2Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "PopupHelp.title"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: popup_help_module.chatParagraph,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "PopupHelp.description"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: popup_help_module.chatParagraph,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "PopupHelp.disabledChat"
        })
      })]
    });
  }, [customMessage]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: popup_help_module.popupHelp,
    children: [popupOpened && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(popup_help_module.chatWrapper, {
        [popup_help_module.chatWrapperRight]: popupBaselinePosition === PopupBaselinePosition.Right,
        [popup_help_module.chatWrapperLeft]: popupBaselinePosition === PopupBaselinePosition.Left
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(popup_help_module.chatContent),
        children: renderChatText()
      }), !customMessage && /* @__PURE__ */(0,jsx_runtime.jsx)(SupportChatHelp, {})]
    }), !hideButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      className: classnames_default()(popup_help_module.button, {
        [popup_help_module.withMarginLeft]: withMarginLeft
      }),
      size: isMobile ? "small" : "medium",
      appearance: popupOpened ? "floating" : "primaryFloating",
      iconName: popupOpened ? "cross" : "help-solid",
      onClick: () => {
        onPopupOpenedChange(!popupOpened);
        onClick?.();
      },
      "aria-label": customMessage ? customMessage.split(/(?:\r?\n)+/)[0] : intl.formatMessage({
        id: "PopupHelp.title"
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/components/app-help/use-app-help-button.ts
var use_app_help_button = __webpack_require__(59495);
;// CONCATENATED MODULE: ./src/components/app-help/app-help.tsx












const AppHelp = (0,react.memo)(_ref => {
  let {
    withMarginLeft,
    hideButton = false,
    popupBaselinePosition,
    closeOnOutsideClick,
    onClick
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const {
    isOpened
  } = (0,use_app_help_button/* useAppHelpButton */.f)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const rootRef = (0,react.useRef)(null);
  const handleChatOpened = (0,react.useCallback)(value => {
    const {
      openHelp
    } = get_url_search_params.getUrlSearchParams;
    const url = value ? openHelp.getOpenUrl(history) : openHelp.getCloseUrl(history);
    history.push(url);
  }, [history]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(rootRef, () => handleChatOpened(false), {
    condition: Boolean(closeOnOutsideClick)
  });
  let customMessage = get_url_search_params.getUrlSearchParams.openHelp.getParam(history);
  if (!customMessage || customMessage === "0" || customMessage === "1") {
    customMessage = null;
  }
  if (Array.isArray(customMessage)) {
    customMessage = customMessage[0];
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: rootRef,
    children: [isOpened && isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(use_block_main_scroll/* MainScrollBlocker */.j, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(PopupHelp, {
      customMessage,
      popupOpened: isOpened,
      onPopupOpenedChange: handleChatOpened,
      hideButton,
      withMarginLeft: Boolean(withMarginLeft),
      popupBaselinePosition,
      onClick
    })]
  });
});
AppHelp.displayName = "AppHelp";

/***/ }),

/***/ 59495:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ useAppHelpButton)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4517);
/* harmony import */ var _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47822);






const useAppHelpButton = () => {
  const history = (0,react_router__WEBPACK_IMPORTED_MODULE_3__/* .useHistory */ .k6)();
  const isOpened = _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.openHelp.isOpen(history);
  const close = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    const url = _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.openHelp.getCloseUrl(history);
    history.push(url);
  }, [history]);
  const open = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    const url = _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.openHelp.getOpenUrl(history);
    history.push(url);
  }, [history]);
  return {
    isOpened: Boolean(isOpened),
    close,
    open
  };
};

/***/ }),

/***/ 79771:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  b: () => (/* binding */ AppPageFooter)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../shared/src/hooks/useFetch.ts
var useFetch = __webpack_require__(29553);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useAsync.js + 2 modules
var useAsync = __webpack_require__(23860);
// EXTERNAL MODULE: ../shared/src/utils/is-revision-app-version/is-revision-app-version.ts + 1 modules
var is_revision_app_version = __webpack_require__(86649);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ./src/api/bunker/bunker.urls.ts
var bunker_urls = __webpack_require__(63608);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../shared/src/domain/domain.ts
var domain = __webpack_require__(72765);
;// CONCATENATED MODULE: ./src/api/bunker/footer-layout/footer-layout.mappers.ts






function mapFooterLayoutResponse(footerResponse) {
  if ((0,domain/* isKzDomain */.k)()) {
    if (!footerResponse.kz) {
      throw new Error("There are no kz in footerLayout dict");
    }
    return mapFooterLayoutDomain(footerResponse.kz);
  }
  return mapFooterLayoutDomain(footerResponse.default);
}
function mapFooterLayoutDomain(footerDomain) {
  return {
    links: mapFooterLayoutLinks(footerDomain.links),
    companyInfoKey: footerDomain.companyInfoKey,
    disclaimerKey: footerDomain.disclaimerKey
  };
}
function mapFooterLayoutLinks(footerLinks) {
  return footerLinks.map(linkGroup => linkGroup.map(mapFooterLayoutOneLink));
}
function mapFooterLayoutOneLink(footerLink) {
  return {
    ...footerLink
  };
}
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/bunker/footer-layout/footer-layout.raw-model.ts



const RawFooterLink = es6.union([es6.type({
  type: es6.literal("external"),
  labelKey: es6.string,
  externalUrlKey: es6.string
}), es6.type({
  type: es6.literal("internal"),
  labelKey: es6.string,
  relativeUrl: es6.string
})]);
const RawFooterLinks = es6.array(es6.array(RawFooterLink));
const RawFooterDomain = es6.intersection([es6.type({
  companyInfoKey: es6.string,
  links: RawFooterLinks
}), es6.partial({
  disclaimerKey: es6.string
})]);
const RawFooter = es6.intersection([es6.type({
  default: RawFooterDomain
}), es6.partial({
  kz: RawFooterDomain
})]);
;// CONCATENATED MODULE: ./src/api/bunker/footer-layout/footer-layout.api.ts






const getFooterLayout = isRevisionAppVersion => (0,http/* makeRequest */.$f)((0,bunker_urls/* GET_FOOTER_LAYOUT */.Ex)(isRevisionAppVersion), {
  responseType: RawFooter,
  resultMapper: mapFooterLayoutResponse,
  throwValidationError: true
});
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
;// CONCATENATED MODULE: ./src/hooks/layout/useFooterLayout.ts









const useFooterLayout = () => {
  const {
    appRevisionExperiment
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const versionState = (0,useAsync/* default */.Z)(async () => (0,is_revision_app_version/* isRevisionAppVersion */.Z)(bunker_api/* getAppRevisionVersion */.Q5), []);
  const isReady = versionState.loading === false;
  const isRevisionVersion = versionState.value ?? false;
  const footerLayoutFetcher = (0,useFetch/* useFetch */.i)(() => getFooterLayout(appRevisionExperiment || isRevisionVersion));
  (0,react.useEffect)(() => {
    if (isReady && footerLayoutFetcher.state === useFetch/* State */.Z.Initial) {
      void footerLayoutFetcher.fetch();
    }
  }, [isReady, footerLayoutFetcher]);
  return footerLayoutFetcher;
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/date-fns/getYear.mjs
var getYear = __webpack_require__(73788);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(47933);
// EXTERNAL MODULE: ../shared/src/domain/urls.ts
var urls = __webpack_require__(92976);
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
// EXTERNAL MODULE: ../ui-kit/src/layout/layout.component.tsx + 1 modules
var layout_component = __webpack_require__(53584);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/api/bunker/footer-layout/footer-layout.model.ts


function isExternalFooterLink(link) {
  return link.type === "external";
}
;// CONCATENATED MODULE: ./src/components/app-page-footer/footer/footer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const footer_module = ({"root":"footer-module__root--peGPz","root-white":"footer-module__root-white--DkSYK","rootWhite":"footer-module__root-white--DkSYK","block-with-margin":"footer-module__block-with-margin--x6M_h","blockWithMargin":"footer-module__block-with-margin--x6M_h","first-row":"footer-module__first-row--iVFNf","firstRow":"footer-module__first-row--iVFNf","links-columns":"footer-module__links-columns--bPvOi","linksColumns":"footer-module__links-columns--bPvOi","links-one-column":"footer-module__links-one-column--l88Cg","linksOneColumn":"footer-module__links-one-column--l88Cg","link-item":"footer-module__link-item--aVKz7","linkItem":"footer-module__link-item--aVKz7","link":"footer-module__link--IF3Hb","disclaimer":"footer-module__disclaimer--GdQgS","last-row":"footer-module__last-row--Ge8wk","lastRow":"footer-module__last-row--Ge8wk","company":"footer-module__company--H9ZfA"});
;// CONCATENATED MODULE: ./src/components/app-page-footer/footer/footer.component.tsx
















var BackgroundColors = /* @__PURE__ */(BackgroundColors2 => {
  BackgroundColors2[BackgroundColors2["White"] = 0] = "White";
  BackgroundColors2[BackgroundColors2["Grey"] = 1] = "Grey";
  return BackgroundColors2;
})(BackgroundColors || {});
const Footer = _ref => {
  let {
    withMarginBottom = true,
    bgColor = 1 /* Grey */,
    footerLayout
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("footer", {
    className: classnames_default()(typography_module/* default */.Z.body2, footer_module.root, {
      [footer_module.rootWhite]: bgColor === 0 /* White */
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()({
          [footer_module.blockWithMargin]: withMarginBottom
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: footer_module.firstRow,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: footer_module.linksColumns,
            children: footerLayout.links.map((linkGroup, groupIndex) => /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
              className: footer_module.linksOneColumn,
              children: linkGroup.map(link => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
                className: footer_module.linkItem,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(FooterLink, {
                  link
                })
              }, link.labelKey))
            }, groupIndex))
          }), footerLayout.disclaimerKey && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: footer_module.disclaimer,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: footerLayout.disclaimerKey
            })
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: footer_module.lastRow,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: footer_module.company,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
              children: intl.formatMessage({
                id: footerLayout.companyInfoKey
              }, {
                practicum_terms: (0,urls/* getExternalUrl */.Eg)("practicum_terms")
              })
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            children: ["\xA9", (0,getYear/* getYear */.S)( /* @__PURE__ */new Date())]
          })]
        })]
      })
    })
  });
};
function FooterLink(_ref2) {
  let {
    link
  } = _ref2;
  const style = classnames_default()(footer_module.link, accessibility_module/* default */.Z.focusVisible);
  if (isExternalFooterLink(link)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("a", {
      className: style,
      target: "_blank",
      href: (0,urls/* getExternalUrl */.Eg)(link.externalUrlKey),
      rel: "noreferrer",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: link.labelKey
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
    className: style,
    to: link.relativeUrl,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
      id: link.labelKey
    })
  });
}
;// CONCATENATED MODULE: ./src/components/app-page-footer/app-page-footer.component.tsx







const AppPageFooter = _ref => {
  let {
    bgColor,
    withMarginBottom
  } = _ref;
  const footerLayoutFetcher = useFooterLayout();
  if (footerLayoutFetcher.state === useFetch/* State */.Z.Error) {
    throw footerLayoutFetcher.error;
  }
  if (footerLayoutFetcher.state === useFetch/* State */.Z.Initial || footerLayoutFetcher.state === useFetch/* State */.Z.Loading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
    footerLayout: footerLayoutFetcher.data,
    bgColor,
    withMarginBottom
  });
};

/***/ }),

/***/ 67398:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ AppPageHelpButton)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _app_help_app_help__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56215);




const AppPageHelpButton = _ref => {
  let {
    onClick,
    hideButton
  } = _ref;
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    role: "presentation",
    children: /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_help_app_help__WEBPACK_IMPORTED_MODULE_1__/* .AppHelp */ .Y, {
      onClick,
      hideButton
    })
  });
};

/***/ }),

/***/ 15079:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: () => (/* binding */ ContentPosition),
/* harmony export */   k: () => (/* binding */ BackgroundColors)
/* harmony export */ });


var ContentPosition = /* @__PURE__ */(ContentPosition2 => {
  ContentPosition2[ContentPosition2["Top"] = 0] = "Top";
  ContentPosition2[ContentPosition2["Center"] = 1] = "Center";
  return ContentPosition2;
})(ContentPosition || {});
var BackgroundColors = /* @__PURE__ */(BackgroundColors2 => {
  BackgroundColors2[BackgroundColors2["White"] = 0] = "White";
  BackgroundColors2[BackgroundColors2["Grey"] = 1] = "Grey";
  return BackgroundColors2;
})(BackgroundColors || {});

/***/ }),

/***/ 71583:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  I: () => (/* binding */ AppPageWrapper)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../../node_modules/react-sticky/lib/index.js
var lib = __webpack_require__(45714);
// EXTERNAL MODULE: ../shared/src/utils/url.ts
var url = __webpack_require__(52702);
// EXTERNAL MODULE: ../ui-kit/src/layout/layout.component.tsx + 1 modules
var layout_component = __webpack_require__(53584);
// EXTERNAL MODULE: ./src/hooks/use-grammar-guide.ts
var use_grammar_guide = __webpack_require__(9784);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ./src/components/app-page-footer/app-page-footer.component.tsx + 7 modules
var app_page_footer_component = __webpack_require__(79771);
// EXTERNAL MODULE: ./src/components/grammar-guide/__button/grammar-guide-button.component.tsx + 5 modules
var grammar_guide_button_component = __webpack_require__(76087);
// EXTERNAL MODULE: ./src/components/grammar-guide/__sheet/grammar-guide-sheet.component.tsx + 3 modules
var grammar_guide_sheet_component = __webpack_require__(80880);
// EXTERNAL MODULE: ./src/components/main-menu/main-menu.tsx + 6 modules
var main_menu = __webpack_require__(74140);
// EXTERNAL MODULE: ./src/components/page-header/index.ts + 29 modules
var page_header = __webpack_require__(17787);
// EXTERNAL MODULE: ./src/components/page-header/types.ts
var types = __webpack_require__(25269);
// EXTERNAL MODULE: ./src/components/promo-code-popup/promo-code-popup.component.tsx + 5 modules
var promo_code_popup_component = __webpack_require__(37042);
// EXTERNAL MODULE: ./src/components/wordbank/wordbank.component.tsx + 13 modules
var wordbank_component = __webpack_require__(99833);
// EXTERNAL MODULE: ./src/components/add-to-calendar-button/add-to-calendar-button.component.tsx + 5 modules
var add_to_calendar_button_component = __webpack_require__(59602);
;// CONCATENATED MODULE: ./src/components/app-page-wrapper/add-page-add-calendar-button.tsx




const AppAddCalendarButton = () => /* @__PURE__ */(0,jsx_runtime.jsx)(add_to_calendar_button_component/* AddToCalendarButton */.m, {
  buttonStyle: "icon",
  desktopDialogType: "modal",
  startTime: /* @__PURE__ */new Date(),
  endTime: /* @__PURE__ */new Date(),
  isMentor: false,
  chapterName: "",
  availableBeforeStartMin: 0,
  inverseColors: true
});
// EXTERNAL MODULE: ./src/components/app-page-wrapper/add-page-helper-button.tsx
var add_page_helper_button = __webpack_require__(67398);
// EXTERNAL MODULE: ./src/components/app-page-wrapper/app-page-wrapper-types.ts
var app_page_wrapper_types = __webpack_require__(15079);
;// CONCATENATED MODULE: ./src/components/app-page-wrapper/app-page-wrapper.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const app_page_wrapper_module = ({"root":"app-page-wrapper-module__root--oucae","with-bottom-menu":"app-page-wrapper-module__with-bottom-menu--bMkWT","withBottomMenu":"app-page-wrapper-module__with-bottom-menu--bMkWT","root-grey":"app-page-wrapper-module__root-grey--_CmtE","rootGrey":"app-page-wrapper-module__root-grey--_CmtE","all-screen-height":"app-page-wrapper-module__all-screen-height--FKy6q","allScreenHeight":"app-page-wrapper-module__all-screen-height--FKy6q","space":"app-page-wrapper-module__space--wvJb7","floated-buttons":"app-page-wrapper-module__floated-buttons--eE5hl","floatedButtons":"app-page-wrapper-module__floated-buttons--eE5hl"});
;// CONCATENATED MODULE: ./src/components/app-page-wrapper/app-page-wrapper.component.tsx
























const AppPageWrapper = _ref => {
  let {
    children,
    self = {
      backgroundImageSrc: null,
      contentPosition: app_page_wrapper_types/* ContentPosition */.E.Top,
      doNotWrapChildrenWithLayout: false,
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.White,
      isStickyContainer: false
    },
    header = {
      hideCourseSelectButton: false,
      hideMenuButton: false,
      hideNotifierBell: false,
      isCourseSelectPage: false,
      hideNavigation: false,
      hideReferralProgramElements: true,
      headerLeftSideBlock: types/* HeaderLefSideBlockContent */.c.Default,
      hideEducationItems: false,
      children: null
    },
    main = {
      hideHelpPopup: false,
      hideHelpButton: false,
      hideGrammarGuideButton: false,
      showCalendarButton: false
    },
    footer = {
      hideFooter: false,
      footerWithMargin: false
    },
    data = {
      isRepetitionAvailable: false
    }
  } = _ref;
  const rootStyles = {};
  if (self.backgroundImageSrc) {
    rootStyles.backgroundImage = (0,url/* convertImageUrlToCssUrl */.v)(self.backgroundImageSrc);
  }
  const history = (0,react_router/* useHistory */.k6)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    showGuidesButton
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const {
    showGrammarGuide,
    toggleGrammarGuideVisibility
  } = (0,use_grammar_guide/* useGrammarGuide */.U)();
  const renderStickyComponent = (isStickyContainer, children2) => {
    if (isStickyContainer) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(lib/* StickyContainer */.L9, {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
          children: children2
        })
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
      children: children2
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(app_page_wrapper_module.root, {
      [app_page_wrapper_module.rootGrey]: self.bgColor === app_page_wrapper_types/* BackgroundColors */.k.Grey,
      [app_page_wrapper_module.withBottomMenu]: footer.withBottomMenu
    }),
    style: rootStyles,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: app_page_wrapper_module.allScreenHeight,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(page_header/* PageHeader */.m, {
        leftSideBlock: header.headerLeftSideBlock,
        hideCourseSelectButton: header.hideCourseSelectButton,
        hideMenuButton: header.hideMenuButton,
        hideNavigation: header.hideNavigation,
        hideNotifierBell: header.hideNotifierBell,
        hideReferralProgramElements: header.hideReferralProgramElements,
        isCourseSelectPage: header.isCourseSelectPage,
        children: header.children
      }), self.contentPosition === app_page_wrapper_types/* ContentPosition */.E.Center && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: app_page_wrapper_module.space
      }), self.doNotWrapChildrenWithLayout ? children : renderStickyComponent(self.isStickyContainer, children)]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: app_page_wrapper_module.space
    }), !footer.hideFooter && /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_footer_component/* AppPageFooter */.b, {
      bgColor: self.bgColor === app_page_wrapper_types/* BackgroundColors */.k.Grey ? app_page_wrapper_types/* BackgroundColors */.k.White : app_page_wrapper_types/* BackgroundColors */.k.Grey,
      withMarginBottom: footer.footerWithMargin
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: app_page_wrapper_module.floatedButtons,
      children: [!main.hideGrammarGuideButton && showGuidesButton && /* @__PURE__ */(0,jsx_runtime.jsx)(grammar_guide_button_component/* GrammarGuideButton */.G, {}), main.showCalendarButton && /* @__PURE__ */(0,jsx_runtime.jsx)(AppAddCalendarButton, {}), !main.hideHelpPopup && /* @__PURE__ */(0,jsx_runtime.jsx)(add_page_helper_button/* AppPageHelpButton */.C, {
        hideButton: main.hideHelpButton
      })]
    }), !header.hideMenuButton && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(main_menu/* MainMenu */.l, {
        isRepetitionAvailable: data.isRepetitionAvailable,
        currentProductId: user.data?.product?.id,
        hideEducationItems: header.hideEducationItems
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(wordbank_component/* Wordbank */.b, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(promo_code_popup_component/* PromoCodePopup */.V, {
        backPath: get_url_search_params.getUrlSearchParams.promocodePopup.getCloseUrl(history),
        customSuccessButtonTextId: "promoCodePopup.continue"
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(grammar_guide_sheet_component/* GrammarGuideSheet */.y, {
      visible: showGrammarGuide,
      onClose: toggleGrammarGuideVisibility
    })]
  });
};

/***/ }),

/***/ 42037:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AO: () => (/* binding */ hideAudioFooter),
/* harmony export */   Wf: () => (/* binding */ $audioFooterVisible),
/* harmony export */   t4: () => (/* binding */ showAudioFooter)
/* harmony export */ });
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31976);



const d = (0,effector__WEBPACK_IMPORTED_MODULE_0__/* .createDomain */ .Fj)("audio-footer");
const $audioFooterVisible = d.createStore(false);
const showAudioFooter = d.createEvent();
const hideAudioFooter = d.createEvent();
$audioFooterVisible.on(showAudioFooter, () => true);
$audioFooterVisible.on(hideAudioFooter, () => false);

/***/ }),

/***/ 54802:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: () => (/* binding */ classEventEmitter)
/* harmony export */ });
/* harmony import */ var _yandex_langly_shared_src_event_emitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1341);



const classEventEmitter = (0,_yandex_langly_shared_src_event_emitter__WEBPACK_IMPORTED_MODULE_0__/* .createEventEmitter */ .I)();

/***/ }),

/***/ 28363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  WM: () => (/* binding */ $accessState),
  Ry: () => (/* binding */ ClassDrawingModule),
  PK: () => (/* binding */ setAccessStatePartial)
});

// UNUSED EXPORTS: setAccessState

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.group-by.js
var es_object_group_by = __webpack_require__(96357);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.flat-map.js
var esnext_async_iterator_flat_map = __webpack_require__(53593);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.flat-map.js
var esnext_iterator_flat_map = __webpack_require__(25534);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
// EXTERNAL MODULE: ./src/components/drawing/model/interfaces.ts
var interfaces = __webpack_require__(76736);
// EXTERNAL MODULE: ./src/components/drawing/model/utils/index.ts + 5 modules
var utils = __webpack_require__(21569);
// EXTERNAL MODULE: ./src/components/class/event-emitter.ts
var event_emitter = __webpack_require__(54802);
// EXTERNAL MODULE: ./src/components/class/platform/models/socket.ts
var socket = __webpack_require__(99956);
// EXTERNAL MODULE: ./src/components/class/modules/toast/index.ts + 5 modules
var toast = __webpack_require__(83693);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/class-drawing-notifications.tsx





const ClassDrawingAccessToast = _ref => {
  let {
    canDraw,
    isTutor,
    isWhiteboard
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  if (isTutor) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(toast/* ClassToast */.ZW, {
      text: intl.formatMessage({
        id: "Drawing.accessToast.tutor"
      }, {
        canDraw,
        isWhiteboard
      }),
      icon: {
        name: canDraw ? "user-outline-ok" : "user-outline-error"
      }
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(toast/* ClassToast */.ZW, {
    text: intl.formatMessage({
      id: "Drawing.accessToast.student"
    }, {
      canDraw,
      isWhiteboard
    }),
    icon: {
      name: canDraw ? "draw" : "draw-crossed"
    }
  });
};
// EXTERNAL MODULE: ./src/components/class/modules/drawing/model/drawing-history.ts + 1 modules
var drawing_history = __webpack_require__(90870);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/class-drawing-module.tsx























const [$accessState, setAccessState] = (0,makeStore/* makeStore */.n)({});
const setAccessStatePartial = (0,effector/* createEvent */.yM)();
$accessState.on(setAccessStatePartial, (state, _ref) => {
  let {
    id,
    access
  } = _ref;
  return {
    ...state,
    [id]: access
  };
});
const drawingAccessViewOnlyToastId = "drawing-view-only-access";
const drawingImagesAccessViewOnlyToastId = "drawing-images-view-only-access";
const drawingAccessFullToastId = "drawing-full-access";
const drawingImagesAccessFullToastId = "drawing-images-full-access";
const ClassDrawingModule = {
  onMessage(_ref2) {
    let {
      state
    } = _ref2;
    const {
      context
    } = state;
    return event => {
      const message = JSON.parse(event.data);
      if ((0,socket/* isInitialStateMessage */.p7)(message)) {
        const drawingMessages = message.data.filter(socket/* isDrawingMessage */.MZ);
        const initialChangesByDrawingId = {};
        const messagesByDrawingId = Object.groupBy(drawingMessages, m => m.data.id);
        Object.keys(messagesByDrawingId).forEach(drawingId => {
          initialChangesByDrawingId[drawingId] = (0,utils/* mergeDrawingChanges */.Fm)(messagesByDrawingId[drawingId].flatMap(_ref3 => {
            let {
              data
            } = _ref3;
            return data.changes;
          }));
        });
        (0,drawing_history/* setInitialChanges */.QI)(initialChangesByDrawingId);
        const drawingAccessMessages = message.data.filter(socket/* isDrawingAccessMessage */.Tf);
        const drawingAccessState = drawingAccessMessages.reduce((acc, item) => {
          acc[item.data.id] = item.data.access;
          return acc;
        }, {});
        setAccessState(drawingAccessState);
      }
      if ((0,socket/* isDrawingMessage */.MZ)(message)) {
        const {
          id,
          userId,
          changes
        } = message.data;
        if (userId !== context.userId) {
          (0,drawing_history/* appendChanges */.Gh)({
            id,
            userId,
            changes
          });
          event_emitter/* classEventEmitter */.R.emit((0,utils/* getDrawingSyncKey */.bH)(id), changes);
        }
      }
      if ((0,socket/* isDrawingAccessMessage */.Tf)(message)) {
        const canDraw = message.data.access === interfaces/* DrawingAccessType */.L.Full;
        const isTutor = message.data.userId === context.userId;
        const isWhiteboard = message.data.id === "drawing-whiteboard";
        if (isTutor) {
          (0,toast/* hideClassNotification */.$$)(getDrawingAccessToastId(!canDraw, isWhiteboard));
          (0,toast/* showClassNotification */.Zu)( /* @__PURE__ */(0,jsx_runtime.jsx)(ClassDrawingAccessToast, {
            isTutor: true,
            isWhiteboard,
            canDraw
          }), {
            toastId: getDrawingAccessToastId(canDraw, isWhiteboard)
          });
        } else {
          (0,toast/* hideClassNotification */.$$)(getDrawingAccessToastId(!canDraw, isWhiteboard));
          (0,toast/* showClassNotification */.Zu)( /* @__PURE__ */(0,jsx_runtime.jsx)(ClassDrawingAccessToast, {
            isTutor: false,
            isWhiteboard,
            canDraw
          }), {
            toastId: getDrawingAccessToastId(canDraw, isWhiteboard)
          });
        }
        if (!isTutor) {
          setAccessStatePartial(message.data);
        }
      }
    };
  },
  clear: () => {
    (0,toast/* hideClassNotification */.$$)(drawingAccessViewOnlyToastId);
    (0,toast/* hideClassNotification */.$$)(drawingImagesAccessViewOnlyToastId);
    (0,toast/* hideClassNotification */.$$)(drawingAccessFullToastId);
    (0,toast/* hideClassNotification */.$$)(drawingImagesAccessFullToastId);
    (0,drawing_history/* resetInitialChanges */.jp)();
  }
};
function getDrawingAccessToastId(canDraw, isWhiteboard) {
  if (isWhiteboard) {
    return canDraw ? drawingAccessFullToastId : drawingAccessViewOnlyToastId;
  }
  return canDraw ? drawingImagesAccessFullToastId : drawingImagesAccessViewOnlyToastId;
}

/***/ }),

/***/ 39909:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  GN: () => (/* binding */ DrawingSyncContextProvider),
  Mi: () => (/* binding */ useDrawingSyncContext)
});

// UNUSED EXPORTS: DrawingSyncContext

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/components/drawing/model/interfaces.ts
var interfaces = __webpack_require__(76736);
// EXTERNAL MODULE: ./src/components/class/platform/class-platform-context.tsx
var class_platform_context = __webpack_require__(47178);
// EXTERNAL MODULE: ./src/components/class/modules/drawing/class-drawing-module.tsx + 1 modules
var class_drawing_module = __webpack_require__(28363);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/hooks/use-drawing-access-button.tsx








function useDrawingAccessButton(id) {
  const intl = (0,useIntl/* default */.Z)();
  const {
    wsSend,
    state
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const {
    userId,
    userRole
  } = state.context;
  const drawingAccess = (0,effector_react/* useStoreMap */.K3)(class_drawing_module/* $accessState */.WM, state2 => state2[id] || interfaces/* DrawingAccessType */.L.View);
  const handleChangeDrawingAccess = (0,react.useCallback)(() => {
    const nextState = drawingAccess === interfaces/* DrawingAccessType */.L.Full ? interfaces/* DrawingAccessType */.L.View : interfaces/* DrawingAccessType */.L.Full;
    (0,class_drawing_module/* setAccessStatePartial */.PK)({
      id,
      access: nextState
    });
    wsSend({
      event_type: "class_action",
      data: {
        type: "drawing_access",
        access: nextState,
        userId,
        id
      }
    });
  }, [drawingAccess, id, userId, wsSend]);
  const tooltip = intl.formatMessage({
    id: drawingAccess === interfaces/* DrawingAccessType */.L.Full ? "Drawing.Tools.revokeStudentDraw" : "Drawing.Tools.grantStudentDraw"
  });
  const accessButton = (0,react.useMemo)(() => ({
    key: "drawing-access",
    iconName: drawingAccess === interfaces/* DrawingAccessType */.L.Full ? "user-outline-ok" : "user-outline-error",
    isActive: drawingAccess === interfaces/* DrawingAccessType */.L.Full,
    onClick: handleChangeDrawingAccess,
    tooltip
  }), [drawingAccess, handleChangeDrawingAccess, tooltip]);
  if (userRole === "student") {
    return void 0;
  }
  return accessButton;
}
;// CONCATENATED MODULE: ../shared/src/utils/getOSActionKey.ts


function getOSActionKey() {
  if (/OS X/.test(navigator.userAgent)) {
    return {
      titleShort: "Cmd",
      eventKey: "metaKey"
    };
  }
  return {
    titleShort: "Ctrl",
    eventKey: "ctrlKey"
  };
}
// EXTERNAL MODULE: ./src/components/class/modules/drawing/model/drawing-history.ts + 1 modules
var drawing_history = __webpack_require__(90870);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/hooks/use-drawing-redo-button.tsx







const OSActionKey = getOSActionKey();
function useDrawingRedoButton(id) {
  const intl = (0,useIntl/* default */.Z)();
  const drawingCanRedo = (0,effector_react/* useStoreMap */.K3)(drawing_history/* $drawingCanRedo */.hj, store => store?.[id]);
  return (0,react.useMemo)(() => ({
    key: "redo",
    iconName: "redo",
    onClick: () => (0,drawing_history/* redoDrawingChange */._7)({
      id
    }),
    tooltip: intl.formatMessage({
      id: "Drawing.Tools.redo"
    }),
    disabled: !drawingCanRedo,
    hotkey: `${OSActionKey.titleShort}+Shift+Z`,
    hotkeyCheck: e => e.code === "KeyZ" && e.shiftKey && e[OSActionKey.eventKey]
  }), [drawingCanRedo, id, intl]);
}
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var src_logger = __webpack_require__(66176);
// EXTERNAL MODULE: ./src/components/drawing/model/constants.ts
var constants = __webpack_require__(76318);
// EXTERNAL MODULE: ./src/components/class/event-emitter.ts
var event_emitter = __webpack_require__(54802);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/hooks/use-drawing-sync.tsx








function useDrawingSync() {
  const {
    wsSend,
    state
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const {
    userId
  } = state.context;
  const logger = (0,react.useRef)(src_logger/* ClientLogger */.q$.create("useDrawingSync")).current;
  const sendChanges = (0,react.useCallback)(_ref => {
    let {
      id,
      changes
    } = _ref;
    logger.debug("sendChanges", changes);
    (0,drawing_history/* appendChanges */.Gh)({
      id: id ?? "",
      userId,
      changes
    });
    wsSend({
      event_type: "class_action",
      data: {
        type: "drawing",
        changes,
        userId,
        id: id ?? ""
      }
    });
  }, [logger, userId, wsSend]);
  (0,react.useEffect)(() => {
    event_emitter/* classEventEmitter */.R.on(constants/* DRAWING_CHANGE_EVENT_NAME */._, sendChanges);
    return () => {
      event_emitter/* classEventEmitter */.R.off(constants/* DRAWING_CHANGE_EVENT_NAME */._, sendChanges);
    };
  }, [sendChanges]);
  return {
    eventEmitter: event_emitter/* classEventEmitter */.R
  };
}
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/hooks/use-drawing-trash-button.tsx








function useDrawingTrashButton(id) {
  const intl = (0,useIntl/* default */.Z)();
  const {
    state
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const {
    userId,
    userRole
  } = state.context;
  const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
  const openModal = (0,react.useCallback)(() => setIsModalOpen(true), []);
  const closeModal = (0,react.useCallback)(() => setIsModalOpen(false), []);
  return (0,react.useMemo)(() => [{
    key: "trash",
    iconName: "trash-outline",
    onClick: openModal,
    tooltip: intl.formatMessage({
      id: "Drawing.Tools.trash"
    })
  }, /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    titleSize: modal/* TitleSize */.Jj.Big,
    title: intl.formatMessage({
      id: "Drawing.Tools.trashModalTitle"
    }),
    subtitle: userRole === "student" ? intl.formatMessage({
      id: "Drawing.Tools.trashModalSubtitleStudent"
    }) : intl.formatMessage({
      id: "Drawing.Tools.trashModalSubtitleTutor"
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "Drawing.Tools.trashModalCancel"
      }),
      appearance: "secondary",
      onClick: closeModal
    }, {
      text: intl.formatMessage({
        id: "Drawing.Tools.trashModalConfirm"
      }),
      appearance: "primary",
      onClick: () => {
        if (userRole === "student") {
          (0,drawing_history/* trashUserDrawing */.OV)({
            id,
            userId
          });
        } else {
          (0,drawing_history/* trashAllDrawing */.zH)({
            id,
            userId
          });
        }
        closeModal();
      }
    }],
    isVisible: isModalOpen,
    buttonsBlockStretch: false,
    isNarrow: false,
    showCloseButton: true,
    closeButtonAriaLabel: intl.formatMessage({
      id: "Drawing.Tools.trashModalCancel"
    }),
    onClose: closeModal
  }, "toolboxTrash")], [closeModal, id, intl, isModalOpen, openModal, userId, userRole]);
}
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/hooks/use-drawing-undo-button.tsx








const use_drawing_undo_button_OSActionKey = getOSActionKey();
function useDrawingUndoButton(id) {
  const intl = (0,useIntl/* default */.Z)();
  const {
    state
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const {
    userId
  } = state.context;
  const drawingCanUndo = (0,effector_react/* useStoreMap */.K3)(drawing_history/* $drawingCanUndo */.mo, store => store?.[id]?.[userId]);
  return (0,react.useMemo)(() => ({
    key: "undo",
    iconName: "undo",
    onClick: () => (0,drawing_history/* undoDrawingChange */.TN)({
      id,
      userId
    }),
    tooltip: intl.formatMessage({
      id: "Drawing.Tools.undo"
    }),
    disabled: !drawingCanUndo,
    hotkey: `${use_drawing_undo_button_OSActionKey.titleShort}+Z`,
    hotkeyCheck: e => e.code === "KeyZ" && !e.shiftKey && e[use_drawing_undo_button_OSActionKey.eventKey]
  }), [drawingCanUndo, id, intl, userId]);
}
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/drawing-sync-context.tsx











const DrawingSyncContext = (0,react.createContext)({});
function useDrawingSyncContext() {
  return (0,react.useContext)(DrawingSyncContext);
}
const DrawingSyncContextProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    eventEmitter
  } = useDrawingSync();
  const context = (0,react.useMemo)(() => ({
    eventEmitter,
    getInitialDrawingState: blockId => drawing_history/* $currentDrawingState */.EH.getState()?.[blockId] ?? [],
    useToolboxCustomButtons: blockId => {
      const drawingAccessButton = useDrawingAccessButton(blockId);
      const undoDrawingChangeButton = useDrawingUndoButton(blockId);
      const redoDrawingChangeButton = useDrawingRedoButton(blockId);
      const [trashDrawingChangeButton, trashModal] = useDrawingTrashButton(blockId);
      const customButtons = [trashDrawingChangeButton, undoDrawingChangeButton, redoDrawingChangeButton];
      if (drawingAccessButton) {
        customButtons.push(drawingAccessButton);
      }
      return [customButtons, [trashModal]];
    }
  }), [eventEmitter]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(DrawingSyncContext.Provider, {
    value: context,
    children
  });
};

/***/ }),

/***/ 90870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  EH: () => (/* binding */ $currentDrawingState),
  hj: () => (/* binding */ $drawingCanRedo),
  mo: () => (/* binding */ $drawingCanUndo),
  Gh: () => (/* binding */ appendChanges),
  _7: () => (/* binding */ redoDrawingChange),
  jp: () => (/* binding */ resetInitialChanges),
  QI: () => (/* binding */ setInitialChanges),
  zH: () => (/* binding */ trashAllDrawing),
  OV: () => (/* binding */ trashUserDrawing),
  TN: () => (/* binding */ undoDrawingChange)
});

// UNUSED EXPORTS: $initialChanges

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.flat-map.js
var esnext_async_iterator_flat_map = __webpack_require__(53593);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.flat-map.js
var esnext_iterator_flat_map = __webpack_require__(25534);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
;// CONCATENATED MODULE: ../shared/src/utils/es2023/find-last.ts


function findLastIndex(array, predicate) {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) {
      return l;
    }
  }
  return -1;
}
function findLast(array, predicate) {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) {
      return array[l];
    }
  }
  return void 0;
}
// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
// EXTERNAL MODULE: ./src/components/drawing/model/constants.ts
var constants = __webpack_require__(76318);
// EXTERNAL MODULE: ./src/components/drawing/model/utils/index.ts + 5 modules
var utils = __webpack_require__(21569);
// EXTERNAL MODULE: ./src/components/class/event-emitter.ts
var event_emitter = __webpack_require__(54802);
;// CONCATENATED MODULE: ./src/components/class/modules/drawing/model/drawing-history.ts
















































const appendChanges = (0,effector/* createEvent */.yM)();
const undoDrawingChange = (0,effector/* createEvent */.yM)();
const redoDrawingChange = (0,effector/* createEvent */.yM)();
const refreshUndoRedo = (0,effector/* createEvent */.yM)();
const trashAllDrawing = (0,effector/* createEvent */.yM)();
const trashUserDrawing = (0,effector/* createEvent */.yM)();
const [$initialChanges, setInitialChanges, resetInitialChanges] = (0,makeStore/* makeStore */.n)({});
const [$drawingHistory, setDrawingHistory] = (0,makeStore/* makeStore */.n)({});
const [$drawingRedoHistory, setDrawingRedoHistory] = (0,makeStore/* makeStore */.n)({});
const $currentDrawingState = (0,effector/* combine */.$e)($initialChanges, $drawingHistory, (initial, history) => {
  const ids = Array.from( /* @__PURE__ */new Set([...Object.keys(initial), ...Object.keys(history)]));
  const result = {};
  ids.forEach(drawingId => {
    result[drawingId] = (0,utils/* mergeDrawingChanges */.Fm)((initial[drawingId] ?? []).concat((history[drawingId] ?? []).flatMap(record => record.changes)));
  });
  return result;
});
const $drawingCanUndo = (0,effector/* createStore */.MT)({});
const $drawingCanRedo = $drawingRedoHistory.map(redoHistory => {
  const result = {};
  for (const id in redoHistory) {
    result[id] = redoHistory[id].length > 0;
  }
  return result;
});
const syncFx = (0,effector/* createEffect */.GW)(_ref => {
  let {
    id,
    userId,
    changes,
    history,
    redoHistory
  } = _ref;
  if (changes.length === 0) {
    return;
  }
  event_emitter/* classEventEmitter */.R.emit((0,utils/* getDrawingSyncKey */.bH)(id), changes);
  event_emitter/* classEventEmitter */.R.emit(constants/* DRAWING_CHANGE_EVENT_NAME */._, {
    id,
    changes
  });
  setDrawingHistory(history);
  setDrawingRedoHistory(redoHistory);
  refreshUndoRedo({
    id,
    userId
  });
});
(0,effector/* sample */.UP)({
  source: $drawingHistory,
  clock: appendChanges,
  fn: (history, _ref2) => {
    let {
      id,
      userId,
      changes
    } = _ref2;
    return {
      ...history,
      [id]: (history[id] ?? []).concat({
        userId: userId || "",
        changes
      })
    };
  },
  target: $drawingHistory
});
(0,effector/* sample */.UP)({
  source: {
    drawingHistory: $drawingHistory,
    drawingRedoHistory: $drawingRedoHistory
  },
  clock: redoDrawingChange,
  fn: (_ref3, _ref4) => {
    let {
      drawingHistory,
      drawingRedoHistory
    } = _ref3;
    let {
      id
    } = _ref4;
    const redoHistory = drawingRedoHistory[id] || [];
    const historyRecord = redoHistory[redoHistory.length - 1];
    if (!historyRecord) {
      return {
        id,
        userId: "",
        changes: [],
        history: drawingHistory,
        redoHistory: drawingRedoHistory
      };
    }
    const updatedHistory = (drawingHistory[id] || []).concat(historyRecord);
    const updatedRedoHistory = redoHistory.slice(0, -1);
    return {
      id,
      userId: historyRecord.userId,
      changes: historyRecord.changes,
      history: {
        ...drawingHistory,
        [id]: updatedHistory
      },
      redoHistory: {
        ...drawingRedoHistory,
        [id]: updatedRedoHistory
      }
    };
  },
  target: syncFx
});
(0,effector/* sample */.UP)({
  source: {
    initialChanges: $initialChanges,
    drawingHistory: $drawingHistory,
    drawingRedoHistory: $drawingRedoHistory
  },
  clock: undoDrawingChange,
  fn: (_ref5, _ref6) => {
    let {
      initialChanges,
      drawingHistory,
      drawingRedoHistory
    } = _ref5;
    let {
      id,
      userId
    } = _ref6;
    const history = drawingHistory[id] || [];
    const lastChangeIndex = findLastUndoableIndex(history, userId);
    if (lastChangeIndex < 0) {
      return {
        id,
        userId,
        changes: [],
        history: drawingHistory,
        redoHistory: drawingRedoHistory
      };
    }
    const changesForReplace = history[lastChangeIndex].changes.filter(change => !hasLaterChanges(change, history.slice(lastChangeIndex + 1, history.length), userId));
    const changes = findStateBeforeUndo(changesForReplace, history.slice(0, lastChangeIndex), initialChanges[id] ?? []);
    let updatedHistory;
    if (changes.length === history[lastChangeIndex].changes.length) {
      updatedHistory = history.filter((_, index) => index !== lastChangeIndex);
    } else {
      updatedHistory = [...history];
      const updatedChange = history[lastChangeIndex].changes.filter(historyChange => changes.every(change => historyChange.id !== change.id));
      updatedHistory[lastChangeIndex].changes = updatedChange;
    }
    const updatedRedoHistory = (drawingRedoHistory[id] || []).concat({
      userId: history[lastChangeIndex].userId,
      changes: changesForReplace
    });
    return {
      id,
      userId,
      changes,
      history: {
        ...drawingHistory,
        [id]: updatedHistory
      },
      redoHistory: {
        ...drawingRedoHistory,
        [id]: updatedRedoHistory
      }
    };
  },
  target: syncFx
});
function findLastUndoableIndex(history, userId) {
  let lastChangeIndex = history.length;
  while (lastChangeIndex >= 0) {
    lastChangeIndex = findLastIndex(history.slice(0, lastChangeIndex), record => record.userId === userId);
    if (lastChangeIndex < 0) {
      break;
    }
    const overchange = history[lastChangeIndex].changes.every(change => hasLaterChanges(change, history.slice(lastChangeIndex + 1, history.length), userId));
    if (!overchange) {
      break;
    }
  }
  return lastChangeIndex;
}
function hasLaterChanges(change, history, userId) {
  return history.some(record => record.userId !== userId && record.changes.some(recordChange => recordChange.id === change.id));
}
function findStateBeforeUndo(changes, history, initialChanges) {
  return changes.map(undo => {
    const previousRecord = findLast(history, record => record.changes.some(recordChange => recordChange.id === undo.id));
    if (previousRecord) {
      return previousRecord.changes.find(recordChange => recordChange.id === undo.id);
    }
    const initialRecord = initialChanges.find(elem => elem.id === undo.id);
    return {
      id: undo.id,
      value: initialRecord?.value || null
    };
  });
}
(0,effector/* sample */.UP)({
  source: $drawingRedoHistory,
  clock: appendChanges,
  fn: (redoHistory, _ref7) => {
    let {
      id
    } = _ref7;
    return {
      ...redoHistory,
      [id]: []
    };
  },
  target: $drawingRedoHistory
});
(0,effector/* sample */.UP)({
  source: {
    history: $drawingHistory,
    canUndo: $drawingCanUndo
  },
  clock: [appendChanges, refreshUndoRedo],
  fn: (_ref8, _ref9) => {
    let {
      history,
      canUndo
    } = _ref8;
    let {
      id,
      userId = ""
    } = _ref9;
    const result = {
      ...canUndo[id]
    };
    result[userId] ??= false;
    for (const user in result) {
      result[user] = findLastUndoableIndex(history[id], user) >= 0;
    }
    return {
      ...canUndo,
      [id]: result
    };
  },
  target: $drawingCanUndo
});
(0,effector/* sample */.UP)({
  source: {
    currentState: $currentDrawingState,
    drawingHistory: $drawingHistory,
    drawingRedoHistory: $drawingRedoHistory
  },
  clock: trashAllDrawing,
  fn: (_ref10, _ref11) => {
    let {
      currentState,
      drawingHistory,
      drawingRedoHistory
    } = _ref10;
    let {
      id,
      userId
    } = _ref11;
    const trashChanges = currentState[id] || [];
    if (trashChanges.length === 0) {
      return {
        id,
        userId,
        changes: [],
        history: drawingHistory,
        redoHistory: drawingRedoHistory
      };
    }
    const changes = trashChanges.map(record => ({
      id: record.id,
      value: null
    }));
    const history = drawingHistory[id] || [];
    const updatedHistory = [...history, {
      userId,
      changes
    }];
    return {
      id,
      userId,
      changes,
      history: {
        ...drawingHistory,
        [id]: updatedHistory
      },
      redoHistory: {
        ...drawingRedoHistory,
        [id]: []
      }
    };
  },
  target: syncFx
});
function findCreatedAndOwnedByUserChangeIds(history, initialChanges, userId) {
  const changeOwner = history.reduce((acc, record) => {
    if (record.userId === userId) {
      record.changes.forEach(change => {
        if (change.value === null) {
          delete acc[change.id];
        } else {
          acc[change.id] = acc[change.id] !== false;
        }
      });
    } else {
      record.changes.forEach(change => {
        if (change.value === null) {
          delete acc[change.id];
        } else {
          acc[change.id] = false;
        }
      });
    }
    return acc;
  }, {});
  return Object.keys(changeOwner).filter(id => changeOwner[id] && !initialChanges.find(initialChange => initialChange.id === id));
}
(0,effector/* sample */.UP)({
  source: {
    initialChanges: $initialChanges,
    drawingHistory: $drawingHistory,
    drawingRedoHistory: $drawingRedoHistory
  },
  clock: trashUserDrawing,
  fn: (_ref12, _ref13) => {
    let {
      initialChanges,
      drawingHistory,
      drawingRedoHistory
    } = _ref12;
    let {
      id,
      userId
    } = _ref13;
    const trashChanges = findCreatedAndOwnedByUserChangeIds(drawingHistory[id] || [], initialChanges[id] || [], userId);
    if (trashChanges.length === 0) {
      return {
        id,
        userId,
        changes: [],
        history: drawingHistory,
        redoHistory: drawingRedoHistory
      };
    }
    const changes = trashChanges.map(id2 => ({
      id: id2,
      value: null
    }));
    const history = drawingHistory[id] || [];
    const updatedHistory = [...history, {
      userId,
      changes
    }];
    return {
      id,
      userId,
      changes,
      history: {
        ...drawingHistory,
        [id]: updatedHistory
      },
      redoHistory: {
        ...drawingRedoHistory,
        [id]: []
      }
    };
  },
  target: syncFx
});

/***/ }),

/***/ 42419:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  KF: () => (/* reexport */ HighlightedWordContext),
  Xn: () => (/* reexport */ HighlightedWordModule),
  em: () => (/* reexport */ useHighlightedWord)
});

// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(80594);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
;// CONCATENATED MODULE: ./src/components/translatable-text/highlighting-notifier.ts









function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class HighlightingNotifier {
  constructor() {
    _defineProperty(this, "subscribers", []);
  }
  subscribe(callback) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter(x => x !== callback);
    };
  }
  emit(event) {
    this.subscribers.forEach(subscriber => subscriber(event));
  }
}
;// CONCATENATED MODULE: ./src/components/class/modules/highlighted-word/store.ts




const $hoveredWordPath = (0,effector/* createStore */.MT)(null);
const $highlightedWordPath = (0,effector/* createStore */.MT)(null);
const $highlightedWordAction = (0,effector/* createStore */.MT)("reset");
const {
  setHoveredWordPath
} = (0,effector/* createApi */.LC)($hoveredWordPath, {
  setHoveredWordPath: (_, value) => value
});
const {
  setHighlightedWordPath
} = (0,effector/* createApi */.LC)($highlightedWordPath, {
  setHighlightedWordPath: (_, value) => value
});
const {
  setHighlightedWordAction
} = (0,effector/* createApi */.LC)($highlightedWordAction, {
  setHighlightedWordAction: (_, value) => value
});
const highlightingNotifier = new HighlightingNotifier();
;// CONCATENATED MODULE: ./src/components/class/modules/highlighted-word/context.ts






const HighlightedWordContext = (0,react.createContext)({
  hoveredWordPath: null,
  highlightedWordPath: null,
  highlightedWordAction: "reset",
  hasActionsTooltip: false
});
const useHighlightedWord = _ref => {
  let {
    userId,
    wsSend
  } = _ref;
  const hoveredWordPath = (0,effector_react/* useStore */.oR)($hoveredWordPath);
  const highlightedWordPath = (0,effector_react/* useStore */.oR)($highlightedWordPath);
  const highlightedWordAction = (0,effector_react/* useStore */.oR)($highlightedWordAction);
  const sendMessage = (0,react.useCallback)((wordPath, action) => wsSend({
    event_type: "class_action",
    data: {
      type: "highlighted_word",
      action,
      wordPath,
      userId
    }
  }), [userId, wsSend]);
  const sendMessageDebounced = (0,react.useMemo)(() => lodash_debounce_default()(sendMessage, 100, {
    trailing: true
  }), [sendMessage]);
  const onWordAction = (0,react.useCallback)((wordPath, action) => {
    if (action === "highlight" || action === "translate" || action === "scroll") {
      setHighlightedWordPath(wordPath);
    }
    if (action === "hover" || action === "leave") {
      sendMessageDebounced(wordPath, action);
    } else {
      sendMessage(wordPath, action);
    }
  }, [sendMessage, sendMessageDebounced]);
  const onOutsideClick = (0,react.useCallback)(() => {
    setHighlightedWordPath(null);
    sendMessage(null, "reset");
  }, [sendMessage]);
  return {
    hoveredWordPath,
    highlightedWordPath,
    highlightedWordAction,
    highlightingNotifier: highlightingNotifier,
    hasActionsTooltip: true,
    onWordAction,
    onOutsideClick
  };
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
;// CONCATENATED MODULE: ./src/components/class/modules/highlighted-word/module.ts





const HighlightedWordModule = {
  onMessage: context => event => {
    const message = JSON.parse(event.data);
    if (message.event_type === "class_action" && message.data.type === "highlighted_word") {
      if (message.data.userId === context.state.context.userId) {
        return;
      }
      const {
        wordPath,
        action
      } = message.data;
      switch (action) {
        case "highlight":
        case "translate":
        case "scroll":
        case "reset":
          setHighlightedWordPath(wordPath);
          break;
        case "hover":
          setHoveredWordPath(wordPath);
          break;
        case "leave":
          setHoveredWordPath(null);
          break;
        default:
          throw new unhandled_case/* UnhandledCaseError */.H(action);
      }
      setHighlightedWordAction(action);
      highlightingNotifier.emit({
        action
      });
    }
  },
  clear: () => {
    setHoveredWordPath(null);
    setHighlightedWordPath(null);
  }
};
;// CONCATENATED MODULE: ./src/components/class/modules/highlighted-word/index.ts





/***/ }),

/***/ 83693:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZW: () => (/* reexport */ ClassToast),
  iH: () => (/* reexport */ ClassToastContainer),
  $$: () => (/* reexport */ hideClassNotification),
  Zu: () => (/* reexport */ showClassNotification)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/components/class/modules/toast/ui/toast/toast.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toast_module = ({"root":"toast-module__root--Q26q0","icon":"toast-module__icon--sA6AV","icon-red":"toast-module__icon-red--MgUZj","iconRed":"toast-module__icon-red--MgUZj"});
;// CONCATENATED MODULE: ./src/components/class/modules/toast/ui/toast/toast.tsx








const ClassToast = _ref => {
  let {
    text,
    icon,
    dataTestId
  } = _ref;
  const renderIcon = (0,react.useCallback)(icon2 => {
    const {
      name,
      color,
      alt
    } = icon2;
    return /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name,
      size: "medium",
      className: classnames_default()(toast_module.icon, {
        [toast_module[`icon-${color}`]]: color
      }),
      alt
    });
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: toast_module.root,
    "data-testid": dataTestId ?? "",
    children: [icon && renderIcon(icon), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body2,
      children: text
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(88932);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useUnmount.js
var useUnmount = __webpack_require__(27027);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
;// CONCATENATED MODULE: ./src/components/class/modules/toast/lib/utils/utils.ts



const showClassNotification = (content, options) => (0,react_toastify_esm/* toast */.Am)(content, {
  containerId: "Class",
  ...options
});
const hideClassNotification = toastId => {
  react_toastify_esm/* toast */.Am.dismiss(toastId);
};
const hideAllClassNotifications = () => {
  react_toastify_esm/* toast */.Am.dismiss();
};
;// CONCATENATED MODULE: ./src/components/class/modules/toast/ui/toaster.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toaster_module = ({"root":"toaster-module__root--SOP0L","toast":"toaster-module__toast--Who2x","toast-body":"toaster-module__toast-body--IJDaL","toastBody":"toaster-module__toast-body--IJDaL"});
;// CONCATENATED MODULE: ./src/components/class/modules/toast/ui/toaster.tsx









const ClassToastContainer = _ref => {
  let {
    className
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  (0,useUnmount/* default */.Z)(() => {
    hideAllClassNotifications();
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
    limit: 3,
    position: isMobile ? "bottom-center" : "top-center",
    className: classnames_default()(toaster_module.root, className),
    draggable: false,
    autoClose: 2e3,
    closeOnClick: false,
    hideProgressBar: true,
    pauseOnHover: false,
    transition: react_toastify_esm/* Slide */.Mi,
    closeButton: false,
    toastClassName: toaster_module.toast,
    enableMultiContainer: true,
    newestOnTop: true,
    containerId: "Class",
    bodyClassName: toaster_module.toastBody
  });
};
;// CONCATENATED MODULE: ./src/components/class/modules/toast/index.ts






/***/ }),

/***/ 47178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ useClassPlatformContext),
/* harmony export */   p: () => (/* binding */ ClassPlatformContext)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5875);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50509);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74736);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38728);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64810);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43419);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32825);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94574);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16093);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36615);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77829);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33281);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60253);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24376);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49225);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79941);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57265);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25888);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15840);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32442);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37610);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(227);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(13351);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(61297);



























const ClassPlatformContext = (0,react__WEBPACK_IMPORTED_MODULE_23__.createContext)({
  state: {},
  send: {},
  wsSend: _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_24__/* .emptyFunction */ .Bi,
  sendLog: _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_24__/* .emptyFunction */ .Bi,
  content: {},
  modules: /* @__PURE__ */new Set()
});
const useClassPlatformContext = () => (0,react__WEBPACK_IMPORTED_MODULE_23__.useContext)(ClassPlatformContext);

/***/ }),

/***/ 29285:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ classErrorLogger)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66176);




function mergeAdditionalData(payload) {
  return {
    feature: "[class]",
    payload
  };
}
const classErrorLogger = {
  captureError: (error, additional) => {
    if (typeof error === "string") {
      _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd.captureError(error, mergeAdditionalData(additional));
      return;
    }
    if (error instanceof Error) {
      _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd.captureException(error, mergeAdditionalData(additional));
      return;
    }
    _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd.captureException(new Error("Unexpected error"), mergeAdditionalData({
      additional,
      error
    }));
  }
};

/***/ }),

/***/ 63960:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  P: () => (/* binding */ withClassErrorBoundary)
});

// UNUSED EXPORTS: ClassErrorBoundary

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.weak-set.add-all.js
var esnext_weak_set_add_all = __webpack_require__(18488);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.weak-set.delete-all.js
var esnext_weak_set_delete_all = __webpack_require__(7116);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/errors/models/forbidden.ts
var forbidden = __webpack_require__(83734);
// EXTERNAL MODULE: ../shared/src/errors/models/not-found-object-error.ts
var not_found_object_error = __webpack_require__(71134);
// EXTERNAL MODULE: ../ui-kit/src/errors/403/error-403.component.tsx + 2 modules
var error_403_component = __webpack_require__(62578);
// EXTERNAL MODULE: ./src/components/errors/not-found-error.tsx
var not_found_error = __webpack_require__(50327);
// EXTERNAL MODULE: ../shared/src/utils/reload-page.ts
var reload_page = __webpack_require__(86710);
// EXTERNAL MODULE: ./src/components/errors/global-error.tsx
var global_error = __webpack_require__(25210);
;// CONCATENATED MODULE: ./src/components/errors/unknown-error.tsx





const UnknownError = _ref => {
  let {
    imageUrl = "https://flowstatic.s3.yandex.net/ui-files/unknown_error.svg",
    titleKey = "unknownError.title",
    descriptionKey = "unknownError.description",
    button = {
      key: "unknownError.buttonText",
      onClick: reload_page/* reloadPage */.s
    },
    ...other
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(global_error/* GlobalError */.g, {
    imageUrl,
    titleKey,
    descriptionKey,
    button,
    ...other
  });
};
// EXTERNAL MODULE: ./src/components/class/platform/error-logger.ts
var error_logger = __webpack_require__(29285);
// EXTERNAL MODULE: ./src/components/class/platform/errors/invalid-webrtc-error.ts
var invalid_webrtc_error = __webpack_require__(27849);
// EXTERNAL MODULE: ./src/components/class/platform/errors/webrtc/applying-devices.ts
var applying_devices = __webpack_require__(50520);
// EXTERNAL MODULE: ./src/components/class/platform/errors/webrtc/request-devices.ts
var request_devices = __webpack_require__(69160);
// EXTERNAL MODULE: ./src/components/class/platform/errors/webrtc/supported.ts
var supported = __webpack_require__(9944);
// EXTERNAL MODULE: ./src/components/class/platform/errors/webrtc/webrtc-error.ts
var webrtc_error = __webpack_require__(43706);
;// CONCATENATED MODULE: ./src/components/class/platform/errors/webrtc/type.ts







function checkWebRtcErrorType(error) {
  return error instanceof webrtc_error/* WebRTCError */.K || error instanceof invalid_webrtc_error/* InvalidWebRTCError */.X || error instanceof request_devices/* WebRTCRequestDevicesError */.p || error instanceof applying_devices/* WebRTCApplyingDevicesError */.R || error instanceof supported/* WebRTCSupportedError */.g;
}
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/routes/teacher-route-paths.ts
var teacher_route_paths = __webpack_require__(64514);
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
;// CONCATENATED MODULE: ./src/components/class/platform/errors/webrtc-error.component.tsx












const WebRTCError = _ref => {
  let {
    error: errorProps
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    speakingSessionId
  } = (0,react_router/* useParams */.UO)();
  const handleClick = (0,react.useCallback)(() => {
    const role = user.data?.me.user?.role;
    const path = role === "student" ? studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(speakingSessionId) : teacher_route_paths/* teacherRoutePaths */.q.SPEAKING_CHECKUP(speakingSessionId);
    history.push(path);
  }, [history, speakingSessionId, user.data?.me.user?.role]);
  const error = (0,react.useMemo)(() => {
    if (errorProps instanceof invalid_webrtc_error/* InvalidWebRTCError */.X) {
      return new webrtc_error/* WebRTCError */.K();
    }
    return errorProps;
  }, [errorProps]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(global_error/* GlobalError */.g, {
    imageUrl: "https://flowstatic.s3.yandex.net/ui-files/09_laptop.svg",
    button: {
      key: "webRTCError.reloadPage",
      onClick: handleClick
    },
    ...error
  });
};
// EXTERNAL MODULE: ./src/components/class/platform/errors/websocket-error.ts
var websocket_error = __webpack_require__(47579);
;// CONCATENATED MODULE: ./src/components/class/platform/errors/websocket-error.component.tsx





const WebSocketError = _ref => {
  let {
    error
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(global_error/* GlobalError */.g, {
    button: {
      key: "webSocketClassError.buttonText",
      onClick: reload_page/* reloadPage */.s
    },
    ...error
  });
};
;// CONCATENATED MODULE: ./src/components/class/platform/errors/class-error-boundary.tsx





var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

var _renderError, renderError_fn;












class ClassErrorBoundary extends react.Component {
  constructor(props) {
    super(props);
    __privateAdd(this, _renderError);
    this.state = {
      error: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    if (checkWebRtcErrorType(error) && !error.writeLog) {
      return;
    }
    error_logger/* classErrorLogger */.H.captureError(error, errorInfo);
  }
  render() {
    const {
      children
    } = this.props;
    const {
      error
    } = this.state;
    if (error) {
      return __privateMethod(this, _renderError, renderError_fn).call(this, error);
    }
    return children;
  }
}
_renderError = new WeakSet();
renderError_fn = function (error) {
  if (error instanceof forbidden/* ForbiddenError */.l) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ClassForbiddenError, {});
  }
  if (error instanceof not_found_object_error/* NotFoundObjectError */.m) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(not_found_error/* NotFoundError */.d, {});
  }
  if (checkWebRtcErrorType(error)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(WebRTCError, {
      error
    });
  }
  if (error instanceof websocket_error/* WebSocketError */.U) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(WebSocketError, {
      error
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownError, {});
};
function ClassForbiddenError() {
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(error_403_component/* Error403 */.K, {
    textConstants: {
      description: intl.formatMessage({
        id: "error.403.description"
      })
    }
  });
}
function withClassErrorBoundary(WrappedComponent) {
  return function WithClassErrorBoundary(props) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ClassErrorBoundary, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(WrappedComponent, {
        ...props
      })
    });
  };
}

/***/ }),

/***/ 27849:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ InvalidWebRTCError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InvalidWebRTCError extends Error {
  constructor(webrtcSettingsDTO) {
    super("InvalidWebRTCError");
    _defineProperty(this, "webrtcSettingsDTO", void 0);
    _defineProperty(this, "writeLog", true);
    this.webrtcSettingsDTO = webrtcSettingsDTO && JSON.stringify(webrtcSettingsDTO) || `${webrtcSettingsDTO}`;
  }
}

/***/ }),

/***/ 50520:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: () => (/* binding */ WebRTCApplyingDevicesError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class WebRTCApplyingDevicesError extends Error {
  constructor(writeLog) {
    super("WebRTC applying devices error");
    _defineProperty(this, "titleKey", "webRTCError.applyingDevices.title");
    _defineProperty(this, "descriptionKey", "webRTCError.applyingDevices.description");
    _defineProperty(this, "writeLog", void 0);
    this.writeLog = writeLog || false;
  }
}

/***/ }),

/***/ 69160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ WebRTCRequestDevicesError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class WebRTCRequestDevicesError extends Error {
  constructor(writeLog) {
    super("WebRTC request devices error");
    _defineProperty(this, "titleKey", "webRTCError.requestDevices.title");
    _defineProperty(this, "descriptionKey", "webRTCError.requestDevices.description");
    _defineProperty(this, "writeLog", void 0);
    this.writeLog = writeLog || false;
  }
}

/***/ }),

/***/ 9944:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: () => (/* binding */ WebRTCSupportedError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class WebRTCSupportedError extends Error {
  constructor(writeLog) {
    super("WebRTC supported error");
    _defineProperty(this, "titleKey", "webRTCError.notSupported.title");
    _defineProperty(this, "descriptionKey", "webRTCError.notSupported.description");
    _defineProperty(this, "writeLog", void 0);
    this.writeLog = writeLog || false;
  }
}

/***/ }),

/***/ 43706:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ WebRTCError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class WebRTCError extends Error {
  constructor(params) {
    super("WebRTC");
    _defineProperty(this, "titleKey", void 0);
    _defineProperty(this, "descriptionKey", void 0);
    _defineProperty(this, "solutionKey", void 0);
    _defineProperty(this, "writeLog", void 0);
    this.writeLog = params?.writeLog || false;
    this.titleKey = params?.title || "webRTCError.defaultTitle";
    this.descriptionKey = params?.description || "webRTCError.defaultDescription";
    this.solutionKey = params?.solution || "webRTCError.defaultSolution";
  }
}

/***/ }),

/***/ 47579:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ WebSocketError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class WebSocketError extends Error {
  constructor() {
    super("Too many retries to connect to WebSocket");
    _defineProperty(this, "titleKey", "webSocketClassError.title");
    _defineProperty(this, "descriptionKey", "webSocketClassError.description");
  }
}

/***/ }),

/***/ 99956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F4: () => (/* binding */ isClassActionConnectMessage),
/* harmony export */   HX: () => (/* binding */ isFinishLessonMessage),
/* harmony export */   Kb: () => (/* binding */ isClassDisconnectMessage),
/* harmony export */   L8: () => (/* binding */ isWebrtcSettingsChangedMessage),
/* harmony export */   MO: () => (/* binding */ isChangeVideoFullScreenMessage),
/* harmony export */   MP: () => (/* binding */ isCanceledSpeakingSessionMessage),
/* harmony export */   MZ: () => (/* binding */ isDrawingMessage),
/* harmony export */   Tf: () => (/* binding */ isDrawingAccessMessage),
/* harmony export */   WH: () => (/* binding */ isWebrtcConnectedMessage),
/* harmony export */   _w: () => (/* binding */ isChangeSpeakingSessionMessage),
/* harmony export */   mL: () => (/* binding */ isStartLessonMessage),
/* harmony export */   p7: () => (/* binding */ isInitialStateMessage),
/* harmony export */   wj: () => (/* binding */ isClassConnectMessage),
/* harmony export */   yj: () => (/* binding */ isLoadNodeMessage)
/* harmony export */ });


function isInitialStateMessage(message) {
  return message.event_type === "initial_state";
}
function isClassConnectMessage(message) {
  return message.event_type === "class_connect";
}
function isClassActionConnectMessage(message) {
  return message.event_type === "class_action" && message.data.type === "class_connect";
}
function isClassDisconnectMessage(message) {
  return message.event_type === "class_disconnect";
}
function isStartLessonMessage(message) {
  return message.event_type === "class_action" && message.data.type === "start_lesson";
}
function isFinishLessonMessage(message) {
  return message.event_type === "class_action" && message.data.type === "finish_lesson";
}
function isChangeVideoFullScreenMessage(message) {
  return message.event_type === "class_action" && message.data.type === "change_video_fullscreen";
}
function isWebrtcSettingsChangedMessage(message) {
  return message.event_type === "webrtc_settings_changed";
}
function isWebrtcConnectedMessage(message) {
  return message.event_type === "webrtc_client_connected";
}
function isLoadNodeMessage(message) {
  return message.event_type === "class_action" && message.data.type === "load_node";
}
function isChangeSpeakingSessionMessage(message) {
  return message.event_type === "class_action" && message.data.type === "change_speaking_session";
}
function isDrawingMessage(message) {
  return message.event_type === "class_action" && message.data.type === "drawing";
}
function isDrawingAccessMessage(message) {
  return message.event_type === "class_action" && message.data.type === "drawing_access";
}
function isCanceledSpeakingSessionMessage(message) {
  return message.event_type === "class_action" && message.data.type === "cancel_speaking_session";
}

/***/ }),

/***/ 92662:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  r: () => (/* binding */ StudentTestResult)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../shared/src/components/text-with-links/text-with-links.tsx + 1 modules
var text_with_links = __webpack_require__(29893);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ./src/store/student-test/student-test-store.ts
var student_test_store = __webpack_require__(33870);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(42180);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/api/tutor/test-restult/test-result.api.ts + 1 modules
var test_result_api = __webpack_require__(50847);
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-student-oral-test-result-query.ts





const useStudentOralTestResultQuery = testResultId => {
  const queryKey = (0,react.useMemo)(() => ["studentOralTestResult", testResultId], [testResultId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(testResultId),
    queryKey,
    queryFn: () => (0,test_result_api/* getOralTestResult */.lS)(testResultId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
;// CONCATENATED MODULE: ./src/components/class/task-guide/student-test-result/student-test-result.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const student_test_result_module = ({"root":"student-test-result-module__root--A5YqD","close-button-block":"student-test-result-module__close-button-block--dtpFB","closeButtonBlock":"student-test-result-module__close-button-block--dtpFB","title":"student-test-result-module__title--WjECf","block":"student-test-result-module__block--M2TUt","block-title":"student-test-result-module__block-title--k3JmR","blockTitle":"student-test-result-module__block-title--k3JmR","block-score":"student-test-result-module__block-score--Uddce","blockScore":"student-test-result-module__block-score--Uddce","block-recommendation-title":"student-test-result-module__block-recommendation-title--kUu0j","blockRecommendationTitle":"student-test-result-module__block-recommendation-title--kUu0j"});
;// CONCATENATED MODULE: ./src/components/class/task-guide/student-test-result/student-oral-test-result.tsx















const StudentOralTestResult = _ref => {
  let {
    id,
    name
  } = _ref;
  const {
    data,
    error,
    isLoading
  } = useStudentOralTestResultQuery(id);
  const onClose = (0,student_test_store/* useStudentTestStore */.C)(state => state.resetTestResult);
  if (isLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {});
  }
  if (error) {
    logger/* Logger */.Yd.captureError("Error oral test result", {
      error,
      id
    }, {
      block: "StudentTestResult",
      method: "StudentOralTestResult"
    });
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
    className: student_test_result_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: student_test_result_module.closeButtonBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        iconName: "cross-bold",
        size: "small",
        appearance: "floating",
        onClick: onClose
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.captionAccent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.testResult.close"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()(typography_module/* default */.Z.headline3, student_test_result_module.title),
        children: name
      }), data && data.blocks.map(block => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: student_test_result_module.block,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, student_test_result_module.blockTitle),
          children: block.title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.body1, student_test_result_module.blockScore),
          children: block.score
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("h3", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, student_test_result_module.blockRecommendationTitle),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "taskGuide.testResult.recommendations"
          }), ":"]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: typography_module/* default */.Z.body2,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_with_links/* TextWithLinks */.X, {
            text: block.recommendation
          })
        })]
      }, block.title))]
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-student-placement-test-result-query.ts





const useStudentPlacementTestResultQuery = testResultId => {
  const queryKey = (0,react.useMemo)(() => ["studentPlacementTestResult", testResultId], [testResultId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(testResultId),
    queryKey,
    queryFn: () => (0,test_result_api/* getPlacementTestResult */.I0)(testResultId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
;// CONCATENATED MODULE: ./src/components/class/task-guide/student-test-result/student-placement-test-result.tsx














const StudentPlacementTestResult = _ref => {
  let {
    id,
    scoreResult,
    maxResult
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    data,
    error,
    isLoading
  } = useStudentPlacementTestResultQuery(id);
  const onClose = (0,student_test_store/* useStudentTestStore */.C)(state => state.resetTestResult);
  if (isLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {});
  }
  if (error) {
    logger/* Logger */.Yd.captureError("Error placement test result", {
      error,
      id
    }, {
      block: "StudentTestResult",
      method: "StudentPlacementTestResult"
    });
    return null;
  }
  const blockTypeToText = {
    lexis: intl.formatMessage({
      id: "taskGuide.testResult.lexis"
    }),
    grammar: intl.formatMessage({
      id: "taskGuide.testResult.grammar"
    }),
    phrases: intl.formatMessage({
      id: "taskGuide.testResult.phrases"
    }),
    reading: intl.formatMessage({
      id: "taskGuide.testResult.reading"
    }),
    speaking: intl.formatMessage({
      id: "taskGuide.testResult.speaking"
    }),
    listening: intl.formatMessage({
      id: "taskGuide.testResult.listening"
    })
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
    className: student_test_result_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: student_test_result_module.closeButtonBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        iconName: "cross-bold",
        size: "small",
        appearance: "floating",
        onClick: onClose
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.captionAccent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.testResult.close"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("main", {
      children: data && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
          className: classnames_default()(typography_module/* default */.Z.headline3, student_test_result_module.title),
          children: data.courseLevel
        }), data.blocks.map(block => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: student_test_result_module.block,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
            className: classnames_default()(typography_module/* default */.Z.headline4Accent, student_test_result_module.blockTitle),
            children: blockTypeToText[block.type]
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
            className: classnames_default()(typography_module/* default */.Z.body1, student_test_result_module.blockScore),
            children: intl.formatMessage({
              id: "taskGuide.testResult.score"
            }, {
              score: scoreResult?.[block.type] ?? 0,
              max: maxResult[block.type]
            })
          }), block.revisionThemes && block.revisionThemes.length && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
              className: typography_module/* default */.Z.body2,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "taskGuide.testResult.revisionThemes"
              })
            }), block.revisionThemes.map((theme, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
              children: theme
            }, index))]
          }), block.skippedThemes && block.skippedThemes.length && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [block.revisionThemes && block.revisionThemes.length && /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
              className: typography_module/* default */.Z.body2,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "taskGuide.testResult.skippedThemes"
              })
            }), block.skippedThemes.map((theme, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
              children: theme
            }, index))]
          })]
        }, block.type))]
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.at.js
var es_array_at = __webpack_require__(5600);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.string.at-alternative.js
var es_string_at_alternative = __webpack_require__(65150);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.string.at.js
var esnext_string_at = __webpack_require__(40903);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/get-url-search-params.ts + 1 modules
var get_url_search_params = __webpack_require__(4761);
// EXTERNAL MODULE: ./src/state-machine/mechanic/trainer/create-trainer-mechanic-machine.ts + 1 modules
var create_trainer_mechanic_machine = __webpack_require__(18570);
// EXTERNAL MODULE: ./src/state-machine/trainer/create-trainer-machine.ts + 4 modules
var create_trainer_machine = __webpack_require__(53828);
// EXTERNAL MODULE: ./src/utils/trainer/trainer-event-types.ts
var trainer_event_types = __webpack_require__(99543);
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-student-written-test-result-query.ts





const useStudentWrittenTestResultQuery = (studentId, chapterId) => {
  const queryKey = (0,react.useMemo)(() => ["studentWrittenTestResult", studentId, chapterId], [studentId, chapterId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(studentId && chapterId),
    queryKey,
    queryFn: () => (0,test_result_api/* getWrittenTestResult */.jv)(studentId, chapterId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
// EXTERNAL MODULE: ./src/components/trainer/renderers/block-renderer/block-renderer.tsx + 251 modules
var block_renderer = __webpack_require__(74600);
// EXTERNAL MODULE: ./src/components/trainer/renderers/one-block-renderer/types.ts
var types = __webpack_require__(56533);
// EXTERNAL MODULE: ./src/components/class/modules/drawing/drawing-sync-context.tsx + 6 modules
var drawing_sync_context = __webpack_require__(39909);
// EXTERNAL MODULE: ./src/components/class/platform/class-platform-context.tsx
var class_platform_context = __webpack_require__(47178);
;// CONCATENATED MODULE: ./src/components/class/task-guide/student-test-result/student-written-test-result.tsx



























const StudentWrittenTestResult = _ref => {
  let {
    id,
    chapterId
  } = _ref;
  const {
    content
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const history = (0,react_router/* useHistory */.k6)();
  const studentId = content.speakingSession?.student?.id ?? get_url_search_params/* getUrlSearchParams */.r.taskGuide.getStudentId(history) ?? null;
  const onClose = (0,student_test_store/* useStudentTestStore */.C)(state => state.resetTestResult);
  if (!studentId) {
    logger/* Logger */.Yd.captureError("Student id not defined", null, {
      block: "StudentTestResult",
      method: "StudentWrittenTestResult"
    });
    throw new Error("Student id not defined");
  }
  const {
    data,
    error,
    isLoading
  } = useStudentWrittenTestResultQuery(studentId, chapterId);
  const containerRef = (0,react.useRef)(null);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    if (!data) {
      return {
        correct: false,
        answer: {}
      };
    }
    const blockEvents = data.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === trainer_event_types/* trainerEventType */.z.result) ?? [];
    const answerJSONString = answerEvent.at(-1)?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [data]);
  const activityKey = (0,react.useMemo)(() => ({
    activityId: "",
    chapterId
  }), [chapterId]);
  const currentBlocks = (0,react.useMemo)(() => data ? (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)(trainer_event_types/* trainerEventType */.z.result)({
    ...data,
    activityIndex: 0
  }) : [], [data]);
  const {
    eventEmitter,
    getInitialDrawingState,
    useToolboxCustomButtons
  } = (0,drawing_sync_context/* useDrawingSyncContext */.Mi)();
  const useDrawingAccessState = _ => false;
  if (isLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {});
  }
  if (error) {
    logger/* Logger */.Yd.captureError("Error written test result", {
      error,
      id
    }, {
      block: "StudentTestResult",
      method: "StudentWrittenTestResult"
    });
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
    className: student_test_result_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: student_test_result_module.closeButtonBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        iconName: "cross-bold",
        size: "small",
        appearance: "floating",
        onClick: onClose
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.captionAccent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.testResult.close"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: containerRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
        renderType: types/* RenderType */.y.VISIBLE_ALL,
        activityKey,
        activityType: "test",
        blockIndex: 0,
        blocks: currentBlocks,
        containerRef,
        currentActivityIndex: 0,
        getBlockAnswerInfo,
        isLastActivity: true,
        isSpeaking: false,
        mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
        onChangeAnswer: function_utils/* emptyFunction */.Bi,
        onNextActivityClick: function_utils/* emptyFunction */.Bi,
        onNextBlockClick: function_utils/* emptyFunction */.Bi,
        onOutroActionTrigger: function_utils/* emptyFunction */.Bi,
        onPrevActivityClick: function_utils/* emptyFunction */.Bi,
        onPrevBlockClick: function_utils/* emptyFunction */.Bi,
        onResetAnswer: function_utils/* emptyFunction */.Bi,
        onSubmitAnswer: function_utils/* emptyFunction */.Bi,
        scrollToBlockIndex: 0,
        showAudioFooter: true,
        showHelpButton: false,
        showNextButton: false,
        showPrevActivityButton: false,
        showPrevButton: false,
        showResetButton: false,
        showSkipButton: false,
        showSubmitButton: false,
        showTutorInstructions: true,
        userEnvironment: types/* UserEnvironment */.P.Tutor,
        getInitialDrawingState,
        useToolboxCustomButtons,
        useDrawingAccessState,
        eventEmitter
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/class/task-guide/student-test-result/student-test-result.tsx






const StudentTestResult = testResult => {
  if (testResult.type === "placement") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentPlacementTestResult, {
      id: testResult.id,
      scoreResult: testResult.scoreResult,
      maxResult: testResult.maxResult
    });
  }
  if (testResult.type === "oral") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentOralTestResult, {
      id: testResult.id,
      name: testResult.name
    });
  }
  if (testResult.type === "written") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentWrittenTestResult, {
      id: testResult.id,
      chapterId: testResult.chapterId
    });
  }
  return null;
};

/***/ }),

/***/ 68570:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  i: () => (/* binding */ CloseTrainerButton)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ./src/app/routes/baseRoutePaths.ts
var baseRoutePaths = __webpack_require__(94506);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
;// CONCATENATED MODULE: ./src/components/close-trainer-button/close-trainer-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const close_trainer_button_module = ({"close-trainer-button":"close-trainer-button-module__close-trainer-button--JEkD9","closeTrainerButton":"close-trainer-button-module__close-trainer-button--JEkD9"});
;// CONCATENATED MODULE: ./src/components/close-trainer-button/close-trainer-button.component.tsx












const CloseTrainerButton = _ref => {
  let {
    className = "",
    onClick
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const intl = (0,useIntl/* default */.Z)();
  const defaultOnClick = () => {
    get_url_search_params.getUrlSearchParams.retPath.haveRetPath(history) ? get_url_search_params.getUrlSearchParams.retPath.goToRetPath(history) : history.push(baseRoutePaths/* baseRoutePaths */.lQ.INDEX);
  };
  return (0,react_dom.createPortal)( /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
    "aria-label": intl.formatMessage({
      id: "CloseTrainerButton.ariaLabel"
    }),
    appearance: "floating",
    size: "medium",
    iconName: "cross",
    className: classnames_default()(close_trainer_button_module.closeTrainerButton, className),
    onClick: onClick ?? defaultOnClick
  }), document.body);
};

/***/ }),

/***/ 34228:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  YO: () => (/* binding */ ControlsPanel),
  zr: () => (/* binding */ ControlsPanelButtons),
  ld: () => (/* binding */ ControlsPanelHelpButton)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ./src/hooks/use-grammar-guide.ts
var use_grammar_guide = __webpack_require__(9784);
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide-provider.tsx
var task_guide_provider = __webpack_require__(59206);
// EXTERNAL MODULE: ./src/components/app-help/app-help.tsx + 7 modules
var app_help = __webpack_require__(56215);
// EXTERNAL MODULE: ./src/components/audio-footer/model.ts
var model = __webpack_require__(42037);
// EXTERNAL MODULE: ./src/components/class/platform/class-platform-context.tsx
var class_platform_context = __webpack_require__(47178);
// EXTERNAL MODULE: ./src/components/grammar-guide/__button/grammar-guide-button.component.tsx + 5 modules
var grammar_guide_button_component = __webpack_require__(76087);
// EXTERNAL MODULE: ./src/components/grammar-guide/__sheet/grammar-guide-sheet.component.tsx + 3 modules
var grammar_guide_sheet_component = __webpack_require__(80880);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/entities/features.ts
var features = __webpack_require__(45404);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/components/next-block-button/constants.ts


const LOCAL_STORAGE_NEXT_BLOCK_BUTTON_TOOLTIP = "flow:nextBlockButtonTooltip";
;// CONCATENATED MODULE: ./src/components/next-block-button/next-block-button.component.tsx












const NextBlockButton = _ref => {
  let {
    onClick = function_utils/* emptyFunction */.Bi,
    enableKeyHandler
  } = _ref;
  const [isVisibleTooltip, setIsVisibleTooltip] = (0,react.useState)(false);
  const tooltipRef = (0,react.useRef)(null);
  const trainerNextButtonHideTimeoutFeature = (0,features/* useFeatureFlag */.ye)("trainerNextButtonHideTimeout");
  const tooltipVisibilityTimeout = (0,react.useMemo)(() => trainerNextButtonHideTimeoutFeature ?? 5e3, [trainerNextButtonHideTimeoutFeature]);
  const intl = (0,useIntl/* default */.Z)();
  (0,react.useEffect)(() => {
    const timeoutId = setTimeout(() => {
      if (localStorage.getItem(LOCAL_STORAGE_NEXT_BLOCK_BUTTON_TOOLTIP) !== "shown") {
        setIsVisibleTooltip(true);
      }
    }, tooltipVisibilityTimeout);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [tooltipVisibilityTimeout]);
  const hideTooltip = (0,react.useCallback)(() => {
    setIsVisibleTooltip(false);
    localStorage.setItem(LOCAL_STORAGE_NEXT_BLOCK_BUTTON_TOOLTIP, "shown");
  }, []);
  const handleClick = (0,react.useCallback)(() => {
    if (enableKeyHandler) {
      hideTooltip();
      onClick();
    }
  }, [hideTooltip, onClick, enableKeyHandler]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(tooltipRef, () => {
    setIsVisibleTooltip(false);
  });
  (0,useKeyPress/* useKeyPress */.K)(["Enter", "Space"], handleClick);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    ref: tooltipRef,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
      overlay: intl.formatMessage({
        id: "nextBlockButton.tooltipOverlay"
      }),
      visible: isVisibleTooltip,
      fixed: true,
      placement: "top",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          "aria-label": intl.formatMessage({
            id: "nextBlockButton.ariaLabel"
          }),
          appearance: "primaryFloating",
          size: "large",
          iconName: "arrow-down",
          onClick: handleClick
        })
      })
    })
  });
};
// EXTERNAL MODULE: ./src/components/skip-mechanic-button/skip-mechanic-button.component.tsx + 1 modules
var skip_mechanic_button_component = __webpack_require__(63469);
// EXTERNAL MODULE: ./src/components/submit-mechanic-button/submit-mechanic-button.component.tsx + 1 modules
var submit_mechanic_button_component = __webpack_require__(2280);
// EXTERNAL MODULE: ./src/components/controls-panel/types.ts
var types = __webpack_require__(36407);
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide.module.css
var task_guide_module = __webpack_require__(70057);
;// CONCATENATED MODULE: ./src/components/controls-panel/controls-panel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const controls_panel_module = ({"control-buttons":"controls-panel-module__control-buttons--t3HlN","controlButtons":"controls-panel-module__control-buttons--t3HlN","control-buttons-fixed":"controls-panel-module__control-buttons-fixed--wi_x5","controlButtonsFixed":"controls-panel-module__control-buttons-fixed--wi_x5","control-buttons-not-fixed":"controls-panel-module__control-buttons-not-fixed--JbRlf","controlButtonsNotFixed":"controls-panel-module__control-buttons-not-fixed--JbRlf","wrapper":"controls-panel-module__wrapper--jshRO","wrapper-without-background":"controls-panel-module__wrapper-without-background--KSMWs","wrapperWithoutBackground":"controls-panel-module__wrapper-without-background--KSMWs","wrapper-without-autoscroll":"controls-panel-module__wrapper-without-autoscroll--ak7j4","wrapperWithoutAutoscroll":"controls-panel-module__wrapper-without-autoscroll--ak7j4","content":"controls-panel-module__content--LcA4T","mobile":"controls-panel-module__mobile--SI4rR","items":"controls-panel-module__items--uzQKU","with-audio-footer":"controls-panel-module__with-audio-footer--RRnyP","withAudioFooter":"controls-panel-module__with-audio-footer--RRnyP","help-button-panel":"controls-panel-module__help-button-panel--TKYg4","helpButtonPanel":"controls-panel-module__help-button-panel--TKYg4","help-button-panel-grammar-guides-button":"controls-panel-module__help-button-panel-grammar-guides-button--hheZA","helpButtonPanelGrammarGuidesButton":"controls-panel-module__help-button-panel-grammar-guides-button--hheZA","button":"controls-panel-module__button--cPjaN","interlocutor-name-wrapper":"controls-panel-module__interlocutor-name-wrapper--NmWUJ","interlocutorNameWrapper":"controls-panel-module__interlocutor-name-wrapper--NmWUJ","interlocutor-name-tooltip":"controls-panel-module__interlocutor-name-tooltip--nfIKt","interlocutorNameTooltip":"controls-panel-module__interlocutor-name-tooltip--nfIKt","interlocutor-name-tooltip-body":"controls-panel-module__interlocutor-name-tooltip-body--JkM7f","interlocutorNameTooltipBody":"controls-panel-module__interlocutor-name-tooltip-body--JkM7f","interlocutor-name-tooltip-arrow":"controls-panel-module__interlocutor-name-tooltip-arrow--E6vDW","interlocutorNameTooltipArrow":"controls-panel-module__interlocutor-name-tooltip-arrow--E6vDW","burger-button":"controls-panel-module__burger-button--b3yZ4","burgerButton":"controls-panel-module__burger-button--b3yZ4","video-settings-panel":"controls-panel-module__video-settings-panel--X4F8n","videoSettingsPanel":"controls-panel-module__video-settings-panel--X4F8n","video-settings-panel-fixed":"controls-panel-module__video-settings-panel-fixed--bmTN5","videoSettingsPanelFixed":"controls-panel-module__video-settings-panel-fixed--bmTN5","video-settings-controls":"controls-panel-module__video-settings-controls--AYvhd","videoSettingsControls":"controls-panel-module__video-settings-controls--AYvhd","video-settings-button":"controls-panel-module__video-settings-button--VrmR6","videoSettingsButton":"controls-panel-module__video-settings-button--VrmR6","video-settings-button-black":"controls-panel-module__video-settings-button-black--xheyx","videoSettingsButtonBlack":"controls-panel-module__video-settings-button-black--xheyx","video-settings-button-red":"controls-panel-module__video-settings-button-red--dR__S","videoSettingsButtonRed":"controls-panel-module__video-settings-button-red--dR__S","hidden":"controls-panel-module__hidden--wOREs"});
;// CONCATENATED MODULE: ./src/components/controls-panel/controls-panel.tsx
























const ControlsPanelButtons = _ref => {
  let {
    place,
    showNextButton = false,
    showSkipButton = false,
    showSubmitButton = false,
    showPrevButton = false,
    showResetButton = false,
    onSkipButtonClick = function_utils/* emptyFunction */.Bi,
    onPrevButtonClick = function_utils/* emptyFunction */.Bi,
    onNextButtonClick = function_utils/* emptyFunction */.Bi,
    onSubmitButtonClick = function_utils/* emptyFunction */.Bi,
    onResetButtonClick = function_utils/* emptyFunction */.Bi
  } = _ref;
  const hasAnyButton = showSubmitButton || showNextButton || showPrevButton || showResetButton || showSkipButton;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    disableAutoScroll
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const intl = (0,useIntl/* default */.Z)();
  if (place === null || !hasAnyButton) {
    return null;
  }
  if (isMobile) {
    return react_dom.createPortal( /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: controls_panel_module.wrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(controls_panel_module.content, controls_panel_module.mobile),
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: controls_panel_module.items,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(controls_panel_module.button, {
              [controls_panel_module.hidden]: !showPrevButton
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
              "aria-label": intl.formatMessage({
                id: "prevButton.ariaLabel"
              }),
              appearance: "floating",
              size: "medium",
              iconName: "arrow-up",
              onClick: onPrevButtonClick
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(controls_panel_module.button, {
              [controls_panel_module.hidden]: !showResetButton
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
              "aria-label": intl.formatMessage({
                id: "resetButton.ariaLabel"
              }),
              appearance: "floating",
              size: "medium",
              iconName: "reset",
              onClick: onResetButtonClick
            })
          }), showSkipButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: controls_panel_module.button,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(skip_mechanic_button_component/* SkipMechanicButton */.Q, {
              enableKeyHandler: showSkipButton,
              onSkip: onSkipButtonClick
            })
          }), showSubmitButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: controls_panel_module.button,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(submit_mechanic_button_component/* SubmitMechanicButton */.x, {
              enableKeyHandler: showSubmitButton,
              onSubmit: onSubmitButtonClick
            })
          }), (!showSubmitButton || showNextButton) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(controls_panel_module.button, {
              [controls_panel_module.hidden]: !showNextButton
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(NextBlockButton, {
              enableKeyHandler: showNextButton,
              onClick: onNextButtonClick
            })
          })]
        })
      })
    }), place);
  }
  return react_dom.createPortal( /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(controls_panel_module.wrapper, {
      [controls_panel_module.wrapperWithoutAutoscroll]: disableAutoScroll,
      [controls_panel_module.wrapperWithoutBackground]: false
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: controls_panel_module.content,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: controls_panel_module.items,
        children: [showSubmitButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: controls_panel_module.button,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(submit_mechanic_button_component/* SubmitMechanicButton */.x, {
            enableKeyHandler: showSubmitButton,
            onSubmit: onSubmitButtonClick
          })
        }), (!showSubmitButton || showNextButton) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(controls_panel_module.button, {
            [controls_panel_module.hidden]: !showNextButton
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(NextBlockButton, {
            enableKeyHandler: showNextButton,
            onClick: onNextButtonClick
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(controls_panel_module.button, {
            [controls_panel_module.hidden]: !showPrevButton
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            appearance: "floating",
            size: "medium",
            iconName: "arrow-up",
            onClick: onPrevButtonClick
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(controls_panel_module.button, {
            [controls_panel_module.hidden]: !showResetButton
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            appearance: "floating",
            size: "medium",
            iconName: "reset",
            onClick: onResetButtonClick
          })
        }), showSkipButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: controls_panel_module.button,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(skip_mechanic_button_component/* SkipMechanicButton */.Q, {
            enableKeyHandler: showSkipButton,
            onSkip: onSkipButtonClick
          })
        })]
      })
    })
  }), place);
};
const ControlsPanel = _ref2 => {
  let {
    position,
    onControlsPanelButtonsPlaceChanged
  } = _ref2;
  const {
    isVisible
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const audioFooterVisible = (0,effector_react/* useStore */.oR)(model/* $audioFooterVisible */.Wf);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(controls_panel_module.controlButtons, {
      [controls_panel_module.controlButtonsNotFixed]: position === types/* ControlsPanelPosition */.d.Initial,
      [controls_panel_module.controlButtonsFixed]: position === types/* ControlsPanelPosition */.d.Fixed,
      [task_guide_module/* default */.Z.withOpenTaskGuide]: isVisible,
      [controls_panel_module.withAudioFooter]: audioFooterVisible
    }),
    ref: onControlsPanelButtonsPlaceChanged
  });
};
const ControlsPanelHelpButton = _ref3 => {
  let {
    className = "",
    isSpeaking = false
  } = _ref3;
  const audioFooterVisible = (0,effector_react/* useStore */.oR)(model/* $audioFooterVisible */.Wf);
  const {
    showGrammarGuide,
    toggleGrammarGuideVisibility
  } = (0,use_grammar_guide/* useGrammarGuide */.U)();
  const {
    showGuidesButton
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const {
    state: {
      context
    }
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const isTutor = context?.userRole === "tutor";
  const isGrammarGuideVisible = !isSpeaking && showGuidesButton && !isTutor;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(controls_panel_module.helpButtonPanel, className, {
      [controls_panel_module.withAudioFooter]: audioFooterVisible
    }),
    children: [isGrammarGuideVisible && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: controls_panel_module.helpButtonPanelGrammarGuidesButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(grammar_guide_button_component/* GrammarGuideButton */.G, {
        isSeparateFromHelpButton: false
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(app_help/* AppHelp */.Y, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(grammar_guide_sheet_component/* GrammarGuideSheet */.y, {
      visible: showGrammarGuide,
      onClose: toggleGrammarGuideVisibility
    })]
  });
};

/***/ }),

/***/ 36407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ ControlsPanelPosition)
/* harmony export */ });


var ControlsPanelPosition = /* @__PURE__ */(ControlsPanelPosition2 => {
  ControlsPanelPosition2["Fixed"] = "fixed";
  ControlsPanelPosition2["Initial"] = "initial";
  return ControlsPanelPosition2;
})(ControlsPanelPosition || {});

/***/ }),

/***/ 1407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  I: () => (/* binding */ DrawingContextProvider),
  j: () => (/* binding */ useDrawingContext)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useUnmount.js
var useUnmount = __webpack_require__(27027);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var src_logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/fabric/dist/fabric.js
var fabric = __webpack_require__(21749);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ./src/components/drawing/model/constants.ts
var constants = __webpack_require__(76318);
// EXTERNAL MODULE: ./src/components/drawing/model/utils/index.ts + 5 modules
var utils = __webpack_require__(21569);
;// CONCATENATED MODULE: ./src/components/drawing/model/drawing-api.ts












function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class DrawingApi {
  constructor(id, canvas, eventEmitter) {
    _defineProperty(this, "logger", void 0);
    _defineProperty(this, "handleSync", void 0);
    this.id = id;
    this.canvas = canvas;
    this.eventEmitter = eventEmitter;
    this.handleSync = changes => this.update(changes);
    eventEmitter.on((0,utils/* getDrawingSyncKey */.bH)(id), this.handleSync);
    this.logger = src_logger/* ClientLogger */.q$.create(`DrawingApi-${id}`);
  }
  dispose() {
    this.logger.log("dispose");
    this.eventEmitter.off((0,utils/* getDrawingSyncKey */.bH)(this.id), this.handleSync);
  }
  clearAll() {
    this.logger.log("clearAll");
    this.canvas.clear();
  }
  update(changes) {
    this.logger.debug("update", {
      changes
    });
    const objects = this.canvas.getObjects();
    const activeObjects = this.canvas.getActiveObjects();
    changes.forEach(_ref => {
      let {
        value,
        id
      } = _ref;
      const object = objects.find(object2 => (0,utils/* getObjectId */.MS)(object2) === id);
      if (object) {
        const isObjectActive = activeObjects.some(object2 => (0,utils/* getObjectId */.MS)(object2) === id);
        if (isObjectActive) {
          this.canvas.discardActiveObject();
        }
        if (value) {
          object.setOptions({
            ...value
          });
          object.set("left", value.left);
          object.set("top", value.top);
          object.setCoords();
        } else {
          (0,utils/* setUpdatedFromRemote */.kM)(object);
          this.canvas.remove(object);
        }
      } else {
        if (value) {
          (0,utils/* setUpdatedFromRemote */.kM)(value);
        }
        switch (value?.type) {
          case "textbox":
            {
              const options = value;
              const textbox = new fabric.fabric.Textbox(options.text ?? "", options);
              this.canvas.add(textbox);
              break;
            }
          case "line":
            {
              const options = value;
              const {
                x1 = 0,
                y1 = 0,
                x2 = 0,
                y2 = 0
              } = options;
              const line = new fabric.fabric.Line([x1, y1, x2, y2], options);
              this.canvas.add(line);
              break;
            }
          case "path":
            {
              const options = value;
              const line = new fabric.fabric.Path(options.path, options);
              this.canvas.add(line);
              break;
            }
          case "rect":
            {
              const options = value;
              const rect = new fabric.fabric.Rect(options);
              this.canvas.add(rect);
              break;
            }
          default:
            {
              const e = Error(`Unsupported type of object: ${value?.type}`);
              console.error(e);
              break;
            }
        }
      }
    });
    this.canvas.renderAll();
  }
  onChange(changes) {
    this.logger.debug("onChange", {
      id: this.id,
      changes
    });
    const updates = changes.map(_ref2 => {
      let {
        id,
        value
      } = _ref2;
      return {
        id,
        value: value instanceof fabric.fabric.Object ? value.toObject(["id"]) : value
      };
    });
    this.eventEmitter.emit(constants/* DRAWING_CHANGE_EVENT_NAME */._, {
      id: this.id,
      changes: updates
    });
  }
}
;// CONCATENATED MODULE: ./src/components/drawing/model/activate-canvas-sync.ts









function activateCanvasSync(_ref) {
  let {
    d,
    id,
    $canvas,
    eventEmitter,
    dispose
  } = _ref;
  const $drawingApi = d.createStore(null);
  const setDrawingApi = d.createEvent();
  $drawingApi.on(setDrawingApi, (previous, value) => {
    previous?.dispose();
    return value;
  });
  $drawingApi.on(dispose, api => {
    api?.dispose();
    return null;
  });
  (0,effector/* sample */.UP)({
    source: $canvas,
    fn: canvas => canvas ? new DrawingApi(id, canvas, eventEmitter) : null,
    target: setDrawingApi
  });
  const activateCanvasSyncFx = d.createEffect(_ref2 => {
    let {
      canvas,
      api
    } = _ref2;
    if (!canvas || !api) {
      return;
    }
    const {
      handleObjectAdded,
      handleObjectModified,
      handleObjectRemoved
    } = createHandlers(api);
    canvas.on("object:added", handleObjectAdded);
    canvas.on("object:modified", handleObjectModified);
    canvas.on("object:removed", handleObjectRemoved);
  });
  (0,effector/* sample */.UP)({
    source: {
      canvas: $canvas,
      api: $drawingApi
    },
    target: activateCanvasSyncFx
  });
}
function createHandlers(api) {
  const logger = src_logger/* ClientLogger */.q$.create("Drawing-sync-link");
  const handleObjectAdded = e => {
    if (!e.target) {
      return;
    }
    const object = (0,utils/* identifyObject */.XL)(e.target);
    logger.debug("object:added", e);
    if ((0,utils/* shouldFireOnChange */.og)(object)) {
      api.onChange([{
        id: object.id,
        value: object
      }]);
    }
  };
  const handleObjectModified = e => {
    let objects = [];
    if (e.target instanceof fabric.fabric.Group) {
      e.target.clone(clone => {
        objects = clone.getObjects();
        clone.ungroupOnCanvas();
      }, ["id"]);
    } else if (e.target) {
      objects = [e.target];
    }
    const changes = objects.map(object => ({
      id: (0,utils/* getObjectId */.MS)(object) ?? "",
      value: object
    }));
    logger.debug("object:modified", {
      objects
    });
    api.onChange(changes);
  };
  const handleObjectRemoved = e => {
    if (!e.target) {
      return;
    }
    const object = (0,utils/* identifyObject */.XL)(e.target);
    if ((0,utils/* shouldFireOnChange */.og)(object)) {
      api.onChange([{
        id: object.id,
        value: null
      }]);
    }
  };
  return {
    handleObjectAdded,
    handleObjectModified,
    handleObjectRemoved
  };
}
// EXTERNAL MODULE: ./src/components/drawing/model/fake-drawing-hack.ts
var fake_drawing_hack = __webpack_require__(33701);
;// CONCATENATED MODULE: ./src/components/drawing/model/fill-color.ts








function createFillColor(_ref) {
  let {
    d,
    $canvas
  } = _ref;
  const [$fillColor, setFillColor] = (0,makeStore/* makeStore */.n)("#000000", d);
  const applyFillColorFx = d.createEffect(_ref2 => {
    let {
      canvas,
      color
    } = _ref2;
    const activeObjects = canvas.getActiveObjects();
    if (activeObjects.length === 0) {
      return;
    }
    activeObjects.forEach(object => {
      if (object instanceof fabric.fabric.Path) {
        object.set("stroke", color);
      } else if (object instanceof fabric.fabric.Line) {
        object.set("stroke", color);
      } else if (object instanceof fabric.fabric.Textbox) {
        object.set("fill", color);
      }
    });
    canvas.fire("object:modified", {
      target: canvas.getActiveObject()
    });
    canvas.renderAll();
  });
  (0,effector/* sample */.UP)({
    source: $canvas,
    clock: setFillColor,
    filter: canvas => canvas !== null,
    fn: (canvas, color) => ({
      canvas,
      color
    }),
    target: applyFillColorFx
  });
  return {
    $fillColor,
    setFillColor
  };
}
;// CONCATENATED MODULE: ./src/components/drawing/model/create-drawing-context.ts








const logger = src_logger/* ClientLogger */.q$.create("DrawingContext");
function createDrawingContext(_ref) {
  let {
    id = "default",
    eventEmitter,
    getInitialDrawingState
  } = _ref;
  logger.log("createDrawingContext");
  const d = (0,effector/* createDomain */.Fj)(`Drawing-${id}`);
  const [$canvas, setCanvas] = (0,makeStore/* makeStore */.n)(null, d);
  const $selectedTool = d.createStore(null);
  const setSelectedTool = d.createEvent();
  const {
    $fillColor,
    setFillColor
  } = createFillColor({
    d,
    $canvas
  });
  const {
    enableFakeDrawingMode,
    disableFakeDrawingMode
  } = (0,fake_drawing_hack/* fakeDrawingHack */.f)(d, $canvas);
  const changeSelectedToolFx = d.createEffect(_ref2 => {
    let {
      prevSelectedTool,
      newSelectedTool
    } = _ref2;
    if (prevSelectedTool?.useFakeDrawing) {
      disableFakeDrawingMode();
    }
    prevSelectedTool?.deactivate();
    if (newSelectedTool?.useFakeDrawing) {
      enableFakeDrawingMode();
    }
    newSelectedTool?.activate({
      $fillColor,
      resetSelectedTool: () => setSelectedTool(null)
    });
    return newSelectedTool;
  });
  (0,effector/* sample */.UP)({
    clock: setSelectedTool,
    source: $selectedTool,
    fn: (prevSelectedTool, newSelectedTool) => ({
      prevSelectedTool,
      newSelectedTool
    }),
    target: changeSelectedToolFx
  });
  (0,effector/* sample */.UP)({
    clock: changeSelectedToolFx.doneData,
    target: $selectedTool
  });
  const dispose = d.createEvent();
  if (eventEmitter) {
    activateCanvasSync({
      d,
      id,
      $canvas,
      dispose,
      eventEmitter
    });
  }
  return {
    id,
    $canvas,
    setCanvas,
    $selectedTool,
    setSelectedTool,
    $fillColor,
    setFillColor,
    getInitialDrawingState,
    eventEmitter,
    dispose
  };
}
;// CONCATENATED MODULE: ./src/components/drawing/drawing-context.tsx







const DrawingContext = (0,react.createContext)(null);
const useDrawingContext = () => {
  const context = (0,react.useContext)(DrawingContext);
  if (!context) {
    throw new Error("DrawingContext is not provided");
  }
  return context;
};
const DrawingContextProvider = _ref => {
  let {
    id,
    children,
    eventEmitter,
    getInitialDrawingState
  } = _ref;
  const context = (0,react.useMemo)(() => createDrawingContext({
    id,
    eventEmitter,
    getInitialDrawingState
  }), [id, eventEmitter, getInitialDrawingState]);
  (0,useUnmount/* default */.Z)(() => {
    context.dispose();
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(DrawingContext.Provider, {
    value: context,
    children
  });
};

/***/ }),

/***/ 4117:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Io: () => (/* reexport */ drawing_context/* DrawingContextProvider */.I),
  Pb: () => (/* reexport */ drawing_layout/* DrawingLayout */.P),
  uR: () => (/* reexport */ DrawingWhiteboard)
});

// UNUSED EXPORTS: DrawingCanvas, useDrawingContext

// EXTERNAL MODULE: ./src/components/drawing/drawing-context.tsx + 4 modules
var drawing_context = __webpack_require__(1407);
// EXTERNAL MODULE: ./src/components/drawing/ui/drawing-canvas/index.ts + 3 modules
var drawing_canvas = __webpack_require__(11038);
// EXTERNAL MODULE: ./src/components/drawing/ui/drawing-layout/drawing-layout.tsx + 23 modules
var drawing_layout = __webpack_require__(70448);
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-layout/index.ts



// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-whiteboard/drawing-whiteboard.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drawing_whiteboard_module = ({"layout-border-radius":"drawing-whiteboard-module__layout-border-radius--HtsWA","layoutBorderRadius":"drawing-whiteboard-module__layout-border-radius--HtsWA","whiteboard":"drawing-whiteboard-module__whiteboard--_gJ_k","position-wrapper":"drawing-whiteboard-module__position-wrapper--qawB3","positionWrapper":"drawing-whiteboard-module__position-wrapper--qawB3"});
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-whiteboard/drawing-whiteboard.tsx






const DrawingWhiteboard = _ref => {
  let {
    naturalWidth,
    naturalHeight,
    showToolbox = true,
    toolboxCustomButtons,
    log,
    exceptionId
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: drawing_whiteboard_module.positionWrapper,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(drawing_layout/* DrawingLayout */.P, {
      naturalWidth,
      naturalHeight,
      fitHeight: "100%",
      align: "center",
      toolboxPosition: isMobile ? "outside" : "inside",
      toolboxCustomButtons,
      showToolbox,
      className: drawing_whiteboard_module.layoutBorderRadius,
      log,
      exceptionId,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        style: {
          width: naturalWidth,
          height: naturalHeight
        },
        className: drawing_whiteboard_module.whiteboard
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-whiteboard/index.ts



;// CONCATENATED MODULE: ./src/components/drawing/index.ts







/***/ }),

/***/ 76318:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: () => (/* binding */ DRAWING_CHANGE_EVENT_NAME)
/* harmony export */ });


const DRAWING_CHANGE_EVENT_NAME = "drawing:change";

/***/ }),

/***/ 33701:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ isFakeDrawingPath),
/* harmony export */   f: () => (/* binding */ fakeDrawingHack)
/* harmony export */ });
/* harmony import */ var fabric__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21749);
/* harmony import */ var fabric__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fabric__WEBPACK_IMPORTED_MODULE_0__);



function fakeDrawingHack(domain, $canvas) {
  let previousFreeDrawingBrushColor = null;
  const $fakeDrawingEnabled = domain.createStore(false);
  const enableFakeDrawingMode = domain.createEvent();
  $fakeDrawingEnabled.on(enableFakeDrawingMode, () => true);
  $canvas.on(enableFakeDrawingMode, canvas => {
    if (canvas) {
      canvas.isDrawingMode = true;
      previousFreeDrawingBrushColor = canvas.freeDrawingBrush.color;
      canvas.freeDrawingBrush.color = "transparent";
    }
    return canvas;
  });
  const disableFakeDrawingMode = domain.createEvent();
  $fakeDrawingEnabled.on(disableFakeDrawingMode, () => false);
  $canvas.on(disableFakeDrawingMode, canvas => {
    if (canvas) {
      canvas.isDrawingMode = false;
      if (previousFreeDrawingBrushColor) {
        canvas.freeDrawingBrush.color = previousFreeDrawingBrushColor;
      }
    }
    return canvas;
  });
  $canvas.subscribe(canvas => {
    canvas?.on("path:created", e => {
      if ($fakeDrawingEnabled.getState()) {
        canvas.remove(e.path);
      }
    });
  });
  return {
    enableFakeDrawingMode,
    disableFakeDrawingMode
  };
}
function isFakeDrawingPath(object) {
  return object instanceof fabric__WEBPACK_IMPORTED_MODULE_0__.fabric.Path && object.stroke === "transparent";
}

/***/ }),

/***/ 76736:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ DrawingAccessType),
/* harmony export */   f: () => (/* binding */ DrawingToolType)
/* harmony export */ });


var DrawingToolType = /* @__PURE__ */(DrawingToolType2 => {
  DrawingToolType2["Pen"] = "pen";
  DrawingToolType2["Line"] = "line";
  DrawingToolType2["Text"] = "text";
  DrawingToolType2["Rectangle"] = "rectangle";
  DrawingToolType2["Cursor"] = "cursor";
  DrawingToolType2["Color"] = "color";
  return DrawingToolType2;
})(DrawingToolType || {});
var DrawingAccessType = /* @__PURE__ */(DrawingAccessType2 => {
  DrawingAccessType2["Full"] = "full";
  DrawingAccessType2["View"] = "view";
  return DrawingAccessType2;
})(DrawingAccessType || {});

/***/ }),

/***/ 21569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  bH: () => (/* reexport */ getDrawingSyncKey),
  MS: () => (/* reexport */ getObjectId),
  XL: () => (/* reexport */ identifyObject),
  Fm: () => (/* reexport */ mergeDrawingChanges),
  kM: () => (/* reexport */ setUpdatedFromRemote),
  og: () => (/* reexport */ shouldFireOnChange)
});

// UNUSED EXPORTS: isObjectWithId, isUpdatedFromRemote, resetUpdatedFromRemote, setObjectId

;// CONCATENATED MODULE: ./src/components/drawing/model/utils/get-drawing-sync-key.ts


const getDrawingSyncKey = id => `drawing:sync:${id}`;
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
;// CONCATENATED MODULE: ./src/components/drawing/model/utils/merge-drawing-changes.ts



















function mergeDrawingChanges(changes) {
  const dict = /* @__PURE__ */new Map();
  changes.forEach(change => {
    if (change.value) {
      dict.set(change.id, change);
    } else {
      dict.delete(change.id);
    }
  });
  return Array.from(dict.values());
}
// EXTERNAL MODULE: ../../node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(37164);
;// CONCATENATED MODULE: ./src/components/drawing/model/utils/object-id.ts



function getObjectId(object) {
  return "id" in object ? object.id : void 0;
}
function setObjectId(object, value) {
  object.id = value;
}
function isObjectWithId(object) {
  return "id" in object && typeof object.id === "string";
}
function identifyObject(object) {
  if (isObjectWithId(object)) {
    return object;
  }
  const id = (0,index_browser/* nanoid */.x0)();
  setObjectId(object, id);
  return object;
}
// EXTERNAL MODULE: ./src/components/drawing/model/fake-drawing-hack.ts
var fake_drawing_hack = __webpack_require__(33701);
;// CONCATENATED MODULE: ./src/components/drawing/model/utils/updated-from-remote.ts


function isUpdatedFromRemote(object) {
  return "isUpdatedFromRemote" in object ? Boolean(object.isUpdatedFromRemote) : false;
}
function setUpdatedFromRemote(object) {
  object.isUpdatedFromRemote = true;
}
function resetUpdatedFromRemote(object) {
  delete object.isUpdatedFromRemote;
}
;// CONCATENATED MODULE: ./src/components/drawing/model/utils/should-fire-on-change.ts




function shouldFireOnChange(object) {
  if (isUpdatedFromRemote(object)) {
    resetUpdatedFromRemote(object);
    return false;
  }
  return !(0,fake_drawing_hack/* isFakeDrawingPath */.D)(object);
}
;// CONCATENATED MODULE: ./src/components/drawing/model/utils/index.ts








/***/ }),

/***/ 11038:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  R: () => (/* reexport */ DrawingCanvas)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMount.js
var useMount = __webpack_require__(70268);
// EXTERNAL MODULE: ./src/components/drawing/drawing-context.tsx + 4 modules
var drawing_context = __webpack_require__(1407);
// EXTERNAL MODULE: ../../node_modules/fabric/dist/fabric.js
var fabric = __webpack_require__(21749);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useUnmount.js
var useUnmount = __webpack_require__(27027);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
;// CONCATENATED MODULE: ./src/components/drawing/ui/hooks/use-fabric.ts







const use_fabric_logger = logger/* ClientLogger */.q$.create("useFabric");
const useFabric = () => {
  const {
    id,
    setCanvas
  } = (0,drawing_context/* useDrawingContext */.j)();
  const canvasRef = (0,react.useRef)(null);
  const ref = (0,react.useCallback)(element => {
    if (!element || canvasRef.current?.getElement() === element) {
      return;
    }
    const size = element.parentElement?.getBoundingClientRect();
    use_fabric_logger.debug("Create fabric canvas", {
      id,
      width: size?.width,
      height: size?.height
    });
    const canvas = new fabric.fabric.Canvas(element, {
      width: size?.width,
      height: size?.height
    });
    canvasRef.current = canvas;
    setCanvas(canvas);
  }, [id, setCanvas]);
  (0,useUnmount/* default */.Z)(() => {
    try {
      use_fabric_logger.debug("Disposing canvas", {
        id
      });
      canvasRef.current?.dispose();
    } catch (e) {
      use_fabric_logger.log("Failed to dispose canvas", {
        id
      }, e);
      logger/* Logger */.Yd.captureException(e);
    }
  });
  return {
    ref
  };
};
// EXTERNAL MODULE: ./src/components/drawing/ui/hooks/use-resize-canvas.ts
var use_resize_canvas = __webpack_require__(33931);
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-canvas/drawing-canvas.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drawing_canvas_module = ({"root":"drawing-canvas-module__root--qfkra"});
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-canvas/drawing-canvas.tsx









const DrawingCanvas = (0,react.memo)(function DrawingCanvas2(_ref) {
  let {
    autoResize = true
  } = _ref;
  const {
    id,
    eventEmitter,
    getInitialDrawingState
  } = (0,drawing_context/* useDrawingContext */.j)();
  const {
    ref
  } = useFabric();
  const parentElementRef = (0,react.useRef)(null);
  (0,useMount/* default */.Z)(() => {
    const changes = getInitialDrawingState?.() ?? [];
    eventEmitter?.emit(`drawing:sync:${id}`, changes);
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: drawing_canvas_module.root,
    ref: parentElementRef,
    children: [autoResize && /* @__PURE__ */(0,jsx_runtime.jsx)(UseAutoResize, {
      parentElementRef
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("canvas", {
      ref
    })]
  });
});
const UseAutoResize = _ref2 => {
  let {
    parentElementRef
  } = _ref2;
  (0,use_resize_canvas/* useResizeCanvas */.S)(parentElementRef);
  return null;
};
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-canvas/index.ts




/***/ }),

/***/ 70448:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  P: () => (/* binding */ DrawingLayout),
  X: () => (/* binding */ OUTSIDE_TOOLBOX_HEIGHT)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/useResizeElement.ts
var useResizeElement = __webpack_require__(28952);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/constants.ts
var constants = __webpack_require__(59496);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip_tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ../ui-kit/src/control-panel/control-panel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const control_panel_module = ({"panel":"control-panel-module__panel--suC0I","panel-transparent":"control-panel-module__panel-transparent--sIbze","panelTransparent":"control-panel-module__panel-transparent--sIbze","panel-floating":"control-panel-module__panel-floating--aX70j","panelFloating":"control-panel-module__panel-floating--aX70j","panel-visible":"control-panel-module__panel-visible--xZmG2","panelVisible":"control-panel-module__panel-visible--xZmG2","panel-content":"control-panel-module__panel-content--evf6f","panelContent":"control-panel-module__panel-content--evf6f","panel-content_vertical":"control-panel-module__panel-content_vertical--KBv6S","panelContentVertical":"control-panel-module__panel-content_vertical--KBv6S","panel-content_horizontal":"control-panel-module__panel-content_horizontal--livLB","panelContentHorizontal":"control-panel-module__panel-content_horizontal--livLB","item-tooltip":"control-panel-module__item-tooltip--TD2Br","itemTooltip":"control-panel-module__item-tooltip--TD2Br","item-hotkey":"control-panel-module__item-hotkey--E8aZQ","itemHotkey":"control-panel-module__item-hotkey--E8aZQ"});
;// CONCATENATED MODULE: ../ui-kit/src/control-panel/control-panel-button.tsx








const ControlPanelButton = (0,react.forwardRef)(function ControlPanelButton2(_ref, ref) {
  let {
    iconName,
    color,
    bigIcon = false,
    isActive = false,
    disabled = false,
    onClick,
    showTooltip = true,
    tooltip,
    tooltipPlacement,
    hotkey,
    className
  } = _ref;
  const [tooltipVisible, setTooltipVisible] = (0,react.useState)(false);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_tooltip/* Tooltip */.u, {
    visible: tooltipVisible,
    overlay: /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
      className: control_panel_module.itemTooltip,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        children: tooltip
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: control_panel_module.itemHotkey,
        children: hotkey
      })]
    }),
    smallOverlay: true,
    placement: tooltipPlacement,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      ref,
      appearance: "default",
      state: isActive ? constants/* ButtonIconState */._E.Active : constants/* ButtonIconState */._E.Initial,
      size: "small",
      iconSize: bigIcon ? "medium" : "small",
      iconName,
      onClick,
      onMouseEnter: () => setTooltipVisible(Boolean(showTooltip && (tooltip || hotkey))),
      onMouseLeave: () => setTooltipVisible(false),
      "aria-label": tooltip,
      disabled,
      style: {
        color,
        borderColor: color
      },
      className
    })
  });
});
;// CONCATENATED MODULE: ../ui-kit/src/control-panel/types.ts


var ControlPanelDirection = /* @__PURE__ */(ControlPanelDirection2 => {
  ControlPanelDirection2["Right"] = "right";
  ControlPanelDirection2["Bottom"] = "bottom";
  return ControlPanelDirection2;
})(ControlPanelDirection || {});
var ControlPanelAppearance = /* @__PURE__ */(ControlPanelAppearance2 => {
  ControlPanelAppearance2["Default"] = "default";
  ControlPanelAppearance2["Floating"] = "floating";
  ControlPanelAppearance2["Transparent"] = "transparent";
  return ControlPanelAppearance2;
})(ControlPanelAppearance || {});
;// CONCATENATED MODULE: ../ui-kit/src/control-panel/control-panel.tsx










const ControlPanel = _ref => {
  let {
    collapsible = true,
    collapseAfterOuterClick = true,
    appearance = ControlPanelAppearance.Floating,
    direction = ControlPanelDirection.Right,
    children,
    className
  } = _ref;
  const [collapsed, setCollapsed] = (0,react.useState)(collapsible);
  const controlPanelRootRef = (0,react.useRef)(null);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(controlPanelRootRef, () => {
    if (collapsible && collapseAfterOuterClick) {
      setCollapsed(true);
    }
  });
  const collapseButtonRef = (0,react.useRef)(null);
  const controlPanelVisibleRef = (0,react.useRef)(null);
  const controlPanelContentRef = (0,react.useRef)(null);
  const handleAnimation = (0,react.useCallback)(() => {
    if (controlPanelContentRef.current && controlPanelVisibleRef.current) {
      const width = collapsed ? (collapseButtonRef.current?.offsetWidth || 0) + 8 * 2 : controlPanelContentRef.current.scrollWidth;
      const height = collapsed ? (collapseButtonRef.current?.offsetHeight || 0) + 8 * 2 : controlPanelContentRef.current.scrollHeight;
      controlPanelVisibleRef.current.style.width = `${width}px`;
      controlPanelVisibleRef.current.style.height = `${height}px`;
    }
  }, [collapsed]);
  (0,useResizeElement/* useResizeElement */.n)(controlPanelContentRef, handleAnimation);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    ref: controlPanelRootRef,
    className: classnames_default()(control_panel_module.panel, className, {
      [control_panel_module.panelFloating]: appearance === ControlPanelAppearance.Floating,
      [control_panel_module.panelTransparent]: appearance === ControlPanelAppearance.Transparent
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: control_panel_module.panelVisible,
      ref: controlPanelVisibleRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(control_panel_module.panelContent, {
          [control_panel_module.panelContentHorizontal]: direction === "right",
          [control_panel_module.panelContentVertical]: direction === "bottom"
        }),
        ref: controlPanelContentRef,
        children: [(collapsed || collapsible) && /* @__PURE__ */(0,jsx_runtime.jsx)(ControlPanelButton, {
          ref: collapseButtonRef,
          iconName: collapsed ? "draw" : "cross",
          onClick: () => {
            setCollapsed(!collapsed);
          },
          isActive: !collapsed
        }), (direction === "right" || direction === "bottom") && children]
      })
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/control-panel/index.ts





// EXTERNAL MODULE: ../ui-kit/src/error-boundary/error-boundary.tsx
var error_boundary = __webpack_require__(514);
// EXTERNAL MODULE: ./src/components/drawing/ui/drawing-canvas/index.ts + 3 modules
var drawing_canvas = __webpack_require__(11038);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../../node_modules/fabric/dist/fabric.js
var dist_fabric = __webpack_require__(21749);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
// EXTERNAL MODULE: ../shared/src/entities/features.ts
var features = __webpack_require__(45404);
// EXTERNAL MODULE: ./src/components/drawing/drawing-context.tsx + 4 modules
var drawing_context = __webpack_require__(1407);
// EXTERNAL MODULE: ./src/components/drawing/model/interfaces.ts
var interfaces = __webpack_require__(76736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
;// CONCATENATED MODULE: ./src/components/drawing/tools/cursor-tool.ts



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class CursorTool {
  constructor() {
    _defineProperty(this, "type", interfaces/* DrawingToolType */.f.Cursor);
    _defineProperty(this, "iconName", "cursor");
    _defineProperty(this, "titleKey", "Drawing.Tools.Select");
    _defineProperty(this, "hotkeyCode", "KeyV");
    _defineProperty(this, "hotkey", "V");
    _defineProperty(this, "canvas", null);
    _defineProperty(this, "logger", logger/* ClientLogger */.q$.create("Drawing.CursorTool"));
  }
  register(canvas) {
    this.canvas = canvas;
  }
  activate() {
    if (!this.canvas) {
      return;
    }
    this.logger.log("activate");
  }
  deactivate() {
    if (!this.canvas) {
      return;
    }
    this.logger.log("deactivate");
  }
  unregister() {
    this.canvas = null;
  }
}
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
;// CONCATENATED MODULE: ./src/components/drawing/model/objects/line.ts



function line_defineProperty(obj, key, value) { key = line_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function line_toPropertyKey(t) { var i = line_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function line_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class line_LinePoint extends dist_fabric.fabric.Rect {
  constructor(line) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    super(...args);
    line_defineProperty(this, "line", void 0);
    line_defineProperty(this, "hoverColor", "black");
    this.line = line;
  }
}
class line_Line extends dist_fabric.fabric.Line {
  constructor(pointers, options) {
    super(pointers, options);
    line_defineProperty(this, "p1", void 0);
    line_defineProperty(this, "p2", void 0);
    this.p1 = createLinePoint({
      line: this,
      position: {
        x: pointers?.[0] ?? 0,
        y: pointers?.[1] ?? 0
      }
    });
    this.p2 = createLinePoint({
      line: this,
      position: {
        x: pointers?.[2] ?? 0,
        y: pointers?.[3] ?? 0
      }
    });
  }
  addTo(canvas) {
    canvas.add(this);
    canvas.add(this.p1);
    canvas.add(this.p2);
  }
  hoverPoints() {
    this.p1.set("fill", this.p1.hoverColor);
    this.p2.set("fill", this.p1.hoverColor);
    this.canvas?.renderAll();
  }
  resetHoverPoints() {
    this.p1.set("fill", "transparent");
    this.p2.set("fill", "transparent");
    this.canvas?.renderAll();
  }
  /**
   * Вычисление координат конечных точек линии
   * https://stackoverflow.com/a/64696624
   *
   * Работает с перемещением, масштабирование и отражением
   * TODO: не работает с вращением линии
   *
   * @returns координаты конечных точек
   */
  calcPointsCoords() {
    const linePoints = this.calcLinePoints();
    const scaleX = this.scaleX ?? 1;
    const scaleY = this.scaleY ?? 1;
    const flipX = this.flipX;
    const flipY = this.flipY;
    const left = this.left ?? 0;
    const top = this.top ?? 0;
    const x1 = left + linePoints.x1 * scaleX;
    const x2 = left + linePoints.x2 * scaleX;
    const y1 = top + linePoints.y1 * scaleY;
    const y2 = top + linePoints.y2 * scaleY;
    if (flipX && flipY || !flipX && !flipY) {
      return {
        p1: {
          x: x1,
          y: y1
        },
        p2: {
          x: x2,
          y: y2
        }
      };
    }
    return {
      p1: {
        x: x1,
        y: y2
      },
      p2: {
        x: x2,
        y: y1
      }
    };
  }
  /** Обновление координат конечных точек линии */
  updatePointsCoordinates() {
    const coords = this.calcPointsCoords();
    this.p1.set("scaleX", 1);
    this.p1.set("scaleY", 1);
    this.p1.set("left", coords.p1.x);
    this.p1.set("top", coords.p1.y);
    this.p1.setCoords();
    this.p2.set("scaleX", 1);
    this.p2.set("scaleY", 1);
    this.p2.set("left", coords.p2.x);
    this.p2.set("top", coords.p2.y);
    this.p2.setCoords();
  }
  /**Обновление координат линии */
  updateLineCoordinates() {
    this.set("scaleX", 1);
    this.set("scaleY", 1);
    this.set("x1", this.flipX ? this.p2.left : this.p1.left);
    this.set("y1", this.flipY ? this.p2.top : this.p1.top);
    this.set("x2", this.flipX ? this.p1.left : this.p2.left);
    this.set("y2", this.flipY ? this.p1.top : this.p2.top);
    this.setCoords();
  }
  // TODO: удалить
  debugCoords() {
    return {
      top: this.top,
      left: this.left,
      x1: this.x1,
      y1: this.y1,
      x2: this.x2,
      y2: this.y2,
      "p1.left": this.p1.left,
      "p1.top": this.p1.top,
      "p2.left": this.p2.left,
      "p2.top": this.p2.top
    };
  }
}
function createLinePoint(_ref) {
  let {
    line,
    position
  } = _ref;
  return new line_LinePoint(line, {
    top: position?.y,
    left: position?.x,
    width: 10,
    height: 10,
    padding: 5,
    fill: "transparent",
    hasControls: false,
    hasBorders: false,
    originX: "center",
    originY: "center"
  });
}
function line_createLine(_ref2) {
  let {
    p1,
    p2
  } = _ref2;
  return new line_Line([p1.x, p1.y, p2.x, p2.y], {
    stroke: "black",
    strokeWidth: 3,
    hasControls: false,
    hasBorders: false,
    originX: "center",
    originY: "center"
  });
}
;// CONCATENATED MODULE: ./src/components/drawing/tools/line-tool.ts































function line_tool_defineProperty(obj, key, value) { key = line_tool_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function line_tool_toPropertyKey(t) { var i = line_tool_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function line_tool_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




class LineTool {
  constructor() {
    line_tool_defineProperty(this, "type", DrawingToolType.Line);
    line_tool_defineProperty(this, "iconName", "line");
    line_tool_defineProperty(this, "useFakeDrawing", true);
    line_tool_defineProperty(this, "titleKey", "Drawing.Tools.Line");
    line_tool_defineProperty(this, "hotkeyCode", "KeyL");
    line_tool_defineProperty(this, "hotkey", "L");
    line_tool_defineProperty(this, "canvas", null);
    line_tool_defineProperty(this, "activeLine", null);
    line_tool_defineProperty(this, "logger", ClientLogger.create("Drawing.LineTool"));
    line_tool_defineProperty(this, "handleMouseDown", void 0);
    line_tool_defineProperty(this, "handleMouseMove", void 0);
    line_tool_defineProperty(this, "handleMouseUp", void 0);
  }
  register(canvas) {
    this.canvas = canvas;
    canvas.on("mouse:over", e => {
      if (e.target instanceof LinePoint) {
        e.target.line.hoverPoints();
      } else if (e.target instanceof Line) {
        e.target.hoverPoints();
      }
    });
    canvas.on("mouse:out", e => {
      if (e.target instanceof LinePoint) {
        e.target.line.resetHoverPoints();
      } else if (e.target instanceof Line) {
        e.target.resetHoverPoints();
      }
    });
    canvas.on("selection:created", e => {
      const selectedObjects = e.selected ?? [];
      const objectsToAdd = /* @__PURE__ */new Set();
      selectedObjects.forEach(object => {
        if (object instanceof Line) {
          objectsToAdd.add(object.p1);
          objectsToAdd.add(object.p2);
        } else if (object instanceof LinePoint) {
          objectsToAdd.add(object.line);
          objectsToAdd.add(object.line.p1);
          objectsToAdd.add(object.line.p2);
        }
      });
      const activeObject = canvas.getActiveObject();
      if (activeObject instanceof fabric.ActiveSelection) {
        [...objectsToAdd].filter(object => !selectedObjects.includes(object)).forEach(object => activeObject.addWithUpdate(object));
      }
    });
    canvas.on("object:moving", e => {
      if (e.target instanceof LinePoint) {
        e.target.line.updateLineCoordinates();
      } else if (e.target instanceof Line) {
        e.target.updatePointsCoordinates();
      }
    });
    canvas.on("selection:cleared", e => {
      e.deselected?.forEach(object => {
        if (object instanceof Line) {
          object.updatePointsCoordinates();
          object.updateLineCoordinates();
        }
      });
    });
  }
  activate(_ref) {
    let {
      resetSelectedTool
    } = _ref;
    if (!this.canvas) {
      return;
    }
    this.logger.log("activate");
    this.handleMouseDown = e => {
      if (!e.pointer) {
        return;
      }
      this.logger.log("handleMouseDown", {
        x: e.pointer.x,
        y: e.pointer.y
      });
      const line = createLine({
        p1: e.pointer,
        p2: e.pointer
      });
      this.activeLine = line;
      if (this.canvas) {
        line.addTo(this.canvas);
      }
    };
    this.canvas.on("mouse:down", this.handleMouseDown);
    this.handleMouseMove = e => {
      this.activeLine?.p2.set("left", e.pointer?.x);
      this.activeLine?.p2.set("top", e.pointer?.y);
      this.activeLine?.set("x2", e.pointer?.x);
      this.activeLine?.set("y2", e.pointer?.y);
      this.canvas?.renderAll();
    };
    this.canvas.on("mouse:move", this.handleMouseMove);
    this.handleMouseUp = e => {
      this.logger.log("handleMouseUp", {
        x: e.pointer?.x,
        y: e.pointer?.y
      });
      this.activeLine?.setCoords();
      this.activeLine?.p2.setCoords();
      this.canvas?.fire("object:modified", {
        target: this.activeLine
      });
      this.activeLine = null;
      this.canvas?.renderAll();
      resetSelectedTool();
    };
    this.canvas.on("mouse:up", this.handleMouseUp);
  }
  deactivate() {
    if (!this.canvas) {
      return;
    }
    this.logger.log("deactivate");
    this.canvas.off("mouse:down", this.handleMouseDown);
    this.canvas.off("mouse:move", this.handleMouseMove);
    this.canvas.off("mouse:up", this.handleMouseUp);
  }
  unregister() {
    this.canvas = null;
  }
}
;// CONCATENATED MODULE: ./src/components/drawing/tools/pen-tool.ts



function pen_tool_defineProperty(obj, key, value) { key = pen_tool_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function pen_tool_toPropertyKey(t) { var i = pen_tool_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function pen_tool_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class PenTool {
  constructor() {
    pen_tool_defineProperty(this, "useFakeDrawing", void 0);
    pen_tool_defineProperty(this, "type", interfaces/* DrawingToolType */.f.Pen);
    pen_tool_defineProperty(this, "iconName", "handline");
    pen_tool_defineProperty(this, "titleKey", "Drawing.Tools.Pen");
    pen_tool_defineProperty(this, "hotkeyCode", "KeyP");
    pen_tool_defineProperty(this, "hotkey", "P");
    pen_tool_defineProperty(this, "canvas", null);
    pen_tool_defineProperty(this, "brushWidth", 3);
    pen_tool_defineProperty(this, "fillColorDeactivate", void 0);
    pen_tool_defineProperty(this, "logger", logger/* ClientLogger */.q$.create("Drawing.PenTool"));
  }
  register(canvas) {
    this.canvas = canvas;
  }
  activate(_ref) {
    let {
      $fillColor
    } = _ref;
    if (!this.canvas) {
      return;
    }
    this.logger.log("activate");
    this.canvas.isDrawingMode = true;
    this.canvas.freeDrawingBrush.width = this.brushWidth;
    this.canvas.freeDrawingBrush.color = $fillColor.getState();
    this.fillColorDeactivate = $fillColor.watch(color => {
      if (this.canvas) {
        this.canvas.freeDrawingBrush.color = color;
      }
    });
  }
  deactivate() {
    if (!this.canvas) {
      return;
    }
    this.logger.log("deactivate");
    this.canvas.isDrawingMode = false;
    this.fillColorDeactivate?.();
  }
  unregister() {
    this.canvas = null;
  }
}
;// CONCATENATED MODULE: ./src/components/drawing/tools/simple-line-tool.ts



function simple_line_tool_defineProperty(obj, key, value) { key = simple_line_tool_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function simple_line_tool_toPropertyKey(t) { var i = simple_line_tool_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function simple_line_tool_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class SimpleLineTool {
  constructor() {
    simple_line_tool_defineProperty(this, "type", interfaces/* DrawingToolType */.f.Line);
    simple_line_tool_defineProperty(this, "iconName", "line");
    simple_line_tool_defineProperty(this, "useFakeDrawing", true);
    simple_line_tool_defineProperty(this, "titleKey", "Drawing.Tools.Line");
    simple_line_tool_defineProperty(this, "hotkeyCode", "KeyL");
    simple_line_tool_defineProperty(this, "hotkey", "L");
    simple_line_tool_defineProperty(this, "canvas", null);
    simple_line_tool_defineProperty(this, "activeLine", null);
    simple_line_tool_defineProperty(this, "fillColorDeactivate", void 0);
    simple_line_tool_defineProperty(this, "logger", logger/* ClientLogger */.q$.create("Drawing.LineTool"));
    simple_line_tool_defineProperty(this, "handleMouseDown", void 0);
    simple_line_tool_defineProperty(this, "handleMouseMove", void 0);
    simple_line_tool_defineProperty(this, "handleMouseUp", void 0);
  }
  register(canvas) {
    this.canvas = canvas;
  }
  activate(_ref) {
    let {
      resetSelectedTool,
      $fillColor
    } = _ref;
    if (!this.canvas) {
      return;
    }
    this.logger.log("activate");
    this.fillColorDeactivate = $fillColor.watch(color => this.activeLine?.set("stroke", color));
    this.handleMouseDown = e => {
      if (!e.pointer) {
        return;
      }
      const {
        x,
        y
      } = e.pointer;
      this.logger.log("handleMouseDown", {
        x,
        y
      });
      const line = new dist_fabric.fabric.Line([x, y, x, y], {
        stroke: $fillColor.getState(),
        strokeWidth: 3
      });
      line?.set("x1", x);
      line?.set("y1", y);
      this.activeLine = line;
      this.canvas?.add(line);
    };
    this.canvas.on("mouse:down", this.handleMouseDown);
    this.handleMouseMove = e => {
      this.activeLine?.set("x2", e.pointer?.x);
      this.activeLine?.set("y2", e.pointer?.y);
      this.canvas?.renderAll();
    };
    this.canvas.on("mouse:move", this.handleMouseMove);
    this.handleMouseUp = e => {
      this.logger.log("handleMouseUp", {
        x: e.pointer?.x,
        y: e.pointer?.y
      });
      this.activeLine?.setCoords();
      this.canvas?.fire("object:modified", {
        target: this.activeLine
      });
      this.canvas?.renderAll();
      this.activeLine = null;
      resetSelectedTool();
    };
    this.canvas.on("mouse:up", this.handleMouseUp);
  }
  deactivate() {
    if (!this.canvas) {
      return;
    }
    this.logger.log("deactivate");
    this.canvas.off("mouse:down", this.handleMouseDown);
    this.canvas.off("mouse:move", this.handleMouseMove);
    this.canvas.off("mouse:up", this.handleMouseUp);
    this.fillColorDeactivate?.();
  }
  unregister() {
    this.canvas = null;
  }
}
;// CONCATENATED MODULE: ./src/components/drawing/tools/text-tool.ts



function text_tool_defineProperty(obj, key, value) { key = text_tool_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function text_tool_toPropertyKey(t) { var i = text_tool_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function text_tool_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



class TextTool {
  constructor() {
    text_tool_defineProperty(this, "type", interfaces/* DrawingToolType */.f.Text);
    text_tool_defineProperty(this, "iconName", "text");
    text_tool_defineProperty(this, "useFakeDrawing", true);
    text_tool_defineProperty(this, "titleKey", "Drawing.Tools.Text");
    text_tool_defineProperty(this, "hotkeyCode", "KeyT");
    text_tool_defineProperty(this, "hotkey", "T");
    text_tool_defineProperty(this, "canvas", null);
    text_tool_defineProperty(this, "fontSize", 48);
    text_tool_defineProperty(this, "logger", logger/* ClientLogger */.q$.create("Drawing.TextTool"));
    text_tool_defineProperty(this, "handleMouseDown", void 0);
  }
  register(canvas) {
    this.canvas = canvas;
    canvas.on("selection:cleared", e => {
      e.deselected?.forEach(object => {
        if (object instanceof dist_fabric.fabric.Textbox && !object.text) {
          canvas.remove(object);
        }
      });
    });
  }
  activate(_ref) {
    let {
      resetSelectedTool,
      $fillColor
    } = _ref;
    if (!this.canvas) {
      return;
    }
    this.logger.log("activate");
    const handleMouseDown = e => {
      const textBox = new dist_fabric.fabric.Textbox("", {
        left: e.pointer?.x,
        top: e.pointer?.y,
        fill: $fillColor.getState(),
        fontSize: this.fontSize,
        width: 250
      });
      this.canvas?.add(textBox);
      this.canvas?.setActiveObject(textBox);
      textBox.enterEditing();
      textBox.selectAll();
      resetSelectedTool();
    };
    this.handleMouseDown = handleMouseDown;
    this.canvas.on("mouse:down", handleMouseDown);
  }
  deactivate() {
    if (!this.canvas) {
      return;
    }
    this.logger.log("deactivate");
    this.canvas.off("mouse:down", this.handleMouseDown);
  }
  unregister() {
    this.canvas = null;
  }
}
;// CONCATENATED MODULE: ./src/components/drawing/tools/index.ts







// EXTERNAL MODULE: ../../node_modules/react-color/es/index.js + 118 modules
var es = __webpack_require__(31324);
// EXTERNAL MODULE: ../../node_modules/react-color/lib/components/common/index.js
var common = __webpack_require__(92375);
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/drawing-toolbox-color-picker.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drawing_toolbox_color_picker_module = ({"root":"drawing-toolbox-color-picker-module__root--zIQgF","saturation":"drawing-toolbox-color-picker-module__saturation--nlvPi","hue":"drawing-toolbox-color-picker-module__hue--WJ9Zh","pointer":"drawing-toolbox-color-picker-module__pointer--ZPbqk","saturation-pointer":"drawing-toolbox-color-picker-module__saturation-pointer--bSUzV","saturationPointer":"drawing-toolbox-color-picker-module__saturation-pointer--bSUzV","hue-pointer":"drawing-toolbox-color-picker-module__hue-pointer--jM7UL","huePointer":"drawing-toolbox-color-picker-module__hue-pointer--jM7UL"});
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/drawing-toolbox-color-picker.tsx







const SaturationPointer = () => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
  className: classnames_default()(drawing_toolbox_color_picker_module.pointer, drawing_toolbox_color_picker_module.saturationPointer)
});
const HuePointer = () => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
  className: classnames_default()(drawing_toolbox_color_picker_module.pointer, drawing_toolbox_color_picker_module.huePointer)
});
const CustomColorPicker = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
  className: drawing_toolbox_color_picker_module.root,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: drawing_toolbox_color_picker_module.saturation,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(common/* Saturation */.OQ, {
      ...props,
      pointer: SaturationPointer
    })
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: drawing_toolbox_color_picker_module.hue,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(common/* Hue */.PS, {
      ...props,
      pointer: HuePointer
    })
  })]
});
const DrawingToolBoxColorPicker = (0,es/* CustomPicker */.iS)(CustomColorPicker);
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/drawing-colors-panel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drawing_colors_panel_module = ({"rainbow":"drawing-colors-panel-module__rainbow--tTbHx"});
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/drawing-toolbox.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drawing_toolbox_module = ({"root":"drawing-toolbox-module__root--IW5En","side-menu":"drawing-toolbox-module__side-menu--ef1qR","sideMenu":"drawing-toolbox-module__side-menu--ef1qR","side-menu-top":"drawing-toolbox-module__side-menu-top--H1wqN","sideMenuTop":"drawing-toolbox-module__side-menu-top--H1wqN","side-menu-right":"drawing-toolbox-module__side-menu-right--9U8Pp","sideMenuRight":"drawing-toolbox-module__side-menu-right--9U8Pp"});
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/drawing-colors-panel.tsx












const DEFAULT_COLORS = [{
  color: "#242424",
  tooltip: "Drawing.Tools.Color.Black"
}, {
  color: "#FF5757",
  tooltip: "Drawing.Tools.Color.Red"
}, {
  color: "#FFCB48",
  tooltip: "Drawing.Tools.Color.Yellow"
}, {
  color: "#69B0CC",
  tooltip: "Drawing.Tools.Color.Blue"
}, {
  color: "#81B38E",
  tooltip: "Drawing.Tools.Color.Green"
}, {
  color: "#FFFFFF",
  tooltip: "Drawing.Tools.Color.White"
}];
const DrawingColorsPanel = _ref => {
  let {
    appearance,
    direction,
    visible
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    $fillColor,
    setFillColor
  } = (0,drawing_context/* useDrawingContext */.j)();
  const fillColor = (0,effector_react/* useStore */.oR)($fillColor);
  const setFillColorEvent = (0,effector_react/* useEvent */.zX)(setFillColor);
  const [paletteColor, setPaletteColor] = (0,react.useState)(fillColor);
  const [isColorPaletteOpen, setIsColorPaletteOpen] = (0,react.useState)(false);
  const [wasColorPaletteOpened, setWasColorPaletteOpened] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (!visible) {
      setIsColorPaletteOpen(false);
    }
  }, [visible]);
  if (!visible) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(drawing_toolbox_module.sideMenu, {
      [drawing_toolbox_module.sideMenuTop]: direction === "right",
      [drawing_toolbox_module.sideMenuRight]: direction === "bottom"
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(ControlPanel, {
      collapsible: false,
      appearance,
      direction,
      children: [DEFAULT_COLORS.map(_ref2 => {
        let {
          color,
          tooltip
        } = _ref2;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(ControlPanelButton, {
          iconName: "circle-filled",
          tooltip: intl.formatMessage({
            id: tooltip
          }),
          isActive: true,
          bigIcon: true,
          color,
          onClick: () => {
            setFillColorEvent(color);
            setIsColorPaletteOpen(false);
          }
        }, color);
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ControlPanelButton, {
        iconName: wasColorPaletteOpened ? "circle-filled" : "palette",
        tooltip: intl.formatMessage({
          id: "Drawing.Tools.Color.Palette"
        }),
        color: wasColorPaletteOpened ? paletteColor : void 0,
        bigIcon: wasColorPaletteOpened,
        onClick: () => {
          setIsColorPaletteOpen(prev => !prev);
          setWasColorPaletteOpened(true);
        },
        className: drawing_colors_panel_module.rainbow,
        isActive: true
      }, "current-color")]
    }), isColorPaletteOpen && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(drawing_toolbox_module.sideMenu, {
        [drawing_toolbox_module.sideMenuTop]: direction === "right",
        [drawing_toolbox_module.sideMenuRight]: direction === "bottom"
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(DrawingToolBoxColorPicker, {
        color: paletteColor,
        onChange: color => setPaletteColor(color.hex),
        onChangeComplete: color => setFillColorEvent(color.hex)
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/drawing-toolbox.tsx


























const DrawingToolBox = _ref => {
  let {
    collapsible,
    appearance,
    direction = ControlPanelDirection.Right,
    hideCursorTool,
    customButtons = array_utils/* emptyArray */.ow,
    className
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const rootRef = (0,react.useRef)(null);
  const {
    $canvas,
    $selectedTool,
    setSelectedTool,
    $fillColor
  } = (0,drawing_context/* useDrawingContext */.j)();
  const canvas = (0,effector_react/* useStore */.oR)($canvas);
  const selectedTool = (0,effector_react/* useStore */.oR)($selectedTool);
  const fillColor = (0,effector_react/* useStore */.oR)($fillColor);
  const [isColorsPanelOpen, setIsColorsPanelOpen] = (0,react.useState)(false);
  const disabledDrawingTools = (0,features/* useFeatureFlag */.ye)("disabledDrawingTools");
  const DRAWING_TOOLS = (0,react.useMemo)(() => [new CursorTool(), new PenTool(), new SimpleLineTool(), new TextTool()].filter(tool => (!hideCursorTool || tool.type !== interfaces/* DrawingToolType */.f.Cursor) && !disabledDrawingTools.includes(tool.type)), [disabledDrawingTools, hideCursorTool]);
  const buttons = (0,react.useMemo)(() =>
  // кнопки инструментов рисования
  DRAWING_TOOLS.map(tool => ({
    key: tool.type,
    iconName: tool.iconName,
    isActive: selectedTool?.type === tool.type || selectedTool === null && tool.type === interfaces/* DrawingToolType */.f.Cursor,
    onClick: () => setSelectedTool(selectedTool?.type === tool.type ? null : tool),
    tooltip: intl.formatMessage({
      id: tool.titleKey
    }),
    tooltipPlacement: direction === ControlPanelDirection.Bottom ? "right" : "top",
    hotkey: tool.hotkey
  })).concat({
    key: "color",
    iconName: "circle-filled",
    color: fillColor,
    isActive: isColorsPanelOpen,
    tooltip: intl.formatMessage({
      id: "Drawing.Tools.Color"
    }),
    onClick: () => setIsColorsPanelOpen(prev => !prev)
  }).concat(customButtons.map(props => ({
    ...props,
    showTooltip: Boolean(props.tooltip),
    tooltipPlacement: direction === ControlPanelDirection.Bottom ? "right" : "top"
  }))), [DRAWING_TOOLS, customButtons, direction, fillColor, intl, isColorsPanelOpen, selectedTool, setSelectedTool]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(rootRef, () => setIsColorsPanelOpen(false));
  (0,react.useEffect)(() => {
    if (!canvas) {
      return;
    }
    DRAWING_TOOLS.forEach(tool => tool.register(canvas));
    return () => {
      DRAWING_TOOLS.forEach(tool => tool.unregister());
    };
  }, [canvas, DRAWING_TOOLS]);
  (0,react.useEffect)(() => {
    const handleDeleteKey = keyCode => {
      const canvas2 = $canvas.getState();
      const activeObject = canvas2?.getActiveObject();
      if (!activeObject || !["Delete", "Backspace"].includes(keyCode)) {
        return false;
      }
      if (activeObject instanceof dist_fabric.fabric.Group) {
        activeObject.getObjects().forEach(object => canvas2?.remove(object));
        canvas2?.discardActiveObject().renderAll();
      } else {
        canvas2?.remove(activeObject);
      }
      return true;
    };
    const handleKeyDown = e => {
      const canvas2 = $canvas.getState();
      const activeObject = canvas2?.getActiveObject();
      if (activeObject instanceof dist_fabric.fabric.Textbox && activeObject.isEditing) {
        return;
      }
      const tool = DRAWING_TOOLS.find(tool2 => tool2.hotkeyCode === e.code);
      if (tool) {
        setSelectedTool(tool);
        return;
      }
      if (handleDeleteKey(e.code)) {
        return;
      }
      const button = customButtons.find(button2 => button2.hotkeyCheck?.(e));
      if (button) {
        button.onClick?.();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [$canvas, setSelectedTool, DRAWING_TOOLS, customButtons]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(drawing_toolbox_module.root, className),
    ref: rootRef,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ControlPanel, {
      collapsible,
      collapseAfterOuterClick: false,
      appearance,
      direction,
      children: buttons && buttons.map(props => /* @__PURE__ */(0,jsx_runtime.jsx)(ControlPanelButton, {
        ...props
      }, props.key))
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(DrawingColorsPanel, {
      visible: isColorsPanelOpen,
      direction,
      appearance
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-toolbox/index.ts



;// CONCATENATED MODULE: ./src/components/drawing/ui/hooks/use-rescaling.ts




function useRescaling(_ref) {
  let {
    rootRef,
    fittedRef,
    scaledRef,
    naturalWidth,
    naturalHeight,
    heightGap = 0,
    log
  } = _ref;
  const rescale = (0,react.useCallback)(() => {
    if (!rootRef.current || !scaledRef.current || !fittedRef.current) {
      return;
    }
    const {
      width: rootWidth,
      height: rootHeight
    } = rootRef.current.getBoundingClientRect();
    const scale = Math.min(rootWidth / naturalWidth, (rootHeight - heightGap) / naturalHeight);
    if (naturalHeight > 0) {
      rootRef.current.style.height = `${rootWidth / naturalWidth * naturalHeight + heightGap}px`;
    }
    if (rootWidth / (rootHeight - heightGap) > naturalWidth / naturalHeight) {
      if (naturalWidth * scale > 0) {
        fittedRef.current.style.width = `${naturalWidth * scale}px`;
      }
      if (rootHeight > heightGap) {
        fittedRef.current.style.height = `${rootHeight - heightGap}px`;
      }
    } else {
      if (rootWidth > 0) {
        fittedRef.current.style.width = `${rootWidth}px`;
      }
      if (naturalHeight * scale > 0) {
        fittedRef.current.style.height = `${naturalHeight * scale}px`;
      }
    }
    if (scale > 0 && naturalWidth > 0 && naturalHeight > 0) {
      scaledRef.current.style.transform = `scale(${scale})`;
      scaledRef.current.style.width = `${naturalWidth}px`;
      scaledRef.current.style.height = `${naturalHeight}px`;
    }
    log?.({
      rootWidth,
      rootHeightFrom: rootHeight,
      rootHeightTo: rootRef.current.style.height,
      naturalWidth,
      naturalHeight,
      heightGap
    });
  }, [fittedRef, heightGap, log, naturalHeight, naturalWidth, rootRef, scaledRef]);
  (0,useResizeElement/* useResizeElement */.n)(rootRef, () => {
    log?.({
      event: "resizeElement"
    });
    window.setTimeout(rescale);
  });
  (0,react.useEffect)(() => {
    log?.({
      event: "setNaturalRect"
    });
    rescale();
  }, [naturalHeight, naturalWidth, log, rescale]);
}
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-layout/disable-drawing-tools.ts




const DisableDrawingTools = () => {
  const {
    setSelectedTool,
    $canvas
  } = (0,drawing_context/* useDrawingContext */.j)();
  setSelectedTool(null);
  const canvas = (0,effector_react/* useStore */.oR)($canvas);
  canvas?.discardActiveObject().renderAll();
  return null;
};
// EXTERNAL MODULE: ./src/components/drawing/ui/hooks/use-resize-canvas.ts
var use_resize_canvas = __webpack_require__(33931);
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-layout/rescale-drawing-canvas.ts



const RescaleDrawingCanvas = _ref => {
  let {
    naturalWidth,
    naturalHeight
  } = _ref;
  const setCanvasDimensions = (0,use_resize_canvas/* useSetCanvasDimensions */.K)();
  setCanvasDimensions({
    width: naturalWidth,
    height: naturalHeight
  });
  return null;
};
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-layout/drawing-layout.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drawing_layout_module = ({"root":"drawing-layout-module__root--KGL8O","align-left":"drawing-layout-module__align-left--whziz","alignLeft":"drawing-layout-module__align-left--whziz","align-center":"drawing-layout-module__align-center--NSvIh","alignCenter":"drawing-layout-module__align-center--NSvIh","fitted-container":"drawing-layout-module__fitted-container--t5snb","fittedContainer":"drawing-layout-module__fitted-container--t5snb","style-container":"drawing-layout-module__style-container--pNVA_","styleContainer":"drawing-layout-module__style-container--pNVA_","scaled-container":"drawing-layout-module__scaled-container--jNqnc","scaledContainer":"drawing-layout-module__scaled-container--jNqnc","canvas-container":"drawing-layout-module__canvas-container--N8OQS","canvasContainer":"drawing-layout-module__canvas-container--N8OQS","disable-events":"drawing-layout-module__disable-events--N88_d","disableEvents":"drawing-layout-module__disable-events--N88_d","toolbox-container":"drawing-layout-module__toolbox-container--Elbgd","toolboxContainer":"drawing-layout-module__toolbox-container--Elbgd","inside":"drawing-layout-module__inside--mlXuO","outside":"drawing-layout-module__outside--dRUT_","root_width-transition":"drawing-layout-module__root_width-transition--a2Aew","rootWidthTransition":"drawing-layout-module__root_width-transition--a2Aew"});
;// CONCATENATED MODULE: ./src/components/drawing/ui/drawing-layout/drawing-layout.tsx















const OUTSIDE_TOOLBOX_HEIGHT = 8 + 48 + 8;
const DrawingLayout = _ref => {
  let {
    children,
    naturalWidth,
    naturalHeight,
    width = "100%",
    fitHeight,
    toolboxPosition = "outside",
    toolboxCustomButtons,
    align = "left",
    showCanvas = true,
    showToolbox = true,
    topChildren,
    className,
    enableWidthTransition = false,
    log,
    exceptionId
  } = _ref;
  const scaledRef = (0,react.useRef)(null);
  const fittedRef = (0,react.useRef)(null);
  const rootRef = (0,react.useRef)(null);
  useRescaling({
    rootRef,
    scaledRef,
    fittedRef,
    naturalWidth,
    naturalHeight,
    fitHeight: Boolean(fitHeight),
    heightGap: toolboxPosition === "outside" && showToolbox ? OUTSIDE_TOOLBOX_HEIGHT : 0,
    log
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
    onError: e => {
      logger/* Logger */.Yd.captureException(e, {
        feature: "drawing-layout",
        block: exceptionId
      });
    },
    onErrorContent: () => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "Drawing.exception.title"
        })
      })
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: rootRef,
      className: classnames_default()(drawing_layout_module.root, {
        [drawing_layout_module.alignLeft]: align === "left",
        [drawing_layout_module.alignCenter]: align === "center",
        [drawing_layout_module.rootWidthTransition]: enableWidthTransition
      }),
      style: {
        width,
        maxHeight: fitHeight
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        ref: fittedRef,
        className: drawing_layout_module.fittedContainer,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drawing_layout_module.styleContainer, className),
          children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            ref: scaledRef,
            className: drawing_layout_module.scaledContainer,
            children: [children, showCanvas && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()(drawing_layout_module.canvasContainer, {
                [drawing_layout_module.disableEvents]: !showToolbox
              }),
              children: [!showToolbox && /* @__PURE__ */(0,jsx_runtime.jsx)(DisableDrawingTools, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(RescaleDrawingCanvas, {
                naturalWidth,
                naturalHeight
              }), /* @__PURE__ */(0,jsx_runtime.jsx)(drawing_canvas/* DrawingCanvas */.R, {
                autoResize: false
              })]
            })]
          })
        }), showToolbox && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drawing_layout_module.toolboxContainer, {
            [drawing_layout_module.inside]: toolboxPosition === "inside",
            [drawing_layout_module.outside]: toolboxPosition === "outside"
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(DrawingToolBox, {
            collapsible: false,
            direction: toolboxPosition === "inside" ? ControlPanelDirection.Bottom : ControlPanelDirection.Right,
            hideCursorTool: toolboxPosition === "outside",
            customButtons: toolboxCustomButtons
          })
        }), topChildren]
      })
    })
  });
};

/***/ }),

/***/ 33931:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ useSetCanvasDimensions),
/* harmony export */   S: () => (/* binding */ useResizeCanvas)
/* harmony export */ });
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34994);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_hooks_useResizeElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28952);
/* harmony import */ var _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66176);
/* harmony import */ var _drawing_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1407);







const logger = _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_2__/* .ClientLogger */ .q$.create("useResizeCanvas");
function useResizeCanvas(ref) {
  const setCanvasDimensions = useSetCanvasDimensions();
  (0,_yandex_langly_shared_src_hooks_useResizeElement__WEBPACK_IMPORTED_MODULE_1__/* .useResizeElement */ .n)(ref, setCanvasDimensions);
}
function useSetCanvasDimensions() {
  const {
    $canvas
  } = (0,_drawing_context__WEBPACK_IMPORTED_MODULE_3__/* .useDrawingContext */ .j)();
  const canvas = (0,effector_react__WEBPACK_IMPORTED_MODULE_4__/* .useStore */ .oR)($canvas);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(_ref => {
    let {
      width,
      height
    } = _ref;
    try {
      const actual = {
        width: canvas?.getWidth(),
        height: canvas?.getHeight()
      };
      if (actual.width !== width || actual.height !== height) {
        logger.debug("Resize canvas", {
          width,
          height
        });
        canvas?.setDimensions({
          width,
          height
        });
      }
    } catch (e) {
      logger.log("Failed to resize canvas", e);
      _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_2__/* .Logger */ .Yd.captureException(e);
    }
  }, [canvas]);
}

/***/ }),

/***/ 899:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  p: () => (/* binding */ getDropdownRule),
  e: () => (/* binding */ useDropdownRules)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/string.utils.ts
var string_utils = __webpack_require__(25680);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../ui-kit/src/hot-key/hot-key.component.tsx + 1 modules
var hot_key_component = __webpack_require__(72416);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/text-button/text-button.component.tsx + 3 modules
var text_button_component = __webpack_require__(5426);
;// CONCATENATED MODULE: ../ui-kit/src/dropdown-mechanic/dropdown-mechanic.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const dropdown_mechanic_module = ({"root":"dropdown-mechanic-module__root--xbguO","dropdown":"dropdown-mechanic-module__dropdown--oy1iP","dropdown-empty":"dropdown-mechanic-module__dropdown-empty--RP2kQ","dropdownEmpty":"dropdown-mechanic-module__dropdown-empty--RP2kQ","cross":"dropdown-mechanic-module__cross--CiH95","bottom-menu":"dropdown-mechanic-module__bottom-menu--oxrzm","bottomMenu":"dropdown-mechanic-module__bottom-menu--oxrzm","options":"dropdown-mechanic-module__options--bOFFq","options-with-margin":"dropdown-mechanic-module__options-with-margin--pzE4S","optionsWithMargin":"dropdown-mechanic-module__options-with-margin--pzE4S","option":"dropdown-mechanic-module__option--Kdars"});
;// CONCATENATED MODULE: ../ui-kit/src/dropdown-mechanic/dropdown-button/dropdown-button.component.tsx









const DropdownButton = _ref => {
  let {
    type,
    buttonLabel,
    isCorrect,
    isActive,
    onClick,
    children
  } = _ref;
  const buttonChildren = typeof children === "string" ? /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
    wrapper: markdown_component/* Wrapper */.im.fragment,
    children
  }) : children;
  switch (type) {
    case "default":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
        shadow: true,
        color: text_button_component/* Color */.I.Transparent,
        transparentText: !children,
        hotKeyText: buttonLabel,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Default,
        hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
        onClick,
        children: buttonChildren
      });
    case "active":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
        shadow: true,
        color: text_button_component/* Color */.I.Transparent,
        transparentText: true,
        onClick,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "cross-bold",
          size: "small",
          className: dropdown_mechanic_module.cross
        })
      });
    case "selected":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
        color: text_button_component/* Color */.I.lightestBlack,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Selected,
        hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
        hotKeyText: buttonLabel,
        transparentText: false,
        shadow: false,
        children: buttonChildren
      });
    case "submitted":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
        color: isCorrect ? text_button_component/* Color */.I.Green : text_button_component/* Color */.I.Red,
        hotKeyState: isCorrect ? hot_key_component/* HotKeyState */.wu.Success : hot_key_component/* HotKeyState */.wu.Error,
        hotKeyContentType: isCorrect ? hot_key_component/* HotKeyContentType */.cu.Check : hot_key_component/* HotKeyContentType */.cu.Cross,
        hotKeyText: buttonLabel,
        transparentText: false,
        shadow: false,
        children: buttonChildren
      });
    case "empty":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
        shadow: false,
        color: isActive ? text_button_component/* Color */.I.lightBlack : text_button_component/* Color */.I.hardGrey,
        transparentText: !children,
        classes: {
          button: dropdown_mechanic_module.dropdownEmpty
        },
        children: buttonChildren
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
// EXTERNAL MODULE: ../ui-kit/src/select/menu/menu.tsx + 1 modules
var menu = __webpack_require__(48036);
;// CONCATENATED MODULE: ../ui-kit/src/dropdown-mechanic/dropdown-menu/dropdown-menu.component.tsx











const DropdownMenu = _ref => {
  let {
    options,
    value,
    sentenceWithButton,
    menuRef,
    isDropdownActive,
    showLabels,
    isMenuVisible: isVisible,
    onChange,
    onClose
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  if (isMobile) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      onClose,
      isVisible,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: dropdown_mechanic_module.bottomMenu,
        children: [sentenceWithButton, /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
          className: classnames_default()(dropdown_mechanic_module.options, {
            [dropdown_mechanic_module.optionsWithMargin]: sentenceWithButton !== null
          }),
          children: options.map((option, index) => {
            const handleClick = () => {
              onChange(options[index].value);
              onClose();
            };
            return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
              className: dropdown_mechanic_module.option,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownButton, {
                type: "default",
                buttonLabel: index + 1,
                onClick: handleClick,
                children: option.title
              })
            }, option.value);
          })
        })]
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    ref: menuRef,
    className: dropdown_mechanic_module.dropdown,
    children: isDropdownActive && /* @__PURE__ */(0,jsx_runtime.jsx)(menu/* Menu */.v, {
      options,
      showLabels,
      onChange,
      value
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/dropdown-mechanic/dropdown-mechanic.component.tsx









const DropdownMechanic = _ref => {
  let {
    btnLabel,
    options,
    showLabels = true,
    correct = false,
    submitted = false,
    selected = false,
    value,
    isDropdownActive,
    onDropdownActiveChange,
    onChange,
    getSentence
  } = _ref;
  const dropdownRef = (0,react.useRef)(null);
  const menuRef = (0,react.useRef)(null);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [isVisible, setIsVisible] = (0,react.useState)(false);
  const buttonType = (0,react.useMemo)(() => {
    if (selected) {
      return "selected";
    }
    if (submitted) {
      return "submitted";
    }
    if (isDropdownActive) {
      return "active";
    }
    return "default";
  }, [isDropdownActive, selected, submitted]);
  const handleDropdownClick = (0,react.useCallback)(() => {
    if (submitted) {
      return;
    }
    setIsVisible(true);
    onDropdownActiveChange(!isDropdownActive);
  }, [isDropdownActive, onDropdownActiveChange, submitted]);
  const handleClickOutside = (0,react.useCallback)(() => {
    if (isDropdownActive && !isMobile) {
      onDropdownActiveChange(false);
    }
  }, [isDropdownActive, isMobile, onDropdownActiveChange]);
  const handleChange = (0,react.useCallback)(value2 => {
    if (value2 === void 0) {
      return;
    }
    onChange(value2);
    onDropdownActiveChange(false);
  }, [onChange, onDropdownActiveChange]);
  const handleClose = () => {
    onDropdownActiveChange(false);
    setIsVisible(false);
  };
  (0,react.useEffect)(() => {
    if (menuRef.current && dropdownRef.current) {
      const menuPosition = menuRef.current.getBoundingClientRect();
      const dropdownPosition = dropdownRef.current.getBoundingClientRect();
      if (menuPosition.left + menuPosition.width > window.innerWidth || menuPosition.left < dropdownPosition.left) {
        menuRef.current.style.transform = `translateX(calc(-100% + ${dropdownPosition.width}px))`;
      }
    }
  }, [isDropdownActive]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(dropdownRef, handleClickOutside);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: dropdownRef,
    className: dropdown_mechanic_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(DropdownButton, {
      type: buttonType,
      buttonLabel: btnLabel,
      isCorrect: correct,
      onClick: handleDropdownClick,
      children: value
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownMenu, {
      options,
      value,
      sentenceWithButton: getSentence(btnLabel),
      isDropdownActive,
      showLabels,
      isMenuVisible: isVisible,
      menuRef,
      onChange: handleChange,
      onClose: handleClose
    })]
  });
};
// EXTERNAL MODULE: ./src/components/dropdown-output/dropdown/useDropdownContext.ts
var useDropdownContext = __webpack_require__(43548);
// EXTERNAL MODULE: ./src/components/dropdown-output/dropdown-output.module.css
var dropdown_output_module = __webpack_require__(39910);
;// CONCATENATED MODULE: ./src/components/dropdown-output/dropdown/dropdown.component.tsx






const Dropdown = _ref => {
  let {
    labelIndex,
    item
  } = _ref;
  const {
    answerKey,
    isCorrect,
    isSubmitted,
    isSelected,
    value,
    isActive,
    onChange,
    onDropdownActiveChange,
    getSentence
  } = (0,useDropdownContext/* useDropdownContext */.tv)(labelIndex, item.correct);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: dropdown_output_module/* default */.Z.dropdownWrapper,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownMechanic, {
      btnLabel: labelIndex,
      options: item.options,
      correct: isCorrect,
      submitted: isSubmitted,
      selected: isSelected,
      value,
      isDropdownActive: isActive,
      onDropdownActiveChange: active => onDropdownActiveChange(labelIndex, active),
      onChange: value2 => {
        onChange(value2, answerKey);
      },
      getSentence
    })
  }, `${answerKey}`);
};
// EXTERNAL MODULE: ./src/components/dropdown-output/parser.ts
var parser = __webpack_require__(57724);
;// CONCATENATED MODULE: ./src/components/dropdown-output/dropdown-rules.tsx

















const DEFAULT_INDEXES = {
  textIndex: 0,
  itemIndex: 0
};
const getDropdownRule = shuffleHash => {
  let dropdownIndex = 0;
  return {
    dropdown: {
      order: 1,
      match: simple_markdown_default().inlineRegex(parser/* STRICT_DROPDOWN_REGEXP */.yL),
      parse: capture => parsedDropdown(capture, ++dropdownIndex, shuffleHash),
      react: node => /* @__PURE__ */(0,jsx_runtime.jsx)(Dropdown, {
        labelIndex: (0,useDropdownContext/* makeLabelIndex */.Tg)(node.content.index),
        item: node.content
      }, `dropdown-${node.content.index}`)
    }
  };
};
const useDropdownRules = _ref => {
  let {
    texts,
    parsedText,
    shuffleHash,
    indexesMap,
    answer,
    activeDropdownIndex
  } = _ref;
  const dropdownWithSentence = labelIndex => {
    const {
      textIndex
    } = indexesMap.get((0,useDropdownContext/* makeLabelIndex */.Tg)(labelIndex - 1)) ?? DEFAULT_INDEXES;
    const minTextItemIndex = minIndexInParsedArray(parsedText[textIndex]);
    const string = texts[textIndex];
    const splitStrings = (0,string_utils/* splitBySentencesWithList */.mN)(string);
    const parsedStrings = (0,parser/* splitStringsToDropdowns */.wb)(splitStrings, shuffleHash);
    const parsedStringIndex = parsedStrings.reduce((res, itemsArray, index) => {
      const hasLabelIndex = itemsArray.some(item =>
      // minItemIndex + item.index + 1 - minItemIndex нужен,
      // чтобы начинать счет с индекса во всем тексте,
      // а не в конкретном кусочке текста
      typeof item !== "string" && minTextItemIndex + item.index + 1 === labelIndex);
      return hasLabelIndex ? index : res;
    }, 0);
    const minStringItemIndex = minIndexInParsedArray(parsedStrings[parsedStringIndex]);
    let dropdownWithSentenceIndex = minTextItemIndex + minStringItemIndex;
    return {
      sentence: parsedStrings[parsedStringIndex].length === 1 ? null : splitStrings[parsedStringIndex],
      rule: {
        dropdown: {
          order: 1,
          match: simple_markdown_default().inlineRegex(parser/* STRICT_DROPDOWN_REGEXP */.yL),
          parse: capture => {
            ++dropdownWithSentenceIndex;
            return parsedDropdown(capture, dropdownWithSentenceIndex, shuffleHash);
          },
          react: node => {
            const itemLabelIndex = node.content.index;
            const {
              textIndex: textIndex2,
              itemIndex
            } = indexesMap.get((0,useDropdownContext/* makeLabelIndex */.Tg)(itemLabelIndex - 1)) ?? DEFAULT_INDEXES;
            const answerValue = answer[`${textIndex2}_${itemIndex}`];
            return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: dropdown_output_module/* default */.Z.dropdownWrapper,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownButton, {
                type: "empty",
                buttonLabel: itemLabelIndex,
                onClick: function_utils/* emptyFunction */.Bi,
                isActive: activeDropdownIndex === itemLabelIndex,
                children: answerValue
              })
            }, `dropdown-with-sentence-${itemLabelIndex}`);
          }
        }
      }
    };
  };
  return {
    dropdown: getDropdownRule(shuffleHash),
    dropdownWithSentence
  };
};
const parsedDropdown = (capture, dropdownIndex, shuffleHash) => ({
  content: (0,parser/* parseDropdownOutput */.xx)(capture[0], dropdownIndex, shuffleHash)
});
const minIndexInParsedArray = array => {
  const itemIndexes = array.reduce((acc, item) => {
    if (typeof item !== "string") {
      acc.push(item.index);
    }
    return acc;
  }, []);
  return itemIndexes.length > 0 ? Math.min(...itemIndexes) : 0;
};

/***/ }),

/***/ 43548:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D6: () => (/* binding */ DropdownStateContext),
/* harmony export */   Tg: () => (/* binding */ makeLabelIndex),
/* harmony export */   tv: () => (/* binding */ useDropdownContext)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2784);
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(44352);
/* harmony import */ var _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61297);



















var LabelIndexTag = /* @__PURE__ */(LabelIndexTag2 => {})(LabelIndexTag || {});
const makeLabelIndex = (0,ts_brand__WEBPACK_IMPORTED_MODULE_15__/* .make */ .Sy)();
const DropdownStateContext = (0,react__WEBPACK_IMPORTED_MODULE_14__.createContext)({
  indexesMap: /* @__PURE__ */new Map(),
  answer: {},
  activeDropdownIndex: makeLabelIndex(0),
  isSubmitted: false,
  isSelected: false,
  onChange: _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_16__/* .emptyFunction */ .Bi,
  onDropdownActiveChange: _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_16__/* .emptyFunction */ .Bi,
  getSentence: () => null
});
const useDropdownContext = (labelIndex, correctAnswer) => {
  const {
    indexesMap,
    answer,
    activeDropdownIndex,
    isSubmitted,
    isSelected,
    onDropdownActiveChange,
    onChange,
    getSentence
  } = (0,react__WEBPACK_IMPORTED_MODULE_14__.useContext)(DropdownStateContext);
  const {
    textIndex,
    itemIndex
  } = indexesMap.get(makeLabelIndex(labelIndex - 1)) ?? {
    textIndex: 0,
    itemIndex: 0
  };
  const answerKey = `${textIndex}_${itemIndex}`;
  return {
    answerKey,
    value: answer[answerKey],
    activeDropdownIndex,
    isCorrect: correctAnswer === answer[answerKey],
    isSubmitted,
    isSelected,
    isActive: activeDropdownIndex === labelIndex,
    onChange,
    onDropdownActiveChange,
    getSentence
  };
};

/***/ }),

/***/ 57724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   wb: () => (/* binding */ splitStringsToDropdowns),
/* harmony export */   xx: () => (/* binding */ parseDropdownOutput),
/* harmony export */   yL: () => (/* binding */ STRICT_DROPDOWN_REGEXP)
/* harmony export */ });
/* unused harmony export DROPDOWN_REGEXP */
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5875);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50509);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74736);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38728);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64810);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43419);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32825);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94574);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16093);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36615);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77829);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33281);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60253);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24376);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49225);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(79941);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57265);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25888);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15840);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(32442);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37610);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(227);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(13351);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _yandex_langly_shared_src_array_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(96799);
/* harmony import */ var _utils_splitStringsByRegex__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(41991);





























const DROPDOWN_REGEXP = /<[^>]+>/;
const STRICT_DROPDOWN_REGEXP = /^<[^>]+>/;
const parseDropdownOutput = (dropdownStr, index, shuffleHash) => {
  const variants = new Set(dropdownStr.substring(1, dropdownStr.length - 1).split("|"));
  const options = Array.from(variants).map(opt => ({
    title: opt,
    value: opt
  }));
  const shuffledOptions = (0,_yandex_langly_shared_src_array_utils__WEBPACK_IMPORTED_MODULE_25__/* .shuffleArray */ .Sy)(options, item => item.value, shuffleHash);
  return {
    options: shuffledOptions,
    correct: options[0].value,
    index
  };
};
const splitStringsToDropdowns = (strings, shuffleHash) => (0,_utils_splitStringsByRegex__WEBPACK_IMPORTED_MODULE_26__/* .splitStringsByRegex */ .z)(strings, DROPDOWN_REGEXP, parseDropdownOutput, shuffleHash);

/***/ }),

/***/ 25210:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: () => (/* binding */ GlobalError)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83112);
/* harmony import */ var _yandex_langly_ui_kit_src_button_button_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60667);
/* harmony import */ var _yandex_langly_ui_kit_src_errors_default_error_default_error_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6734);







const GlobalError = _ref => {
  let {
    titleKey,
    descriptionKey,
    imageUrl,
    button,
    fixed,
    children
  } = _ref;
  const intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const textConstants = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => ({
    title: intl.formatMessage({
      id: titleKey
    }),
    description: intl.formatMessage({
      id: descriptionKey
    })
  }), [descriptionKey, intl, titleKey]);
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_yandex_langly_ui_kit_src_errors_default_error_default_error_component__WEBPACK_IMPORTED_MODULE_3__/* .DefaultError */ .b, {
    textConstants,
    imageUrl,
    fixed,
    children: [button && /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yandex_langly_ui_kit_src_button_button_component__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
      appearance: "primary",
      onClick: button.onClick,
      children: intl.formatMessage({
        id: button.key
      })
    }), children]
  });
};

/***/ }),

/***/ 50327:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ NotFoundError)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4517);
/* harmony import */ var _global_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25210);






const NotFoundError = _ref => {
  let {
    imageUrl = "https://flowstatic.s3.yandex.net/ui-files/404_error.svg",
    titleKey = "error404.title",
    descriptionKey = "error404.description",
    ...other
  } = _ref;
  const history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useHistory */ .k6)();
  const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => history.goBack(), [history]);
  const {
    button,
    children
  } = {
    button: {
      key: "error404.goBack",
      onClick: handleClick
    },
    ...other
  };
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_error__WEBPACK_IMPORTED_MODULE_2__/* .GlobalError */ .g, {
    imageUrl,
    titleKey,
    descriptionKey,
    button,
    ...other,
    children
  });
};

/***/ }),

/***/ 44199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ getFillTheGapRule)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/hot-key/hot-key.component.tsx + 1 modules
var hot_key_component = __webpack_require__(72416);
// EXTERNAL MODULE: ../ui-kit/src/input-with-auto-width/input-with-auto-width.component.tsx + 3 modules
var input_with_auto_width_component = __webpack_require__(86198);
// EXTERNAL MODULE: ../ui-kit/src/medium-input/medium-input.component.tsx + 1 modules
var medium_input_component = __webpack_require__(30355);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/use-fill-the-gap-context.ts
var use_fill_the_gap_context = __webpack_require__(21254);
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/fill-the-gap-output.module.css
var fill_the_gap_output_module = __webpack_require__(70550);
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/fill-the-gap.tsx












const FillTheGap = _ref => {
  let {
    index
  } = _ref;
  const {
    placeholder,
    feedbackStatus,
    value,
    onValueChanged,
    isSubmit
  } = (0,use_fill_the_gap_context/* useFillTheGapContext */.v)(index);
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    ref,
    inView
  } = (0,react_intersection_observer_m/* useInView */.YD)();
  const withAutoFocus = isDesktop && inView && index === 0;
  const handleChangeAnswer = (0,react.useCallback)(event => {
    onValueChanged(index, event.currentTarget.value);
  }, [index, onValueChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: fill_the_gap_output_module/* default */.Z.inputWrapper,
    ref,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(input_with_auto_width_component/* InputWithAutoWidth */.o, {
      fontStyle: typography_module/* default */.Z.body1,
      height: "medium",
      autoFocus: withAutoFocus,
      disabled: isSubmit,
      status: feedbackStatus,
      value,
      onChange: handleChangeAnswer,
      placeholder,
      icon: mapStatusToHotKey(feedbackStatus)
    })
  });
};
const mapStatusToHotKey = status => {
  switch (status) {
    case medium_input_component/* MediumInputStatus */._.Success:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
        state: hot_key_component/* HotKeyState */.wu.Success,
        contentType: hot_key_component/* HotKeyContentType */.cu.Check
      });
    case medium_input_component/* MediumInputStatus */._.Typo:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
        state: hot_key_component/* HotKeyState */.wu.Warning,
        contentType: hot_key_component/* HotKeyContentType */.cu.Exclamation
      });
    case medium_input_component/* MediumInputStatus */._.Error:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
        state: hot_key_component/* HotKeyState */.wu.Error,
        contentType: hot_key_component/* HotKeyContentType */.cu.Cross
      });
    default:
      return void 0;
  }
};
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/parser.ts
var parser = __webpack_require__(77487);
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/fill-the-gap-rule.tsx






const getFillTheGapRule = () => {
  let index = 0;
  return {
    fillTheGap: {
      order: 1,
      match: simple_markdown_default().inlineRegex(parser/* STRICT_FILL_THE_GAP_REGEXP */.vu),
      parse: capture => ({
        content: (0,parser/* parseFillTheGapOutput */.Fj)(capture[1], index++)
      }),
      react: node => /* @__PURE__ */(0,jsx_runtime.jsx)(FillTheGap, {
        index: node.content.index
      }, `fill-the-gap-${node.content.index}`)
    }
  };
};

/***/ }),

/***/ 77487:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B3: () => (/* binding */ FILL_THE_GAP_REGEXP),
/* harmony export */   Ct: () => (/* binding */ splitStringToFillTheGap),
/* harmony export */   Fj: () => (/* binding */ parseFillTheGapOutput),
/* harmony export */   Yc: () => (/* binding */ parseFillTheGapRegexp),
/* harmony export */   vu: () => (/* binding */ STRICT_FILL_THE_GAP_REGEXP)
/* harmony export */ });
/* harmony import */ var _utils_splitStringsByRegex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41991);



const FILL_THE_GAP_REGEXP = /<[^>]+>/;
const STRICT_FILL_THE_GAP_REGEXP = /^<([^<>]+)>/;
function parseFillTheGapRegexp(fillTheGapStr) {
  return fillTheGapStr.replace(/[><]/g, "").split("|");
}
function parseFillTheGapOutput(fillTheGapStr, index) {
  return {
    rightAnswers: parseFillTheGapRegexp(fillTheGapStr),
    index
  };
}
function splitStringToFillTheGap(string, shuffleHash) {
  return (0,_utils_splitStringsByRegex__WEBPACK_IMPORTED_MODULE_0__/* .splitStringsByRegex */ .z)([string], FILL_THE_GAP_REGEXP, parseFillTheGapOutput, shuffleHash)[0];
}

/***/ }),

/***/ 21254:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: () => (/* binding */ FillTheGapStateContext),
/* harmony export */   v: () => (/* binding */ useFillTheGapContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61297);
/* harmony import */ var _yandex_langly_ui_kit_src_medium_input_medium_input_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30355);





const FillTheGapStateContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  placeholders: [],
  currentUserAnswer: {},
  isSubmit: false,
  getFeedbackStatusForGap: _ => _yandex_langly_ui_kit_src_medium_input_medium_input_component__WEBPACK_IMPORTED_MODULE_2__/* .MediumInputStatus */ ._.Default,
  handleValueChanged: _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_1__/* .emptyFunction */ .Bi
});
const useFillTheGapContext = index => {
  const {
    placeholders,
    getFeedbackStatusForGap,
    currentUserAnswer,
    isSubmit,
    handleValueChanged
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(FillTheGapStateContext);
  return {
    placeholder: placeholders && placeholders[index],
    feedbackStatus: getFeedbackStatusForGap(index),
    value: currentUserAnswer[index],
    onValueChanged: handleValueChanged,
    isSubmit
  };
};

/***/ }),

/***/ 76087:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  G: () => (/* binding */ GrammarGuideButton)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../shared/src/utils/storage/index.ts + 4 modules
var storage = __webpack_require__(81597);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ./src/hooks/use-grammar-guide.ts
var use_grammar_guide = __webpack_require__(9784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useEvent.js + 1 modules
var useEvent = __webpack_require__(23738);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
;// CONCATENATED MODULE: ../ui-kit/src/tooltip/types.ts


var TailPosition = /* @__PURE__ */(TailPosition2 => {
  TailPosition2["Top"] = "top";
  TailPosition2["Bottom"] = "bottom";
  TailPosition2["Left"] = "left";
  TailPosition2["Right"] = "right";
  return TailPosition2;
})(TailPosition || {});
var PaddingType = /* @__PURE__ */(PaddingType2 => {
  PaddingType2["Default"] = "default";
  PaddingType2["Small"] = "small";
  return PaddingType2;
})(PaddingType || {});
;// CONCATENATED MODULE: ../ui-kit/src/tooltip/tooltip-large.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tooltip_large_module = ({"root":"tooltip-large-module__root--zrYq4","tail":"tooltip-large-module__tail--cPTcF","tail-top":"tooltip-large-module__tail-top--LNo4_","tailTop":"tooltip-large-module__tail-top--LNo4_","tail-bottom":"tooltip-large-module__tail-bottom--PE6My","tailBottom":"tooltip-large-module__tail-bottom--PE6My","tail-left":"tooltip-large-module__tail-left--GWWt0","tailLeft":"tooltip-large-module__tail-left--GWWt0","tail-right":"tooltip-large-module__tail-right--Hh55t","tailRight":"tooltip-large-module__tail-right--Hh55t","root-padding-small":"tooltip-large-module__root-padding-small--bo02l","rootPaddingSmall":"tooltip-large-module__root-padding-small--bo02l"});
;// CONCATENATED MODULE: ../ui-kit/src/tooltip/tooltip-large.tsx






const TooltipLarge = _ref => {
  let {
    padding = PaddingType.Default,
    children,
    tailPosition,
    tailLeftStyle,
    tailRightStyle,
    className
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(tooltip_large_module.root, className, {
      [tooltip_large_module.rootPaddingSmall]: padding === PaddingType.Small
    }),
    children: [children, /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(tooltip_large_module.tail, {
        [tooltip_large_module.tailTop]: tailPosition === TailPosition.Top,
        [tooltip_large_module.tailBottom]: tailPosition === TailPosition.Bottom,
        [tooltip_large_module.tailLeft]: tailPosition === TailPosition.Left,
        [tooltip_large_module.tailRight]: tailPosition === TailPosition.Right
      }),
      style: {
        left: tailLeftStyle,
        right: tailRightStyle
      }
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/components/grammar-guide/grammar-tooltip.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const grammar_tooltip_module = ({"wrapper":"grammar-tooltip-module__wrapper--BVTEU","wrapper-mobile":"grammar-tooltip-module__wrapper-mobile--UDc9A","wrapperMobile":"grammar-tooltip-module__wrapper-mobile--UDc9A","wrapper-not-separate-from-help-button":"grammar-tooltip-module__wrapper-not-separate-from-help-button--_D7jf","wrapperNotSeparateFromHelpButton":"grammar-tooltip-module__wrapper-not-separate-from-help-button--_D7jf","tooltip-root":"grammar-tooltip-module__tooltip-root--Hm2dZ","tooltipRoot":"grammar-tooltip-module__tooltip-root--Hm2dZ","tooltip-ok-button":"grammar-tooltip-module__tooltip-ok-button--OKgIO","tooltipOkButton":"grammar-tooltip-module__tooltip-ok-button--OKgIO"});
;// CONCATENATED MODULE: ./src/components/grammar-guide/grammar-tooltip.tsx














const GrammarTooltip = _ref => {
  let {
    isSeparateFromHelpButton,
    buttonRef
  } = _ref;
  const [tooltipStyle, setTooltipStyle] = (0,react.useState)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [isShown, setIsShown] = (0,react.useState)(storage/* localStorageWrapper */.Y6.grammarGuidesTooltip.isShown());
  const setAsShownGrammarTooltip = (0,react.useCallback)(() => {
    storage/* localStorageWrapper */.Y6.grammarGuidesTooltip.setAsShown();
    setIsShown(true);
  }, []);
  const handleChangeTooltipStyle = (0,react.useCallback)(() => {
    if (!buttonRef.current) {
      return;
    }
    if (isMobile) {
      return setTooltipStyle({
        bottom: buttonRef.current.getBoundingClientRect().height + 26
      });
    }
    if (!isSeparateFromHelpButton) {
      return setTooltipStyle({
        right: buttonRef.current.getBoundingClientRect().width + 26
      });
    }
    return setTooltipStyle({
      right: buttonRef.current.getBoundingClientRect().width + 16,
      top: "calc(-50% - 8px)"
    });
  }, [isSeparateFromHelpButton, isMobile, buttonRef]);
  (0,react.useEffect)(() => {
    handleChangeTooltipStyle();
  }, [handleChangeTooltipStyle]);
  (0,useEvent/* default */.Z)("resize", handleChangeTooltipStyle);
  if (isShown) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(grammar_tooltip_module.wrapper, {
      [grammar_tooltip_module.wrapperMobile]: isMobile,
      [grammar_tooltip_module.wrapperNotSeparateFromHelpButton]: !isSeparateFromHelpButton
    }),
    style: tooltipStyle,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(TooltipLarge, {
      tailPosition: isMobile ? TailPosition.Bottom : TailPosition.Right,
      tailLeftStyle: "auto",
      tailRightStyle: isMobile ? "0" : "-5px",
      padding: PaddingType.Small,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: grammar_tooltip_module.tooltipRoot,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.body2,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "grammarGuide.grammarGuideTooltipTitle"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.caption,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "grammarGuide.grammarGuideTooltipSubtitle"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: grammar_tooltip_module.tooltipOkButton,
          appearance: "primaryOnBlack",
          size: "small",
          onClick: setAsShownGrammarTooltip,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "grammarGuide.grammarGuideTooltipOkButton"
          })
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/grammar-guide/__button/grammar-guide-button.component.tsx









const GrammarGuideButton = _ref => {
  let {
    isSeparateFromHelpButton = true
  } = _ref;
  const buttonRef = (0,react.useRef)(null);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    toggleGrammarGuideVisibility
  } = (0,use_grammar_guide/* useGrammarGuide */.U)();
  const showGrammarTooltip = !storage/* localStorageWrapper */.Y6.grammarGuidesTooltip.isShown();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [buttonRef.current && showGrammarTooltip && /* @__PURE__ */(0,jsx_runtime.jsx)(GrammarTooltip, {
      isSeparateFromHelpButton,
      buttonRef
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      ref: buttonRef,
      onClick: toggleGrammarGuideVisibility,
      appearance: "primary",
      size: isMobile ? "small" : "medium",
      iconName: "notes"
    })]
  });
};

/***/ }),

/***/ 80880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  y: () => (/* binding */ GrammarGuideSheet)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/hooks/useFetch.ts
var useFetch = __webpack_require__(29553);
// EXTERNAL MODULE: ../ui-kit/src/bottom-sheet/bottom-sheet@light.component.tsx + 1 modules
var bottom_sheet_light_component = __webpack_require__(80814);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(47933);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/components/grammar-guide/__chapter-link/grammar-guide-chapter-link.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const grammar_guide_chapter_link_module = ({"guide-link":"grammar-guide-chapter-link-module__guide-link--kAouo","guideLink":"grammar-guide-chapter-link-module__guide-link--kAouo"});
;// CONCATENATED MODULE: ./src/components/grammar-guide/__chapter-link/grammar-guide-chapter-link.component.tsx










const GrammarGuideChapterLink = _ref => {
  let {
    title,
    link
  } = _ref;
  const [isVisibleArrow, setArrowVisible] = (0,react.useState)(false);
  const {
    isMobile,
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
    to: link,
    target: "__blank",
    className: grammar_guide_chapter_link_module.guideLink,
    onMouseEnter: () => setArrowVisible(true),
    onMouseLeave: () => setArrowVisible(false),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(isMobile ? typography_module/* default */.Z.body2Accent : typography_module/* default */.Z.headline4Accent),
      children: title
    }), isVisibleArrow && isDesktop && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: "arrow-with-line-right",
      size: "medium"
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/grammar-guide/__sheet/grammar-guide-sheet.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const grammar_guide_sheet_module = ({"content":"grammar-guide-sheet-module__content--PKmTF","loader-container":"grammar-guide-sheet-module__loader-container--hy1Dt","loaderContainer":"grammar-guide-sheet-module__loader-container--hy1Dt"});
;// CONCATENATED MODULE: ./src/components/grammar-guide/__sheet/grammar-guide-sheet.component.tsx















const GrammarGuideSheet = _ref => {
  let {
    visible,
    onClose
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const grammarGuidesFetcher = (0,useFetch/* useFetch */.i)(bunker_api/* getGrammarGuides */.O);
  (0,react.useEffect)(() => {
    if (grammarGuidesFetcher.state === useFetch/* State */.Z.Initial && visible) {
      void grammarGuidesFetcher.fetch();
    }
  }, [grammarGuidesFetcher, visible]);
  const content = (0,react.useMemo)(() => {
    if (grammarGuidesFetcher.state === useFetch/* State */.Z.Initial || grammarGuidesFetcher.state === useFetch/* State */.Z.Loading) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: grammar_guide_sheet_module.loaderContainer,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderDelay */.Wv, {})
      });
    }
    if (grammarGuidesFetcher.state === useFetch/* State */.Z.Error) {
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          children: intl.formatMessage({
            id: "grammarGuideSheet.errorMessage"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primary",
          children: intl.formatMessage({
            id: "grammarGuideSheet.loadAgain"
          })
        })]
      });
    }
    return grammarGuidesFetcher.data.map(guide => /* @__PURE__ */(0,jsx_runtime.jsx)(GrammarGuideChapterLink, {
      link: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(guide.productId, guide.chapterId),
      title: guide.title
    }, guide.title));
  }, [grammarGuidesFetcher.data, grammarGuidesFetcher.state, intl]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_sheet_light_component/* BottomSheetLight */.e_, {
    headerPaddings: bottom_sheet_light_component/* HeaderPaddings */.wR.Large,
    headerWithBorder: true,
    visible,
    title: intl.formatMessage({
      id: "grammarGuideSheet.grammarGuide"
    }),
    onClose,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: grammar_guide_sheet_module.content,
      children: content
    })
  });
};

/***/ }),

/***/ 74140:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  l: () => (/* binding */ MainMenu)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../shared/src/entities/features.ts
var features = __webpack_require__(45404);
// EXTERNAL MODULE: ../shared/src/utils/is-revision-app-version/is-revision-app-version.ts + 1 modules
var is_revision_app_version = __webpack_require__(86649);
// EXTERNAL MODULE: ../ui-kit/src/chip/index.ts + 2 modules
var chip = __webpack_require__(56317);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
// EXTERNAL MODULE: ./src/app/routes/baseRoutePaths.ts
var baseRoutePaths = __webpack_require__(94506);
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ./src/components/main-menu/menu-button/menu-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const menu_button_module = ({"button-wrapper":"menu-button-module__button-wrapper--nbJvO","buttonWrapper":"menu-button-module__button-wrapper--nbJvO","button":"menu-button-module__button--d2wmu","button-icon":"menu-button-module__button-icon--QLPfo","buttonIcon":"menu-button-module__button-icon--QLPfo","text":"menu-button-module__text--d7UZp"});
;// CONCATENATED MODULE: ./src/components/main-menu/menu-button/menu-button.tsx









const MenuButton = _ref => {
  let {
    onClick,
    iconName,
    textId,
    customComponent,
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: menu_button_module.buttonWrapper,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
      appearance: "secondary",
      size: "medium",
      className: menu_button_module.button,
      onClick,
      children: [iconName && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: iconName,
        size: "medium",
        className: menu_button_module.buttonIcon
      }), !iconName && customComponent, /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2Accent, menu_button_module.text),
        children: textId ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: textId
        }) : children
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
;// CONCATENATED MODULE: ./src/components/main-menu/main-menu-items/main-menu-items.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const main_menu_items_module = ({"root":"main-menu-items-module__root--Esg7H","menu-item":"main-menu-items-module__menu-item--dm0MD","menuItem":"main-menu-items-module__menu-item--dm0MD","title":"main-menu-items-module__title--eetSi","referral-chip":"main-menu-items-module__referral-chip--LkYbp","referralChip":"main-menu-items-module__referral-chip--LkYbp"});
;// CONCATENATED MODULE: ./src/components/main-menu/main-menu-items/education-menu-item/education-menu-item.tsx
















const EducationMenuItem = _ref => {
  let {
    isRepetitionAvailable,
    currentProductId
  } = _ref;
  const {
    isMentorNotesVisible,
    showGrammarGuideButtonInMenu,
    fixedChapters
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const history = (0,react_router/* useHistory */.k6)();
  const fixedChaptersItems = (0,react.useMemo)(() => {
    if (fixedChapters === null || !currentProductId) {
      return null;
    }
    return fixedChapters.map(chapter => /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
      onClick: () => {
        history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
        get_url_search_params.getUrlSearchParams.retPath.goToLinkWithRetPath({
          link: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(currentProductId, chapter.chapterId),
          history
        });
      },
      iconName: "info",
      children: chapter.title
    }, chapter.chapterId));
  }, [currentProductId, fixedChapters, history]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: main_menu_items_module.menuItem,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(main_menu_items_module.title, typography_module/* default */.Z.caption),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "menuModal.education"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
      onClick: () => {
        history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
        history.push(get_url_search_params.getUrlSearchParams.wordbankPopup.getOpenUrl(history));
      },
      iconName: "vocabulary",
      textId: "menuModal.vocabulary"
    }), isRepetitionAvailable && /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
      onClick: () => {
        history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
        get_url_search_params.getUrlSearchParams.retPath.goToLinkWithRetPath({
          link: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REPETITION(currentProductId),
          history
        });
      },
      iconName: "reset",
      textId: "menuModal.learnWords"
    }), isMentorNotesVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
      onClick: () => {
        get_url_search_params.getUrlSearchParams.retPath.goToLinkWithRetPath({
          link: studentRoutePaths/* studentRoutePaths */.dR.NOTES({}),
          history
        });
      },
      iconName: "speaking-notes",
      textId: "menuModal.notes"
    }), showGrammarGuideButtonInMenu && /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
      onClick: () => {
        history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
        history.push(get_url_search_params.getUrlSearchParams.grammarGuide.getOpenUrl(history));
      },
      iconName: "numbered-list",
      textId: "menuModal.grammarGuide"
    }), fixedChaptersItems]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
;// CONCATENATED MODULE: ./src/components/main-menu/main-menu-items/hooks.ts







const useReferralMenuItemVisibility = () => {
  const {
    referral
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const isReferralExperimentActive = Boolean(referral.tariff_slug);
  const availablePaths = [studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE_LIST, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.TASKS, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.EDUCATION_MATERIALS, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.RESOURCES];
  return isReferralExperimentActive && availablePaths.some(path => location.pathname.includes(path));
};
;// CONCATENATED MODULE: ./src/components/main-menu/main-menu-items/main-menu-items.tsx





















const MainMenuItems = _ref => {
  let {
    isEducationItemVisible,
    currentProductId,
    isRepetitionAvailable
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const canBuyGift = (0,features/* useGiftPurchaseAvailability */.g3)();
  const {
    appRevisionExperiment
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const [isRevisionVersion, setIsRevisionVersion] = (0,react.useState)(false);
  const isReferralMenuItemVisible = useReferralMenuItemVisibility();
  (0,react.useEffect)(() => {
    if (appRevisionExperiment) {
      setIsRevisionVersion(true);
      return;
    }
    void (0,is_revision_app_version/* isRevisionAppVersion */.Z)(bunker_api/* getAppRevisionVersion */.Q5).then(result => setIsRevisionVersion(Boolean(result)));
  }, [appRevisionExperiment]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: main_menu_items_module.root,
    children: [isEducationItemVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(EducationMenuItem, {
      currentProductId,
      isRepetitionAvailable
    }), !isRevisionVersion && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: main_menu_items_module.menuItem,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(main_menu_items_module.title, typography_module/* default */.Z.caption),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "menuModal.discount"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
        onClick: () => {
          history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
          history.push(get_url_search_params.getUrlSearchParams.promocodePopup.getOpenUrl(history));
        },
        iconName: "tag",
        textId: "menuModal.promocode"
      }), isReferralMenuItemVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
        onClick: () => {
          history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
          history.push(studentRoutePaths/* studentRoutePaths */.dR.REFERRAL_PROGRAM);
        },
        textId: "menuModal.referral.text",
        customComponent: /* @__PURE__ */(0,jsx_runtime.jsx)(chip/* Chip */.A, {
          className: main_menu_items_module.referralChip,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: typography_module/* default */.Z.captionAccent,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "menuModal.referral.tag"
            })
          })
        })
      })]
    }), canBuyGift && !isRevisionVersion && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: main_menu_items_module.menuItem,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(main_menu_items_module.title, typography_module/* default */.Z.caption),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "menuModal.gift"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(MenuButton, {
        onClick: () => {
          history.push(baseRoutePaths/* baseRoutePaths */.lQ.BUY_GIFT_CERTIFICATE);
        },
        iconName: "gift",
        textId: "menuModal.buySertificate"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/main-menu/main-menu.tsx











const MainMenu = _ref => {
  let {
    isRepetitionAvailable = false,
    hideEducationItems = false,
    currentProductId
  } = _ref;
  const user = (0,useUser/* useUser */.aF)();
  const history = (0,react_router/* useHistory */.k6)();
  const isVisible = get_url_search_params.getUrlSearchParams.mainMenuPopup.isOpen(history);
  const isEducationItemVisible = !hideEducationItems && user.data?.product?.businessId && (user.data?.product?.businessId === product_model/* BusinessProductId */.HV.Packet || user.data?.attributes.onboardingStates.has(user.data?.product?.businessId));
  const handleClose = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history));
  }, [history]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    onClose: handleClose,
    isVisible,
    showCloseButton: true,
    size: modal/* ModalSize */.Cg.Small,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(MainMenuItems, {
      isRepetitionAvailable,
      currentProductId,
      isEducationItemVisible
    })
  });
};

/***/ }),

/***/ 59889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D: () => (/* binding */ MarkdownStrings)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/hooks/useArray.ts



function useArray(el) {
  return (0,react.useMemo)(() => Array.isArray(el) ? el : [el], [el]);
}
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
;// CONCATENATED MODULE: ./src/utils/renderTextArrayInMarkdown.tsx





const renderTextArrayInMarkdown = function (text, index, arr) {
  let withIndent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const isLast = index === arr.length - 1;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      children: text
    }), withIndent && !isLast && /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})]
  }, text);
};
;// CONCATENATED MODULE: ./src/components/markdown-strings/markdown-strings.component.tsx







const MarkdownStrings = _ref => {
  let {
    value,
    withIndent
  } = _ref;
  const valueArray = useArray(value);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: valueArray.map((text, index, arr) => renderTextArrayInMarkdown(text, index, arr, withIndent))
  });
};

/***/ }),

/***/ 17787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  m: () => (/* reexport */ PageHeader)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/services/bell/useBell.ts + 5 modules
var useBell = __webpack_require__(41944);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
;// CONCATENATED MODULE: ../ui-kit/src/notifier/bell/notifier-bell.component.tsx




const NotifierBell = _ref => {
  let {
    hasNew,
    textConstants: {
      ariaLabel
    },
    onClick
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
    onClick,
    appearance: "secondary",
    "aria-label": ariaLabel,
    size: "small",
    iconName: hasNew ? "notification-bell-unread" : "notification-bell"
  });
};
// EXTERNAL MODULE: ./src/app/routes/baseRoutePaths.ts
var baseRoutePaths = __webpack_require__(94506);
// EXTERNAL MODULE: ./src/hooks/bell/use-notifier-texts.ts
var use_notifier_texts = __webpack_require__(81923);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
;// CONCATENATED MODULE: ./src/components/course-select-button/course-select-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_select_button_module = ({"button-content":"course-select-button-module__button-content--zsNzO","buttonContent":"course-select-button-module__button-content--zsNzO","dropdown-icon":"course-select-button-module__dropdown-icon--gqYTN","dropdownIcon":"course-select-button-module__dropdown-icon--gqYTN"});
;// CONCATENATED MODULE: ./src/components/course-select-button/course-select-button.tsx











const CourseSelectButton = _ref => {
  let {
    isCourseSelectPage = false
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const handleClick = (0,react.useCallback)(() => {
    history.push(isCourseSelectPage ? studentRoutePaths/* studentRoutePaths */.dR.INDEX : studentRoutePaths/* studentRoutePaths */.dR.COURSE_SELECT);
  }, [history, isCourseSelectPage]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    appearance: "secondary",
    size: "small",
    onClick: handleClick,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: course_select_button_module.buttonContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: course_select_button_module.dropdownIcon,
        name: isCourseSelectPage ? "simple-arrow-up" : "simple-arrow-down",
        size: "small"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "courseSelectButton.buttonText"
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/course-select-button/index.ts



// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/auth/index.ts + 2 modules
var auth = __webpack_require__(60980);
// EXTERNAL MODULE: ../shared/src/domain/urls.ts
var urls = __webpack_require__(92976);
// EXTERNAL MODULE: ../shared/src/entities/user/index.ts + 3 modules
var entities_user = __webpack_require__(91485);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu/header-avatar-menu.model.ts


var HeaderAvatarMenuItemType = /* @__PURE__ */(HeaderAvatarMenuItemType2 => {
  HeaderAvatarMenuItemType2["Link"] = "link";
  HeaderAvatarMenuItemType2["Button"] = "button";
  return HeaderAvatarMenuItemType2;
})(HeaderAvatarMenuItemType || {});
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../ui-kit/src/avatar/avatar.component.tsx + 1 modules
var avatar_component = __webpack_require__(66202);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(47933);
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu-item/header-avatar-menu-item.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const header_avatar_menu_item_module = ({"root":"header-avatar-menu-item-module__root--fY23u","wrapper":"header-avatar-menu-item-module__wrapper--dhdnR"});
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu-item/header-avatar-menu-item.component.tsx









const HeaderAvatarMenuItem = _ref => {
  let {
    children,
    isMobile,
    ...itemProps
  } = _ref;
  const className = classnames_default()(header_avatar_menu_item_module.root, typography_module/* default */.Z.body2Accent, accessibility_module/* default */.Z.focusVisible);
  const renderItem = () => {
    if (itemProps.type === HeaderAvatarMenuItemType.Link) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
        role: "menuitem",
        to: itemProps.href,
        className,
        children: itemProps.title
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      type: "button",
      role: "menuitem",
      onClick: itemProps.onClick,
      className,
      children: itemProps.title
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    className: header_avatar_menu_item_module.wrapper,
    children: renderItem()
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu/menu/header-avatar-menu.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const header_avatar_menu_module = ({"user-menu":"header-avatar-menu-module__user-menu--NqJil","userMenu":"header-avatar-menu-module__user-menu--NqJil","user-menu-hidden":"header-avatar-menu-module__user-menu-hidden--AQE0X","userMenuHidden":"header-avatar-menu-module__user-menu-hidden--AQE0X","close-button-container":"header-avatar-menu-module__close-button-container--LosWd","closeButtonContainer":"header-avatar-menu-module__close-button-container--LosWd","close-button":"header-avatar-menu-module__close-button--NMqQS","closeButton":"header-avatar-menu-module__close-button--NMqQS","avatar":"header-avatar-menu-module__avatar--WP9br","name":"header-avatar-menu-module__name--VMMMK","email":"header-avatar-menu-module__email--FP_oZ"});
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu/menu/header-avatar-menu.tsx













const HeaderAvatarMenu = _ref => {
  let {
    isVisible,
    items,
    user,
    hideMenu
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const labelId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    role: "menu",
    "aria-labelledby": labelId,
    className: classnames_default()(header_avatar_menu_module.userMenu, {
      [header_avatar_menu_module.userMenuHidden]: !isVisible
    }),
    children: [isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: header_avatar_menu_module.closeButtonContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "default",
        size: "medium",
        iconName: "cross",
        className: header_avatar_menu_module.closeButton,
        onClick: hideMenu
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      id: labelId,
      className: header_avatar_menu_module.avatar,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
        size: avatar_component/* AvatarSize */.D.Size64,
        avatarId: user.id,
        hasPlus: user.hasPlus,
        tabIndex: -1
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body2, header_avatar_menu_module.name),
        children: user.name
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.caption, header_avatar_menu_module.email),
        children: user.email
      })]
    }), items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)(HeaderAvatarMenuItem, {
      isMobile,
      ...item,
      children: item.title
    }, item.title))]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu/header-avatar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const header_avatar_module = ({"root":"header-avatar-module__root--BaZCm","avatar":"header-avatar-module__avatar--ExNig","menu":"header-avatar-module__menu--cHcRR"});
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu/header-avatar.component.tsx









const HeaderAvatar = _ref => {
  let {
    isVisible,
    user,
    items,
    hideMenu,
    showMenu,
    ...rest
  } = _ref;
  const userMenuRef = (0,react.useRef)(null);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(userMenuRef, hideMenu);
  const handleClickAvatar = (0,react.useCallback)(() => isVisible ? hideMenu() : showMenu(), [hideMenu, isVisible, showMenu]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: userMenuRef,
    className: header_avatar_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: header_avatar_module.avatar,
      "data-testid": "header avatar",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
        className: accessibility_module/* default */.Z.focusVisible,
        size: avatar_component/* AvatarSize */.D.Size32,
        avatarId: user.id,
        hasPlus: user.hasPlus,
        onClick: handleClickAvatar,
        ...rest
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: header_avatar_module.menu,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(HeaderAvatarMenu, {
        items,
        isVisible,
        user,
        hideMenu
      })
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/header-avatar-menu/hook/header-avatar-menu-hook.ts



const useHeaderAvatar = () => {
  const [isMenuActive, setIsMenuActive] = (0,react.useState)(false);
  const showMenu = (0,react.useCallback)(() => setIsMenuActive(true), [setIsMenuActive]);
  const hideMenu = (0,react.useCallback)(() => setIsMenuActive(false), [setIsMenuActive]);
  return {
    isMenuActive,
    showMenu,
    hideMenu
  };
};
// EXTERNAL MODULE: ./src/hooks/use-mobile-app.ts
var use_mobile_app = __webpack_require__(74126);
;// CONCATENATED MODULE: ./src/components/header-avatar/header-avatar.tsx
















const header_avatar_HeaderAvatar = (0,react.memo)(function HeaderAvatar2() {
  const intl = (0,useIntl/* default */.Z)();
  const userInfo = (0,useUser/* useUser */.aF)();
  const {
    isMobileApp
  } = (0,use_mobile_app/* useMobileApp */._g)();
  const user = userInfo.data?.me.user;
  const avatar = {
    id: user?.avatar ?? "",
    hasPlus: user?.hasPlus ?? false,
    email: user?.defaultEmail ?? "",
    name: user?.publicName ?? ""
  };
  const userRole = user?.role;
  const {
    isMenuActive,
    showMenu,
    hideMenu
  } = useHeaderAvatar();
  const menuItems = (0,react.useMemo)(() => {
    const items = [{
      type: HeaderAvatarMenuItemType.Button,
      title: intl.formatMessage({
        id: "appPageHeader.accountSettings"
      }),
      onClick: () => {
        window.open((0,urls/* getExternalUrl */.Eg)("passport"), "_blank");
      }
    }];
    const canSeeSettings = [entities_user/* UserRole */.i4.ROLE_STUDENT, entities_user/* UserRole */.i4.ROLE_TESTER, entities_user/* UserRole */.i4.ROLE_DEVELOPER];
    if (canSeeSettings.includes(userRole)) {
      items.push({
        type: HeaderAvatarMenuItemType.Link,
        title: intl.formatMessage({
          id: "appPageHeader.settings"
        }),
        href: baseRoutePaths/* baseRoutePaths */.lQ.SETTINGS
      });
    }
    items.push({
      type: HeaderAvatarMenuItemType.Button,
      title: intl.formatMessage({
        id: "appPageHeader.exit"
      }),
      onClick: () => {
        auth/* Auth */.g.redirectToLogout(isMobileApp ? `${window.location.origin}${(0,site_utils/* getAppPath */.bY)()}` : void 0);
      }
    });
    return items;
  }, [intl, isMobileApp, userRole]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(HeaderAvatar, {
    isVisible: isMenuActive,
    showMenu,
    hideMenu,
    items: menuItems,
    user: avatar,
    "aria-label": intl.formatMessage({
      id: "appPageHeader.avatar.ariaLabel"
    })
  });
});
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
;// CONCATENATED MODULE: ./src/components/page-header/main-menu-button/main-menu-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const main_menu_button_module = ({"content":"main-menu-button-module__content--bKEWx","icon":"main-menu-button-module__icon--Tjybl","text":"main-menu-button-module__text--Ej4DD"});
;// CONCATENATED MODULE: ./src/components/page-header/main-menu-button/main-menu-button.tsx















const MainMenuButton = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const isMenuOpen = get_url_search_params.getUrlSearchParams.mainMenuPopup.isOpen(history);
  const iconName = isMenuOpen ? "cross-bold" : "burger-menu";
  const {
    isTabletOrDesktop,
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const handleClick = (0,react.useCallback)(() => {
    history.push(isMenuOpen ? get_url_search_params.getUrlSearchParams.mainMenuPopup.getCloseUrl(history) : get_url_search_params.getUrlSearchParams.mainMenuPopup.getOpenUrl(history));
  }, [history, isMenuOpen]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isTabletOrDesktop && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "primary",
      size: "small",
      onClick: handleClick,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(main_menu_button_module.content, typography_module/* default */.Z.captionAccent),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: main_menu_button_module.icon,
          name: iconName,
          size: "small"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: main_menu_button_module.text,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "mainMenuButton.text"
          })
        })]
      })
    }), isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      iconName,
      appearance: "primary",
      size: "small",
      onClick: handleClick
    })]
  });
};
// EXTERNAL MODULE: ./src/components/page-header/types.ts
var types = __webpack_require__(25269);
// EXTERNAL MODULE: ../shared/src/constants.ts
var constants = __webpack_require__(51157);
// EXTERNAL MODULE: ../shared/src/models/bell/item.ts
var item = __webpack_require__(25382);
// EXTERNAL MODULE: ../shared/src/services/bell/useBellNotification.ts
var useBellNotification = __webpack_require__(53378);
;// CONCATENATED MODULE: ./src/components/page-header/mobile-header/floating-notification/floating-notification.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const floating_notification_module = ({"wrapper":"floating-notification-module__wrapper--FiBpB","icons":"floating-notification-module__icons--unoYg","icon-wrapper":"floating-notification-module__icon-wrapper--vUGQL","iconWrapper":"floating-notification-module__icon-wrapper--vUGQL","link":"floating-notification-module__link--LFtgj"});
;// CONCATENATED MODULE: ./src/components/page-header/mobile-header/floating-notification/floating-notification.tsx














const FloatingNotification = () => {
  const [needToShowReferralTooltipNotification, setNeedToShowReferralTooltipNotification] = (0,react.useState)(false);
  const {
    getBellNotifications
  } = (0,useBellNotification/* useBellNotification */.C)();
  const intl = (0,useIntl/* default */.Z)();
  const appBellReferralAnnouncementItem = getBellNotifications(item/* AppBellItemType */.M.Referral)[0];
  const announcementId = appBellReferralAnnouncementItem?.payload?.announcementId;
  (0,react.useEffect)(() => {
    if (!appBellReferralAnnouncementItem) {
      setNeedToShowReferralTooltipNotification(false);
      return;
    }
    setNeedToShowReferralTooltipNotification(!appBellReferralAnnouncementItem?.isRead);
  }, [appBellReferralAnnouncementItem]);
  const handleCloseNotification = () => {
    appBellReferralAnnouncementItem.markAsRead();
  };
  if (!needToShowReferralTooltipNotification) {
    return null;
  }
  if (!announcementId) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: floating_notification_module.wrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: floating_notification_module.icons,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: floating_notification_module.iconWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "lamp",
          size: "medium"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "floating",
        size: "small",
        iconName: "cross",
        onClick: handleCloseNotification
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
      className: typography_module/* default */.Z.caption,
      children: [intl.formatMessage({
        id: `referralProgram.${announcementId}.mobile`
      }), constants/* NBSP */.Xz, /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
        className: floating_notification_module.link,
        to: studentRoutePaths/* studentRoutePaths */.dR.REFERRAL_PROGRAM,
        onClick: handleCloseNotification,
        children: intl.formatMessage({
          id: `referralProgram.${announcementId}.mobile.link`
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/page-header/mobile-header/mobile-header.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const mobile_header_module = ({"space":"mobile-header-module__space--K_l9r","main-menu-button":"mobile-header-module__main-menu-button--QfJLi","mainMenuButton":"mobile-header-module__main-menu-button--QfJLi","right-buttons":"mobile-header-module__right-buttons--KtOTP","rightButtons":"mobile-header-module__right-buttons--KtOTP","right-button":"mobile-header-module__right-button--xQAyn","rightButton":"mobile-header-module__right-button--xQAyn","root-mobile":"mobile-header-module__root-mobile--waj0m","rootMobile":"mobile-header-module__root-mobile--waj0m","menu-icon-mobile":"mobile-header-module__menu-icon-mobile--MYRQO","menuIconMobile":"mobile-header-module__menu-icon-mobile--MYRQO","notifier-bell-wrapper":"mobile-header-module__notifier-bell-wrapper--KZj1Y","notifierBellWrapper":"mobile-header-module__notifier-bell-wrapper--KZj1Y","referral-program-button":"mobile-header-module__referral-program-button--qASGH","referralProgramButton":"mobile-header-module__referral-program-button--qASGH"});
;// CONCATENATED MODULE: ./src/components/page-header/mobile-header/mobile-header.tsx



















const MobileHeader = _ref => {
  let {
    children,
    hideCourseSelectButton,
    hideMenuButton,
    hideNotifierBell,
    isCourseSelectPage,
    leftSideBlock = types/* HeaderLefSideBlockContent */.c.Default,
    hideReferralProgramElements = true
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const user = (0,useUser/* useUser */.aF)();
  const isNewbie = user.data?.me?.user?.role === "newbie";
  const notifierTexts = (0,use_notifier_texts/* useIntlNotifierTexts */.s)();
  const {
    hasNewNotifierItems,
    notifierBellVisible,
    showNotifier
  } = (0,useBell/* useBell */.z)();
  const hasMainMenuButton = !isNewbie && !hideMenuButton;
  const hasCourseSelectButton = !isNewbie && !hideCourseSelectButton;
  const openMainPage = (0,react.useCallback)(() => {
    history.push(baseRoutePaths/* baseRoutePaths */.lQ.INDEX);
  }, [history]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: mobile_header_module.rootMobile,
    children: [leftSideBlock === types/* HeaderLefSideBlockContent */.c.CrossIcon && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "default",
      size: "small",
      iconName: "cross",
      onClick: openMainPage
    }), hasMainMenuButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: mobile_header_module.mainMenuButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(MainMenuButton, {})
    }), children || /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: mobile_header_module.space
    }), !hideReferralProgramElements && /* @__PURE__ */(0,jsx_runtime.jsx)(FloatingNotification, {}), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: mobile_header_module.rightButtons,
      children: [!hideNotifierBell && notifierBellVisible && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: mobile_header_module.rightButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierBell, {
          textConstants: notifierTexts.bell,
          hasNew: hasNewNotifierItems,
          onClick: showNotifier
        })
      }), hasCourseSelectButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(mobile_header_module.rightButton),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CourseSelectButton, {
          isCourseSelectPage
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: mobile_header_module.rightButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(header_avatar_HeaderAvatar, {})
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-progress-page-enabled.ts
var use_progress_page_enabled = __webpack_require__(67512);
;// CONCATENATED MODULE: ./src/components/page-header/navigation/navigation.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const navigation_module = ({"navigation":"navigation-module__navigation--Em3n4","nav-link":"navigation-module__nav-link--Oo4_t","navLink":"navigation-module__nav-link--Oo4_t"});
;// CONCATENATED MODULE: ./src/components/page-header/navigation/navigation.tsx













const Navigation = () => {
  const {
    routes
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const {
    shouldShowProgress
  } = (0,use_progress_page_enabled/* useProgressPageEnabled */.e)();
  const isScheduleRoute = (0,react_router/* useRouteMatch */.$B)(routes.SCHEDULE);
  const isResourcesRoute = (0,react_router/* useRouteMatch */.$B)(routes.RESOURCES);
  const isScheduleListRoute = (0,react_router/* useRouteMatch */.$B)(routes.SCHEDULE_LIST);
  const isTasksRoute = (0,react_router/* useRouteMatch */.$B)(routes.TASKS);
  const isEducationMaterialsRoute = (0,react_router/* useRouteMatch */.$B)(routes.EDUCATION_MATERIALS);
  const isProgressRoute = (0,react_router/* useRouteMatch */.$B)(routes.PROGRESS.INDEX);
  const buttons = [{
    translationId: "pageHeader.main",
    route: routes.SCHEDULE,
    isSelected: isScheduleRoute || isResourcesRoute
  }, {
    translationId: "pageHeader.schedule",
    route: routes.SCHEDULE_LIST,
    isSelected: isScheduleListRoute
  }, {
    translationId: "pageHeader.tasks",
    route: routes.TASKS,
    isSelected: isTasksRoute
  }, {
    translationId: "pageHeader.educationalMaterials",
    route: routes.EDUCATION_MATERIALS,
    isSelected: isEducationMaterialsRoute
  }];
  if (shouldShowProgress) {
    buttons.push({
      translationId: "pageHeader.progress",
      route: routes.PROGRESS.SKILLS,
      isSelected: isProgressRoute
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: navigation_module.navigation,
    children: buttons.map(_ref => {
      let {
        isSelected,
        route,
        translationId
      } = _ref;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* NavLink */.OL, {
        to: route,
        className: navigation_module.navLink,
        isActive: (match, location) => {
          const idResourcesRoute = route === routes.SCHEDULE && location.pathname === routes.RESOURCES;
          return Boolean(match) || idResourcesRoute;
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: isSelected ? "secondaryFloating" : "tertiary",
          size: "small",
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: translationId
          })
        })
      }, translationId);
    })
  });
};
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/components/logo/svg/logo-practicum_ru.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* harmony default export */ const logo_practicum_ru = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 135 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M.873 5.15V26h3.63V7.97h6.48V26h3.63V5.15H.873zm20.029 5.76h-3.3v19.44h3.57v-6.12c.9 1.35 2.22 2.07 3.75 2.07 3.48 0 5.88-2.79 5.88-7.86 0-5.04-2.34-7.83-5.7-7.83-1.68 0-3.06.78-4.02 2.25l-.18-1.95zm3.12 12.57c-1.89 0-2.85-1.53-2.85-5.01 0-3.51 1.02-5.04 3.03-5.04 1.95 0 2.91 1.53 2.91 5.01 0 3.51-1.02 5.04-3.09 5.04zm20.299-7.77c0-3.66-1.86-5.04-5.64-5.04-2.37 0-4.23.75-5.31 1.38v2.97c.96-.72 3.06-1.5 4.89-1.5 1.71 0 2.49.6 2.49 2.22v.84h-.57c-5.46 0-7.89 1.8-7.89 4.86 0 3.06 1.86 4.77 4.62 4.77 2.1 0 3-.69 3.69-1.41h.15c.03.39.15.9.27 1.2h3.48a37.98 37.98 0 01-.18-3.69v-6.6zm-3.57 6.69c-.45.66-1.29 1.2-2.55 1.2-1.5 0-2.25-.9-2.25-2.25 0-1.77 1.23-2.4 4.29-2.4h.51v3.45zm15.29 3.6h4.05l-5.73-8.13 5.04-6.96h-3.6l-5.04 6.96v-6.96h-3.57V26h3.57v-7.41l5.28 7.41zm15.873-12.27v-2.82h-11.97v2.82h4.2V26h3.57V13.73h4.2zm2.113-2.82V26h3.09l5.52-9.33V26h3.48V10.91h-3.09l-5.52 9.33v-9.33h-3.48zM97.965 26h4.05l-5.73-8.13 5.04-6.96h-3.6l-5.04 6.96v-6.96h-3.57V26h3.57v-7.41l5.28 7.41zm7.191 4.65c3.33 0 4.56-2.37 5.58-5.46l4.71-14.28h-3.45l-3.33 11.34-3.33-11.34h-3.75l5.19 15.75c-.39.72-.96 1.17-1.95 1.17-.66 0-1.23-.21-1.62-.6v2.91s.54.51 1.95.51zM129.671 26h3.48l-.06-15.09h-4.89l-3.27 10.05-2.94-10.05h-5.19V26h3.03V14.72l3.27 11.28h2.91l3.66-11.28V26z"
  }));
});
;// CONCATENATED MODULE: ./src/components/logo/svg/logo-yandex_ru.svg
function logo_yandex_ru_extends() { logo_yandex_ru_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logo_yandex_ru_extends.apply(this, arguments); }

/* harmony default export */ const logo_yandex_ru = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", logo_yandex_ru_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M2 16C2 8.268 8.268 2 16 2s14 6.268 14 14-6.268 14-14 14S2 23.732 2 16z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M18.064 9.84h-1.416c-2.43 0-3.644 1.215-3.644 3.037 0 2.024.81 3.036 2.632 4.25l1.416 1.013-4.048 6.274H9.766l3.845-5.667c-2.226-1.62-3.44-3.036-3.44-5.668 0-3.238 2.226-5.465 6.477-5.465h4.25v16.8h-2.834V9.841z"
  }));
});
;// CONCATENATED MODULE: ./src/components/logo/logo.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const logo_module = ({"root":"logo-module__root--gDa5i","link":"logo-module__link--kjgEu","link-main":"logo-module__link-main--VTa_g","linkMain":"logo-module__link-main--VTa_g","link-praktikum":"logo-module__link-praktikum--Fwxj0","linkPraktikum":"logo-module__link-praktikum--Fwxj0","light":"logo-module__light--gzL1Q"});
;// CONCATENATED MODULE: ./src/components/logo/logo.component.tsx











var Theme = /* @__PURE__ */(Theme2 => {
  Theme2["Dark"] = "dark";
  Theme2["Light"] = "light";
  return Theme2;
})(Theme || {});
const Logo = _ref => {
  let {
    theme = "dark" /* Dark */
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: logo_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
      className: classnames_default()(logo_module.link, accessibility_module/* default */.Z.focusVisible),
      to: studentRoutePaths/* studentRoutePaths */.dR.INDEX,
      "aria-label": intl.formatMessage({
        id: "appPageHeader.myFlow"
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(logo_yandex_ru, {
        className: classnames_default()({
          [logo_module.light]: theme === "light" /* Light */
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(logo_practicum_ru, {
        className: classnames_default()({
          [logo_module.light]: theme === "light" /* Light */
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/page-header/tablet-desktop-header/tablet-desktop-header.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tablet_desktop_header_module = ({"root":"tablet-desktop-header-module__root--NC33g","logo-blocks":"tablet-desktop-header-module__logo-blocks--zJFCW","logoBlocks":"tablet-desktop-header-module__logo-blocks--zJFCW","middle-block":"tablet-desktop-header-module__middle-block--gWMDE","middleBlock":"tablet-desktop-header-module__middle-block--gWMDE","right-block":"tablet-desktop-header-module__right-block--gZMDW","rightBlock":"tablet-desktop-header-module__right-block--gZMDW","right-buttons":"tablet-desktop-header-module__right-buttons--O8Brk","rightButtons":"tablet-desktop-header-module__right-buttons--O8Brk","right-button":"tablet-desktop-header-module__right-button--oX88K","rightButton":"tablet-desktop-header-module__right-button--oX88K","avatar-wrapper":"tablet-desktop-header-module__avatar-wrapper--TEhqt","avatarWrapper":"tablet-desktop-header-module__avatar-wrapper--TEhqt","button-icon":"tablet-desktop-header-module__button-icon--_VBzA","buttonIcon":"tablet-desktop-header-module__button-icon--_VBzA","cross-button-wrapper":"tablet-desktop-header-module__cross-button-wrapper--_V7Vo","crossButtonWrapper":"tablet-desktop-header-module__cross-button-wrapper--_V7Vo","layout-fixed":"tablet-desktop-header-module__layout-fixed--VVoBS","layoutFixed":"tablet-desktop-header-module__layout-fixed--VVoBS","root-mobile":"tablet-desktop-header-module__root-mobile--dk6dF","rootMobile":"tablet-desktop-header-module__root-mobile--dk6dF","referral-program-button":"tablet-desktop-header-module__referral-program-button--sbact","referralProgramButton":"tablet-desktop-header-module__referral-program-button--sbact","tooltip-overlay-wrapper":"tablet-desktop-header-module__tooltip-overlay-wrapper--v74of","tooltipOverlayWrapper":"tablet-desktop-header-module__tooltip-overlay-wrapper--v74of","icon-wrapper":"tablet-desktop-header-module__icon-wrapper--gGcTw","iconWrapper":"tablet-desktop-header-module__icon-wrapper--gGcTw","tooltip-icons":"tablet-desktop-header-module__tooltip-icons--f2u5n","tooltipIcons":"tablet-desktop-header-module__tooltip-icons--f2u5n"});
;// CONCATENATED MODULE: ./src/components/page-header/tablet-desktop-header/tablet-desktop-header.tsx





























const TabletDesktopHeader = _ref => {
  let {
    children,
    hideCourseSelectButton,
    hideMenuButton,
    hideNotifierBell,
    isCourseSelectPage,
    leftSideBlock = types/* HeaderLefSideBlockContent */.c.Default,
    hideReferralProgramElements = true
  } = _ref;
  const userInfo = (0,useUser/* useUser */.aF)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    isTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const isNewbie = userInfo.data?.me?.user?.role === "newbie";
  const notifierTexts = (0,use_notifier_texts/* useIntlNotifierTexts */.s)();
  const {
    hasNewNotifierItems,
    notifierBellVisible,
    showNotifier
  } = (0,useBell/* useBell */.z)();
  const {
    getBellNotifications
  } = (0,useBellNotification/* useBellNotification */.C)();
  const [needToShowReferralTooltipNotification, setNeedToShowReferralTooltipNotification] = (0,react.useState)(false);
  const isCourseSelectButton = !isNewbie && !hideCourseSelectButton;
  const isMainMenuButton = !isNewbie && !hideMenuButton;
  const appBellReferralAnnouncementItem = getBellNotifications(item/* AppBellItemType */.M.Referral)[0];
  const announcementId = appBellReferralAnnouncementItem?.payload?.announcementId;
  (0,react.useEffect)(() => {
    if (!appBellReferralAnnouncementItem) {
      setNeedToShowReferralTooltipNotification(false);
      return;
    }
    setNeedToShowReferralTooltipNotification(!appBellReferralAnnouncementItem?.isRead);
  }, [appBellReferralAnnouncementItem]);
  const handleCloseReferralNotificationTooltip = () => {
    appBellReferralAnnouncementItem?.markAsRead();
  };
  const openMainPage = () => {
    if (get_url_search_params.getUrlSearchParams.retPath.haveRetPath(history)) {
      get_url_search_params.getUrlSearchParams.retPath.goToRetPath(history);
      return;
    }
    history.push(baseRoutePaths/* baseRoutePaths */.lQ.INDEX);
  };
  const handleKeyDown = event => {
    if (event.key === "Enter" || event.key === " ") {
      openMainPage();
    }
  };
  const openReferralProgramPage = () => {
    handleCloseReferralNotificationTooltip();
    history.push(studentRoutePaths/* studentRoutePaths */.dR.REFERRAL_PROGRAM);
  };
  const renderLeftSideBlock = () => {
    switch (leftSideBlock) {
      case types/* HeaderLefSideBlockContent */.c.CrossIcon:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            role: "button",
            tabIndex: 0,
            className: tablet_desktop_header_module.crossButtonWrapper,
            onClick: openMainPage,
            onKeyDown: handleKeyDown,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
              appearance: "default",
              size: "medium",
              iconName: "cross"
            })
          });
        }
      case types/* HeaderLefSideBlockContent */.c.Default:
        {
          if (isTablet && children) {
            return null;
          }
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: tablet_desktop_header_module.logoBlocks,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(Logo, {})
          });
        }
      case types/* HeaderLefSideBlockContent */.c.None:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {});
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(leftSideBlock);
    }
  };
  const tooltipOverlay = Boolean(announcementId) && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: tablet_desktop_header_module.tooltipOverlayWrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: tablet_desktop_header_module.tooltipIcons,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: tablet_desktop_header_module.iconWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "lamp",
          size: "large"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "floating",
        size: "small",
        iconName: "cross",
        onClick: handleCloseReferralNotificationTooltip
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.caption,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: `referralProgram.${announcementId}`
      })
    })]
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: tablet_desktop_header_module.root,
    children: [renderLeftSideBlock(), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: tablet_desktop_header_module.middleBlock,
      children
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: tablet_desktop_header_module.rightBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: tablet_desktop_header_module.rightButtons,
        children: [!hideReferralProgramElements && /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
          overlay: tooltipOverlay,
          visible: needToShowReferralTooltipNotification,
          placement: "bottom",
          overlayInnerStyle: {
            width: "680px"
          },
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "secondary",
            size: "small",
            onClick: openReferralProgramPage,
            className: tablet_desktop_header_module.referralProgramButton,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "menuModal.referral.text"
            })
          })
        }), !hideNotifierBell && notifierBellVisible && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: tablet_desktop_header_module.rightButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierBell, {
            textConstants: notifierTexts.bell,
            hasNew: hasNewNotifierItems,
            onClick: showNotifier
          })
        }), isCourseSelectButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: tablet_desktop_header_module.rightButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(CourseSelectButton, {
            isCourseSelectPage
          })
        }), isMainMenuButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: tablet_desktop_header_module.rightButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(MainMenuButton, {})
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: tablet_desktop_header_module.avatarWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(header_avatar_HeaderAvatar, {})
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/page-header/page-header.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const page_header_module = ({"spacer":"page-header-module__spacer--WZV8H","root":"page-header-module__root--KtdFx","mobile-header":"page-header-module__mobile-header--cw5Ee","mobileHeader":"page-header-module__mobile-header--cw5Ee","desktop-header":"page-header-module__desktop-header--EAHWL","desktopHeader":"page-header-module__desktop-header--EAHWL"});
;// CONCATENATED MODULE: ./src/components/page-header/page-header.tsx










const PageHeader = _ref => {
  let {
    children,
    hideNavigation,
    hideCourseSelectButton,
    hideMenuButton,
    hideNotifierBell,
    hideReferralProgramElements,
    isCourseSelectPage,
    leftSideBlock = types/* HeaderLefSideBlockContent */.c.Default
  } = _ref;
  const {
    productMainType
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const {
    isDesktop,
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const shouldShowNavigation = isDesktop && !hideNavigation && productMainType === experimentDi/* ProductMainType */.SH.General;
  if (isMobile) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("nav", {
        className: page_header_module.root,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: page_header_module.mobileHeader,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(MobileHeader, {
            leftSideBlock,
            hideCourseSelectButton,
            hideMenuButton,
            hideNotifierBell,
            isCourseSelectPage,
            hideReferralProgramElements,
            children
          })
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: page_header_module.spacer
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("nav", {
      className: page_header_module.root,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: page_header_module.desktopHeader,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TabletDesktopHeader, {
          leftSideBlock,
          hideCourseSelectButton,
          hideMenuButton,
          hideNotifierBell,
          hideReferralProgramElements,
          isCourseSelectPage,
          children: children ?? (shouldShowNavigation && /* @__PURE__ */(0,jsx_runtime.jsx)(Navigation, {}))
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: page_header_module.spacer
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/page-header/index.ts




/***/ }),

/***/ 25269:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ HeaderLefSideBlockContent)
/* harmony export */ });


var HeaderLefSideBlockContent = /* @__PURE__ */(HeaderLefSideBlockContent2 => {
  HeaderLefSideBlockContent2["CrossIcon"] = "crossIcon";
  HeaderLefSideBlockContent2["Default"] = "default";
  HeaderLefSideBlockContent2["None"] = "none";
  return HeaderLefSideBlockContent2;
})(HeaderLefSideBlockContent || {});

/***/ }),

/***/ 37042:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  V: () => (/* binding */ PromoCodePopup)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/domain/domain.ts
var domain = __webpack_require__(72765);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
;// CONCATENATED MODULE: ../ui-kit/src/block-container-modal/block-container-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const block_container_modal_module = ({"root":"block-container-modal-module__root--j5SZm"});
;// CONCATENATED MODULE: ../ui-kit/src/block-container-modal/block-container-modal.component.tsx




const BlockContainerModal = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: block_container_modal_module.root,
    children
  });
};
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/input-depricated/input-depricated.component.tsx + 1 modules
var input_depricated_component = __webpack_require__(54157);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ./src/api/student/student.api.ts + 4 modules
var student_api = __webpack_require__(91514);
// EXTERNAL MODULE: ./src/api/student/student.model.ts
var student_model = __webpack_require__(85715);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
;// CONCATENATED MODULE: ./src/components/bottom-aligned-popup/bottom-aligned-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const bottom_aligned_popup_module = ({"main":"bottom-aligned-popup-module__main--kmaCa","popup":"bottom-aligned-popup-module__popup--zZOdg"});
;// CONCATENATED MODULE: ./src/components/bottom-aligned-popup/bottom-aligned-popup.component.tsx








const BottomAlignedPopup = _ref => {
  let {
    onClose,
    children
  } = _ref;
  const popupRef = (0,react.useRef)(null);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(popupRef, onClose);
  (0,useKeyPress/* useKeyPress */.K)("Escape", onClose);
  (0,use_block_main_scroll/* useBlockMainScroll */.K)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: bottom_aligned_popup_module.main,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: bottom_aligned_popup_module.popup,
      ref: popupRef,
      children
    })
  });
};
;// CONCATENATED MODULE: ./src/components/promo-code-popup/promo-code-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const promo_code_popup_module = ({"back-button":"promo-code-popup-module__back-button--EuTf8","backButton":"promo-code-popup-module__back-button--EuTf8","header":"promo-code-popup-module__header--L_MHt","code-description":"promo-code-popup-module__code-description--r3ZbH","codeDescription":"promo-code-popup-module__code-description--r3ZbH","input-label":"promo-code-popup-module__input-label--V7u4e","inputLabel":"promo-code-popup-module__input-label--V7u4e","input-wrapper":"promo-code-popup-module__input-wrapper--x0Lzf","inputWrapper":"promo-code-popup-module__input-wrapper--x0Lzf","error-message":"promo-code-popup-module__error-message--uf3mI","errorMessage":"promo-code-popup-module__error-message--uf3mI","content-panel":"promo-code-popup-module__content-panel--CfZGG","contentPanel":"promo-code-popup-module__content-panel--CfZGG","bottom-panel":"promo-code-popup-module__bottom-panel--FfKn8","bottomPanel":"promo-code-popup-module__bottom-panel--FfKn8","bottom-panel-content":"promo-code-popup-module__bottom-panel-content--jx2M3","bottomPanelContent":"promo-code-popup-module__bottom-panel-content--jx2M3"});
;// CONCATENATED MODULE: ./src/components/promo-code-popup/promo-code-popup.component.tsx























const promoCodeErrorMessageIdMap = {
  [student_model/* ApplyPromoCodeError */.Hi.PromoCodeAlreadyUsed]: "promoCodePopup.promocodeAlreadyUsed",
  [student_model/* ApplyPromoCodeError */.Hi.UnknownPromoCode]: "promoCodePopup.promocodeIsIncorrect",
  [student_model/* ApplyPromoCodeError */.Hi.PromoCodeNotSuitableForRestrictions]: "promoCodePopup.promocodeUnsuitable",
  [student_model/* ApplyPromoCodeError */.Hi.RegionDoesntMatch]: "promoCodePopup.regionDoesntMatch",
  [student_model/* ApplyPromoCodeError */.Hi.PromocodeExpired]: "promoCodePopup.promocodeExpired",
  [api_model/* unexpectedError */.g]: "promoCodePopup.promocodeSendError"
};
const giftErrorMessageIdMap = {
  [student_model/* ApplyGiftError */.U6.GiftPromoCodeApplyingError]: "promoCodePopup.giftApplyError",
  [api_model/* unexpectedError */.g]: "promoCodePopup.promocodeSendError"
};
var FormStateType = /* @__PURE__ */(FormStateType2 => {
  FormStateType2[FormStateType2["Initial"] = 0] = "Initial";
  FormStateType2[FormStateType2["Error"] = 1] = "Error";
  FormStateType2[FormStateType2["Success"] = 2] = "Success";
  return FormStateType2;
})(FormStateType || {});
const PromoCodePopup = _ref => {
  let {
    backPath,
    customSuccessButtonTextId,
    customHeaderId
  } = _ref;
  const user = (0,useUser/* useUser */.aF)();
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const isVisible = get_url_search_params.getUrlSearchParams.promocodePopup.isOpen(history);
  const [requestInProgress, setRequestInProgress] = (0,react.useState)(false);
  const [state, setState] = (0,react.useState)(null);
  const needReloadUserInfoBeforeExit = (0,react.useRef)(false);
  const [code, setCode] = (0,react.useState)("");
  const handleClose = (0,react.useCallback)(() => {
    if (state?.type === 2 /* Success */) {
      void user.functions?.reloadMe();
    }
    history.push(backPath);
  }, [backPath, history, state?.type, user.functions]);
  (0,react.useEffect)(() => () => {
    if (needReloadUserInfoBeforeExit.current) {
      void user.functions?.reloadMe();
    }
  }, [user.functions]);
  const handleChangeCode = value => {
    setCode(value);
    setState(null);
  };
  const handleActivatePromoCode = (0,react.useCallback)(async () => {
    setRequestInProgress(true);
    if (code.indexOf("gift_") === 0) {
      const giftResult = await (0,student_api/* applyGift */.mL)(code);
      if ((0,Either.isRight)(giftResult)) {
        needReloadUserInfoBeforeExit.current = true;
        setState({
          type: 2 /* Success */,
          text: intl.formatMessage({
            id: "promoCodePopup.giftApplySuccess"
          })
        });
      } else {
        const id = giftErrorMessageIdMap[giftResult.left] ?? null;
        setState({
          type: 1 /* Error */,
          text: id === null ? "" : intl.formatMessage({
            id
          })
        });
      }
    } else {
      const promoCodeResult = await (0,student_api/* applyPromoCode */.gs)(code, (0,domain/* isKzDomain */.k)() ? "KZ" : "RU");
      if ((0,Either.isRight)(promoCodeResult)) {
        needReloadUserInfoBeforeExit.current = true;
        const promoCodeData = promoCodeResult.right;
        switch (promoCodeData.type) {
          case student_model/* ApplyPromoCodeType */.gv.Absolute:
            setState({
              type: 2 /* Success */,
              text: intl.formatMessage({
                id: "promoCodePopup.successAbsoluteMessage"
              }, {
                price: promoCodeData.price
              })
            });
            break;
          case student_model/* ApplyPromoCodeType */.gv.Percent:
            setState({
              type: 2 /* Success */,
              text: promoCodeData.discountPercent > 0 ? intl.formatMessage({
                id: "promoCodePopup.successPercentMessage"
              }, {
                percent: promoCodeData.discountPercent
              }) : ""
            });
            break;
          default:
            break;
        }
      } else {
        const id = promoCodeErrorMessageIdMap[promoCodeResult.left] ?? null;
        setState({
          type: 1 /* Error */,
          text: id === null ? "" : intl.formatMessage({
            id
          })
        });
      }
    }
    setRequestInProgress(false);
  }, [code, intl]);
  const handleFormSubmitted = (0,react.useCallback)(async event => {
    event.preventDefault();
    await handleActivatePromoCode();
  }, [handleActivatePromoCode]);
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(BottomAlignedPopup, {
    onClose: handleClose,
    children: [(state === null || state.type === 1 /* Error */) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: promo_code_popup_module.backButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "default",
        size: "medium",
        iconName: "arrow-left",
        onClick: handleClose
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: promo_code_popup_module.contentPanel,
      children: state === null || state.type === 1 /* Error */ ? /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainerModal, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          className: classnames_default()(promo_code_popup_module.header, typography_module/* default */.Z.headline3),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: customHeaderId ? customHeaderId : "promoCodePopup.headerActivate"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(promo_code_popup_module.inputLabel, typography_module/* default */.Z.caption),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "promoCodePopup.promocodeInputLabel"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("form", {
          className: promo_code_popup_module.inputWrapper,
          onSubmit: handleFormSubmitted,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
            autoFocus: true,
            size: input_depricated_component/* InputSize */.fz.Small,
            value: code,
            onChange: handleChangeCode
          }), requestInProgress && /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {
            marginTop: 40
          })]
        }), state !== null && state.type === 1 /* Error */ && !requestInProgress && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(promo_code_popup_module.errorMessage, typography_module/* default */.Z.caption),
          children: state.text
        })]
      }) : /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainerModal, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          className: classnames_default()(promo_code_popup_module.header, typography_module/* default */.Z.headline3),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "promoCodePopup.headerActivated"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()(promo_code_popup_module.codeDescription, typography_module/* default */.Z.headline4),
          children: state.text
        })]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: promo_code_popup_module.bottomPanel,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(BlockContainerModal, {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: promo_code_popup_module.bottomPanelContent,
          children: state === null || state.type === 1 /* Error */ ? /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "primary",
            disabled: code === "" || requestInProgress,
            onClick: handleActivatePromoCode,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "promoCodePopup.activate"
            })
          }) : /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "primary",
            onClick: handleClose,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: customSuccessButtonTextId ? customSuccessButtonTextId : "promoCodePopup.buy"
            })
          })
        })
      })
    })]
  });
};

/***/ }),

/***/ 9266:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ useSelectionStore)
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9367);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47832);




const initialState = {
  selection: null,
  context: null,
  selectionStartIndex: null,
  isTooltipVisible: false
};
const useSelectionStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .U)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .devtools */ .mW)(set => ({
  ...initialState,
  setSelection: selection => set(state => {
    if (state.isTooltipVisible) {
      return {};
    }
    return {
      selection
    };
  }, void 0, "setSelection"),
  setContext: (context, force) => set(state => {
    if (state.isTooltipVisible && !force) {
      return {};
    }
    return {
      context
    };
  }, void 0, "setContext"),
  setSelectionStartIndex: (selectionStartIndex, force) => set(state => {
    if (state.isTooltipVisible && !force) {
      return {};
    }
    return {
      selectionStartIndex
    };
  }, void 0, "setSelectionStartIndex"),
  resetSelection: () => set(() => ({
    selection: null,
    selectionStartIndex: null,
    context: null
  }), void 0, "resetSelection"),
  setIsTooltipVisible: isTooltipVisible => set(() => ({
    isTooltipVisible
  }), void 0, "setIsTooltipVisible")
}), {
  store: "selectionStore"
}));

/***/ }),

/***/ 63469:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Q: () => (/* binding */ SkipMechanicButton)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/tooltip-simple/tooltip-simple.tsx + 1 modules
var tooltip_simple = __webpack_require__(45451);
;// CONCATENATED MODULE: ./src/components/skip-mechanic-button/skip-mechanic-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const skip_mechanic_button_module = ({"tooltip":"skip-mechanic-button-module__tooltip--r5EzT","tooltipWrapper":"skip-mechanic-button-module__tooltipWrapper--zYK7T","root":"skip-mechanic-button-module__root--pZwwZ"});
;// CONCATENATED MODULE: ./src/components/skip-mechanic-button/skip-mechanic-button.component.tsx











const LOCAL_STORAGE_SKIP_MECHANIC_BUTTON_TOOLTIP = "flow:skipMechanicButtonTooltip";
const SkipMechanicButton = _ref => {
  let {
    onSkip,
    enableKeyHandler
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const isTooltipWasShown = (0,react.useMemo)(() => localStorage.getItem(LOCAL_STORAGE_SKIP_MECHANIC_BUTTON_TOOLTIP) === "shown", []);
  const {
    ref: observableContainerRef,
    inView
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 1,
    skip: isTooltipWasShown
  });
  const [isVisibleTooltip, setIsVisibleTooltip] = (0,react.useState)(false);
  const buttonRef = (0,react.useRef)(null);
  const onKeyPress = (0,react.useCallback)(() => {
    if (enableKeyHandler) {
      onSkip();
    }
  }, [enableKeyHandler, onSkip]);
  const hideTooltip = (0,react.useCallback)(() => {
    setIsVisibleTooltip(false);
    localStorage.setItem(LOCAL_STORAGE_SKIP_MECHANIC_BUTTON_TOOLTIP, "shown");
  }, []);
  const handleClick = (0,react.useCallback)(() => {
    enableKeyHandler && hideTooltip();
    onSkip();
  }, [enableKeyHandler, onSkip, hideTooltip]);
  const handleOnScreen = (0,react.useCallback)(() => {
    if (!isTooltipWasShown) {
      setIsVisibleTooltip(true);
    }
  }, [isTooltipWasShown]);
  (0,react.useEffect)(() => {
    inView && handleOnScreen();
  }, [handleOnScreen, inView]);
  (0,useKeyPress/* useKeyPress */.K)(["Escape"], onKeyPress);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(buttonRef, hideTooltip);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: observableContainerRef,
    children: [isVisibleTooltip && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: skip_mechanic_button_module.tooltipWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_simple/* TooltipSimple */.w, {
        className: skip_mechanic_button_module.tooltip,
        targetRef: buttonRef,
        children: intl.formatMessage({
          id: "skipButton.tooltipOverlay"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: buttonRef,
      className: skip_mechanic_button_module.root,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "secondaryFloating",
        size: "medium",
        onClick: handleClick,
        "aria-label": intl.formatMessage({
          id: "skipButton.ariaLabel"
        }),
        children: intl.formatMessage({
          id: "skipButton.label"
        })
      })
    })]
  });
};

/***/ }),

/***/ 2280:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  x: () => (/* binding */ SubmitMechanicButton)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
;// CONCATENATED MODULE: ./src/components/submit-mechanic-button/submit-mechanic-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const submit_mechanic_button_module = ({"root":"submit-mechanic-button-module__root--u2uYm"});
;// CONCATENATED MODULE: ./src/components/submit-mechanic-button/submit-mechanic-button.component.tsx








const SubmitMechanicButton = _ref => {
  let {
    onSubmit,
    enableKeyHandler
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const onKeySubmit = (0,react.useCallback)(() => {
    if (enableKeyHandler) {
      onSubmit();
    }
  }, [enableKeyHandler, onSubmit]);
  (0,useKeyPress/* useKeyPress */.K)(["Enter", "Space"], onKeySubmit);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: submit_mechanic_button_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "primary",
      size: "medium",
      "aria-label": intl.formatMessage({
        id: "submitButton.ariaLabel"
      }),
      onClick: onSubmit,
      children: intl.formatMessage({
        id: "submitButton.label"
      })
    })
  });
};

/***/ }),

/***/ 84747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  x: () => (/* binding */ TrainerLayout)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-translation-v2-enabled.ts
var use_translation_v2_enabled = __webpack_require__(3832);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/utils/storage/index.ts + 4 modules
var storage = __webpack_require__(81597);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/hooks.ts
var hooks = __webpack_require__(62436);
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/translation-tooltip-v2.tsx + 17 modules
var translation_tooltip_v2 = __webpack_require__(66553);
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/types.ts
var types = __webpack_require__(1692);
;// CONCATENATED MODULE: ./src/components/selection-translation/constants.ts


const WRONG_SELECTION_SYMBOLS = ["", " "];
const CLASS_TASK_GUIDE_WIDTH_IN_PX = 469;
// EXTERNAL MODULE: ./src/components/selection-translation/store/store.ts
var store = __webpack_require__(9266);
;// CONCATENATED MODULE: ./src/components/selection-translation/types.ts


var TooltipType = /* @__PURE__ */(TooltipType2 => {
  TooltipType2["Buttons"] = "buttons";
  TooltipType2["Translation"] = "translation";
  return TooltipType2;
})(TooltipType || {});
// EXTERNAL MODULE: ../shared/src/routes/constants.ts
var constants = __webpack_require__(85087);
;// CONCATENATED MODULE: ./src/components/selection-translation/utils.ts



const getSentenceElement = node => {
  let current = node;
  while (current) {
    if (current.parentElement?.dataset.translation === "sentence") {
      return current.parentElement;
    }
    current = current.parentNode;
  }
  return null;
};
const getWordElement = node => {
  let current = node;
  while (current && (current.nodeName === "#text" || current.nodeName === "SPAN")) {
    if (current.parentElement?.dataset.translation === "word") {
      return current.parentElement;
    }
    current = current.parentNode;
  }
  return null;
};
const getTextElement = node => node.nodeName === "#text" ? node : null;
const getInsideNode = node => {
  let current = node;
  while (current && current.firstChild) {
    current = current.firstChild;
  }
  return current;
};
const isSpeakingPage = pathname => pathname.startsWith(`${constants/* TEACHER_PREFIX */.o}/speaking/`) || pathname.startsWith(`${constants/* TEACHER_PREFIX */.o}/mentor-speaking/`);
;// CONCATENATED MODULE: ./src/components/selection-translation/use-selection.ts






const useSelection = () => {
  const {
    setSelection
  } = (0,store/* useSelectionStore */.f)();
  const [position, setPosition] = (0,react.useState)({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  });
  const sentenceRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    const selectionHandler = () => {
      const activeSelection = document.getSelection();
      const range = activeSelection?.rangeCount && activeSelection?.getRangeAt(0);
      if (!activeSelection || !range) {
        return;
      }
      const {
        commonAncestorContainer: ancestor,
        startContainer,
        endContainer,
        startOffset,
        endOffset
      } = range;
      if (range.collapsed) {
        return;
      }
      const sentenceEl = getSentenceElement(ancestor);
      sentenceRef.current = sentenceEl;
      const context = sentenceEl?.textContent;
      if (!sentenceEl || !context) {
        return;
      }
      let startNode = startContainer;
      if (WRONG_SELECTION_SYMBOLS.includes(startNode.textContent ?? "") && startNode.nextSibling) {
        startNode = getInsideNode(startNode.nextSibling);
      }
      const startWordEl = getWordElement(startNode);
      const endWordEl = getTextElement(endContainer);
      if (!startWordEl || !endWordEl) {
        return;
      }
      range.setStartBefore(startWordEl);
      range.setEndAfter(endWordEl);
      const selectionText = range.toString();
      setSelection(selectionText);
      const rect = range.getBoundingClientRect();
      setPosition({
        x: rect.left,
        y: rect.top + window.scrollY,
        width: rect.width,
        height: rect.height
      });
    };
    document.addEventListener("mouseup", selectionHandler);
    document.addEventListener("keyup", selectionHandler);
    return () => {
      document.removeEventListener("mouseup", selectionHandler);
      document.removeEventListener("keyup", selectionHandler);
    };
  }, [setSelection]);
  return {
    position
  };
};
;// CONCATENATED MODULE: ./src/components/selection-translation/selection-translation.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const selection_translation_module = ({"tooltip-overlay":"selection-translation-module__tooltip-overlay--Sfkc_","tooltipOverlay":"selection-translation-module__tooltip-overlay--Sfkc_"});
;// CONCATENATED MODULE: ./src/components/selection-translation/selection-translation.tsx



















const SelectionTranslation = () => {
  const location = (0,react_router/* useLocation */.TH)();
  const {
    selection,
    resetSelection
  } = (0,store/* useSelectionStore */.f)();
  const {
    position
  } = useSelection();
  const [tooltipType, setTooltipType] = (0,react.useState)(null);
  (0,react.useEffect)(() => () => resetSelection(), [resetSelection]);
  const wordRef = (0,react.useRef)(null);
  const containerRef = (0,react.useRef)(null);
  const buttonsTooltipContentRef = (0,react.useRef)(null);
  const isMoreThanOneWordSelected = selection && selection.split(" ").length > 1;
  const {
    play
  } = (0,hooks/* usePlayTextToSpeech */.l)(selection, {
    enablePlayOnMount: false
  });
  (0,react.useEffect)(() => {
    if (!selection) {
      return;
    }
    if (isMoreThanOneWordSelected) {
      setTooltipType(TooltipType.Buttons);
    } else {
      resetSelection();
    }
  }, [isMoreThanOneWordSelected, resetSelection, selection]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(buttonsTooltipContentRef, () => {
    resetSelection();
    setTooltipType(null);
  }, {
    condition: tooltipType === TooltipType.Buttons
  });
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(wordRef, () => {
    resetSelection();
    setTooltipType(null);
  }, {
    condition: tooltipType === TooltipType.Translation
  });
  const handleSpeakerButtonClick = () => {
    if (!selection) {
      return;
    }
    void play(selection);
  };
  const handleTranslateButtonClick = () => {
    setTooltipType(TooltipType.Translation);
  };
  const isTaskGuideVisible = storage/* localStorageWrapper */.Y6.taskGuide.isVisible();
  const xPositionCorrection = isTaskGuideVisible && isSpeakingPage(location.pathname) ? CLASS_TASK_GUIDE_WIDTH_IN_PX : 0;
  const buttonsTooltipContent = /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    id: "buttons-tooltip-content",
    ref: buttonsTooltipContentRef,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      size: "small-circle",
      appearance: "tertiaryOnBlack",
      onClick: handleSpeakerButtonClick,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "speaker",
        size: "small"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      size: "small-circle",
      appearance: "tertiaryOnBlack",
      onClick: handleTranslateButtonClick,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "translate",
        size: "small"
      })
    })]
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    visible: tooltipType === TooltipType.Buttons,
    overlay: buttonsTooltipContent,
    showArrow: false,
    smallOverlay: true,
    placement: "topRight",
    overlayInnerStyle: {
      borderRadius: "20px",
      padding: "4px"
    },
    tooltipOverlayClassName: selection_translation_module.tooltipOverlay,
    align: {
      offset: [0, 6]
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: wordRef,
      style: {
        position: "absolute",
        top: position.y,
        left: position.x - xPositionCorrection,
        background: "transparent",
        width: position.width,
        height: position.height
      },
      children: tooltipType === TooltipType.Translation && /* @__PURE__ */(0,jsx_runtime.jsx)(translation_tooltip_v2/* TranslationTooltipV2 */.Q, {
        type: types/* TranslationType */.r.Highlight,
        wordRef,
        containerRef,
        selection: selection || ""
      })
    })
  });
};
SelectionTranslation.displayName = "SelectionTranslation";
;// CONCATENATED MODULE: ./src/components/trainer-layout/trainer-layout.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const trainer_layout_module = ({"root":"trainer-layout-module__root--ylfVN","tooltip-selection":"trainer-layout-module__tooltip-selection--K5cl2","tooltipSelection":"trainer-layout-module__tooltip-selection--K5cl2","one-element-per-screen":"trainer-layout-module__one-element-per-screen--k4P1g","oneElementPerScreen":"trainer-layout-module__one-element-per-screen--k4P1g","main-root":"trainer-layout-module__main-root--UmOSk","mainRoot":"trainer-layout-module__main-root--UmOSk"});
;// CONCATENATED MODULE: ./src/components/trainer-layout/trainer-layout.component.tsx









const TrainerLayout = _ref => {
  let {
    oneElementPerScreen = false,
    children
  } = _ref;
  const {
    selection
  } = (0,store/* useSelectionStore */.f)();
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  (0,react.useEffect)(() => {
    const root = window.document.getElementById("root");
    root?.classList.add(trainer_layout_module.mainRoot);
    return () => {
      root?.classList.remove(trainer_layout_module.mainRoot);
    };
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(trainer_layout_module.root, {
      [trainer_layout_module.oneElementPerScreen]: oneElementPerScreen,
      [trainer_layout_module.tooltipSelection]: Boolean(selection)
    }),
    children: [isTranslationV2Enabled && /* @__PURE__ */(0,jsx_runtime.jsx)(SelectionTranslation, {}), children]
  });
};

/***/ }),

/***/ 67059:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ MechanicBlockAlign)
/* harmony export */ });


var MechanicBlockAlign = /* @__PURE__ */(MechanicBlockAlign2 => {
  MechanicBlockAlign2["Center"] = "center";
  MechanicBlockAlign2["Stretch"] = "stretch";
  return MechanicBlockAlign2;
})(MechanicBlockAlign || {});

/***/ }),

/***/ 74600:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  g: () => (/* binding */ BlocksRender)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../shared/src/event-emitter.ts
var event_emitter = __webpack_require__(1341);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/index.ts + 5 modules
var useAudio = __webpack_require__(12745);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
;// CONCATENATED MODULE: ../shared/src/utils/useLoader.ts



function useLoader(loading) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let minDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  const [value, setValue] = (0,react.useState)(false);
  const timer1 = (0,react.useRef)(null);
  const timer2 = (0,react.useRef)(null);
  const _value = (0,react.useRef)(false);
  (0,react.useEffect)(() => {
    _value.current = loading;
    if (loading) {
      timer1.current = setTimeout(() => {
        setValue(true);
        timer2.current = setTimeout(() => {
          !_value.current && setValue(false);
          timer2.current = null;
        }, minDuration);
      }, delay);
    } else {
      timer1.current && clearTimeout(timer1.current);
      !timer2.current && setValue(false);
    }
  }, [delay, loading, minDuration]);
  return value;
}
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide-provider.tsx
var task_guide_provider = __webpack_require__(59206);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/use-audio-control.ts
var use_audio_control = __webpack_require__(25834);
// EXTERNAL MODULE: ../shared/src/utils/is-safari.ts
var is_safari = __webpack_require__(66415);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/play-pause-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const play_pause_button_module = ({"container":"play-pause-button-module__container--PGqMI","lock":"play-pause-button-module__lock--Xa3Ug"});
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/play-pause-button.component.tsx










const PlayPauseButton = _ref => {
  let {
    paused,
    loading,
    canPause,
    canPlay,
    onClick
  } = _ref;
  const {
    formatMessage
  } = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [tooltipVisible, setTooltipVisible] = (0,react.useState)(false);
  const pauseDisabled = !paused && !canPause;
  const playDisabled = paused && !canPlay;
  const disabled = pauseDisabled || playDisabled;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    visible: disabled && tooltipVisible,
    onVisibleChange: setTooltipVisible,
    placement: isMobile ? "top" : "topRight",
    overlay: formatMessage({
      id: "audioBar.audioControlledByTutor"
    }),
    trigger: ["hover", "click"],
    autoWidth: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: play_pause_button_module.container,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        size: "medium",
        loading,
        disabled: loading || disabled,
        appearance: "primary",
        iconName: paused ? "play" : "pause",
        onClick
      }), disabled && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        size: "medium",
        name: "lock-filled",
        className: play_pause_button_module.lock
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/react-slider/dist/es/prod/components/ReactSlider/ReactSlider.mjs
var ReactSlider = __webpack_require__(96346);
;// CONCATENATED MODULE: ../ui-kit/src/slider/slider.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const slider_module = ({"track":"slider-module__track--I_aae","thumb":"slider-module__thumb--BcQgm","root-disabled":"slider-module__root-disabled--jCYTF","rootDisabled":"slider-module__root-disabled--jCYTF","root":"slider-module__root--hTE4Y"});
;// CONCATENATED MODULE: ../ui-kit/src/slider/slider.component.tsx






const Slider = _ref => {
  let {
    disabled,
    ...props
  } = _ref;
  const propsWithStyles = {
    className: classnames_default()(slider_module.root, {
      [slider_module.rootDisabled]: disabled
    }),
    trackClassName: slider_module.track,
    thumbClassName: slider_module.thumb,
    ...props
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ReactSlider/* default */.Z, {
    ...propsWithStyles
  });
};
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/volume-bar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const volume_bar_module = ({"volume-container":"volume-bar-module__volume-container--vuEI1","volumeContainer":"volume-bar-module__volume-container--vuEI1","volume-slider":"volume-bar-module__volume-slider--Togdy","volumeSlider":"volume-bar-module__volume-slider--Togdy"});
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/volume-bar.component.tsx







const VOLUME_MULTIPLIER = 100;
const VolumeBar = _ref => {
  let {
    volume,
    muted,
    muteAudio,
    unmuteAudio,
    onVolumeChange
  } = _ref;
  const handleVolumeChange = (0,react.useCallback)(value => {
    onVolumeChange(value / VOLUME_MULTIPLIER);
  }, [onVolumeChange]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: volume_bar_module.volumeContainer,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      size: "medium",
      appearance: "default",
      iconName: muted ? "speaker-off" : "speaker",
      onClick: muted ? unmuteAudio : muteAudio
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: volume_bar_module.volumeSlider,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Slider, {
        value: muted ? 0 : volume * VOLUME_MULTIPLIER,
        max: VOLUME_MULTIPLIER,
        onChange: handleVolumeChange
      })
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/progress-slider.component.tsx





const TIME_MULTIPLIER = 100;
const ProgressSlider = _ref => {
  let {
    disabled,
    currentTime,
    duration,
    setCurrentTime,
    onProgressChange
  } = _ref;
  const handleClick = (0,react.useCallback)(value => {
    setCurrentTime(value / TIME_MULTIPLIER);
    onProgressChange(value / TIME_MULTIPLIER);
  }, [onProgressChange, setCurrentTime]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Slider, {
    disabled,
    value: (currentTime ?? 0) * TIME_MULTIPLIER,
    max: (duration ?? 100) * TIME_MULTIPLIER,
    onAfterChange: handleClick
  });
};
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/use-audio-progress.ts




function useAudioProgress() {
  const [playing, setPlaying] = (0,react.useState)(false);
  const [duration, setDuration] = (0,react.useState)(null);
  const [currentTime, setCurrentTime] = (0,react.useState)(null);
  const currentAudio = (0,useAudio/* useCurrentAudio */.sJ)();
  const setCurrentAudioTime = (0,react.useCallback)(() => {
    setCurrentTime(currentAudio && !isNaN(currentAudio.currentTime) ? currentAudio.currentTime : 0);
  }, [currentAudio]);
  const setCurrentAudioDuration = (0,react.useCallback)(() => {
    setDuration(currentAudio && !isNaN(currentAudio.duration) ? currentAudio.duration : null);
  }, [currentAudio]);
  const onAudioEnd = (0,react.useCallback)(() => {
    setCurrentTime(currentAudio?.duration ?? null);
    setPlaying(false);
  }, [currentAudio]);
  (0,useAudio/* useCurrentAudioEvents */.gc)((0,react.useMemo)(() => ({
    onPlay: () => setPlaying(true),
    onPause: () => setPlaying(false),
    onEnd: onAudioEnd
  }), [onAudioEnd]));
  (0,react.useEffect)(() => {
    setCurrentAudioTime();
    setCurrentAudioDuration();
    setPlaying(currentAudio?.playing ?? false);
  }, [currentAudio, currentAudio?.duration, setCurrentAudioTime, setCurrentAudioDuration]);
  (0,react.useEffect)(() => {
    let intervalId;
    if (currentAudio && playing) {
      intervalId = window.setInterval(() => {
        if (currentAudio?.playing) {
          setCurrentAudioTime();
        }
      }, 10);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [currentAudio, playing, setCurrentAudioTime]);
  return {
    currentTime,
    duration,
    setCurrentTime,
    setDuration
  };
}
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
;// CONCATENATED MODULE: ./src/components/audio-footer/shared/utils.ts



const utils_TIME_MULTIPLIER = 100;
var AudioSpeed = /* @__PURE__ */(AudioSpeed2 => {
  AudioSpeed2["speed075"] = "speed075";
  AudioSpeed2["speed1"] = "speed1";
  AudioSpeed2["speed125"] = "speed125";
  return AudioSpeed2;
})(AudioSpeed || {});
const SpeedIconMap = {
  speed075: "speed-0.75x",
  speed1: "speed-1x",
  speed125: "speed-1.25x"
};
function mapAudioSpeed(value) {
  switch (value) {
    case "speed075" /* speed075 */:
      return 0.75;
    case "speed1" /* speed1 */:
      return 1;
    case "speed125" /* speed125 */:
      return 1.25;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(value);
  }
}
function mapPlaybackRate(value) {
  if (value < 1) {
    return "speed075" /* speed075 */;
  }
  if (value > 1) {
    return "speed125" /* speed125 */;
  }
  return "speed1" /* speed1 */;
}
function formatTime() {
  let dirtyTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const time = isNaN(dirtyTime) ? 0 : dirtyTime;
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
}
;// CONCATENATED MODULE: ./src/components/audio-footer/desktop/audio-footer-desktop.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_footer_desktop_module = ({"footer":"audio-footer-desktop-module__footer--ClRUT","safari":"audio-footer-desktop-module__safari--WXF7X","controls-block":"audio-footer-desktop-module__controls-block--ZuhVV","controlsBlock":"audio-footer-desktop-module__controls-block--ZuhVV","progress-container":"audio-footer-desktop-module__progress-container--MakJf","progressContainer":"audio-footer-desktop-module__progress-container--MakJf","duration-grey":"audio-footer-desktop-module__duration-grey--xGPVB","durationGrey":"audio-footer-desktop-module__duration-grey--xGPVB"});
;// CONCATENATED MODULE: ./src/components/audio-footer/desktop/progress-bar.component.tsx










const ProgressBar = (0,react.memo)(function ProgressBar2(_ref) {
  let {
    disabled,
    onProgressChange
  } = _ref;
  const {
    currentTime,
    duration,
    setCurrentTime
  } = useAudioProgress();
  const [durationText, isDurationUndefined] = (0,react.useMemo)(() => {
    if (duration === Infinity || duration === null) {
      return ["--:--", true];
    }
    return [formatTime(duration), false];
  }, [duration]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: audio_footer_desktop_module.progressContainer,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: typography_module/* default */.Z.caption,
      children: currentTime !== null ? formatTime(currentTime) : null
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressSlider, {
      disabled,
      currentTime,
      duration,
      setCurrentTime,
      onProgressChange
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.caption, {
        [audio_footer_desktop_module.durationGrey]: isDurationUndefined
      }),
      children: durationText
    })]
  });
});
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide.module.css
var task_guide_module = __webpack_require__(70057);
;// CONCATENATED MODULE: ./src/components/audio-footer/desktop/audio-footer-desktop.component.tsx














const AudioFooterDesktop = _ref => {
  let {
    paused,
    speedIcon,
    volume,
    muted,
    loading,
    onPlayControlClick,
    onProgressChange,
    onVolumeChange,
    updateSpeed,
    hidePanel,
    muteAudio,
    unmuteAudio
  } = _ref;
  const {
    isVisible: taskGuideVisible
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const currentAudio = (0,useAudio/* useCurrentAudio */.sJ)();
  const {
    canPlay,
    canPause,
    canSeek,
    canChangeSpeed,
    canClose
  } = (0,use_audio_control/* useAudioControl */.b)(currentAudio?.type);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(audio_footer_desktop_module.footer, {
      [task_guide_module/* default */.Z.withOpenTaskGuide]: taskGuideVisible,
      [audio_footer_desktop_module.safari]: (0,is_safari/* isSafariBrowser */.f)()
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: audio_footer_desktop_module.controlsBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(PlayPauseButton, {
        paused,
        loading,
        canPlay,
        canPause,
        onClick: onPlayControlClick
      }), canChangeSpeed && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "secondary",
        size: "medium",
        iconName: speedIcon,
        onClick: updateSpeed
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
      disabled: !canSeek,
      onProgressChange
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(VolumeBar, {
      volume,
      muted,
      muteAudio,
      unmuteAudio,
      onVolumeChange
    }), canClose && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      onClick: hidePanel,
      appearance: "default",
      size: "medium",
      iconName: "cross"
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
;// CONCATENATED MODULE: ./src/components/audio-footer/mobile/audio-footer-mobile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_footer_mobile_module = ({"footer":"audio-footer-mobile-module__footer--CYZnm","slider":"audio-footer-mobile-module__slider--Gu4Ip","bottom-container":"audio-footer-mobile-module__bottom-container--Eu8b5","bottomContainer":"audio-footer-mobile-module__bottom-container--Eu8b5","time-container":"audio-footer-mobile-module__time-container--kdLGS","timeContainer":"audio-footer-mobile-module__time-container--kdLGS","duration":"audio-footer-mobile-module__duration--C5cPC","buttons-container":"audio-footer-mobile-module__buttons-container--ttCU8","buttonsContainer":"audio-footer-mobile-module__buttons-container--ttCU8","right-panel":"audio-footer-mobile-module__right-panel--NjcaB","rightPanel":"audio-footer-mobile-module__right-panel--NjcaB"});
;// CONCATENATED MODULE: ./src/components/audio-footer/mobile/audio-footer-mobile.component.tsx
















const AudioFooterMobile = _ref => {
  let {
    paused,
    loading,
    speedIcon,
    onProgressChange,
    onPlayControlClick,
    updateSpeed,
    hidePanel,
    volume,
    muted,
    muteAudio,
    unmuteAudio,
    onVolumeChange
  } = _ref;
  const currentAudio = (0,useAudio/* useCurrentAudio */.sJ)();
  const {
    canPlay,
    canPause,
    canSeek,
    canChangeSpeed,
    canClose
  } = (0,use_audio_control/* useAudioControl */.b)(currentAudio?.type);
  const {
    currentTime,
    duration,
    setCurrentTime
  } = useAudioProgress();
  const [showVolumeModal, setShowVolumeModal] = (0,react.useState)(false);
  const toggleVolumeModalVisibility = (0,react.useCallback)(() => setShowVolumeModal(value => !value), []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showVolumeModal && /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      onClose: toggleVolumeModalVisibility,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(VolumeBar, {
        volume,
        muted,
        muteAudio,
        unmuteAudio,
        onVolumeChange
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: audio_footer_mobile_module.footer,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: audio_footer_mobile_module.slider,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressSlider, {
          disabled: !canSeek,
          currentTime,
          duration,
          setCurrentTime,
          onProgressChange
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: audio_footer_mobile_module.bottomContainer,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(typography_module/* default */.Z.caption, audio_footer_mobile_module.timeContainer),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            children: formatTime(currentTime ?? 0)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            children: "/"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: audio_footer_mobile_module.duration,
            children: formatTime(duration ?? 0)
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: audio_footer_mobile_module.buttonsContainer,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(PlayPauseButton, {
            paused,
            loading,
            canPlay,
            canPause,
            onClick: onPlayControlClick
          }), canChangeSpeed && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            appearance: "secondary",
            size: "medium",
            iconName: speedIcon,
            onClick: updateSpeed
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: audio_footer_mobile_module.rightPanel,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            size: "medium",
            appearance: "default",
            iconName: muted ? "speaker-off" : "speaker",
            onClick: toggleVolumeModalVisibility
          }), canClose && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            className: audio_footer_mobile_module.rightSide,
            onClick: hidePanel,
            appearance: "default",
            size: "medium",
            iconName: "cross"
          })]
        })]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/components/audio-footer/model.ts
var model = __webpack_require__(42037);
;// CONCATENATED MODULE: ./src/components/audio-footer/audio-footer.component.tsx














const AudioFooter = () => {
  const shown = (0,effector_react/* useStore */.oR)(model/* $audioFooterVisible */.Wf);
  const [waiting, setWaiting] = (0,react.useState)(false);
  const loading = useLoader(waiting);
  const [paused, setPaused] = (0,react.useState)(true);
  const [speed, setSpeed] = (0,react.useState)(AudioSpeed.speed1);
  const [volume, setVolume] = (0,react.useState)(1);
  const [mute, setMute] = (0,react.useState)(false);
  const {
    isTabletOrDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const currentAudioElement = (0,useAudio/* useCurrentAudio */.sJ)();
  const player = (0,react.useContext)(useAudio/* AudioPlayerContext */.D8);
  const updateVolume = (0,react.useCallback)(_ref => {
    let {
      muted,
      value = 1
    } = _ref;
    player.setVolume(muted ? 0 : value);
  }, [player]);
  const muteAudio = (0,react.useCallback)(() => {
    setMute(true);
    updateVolume({
      muted: true
    });
  }, [updateVolume]);
  const unmuteAudio = (0,react.useCallback)(() => {
    setMute(false);
    updateVolume({
      muted: false,
      value: volume
    });
  }, [updateVolume, volume]);
  const updateSpeed = (0,react.useCallback)(() => {
    const speeds = [AudioSpeed.speed075, AudioSpeed.speed1, AudioSpeed.speed125];
    const currentIndex = speeds.findIndex(s => s === speed);
    const newIndex = (currentIndex + 1) % speeds.length;
    const newSpeed = speeds[newIndex];
    setSpeed(newSpeed);
    player.setPlaybackRate(mapAudioSpeed(newSpeed));
  }, [player, speed]);
  const speedIcon = (0,react.useMemo)(() => SpeedIconMap[speed], [speed]);
  const onAudioStateChanged = (0,react.useCallback)(() => {
    if (!currentAudioElement) {
      return;
    }
    setPaused(currentAudioElement.paused);
    if (!currentAudioElement.paused) {
      (0,model/* showAudioFooter */.t4)();
    }
  }, [currentAudioElement]);
  (0,useAudio/* useCurrentAudioEvents */.gc)((0,react.useMemo)(() => ({
    onPlay: onAudioStateChanged,
    onPause: onAudioStateChanged,
    onEnd: onAudioStateChanged
  }), [onAudioStateChanged]));
  (0,react.useEffect)(() => {
    if (currentAudioElement === null) {
      setPaused(true);
      return;
    }
    onAudioStateChanged();
  }, [currentAudioElement, onAudioStateChanged]);
  (0,react.useEffect)(() => {
    if (!currentAudioElement) {
      return;
    }
    if (currentAudioElement.volume === 0) {
      setMute(true);
    } else {
      setMute(false);
      setVolume(currentAudioElement.volume);
    }
    setSpeed(mapPlaybackRate(currentAudioElement.playbackRate));
  }, [currentAudioElement, currentAudioElement?.volume, currentAudioElement?.playbackRate]);
  (0,react.useEffect)(() => {
    event_emitter/* eventEmitter */.T.on("hideAudioPlayer", model/* hideAudioFooter */.AO);
    return () => {
      event_emitter/* eventEmitter */.T.off("hideAudioPlayer", model/* hideAudioFooter */.AO);
    };
  }, []);
  (0,react.useEffect)(() => () => {
    void player.stopAudio();
    (0,model/* hideAudioFooter */.AO)();
  }, [player]);
  const hidePanel = (0,react.useCallback)(() => {
    (0,model/* hideAudioFooter */.AO)();
    void player.stopAudio(currentAudioElement);
    player.close?.();
  }, [currentAudioElement, player]);
  const handleProgressChange = (0,react.useCallback)(time => {
    if (currentAudioElement) {
      player.seekAudio(currentAudioElement, time);
    }
  }, [player, currentAudioElement]);
  const handlePlayControlClick = (0,react.useCallback)(async () => {
    if (currentAudioElement) {
      try {
        setWaiting(true);
        if (paused) {
          await player.playAudio(currentAudioElement);
        } else {
          void player.pauseAudio(currentAudioElement);
        }
      } catch (e) {
        logger/* Logger */.Yd.captureException(e, {
          message: "failed to play/pause audio"
        });
      } finally {
        setWaiting(false);
      }
    }
  }, [player, currentAudioElement, paused]);
  const handleVolumeChange = (0,react.useCallback)(value => {
    setVolume(value);
    setMute(value === 0);
    updateVolume({
      muted: value === 0,
      value
    });
  }, [updateVolume]);
  if (!shown) {
    return null;
  }
  const Component = isTabletOrDesktop ? AudioFooterDesktop : AudioFooterMobile;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Component, {
    paused,
    speedIcon,
    volume,
    muted: mute,
    loading,
    onPlayControlClick: handlePlayControlClick,
    onProgressChange: handleProgressChange,
    onVolumeChange: handleVolumeChange,
    updateSpeed,
    hidePanel,
    muteAudio,
    unmuteAudio
  });
};
// EXTERNAL MODULE: ./src/components/controls-panel/controls-panel.tsx + 3 modules
var controls_panel = __webpack_require__(34228);
// EXTERNAL MODULE: ./src/components/controls-panel/types.ts
var types = __webpack_require__(36407);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
;// CONCATENATED MODULE: ./src/components/prev-activity-button/prev-activity-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const prev_activity_button_module = ({"root":"prev-activity-button-module__root--YvSzu","text":"prev-activity-button-module__text--dWqnE"});
;// CONCATENATED MODULE: ./src/components/prev-activity-button/prev-activity-button.component.tsx






const PrevActivityButton = _ref => {
  let {
    onClick
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: prev_activity_button_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      iconName: "arrow-up-small",
      appearance: "primary",
      size: "small",
      onClick
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: prev_activity_button_module.text,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "prevActivityButton.prevPart"
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/ramda/es/equals.js + 5 modules
var equals = __webpack_require__(5238);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
;// CONCATENATED MODULE: ./src/utils/scrollToBlock.ts


const scrollToBlock = (blockRef, disableSmooth) => {
  setTimeout(() => {
    blockRef?.current?.scrollIntoView({
      behavior: disableSmooth ? "auto" : "smooth",
      block: "start"
    });
  }, 100);
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
;// CONCATENATED MODULE: ./src/components/trainer-blocks/test-results.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const test_results_module = ({"relativeBlock":"test-results-module__relativeBlock--wQHqA","container":"test-results-module__container--udHUy","infoBlock":"test-results-module__infoBlock--RefZ5","topLabel":"test-results-module__topLabel--TC1kT","resultsLabel":"test-results-module__resultsLabel--kiynR","resultsScores":"test-results-module__resultsScores--XiOOk","resultsButton":"test-results-module__resultsButton--r0rec","image":"test-results-module__image--AnG8h","resultsBlock":"test-results-module__resultsBlock--EcJ4x"});
;// CONCATENATED MODULE: ./src/components/trainer-blocks/test-results.tsx








const TestResults = _ref => {
  let {
    imgSrc,
    showScore = false,
    score,
    maxScore,
    label,
    buttonText,
    topLabel,
    onButtonClick
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: test_results_module.relativeBlock,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: test_results_module.container,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: test_results_module.infoBlock,
        children: [topLabel && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(test_results_module.topLabel, typography_module/* default */.Z.body2),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            isDarkMode: true,
            children: topLabel
          })
        }), showScore && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(test_results_module.resultsScores, typography_module/* default */.Z.headline2),
          children: [score, "/", maxScore]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(test_results_module.resultsLabel, typography_module/* default */.Z.body1),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            isDarkMode: true,
            children: label
          })
        }), buttonText && onButtonClick && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primaryOnBlack",
          size: "medium",
          className: classnames_default()(test_results_module.resultsButton, typography_module/* default */.Z.body2Accent),
          onClick: onButtonClick,
          children: buttonText
        })]
      }), imgSrc && /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        src: imgSrc,
        className: test_results_module.image,
        alt: ""
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/trainer-blocks/test-results-block.tsx








const TestResultsBlock = _ref => {
  let {
    imgSrc,
    labelVariants,
    answers,
    blockIds,
    showScore,
    buttonText,
    topLabel,
    onButtonClick
  } = _ref;
  const {
    label,
    score,
    maxScore
  } = (0,react.useMemo)(() => {
    const labelVariantsSorted = Object.entries(labelVariants).sort((firstItem, secondItem) => Number(firstItem[0]) - Number(secondItem[0]));
    const {
      score: score2,
      maxScore: maxScore2
    } = answers.reduce((result, answer) => {
      if (!blockIds || blockIds.includes(answer.blockId)) {
        result.score += answer.score;
        result.maxScore += answer.maxScore;
      }
      return result;
    }, {
      score: 0,
      maxScore: 0
    });
    return {
      score: score2,
      maxScore: maxScore2,
      label: labelVariantsSorted.reduce((res, item) => score2 >= Number(item[0]) ? item[1] : res, "")
    };
  }, [answers, blockIds, labelVariants]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TestResults, {
    imgSrc,
    showScore,
    label,
    score,
    maxScore,
    buttonText,
    topLabel,
    onButtonClick
  });
};
// EXTERNAL MODULE: ./src/components/ya-form/ya-form.component.tsx + 2 modules
var ya_form_component = __webpack_require__(97030);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../shared/src/utils/url.ts
var url = __webpack_require__(52702);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(18360);
;// CONCATENATED MODULE: ./src/hooks/useLineInView.ts





var LinePoistion = /* @__PURE__ */(LinePoistion2 => {
  LinePoistion2["Top"] = "top";
  LinePoistion2["Bottom"] = "bottom";
  LinePoistion2["Unknown"] = "unknown";
  return LinePoistion2;
})(LinePoistion || {});
const useLineInView = _ref => {
  let {
    top = "auto",
    bottom = "auto",
    backgroundColor = "initial",
    options = {}
  } = _ref;
  const {
    inView,
    ref
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 1,
    ...options
  });
  const [line, setLine] = (0,react.useState)(null);
  const [lineContainer, setLineContainer] = (0,react.useState)(null);
  const getLinePosition = (0,react.useCallback)(() => {
    const halfOfHeight = document.documentElement.clientHeight / 2;
    if (!line) {
      return "unknown" /* Unknown */;
    }
    if (inView) {
      const lineTop = line.getBoundingClientRect().top;
      return lineTop <= halfOfHeight ? "top" /* Top */ : "bottom" /* Bottom */;
    }
    if (line.getBoundingClientRect().top <= 0) {
      return "top" /* Top */;
    }
    if (line.getBoundingClientRect().top >= document.documentElement.clientHeight) {
      return "bottom" /* Bottom */;
    }
    return "unknown" /* Unknown */;
  }, [inView, line]);
  const lineContainerRefCallback = (0,react.useCallback)(el => {
    setLineContainer(el);
  }, []);
  (0,react.useEffect)(() => {
    const el = document.createElement("div");
    el.style.cssText = `
          left: 0;
          width: 100%;
          position: absolute;
          height: 1px;
          bottom: ${bottom};
          top: ${top};
          width: 100%;
          background: ${backgroundColor};
        `;
    if (lineContainer) {
      lineContainer.appendChild(el);
      ref(el);
      setLine(el);
    }
    return () => {
      ref(null);
      lineContainer?.removeChild(el);
    };
  }, [backgroundColor, bottom, lineContainer, ref, top]);
  return {
    inView,
    getLinePosition,
    containerRefCallback: lineContainerRefCallback
  };
};
const useMechanicInView = callback => {
  const {
    inView,
    containerRefCallback
  } = useLineInView({
    bottom: "0"
  });
  (0,react.useEffect)(() => {
    callback(inView);
  }, [callback, inView]);
  return {
    containerRefCallback
  };
};
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
;// CONCATENATED MODULE: ../ui-kit/src/instruction-block/instruction-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const instruction_block_module = ({"root":"instruction-block-module__root--j3O08","block":"instruction-block-module__block--psj3E","block-title":"instruction-block-module__block-title--yvQk6","blockTitle":"instruction-block-module__block-title--yvQk6"});
;// CONCATENATED MODULE: ../ui-kit/src/instruction-block/instruction-block.component.tsx










const listRule = {
  order: (simple_markdown_default()).defaultRules.list.order,
  match: (simple_markdown_default()).defaultRules.list.match,
  parse: (simple_markdown_default()).defaultRules.list.parse,
  react(node, output, state) {
    const {
      start
    } = node;
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [start === 1 && /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}), simple_markdown_default().defaultRules.list.react(node, output, state)]
    });
  }
};
const InstructionBlock = _ref => {
  let {
    paragraphs
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(instruction_block_module.root),
    children: paragraphs.map((paragraph, paragraphIndex) => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: instruction_block_module.block,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.body2Accent, instruction_block_module.blockTitle),
        children: paragraph.title
      }), paragraph.lines.map((textString, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        wrapper: index === 0 ? markdown_component/* Wrapper */.im.span : markdown_component/* Wrapper */.im.div,
        rules: {
          list: listRule
        },
        className: typography_module/* default */.Z.body2,
        children: textString
      }, index))]
    }, paragraphIndex))
  });
};
;// CONCATENATED MODULE: ./src/components/tutor-instruction-block/tutor-instruction-block.component.tsx












const TutorInstructionBlock = _ref => {
  let {
    data
  } = _ref;
  const paragraphs = (0,react.useMemo)(() => {
    const toArray = data2 => {
      const result = data2 ?? [];
      return Array.isArray(result) ? result : [result];
    };
    const keys = Object.keys(data);
    const orderWeights = {
      type: 0,
      procedure: 1,
      say: 2,
      tips: 3,
      time: 4
    };
    return keys.sort((key1, key2) => {
      const weight1 = orderWeights[key1];
      const weight2 = orderWeights[key2];
      if (!weight1 || !weight2) {
        return 0;
      }
      return weight1 - weight2;
    }).filter(key => {
      const value = data[key];
      if (key === "type") {
        return false;
      }
      if (Array.isArray(value)) {
        return value.some(el => el !== "");
      }
      return value !== "";
    }).map(key => (
    // Создаем переменную чтоб явно определить тип ключа
    {
      lines: toArray(data[key]),
      title: key + ": "
    }));
  }, [data]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(InstructionBlock, {
    paragraphs
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/audio-lines/audio-lines.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_lines_module = ({"lines":"audio-lines-module__lines--qZxPI","line":"audio-lines-module__line--lRZfb","orange-line":"audio-lines-module__orange-line--sfmAa","orangeLine":"audio-lines-module__orange-line--sfmAa"});
;// CONCATENATED MODULE: ../ui-kit/src/audio-lines/audio-lines.component.tsx








const MIN_LINE_HEIGHT = 6;
const MAX_LINE_HEIGHT = 64;
const AudioLines = _ref => {
  let {
    numberOfLines,
    playing,
    className
  } = _ref;
  const linesHeights = (0,react.useMemo)(() => Array(numberOfLines).fill(0).map((_, i) => {
    const sinValue = Math.round(Math.abs(Math.sin(i)) * 100) / 100;
    return Math.max(Math.round(Math.random() * (MAX_LINE_HEIGHT * sinValue - MIN_LINE_HEIGHT) + MIN_LINE_HEIGHT), MIN_LINE_HEIGHT);
  }), [numberOfLines]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(audio_lines_module.lines, className),
    children: linesHeights.map((lineHeight, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(audio_lines_module.line, {
        [audio_lines_module.orangeLine]: playing
      }),
      style: {
        height: `${lineHeight}px`
      }
    }, `${lineHeight}_${index}`))
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../ui-kit/src/markdown/regexp.ts
var regexp = __webpack_require__(30095);
// EXTERNAL MODULE: ../shared/src/string.utils.ts
var string_utils = __webpack_require__(25680);
;// CONCATENATED MODULE: ../shared/src/markdown.utils.tsx
























const headingRegexp = / *(#{1,6})([^\n]+?)#* *(?:\n *)+\n/g;
const tooltipRegexpExp = /\[([^|:]+)\|([^|:]+)]/g;
const strongTextRegexp = /\*\*((?:\\[\s\S]|[^\\])+?)\*\*(?!\*)/g;
const em = new RegExp("^\\b_((?:__|\\\\[\\s\\S]|[^\\\\_])+?)_\\b|^\\*(?=\\S)((?:\\*\\*|\\\\[\\s\\S]|\\s+(?:\\\\[\\s\\S]|[^\\s\\*\\\\]|\\*\\*)|[^\\s\\*\\\\])+?)\\*(?!\\*)");
const em1 = /\*.*\*/gm;
const table = / *(\|.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/;
const list = /\n\d+\. |\n[-+] /;
const splitMarkdownTextBySentences = text => {
  const notSplitBySentenceRegexps = [regexp/* SPOILER_REGEXP */.qQ, regexp/* TARGET_BLANK_LINK */.$6, regexp/* LINK */.Zj, headingRegexp, strongTextRegexp, em, em1, tooltipRegexpExp, table];
  const markdownMap = /* @__PURE__ */new Map();
  const getHash = value => `${String((0,string_utils/* stringToHash */.xY)(value))}`;
  const textStartWithListMatch = simple_markdown_default().defaultRules.list.match(text, {}, "") !== null;
  let textWithListMatch = text.match(list);
  while (textWithListMatch !== null) {
    const textStartWithList = textStartWithListMatch ? text : text.slice((textWithListMatch.index || 0) + 1);
    const listMatch = simple_markdown_default().defaultRules.list.match(textStartWithList, {}, "");
    if (listMatch !== null) {
      const hash = getHash(listMatch[0]);
      text = text.replace(listMatch[0], `${hash}`);
      markdownMap.set(hash, listMatch[0]);
    }
    textWithListMatch = text.match(list);
  }
  notSplitBySentenceRegexps.forEach(regexp => {
    text = text.replace(regexp, match2 => {
      const hash = getHash(match2);
      markdownMap.set(hash, match2);
      return hash;
    });
  });
  let splittedTextBySentences = (0,string_utils/* splitBySentences */.Ee)(text);
  const match = text.match(/\s+/);
  const textIsSpace = match !== null && match[0] === text;
  if (textIsSpace) {
    splittedTextBySentences = [text];
  }
  const reversHashes = Array.from(markdownMap.keys()).reverse();
  return splittedTextBySentences.map(sentence => {
    for (const hash of reversHashes) {
      sentence = sentence.split(hash).join(markdownMap.get(hash));
    }
    return sentence;
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../shared/src/constants.ts
var constants = __webpack_require__(51157);
// EXTERNAL MODULE: ../ui-kit/src/markdown/rules/link-rule.tsx
var link_rule = __webpack_require__(2510);
// EXTERNAL MODULE: ../ui-kit/src/markdown/rules/spoiler-rule.tsx + 3 modules
var spoiler_rule = __webpack_require__(1225);
// EXTERNAL MODULE: ../ui-kit/src/markdown/rules/target-blank-link-rule.tsx
var target_blank_link_rule = __webpack_require__(86524);
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-translation-v2-enabled.ts
var use_translation_v2_enabled = __webpack_require__(3832);
// EXTERNAL MODULE: ./src/utils/cleanFromMarkdown.tsx
var cleanFromMarkdown = __webpack_require__(4527);
// EXTERNAL MODULE: ./src/components/selection-translation/store/store.ts
var store = __webpack_require__(9266);
;// CONCATENATED MODULE: ./src/components/translatable-text/translatable-text-context.ts



const TranslatableTextContext = (0,react.createContext)({
  hideAddToWordbankButton: false,
  hasActionsTooltip: false,
  fetchTranslation: () => Promise.resolve({
    id: "",
    word: "",
    partOfSpeech: "",
    addedInWordbank: false,
    translations: [""],
    context: ""
  })
});
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip/translation-tooltip-rule.tsx + 1 modules
var translation_tooltip_rule = __webpack_require__(73766);
;// CONCATENATED MODULE: ./src/components/translatable-text/constants.ts



const UNICODE_WORD_BOUNDARY_REGEX_START = `(?<=[ ${constants/* NBSP */.Xz}/,.:;-+"'\u201C]|/^)`;
const UNICODE_WORD_BOUNDARY_REGEX_END = `(?=[ ${constants/* NBSP */.Xz}/,.:;?!-+"'\u201D]|/$)`;
;// CONCATENATED MODULE: ./src/components/translatable-text/utils.ts




const isSingleSpace = string => {
  const regex = /^ $/;
  return regex.test(string);
};
const getWordIndexInFullSentence = params => {
  const sentence = params.sentence.toLowerCase();
  const word = params.word.toLowerCase();
  let regex;
  try {
    regex = new RegExp(UNICODE_WORD_BOUNDARY_REGEX_START + (0,string_utils/* escape */.YU)(word) + UNICODE_WORD_BOUNDARY_REGEX_END);
  } catch {
    regex = new RegExp("(\\b)" + (0,string_utils/* escape */.YU)(word) + "(\\b)");
  }
  const replacementValue = Array(word.length).fill("0").join("");
  return (0,string_utils/* replace */.gx)(sentence, regex, replacementValue, params.timesEntered).search(regex);
};
// EXTERNAL MODULE: ./src/components/translatable-text/word/translatable-word.tsx + 7 modules
var translatable_word = __webpack_require__(77703);
;// CONCATENATED MODULE: ./src/components/translatable-text/translatable-text.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const translatable_text_module = ({"root":"translatable-text-module__root--vykUy","table":"translatable-text-module__table--Z3VTa","word":"translatable-text-module__word--uGo4v","tooltip":"translatable-text-module__tooltip--XnchS"});
;// CONCATENATED MODULE: ./src/components/translatable-text/use-translatable-text-rules.tsx




































const MarkdownContext = (0,react.createContext)({
  translatableTextId: "",
  sentence: "",
  sentenceIndex: 0
});
const isWordCharacter = char => /[a-zA-Z0-9_’'`\-&@]/.test(char);
const splitIntoWordsAndNonWords = text => {
  const result = [];
  let currentWord = "";
  let isCollectingWord = false;
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const isCharPartOfWord = isWordCharacter(char);
    if (isCharPartOfWord) {
      if (!isCollectingWord && currentWord) {
        result.push({
          type: "non-word",
          text: currentWord
        });
        currentWord = "";
      }
      currentWord += char;
      isCollectingWord = true;
    } else {
      if (isCollectingWord && currentWord) {
        result.push({
          type: "word",
          text: currentWord
        });
        currentWord = "";
      }
      currentWord += char;
      isCollectingWord = false;
    }
  }
  if (currentWord) {
    result.push({
      type: isCollectingWord ? "word" : "non-word",
      text: currentWord
    });
  }
  return result;
};
const useTranslatableTextRules = _ref => {
  let {
    isDarkMode
  } = _ref;
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const link = (0,link_rule/* linkRule */.t)({
    isDarkMode
  });
  const targetBlankLink = (0,target_blank_link_rule/* targetBlankLinkRule */.S)({
    isDarkMode
  });
  const table = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.table.order,
    match: (simple_markdown_default()).defaultRules.table.match,
    parse: capture => ({
      content: capture.input
    }),
    react: node => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: translatable_text_module.table,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: node.content
      })
    })
  }), []);
  const em = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.em.order,
    match: simple_markdown_default().inlineRegex(regexp.EM),
    parse: (capture, parse, state) => {
      state.key = Number(state.key || 0) + 1;
      return {
        beforeContent: capture[2],
        content: parse(capture[3], state),
        mark: capture[4],
        spaces: capture[5],
        key: state.key
      };
    },
    react: (node, output, state) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [node.beforeContent, simple_markdown_default().defaultRules.em.react(node, output, state), node.mark, node.spaces]
    }, node.key)
  }), []);
  const strong = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.strong.order,
    match: simple_markdown_default().inlineRegex(regexp/* STRONG */.jV),
    parse: (capture, parse, state) => {
      state.key = Number(state.key || 0) + 1;
      return {
        beforeContent: capture[1],
        content: simple_markdown_default().parseInline(parse, capture[2], state),
        mark: capture[3],
        spaces: capture[4],
        key: state.key
      };
    },
    react: (node, output, state) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [node.beforeContent, simple_markdown_default().defaultRules.strong.react(node, output, state), node.mark, node.spaces]
    }, node.key)
  }), []);
  const del = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.del.order,
    match: simple_markdown_default().inlineRegex(regexp/* DEL */.fU),
    parse: (capture, parse, state) => {
      state.key = Number(state.key || 0) + 1;
      return {
        beforeContent: capture[1],
        content: simple_markdown_default().parseInline(parse, capture[2], state),
        mark: capture[3],
        spaces: capture[4],
        key: state.key
      };
    },
    react(node, output, state) {
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [node.beforeContent, simple_markdown_default().defaultRules.del.react(node, output, state), node.mark, node.spaces]
      }, node.key);
    }
  }), []);
  const paragraph = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.paragraph.order,
    match: (simple_markdown_default()).defaultRules.paragraph.match,
    parse: (simple_markdown_default()).defaultRules.paragraph.parse,
    react(node, output, state) {
      const {
        content
      } = node;
      return output(content, state);
    }
  }), []);
  const text = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.text.order,
    match: simple_markdown_default().anyScopeRegex(regexp/* TEXT */.lD),
    parse: (simple_markdown_default()).defaultRules.text.parse,
    react: node => {
      const {
        content
      } = node;
      return content.replace(/\u0008/g, "");
    }
  }), []);
  const tooltip = (0,react.useMemo)(() =>
  // Для v2 сохраняем форматирование для tooltip [word word|слово слово] - отображается только часть до |,
  // т.к. в контенте много таких элементов, но при этом разбиваем его на отдельные слова
  // чтобы была возможность взаимодействовать с ними по отдельности
  isTranslationV2Enabled ? {
    order: (simple_markdown_default()).defaultRules.link.order - 1,
    match: translation_tooltip_rule/* translationTooltipRule */.N.tooltip?.match,
    parse: translation_tooltip_rule/* translationTooltipRule */.N.tooltip?.parse,
    react: _ref2 => {
      let {
        beforeContent,
        visibleValue,
        punctuationMark,
        spaces,
        key
      } = _ref2;
      const normalizedBeforeContent = isSingleSpace(beforeContent) ? constants/* NBSP */.Xz : beforeContent;
      const parts = splitIntoWordsAndNonWords(visibleValue);
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: translatable_text_module.word,
          children: [normalizedBeforeContent, parts.map((part, index) => {
            if (part.type === "word") {
              return /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableTextWord, {
                type: "word",
                timesEntered: 0,
                children: part.text
              }, index);
            }
            return part.text;
          }), punctuationMark]
        }), spaces]
      }, key);
    }
  } : {
    order: (simple_markdown_default()).defaultRules.link.order - 1,
    match: translation_tooltip_rule/* translationTooltipRule */.N.tooltip?.match,
    parse: translation_tooltip_rule/* translationTooltipRule */.N.tooltip?.parse,
    react: _ref3 => {
      let {
        beforeContent,
        visibleValue,
        punctuationMark,
        spaces,
        translation,
        key
      } = _ref3;
      const normalizedBeforeContent = isSingleSpace(beforeContent) ? constants/* NBSP */.Xz : beforeContent;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: translatable_text_module.tooltip,
          children: [normalizedBeforeContent, /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableTextWord, {
            type: "tooltip",
            translation,
            children: visibleValue
          }), punctuationMark]
        }), spaces]
      }, key);
    }
  }, [isTranslationV2Enabled]);
  const spoiler = spoiler_rule/* spoilerRule */.h;
  const word = (0,react.useMemo)(() => ({
    order: (simple_markdown_default()).defaultRules.text.order - 0.5,
    match: simple_markdown_default().inlineRegex(regexp/* WORD */.vk),
    parse: (capture, parser, parserState) => {
      const word2 = capture[2].trim().toLowerCase();
      const state = parserState;
      const entriesCounter = state.entriesMap?.get(word2) || 0;
      if (!state.entriesMap) {
        state.entriesMap = /* @__PURE__ */new Map();
      }
      state.key = (state.key || 0) + 1;
      state.entriesMap.set(word2, entriesCounter + 1);
      return {
        beforeContent: capture[1],
        content: capture[2],
        mark: capture[3],
        spaces: capture[4],
        timesEntered: entriesCounter,
        key: state.key
      };
    },
    react: node => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [node.beforeContent, /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
        className: translatable_text_module.word,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableTextWord, {
          type: "word",
          timesEntered: node.timesEntered,
          children: node.content
        }), node.mark]
      }), node.spaces]
    }, node.key)
  }), []);
  return {
    table,
    tooltip,
    strong,
    text,
    paragraph,
    spoiler,
    link,
    targetBlankLink,
    em,
    del,
    word
  };
};
const TranslatableTextWord = props => {
  const {
    type,
    children
  } = props;
  const {
    fetchTranslation,
    fetchTooltipTranslation,
    onPlayTextToSpeech,
    onAddWordClick = () => Promise.resolve(false),
    onDeleteWordClick = () => Promise.resolve(false),
    onAddTooltip = () => Promise.resolve(false),
    textConstants,
    hasActionsTooltip,
    hideAddToWordbankButton,
    hoveredWordPath,
    highlightedWordPath,
    highlightingNotifier,
    containerRef,
    onWordAction,
    onOutsideClick,
    blockKey
  } = (0,react.useContext)(TranslatableTextContext);
  const {
    sentence,
    sentenceIndex,
    translatableTextId
  } = (0,react.useContext)(MarkdownContext);
  const {
    setContext,
    setSelectionStartIndex
  } = (0,store/* useSelectionStore */.f)();
  const {
    timesEntered
  } = type === "word" ? props : {
    timesEntered: 0
  };
  const wordIndex = (0,react.useMemo)(() => type === "word" ? getWordIndexInFullSentence({
    sentence: sentence.trim(),
    word: children,
    timesEntered
  }) : 1, [type, sentence, children, timesEntered]);
  const hovered = (0,react.useMemo)(() => Boolean(hoveredWordPath) && translatableTextId === hoveredWordPath?.translatableTextId && sentenceIndex === hoveredWordPath?.sentenceIndex && wordIndex === hoveredWordPath?.tokenIndex, [hoveredWordPath, sentenceIndex, translatableTextId, wordIndex]);
  const highlighted = (0,react.useMemo)(() => Boolean(highlightedWordPath) && translatableTextId === highlightedWordPath?.translatableTextId && sentenceIndex === highlightedWordPath?.sentenceIndex && wordIndex === highlightedWordPath?.tokenIndex, [highlightedWordPath, sentenceIndex, translatableTextId, wordIndex]);
  const {
    translation
  } = type === "tooltip" ? props : {
    translation: ""
  };
  const handleFetchTranslation = (0,react.useCallback)(() => {
    const withoutMarkdown = (0,cleanFromMarkdown/* cleanFromMarkdown */.s)(sentence.replaceAll("\n", " ")).trim();
    const wordIndexWithoutMarkdown = getWordIndexInFullSentence({
      sentence: withoutMarkdown,
      word: children,
      timesEntered
    });
    return type === "tooltip" && fetchTooltipTranslation ? fetchTooltipTranslation({
      context: withoutMarkdown,
      term: children,
      translation
    }) : fetchTranslation(withoutMarkdown, wordIndexWithoutMarkdown);
  }, [sentence, children, timesEntered, type, fetchTooltipTranslation, translation, fetchTranslation]);
  const handleAddWord = (0,react.useCallback)(params => type === "word" ? onAddWordClick(params) : onAddTooltip(params.termId), [onAddTooltip, onAddWordClick, type]);
  const handleWordAction = (0,react.useCallback)(action => {
    onWordAction?.(translatableTextId, sentenceIndex, wordIndex, action);
  }, [onWordAction, sentenceIndex, translatableTextId, wordIndex]);
  const handleHover = (0,react.useCallback)(() => {
    const contextWithoutMarkdown = (0,cleanFromMarkdown/* cleanFromMarkdown */.s)(sentence.replaceAll("\n", " ")).trim();
    const wordIndexWithoutMarkdown = getWordIndexInFullSentence({
      sentence: contextWithoutMarkdown,
      word: children,
      timesEntered
    });
    setContext(contextWithoutMarkdown);
    setSelectionStartIndex(wordIndexWithoutMarkdown);
    handleWordAction("hover");
  }, [children, handleWordAction, sentence, setContext, setSelectionStartIndex, timesEntered]);
  const handleLeave = (0,react.useCallback)(() => handleWordAction("leave"), [handleWordAction]);
  const handleHighlight = (0,react.useCallback)(() => {
    const contextWithoutMarkdown = (0,cleanFromMarkdown/* cleanFromMarkdown */.s)(sentence.replaceAll("\n", " ")).trim();
    const wordIndexWithoutMarkdown = getWordIndexInFullSentence({
      sentence: contextWithoutMarkdown,
      word: children,
      timesEntered
    });
    setContext(contextWithoutMarkdown, true);
    setSelectionStartIndex(wordIndexWithoutMarkdown, true);
    handleWordAction("highlight");
  }, [children, handleWordAction, sentence, setContext, setSelectionStartIndex, timesEntered]);
  const handleTranslate = (0,react.useCallback)(() => handleWordAction("translate"), [handleWordAction]);
  const handleScroll = (0,react.useCallback)(() => handleWordAction("scroll"), [handleWordAction]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(translatable_word/* TranslatableWord */.$, {
    textConstants,
    hasActionsTooltip,
    hideAddToWordbankButton,
    onAddWord: handleAddWord,
    onDeleteWord: onDeleteWordClick,
    onPlayTextToSpeech,
    fetchTranslation: handleFetchTranslation,
    onHover: handleHover,
    onLeave: handleLeave,
    onHighlight: handleHighlight,
    onTranslate: handleTranslate,
    onScroll: handleScroll,
    onClose: onOutsideClick,
    hovered,
    highlighted,
    highlightingNotifier,
    containerRef,
    blockKey,
    children
  });
};
;// CONCATENATED MODULE: ./src/components/translatable-text/translatable-text.component.tsx


























const TranslatableText = (0,react.memo)(_ref => {
  let {
    id,
    children,
    additionalRules,
    typography,
    className,
    isDarkMode
  } = _ref;
  const sentences = (0,react.useMemo)(() => splitMarkdownTextBySentences(children), [children]);
  const wordbankRule = useTranslatableTextRules({
    isDarkMode
  });
  const markdownRules = (0,react.useMemo)(() => ({
    ...wordbankRule,
    ...additionalRules
  }), [additionalRules, wordbankRule]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    children: sentences.map((sentence, sentenceIndex) => /* @__PURE__ */(0,jsx_runtime.jsx)(MarkdownContext.Provider, {
      value: {
        translatableTextId: id,
        sentence,
        sentenceIndex
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        "data-translation": "sentence",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          className: classnames_default()(className, typography && typography_module/* default */.Z[typography], translatable_text_module.root),
          wrapper: markdown_component/* Wrapper */.im.span,
          rules: markdownRules,
          internalState: {
            entriesMap: /* @__PURE__ */new Map(),
            key: 0
          },
          children: sentence
        })
      })
    }, sentenceIndex))
  });
});
TranslatableText.displayName = "TranslatableText";
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-to-play/text-to-play-desktop.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_to_play_desktop_module = ({"root":"text-to-play-desktop-module__root--ZXvsP","author":"text-to-play-desktop-module__author--Z8NUJ","audio-button":"text-to-play-desktop-module__audio-button--Q2FpR","audioButton":"text-to-play-desktop-module__audio-button--Q2FpR","button-icon":"text-to-play-desktop-module__button-icon--iAW4u","buttonIcon":"text-to-play-desktop-module__button-icon--iAW4u","button-icon-active":"text-to-play-desktop-module__button-icon-active--upVOA","buttonIconActive":"text-to-play-desktop-module__button-icon-active--upVOA","text-root":"text-to-play-desktop-module__text-root--Od2Qz","textRoot":"text-to-play-desktop-module__text-root--Od2Qz","text-root-center":"text-to-play-desktop-module__text-root-center--Ra54q","textRootCenter":"text-to-play-desktop-module__text-root-center--Ra54q","audio-button-hidden":"text-to-play-desktop-module__audio-button-hidden--GcbRw","audioButtonHidden":"text-to-play-desktop-module__audio-button-hidden--GcbRw","replica":"text-to-play-desktop-module__replica--zIgj2","array-text-container":"text-to-play-desktop-module__array-text-container--XEvXI","arrayTextContainer":"text-to-play-desktop-module__array-text-container--XEvXI"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-to-play/text-to-play-desktop.component.tsx













const TextToPlayDesktop = _ref => {
  let {
    onClick = function_utils/* emptyFunction */.Bi,
    text,
    loading,
    playing,
    author = "",
    hidePlayButton = false,
    canPlay,
    blockId
  } = _ref;
  const textArray = (0,react.useMemo)(() => Array.isArray(text) ? text : [text], [text]);
  const isEmptyText = (0,react.useMemo)(() => textArray.join("").trim() === "", [textArray]);
  const renderText = (0,react.useCallback)((text2, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
    id: `${blockId} text-to-play text-${index}`,
    children: text2
  }, index), [blockId]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: text_to_play_desktop_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(text_to_play_desktop_module.author, typography_module/* default */.Z.body2),
      children: author
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(text_to_play_desktop_module.textRoot, {
        [text_to_play_desktop_module.textRootCenter]: isEmptyText
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(text_to_play_desktop_module.audioButton, {
          [text_to_play_desktop_module.audioButtonHidden]: hidePlayButton
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          disabled: !canPlay,
          appearance: "default",
          size: "medium",
          iconName: canPlay ? "speaker" : "waves",
          classes: {
            buttonIcon: classnames_default()({
              [text_to_play_desktop_module.buttonIcon]: !playing,
              [text_to_play_desktop_module.buttonIconActive]: playing
            })
          },
          onFocus: e => e.currentTarget.blur(),
          onClick,
          loading
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.headline4, text_to_play_desktop_module.replica),
        children: isEmptyText ? /* @__PURE__ */(0,jsx_runtime.jsx)(AudioLines, {
          numberOfLines: 82,
          playing: Boolean(playing)
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: text_to_play_desktop_module.arrayTextContainer,
          children: textArray.map(renderText)
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-to-play/text-to-play-mobile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_to_play_mobile_module = ({"root":"text-to-play-mobile-module__root--xxq8g","root-center":"text-to-play-mobile-module__root-center--m902w","rootCenter":"text-to-play-mobile-module__root-center--m902w","author":"text-to-play-mobile-module__author--LMl94","text":"text-to-play-mobile-module__text--Wb7yn","speaker-icon":"text-to-play-mobile-module__speaker-icon--ed3JS","speakerIcon":"text-to-play-mobile-module__speaker-icon--ed3JS","speaker-icon-active":"text-to-play-mobile-module__speaker-icon-active--QtjYq","speakerIconActive":"text-to-play-mobile-module__speaker-icon-active--QtjYq"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-to-play/text-to-play-mobile.component.tsx













const TextToPlayMobile = _ref => {
  let {
    onClick = function_utils/* emptyFunction */.Bi,
    text,
    author = "",
    hidePlayButton = false,
    canPlay,
    loading,
    playing,
    blockId
  } = _ref;
  const textArray = (0,react.useMemo)(() => Array.isArray(text) ? text : [text], [text]);
  const isEmptyText = (0,react.useMemo)(() => textArray.join("").trim() === "", [textArray]);
  const renderText = (0,react.useCallback)((text2, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
    id: `${blockId} text-to-play text-${index}`,
    typography: "body1",
    children: text2
  }, index), [blockId]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(text_to_play_mobile_module.root, {
      [text_to_play_mobile_module.rootCenter]: isEmptyText
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body1, text_to_play_mobile_module.author),
      children: author
    }), !hidePlayButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      size: "small",
      appearance: "default",
      iconName: canPlay ? "speaker" : "waves",
      className: classnames_default()(text_to_play_mobile_module.speakerIcon, {
        [text_to_play_mobile_module.speakerIconActive]: playing
      }),
      onFocus: e => e.currentTarget.blur(),
      loading,
      disabled: !canPlay,
      onClick
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: text_to_play_mobile_module.text,
      children: isEmptyText ? /* @__PURE__ */(0,jsx_runtime.jsx)(AudioLines, {
        numberOfLines: 82,
        playing: Boolean(playing)
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: textArray.map(renderText)
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-to-play-component.tsx






const TextToPlayComponent = _ref => {
  let {
    text,
    author,
    onClick,
    loading,
    playing,
    hidePlayButton = true,
    canPlay = true,
    blockId
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const props = {
    text,
    author,
    onClick,
    hidePlayButton,
    playing,
    loading,
    canPlay,
    blockId
  };
  return isMobile ? /* @__PURE__ */(0,jsx_runtime.jsx)(TextToPlayMobile, {
    ...props
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(TextToPlayDesktop, {
    ...props
  });
};
// EXTERNAL MODULE: ./src/api/trainer/trainer.urls.ts
var trainer_urls = __webpack_require__(47160);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_block_module = ({"author":"text-block-module__author--G4j0s","audio-button":"text-block-module__audio-button--QBQoW","audioButton":"text-block-module__audio-button--QBQoW","button-icon":"text-block-module__button-icon--zqSWD","buttonIcon":"text-block-module__button-icon--zqSWD","passed":"text-block-module__passed--heFLv","text-root":"text-block-module__text-root--oMgPN","textRoot":"text-block-module__text-root--oMgPN","toggle":"text-block-module__toggle--WNAXX"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-to-play-with-audio.component.tsx











const TextToPlayWithAudio = _ref => {
  let {
    text,
    author,
    audio,
    autoPlay,
    blockId
  } = _ref;
  const audioLink = (0,react.useMemo)(() => {
    const type = audio.type;
    switch (type) {
      case "t2s":
        return (0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(audio.text, audio.voice);
      case "voiceover":
        return encodeURI(audio.url);
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  }, [audio]);
  const audioPriority = (0,react.useMemo)(() => {
    switch (audio?.priority) {
      case "low":
        return useAudio/* Priority */.UL.Low;
      case "primary":
        return useAudio/* Priority */.UL.Primary;
      default:
        return useAudio/* Priority */.UL.Normal;
    }
  }, [audio?.priority]);
  const audioOptions = (0,react.useMemo)(() => ({
    priority: audioPriority,
    autoPlay
  }), [audioPriority, autoPlay]);
  const {
    playing,
    waiting,
    playFromStart,
    canPlay
  } = (0,useAudio/* useAudioHandler */.GH)(audioLink, "dialog", audioOptions);
  const loading = useLoader(waiting);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TextToPlayComponent, {
      text,
      author,
      onClick: playFromStart,
      hidePlayButton: false,
      loading,
      playing,
      canPlay,
      blockId
    }), audio.toggle && /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: "text-to-play-with-audio toggle",
      className: text_block_module.toggle,
      children: audio.toggle
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/text-block/text-block.component.tsx










const TextBlock = _ref => {
  let {
    text,
    author,
    audio,
    lastBlock,
    showNextButton,
    showPrevButton,
    showTutorInstructions,
    tutorInstructions,
    onNextBlock = function_utils/* emptyFunction */.Bi,
    onPrevBlock = function_utils/* emptyFunction */.Bi,
    controlsPanelButtonsPlace,
    blockId
  } = _ref;
  const {
    inView,
    ref
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.1,
    triggerOnce: true
  });
  const {
    inView: actionControlsVisible,
    ref: actionControlsRef
  } = (0,react_intersection_observer_m/* useInView */.YD)();
  const isVisibleControlsPanel = (0,react.useMemo)(() => actionControlsVisible && lastBlock && showNextButton, [actionControlsVisible, lastBlock, showNextButton]);
  const handleRef = (0,react.useCallback)(el => {
    ref(el);
    actionControlsRef(el);
  }, [actionControlsRef, ref]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: "text-block",
    ref: handleRef,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), audio ? /* @__PURE__ */(0,jsx_runtime.jsx)(TextToPlayWithAudio, {
      text,
      author,
      audio,
      autoPlay: inView && Boolean(lastBlock) && (audio["auto-play"] ?? true),
      blockId
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(TextToPlayComponent, {
      text,
      author,
      blockId
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton: true,
      onNextButtonClick: onNextBlock
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/blocks-list-with-illustration/components/in-view-container/in-view-container.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const in_view_container_module = ({"container":"in-view-container-module__container--v_QAf"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/blocks-list-with-illustration/components/in-view-container/in-view-container.tsx







const InViewContainer = _ref => {
  let {
    onInView,
    children,
    isVisible,
    marginTop
  } = _ref;
  const [element, setElement] = (0,react.useState)(null);
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    top: "40vh"
  });
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  (0,react.useEffect)(() => {
    (element?.getBoundingClientRect().top ?? -1) > 0 && onInView(inView);
  }, [inView, element, onInView]);
  (0,react.useEffect)(() => {
    if (isVisible && element) {
      if (isMobile) {
        window.scrollTo({
          behavior: "smooth",
          top: element.getBoundingClientRect().top + window.pageYOffset - marginTop
        });
      } else {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }
  }, [element, isVisible, marginTop, isMobile]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: in_view_container_module.container,
    ref: el => {
      ref(el);
      setElement(el);
    },
    children
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/blocks-list-with-illustration/blocks-list-with-illustration.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const blocks_list_with_illustration_module = ({"illustration-container":"blocks-list-with-illustration-module__illustration-container--QPtIg","illustrationContainer":"blocks-list-with-illustration-module__illustration-container--QPtIg","illustration":"blocks-list-with-illustration-module__illustration--iBekf","root":"blocks-list-with-illustration-module__root--Di5rH","container":"blocks-list-with-illustration-module__container--kmb9y","texts-block":"blocks-list-with-illustration-module__texts-block--hXP6e","textsBlock":"blocks-list-with-illustration-module__texts-block--hXP6e","with-margin":"blocks-list-with-illustration-module__with-margin--_JRsh","withMargin":"blocks-list-with-illustration-module__with-margin--_JRsh","dialog-replica":"blocks-list-with-illustration-module__dialog-replica--XReii","dialogReplica":"blocks-list-with-illustration-module__dialog-replica--XReii","illustration-hidden":"blocks-list-with-illustration-module__illustration-hidden--sZZVa","illustrationHidden":"blocks-list-with-illustration-module__illustration-hidden--sZZVa"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/blocks-list-with-illustration/blocks-list-with-illustration.component.tsx


















const BlocksListWithIllustration = _ref => {
  let {
    blocks,
    showNextButton,
    showPrevButton,
    controlsPanelButtonsPlace,
    lastBlock,
    onNextBlock,
    onPrevBlock,
    showTutorInstructions,
    onChangeAnswer,
    onSubmitAnswer,
    initialAnswer
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [visibleBlockIndex, setVisibleBlockIndex] = (0,react.useState)(0);
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  (0,react.useEffect)(() => {
    setVisibleBlockIndex(initialAnswer.visibleBlockIndex || 0);
  }, [initialAnswer]);
  const [illustration, setIllustration] = (0,react.useState)(blocks[0].type === "text" ? blocks[0].illustration : void 0);
  const illustrationRef = (0,react.useRef)(null);
  const [illustrationHeight, setIllustrationHeight] = (0,react.useState)(360);
  const {
    inView: startInView,
    getLinePosition: getStartLinePosition,
    containerRefCallback: startLineContainerRefCallback
  } = useLineInView({
    top: `50vh`
  });
  const {
    inView: endInView,
    getLinePosition: getEndLinePosition,
    containerRefCallback: endLineContainerRefCallback
  } = useLineInView({
    bottom: isMobile ? `${illustrationHeight}px` : `50vh`
  });
  const [hidden, setHidden] = (0,react.useState)(true);
  const blocksWithIllustrations = (0,react.useMemo)(() => blocks.filter(block => block.type === "text"), [blocks]);
  (0,react.useEffect)(() => {
    if (!startInView && getStartLinePosition() === LinePoistion.Bottom) {
      setHidden(true);
    } else if (startInView && getStartLinePosition() === LinePoistion.Bottom) {
      setHidden(false);
    }
  }, [getStartLinePosition, startInView]);
  (0,react.useEffect)(() => {
    if (!endInView && getEndLinePosition() === LinePoistion.Top) {
      setHidden(true);
    } else if (endInView && getEndLinePosition() === LinePoistion.Top) {
      setHidden(false);
    }
  }, [endInView, getEndLinePosition]);
  (0,react.useEffect)(() => {
    if (!endInView && !startInView) {
      setHidden(true);
    }
  }, [endInView, startInView]);
  (0,react.useEffect)(() => {
    const image = illustrationRef.current;
    if (image) {
      image.onload = () => {
        setIllustrationHeight(() => image.offsetHeight);
      };
      return () => {
        image.onload = null;
      };
    }
  }, [illustration]);
  const callbackRef = (0,react.useCallback)(el => {
    startLineContainerRefCallback(el);
    endLineContainerRefCallback(el);
  }, [endLineContainerRefCallback, startLineContainerRefCallback]);
  const margin = (0,react.useMemo)(() => {
    if (lastBlock) {
      const trainerLayoutMarginBottom = 288;
      const dialogHeight = 115;
      return isMobile ? `calc(100vh - ${trainerLayoutMarginBottom}px - ${illustrationHeight}px - ${dialogHeight}px)` : `calc(50vh - ${trainerLayoutMarginBottom}px - 12px)`;
    }
    return "auto";
  }, [illustrationHeight, lastBlock, isMobile]);
  const isShowNextButton = (0,react.useMemo)(() => showNextButton && (lastBlock || visibleBlockIndex !== blocksWithIllustrations.length - 1), [blocksWithIllustrations.length, lastBlock, showNextButton, visibleBlockIndex]);
  const isShowPrevButton = (0,react.useMemo)(() => lastBlock && (visibleBlockIndex !== 0 || showPrevButton), [lastBlock, showPrevButton, visibleBlockIndex]);
  const handlePrevButtonClick = (0,react.useCallback)(() => {
    if (visibleBlockIndex === 0) {
      onPrevBlock();
      return;
    }
    setVisibleBlockIndex(prev => {
      onChangeAnswer?.({
        visibleBlockIndex: prev - 1
      });
      return prev - 1;
    });
    const prevElement = blocksWithIllustrations[visibleBlockIndex - 1];
    if (prevElement && prevElement.type === "text") {
      setIllustration(prevElement.illustration);
    }
  }, [blocksWithIllustrations, onChangeAnswer, onPrevBlock, visibleBlockIndex]);
  const handleNextButtonClick = (0,react.useCallback)(() => {
    if (visibleBlockIndex !== blocksWithIllustrations.length - 1) {
      setVisibleBlockIndex(prev => {
        onSubmitAnswer({
          answer: {
            visibleBlockIndex: prev + 1
          },
          correct: true
        });
        onChangeAnswer?.({
          visibleBlockIndex: prev + 1
        });
        return prev + 1;
      });
    } else {
      onNextBlock();
    }
  }, [blocksWithIllustrations.length, onChangeAnswer, onNextBlock, onSubmitAnswer, visibleBlockIndex]);
  const mobileIllustration = /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
    className: classnames_default()(blocks_list_with_illustration_module.illustrationContainer, {
      [blocks_list_with_illustration_module.illustrationHidden]: hidden
    }),
    ref: illustrationRef,
    src: illustration,
    alt: ""
  });
  const desktopIllustration = /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(blocks_list_with_illustration_module.illustrationContainer, {
      [blocks_list_with_illustration_module.illustrationHidden]: hidden
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: blocks_list_with_illustration_module.illustration,
      style: {
        backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(illustration)
      },
      ref: illustrationRef
    })
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    ref,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(blocks_list_with_illustration_module.root),
      ref: callbackRef,
      style: {
        marginBottom: margin
      },
      children: [isMobile && mobileIllustration, /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: blocks_list_with_illustration_module.container,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: blocks_list_with_illustration_module.textsBlock,
          children: blocksWithIllustrations.map((block, index, arr) => {
            if (index > visibleBlockIndex) {
              return null;
            }
            const isVisibleContainer = index === visibleBlockIndex && index !== 0;
            if (block.type === "text") {
              return /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
                children: [showTutorInstructions && block["tutor-instruction"] && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
                  data: block["tutor-instruction"]
                }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                  className: blocks_list_with_illustration_module.dialogReplica,
                  children: /* @__PURE__ */(0,jsx_runtime.jsx)(InViewContainer, {
                    marginTop: illustrationHeight,
                    isVisible: isVisibleContainer,
                    onInView: replicaInView => {
                      if (replicaInView) {
                        setIllustration(block.illustration);
                      } else {
                        const prevElement = arr[index - 1];
                        if (prevElement && prevElement.type === "text") {
                          setIllustration(prevElement.illustration);
                        }
                      }
                    },
                    children: /* @__PURE__ */(0,jsx_runtime.jsx)(TextBlock, {
                      text: block.text,
                      audio: block.audio,
                      author: block.author,
                      showNextButton: false,
                      showPrevButton: false,
                      showTutorInstructions: false,
                      controlsPanelButtonsPlace,
                      lastBlock: lastBlock && index === visibleBlockIndex,
                      blockId: block.id
                    })
                  })
                })]
              }, block.id);
            }
          })
        }), !isMobile && desktopIllustration]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        style: {
          marginTop: isMobile && lastBlock ? `80px` : 0
        }
      }), lastBlock && inView && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
        place: controlsPanelButtonsPlace,
        showPrevButton: isShowPrevButton,
        onPrevButtonClick: handlePrevButtonClick,
        showNextButton: isShowNextButton,
        onNextButtonClick: handleNextButtonClick
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/caption-block/caption/caption-desktop.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const caption_desktop_module = ({"image":"caption-desktop-module__image--HM7Md","root":"caption-desktop-module__root--pedBf","title":"caption-desktop-module__title--_cst9","long-text-caption-setting":"caption-desktop-module__long-text-caption-setting--V_pKS","longTextCaptionSetting":"caption-desktop-module__long-text-caption-setting--V_pKS","long-text-caption-root":"caption-desktop-module__long-text-caption-root--EtiGg","longTextCaptionRoot":"caption-desktop-module__long-text-caption-root--EtiGg","long-text-caption-text-container":"caption-desktop-module__long-text-caption-text-container--mgtM2","longTextCaptionTextContainer":"caption-desktop-module__long-text-caption-text-container--mgtM2","long-text-caption-image":"caption-desktop-module__long-text-caption-image--XqnnG","longTextCaptionImage":"caption-desktop-module__long-text-caption-image--XqnnG","image-container":"caption-desktop-module__image-container--R1NPo","imageContainer":"caption-desktop-module__image-container--R1NPo","short-text-caption-title":"caption-desktop-module__short-text-caption-title--H_mxv","shortTextCaptionTitle":"caption-desktop-module__short-text-caption-title--H_mxv","short-text-caption-setting":"caption-desktop-module__short-text-caption-setting--Olons","shortTextCaptionSetting":"caption-desktop-module__short-text-caption-setting--Olons","left-position-image":"caption-desktop-module__left-position-image--X3jSO","leftPositionImage":"caption-desktop-module__left-position-image--X3jSO","left-position-text-container":"caption-desktop-module__left-position-text-container--BfLA1","leftPositionTextContainer":"caption-desktop-module__left-position-text-container--BfLA1","left-position-root":"caption-desktop-module__left-position-root--pQ5Cw","leftPositionRoot":"caption-desktop-module__left-position-root--pQ5Cw"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/caption-block/caption/caption-desktop.component.tsx











const CaptionDesktop = _ref => {
  let {
    imagePosition = null,
    title,
    imageSrc,
    setting = ""
  } = _ref;
  let position = imagePosition;
  if (position === null) {
    position = setting.length > 150 || Array.isArray(setting) ? "right" : "top";
  }
  if (["left", "right"].includes(position)) {
    if (typeof setting === "string") {
      setting = [setting];
    }
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(caption_desktop_module.longTextCaptionRoot, {
        [caption_desktop_module.leftPositionRoot]: position === "left"
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(caption_desktop_module.longTextCaptionTextContainer, {
          [caption_desktop_module.leftPositionTextContainer]: position === "left"
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          className: caption_desktop_module.title,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            rules: translation_tooltip_rule/* translationTooltipRule */.N,
            children: title
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body1, caption_desktop_module.longTextCaptionSetting),
          children: setting.map((s, i) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
              rules: translation_tooltip_rule/* translationTooltipRule */.N,
              children: s
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})]
          }, i))
        })]
      }), imageSrc.length !== 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(caption_desktop_module.longTextCaptionImage, {
          [caption_desktop_module.leftPositionImage]: position === "left"
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          src: imageSrc,
          alt: ""
        })
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: caption_desktop_module.root,
    children: [imageSrc.length !== 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: caption_desktop_module.imageContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        className: caption_desktop_module.image,
        src: imageSrc,
        alt: ""
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()(caption_desktop_module.title, caption_desktop_module.shortTextCaptionTitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        rules: translation_tooltip_rule/* translationTooltipRule */.N,
        children: title
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body1, caption_desktop_module.shortTextCaptionSetting),
      children: Array.isArray(setting) ? setting.map((s, i) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          rules: translation_tooltip_rule/* translationTooltipRule */.N,
          children: s
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})]
      }, i)) : /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        rules: translation_tooltip_rule/* translationTooltipRule */.N,
        children: setting
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/caption-block/caption/caption-mobile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const caption_mobile_module = ({"title":"caption-mobile-module__title--cqxZ8","subtitle":"caption-mobile-module__subtitle--Xd6L0"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/caption-block/caption/caption-mobile.component.tsx











const CaptionMobile = _ref => {
  let {
    title,
    imageSrc,
    setting = ""
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [imageSrc.length !== 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        alt: "Caption",
        src: imageSrc
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()(typography_module/* default */.Z.headline4Accent, caption_mobile_module.title),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        rules: translation_tooltip_rule/* translationTooltipRule */.N,
        children: title
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2, caption_mobile_module.subtitle),
      children: Array.isArray(setting) ? setting.map((s, i) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          rules: translation_tooltip_rule/* translationTooltipRule */.N,
          children: s
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})]
      }, i)) : /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        rules: translation_tooltip_rule/* translationTooltipRule */.N,
        children: setting
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/caption-block/caption-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const caption_block_module = ({"root":"caption-block-module__root--MBf5v","controls":"caption-block-module__controls--Pn0xh","passed":"caption-block-module__passed--sU6tu"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/caption-block/caption-block.component.tsx











const CaptionBlock = _ref => {
  let {
    image = "",
    title = "",
    setting = "",
    lastBlock = false,
    imagePosition,
    showTutorInstructions,
    tutorInstructions,
    onNextBlock,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: caption_block_module.root,
    ref,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), isMobile ? /* @__PURE__ */(0,jsx_runtime.jsx)(CaptionMobile, {
      title,
      imageSrc: image,
      setting
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(CaptionDesktop, {
      imageSrc: image,
      title,
      setting,
      imagePosition
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/grammar-intro-block/grammar-intro/grammar-intro.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const grammar_intro_module = ({"root":"grammar-intro-module__root--qPN0s","text":"grammar-intro-module__text--KQYxM"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/grammar-intro-block/grammar-intro/grammar-intro.component.tsx







const GrammarIntro = _ref => {
  let {
    title,
    text
  } = _ref;
  if (!text) {
    text = [];
  }
  if (typeof text === "string") {
    text = [text];
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: grammar_intro_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "grammar-info title",
        children: title
      })
    }), text.map((t, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: grammar_intro_module.text,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: `grammar-info text-${index}`,
        typography: "body1",
        children: t
      })
    }, index))]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/grammar-intro-block/grammar-intro-block.component.tsx








const GrammarIntroBlock = _ref => {
  let {
    title,
    text = "",
    onNextBlock,
    lastBlock = false,
    showTutorInstructions,
    tutorInstructions,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace
  } = _ref;
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(GrammarIntro, {
      title,
      text
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
// EXTERNAL MODULE: ./src/components/drawing/index.ts + 4 modules
var components_drawing = __webpack_require__(4117);
// EXTERNAL MODULE: ./src/components/drawing/ui/drawing-layout/drawing-layout.tsx + 23 modules
var drawing_layout = __webpack_require__(70448);
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
;// CONCATENATED MODULE: ../ui-kit/src/resizable-image/resizable-image.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const resizable_image_module = ({"image":"resizable-image-module__image--ZcAJx","layout-image-small":"resizable-image-module__layout-image-small--tbmN0","layoutImageSmall":"resizable-image-module__layout-image-small--tbmN0","layout-image-big":"resizable-image-module__layout-image-big--I0wfd","layoutImageBig":"resizable-image-module__layout-image-big--I0wfd","button":"resizable-image-module__button--ur5JF","root":"resizable-image-module__root--i8aCX","layout-transition":"resizable-image-module__layout-transition--Zj7jZ","layoutTransition":"resizable-image-module__layout-transition--Zj7jZ","layout-fade-in":"resizable-image-module__layout-fade-in--YpwHB","layoutFadeIn":"resizable-image-module__layout-fade-in--YpwHB","fade-in":"resizable-image-module__fade-in--ZwmVB","fadeIn":"resizable-image-module__fade-in--ZwmVB"});
;// CONCATENATED MODULE: ../ui-kit/src/resizable-image/resizable-image.component.tsx












const resizable_image_component_logger = logger/* ClientLogger */.q$.create("resizable-image");
const debug = resizable_image_component_logger.debug.bind(resizable_image_component_logger);
const ResizableImage = _ref => {
  let {
    loading,
    decoding = "async",
    startSize = "small",
    enableDrawing = false,
    showToolbox = false,
    toolboxCustomButtons = array_utils/* emptyArray */.ow,
    hideResizeButton = false,
    onResize,
    exceptionId,
    ...otherImageProps
  } = _ref;
  const [imageSize, setImageSize] = (0,react.useState)(startSize);
  const [imageShape, setImageShape] = (0,react.useState)(null);
  const buttonIcon = imageSize === "small" ? "vector" : "collapse";
  const handleButtonClick = (0,react.useCallback)(() => {
    onResize?.();
    setEnableAnimation(true);
    if (imageSize === "small") {
      return setImageSize("big");
    }
    return setImageSize("small");
  }, [imageSize, onResize]);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const BASE_WIDTH = 1e3;
  const [nWidth, setNaturalWidth] = (0,react.useState)(BASE_WIDTH);
  const [nHeight, setNaturalHeight] = (0,react.useState)(0);
  const [width, setWidth] = (0,react.useState)("0");
  const [enableAnimation, setEnableAnimation] = (0,react.useState)(false);
  const handleImgLoaded = (0,react.useCallback)(_ref2 => {
    let {
      currentTarget: {
        naturalWidth,
        naturalHeight
      }
    } = _ref2;
    if (naturalWidth === 0 && naturalHeight === 0) {
      naturalWidth = 800;
      naturalHeight = 592;
    }
    setNaturalWidth(BASE_WIDTH);
    setNaturalHeight(BASE_WIDTH * naturalHeight / naturalWidth);
    const ratio = naturalWidth / naturalHeight;
    if (ratio > 1.1) {
      setImageShape("horizontal");
    } else if (ratio > 0.9) {
      setImageShape("square");
    } else {
      setImageShape("vertical");
    }
  }, []);
  (0,react.useEffect)(() => {
    if (isMobile) {
      setWidth("100%");
    } else {
      switch (imageShape) {
        case "horizontal":
          setWidth(imageSize === "big" ? "min(800px, 100%)" : "min(400px, 100%)");
          break;
        case "square":
          setWidth(imageSize === "big" ? "min(600px, 100%)" : "min(300px, 100%)");
          break;
        case "vertical":
          setWidth("100%");
          break;
        default:
          break;
      }
    }
  }, [imageShape, imageSize, isMobile]);
  const toolBoxHeight = (0,react.useMemo)(() => enableDrawing && showToolbox ? drawing_layout/* OUTSIDE_TOOLBOX_HEIGHT */.X : 0, [enableDrawing, showToolbox]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(components_drawing/* DrawingLayout */.Pb, {
    showCanvas: enableDrawing,
    showToolbox,
    naturalWidth: nWidth,
    naturalHeight: nHeight,
    width,
    fitHeight: `min(calc(600px + ${toolBoxHeight}px), 90vh)`,
    toolboxPosition: "outside",
    toolboxCustomButtons,
    topChildren: hideResizeButton ? void 0 : /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      className: resizable_image_module.button,
      appearance: "floating",
      size: "small",
      iconName: buttonIcon,
      onClick: handleButtonClick
    }),
    className: classnames_default()(resizable_image_module.layoutFadeIn, {
      [resizable_image_module.layoutTransition]: enableAnimation,
      [resizable_image_module.layoutImageBig]: imageSize === "big",
      [resizable_image_module.layoutImageSmall]: imageSize === "small"
    }),
    enableWidthTransition: enableAnimation,
    exceptionId,
    log: debug,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      alt: "",
      ...otherImageProps,
      loading,
      decoding,
      onLoad: handleImgLoaded,
      className: resizable_image_module.image
    })
  });
};
// EXTERNAL MODULE: ./src/components/trainer/renderers/product-trainer-renderer/product-trainer-renderer.context.ts
var product_trainer_renderer_context = __webpack_require__(72360);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/image-block/image-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const image_block_module = ({"root":"image-block-module__root--RaTbx","layout-border-radius":"image-block-module__layout-border-radius--VLj83","layoutBorderRadius":"image-block-module__layout-border-radius--VLj83"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/image-block/image-block.component.tsx











const ImageBlock = _ref => {
  let {
    id,
    url = "",
    lastBlock = false,
    onNextBlock,
    showTutorInstructions,
    tutorInstructions,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace,
    getInitialDrawingState,
    toolboxCustomButtons,
    showToolbox,
    eventEmitter
  } = _ref;
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  const {
    drawing
  } = (0,react.useContext)(product_trainer_renderer_context/* ProductTrainerRendererContextComponent */.p);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: image_block_module.root,
    ref,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(components_drawing/* DrawingContextProvider */.Io, {
      id,
      eventEmitter,
      getInitialDrawingState,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ResizableImage, {
        src: url,
        startSize: "big",
        enableDrawing: drawing,
        showToolbox,
        toolboxCustomButtons,
        exceptionId: `image-block ${id}`,
        hideResizeButton: true
      })
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
// EXTERNAL MODULE: ./src/utils/yandexMetrica.ts
var yandexMetrica = __webpack_require__(11226);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/info-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const info_block_module = ({"root":"info-block-module__root--nS6AR","controls":"info-block-module__controls--oDpRv","passed":"info-block-module__passed--zeNOk","side-image":"info-block-module__side-image--nwjCe","sideImage":"info-block-module__side-image--nwjCe","side-video":"info-block-module__side-video--noIUF","sideVideo":"info-block-module__side-video--noIUF","layout-border-radius":"info-block-module__layout-border-radius--XY1LR","layoutBorderRadius":"info-block-module__layout-border-radius--XY1LR"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/__info-block-media/info-block-media.component.tsx










const InfoBlockMedia = _ref => {
  let {
    id,
    position,
    image,
    video,
    lastBlock,
    getInitialDrawingState,
    toolboxCustomButtons,
    showToolbox,
    eventEmitter
  } = _ref;
  const {
    ref: resizableImageRef,
    inView: resizableImageInView
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true
  });
  const {
    drawing
  } = (0,react.useContext)(product_trainer_renderer_context/* ProductTrainerRendererContextComponent */.p);
  (0,react.useEffect)(() => {
    resizableImageInView && (0,yandexMetrica/* ymGoal */.qf)("Resizable_Image_Visible");
  }, [resizableImageInView]);
  const BASE_WIDTH = 1e3;
  const [nWidth, setNaturalWidth] = (0,react.useState)(BASE_WIDTH);
  const [nHeight, setNaturalHeight] = (0,react.useState)(0);
  const handleImgLoaded = (0,react.useCallback)(_ref2 => {
    let {
      currentTarget: {
        naturalWidth,
        naturalHeight
      }
    } = _ref2;
    if (naturalWidth === 0 && naturalHeight === 0) {
      naturalWidth = 800;
      naturalHeight = 592;
    }
    setNaturalWidth(BASE_WIDTH);
    setNaturalHeight(BASE_WIDTH * naturalHeight / naturalWidth);
  }, []);
  if (image?.url && position === "top") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: resizableImageRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_drawing/* DrawingContextProvider */.Io, {
        id,
        eventEmitter,
        getInitialDrawingState,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ResizableImage, {
          onResize: () => (0,yandexMetrica/* ymGoal */.qf)("Resize_Image"),
          src: image?.url,
          startSize: "big",
          enableDrawing: drawing ?? false,
          showToolbox,
          toolboxCustomButtons,
          exceptionId: `info-block resizable-image ${id}`
        })
      })
    });
  }
  if (image?.url) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(components_drawing/* DrawingContextProvider */.Io, {
      id,
      eventEmitter,
      getInitialDrawingState,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_drawing/* DrawingLayout */.Pb, {
        showCanvas: drawing ?? false,
        showToolbox,
        toolboxCustomButtons,
        width: "100%",
        naturalWidth: nWidth,
        naturalHeight: nHeight,
        exceptionId: `info-block image ${id}`,
        className: info_block_module.layoutBorderRadius,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          style: {
            width: "100%",
            height: "100%"
          },
          className: info_block_module.sideImage,
          src: image.url,
          onLoad: handleImgLoaded,
          alt: ""
        })
      })
    });
  }
  if (video?.url) {
    const {
      url,
      loop = true,
      muted = true,
      "show-controls": showControls = false,
      "auto-play": autoPlay = true
    } = video;
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: info_block_module.sideVideo,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("video", {
        loop,
        muted,
        controls: showControls || !loop || !muted,
        autoPlay: lastBlock && autoPlay,
        playsInline: true,
        preload: "auto",
        className: info_block_module.sideImage,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("source", {
          src: url
        })
      })
    });
  }
  return null;
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/info/__info-text-content/info-text-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const info_text_content_module = ({"root":"info-text-content-module__root--MJMio","info-element":"info-text-content-module__info-element--yNNuB","infoElement":"info-text-content-module__info-element--yNNuB"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/info/__info-text-content/info-text-content.component.tsx








const InfoTextContent = _ref => {
  let {
    text
  } = _ref;
  if (typeof text === "string") {
    text = [text];
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: info_text_content_module.root,
    children: text.map((str, index) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: `info-text text-${index}`,
        typography: "body1",
        children: str
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "\n"
      })]
    }, index))
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/info/info.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const info_module = ({"side-info-root":"info-module__side-info-root--MgQh7","sideInfoRoot":"info-module__side-info-root--MgQh7","left-position-root":"info-module__left-position-root--Tg8iT","leftPositionRoot":"info-module__left-position-root--Tg8iT","top-position-root":"info-module__top-position-root--e1wa4","topPositionRoot":"info-module__top-position-root--e1wa4","side-info-text-container":"info-module__side-info-text-container--G25tp","sideInfoTextContainer":"info-module__side-info-text-container--G25tp","left-position-text-container":"info-module__left-position-text-container--aTbjP","leftPositionTextContainer":"info-module__left-position-text-container--aTbjP","top-position-text-container":"info-module__top-position-text-container--DBzRu","topPositionTextContainer":"info-module__top-position-text-container--DBzRu","side-info-image":"info-module__side-info-image--preJ9","sideInfoImage":"info-module__side-info-image--preJ9","left-position-image":"info-module__left-position-image--JCc_p","leftPositionImage":"info-module__left-position-image--JCc_p","top-position-image":"info-module__top-position-image--ktspk","topPositionImage":"info-module__top-position-image--ktspk"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/info/info.component.tsx






const rootAlignmentClassMap = {
  top: info_module.topPositionRoot,
  left: info_module.leftPositionRoot,
  right: info_module.sideInfoRoot
};
const textContainerAlignmentClassMap = {
  top: info_module.topPositionTextContainer,
  left: info_module.leftPositionTextContainer,
  right: info_module.sideInfoTextContainer
};
const imageAlignmentClassMap = {
  top: info_module.topPositionImage,
  left: info_module.leftPositionImage,
  right: info_module.sideInfoImage
};
const Info = _ref => {
  let {
    text,
    renderChild,
    childPosition,
    children
  } = _ref;
  childPosition = childPosition ?? "left";
  if (!renderChild) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(InfoTextContent, {
      text
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(info_module.sideInfoRoot, rootAlignmentClassMap[childPosition]),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(info_module.sideInfoTextContainer, textContainerAlignmentClassMap[childPosition]),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(InfoTextContent, {
        text
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(info_module.sideInfoImage, imageAlignmentClassMap[childPosition]),
      children
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/info-block/info-block.component.tsx










const InfoBlock = _ref => {
  let {
    id,
    text = "",
    lastBlock = false,
    onNextBlock,
    image,
    video,
    showTutorInstructions,
    tutorInstructions,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace,
    getInitialDrawingState,
    toolboxCustomButtons,
    showToolbox,
    eventEmitter
  } = _ref;
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  const position = (0,react.useMemo)(() => {
    if (image?.url) {
      return image.align;
    }
    return video?.align;
  }, [image, video]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: info_block_module.root,
    ref,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Info, {
      text,
      renderChild: Boolean(image?.url || video?.url),
      childPosition: position,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(InfoBlockMedia, {
        id,
        position,
        image,
        video,
        lastBlock,
        getInitialDrawingState,
        toolboxCustomButtons,
        showToolbox,
        eventEmitter
      })
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
;// CONCATENATED MODULE: ../shared/src/hooks/useScroll.ts



const useScroll = handler => {
  const scrollHandler = (0,react.useCallback)(() => {
    handler(window.scrollY);
  }, [handler]);
  (0,react.useEffect)(() => {
    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/intro-block/intro/intro.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const intro_module = ({"root":"intro-module__root--iDvAF","image-wrapper":"intro-module__image-wrapper--kTAn6","imageWrapper":"intro-module__image-wrapper--kTAn6","image":"intro-module__image--x8LV5","title":"intro-module__title--JXix8","setting":"intro-module__setting--gjcLw","full-size-image":"intro-module__full-size-image--VgPtx","fullSizeImage":"intro-module__full-size-image--VgPtx","cutted-size-image":"intro-module__cutted-size-image--h7Ak6","cuttedSizeImage":"intro-module__cutted-size-image--h7Ak6","opacity-animation":"intro-module__opacity-animation--aI8cg","opacityAnimation":"intro-module__opacity-animation--aI8cg"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/intro-block/intro/intro.component.tsx












var ImageStyle = /* @__PURE__ */(ImageStyle2 => {
  ImageStyle2["Fullsize"] = "fullsize";
  ImageStyle2["Cutted"] = "cutted";
  return ImageStyle2;
})(ImageStyle || {});
const imageStyleClass = {
  ["fullsize" /* Fullsize */]: intro_module.fullSizeImage,
  ["cutted" /* Cutted */]: intro_module.cuttedSizeImage
};
const Intro = _ref => {
  let {
    title,
    imageSrc,
    setting
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [imageStyle, setImageStyles] = (0,react.useState)("cutted" /* Cutted */);
  const scrollHandler = (0,react.useCallback)(scroll => {
    if (scroll >= 200 && imageStyle !== "fullsize" /* Fullsize */) {
      setImageStyles("fullsize" /* Fullsize */);
    } else if (scroll < 200 && imageStyle !== "cutted" /* Cutted */) {
      setImageStyles("cutted" /* Cutted */);
    }
  }, [imageStyle]);
  useScroll(scrollHandler);
  if (typeof setting === "string") {
    setting = [setting];
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: intro_module.root,
    children: [imageSrc && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: intro_module.imageWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(intro_module.image, imageStyleClass[imageStyle]),
        style: {
          backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(imageSrc)
        }
      })
    }), title && /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      className: intro_module.title,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "intro title",
        typography: isMobile ? "headline3" : void 0,
        children: title
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: intro_module.setting,
      children: setting.map((s, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: `intro setting-${index}`,
        typography: "body1",
        children: s
      }, index))
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/intro-block/intro-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const intro_block_module = ({"root":"intro-block-module__root--EpJUQ","controls":"intro-block-module__controls--WyMfH","passed":"intro-block-module__passed--WnhR4"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/intro-block/intro-block.component.tsx









const IntroBlock = _ref => {
  let {
    title = "",
    image = "",
    setting = "",
    onNextBlock,
    lastBlock = false,
    showTutorInstructions,
    tutorInstructions,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace
  } = _ref;
  const {
    inView,
    ref
  } = (0,react_intersection_observer_m/* useInView */.YD)();
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref,
    className: intro_block_module.root,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Intro, {
      title,
      imageSrc: image,
      setting
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/picture/picture.component.tsx + 1 modules
var picture_component = __webpack_require__(33364);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/lexis-info-block/lexis-info-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const lexis_info_block_module = ({"root":"lexis-info-block-module__root--eBW2H","picture":"lexis-info-block-module__picture--rK9lJ","context":"lexis-info-block-module__context--vP_pq","audio-icon":"lexis-info-block-module__audio-icon--pYCYS","audioIcon":"lexis-info-block-module__audio-icon--pYCYS","audio-icon-svg":"lexis-info-block-module__audio-icon-svg--Dlu88","audioIconSvg":"lexis-info-block-module__audio-icon-svg--Dlu88","context-target":"lexis-info-block-module__context-target--SXnxH","contextTarget":"lexis-info-block-module__context-target--SXnxH","contexts":"lexis-info-block-module__contexts--IHoWF","term-wrapper":"lexis-info-block-module__term-wrapper--eyqSQ","termWrapper":"lexis-info-block-module__term-wrapper--eyqSQ","term":"lexis-info-block-module__term--z9No4"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/lexis-info-block/lexis-info-block.component.tsx


















const Context = _ref => {
  let {
    target,
    source
  } = _ref;
  const {
    playFromStart,
    canPlay,
    waiting
  } = (0,useAudio/* useAudioHandler */.GH)((0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(target), "lexis");
  const loading = useLoader(waiting);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: lexis_info_block_module.context,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      disabled: !canPlay,
      appearance: "default",
      size: "medium",
      iconName: "speaker",
      className: lexis_info_block_module.audioIcon,
      classes: {
        buttonIcon: lexis_info_block_module.audioIconSvg
      },
      onFocus: e => {
        e.currentTarget.blur();
      },
      onClick: playFromStart,
      loading
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: typography_module/* default */.Z.headline4Accent,
        children: target
      }), source && /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: classnames_default()(typography_module/* default */.Z.body2, lexis_info_block_module.contextTarget),
        children: source
      })]
    })]
  });
};
const LexisInfo = _ref2 => {
  let {
    synonyms,
    image,
    contexts,
    term,
    translations,
    showTutorInstructions,
    tutorInstructions,
    onNextBlock,
    lastBlock,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace
  } = _ref2;
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: lexis_info_block_module.root,
    ref,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: lexis_info_block_module.termWrapper,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.headline3, lexis_info_block_module.term),
        children: term
      }), translations.map(t => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4,
        children: t
      }, t)), synonyms && synonyms.map(s => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4,
        children: s
      }, s)), image && /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
        src: image,
        classes: {
          root: lexis_info_block_module.picture
        }
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: lexis_info_block_module.contexts,
      children: contexts.map(c => /* @__PURE__ */(0,jsx_runtime.jsx)(Context, {
        target: c.target,
        source: c.source
      }, `${c.target}_${c.source}`))
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/@xstate/react/es/useMachine.js + 1 modules
var useMachine = __webpack_require__(95640);
// EXTERNAL MODULE: ../../node_modules/react-sticky/lib/index.js
var lib = __webpack_require__(45714);
// EXTERNAL MODULE: ../shared/src/models/trainer/trainer.model.ts
var trainer_model = __webpack_require__(97703);
// EXTERNAL MODULE: ../ui-kit/src/error-boundary/error-boundary.tsx
var error_boundary = __webpack_require__(514);
// EXTERNAL MODULE: ./src/state-machine/mechanic/mechanic.machine.consts.ts
var mechanic_machine_consts = __webpack_require__(74027);
;// CONCATENATED MODULE: ./src/state-machine/mechanic/mechanic.machine.utils.ts



const isSubmitState = value => value === mechanic_machine_consts/* STATES */.PO.SUBMITTED;
;// CONCATENATED MODULE: ./src/utils/translations.ts


const isEnglishText = text => /[A-z]/i.test(text);
// EXTERNAL MODULE: ./src/components/skip-mechanic-button/skip-mechanic-button.component.tsx + 1 modules
var skip_mechanic_button_component = __webpack_require__(63469);
// EXTERNAL MODULE: ./src/components/submit-mechanic-button/submit-mechanic-button.component.tsx + 1 modules
var submit_mechanic_button_component = __webpack_require__(2280);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../ui-kit/src/side-menu/side-menu.component.tsx + 1 modules
var side_menu_component = __webpack_require__(23725);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
;// CONCATENATED MODULE: ./src/hooks/useGrammarReferences.ts





const useGrammarReferences = () => {
  const [references, setReferences] = (0,react.useState)({});
  const fetchReferences = (0,react.useCallback)(async () => {
    const response = await (0,bunker_api/* getGrammarReferences */.Zw)();
    if ((0,Either.isRight)(response)) {
      setReferences(response.right);
    }
  }, []);
  (0,react.useEffect)(() => {
    void fetchReferences();
  }, [fetchReferences]);
  const get = (0,react.useCallback)(key => references[key], [references]);
  return {
    get
  };
};
;// CONCATENATED MODULE: ./src/components/grammar-reference/grammar-reference.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const grammar_reference_module = ({"references-container":"grammar-reference-module__references-container--yIl_j","referencesContainer":"grammar-reference-module__references-container--yIl_j"});
;// CONCATENATED MODULE: ./src/components/grammar-reference/grammar-reference.component.tsx










const GrammarReference = _ref => {
  let {
    referenceId,
    onClose,
    open
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    get: getReference
  } = useGrammarReferences();
  const grammarReference = (0,react.useMemo)(() => {
    if (referenceId) {
      return getReference(referenceId);
    }
    return null;
  }, [getReference, referenceId]);
  (0,react.useEffect)(() => {
    if (open && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open, isMobile]);
  if (!grammarReference || !open) {
    return null;
  }
  return react_dom.createPortal( /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: grammar_reference_module.referencesContainer,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(side_menu_component/* SideMenu */.f, {
      isMobile,
      title: "Grammar Reference",
      onClose,
      children: grammarReference?.text.map((sentence, index) => /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          children: sentence
        }, sentence), /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})]
      }, index))
    })
  }), document.body);
};
;// CONCATENATED MODULE: ./src/components/trainer-clue-button/mechanic-clue-button/mechanic-clue-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const mechanic_clue_button_module = ({"root":"mechanic-clue-button-module__root--_PsHQ","button-root":"mechanic-clue-button-module__button-root--shUaQ","buttonRoot":"mechanic-clue-button-module__button-root--shUaQ","button-root-hidden":"mechanic-clue-button-module__button-root-hidden--zAHl6","buttonRootHidden":"mechanic-clue-button-module__button-root-hidden--zAHl6","text":"mechanic-clue-button-module__text--uIyiM","hint-container":"mechanic-clue-button-module__hint-container--pxj9P","hintContainer":"mechanic-clue-button-module__hint-container--pxj9P","hint-container-hidden":"mechanic-clue-button-module__hint-container-hidden--OkUlk","hintContainerHidden":"mechanic-clue-button-module__hint-container-hidden--OkUlk","hint-text":"mechanic-clue-button-module__hint-text--L_aus","hintText":"mechanic-clue-button-module__hint-text--L_aus","hint-button":"mechanic-clue-button-module__hint-button--swyqi","hintButton":"mechanic-clue-button-module__hint-button--swyqi","secondary-button":"mechanic-clue-button-module__secondary-button--iepWE","secondaryButton":"mechanic-clue-button-module__secondary-button--iepWE","action-buttons":"mechanic-clue-button-module__action-buttons--DrdGg","actionButtons":"mechanic-clue-button-module__action-buttons--DrdGg"});
;// CONCATENATED MODULE: ./src/components/trainer-clue-button/mechanic-clue-button/mechanic-clue-button.component.tsx











const MechanicClueButton = _ref => {
  let {
    onClickSecondaryButton,
    isVisibleSecondaryButton,
    hintTitle,
    hintText,
    secondaryButtonText,
    hintActionButtonText
  } = _ref;
  const [visible, setVisible] = (0,react.useState)(false);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: mechanic_clue_button_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "primary",
      size: "small",
      iconName: "help",
      onClick: () => setVisible(true)
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(mechanic_clue_button_module.hintContainer, {
        [mechanic_clue_button_module.hintContainerHidden]: !visible
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.body2Accent,
        children: hintTitle
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.caption, mechanic_clue_button_module.hintText),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          rules: translation_tooltip_rule/* translationTooltipRule */.N,
          children: hintText
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: mechanic_clue_button_module.actionButtons,
        children: [isVisibleSecondaryButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          onClick: () => {
            onClickSecondaryButton();
            setVisible(false);
          },
          className: mechanic_clue_button_module.secondaryButton,
          appearance: "secondary",
          size: "small",
          children: secondaryButtonText
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: mechanic_clue_button_module.hintButton,
          size: "small",
          appearance: "primary",
          onClick: () => {
            setVisible(false);
          },
          children: hintActionButtonText
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer-clue-button/trainer-clue-button.component.tsx







const TrainerClueButton = _ref => {
  let {
    grammarReferenceId,
    hintTitle,
    hintText,
    hintActionButtonText
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isVisibleGrammar, setVisibleGrammar] = (0,react.useState)(false);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(GrammarReference, {
      onClose: () => setVisibleGrammar(false),
      referenceId: grammarReferenceId,
      open: isVisibleGrammar
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicClueButton, {
      secondaryButtonText: intl.formatMessage({
        id: "trainerClueButton.hintSecondaryButtonText",
        defaultMessage: "More"
      }),
      onClickSecondaryButton: () => setVisibleGrammar(true),
      isVisibleSecondaryButton: Boolean(grammarReferenceId),
      hintTitle: hintTitle ?? intl.formatMessage({
        id: "mechanicBlock.hintTitle"
      }),
      hintText,
      hintActionButtonText: hintActionButtonText ?? intl.formatMessage({
        id: "mechanicBlock.hintActionButtonText"
      })
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/utils/time/time.ts
var time = __webpack_require__(67288);
;// CONCATENATED MODULE: ../ui-kit/src/progress-bar/progress-bar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const progress_bar_module = ({"progress-bar-default":"progress-bar-module__progress-bar-default--sI5Bf","progressBarDefault":"progress-bar-module__progress-bar-default--sI5Bf","progress-bar-light":"progress-bar-module__progress-bar-light--WQgsB","progressBarLight":"progress-bar-module__progress-bar-light--WQgsB","progress-bar-dark":"progress-bar-module__progress-bar-dark--HRY08","progressBarDark":"progress-bar-module__progress-bar-dark--HRY08","progress":"progress-bar-module__progress--GgEN9","label":"progress-bar-module__label--c1W4i"});
;// CONCATENATED MODULE: ../ui-kit/src/progress-bar/progress-bar.component.tsx






var ProgressBarTheme = /* @__PURE__ */(ProgressBarTheme2 => {
  ProgressBarTheme2["Light"] = "light";
  ProgressBarTheme2["Dark"] = "dark";
  return ProgressBarTheme2;
})(ProgressBarTheme || {});
const themeCssMap = {
  ["light" /* Light */]: progress_bar_module.progressBarLight,
  ["dark" /* Dark */]: progress_bar_module.progressBarDark
};
const progress_bar_component_ProgressBar = _ref => {
  let {
    value,
    maxValue = 100,
    valueLabel,
    maxValueLabel,
    theme = "light" /* Light */
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(progress_bar_module.progressBarDefault, themeCssMap[theme]),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(progress_bar_module.label, typography_module/* default */.Z.captionAccent),
      children: valueLabel || value
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("progress", {
      value,
      max: maxValue,
      className: progress_bar_module.progress
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(progress_bar_module.label, typography_module/* default */.Z.captionAccent),
      children: maxValueLabel || maxValue
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/video/video.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const video_module = ({"container":"video-module__container--decsL","video":"video-module__video--th7XC","video-mobile":"video-module__video-mobile--IDLgW","videoMobile":"video-module__video-mobile--IDLgW","video-hidden":"video-module__video-hidden--gj2zn","videoHidden":"video-module__video-hidden--gj2zn","widget-desktop":"video-module__widget-desktop--qcRyw","widgetDesktop":"video-module__widget-desktop--qcRyw","widget-mobile":"video-module__widget-mobile--CtvBA","widgetMobile":"video-module__widget-mobile--CtvBA","widget-without-video":"video-module__widget-without-video--t_Wp5","widgetWithoutVideo":"video-module__widget-without-video--t_Wp5","button":"video-module__button--BAR04","progress":"video-module__progress--njyZ5"});
;// CONCATENATED MODULE: ../ui-kit/src/video/video.component.tsx











const videoSourceTypeMap = {
  mp4: "video/mp4",
  avi: "video/avi",
  webm: "video/webm"
};
var VideoMode = /* @__PURE__ */(VideoMode2 => {
  VideoMode2["Desktop"] = "desktop";
  VideoMode2["Mobile"] = "mobile";
  return VideoMode2;
})(VideoMode || {});
const progressBarModeMap = {
  ["desktop" /* Desktop */]: ProgressBarTheme.Light,
  ["mobile" /* Mobile */]: ProgressBarTheme.Dark
};
function mapSrcToSource(src) {
  const splits = src.split(".");
  const extension = splits[splits.length - 1];
  return {
    src,
    type: videoSourceTypeMap[extension] ?? videoSourceTypeMap.mp4
  };
}
const Video = _ref => {
  let {
    src,
    controls = false,
    loop = false,
    muted = true,
    playsInline = true,
    autoPlay = true,
    disablePictureInPicture = false,
    mode,
    poster,
    textConstants: {
      hiddenBtnAriaLabel,
      showingBtnAriaLabel
    },
    onEnded,
    onStarted,
    onChangeVideoVisible
  } = _ref;
  const [isVideoShow, setVideoShow] = (0,react.useState)(true);
  const [duration, setDuration] = (0,react.useState)(0);
  const [currentTime, setCurrentTime] = (0,react.useState)(0);
  const setVideoShowWrap = (0,react.useCallback)(newValue => {
    setVideoShow(newValue);
    onChangeVideoVisible?.(newValue);
  }, [setVideoShow, onChangeVideoVisible]);
  (0,react.useEffect)(() => {
    if (mode === "desktop" /* Desktop */ && !isVideoShow) {
      setVideoShowWrap(true);
    }
  }, [isVideoShow, mode, setVideoShowWrap]);
  const videoSources = (0,react.useMemo)(() => (Array.isArray(src) ? src : [src]).map(mapSrcToSource), [src]);
  const durationLabel = (0,react.useMemo)(() => (0,time/* convertSecondsToPlayerLabel */.X)(duration), [duration]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: video_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("video", {
      className: classnames_default()(video_module.video, {
        [video_module.videoHidden]: !isVideoShow,
        [video_module.videoMobile]: mode === "mobile" /* Mobile */
      }),
      loop,
      muted,
      controls,
      autoPlay,
      playsInline,
      preload: "auto",
      disablePictureInPicture,
      pip: disablePictureInPicture ? "false" : void 0,
      poster,
      onLoadedData: onStarted ? () => {
        onStarted?.();
      } : void 0,
      onEnded: onEnded ? () => {
        onEnded?.();
      } : void 0,
      onTimeUpdate: e => {
        setCurrentTime(e.currentTarget.currentTime);
      },
      onLoadedMetadata: e => {
        setDuration(e.currentTarget.duration);
      },
      children: videoSources.map(_ref2 => {
        let {
          src: src2,
          type
        } = _ref2;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("source", {
          src: src2,
          type
        }, src2);
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()({
        [video_module.widgetDesktop]: mode === "desktop" /* Desktop */,
        [video_module.widgetMobile]: mode === "mobile" /* Mobile */,
        [video_module.widgetWithoutVideo]: !isVideoShow
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: video_module.progress,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(progress_bar_component_ProgressBar, {
          value: currentTime,
          maxValue: duration,
          theme: progressBarModeMap[mode],
          valueLabel: (0,time/* convertSecondsToPlayerLabel */.X)(currentTime),
          maxValueLabel: durationLabel
        })
      }), mode === "mobile" /* Mobile */ && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        className: video_module.button,
        appearance: "primary",
        iconName: isVideoShow ? "simple-arrow-up" : "simple-arrow-down",
        size: "small",
        "aria-label": isVideoShow ? hiddenBtnAriaLabel : showingBtnAriaLabel,
        onClick: () => {
          setVideoShowWrap(!isVideoShow);
        }
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/video/flex-video.component.tsx





const FlexVideo = _ref => {
  let {
    mobileModeFrom = "mobile",
    ...videoProps
  } = _ref;
  const {
    isMobile,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const useMobileMode = mobileModeFrom === "mobile" ? isMobile : isMobileOrTablet;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Video, {
    ...videoProps,
    mode: useMobileMode ? VideoMode.Mobile : VideoMode.Desktop
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/audio-with-lines/audio-with-lines.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_with_lines_module = ({"root":"audio-with-lines-module__root--Aae6V","play-button":"audio-with-lines-module__play-button--FFcnL","playButton":"audio-with-lines-module__play-button--FFcnL"});
;// CONCATENATED MODULE: ../ui-kit/src/audio-with-lines/audio-with-lines.component.tsx






const AudioWithLines = _ref => {
  let {
    loading,
    playing,
    numberOfLines = 82,
    onFocus,
    onClick,
    disabled = false
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: audio_with_lines_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      size: "medium",
      appearance: "floating",
      className: audio_with_lines_module.playButton,
      iconName: playing ? "pause" : "play",
      onFocus,
      onClick,
      disabled,
      loading
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(AudioLines, {
      numberOfLines,
      playing
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
;// CONCATENATED MODULE: ./src/utils/trainer/option.ts








function checkOptionsType(options, type) {
  return options.every(option => option.type === type);
}
const getOptionAudioSrc = audio => audio.type === "voiceover" ? encodeURI(audio.url) : (0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(audio.text, audio.voice);
const getOptionStringContent = option => {
  const type = option.type;
  switch (type) {
    case trainer_model/* OptionType */.GL.Text:
      return typeof option.text === "string" ? option.text : option.text.join();
    case trainer_model/* OptionType */.GL.Image:
      return option.image.url;
    case trainer_model/* OptionType */.GL.Audio:
      return getOptionAudioSrc(option.audio);
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
;// CONCATENATED MODULE: ./src/components/audio-input/audio-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_input_module = ({"toggle":"audio-input-module__toggle--YsA2n"});
;// CONCATENATED MODULE: ./src/components/audio-input/audio-input.component.tsx











const NUMBER_OF_LINES = 82;
const AudioInput = _ref => {
  let {
    audio,
    lastBlock,
    autoPlay = false,
    className
  } = _ref;
  const src = (0,react.useMemo)(() => getOptionAudioSrc(audio), [audio]);
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    options: {
      triggerOnce: true
    }
  });
  const {
    play,
    playing,
    waiting,
    pause,
    canPlay,
    canPause
  } = (0,useAudio/* useAudioHandler */.GH)(src, "audioInput", {
    autoPlay: lastBlock && inView && autoPlay
  });
  const loading = useLoader(waiting);
  const handleClickPlayButton = (0,react.useCallback)(() => playing ? pause() : play(), [pause, play, playing]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref,
    className,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(AudioWithLines, {
      disabled: playing && !canPause || !playing && !canPlay,
      loading,
      playing,
      numberOfLines: NUMBER_OF_LINES,
      onFocus: e => {
        e.currentTarget.blur();
      },
      onClick: handleClickPlayButton
    }), audio.toggle && /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: "audio-input toggle",
      className: audio_input_module.toggle,
      children: audio.toggle
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/condition-text-input/condition-text-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const condition_text_input_module = ({"root":"condition-text-input-module__root--LJinA","title":"condition-text-input-module__title--nlb02","text":"condition-text-input-module__text--BdIPZ"});
;// CONCATENATED MODULE: ./src/components/condition-text-input/condition-text-input.component.tsx





const ConditionTextInput = _ref => {
  let {
    title,
    text = ""
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: condition_text_input_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "condition-text-input title",
        typography: "headline4Accent",
        className: condition_text_input_module.title,
        children: title
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: "condition-text-input text",
      typography: "body2",
      className: condition_text_input_module.text,
      children: text
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/hint-input/hint-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const hint_input_module = ({"description":"hint-input-module__description--TMeQ2"});
;// CONCATENATED MODULE: ./src/components/hint-input/hint-input.component.tsx





const HintInput = _ref => {
  let {
    title = "",
    description = ""
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "hint-input title",
        typography: "headline4Accent",
        children: title
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: hint_input_module.description,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "hint-input description",
        typography: "body2",
        children: description
      })
    })]
  });
};
const HintInputComponent = _ref2 => {
  let {
    input
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(HintInput, {
    title: input.darkText,
    description: input.lightText
  });
};
;// CONCATENATED MODULE: ./src/components/paragraphs-input/paragraphs-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const paragraphs_input_module = ({"paragraph":"paragraphs-input-module__paragraph--lyD3Z","title-wrapper":"paragraphs-input-module__title-wrapper--nBiNj","titleWrapper":"paragraphs-input-module__title-wrapper--nBiNj"});
;// CONCATENATED MODULE: ./src/components/paragraphs-input/paragraphs-input.component.tsx







const ParagraphsInput = _ref => {
  let {
    paragraphs
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    children: paragraphs.map((p, i) => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: paragraphs_input_module.paragraph,
      children: [(p.title || p.subtitle) && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: paragraphs_input_module.titleWrapper,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          children: p.title && /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
            id: `paragraphs-input paragraph-${i} title`,
            typography: "body1Accent",
            children: p.title
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          children: p.subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
            id: `paragraphs-input paragraph-${i} subtitle`,
            typography: "body2",
            children: p.subtitle
          })
        })]
      }), p.text && /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: `paragraphs-input paragraph-${i} body`,
        typography: "body1",
        children: p.text
      })]
    }, p.title))
  });
};
;// CONCATENATED MODULE: ./src/components/text-input/text-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_input_module = ({"root":"text-input-module__root--dBOEM","audio-button":"text-input-module__audio-button--QpFpu","audioButton":"text-input-module__audio-button--QpFpu","text-with-highlights":"text-input-module__text-with-highlights--OGUAG","textWithHighlights":"text-input-module__text-with-highlights--OGUAG","highlighted-text":"text-input-module__highlighted-text--KwWHy","highlightedText":"text-input-module__highlighted-text--KwWHy"});
;// CONCATENATED MODULE: ./src/components/text-input/text-input.component.tsx













const MARKDOWN_HIGHTLIGHTED_TEXT_REGEXP = /^<[^|]+?>/;
const HIGHTLIGHTED_TEXT_REGEXP = /<[^|]+>/;
const highlightedWordMatcher = simple_markdown_default().inlineRegex(MARKDOWN_HIGHTLIGHTED_TEXT_REGEXP);
const highlightedWordParser = capture => ({
  value: capture[0].replace(/[><]/g, "")
});
const LONG_TEXT_LENGTH = 50;
const highlightedTextRule = {
  ...translation_tooltip_rule/* translationTooltipRule */.N,
  hightlighted: {
    order: 0,
    match: highlightedWordMatcher,
    parse: highlightedWordParser,
    react: _ref => {
      let {
        value
      } = _ref;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: text_input_module.highlightedText,
        children: value
      });
    }
  }
};
const TextInput = _ref2 => {
  let {
    text,
    audio,
    lastBlock,
    autoPlay = false
  } = _ref2;
  if (!Array.isArray(text)) {
    text = [text];
  }
  const isLongText = text.join("").length > LONG_TEXT_LENGTH;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: text_input_module.root,
    children: [audio && /* @__PURE__ */(0,jsx_runtime.jsx)(AudioInput, {
      lastBlock,
      audio,
      autoPlay,
      className: text_input_module.audioButton
    }), text.map((t, i) => {
      if (HIGHTLIGHTED_TEXT_REGEXP.test(t)) {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(text_input_module.textWithHighlights, typography_module/* default */.Z.headline4),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            rules: highlightedTextRule,
            children: t
          })
        }, t);
      }
      return /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
          id: `text-input text-${i}`,
          typography: isLongText ? "body1" : "headline4",
          children: t
        })
      }, t);
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/__mechanic-input/mechanic-input.component.tsx














const MechanicInput = _ref => {
  let {
    input,
    isBlockSubmitted,
    lastBlock,
    onSubmit,
    setVideoShow
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    ref: imageRef,
    inView: imageInView
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true
  });
  const flexVideoTextConstants = (0,react.useMemo)(() => ({
    showingBtnAriaLabel: intl.formatMessage({
      id: "mechanicBlock.testVideo.showingBtnAriaLabel"
    }),
    hiddenBtnAriaLabel: intl.formatMessage({
      id: "mechanicBlock.testVideo.hiddenBtnAriaLabel"
    })
  }), [intl]);
  const handleResizeImage = (0,react.useCallback)(() => (0,yandexMetrica/* ymGoal */.qf)("Resize_Image"), []);
  (0,react.useEffect)(() => {
    imageInView && (0,yandexMetrica/* ymGoal */.qf)("Resizable_Image_Visible");
  }, [imageInView]);
  switch (input.type) {
    case "text":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TextInput, {
        text: input.text,
        audio: input.audio,
        lastBlock
      });
    case "image":
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        ref: imageRef,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ResizableImage, {
          src: input.image.url,
          onResize: handleResizeImage,
          exceptionId: "mechanic-input resizable-image"
        })
      });
    case "audio":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(AudioInput, {
        audio: input.audio,
        lastBlock
      });
    case "paragraphs":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ParagraphsInput, {
        paragraphs: input.paragraphs
      });
    case "condition-text":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ConditionTextInput, {
        text: input.text,
        title: input.title
      });
    case "hint-text":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(HintInputComponent, {
        input
      });
    case "test-video":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FlexVideo, {
        src: input.video.src,
        textConstants: flexVideoTextConstants,
        disablePictureInPicture: true,
        autoPlay: !isBlockSubmitted,
        controls: false,
        muted: false,
        loop: false,
        mobileModeFrom: "tablet",
        onEnded: onSubmit,
        onChangeVideoVisible: setVideoShow
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "not implemented"
      });
  }
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/__mechanic-input/sticky-mechanic-input.component.tsx





const StickyMechanicInput = _ref => {
  let {
    input,
    isBlockSubmitted,
    lastBlock,
    onSubmit,
    setVideoShow
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(lib/* Sticky */.Le, {
    topOffset: 40,
    bottomOffset: 40,
    children: _ref2 => {
      let {
        style
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        style: {
          ...style,
          zIndex: 1
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicInput, {
          input,
          isBlockSubmitted,
          lastBlock,
          onSubmit,
          setVideoShow
        })
      });
    }
  });
};
// EXTERNAL MODULE: ../shared/src/hooks/useDigitKeyPress.ts
var useDigitKeyPress = __webpack_require__(67015);
;// CONCATENATED MODULE: ../shared/src/hooks/useStrictMemo.ts




const useStrictMemo = (calculateFunction, deps) => {
  const lastState = (0,react.useRef)(null);
  if (lastState.current === null || !(0,equals/* default */.Z)(lastState.current.deps, deps)) {
    const value = calculateFunction();
    lastState.current = {
      value,
      deps
    };
    return value;
  }
  return lastState.current.value;
};
;// CONCATENATED MODULE: ./src/hooks/trainer/useOptionsShuffle.ts







const useOptionsShuffle = (options, shuffleHash) => useStrictMemo(() => (0,array_utils/* shuffleArray */.Sy)(options, getOptionStringContent, shuffleHash).map((part, index) => ({
  id: index,
  ...part
})), [options]);
;// CONCATENATED MODULE: ./src/utils/getRandomMessageKey.ts


var MessageType = /* @__PURE__ */(MessageType2 => {
  MessageType2["Success"] = "success";
  MessageType2["Error"] = "error";
  MessageType2["Typo"] = "typo";
  MessageType2["Fork"] = "fork";
  MessageType2["TranslatorTypo"] = "translatorTypo";
  return MessageType2;
})(MessageType || {});
const successMessageKeys = ["trainer.successMessage1", "trainer.successMessage2", "trainer.successMessage3", "trainer.successMessage4", "trainer.successMessage5", "trainer.successMessage6", "trainer.successMessage7"];
const errorMessageKeys = ["trainer.errorMessage1", "trainer.errorMessage2", "trainer.errorMessage3", "trainer.errorMessage4", "trainer.errorMessage5"];
const typoMessageKeys = ["trainer.typoMessage1", "trainer.typoMessage2", "trainer.typoMessage3", "trainer.typoMessage4", "trainer.typoMessage5"];
const TranslatorTypoKeys = ["translationsList.typoText1", "translationsList.typoText2", "translationsList.typoText3"];
const forkMessageKeys = ["trainer.forkMessage1", "trainer.forkMessage2", "trainer.forkMessage3"];
const messagesMap = {
  ["success" /* Success */]: successMessageKeys,
  ["error" /* Error */]: errorMessageKeys,
  ["typo" /* Typo */]: typoMessageKeys,
  ["fork" /* Fork */]: forkMessageKeys,
  ["translatorTypo" /* TranslatorTypo */]: TranslatorTypoKeys
};
const getRandomMessageKey = type => {
  const arr = messagesMap[type];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
};
;// CONCATENATED MODULE: ./src/widgets/mechanic-feedback/feedback/feedback.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_module = ({"root":"feedback-module__root--byj7O","custom-root":"feedback-module__custom-root--dhnkt","customRoot":"feedback-module__custom-root--dhnkt","custom-icon":"feedback-module__custom-icon--F3QuX","customIcon":"feedback-module__custom-icon--F3QuX","children-array":"feedback-module__children-array--TYTax","childrenArray":"feedback-module__children-array--TYTax","scrollable-children-array":"feedback-module__scrollable-children-array--xCP_5","scrollableChildrenArray":"feedback-module__scrollable-children-array--xCP_5","children":"feedback-module__children--m3Hvr"});
;// CONCATENATED MODULE: ./src/widgets/mechanic-feedback/feedback/feedback.component.tsx









const Feedback = _ref => {
  let {
    successMessages = "",
    errorMessages = "",
    success = false,
    children = null,
    isCustom = false,
    isScrollable = false
  } = _ref;
  let messages = success ? successMessages : errorMessages;
  if (Array.isArray(messages)) {
    messages = messages.join("\n");
  }
  const childrenArray = Array.isArray(children) ? children : [children];
  const feedbackWithChildren = children && childrenArray.length > 0;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(feedback_module.root, {
      [feedback_module.customRoot]: isCustom
    }),
    children: [isCustom && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: feedback_module.customIcon,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        size: "large",
        name: "star"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: "feedback message",
      typography: "body1",
      isDarkMode: isCustom,
      children: messages
    }), feedbackWithChildren && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(feedback_module.childrenArray, {
        [feedback_module.scrollableChildrenArray]: isScrollable
      }),
      children: childrenArray.map((child, i) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: feedback_module.children,
        children: typeof child === "string" ? /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
          id: `feedback child-${i}`,
          typography: "headline4",
          isDarkMode: isCustom,
          children: child
        }) : child
      }, i))
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/mechanic-feedback/mechanic-feedback.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const mechanic_feedback_module = ({"feedback-wrapper":"mechanic-feedback-module__feedback-wrapper--wVFel","feedbackWrapper":"mechanic-feedback-module__feedback-wrapper--wVFel"});
;// CONCATENATED MODULE: ./src/widgets/mechanic-feedback/mechanic-feedback.component.tsx






const MechanicFeedback = (0,react.memo)(function TranslatableText(_ref) {
  let {
    children,
    ...feedbackUiProps
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: mechanic_feedback_module.feedbackWrapper,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(Feedback, {
      ...feedbackUiProps,
      children
    })
  });
});
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
;// CONCATENATED MODULE: ../ui-kit/src/audio-output/audio-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_output_module = ({"root":"audio-output-module__root--tOvuQ","button":"audio-output-module__button--xfFBa"});
;// CONCATENATED MODULE: ../ui-kit/src/audio-output/audio-output.component.tsx









const AudioOutput = _ref => {
  let {
    src,
    classes = {},
    iconSize = "large",
    appearance = "default",
    type,
    isStopPropagationNeeded = false
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(audio_output_module, classes);
  const {
    play,
    playing,
    pause,
    canPlay,
    canPause,
    waiting
  } = (0,useAudio/* useAudioHandler */.GH)(src, type);
  const loading = useLoader(waiting);
  const togglePlay = (0,react.useCallback)(event => {
    if (isStopPropagationNeeded) {
      event.stopPropagation();
    }
    if (playing) {
      void pause();
    } else {
      void play();
    }
  }, [isStopPropagationNeeded, playing, pause, play]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classNames.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      disabled: playing && !canPause || !playing && !canPlay,
      className: classNames?.button,
      onClick: togglePlay,
      onFocus: e => e.currentTarget.blur(),
      appearance,
      size: iconSize,
      iconName: playing ? "pause" : "play",
      loading
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/checkbox-button/checkbox-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const checkbox_button_module = ({"root":"checkbox-button-module__root--h_PkF","index":"checkbox-button-module__index--cRpJv","radio":"checkbox-button-module__radio--AYObE","checked-index":"checkbox-button-module__checked-index--qrP8w","checkedIndex":"checkbox-button-module__checked-index--qrP8w","disabled-index":"checkbox-button-module__disabled-index--FdB_R","disabledIndex":"checkbox-button-module__disabled-index--FdB_R","error-index":"checkbox-button-module__error-index--V4fAM","errorIndex":"checkbox-button-module__error-index--V4fAM","success-index":"checkbox-button-module__success-index--cyT_D","successIndex":"checkbox-button-module__success-index--cyT_D","submit-index":"checkbox-button-module__submit-index--lKl7B","submitIndex":"checkbox-button-module__submit-index--lKl7B","unchecked-disabled-error-index":"checkbox-button-module__unchecked-disabled-error-index--EAEmz","uncheckedDisabledErrorIndex":"checkbox-button-module__unchecked-disabled-error-index--EAEmz","input":"checkbox-button-module__input--KhL7o","container":"checkbox-button-module__container--WoIzB","focused":"checkbox-button-module__focused--JIOBl","disabled":"checkbox-button-module__disabled--Q7oZe","disabled-root":"checkbox-button-module__disabled-root--DKxdG","disabledRoot":"checkbox-button-module__disabled-root--DKxdG","error-root":"checkbox-button-module__error-root--RNDYw","errorRoot":"checkbox-button-module__error-root--RNDYw","submit-root":"checkbox-button-module__submit-root--WD5hk","submitRoot":"checkbox-button-module__submit-root--WD5hk","success-root":"checkbox-button-module__success-root--lCodx","successRoot":"checkbox-button-module__success-root--lCodx","unchecked-disabled-error-root":"checkbox-button-module__unchecked-disabled-error-root--H4Vg0","uncheckedDisabledErrorRoot":"checkbox-button-module__unchecked-disabled-error-root--H4Vg0","content":"checkbox-button-module__content--twnlf","disabled-content":"checkbox-button-module__disabled-content--ElbF7","disabledContent":"checkbox-button-module__disabled-content--ElbF7","success-content":"checkbox-button-module__success-content--nLs4P","successContent":"checkbox-button-module__success-content--nLs4P","error-content":"checkbox-button-module__error-content--TaY1w","errorContent":"checkbox-button-module__error-content--TaY1w","unchecked-disabled-error-content":"checkbox-button-module__unchecked-disabled-error-content--nlnWg","uncheckedDisabledErrorContent":"checkbox-button-module__unchecked-disabled-error-content--nlnWg","audio-root":"checkbox-button-module__audio-root--Mndtn","audioRoot":"checkbox-button-module__audio-root--Mndtn"});
;// CONCATENATED MODULE: ../ui-kit/src/checkbox-button/checkbox-button.component.tsx








var Theme = /* @__PURE__ */(Theme2 => {
  Theme2["Default"] = "default";
  Theme2["Audio"] = "audio";
  return Theme2;
})(Theme || {});
const CheckboxButton = _ref => {
  let {
    children,
    index = null,
    checked = false,
    onChange,
    disabled = false,
    type = "default",
    classes = {},
    style = {},
    theme = "default" /* Default */,
    isRadio
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(checkbox_button_module, classes);
  const handleChange = (0,react.useCallback)(e => {
    if (!disabled && onChange !== void 0) {
      onChange(e.target.checked);
    }
  }, [disabled, onChange]);
  const [focused, setFocused] = (0,react.useState)(false);
  const handleFocus = (0,react.useCallback)(() => setFocused(true), []);
  const handleBlur = (0,react.useCallback)(() => setFocused(false), []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
    style,
    className: classnames_default()(classNames.container, {
      [classNames.focused]: focused,
      [classNames.disabled]: disabled
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("label", {
      className: classNames.input,
      tabIndex: 0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
        style: {
          position: "absolute",
          visibility: "hidden"
        },
        type: isRadio ? "radio" : "checkbox",
        checked,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        disabled
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
      className: classnames_default()(classNames.root, {
        [classNames.uncheckedDisabledErrorRoot]: !checked && disabled && type === "error",
        [classNames.errorRoot]: type === "error",
        [classNames.successRoot]: type === "success",
        [classNames.submitRoot]: type === "submit" && checked,
        [classNames.disabledRoot]: disabled,
        [classNames.audioRoot]: theme === "audio" /* Audio */
      }),
      children: [index !== null ? /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.captionAccent, classNames.index, {
          [classNames.checkedIndex]: checked,
          [classNames.disabledIndex]: disabled,
          [classNames.errorIndex]: type === "error",
          [classNames.successIndex]: type === "success",
          [classNames.submitIndex]: type === "submit" && checked,
          [classNames.uncheckedDisabledErrorIndex]: !checked && type === "error" && disabled,
          [classNames.radio]: isRadio === void 0 || isRadio
        }),
        children: index
      }) : null, /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.body2Accent, classNames.content, {
          [classNames.uncheckedDisabledErrorContent]: !checked && disabled && type === "error",
          [classNames.disabledContent]: disabled,
          [classNames.errorContent]: type === "error",
          [classNames.successContent]: type === "success"
        }),
        children
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/audio-checkbox-button/audio-checkbox-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const audio_checkbox_button_module = ({"checkbox-root":"audio-checkbox-button-module__checkbox-root--XCEYm checkbox-button-module__root--h_PkF","checkboxRoot":"audio-checkbox-button-module__checkbox-root--XCEYm checkbox-button-module__root--h_PkF","checkbox-index":"audio-checkbox-button-module__checkbox-index--GYEZ2 checkbox-button-module__index--cRpJv","checkboxIndex":"audio-checkbox-button-module__checkbox-index--GYEZ2 checkbox-button-module__index--cRpJv","audio-output-root":"audio-checkbox-button-module__audio-output-root--rt8th audio-output-module__root--tOvuQ","audioOutputRoot":"audio-checkbox-button-module__audio-output-root--rt8th audio-output-module__root--tOvuQ","audio-button":"audio-checkbox-button-module__audio-button--vsw8H","audioButton":"audio-checkbox-button-module__audio-button--vsw8H","checkbox-container":"audio-checkbox-button-module__checkbox-container--p93gT","checkboxContainer":"audio-checkbox-button-module__checkbox-container--p93gT","checkbox-content":"audio-checkbox-button-module__checkbox-content--B0a23","checkboxContent":"audio-checkbox-button-module__checkbox-content--B0a23","audio-output-button":"audio-checkbox-button-module__audio-output-button--ykoXt","audioOutputButton":"audio-checkbox-button-module__audio-output-button--ykoXt","audio-wave-wrapper":"audio-checkbox-button-module__audio-wave-wrapper--b10QP","audioWaveWrapper":"audio-checkbox-button-module__audio-wave-wrapper--b10QP","progress-wave":"audio-checkbox-button-module__progress-wave--WRQG0","progressWave":"audio-checkbox-button-module__progress-wave--WRQG0"});
;// CONCATENATED MODULE: ../ui-kit/src/audio-checkbox-button/audio-checkbox-button.component.tsx







const AudioCheckboxButton = _ref => {
  let {
    children,
    src,
    classes = {},
    ...props
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(audio_checkbox_button_module, classes);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(CheckboxButton, {
    ...props,
    classes: {
      root: classNames.checkboxRoot,
      container: classNames.checkboxContainer,
      index: classNames.checkboxIndex,
      content: classNames.checkboxContent
    },
    theme: Theme.Audio,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(AudioOutput, {
      src,
      type: "chooseAudio",
      classes: {
        root: classNames.audioOutputRoot,
        button: classNames.audioOutputButton
      }
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/choose-controls/choose-text-checkbox-button/choose-text-checkbox-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const choose_text_checkbox_button_module = ({"input":"choose-text-checkbox-button-module__input--OuTZ7","container":"choose-text-checkbox-button-module__container--nJ2A8","disabled":"choose-text-checkbox-button-module__disabled--Bp1mK","selected":"choose-text-checkbox-button-module__selected--_v20e","icon":"choose-text-checkbox-button-module__icon--VHseY","is-radio":"choose-text-checkbox-button-module__is-radio--FIFjP","isRadio":"choose-text-checkbox-button-module__is-radio--FIFjP","number":"choose-text-checkbox-button-module__number--uZjC3","checkmark":"choose-text-checkbox-button-module__checkmark--g2F35","error-icon":"choose-text-checkbox-button-module__error-icon--Bo4GQ","errorIcon":"choose-text-checkbox-button-module__error-icon--Bo4GQ","success-icon":"choose-text-checkbox-button-module__success-icon--zAWXb","successIcon":"choose-text-checkbox-button-module__success-icon--zAWXb","focused":"choose-text-checkbox-button-module__focused--vY2vo","error":"choose-text-checkbox-button-module__error--b1ViB","success":"choose-text-checkbox-button-module__success--r32XR","submit":"choose-text-checkbox-button-module__submit--qjzUL","correct-not-selected":"choose-text-checkbox-button-module__correct-not-selected--cLDln","correctNotSelected":"choose-text-checkbox-button-module__correct-not-selected--cLDln","icon-radio":"choose-text-checkbox-button-module__icon-radio--NHGJl","iconRadio":"choose-text-checkbox-button-module__icon-radio--NHGJl"});
;// CONCATENATED MODULE: ../ui-kit/src/choose-controls/choose-text-checkbox-button/choose-text-checkbox-button.component.tsx









var choose_text_checkbox_button_component_Theme = /* @__PURE__ */(Theme2 => {
  Theme2["Default"] = "default";
  Theme2["Audio"] = "audio";
  return Theme2;
})(choose_text_checkbox_button_component_Theme || {});
const ChooseTextCheckboxButton = _ref => {
  let {
    children,
    index = null,
    checked = false,
    onChange,
    disabled = false,
    type = "default",
    classes = {},
    style = {},
    isRadio
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(choose_text_checkbox_button_module, classes);
  const [focused, setFocused] = (0,react.useState)(false);
  const labelRef = (0,react.useRef)(null);
  const handleFocus = (0,react.useCallback)(() => setFocused(true), []);
  const handleBlur = (0,react.useCallback)(() => setFocused(false), []);
  const handleChange = (0,react.useCallback)(e => {
    if (!disabled && onChange !== void 0) {
      onChange(e.target.checked);
    }
    if (labelRef.current) {
      labelRef.current.blur();
    }
    handleBlur();
  }, [disabled, handleBlur, onChange]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
    style,
    className: classnames_default()(classNames.container, {
      [classNames.focused]: focused,
      [classNames.disabled]: disabled,
      [classNames.selected]: checked,
      [classNames.success]: checked && disabled && type === "success",
      [classNames.error]: checked && disabled && type === "error",
      [classNames.submit]: type === "submit",
      [classNames.isRadio]: isRadio,
      [classNames.correctNotSelected]: !checked && disabled && type === "error"
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("label", {
      ref: labelRef,
      className: classNames.input,
      onFocus: handleFocus,
      onBlur: handleBlur,
      tabIndex: 0,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
        style: {
          position: "absolute",
          visibility: "hidden"
        },
        type: "checkbox",
        checked,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        disabled
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(choose_text_checkbox_button_module.icon, {
        [classNames.iconRadio]: isRadio,
        [classNames.errorIcon]: checked && disabled && type === "error",
        [classNames.successIcon]: checked && disabled && type === "success"
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(choose_text_checkbox_button_module.number, typography_module/* default */.Z.captionAccent),
        children: index
      }), !isRadio && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: choose_text_checkbox_button_module.checkmark,
        name: "checkmark",
        size: "small"
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: typography_module/* default */.Z.headline4,
      children
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/image-checkbox-button/image-checkbox-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const image_checkbox_button_module = ({"picture":"image-checkbox-button-module__picture--GLX4l","checkbox-index":"image-checkbox-button-module__checkbox-index--prX79 checkbox-button-module__index--cRpJv","checkboxIndex":"image-checkbox-button-module__checkbox-index--prX79 checkbox-button-module__index--cRpJv","checkbox-root":"image-checkbox-button-module__checkbox-root--W00K5 checkbox-button-module__root--h_PkF","checkboxRoot":"image-checkbox-button-module__checkbox-root--W00K5 checkbox-button-module__root--h_PkF","checkbox-container":"image-checkbox-button-module__checkbox-container--cq4zC","checkboxContainer":"image-checkbox-button-module__checkbox-container--cq4zC"});
;// CONCATENATED MODULE: ../ui-kit/src/image-checkbox-button/image-checkbox-button.component.tsx








const ImageCheckboxButton = _ref => {
  let {
    src,
    classes = {},
    ...props
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(image_checkbox_button_module, classes);
  const style = (0,react.useMemo)(() => ({
    backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(src),
    display: "block"
  }), [src]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(CheckboxButton, {
    ...props,
    classes: {
      root: classNames.checkboxRoot,
      index: classNames.checkboxIndex,
      container: classNames.checkboxContainer
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      style,
      className: classNames.picture
    })
  });
};
;// CONCATENATED MODULE: ./src/components/choose-output/choose-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const choose_output_module = ({"root":"choose-output-module__root--tFL_3","horizontal-root":"choose-output-module__horizontal-root--tmHQ_","horizontalRoot":"choose-output-module__horizontal-root--tmHQ_","checkbox-button-wrapper":"choose-output-module__checkbox-button-wrapper--Slmba","checkboxButtonWrapper":"choose-output-module__checkbox-button-wrapper--Slmba"});
;// CONCATENATED MODULE: ./src/components/choose-output/choose-option/choose-option.component.tsx










const ChooseOption = _ref => {
  let {
    index,
    option,
    isRadio = true,
    type,
    isDisabled = false,
    isChecked,
    onChange
  } = _ref;
  const handleChange = (0,react.useCallback)(() => {
    onChange(index);
  }, [index, onChange]);
  switch (option.type) {
    case "text":
      {
        const text = Array.isArray(option.text) ? option.text.join(" ") : option.text;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: choose_output_module.checkboxButtonWrapper,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChooseTextCheckboxButton, {
            index: index + 1,
            disabled: isDisabled,
            checked: isChecked,
            type,
            onChange: handleChange,
            isRadio,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
              wrapper: markdown_component/* Wrapper */.im.fragment,
              children: text
            })
          })
        });
      }
    case "image":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: choose_output_module.checkboxButtonWrapper,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(ImageCheckboxButton, {
            isRadio,
            index: index + 1,
            type,
            disabled: isDisabled,
            checked: isChecked,
            onChange: handleChange,
            src: option.image.url
          })
        });
      }
    case "audio":
      {
        const src = getOptionAudioSrc(option.audio);
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: choose_output_module.checkboxButtonWrapper,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(AudioCheckboxButton, {
            isRadio,
            index: index + 1,
            type,
            disabled: isDisabled,
            checked: isChecked,
            onChange: handleChange,
            src
          })
        });
      }
    default:
      return null;
  }
};
;// CONCATENATED MODULE: ./src/components/choose-output/choose-output.component.tsx




























const ChooseOutput = _ref => {
  let {
    variants: options,
    feedback,
    shuffleHash,
    mechanicMachine,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    disableKeyPress,
    isNotShuffled = false
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const answer = (0,react.useMemo)(() => state?.context.answer || {}, [state?.context.answer]);
  const optionsType = options[0].type;
  const intl = (0,useIntl/* default */.Z)();
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const correctOptions = (0,react.useMemo)(() => options.reduce((acc, option, index) => {
    if (option["correct?"]) {
      acc.push({
        ...option,
        id: index
      });
    }
    return acc;
  }, []), [options]);
  const isSuccessAnswer = (0,react.useCallback)(answer2 => options.every((option, index) => {
    const checked = answer2[index];
    const correct = option["correct?"];
    return correct && checked || !correct && !checked;
  }), [options]);
  const isSuccess = (0,react.useMemo)(() => isSuccessAnswer(answer), [isSuccessAnswer, answer]);
  const isForkChoose = (0,react.useMemo)(() => !options.some(o => o["correct?"]), [options]);
  const isSuccessMechanicAnswer = isSuccess || isForkChoose;
  const isCustomFeedback = Boolean(isSuccessMechanicAnswer && feedback?.["on-success"] || !isSuccessMechanicAnswer && feedback?.["on-error"]);
  const successMessages = (0,react.useMemo)(() => {
    const unSuccessMessage = isForkChoose ? intl.formatMessage({
      id: getRandomMessageKey(MessageType.Fork)
    }) : intl.formatMessage({
      id: getRandomMessageKey(MessageType.Success)
    });
    return feedback?.["on-success"] ?? unSuccessMessage;
  }, [feedback, intl, isForkChoose]);
  const errorMessages = (0,react.useMemo)(() => feedback?.["on-error"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Error)
  }), [feedback, intl]);
  const isSingleChoose = (0,react.useMemo)(() => correctOptions.length === 1 || isForkChoose, [correctOptions, isForkChoose]);
  const optionsArray = options.map((option, index) => ({
    ...option,
    id: index
  }));
  const shuffledOptionsArray = useOptionsShuffle(optionsArray, shuffleHash);
  const shuffledOptions = isNotShuffled ? optionsArray : shuffledOptionsArray;
  const handleSelectOption = (0,react.useCallback)(i => {
    const index = shuffledOptions[i].id;
    const contextAnswer = answer;
    const data = isSingleChoose ? {
      [index]: !contextAnswer[index]
    } : {
      ...contextAnswer,
      [index]: !contextAnswer[index]
    };
    const checkedCheckboxes = Object.keys(data).filter(key => data[key]);
    if (checkedCheckboxes.length === 0) {
      return send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: data,
          correct: isSuccessAnswer(data)
        }
      });
    }
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: isSuccessAnswer(data)
      }
    });
  }, [shuffledOptions, answer, isSingleChoose, send, isSuccessAnswer]);
  const handleSelectCode = (0,react.useCallback)(digit => {
    if (digit >= 1 && digit <= options.length) {
      handleSelectOption(digit - 1);
    }
  }, [handleSelectOption, options.length]);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(handleSelectCode, disableKeyPress);
  const isVisibleFeedback = isSubmitState(state.value);
  const getAnswerStatus = (correct, checked) => {
    if (isForkChoose) {
      return "submit";
    }
    if (checked && correct) {
      return "success";
    }
    if (correct && !checked || !correct && checked) {
      return "error";
    }
    if (!correct && !checked) {
      return "default";
    }
    return void 0;
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(choose_output_module.root, {
        [choose_output_module.horizontalRoot]: optionsType !== "text"
      }),
      ref: elementRef,
      children: shuffledOptions.map((option, index) => {
        let disabled = false;
        let type = "default";
        const checked = answer[option.id];
        const correct = option["correct?"];
        if (isSubmitState(state.value)) {
          disabled = true;
          type = getAnswerStatus(correct, checked);
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(ChooseOption, {
          index,
          option,
          isRadio: isSingleChoose,
          type,
          isDisabled: disabled,
          isChecked: checked,
          onChange: handleSelectOption
        }, option.id);
      })
    }), isVisibleFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      successMessages,
      errorMessages,
      success: isSuccessMechanicAnswer,
      isCustom: isCustomFeedback
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/choose-output/multiselect-choose-output.component.tsx






















const MultiselectChoose = _ref => {
  let {
    variants: options,
    feedback,
    shuffleHash,
    mechanicMachine,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    disableKeyPress,
    isNotShuffled = false
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const answer = (0,react.useMemo)(() => state?.context.answer || {}, [state?.context.answer]);
  const intl = (0,useIntl/* default */.Z)();
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const isSuccessAnswer = (0,react.useCallback)(answer2 => options.every((option, index) => {
    const checked = answer2[index];
    const correct = option["correct?"];
    return correct && checked || !correct && !checked;
  }), [options]);
  const successMessages = (0,react.useMemo)(() => feedback?.["on-success"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Success)
  }), [feedback, intl]);
  const errorMessages = (0,react.useMemo)(() => feedback?.["on-error"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Error)
  }), [feedback, intl]);
  const optionsArray = options.map((option, index) => ({
    ...option,
    id: index
  }));
  const shuffledOptionsArray = useOptionsShuffle(optionsArray, shuffleHash);
  const shuffledOptions = isNotShuffled ? optionsArray : shuffledOptionsArray;
  const handleSelectOption = (0,react.useCallback)(i => {
    const index = shuffledOptions[i].id;
    const contextAnswer = answer;
    const data = {
      ...contextAnswer,
      [index]: !contextAnswer[index]
    };
    const checkedCheckboxes = Object.keys(data).filter(key => data[key]);
    if (checkedCheckboxes.length === 0) {
      return send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: data,
          correct: isSuccessAnswer(data)
        }
      });
    }
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: isSuccessAnswer(data)
      }
    });
  }, [send, shuffledOptions, answer, isSuccessAnswer]);
  const handleSelectCode = (0,react.useCallback)(digit => {
    if (digit >= 1 && digit <= options.length) {
      handleSelectOption(digit - 1);
    }
  }, [handleSelectOption, options.length]);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(handleSelectCode, disableKeyPress);
  const isVisibleFeedback = isSubmitState(state.value) && feedback;
  const isCustomFeedback = Boolean(feedback?.["on-success"]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: choose_output_module.root,
      ref: elementRef,
      children: shuffledOptions.map((option, index) => {
        let disabled = false;
        let type = "default";
        const checked = answer[option.id];
        if (isSubmitState(state.value)) {
          disabled = true;
          type = checked ? "success" : "default";
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(ChooseOption, {
          index,
          option,
          isRadio: false,
          type,
          isDisabled: disabled,
          isChecked: checked,
          onChange: handleSelectOption
        }, option.id);
      })
    }), isVisibleFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      successMessages,
      errorMessages,
      success: true,
      isCustom: isCustomFeedback
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/condition-choose/condition-choose.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const condition_choose_module = ({"root":"condition-choose-module__root--Xtvgr","root-left":"condition-choose-module__root-left--TiAPt","rootLeft":"condition-choose-module__root-left--TiAPt","button":"condition-choose-module__button--dr_gW","picture-container":"condition-choose-module__picture-container--_tm8x","pictureContainer":"condition-choose-module__picture-container--_tm8x","text":"condition-choose-module__text--Quhou","variants":"condition-choose-module__variants--CaVns","right-block":"condition-choose-module__right-block--p88A_","rightBlock":"condition-choose-module__right-block--p88A_","main-text":"condition-choose-module__main-text--yJrlD","mainText":"condition-choose-module__main-text--yJrlD","second-text":"condition-choose-module__second-text--mNnPv","secondText":"condition-choose-module__second-text--mNnPv"});
;// CONCATENATED MODULE: ./src/components/condition-choose/condition-choose.component.tsx













const ConditionalChoose = _ref => {
  let {
    mainText,
    secondText,
    image,
    variants,
    mechanicMachine,
    submitAnswer,
    position = "left",
    onInViewChange = function_utils/* emptyFunction */.Bi
  } = _ref;
  const {
    send
  } = mechanicMachine;
  const [clickedIndex, setClickedIndex] = (0,react.useState)(-1);
  const handleClickButton = (0,react.useCallback)(index => {
    setClickedIndex(index);
    send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: {
          [index]: true
        },
        correct: true
      }
    });
  }, [send]);
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  (0,react.useEffect)(() => {
    setClickedIndex(prev => {
      if (prev < 0) {
        return prev;
      }
      submitAnswer({
        withScroll: true
      });
      return -1;
    });
  }, [clickedIndex, send, submitAnswer]);
  if (!image || !mainText) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(condition_choose_module.root, {
        [condition_choose_module.rootLeft]: position === "left"
      }),
      children: variants.map((v, index) => {
        const text = Array.isArray(v.text) ? v.text.join(" ") : v.text;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primary",
          className: condition_choose_module.button,
          onClick: () => handleClickButton(index),
          children: text
        }, text);
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(condition_choose_module.root, {
      [condition_choose_module.rootLeft]: position === "left"
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: condition_choose_module.pictureContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        alt: "illustration",
        src: image
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: condition_choose_module.rightBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: condition_choose_module.text,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(condition_choose_module.mainText, typography_module/* default */.Z.headline4),
          children: mainText
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(condition_choose_module.secondText, typography_module/* default */.Z.body2),
          children: secondText
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: condition_choose_module.variants,
        ref: elementRef,
        children: variants.map((v, index) => {
          const text = Array.isArray(v.text) ? v.text.join(" ") : v.text;
          return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "primary",
            className: condition_choose_module.button,
            onClick: () => handleClickButton(index),
            children: text
          }, text);
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../shared/src/hooks/app/use-did-mount.ts
var use_did_mount = __webpack_require__(73058);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/hot-key/hot-key.component.tsx + 1 modules
var hot_key_component = __webpack_require__(72416);
// EXTERNAL MODULE: ../ui-kit/src/text-button/text-button.component.tsx + 3 modules
var text_button_component = __webpack_require__(5426);
;// CONCATENATED MODULE: ../ui-kit/src/drag-and-drop-image/__button/drag-and-drop-image-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drag_and_drop_image_button_module = ({"empty":"drag-and-drop-image-button-module__empty--q0Smu","empty-button":"drag-and-drop-image-button-module__empty-button--sA9Wr","emptyButton":"drag-and-drop-image-button-module__empty-button--sA9Wr","translucent-background":"drag-and-drop-image-button-module__translucent-background--Pxj2I","translucentBackground":"drag-and-drop-image-button-module__translucent-background--Pxj2I","selected":"drag-and-drop-image-button-module__selected--yd8CD","hidden":"drag-and-drop-image-button-module__hidden--ntcYO","not-selected":"drag-and-drop-image-button-module__not-selected--jWSIm","notSelected":"drag-and-drop-image-button-module__not-selected--jWSIm","submitted":"drag-and-drop-image-button-module__submitted--XvZ51","answer-button":"drag-and-drop-image-button-module__answer-button--mVzEd","answerButton":"drag-and-drop-image-button-module__answer-button--mVzEd"});
;// CONCATENATED MODULE: ../ui-kit/src/drag-and-drop-image/__button/drag-and-drop-image-button.component.tsx











const DragAndDropImageButton = _ref => {
  let {
    type,
    text,
    onClick,
    isSelected,
    isCorrect,
    withoutText,
    hotKeyText,
    isCompact = false
  } = _ref;
  const handleSelectField = (0,react.useCallback)(() => {
    onClick?.();
  }, [onClick]);
  const handleSelectAnswer = (0,react.useCallback)(digit => {
    if (hotKeyText === digit) {
      handleSelectField();
    }
  }, [handleSelectField, hotKeyText]);
  const size = isCompact ? "compact" : "regular";
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(handleSelectAnswer);
  (0,useKeyPress/* useKeyPress */.K)(`Key${hotKeyText}`, handleSelectField);
  switch (type) {
    case "emptyField":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drag_and_drop_image_button_module.empty, drag_and_drop_image_button_module.answerButton),
          onDragOver: event => event.preventDefault(),
          onDrop: event => {
            event.preventDefault();
            if (onClick) {
              onClick();
            }
          },
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
            shadow: false,
            color: text_button_component/* Color */.I.lightestBlack,
            hotKeyState: hot_key_component/* HotKeyState */.wu.Selected,
            hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
            hotKeyText,
            transparentText: true,
            onClick,
            withoutChildren: withoutText,
            classes: {
              button: classnames_default()(drag_and_drop_image_button_module.emptyButton, drag_and_drop_image_button_module.translucentBackground, drag_and_drop_image_button_module.answerButton)
            },
            size
          })
        });
      }
    case "notSelected":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drag_and_drop_image_button_module.notSelected, drag_and_drop_image_button_module.answerButton),
          draggable: true,
          onDragStart: onClick,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
            shadow: true,
            color: text_button_component/* Color */.I.Transparent,
            hotKeyState: isSelected ? hot_key_component/* HotKeyState */.wu.Selected : hot_key_component/* HotKeyState */.wu.Default,
            hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
            hotKeyText,
            transparentText: false,
            onClick,
            withoutChildren: withoutText,
            size,
            children: text
          })
        });
      }
    case "hidden":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drag_and_drop_image_button_module.hidden, drag_and_drop_image_button_module.answerButton),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
            shadow: true,
            color: text_button_component/* Color */.I.Transparent,
            hotKeyState: hot_key_component/* HotKeyState */.wu.Default,
            hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
            hotKeyText,
            transparentText: false,
            withoutChildren: withoutText,
            size,
            children: text
          })
        });
      }
    case "selected":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drag_and_drop_image_button_module.selected, drag_and_drop_image_button_module.answerButton),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
            shadow: true,
            color: text_button_component/* Color */.I.lightestBlack,
            hotKeyState: hot_key_component/* HotKeyState */.wu.Selected,
            hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
            hotKeyText,
            transparentText: false,
            onClick,
            withoutChildren: withoutText,
            classes: isSelected ? {
              button: drag_and_drop_image_button_module.translucentBackground
            } : {},
            size,
            children: text
          })
        });
      }
    case "submitted":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drag_and_drop_image_button_module.submitted, drag_and_drop_image_button_module.answerButton),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
            shadow: false,
            color: isCorrect ? text_button_component/* Color */.I.Green : text_button_component/* Color */.I.Red,
            hotKeyState: isCorrect ? hot_key_component/* HotKeyState */.wu.Success : hot_key_component/* HotKeyState */.wu.Error,
            hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Text,
            hotKeyText,
            transparentText: false,
            withoutChildren: withoutText,
            size,
            children: text
          })
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
;// CONCATENATED MODULE: ../ui-kit/src/drag-and-drop-image/__container/drag-and-drop-image-container.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drag_and_drop_image_container_module = ({"image-block":"drag-and-drop-image-container-module__image-block--wbZYt","imageBlock":"drag-and-drop-image-container-module__image-block--wbZYt","image":"drag-and-drop-image-container-module__image--hPHHn","slot-block":"drag-and-drop-image-container-module__slot-block--DrKXU","slotBlock":"drag-and-drop-image-container-module__slot-block--DrKXU"});
;// CONCATENATED MODULE: ../ui-kit/src/drag-and-drop-image/__container/drag-and-drop-image-container.component.tsx





const DragAndDropImageContainer = (0,react.forwardRef)(function DragAndDropImageContainer2(_ref, ref) {
  let {
    children,
    height,
    width,
    imageUrl
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: drag_and_drop_image_container_module.imageBlock,
    ref,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      src: imageUrl,
      alt: "drag and drop",
      className: drag_and_drop_image_container_module.image,
      style: {
        aspectRatio: `${width} / ${height}`
      }
    }), children]
  });
});
const DragAndDropImageContainerSlot = _ref2 => {
  let {
    children,
    x,
    y
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: drag_and_drop_image_container_module.slotBlock,
    style: {
      left: x + "%",
      top: y + "%"
    },
    children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/drag-and-drop-image/drag-and-drop-image.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const drag_and_drop_image_module = ({"drag-and-drop-container":"drag-and-drop-image-module__drag-and-drop-container--d6IQh","dragAndDropContainer":"drag-and-drop-image-module__drag-and-drop-container--d6IQh","answer-block":"drag-and-drop-image-module__answer-block--eeNGf","answerBlock":"drag-and-drop-image-module__answer-block--eeNGf","answer-block-mobile":"drag-and-drop-image-module__answer-block-mobile--XaDwK","answerBlockMobile":"drag-and-drop-image-module__answer-block-mobile--XaDwK","popup-answers":"drag-and-drop-image-module__popup-answers--LaDoS","popupAnswers":"drag-and-drop-image-module__popup-answers--LaDoS","answer-button":"drag-and-drop-image-module__answer-button--uI1WM","answerButton":"drag-and-drop-image-module__answer-button--uI1WM"});
;// CONCATENATED MODULE: ../ui-kit/src/drag-and-drop-image/drag-and-drop-image.component.tsx















const DragAndDropImage = _ref => {
  let {
    width,
    height,
    buttons,
    onChange,
    isMobile,
    imageUrl
  } = _ref;
  const [moveId, setMoveId] = (0,react.useState)(null);
  const [isAnswersHidden, setIsAnswerHidden] = (0,react.useState)(true);
  const [fieldId, setFieldId] = (0,react.useState)(null);
  const imageButtons = (0,react.useMemo)(() => {
    const imageButtonsTypes = ["emptyField", "selected", "submitted"];
    return Object.keys(buttons).filter(key => imageButtonsTypes.includes(buttons[key].type)).sort((key1, key2) => {
      const button1 = buttons[key1];
      const button2 = buttons[key2];
      return button1.x - button2.x;
    });
  }, [buttons]);
  const answerButtons = (0,react.useMemo)(() => {
    const answerButtonsTypes = ["hidden", "notSelected"];
    return Object.keys(buttons).filter(key => answerButtonsTypes.includes(buttons[key].type));
  }, [buttons]);
  const setEmptyField = (0,react.useCallback)((emptyItemId, moveItemId) => {
    const moveItem = buttons[moveItemId];
    const emptyItem = buttons[emptyItemId];
    const buttonsMap = {
      ...buttons,
      [emptyItemId]: {
        ...emptyItem,
        type: "selected",
        text: moveItem.text,
        hiddenItemId: moveItem.id
      },
      [moveItemId]: {
        ...moveItem,
        type: "hidden"
      }
    };
    onChange(buttonsMap);
    setMoveId(null);
    setFieldId(null);
    return buttonsMap;
  }, [buttons, onChange]);
  const setSelectedField = (0,react.useCallback)(item => {
    const selectedItem = buttons[item.id];
    const hiddenItem = buttons[selectedItem.type === "selected" ? selectedItem.hiddenItemId : 0];
    const buttonsMap = {
      ...buttons,
      [selectedItem.id]: {
        ...selectedItem,
        type: "emptyField"
      },
      [hiddenItem.id]: {
        ...hiddenItem,
        type: "notSelected",
        text: hiddenItem.text
      }
    };
    onChange(buttonsMap);
    return buttonsMap;
  }, [buttons, onChange]);
  const containerRef = (0,react.useRef)(null);
  const [isCompact, setIsCompact] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const containerNode = containerRef.current;
    const resizeObserver = new ResizeObserver(entries => {
      setIsCompact(Boolean(entries?.[0].contentRect.width < width * 0.8));
    });
    containerNode && resizeObserver.observe(containerNode);
    return () => {
      containerNode && resizeObserver.unobserve(containerNode);
    };
  }, [width]);
  const renderCoordinateItem = (0,react.useCallback)((item, onImage, hotKeyNum) => {
    const hotKeyText = String.fromCharCode(hotKeyNum + 65);
    switch (item.type) {
      case "emptyField":
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageButton, {
            type: !onImage && isMobile ? "notSelected" : item.type,
            onClick: () => {
              if (moveId !== null) {
                setEmptyField(item.id, moveId);
              } else {
                setIsAnswerHidden(false);
              }
              if (item.id !== fieldId && isMobile) {
                setFieldId(item.id);
              }
            },
            withoutText: isMobile,
            hotKeyText,
            isCompact
          });
        }
      case "selected":
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageButton, {
            type: item.type,
            text: item.text,
            onClick: () => {
              setSelectedField(item);
            },
            withoutText: onImage,
            isSelected: onImage,
            hotKeyText,
            isCompact
          });
        }
      case "submitted":
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageButton, {
            type: item.type,
            text: item.text,
            isCorrect: item.isCorrect,
            withoutText: isMobile && onImage,
            hotKeyText,
            isCompact
          });
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(item);
    }
  }, [fieldId, moveId, isMobile, setEmptyField, setSelectedField, isCompact]);
  const renderPlainItem = (0,react.useCallback)((item, onImage, hotKeyText) => {
    const type = item.type;
    switch (type) {
      case "hidden":
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageButton, {
            text: item.text,
            type: isMobile ? "notSelected" : item.type,
            isSelected: isMobile,
            withoutText: isMobile && onImage,
            hotKeyText
          });
        }
      case "notSelected":
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageButton, {
            type: item.type,
            text: item.text,
            onClick: () => {
              if (item.id !== moveId) {
                setMoveId(item.id);
              } else {
                setMoveId(null);
              }
              if (fieldId !== null) {
                setEmptyField(fieldId, item.id);
                setIsAnswerHidden(true);
              }
            },
            isSelected: item.id === moveId,
            withoutText: false,
            hotKeyText
          });
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  }, [fieldId, moveId, isMobile, setEmptyField]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: drag_and_drop_image_module.dragAndDropContainer,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageContainer, {
      width,
      height,
      imageUrl,
      ref: containerRef,
      children: imageButtons.map((id, index) => {
        const item = buttons[id];
        return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageContainerSlot, {
          x: item.x,
          y: item.y,
          children: renderCoordinateItem(item, isMobile, index)
        }, index);
      })
    }), !isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: drag_and_drop_image_module.answerBlock,
      children: answerButtons.map((id, index) => {
        const item = buttons[id];
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: drag_and_drop_image_module.answerButton,
          children: renderPlainItem(item, false, index + 1)
        }, index);
      })
    }), isMobile && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: drag_and_drop_image_module.answerBlockMobile,
        children: imageButtons.map((id, index) => {
          const item = buttons[id];
          return renderCoordinateItem(item, false, index);
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
        onClose: () => {
          setIsAnswerHidden(true);
        },
        showCloseButton: true,
        isVisible: !isAnswersHidden,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(drag_and_drop_image_module.answerBlockMobile, drag_and_drop_image_module.popupAnswers),
          children: answerButtons.map((id, index) => {
            const item = buttons[id];
            return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: drag_and_drop_image_module.answerButton,
              children: renderPlainItem(item, false, index + 1)
            }, index);
          })
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/drag-and-drop-image-output/drag-and-drop-image-output.component.tsx





















const mapAnswersToButtonsMap = answers => answers.reduce((buttonsMap, answer) => {
  buttonsMap[answer.id] = {
    ...answer,
    type: "selected",
    text: answer.value
  };
  buttonsMap[answer.hiddenItemId] = {
    ...answer,
    type: "hidden",
    text: answer.value
  };
  return buttonsMap;
}, {});
const DragAndDropImageOutput = _ref => {
  let {
    feedback,
    parts,
    mechanicMachine,
    width,
    height,
    imageUrl,
    shuffleHash
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const answers = (0,react.useMemo)(() => !Array.isArray(state.context.answer) ? [] : state.context.answer, [state?.context.answer]);
  const [buttonsMap, setButtonsMap] = (0,react.useState)(() => answers.length !== 0 ? mapAnswersToButtonsMap(answers) : {});
  const [initialButtonsMap, setInitialButtonsMap] = (0,react.useState)({});
  const isSubmitted = isSubmitState(state.value);
  const findCorrectAnswer = (0,react.useCallback)(answer => parts.find(part => answer.x === part.x && answer.y === part.y && answer.value === part.value), [parts]);
  const getSubmittedAnswer = (0,react.useCallback)(() => {
    answers.forEach(answer => {
      const isCorrect2 = findCorrectAnswer(answer) !== void 0;
      const element = buttonsMap[answer.id];
      if (element.type === "selected") {
        buttonsMap[element.id] = {
          ...element,
          type: "submitted",
          text: element.text,
          isCorrect: isCorrect2
        };
      }
    });
    return buttonsMap;
  }, [answers, buttonsMap, findCorrectAnswer]);
  const isCorrect = (0,react.useMemo)(() => {
    const correctAnswers = answers.filter(answer => findCorrectAnswer(answer) !== void 0);
    return correctAnswers.length === answers.length;
  }, [answers, findCorrectAnswer]);
  (0,use_did_mount/* useDidMount */.H)(() => {
    if (answers.length === 0 && !isSubmitted) {
      const result = (0,array_utils/* shuffleArray */.Sy)(parts, part => part.value, shuffleHash).reduce((res, cur, index) => {
        res["field" + index] = {
          id: "field" + index,
          type: "emptyField",
          x: cur.x,
          y: cur.y
        };
        res["answer" + index] = {
          id: "answer" + index,
          type: "notSelected",
          text: cur.value
        };
        return res;
      }, {});
      setInitialButtonsMap(result);
    }
  });
  (0,react.useEffect)(() => {
    setButtonsMap({
      ...initialButtonsMap,
      ...mapAnswersToButtonsMap(answers)
    });
  }, [answers, initialButtonsMap]);
  const itemsWithAnswer = (0,react.useMemo)(() => {
    const result = {
      ...buttonsMap
    };
    if (isSubmitted) {
      return getSubmittedAnswer();
    }
    answers.forEach(answer => {
      const answerButton = result[answer.id];
      if (answerButton.type !== "emptyField") {
        return;
      }
      result[answer.id] = {
        ...answerButton,
        type: "selected",
        text: answer.value,
        hiddenItemId: answer.hiddenItemId
      };
      result[answer.hiddenItemId] = {
        ...answerButton,
        type: "hidden",
        text: answer.value
      };
    });
    return result;
  }, [answers, buttonsMap, isSubmitted, getSubmittedAnswer]);
  const handleChangeMap = (0,react.useCallback)(buttons => {
    const answer = [];
    setButtonsMap(buttons);
    Object.keys(buttons).forEach(id => {
      const curButton = buttons[id];
      if (curButton.type === "selected") {
        answer.push({
          id,
          x: curButton.x,
          y: curButton.y,
          value: curButton.text,
          hiddenItemId: curButton.hiddenItemId
        });
      }
    });
    if (parts.length === answer.length) {
      return send({
        type: mechanic_machine_consts/* EVENTS */.FP.ANSWER,
        data: {
          answer,
          correct: isCorrect,
          typo: false
        }
      });
    }
    return send({
      type: mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER,
      data: {
        answer
      }
    });
  }, [isCorrect, parts, send]);
  const successMessages = feedback?.["on-success"];
  const errorMessages = feedback?.["on-error"];
  const isCustomFeedback = Boolean(isCorrect && successMessages || !isCorrect && errorMessages);
  const showFeedback = isSubmitted && isCustomFeedback;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImage, {
      isMobile,
      width,
      height,
      buttons: itemsWithAnswer,
      onChange: handleChangeMap,
      imageUrl
    }), showFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      successMessages,
      errorMessages,
      success: isCorrect,
      isCustom: isCustomFeedback
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
// EXTERNAL MODULE: ./src/components/dropdown-output/dropdown/useDropdownContext.ts
var useDropdownContext = __webpack_require__(43548);
// EXTERNAL MODULE: ./src/components/dropdown-output/dropdown-rules.tsx + 5 modules
var dropdown_rules = __webpack_require__(899);
;// CONCATENATED MODULE: ./src/components/dropdown-output/feedback/dropdown-feedback.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const dropdown_feedback_module = ({"feedback-child":"dropdown-feedback-module__feedback-child--X2uaY","feedbackChild":"dropdown-feedback-module__feedback-child--X2uaY","custom-feedback-child":"dropdown-feedback-module__custom-feedback-child--ePM3m","customFeedbackChild":"dropdown-feedback-module__custom-feedback-child--ePM3m","root":"dropdown-feedback-module__root--dgbU8"});
;// CONCATENATED MODULE: ./src/components/dropdown-output/feedback/dropdown-feedback.component.tsx













function mapParsedTextItem(item) {
  return item.map(mapItem).join("");
}
function mapItem(item) {
  return typeof item === "string" ? item : `**${(0,cleanFromMarkdown/* cleanFromMarkdown */.s)(item.correct)}**`;
}
const DropdownFeedback = _ref => {
  let {
    successMessages,
    errorMessages,
    isCorrect,
    parsedText
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const correctAnswer = (0,react.useMemo)(() => parsedText.map(mapParsedTextItem), [parsedText]);
  const feedbackSuccessMessages = (0,react.useMemo)(() => successMessages ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Success)
  }), [intl, successMessages]);
  const feedbackErrorMessages = (0,react.useMemo)(() => errorMessages ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Error)
  }), [errorMessages, intl]);
  const isCustomFeedback = Boolean(isCorrect && successMessages || !isCorrect && errorMessages);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
    successMessages: feedbackSuccessMessages,
    errorMessages: feedbackErrorMessages,
    success: isCorrect,
    isCustom: isCustomFeedback,
    children: !isCorrect && /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: correctAnswer.map((text, i) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(dropdown_feedback_module.feedbackChild, {
          [dropdown_feedback_module.customFeedbackChild]: isCustomFeedback
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
          id: `dropdown-feedback answer-${i}`,
          typography: "headline4",
          children: text
        })
      }, i))
    })
  });
};
// EXTERNAL MODULE: ./src/components/dropdown-output/parser.ts
var parser = __webpack_require__(57724);
// EXTERNAL MODULE: ./src/components/dropdown-output/dropdown-output.module.css
var dropdown_output_module = __webpack_require__(39910);
;// CONCATENATED MODULE: ./src/components/dropdown-output/dropdown-output.component.tsx












































const DEFAULT_ACTIVE_INDEX = (0,useDropdownContext/* makeLabelIndex */.Tg)(0);
const NEL = "\n";
const checkDropdownAnswer = answer => answer != null && Object.entries(answer).every(_ref => {
  let [key, value] = _ref;
  return !isNaN(parseInt(key)) && typeof value === "string";
});
const DropdownOutput = _ref2 => {
  let {
    text = "",
    feedback = {},
    shuffleHash,
    mechanicMachine,
    lastBlock,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    disableKeyPress,
    isHiddenFeedback,
    skill
  } = _ref2;
  const {
    send,
    state
  } = mechanicMachine;
  const [activeDropdownIndex, setActiveDropdownIndex] = (0,react.useState)(DEFAULT_ACTIVE_INDEX);
  const answer = (0,react.useMemo)(() => checkDropdownAnswer(state?.context.answer) ? state?.context.answer : {}, [state?.context.answer]);
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const texts = (0,react.useMemo)(() => Array.isArray(text) ? text : [text], [text]);
  const parsedText = (0,react.useMemo)(() => (0,parser/* splitStringsToDropdowns */.wb)(texts, shuffleHash), [shuffleHash, texts]);
  const isCorrect = (0,react.useCallback)(userAnswer => !parsedText.some((arr, arrIndex) => arr.some((val, valIndex) => {
    if (userAnswer === null || typeof userAnswer !== "object") {
      logger/* Logger */.Yd.unexpectedState();
      return false;
    }
    const userAnswerObject = checkDropdownAnswer(userAnswer) ? userAnswer : {};
    return typeof val !== "string" && val.correct !== userAnswerObject[`${arrIndex}_${valIndex}`];
  })), [parsedText]);
  const dropdownsCount = (0,react.useMemo)(() => parsedText.map(splittedString => splittedString.reduce((sum, item) => typeof item === "string" ? sum : sum + 1, 0)).reduce((sum, item) => sum + item, 0), [parsedText]);
  const calcRightAnswers = (0,react.useCallback)(answer2 => (0,object_utils/* getObjectKeys */.Z)(answer2).reduce((res, key, index) => {
    const [i, j] = String(key).split("_").map(keyValue => Number(keyValue));
    const text2 = parsedText[i][j];
    if (typeof text2 !== "string") {
      res[index] = {
        isRight: text2.correct === answer2[key],
        answer: answer2[key]
      };
    }
    return res;
  }, {}), [parsedText]);
  const updateCurrentValue = (0,react.useCallback)((value, index) => {
    const newAnswer = {
      ...answer,
      [index]: value
    };
    if (Object.keys(newAnswer).length < dropdownsCount) {
      return send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: newAnswer,
          correct: isCorrect(newAnswer)
        }
      });
    }
    const dropdownAnswer = calcRightAnswers(newAnswer);
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: newAnswer,
        correct: isCorrect(newAnswer),
        maxPossibleScore: dropdownsCount,
        rightAnswersScore: Object.values(dropdownAnswer).filter(answer2 => answer2?.isRight).length,
        optionDescription: dropdownAnswer,
        skill
      }
    });
  }, [answer, dropdownsCount, calcRightAnswers, send, isCorrect, skill]);
  const labelsCount = (0,react.useMemo)(() => parsedText.reduce((count, el) => el.filter(item => typeof item !== "string").length + count, 0), [parsedText]);
  const indexesMap = (0,react.useMemo)(() => parsedText.reduce((acc, parsedString, textIndex) => {
    parsedString.forEach((parsedItem, itemIndex) => {
      if (typeof parsedItem !== "string") {
        acc.set((0,useDropdownContext/* makeLabelIndex */.Tg)(parsedItem.index), {
          textIndex,
          itemIndex
        });
      }
    });
    return acc;
  }, /* @__PURE__ */new Map()), [parsedText]);
  const {
    dropdown,
    dropdownWithSentence
  } = (0,dropdown_rules/* useDropdownRules */.e)({
    texts,
    parsedText,
    shuffleHash,
    indexesMap,
    answer,
    activeDropdownIndex
  });
  const handleSelectCode = (0,react.useCallback)(digit => {
    if (lastBlock && activeDropdownIndex === 0 && digit > 0 && digit <= labelsCount) {
      setActiveDropdownIndex((0,useDropdownContext/* makeLabelIndex */.Tg)(digit));
    }
  }, [activeDropdownIndex, labelsCount, lastBlock]);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(handleSelectCode, disableKeyPress);
  const getSentence = (0,react.useCallback)(labelIndex => {
    const {
      sentence,
      rule
    } = dropdownWithSentence(labelIndex);
    if (sentence === null) {
      return null;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: `dropdown text-${labelIndex}`,
      typography: "body1",
      className: dropdown_output_module/* default */.Z.sentenceText,
      additionalRules: rule,
      children: sentence
    });
  }, [dropdownWithSentence]);
  const isVisibleFeedback = isSubmitState(state.value) && !isHiddenFeedback;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: elementRef,
      className: dropdown_output_module/* default */.Z.text,
      children: texts.map((text2, textIndex) => {
        const handleChange = (val, answerKey) => updateCurrentValue(val, answerKey);
        const handleDropdownActiveChange = (labelIndex, active) => {
          setActiveDropdownIndex(active ? labelIndex : DEFAULT_ACTIVE_INDEX);
        };
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(useDropdownContext/* DropdownStateContext */.D6.Provider, {
          value: {
            indexesMap,
            answer,
            activeDropdownIndex,
            isSubmitted: isSubmitState(state.value),
            isSelected: Boolean(isSubmitState(state.value) && isHiddenFeedback),
            onChange: handleChange,
            onDropdownActiveChange: handleDropdownActiveChange,
            getSentence
          },
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
            id: `dropdown text-${textIndex}`,
            typography: "headline4Mechanic",
            additionalRules: dropdown,
            children: text2
          }), NEL]
        }, textIndex);
      })
    }), isVisibleFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownFeedback, {
      successMessages: feedback["on-success"],
      errorMessages: feedback["on-error"],
      isCorrect: isCorrect(answer),
      parsedText
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.to-sorted.js
var es_array_to_sorted = __webpack_require__(15398);
// EXTERNAL MODULE: ../../node_modules/damerau-levenshtein/index.js
var damerau_levenshtein = __webpack_require__(15266);
var damerau_levenshtein_default = /*#__PURE__*/__webpack_require__.n(damerau_levenshtein);
;// CONCATENATED MODULE: ./src/utils/regexp-constants.ts


const REMOVING_CHAR_REGEXP = /[^A-zА-я0-9\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e\u2010-\u201f]/g;
const APOSTROPHE_REGEXP = /\u0027/g;
const BEAUTY_APOSTROPHE = "\u2019";
;// CONCATENATED MODULE: ./src/utils/prepare-text.ts



function prepareText(text) {
  return text.replace(REMOVING_CHAR_REGEXP, "").replace(APOSTROPHE_REGEXP, BEAUTY_APOSTROPHE).toLowerCase();
}
;// CONCATENATED MODULE: ./src/utils/getClosestText.ts





const getClosestText = (patternText, texts) => {
  if (texts.length > 1e3) {
    console.warn("\u0410\u043B\u0433\u043E\u0440\u0438\u0442\u043C \u043C\u0435\u0442\u043E\u0434\u0430 \u043D\u0435 \u043E\u043F\u0442\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439, \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B \u0441 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C\u044E");
  }
  return texts.toSorted((a, b) => {
    const preparedA = prepareText(a);
    const preparedB = prepareText(b);
    const preparedPattern = prepareText(patternText);
    const {
      steps: answer1Steps
    } = damerau_levenshtein_default()(preparedA, preparedPattern);
    const {
      steps: answer2Steps
    } = damerau_levenshtein_default()(preparedB, preparedPattern);
    return answer1Steps - answer2Steps;
  })[0];
};
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/fill-the-gap-output.module.css
var fill_the_gap_output_module = __webpack_require__(70550);
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/correct-variant.tsx










const checkContextFillTheGapAnswer = answer => answer !== null && Object.entries(answer).every(_ref => {
  let [key, value] = _ref;
  return !isNaN(parseInt(key)) && typeof value === "string";
});
const CorrectVariant = _ref2 => {
  let {
    rightAnswers,
    index: id,
    answer
  } = _ref2;
  const closeToUserAnswerRightAnswer = (0,react.useMemo)(() => {
    const currentAnswer = checkContextFillTheGapAnswer(answer) && answer[id] ? answer[id] : "";
    return getClosestText(currentAnswer, rightAnswers);
  }, [answer, id, rightAnswers]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
    id: `fill-the-gap correct-variant-${id}`,
    className: fill_the_gap_output_module/* default */.Z.rightAnswerFeedback,
    typography: "headline4",
    children: closeToUserAnswerRightAnswer
  });
};
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/parser.ts
var fill_the_gap_output_parser = __webpack_require__(77487);
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/correct-variant-rule.tsx






const getCorrectVariantRule = answer => {
  let index = 0;
  return {
    correctVariant: {
      order: 1,
      match: simple_markdown_default().inlineRegex(fill_the_gap_output_parser/* STRICT_FILL_THE_GAP_REGEXP */.vu),
      parse: capture => ({
        content: (0,fill_the_gap_output_parser/* parseFillTheGapOutput */.Fj)(capture[1], index++)
      }),
      react: node => /* @__PURE__ */(0,jsx_runtime.jsx)(CorrectVariant, {
        rightAnswers: node.content.rightAnswers,
        index: node.content.index,
        answer
      }, `correct-variant-${node.content.index}`)
    }
  };
};
// EXTERNAL MODULE: ../ui-kit/src/medium-input/medium-input.component.tsx + 1 modules
var medium_input_component = __webpack_require__(30355);
;// CONCATENATED MODULE: ./src/utils/isEqualText.ts



const isEqualText = function (benchmarkText) {
  let checkingText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const preparedBenchmarkText = prepareText(benchmarkText);
  const preparedCheckingText = prepareText(checkingText);
  return preparedBenchmarkText === preparedCheckingText;
};
;// CONCATENATED MODULE: ./src/utils/withTypo.ts




const withTypo = function (benchmarkText) {
  let checkingText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const preparedBenchmarkText = prepareText(benchmarkText);
  const preparedCheckingText = prepareText(checkingText);
  const {
    steps
  } = damerau_levenshtein_default()(preparedBenchmarkText, preparedCheckingText);
  if (benchmarkText.length <= 3) {
    return false;
  }
  if (benchmarkText.length <= 7) {
    return steps <= 1;
  }
  if (benchmarkText.length <= 12) {
    return steps <= 2;
  }
  return steps <= 3;
};
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/feedback/useFillTheGapFeedback.ts

























const getFeedbackStatus = (userAnswer, rightAnswer) => {
  const isSame = rightAnswer.some(answers => isEqualText(answers, userAnswer));
  if (isSame) {
    return medium_input_component/* MediumInputStatus */._.Success;
  }
  const haveTypo = rightAnswer.some(answer => withTypo(answer, userAnswer));
  if (haveTypo) {
    return medium_input_component/* MediumInputStatus */._.Typo;
  }
  return medium_input_component/* MediumInputStatus */._.Error;
};
const feedbackMessageMapper = feedbackStatus => {
  switch (feedbackStatus) {
    case medium_input_component/* MediumInputStatus */._.Success:
      return MessageType.Success;
    case medium_input_component/* MediumInputStatus */._.Error:
      return MessageType.Error;
    case medium_input_component/* MediumInputStatus */._.Typo:
      return MessageType.Typo;
    default:
      return null;
  }
};
const feedbackStatusMapper = feedbackStatus => {
  switch (feedbackStatus) {
    case medium_input_component/* MediumInputStatus */._.Success:
      return medium_input_component/* MediumInputStatus */._.Success;
    case medium_input_component/* MediumInputStatus */._.Error:
      return medium_input_component/* MediumInputStatus */._.Error;
    case medium_input_component/* MediumInputStatus */._.Typo:
      return medium_input_component/* MediumInputStatus */._.Typo;
    case medium_input_component/* MediumInputStatus */._.Selected:
      return medium_input_component/* MediumInputStatus */._.Selected;
    default:
      return medium_input_component/* MediumInputStatus */._.Selected;
  }
};
const useFillTheGapFeedback = _ref => {
  let {
    rightAnswers,
    currentUserAnswer,
    isSubmit,
    isHiddenFeedback
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const feedbackStatusesCache = (0,react.useRef)( /* @__PURE__ */new Map());
  const getFeedbackStatusWithCache = (0,react.useCallback)((itemIndex, userAnswer, rightAnswer) => {
    const cacheItem = feedbackStatusesCache.current.get(itemIndex);
    if (cacheItem !== void 0 && cacheItem.answer === userAnswer) {
      return cacheItem.result;
    }
    const newStatus = getFeedbackStatus(userAnswer, rightAnswer);
    feedbackStatusesCache.current.set(itemIndex, {
      answer: userAnswer,
      result: newStatus
    });
    return newStatus;
  }, []);
  const feedbackStatuses = (0,react.useMemo)(() => {
    const result = /* @__PURE__ */new Map();
    for (const [itemIndex, itemAnswers] of rightAnswers) {
      const userAnswer = currentUserAnswer[itemIndex] ?? "";
      result.set(itemIndex, getFeedbackStatusWithCache(itemIndex, userAnswer, itemAnswers));
    }
    return result;
  }, [currentUserAnswer, getFeedbackStatusWithCache, rightAnswers]);
  const generalFeedbackStatus = (0,react.useMemo)(() => {
    let hasTypo = false;
    for (const [, value] of feedbackStatuses) {
      switch (value) {
        case "error":
          return medium_input_component/* MediumInputStatus */._.Error;
        case "typo":
          hasTypo = true;
          break;
        default:
          break;
      }
    }
    return hasTypo ? medium_input_component/* MediumInputStatus */._.Typo : medium_input_component/* MediumInputStatus */._.Success;
  }, [feedbackStatuses]);
  const feedbackMessage = (0,react.useMemo)(() => {
    const messageType = feedbackMessageMapper(generalFeedbackStatus);
    if (messageType === null) {
      return "";
    }
    return intl.formatMessage({
      id: getRandomMessageKey(messageType)
    });
  }, [generalFeedbackStatus, intl]);
  const getFeedbackStatusForGap = (0,react.useCallback)(index => {
    if (isSubmit) {
      if (isHiddenFeedback) {
        return medium_input_component/* MediumInputStatus */._.Selected;
      }
      const feedbackStatus = feedbackStatuses.get(index);
      if (feedbackStatus) {
        return feedbackStatusMapper(feedbackStatus);
      }
    }
    return medium_input_component/* MediumInputStatus */._.Default;
  }, [feedbackStatuses, isHiddenFeedback, isSubmit]);
  return {
    feedbackMessage,
    generalFeedbackStatus,
    getFeedbackStatusForGap,
    getFeedbackStatusWithCache
  };
};
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/feedback/feedback.tsx













const FillTheGapFeedback = _ref => {
  let {
    feedback,
    rightAnswers,
    currentUserAnswer,
    audio,
    isSubmit,
    isHiddenFeedback,
    children
  } = _ref;
  const {
    feedbackMessage,
    generalFeedbackStatus
  } = useFillTheGapFeedback({
    rightAnswers,
    currentUserAnswer,
    isSubmit,
    isHiddenFeedback
  });
  const isSuccess = generalFeedbackStatus === "success";
  const isFeedbackContentVisible = isSubmit && generalFeedbackStatus !== "success";
  const isCustomFeedback = Boolean(isSuccess && feedback?.["on-success"] || !isSuccess && feedback?.["on-error"]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
    successMessages: feedback?.["on-success"] ?? feedbackMessage,
    errorMessages: feedback?.["on-error"] ?? feedbackMessage,
    success: isSuccess,
    isCustom: isCustomFeedback,
    children: isFeedbackContentVisible && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(fill_the_gap_output_module/* default */.Z.feedbackContent, {
        [fill_the_gap_output_module/* default */.Z.customFeedbackContent]: isCustomFeedback
      }),
      children: [audio && /* @__PURE__ */(0,jsx_runtime.jsx)(AudioButton, {
        audio
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.headline4, fill_the_gap_output_module/* default */.Z.feedbackText),
        children
      })]
    })
  });
};
const AudioButton = _ref2 => {
  let {
    audio
  } = _ref2;
  const audioLink = (0,react.useMemo)(() => getOptionAudioSrc(audio), [audio]);
  const audioPriority = (0,react.useMemo)(() => {
    switch (audio?.priority) {
      case "low":
        return useAudio/* Priority */.UL.Low;
      case "primary":
        return useAudio/* Priority */.UL.Primary;
      default:
        return useAudio/* Priority */.UL.Normal;
    }
  }, [audio?.priority]);
  const audioOptions = (0,react.useMemo)(() => ({
    priority: audioPriority
  }), [audioPriority]);
  const {
    playFromStart,
    canPlay,
    waiting
  } = (0,useAudio/* useAudioHandler */.GH)(audioLink, "feedbackWithAudio", audioOptions);
  const loading = useLoader(waiting);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
    disabled: !canPlay,
    size: "medium",
    iconName: "speaker",
    appearance: "default",
    onFocus: e => e.currentTarget.blur(),
    className: fill_the_gap_output_module/* default */.Z.audioButton,
    onClick: playFromStart,
    loading
  });
};
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/fill-the-gap-rule.tsx + 1 modules
var fill_the_gap_rule = __webpack_require__(44199);
// EXTERNAL MODULE: ./src/components/fill-the-gap-output/use-fill-the-gap-context.ts
var use_fill_the_gap_context = __webpack_require__(21254);
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/fill-the-gap-text.tsx





const FillTheGapText = _ref => {
  let {
    text,
    currentUserAnswer,
    additionalRules,
    isSubmit,
    placeholders,
    getFeedbackStatusForGap,
    handleValueChanged,
    isFeedback
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(use_fill_the_gap_context/* FillTheGapStateContext */.M.Provider, {
    value: {
      placeholders,
      getFeedbackStatusForGap,
      currentUserAnswer,
      isSubmit,
      handleValueChanged
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: `fill-the-gap text${isFeedback ? " feedback" : ""}`,
      additionalRules,
      typography: "headline4Mechanic",
      children: text
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/use-fill-the-gap-parser.ts














































const useFillTheGapParser = _ref => {
  let {
    texts,
    shuffleHash
  } = _ref;
  const preparedText = (0,react.useMemo)(() => {
    if (texts.length === 1) {
      return texts[0];
    }
    const rightAnswerVariants = texts.reduce((acc, t) => {
      const regexpMatchArray = t.match(fill_the_gap_output_parser/* FILL_THE_GAP_REGEXP */.B3);
      if (regexpMatchArray !== null) {
        const words = (0,fill_the_gap_output_parser/* parseFillTheGapRegexp */.Yc)(regexpMatchArray[0]);
        return acc.concat(words);
      }
      return acc;
    }, []).join("|");
    return texts[0].replace(fill_the_gap_output_parser/* FILL_THE_GAP_REGEXP */.B3, `<${rightAnswerVariants}>`);
  }, [texts]);
  const parsedText = (0,react.useMemo)(() => (0,fill_the_gap_output_parser/* splitStringToFillTheGap */.Ct)(preparedText, shuffleHash), [preparedText, shuffleHash]);
  const numberOfFillTheGapControls = (0,react.useMemo)(() => parsedText.reduce((acc, t) => typeof t !== "string" ? acc + 1 : acc, 0), [parsedText]);
  const fillTheGapInputs = (0,react.useMemo)(() => {
    const result = {
      inputIds: /* @__PURE__ */new Set(),
      rightAnswers: /* @__PURE__ */new Map()
    };
    parsedText.forEach(item => {
      if (typeof item !== "string") {
        result.inputIds.add(item.index);
        result.rightAnswers.set(item.index, item.rightAnswers);
      }
    });
    return result;
  }, [parsedText]);
  return {
    numberOfFillTheGapControls,
    inputIds: fillTheGapInputs.inputIds,
    rightAnswers: fillTheGapInputs.rightAnswers,
    preparedText
  };
};
;// CONCATENATED MODULE: ./src/components/fill-the-gap-output/fill-the-gap-output.component.tsx























const FillTheGapOutput = _ref => {
  let {
    texts,
    audio,
    placeholders,
    shuffleHash,
    mechanicMachine,
    submitAnswer,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    feedback,
    isHiddenFeedback,
    acceptAnyAnswer,
    skill
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    state,
    send
  } = mechanicMachine;
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const {
    numberOfFillTheGapControls,
    inputIds,
    rightAnswers,
    preparedText
  } = useFillTheGapParser({
    texts,
    shuffleHash
  });
  const currentUserAnswer = (0,react.useMemo)(() => {
    const answer = state?.context.answer || {};
    if (checkContextFillTheGapAnswer(answer)) {
      return answer;
    }
    return {};
  }, [state?.context.answer]);
  const isAnswered = state.matches(mechanic_machine_consts/* STATES */.PO.ANSWERED);
  const isSubmit = isSubmitState(state.value);
  const {
    getFeedbackStatusForGap,
    getFeedbackStatusWithCache
  } = useFillTheGapFeedback({
    rightAnswers,
    currentUserAnswer,
    isSubmit,
    isHiddenFeedback: isHiddenFeedback || acceptAnyAnswer
  });
  const isVisibleFeedback = isSubmit && !isHiddenFeedback;
  (0,react.useEffect)(() => {
    if (currentUserAnswer[0] === "empty_answer" && isAnswered) {
      submitAnswer();
    }
  }, [currentUserAnswer, isAnswered, submitAnswer]);
  (0,react.useEffect)(() => {
    if (numberOfFillTheGapControls === 0) {
      send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
        data: {
          answer: {
            [0]: "empty_answer"
          },
          correct: null
        }
      });
    }
  }, [numberOfFillTheGapControls, send]);
  const handleValueChanged = (0,react.useCallback)((index, value) => {
    const newAnswer = {
      ...currentUserAnswer,
      [index]: value
    };
    const allInputsFilled = Array.from(inputIds).every(inputId => newAnswer[inputId] && newAnswer[inputId].length > 0);
    let correct = true;
    let typo = false;
    let maxPossibleScore = 0;
    let rightAnswersScore = 0;
    const isRight = [];
    for (const [itemIndex, itemAnswers] of rightAnswers) {
      const status = getFeedbackStatusWithCache(itemIndex, newAnswer[itemIndex], itemAnswers);
      ++maxPossibleScore;
      isRight.push(status === "success");
      if (status === "success") {
        ++rightAnswersScore;
      }
      if (status === "error") {
        correct = false;
      }
      if (status === "typo") {
        typo = true;
      }
    }
    if (allInputsFilled) {
      const fillTheGapAnswer = (0,object_utils/* getObjectKeys */.Z)(newAnswer).reduce((res, itemIndex) => {
        res[itemIndex] = {
          answer: newAnswer[itemIndex],
          isRight: isRight[itemIndex]
        };
        return res;
      }, {});
      send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
        data: {
          answer: newAnswer,
          correct,
          typo,
          maxPossibleScore,
          rightAnswersScore,
          optionDescription: fillTheGapAnswer,
          skill
        }
      });
    } else {
      send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: newAnswer,
          correct,
          typo
        }
      });
    }
  }, [currentUserAnswer, getFeedbackStatusWithCache, inputIds, rightAnswers, send, skill]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: elementRef,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(FillTheGapText, {
      text: preparedText,
      currentUserAnswer,
      isSubmit,
      additionalRules: (0,fill_the_gap_rule/* getFillTheGapRule */.Z)(),
      placeholders,
      getFeedbackStatusForGap,
      handleValueChanged,
      isFeedback: false
    }), isVisibleFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      role: "status",
      "aria-label": intl.formatMessage({
        id: "mechanic.fillTheGap.feedback"
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(FillTheGapFeedback, {
        feedback,
        rightAnswers,
        currentUserAnswer,
        audio,
        isSubmit,
        isHiddenFeedback,
        children: !acceptAnyAnswer && /* @__PURE__ */(0,jsx_runtime.jsx)(FillTheGapText, {
          text: preparedText,
          currentUserAnswer,
          isSubmit,
          additionalRules: getCorrectVariantRule(currentUserAnswer),
          placeholders,
          getFeedbackStatusForGap,
          handleValueChanged,
          isFeedback: true
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.has-own.js
var es_object_has_own = __webpack_require__(20110);
// EXTERNAL MODULE: ../ui-kit/src/checkbox/index.ts + 7 modules
var src_checkbox = __webpack_require__(7535);
;// CONCATENATED MODULE: ./src/components/form-output/form-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_output_module = ({"root":"form-output-module__root--iviLw","label":"form-output-module__label--Bryxc","item":"form-output-module__item--YkbxC"});
;// CONCATENATED MODULE: ./src/components/form-output/form-output-checkbox/form-output-checkbox.component.tsx












const FormOutputCheckbox = _ref => {
  let {
    options,
    label,
    id,
    mechanicMachine
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const handleChange = (0,react.useCallback)((index, value) => {
    const contextAnswer = state.context.answer || {};
    const data = {
      ...contextAnswer,
      [id]: {
        ...contextAnswer[id],
        [index]: value
      }
    };
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: false
      }
    });
  }, [id, send, state.context.answer]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: form_output_module.root,
    children: [label && label.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(form_output_module.label, typography_module/* default */.Z.body2Accent),
      children: label
    }), options.map((option, index) => {
      const checked = ((state.context.answer || {})[id] || {})[index] || false;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
        className: form_output_module.item,
        onChange: value => handleChange(index, value),
        checked,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          wrapper: markdown_component/* Wrapper */.im.fragment,
          children: option
        })
      }, index);
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/radio-button/index.ts + 6 modules
var radio_button = __webpack_require__(13777);
;// CONCATENATED MODULE: ./src/components/form-output/form-output-radio/form-output-radio.component.tsx












const FormOutputRadio = _ref => {
  let {
    options,
    label,
    id,
    mechanicMachine
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const handleChange = (0,react.useCallback)(index => {
    const contextAnswer = state.context.answer || {};
    const data = {
      ...contextAnswer,
      [id]: index
    };
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: false
      }
    });
  }, [id, send, state.context.answer]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: form_output_module.root,
    children: [label && label.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(form_output_module.label, typography_module/* default */.Z.body2Accent),
      children: label
    }), options.map((option, index) => {
      const checked = (state.context.answer || {})[id] === index;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
        className: form_output_module.item,
        onChange: () => handleChange(index),
        checked,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          wrapper: markdown_component/* Wrapper */.im.fragment,
          children: option
        })
      }, index);
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/form-output/form-output-text/form-output-text.component.tsx









const FormOutputText = _ref => {
  let {
    label,
    id,
    mechanicMachine
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const handleChange = (0,react.useCallback)(event => {
    const contextAnswer = state.context.answer || {};
    const data = {
      ...contextAnswer,
      [id]: event.target.value
    };
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: false
      }
    });
  }, [id, send, state.context.answer]);
  const value = (0,react.useMemo)(() => (state.context.answer || {})[id] || "", [state.context.answer, id]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: form_output_module.root,
    children: [label && label.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(form_output_module.label, typography_module/* default */.Z.body2Accent),
      children: label
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(medium_input_component/* MediumInput */.m, {
      value,
      onChange: handleChange,
      isMultiline: true
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/form-output/form-output-textarea/form-output-textarea.component.tsx









const FormOutputTextarea = _ref => {
  let {
    label,
    id,
    mechanicMachine
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const handleChange = (0,react.useCallback)(event => {
    const contextAnswer = state.context.answer || {};
    const data = {
      ...contextAnswer,
      [id]: event.target.value
    };
    return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: false
      }
    });
  }, [id, send, state.context.answer]);
  const value = (0,react.useMemo)(() => (state.context.answer || {})[id] || "", [state.context.answer, id]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: form_output_module.root,
    children: [label && label.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(form_output_module.label, typography_module/* default */.Z.body2Accent),
      children: label
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(medium_input_component/* MediumInput */.m, {
      value,
      onChange: handleChange,
      isMultiline: true
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/form-output/form-output.component.tsx













const formContent = {
  checkbox: FormOutputCheckbox,
  radio: FormOutputRadio,
  textarea: FormOutputTextarea,
  text: FormOutputText
};
const FormOutput = _ref => {
  let {
    fields,
    mechanicMachine,
    onInViewChange,
    feedback
  } = _ref;
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const {
    state
  } = mechanicMachine;
  const customFeedbackMessages = feedback?.["on-success"] || feedback?.["on-error"];
  const isCustomFeedback = Boolean(customFeedbackMessages);
  const feedbackMessage = isSubmitState(state.value) && customFeedbackMessages;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: elementRef,
      children: fields.map(field => {
        const FormContent = formContent[field.type];
        return /* @__PURE__ */(0,jsx_runtime.jsx)(FormContent, {
          mechanicMachine,
          options: fieldHasOptions(field) ? field.options : [],
          ...field
        }, field.id);
      })
    }), feedbackMessage && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      errorMessages: feedbackMessage,
      isCustom: isCustomFeedback
    })]
  });
};
function fieldHasOptions(field) {
  return Object.hasOwn(field, "options");
}
// EXTERNAL MODULE: ../ui-kit/src/new-card/__content/card-content.component.tsx
var card_content_component = __webpack_require__(31533);
// EXTERNAL MODULE: ../ui-kit/src/new-card/card.component.tsx + 1 modules
var card_component = __webpack_require__(84435);
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/match-pairs.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const match_pairs_module = ({"root":"match-pairs-module__root--tpGHr","header":"match-pairs-module__header--maT2w","pairs":"match-pairs-module__pairs--Qi7fW","center":"match-pairs-module__center--kzkzI","key-card":"match-pairs-module__key-card--dEA1D","keyCard":"match-pairs-module__key-card--dEA1D"});
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__match-pair-card/match-pair-card-value.component.tsx









var MatchPairCardPos = /* @__PURE__ */(MatchPairCardPos2 => {
  MatchPairCardPos2["Default"] = "default";
  MatchPairCardPos2["Popup"] = "popup";
  return MatchPairCardPos2;
})(MatchPairCardPos || {});
var MatchPairCardValueStatus = /* @__PURE__ */(MatchPairCardValueStatus2 => {
  MatchPairCardValueStatus2["Empty"] = "empty";
  MatchPairCardValueStatus2["Unselected"] = "unselected";
  MatchPairCardValueStatus2["Selected"] = "selected";
  MatchPairCardValueStatus2["Submitted"] = "submitted";
  MatchPairCardValueStatus2["Feedback"] = "feedback";
  return MatchPairCardValueStatus2;
})(MatchPairCardValueStatus || {});
const MatchPairCardValue = _ref => {
  let {
    id,
    indexText,
    childrenType,
    children,
    onCardClick,
    status,
    position,
    isCorrect,
    isMobile
  } = _ref;
  const cardSize = (0,react.useMemo)(() => {
    if (childrenType === card_content_component/* ChildrenType */.L5.Box && isMobile) {
      if (position === "default" /* Default */) {
        return card_component/* CardSize */.Id.Large;
      }
      if (position === "popup" /* Popup */) {
        return card_component/* CardSize */.Id.Medium;
      }
    }
    return card_component/* CardSize */.Id.Large;
  }, [childrenType, position, isMobile]);
  const hotkey = (0,react.useMemo)(() => {
    if (status === "empty" /* Empty */ || status === "feedback" /* Feedback */) {
      return void 0;
    }
    let state;
    let content;
    if (status === "submitted" /* Submitted */) {
      state = isCorrect ? hot_key_component/* HotKeyState */.wu.Success : hot_key_component/* HotKeyState */.wu.Error;
      content = isCorrect ? hot_key_component/* HotKeyContentType */.cu.Check : hot_key_component/* HotKeyContentType */.cu.Cross;
    } else {
      state = status === "selected" /* Selected */ ? hot_key_component/* HotKeyState */.wu.Selected : hot_key_component/* HotKeyState */.wu.Default;
      content = hot_key_component/* HotKeyContentType */.cu.Text;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
      state,
      contentType: content,
      text: indexText
    });
  }, [indexText, isCorrect, status]);
  const borderColor = (0,react.useMemo)(() => {
    if (status === "submitted" /* Submitted */) {
      return isCorrect ? card_component/* BorderColor */.kf.Green : card_component/* BorderColor */.kf.Red;
    }
    return void 0;
  }, [isCorrect, status]);
  const backgroundColor = (0,react.useMemo)(() => {
    switch (status) {
      case "empty" /* Empty */:
      case "selected" /* Selected */:
      case "feedback" /* Feedback */:
        return card_component/* BgColor */.tv.Grey;
      default:
        return card_component/* BgColor */.tv.White;
    }
  }, [status]);
  const haveShadow = status === "unselected" /* Unselected */;
  const isCursorPointer = status !== "feedback" /* Feedback */;
  const isAdaptiveCard = childrenType === card_content_component/* ChildrenType */.L5.Text || status === "empty" /* Empty */ || (status === "selected" /* Selected */ || status === "submitted" /* Submitted */) && isMobile && position === "default" /* Default */;
  let cardTheme = 0;
  if (isCursorPointer) {
    cardTheme |= card_component/* CardTheme */.r0.CursorPointer;
  }
  if (isAdaptiveCard) {
    cardTheme |= card_component/* CardTheme */.r0.Adaptive;
  }
  if (status === "empty" /* Empty */) {
    cardTheme |= card_component/* CardTheme */.r0.SmallHeight;
  }
  if (status === "selected" /* Selected */ && position === "popup" /* Popup */) {
    cardTheme |= card_component/* CardTheme */.r0.WhiteHover;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(card_component/* Card */.Zb, {
    id,
    state: card_content_component/* CardState */.WF.Loaded,
    appearance: {
      size: cardSize,
      borderColor,
      bgColor: backgroundColor,
      haveShadow
    },
    childrenType,
    index: hotkey,
    cardTheme,
    onCardClick: status === "feedback" /* Feedback */ ? void 0 : onCardClick,
    isMobile,
    children: status === "empty" /* Empty */ ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: match_pairs_module.center,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "plus",
        size: "small"
      })
    }) : children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__match-pair-card/match-pair-card-key.component.tsx









var MatchPairCardKeyStatus = /* @__PURE__ */(MatchPairCardKeyStatus2 => {
  MatchPairCardKeyStatus2["Unselected"] = "unselected";
  MatchPairCardKeyStatus2["Selected"] = "selected";
  return MatchPairCardKeyStatus2;
})(MatchPairCardKeyStatus || {});
const MatchPairCardKey = _ref => {
  let {
    id,
    indexText,
    childrenType,
    children,
    position,
    isMobile
  } = _ref;
  const cardSize = (0,react.useMemo)(() => {
    if (childrenType === card_content_component/* ChildrenType */.L5.Box && isMobile) {
      if (position === MatchPairCardPos.Default) {
        return card_component/* CardSize */.Id.Small;
      }
      return card_component/* CardSize */.Id.Medium;
    }
    return card_component/* CardSize */.Id.Large;
  }, [childrenType, isMobile, position]);
  const hotkey = (0,react.useMemo)(() => {
    if (!indexText) {
      return void 0;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
      state: hot_key_component/* HotKeyState */.wu.Default,
      contentType: hot_key_component/* HotKeyContentType */.cu.Text,
      text: indexText
    });
  }, [indexText]);
  const borderColor = (0,react.useMemo)(() => {
    if (position === MatchPairCardPos.Popup) {
      return card_component/* BorderColor */.kf.Grey;
    }
    return void 0;
  }, [position]);
  const cardTheme = (0,react.useMemo)(() => {
    let val = 0;
    if (isMobile && position === MatchPairCardPos.Default) {
      val |= card_component/* CardTheme */.r0.WithoutPadding;
    }
    if (childrenType === card_content_component/* ChildrenType */.L5.Text) {
      val |= card_component/* CardTheme */.r0.Adaptive;
    }
    return val;
  }, [childrenType, isMobile, position]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: match_pairs_module.keyCard,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(card_component/* Card */.Zb, {
      id,
      state: card_content_component/* CardState */.WF.Loaded,
      appearance: {
        size: cardSize,
        borderColor,
        bgColor: card_component/* BgColor */.tv.White,
        haveShadow: false
      },
      cardTheme,
      index: hotkey,
      childrenType,
      children,
      isMobile
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__match-pair-card/match-pair-card.component.tsx






var CardType = /* @__PURE__ */(CardType2 => {
  CardType2["Key"] = "key";
  CardType2["Value"] = "value";
  return CardType2;
})(CardType || {});
const MatchPairCard = props => {
  const {
    id,
    indexText,
    childrenType,
    position,
    isMobile,
    children,
    type,
    onCardClick
  } = props;
  switch (type) {
    case "key" /* Key */:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairCardKey, {
          id,
          indexText,
          childrenType,
          position,
          isMobile,
          children
        });
      }
    case "value" /* Value */:
      {
        const {
          status,
          isCorrect
        } = props;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairCardValue, {
          id,
          indexText,
          childrenType,
          onCardClick,
          status,
          position,
          isCorrect,
          isMobile,
          children
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__big-card/big-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const big_card_module = ({"root":"big-card-module__root--AInfE","values":"big-card-module__values--GVLct","value":"big-card-module__value--v2P__","grey-background":"big-card-module__grey-background--ZkS9n","greyBackground":"big-card-module__grey-background--ZkS9n","shadow":"big-card-module__shadow--Bt1Di","text-value":"big-card-module__text-value--_RVQC","textValue":"big-card-module__text-value--_RVQC"});
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__big-card/big-card.component.tsx











var BigCardStatus = /* @__PURE__ */(BigCardStatus2 => {
  BigCardStatus2["Unselected"] = "unselected";
  BigCardStatus2["Selected"] = "selected";
  BigCardStatus2["Submitted"] = "submitted";
  BigCardStatus2["Feedback"] = "feedback";
  return BigCardStatus2;
})(BigCardStatus || {});
const BigCard = _ref => {
  let {
    id,
    card,
    onClick,
    isMobile = false,
    isKeyPressAvailable
  } = _ref;
  const {
    key,
    values,
    status
  } = card;
  const handlePairClick = (0,react.useCallback)(() => {
    if (status !== "submitted" /* Submitted */) {
      onClick(id);
    }
  }, [id, onClick, status]);
  (0,useKeyPress/* useKeyPress */.K)(`Key${key.indexText}`, () => {
    isKeyPressAvailable && handlePairClick();
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    role: "presentation",
    className: classnames_default()(big_card_module.root, {
      [big_card_module.shadow]: status === "unselected" /* Unselected */
    }),
    onClick: handlePairClick,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairCard, {
      id: key.id,
      indexText: status === "feedback" /* Feedback */ ? void 0 : key.indexText,
      childrenType: key.childrenType,
      type: CardType.Key,
      position: MatchPairCardPos.Default,
      isMobile,
      children: key.children
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: big_card_module.values,
      children: values.map(value => {
        const valueStatus = {
          unselected: MatchPairCardValueStatus.Empty,
          selected: MatchPairCardValueStatus.Selected,
          submitted: MatchPairCardValueStatus.Submitted,
          feedback: MatchPairCardValueStatus.Feedback
        }[status];
        const handleValueClick = valueId => {
          if (value.onCardClick) {
            value.onCardClick(valueId);
          }
        };
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: big_card_module.value,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairCard, {
            id: value.id,
            indexText: value.indexText,
            childrenType: value.childrenType,
            onCardClick: handleValueClick,
            status: valueStatus,
            position: MatchPairCardPos.Default,
            type: CardType.Value,
            isCorrect: value.isCorrect,
            isMobile,
            children: value.children
          })
        }, value.id);
      })
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__popup/popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const popup_module = ({"popup":"popup-module__popup--BdXsB","values":"popup-module__values--eg6CM","values-box":"popup-module__values-box--QSMFr","valuesBox":"popup-module__values-box--QSMFr"});
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/__popup/popup.component.tsx












const PopupValues = _ref => {
  let {
    valueCards,
    valuePairMap,
    onValueClick,
    isMobile
  } = _ref;
  const isValueChildrenTypeBox = valueCards.length !== 0 ? valueCards[0].childrenType === card_content_component/* ChildrenType */.L5.Box : false;
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(digit => (
  /* valueId для функции onValueClick берется из файла match-pairs-output.
   * для элементов попапа id формируется так: `popup_value_${index}`,
   * где index - номер элемента
   * */
  onValueClick(`popup_value_${digit - 1}`)));
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(popup_module.values, {
      [popup_module.valuesBox]: isValueChildrenTypeBox
    }),
    children: valueCards.map(value => /* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairCard, {
      ...value,
      type: CardType.Value,
      status: valuePairMap[value.id] && valuePairMap[value.id] !== null ? MatchPairCardValueStatus.Selected : MatchPairCardValueStatus.Unselected,
      position: MatchPairCardPos.Popup,
      onCardClick: value.onCardClick ?? onValueClick,
      isMobile
    }, value.id))
  });
};
const Popup = _ref2 => {
  let {
    textConstants,
    keyCard,
    valueCards,
    valuePairMap,
    isVisible,
    onClose,
    onValueClick,
    isNarrow = false,
    isMobile = false
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* TinyModal */.WR, {
    isNarrow,
    isVisible: isVisible && keyCard !== null,
    onClose,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: popup_module.popup,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(modal/* ModalContent */.hz, {
        size: modal/* ModalSize */.Cg.Huge,
        title: !isMobile && textConstants.title,
        subtitle: isMobile ? textConstants.title : textConstants.subtitle,
        children: [keyCard !== null && /* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairCard, {
          ...keyCard,
          type: CardType.Key,
          position: MatchPairCardPos.Popup,
          isMobile
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(PopupValues, {
          valuePairMap,
          valueCards,
          onValueClick,
          isMobile
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/match-pairs/match-pairs.component.tsx













const MatchPairs = _ref => {
  let {
    pairs,
    onPairsChange,
    values,
    valuePairMap,
    textConstants,
    isNarrow,
    isMobile,
    isKeyPressAvailable
  } = _ref;
  const [pairId, setPairId] = (0,react.useState)(null);
  const handleClosePopup = (0,react.useCallback)(() => {
    setPairId(null);
  }, []);
  const setSelectedValues = (0,react.useCallback)((popupValueId, pairsWithoutSelectedPair) => {
    if (pairId === null) {
      return pairsWithoutSelectedPair;
    }
    const changingPair = pairsWithoutSelectedPair[pairId];
    const changingPairValue = changingPair.values[0];
    const newValue = values[popupValueId];
    return {
      ...pairsWithoutSelectedPair,
      [pairId]: {
        ...changingPair,
        values: [{
          id: changingPairValue.id,
          optionId: newValue.optionId,
          indexText: newValue.indexText,
          childrenType: newValue.childrenType,
          children: newValue.children,
          onCardClick: newValue.onCardClick,
          content: newValue.content
        }],
        status: BigCardStatus.Selected
      }
    };
  }, [pairId, values]);
  const setEmptyValues = (0,react.useCallback)((popupValueId, pairsWithNotEmptyPair) => {
    const changingPairId = valuePairMap[popupValueId];
    if (!changingPairId) {
      return pairsWithNotEmptyPair;
    }
    const changingPair = pairsWithNotEmptyPair[changingPairId];
    const changingPairValue = changingPair.values[0];
    const pairsWithEmptyPair = {
      ...pairsWithNotEmptyPair,
      [changingPairId]: {
        ...changingPair,
        values: [{
          id: changingPairValue.id,
          optionId: void 0,
          childrenType: changingPairValue.childrenType
        }],
        status: BigCardStatus.Unselected
      }
    };
    return setSelectedValues(popupValueId, pairsWithEmptyPair);
  }, [setSelectedValues, valuePairMap]);
  const handlePairClick = (0,react.useCallback)(pairId2 => {
    setPairId(pairId2);
  }, []);
  const handlePopupValueClick = (0,react.useCallback)(popupValueId => {
    const newValuePairMap = (0,object_utils/* getObjectKeys */.Z)(valuePairMap).reduce((res, popupValueId2) => {
      res[popupValueId2] = valuePairMap[popupValueId2] === pairId ? null : valuePairMap[popupValueId2];
      return res;
    }, {});
    const newPairs = newValuePairMap[popupValueId] ? setEmptyValues(popupValueId, pairs) : setSelectedValues(popupValueId, pairs);
    if (pairId !== null) {
      newValuePairMap[popupValueId] = pairId;
    }
    onPairsChange(newPairs, newValuePairMap);
    handleClosePopup();
  }, [handleClosePopup, onPairsChange, pairId, pairs, setEmptyValues, setSelectedValues, valuePairMap]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: match_pairs_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: match_pairs_module.pairs,
      children: Object.keys(pairs).map(pairId2 => {
        const pair = pairs[pairId2];
        return /* @__PURE__ */(0,jsx_runtime.jsx)(BigCard, {
          isKeyPressAvailable,
          id: pairId2,
          card: pair,
          onClick: handlePairClick,
          isMobile
        }, pairId2);
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Popup, {
      textConstants: {
        title: textConstants.popupTitle,
        subtitle: textConstants.popupSubtitle
      },
      keyCard: pairId ? pairs[pairId]?.key : null,
      valueCards: Object.values(values),
      valuePairMap,
      isVisible: Boolean(pairId),
      onClose: handleClosePopup,
      onValueClick: handlePopupValueClick,
      isNarrow,
      isMobile
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/match-pairs-output/__feedback/feedback.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const _feedback_feedback_module = ({"custom-feedback-content":"feedback-module__custom-feedback-content--C2j4o","customFeedbackContent":"feedback-module__custom-feedback-content--C2j4o"});
;// CONCATENATED MODULE: ./src/components/match-pairs-output/__feedback/feedback.component.tsx

















const feedback_component_Feedback = _ref => {
  let {
    feedback,
    isMobile,
    pairs,
    rightPairs
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const successFeedbackMessages = (0,react.useMemo)(() => feedback?.["on-success"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Success)
  }), [intl, feedback]);
  const errorFeedbackMessages = (0,react.useMemo)(() => feedback?.["on-error"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Error)
  }), [feedback, intl]);
  const wrongAnswersPairId = Object.keys(pairs).reduce((res, pairId) => {
    const pairValue = pairs[pairId].values[0];
    if (!pairValue.isCorrect) {
      res.push(pairId);
    }
    return res;
  }, []);
  const isSuccess = wrongAnswersPairId.length === 0;
  const isCustomFeedback = Boolean(isSuccess && feedback?.["on-success"] || !isSuccess && feedback?.["on-error"]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
    success: isSuccess,
    successMessages: successFeedbackMessages,
    errorMessages: errorFeedbackMessages,
    isCustom: isCustomFeedback,
    isScrollable: true,
    children: wrongAnswersPairId.map(wrongAnswerPairId => {
      const feedbackPair = {
        ...rightPairs[wrongAnswerPairId],
        status: BigCardStatus.Feedback
      };
      return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()({
          [_feedback_feedback_module.customFeedbackContent]: isCustomFeedback
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(BigCard, {
          isKeyPressAvailable: false,
          id: feedbackPair.key.id,
          card: feedbackPair,
          onClick: function_utils/* emptyFunction */.Bi,
          isMobile
        })
      }, feedbackPair.key.id);
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/centered-audio-with-lines/centered-audio-with-lines.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const centered_audio_with_lines_module = ({"box":"centered-audio-with-lines-module__box--CcsKA","play":"centered-audio-with-lines-module__play--ueeNS","center":"centered-audio-with-lines-module__center--EL2U_","center-y":"centered-audio-with-lines-module__center-y--sBwN1","centerY":"centered-audio-with-lines-module__center-y--sBwN1","lines":"centered-audio-with-lines-module__lines--k8zTw","line":"centered-audio-with-lines-module__line--N9w30","orange-line":"centered-audio-with-lines-module__orange-line--CDVyL","orangeLine":"centered-audio-with-lines-module__orange-line--CDVyL","disabled":"centered-audio-with-lines-module__disabled--yGTGz"});
;// CONCATENATED MODULE: ../ui-kit/src/centered-audio-with-lines/centered-audio-with-lines.component.tsx








const CenteredAudioWithLines = _ref => {
  let {
    src,
    iconSize = "medium",
    type
  } = _ref;
  const {
    playing,
    canPlay
  } = (0,useAudio/* useAudioHandler */.GH)(src, type);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: centered_audio_with_lines_module.box,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(AudioLines, {
      numberOfLines: 52,
      playing,
      className: classnames_default()(centered_audio_with_lines_module.centerY, {
        [centered_audio_with_lines_module.disabled]: !canPlay
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(centered_audio_with_lines_module.lines, centered_audio_with_lines_module.center, centered_audio_with_lines_module.play),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: centered_audio_with_lines_module.center,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(AudioOutput, {
          src,
          type,
          iconSize,
          appearance: "primary",
          isStopPropagationNeeded: true
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/match-pairs-output/useMatchPairs.tsx


























const useMatchPairs = _ref => {
  let {
    outputPairs,
    hint,
    shuffleHash,
    answer
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const textConstants = (0,react.useMemo)(() => ({
    popupTitle: hint?.target ?? intl.formatMessage({
      id: "matchPairs.title"
    }),
    popupSubtitle: hint?.source ?? intl.formatMessage({
      id: "matchPairs.subtitle"
    })
  }), [hint?.source, hint?.target, intl]);
  const rightAnswer = (0,react.useMemo)(() => {
    if (!outputPairs) {
      return [];
    }
    return outputPairs.reduce((res, _ref2, index) => {
      let [firstOption, secondOption] = _ref2;
      const isIncorrectOrderOptions = firstOption.type !== "audio" && secondOption.type === "audio";
      res.push({
        id: `pair_${index}`,
        key: isIncorrectOrderOptions ? secondOption : firstOption,
        value: isIncorrectOrderOptions ? firstOption : secondOption
      });
      return res;
    }, []);
  }, [outputPairs]);
  const optionsMap = (0,react.useMemo)(() => rightAnswer.reduce((res, _ref3, index) => {
    let {
      key,
      value
    } = _ref3;
    res[`option_key_${index}`] = key;
    res[`option_value_${index}`] = value;
    return res;
  }, {}), [rightAnswer]);
  const rightPairs = (0,react.useMemo)(() => rightAnswer.reduce((res, _ref4, index) => {
    let {
      id,
      key,
      value
    } = _ref4;
    res[id] = {
      key: {
        id: `key_${index}`,
        childrenType: mapCardType(key),
        children: mapCardChildren({
          option: key,
          audioComponent: "feedbackWithAudio"
        }),
        content: getOptionStringContent(key)
      },
      values: [{
        id: `value_${index}`,
        childrenType: mapCardType(value),
        children: mapCardChildren({
          option: value,
          audioComponent: "feedbackWithAudio"
        }),
        content: getOptionStringContent(value)
      }],
      status: BigCardStatus.Unselected
    };
    return res;
  }, {}), [rightAnswer]);
  const values = (0,react.useMemo)(() => {
    const shuffleAnswers = (0,array_utils/* shuffleArray */.Sy)(rightAnswer.map((rightAnswer2, index) => ({
      optionId: `option_value_${index}`,
      childrenType: mapCardType(rightAnswer2.value),
      children: mapCardChildren({
        option: rightAnswer2.value
      }),
      content: getOptionStringContent(rightAnswer2.value)
    })), answer2 => answer2.content, shuffleHash);
    return shuffleAnswers.reduce((res, answer2, index) => {
      res[`popup_value_${index}`] = {
        id: `popup_value_${index}`,
        indexText: String(index + 1),
        ...answer2
      };
      return res;
    }, {});
  }, [rightAnswer, shuffleHash]);
  const shuffledPairs = (0,react.useMemo)(() => rightAnswer.reduce((res, _ref5, index) => {
    let {
      id,
      key,
      value
    } = _ref5;
    const answerValue = answer && answer[index] ? answer[index][1] : null;
    const popupValue = answerValue ? Object.values(values).find(initialValue => initialValue.optionId === answerValue.id) : null;
    const pairValue = popupValue ? {
      id: `value_${index}`,
      optionId: popupValue.optionId,
      indexText: popupValue.indexText,
      childrenType: popupValue.childrenType,
      children: popupValue.children,
      content: popupValue.content
    } : {
      id: `value_${index}`,
      childrenType: mapCardType(value)
    };
    res[id] = {
      key: {
        id: `key_${index}`,
        optionId: `option_key_${index}`,
        indexText: String.fromCharCode(string_utils/* A_CHAR_CODE */.WM + index),
        childrenType: mapCardType(key),
        children: mapCardChildren({
          option: key
        }),
        content: getOptionStringContent(key)
      },
      values: [pairValue],
      status: answerValue ? BigCardStatus.Selected : BigCardStatus.Unselected
    };
    return res;
  }, {}), [answer, rightAnswer, values]);
  return {
    textConstants,
    rightAnswer,
    optionsMap,
    rightPairs,
    values,
    shuffledPairs,
    getIncorrectPairIds,
    reduceSubmittedPairs
  };
};
const mapCardType = option => {
  const type = option.type;
  switch (type) {
    case trainer_model/* OptionType */.GL.Text:
      return card_content_component/* ChildrenType */.L5.Text;
    case trainer_model/* OptionType */.GL.Image:
    case trainer_model/* OptionType */.GL.Audio:
      return card_content_component/* ChildrenType */.L5.Box;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
const mapCardChildren = _ref6 => {
  let {
    option,
    cardSize,
    audioComponent = "matchPairsWithAudio"
  } = _ref6;
  const type = option.type;
  switch (type) {
    case trainer_model/* OptionType */.GL.Text:
      return option.text;
    case trainer_model/* OptionType */.GL.Image:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
        src: option.image.url
      });
    case trainer_model/* OptionType */.GL.Audio:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(CenteredAudioWithLines, {
        src: getOptionAudioSrc(option.audio),
        iconSize: cardSize,
        type: audioComponent
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
const isCorrectAnswer = (rightAnswer, userAnswer) => {
  if (!rightAnswer || userAnswer === null) {
    return false;
  }
  return getOptionStringContent(rightAnswer.key) === userAnswer.key.content && getOptionStringContent(rightAnswer.value) === userAnswer.values[0].content;
};
const getIncorrectPairIds = (pairs, initialRightAnswer) => Object.keys(pairs).filter(pairId => {
  const pair = pairs[pairId];
  return pair.values.every(() => {
    const rightAnswer = initialRightAnswer.find(rightAnswer2 => rightAnswer2.id === pairId);
    return !isCorrectAnswer(rightAnswer, pair);
  });
});
const reduceSubmittedPairs = (pairs, initialRightAnswer) => Object.keys(pairs).reduce((res, pairId) => {
  const pair = pairs[pairId];
  const newPairValues = pair.values.map(value => {
    const rightAnswer = initialRightAnswer.find(rightAnswer2 => rightAnswer2.id === pairId);
    return {
      ...value,
      isCorrect: isCorrectAnswer(rightAnswer, pair)
    };
  });
  res[pairId] = {
    ...pair,
    values: newPairValues,
    status: BigCardStatus.Submitted
  };
  return res;
}, {});
;// CONCATENATED MODULE: ./src/components/match-pairs-output/match-pairs-output.component.tsx


















const mapPairsToMatchPairsAnswer = (pairs, optionsMap) => Object.values(pairs).reduce((res, _ref) => {
  let {
    key,
    values
  } = _ref;
  const keyId = key.optionId;
  const valueId = values[0].optionId;
  if (keyId && valueId) {
    res.push([{
      id: keyId,
      value: optionsMap[keyId]
    }, {
      id: valueId,
      value: optionsMap[valueId]
    }]);
  } else if (keyId) {
    res.push([{
      id: keyId,
      value: optionsMap[keyId]
    }, null]);
  }
  return res;
}, []);
const MatchPairsOutput = _ref2 => {
  let {
    outputPairs,
    shuffleHash,
    mechanicMachine,
    feedback,
    hint,
    isLastBlock
  } = _ref2;
  const {
    state,
    send
  } = mechanicMachine;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    withTaskGuide
  } = (0,react.useContext)(product_trainer_renderer_context/* ProductTrainerRendererContextComponent */.p);
  const isSubmitted = isSubmitState(state.value);
  const answer = (0,react.useMemo)(() => {
    if (!Array.isArray(state.context.answer)) {
      return [];
    }
    return state.context.answer;
  }, [state.context.answer]);
  const {
    textConstants,
    rightAnswer: initialRightAnswer,
    optionsMap,
    rightPairs: initialRightPairs,
    values: initialValues,
    shuffledPairs: initialPairs,
    getIncorrectPairIds,
    reduceSubmittedPairs
  } = useMatchPairs({
    outputPairs,
    answer,
    hint,
    shuffleHash
  });
  const [pairs, setPairs] = (0,react.useState)({});
  const [valuePairMap, setValuePairMap] = (0,react.useState)({});
  const handleChangePairs = (newPairs, newValuePairMap) => {
    setPairs(newPairs);
    setValuePairMap(newValuePairMap);
    const allPairsMatched = Object.values(newPairs).every(pair => pair.status === BigCardStatus.Selected);
    const answerPairs = mapPairsToMatchPairsAnswer(newPairs, optionsMap);
    if (allPairsMatched) {
      send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
        data: {
          answer: answerPairs,
          correct: getIncorrectPairIds(newPairs, initialRightAnswer).length === 0
        }
      });
    } else {
      send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: answerPairs
        }
      });
    }
  };
  (0,react.useEffect)(() => {
    if (!isSubmitted) {
      setPairs(initialPairs);
    }
    if (answer.length === 0 && !isSubmitted) {
      setValuePairMap({});
    }
    if (isSubmitted) {
      setPairs(prevState => reduceSubmittedPairs(Object.keys(prevState).length ? prevState : initialPairs, initialRightAnswer));
    }
  }, [answer.length, initialPairs, initialRightAnswer, isSubmitted, reduceSubmittedPairs]);
  const isFeedbackVisible = (0,react.useMemo)(() => {
    const isSubmittedPairs = Object.values(pairs).every(pair => pair.status === BigCardStatus.Submitted);
    return isSubmitted && isSubmittedPairs;
  }, [isSubmitted, pairs]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairs, {
      pairs,
      values: initialValues,
      valuePairMap,
      onPairsChange: handleChangePairs,
      textConstants,
      isNarrow: withTaskGuide,
      isMobile,
      isKeyPressAvailable: isLastBlock
    }), isFeedbackVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(feedback_component_Feedback, {
      feedback,
      pairs,
      isMobile,
      rightPairs: initialRightPairs
    })]
  });
};
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.model.ts
var trainer_trainer_model = __webpack_require__(92601);
;// CONCATENATED MODULE: ./src/components/match-titles-output/title/titles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const titles_module = ({"titles-container":"titles-module__titles-container--VglSs","titlesContainer":"titles-module__titles-container--VglSs","selected-title":"titles-module__selected-title--r1mGY","selectedTitle":"titles-module__selected-title--r1mGY"});
;// CONCATENATED MODULE: ./src/components/match-titles-output/title/title.component.tsx






const MatchTitlesTitle = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
    ...getTextButtonProps(props),
    children
  });
};
const getTextButtonProps = _ref2 => {
  let {
    id,
    type,
    onClick
  } = _ref2;
  switch (type) {
    case "selected":
      return {
        shadow: false,
        color: text_button_component/* Color */.I.Transparent,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Default,
        hotKeyText: id,
        transparentText: false,
        onClick,
        classes: {
          button: titles_module.selectedTitle
        }
      };
    case "active":
      return {
        shadow: false,
        color: text_button_component/* Color */.I.Transparent,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Selected,
        hotKeyText: id,
        hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Check,
        transparentText: false,
        onClick
      };
    case "success":
      return {
        shadow: false,
        color: text_button_component/* Color */.I.Green,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Success,
        hotKeyText: id,
        hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Check,
        transparentText: false
      };
    case "error":
      return {
        shadow: false,
        color: text_button_component/* Color */.I.Red,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Error,
        hotKeyText: id,
        hotKeyContentType: hot_key_component/* HotKeyContentType */.cu.Cross,
        transparentText: false
      };
    case "empty":
      return {
        shadow: true,
        color: text_button_component/* Color */.I.Transparent,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Default,
        hotKeyText: id,
        transparentText: true,
        onClick
      };
    case "default":
    default:
      return {
        shadow: true,
        color: text_button_component/* Color */.I.Transparent,
        hotKeyState: hot_key_component/* HotKeyState */.wu.Default,
        hotKeyText: id,
        transparentText: false,
        onClick
      };
  }
};
;// CONCATENATED MODULE: ./src/components/match-titles-output/title/titles.component.tsx









const Titles = _ref => {
  let {
    isOpened,
    titleIndex,
    curTitleOptions,
    titleOptions,
    onChange
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: titles_module.titlesContainer,
    children: isOpened ? /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: titleOptions.map(titleOption => {
        const id = String.fromCharCode(string_utils/* A_CHAR_CODE */.WM + Number(titleOption.value));
        return /* @__PURE__ */(0,jsx_runtime.jsx)(MatchTitlesTitle, {
          id: (0,trainer_trainer_model/* makeTitleId */.bD)(id),
          type: titleOption.disabled ? "selected" : "default",
          onClick: () => onChange(titleOption.value),
          children: titleOption.title
        }, titleOption.value);
      })
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(CurrentTitle, {
      titleIndex,
      curTitleOptions,
      onChange
    })
  });
};
const CurrentTitle = _ref2 => {
  let {
    titleIndex,
    curTitleOptions,
    onChange
  } = _ref2;
  if (curTitleOptions.length > 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: curTitleOptions.map(curTitleOption => /* @__PURE__ */(0,jsx_runtime.jsx)(MatchTitlesTitle, {
        id: (0,trainer_trainer_model/* makeTitleId */.bD)(titleIndex),
        type: curTitleOption.type ?? "default",
        onClick: () => onChange((0,trainer_trainer_model/* makeTitleId */.bD)(titleIndex)),
        children: curTitleOption.title
      }, titleIndex))
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(MatchTitlesTitle, {
    id: (0,trainer_trainer_model/* makeTitleId */.bD)(titleIndex),
    type: "empty",
    onClick: () => onChange((0,trainer_trainer_model/* makeTitleId */.bD)(titleIndex))
  }, titleIndex);
};
;// CONCATENATED MODULE: ./src/components/match-titles-output/match-titles-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const match_titles_output_module = ({"paragraph":"match-titles-output-module__paragraph--ZdUPS","text":"match-titles-output-module__text--D8MoV"});
;// CONCATENATED MODULE: ./src/components/match-titles-output/match-titles-output.component.tsx




























const MatchTitlesOutputComponent = _ref => {
  let {
    paragraphs,
    shuffleHash,
    mechanicMachine,
    feedback,
    lastBlock = false
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  const [openedTitleId, setOpenedTitleId] = (0,react.useState)(null);
  const answer = (0,react.useMemo)(() => state.context.answer || {}, [state.context.answer]);
  const isSubmitted = (0,react.useMemo)(() => isSubmitState(state.value), [state.value]);
  const selectedTitles = (0,react.useMemo)(() => Object.keys(answer).reduce((acc, paragraphIndex) => {
    const titleId = answer[(0,trainer_trainer_model/* makeParagraphId */.Gi)(paragraphIndex)].value;
    return {
      ...acc,
      [titleId]: (0,trainer_trainer_model/* makeParagraphId */.Gi)(paragraphIndex)
    };
  }, {}), [answer]);
  const shuffledTitleOptions = (0,react.useMemo)(() => (0,array_utils/* shuffleArray */.Sy)(paragraphs, paragraph => paragraph.text, shuffleHash), [paragraphs, shuffleHash]);
  const titleOptions = (0,react.useMemo)(() => shuffledTitleOptions.map((paragraph, index) => {
    const titleIndex = (0,trainer_trainer_model/* makeTitleId */.bD)(index);
    const isTitleSelected = selectedTitles[titleIndex] !== void 0;
    return {
      title: paragraph.title,
      value: titleIndex,
      disabled: isTitleSelected
    };
  }), [selectedTitles, shuffledTitleOptions]);
  const getIsAllSelectionsRightFlag = (0,react.useCallback)(userAnswer => {
    if (!isSubmitted) {
      return true;
    }
    return paragraphs.every((p, index) => p.title === userAnswer[(0,trainer_trainer_model/* makeParagraphId */.Gi)(index)].title);
  }, [isSubmitted, paragraphs]);
  const handleAnswer = (0,react.useCallback)((titleId, paragraphIndex) => {
    const selectedTitleParagraphIndex = selectedTitles[titleId];
    const mutableAnswer = {
      ...state.context.answer
    };
    if (selectedTitleParagraphIndex !== void 0) {
      delete mutableAnswer[selectedTitleParagraphIndex];
    }
    const selectedTitle = titleOptions.find(o => o.value === titleId);
    const newAnswer = {
      ...mutableAnswer,
      ...(selectedTitle && {
        [paragraphIndex]: selectedTitle
      })
    };
    const actionType = Object.keys(newAnswer).length !== paragraphs.length ? mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER : mechanic_machine_consts/* EVENTS */.FP.ANSWER;
    return send(actionType, {
      data: {
        answer: newAnswer,
        correct: getIsAllSelectionsRightFlag(newAnswer)
      }
    });
  }, [getIsAllSelectionsRightFlag, paragraphs.length, selectedTitles, send, state.context.answer, titleOptions]);
  const handleChange = (titleId, paragraphId) => {
    setOpenedTitleId(prev => {
      if (prev === null) {
        return titleId;
      }
      return null;
    });
    openedTitleId !== null && handleAnswer(titleId, paragraphId);
  };
  const isAllSelectionsRight = (0,react.useMemo)(() => getIsAllSelectionsRightFlag(answer), [answer, getIsAllSelectionsRightFlag]);
  const titleOptionsChars = titleOptions.reduce((acc, titleOption) => {
    const key = `Key${String.fromCharCode(string_utils/* A_CHAR_CODE */.WM + Number(titleOption.value))}`;
    acc[key] = titleOption.value;
    return acc;
  }, {});
  const titleOptionsDigits = titleOptions.map(titleOption => Number(titleOption.value) + 1);
  (0,useKeyPress/* useKeyPress */.K)(Object.keys(titleOptionsChars), event => {
    const titleId = titleOptionsChars[event.code];
    const paragraphId = Number(openedTitleId) - 1;
    openedTitleId !== null && handleChange(titleId, (0,trainer_trainer_model/* makeParagraphId */.Gi)(paragraphId));
  }, !lastBlock);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(digit => {
    if (titleOptionsDigits.includes(digit)) {
      setOpenedTitleId((0,trainer_trainer_model/* makeTitleId */.bD)(digit));
    }
  }, !lastBlock);
  const successMessages = feedback ? feedback["on-success"] : void 0;
  const errorMessages = feedback ? feedback["on-error"] : void 0;
  const isCustomFeedback = Boolean(isAllSelectionsRight && successMessages || !isAllSelectionsRight && errorMessages);
  const showFeedback = isSubmitted && isCustomFeedback;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [paragraphs.map((p, index) => {
      const paragraphId = (0,trainer_trainer_model/* makeParagraphId */.Gi)(index);
      const type = getType({
        isSubmit: isSubmitted,
        userAnswerTitle: String(answer[paragraphId]?.title ?? ""),
        correctAnswerTitle: p.title ?? ""
      });
      const cutTitleOption = answer[paragraphId] ? [{
        ...answer[paragraphId],
        type
      }] : [];
      if (isSubmitted && answer[paragraphId]?.title !== p.title) {
        cutTitleOption.push({
          type: "active",
          title: p.title,
          value: (0,trainer_trainer_model/* makeTitleId */.bD)(0),
          disabled: false
        });
      }
      const titleIndex = index + 1;
      const isOpenedTitle = openedTitleId === titleIndex;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: match_titles_output_module.paragraph,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Titles, {
          isOpened: isOpenedTitle,
          titleIndex,
          curTitleOptions: cutTitleOption,
          titleOptions,
          onChange: titleId => handleChange(titleId, paragraphId)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body1, match_titles_output_module.text),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            rules: translation_tooltip_rule/* translationTooltipRule */.N,
            children: p.text
          })
        })]
      }, p.text);
    }), showFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      successMessages,
      errorMessages,
      success: isAllSelectionsRight,
      isCustom: isCustomFeedback
    })]
  });
};
const getType = props => {
  if (!props.isSubmit) {
    return "default";
  }
  return props.userAnswerTitle === props.correctAnswerTitle ? "success" : "error";
};
// EXTERNAL MODULE: ../shared/src/getComponentSize.ts
var getComponentSize = __webpack_require__(52856);
;// CONCATENATED MODULE: ../ui-kit/src/option-button/option-button.component.tsx












const color = {
  default: text_button_component/* Color */.I.Transparent,
  selected: text_button_component/* Color */.I.Transparent,
  success: text_button_component/* Color */.I.Green,
  error: text_button_component/* Color */.I.Red,
  submit: text_button_component/* Color */.I.lightBlack,
  checked: text_button_component/* Color */.I.Transparent
};
const hotKeyState = {
  default: hot_key_component/* HotKeyState */.wu.Default,
  selected: hot_key_component/* HotKeyState */.wu.Selected,
  success: hot_key_component/* HotKeyState */.wu.Success,
  error: hot_key_component/* HotKeyState */.wu.Error,
  submit: hot_key_component/* HotKeyState */.wu.Selected,
  checked: hot_key_component/* HotKeyState */.wu.Selected
};
const hotKeyContentType = {
  default: hot_key_component/* HotKeyContentType */.cu.Text,
  selected: hot_key_component/* HotKeyContentType */.cu.Text,
  success: hot_key_component/* HotKeyContentType */.cu.Check,
  error: hot_key_component/* HotKeyContentType */.cu.Cross,
  submit: hot_key_component/* HotKeyContentType */.cu.Text,
  checked: hot_key_component/* HotKeyContentType */.cu.Check
};
const borderColor = {
  default: void 0,
  selected: void 0,
  success: card_component/* BorderColor */.kf.Green,
  error: card_component/* BorderColor */.kf.Red,
  submit: card_component/* BorderColor */.kf.Black,
  checked: void 0
};
const Index = _ref => {
  let {
    type,
    label
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
    state: hotKeyState[type],
    contentType: hotKeyContentType[type],
    text: label
  });
};
const OptionTextButton = _ref2 => {
  let {
    type,
    part,
    onClick
  } = _ref2;
  const labelIndex = part.id + 1;
  const withShadow = type === "default" || type === "selected";
  const text = Array.isArray(part.text) ? part.text.join(" ") : part.text;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(text_button_component/* TextButton */.A, {
    shadow: withShadow,
    color: color[type],
    transparentText: false,
    hotKeyText: labelIndex,
    hotKeyState: hotKeyState[type],
    hotKeyContentType: hotKeyContentType[type],
    onClick,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      wrapper: markdown_component/* Wrapper */.im.fragment,
      children: text
    })
  });
};
const OptionBoxButton = _ref3 => {
  let {
    type,
    part,
    partSize,
    onClick,
    children,
    isMobile
  } = _ref3;
  const cardId = String(part.id + 1);
  const haveShadow = type === "default" || type === "selected";
  const cardTheme = haveShadow ? card_component/* CardTheme */.r0.CursorPointer : void 0;
  const cardSize = partSize ?? (type === "default" ? card_component/* CardSize */.Id.Large : card_component/* CardSize */.Id.Small);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(card_component/* Card */.Zb, {
    id: cardId,
    index: /* @__PURE__ */(0,jsx_runtime.jsx)(Index, {
      type,
      label: cardId
    }),
    state: card_content_component/* CardState */.WF.Loaded,
    appearance: {
      size: cardSize,
      bgColor: card_component/* BgColor */.tv.White,
      haveShadow,
      borderColor: borderColor[type]
    },
    childrenType: card_content_component/* ChildrenType */.L5.Box,
    cardTheme,
    onCardClick: onClick,
    isMobile,
    children
  });
};
const iconSize = {
  small: "small",
  medium: "medium",
  large: "medium"
};
const OptionButton = _ref4 => {
  let {
    part,
    getAudioSrc,
    audioComponent,
    ...props
  } = _ref4;
  const type = part.type;
  switch (type) {
    case trainer_model/* OptionType */.GL.Text:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(OptionTextButton, {
        part,
        ...props
      });
    case trainer_model/* OptionType */.GL.Image:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(OptionBoxButton, {
        part,
        ...props,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
          src: part.image.url
        })
      });
    case trainer_model/* OptionType */.GL.Audio:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(OptionBoxButton, {
        part,
        ...props,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CenteredAudioWithLines, {
          type: audioComponent,
          src: getAudioSrc(part.audio),
          iconSize: iconSize[props.partSize ?? (props.type === "default" ? "medium" : "small")]
        })
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
;// CONCATENATED MODULE: ./src/components/put-in-bins-output/put-in-bins-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const put_in_bins_output_module = ({"titles-wrapper":"put-in-bins-output-module__titles-wrapper--J053y","titlesWrapper":"put-in-bins-output-module__titles-wrapper--J053y","title-wrapper":"put-in-bins-output-module__title-wrapper--bL4VZ","titleWrapper":"put-in-bins-output-module__title-wrapper--bL4VZ","matched-pieces":"put-in-bins-output-module__matched-pieces--SVr53","matchedPieces":"put-in-bins-output-module__matched-pieces--SVr53","pieces-wrapper":"put-in-bins-output-module__pieces-wrapper--zskUZ","piecesWrapper":"put-in-bins-output-module__pieces-wrapper--zskUZ","matched-piece":"put-in-bins-output-module__matched-piece--FT5zR","matchedPiece":"put-in-bins-output-module__matched-piece--FT5zR","piece-button":"put-in-bins-output-module__piece-button--I2GaU","pieceButton":"put-in-bins-output-module__piece-button--I2GaU","bins-title":"put-in-bins-output-module__bins-title--pBwiq","binsTitle":"put-in-bins-output-module__bins-title--pBwiq","success-title":"put-in-bins-output-module__success-title--hFcXa","successTitle":"put-in-bins-output-module__success-title--hFcXa","error-title":"put-in-bins-output-module__error-title--StIXs","errorTitle":"put-in-bins-output-module__error-title--StIXs","title-label":"put-in-bins-output-module__title-label--jPtI7","titleLabel":"put-in-bins-output-module__title-label--jPtI7","pieces-wrapper-horizontal":"put-in-bins-output-module__pieces-wrapper-horizontal--AFErC","piecesWrapperHorizontal":"put-in-bins-output-module__pieces-wrapper-horizontal--AFErC"});
;// CONCATENATED MODULE: ./src/components/put-in-bins-output/__bin/__bin.component.tsx












const Bin = _ref => {
  let {
    title,
    pieces,
    binHeight,
    selectedPiece,
    onBinClick,
    onPieceClick,
    isSubmitted,
    isMobile
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: put_in_bins_output_module.titleWrapper,
    onClick: () => {
      onBinClick(title);
    },
    onDragOver: e => e.preventDefault(),
    onDrop: e => {
      e.preventDefault();
      onBinClick(title);
    },
    style: {
      minHeight: `${binHeight}px`
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2, put_in_bins_output_module.binsTitle),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(put_in_bins_output_module.titleLabel, typography_module/* default */.Z.captionAccent),
        children: title.badge
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        wrapper: markdown_component/* Wrapper */.im.span,
        children: title.title
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: put_in_bins_output_module.matchedPieces,
      children: pieces.map(piece => {
        const checked = selectedPiece && piece.id === selectedPiece.id;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: put_in_bins_output_module.matchedPiece,
          draggable: true,
          onDragStart: () => {
            onPieceClick(piece);
          },
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
            part: {
              ...piece,
              id: piece.badge
            },
            partSize: card_component/* CardSize */.Id.Small,
            type: _bin_component_getType(piece, {
              isSubmitted,
              checked
            }),
            onClick: () => {
              onPieceClick(piece);
            },
            getAudioSrc: getOptionAudioSrc,
            isMobile,
            audioComponent: "putInBins"
          })
        }, piece.id);
      })
    })]
  }, title.id);
};
const _bin_component_getType = (piece, params) => {
  if (params.isSubmitted) {
    if (piece["correct?"] === void 0) {
      return "checked";
    }
    return piece["correct?"] ? "success" : "error";
  }
  return params.checked ? "selected" : "default";
};
;// CONCATENATED MODULE: ./src/components/put-in-bins-output/__bin/__bins.component.tsx














const Bins = _ref => {
  let {
    bins,
    binHeight,
    contextAnswer,
    rightAnswers,
    onBinClick,
    ...props
  } = _ref;
  const binTitles = (0,react.useMemo)(() => bins.map((bin, index) => ({
    title: bin.title,
    id: index,
    badge: getBadgeKey(index)
  })), [bins]);
  const handleTitleKeyPress = (0,react.useCallback)(e => {
    const badge = e.code.replace("Key", "");
    const title = binTitles.find(t => t.badge === badge);
    if (!title) {
      return;
    }
    onBinClick(title);
  }, [binTitles, onBinClick]);
  const titleKeyboardKeys = (0,react.useMemo)(() => binTitles.map(title => `Key${title.badge}`), [binTitles]);
  (0,useKeyPress/* useKeyPress */.K)(titleKeyboardKeys, handleTitleKeyPress);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(put_in_bins_output_module.titlesWrapper),
    children: binTitles.map(title => {
      let titlePieces = [];
      const answerTitle = Array.isArray(contextAnswer) && contextAnswer.find(a => a.titleId === title.id);
      if (answerTitle && !props.isSubmitted) {
        titlePieces = answerTitle.pieces.map(piece => ({
          ...piece,
          badge: piece.badge
        }));
      } else if (props.isSubmitted) {
        titlePieces = rightAnswers[title.id];
      }
      return /* @__PURE__ */(0,jsx_runtime.jsx)(Bin, {
        binHeight,
        title,
        pieces: titlePieces,
        onBinClick,
        ...props
      }, title.id);
    })
  });
};
const getBadgeKey = digit => String.fromCharCode(string_utils/* A_CHAR_CODE */.WM + digit);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.flat-map.js
var esnext_async_iterator_flat_map = __webpack_require__(53593);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.flat-map.js
var esnext_iterator_flat_map = __webpack_require__(25534);
;// CONCATENATED MODULE: ./src/components/put-in-bins-output/use-put-in-bins.ts





















const usePutInBins = _ref => {
  let {
    send,
    bins,
    answer,
    shuffleHash,
    isSubmitted
  } = _ref;
  const [selectedPiece, setSelectedPiece] = (0,react.useState)(null);
  const binPieces = useOptionsShuffle(bins.flatMap((bin, index) => bins[index].pieces).map((piece, index) => ({
    ...piece,
    id: index
  })), shuffleHash).map((piece, index) => ({
    ...piece,
    badge: index
  }));
  const isAllPiecesMatched = (0,react.useMemo)(() => {
    if (!answer || !Array.isArray(answer)) {
      return false;
    }
    const selectedPieces = getFlattenPieces(answer);
    return checkAllPiecesMatched({
      binPieces,
      selectedPieces
    });
  }, [answer, binPieces]);
  const getRightAnswerBins = (0,react.useCallback)(userAnswer => {
    const rightAnswerMap = {};
    let minId = 0;
    const rightAnswerIndexes = bins.reduce((acc, _ref2, index) => {
      let {
        pieces
      } = _ref2;
      acc[index] = Array.from({
        length: pieces.length
      }, (_, i) => minId + i);
      minId += pieces.length;
      return acc;
    }, {});
    for (let i = 0; i < bins.length; i++) {
      const answerBin = userAnswer.find(b => b.titleId === i);
      const answerBinPieces = answerBin ? [...answerBin.pieces] : [];
      const rightAnswerPieces = [];
      let rightPiecesIndexes = rightAnswerIndexes[i];
      answerBinPieces.forEach(answerBinPiece => {
        if (rightPiecesIndexes.includes(answerBinPiece.id)) {
          rightPiecesIndexes = rightPiecesIndexes.filter(index => index !== answerBinPiece.id);
          rightAnswerPieces.push({
            ...answerBinPiece,
            badge: 0,
            "correct?": true
          });
        } else {
          rightAnswerPieces.push({
            ...answerBinPiece,
            badge: 0,
            "correct?": false
          });
        }
      });
      rightPiecesIndexes.forEach(index => {
        const piece = binPieces.find(piece2 => piece2.id === index);
        if (piece) {
          rightAnswerPieces.push({
            ...piece
          });
        }
      });
      rightAnswerMap[i] = rightAnswerPieces;
    }
    return rightAnswerMap;
  }, [binPieces, bins]);
  const rightAnswerBins = (0,react.useMemo)(() => {
    if (!isSubmitted) {
      return {};
    }
    return getRightAnswerBins(answer);
  }, [answer, getRightAnswerBins, isSubmitted]);
  const isCorrectAnswer = (0,react.useMemo)(() => {
    if (!isSubmitted) {
      return false;
    }
    return checkCorrectRightAnswer(rightAnswerBins);
  }, [isSubmitted, rightAnswerBins]);
  const isCorrectUserAnswer = (0,react.useCallback)(userAnswer => {
    const rightAnswer = getRightAnswerBins(userAnswer);
    return checkCorrectRightAnswer(rightAnswer);
  }, [getRightAnswerBins]);
  const matchPieceWithTitle = (0,react.useCallback)(title => {
    if (selectedPiece === null) {
      return;
    }
    if (!Array.isArray(answer) || answer.length === 0) {
      send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: [{
            title: title.title,
            titleId: title.id,
            pieces: [selectedPiece]
          }]
        }
      });
      return setSelectedPiece(null);
    }
    const indexOfBinWithClickedTitle = answer.findIndex(a => a.titleId === title.id);
    if (indexOfBinWithClickedTitle !== -1) {
      const newAnswer = answer.reduce((acc, a) => [...acc, {
        ...a,
        pieces: a.pieces.filter(p => p.id !== selectedPiece.id)
      }], []);
      const binWithClickedTitle = newAnswer[indexOfBinWithClickedTitle];
      newAnswer[indexOfBinWithClickedTitle] = {
        ...binWithClickedTitle,
        pieces: [...binWithClickedTitle.pieces, selectedPiece]
      };
      const answerPieces2 = getFlattenPieces(newAnswer);
      const allPiecesSelected2 = checkAllPiecesMatched({
        binPieces,
        selectedPieces: answerPieces2
      });
      allPiecesSelected2 ? send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
        data: {
          answer: newAnswer,
          correct: isCorrectUserAnswer(newAnswer)
        }
      }) : send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: newAnswer
        }
      });
      return setSelectedPiece(null);
    }
    const oldAnswerFiltered = answer.map(title2 => ({
      ...title2,
      pieces: title2.pieces.filter(p => p.id !== selectedPiece.id)
    }));
    const data = [...oldAnswerFiltered, {
      title: title.title,
      titleId: title.id,
      pieces: [selectedPiece]
    }];
    const answerPieces = getFlattenPieces(data);
    const allPiecesSelected = checkAllPiecesMatched({
      binPieces,
      selectedPieces: answerPieces
    });
    allPiecesSelected ? send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: isCorrectUserAnswer(data)
      }
    }) : send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: {
        answer: data
      }
    });
    return setSelectedPiece(null);
  }, [answer, binPieces, isCorrectUserAnswer, selectedPiece, send]);
  return {
    binPieces,
    rightAnswerBins,
    isAllPiecesMatched,
    isCorrectAnswer,
    isCorrectUserAnswer,
    getRightAnswerBins,
    matchPieceWithTitle,
    selectedPiece,
    setSelectedPiece
  };
};
const getFlattenPieces = objectWithPieces => objectWithPieces.flatMap(obj => obj.pieces);
const checkCorrectRightAnswer = rightAnswer => Object.values(rightAnswer).every(pieces => pieces.every(piece => piece["correct?"]));
const checkAllPiecesMatched = _ref3 => {
  let {
    binPieces,
    selectedPieces
  } = _ref3;
  return binPieces.every(p => selectedPieces.find(selectedPiece => selectedPiece.id === p.id));
};
;// CONCATENATED MODULE: ./src/components/put-in-bins-output/__pieces/__pieces.component.tsx


















const Pieces = _ref => {
  let {
    pieces,
    contextAnswer,
    selectedPiece,
    onPieceClick,
    disableKeyPress,
    isMobile
  } = _ref;
  const selectedPieces = (0,react.useMemo)(() => {
    if (!Array.isArray(contextAnswer) || contextAnswer.length === 0) {
      return [];
    }
    return getFlattenPieces(contextAnswer);
  }, [contextAnswer]);
  const handlePressPieceKey = (0,react.useCallback)(digit => {
    if (digit >= 1 && digit <= pieces.length) {
      const piece = pieces.find(b => b.badge === digit - 1);
      onPieceClick(piece ?? null);
    }
  }, [onPieceClick, pieces]);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(handlePressPieceKey, disableKeyPress);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(put_in_bins_output_module.piecesWrapper, {
      [put_in_bins_output_module.piecesWrapperHorizontal]: pieces.every(piece => piece.type !== "text")
    }),
    children: pieces.map(piece => {
      const hidden = selectedPieces.find(p => p.id === piece.id);
      if (hidden) {
        return null;
      }
      const isSelected = selectedPiece !== null && selectedPiece.id === piece.id;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: put_in_bins_output_module.pieceButton,
        draggable: true,
        onDragStart: () => {
          onPieceClick(piece);
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
          part: {
            ...piece,
            id: piece.badge
          },
          partSize: card_component/* CardSize */.Id.Small,
          type: isSelected ? "selected" : "default",
          onClick: () => onPieceClick(piece),
          getAudioSrc: getOptionAudioSrc,
          isMobile,
          audioComponent: "putInBins"
        })
      }, piece.id);
    })
  });
};
;// CONCATENATED MODULE: ./src/components/put-in-bins-output/put-in-bins-output.component.tsx


























const BIN_PADDING = 16;
const BIN_BORDER = 2;
const PutInBinsOutput = _ref => {
  let {
    bins,
    feedback,
    shuffleHash,
    mechanicMachine,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    disableKeyPress
  } = _ref;
  const {
    state,
    send
  } = mechanicMachine;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const answer = (0,react.useMemo)(() => {
    const stateAnswer = state.context.answer;
    return checkPutInBinsAnswer(stateAnswer) ? stateAnswer : [];
  }, [state.context.answer]);
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const isSubmitted = isSubmitState(state.value);
  const {
    binPieces,
    isAllPiecesMatched,
    rightAnswerBins,
    isCorrectAnswer,
    matchPieceWithTitle,
    selectedPiece,
    setSelectedPiece
  } = usePutInBins({
    send,
    bins,
    shuffleHash,
    answer,
    isSubmitted
  });
  const binHeight = (0,react.useMemo)(() => {
    const piece = binPieces[0];
    const titles = bins.map(bin => bin.title);
    if (!piece || titles.length === 0) {
      return "auto";
    }
    const contentHeight = Math.max(...binPieces.map(binPiece => {
      const {
        height
      } = (0,getComponentSize/* getComponentSize */.Z)( /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
        part: {
          ...binPiece,
          id: binPiece.badge
        },
        partSize: card_component/* CardSize */.Id.Small,
        type: "default",
        onClick: function_utils/* emptyFunction */.Bi,
        getAudioSrc: getOptionAudioSrc,
        isMobile,
        audioComponent: "putInBins"
      }));
      return height;
    }));
    const titleHeight = Math.max(...titles.map((title, index) => {
      const {
        height
      } = (0,getComponentSize/* getComponentSize */.Z)( /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2, put_in_bins_output_module.binsTitle),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(put_in_bins_output_module.titleLabel, typography_module/* default */.Z.captionAccent),
          children: index
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          children: title
        })]
      }));
      return height;
    }));
    return contentHeight + titleHeight + 2 * (BIN_PADDING + BIN_BORDER);
  }, [binPieces, bins, isMobile]);
  (0,react.useEffect)(() => {
    if (isSubmitted) {
      send(mechanic_machine_consts/* EVENTS */.FP.SET_CORRECT_STATUS, {
        data: {
          correct: isCorrectAnswer
        }
      });
    }
  }, [isCorrectAnswer, isSubmitted, rightAnswerBins, send, state.value]);
  const successMessages = feedback?.["on-success"] ?? void 0;
  const errorMessages = feedback?.["on-error"] ?? void 0;
  const isCustomFeedback = Boolean(successMessages && isCorrectAnswer || errorMessages && !isCorrectAnswer);
  const showFeedback = isSubmitted && isCustomFeedback;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      ref: elementRef,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Bins, {
        binHeight,
        bins,
        contextAnswer: answer,
        rightAnswers: rightAnswerBins,
        selectedPiece,
        onBinClick: matchPieceWithTitle,
        onPieceClick: setSelectedPiece,
        isSubmitted,
        isMobile
      }), !isAllPiecesMatched && /* @__PURE__ */(0,jsx_runtime.jsx)(Pieces, {
        pieces: binPieces,
        contextAnswer: answer,
        selectedPiece,
        onPieceClick: setSelectedPiece,
        disableKeyPress,
        isMobile
      })]
    }), showFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      successMessages,
      errorMessages,
      success: isCorrectAnswer,
      isCustom: isCustomFeedback
    })]
  });
};
const checkPutInBinsAnswerObject = object => typeof object === "object" && object !== null && Object.hasOwn(object, "title") && Object.hasOwn(object, "titleId") && Object.hasOwn(object, "pieces");
const checkPutInBinsAnswer = answer => answer !== null && Array.isArray(answer) && answer.some(checkPutInBinsAnswerObject);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.to-spliced.js
var es_array_to_spliced = __webpack_require__(72805);
;// CONCATENATED MODULE: ./src/components/put-in-order-output/constants.ts


const CONTENT_CONTAINER_PADDING_IN_PX = 16;
const CONTENT_CONTAINER_BORDER_IN_PX = 2;
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const put_in_order_output_module = ({"options":"put-in-order-output-module__options--F6KJt","ordered-values-container":"put-in-order-output-module__ordered-values-container--QFQAY","orderedValuesContainer":"put-in-order-output-module__ordered-values-container--QFQAY","ordered-value":"put-in-order-output-module__ordered-value--eOxkH","orderedValue":"put-in-order-output-module__ordered-value--eOxkH","text-feedback-wrapper":"put-in-order-output-module__text-feedback-wrapper--lBVqy","textFeedbackWrapper":"put-in-order-output-module__text-feedback-wrapper--lBVqy","text-feedback-audio-button-icon":"put-in-order-output-module__text-feedback-audio-button-icon--ls7Cf","textFeedbackAudioButtonIcon":"put-in-order-output-module__text-feedback-audio-button-icon--ls7Cf","text-feedback-audio-button-icon-active":"put-in-order-output-module__text-feedback-audio-button-icon-active--lO6ni","textFeedbackAudioButtonIconActive":"put-in-order-output-module__text-feedback-audio-button-icon-active--lO6ni","text-feedback-audio-button":"put-in-order-output-module__text-feedback-audio-button--ySVNz","textFeedbackAudioButton":"put-in-order-output-module__text-feedback-audio-button--ySVNz","horizontal-feedback-layout":"put-in-order-output-module__horizontal-feedback-layout--_gkLl","horizontalFeedbackLayout":"put-in-order-output-module__horizontal-feedback-layout--_gkLl","horizontal-feedback-part":"put-in-order-output-module__horizontal-feedback-part--eUGp_","horizontalFeedbackPart":"put-in-order-output-module__horizontal-feedback-part--eUGp_","vertical-feedback-part":"put-in-order-output-module__vertical-feedback-part--CdIr4","verticalFeedbackPart":"put-in-order-output-module__vertical-feedback-part--CdIr4","hidden-part":"put-in-order-output-module__hidden-part--G3wZ4","hiddenPart":"put-in-order-output-module__hidden-part--G3wZ4","hidden-empty-part":"put-in-order-output-module__hidden-empty-part--RfdLH","hiddenEmptyPart":"put-in-order-output-module__hidden-empty-part--RfdLH","vertical-direction":"put-in-order-output-module__vertical-direction--opCbD","verticalDirection":"put-in-order-output-module__vertical-direction--opCbD"});
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/feedback-card.tsx








const FeedbackCard = _ref => {
  let {
    key,
    isVertical,
    isMobile,
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(put_in_order_output_module.horizontalFeedbackPart, {
      [put_in_order_output_module.verticalFeedbackPart]: isVertical
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(card_component/* Card */.Zb, {
      id: key,
      state: card_content_component/* CardState */.WF.Loaded,
      appearance: {
        size: card_component/* CardSize */.Id.Medium,
        bgColor: card_component/* BgColor */.tv.White,
        haveShadow: false
      },
      childrenType: card_content_component/* ChildrenType */.L5.Box,
      onCardClick: function_utils/* emptyFunction */.Bi,
      isMobile,
      children
    })
  }, key);
};
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/audio-feedback.tsx










const AudioFeedback = _ref => {
  let {
    parts,
    isVertical,
    isMobile
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(put_in_order_output_module.horizontalFeedbackLayout, {
      [put_in_order_output_module.verticalDirection]: isVertical
    }),
    children: parts.map(part => {
      const audioSrc = getOptionAudioSrc(part.audio);
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackCard, {
        isVertical,
        isMobile,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CenteredAudioWithLines, {
          src: audioSrc,
          type: "feedbackWithAudio"
        })
      }, audioSrc);
    })
  });
};
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/image-feedback.tsx









const ImageFeedback = _ref => {
  let {
    parts,
    isVertical,
    isMobile
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(put_in_order_output_module.horizontalFeedbackLayout, {
      [put_in_order_output_module.verticalDirection]: isVertical
    }),
    children: parts.map(part => /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackCard, {
      isVertical,
      isMobile,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
        src: part.image.url
      })
    }, part.image.url))
  });
};
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/constants.ts


const MAX_TEXT_TO_SPEECH_LENGTH = 1500;
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/text-feedback.tsx













const TextFeedback = _ref => {
  let {
    parts,
    isVertical
  } = _ref;
  const rightAnswerString = parts.map(part => part.text).join(isVertical ? "\n" : " ");
  const {
    play,
    canPlay,
    waiting,
    playing
  } = (0,useAudio/* useAudioHandler */.GH)((0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(rightAnswerString), "feedbackWithAudio");
  const disabled = rightAnswerString.length > MAX_TEXT_TO_SPEECH_LENGTH || !canPlay;
  const loading = useLoader(waiting);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: put_in_order_output_module.textFeedbackWrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      disabled,
      classes: {
        buttonIcon: classnames_default()(put_in_order_output_module.textFeedbackAudioButtonIcon, {
          [put_in_order_output_module.textFeedbackAudioButtonIconActive]: playing
        })
      },
      onFocus: event => event.currentTarget.blur(),
      onClick: play,
      appearance: "default",
      size: "medium",
      iconName: disabled ? "waves" : "speaker",
      className: put_in_order_output_module.textFeedbackAudioButton,
      loading
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "put-in-order right-answer",
        children: rightAnswerString
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/put-in-order-feedback-content.tsx








const PutInOrderFeedbackContent = _ref => {
  let {
    parts,
    isVertical,
    isMobile
  } = _ref;
  if (checkOptionsType(parts, trainer_model/* OptionType */.GL.Text)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(TextFeedback, {
      parts,
      isVertical
    });
  }
  if (checkOptionsType(parts, trainer_model/* OptionType */.GL.Audio)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(AudioFeedback, {
      parts,
      isVertical,
      isMobile
    });
  }
  if (checkOptionsType(parts, trainer_model/* OptionType */.GL.Image)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ImageFeedback, {
      parts,
      isVertical,
      isMobile
    });
  }
  return null;
};
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-feedback/put-in-order-feedback.tsx










const PutInOrderFeedback = _ref => {
  let {
    parts,
    feedback,
    isSuccess,
    isVertical,
    acceptAnyAnswer,
    isMobile
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const successMessages = (0,react.useMemo)(() => feedback?.["on-success"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Success)
  }), [intl, feedback]);
  const errorMessages = (0,react.useMemo)(() => feedback?.["on-error"] ?? intl.formatMessage({
    id: getRandomMessageKey(MessageType.Error)
  }), [intl, feedback]);
  const isCustomFeedback = Boolean(isSuccess && feedback?.["on-success"] || !isSuccess && feedback?.["on-error"]);
  const isScrollableFeedback = checkOptionsType(parts, trainer_model/* OptionType */.GL.Image) || checkOptionsType(parts, trainer_model/* OptionType */.GL.Audio);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
    successMessages,
    errorMessages,
    success: isSuccess,
    isCustom: isCustomFeedback,
    isScrollable: isScrollableFeedback,
    children: !acceptAnyAnswer && /* @__PURE__ */(0,jsx_runtime.jsx)(PutInOrderFeedbackContent, {
      parts,
      isVertical,
      isMobile
    })
  });
};
;// CONCATENATED MODULE: ./src/components/put-in-order-output/put-in-order-output.tsx






























const PutInOrderOutput = _ref => {
  let {
    parts,
    direction,
    feedback,
    shuffleHash,
    mechanicMachine,
    acceptAnyAnswer,
    isMobile,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    disableKeyPress
  } = _ref;
  const {
    state,
    send
  } = mechanicMachine;
  const [dragPart, setDragPart] = (0,react.useState)(null);
  const [fakePart, setFakePart] = (0,react.useState)(null);
  const [fakePartIndex, setFakePartIndex] = (0,react.useState)(null);
  const answer = (0,react.useMemo)(() => Array.isArray(state.context.answer) ? state.context.answer : [], [state.context.answer]);
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  const shuffledParts = useOptionsShuffle(parts, shuffleHash);
  const renderingAnswer = (0,react.useMemo)(() => {
    if (fakePart !== null && dragPart !== null && fakePartIndex !== null) {
      const answerType = answer;
      return answerType.toSpliced(fakePartIndex, 0, {
        ...fakePart,
        isFake: true
      });
    }
    return answer;
  }, [answer, dragPart, fakePart, fakePartIndex]);
  (0,useKeyPress/* useKeyPress */.K)(["Backspace"], () => {
    send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: {
        answer: answer.slice(0, answer.length - 1)
      }
    });
  });
  const containerHeight = (0,react.useMemo)(() => {
    if (!Array.isArray(shuffledParts) || !shuffledParts[0]) {
      return "auto";
    }
    const {
      height: contentHeight
    } = (0,getComponentSize/* getComponentSize */.Z)( /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
      audioComponent: "putInOrder",
      type: "default",
      part: shuffledParts[0],
      partSize: card_component/* CardSize */.Id.Small,
      onClick: function_utils/* emptyFunction */.Bi,
      getAudioSrc: getOptionAudioSrc,
      isMobile
    }));
    return contentHeight + 2 * (CONTENT_CONTAINER_PADDING_IN_PX + CONTENT_CONTAINER_BORDER_IN_PX);
  }, [isMobile, shuffledParts]);
  const isAllAnswersRight = (0,react.useCallback)(userAnswer => userAnswer.every((_ref2, index) => {
    let {
      id,
      ...a
    } = _ref2;
    return (0,equals/* default */.Z)(a, parts[index]);
  }), [parts]);
  const handleSelectValue = (0,react.useCallback)(value => {
    const data = [...answer, value];
    if (data.length === shuffledParts.length) {
      return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
        data: {
          answer: data,
          correct: isAllAnswersRight(data)
        }
      });
    }
    return send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: {
        answer: data
      }
    });
  }, [answer, shuffledParts.length, send, isAllAnswersRight]);
  const handleKeyPress = (0,react.useCallback)(key => {
    if (key < 1 || key > shuffledParts.length) {
      return;
    }
    const partId = key - 1;
    if (answer.find(a => a.id === partId)) {
      return send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
        data: {
          answer: answer.filter(v => v.id !== partId)
        }
      });
    }
    const part = shuffledParts.find(p => p.id === partId);
    const data = part ? [...answer, part] : answer;
    return data.length === shuffledParts.length ? send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: data,
        correct: isAllAnswersRight(data)
      }
    }) : send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: {
        answer: data
      }
    });
  }, [answer, send, shuffledParts, isAllAnswersRight]);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(handleKeyPress, disableKeyPress);
  const allAnswersRight = (0,react.useMemo)(() => isAllAnswersRight(answer), [answer, isAllAnswersRight]);
  const handleDragStart = (0,react.useCallback)((event, part) => {
    setDragPart(part);
  }, []);
  const handleDragOver = (0,react.useCallback)(event => {
    event.preventDefault();
  }, []);
  const handleDragEnter = (0,react.useCallback)(index => {
    if (dragPart) {
      setFakePart(dragPart);
      setFakePartIndex(index);
    }
  }, [dragPart]);
  const handleDragEnd = (0,react.useCallback)(() => {
    setDragPart(null);
    setFakePart(null);
    setFakePartIndex(null);
  }, []);
  const handleDropInContainer = (0,react.useCallback)(event => {
    event.preventDefault();
    if (dragPart === null) {
      return false;
    }
    let newAnswer;
    if (answer.find(part => part.id === dragPart.id)) {
      newAnswer = [...answer.filter(part => part.id !== dragPart.id), dragPart];
    } else {
      newAnswer = [...answer, dragPart];
    }
    handleDragEnd();
    return newAnswer.length === parts.length ? send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: newAnswer,
        correct: isAllAnswersRight(newAnswer)
      }
    }) : send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: {
        answer: newAnswer
      }
    });
  }, [answer, dragPart, handleDragEnd, isAllAnswersRight, parts.length, send]);
  const handleDropOnPart = (0,react.useCallback)((event, partIndex) => {
    event.preventDefault();
    event.stopPropagation();
    if (dragPart === null) {
      return;
    }
    const dragPartIndex = answer.findIndex(part => part.id === dragPart.id);
    const filteredAnswer = answer.filter((_, index) => index !== dragPartIndex);
    if (dragPartIndex !== -1 && dragPartIndex < partIndex) {
      partIndex--;
    }
    const newAnswer = filteredAnswer.toSpliced(partIndex, 0, dragPart);
    handleDragEnd();
    return newAnswer.length === parts.length ? send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
      data: {
        answer: newAnswer,
        correct: isAllAnswersRight(newAnswer)
      }
    }) : send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: {
        answer: newAnswer
      }
    });
  }, [answer, dragPart, handleDragEnd, isAllAnswersRight, parts.length, send]);
  const isVisibleFeedback = isSubmitState(state.value);
  const removePartFromAnswer = removingPart => send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
    data: {
      answer: answer.filter(a => a.id !== removingPart.id)
    }
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      style: {
        minHeight: containerHeight
      },
      className: classnames_default()(put_in_order_output_module.orderedValuesContainer, {
        [put_in_order_output_module.verticalDirection]: direction === "vertical"
      }),
      onDrop: handleDropInContainer,
      onDragOver: handleDragOver,
      ref: elementRef,
      children: renderingAnswer.map((part, index) => {
        let type = "default";
        const {
          id,
          ...initialCurrentElement
        } = part;
        if (isSubmitState(state.value)) {
          if (acceptAnyAnswer) {
            type = "submit";
          } else if (allAnswersRight) {
            type = "success";
          } else if (!allAnswersRight) {
            const isRightThisAnswer = (0,equals/* default */.Z)(initialCurrentElement, parts[index]);
            type = isRightThisAnswer ? "success" : "error";
          }
        }
        if (part.isFake) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            onDragOver: handleDragOver,
            onDrop: e => handleDropOnPart(e, index),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()(put_in_order_output_module.orderedValue, put_in_order_output_module.hiddenPart),
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
                audioComponent: "putInOrder",
                type,
                part,
                partSize: card_component/* CardSize */.Id.Small,
                onClick: () => {
                  removePartFromAnswer(part);
                },
                getAudioSrc: getOptionAudioSrc,
                isMobile
              })
            })
          }, `fake_${part.id}`);
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(put_in_order_output_module.orderedValue, {
            [put_in_order_output_module.hiddenEmptyPart]: part.id === fakePart?.id
          }),
          draggable: true,
          onDragStart: event => handleDragStart(event, part),
          onDragEnter: () => handleDragEnter(index),
          onDragEnd: handleDragEnd,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
            audioComponent: "putInOrder",
            type,
            part,
            partSize: card_component/* CardSize */.Id.Small,
            onClick: () => {
              removePartFromAnswer(part);
            },
            getAudioSrc: getOptionAudioSrc,
            isMobile
          })
        }, part.id);
      })
    }), !isSubmitState(state.value) && answer.length !== shuffledParts.length && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: put_in_order_output_module.options,
      children: shuffledParts.map(part => {
        const selected = answer.find(el => el.id === part.id);
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          style: {
            display: selected ? "none" : "block"
          },
          className: put_in_order_output_module.orderedValue,
          draggable: true,
          onDragStart: e => handleDragStart(e, part),
          onDragEnd: handleDragEnd,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(OptionButton, {
            audioComponent: "putInOrder",
            type: "default",
            part,
            onClick: () => {
              handleSelectValue(part);
            },
            getAudioSrc: getOptionAudioSrc,
            isMobile
          })
        }, part.id);
      })
    }), isVisibleFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(PutInOrderFeedback, {
      parts,
      feedback,
      isSuccess: isSubmitState(state.value) && allAnswersRight,
      isVertical: direction === "vertical",
      isMobile,
      acceptAnyAnswer
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/input-with-auto-width/input-with-auto-width.component.tsx + 3 modules
var input_with_auto_width_component = __webpack_require__(86198);
;// CONCATENATED MODULE: ./src/components/text-output/text-output.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_output_module = ({"root":"text-output-module__root--VEsCE","audio-button":"text-output-module__audio-button--_sP0S","audioButton":"text-output-module__audio-button--_sP0S","input-wrapper":"text-output-module__input-wrapper--XHZ2J","inputWrapper":"text-output-module__input-wrapper--XHZ2J","button-icon":"text-output-module__button-icon--mbLMH","buttonIcon":"text-output-module__button-icon--mbLMH"});
;// CONCATENATED MODULE: ./src/components/text-output/text-output.component.tsx






























const RIGHT_ANSWER_VARIANTS = fill_the_gap_output_parser/* STRICT_FILL_THE_GAP_REGEXP */.vu;
const TextOutput = _ref => {
  let {
    texts: propsTexts,
    audio,
    lastBlock,
    mechanicMachine,
    onInViewChange = function_utils/* emptyFunction */.Bi,
    feedback
  } = _ref;
  const {
    send,
    state
  } = mechanicMachine;
  let disabled = false;
  const intl = (0,useIntl/* default */.Z)();
  const {
    containerRefCallback: elementRef
  } = useMechanicInView(onInViewChange);
  let status = medium_input_component/* MediumInputStatus */._.Default;
  const texts = (0,react.useMemo)(() => propsTexts.reduce((acc, t) => {
    if (!RIGHT_ANSWER_VARIANTS.test(t)) {
      acc.push(t);
      return acc;
    }
    const splitedTexts = t.replace(/[><]/g, "").split("|");
    return acc.concat(splitedTexts);
  }, []), [propsTexts]);
  const answer = (0,react.useMemo)(() => typeof state.context.answer === "string" ? state.context.answer : "", [state.context.answer]);
  const closeToUserAnswerRightAnswer = (0,react.useMemo)(() => getClosestText(answer, texts), [answer, texts]);
  const getAnswerStatus = (0,react.useCallback)(userAnswer => {
    const isFullEqualsAnswer = texts.some(a => isEqualText(a, userAnswer));
    const isAnswerWithTypo = texts.some(a => withTypo(a, userAnswer));
    if (isFullEqualsAnswer) {
      return "success";
    } else if (isAnswerWithTypo) {
      return "typo";
    }
    return "error";
  }, [texts]);
  const handleChange = (0,react.useCallback)(e => {
    if (e.target.value.length !== 0) {
      return send(mechanic_machine_consts/* EVENTS */.FP.ANSWER, {
        data: {
          answer: e.target.value,
          correct: getAnswerStatus(e.target.value) === "success"
        }
      });
    }
    return send(mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER, {
      data: e.target.value
    });
  }, [getAnswerStatus, send]);
  if (isSubmitState(state.value)) {
    disabled = true;
    status = getAnswerStatus(answer);
  }
  const isVisibleFeedback = isSubmitState(state.value);
  const feedbackMessage = (0,react.useMemo)(() => {
    switch (status) {
      case "success":
        {
          return feedback?.["on-success"] ?? intl.formatMessage({
            id: getRandomMessageKey(MessageType.Success)
          });
        }
      case "error":
        {
          return feedback?.["on-error"] ?? intl.formatMessage({
            id: getRandomMessageKey(MessageType.Error)
          });
        }
      case "typo":
        {
          return feedback?.["on-error"] ?? intl.formatMessage({
            id: getRandomMessageKey(MessageType.Typo)
          });
        }
      default:
        return "";
    }
  }, [feedback, intl, status]);
  const isSuccess = status === "success";
  const isCustomFeedback = Boolean(isSuccess && feedback?.["on-success"] || !isSuccess && feedback?.["on-error"]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: text_output_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: text_output_module.inputWrapper,
      ref: elementRef,
      children: [audio && /* @__PURE__ */(0,jsx_runtime.jsx)(text_output_component_AudioButton, {
        audio,
        lastBlock
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(input_with_auto_width_component/* InputWithAutoWidth */.o, {
        height: "thin",
        autoFocus: true,
        onChange: handleChange,
        value: answer,
        status,
        disabled,
        expectedValues: texts
      })]
    }), isVisibleFeedback && /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicFeedback, {
      errorMessages: feedbackMessage,
      isCustom: isCustomFeedback,
      children: status !== "success" && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.headline4,
        children: closeToUserAnswerRightAnswer
      })
    })]
  });
};
const text_output_component_AudioButton = _ref2 => {
  let {
    audio,
    lastBlock
  } = _ref2;
  const audioLink = (0,react.useMemo)(() => {
    const type = audio.type;
    switch (type) {
      case "t2s":
        return (0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(audio.text, audio.voice);
      case "voiceover":
        return encodeURI(audio.url);
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  }, [audio]);
  const {
    play,
    canPlay,
    waiting
  } = (0,useAudio/* useAudioHandler */.GH)(audioLink, "textWithAudio", {
    autoPlay: lastBlock
  });
  const loading = useLoader(waiting);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
    disabled: !canPlay,
    onClick: play,
    onFocus: e => e.currentTarget.blur(),
    appearance: "default",
    size: "medium",
    iconName: "speaker",
    classes: {
      buttonIcon: text_output_module.buttonIcon
    },
    className: text_output_module.audioButton,
    loading
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/__mechanic-output/mechanic-output.component.tsx
















const Output = _ref => {
  let {
    output,
    feedback,
    shuffleHash,
    lastBlock,
    mechanicMachine,
    submitAnswer,
    onInViewChange,
    disableKeyPress,
    hint,
    isHiddenFeedback,
    skill
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  switch (output.type) {
    case "drag-and-drop-image":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(DragAndDropImageOutput, {
        feedback,
        parts: output.parts,
        mechanicMachine,
        width: output.width,
        height: output.height,
        imageUrl: output.image,
        shuffleHash
      });
    case "choose":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ChooseOutput, {
        feedback,
        variants: output.variants,
        shuffleHash,
        mechanicMachine,
        onInViewChange,
        disableKeyPress,
        isNotShuffled: output["not-shuffled-options?"]
      });
    case "multiselect-choose":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(MultiselectChoose, {
        feedback,
        variants: output.variants,
        shuffleHash,
        mechanicMachine,
        onInViewChange,
        disableKeyPress,
        isNotShuffled: output["not-shuffled-options?"]
      });
    case "dropdowns":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownOutput, {
        feedback,
        text: output.text,
        shuffleHash,
        mechanicMachine,
        onInViewChange,
        lastBlock: Boolean(lastBlock),
        disableKeyPress,
        isHiddenFeedback,
        skill
      });
    case "match-pairs":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(MatchPairsOutput, {
        feedback,
        outputPairs: output.pairs,
        shuffleHash,
        mechanicMachine,
        isLastBlock: Boolean(lastBlock),
        hint
      });
    case "text":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TextOutput, {
        feedback,
        texts: output.texts,
        translation: output.translation,
        audio: output.audio,
        lastBlock,
        mechanicMachine,
        onInViewChange
      });
    case "fill-the-gap":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FillTheGapOutput, {
        shuffleHash,
        feedback,
        texts: output.texts,
        audio: output.audio,
        placeholders: output.placeholders,
        mechanicMachine,
        submitAnswer,
        onInViewChange,
        isHiddenFeedback,
        acceptAnyAnswer: output["accept-any-answer?"],
        skill
      });
    case "put-in-bins":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(PutInBinsOutput, {
        feedback,
        shuffleHash,
        mechanicMachine,
        onInViewChange,
        disableKeyPress,
        ...output
      });
    case "put-in-order":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(PutInOrderOutput, {
        feedback,
        ...output,
        lastBlock,
        shuffleHash,
        mechanicMachine,
        onInViewChange,
        disableKeyPress,
        acceptAnyAnswer: output["accept-any-answer?"],
        isMobile
      });
    case "match-titles":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(MatchTitlesOutputComponent, {
        feedback,
        paragraphs: output.paragraphs,
        shuffleHash,
        mechanicMachine,
        onInViewChange,
        lastBlock
      });
    case "condition-choose":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ConditionalChoose, {
        image: output.image,
        variants: output.variants,
        mainText: output.mainText,
        secondText: output.secondText,
        position: output.position,
        mechanicMachine,
        submitAnswer,
        onInViewChange
      });
    case "form":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FormOutput, {
        feedback,
        fields: output.fields,
        mechanicMachine,
        onInViewChange
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "not implemented"
      });
  }
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/hint/hint.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const hint_module = ({"root":"hint-module__root--brWg9","source":"hint-module__source--z62xZ","header":"hint-module__header--VNbb0"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/hint/hint.component.tsx





const Hint = _ref => {
  let {
    source,
    target
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: hint_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
      className: hint_module.header,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
        id: "hint target",
        typography: "headline4Accent",
        children: target
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
      id: "hint source",
      className: hint_module.source,
      typography: "body1",
      children: source
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/mechanic-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const mechanic_block_module = ({"root":"mechanic-block-module__root--ANrkB","root-center":"mechanic-block-module__root-center--hKtNw","rootCenter":"mechanic-block-module__root-center--hKtNw","root-stretch":"mechanic-block-module__root-stretch--JUMvk","rootStretch":"mechanic-block-module__root-stretch--JUMvk","root-placed-center":"mechanic-block-module__root-placed-center--UoOWQ","rootPlacedCenter":"mechanic-block-module__root-placed-center--UoOWQ","controls":"mechanic-block-module__controls--f4ZYp","passed":"mechanic-block-module__passed--zOzUH","tutor-instruction":"mechanic-block-module__tutor-instruction--FB5xO","tutorInstruction":"mechanic-block-module__tutor-instruction--FB5xO","hint":"mechanic-block-module__hint--tNW_9","input":"mechanic-block-module__input--tuabK","input-float":"mechanic-block-module__input-float--GYekB","inputFloat":"mechanic-block-module__input-float--GYekB","output":"mechanic-block-module__output--UVFJP","output-float":"mechanic-block-module__output-float--uugJu","outputFloat":"mechanic-block-module__output-float--uugJu","mechanic-actions":"mechanic-block-module__mechanic-actions--uoKRB","mechanicActions":"mechanic-block-module__mechanic-actions--uoKRB","hint-button":"mechanic-block-module__hint-button--tJ5IP","hintButton":"mechanic-block-module__hint-button--tJ5IP","root-placed-left":"mechanic-block-module__root-placed-left--MmUGt","rootPlacedLeft":"mechanic-block-module__root-placed-left--MmUGt","root-placed-right":"mechanic-block-module__root-placed-right--ChQ1l","rootPlacedRight":"mechanic-block-module__root-placed-right--ChQ1l","root-float":"mechanic-block-module__root-float--AZRCB","rootFloat":"mechanic-block-module__root-float--AZRCB"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/mechanic-block/mechanic-block.component.tsx












































const mechanicBlockAlignClasses = {
  center: mechanic_block_module.rootCenter,
  stretch: mechanic_block_module.rootStretch
};
const skipButtonClickGoalsMap = /* @__PURE__ */new Map([[trainer_model/* TrainerEnvironment */.r$.Trainer, "Trainer_Skip_Button_Click"], [trainer_model/* TrainerEnvironment */.r$.Repetition, "Repetition_Skip_Button_Click"]]);
const skipButtonShowGoalsMap = /* @__PURE__ */new Map([[trainer_model/* TrainerEnvironment */.r$.Trainer, "Trainer_Skip_Button_Show"], [trainer_model/* TrainerEnvironment */.r$.Repetition, "Repetition_Skip_Button_Show"]]);
const MechanicBlock = _ref => {
  let {
    onSubmitAnswer,
    isActive,
    initialAnswer,
    hint,
    input,
    output,
    feedback,
    skill,
    lastBlock,
    onNextBlock,
    machineCreator,
    correct,
    inProgress,
    onChangeAnswer,
    position = "right",
    shuffleHash,
    onResetAnswer,
    showTutorInstructions,
    tutorInstructions,
    showPrevButton,
    showNextButton,
    showResetButton,
    showSkipButton,
    onPrevBlock,
    clueButton,
    showSubmitButton: isSubmitButtonVisible,
    controlsPanelButtonsPlace,
    disableKeyPress,
    isHiddenFeedback = false
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const machine = (0,react.useRef)(machineCreator(initialAnswer, correct, onChangeAnswer)).current;
  const [state, send, interpreter] = (0,useMachine/* useMachine */.e)(machine);
  const mechanicMachine = (0,react.useMemo)(() => ({
    send,
    state
  }), [send, state]);
  const isBlockSubmitted = isSubmitState(state.value);
  const {
    mechanicBlockAlign: align,
    trainerEnvironment
  } = (0,react.useContext)(product_trainer_renderer_context/* ProductTrainerRendererContextComponent */.p);
  const {
    ref: skipButtonRef,
    inView: skipButtonInView
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true
  });
  const [, setVideoShow] = (0,react.useState)(true);
  const currentElementRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    const goalName = skipButtonShowGoalsMap.get(trainerEnvironment);
    if (skipButtonInView && goalName) {
      (0,yandexMetrica/* ymGoal */.qf)(goalName);
    }
  }, [trainerEnvironment, skipButtonInView]);
  const onSkip = (0,react.useCallback)(() => {
    const goalName = skipButtonClickGoalsMap.get(trainerEnvironment);
    if (goalName) {
      (0,yandexMetrica/* ymGoal */.qf)(goalName);
    }
    void onNextBlock();
  }, [trainerEnvironment, onNextBlock]);
  (0,react.useEffect)(() => {
    const isEqualInitialAnswer = (0,equals/* default */.Z)(initialAnswer, state.context.initialAnswer);
    const isEqualCorrect = correct === state.context.correct;
    const isEqualInProgress = inProgress === state.context.inProgress;
    if (interpreter.initialized && (!isEqualInitialAnswer || !isEqualCorrect || !isEqualInProgress)) {
      interpreter.send(mechanic_machine_consts/* EVENTS */.FP.CHANGE_INITIAL_DATA, {
        data: {
          initialAnswer,
          correct,
          inProgress
        }
      });
    }
  }, [correct, initialAnswer, inProgress, interpreter, state.context.correct, state.context.initialAnswer, state.context.inProgress]);
  const onSubmit = (0,react.useCallback)(params => {
    send(mechanic_machine_consts/* EVENTS */.FP.SUBMIT);
    onSubmitAnswer({
      answer: state.context.answer,
      correct: state.context.correct,
      typo: state.context.typo,
      maxPossibleScore: state.context.maxPossibleScore,
      rightAnswersScore: state.context.rightAnswersScore,
      optionDescription: state.context.optionDescription,
      skill: state.context.skill
    });
    lastBlock && onNextBlock({
      withScroll: params?.withScroll || isHiddenFeedback
    });
  }, [isHiddenFeedback, lastBlock, onNextBlock, onSubmitAnswer, send, state.context.answer, state.context.correct, state.context.maxPossibleScore, state.context.optionDescription, state.context.rightAnswersScore, state.context.skill, state.context.typo]);
  const onReset = (0,react.useCallback)(() => {
    send(mechanic_machine_consts/* EVENTS */.FP.RESET_ANSWER);
    onResetAnswer();
  }, [onResetAnswer, send]);
  const renderOnErrorContent = () => lastBlock && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
    place: controlsPanelButtonsPlace,
    showPrevButton,
    onPrevButtonClick: onPrevBlock,
    showNextButton,
    onNextButtonClick: onNextBlock
  });
  const isConditionChooseMech = output.type === "condition-choose";
  const handleError = error => {
    logger/* Logger */.Yd.captureException(error, {
      context: JSON.stringify(state.context),
      mechanic: JSON.stringify({
        input,
        output
      })
    }, {
      block: "MechanicBlock"
    });
  };
  const isResetButton = showResetButton && isSubmitState(state.value) && !isConditionChooseMech;
  const isSkipButton = !isSubmitState(state.value) && showSkipButton && lastBlock && !isConditionChooseMech;
  const isInputFloat = input?.isFloat === true;
  const useSticky = isInputFloat && isActive && !isBlockSubmitted;
  const RootComponent = useSticky ? lib/* StickyContainer */.L9 : "div";
  const showSubmitButton = state.matches(mechanic_machine_consts/* STATES */.PO.ANSWERED) && isSubmitButtonVisible && input?.type !== "test-video" && !isConditionChooseMech;
  const hintSource = (0,react.useMemo)(() => {
    if (output.type === "match-pairs") {
      if (isEnglishText(hint?.target || "")) {
        return intl.formatMessage({
          id: "matchPairs.subtitleEng"
        });
      }
      return intl.formatMessage({
        id: "matchPairs.subtitleRus"
      });
    }
    return hint?.source || "";
  }, [hint?.source, hint?.target, intl, output.type]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
    onError: handleError,
    onErrorContent: renderOnErrorContent,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(RootComponent, {
      ref: currentElementRef,
      className: classnames_default()(mechanic_block_module.root, mechanicBlockAlignClasses[align], {
        [mechanic_block_module.rootFloat]: isInputFloat,
        [mechanic_block_module.rootPlacedCenter]: position === "center",
        [mechanic_block_module.rootPlacedLeft]: position === "left",
        [mechanic_block_module.rootPlacedRight]: position === "right"
      }),
      children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: mechanic_block_module.tutorInstruction,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
          data: tutorInstructions
        })
      }), hint && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: mechanic_block_module.hint,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Hint, {
          source: hintSource,
          target: hint.target
        }), clueButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: mechanic_block_module.hintButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerClueButton, {
            hintActionButtonText: clueButton["action-button"],
            grammarReferenceId: clueButton["grammar-reference-id"],
            hintTitle: clueButton.title,
            hintText: clueButton.text
          })
        })]
      }), input && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(mechanic_block_module.input, {
          [mechanic_block_module.inputFloat]: isInputFloat
        }),
        children: useSticky ? /* @__PURE__ */(0,jsx_runtime.jsx)(StickyMechanicInput, {
          input,
          isBlockSubmitted,
          lastBlock,
          onSubmit,
          setVideoShow
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicInput, {
          input,
          isBlockSubmitted,
          lastBlock,
          onSubmit,
          setVideoShow
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(mechanic_block_module.output, {
          [mechanic_block_module.outputFloat]: isInputFloat
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(Output, {
          hint: {
            source: hintSource,
            target: hint?.target || ""
          },
          output,
          feedback,
          shuffleHash,
          lastBlock,
          mechanicMachine,
          submitAnswer: onSubmit,
          onInViewChange: function_utils/* emptyFunction */.Bi,
          disableKeyPress,
          isHiddenFeedback,
          skill
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
        place: controlsPanelButtonsPlace,
        showNextButton: isSubmitState(state.value) && showNextButton,
        onNextButtonClick: onNextBlock,
        showPrevButton: showPrevButton && lastBlock,
        onPrevButtonClick: onPrevBlock
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: mechanic_block_module.mechanicActions,
        children: [showSubmitButton && /* @__PURE__ */(0,jsx_runtime.jsx)(submit_mechanic_button_component/* SubmitMechanicButton */.x, {
          enableKeyHandler: true,
          onSubmit
        }), isResetButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          "aria-label": intl.formatMessage({
            id: "resetButton.ariaLabel"
          }),
          appearance: "floating",
          size: "medium",
          iconName: "reset",
          onClick: onReset
        }), isSkipButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          ref: skipButtonRef,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(skip_mechanic_button_component/* SkipMechanicButton */.Q, {
            enableKeyHandler: isSkipButton,
            onSkip
          })
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfHour.mjs
var startOfHour = __webpack_require__(24938);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInMinutes.mjs
var differenceInMinutes = __webpack_require__(34002);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMinutes.mjs
var addMinutes = __webpack_require__(7300);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/entities/features.ts
var features = __webpack_require__(45404);
// EXTERNAL MODULE: ./src/hooks/useCurrentTime.ts
var useCurrentTime = __webpack_require__(70822);
// EXTERNAL MODULE: ./src/adapters/syllabus/syllabus.api-adapter.ts
var syllabus_api_adapter = __webpack_require__(13162);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
;// CONCATENATED MODULE: ./src/adapters/syllabus/syllabus.storage-adapter.ts




const syllabusNodeAttributes = (0,effector/* createDomain */.Fj)();
const $syllabusNodesAttributes = syllabusNodeAttributes.createStore({});
const setSyllabusNodeFavoriteFx = syllabusNodeAttributes.createEvent();
const setSyllabusNodeAttributesFx = syllabusNodeAttributes.createEvent();
$syllabusNodesAttributes.on(setSyllabusNodeFavoriteFx, (state, payload) => {
  const currentSyllabusNode = state[payload.syllabusNodeId] || {};
  return {
    ...state,
    [payload.syllabusNodeId]: {
      ...currentSyllabusNode,
      attributes: {
        ...currentSyllabusNode.attributes,
        isFavorite: payload.isFavorite
      }
    }
  };
});
$syllabusNodesAttributes.on(setSyllabusNodeAttributesFx, (state, payload) => ({
  ...state,
  [payload.syllabusNodeId]: payload.syllabusNodeAttributes
}));
const useSyllabusNodesAttributesStorage = () => {
  const syllabusNodesAttributes = (0,effector_react/* useStore */.oR)($syllabusNodesAttributes);
  return {
    syllabusNodesAttributes,
    setSyllabusNodeAttributes: setSyllabusNodeAttributesFx,
    setSyllabusNodeFavorite: setSyllabusNodeFavoriteFx
  };
};
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/These.js
var These = __webpack_require__(37138);
;// CONCATENATED MODULE: ./src/services/syllabus/syllabus.ts




const createSyllabusNodesAttributesService = adapters => {
  const {
    apiAdapter,
    storageAdapter
  } = adapters;
  const loadSyllabusNodeAttributes = syllabusNodeId => apiAdapter.getSyllabusNodeAttributes({
    syllabusNodeId
  }).then(result => {
    if ((0,These.isRight)(result)) {
      storageAdapter.setSyllabusNodeAttributes({
        syllabusNodeId,
        syllabusNodeAttributes: result.right
      });
    }
  });
  const setFavoriteNode = async (syllabusNodeId, isFavorite) => {
    storageAdapter.setSyllabusNodeFavorite({
      syllabusNodeId,
      isFavorite
    });
    const res = await apiAdapter.setSyllabusNodeAttributes({
      syllabusNodeId,
      isFavorite
    });
    if ((0,Either.isLeft)(res)) {
      storageAdapter.setSyllabusNodeFavorite({
        syllabusNodeId,
        isFavorite: !isFavorite
      });
    }
  };
  const isFavoriteNode = syllabusNodeId => {
    if (Object.keys(storageAdapter.syllabusNodesAttributes).length === 0) {
      return false;
    }
    const nodeAttributes = storageAdapter.syllabusNodesAttributes[syllabusNodeId];
    if (!nodeAttributes) {
      return false;
    }
    return Object.keys(nodeAttributes) ? storageAdapter.syllabusNodesAttributes[syllabusNodeId].attributes.isFavorite : false;
  };
  return {
    isFavoriteNode,
    loadSyllabusNodeAttributes,
    setFavoriteNode
  };
};
;// CONCATENATED MODULE: ./src/services/syllabus/use-syllabus.ts





const useSyllabusNodesAttributesService = () => {
  const storageAdapter = useSyllabusNodesAttributesStorage();
  return createSyllabusNodesAttributesService({
    apiAdapter: syllabus_api_adapter/* syllabusApi */.A,
    storageAdapter
  });
};
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ./src/components/markdown-strings/markdown-strings.component.tsx + 2 modules
var markdown_strings_component = __webpack_require__(59889);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInMilliseconds.mjs
var differenceInMilliseconds = __webpack_require__(41645);
// EXTERNAL MODULE: ../../node_modules/date-fns/addHours.mjs
var addHours = __webpack_require__(38769);
// EXTERNAL MODULE: ../../node_modules/date-fns/addDays.mjs
var addDays = __webpack_require__(78016);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(8106);
// EXTERNAL MODULE: ../../node_modules/date-fns/isEqual.mjs
var isEqual = __webpack_require__(94527);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameHour.mjs
var isSameHour = __webpack_require__(50390);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameDay.mjs
var isSameDay = __webpack_require__(51418);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(71502);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMilliseconds.mjs
var addMilliseconds = __webpack_require__(87812);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInDays.mjs
var differenceInDays = __webpack_require__(96017);
// EXTERNAL MODULE: ../../node_modules/date-fns/getHours.mjs
var getHours = __webpack_require__(91253);
// EXTERNAL MODULE: ../../node_modules/date-fns/getMinutes.mjs
var getMinutes = __webpack_require__(40618);
// EXTERNAL MODULE: ../shared/src/utils/locale.ts
var locale = __webpack_require__(90790);
// EXTERNAL MODULE: ../ui-kit/src/big-text-dropdown/big-text-dropdown.component.tsx + 1 modules
var big_text_dropdown_component = __webpack_require__(89008);
// EXTERNAL MODULE: ./src/components/student-scheduler/schedule-select-time.module.css
var schedule_select_time_module = __webpack_require__(70666);
;// CONCATENATED MODULE: ./src/components/student-scheduler/schedule-select-timea2.component.tsx











































const createNearestTimeReducer = targetTime => (a, b) => {
  const diffA = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(a, targetTime);
  const diffB = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(b, targetTime);
  const absDiffA = Math.abs(diffA);
  const absDiffB = Math.abs(diffB);
  if (absDiffA === absDiffB) {
    return diffA > diffB ? a : b;
  }
  return absDiffA < absDiffB ? a : b;
};
const DAYS_COUNT = 7;
const ScheduleSelectTimeA2 = _ref => {
  let {
    activeTutorId,
    speakingId,
    selectedTime,
    nearestPossibleTime,
    availableTimeRequestTimestamp,
    slotMinutes,
    className,
    onSelectedTimeChanged,
    onSubmitDisabledChanged
  } = _ref;
  const [availableTimes, setAvailableTimes] = (0,react.useState)(null);
  const isTimeDisabled = availableTimes === null || availableTimes.length === 0;
  (0,react.useEffect)(() => {
    onSubmitDisabledChanged(isTimeDisabled);
  }, [isTimeDisabled, onSubmitDisabledChanged]);
  (0,react.useEffect)(() => {
    let isActive = true;
    (() => {
      setAvailableTimes(null);
      if (activeTutorId === null) {
        return;
      }
      const availableTime = new Array(7).fill(0).reduce((acc, _, index) => [...acc, ...new Array(12).fill(0).map((_2, i) => ({
        startAt: (0,addHours/* addHours */.T)((0,addDays/* addDays */.E)((0,startOfDay/* startOfDay */.b)( /* @__PURE__ */new Date()), index), i)
      }))]);
      if (isActive) {
        const availableTutorTimesForAllTime = availableTime.map(time => time.startAt);
        setAvailableTimes(availableTutorTimesForAllTime);
      }
    })();
    return () => {
      isActive = false;
    };
  }, [availableTimeRequestTimestamp, nearestPossibleTime, speakingId, activeTutorId]);
  const getNearestHourThenDayAvailableTime = (0,react.useCallback)(newTime => {
    if (availableTimes === null || availableTimes.length === 0) {
      return null;
    }
    const hasExactTime = availableTimes.some(time => (0,isEqual/* isEqual */.X)(newTime, time));
    if (hasExactTime) {
      return newTime.getTime();
    }
    const sameHourItems = availableTimes.filter(time => (0,isSameHour/* isSameHour */.f)(newTime, time));
    if (sameHourItems.length !== 0) {
      return sameHourItems.reduce(createNearestTimeReducer(newTime)).getTime();
    }
    const sameDayItems = availableTimes.filter(time => (0,isSameDay/* isSameDay */.K)(newTime, time));
    if (sameDayItems.length !== 0) {
      return sameDayItems.reduce(createNearestTimeReducer(newTime)).getTime();
    }
    return availableTimes.reduce(createNearestTimeReducer(newTime)).getTime();
  }, [availableTimes]);
  const getNearestAvailableTime = (0,react.useCallback)(newTime => {
    if (newTime === null || availableTimes === null || availableTimes.length === 0) {
      return null;
    }
    return availableTimes.reduce(createNearestTimeReducer(newTime)).getTime();
  }, [availableTimes]);
  (0,react.useEffect)(() => {
    onSelectedTimeChanged(oldSelectedTime => {
      const newTime = getNearestAvailableTime(new Date(oldSelectedTime === null ? nearestPossibleTime : oldSelectedTime));
      if (newTime === null) {
        return oldSelectedTime;
      }
      return newTime;
    });
  }, [getNearestAvailableTime, nearestPossibleTime, onSelectedTimeChanged]);
  const dayItems = (0,react.useMemo)(() => {
    if (availableTimes === null) {
      return [];
    }
    const days = availableTimes.map(interval => (0,startOfDay/* startOfDay */.b)(interval).getTime());
    const availableDays = new Set(days);
    const items = [];
    const currentDate = (0,startOfDay/* startOfDay */.b)(nearestPossibleTime);
    for (let i = 0; i < DAYS_COUNT; i++) {
      const day = (0,addDays/* addDays */.E)(currentDate, i);
      items.push({
        id: i,
        isDisabled: !availableDays.has(day.getTime()),
        accentedText: (0,format/* format */.WU)(day, "dd MMMM,", {
          locale: locale/* dateFnsLocale */.Y
        }),
        text: (0,format/* format */.WU)(day, "EEEEEE", {
          locale: locale/* dateFnsLocale */.Y
        })
      });
    }
    return items;
  }, [availableTimes, nearestPossibleTime]);
  const hourItems = (0,react.useMemo)(() => {
    if (availableTimes === null || selectedTime === null) {
      return [];
    }
    const availableHours = availableTimes.filter(interval => (0,isSameDay/* isSameDay */.K)(interval, selectedTime)).map(interval => (0,startOfHour/* startOfHour */.o)(interval).getTime());
    const availableHoursSet = new Set(availableHours);
    const items = [];
    const startOfSelectedDay = (0,startOfDay/* startOfDay */.b)(selectedTime);
    const nearestPossibleTimeHour = (0,startOfHour/* startOfHour */.o)(nearestPossibleTime);
    for (let i = 0; i < 24; i++) {
      const hour = (0,addHours/* addHours */.T)(startOfSelectedDay, i);
      if ((0,isBefore/* isBefore */.R)(hour, nearestPossibleTimeHour)) {
        continue;
      }
      items.push({
        id: i,
        isDisabled: !availableHoursSet.has(hour.getTime()),
        accentedText: (0,format/* format */.WU)(hour, "HH", {
          locale: locale/* dateFnsLocale */.Y
        })
      });
    }
    return items;
  }, [availableTimes, nearestPossibleTime, selectedTime]);
  const minuteItems = (0,react.useMemo)(() => {
    if (availableTimes === null || selectedTime === null) {
      return [];
    }
    const availableMinutes = availableTimes.filter(interval => (0,isSameHour/* isSameHour */.f)(interval, selectedTime)).map(interval => interval.getTime());
    const availableMinutesSet = new Set(availableMinutes);
    const items = [];
    const currentHour = (0,startOfHour/* startOfHour */.o)(selectedTime);
    for (let i = 0; i < 60; i += slotMinutes) {
      const minute = (0,addMinutes/* addMinutes */.m)(currentHour, i);
      if ((0,isBefore/* isBefore */.R)(minute, nearestPossibleTime)) {
        continue;
      }
      items.push({
        id: i,
        isDisabled: !availableMinutesSet.has(minute.getTime()),
        accentedText: (0,format/* format */.WU)(minute, "mm", {
          locale: locale/* dateFnsLocale */.Y
        })
      });
    }
    return items;
  }, [availableTimes, nearestPossibleTime, selectedTime, slotMinutes]);
  const handleChangeDay = (0,react.useCallback)(day => {
    onSelectedTimeChanged(oldSelectedTime => {
      if (oldSelectedTime === null) {
        return null;
      }
      const msFromStart = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(oldSelectedTime, (0,startOfDay/* startOfDay */.b)(oldSelectedTime));
      const newSelectedTime = (0,addMilliseconds/* addMilliseconds */.n)((0,addDays/* addDays */.E)((0,startOfDay/* startOfDay */.b)(nearestPossibleTime), day), msFromStart);
      return getNearestHourThenDayAvailableTime(newSelectedTime);
    });
  }, [getNearestHourThenDayAvailableTime, nearestPossibleTime, onSelectedTimeChanged]);
  const handleChangeHour = (0,react.useCallback)(hour => {
    onSelectedTimeChanged(oldSelectedTime => {
      if (oldSelectedTime === null) {
        return null;
      }
      const msFromStart = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(oldSelectedTime, (0,startOfHour/* startOfHour */.o)(oldSelectedTime));
      const newSelectedTime = (0,addMilliseconds/* addMilliseconds */.n)((0,addHours/* addHours */.T)((0,startOfDay/* startOfDay */.b)(oldSelectedTime), hour), msFromStart);
      return getNearestHourThenDayAvailableTime(newSelectedTime);
    });
  }, [getNearestHourThenDayAvailableTime, onSelectedTimeChanged]);
  const handleChangeMinutes = (0,react.useCallback)(minutes => {
    onSelectedTimeChanged(oldSelectedTime => {
      if (oldSelectedTime === null) {
        return null;
      }
      const newSelectedTime = (0,addMinutes/* addMinutes */.m)((0,startOfHour/* startOfHour */.o)(oldSelectedTime), minutes);
      return getNearestHourThenDayAvailableTime(newSelectedTime);
    });
  }, [getNearestHourThenDayAvailableTime, onSelectedTimeChanged]);
  const dateTimeDropdownsClasses = classnames_default()(schedule_select_time_module/* default */.Z.dateTimeDropdowns, {
    [schedule_select_time_module/* default */.Z.dateTimeDropdownsDisabled]: isTimeDisabled
  });
  const timeForShow = selectedTime === null ? nearestPossibleTime : selectedTime;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: schedule_select_time_module/* default */.Z.dateTime,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: schedule_select_time_module/* default */.Z.dateTimeRow,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.caption,
          children: "\u0414\u0430\u0442\u0430"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: dateTimeDropdownsClasses,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
            content: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
              children: (0,format/* format */.WU)(timeForShow, "dd", {
                locale: locale/* dateFnsLocale */.Y
              })
            }),
            additionalContent: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()(schedule_select_time_module/* default */.Z.monthAndDayOfWeek, typography_module/* default */.Z.captionAccent),
              children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
                children: [(0,format/* format */.WU)(timeForShow, "MMMM", {
                  locale: locale/* dateFnsLocale */.Y
                }), ","]
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                children: (0,format/* format */.WU)(timeForShow, "EEEE", {
                  locale: locale/* dateFnsLocale */.Y
                })
              })]
            }),
            items: dayItems,
            isDisabled: isTimeDisabled,
            activeItemId: (0,differenceInDays/* differenceInDays */.j)((0,startOfDay/* startOfDay */.b)(timeForShow), (0,startOfDay/* startOfDay */.b)(nearestPossibleTime)),
            onChange: handleChangeDay
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: schedule_select_time_module/* default */.Z.dateTimeRow,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.caption,
          children: "\u0412\u0440\u0435\u043C\u044F"
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: dateTimeDropdownsClasses,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
            content: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
              children: (0,format/* format */.WU)(timeForShow, "HH", {
                locale: locale/* dateFnsLocale */.Y
              })
            }),
            items: hourItems,
            activeItemId: (0,getHours/* getHours */.p)(timeForShow),
            isDisabled: isTimeDisabled,
            onChange: handleChangeHour
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
            children: ":"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
            content: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
              children: (0,format/* format */.WU)(timeForShow, "mm", {
                locale: locale/* dateFnsLocale */.Y
              })
            }),
            items: minuteItems,
            activeItemId: (0,getMinutes/* getMinutes */.q)(timeForShow),
            isDisabled: isTimeDisabled,
            onChange: handleChangeMinutes
          })]
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/outro/constants.ts


const SLOT_MINUTES = 20;
const TASKS_OUTRO_IMAGE_URL = "https://flowstatic.s3.yandex.net/ui-files/tasksOutroPicture.svg";
// EXTERNAL MODULE: ../shared/src/hooks/useFetch.ts
var useFetch = __webpack_require__(29553);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/api/events/events.urls.ts
var events_urls = __webpack_require__(88620);
;// CONCATENATED MODULE: ../shared/src/api/surveys/user-survey/user-survey.mappers.ts


function mapCreateUserSurvey(response) {
  if (response.data.survey_state !== "active") {
    return {
      surveyState: response.data.survey_state
    };
  }
  return {
    surveyState: response.data.survey_state,
    surveyMarkup: response.data.survey_markup,
    userSurveyId: response.data.user_survey_id,
    userSurveyAnswers: response.data.user_survey_answers
  };
}
// EXTERNAL MODULE: ../shared/src/api/surveys/surveys.raw-models.ts
var surveys_raw_models = __webpack_require__(89438);
;// CONCATENATED MODULE: ../shared/src/api/surveys/user-survey/user-survey.raw-models.ts




const CreateUserSurveyResponse = markup => es6.type({
  data: es6.union([es6.type({
    survey_state: es6.union([es6.literal("inactive"), es6.literal("draft")])
  }), es6.type({
    survey_state: es6.literal("active"),
    survey_markup: markup,
    user_survey_id: es6.number,
    user_survey_answers: es6.array(surveys_raw_models/* StepAnswer */.p)
  })])
});
;// CONCATENATED MODULE: ../shared/src/api/surveys/user-survey/user-survey.api.ts








function createUserSurvey(surveyName, context, markupType) {
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/user-survey`, {
    method: "POST",
    body: {
      survey_name: surveyName,
      context
    },
    responseType: CreateUserSurveyResponse(markupType),
    resultMapper: rawResponse => mapCreateUserSurvey(rawResponse)
  });
}
function postSurveyAnswerEvent(payload) {
  void (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
    method: "POST",
    body: {
      type: "survey_answer",
      payload
    },
    responseType: es6.type({})
  });
}
function radioAnswer(userSurveyId, id, stepId) {
  return postSurveyAnswerEvent({
    type: "radio",
    value: id,
    user_survey_id: userSurveyId,
    is_final: false,
    step_id: stepId
  });
}
function checkboxAnswer(userSurveyId, itemIds, stepId) {
  return postSurveyAnswerEvent({
    type: "checkbox",
    value: itemIds,
    user_survey_id: userSurveyId,
    is_final: false,
    step_id: stepId
  });
}
function textAnswer(userSurveyId, text, stepId) {
  return postSurveyAnswerEvent({
    type: "text",
    value: text,
    user_survey_id: userSurveyId,
    is_final: false,
    step_id: stepId
  });
}
function finalAnswer(userSurveyId) {
  return postSurveyAnswerEvent({
    user_survey_id: userSurveyId,
    is_final: true
  });
}
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/api/raw-model.ts



const RawCreateHomeworkFeedbackSurveyMarkup = es6.type({
  title: es6.string,
  good: es6.type({
    items_title: es6.string,
    items: es6.array(es6.type({
      id: es6.string,
      text: es6.string
    }))
  }),
  bad: es6.type({
    items_title: es6.string,
    items: es6.array(es6.type({
      id: es6.string,
      text: es6.string
    }))
  }),
  text: es6.type({
    placeholder: es6.string,
    max_length: es6.number
  })
});
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/api/get-survey.ts




function createHomeworkFeedbackSurvey(nodeId) {
  return createUserSurvey("homework_feedback", {
    node_id: nodeId
  }, RawCreateHomeworkFeedbackSurveyMarkup);
}
// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/model/model.ts














const [$taskSurveyResponse, setTaskSurveyResponse, resetTaskSurveyResponse] = (0,makeStore/* makeStore */.n)(null);
const $checkboxItems = (0,effector/* createStore */.MT)(null);
const $textArea = (0,effector/* createStore */.MT)(null);
const $titles = (0,effector/* createStore */.MT)(null);
const $userSurveyId = $taskSurveyResponse.map(response => response?.userSurveyId ?? null);
const [$rateWay, _, resetRateWay] = (0,makeStore/* makeStore */.n)(null);
const [$isFinalModalVisible, setIsFinalModalVisible, resetIsFinalModalVisible] = (0,makeStore/* makeStore */.n)(false);
const [$isSurveyEnded, setIsSurveyEnded, resetIsSurveyEnded] = (0,makeStore/* makeStore */.n)(false);
const $selectedCheckboxItemsGroup = (0,effector/* combine */.$e)($rateWay, $checkboxItems, (rateWay, checkboxItems) => {
  if (!rateWay || !checkboxItems) {
    return [];
  }
  return [...checkboxItems[rateWay]];
});
const setTextAreaValue = (0,effector/* createEvent */.yM)();
const handleChangeRateWay = (0,effector/* createEvent */.yM)();
const handleSelectItem = (0,effector/* createEvent */.yM)();
const submitAnswers = (0,effector/* createEvent */.yM)();
$textArea.on(setTextAreaValue, (state, payload) => {
  if (state === null) {
    return;
  }
  return {
    ...state,
    value: payload
  };
});
$rateWay.on(handleChangeRateWay, (rateWay, payload) => payload);
$checkboxItems.on(handleChangeRateWay, (items, newRateWay) => {
  const copy = {
    ...items
  };
  (0,object_utils/* getObjectKeys */.Z)(copy).forEach(rateWay => {
    if (rateWay === newRateWay) {
      return;
    }
    copy[rateWay] = copy[rateWay].map(item => ({
      ...item,
      isSelected: false
    }));
  });
  return copy;
});
$checkboxItems.on(handleSelectItem, (items, id) => {
  const copy = {
    ...items
  };
  (0,object_utils/* getObjectKeys */.Z)(copy).forEach(rateWay => {
    const copyRateWay = copy[rateWay];
    const itemIndex = copyRateWay.findIndex(item => item.id === id);
    if (itemIndex !== -1) {
      copyRateWay[itemIndex].isSelected = !copyRateWay[itemIndex].isSelected;
    }
  });
  return copy;
});
const submitAnswersFx = (0,effector/* createEffect */.GW)(async _ref => {
  let {
    rateWay,
    selectedCheckboxItemsGroup,
    textArea,
    userSurveyId
  } = _ref;
  if (userSurveyId === null) {
    return;
  }
  const selectedItems = selectedCheckboxItemsGroup.reduce((acc, item) => {
    if (item.isSelected) {
      acc.push(item.id);
    }
    return acc;
  }, []);
  const textAreaValue = textArea?.value || "";
  if (rateWay) {
    await radioAnswer(userSurveyId, rateWay, "radio");
  }
  if (selectedItems.length) {
    await checkboxAnswer(userSurveyId, selectedItems, "checkbox");
  }
  if (textAreaValue.length) {
    await textAnswer(userSurveyId, textAreaValue, "text");
  }
  if (rateWay || selectedItems.length || textAreaValue.length) {
    await finalAnswer(userSurveyId);
  }
});
(0,effector/* sample */.UP)({
  clock: submitAnswers,
  source: {
    rateWay: $rateWay,
    selectedCheckboxItemsGroup: $selectedCheckboxItemsGroup,
    textArea: $textArea,
    userSurveyId: $userSurveyId
  },
  target: submitAnswersFx
});
(0,effector/* sample */.UP)({
  source: $taskSurveyResponse,
  fn: response => {
    if (!response) {
      return null;
    }
    return {
      good: response.surveyMarkup.good.items.map(item => ({
        id: item.id,
        name: item.text,
        isSelected: false
      })),
      bad: response.surveyMarkup.bad.items.map(item => ({
        id: item.id,
        name: item.text,
        isSelected: false
      }))
    };
  },
  target: $checkboxItems
});
(0,effector/* sample */.UP)({
  source: $taskSurveyResponse,
  fn: response => {
    if (!response) {
      return null;
    }
    return {
      value: "",
      maxLength: response.surveyMarkup.text.max_length,
      placeholder: response.surveyMarkup.text.placeholder
    };
  },
  target: $textArea
});
(0,effector/* sample */.UP)({
  source: $taskSurveyResponse,
  fn: response => {
    if (!response) {
      return null;
    }
    return {
      main: response.surveyMarkup.title,
      good: response.surveyMarkup.good.items_title,
      bad: response.surveyMarkup.bad.items_title
    };
  },
  target: $titles
});
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useUnmount.js
var useUnmount = __webpack_require__(27027);
;// CONCATENATED MODULE: ./src/hooks/useOnBeforeUnload.ts



function useOnBeforeUnload(onBeforeUnload) {
  (0,react.useEffect)(() => {
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [onBeforeUnload]);
}
/* harmony default export */ const hooks_useOnBeforeUnload = (useOnBeforeUnload);
;// CONCATENATED MODULE: ../ui-kit/src/tag/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_module = ({"root":"styles-module__root--yHnHK","disabled":"styles-module__disabled--AdQBS","checked":"styles-module__checked--ub7z6","input":"styles-module__input--ILDKX"});
;// CONCATENATED MODULE: ../ui-kit/src/tag/component.tsx





const Tag = _ref => {
  let {
    checked,
    children,
    disabled,
    onChange
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    className: classnames_default()(styles_module.root, {
      [styles_module.disabled]: disabled,
      [styles_module.checked]: checked
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      type: "checkbox",
      className: styles_module.input,
      onChange
    }), children]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/text-area/component.tsx + 2 modules
var component = __webpack_require__(22292);
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/additional-section/additional-section.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const additional_section_module = ({"subtitle":"additional-section-module__subtitle--C1poG","checkbox-list-block":"additional-section-module__checkbox-list-block--Mws3g","checkboxListBlock":"additional-section-module__checkbox-list-block--Mws3g","text-area":"additional-section-module__text-area--EMyRQ","textArea":"additional-section-module__text-area--EMyRQ"});
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/additional-section/additional-section.tsx















const HomeworkFeedbackSurveyAdditionalSection = _ref => {
  let {
    onSubmit
  } = _ref;
  const rateWay = (0,effector_react/* useStore */.oR)($rateWay);
  const textArea = (0,effector_react/* useStore */.oR)($textArea);
  const selectedCheckboxItemsGroup = (0,effector_react/* useStore */.oR)($selectedCheckboxItemsGroup);
  const titles = (0,effector_react/* useStore */.oR)($titles);
  const checkboxGroupDescriptionId = (0,react.useId)();
  const handleSubmit = (0,react.useCallback)(() => {
    onSubmit();
    setIsFinalModalVisible(true);
  }, [onSubmit]);
  const isSubmitButtonDisabled = (0,react.useMemo)(() => textArea ? textArea.value.length > textArea.maxLength : false, [textArea]);
  const handleTextareaOnChange = (0,react.useCallback)(e => {
    setTextAreaValue(e.target.value);
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    children: [rateWay && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      id: checkboxGroupDescriptionId,
      className: classnames_default()(typography_module/* default */.Z.body2, additional_section_module.subtitle),
      children: titles?.[rateWay]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      "aria-describedby": checkboxGroupDescriptionId,
      role: "group",
      className: additional_section_module.checkboxListBlock,
      children: selectedCheckboxItemsGroup.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)(Tag, {
        onChange: () => handleSelectItem(item.id),
        checked: item.isSelected,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.body2,
          children: item.name
        })
      }, item.id))
    }), textArea && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: additional_section_module.textArea,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(component/* TextArea */.K, {
        placeholder: textArea.placeholder,
        maxLength: textArea.maxLength,
        value: textArea.value,
        onChange: handleTextareaOnChange
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "secondary",
      onClick: handleSubmit,
      disabled: isSubmitButtonDisabled,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "homeworkFeedbackSurvey.submitButton"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/modal/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_styles_module = ({"root":"styles-module__root--potaG","icon-block":"styles-module__icon-block--h0gez","iconBlock":"styles-module__icon-block--h0gez","icon":"styles-module__icon--AlGtr","title":"styles-module__title--qBas9"});
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/modal/component.tsx












const HomeworkFeedbackSurveyModal = props => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    onClose
  } = props;
  const buttons = (0,react.useMemo)(() => {
    const result = [];
    if (!isMobile) {
      return result;
    }
    result.push({
      appearance: "secondary",
      text: intl.formatMessage({
        id: "homeworkFeedbackSurvey.modal.closeButton"
      }),
      onClick: onClose
    });
    return result;
  }, [intl, isMobile, onClose]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    buttons,
    ...props,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: modal_styles_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        size: "large",
        name: "check-solid",
        className: modal_styles_module.icon
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, modal_styles_module.title),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "homeworkFeedbackSurvey.modal.title"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body1),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "homeworkFeedbackSurvey.modal.subtitle"
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/model/types.ts


function isGoodWay(way) {
  return way === "good";
}
function isBadWay(way) {
  return way === "bad";
}
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/rate-section/rate-section.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const rate_section_module = ({"title":"rate-section-module__title--yF2wG","radio-block":"rate-section-module__radio-block--Q_lhk","radioBlock":"rate-section-module__radio-block--Q_lhk"});
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/rate-section/rate-section.tsx











const HomeworkFeedbackSurveyRateSection = () => {
  const rateWay = (0,effector_react/* useStore */.oR)($rateWay);
  const titles = (0,effector_react/* useStore */.oR)($titles);
  const handleChangeGoodRateWay = (0,react.useCallback)(() => {
    handleChangeRateWay("good");
  }, []);
  const handleChangeBadRateWay = (0,react.useCallback)(() => {
    handleChangeRateWay("bad");
  }, []);
  const radioGroupDescriptionId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    children: [titles?.main && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      id: radioGroupDescriptionId,
      className: classnames_default()(typography_module/* default */.Z.body1Accent, rate_section_module.title),
      children: titles.main
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      role: "radiogroup",
      className: rate_section_module.radioBlock,
      "aria-describedby": radioGroupDescriptionId,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: isBadWay(rateWay) ? "primary" : "secondary",
        size: "large",
        iconName: "thumb-down",
        onClick: handleChangeBadRateWay,
        role: "radio",
        "aria-checked": isBadWay(rateWay)
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: isGoodWay(rateWay) ? "primary" : "secondary",
        size: "large",
        iconName: "thumb-up",
        onClick: handleChangeGoodRateWay,
        role: "radio",
        "aria-checked": isGoodWay(rateWay)
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ui_styles_module = ({"root":"styles-module__root--DxVlu"});
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/content.tsx













const HomeworkFeedbackSurveyContent = () => {
  const rateWay = (0,effector_react/* useStore */.oR)($rateWay);
  const isFinalModalVisible = (0,effector_react/* useStore */.oR)($isFinalModalVisible);
  const isSurveyEnded = (0,effector_react/* useStore */.oR)($isSurveyEnded);
  const areAnswersSent = (0,react.useRef)(false);
  const handleSubmit = (0,react.useCallback)(() => {
    areAnswersSent.current = true;
    void submitAnswers();
  }, []);
  const handleCloseModal = (0,react.useCallback)(() => {
    setIsFinalModalVisible(false);
    setIsSurveyEnded(true);
  }, []);
  const handleOnBeforeUnloadAndUnmount = (0,react.useCallback)(() => {
    if (!areAnswersSent.current) {
      areAnswersSent.current = true;
      void submitAnswers();
    }
    resetRateWay();
    resetTaskSurveyResponse();
    resetIsFinalModalVisible();
    resetIsSurveyEnded();
  }, []);
  hooks_useOnBeforeUnload(handleOnBeforeUnloadAndUnmount);
  (0,useUnmount/* default */.Z)(handleOnBeforeUnloadAndUnmount);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isSurveyEnded && /* @__PURE__ */(0,jsx_runtime.jsxs)("article", {
      className: ui_styles_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(HomeworkFeedbackSurveyRateSection, {}), rateWay && /* @__PURE__ */(0,jsx_runtime.jsx)(HomeworkFeedbackSurveyAdditionalSection, {
        onSubmit: handleSubmit
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(HomeworkFeedbackSurveyModal, {
      size: modal/* ModalSize */.Cg.Small,
      isVisible: isFinalModalVisible,
      showCloseButton: true,
      onClose: handleCloseModal
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/ui/component.tsx








const HomeworkFeedbackSurvey = _ref => {
  let {
    chapterId
  } = _ref;
  const createUserSurveyFetcher = (0,useFetch/* useFetch */.i)(createHomeworkFeedbackSurvey);
  (0,use_did_mount/* useDidMount */.H)(() => {
    if (createUserSurveyFetcher.state === useFetch/* State */.Z.Initial) {
      void createUserSurveyFetcher.fetch(chapterId);
    }
  });
  if (createUserSurveyFetcher.state !== useFetch/* State */.Z.Loaded || createUserSurveyFetcher.data.surveyState !== "active" || createUserSurveyFetcher.data.userSurveyAnswers.length !== 0) {
    return null;
  }
  setTaskSurveyResponse(createUserSurveyFetcher.data);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(HomeworkFeedbackSurveyContent, {});
};
;// CONCATENATED MODULE: ./src/components/outro/homework-feedback-survey/index.ts



;// CONCATENATED MODULE: ./src/components/outro/outro.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const outro_module = ({"root":"outro-module__root--JA2aD","icon":"outro-module__icon--w77Ed","actions":"outro-module__actions--OOcs9","action-button":"outro-module__action-button--jcjnz","actionButton":"outro-module__action-button--jcjnz","separate-line":"outro-module__separate-line--cew1l","separateLine":"outro-module__separate-line--cew1l","picture-wrapper":"outro-module__picture-wrapper--biZmf","pictureWrapper":"outro-module__picture-wrapper--biZmf","text-wrapper":"outro-module__text-wrapper--t4INI","textWrapper":"outro-module__text-wrapper--t4INI","buttons":"outro-module__buttons--cJjFx","text":"outro-module__text--J7Gws","schedule-time-item":"outro-module__schedule-time-item--dyf7r","scheduleTimeItem":"outro-module__schedule-time-item--dyf7r","schedule-time-button":"outro-module__schedule-time-button--RKbhp","scheduleTimeButton":"outro-module__schedule-time-button--RKbhp"});
;// CONCATENATED MODULE: ./src/components/outro/outro.tsx
































const Outro = _ref => {
  let {
    title,
    text,
    image,
    actionControls,
    onChange,
    isRevision
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const {
    notForSale
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const scheduleSelectTimeA2FeatureFlagEnabled = (0,features/* useFeatureFlag */.ye)("scheduleSelectTimeA2");
  const history = (0,react_router/* useHistory */.k6)();
  const {
    loadSyllabusNodeAttributes,
    setFavoriteNode,
    isFavoriteNode
  } = useSyllabusNodesAttributesService();
  const fetchSyllabusNodeAttributes = (0,react.useRef)(loadSyllabusNodeAttributes);
  const syllabusNodeId = get_url_search_params.getUrlSearchParams.chapterLink.getSyllabusNodeId(history);
  (0,react.useEffect)(() => {
    if (syllabusNodeId) {
      void fetchSyllabusNodeAttributes.current(syllabusNodeId);
    }
  }, [syllabusNodeId]);
  const nearestPossibleTime = (0,react.useMemo)(() => {
    const hourStart = (0,startOfHour/* startOfHour */.o)(currentTime);
    const minutesDiff = (0,differenceInMinutes/* differenceInMinutes */.X)(currentTime, hourStart);
    const minutesToNearest = Math.ceil((minutesDiff + 1) / SLOT_MINUTES) * SLOT_MINUTES;
    return (0,addMinutes/* addMinutes */.m)(hourStart, minutesToNearest).getTime();
  }, [currentTime]);
  const [selectedTime, setSelectedTime] = (0,react.useState)(null);
  const filteredActionControls = (0,react.useMemo)(() => {
    const scheduleSpeakingWidget = actionControls.find(control => control.type === "schedule-widget");
    if (scheduleSpeakingWidget && scheduleSelectTimeA2FeatureFlagEnabled) {
      return [];
    }
    return actionControls.filter(actionControl => {
      switch (actionControl.action.type) {
        case "SCHEDULE_SPEAKING":
        case "REDIRECT_TO_SPEAKING":
          if (notForSale) {
            return false;
          }
          return !isRevision;
        case "REPEAT_REVISION":
          return isRevision;
        default:
          return true;
      }
    });
  }, [actionControls, isRevision, notForSale, scheduleSelectTimeA2FeatureFlagEnabled]);
  const renderOutroActions = (0,react.useCallback)(() => {
    const scheduleSpeakingWidget = actionControls.find(control => control.type === "schedule-widget");
    if (scheduleSpeakingWidget && scheduleSelectTimeA2FeatureFlagEnabled) {
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleSelectTimeA2, {
          className: outro_module.scheduleTimeItem,
          activeTutorId: "1",
          speakingId: "",
          createSpeakingSessionErrorInfo: null,
          selectedTime,
          nearestPossibleTime,
          availableTimeRequestTimestamp: ( /* @__PURE__ */new Date()).getTime(),
          slotMinutes: 20,
          isMentor: false,
          onSelectedTimeChanged: setSelectedTime,
          onSubmitDisabledChanged: function_utils/* emptyFunction */.Bi
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: outro_module.scheduleTimeButton,
          appearance: "primary",
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "outro.scheduleSpeakingWidget.buttonText"
          })
        })]
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: outro_module.actions,
      children: [filteredActionControls.map(control => /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: control?.type === "primary" ? "primary" : "secondary",
        className: classnames_default()(outro_module.actionButton, {
          [outro_module.separateLine]: control.separateLine && !syllabusNodeId
        }),
        onClick: () => {
          if (onChange) {
            return onChange(control.action);
          }
        },
        children: control.text
      }, control.action.type)), syllabusNodeId && (isMobile ? /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
        appearance: "secondary",
        className: classnames_default()(outro_module.actionButton, {
          [outro_module.separateLine]: isMobile
        }),
        onClick: () => {
          setFavoriteNode(syllabusNodeId, !isFavoriteNode(syllabusNodeId));
        },
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: isFavoriteNode(syllabusNodeId) ? "bookmark-filled" : "bookmark",
          size: "medium"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "outro.addToBookmarksButton.text"
        })]
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        className: outro_module.actionButton,
        appearance: "secondary",
        size: "medium",
        iconName: isFavoriteNode(syllabusNodeId) ? "bookmark-filled" : "bookmark",
        onClick: () => {
          setFavoriteNode(syllabusNodeId, !isFavoriteNode(syllabusNodeId));
        }
      }))]
    });
  }, [actionControls, filteredActionControls, isFavoriteNode, isMobile, nearestPossibleTime, onChange, scheduleSelectTimeA2FeatureFlagEnabled, selectedTime, setFavoriteNode, syllabusNodeId]);
  const prepareText = (0,react.useCallback)(text2 => {
    if (Array.isArray(text2) || typeof text2 === "string") {
      return text2;
    }
    return intl.formatMessage(text2);
  }, [intl]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: outro_module.root,
    "data-testid": "outro-block",
    children: [image && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: outro_module.pictureWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
        src: syllabusNodeId ? TASKS_OUTRO_IMAGE_URL : image
      })
    }), (checkTextExist(title) || checkTextExist(text)) && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: outro_module.textWrapper,
      children: [checkTextExist(title) && /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        className: typography_module/* default */.Z.headline4Accent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: prepareText(title)
        })
      }), checkTextExist(text) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body1, outro_module.text),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: prepareText(text)
        })
      })]
    }), syllabusNodeId && /* @__PURE__ */(0,jsx_runtime.jsx)(HomeworkFeedbackSurvey, {
      chapterId: syllabusNodeId
    }), renderOutroActions()]
  });
};
function checkTextExist(text) {
  if (!text) {
    return false;
  }
  if (typeof text === "string" || Array.isArray(text)) {
    return Boolean((Array.isArray(text) ? text.join("") : text).trim());
  }
  return Boolean(text);
}
;// CONCATENATED MODULE: ./src/components/trainer/blocks/outro-block/outro-block.component.tsx








const OutroBlock = _ref => {
  let {
    showPrevButton,
    onPrevBlock,
    controlsPanelButtonsPlace,
    lastBlock,
    ...restProps
  } = _ref;
  const {
    ref,
    inView
  } = (0,react_intersection_observer_m/* useInView */.YD)();
  (0,react.useEffect)(() => {
    if (inView) {
      (0,model/* hideAudioFooter */.AO)();
    }
  }, [inView]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Outro, {
      ...restProps
    }), lastBlock && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/story-intro-block/story-intro/story-intro.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const story_intro_module = ({"root":"story-intro-module__root--JdBdH","root-top-side":"story-intro-module__root-top-side--jpk1V","rootTopSide":"story-intro-module__root-top-side--jpk1V","block":"story-intro-module__block--yT7vn","text-block":"story-intro-module__text-block--BtcLb","textBlock":"story-intro-module__text-block--BtcLb","image-block":"story-intro-module__image-block--G_mi7","imageBlock":"story-intro-module__image-block--G_mi7","image":"story-intro-module__image--dbBYu","title":"story-intro-module__title--iGXTO","text":"story-intro-module__text--As2Lk","right-side-image-block":"story-intro-module__right-side-image-block--ADulU","rightSideImageBlock":"story-intro-module__right-side-image-block--ADulU"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/story-intro-block/story-intro/story-intro.component.tsx








const StoryIntro = _ref => {
  let {
    imagePosition = null,
    title,
    imageSrc,
    text
  } = _ref;
  let position = imagePosition;
  if (position === null) {
    position = text && text.length > 300 || Array.isArray(text) && text.join().length > 300 ? "top" : "right";
  }
  if (typeof text === "undefined") {
    text = [];
  }
  if (typeof text === "string") {
    text = [text];
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(story_intro_module.root, {
      [story_intro_module.rootTopSide]: position === "top"
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(story_intro_module.block, story_intro_module.imageBlock, {
        [story_intro_module.rightSideImageBlock]: position === "right"
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        alt: title,
        src: imageSrc,
        className: story_intro_module.image
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(story_intro_module.block, story_intro_module.textBlock),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
        className: story_intro_module.title,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
          id: "story-intro title",
          children: title
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: text.map((s, i) => /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: story_intro_module.text,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
            id: `story-intro text-${i}`,
            typography: "body1",
            children: s
          })
        }, i))
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/story-intro-block/story-intro-block.component.tsx








const StoryIntroBlock = _ref => {
  let {
    text,
    title,
    image,
    lastBlock = false,
    showTutorInstructions,
    tutorInstructions,
    onNextBlock,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace
  } = _ref;
  const {
    inView,
    containerRefCallback
  } = useLineInView({
    bottom: "-200px"
  });
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: containerRefCallback,
    children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
      data: tutorInstructions
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StoryIntro, {
      imageSrc: image.url,
      title,
      text,
      imagePosition: image.align
    }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
      place: controlsPanelButtonsPlace,
      showPrevButton,
      onPrevButtonClick: onPrevBlock,
      showNextButton,
      onNextButtonClick: onNextBlock
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/hooks/use-effect-once.ts
var use_effect_once = __webpack_require__(28504);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/get-url-search-params.ts + 1 modules
var query_params_utils_get_url_search_params = __webpack_require__(4761);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
;// CONCATENATED MODULE: ./src/api/tutor/placement-result/placement-result.mapper.ts


const mapPlacementResultBody = data => ({
  course_level: data.courseLevel,
  skipped_themes: data.skippedThemes,
  revision_themes: data.revisionThemes,
  student_id: data.studentId
});
;// CONCATENATED MODULE: ./src/api/tutor/placement-result/placement-result.api.ts







const postPlacementResult = (0,un_either/* unEither */.K)(data => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/placement-result`, {
  method: "POST",
  responseType: es6.type({
    data: es6["null"]
  }),
  body: mapPlacementResultBody(data)
}));
// EXTERNAL MODULE: ./src/models/task-guide/task-guide.model.ts
var task_guide_model = __webpack_require__(63054);
// EXTERNAL MODULE: ./src/components/class/platform/class-platform-context.tsx
var class_platform_context = __webpack_require__(47178);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/submit-placement-results/constants.ts


var Finish = /* @__PURE__ */(Finish2 => {
  Finish2["SubmitPlacementResult"] = "";
  return Finish2;
})(Finish || {});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/submit-placement-results/store.ts



const updateCourseLevel = (0,effector/* createEvent */.yM)();
const addSkippedTheme = (0,effector/* createEvent */.yM)();
const addRevisionTheme = (0,effector/* createEvent */.yM)();
const resetPlacementData = (0,effector/* createEvent */.yM)();
const $placementData = (0,effector/* createStore */.MT)({
  courseLevel: "",
  skippedThemes: [],
  revisionThemes: []
});
$placementData.on(updateCourseLevel, (data, courseLevel) => ({
  ...data,
  courseLevel
})).on(addSkippedTheme, (data, theme) => ({
  ...data,
  skippedThemes: data.skippedThemes.includes(theme) ? data.skippedThemes : [...data.skippedThemes, theme]
})).on(addRevisionTheme, (data, theme) => ({
  ...data,
  revisionThemes: data.revisionThemes.includes(theme) ? data.revisionThemes : [...data.revisionThemes, theme]
})).reset(resetPlacementData);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/submit-placement-results/submit-placement-results.tsx
















const SubmitPlacementResults = _ref => {
  let {
    course_level: courseLevel,
    skip,
    revise,
    finish,
    onNext
  } = _ref;
  const {
    content
  } = (0,class_platform_context/* useClassPlatformContext */.c)();
  const {
    lessonState
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const [isError, setIsError] = (0,react.useState)(false);
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const studentId = content.speakingSession?.student?.id ?? query_params_utils_get_url_search_params/* getUrlSearchParams */.r.taskGuide.getStudentId(history);
  (0,react.useEffect)(() => {
    if (courseLevel) {
      updateCourseLevel(Array.isArray(courseLevel) ? courseLevel.join(", ") : courseLevel);
    }
    if (skip) {
      addSkippedTheme(Array.isArray(skip) ? skip.join(", ") : skip);
    }
    if (revise) {
      addRevisionTheme(Array.isArray(revise) ? revise.join(", ") : revise);
    }
  }, [courseLevel, skip, revise]);
  (0,react.useEffect)(() => {
    if (lessonState !== task_guide_model/* TaskGuideFSMState */.ld.Started) {
      return;
    }
    if (finish === Finish.SubmitPlacementResult) {
      const placementData = $placementData.getState();
      if (!studentId || !placementData.courseLevel) {
        logger/* Logger */.Yd.captureError("Submit placement result miss parameter", {
          studentId,
          courseLevel: placementData.courseLevel
        }, {
          block: "SubmitPlacementResults"
        });
        setIsError(true);
        return;
      }
      postPlacementResult({
        ...placementData,
        studentId
      }).then(() => {
        resetPlacementData();
      }).catch(error => {
        logger/* Logger */.Yd.captureError("Submit placement result error", {
          studentId,
          error,
          placementData
        }, {
          block: "SubmitPlacementResults",
          method: "postPlacementResult"
        });
        setIsError(true);
      });
    }
  }, [studentId, finish, lessonState]);
  (0,use_effect_once/* useEffectOnce */.q)(onNext);
  const closeErrorModal = () => {
    setIsError(false);
  };
  return isError && /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: intl.formatMessage({
      id: "oneBlockRenderer.submitPlacementResult.errorModal.title"
    }),
    subtitle: intl.formatMessage({
      id: "oneBlockRenderer.submitPlacementResult.errorModal.subtitle"
    }),
    buttons: [{
      appearance: "primary",
      text: intl.formatMessage({
        id: "oneBlockRenderer.submitPlacementResult.errorModal.buttonText"
      }),
      onClick: closeErrorModal
    }],
    onClose: closeErrorModal
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/assets/challenge-icon.tsx



const Icon = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
  fill: "none",
  ...props,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3608 113C34.6086 115.462 38.0975 117.588 41.7742 119.347C67.8808 131.853 102.161 122.213 115.401 96.0265C128.641 69.8398 124.334 38.8798 100.361 20.0265C71.7875 -2.34683 28.7075 8.17317 13.0142 40.9998C0.774159 66.6665 9.65416 96.5732 31.3608 113Z",
    fill: "currentColor"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M72.0803 73.1189C77.2403 70.7322 82.587 68.7989 87.707 66.2122C93.7203 63.1722 100.534 60.4922 104 53.8389L104.174 53.4922C105.821 54.3109 107.19 55.5982 108.108 57.1924C109.026 58.7865 109.452 60.6164 109.334 62.4522C109.152 64.7061 108.369 66.87 107.067 68.7189C105.653 70.7358 103.837 72.4382 101.734 73.7189C97.8403 76.1189 93.427 77.2389 89.2136 78.8655C84.027 80.8655 79.9736 84.1055 75.2136 86.3055C75.1336 85.7855 75.0803 85.2655 74.9603 84.6789C74.5402 83.1858 73.8536 81.781 72.9336 80.5322C70.267 76.5322 63.347 75.4389 61.227 80.7455C60.347 82.9722 61.3203 85.3855 62.4003 87.5055C62.2403 87.7189 62.0803 87.9189 61.9336 88.1322C58.8403 87.2789 56.6003 85.0389 57.0936 80.4922C57.2665 79.0483 57.8033 77.6719 58.6536 76.4922C59.2462 76.6143 59.8487 76.6813 60.4536 76.6922C63.794 76.5743 67.0655 75.7086 70.027 74.1589L72.0803 73.1189Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M76.5071 99.8937C82.4056 97.9365 88.1503 95.5432 93.6937 92.7337C98.2271 90.4404 102.8 87.6937 105.694 83.4004C107.555 85.0741 108.717 87.388 108.947 89.8804C108.947 92.5471 107.414 95.0004 105.707 96.9604C102.32 100.84 98.8404 102.534 94.4537 104.747C91.0937 106.454 87.7871 108.294 84.4404 110.08C84.0404 108.947 83.6004 107.814 83.1071 106.694C82.7644 105.682 82.1837 104.767 81.4137 104.027C77.7871 101.08 74.7471 106.454 76.0804 109.947C76.535 111.133 77.1448 112.254 77.8937 113.28C76.7502 113.568 75.5523 113.562 74.412 113.261C73.2718 112.96 72.2264 112.375 71.3737 111.56C70.6385 110.839 70.0776 109.958 69.7337 108.987C68.9403 106.689 68.9403 104.192 69.7337 101.894C70.726 101.723 71.7059 101.487 72.6671 101.187C74.0004 100.667 75.2537 100.307 76.5071 99.8937Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M105.747 83.3328C102.801 87.6794 98.2274 90.4261 93.7474 92.6661C88.204 95.4756 82.4592 97.8688 76.5608 99.8261C76.4791 98.5768 76.1719 97.3526 75.6541 96.2128C75.195 95.0873 74.4105 94.1245 73.401 93.4476C72.3914 92.7706 71.2029 92.4103 69.9874 92.4128C68.9035 92.5965 67.8918 93.0777 67.0655 93.8029C66.2391 94.528 65.6304 95.4685 65.3074 96.5194C64.8332 97.9633 64.7188 99.5012 64.9741 100.999C63.6841 100.302 62.5845 99.2994 61.771 98.0792C60.9576 96.8591 60.4551 95.4584 60.3074 93.9994C60.1764 91.9251 60.7496 89.8673 61.9341 88.1594C62.2274 88.2528 62.5341 88.3194 62.8408 88.3861C65.0274 88.7397 67.2606 88.6854 69.4274 88.2261C71.399 87.8274 73.3152 87.1916 75.1341 86.3328C79.8941 84.1328 83.9474 80.8928 89.1341 78.8928C93.3474 77.2661 97.7608 76.1461 101.654 73.7461C103.758 72.4655 105.574 70.763 106.987 68.7461C109.334 72.8261 108.681 78.6794 106.107 82.7861C106.001 82.9594 105.881 83.1594 105.747 83.3328Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M64.9206 101.067C65.7447 101.517 66.6522 101.794 67.5872 101.88C68.3216 101.943 69.0609 101.912 69.7873 101.787C68.9938 104.085 68.9938 106.582 69.7873 108.88C70.1311 109.852 70.692 110.732 71.4273 111.454C59.3206 114.92 36.7606 119.174 18.8806 121.547C10.6673 108.214 8.21392 91.8536 6.13393 76.2136C5.31528 71.4597 4.98023 66.6351 5.13393 61.8136C5.33393 59.2536 6.66726 56.7736 7.18726 54.307C22.6806 51.6403 39.2806 46.987 44.8273 35.6403C46.3544 32.507 47.0128 29.0214 46.7339 25.547C48.3212 23.948 49.4732 21.9698 50.0806 19.8003C50.4588 18.46 50.551 17.0552 50.3512 15.677C50.1513 14.2987 49.6639 12.9779 48.9206 11.8003C48.3007 10.9464 47.4254 10.3118 46.4211 9.98826C45.4168 9.66469 44.3357 9.6689 43.3339 10.0003C42.3214 10.2636 41.385 10.7614 40.6006 11.4536C40.5869 11.2717 40.5869 11.0889 40.6006 10.907C40.4673 7.84029 42.7073 5.18695 45.2406 3.82695C51.1073 0.666955 58.7473 3.10695 63.0273 8.52029C67.3073 13.9336 68.4939 21.7203 67.1206 28.707C65.6956 34.3041 63.7586 39.7582 61.3339 45.0003C61.8539 44.4003 64.8673 43.787 65.5206 43.587C66.8539 43.187 68.1873 43.0003 69.5206 42.5736C72.8672 41.4536 76.3873 40.827 79.7873 39.907C84.9339 38.507 90.2806 37.1336 95.6139 37.947C103.441 39.1336 108.267 45.2803 104.201 53.507L104.027 53.8536C100.561 60.5203 93.7473 63.187 87.7339 66.227C82.6139 68.8136 77.2673 70.747 72.1073 73.1336C71.4139 71.8003 71.4539 69.667 71.1073 68.467C70.7088 66.8011 69.8221 65.2922 68.5606 64.1336C67.9158 63.607 67.1567 63.2387 66.344 63.0581C65.5314 62.8775 64.6877 62.8897 63.8806 63.0936C62.8204 63.4157 61.8772 64.0401 61.1667 64.8904C60.4562 65.7406 60.0092 66.7797 59.8806 67.8803C59.6246 70.218 59.7099 72.5805 60.1339 74.8936C59.5772 75.3404 59.0838 75.8607 58.6673 76.4403C57.8169 77.62 57.2801 78.9964 57.1073 80.4403C56.5873 84.987 58.8539 87.227 61.9473 88.0803C60.7404 89.8084 60.1617 91.8976 60.3073 94.0003C60.4389 95.4659 60.9284 96.8767 61.7328 98.1088C62.5372 99.341 63.6318 100.357 64.9206 101.067Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M83.1996 106.653C83.6529 107.773 84.0929 108.906 84.5329 110.04C82.9596 110.893 81.3863 111.733 79.8129 112.533C79.2559 112.82 78.6645 113.035 78.0529 113.173C77.304 112.147 76.6942 111.026 76.2396 109.84C74.9063 106.346 77.9196 100.973 81.5729 103.92C82.3278 104.686 82.8859 105.624 83.1996 106.653Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M69.8001 101.787C69.0737 101.912 68.3344 101.943 67.6001 101.88C66.665 101.794 65.7575 101.517 64.9334 101.067C64.6781 99.569 64.7925 98.0311 65.2667 96.5872C65.5898 95.5362 66.1984 94.5958 67.0248 93.8706C67.8512 93.1455 68.8628 92.6642 69.9467 92.4805C71.1622 92.478 72.3508 92.8383 73.3603 93.5153C74.3698 94.1922 75.1543 95.1551 75.6134 96.2805C76.1312 97.4203 76.4384 98.6445 76.5201 99.8938C75.2667 100.307 74.0134 100.707 72.7467 101.08C71.7812 101.381 70.7968 101.617 69.8001 101.787Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M62.4 87.5066C61.32 85.3866 60.3466 82.9732 61.2266 80.7466C63.3466 75.4132 70.28 76.5199 72.9333 80.5332C73.8236 81.7839 74.4829 83.1837 74.88 84.6666C75 85.2532 75.0533 85.7732 75.1333 86.2932C73.3144 87.1521 71.3982 87.7878 69.4266 88.1866C67.2598 88.6459 65.0266 88.7002 62.84 88.3466L62.4 87.5066Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M60.0655 74.8805C59.6414 72.5673 59.5561 70.2048 59.8121 67.8671C59.9407 66.7666 60.3877 65.7275 61.0982 64.8772C61.8087 64.027 62.7519 63.4025 63.8121 63.0805C64.6192 62.8765 65.4629 62.8644 66.2756 63.045C67.0882 63.2256 67.8473 63.5939 68.4921 64.1205C69.7536 65.2791 70.6404 66.788 71.0388 68.4538C71.3855 69.6538 71.3455 71.8271 72.0388 73.1205L69.9855 74.1071C67.0382 75.6604 63.781 76.5351 60.4521 76.6671C60.2921 76.0671 60.1721 75.4671 60.0655 74.8805Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M48.9196 11.8124C49.663 12.9901 50.1504 14.3109 50.3502 15.6891C50.55 17.0673 50.4579 18.4721 50.0796 19.8124C49.4722 21.982 48.3202 23.9602 46.7329 25.5591C46.5717 23.3688 45.9249 21.2418 44.8396 19.3324C43.3463 16.7591 40.9863 14.5058 40.5996 11.5458C41.3746 10.8199 42.3117 10.2896 43.3329 9.99909C44.336 9.66908 45.4182 9.66693 46.4226 9.99294C47.427 10.319 48.3015 10.9562 48.9196 11.8124Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M71.4932 111.453C59.3865 114.92 36.8265 119.173 18.9465 121.546L16.8398 121.826",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M61.3342 45.066C61.8542 44.466 64.8675 43.8527 65.5209 43.6527C66.8542 43.2527 68.1875 43.066 69.5209 42.6393C72.8675 41.5193 76.3875 40.8927 79.7875 39.9727C84.9342 38.5727 90.2809 37.1993 95.6142 38.0127C103.441 39.1993 108.268 45.346 104.201 53.5727L104.028 53.9193C100.561 60.586 93.7475 63.2527 87.7342 66.2927C82.6142 68.8793 77.2675 70.8127 72.1075 73.1993L70.0542 74.186C67.0803 75.7211 63.7995 76.5686 60.4542 76.666C59.8529 76.6455 59.2548 76.5697 58.6675 76.4393C57.4264 76.1883 56.3009 75.5397 55.4612 74.5918C54.6216 73.644 54.1136 72.4484 54.0142 71.186C52.5475 62.4393 58.2275 55.186 64.8542 51.186C69.5538 48.4871 74.6743 46.5985 80.0009 45.5993",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M5.1875 54.6404L7.1875 54.307C22.6808 51.6404 39.2808 46.987 44.8275 35.6404C46.3546 32.5071 47.0131 29.0215 46.7342 25.547C46.5709 23.3613 45.9242 21.2391 44.8408 19.3337C43.3475 16.7604 40.9875 14.507 40.6008 11.547C40.5871 11.3651 40.5871 11.1823 40.6008 11.0004C40.4675 7.93369 42.7075 5.28036 45.2408 3.92036C51.1075 0.667024 58.7475 3.10702 63.0275 8.52036C67.3075 13.9337 68.4942 21.7204 67.1208 28.707C65.6959 34.3042 63.7588 39.7583 61.3342 45.0004C60.5208 46.907 59.7208 48.667 59.0408 50.0004",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M40.5996 11.5064C41.3787 10.795 42.3154 10.2786 43.3329 9.99975C44.3306 9.66418 45.4089 9.65379 46.4129 9.97006C47.4168 10.2863 48.2945 10.913 48.9196 11.7597C49.663 12.9374 50.1504 14.2582 50.3502 15.6364C50.55 17.0146 50.4579 18.4195 50.0796 19.7597C49.4722 21.9293 48.3202 23.9075 46.7329 25.5064",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M104.174 53.4922C105.821 54.3109 107.19 55.5982 108.108 57.1924C109.026 58.7865 109.452 60.6164 109.334 62.4522C109.152 64.7061 108.369 66.87 107.067 68.7189C105.653 70.7358 103.838 72.4382 101.734 73.7189C97.8404 76.1189 93.427 77.2389 89.2137 78.8655C84.027 80.8655 79.9737 84.1055 75.2137 86.3055C73.3948 87.1644 71.4786 87.8001 69.507 88.1989C67.3402 88.6582 65.107 88.7125 62.9204 88.3589C62.6137 88.3589 62.307 88.2255 62.0137 88.1322C58.9204 87.2789 56.6804 85.0389 57.1737 80.4922C57.3466 79.0483 57.8834 77.6719 58.7337 76.4922",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M61.9337 88.1346C60.7434 89.8498 60.1699 91.918 60.307 94.0013C60.4345 95.4715 60.922 96.8878 61.7266 98.1249C62.5312 99.362 63.6281 100.382 64.9204 101.095C65.7444 101.545 66.652 101.822 67.587 101.908C68.3214 101.971 69.0607 101.939 69.787 101.815C70.7793 101.644 71.7592 101.408 72.7204 101.108C74.0537 100.735 75.2404 100.335 76.4937 99.9213C82.3922 97.964 88.1369 95.5708 93.6804 92.7613C98.2137 90.468 102.787 87.7213 105.68 83.428C105.814 83.2413 105.934 83.0413 106.054 82.8413C108.694 78.6546 109.334 72.8013 107 68.668",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M69.8002 101.785C69.0067 104.083 69.0067 106.581 69.8002 108.879C70.144 109.85 70.7049 110.73 71.4402 111.452C72.2928 112.267 73.3382 112.852 74.4784 113.152C75.6187 113.453 76.8166 113.46 77.9602 113.172C78.5717 113.035 79.1631 112.819 79.7202 112.532C81.2935 111.732 82.8668 110.892 84.4402 110.039C87.7735 108.239 91.1068 106.399 94.4535 104.705C98.8401 102.492 102.32 100.799 105.707 96.9187C107.413 94.9587 109.013 92.5454 108.947 89.8387C108.737 87.3444 107.594 85.021 105.747 83.332",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M72.0798 73.1205C71.3865 71.7871 71.4265 69.6538 71.0798 68.4538C70.6814 66.788 69.7946 65.2791 68.5331 64.1205C67.8883 63.5939 67.1292 63.2256 66.3166 63.045C65.5039 62.8644 64.6603 62.8765 63.8531 63.0805C62.7929 63.4025 61.8498 64.027 61.1392 64.8772C60.4287 65.7275 59.9818 66.7666 59.8531 67.8671C59.5971 70.2048 59.6825 72.5673 60.1065 74.8805C60.2131 75.4671 60.3331 76.0671 60.4931 76.6405",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M62.84 88.3599L62.4 87.5066C61.32 85.3866 60.3466 82.9732 61.2266 80.7466C63.3466 75.4132 70.28 76.5199 72.9333 80.5332C73.8236 81.7839 74.4829 83.1837 74.88 84.6666C75 85.2532 75.0533 85.7732 75.1333 86.2932",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M64.9197 101.067C64.6644 99.569 64.7789 98.0311 65.2531 96.5872C65.5761 95.5362 66.1847 94.5958 67.0111 93.8706C67.8375 93.1455 68.8491 92.6642 69.9331 92.4805C71.1485 92.478 72.3371 92.8383 73.3466 93.5153C74.3561 94.1922 75.1406 95.1551 75.5997 96.2805C76.1175 97.4203 76.4247 98.6445 76.5064 99.8938",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M78.0139 113.173C77.2649 112.147 76.6552 111.026 76.2005 109.84C74.8672 106.346 77.8805 100.973 81.5339 103.92C82.3038 104.66 82.8845 105.575 83.2272 106.586C83.6805 107.706 84.1205 108.84 84.5605 109.973",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
/* harmony default export */ const challenge_icon = (Icon);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/assets/global-english-icon.tsx



const global_english_icon_Icon = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
  fill: "none",
  ...props,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3608 113C34.6086 115.462 38.0975 117.588 41.7742 119.347C67.8808 131.853 102.161 122.213 115.401 96.0265C128.641 69.8398 124.334 38.8798 100.361 20.0265C71.7875 -2.34683 28.7075 8.17317 13.0142 40.9998C0.774159 66.6665 9.65416 96.5732 31.3608 113Z",
    fill: "currentColor"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M106.961 75.453C108.207 75.8008 109.351 76.4459 110.294 77.333C110.897 77.9351 111.325 78.69 111.532 79.5169C111.739 80.3437 111.716 81.2113 111.467 82.0264C110.934 83.3607 110.114 84.5621 109.067 85.5464C108.244 86.587 107.667 87.8008 107.381 89.0964C107.095 90.392 107.106 91.7357 107.414 93.0264C107.784 94.3667 108.529 95.5738 109.561 96.5064C110.707 97.5464 111.854 98.2797 113.094 99.173C118.347 97.573 120.401 97.1197 125.574 95.5064C122.667 93.5997 121.694 89.5597 122.627 86.173C123.246 84.3595 124.008 82.5983 124.907 80.9064C125.801 79.2019 126.19 77.2775 126.027 75.3597C125.747 73.4664 124.774 71.173 122.921 71.6264C109.125 75.0308 95.2629 78.1864 81.334 81.093",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M106.961 75.453C108.207 75.8008 109.351 76.4459 110.294 77.333C110.897 77.9351 111.325 78.69 111.532 79.5169C111.739 80.3437 111.716 81.2113 111.467 82.0264C110.934 83.3607 110.114 84.5621 109.067 85.5464C108.244 86.587 107.667 87.8008 107.381 89.0964C107.095 90.392 107.106 91.7357 107.414 93.0264C107.784 94.3667 108.529 95.5738 109.561 96.5064C110.707 97.5464 111.854 98.2797 113.094 99.173C118.347 97.573 120.401 97.1197 125.574 95.5064C122.667 93.5997 121.694 89.5597 122.627 86.173C123.246 84.3595 124.008 82.5983 124.907 80.9064C125.801 79.2019 126.19 77.2775 126.027 75.3597C125.747 73.4664 124.774 71.173 122.921 71.6264C109.125 75.0308 95.2629 78.1864 81.334 81.093",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M118.187 82.3867C118.889 82.5343 119.541 82.8604 120.081 83.3334C119.854 83.8667 119.601 84.4001 119.361 84.9334C118.696 84.6121 117.985 84.3962 117.254 84.2934C117.502 83.8946 117.725 83.4804 117.921 83.0534C118.023 82.8369 118.112 82.6142 118.187 82.3867Z",
    stroke: "#242424",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M115.001 84.2539L114.721 84.7206C114.281 85.4006 113.761 86.0539 113.388 86.7072C113.172 87.0654 112.985 87.4399 112.828 87.8273C112.094 87.2139 111.881 86.3606 112.828 85.2672C113.405 84.6767 114.178 84.3165 115.001 84.2539V84.2539Z",
    stroke: "#242424",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M116.667 84.2264C116.862 84.2148 117.058 84.2148 117.254 84.2264C116.96 84.7331 116.64 85.2398 116.374 85.7731C115.882 86.6966 115.505 87.6773 115.254 88.6931C114.367 88.5895 113.52 88.269 112.787 87.7598C112.941 87.3819 113.124 87.0164 113.334 86.6664C113.747 85.9731 114.267 85.3331 114.667 84.6797L114.947 84.2131C115.519 84.154 116.096 84.1585 116.667 84.2264V84.2264Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M120.454 81.5476L120.641 81.6809C120.496 82.2455 120.309 82.7982 120.081 83.3343C119.542 82.8612 118.889 82.5352 118.188 82.3876C118.362 81.9305 118.465 81.4494 118.494 80.9609C119.189 80.9709 119.868 81.174 120.454 81.5476V81.5476Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M115.253 88.7595C115.259 88.7948 115.259 88.8309 115.253 88.8662C115.102 89.4865 115.017 90.1212 115 90.7595C114.225 90.6254 113.488 90.3252 112.84 89.8795C112.675 89.7666 112.519 89.6418 112.373 89.5062C112.457 88.9315 112.604 88.368 112.813 87.8262C113.538 88.3313 114.376 88.6517 115.253 88.7595V88.7595Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M118.479 90.1875C118.559 90.5409 118.675 90.8851 118.826 91.2142C117.735 91.956 116.419 92.2911 115.106 92.1608C115.015 91.6998 114.97 91.2308 114.973 90.7608C115.578 90.8608 116.195 90.8608 116.799 90.7608C117.386 90.6583 117.953 90.4649 118.479 90.1875V90.1875Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M114.974 90.7611C114.971 91.2311 115.016 91.7001 115.107 92.1611C114.603 92.1241 114.103 92.0393 113.614 91.9078C113.143 91.7784 112.694 91.5807 112.281 91.3211C112.229 90.7162 112.252 90.1073 112.347 89.5078C112.493 89.6435 112.649 89.7682 112.814 89.8812C113.462 90.3268 114.199 90.627 114.974 90.7611V90.7611Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M117.534 81.0132C117.854 80.98 118.175 80.98 118.494 81.0132C118.466 81.5016 118.362 81.9828 118.188 82.4398H117.628C116.985 82.4074 116.343 82.4979 115.734 82.7065C115.855 82.3007 115.944 81.8861 116.001 81.4665C116.387 81.2817 116.794 81.1473 117.214 81.0665L117.534 81.0132Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M118.187 82.3866C118.112 82.6141 118.023 82.8368 117.92 83.0533C117.724 83.4803 117.502 83.8945 117.253 84.2933C117.058 84.2817 116.862 84.2817 116.667 84.2933C116.113 84.2337 115.554 84.2337 115 84.2933C115.301 83.7646 115.547 83.206 115.733 82.6266C116.342 82.418 116.984 82.3275 117.627 82.3599L118.187 82.3866Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M118.346 88.5469C118.316 89.0971 118.361 89.6487 118.479 90.1869C117.953 90.4689 117.386 90.6668 116.799 90.7735C116.195 90.8735 115.577 90.8735 114.973 90.7735C114.99 90.1352 115.075 89.5005 115.226 88.8802C115.232 88.8449 115.232 88.8088 115.226 88.7735H115.466C116.431 88.8911 117.411 88.8141 118.346 88.5469V88.5469Z",
    stroke: "#242424",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M120.361 85.7469C121.081 86.8003 120.081 87.7203 119.201 88.2136C118.93 88.357 118.644 88.4689 118.348 88.5469C118.348 88.3336 118.348 88.1203 118.348 87.9069C118.537 86.8782 118.859 85.8786 119.308 84.9336C119.724 85.1082 120.087 85.3886 120.361 85.7469V85.7469Z",
    stroke: "#242424",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M115.733 82.5868C115.547 83.1662 115.302 83.7248 115 84.2535C114.163 84.3065 113.374 84.6674 112.787 85.2668C111.84 86.3601 112.053 87.2135 112.787 87.8268C112.578 88.3686 112.43 88.9321 112.347 89.5068C112.251 90.1063 112.229 90.7152 112.28 91.3201C111.642 90.9786 111.157 90.4061 110.927 89.7196C110.696 89.0331 110.737 88.2845 111.04 87.6268C111.346 86.9813 111.731 86.3766 112.187 85.8268C112.801 84.7324 113.482 83.677 114.227 82.6668C114.742 82.1646 115.342 81.7582 116 81.4668C115.938 81.8459 115.849 82.2202 115.733 82.5868V82.5868Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M117.253 84.293C117.984 84.3958 118.695 84.6117 119.36 84.933C118.912 85.878 118.589 86.8776 118.4 87.9063C118.4 88.1196 118.4 88.333 118.4 88.5463C117.474 88.8144 116.504 88.896 115.547 88.7863H115.307C115.558 87.7706 115.934 86.7898 116.427 85.8663C116.64 85.333 116.96 84.7996 117.253 84.293Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M118.48 90.1864C118.362 89.6482 118.317 89.0965 118.347 88.5464C118.643 88.4683 118.929 88.3564 119.2 88.213C120.08 87.7197 121.08 86.7997 120.36 85.7464C120.101 85.3952 119.757 85.1154 119.36 84.933C119.6 84.3997 119.853 83.8664 120.08 83.333C120.308 82.7969 120.496 82.2442 120.64 81.6797C122.76 83.293 120.64 85.5197 120.427 87.5063C120.427 87.8663 120.427 88.2264 120.333 88.5864C120.283 89.1115 120.122 89.6201 119.863 90.0794C119.603 90.5388 119.25 90.9386 118.827 91.253C118.673 90.9111 118.557 90.5534 118.48 90.1864V90.1864Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M120.08 83.332C120.62 83.802 120.994 84.4331 121.147 85.132",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M120.28 88.625C119.809 89.2773 119.193 89.8113 118.48 90.185",
    stroke: "#242424",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M113.334 84.1193C114.042 83.4438 114.882 82.9218 115.801 82.5859",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M112.347 89.507L112.107 89.3337C111.679 88.7313 111.384 88.0451 111.24 87.3203",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M93.9861 88.7472C94.2261 92.1605 92.0794 95.6939 90.1461 98.6805C89.7327 99.3339 89.2927 100.014 88.8127 100.681C88.264 100.535 87.7288 100.344 87.2127 100.107C85.4301 99.3177 83.9903 97.914 83.1558 96.1519C82.3212 94.3899 82.1475 92.3866 82.6661 90.5072C83.5594 86.5739 86.6661 84.6805 90.5461 86.3872C91.816 86.977 92.9786 87.7747 93.9861 88.7472Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M44.3868 63.7317C44.9187 63.5171 45.4206 63.2348 45.8802 62.8917C48.1735 61.1451 49.1202 57.7184 50.1602 55.1451C51.245 52.3612 52.584 49.6833 54.1602 47.1451C56.6811 42.9386 60.3239 39.5174 64.6802 37.2651C65.5128 36.8667 66.3728 36.528 67.2535 36.2517C70.469 35.2919 73.8585 35.0641 77.1735 35.5851C84.1602 36.5851 91.2935 41.2917 92.2935 48.2784C92.8268 52.0117 91.5735 55.7851 90.7735 59.5051C89.3326 60.0955 88.1084 61.1149 87.2668 62.4251C86.3459 63.7137 85.747 65.2042 85.5202 66.7717C85.1468 69.8651 87.1202 73.5317 90.7335 72.4651C91.2095 72.3186 91.6594 72.0981 92.0668 71.8117C92.2471 72.5971 92.2471 73.413 92.0668 74.1984C91.6467 75.675 90.6657 76.9288 89.3335 77.6917C85.3335 80.1584 79.6935 78.9451 76.3868 75.5717C74.8128 73.8052 73.6459 71.7145 72.9685 69.4474C72.2911 67.1804 72.1199 64.7922 72.4668 62.4517C72.6535 60.8651 72.7868 58.8251 71.3468 58.1451C66.4135 55.8251 63.7602 71.8651 63.3468 74.3717C62.236 81.6666 62.4573 89.1025 64.0002 96.3184C64.2123 97.8128 64.7792 99.2346 65.6535 100.465C66.1007 101.073 66.7254 101.528 67.4417 101.767C68.158 102.006 68.9307 102.017 69.6535 101.798C71.2802 101.145 71.8668 99.1317 72.3202 97.4784C73.4802 92.7451 75.1468 87.8651 78.8135 84.6517C82.4802 81.4384 88.6802 80.6517 92.0002 84.2651C93.1805 85.4743 93.8979 87.0602 94.0268 88.7451C93.0435 87.7798 91.9085 86.9825 90.6668 86.3851C86.8402 84.6784 83.6802 86.5717 82.7868 90.5051C82.2682 92.3845 82.442 94.3877 83.2765 96.1498C84.1111 97.9119 85.5508 99.3155 87.3335 100.105C87.8495 100.341 88.3848 100.533 88.9335 100.678C87.4036 102.912 86.0655 105.272 84.9335 107.732C83.6002 110.825 82.7735 114.278 80.3335 116.745C79.3738 117.673 78.2929 118.467 77.1202 119.105C68.9335 123.825 61.1202 122.825 52.2935 120.652C43.0258 118.152 33.5595 116.456 24.0002 115.585C18.4935 115.198 13.0535 114.665 7.60017 114.358C7.80017 98.3851 -0.839831 82.8651 4.00017 65.2517C14.7735 65.2517 28.7868 64.8917 39.2135 64.5184C40.9701 64.5516 42.7195 64.2856 44.3868 63.7317Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M91.9998 71.7989C91.5924 72.0852 91.1424 72.3057 90.6665 72.4522C87.0531 73.5189 85.0798 69.7855 85.4531 66.7589C85.68 65.1913 86.2789 63.7009 87.1998 62.4122C88.0413 61.1021 89.2656 60.0826 90.7065 59.4922C90.0242 62.0407 89.9647 64.7159 90.5331 67.2922C90.9598 68.8122 91.7331 70.3055 91.9998 71.7989Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M69.1867 7.17291L71.2267 6.98624C72.6934 6.89291 74.1601 6.83957 75.6267 6.86624C75.664 7.62002 75.8748 8.35503 76.2424 9.0141C76.6101 9.67317 77.1249 10.2385 77.7467 10.6662C78.8557 11.5385 80.1268 12.1821 81.4863 12.5598C82.8458 12.9374 84.2667 13.0416 85.6667 12.8662C87.0737 12.6845 88.4321 12.2317 89.6667 11.5329C90.8098 12.982 91.4314 14.7739 91.4314 16.6196C91.4314 18.4652 90.8098 20.2571 89.6667 21.7062C87.0001 24.9062 82.2934 25.3862 78.2401 26.5329C72.5201 28.1462 67.0667 31.8662 64.68 37.1996C60.3238 39.4519 56.681 42.8731 54.16 47.0796C52.5839 49.6178 51.2449 52.2957 50.16 55.0796C49.12 57.6529 48.1734 61.0796 45.8801 62.8262C45.4205 63.1693 44.9186 63.4516 44.3867 63.6662C45.0722 62.3782 45.5236 60.9787 45.7201 59.5329C45.8534 58.6129 45.9334 57.6929 45.9867 56.7596C46.1867 53.1729 45.8534 49.5596 45.7067 45.9596C45.7067 45.2129 45.7067 44.4662 45.7067 43.7196C45.6467 36.3041 47.0043 28.9454 49.7067 22.0396C50.9883 18.2237 53.1804 14.7777 56.0934 11.9996C59.6934 8.95957 64.4401 7.69291 69.1867 7.17291Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M89.667 11.5732C88.4324 12.272 87.0739 12.7248 85.667 12.9065C84.2643 13.0763 82.8418 12.9657 81.4822 12.5812C80.1226 12.1966 78.8529 11.5458 77.747 10.6665C77.1217 10.2361 76.6047 9.66652 76.2369 9.00252C75.869 8.33851 75.6602 7.59821 75.627 6.83984C78.9973 6.84755 82.3375 7.4758 85.4803 8.69318C86.8511 9.21794 88.1058 10.0061 89.1736 11.0132C89.349 11.1899 89.5137 11.3769 89.667 11.5732Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M44.9593 13.6401C45.8492 12.5667 46.7973 11.5429 47.7993 10.5734C49.1555 9.22439 50.6279 7.99743 52.1993 6.90677C52.4731 7.26153 52.8127 7.56029 53.1993 7.78677C53.9791 8.16332 54.8412 8.33756 55.706 8.29344C57.4937 8.24709 59.2509 7.81993 60.8604 7.04049C62.4698 6.26105 63.8945 5.14725 65.0393 3.77344C65.5032 3.93278 65.9499 4.13826 66.3727 4.38677C67.5006 5.05316 68.4232 6.0173 69.0393 7.17344C64.2927 7.69344 59.546 8.9601 55.946 12.0268C52.984 14.8029 50.7496 18.2644 49.4393 22.1068C46.737 29.0126 45.3793 36.3713 45.4393 43.7868C45.4393 44.5334 45.4393 45.2801 45.4393 46.0268L42.026 40.8934C41.386 39.9201 40.6927 38.9601 40.146 37.9734C39.4437 35.6012 38.9967 33.1607 38.8127 30.6934C38.5333 24.421 40.7424 18.2919 44.9593 13.6401Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M65.0939 3.77272C63.9491 5.14653 62.5244 6.26033 60.9149 7.03977C59.3055 7.81922 57.5482 8.24637 55.7606 8.29272C54.8957 8.33684 54.0337 8.1626 53.2539 7.78605C52.8672 7.55958 52.5277 7.26081 52.2539 6.90605C54.4761 5.36586 56.9684 4.25768 59.6006 3.63939C61.4114 3.19893 63.3065 3.24492 65.0939 3.77272Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M45.6527 46.026C45.7994 49.626 46.1327 53.2393 45.9327 56.826C45.9718 54.9838 45.761 53.1449 45.306 51.3593C44.454 48.7538 43.466 46.1947 42.346 43.6927C41.5788 41.8241 40.9156 39.9145 40.3594 37.9727C40.946 38.9593 41.5994 39.9193 42.2394 40.8927L45.6527 46.026Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M41.2142 11.1478C42.6648 11.6263 43.9593 12.4878 44.9608 13.6412C40.8422 18.3258 38.7261 24.4395 39.0675 30.6678C39.2515 33.135 39.6985 35.5755 40.4008 37.9478C39.9002 37.0882 39.4548 36.1975 39.0675 35.2812C37.4675 31.6812 37.1208 27.8145 36.1342 24.0678C36.4117 23.5359 36.6222 22.9716 36.7608 22.3878C36.9956 21.3921 37.0233 20.3587 36.8421 19.3518C36.6609 18.3449 36.2747 17.3859 35.7075 16.5345C35.2939 15.8519 34.6856 15.3086 33.9608 14.9745C33.7149 14.8728 33.4533 14.8142 33.1875 14.8012C33.2186 13.9258 33.5587 13.0897 34.1475 12.4412C35.5608 10.7878 38.7608 10.3345 41.2142 11.1478Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M35.6139 16.6122C36.1811 17.4637 36.5673 18.4226 36.7485 19.4295C36.9297 20.4364 36.902 21.4698 36.6672 22.4656C36.5159 23.0512 36.2919 23.6156 36.0005 24.1456C35.7144 23.0451 35.349 21.9667 34.9072 20.9189C34.0805 18.9722 32.9472 16.8256 33.0539 14.8789C33.3197 14.8919 33.5813 14.9505 33.8272 15.0522C34.5668 15.3796 35.1897 15.9236 35.6139 16.6122Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M93.9872 88.7472C93.016 87.7855 91.8946 86.9884 90.6672 86.3872C86.8405 84.6805 83.6805 86.5739 82.7872 90.5072C82.2685 92.3866 82.4423 94.3899 83.2769 96.1519C84.1114 97.914 85.5511 99.3177 87.3338 100.107C87.8498 100.344 88.3851 100.535 88.9338 100.681",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M90.7338 59.4922C89.2929 60.0826 88.0687 61.1021 87.2271 62.4122C86.3062 63.7009 85.7073 65.1913 85.4805 66.7589C85.1071 69.8522 87.0805 73.5189 90.6938 72.4522C91.1698 72.3057 91.6197 72.0852 92.0271 71.7989",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M5.71911 114.253L7.59911 114.36C13.0524 114.68 18.4924 115.2 23.9324 115.587C33.5008 116.457 42.976 118.152 52.2524 120.653C61.0524 122.827 68.8925 123.827 77.0791 119.107C78.2519 118.469 79.3328 117.675 80.2925 116.747C82.7325 114.28 83.5591 110.827 84.8924 107.733C86.0245 105.274 87.3626 102.914 88.8924 100.68C89.3191 100 89.7591 99.3467 90.2258 98.68C92.1591 95.6933 94.3058 92.16 94.0658 88.7467C93.926 87.0566 93.1941 85.47 91.9991 84.2667C88.6791 80.7067 82.4658 81.4533 78.8125 84.6533C75.1591 87.8533 73.4791 92.7467 72.3191 97.48C71.8925 99.1867 71.3058 101.147 69.6525 101.8C68.9297 102.018 68.157 102.007 67.4407 101.769C66.7244 101.53 66.0997 101.075 65.6525 100.467C64.7782 99.2363 64.2113 97.8144 63.9991 96.32C62.4607 89.1033 62.2439 81.6674 63.3591 74.3733C63.7325 71.8667 66.3858 55.8267 71.3591 58.1467C72.7991 58.8267 72.6925 60.8133 72.4791 62.4533C72.1322 64.7939 72.3034 67.182 72.9808 69.4491C73.6581 71.7161 74.8251 73.8068 76.3991 75.5733C79.6658 78.9467 85.3325 80.16 89.3325 77.6933C90.6876 76.9379 91.6892 75.6774 92.1191 74.1867C92.2994 73.4013 92.2994 72.5853 92.1191 71.8C91.7991 70.3067 91.0258 68.8133 90.6258 67.2933C90.0574 64.717 90.1168 62.0418 90.7991 59.4933C91.5991 55.7733 92.8524 52 92.3191 48.2667C91.3191 41.28 84.1858 36.5733 77.1991 35.5733C73.8841 35.0524 70.4946 35.2802 67.2791 36.24C66.3984 36.5163 65.5384 36.8549 64.7058 37.2533C60.3495 39.5057 56.7067 42.9268 54.1858 47.1333C52.6096 49.6715 51.2707 52.3495 50.1858 55.1333C49.1458 57.7067 48.1991 61.1333 45.9058 62.88C45.4462 63.2231 44.9443 63.5054 44.4125 63.72C42.7494 64.2724 41.0046 64.5384 39.2525 64.5067C28.8258 64.88 14.8124 65.1867 4.03911 65.24H2.42578",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M75.627 6.86719C75.6643 7.62097 75.875 8.35597 76.2427 9.01505C76.6104 9.67412 77.1251 10.2395 77.747 10.6672C78.856 11.5395 80.127 12.1831 81.4865 12.5607C82.846 12.9384 84.2669 13.0425 85.667 12.8672C87.0739 12.6855 88.4324 12.2327 89.667 11.5339",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M52.1992 6.90677C52.473 7.26153 52.8125 7.56029 53.1992 7.78677C53.979 8.16332 54.841 8.33756 55.7059 8.29344C57.4936 8.24709 59.2508 7.81993 60.8603 7.04049C62.4697 6.26105 63.8944 5.14725 65.0392 3.77344",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M64.6399 37.2522C67.0266 31.9189 72.4799 28.1856 78.1999 26.5856C82.1999 25.4389 86.8932 24.9589 89.6266 21.7589C90.7696 20.3098 91.3913 18.5179 91.3913 16.6722C91.3913 14.8266 90.7696 13.0347 89.6266 11.5856C89.4725 11.3985 89.3078 11.2204 89.1332 11.0522C88.0654 10.0452 86.8107 9.25701 85.4399 8.73224C82.2971 7.51487 78.9569 6.88661 75.5866 6.87891C74.1199 6.87891 72.6532 6.87891 71.1866 6.99891L69.1466 7.18557C64.3999 7.70557 59.6532 8.97224 56.0532 12.0389C53.0912 14.815 50.8568 18.2765 49.5466 22.1189C46.8442 29.0247 45.4865 36.3834 45.5466 43.7989C45.5466 44.5456 45.5466 45.2922 45.5466 46.0389C45.6932 49.6389 46.0266 53.2522 45.8266 56.8389C45.8266 57.7722 45.6932 58.6922 45.5599 59.6122C45.3634 61.058 44.912 62.4575 44.2266 63.7456",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M69.1856 7.17206C68.5695 6.01592 67.6469 5.05179 66.519 4.38539C66.0961 4.13688 65.6495 3.9314 65.1856 3.77206C63.3816 3.23466 61.4668 3.18863 59.639 3.63873C57.0068 4.25702 54.5145 5.3652 52.2923 6.90539C50.7208 7.99605 49.2484 9.22301 47.8923 10.5721C46.8902 11.5416 45.9421 12.5653 45.0523 13.6387C40.8999 18.3089 38.7498 24.4242 39.0656 30.6654C39.2496 33.1326 39.6966 35.5731 40.399 37.9454C40.9551 39.8872 41.6184 41.7968 42.3856 43.6654C43.5019 46.1765 44.4855 48.7444 45.3323 51.3587C45.7873 53.1443 45.9981 54.9832 45.959 56.8254",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M40.361 37.9737C39.8603 37.1141 39.415 36.2234 39.0276 35.3071C37.4276 31.7071 37.081 27.8404 36.0943 24.0937C35.8082 22.9932 35.4428 21.9148 35.001 20.8671C34.1743 18.9204 33.041 16.7737 33.1476 14.8271C33.1787 13.9517 33.5188 13.1156 34.1076 12.4671C35.6143 10.7337 38.8143 10.2804 41.2676 11.1337C42.7183 11.6122 44.0128 12.4737 45.0143 13.6271",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M33.0938 14.8789C33.3596 14.8919 33.6212 14.9505 33.8671 15.0522C34.5919 15.3863 35.2002 15.9296 35.6137 16.6122C36.181 17.4637 36.5672 18.4226 36.7483 19.4295C36.9295 20.4364 36.9019 21.4698 36.6671 22.4656C36.5158 23.0512 36.2918 23.6156 36.0004 24.1456",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
/* harmony default export */ const global_english_icon = (global_english_icon_Icon);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/assets/hint-icon.tsx



const hint_icon_Icon = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
  fill: "none",
  ...props,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3608 113C34.6086 115.462 38.0975 117.588 41.7742 119.347C67.8808 131.853 102.161 122.213 115.401 96.0265C128.641 69.8398 124.334 38.8798 100.361 20.0265C71.7875 -2.34683 28.7075 8.17317 13.0142 40.9998C0.774159 66.6665 9.65416 96.5732 31.3608 113Z",
    fill: "currentColor"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M83.1994 80.5469C81.7104 81.9187 79.9536 82.9674 78.0394 83.6269C74.5061 84.8669 70.7594 84.9602 67.1061 85.5469C62.5994 86.2402 58.7861 88.1336 54.5861 89.0536C54.5861 88.6269 54.6528 88.2002 54.6661 87.7202C54.6232 86.4397 54.3429 85.1784 53.8394 84.0002C52.4128 80.3202 47.0528 78.2402 44.4261 82.1202C43.3328 83.7469 43.6794 85.8536 44.1728 87.7469L43.9061 87.9602C42.5178 89.1468 41.6041 90.7942 41.3328 92.6002C41.1755 93.7977 41.3159 95.0154 41.7415 96.1457C42.1671 97.276 42.8648 98.2839 43.7728 99.0802C44.3627 99.5869 45.0469 99.972 45.7861 100.214C46.3638 100.382 46.9587 100.485 47.5594 100.52C46.5343 102.231 46.1118 104.235 46.3594 106.214C46.465 107.062 46.7662 107.875 47.2394 108.587C40.4661 109.147 33.6261 109.187 26.8528 109.694C19.1461 110.267 11.4394 110.84 3.71942 111.107C2.61929 107.242 1.88714 103.283 1.53276 99.2802C1.13276 94.0536 1.62609 88.7869 0.94609 83.5736C0.477767 78.6929 0.531404 73.7762 1.10609 68.9069C1.29092 64.9574 1.86707 61.036 2.82609 57.2002C3.39942 55.2136 4.82609 53.4402 5.73276 51.5602C18.6128 52.1736 32.7328 51.3336 39.1594 43.2136C40.9337 40.973 42.0755 38.2981 42.4661 35.4669C44.0145 34.47 45.2815 33.0928 46.1461 31.4669C46.7055 30.4554 47.0414 29.3357 47.1311 28.1833C47.2208 27.031 47.0623 25.8727 46.6661 24.7869C46.3238 23.9929 45.7334 23.3312 44.9835 22.9009C44.2335 22.4707 43.3643 22.295 42.5061 22.4002C41.6505 22.4312 40.8144 22.6643 40.0661 23.0802C40.0661 22.9336 40.0661 22.7869 40.0661 22.6269C40.3687 21.4388 40.993 20.3572 41.8704 19.501C42.7478 18.6447 43.8443 18.047 45.0394 17.7736C50.3728 16.2669 56.0128 19.5336 58.5061 24.6136C60.9994 29.6936 60.5594 36.1602 58.2394 41.5069C55.9194 46.8536 53.8528 50.8402 48.9061 54.1736C53.8702 53.8405 58.8115 53.2262 63.7061 52.3336C73.5994 50.7202 83.5728 49.6669 93.5728 49.0936C98.5299 48.6724 103.505 48.5033 108.479 48.5869C113.373 48.7736 118.639 47.8536 122.733 51.2536C124.146 52.3134 125.082 53.8912 125.333 55.6402C125.344 56.8536 125.028 58.0476 124.418 59.0965C123.808 60.1454 122.926 61.0104 121.866 61.6002C119.737 62.7527 117.414 63.503 115.013 63.8136C100.213 66.6136 85.1728 65.1469 70.4528 67.8136C76.0661 67.5602 88.6527 67.2402 86.1194 75.8802C85.5841 77.6704 84.5753 79.2827 83.1994 80.5469Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.2811 108.587C46.8079 107.874 46.5066 107.062 46.4011 106.213C46.1535 104.235 46.576 102.23 47.6011 100.52C48.4224 100.573 49.2464 100.573 50.0677 100.52C51.1477 100.44 52.2277 100.333 53.3077 100.227C58.3763 99.7148 63.3993 98.8234 68.3344 97.5599C72.3344 96.5199 76.5077 95.1199 79.6278 92.2266C80.833 93.8897 81.3619 95.9484 81.1078 97.9866C80.4766 100.024 79.1384 101.769 77.3344 102.907C73.9344 105.427 70.8544 106.173 66.9477 107.187C63.9611 107.96 60.9744 108.853 57.9877 109.707C57.8677 108.72 57.7211 107.747 57.5477 106.773C57.4683 105.881 57.1657 105.024 56.6677 104.28C54.2811 101.28 50.9077 105.053 51.3344 108.093C51.4883 109.122 51.7751 110.126 52.1877 111.08C51.2264 111.109 50.2731 110.896 49.4157 110.46C48.5582 110.025 47.8242 109.38 47.2811 108.587Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M79.6266 91.9995C76.5066 94.9595 72.3599 96.3595 68.3332 97.3329C63.3981 98.5964 58.3751 99.4878 53.3066 99.9995C53.4629 98.9846 53.4313 97.9496 53.2132 96.9462C53.0357 95.9722 52.5738 95.0725 51.8857 94.3606C51.1975 93.6488 50.314 93.1566 49.3466 92.9462C48.4472 92.9067 47.5543 93.1161 46.7663 93.5513C45.9782 93.9865 45.3255 94.6306 44.8799 95.4129C44.2409 96.4858 43.8747 97.6989 43.8132 98.9462C42.918 98.1673 42.2248 97.183 41.7929 96.0778C41.361 94.9725 41.2033 93.7791 41.3332 92.5995C41.6137 90.8079 42.5266 89.176 43.9066 87.9995L44.2932 88.2129C45.9752 89.0437 47.8178 89.4987 49.6932 89.5462C51.3395 89.5732 52.9828 89.3986 54.5866 89.0262C58.7866 88.1062 62.5866 86.2129 67.1066 85.5195C70.7599 84.9595 74.5066 84.8395 78.0399 83.5995C79.954 82.94 81.7109 81.8913 83.1999 80.5195C84.3599 84.2129 82.8132 88.7862 80.0399 91.6262L79.6266 91.9995Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M57.4795 106.773C57.6528 107.747 57.7995 108.72 57.9195 109.707C56.5862 110.107 55.1062 110.507 53.7062 110.88C53.2046 111.006 52.69 111.073 52.1728 111.08C51.7602 110.126 51.4734 109.122 51.3195 108.093C50.8395 105.053 54.2128 101.28 56.6528 104.28C57.132 105.029 57.4161 105.886 57.4795 106.773Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.5992 100.52C46.9984 100.485 46.4035 100.382 45.8258 100.214C45.0867 99.9721 44.4025 99.587 43.8125 99.0803C43.8739 97.8331 44.2402 96.6199 44.8792 95.547C45.3237 94.7668 45.9743 94.124 46.7598 93.6889C47.5453 93.2539 48.4353 93.0433 49.3325 93.0803C50.3 93.2907 51.1835 93.7829 51.8716 94.4948C52.5597 95.2066 53.0217 96.1063 53.1992 97.0803C53.4355 98.0942 53.4807 99.1432 53.3325 100.174C52.2525 100.28 51.1725 100.387 50.0925 100.467C49.2634 100.539 48.4306 100.557 47.5992 100.52Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M44.1739 87.7854C43.6806 85.8921 43.3339 83.7854 44.4273 82.1588C47.0939 78.2788 52.4273 80.3588 53.8406 84.0388C54.3361 85.1961 54.6163 86.4342 54.6673 87.6921C54.6673 88.1988 54.6673 88.6254 54.5873 89.0254C52.9835 89.3978 51.3401 89.5724 49.6939 89.5454C47.8185 89.4979 45.9759 89.0429 44.2939 88.2121L44.1739 87.7854Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M46.6668 24.7879C47.0592 25.8587 47.2205 27.0004 47.14 28.1379C47.0596 29.2754 46.7393 30.3831 46.2002 31.3879C45.3355 33.0139 44.0686 34.391 42.5202 35.3879C42.7717 33.6004 42.626 31.7794 42.0935 30.0546C41.3335 27.7346 39.8402 25.5079 40.0002 23.0813C40.7485 22.6653 41.5846 22.4323 42.4402 22.4013C43.3089 22.2807 44.1932 22.449 44.9569 22.8802C45.7206 23.3115 46.3214 23.9818 46.6668 24.7879Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.2805 108.586C40.5072 109.146 33.6672 109.186 26.8938 109.693C19.1872 110.266 11.4805 110.839 3.76049 111.106H1.17383",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M4.12109 51.4136L5.77443 51.4936C18.6544 52.1069 32.7744 51.2669 39.2011 43.1469C40.9754 40.9063 42.1172 38.2314 42.5078 35.4002C42.7593 33.6127 42.6136 31.7917 42.0811 30.0669C41.3344 27.7336 39.8411 25.5069 40.0011 23.0802C40.0011 22.9336 40.0011 22.7869 40.0011 22.6269C40.3037 21.4388 40.928 20.3572 41.8054 19.501C42.6828 18.6447 43.7793 18.047 44.9744 17.7736C50.3078 16.2669 55.9478 19.5336 58.4411 24.6136C60.9344 29.6936 60.4944 36.1602 58.1744 41.5069C55.8544 46.8536 53.7878 50.8402 48.8411 54.1736C53.8052 53.8405 58.7465 53.2262 63.6411 52.3336C73.5344 50.7202 83.5078 49.6669 93.5078 49.0936C98.4649 48.6724 103.44 48.5033 108.414 48.5869C113.308 48.7736 118.574 47.8536 122.668 51.2536C123.38 51.7722 123.983 52.427 124.44 53.1799C124.898 53.9329 125.202 54.7691 125.334 55.6402C125.346 56.8536 125.03 58.0476 124.42 59.0965C123.81 60.1454 122.928 61.0104 121.868 61.6002C119.739 62.7527 117.415 63.503 115.014 63.8136C100.214 66.6136 85.1744 65.1469 70.4544 67.8136C76.0678 67.5602 88.6544 67.2402 86.1211 75.8802C85.5772 77.6512 84.5689 79.2441 83.2011 80.4936C81.7121 81.8654 79.9552 82.914 78.0411 83.5736C74.5078 84.8136 70.7611 84.9069 67.1078 85.4936C62.6011 86.1869 58.7878 88.0802 54.5878 89.0002C52.984 89.3726 51.3406 89.5472 49.6944 89.5202C47.819 89.4727 45.9764 89.0177 44.2944 88.1869L43.9078 88.0002C42.9409 87.5426 42.115 86.8331 41.5168 85.9464C40.9186 85.0596 40.57 84.0281 40.5078 82.9602C40.3878 72.3602 55.3078 70.6669 62.6678 73.4402",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M40 23.0813C40.7483 22.6653 41.5844 22.4323 42.44 22.4013C43.3087 22.2807 44.193 22.449 44.9567 22.8802C45.7204 23.3115 46.3212 23.9818 46.6667 24.7879C47.059 25.8587 47.2203 27.0004 47.1399 28.1379C47.0594 29.2754 46.7391 30.3831 46.2 31.3879C45.3354 33.0139 44.0684 34.391 42.52 35.3879",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M43.9074 87.9987C42.5274 89.1753 41.6145 90.8071 41.334 92.5987C41.1768 93.7962 41.3172 95.014 41.7427 96.1442C42.1683 97.2745 42.866 98.2824 43.774 99.0787C44.364 99.5854 45.0482 99.9705 45.7874 100.212C46.3651 100.381 46.9599 100.484 47.5607 100.519C48.3821 100.572 49.206 100.572 50.0274 100.519C51.1074 100.439 52.1874 100.332 53.2674 100.225C58.3359 99.7137 63.3589 98.8223 68.294 97.5587C72.294 96.5187 76.4674 95.1187 79.5874 92.2254L80.0007 91.8254C82.774 88.9854 84.3207 84.4121 83.1607 80.7188",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.6011 100.52C46.576 102.23 46.1535 104.235 46.4011 106.213C46.5066 107.062 46.8079 107.874 47.2811 108.587C47.8229 109.379 48.5549 110.022 49.4098 110.457C50.2647 110.893 51.2153 111.107 52.1744 111.08C52.6915 111.073 53.2061 111.006 53.7077 110.88C55.0411 110.507 56.5211 110.107 57.9211 109.707C60.9077 108.853 63.8944 107.96 66.8811 107.187C70.7877 106.173 73.8677 105.427 77.2677 102.907C79.1301 101.738 80.497 99.9252 81.1077 97.8133C81.3759 95.7576 80.8463 93.6772 79.6277 92",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M44.2939 88.2121L44.1739 87.7854C43.6806 85.8921 43.3339 83.7854 44.4273 82.1588C47.0939 78.2788 52.4273 80.3588 53.8406 84.0388C54.3361 85.1961 54.6163 86.4342 54.6673 87.6921C54.6673 88.1988 54.6673 88.6254 54.5873 89.0254",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M43.8125 99.0803C43.8739 97.8331 44.2402 96.6199 44.8792 95.547C45.3237 94.7668 45.9743 94.124 46.7598 93.6889C47.5453 93.2539 48.4353 93.0433 49.3325 93.0803C50.3 93.2907 51.1835 93.7829 51.8716 94.4948C52.5597 95.2066 53.0217 96.1063 53.1992 97.0803C53.4355 98.0942 53.4807 99.1432 53.3325 100.174",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M52.1728 111.08C51.7602 110.126 51.4734 109.122 51.3195 108.093C50.8395 105.053 54.2128 101.28 56.6528 104.28C57.1508 105.024 57.4534 105.882 57.5328 106.773C57.7062 107.747 57.8528 108.72 57.9728 109.707",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
/* harmony default export */ const hint_icon = (hint_icon_Icon);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/assets/instruction-icon.tsx



const instruction_icon_Icon = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
  fill: "none",
  ...props,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3608 113C34.6086 115.462 38.0975 117.588 41.7742 119.347C67.8808 131.853 102.161 122.213 115.401 96.0265C128.641 69.8398 124.334 38.8798 100.361 20.0265C71.7875 -2.34683 28.7075 8.17317 13.0142 40.9998C0.774159 66.6665 9.65416 96.5732 31.3608 113Z",
    fill: "currentColor"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M11.8535 7.99992L13.7735 4.91992C13.9068 6.89326 13.9468 8.91992 13.8935 10.8666",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M11.507 71.6802C11.8937 70.7869 13.787 69.8669 14.0404 71.3069C14.187 72.1869 12.9337 73.4002 12.2404 73.7469C13.947 72.8536 15.4937 75.5736 13.9337 76.6269C13.0537 77.2269 11.1737 77.0136 11.267 75.6536",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M108.067 25.1465L104 26.1865C105.333 25.8131 106.667 25.4665 108.067 25.1465Z",
    fill: "#FFCB48"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M92.8261 90.268C91.8306 91.5538 90.5886 92.6281 89.1728 93.428C86.413 94.7512 83.5447 95.8352 80.5995 96.668C77.0528 97.9213 74.2795 99.9613 71.0261 101.348C71.0261 101.028 70.9328 100.695 70.8528 100.321C70.5833 99.3552 70.1307 98.4499 69.5195 97.6546C67.7061 95.1213 62.9595 94.4546 61.5195 97.788C61.3226 98.5135 61.2923 99.2741 61.4308 100.013C61.5694 100.752 61.8732 101.45 62.3195 102.055C62.2128 102.188 62.1061 102.308 61.9995 102.455C61.46 102.375 60.9425 102.186 60.4788 101.9C60.015 101.613 59.6147 101.234 59.3025 100.787C58.9903 100.34 58.7729 99.8343 58.6634 99.3001C58.554 98.766 58.5549 98.2151 58.6661 97.6813C58.7897 96.7488 59.1577 95.8656 59.7328 95.1213C60.1362 95.2066 60.5472 95.2513 60.9595 95.2546C63.2344 95.1888 65.4697 94.6436 67.5195 93.6546L68.9195 93.0413C72.4528 91.5346 76.1061 90.3746 79.5861 88.6813C83.7061 86.7746 88.3595 85.0813 90.7328 80.8946L90.8528 80.668C91.9429 81.1393 92.8616 81.9346 93.4841 82.946C94.1067 83.9573 94.403 85.1358 94.3328 86.3213C94.2165 87.7535 93.6938 89.1227 92.8261 90.268Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M72.0002 109.907C76.0107 108.664 79.9273 107.135 83.7202 105.334C86.9253 104.104 89.7717 102.092 92.0002 99.4805C92.6232 99.9801 93.1417 100.598 93.526 101.298C93.9104 101.998 94.1531 102.767 94.2402 103.56C94.0941 105.274 93.2916 106.865 92.0002 108C89.7965 110.143 87.1786 111.812 84.3068 112.907C82.0135 113.974 79.7335 115.147 77.4535 116.267C77.1735 115.56 76.8802 114.84 76.5735 114.147C76.3392 113.481 75.9402 112.884 75.4135 112.414C72.9335 110.56 70.8535 113.947 71.7868 116.147C72.098 116.902 72.5107 117.611 73.0135 118.254C72.2373 118.43 71.4306 118.423 70.6576 118.234C69.8845 118.044 69.1664 117.676 68.5602 117.16C68.0626 116.72 67.6785 116.167 67.4402 115.547C66.9002 114.107 66.9002 112.52 67.4402 111.08C68.0787 110.979 68.7109 110.841 69.3335 110.667C70.2402 110.414 71.1068 110.174 72.0002 109.907Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M91.9992 99.4796C89.7708 102.091 86.9244 104.103 83.7192 105.333C79.9264 107.134 76.0097 108.663 71.9992 109.906C71.9344 109.114 71.7218 108.341 71.3726 107.626C71.0252 106.896 70.4741 106.283 69.7856 105.859C69.097 105.436 68.3007 105.22 67.4926 105.24C66.7749 105.34 66.0981 105.634 65.5344 106.09C64.9708 106.546 64.5416 107.146 64.2926 107.826C63.9456 108.73 63.8443 109.71 63.9992 110.666C63.139 110.248 62.3984 109.619 61.846 108.839C61.2935 108.058 60.9473 107.15 60.8392 106.2C60.7554 104.88 61.1481 103.574 61.9459 102.52L62.6659 102.666C64.1627 102.889 65.6863 102.857 67.1726 102.573C68.5165 102.324 69.8274 101.922 71.0792 101.373C74.3326 100.04 77.1059 97.9463 80.6526 96.693C83.5978 95.8602 86.4661 94.7762 89.2259 93.453C90.6417 92.6531 91.8837 91.5788 92.8792 90.293C93.6051 91.6806 93.9333 93.2418 93.8274 94.8042C93.7215 96.3666 93.1857 97.8693 92.2792 99.1463L91.9992 99.4796Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M64.0006 110.666C64.5767 110.949 65.2009 111.121 65.8406 111.173C66.337 111.226 66.8376 111.226 67.334 111.173C66.794 112.613 66.794 114.2 67.334 115.64C67.5723 116.26 67.9565 116.813 68.454 117.253C53.4985 120.76 38.3141 123.206 23.014 124.573C21.094 120.386 18.8807 116.333 17.334 112C16.2846 109.05 15.3944 106.045 14.6673 103C12.8273 96.422 11.0495 89.822 9.33398 83.1998C20.654 81.4931 44.494 80.4531 50.3473 69.4264C51.3879 67.4765 51.8505 65.2701 51.6806 63.0664C52.7486 62.0809 53.5354 60.8293 53.9607 59.4398C54.2182 58.597 54.2812 57.7067 54.145 56.836C54.0087 55.9653 53.6767 55.1369 53.174 54.4131C52.7149 53.8702 52.1038 53.4772 51.4195 53.2848C50.7351 53.0923 50.0087 53.1091 49.334 53.3331C48.6488 53.4909 48.0098 53.8058 47.4673 54.2531C47.4612 54.1376 47.4612 54.0219 47.4673 53.9064C47.5188 52.9378 47.8444 52.0037 48.4062 51.2129C48.968 50.4221 49.7429 49.8072 50.6406 49.4398C54.6406 47.4398 59.974 48.9464 62.8406 52.3598C64.2387 54.1303 65.2169 56.1949 65.7019 58.3981C66.1869 60.6013 66.166 62.8858 65.6406 65.0798C64.7573 68.574 63.4779 71.9559 61.8273 75.1598C63.8673 74.7731 65.9073 74.1198 67.9206 73.6131C69.934 73.1064 72.174 72.6664 74.2806 72.1331C77.7789 71.0187 81.4611 70.5975 85.1206 70.8931C90.454 71.6398 93.774 75.5064 90.9873 80.6931L90.8673 80.9198C88.494 85.1064 83.8406 86.7998 79.7206 88.7064C76.214 90.3464 72.5606 91.5598 69.054 93.0664C68.7198 92.1121 68.4918 91.124 68.374 90.1198C68.082 89.0714 67.4717 88.1396 66.6273 87.4531C66.1774 87.1106 65.656 86.874 65.102 86.7608C64.5479 86.6477 63.9755 86.661 63.4273 86.7998C62.722 86.9706 62.0833 87.3468 61.592 87.8809C61.1007 88.4149 60.7789 89.0827 60.6673 89.7998C60.4911 91.2752 60.5496 92.7693 60.8406 94.2264C60.4743 94.5061 60.147 94.8334 59.8673 95.1998C59.2922 95.9441 58.9242 96.8273 58.8006 97.7598C58.6811 98.2954 58.673 98.8498 58.7769 99.3887C58.8808 99.9275 59.0945 100.439 59.4047 100.892C59.7148 101.345 60.1148 101.729 60.5798 102.02C61.0447 102.312 61.5647 102.504 62.1073 102.586C61.3096 103.641 60.9169 104.947 61.0006 106.266C61.103 107.189 61.43 108.073 61.953 108.84C62.476 109.607 63.1791 110.234 64.0006 110.666Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M76.5456 114.174C76.8522 114.868 77.1456 115.588 77.4256 116.294C76.3456 116.841 75.2789 117.361 74.1989 117.868C73.8114 118.051 73.4043 118.189 72.9856 118.281C72.4828 117.638 72.0701 116.929 71.7589 116.174C70.8256 113.974 72.9056 110.588 75.3856 112.441C75.9123 112.912 76.3113 113.508 76.5456 114.174Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M67.3737 111.106C66.8773 111.16 66.3767 111.16 65.8804 111.106C65.2314 111.081 64.5934 110.931 64.0004 110.666C63.8266 109.721 63.9048 108.746 64.227 107.84C64.4761 107.159 64.9053 106.559 65.4689 106.103C66.0325 105.648 66.7094 105.354 67.427 105.253C68.2351 105.234 69.0315 105.449 69.72 105.873C70.4085 106.296 70.9597 106.91 71.307 107.64C71.6778 108.345 71.913 109.114 72.0004 109.906C71.1337 110.173 70.267 110.413 69.4004 110.653C68.7349 110.846 68.058 110.998 67.3737 111.106Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M62.3061 102.106C61.8598 101.501 61.556 100.803 61.4174 100.065C61.2789 99.3256 61.3092 98.565 61.5061 97.8395C62.9594 94.5062 67.7061 95.1729 69.5061 97.7062C70.1173 98.5015 70.5699 99.4068 70.8394 100.373C70.9194 100.746 70.9594 101.08 71.0127 101.4C69.7609 101.948 68.4501 102.351 67.1061 102.6C65.64 102.868 64.1396 102.89 62.6661 102.666L62.3061 102.106Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M60.7199 94.1457C60.4289 92.6885 60.3704 91.1945 60.5466 89.719C60.6483 88.9924 60.9657 88.3129 61.4577 87.7686C61.9498 87.2242 62.5938 86.8401 63.3066 86.6657C63.8548 86.527 64.4272 86.5137 64.9812 86.6268C65.5352 86.7399 66.0566 86.9765 66.5066 87.319C67.3509 88.0055 67.9613 88.9374 68.2532 89.9857C68.3711 90.9899 68.5991 91.9781 68.9332 92.9324L67.5332 93.5457C65.4835 94.5346 63.2481 95.0799 60.9732 95.1457C60.8799 94.8924 60.7866 94.519 60.7199 94.1457Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M62.3057 102.105L62.6657 102.665L62.0391 102.532C62.0924 102.359 62.1991 102.239 62.3057 102.105Z",
    fill: "#FFCB48"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M60.7194 94.1465C60.7861 94.5198 60.8794 94.8932 60.9728 95.2532C60.5604 95.2498 60.1495 95.2051 59.7461 95.1198C60.0257 94.7535 60.3531 94.4261 60.7194 94.1465Z",
    fill: "#FFCB48"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M53.0927 54.413C53.5954 55.1368 53.9274 55.9652 54.0637 56.8359C54.1999 57.7066 54.1369 58.5968 53.8794 59.4396C53.4541 60.8292 52.6673 62.0808 51.5994 63.0663C51.4764 61.6465 51.0196 60.2759 50.266 59.0663C49.2394 57.4396 47.5994 56.0263 47.3594 54.173C47.9405 53.7392 48.6172 53.4511 49.3327 53.333C49.9964 53.1262 50.7062 53.1183 51.3743 53.3102C52.0425 53.5021 52.6399 53.8855 53.0927 54.413Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M39 21.9987L45.44 20.332C43.328 21.0139 41.1776 21.5704 39 21.9987Z",
    fill: "#FFCB48"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M43.1988 24.6934L39.1055 25.7334C40.4655 25.3334 41.8255 25.0134 43.1988 24.6934Z",
    fill: "#FFCB48"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M37 20.9746C38.3444 24.0748 39.1861 27.3695 39.4933 30.7346",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M32.9315 22.1602C32.2148 24.0675 30.851 25.6626 29.0781 26.6668",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M29.5332 28.8136C30.6173 28.6301 31.7317 28.8024 32.7099 29.3047C33.688 29.8069 34.4773 30.6123 34.9599 31.6003",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M40.546 29.5472L41.3327 29.3338C43.2019 28.7254 45.1201 28.2793 47.066 28.0005C48.266 27.8672 51.6527 27.4805 52.186 29.0405C52.2565 29.3303 52.2439 29.6342 52.1495 29.9172C52.0552 30.2002 51.883 30.4509 51.6527 30.6405C51.1908 31.0139 50.6611 31.2946 50.0927 31.4672C40.7952 34.6459 31.2993 37.2114 21.666 39.1472",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M43.1987 24.6935C45.3854 24.1958 47.6076 23.7824 49.8654 23.4535C50.7982 23.1519 51.7854 23.0564 52.7587 23.1735C52.9767 23.2717 53.1703 23.4167 53.3259 23.5982C53.4815 23.7797 53.5951 23.9932 53.6588 24.2236C53.7224 24.4541 53.7345 24.6957 53.6942 24.9313C53.6538 25.1669 53.562 25.3908 53.4254 25.5869C52.692 26.4269 50.7587 26.6269 49.7054 26.9202L41.332 29.3335",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M43.1988 24.6934L39.1055 25.7334C40.4655 25.3334 41.8255 25.0134 43.1988 24.6934Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M45.4392 20.333L47.6392 19.773C49.0443 19.2915 50.5144 19.0263 51.9992 18.9863C52.2802 18.9984 52.5511 19.0941 52.7774 19.261C53.0037 19.428 53.175 19.6586 53.2695 19.9235C53.364 20.1883 53.3773 20.4753 53.3078 20.7478C53.2383 21.0203 53.0891 21.2658 52.8792 21.453C51.7184 22.3772 50.3422 22.9919 48.8792 23.2397L43.1992 24.693",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M45.44 20.334C43.328 21.0159 41.1776 21.5724 39 22.0007L45.44 20.334Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M15.6523 21.1604C19.6523 20.4937 24.5323 20.2537 28.079 18.2271C31.0923 16.5071 33.1723 13.5071 36.3057 11.9604C36.935 11.611 37.6394 11.4189 38.359 11.4004C38.7211 11.3992 39.0772 11.492 39.3927 11.6696C39.7082 11.8472 39.9722 12.1036 40.159 12.4137C40.3078 12.744 40.3711 13.1064 40.3431 13.4675C40.3152 13.8287 40.1968 14.177 39.999 14.4804C39.5812 15.0778 39.0569 15.5931 38.4523 16.0004C36.8482 17.2114 35.134 18.2694 33.3323 19.1604C36.9857 18.1071 40.639 17.1471 44.359 16.3071C45.8578 15.883 47.4184 15.7207 48.9723 15.8271C49.8523 15.9337 50.9057 16.6671 50.4657 17.7337C50.0257 18.8004 48.2523 19.2404 47.3857 19.6137C46.7723 19.8804 46.1323 20.1204 45.4923 20.3337",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M101.867 21.4277C103.213 24.532 104.055 27.8313 104.361 31.2011",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M97.7986 22.668C97.0968 24.5975 95.7308 26.2141 93.9453 27.228",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M94.4004 29.3343C95.4714 29.1365 96.5776 29.289 97.5551 29.7694C98.5326 30.2497 99.3293 31.0322 99.8271 32.0009",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M93.4258 10.6685L93.9858 10.5885C94.2015 10.5691 94.4189 10.5933 94.6251 10.6598C94.8313 10.7262 95.022 10.8335 95.1858 10.9752C95.3412 11.1392 95.4594 11.3347 95.5324 11.5485C95.6541 11.9457 95.6751 12.3668 95.5936 12.7741C95.5122 13.1814 95.3308 13.562 95.0658 13.8819",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M103.306 8.84125L102.119 7.50792C102.679 7.16125 103.092 6.62792 103.652 6.28125",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M102.252 7.48086C105.159 7.34753 107.799 7.34753 110.132 9.3342C111.529 10.5961 112.654 12.1296 113.439 13.8409",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M105.414 30.0145L106.214 29.7745C108.083 29.1661 110.001 28.72 111.947 28.4411C113.147 28.3078 116.534 27.9211 117.067 29.4945C117.138 29.7811 117.127 30.0819 117.035 30.3625C116.943 30.643 116.774 30.8921 116.547 31.0811C116.082 31.4572 115.547 31.7381 114.974 31.9078C105.676 35.0865 96.1801 37.652 86.5469 39.5878",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M108.066 25.1486C110.253 24.6597 112.475 24.2464 114.733 23.9086C115.665 23.607 116.653 23.5115 117.626 23.6286C117.844 23.7268 118.038 23.8717 118.193 24.0532C118.349 24.2347 118.462 24.4483 118.526 24.6787C118.59 24.9091 118.602 25.1508 118.561 25.3864C118.521 25.622 118.429 25.8458 118.293 26.042C117.559 26.8953 115.626 27.082 114.573 27.3753L106.279 29.7753",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M108.067 25.1484L104 26.1884C105.333 25.8151 106.667 25.4684 108.067 25.1484Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M110.307 20.8014L112.507 20.2281C113.899 19.7506 115.355 19.4854 116.827 19.4414C117.107 19.4571 117.377 19.5554 117.602 19.724C117.827 19.8925 117.997 20.1238 118.091 20.3887C118.185 20.6537 118.199 20.9405 118.131 21.2132C118.062 21.4859 117.915 21.7323 117.707 21.9214C116.545 22.8419 115.169 23.4521 113.707 23.6947L108 25.1481",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M110.307 20.8008C108.192 21.4703 106.042 22.0266 103.867 22.4674L110.307 20.8008Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M80.5195 21.6142C84.9329 20.8809 92.1195 21.1476 94.5462 16.5609C94.9036 15.9235 95.0913 15.205 95.0913 14.4742C95.0913 13.7435 94.9036 13.025 94.5462 12.3876C94.1062 11.6809 93.3862 11.0542 93.3595 10.2542C93.3869 9.85827 93.5269 9.47838 93.7632 9.15943C93.9995 8.84048 94.322 8.59579 94.6929 8.45425C95.5345 8.0954 96.469 8.01571 97.3593 8.22688C98.2495 8.43805 99.0487 8.92895 99.6395 9.62758C100.204 10.347 100.6 11.1846 100.796 12.0781C100.992 12.9715 100.984 13.8976 100.773 14.7876C100.307 16.5691 99.3887 18.1997 98.1062 19.5209C98.8971 19.1903 99.7255 18.9575 100.573 18.8276C101.386 18.6142 102.253 18.4676 103.08 18.2542C105.093 17.7209 107.08 17.2276 109.146 16.7609C110.646 16.344 112.206 16.1818 113.76 16.2809C114.64 16.3876 115.693 17.1209 115.253 18.1876C114.813 19.2542 113.04 19.7076 112.173 20.0809C111.56 20.3476 110.92 20.5876 110.28 20.8009",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M78.3199 6.86747C78.3199 5.97414 78.4666 4.93414 79.4932 4.72081C79.8088 4.65342 80.1381 4.70276 80.4201 4.85968C80.702 5.0166 80.9175 5.27044 81.0266 5.57414C81.0703 6.146 80.9905 6.72057 80.7927 7.25889C80.5948 7.79721 80.2835 8.28669 79.8799 8.69414L78.2266 10.7741H80.8932",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M102.039 68.6934C105.317 69.4316 108.464 70.6634 111.372 72.3467C114.299 74.0503 116.596 76.6558 117.919 79.7734C118.669 81.979 118.905 84.3268 118.609 86.6376C118.313 88.9484 117.494 91.161 116.212 93.1067C113.617 96.9745 110.067 100.107 105.906 102.2",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M106.666 99.1738L105.586 102.56C107.005 102.48 108.428 102.601 109.813 102.92",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M68.532 117.186C53.5766 120.692 38.3921 123.138 23.092 124.506C21.6787 124.612 20.4254 124.666 19.332 124.692",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M61.7325 75.1337C63.7725 74.747 65.8125 74.0937 67.8259 73.587C69.8392 73.0804 72.0792 72.6404 74.1859 72.107C77.6842 70.9926 81.3663 70.5714 85.0259 70.867C90.3592 71.6137 93.6792 75.4804 90.8925 80.667L90.7725 80.8937C88.3992 85.0804 83.7459 86.7737 79.6259 88.6804C76.1192 90.3204 72.4659 91.5337 68.9592 93.0404L67.5592 93.6537C65.5095 94.6426 63.2741 95.1878 60.9992 95.2537C60.5869 95.2503 60.176 95.2057 59.7725 95.1204C58.9553 94.993 58.202 94.6025 57.6269 94.0081C57.0518 93.4137 56.6863 92.648 56.5859 91.827C55.5859 86.307 59.4792 81.7604 64.0125 79.187C67.2714 77.4881 70.776 76.3094 74.3992 75.6937",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M8.35938 83.3464L9.33271 83.1997C20.6527 81.493 44.4927 80.453 50.346 69.4264C51.3866 67.4764 51.8492 65.27 51.6794 63.0664C51.5564 61.6466 51.0996 60.276 50.346 59.0664C49.3194 57.4397 47.6794 56.0264 47.4394 54.173C47.4333 54.0575 47.4333 53.9418 47.4394 53.8264C47.4909 52.8577 47.8165 51.9236 48.3783 51.1328C48.9401 50.342 49.715 49.7271 50.6127 49.3597C54.6127 47.3597 59.946 48.8664 62.8127 52.2797C64.2107 54.0503 65.189 56.1148 65.674 58.318C66.159 60.5212 66.138 62.8057 65.6127 64.9997C64.7294 68.4939 63.45 71.8758 61.7994 75.0797C61.5194 75.653 61.2394 76.1864 60.9594 76.6664",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.3984 54.2256C47.9628 53.7785 48.6255 53.4723 49.3318 53.3323C50.0073 53.1142 50.7325 53.1031 51.4144 53.3003C52.0962 53.4975 52.7036 53.894 53.1584 54.439C53.6612 55.1628 53.9932 55.9912 54.1294 56.8619C54.2657 57.7326 54.2027 58.6228 53.9451 59.4656C53.4968 60.8529 52.6868 62.0956 51.5984 63.0656",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M90.8929 80.666C91.983 81.1373 92.9017 81.9327 93.5242 82.944C94.1468 83.9554 94.4431 85.1338 94.3729 86.3193C94.255 87.7742 93.7178 89.1636 92.8263 90.3193C91.8307 91.6051 90.5887 92.6794 89.1729 93.4794C86.4131 94.8026 83.5448 95.8866 80.5996 96.7194C77.0529 97.9727 74.2796 100.013 71.0263 101.399C69.7744 101.948 68.4636 102.351 67.1196 102.599C65.6492 102.869 64.1441 102.891 62.6663 102.666L62.0396 102.533C61.4882 102.459 60.9582 102.272 60.4834 101.982C60.0085 101.693 59.5993 101.307 59.2819 100.85C58.9644 100.394 58.7457 99.8758 58.6397 99.3298C58.5337 98.7838 58.5428 98.2217 58.6663 97.6794C58.7898 96.7469 59.1578 95.8637 59.7329 95.1193",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M61.9869 102.506C61.1892 103.56 60.7965 104.866 60.8802 106.186C60.9821 107.134 61.3214 108.042 61.8667 108.825C62.412 109.608 63.1458 110.241 64.0002 110.666C64.5763 110.949 65.2005 111.121 65.8402 111.172C66.3366 111.226 66.8372 111.226 67.3336 111.172C68.01 111.045 68.678 110.876 69.3336 110.666C70.2002 110.426 71.0669 110.186 71.9336 109.919C75.9671 108.674 79.9061 107.141 83.7202 105.332C86.9254 104.103 89.7718 102.09 92.0002 99.479L92.2669 99.119C93.1734 97.842 93.7092 96.3393 93.815 94.7769C93.9209 93.2145 93.5928 91.6532 92.8669 90.2656",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M67.3718 111.107C66.8318 112.547 66.8318 114.134 67.3718 115.574C67.6101 116.194 67.9943 116.747 68.4918 117.187C69.098 117.703 69.8162 118.07 70.5892 118.26C71.3623 118.45 72.1689 118.457 72.9451 118.28C73.3639 118.189 73.771 118.05 74.1585 117.867C75.2385 117.36 76.3052 116.84 77.3852 116.294C79.6652 115.174 81.9452 114 84.2385 112.934C87.1362 111.839 89.7777 110.16 91.9985 108C93.2911 106.856 94.0893 105.255 94.2252 103.534C94.0458 101.942 93.2456 100.486 91.9985 99.4805",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M68.9332 93.0398C68.5991 92.0855 68.3711 91.0973 68.2532 90.0931C67.9613 89.0448 67.3509 88.113 66.5066 87.4265C66.0566 87.0839 65.5352 86.8473 64.9812 86.7342C64.4272 86.6211 63.8548 86.6344 63.3066 86.7731C62.6013 86.9439 61.9626 87.3202 61.4712 87.8542C60.9799 88.3883 60.6581 89.0561 60.5466 89.7731C60.3704 91.2486 60.4289 92.7426 60.7199 94.1998C60.7866 94.5731 60.8799 94.9465 60.9732 95.3065",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M62.6655 102.667L62.3588 102.134C61.9125 101.529 61.6087 100.831 61.4702 100.092C61.3316 99.353 61.3619 98.5924 61.5588 97.8669C63.0121 94.5336 67.7588 95.2002 69.5588 97.7336C70.17 98.5288 70.6227 99.4341 70.8921 100.4C70.9721 100.774 71.0121 101.107 71.0655 101.427",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M64.0004 110.666C63.8266 109.721 63.9048 108.746 64.227 107.84C64.4761 107.159 64.9053 106.559 65.4689 106.103C66.0325 105.648 66.7094 105.354 67.427 105.253C68.2351 105.234 69.0315 105.449 69.72 105.873C70.4085 106.296 70.9597 106.91 71.307 107.64C71.6778 108.345 71.913 109.114 72.0004 109.906",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M72.9856 118.279C72.4828 117.636 72.0701 116.927 71.7589 116.172C70.8256 113.972 72.9056 110.586 75.3856 112.439C75.9123 112.91 76.3113 113.506 76.5456 114.172C76.8522 114.866 77.1456 115.586 77.4256 116.292",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
/* harmony default export */ const instruction_icon = (instruction_icon_Icon);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/assets/level-up-icon.tsx



const level_up_icon_Icon = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
  fill: "none",
  ...props,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3608 113C34.6086 115.462 38.0975 117.588 41.7742 119.347C67.8808 131.853 102.161 122.213 115.401 96.0265C128.641 69.8398 124.334 38.8798 100.361 20.0265C71.7875 -2.34683 28.7075 8.17317 13.0142 40.9998C0.77416 66.6665 9.65416 96.5732 31.3608 113Z",
    fill: "currentColor"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M23.546 38.6655C20.8793 38.0389 21.2527 42.5455 21.5727 44.6522C22.337 48.9889 23.3746 53.273 24.6793 57.4789C26.4927 63.6922 28.6793 69.8922 30.0127 76.2255C29.0328 78.2178 28.8238 80.5019 29.426 82.6389C29.7483 84.2743 30.4116 85.8235 31.3727 87.1855C31.3727 87.6655 31.3727 88.1455 31.3727 88.6255C31.2973 91.1533 30.848 93.656 30.0393 96.0522C29.2168 98.6773 27.5653 100.965 25.3327 102.572C20.9593 105.412 15.066 105.092 11.666 101.332C14.586 100.532 17.4127 99.0389 18.6927 96.3455C19.1684 95.14 19.3992 93.8518 19.3718 92.5561C19.3443 91.2604 19.059 89.9831 18.5327 88.7989C18.0946 87.4455 17.2523 86.259 16.1193 85.3989C15.1262 84.8092 14.0155 84.445 12.866 84.3322C11.6697 84.0854 10.4356 84.0854 9.23932 84.3322C9.59932 72.9589 8.09266 62.6655 2.97266 52.1722C3.1102 38.5564 4.44872 24.9793 6.97266 11.5989C7.2858 9.32996 7.91875 7.11687 8.85266 5.02552C9.54608 3.63419 10.5552 2.42422 11.7993 1.49219C15.7993 3.90552 19.6793 6.73219 23.6793 8.99885C28.0793 11.5055 33.386 12.9989 37.9727 15.2922C38.8946 15.7184 39.7856 16.2085 40.6393 16.7589C46.5593 20.7589 50.7993 24.3055 58.1327 25.8255C65.2393 27.2922 71.906 21.1322 77.866 17.9722C80.4312 16.4552 83.3086 15.5432 86.2793 15.3055C94.4127 14.9989 95.946 23.0655 98.386 29.1989C100.146 33.5989 101.866 38.0255 103.906 42.3055C102.534 44.8878 102.096 47.8643 102.666 50.7322C102.93 52.3342 103.769 53.7849 105.026 54.8122C105.92 55.3961 106.942 55.7566 108.005 55.8634C109.067 55.9701 110.14 55.8199 111.133 55.4255C111.315 55.3728 111.494 55.306 111.666 55.2255C111.68 55.3897 111.68 55.5547 111.666 55.7189C111.763 59.0998 110.72 62.4152 108.706 65.1322C104.466 70.4655 97.9193 69.5189 92.506 66.5855C88.3193 64.3055 85.346 59.5455 83.5193 55.1722C82.4466 52.5525 81.7898 49.7813 81.5727 46.9589C81.4793 45.7989 80.826 40.1722 81.8127 39.4389C77.4418 42.9544 72.7449 46.044 67.786 48.6655C66.1786 49.4511 64.5165 50.1195 62.8127 50.6655C57.2826 52.5268 51.3608 52.9038 45.6393 51.7589C44.3926 51.4759 43.1708 51.0925 41.986 50.6122C38.2161 48.8729 34.6996 46.6302 31.5327 43.9455C29.3974 42.2445 27.172 40.66 24.866 39.1989C24.4538 38.9589 24.0092 38.7793 23.546 38.6655V38.6655Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M51.0406 94.5467C51.9314 89.3519 53.6797 84.3414 56.214 79.72C56.8126 78.7003 57.2193 77.5796 57.414 76.4134C57.6406 74.04 56.0806 71.92 54.5873 70.0267C50.454 64.5734 46.8673 58.4 45.6406 51.7334C51.3598 52.8868 57.2815 52.519 62.814 50.6667C64.517 50.1294 66.1791 49.4699 67.7873 48.6934C69.014 52.763 70.6677 56.6915 72.7206 60.4134C75.3873 65.12 78.694 70.0667 77.8273 75.3734C77.3951 77.3273 76.7046 79.2151 75.774 80.9867C73.7092 85.2991 72.0358 89.7883 70.774 94.4C70.3393 94.6947 69.9526 95.0544 69.6273 95.4667C67.374 98.2534 66.1073 103 67.7073 106.413C67.8527 106.726 68.0462 107.014 68.2806 107.267C67.8449 107.978 67.3005 108.617 66.6673 109.16C62.6673 112.733 55.6273 113.093 52.934 107.747C51.366 104.508 50.6326 100.928 50.8006 97.3334C50.8006 96.72 50.8006 96.12 50.9206 95.52C50.9606 95.16 50.9873 94.8534 51.0406 94.5467Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M69.6268 95.4671C69.9521 95.0548 70.3388 94.695 70.7735 94.4004C70.1429 96.8778 69.7456 99.4089 69.5868 101.96C69.6104 103.823 69.1511 105.661 68.2535 107.294C68.019 107.041 67.8256 106.753 67.6801 106.44C66.1068 103 67.3735 98.2537 69.6268 95.4671Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M35.0932 89.1067C35.2485 88.2737 35.4806 87.4569 35.7865 86.6667C36.7222 84.3815 38.0387 82.2716 39.6799 80.4267C42.3465 77.2933 45.4932 74.5333 47.7732 71.0933C48.1994 70.5486 48.4711 69.8992 48.5599 69.2133C48.5275 68.4482 48.2879 67.7062 47.8665 67.0667C47.8665 65.04 44.2799 60.0133 43.1065 58.2933C41.4548 55.9641 39.5938 53.7906 37.5465 51.8C35.605 49.9587 33.8866 47.8957 32.4265 45.6533C32.0987 45.119 31.8005 44.5671 31.5332 44C34.7002 46.6847 38.2167 48.9274 41.9865 50.6667C43.1713 51.1469 44.3931 51.5304 45.6399 51.8133C46.8665 58.48 50.4532 64.6533 54.5865 70.1067C56.0399 72 57.6399 74.1067 57.4132 76.4933C57.2185 77.6596 56.8118 78.7803 56.2132 79.8C53.6789 84.4213 51.9306 89.4319 51.0399 94.6267C49.7227 94.6411 48.42 94.9035 47.1999 95.4C44.8349 96.3759 42.8995 98.1694 41.7465 100.453C41.418 100.473 41.0885 100.473 40.7599 100.453C39.762 100.47 38.7836 100.177 37.9599 99.6133C37.2423 98.9844 36.6847 98.1937 36.3332 97.3067C35.0587 94.7746 34.6244 91.9023 35.0932 89.1067V89.1067Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M51.0394 94.5469C51.0394 94.8535 50.9594 95.1602 50.9194 95.4669C50.9194 96.0669 50.8128 96.6669 50.7994 97.2802C47.8128 98.6135 44.9061 100.187 41.7461 100.374C42.899 98.0896 44.8344 96.2961 47.1994 95.3202C48.4195 94.8237 49.7222 94.5613 51.0394 94.5469Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.8669 67.0546C48.2882 67.6942 48.5278 68.4361 48.5602 69.2013C48.4715 69.8872 48.1997 70.5366 47.7735 71.0813C45.4935 74.4946 42.3602 77.2546 39.6802 80.4146C38.0377 82.2636 36.7212 84.3781 35.7869 86.668C34.5279 86.7553 33.3245 87.22 32.3335 88.0013C31.9868 87.728 31.6735 87.4147 31.4002 87.068C31.3561 83.8814 31.0034 80.7065 30.3469 77.588C30.2535 77.0946 30.1469 76.6013 30.0402 76.108C30.3553 75.4506 30.7116 74.8138 31.1069 74.2013C32.2254 72.4749 33.6908 71.0001 35.4101 69.8708C37.1294 68.7414 39.0649 67.9822 41.0935 67.6413C42.5869 67.4013 44.6402 66.828 44.4535 65.3213C44.3602 64.5346 43.6402 63.988 43.0002 63.5346C34.4402 57.3346 31.8135 45.068 23.5469 38.668C24.0184 38.8014 24.4677 39.0035 24.8802 39.268C27.1862 40.7291 29.4117 42.3136 31.5469 44.0146C31.8128 44.5953 32.1111 45.1606 32.4402 45.708C33.9002 47.9503 35.6187 50.0133 37.5602 51.8546C39.6074 53.8452 41.4685 56.0187 43.1202 58.348C44.2802 60.0013 47.8669 65.028 47.8669 67.0546Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M35.7873 86.668C35.479 87.4711 35.2469 88.3014 35.094 89.148C34.3832 89.0911 33.6903 88.8963 33.054 88.5746C32.804 88.4302 32.5635 88.2698 32.334 88.0946C33.3137 87.2797 34.5181 86.7821 35.7873 86.668V86.668Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3993 87.1201C30.4383 85.7581 29.775 84.2089 29.4526 82.5735C28.8504 80.4365 29.0594 78.1524 30.0393 76.1602C30.1459 76.6535 30.2526 77.1468 30.3459 77.6402C31.0024 80.7587 31.3552 83.9335 31.3993 87.1201Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M18.546 88.7986C19.066 89.9856 19.3444 91.2642 19.365 92.5599C19.3856 93.8556 19.148 95.1424 18.666 96.3453C17.3327 99.012 14.5593 100.532 11.6393 101.332C10.8413 100.443 10.2091 99.4176 9.77267 98.3053C8.43934 95.0786 8.83934 91.4786 9.05267 88.012C9.05267 86.7853 9.18601 85.5586 9.21267 84.3453C10.409 84.0984 11.6431 84.0984 12.8393 84.3453C13.9889 84.4581 15.0995 84.8223 16.0927 85.412C17.2383 86.2627 18.0947 87.4449 18.546 88.7986V88.7986Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M111.694 55.2266C111.522 55.3071 111.344 55.374 111.161 55.4266C110.169 55.8211 109.096 55.9712 108.033 55.8645C106.97 55.7578 105.949 55.3972 105.054 54.8133C103.787 53.7905 102.938 52.3392 102.668 50.7333C102.074 47.8746 102.483 44.8985 103.828 42.3066C105.061 44.9194 106.455 47.4531 108.001 49.8933C109.254 51.8533 111.401 53.0666 111.694 55.2266Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M103.853 42.3066C102.499 44.8953 102.08 47.8716 102.666 50.7333C102.93 52.3353 103.769 53.786 105.026 54.8133C105.92 55.3972 106.942 55.7578 108.005 55.8645C109.067 55.9712 110.14 55.8211 111.133 55.4266C111.315 55.374 111.494 55.3071 111.666 55.2266",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.5332 43.998C31.7992 44.5787 32.0974 45.144 32.4265 45.6914C33.8866 47.9337 35.605 49.9968 37.5465 51.838C39.5938 53.8286 41.4548 56.0021 43.1065 58.3314C44.2799 60.0514 47.8665 65.078 47.8665 67.1047C48.2879 67.7442 48.5275 68.4862 48.5599 69.2514C48.4711 69.9373 48.1994 70.5867 47.7732 71.1314C45.4932 74.5447 42.3599 77.3047 39.6799 80.4647C38.0425 82.2976 36.7262 84.3937 35.7865 86.6647C35.4783 87.4678 35.2461 88.2982 35.0932 89.1447C34.6388 91.9188 35.0728 94.7654 36.3332 97.278C36.6847 98.1651 37.2423 98.9558 37.9599 99.5847C38.7836 100.148 39.762 100.442 40.7599 100.425C41.0885 100.445 41.418 100.445 41.7465 100.425C44.9065 100.238 47.8132 98.6247 50.7999 97.3314",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M67.7873 48.666C69.014 52.7357 70.6677 56.6642 72.7206 60.386C75.3873 65.0927 78.694 70.0393 77.8273 75.346C77.3951 77.3 76.7046 79.1877 75.774 80.9593C73.7077 85.2804 72.0343 89.7785 70.774 94.3994C70.1434 96.8768 69.7461 99.4078 69.5873 101.959C69.6109 103.822 69.1516 105.66 68.254 107.293C67.824 107.993 67.2889 108.622 66.6673 109.159C62.6673 112.733 55.6273 113.093 52.934 107.746C51.366 104.507 50.6326 100.927 50.8006 97.3327C50.8006 96.7193 50.8006 96.1193 50.9206 95.5193C50.9206 95.2127 50.9873 94.906 51.0406 94.5993C51.9314 89.4045 53.6797 84.394 56.214 79.7727C56.8126 78.753 57.2193 77.6323 57.414 76.466C57.6406 74.0927 56.0806 71.9727 54.5873 70.0793C50.454 64.626 46.8673 58.4527 45.6406 51.786",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M70.7725 94.3984C70.3378 94.6931 69.9511 95.0528 69.6258 95.4651C67.3725 98.2518 66.1058 102.998 67.7058 106.412C67.8513 106.724 68.0447 107.012 68.2792 107.265",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M41.7461 100.372C42.899 98.0876 44.8344 96.2942 47.1994 95.3182C48.4195 94.8217 49.7222 94.5594 51.0394 94.5449",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M32.334 87.9994C33.325 87.218 34.5284 86.7534 35.7873 86.666",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M2.30664 50.852C2.53331 51.292 2.75997 51.732 2.97331 52.1854C8.09331 62.6654 9.59997 72.9587 9.25331 84.3454C9.25331 85.5587 9.15997 86.7854 9.09331 88.012C8.87997 91.4787 8.53331 95.0787 9.81331 98.3054C10.2497 99.4177 10.8819 100.443 11.68 101.332C15.08 105.092 21.0133 105.412 25.3466 102.572C27.5787 100.947 29.2214 98.6397 30.0266 95.9987C30.8353 93.6025 31.2846 91.0998 31.36 88.572C31.36 88.092 31.36 87.612 31.36 87.132C31.3159 83.9454 30.9631 80.7706 30.3066 77.652C30.2133 77.1587 30.1066 76.6654 30 76.172C28.6666 69.8387 26.4533 63.6387 24.6666 57.4254C23.3619 53.2195 22.3243 48.9354 21.56 44.5987C21.24 42.492 20.8266 37.932 23.5333 38.612C24.0048 38.7454 24.4541 38.9476 24.8666 39.212C27.1726 40.6732 29.3981 42.2577 31.5333 43.9587C34.7003 46.6434 38.2168 48.8861 41.9866 50.6254C43.1715 51.1056 44.3932 51.4891 45.64 51.772C51.3626 52.9126 57.2844 52.531 62.8133 50.6654C64.5164 50.128 66.1785 49.4685 67.7866 48.692C72.7687 46.0742 77.488 42.9845 81.88 39.4654C80.8933 40.1987 81.5466 45.8254 81.64 46.9854C81.8571 49.8078 82.5139 52.579 83.5866 55.1987C85.4133 59.572 88.3866 64.332 92.5733 66.612C97.9866 69.5454 104.573 70.532 108.773 65.1587C110.788 62.4417 111.83 59.1263 111.733 55.7454C111.747 55.5812 111.747 55.4162 111.733 55.252C111.44 53.092 109.293 51.8787 108.053 49.9187C106.511 47.4782 105.122 44.9444 103.893 42.332C101.853 38.052 100.133 33.6254 98.3733 29.2254C95.9333 23.092 94.3733 15.0254 86.2666 15.332C83.2959 15.5697 80.4185 16.4817 77.8533 17.9987C71.8933 21.1587 65.2266 27.332 58.12 25.852C50.7866 24.332 46.5466 20.8387 40.6266 16.7854C39.773 16.235 38.8819 15.7449 37.96 15.3187C33.3333 12.9987 28.08 11.5054 23.68 8.9987C19.68 6.73203 15.8 3.90536 11.8 1.49203L11.48 1.33203",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.4004 87.1191C31.6737 87.4659 31.987 87.7792 32.3337 88.0525C32.5632 88.2277 32.8037 88.388 33.0537 88.5325C33.6901 88.8542 34.383 89.0489 35.0937 89.1058",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M23.5469 38.666C31.8135 45.1327 34.4402 57.3327 43.0002 63.6527C43.6402 64.1193 44.3335 64.6527 44.4535 65.4393C44.6402 66.946 42.5869 67.5193 41.0935 67.7593C39.0649 68.1002 37.1294 68.8594 35.4101 69.9888C33.6908 71.1182 32.2254 72.5929 31.1069 74.3193C30.7116 74.9318 30.3553 75.5687 30.0402 76.226",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M9.25391 84.3453C10.4502 84.0984 11.6843 84.0984 12.8806 84.3453C14.0301 84.4581 15.1407 84.8223 16.1339 85.412C17.2669 86.272 18.1091 87.4586 18.5472 88.812C19.0654 89.997 19.3429 91.2733 19.3635 92.5666C19.3841 93.8598 19.1474 95.1443 18.6672 96.3453C17.3339 99.012 14.5606 100.532 11.6406 101.332",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M125.333 45.9863C124.493 53.5997 125.827 61.533 125 69.2397C124.64 72.5997 123.867 75.9063 123.467 79.2797C122.973 83.5197 123.08 87.813 122.787 92.0797C122.307 97.4561 121.505 102.799 120.387 108.08C120.273 109.096 119.936 110.075 119.4 110.946C118.067 112.92 115.187 112.973 112.733 113.186C108.16 113.586 103.8 115.2 99.4001 116.533C82.5 125.5 64.1533 125.673 46.5 125.5C47.18 122.38 48.6667 116.186 49.4534 113.093C58.5917 112.665 67.6422 111.111 76.4001 108.466C77.1734 101.346 77.7334 94.173 78.3067 87.0397C84.4934 86.1997 90.7734 85.1997 96.9734 84.373C98.0134 79.5863 98.9734 74.6263 99.6401 69.7063C105.71 68.7077 111.719 67.3723 117.64 65.7063C118.613 59.3063 119.747 53.0263 120.72 46.6263C122.267 46.4397 123.787 46.1863 125.333 45.9863Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M126.414 45.8398L125.307 45.9865C123.787 46.1865 122.267 46.4398 120.774 46.7465C119.801 53.1465 118.667 59.4265 117.694 65.8265C111.773 67.4925 105.764 68.8279 99.6941 69.8265C98.9607 74.6798 98.0007 79.6398 97.0274 84.4932C90.8407 85.3332 84.5607 86.3332 78.3607 87.1598C77.7341 94.1732 77.1741 101.333 76.4007 108.467C67.6526 111.118 58.6112 112.681 49.4807 113.12C48.6941 116.173 47.7874 119.293 47.1074 122.453C46.8407 123.653 46.6007 124.84 46.4141 126.04",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
/* harmony default export */ const level_up_icon = (level_up_icon_Icon);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/assets/tip-icon.tsx



const tip_icon_Icon = props => /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
  fill: "none",
  ...props,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M31.3608 113C34.6086 115.462 38.0975 117.588 41.7742 119.347C67.8808 131.853 102.161 122.213 115.401 96.0265C128.641 69.8398 124.334 38.8798 100.361 20.0265C71.7875 -2.34683 28.7075 8.17317 13.0142 40.9998C0.774159 66.6665 9.65416 96.5732 31.3608 113Z",
    fill: "currentColor"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M87.5332 76.7471C85.4532 76.9071 84.8666 79.5471 84.7066 81.1871C84.3403 82.9778 84.5262 84.8376 85.2399 86.5204C85.9199 87.9737 87.2132 89.2671 88.7466 87.7337C89.3669 87.0023 89.7526 86.1009 89.8532 85.1471C90.6132 85.1471 93.8532 84.4271 94.3199 85.0537C94.434 85.2541 94.5023 85.4772 94.5199 85.7071C94.7466 87.2671 95.7199 90.1204 97.8399 89.5604C99.9599 89.0004 99.9999 85.0137 99.9999 83.2671C99.9999 81.5204 99.8932 77.0271 98.3999 76.0004C98.018 75.7894 97.5807 75.7006 97.1468 75.7459C96.7129 75.7912 96.3033 75.9684 95.9732 76.2537C94.879 77.3071 94.226 78.737 94.1466 80.2537C94.1466 80.3337 90.7999 80.6671 90.5332 80.6671C89.7999 80.6404 89.6932 76.6004 87.5332 76.7471Z",
    fill: "#242424",
    stroke: "#242424",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M46.6669 63.732C47.1987 63.5174 47.7006 63.2351 48.1602 62.892C50.4535 61.1454 51.4002 57.7187 52.4402 55.1454C53.5196 52.3591 54.8588 49.6806 56.4402 47.1454C58.9612 42.9389 62.604 39.5177 66.9602 37.2654C67.7919 36.8647 68.652 36.526 69.5335 36.252C72.7489 35.2918 76.1386 35.064 79.4535 35.5854C86.4402 36.5854 93.5602 41.292 94.5735 48.2787C95.1069 52.012 93.8402 55.7854 93.0535 59.5054C91.6127 60.0958 90.3884 61.1152 89.5469 62.4254C88.626 63.714 88.0271 65.2045 87.8002 66.772C87.4269 69.8654 89.4002 73.532 93.0135 72.4654C93.3555 72.361 93.686 72.2225 94.0002 72.052C94.3202 74.7187 93.7069 77.0387 89.9069 77.1854C88.7363 77.0945 87.5591 77.1437 86.4002 77.332C85.6935 77.5187 85.0669 77.8787 84.3602 78.092C77.0535 80.2654 74.1202 67.3187 74.6669 62.452C74.8535 60.8654 74.9869 58.8254 73.5469 58.1454C68.6135 55.8254 65.9602 71.8654 65.5469 74.372C64.4535 81.612 62.1469 90.5587 65.4402 97.532C67.3202 101.465 70.3869 104.585 73.5735 100.199C75.9735 96.892 76.5469 92.5454 79.4535 89.532C82.8669 85.9854 90.7602 85.3187 94.3202 89.052C95.0006 89.8719 95.5055 90.8227 95.8036 91.8456C96.1018 92.8685 96.1868 93.9416 96.0535 94.9987C94.7306 93.7539 93.1892 92.764 91.5069 92.0787C90.3024 91.3674 88.8732 91.1388 87.5069 91.4387C86.6065 91.7487 85.7861 92.2545 85.1047 92.9197C84.4233 93.5849 83.8979 94.3929 83.5664 95.2856C83.2348 96.1782 83.1053 97.1333 83.1873 98.082C83.2692 99.0307 83.5605 99.9494 84.0402 100.772C85.6183 103.265 88.1217 105.03 91.0002 105.679C87.3602 110.879 83.2535 115.852 77.8935 119.185C69.8935 124.119 62.6002 123.092 54.5735 119.492C51.7069 118.159 49.0269 116.145 45.9469 115.492C42.5069 114.759 38.7469 115.732 35.2802 115.719C26.9335 115.719 18.5869 114.852 10.2269 114.385C9.69354 98.1054 6.94688 81.7454 6.54688 65.4787C17.2802 65.3854 31.2135 64.8787 41.4802 64.5187C43.2413 64.5535 44.9953 64.2874 46.6669 63.732Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M96.1063 95.0126C96.0787 95.4612 96.0163 95.907 95.9196 96.3459C95.1246 99.2494 93.7654 101.968 91.9196 104.346L91.0263 105.679C88.1477 105.031 85.6444 103.266 84.0663 100.773C83.5866 99.95 83.2953 99.0313 83.2133 98.0826C83.1314 97.1339 83.2609 96.1788 83.5924 95.2861C83.924 94.3935 84.4494 93.5854 85.1308 92.9203C85.8121 92.2551 86.6326 91.7493 87.5329 91.4393C88.8992 91.1393 90.3284 91.368 91.5329 92.0793C93.2258 92.7656 94.7765 93.7602 96.1063 95.0126Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M93.9324 71.9998C93.6182 72.1703 93.2876 72.3088 92.9457 72.4131C89.3324 73.4798 87.3591 69.7465 87.7324 66.7198C87.9593 65.1522 88.5582 63.6618 89.4791 62.3731C90.3206 61.063 91.5449 60.0435 92.9857 59.4531C92.299 62.0006 92.235 64.6758 92.7991 67.2531C93.2903 68.8061 93.6691 70.3924 93.9324 71.9998Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M71.426 7.17291L73.4794 6.98624C74.946 6.89291 76.4127 6.83957 77.8793 6.86624C77.9167 7.62002 78.1274 8.35503 78.4951 9.0141C78.8628 9.67317 79.3775 10.2385 79.9994 10.6662C81.1084 11.5385 82.3794 12.1821 83.7389 12.5598C85.0984 12.9374 86.5193 13.0416 87.9194 12.8662C89.3263 12.6845 90.6847 12.2317 91.9194 11.5329C93.0624 12.982 93.6841 14.7739 93.6841 16.6196C93.6841 18.4652 93.0624 20.2571 91.9194 21.7062C89.2527 24.9062 84.5327 25.3862 80.4927 26.5329C74.7727 28.1462 69.3194 31.8662 66.9327 37.1996C62.5764 39.4519 58.9336 42.8731 56.4127 47.0796C54.8313 49.6148 53.492 52.2933 52.4127 55.0796C51.3727 57.6529 50.426 61.0796 48.1327 62.8262C47.6851 63.1907 47.1921 63.4954 46.666 63.7329C47.3515 62.4448 47.8029 61.0454 47.9993 59.5996C48.1327 58.6796 48.2127 57.7596 48.266 56.8262C48.4527 53.2396 48.1327 49.6262 47.986 46.0262C47.986 45.2796 47.986 44.5329 47.986 43.7862C47.9194 36.3702 49.2773 29.0103 51.986 22.1062C53.2502 18.2692 55.4336 14.7995 58.346 11.9996C61.946 8.95957 66.666 7.69291 71.426 7.17291Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M91.9189 11.5732C90.6843 12.272 89.3259 12.7248 87.9189 12.9065C86.5162 13.0763 85.0938 12.9657 83.7342 12.5812C82.3745 12.1966 81.1049 11.5458 79.9989 10.6665C79.3736 10.2361 78.8567 9.66652 78.4888 9.00252C78.121 8.33851 77.9122 7.59821 77.8789 6.83984C81.2509 6.85605 84.5911 7.49336 87.7322 8.71984C89.103 9.24461 90.3578 10.0328 91.4256 11.0398C91.6001 11.208 91.7649 11.3861 91.9189 11.5732Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.2129 13.6401C48.099 12.5635 49.0473 11.5395 50.0529 10.5734C51.409 9.22439 52.8814 7.99743 54.4529 6.90677C54.7267 7.26153 55.0662 7.56029 55.4529 7.78677C56.2285 8.16167 57.0858 8.33588 57.9462 8.29344C59.7335 8.24538 61.4902 7.81747 63.0994 7.03815C64.7086 6.25883 66.1336 5.14594 67.2795 3.77344C67.7424 3.93523 68.1888 4.14059 68.6129 4.38677C69.7447 5.04818 70.6685 6.01358 71.2795 7.17344C66.6662 7.69344 61.9462 8.9601 58.3462 12.0001C55.3841 14.7762 53.1497 18.2377 51.8395 22.0801C49.1308 28.9841 47.7729 36.344 47.8395 43.7601C47.8395 44.5068 47.8395 45.2534 47.8395 46.0001L44.4262 40.8668C43.7729 39.8934 43.0929 38.9334 42.5329 37.9468C41.875 35.5697 41.4727 33.1292 41.3329 30.6668C40.9806 24.4392 43.0927 18.3232 47.2129 13.6401Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M67.3462 3.7729C66.2002 5.1454 64.7753 6.25829 63.1661 7.03761C61.5569 7.81693 59.8002 8.24484 58.0129 8.2929C57.1524 8.33534 56.2951 8.16113 55.5195 7.78623C55.1328 7.55975 54.7933 7.26099 54.5195 6.90623C56.7418 5.36603 59.234 4.25786 61.8662 3.63956C63.6728 3.2015 65.563 3.24749 67.3462 3.7729Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M47.906 46.026C48.0527 49.626 48.3727 53.2393 48.186 56.826C48.2272 54.9829 48.0118 53.1431 47.546 51.3593C46.7057 48.7496 45.7174 46.1899 44.586 43.6927C43.8414 41.8227 43.2004 39.9132 42.666 37.9727C43.266 38.9593 43.906 39.9193 44.5593 40.8927L47.906 46.026Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M43.4661 11.1478C44.9133 11.6334 46.2061 12.4937 47.2128 13.6412C43.0927 18.3242 40.9805 24.4403 41.3328 30.6678C41.5162 33.1351 41.9632 35.5757 42.6661 37.9478C42.1705 37.0855 41.7253 36.1951 41.3328 35.2812C39.7195 31.6812 39.3861 27.8145 38.3861 24.0678C38.6679 23.5364 38.8829 22.9721 39.0261 22.3878C39.2546 21.3916 39.2791 20.3594 39.0981 19.3534C38.917 18.3475 38.5343 17.3886 37.9728 16.5345C37.5557 15.8499 36.9425 15.3064 36.2128 14.9745C35.9678 14.8698 35.7057 14.8111 35.4395 14.8012C35.4826 13.9284 35.8211 13.0962 36.3995 12.4412C37.8128 10.7878 41.0128 10.3345 43.4661 11.1478Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M37.8664 16.6122C38.4279 17.4663 38.8107 18.4252 38.9917 19.4312C39.1728 20.4371 39.1483 21.4693 38.9198 22.4656C38.7765 23.0498 38.5616 23.6141 38.2798 24.1456C37.9921 23.0471 37.6313 21.9692 37.1998 20.9189C36.3731 18.9722 35.2264 16.8256 35.3331 14.8789C35.5993 14.8888 35.8615 14.9476 36.1064 15.0522C36.8362 15.3841 37.4494 15.9276 37.8664 16.6122Z",
    fill: "white"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M92.9857 59.4922C91.5449 60.0826 90.3206 61.1021 89.4791 62.4122C88.5582 63.7009 87.9593 65.1913 87.7324 66.7589C87.3591 69.8522 89.3324 73.5189 92.9457 72.4522C93.2876 72.3478 93.6182 72.2093 93.9324 72.0388",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M7.99979 114.252L10.3331 114.385C18.6931 114.879 27.0398 115.719 35.3865 115.719C38.8531 115.719 42.6131 114.759 46.0531 115.492C49.1331 116.132 51.8131 118.159 54.6798 119.492C62.6798 123.092 70.0531 124.119 77.9998 119.185C83.3331 115.852 87.4665 110.879 91.1065 105.679L91.9998 104.345C93.8456 101.967 95.2048 99.2488 95.9998 96.3454C96.0964 95.9064 96.1588 95.4606 96.1865 95.012C96.3197 93.955 96.2347 92.8818 95.9365 91.8589C95.6384 90.8361 95.1335 89.8853 94.4531 89.0654C90.8931 85.332 82.9998 85.9987 79.5865 89.5454C76.6798 92.5454 76.1065 96.892 73.7065 100.212C70.5198 104.599 67.4531 101.479 65.5731 97.5454C62.2798 90.572 64.5865 81.6254 65.6798 74.3854C66.0665 71.8787 68.7198 55.8387 73.6798 58.1587C75.1198 58.8387 75.0131 60.8254 74.7998 62.4654C74.2265 67.332 77.1598 80.2787 84.4665 78.1054C85.1598 77.892 85.7998 77.532 86.5064 77.3454C87.6429 77.1579 88.7975 77.1042 89.9465 77.1854C93.7465 77.0387 94.3598 74.692 94.0398 72.052C93.7765 70.4446 93.3977 68.8583 92.9065 67.3054C92.3424 64.728 92.4064 62.0528 93.0931 59.5054C93.8798 55.7854 95.1465 52.012 94.6131 48.2787C93.5998 41.292 86.4798 36.5854 79.4931 35.5854C76.1782 35.064 72.7885 35.2918 69.5731 36.252C68.6916 36.526 67.8315 36.8647 66.9998 37.2654C62.6435 39.5177 59.0007 42.9389 56.4798 47.1454C54.8984 49.6806 53.5591 52.3591 52.4798 55.1454C51.4398 57.7187 50.4931 61.1454 48.1998 62.892C47.7278 63.2381 47.2122 63.5206 46.6665 63.732C45.0034 64.2844 43.2586 64.5504 41.5065 64.5187C31.2398 64.8787 17.3065 65.3854 6.57312 65.4787H4.45312",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M77.8789 6.86719C77.9162 7.62097 78.1269 8.35597 78.4946 9.01505C78.8623 9.67412 79.3771 10.2395 79.9989 10.6672C81.1079 11.5395 82.379 12.1831 83.7385 12.5607C85.098 12.9384 86.5189 13.0425 87.9189 12.8672C89.3259 12.6855 90.6843 12.2327 91.9189 11.5339",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M54.4531 6.90677C54.7269 7.26153 55.0664 7.56029 55.4531 7.78677C56.2287 8.16167 57.086 8.33588 57.9465 8.29344C59.7338 8.24538 61.4905 7.81747 63.0997 7.03815C64.7089 6.25883 66.1338 5.14594 67.2798 3.77344",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M66.8929 37.2539C69.2795 31.9205 74.7329 28.1872 80.4529 26.5872C84.4529 25.4405 89.1462 24.9605 91.8795 21.7605C93.0226 20.3114 93.6442 18.5195 93.6442 16.6739C93.6442 14.8282 93.0226 13.0363 91.8795 11.5872C91.7255 11.4001 91.5608 11.222 91.3862 11.0539C90.3314 10.0464 89.0905 9.25388 87.7329 8.72052C84.59 7.50315 81.2499 6.87489 77.8795 6.86719C76.4129 6.86719 74.9462 6.86719 73.4795 6.98719L71.4262 7.17385C66.6662 7.69385 61.9462 8.96052 58.3462 12.0005C55.3842 14.7766 53.1498 18.2381 51.8395 22.0805C49.1308 28.9845 47.7729 36.3444 47.8395 43.7605C47.8395 44.5072 47.8395 45.2539 47.8395 46.0005C47.9862 49.6005 48.3062 53.2139 48.1195 56.8005C48.1195 57.7339 47.9862 58.6539 47.8529 59.5739C47.6564 61.0197 47.205 62.4191 46.5195 63.7072",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M71.4274 7.17206C70.8164 6.0122 69.8926 5.0468 68.7607 4.38539C68.3367 4.13921 67.8902 3.93385 67.4274 3.77206C65.6233 3.23466 63.7085 3.18863 61.8807 3.63873C59.2485 4.25702 56.7563 5.3652 54.534 6.90539C52.9626 7.99605 51.4902 9.22301 50.134 10.5721C49.1285 11.5381 48.1802 12.5621 47.294 13.6387C43.145 18.3093 41.0037 24.4268 41.334 30.6654C41.5174 33.1327 41.9644 35.5733 42.6674 37.9454C43.2236 39.8872 43.8868 41.7968 44.654 43.6654C45.7855 46.1627 46.7737 48.7224 47.614 51.3321C48.0798 53.1158 48.2952 54.9556 48.254 56.7987",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M42.6672 37.9737C42.1716 37.1114 41.7264 36.221 41.3339 35.3071C39.7205 31.7071 39.3872 27.8404 38.3872 24.0937C38.0996 22.9953 37.7388 21.9173 37.3072 20.8671C36.4805 18.9204 35.3339 16.7737 35.4405 14.8271C35.4837 13.9543 35.8222 13.1221 36.4005 12.4671C37.9205 10.7337 41.1205 10.2804 43.5739 11.1337C45.0211 11.6193 46.3138 12.4796 47.3205 13.6271",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M35.332 14.8789C35.5983 14.8888 35.8604 14.9476 36.1054 15.0522C36.8351 15.3841 37.4483 15.9276 37.8654 16.6122C38.4268 17.4663 38.8096 18.4252 38.9907 19.4312C39.1717 20.4371 39.1472 21.4693 38.9187 22.4656C38.7755 23.0498 38.5605 23.6141 38.2787 24.1456",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M96.1069 95.0129C94.784 93.7681 93.2426 92.7782 91.5603 92.0929C90.3558 91.3817 88.9266 91.153 87.5603 91.4529C86.6599 91.7629 85.8395 92.2687 85.1581 92.9339C84.4767 93.5991 83.9513 94.4071 83.6198 95.2998C83.2882 96.1925 83.1587 97.1475 83.2407 98.0962C83.3226 99.0449 83.6139 99.9637 84.0936 100.786C85.6717 103.28 88.1751 105.044 91.0536 105.693",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
    d: "M98.8125 82.4651C104.572 81.9584 110.35 81.4739 116.146 81.0117",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
/* harmony default export */ const tip_icon = (tip_icon_Icon);
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/constants.ts








const TEACHER_VOICE_ICONS = {
  challenge: challenge_icon,
  "global-english": global_english_icon,
  hint: hint_icon,
  instruction: instruction_icon,
  "level-up": level_up_icon,
  tip: tip_icon
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/teacher-voice.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const teacher_voice_module = ({"root":"teacher-voice-module__root--iWkgz","icon":"teacher-voice-module__icon--Dy_oS","content":"teacher-voice-module__content--Nv3_F","text":"teacher-voice-module__text--hB6Ia","paragraph":"teacher-voice-module__paragraph--ZmX4H","action-button":"teacher-voice-module__action-button--Fq7bh","actionButton":"teacher-voice-module__action-button--Fq7bh"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice/teacher-voice.tsx











const TeacherVoice = _ref => {
  let {
    isVisibleActionButton = false,
    texts,
    title,
    kind,
    onClickAction,
    textConstants
  } = _ref;
  const Icon = TEACHER_VOICE_ICONS[kind];
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: teacher_voice_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Icon, {
      className: teacher_voice_module.icon
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: teacher_voice_module.content,
      children: [title && /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
          id: "teacher-voice title",
          typography: "headline4Accent",
          children: title
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: teacher_voice_module.text,
        children: texts.map((text, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: teacher_voice_module.paragraph,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableText, {
            id: `teacher-voice text-${index}`,
            typography: "body1",
            children: text
          }, text)
        }, text))
      }), isVisibleActionButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        onClick: onClickAction,
        className: classnames_default()(teacher_voice_module.actionButton, typography_module/* default */.Z.captionAccent),
        appearance: "primary",
        size: "small",
        children: textConstants.buttonText
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const teacher_voice_block_module = ({"root":"teacher-voice-block-module__root--Zq7i0","content":"teacher-voice-block-module__content--cnSf0"});
;// CONCATENATED MODULE: ./src/components/trainer/blocks/teacher-voice-block/teacher-voice-block.tsx











const TeacherVoiceBlock = _ref => {
  let {
    lastBlock = false,
    onNextBlock,
    title,
    text,
    kind,
    showTutorInstructions,
    tutorInstructions,
    showNextButton = false,
    showPrevButton = false,
    onPrevBlock,
    controlsPanelButtonsPlace,
    grammarReferenceId
  } = _ref;
  const {
    inView,
    containerRefCallback: ref
  } = useLineInView({
    bottom: "-200px"
  });
  const [isVisibleGrammar, setGrammarIsVisible] = (0,react.useState)(false);
  const intl = (0,useIntl/* default */.Z)();
  const isVisibleControlsPanel = (0,react.useMemo)(() => inView && lastBlock, [inView, lastBlock]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: teacher_voice_block_module.root,
    ref,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: teacher_voice_block_module.content,
      children: [showTutorInstructions && tutorInstructions && /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInstructionBlock, {
        data: tutorInstructions
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherVoice, {
        isVisibleActionButton: Boolean(grammarReferenceId),
        onClickAction: () => setGrammarIsVisible(true),
        title: title ?? "",
        kind,
        texts: Array.isArray(text) ? text : [text],
        textConstants: {
          buttonText: intl.formatMessage({
            id: "teacherVoice.openGrammarReference"
          })
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(GrammarReference, {
        onClose: () => setGrammarIsVisible(false),
        open: isVisibleGrammar,
        referenceId: grammarReferenceId
      }), isVisibleControlsPanel && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
        place: controlsPanelButtonsPlace,
        showPrevButton,
        onPrevButtonClick: onPrevBlock,
        showNextButton,
        onNextButtonClick: onNextBlock
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/renderers/one-block-renderer/trainer-block-container.tsx




const TrainerBlockContainer = (0,react.forwardRef)((_ref, ref) => {
  let {
    block,
    className,
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    id: block.id,
    "data-block-id": block.id,
    "data-block-type": block.type,
    className,
    ref,
    children
  });
});
TrainerBlockContainer.displayName = "BlockContainer";
// EXTERNAL MODULE: ./src/components/trainer/renderers/one-block-renderer/types.ts
var one_block_renderer_types = __webpack_require__(56533);
;// CONCATENATED MODULE: ./src/components/trainer/renderers/one-block-renderer/one-block-renderer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const one_block_renderer_module = ({"root":"one-block-renderer-module__root--E3cWK","first-of-type-block":"one-block-renderer-module__first-of-type-block--sKKfu","firstOfTypeBlock":"one-block-renderer-module__first-of-type-block--sKKfu","first-of-type-a2":"one-block-renderer-module__first-of-type-a2--ScVSV","firstOfTypeA2":"one-block-renderer-module__first-of-type-a2--ScVSV","second-block":"one-block-renderer-module__second-block--Fa0vI","secondBlock":"one-block-renderer-module__second-block--Fa0vI","second-block-a2":"one-block-renderer-module__second-block-a2--AXPn6","secondBlockA2":"one-block-renderer-module__second-block-a2--AXPn6","first-text-block-with-illustration":"one-block-renderer-module__first-text-block-with-illustration--oWbaV","firstTextBlockWithIllustration":"one-block-renderer-module__first-text-block-with-illustration--oWbaV","sing-page-block":"one-block-renderer-module__sing-page-block--PUwY7","singPageBlock":"one-block-renderer-module__sing-page-block--PUwY7","first-block":"one-block-renderer-module__first-block--dZj4y","firstBlock":"one-block-renderer-module__first-block--dZj4y","text-block":"one-block-renderer-module__text-block--mfW1Q","textBlock":"one-block-renderer-module__text-block--mfW1Q","intro-block":"one-block-renderer-module__intro-block--p5O9c","introBlock":"one-block-renderer-module__intro-block--p5O9c","intro-block-a2":"one-block-renderer-module__intro-block-a2--Hlh2M","introBlockA2":"one-block-renderer-module__intro-block-a2--Hlh2M","landing-intro":"one-block-renderer-module__landing-intro--L_osu","landingIntro":"one-block-renderer-module__landing-intro--L_osu","landing-block":"one-block-renderer-module__landing-block--NCzeL","landingBlock":"one-block-renderer-module__landing-block--NCzeL","info-block":"one-block-renderer-module__info-block--hXVLB","infoBlock":"one-block-renderer-module__info-block--hXVLB","teachers-voice":"one-block-renderer-module__teachers-voice--SPwSy","teachersVoice":"one-block-renderer-module__teachers-voice--SPwSy","check-test-button-block":"one-block-renderer-module__check-test-button-block--aDg9Z","checkTestButtonBlock":"one-block-renderer-module__check-test-button-block--aDg9Z","check-test-button":"one-block-renderer-module__check-test-button--EJ8H1","checkTestButton":"one-block-renderer-module__check-test-button--EJ8H1"});
;// CONCATENATED MODULE: ./src/components/trainer/renderers/one-block-renderer/one-block-renderer.tsx






























const OneBlockRenderer = (0,react.memo)(
// eslint-disable-next-line sonarjs/cognitive-complexity
function OneBlockRenderer2(props) {
  const {
    block,
    renderType,
    mechanicMachineCreator,
    onSubmitAnswer,
    blockAnswerInfo,
    onChangeAnswer,
    onOutroActionTrigger,
    onCheckTestClick,
    controlsPanelButtonsPlace,
    showTutorInstructions,
    lastBlock,
    handleNextClick,
    handlePrevClick,
    isHiddenPrevButton,
    showNextButton,
    index,
    isOneBlockPerPageRendering,
    isFirstOfTypeBlock,
    withLargeMargin,
    shuffleHash,
    showResetButton,
    showSkipButton,
    userEnvironment,
    isRevision,
    shouldScrollIntoView,
    disableSmooth = false,
    onResetAnswer,
    showSubmitButton,
    isHiddenMechanicFeedback,
    isActive,
    getInitialDrawingState,
    useToolboxCustomButtons,
    useDrawingAccessState,
    eventEmitter,
    answers
  } = props;
  const {
    id,
    type
  } = block;
  const currentElementRef = (0,react.useRef)(null);
  const intl = (0,useIntl/* default */.Z)();
  const withTopMargin = isFirstOfTypeBlock && !isOneBlockPerPageRendering || ["outro", "chapter-outro"].includes(type);
  const isFirstIndex = index === 0;
  const blockClasses = classnames_default()(one_block_renderer_module.root, {
    [one_block_renderer_module.singPageBlock]: isOneBlockPerPageRendering,
    [one_block_renderer_module.firstOfTypeBlock]: withTopMargin,
    [one_block_renderer_module.secondBlock]: withLargeMargin && !isOneBlockPerPageRendering,
    [one_block_renderer_module.firstBlock]: isFirstIndex || isOneBlockPerPageRendering,
    [one_block_renderer_module.landingBlock]: renderType === one_block_renderer_types/* RenderType */.y.LANDING
  });
  const handleSubmitAnswer = (0,react.useCallback)(object => onSubmitAnswer({
    ...object,
    blockId: id
  }), [id, onSubmitAnswer]);
  const handleChangeAnswer = (0,react.useCallback)((answer, inProgress) => {
    if (onChangeAnswer) {
      onChangeAnswer(answer, block, inProgress);
    }
  }, [block, onChangeAnswer]);
  const handleResetAnswer = (0,react.useCallback)(() => {
    onResetAnswer(block);
  }, [block, onResetAnswer]);
  (0,react.useEffect)(() => {
    if (shouldScrollIntoView) {
      scrollToBlock(currentElementRef, disableSmooth);
    }
  }, [type, disableSmooth, shouldScrollIntoView]);
  const getInitialDrawingStateForBlock = (0,react.useMemo)(() => {
    const blockId = id;
    if (!blockId || !getInitialDrawingState) {
      return void 0;
    }
    return () => getInitialDrawingState(blockId);
  }, [id, getInitialDrawingState]);
  const [toolboxCustomButtonsForBlock, modalsForBlock] = useToolboxCustomButtons?.(id ?? `${type}-no_id`) || [];
  const drawingAccessState = useDrawingAccessState?.(id ?? `${type}-no_id`) || false;
  switch (type) {
    case "intro":
    case "chapter-intro":
      {
        const imageSrc = type === "intro" ? block.image : block.image.url;
        const settings = type === "intro" ? block.setting : block.text;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
          block,
          ref: currentElementRef,
          className: classnames_default()(one_block_renderer_module.introBlock, {
            [one_block_renderer_module.landingIntro]: renderType === one_block_renderer_types/* RenderType */.y.LANDING
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(IntroBlock, {
            controlsPanelButtonsPlace,
            showTutorInstructions,
            tutorInstructions: block["tutor-instruction"],
            title: block.title,
            image: imageSrc,
            setting: settings,
            lastBlock,
            onNextBlock: handleNextClick,
            onPrevBlock: handlePrevClick,
            autoScrollToTitle: false,
            showPrevButton: !isHiddenPrevButton,
            showNextButton
          })
        });
      }
    case "story-intro":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(StoryIntroBlock, {
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          title: block.title,
          text: block.text,
          image: block.image,
          lastBlock,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton
        })
      });
    case "grammar-intro":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(GrammarIntroBlock, {
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          title: block.title,
          text: block.text,
          lastBlock,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton
        })
      });
    case "caption":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CaptionBlock, {
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          title: block.title,
          image: block.image,
          setting: block.setting,
          lastBlock,
          imagePosition: block.imagePosition,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton
        })
      });
    case "image":
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ImageBlock, {
          id,
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          url: block.url,
          lastBlock,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton,
          getInitialDrawingState: getInitialDrawingStateForBlock,
          toolboxCustomButtons: toolboxCustomButtonsForBlock,
          showToolbox: drawingAccessState,
          eventEmitter
        }), modalsForBlock]
      });
    case "info":
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: classnames_default()(blockClasses, {
          [one_block_renderer_module.infoBlock]: !isFirstIndex && !isOneBlockPerPageRendering && !isFirstOfTypeBlock
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(InfoBlock, {
          id,
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          text: block.text,
          image: block.image,
          video: block.video,
          lastBlock,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton,
          getInitialDrawingState: getInitialDrawingStateForBlock,
          toolboxCustomButtons: toolboxCustomButtonsForBlock,
          showToolbox: drawingAccessState,
          eventEmitter
        }), modalsForBlock]
      });
    case "mechanic":
      {
        const {
          answer: initialAnswer,
          correct,
          inProgress
        } = blockAnswerInfo ?? {
          answer: null,
          correct: false
        };
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
          block,
          ref: currentElementRef,
          className: classnames_default()(one_block_renderer_module.root, {
            [one_block_renderer_module.firstOfTypeBlock]: !isOneBlockPerPageRendering,
            [one_block_renderer_module.secondBlock]: withLargeMargin && !isOneBlockPerPageRendering,
            [one_block_renderer_module.singPageBlock]: isOneBlockPerPageRendering,
            [one_block_renderer_module.firstBlock]: isFirstIndex || isOneBlockPerPageRendering
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(MechanicBlock, {
            clueButton: block.clue,
            controlsPanelButtonsPlace,
            correct,
            disableKeyPress: renderType === one_block_renderer_types/* RenderType */.y.VISIBLE_ALL,
            feedback: block.feedback,
            hint: block.hint,
            inProgress,
            initialAnswer,
            input: block.input,
            skill: block.skill,
            isActive,
            isHiddenFeedback: isHiddenMechanicFeedback,
            lastBlock,
            machineCreator: mechanicMachineCreator,
            onChangeAnswer: handleChangeAnswer,
            onNextBlock: handleNextClick,
            onPrevBlock: handlePrevClick,
            onResetAnswer: handleResetAnswer,
            onSubmitAnswer: handleSubmitAnswer,
            output: block.output,
            position: isOneBlockPerPageRendering ? "center" : "right",
            showNextButton: showNextButton && (lastBlock || isOneBlockPerPageRendering),
            showPrevButton: !isHiddenPrevButton,
            showResetButton,
            showSkipButton,
            showSubmitButton,
            showTutorInstructions,
            shuffleHash,
            tutorInstructions: block["tutor-instruction"]
          })
        });
      }
    case "text":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
          block,
          ref: currentElementRef,
          className: classnames_default()(blockClasses, {
            [one_block_renderer_module.textBlock]: index !== 0 && !isOneBlockPerPageRendering && !isFirstOfTypeBlock
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TextBlock, {
            controlsPanelButtonsPlace,
            showTutorInstructions,
            tutorInstructions: block["tutor-instruction"],
            blockId: id,
            text: block.text,
            audio: block.audio,
            author: block.author,
            isFirstOfType: isFirstOfTypeBlock,
            illustration: block.illustration,
            lastBlock,
            onNextBlock: handleNextClick,
            onPrevBlock: handlePrevClick,
            showPrevButton: !isHiddenPrevButton,
            showNextButton
          })
        });
      }
    case "teachers-voice":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: classnames_default()(blockClasses, one_block_renderer_module.teachersVoice),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherVoiceBlock, {
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          text: block.text,
          title: block.title,
          kind: block.kind,
          lastBlock,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton,
          grammarReferenceId: block["grammar-reference-id"]
        })
      });
    case "lexis-info":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(LexisInfo, {
          controlsPanelButtonsPlace,
          showTutorInstructions,
          tutorInstructions: block["tutor-instruction"],
          term: block.term,
          translations: block.translations,
          contexts: block.contexts,
          lastBlock,
          onNextBlock: handleNextClick,
          onPrevBlock: handlePrevClick,
          showPrevButton: !isHiddenPrevButton,
          showNextButton
        })
      });
    case "outro":
    case "chapter-outro":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(OutroBlock, {
          controlsPanelButtonsPlace,
          image: block.image,
          title: block.title,
          text: block.text,
          lastBlock,
          actionControls: block.actionControls,
          onChange: onOutroActionTrigger,
          showPrevButton: !isHiddenPrevButton,
          onPrevBlock: handlePrevClick,
          isRevision
        })
      });
    case "illustrated-block":
      {
        const {
          answer: initialAnswer
        } = blockAnswerInfo ?? {
          answer: {
            visibleBlockIndex: 0
          }
        };
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
          block,
          ref: currentElementRef,
          className: blockClasses,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(BlocksListWithIllustration, {
            blocks: block.blocks,
            controlsPanelButtonsPlace,
            onPrevBlock: handlePrevClick,
            onNextBlock: handleNextClick,
            showPrevButton: !isHiddenPrevButton,
            showNextButton,
            lastBlock,
            showTutorInstructions,
            onChangeAnswer: handleChangeAnswer,
            onSubmitAnswer: handleSubmitAnswer,
            initialAnswer
          })
        });
      }
    case "information-gap":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [block.student !== void 0 && userEnvironment === one_block_renderer_types/* UserEnvironment */.P.Student && /* @__PURE__ */(0,jsx_runtime.jsx)(OneBlockRenderer2, {
            ...props,
            block: block.student
          }), block.tutor !== void 0 && userEnvironment === one_block_renderer_types/* UserEnvironment */.P.Tutor && /* @__PURE__ */(0,jsx_runtime.jsx)(OneBlockRenderer2, {
            ...props,
            block: block.tutor
          }), userEnvironment === one_block_renderer_types/* UserEnvironment */.P.Methodologist && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [block.student !== void 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: typography_module/* default */.Z.headline4Accent,
                children: intl.formatMessage({
                  id: "class.informationGapForStudent"
                })
              }), /* @__PURE__ */(0,jsx_runtime.jsx)(OneBlockRenderer2, {
                ...props,
                block: block.student
              })]
            }), block.tutor !== void 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: typography_module/* default */.Z.headline4Accent,
                children: intl.formatMessage({
                  id: "class.informationGapForTutor"
                })
              }), /* @__PURE__ */(0,jsx_runtime.jsx)(OneBlockRenderer2, {
                ...props,
                block: block.tutor
              })]
            })]
          })]
        });
      }
    case "ya-form":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: blockClasses,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ya_form_component/* YaForm */.S, {
          title: block.title,
          subtitle: block.subtitle,
          url: block.url,
          width: Number(block.width),
          name: block.name,
          onNextBlock: handleNextClick
        })
      });
    case "placement-result":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(SubmitPlacementResults, {
        course_level: block.course_level,
        skip: block.skip,
        revise: block.revise,
        finish: block.finish,
        onNext: handleNextClick
      });
    case "check-test":
      if (!isHiddenMechanicFeedback) {
        return null;
      }
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
        block,
        ref: currentElementRef,
        className: classnames_default()(blockClasses, one_block_renderer_module.checkTestButtonBlock),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primary",
          onClick: onCheckTestClick,
          className: one_block_renderer_module.checkTestButton,
          children: block.text
        })
      });
    case "test-results":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerBlockContainer, {
          block,
          ref: currentElementRef,
          className: blockClasses,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TestResultsBlock, {
            answers,
            imgSrc: block["img-src"],
            buttonText: block["button-text"],
            topLabel: block["top-label"],
            labelVariants: block["label-variants"],
            blockIds: block["block-ids"],
            showScore: block["show-score"],
            onButtonClick: handleNextClick
          })
        });
      }
    default:
      logger/* Logger */.Yd.captureError(`Block not implemented`, new unhandled_case/* UnhandledCaseError */.H(type));
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "Block not implemented"
      });
  }
}, (prevProps, nextProps) => {
  for (const prop in nextProps) {
    const typedProp = prop;
    if (!(0,equals/* default */.Z)(prevProps[typedProp], nextProps[typedProp])) {
      return false;
    }
  }
  return true;
});
// EXTERNAL MODULE: ./src/api/student/wordbank/wordbank.api.ts + 4 modules
var wordbank_api = __webpack_require__(23643);
// EXTERNAL MODULE: ./src/components/class/modules/highlighted-word/index.ts + 4 modules
var highlighted_word = __webpack_require__(42419);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
;// CONCATENATED MODULE: ./src/hooks/use-translatable-text.ts











const useTranslatableText = blockKey => {
  const {
    hideAddToWordbankButton
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const {
    playAudioByLink
  } = (0,useAudio/* usePlayAudioByLink */.CH)({
    priority: useAudio/* Priority */.UL.Low
  });
  const intl = (0,useIntl/* default */.Z)();
  const user = (0,useUser/* useUser */.aF)();
  const translatableTextButtonTexts = (0,react.useMemo)(() => ({
    addedWordActionButtonText: intl.formatMessage({
      id: "translatableText.addedInWordbank"
    }),
    notAddedWordActionButtonText: intl.formatMessage({
      id: "translatableText.addToWordbank"
    }),
    failedToAddWordMessage: intl.formatMessage({
      id: "translatableText.failedToAddWord"
    }),
    failedToRemoveWordMessage: intl.formatMessage({
      id: "translatableText.failedToRemoveWord"
    }),
    failedToPlayAudioMessage: intl.formatMessage({
      id: "translatableText.failedToPlay"
    }),
    translateButtonText: intl.formatMessage({
      id: "translatableText.translate"
    }),
    scrollButtonText: intl.formatMessage({
      id: "translatableText.scroll"
    }),
    loadingText: intl.formatMessage({
      id: "translatableText.loading"
    })
  }), [intl]);
  const {
    hoveredWordPath,
    highlightedWordPath,
    highlightedWordAction,
    highlightingNotifier,
    hasActionsTooltip,
    onWordAction,
    onOutsideClick
  } = (0,react.useContext)(highlighted_word/* HighlightedWordContext */.KF);
  const handleFetchTranslation = (0,react.useCallback)(async (context, tokenIndex) => {
    const response = await (0,wordbank_api/* translateTermInContext */.nP)(context, tokenIndex);
    if ((0,Either.isRight)(response)) {
      const {
        word,
        partOfSpeech,
        translations,
        id,
        context: context2,
        addedInWordbank
      } = response.right;
      return {
        id,
        word,
        addedInWordbank,
        partOfSpeech: intl.formatMessage({
          id: partOfSpeech
        }),
        translations,
        context: context2
      };
    }
    return {
      id: "",
      word: "",
      addedInWordbank: false,
      partOfSpeech: "",
      translations: [],
      context: ""
    };
  }, [intl]);
  const handlePlayTextToSpeech = (0,react.useCallback)(word => playAudioByLink((0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(word), "wordbank"), [playAudioByLink]);
  const handleAddTranslation = (0,react.useCallback)(async _ref => {
    let {
      termId,
      context
    } = _ref;
    const r = await (0,wordbank_api/* postTermInWordBank */.Is)({
      blockKey,
      termId,
      context
    });
    return (0,Either.isRight)(r);
  }, [blockKey]);
  const handleDeleteTerm = (0,react.useCallback)(async termId => {
    const r = await (0,wordbank_api/* deleteWordBankTerm */.zb)(termId);
    return (0,Either.isRight)(r);
  }, []);
  const handleFetchTooltipTranslation = (0,react.useCallback)(async params => {
    const {
      context,
      term,
      translation
    } = params;
    const response = await (0,wordbank_api/* getWordBankTooltip */.jP)(context, term, translation, blockKey);
    if ((0,Either.isRight)(response)) {
      const {
        word,
        partOfSpeech,
        translations,
        id,
        context: context2,
        addedInWordbank
      } = response.right;
      return {
        id,
        word,
        partOfSpeech,
        addedInWordbank,
        translations,
        context: context2
      };
    }
    return {
      id: "",
      word: "",
      partOfSpeech: "",
      addedInWordbank: false,
      translations: [],
      context: ""
    };
  }, [blockKey]);
  const handleAddTooltip = (0,react.useCallback)(async termId => {
    const response = await (0,wordbank_api/* postWordBankTooltip */.r6)({
      blockKey,
      termId
    });
    return Boolean((0,Either.isRight)(response));
  }, [blockKey]);
  const handleWordAction = (0,react.useCallback)((translatableTextId, sentenceIndex, tokenIndex, type) => {
    onWordAction?.({
      blockKey,
      translatableTextId,
      sentenceIndex,
      tokenIndex
    }, type);
  }, [blockKey, onWordAction]);
  return (0,react.useMemo)(() => ({
    textConstants: translatableTextButtonTexts,
    fetchTranslation: handleFetchTranslation,
    onAddWordClick: handleAddTranslation,
    onDeleteWordClick: handleDeleteTerm,
    fetchTooltipTranslation: handleFetchTooltipTranslation,
    onAddTooltip: handleAddTooltip,
    onPlayTextToSpeech: handlePlayTextToSpeech,
    hideAddToWordbankButton: hideAddToWordbankButton || user.data?.me.user?.role === "tutor",
    hasActionsTooltip: hasActionsTooltip && user.data?.me.user?.role === "tutor",
    onWordAction: handleWordAction,
    onOutsideClick,
    hoveredWordPath,
    highlightedWordPath,
    highlightedWordAction,
    highlightingNotifier
  }), [translatableTextButtonTexts, handleFetchTranslation, handleAddTranslation, handleDeleteTerm, handleFetchTooltipTranslation, handleAddTooltip, handlePlayTextToSpeech, hideAddToWordbankButton, user.data?.me.user?.role, hasActionsTooltip, handleWordAction, onOutsideClick, hoveredWordPath, highlightedWordPath, highlightedWordAction, highlightingNotifier]);
};
;// CONCATENATED MODULE: ./src/components/trainer/renderers/block-renderer/block-translatable-text-context.tsx





const BlockTranslatableTextContext = _ref => {
  let {
    blockKey,
    children,
    containerRef
  } = _ref;
  const translatableTextContext = useTranslatableText(blockKey);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableTextContext.Provider, {
    value: {
      ...translatableTextContext,
      blockKey,
      containerRef
    },
    children
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/renderers/block-renderer/get-one-block-params.ts



const getOneBlockParams = _ref => {
  let {
    activityKey,
    block,
    blocksLength,
    getBlockAnswerInfo,
    index,
    isLastActivity,
    isMobileOrTablet,
    lastOpenBlockIndex,
    prevBlockType,
    renderType,
    scrollToBlockIndex,
    showNextButton,
    showSkipButton,
    withIllustratedBlock
  } = _ref;
  const isOneBlockPerPageRendering = renderType === one_block_renderer_types/* RenderType */.y.ONE_BLOCK_PER_PAGE;
  const withLargeMargin = index === 1 && !isOneBlockPerPageRendering;
  const renderNothing = isOneBlockPerPageRendering && index !== lastOpenBlockIndex || index > lastOpenBlockIndex && (renderType === void 0 || ![one_block_renderer_types/* RenderType */.y.VISIBLE_ALL, one_block_renderer_types/* RenderType */.y.LANDING].includes(renderType));
  const isActiveBlock = index === lastOpenBlockIndex;
  const isLastActiveBlock = isActiveBlock || renderType === one_block_renderer_types/* RenderType */.y.LANDING;
  const isLastBlock = blocksLength - 1 !== index;
  const showNextButtonValue = showNextButton && renderType !== one_block_renderer_types/* RenderType */.y.VISIBLE_ALL && (!isLastActivity || isLastBlock);
  const showSkipButtonValue = showSkipButton && (!isLastActivity || isLastBlock);
  const isFirstOfTypeBlock = prevBlockType !== block.type;
  const isFirstElement = index === 0;
  const shouldScrollIntoView = !isFirstElement && index === scrollToBlockIndex;
  const disableSmooth = isFirstElement || withIllustratedBlock && isMobileOrTablet;
  const blockAnswerInfo = block.id ? getBlockAnswerInfo(block.id) : null;
  const blockKey = {
    ...activityKey,
    blockId: block.id
  };
  return {
    blockAnswerInfo,
    blockKey,
    disableSmooth,
    isActiveBlock,
    isFirstOfTypeBlock,
    isOneBlockPerPageRendering,
    lastBlock: isLastActiveBlock,
    renderNothing,
    shouldScrollIntoView,
    showNextButtonValue,
    showSkipButtonValue,
    withLargeMargin
  };
};
;// CONCATENATED MODULE: ./src/components/trainer/renderers/block-renderer/use-block-renderer.ts





const useBlockRenderer = _ref => {
  let {
    onChangeAnswer,
    onNextBlockClick,
    onPrevBlockClick,
    onResetAnswer,
    onSubmitAnswer
  } = _ref;
  const player = (0,react.useContext)(useAudio/* AudioPlayerContext */.D8);
  const handleChangeAnswer = (0,react.useCallback)((answer, block, inProgress) => {
    if (onChangeAnswer) {
      onChangeAnswer(answer, block.id, inProgress);
    }
  }, [onChangeAnswer]);
  const handleNextClick = (0,react.useCallback)(async params => {
    await player.stopAudio();
    onNextBlockClick(params);
  }, [player, onNextBlockClick]);
  const handlePrevClick = (0,react.useCallback)(async () => {
    await player.stopAudio();
    if (onPrevBlockClick) {
      onPrevBlockClick();
    }
  }, [player, onPrevBlockClick]);
  const handleResetAnswer = (0,react.useCallback)(block => {
    if (block.id) {
      onResetAnswer(block.id);
    }
  }, [onResetAnswer]);
  const [answers, setAnswers] = (0,react.useState)([]);
  const handleSubmitAnswer = (0,react.useCallback)(answerResult => {
    const {
      blockId,
      maxPossibleScore,
      rightAnswersScore
    } = answerResult;
    if (blockId) {
      setAnswers(prev => {
        const newAnswers = [...prev];
        const index = prev.findIndex(item => item.blockId === blockId);
        if (index >= 0) {
          newAnswers[index].maxScore = maxPossibleScore ?? 0;
          newAnswers[index].score = rightAnswersScore ?? 0;
        } else {
          newAnswers.push({
            blockId,
            maxScore: maxPossibleScore ?? 0,
            score: rightAnswersScore ?? 0
          });
        }
        return newAnswers;
      });
    }
    onSubmitAnswer(answerResult);
  }, [onSubmitAnswer]);
  return {
    handleChangeAnswer,
    handleNextClick,
    handlePrevClick,
    handleResetAnswer,
    handleSubmitAnswer,
    answers
  };
};
;// CONCATENATED MODULE: ./src/components/trainer/renderers/block-renderer/block-renderer.tsx























const BlocksRender = _ref => {
  let {
    activityKey,
    activityType,
    blockIndex,
    blocks,
    containerRef,
    currentActivityIndex,
    getBlockAnswerInfo,
    isLastActivity = false,
    isRevision = false,
    isSpeaking,
    mechanicMachineCreator,
    onPrevActivityClick = function_utils/* emptyFunction */.Bi,
    onNextActivityClick,
    onPrevBlockClick = function_utils/* emptyFunction */.Bi,
    onNextBlockClick,
    onOutroActionTrigger,
    onChangeAnswer,
    onResetAnswer,
    onSubmitAnswer,
    renderType: renderTypeProp,
    scrollToBlockIndex = 0,
    showAudioFooter,
    showHelpButton = true,
    showNextButton,
    showPrevActivityButton = true,
    showPrevButton,
    showResetButton,
    showSkipButton,
    showSubmitButton,
    showTutorInstructions = false,
    shuffleHash = 0,
    userEnvironment,
    getInitialDrawingState,
    useToolboxCustomButtons,
    useDrawingAccessState,
    eventEmitter
  } = _ref;
  const [controlsPanelButtonsPlace, setControlsPanelButtonsPlace] = (0,react.useState)(null);
  const [visibleAllControlsPanelButtonsPlace, setVisibleAllControlsPanelButtonsPlace] = (0,react.useState)(null);
  const isHiddenPrevButton = currentActivityIndex === 0 && blockIndex === 0 || !showPrevButton;
  const [currentActivityType, setCurrentActivityType] = (0,react.useState)(activityType);
  const {
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const renderType = (0,react.useMemo)(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("renderType") === "visibleAll") {
      return one_block_renderer_types/* RenderType */.y.VISIBLE_ALL;
    }
    return renderTypeProp;
  }, [renderTypeProp]);
  const withIllustratedBlock = (0,react.useMemo)(() => blocks.some(block => block.type === "illustrated-block"), [blocks]);
  const {
    handleChangeAnswer,
    handleNextClick,
    handlePrevClick,
    handleResetAnswer,
    handleSubmitAnswer,
    answers
  } = useBlockRenderer({
    onChangeAnswer,
    onNextBlockClick,
    onPrevBlockClick,
    onResetAnswer,
    onSubmitAnswer
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [currentActivityIndex !== 0 && showPrevActivityButton && /* @__PURE__ */(0,jsx_runtime.jsx)(PrevActivityButton, {
      onClick: onPrevActivityClick
    }), blocks.map((block, index) => {
      const {
        blockAnswerInfo,
        blockKey,
        disableSmooth,
        isActiveBlock,
        isFirstOfTypeBlock,
        isOneBlockPerPageRendering,
        lastBlock,
        renderNothing,
        shouldScrollIntoView,
        showNextButtonValue,
        showSkipButtonValue,
        withLargeMargin
      } = getOneBlockParams({
        activityKey,
        block,
        blocksLength: blocks.length,
        getBlockAnswerInfo,
        index,
        isLastActivity,
        isMobileOrTablet,
        lastOpenBlockIndex: blockIndex,
        prevBlockType: index === 0 ? void 0 : blocks[index - 1].type,
        renderType,
        scrollToBlockIndex,
        showNextButton,
        showSkipButton,
        withIllustratedBlock
      });
      if (renderNothing) {
        return null;
      }
      return /* @__PURE__ */(0,jsx_runtime.jsx)(BlockTranslatableTextContext, {
        blockKey,
        containerRef,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(OneBlockRenderer, {
          block,
          blockAnswerInfo,
          controlsPanelButtonsPlace,
          disableSmooth,
          handleNextClick,
          handlePrevClick: renderType === one_block_renderer_types/* RenderType */.y.VISIBLE_ALL ? onPrevActivityClick : handlePrevClick,
          index,
          isActive: isActiveBlock,
          isFirstOfTypeBlock,
          isHiddenMechanicFeedback: currentActivityType === "test",
          isHiddenPrevButton,
          isOneBlockPerPageRendering,
          isRevision,
          lastBlock,
          mechanicMachineCreator,
          onChangeAnswer: handleChangeAnswer,
          onCheckTestClick: () => setCurrentActivityType("story"),
          onOutroActionTrigger,
          onResetAnswer: handleResetAnswer,
          onSubmitAnswer: handleSubmitAnswer,
          renderType,
          shouldScrollIntoView: shouldScrollIntoView && renderType !== one_block_renderer_types/* RenderType */.y.VISIBLE_ALL,
          showNextButton: showNextButtonValue,
          showResetButton: showResetButton && activityType !== "test",
          showSkipButton: showSkipButtonValue,
          showSubmitButton,
          showTutorInstructions,
          shuffleHash,
          userEnvironment,
          withLargeMargin,
          getInitialDrawingState,
          useToolboxCustomButtons,
          useDrawingAccessState,
          eventEmitter,
          answers
        })
      }, block.id !== "" ? block.id : index);
    }), renderType === one_block_renderer_types/* RenderType */.y.VISIBLE_ALL && !isLastActivity && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelButtons */.zr, {
        onNextButtonClick: onNextActivityClick ?? function_utils/* emptyFunction */.Bi,
        place: visibleAllControlsPanelButtonsPlace,
        showNextButton: true
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanel */.YO, {
        onControlsPanelButtonsPlaceChanged: setVisibleAllControlsPanelButtonsPlace,
        position: types/* ControlsPanelPosition */.d.Initial
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanel */.YO, {
      position: types/* ControlsPanelPosition */.d.Fixed,
      onControlsPanelButtonsPlaceChanged: setControlsPanelButtonsPlace
    }), showHelpButton && /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelHelpButton */.ld, {
      isSpeaking
    }), showAudioFooter && /* @__PURE__ */(0,jsx_runtime.jsx)(AudioFooter, {})]
  });
};

/***/ }),

/***/ 56533:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ UserEnvironment),
/* harmony export */   y: () => (/* binding */ RenderType)
/* harmony export */ });


var UserEnvironment = /* @__PURE__ */(UserEnvironment2 => {
  UserEnvironment2[UserEnvironment2["Tutor"] = 0] = "Tutor";
  UserEnvironment2[UserEnvironment2["Student"] = 1] = "Student";
  UserEnvironment2[UserEnvironment2["Methodologist"] = 2] = "Methodologist";
  return UserEnvironment2;
})(UserEnvironment || {});
var RenderType = /* @__PURE__ */(RenderType2 => {
  RenderType2["ONE_BLOCK_PER_PAGE"] = "one-block-per-page";
  RenderType2["VISIBLE_ALL"] = "visible-all";
  RenderType2["LANDING"] = "landing";
  return RenderType2;
})(RenderType || {});

/***/ }),

/***/ 72360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ ProductTrainerRendererContextComponent)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97703);
/* harmony import */ var _blocks_mechanic_block_mechanic_block_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67059);





const ProductTrainerRendererDefaultValue = {
  mechanicBlockAlign: _blocks_mechanic_block_mechanic_block_models__WEBPACK_IMPORTED_MODULE_2__/* .MechanicBlockAlign */ .H.Center,
  trainerEnvironment: _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_1__/* .TrainerEnvironment */ .r$.Trainer,
  withTaskGuide: false,
  drawing: false
};
const ProductTrainerRendererContextComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(ProductTrainerRendererDefaultValue);

/***/ }),

/***/ 62436:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ usePlayTextToSpeech)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_hooks_use_effect_once__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28504);
/* harmony import */ var _yandex_langly_shared_src_hooks_useAudio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12745);
/* harmony import */ var _api_trainer_trainer_urls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47160);






const usePlayTextToSpeech = (selection, options) => {
  const {
    playAudioByLink
  } = (0,_yandex_langly_shared_src_hooks_useAudio__WEBPACK_IMPORTED_MODULE_2__/* .usePlayAudioByLink */ .CH)({
    priority: _yandex_langly_shared_src_hooks_useAudio__WEBPACK_IMPORTED_MODULE_2__/* .Priority */ .UL.Low
  });
  const handlePlayTextToSpeech = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((word, isInit) => playAudioByLink((0,_api_trainer_trainer_urls__WEBPACK_IMPORTED_MODULE_3__/* .GET_TEXT_TO_SPEECH_URL */ .C)(word), "wordbank", isInit), [playAudioByLink]);
  (0,_yandex_langly_shared_src_hooks_use_effect_once__WEBPACK_IMPORTED_MODULE_1__/* .useEffectOnce */ .q)(() => {
    if (options?.initPlayer && !_yandex_langly_shared_src_hooks_useAudio__WEBPACK_IMPORTED_MODULE_2__/* .audioPlayer */ .el.isInitialized()) {
      void handlePlayTextToSpeech("", true);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!options?.enablePlayOnMount || !selection) {
      return;
    }
    void handlePlayTextToSpeech(selection);
  }, [handlePlayTextToSpeech, options?.enablePlayOnMount, selection]);
  return {
    play: handlePlayTextToSpeech
  };
};

/***/ }),

/***/ 66553:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Q: () => (/* binding */ TranslationTooltipV2)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/tooltip-simple/tooltip-simple.tsx + 1 modules
var tooltip_simple = __webpack_require__(45451);
// EXTERNAL MODULE: ./src/components/selection-translation/store/store.ts
var store = __webpack_require__(9266);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(42180);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useMutation.js + 1 modules
var useMutation = __webpack_require__(88923);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/api/student/translations/constants.ts






const TRANSLATE_HIGHLIGHT_API_URL = (highlight, context) => {
  const params = new URLSearchParams();
  params.append("highlight", highlight);
  params.append("context", context);
  return `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank/translate-v2/highlight?${params}`;
};
const TRANSLATE_WORD_API_URL = (context, wordStartIndex) => {
  const params = new URLSearchParams();
  params.append("word_start_index", wordStartIndex.toString());
  params.append("context", context);
  return `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank/translate-v2/word?${params}`;
};
const SAVE_HIGHLIGHT_TO_WORDBANK_API_URL = `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank/student-highlights`;
const SAVE_WORD_TO_WORDBANK_API_URL = `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank/student-words`;
const SAVE_WORD_VARIANT_TO_WORDBANK_API_URL = `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank/student-words-variants`;
const DELETE_FROM_WORDBANK = termId => `${(0,site_utils/* getAPIPath */.NZ)()}/student/wordbank/student-dictionary/${termId}`;
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
;// CONCATENATED MODULE: ./src/api/student/translations/translations.mappers.ts




const mapTranslateHighlight = _ref => {
  let {
    data
  } = _ref;
  return {
    translation: data.translation,
    contextId: data.context_id,
    highlightId: data.highlight_id,
    isInWordbank: data.is_in_wordbank
  };
};
const mapPartOfSpeechToTankerKey = rawPartOfSpeech => {
  switch (rawPartOfSpeech) {
    case "ADJ":
      return "wordTranslations.adj";
    case "ADV":
      return "wordTranslations.adv";
    case "CONJ":
      return "wordTranslations.conj";
    case "DET":
      return "wordTranslations.det";
    case "INTJ":
      return "wordTranslations.interj";
    case "NUM":
      return "wordTranslations.num";
    case "PART":
      return "wordTranslations.particle";
    case "ADP":
      return "wordTranslations.prep";
    case "PRON":
      return "wordTranslations.pron";
    case "VERB":
      return "wordTranslations.v";
    case "NOUN":
      return "wordTranslations.n";
    case "AUX":
      return "wordTranslations.aux";
    case "PROPN":
      return "wordTranslations.propn";
    case "SCONJ":
      return "wordTranslations.sconj";
    case "CCONJ":
      return "wordTranslations.sconj";
    case "PHRASE":
      return "translationTooltip.phrase";
    default:
      return "wordTranslations.unknown";
  }
};
const mapTranslatedWord = _ref2 => {
  let {
    data
  } = _ref2;
  return {
    align: data.align.map(_ref3 => {
      let {
        index_from: indexFrom,
        index_to: indexTo
      } = _ref3;
      return {
        indexFrom,
        indexTo
      };
    }),
    translation: data.translation,
    wordId: data.word_id,
    contextId: data.context_id,
    v2: data.v2,
    popup: data.popup,
    partOfSpeechTankerKey: mapPartOfSpeechToTankerKey(data.part_of_speech),
    definition: data.definition,
    transcription: data.transcription,
    variants: data.variants.map(_ref4 => {
      let {
        uuid,
        translation,
        transcription,
        context,
        context_translation: contextTranslation,
        part_of_speech: partOfSpeech,
        word_start_index: wordStartIndex,
        is_in_wordbank: isInWordbank,
        word_id: wordId
      } = _ref4;
      return {
        id: uuid,
        context,
        translation,
        transcription,
        partOfSpeech,
        wordStartIndex,
        contextTranslation,
        isInWordbank,
        wordId
      };
    }),
    isInWordbank: data.is_in_wordbank
  };
};
;// CONCATENATED MODULE: ./src/api/student/translations/translations.raw-model.ts



const RawPartOfSpeech = es6.keyof({
  ADJ: null,
  ADV: null,
  CONJ: null,
  DET: null,
  INTJ: null,
  NUM: null,
  PART: null,
  ADP: null,
  PRON: null,
  VERB: null,
  NOUN: null,
  AUX: null,
  PROPN: null,
  SCONJ: null,
  CCONJ: null
});
const RawTranslateHighlightResponseData = es6.type({
  translation: es6.string,
  context_id: es6.string,
  highlight_id: es6.number,
  is_in_wordbank: es6.boolean
});
const RawTranslateHighlightResponse = es6.type({
  data: RawTranslateHighlightResponseData
});
const RawAlign = es6.type({
  index_from: es6.number,
  index_to: es6.number
});
const RawAligns = es6.array(RawAlign);
const RawVariant = es6.type({
  uuid: es6.string,
  context: es6.string,
  translation: es6.string,
  transcription: es6.string,
  part_of_speech: RawPartOfSpeech,
  word_start_index: es6.number,
  context_translation: es6.string,
  is_in_wordbank: es6.boolean,
  word_id: es6.union([es6.number, es6["null"]])
});
const RawVariants = es6.array(RawVariant);
const RawTranslateWordResponseData = es6.type({
  align: RawAligns,
  translation: es6.string,
  word_id: es6.number,
  context_id: es6.string,
  v2: es6.boolean,
  popup: es6.string,
  part_of_speech: RawPartOfSpeech,
  definition: es6.union([es6.string, es6["null"]]),
  transcription: es6.union([es6.string, es6["null"]]),
  variants: RawVariants,
  is_in_wordbank: es6.boolean
});
const RawTranslateWordResponse = es6.type({
  data: RawTranslateWordResponseData
});
const RawSaveWordVariantToWordbankData = es6.type({
  word_id: es6.number
});
const RawSaveWordVariantToWordbankResponse = es6.type({
  data: RawSaveWordVariantToWordbankData
});
;// CONCATENATED MODULE: ./src/api/student/translations/translations.api.ts









const translateHighlight = (0,un_either/* unEither */.K)((highlight, context) => (0,http/* makeRequest */.$f)(TRANSLATE_HIGHLIGHT_API_URL(highlight, context), {
  responseType: RawTranslateHighlightResponse,
  resultMapper: mapTranslateHighlight,
  errorMapper: () => api_model/* unexpectedError */.g
}));
const translateWord = (0,un_either/* unEither */.K)((context, wordStartIndex) => (0,http/* makeRequest */.$f)(TRANSLATE_WORD_API_URL(context, wordStartIndex), {
  responseType: RawTranslateWordResponse,
  resultMapper: mapTranslatedWord,
  errorMapper: () => api_model/* unexpectedError */.g
}));
const saveHighlightToWordbank = (0,un_either/* unEither */.K)((highlightId, contextId, params) => (0,http/* makeRequest */.$f)(SAVE_HIGHLIGHT_TO_WORDBANK_API_URL, {
  method: "POST",
  body: {
    highlight_id: highlightId,
    context_id: contextId,
    product_id: params?.productId,
    chapter_id: params?.chapterId,
    activity_id: params?.activityId,
    block_id: params?.blockId
  },
  responseType: es6["void"],
  errorMapper: () => api_model/* unexpectedError */.g
}));
const saveWordToWordbank = (0,un_either/* unEither */.K)((wordId, contextId, v2, params) => (0,http/* makeRequest */.$f)(SAVE_WORD_TO_WORDBANK_API_URL, {
  method: "POST",
  body: {
    word_id: wordId,
    context_id: contextId,
    v2,
    product_id: params?.productId,
    chapter_id: params?.chapterId,
    activity_id: params?.activityId,
    block_id: params?.blockId
  },
  responseType: es6["void"],
  errorMapper: () => api_model/* unexpectedError */.g
}));
const saveWordVariantToWordbank = (0,un_either/* unEither */.K)((id, word) => (0,http/* makeRequest */.$f)(SAVE_WORD_VARIANT_TO_WORDBANK_API_URL, {
  method: "POST",
  body: {
    variant_id: id,
    popup: word
  },
  responseType: RawSaveWordVariantToWordbankResponse,
  resultMapper: _ref => {
    let {
      data
    } = _ref;
    return {
      wordId: data.word_id
    };
  },
  errorMapper: () => api_model/* unexpectedError */.g
}));
const deleteTermFromWordbank = (0,un_either/* unEither */.K)((termId, termType) => (0,http/* makeRequest */.$f)(DELETE_FROM_WORDBANK(termId), {
  method: "DELETE",
  body: {
    term_type: termType
  },
  responseType: es6["void"],
  errorMapper: () => api_model/* unexpectedError */.g
}));
;// CONCATENATED MODULE: ./src/api/student/translations/hooks.ts





const useTranslateHighlightQuery = (highlight, context) => {
  const queryKey = (0,react.useMemo)(() => ["translateHighlight", highlight], [highlight]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(highlight && context),
    queryKey,
    queryFn: () => {
      if (!context) {
        return;
      }
      return translateHighlight(highlight, context);
    },
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    throwOnError: false
  });
};
const useTranslateWordQuery = (context, wordStartIndex) => {
  const queryKey = (0,react.useMemo)(() => ["translateWord", context, wordStartIndex], [context, wordStartIndex]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(wordStartIndex !== null && context),
    queryKey,
    queryFn: () => {
      if (!context || wordStartIndex === null) {
        return;
      }
      return translateWord(context, wordStartIndex);
    },
    staleTime: 0,
    // При походе в gpt ответ может быть долгим и часто отваливается по таймауту,
    // в то же время на сервере обработка запроса не прекращается
    // и слово может быть добавлено в словарь уже после возвращения таймаута,
    // поэтому добавляем повторы чтобы достать сохраненный перевод
    retry: 5,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    throwOnError: false
  });
};
const useSaveWordToWordbank = () => (0,useMutation/* useMutation */.D)({
  mutationFn: _ref => {
    let {
      wordId,
      contextId,
      v2,
      params
    } = _ref;
    return saveWordToWordbank(wordId, contextId, v2, params);
  }
});
const useSaveWordVariantToWordbank = () => (0,useMutation/* useMutation */.D)({
  mutationFn: _ref2 => {
    let {
      id,
      word
    } = _ref2;
    return saveWordVariantToWordbank(id, word);
  }
});
const useDeleteWordFromWordbank = () => (0,useMutation/* useMutation */.D)({
  mutationFn: _ref3 => {
    let {
      termId,
      termType
    } = _ref3;
    return deleteTermFromWordbank(termId, termType);
  }
});
;// CONCATENATED MODULE: ./src/api/student/translations/translations.model.ts


var TermType = /* @__PURE__ */(TermType2 => {
  TermType2["Word"] = "word";
  TermType2["Highlight"] = "highlight";
  TermType2["Tooltip"] = "tooltip";
  return TermType2;
})(TermType || {});
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/hooks.ts
var hooks = __webpack_require__(62436);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/translation-tooltip-v2.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const translation_tooltip_v2_module = ({"translation-tooltip":"translation-tooltip-v2-module__translation-tooltip--O1Vd_","translationTooltip":"translation-tooltip-v2-module__translation-tooltip--O1Vd_","phrase":"translation-tooltip-v2-module__phrase--VMMQU","variants-open":"translation-tooltip-v2-module__variants-open--mhQtU","variantsOpen":"translation-tooltip-v2-module__variants-open--mhQtU","tail":"translation-tooltip-v2-module__tail--Jhd2J","container":"translation-tooltip-v2-module__container--TrP3o","translation-tooltip-content":"translation-tooltip-v2-module__translation-tooltip-content--avfHU","translationTooltipContent":"translation-tooltip-v2-module__translation-tooltip-content--avfHU","top-block":"translation-tooltip-v2-module__top-block--Flk0q","topBlock":"translation-tooltip-v2-module__top-block--Flk0q","translatable-word":"translation-tooltip-v2-module__translatable-word--mFav1","translatableWord":"translation-tooltip-v2-module__translatable-word--mFav1","buttons-block":"translation-tooltip-v2-module__buttons-block--hc5eN","buttonsBlock":"translation-tooltip-v2-module__buttons-block--hc5eN","middle-block":"translation-tooltip-v2-module__middle-block--fXVbQ","middleBlock":"translation-tooltip-v2-module__middle-block--fXVbQ","translation":"translation-tooltip-v2-module__translation--Xbvqt","bottom-block":"translation-tooltip-v2-module__bottom-block--Pv2r3","bottomBlock":"translation-tooltip-v2-module__bottom-block--Pv2r3","highlight-bottom-block":"translation-tooltip-v2-module__highlight-bottom-block--AplM8","highlightBottomBlock":"translation-tooltip-v2-module__highlight-bottom-block--AplM8","bottom-buttons-block":"translation-tooltip-v2-module__bottom-buttons-block--AWwz4","bottomButtonsBlock":"translation-tooltip-v2-module__bottom-buttons-block--AWwz4","switch":"translation-tooltip-v2-module__switch--OUYrJ","translate":"translation-tooltip-v2-module__translate--uOFPl","add-to-wordbank-button":"translation-tooltip-v2-module__add-to-wordbank-button--bG_bz","addToWordbankButton":"translation-tooltip-v2-module__add-to-wordbank-button--bG_bz","highlight":"translation-tooltip-v2-module__highlight--VWAhv","added-to-wordbank":"translation-tooltip-v2-module__added-to-wordbank--an2_t","addedToWordbank":"translation-tooltip-v2-module__added-to-wordbank--an2_t","gpt-icon":"translation-tooltip-v2-module__gpt-icon--CM_3j","gptIcon":"translation-tooltip-v2-module__gpt-icon--CM_3j"});
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/highlight-tooltip-content.tsx

















const HighlightTooltipContent = _ref => {
  let {
    selection,
    translationContext
  } = _ref;
  const {
    data,
    isLoading
  } = useTranslateHighlightQuery(selection, translationContext);
  const [isAddedToWordbank, setIsAddedToWordbank] = (0,react.useState)(false);
  const [saving, setSaving] = (0,react.useState)(false);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    params
  } = (0,react_router/* useRouteMatch */.$B)();
  const {
    play
  } = (0,hooks/* usePlayTextToSpeech */.l)(selection, {
    enablePlayOnMount: false
  });
  (0,react.useEffect)(() => {
    if (!data) {
      return;
    }
    setIsAddedToWordbank(data.isInWordbank);
  }, [data]);
  const translation = isLoading && !data ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
    id: "translatableText.loading"
  }) : data?.translation || "";
  const isAddToWordbankButtonDisabled = !data || isLoading;
  const handleClickSpeakerButton = () => {
    void play(selection);
  };
  const handleClickWordbankButton = async () => {
    if (!data) {
      return;
    }
    if (!isAddedToWordbank) {
      setSaving(true);
      try {
        await saveHighlightToWordbank(data.highlightId, data.contextId, params);
        setIsAddedToWordbank(true);
      } catch (error) {
        logger/* Logger */.Yd.captureError("Error saving highlight in wordbank", {
          error,
          data
        }, {
          block: "TranslationTooltipV2/Phrase",
          method: "handleClickWordbankButton"
        });
      } finally {
        setSaving(false);
      }
    } else {
      setSaving(true);
      try {
        await deleteTermFromWordbank(data.highlightId.toString(), TermType.Highlight);
        setIsAddedToWordbank(false);
      } catch (error) {
        logger/* Logger */.Yd.captureError("Error deleting highlight from wordbank", {
          error,
          data
        }, {
          block: "TranslationTooltipV2/Phrase",
          method: "handleClickWordbankButton"
        });
      } finally {
        setSaving(false);
      }
    }
  };
  const buttons = /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: translation_tooltip_v2_module.buttonsBlock,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      size: "small-circle",
      appearance: "secondaryOnBlack",
      onClick: handleClickSpeakerButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "speaker",
        size: "small"
      })
    })
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: translation_tooltip_v2_module.topBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.body2, translation_tooltip_v2_module.translation),
        children: translation
      }), !isMobile && buttons]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: translation_tooltip_v2_module.highlightBottomBlock,
      children: [isMobile && buttons, /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "secondaryOnBlack",
        size: "small",
        className: classnames_default()(translation_tooltip_v2_module.addToWordbankButton, translation_tooltip_v2_module.highlight),
        disabled: isAddToWordbankButtonDisabled,
        loading: saving,
        onClick: handleClickWordbankButton,
        children: !isAddedToWordbank ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "translatableText.addToWordbank"
        }) : /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: translation_tooltip_v2_module.addedToWordbank,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: "checkmark",
            size: "small"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "translatableText.addedToWordbank"
          })]
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/utils/is-safari.ts
var is_safari = __webpack_require__(66415);
// EXTERNAL MODULE: ../shared/src/utils/storage/index.ts + 4 modules
var storage = __webpack_require__(81597);
// EXTERNAL MODULE: ../ui-kit/src/switch/switch.component.tsx + 1 modules
var switch_component = __webpack_require__(5714);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/constants.ts


const DELIMITER = " \u2022 ";
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/variant/custom-markdown/rules.tsx




const bracketRule = {
  order: (simple_markdown_default()).defaultRules.text.order - 0.5,
  match: source => /^<([^>]+)>/.exec(source),
  parse: capture => ({
    content: capture[1]
  }),
  react: (node, output, state) => /* @__PURE__ */(0,jsx_runtime.jsx)("strong", {
    children: node.content
  }, state.key)
};
const rules = {
  bracketBold: bracketRule,
  text: (simple_markdown_default()).defaultRules.text
};
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/variant/custom-markdown/custom-markdown.tsx






const CustomMarkdown = _ref => {
  let {
    children
  } = _ref;
  const parser = simple_markdown_default().parserFor(rules);
  const reactOutput = (0,react.useMemo)(() => markdown_component/* CustomSimpleMarkdown */.fB.reactFor(markdown_component/* CustomSimpleMarkdown */.fB.ruleOutput(rules, "react")), []);
  return reactOutput(parser(children, {
    inline: true
  }));
};
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/variant/hint-tooltip/hint-tooltip.tsx






const HintTooltip = _ref => {
  let {
    type,
    isVisible,
    children
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const text = (0,react.useMemo)(() => type === "add" ? intl.formatMessage({
    id: "translatableText.addToWordbank"
  }) : intl.formatMessage({
    id: "translatableText.addedInWordbank"
  }), [intl, type]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    overlay: text,
    visible: isVisible,
    smallOverlay: true,
    autoWidth: true,
    showArrow: false,
    trigger: "hover",
    align: {
      offset: [4, 0]
    },
    placement: "left",
    children
  });
};
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/variant/variant.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const variant_module = ({"wrapper":"variant-module__wrapper--F3tui","translation-block":"variant-module__translation-block--E913M","translationBlock":"variant-module__translation-block--E913M","example":"variant-module__example--jdjgO","example-translation":"variant-module__example-translation--_P5oP","exampleTranslation":"variant-module__example-translation--_P5oP"});
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/variant/variant.tsx













const Variant = _ref => {
  let {
    popup,
    variant: {
      id,
      translation,
      context,
      contextTranslation,
      wordId: wordIdFromProps
    }
  } = _ref;
  const [wordId, setWordId] = (0,react.useState)(wordIdFromProps);
  const {
    mutate: mutateSave,
    isPending: isPendingSave
  } = useSaveWordVariantToWordbank();
  const {
    mutate: mutateDelete,
    isPending: isPendingDelete
  } = useDeleteWordFromWordbank();
  const [isHintTooltipVisible, setIsHintTooltipVisible] = (0,react.useState)(false);
  const isPending = isPendingDelete || isPendingSave;
  const addWordToWordbank = () => {
    setIsHintTooltipVisible(false);
    mutateSave({
      id,
      word: popup
    }, {
      onSuccess: _ref2 => {
        let {
          wordId: wordId2
        } = _ref2;
        setWordId(wordId2);
      },
      onError: error => {
        logger/* Logger */.Yd.captureException("Error saving word variant to wordbank", {
          error,
          popup,
          id
        }, {
          block: "Variant",
          method: "addWordToWordbank"
        });
      }
    });
  };
  const removeWordFromWordbank = () => {
    setIsHintTooltipVisible(false);
    if (!wordId) {
      return;
    }
    mutateDelete({
      termId: wordId.toString(),
      termType: TermType.Word
    }, {
      onSuccess: () => {
        setWordId(null);
      },
      onError: error => {
        logger/* Logger */.Yd.captureException("Error deleting word variant from wordbank", {
          error,
          wordId,
          id
        }, {
          block: "Variant",
          method: "removeWordFromWordbank"
        });
      }
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: variant_module.wrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: variant_module.translationBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2Accent,
        children: translation
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(HintTooltip, {
        type: wordId ? "remove" : "add",
        isVisible: isHintTooltipVisible,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          loading: isPending,
          size: "small",
          appearance: "secondary",
          iconName: wordId ? "checkmark" : "plus",
          onClick: wordId ? removeWordFromWordbank : addWordToWordbank,
          onMouseOver: () => setIsHintTooltipVisible(true),
          onMouseOut: () => setIsHintTooltipVisible(false)
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: variant_module.example,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CustomMarkdown, {
          children: context
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.body2, variant_module.exampleTranslation),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CustomMarkdown, {
          children: contextTranslation
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/word-variants-panel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const word_variants_panel_module = ({"overlay":"word-variants-panel-module__overlay--cSaMG","wrapper":"word-variants-panel-module__wrapper--DyTeI","open":"word-variants-panel-module__open--yKDFQ","close-button":"word-variants-panel-module__close-button--WIBJA","closeButton":"word-variants-panel-module__close-button--WIBJA","word-wrapper":"word-variants-panel-module__word-wrapper--f69a_","wordWrapper":"word-variants-panel-module__word-wrapper--f69a_","block":"word-variants-panel-module__block--hHLfu","word-block":"word-variants-panel-module__word-block--rwBIP","wordBlock":"word-variants-panel-module__word-block--rwBIP","text":"word-variants-panel-module__text--Ah8zg","add-to-wordbank-button":"word-variants-panel-module__add-to-wordbank-button--m_BDo","addToWordbankButton":"word-variants-panel-module__add-to-wordbank-button--m_BDo","highlight":"word-variants-panel-module__highlight--wH_cK","added-to-wordbank":"word-variants-panel-module__added-to-wordbank--UHJ2h","addedToWordbank":"word-variants-panel-module__added-to-wordbank--UHJ2h","variants-title":"word-variants-panel-module__variants-title--DKC8B","variantsTitle":"word-variants-panel-module__variants-title--DKC8B","variants":"word-variants-panel-module__variants--gsDQB"});
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-variants-panel/word-variants-panel.tsx


















const WordVariantsPanel = _ref => {
  let {
    isOpen,
    isWordInWordbank,
    isWordSaving,
    word: {
      variants,
      translation,
      transcription,
      popup,
      partOfSpeechTankerKey,
      definition
    },
    onWordbankButtonClick,
    onClose
  } = _ref;
  const {
    play
  } = (0,hooks/* usePlayTextToSpeech */.l)("", {
    enablePlayOnMount: false
  });
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const partOfSpeech = partOfSpeechTankerKey && /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
    id: partOfSpeechTankerKey
  });
  (0,useKeyPress/* useKeyPress */.K)("Escape", onClose);
  const handleClickSpeakerButton = () => {
    void play(popup);
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isOpen && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(use_block_main_scroll/* MainScrollBlocker */.j, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        role: "presentation",
        tabIndex: -1,
        onClick: onClose,
        className: word_variants_panel_module.overlay
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("dialog", {
      open: isOpen,
      className: classnames_default()(word_variants_panel_module.wrapper, {
        [word_variants_panel_module.open]: isOpen
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: isMobile ? "secondary" : "default",
        size: isMobile ? "small" : "medium",
        className: word_variants_panel_module.closeButton,
        iconName: "cross",
        onClick: onClose
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: word_variants_panel_module.wordWrapper,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: word_variants_panel_module.block,
          children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: word_variants_panel_module.wordBlock,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.headline4,
              children: popup
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
              size: "small-circle",
              appearance: "tertiary",
              onClick: handleClickSpeakerButton,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
                name: "speaker",
                size: "medium"
              })
            })]
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
            className: typography_module/* default */.Z.body2,
            children: [transcription && `[${transcription}]`, transcription && partOfSpeech && DELIMITER, partOfSpeech]
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: word_variants_panel_module.block,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: classnames_default()(typography_module/* default */.Z.body1Accent, word_variants_panel_module.text),
            children: translation
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: classnames_default()(typography_module/* default */.Z.body2, word_variants_panel_module.text),
            children: definition
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "secondary",
          size: isMobile ? "medium" : "small",
          className: word_variants_panel_module.addToWordbankButton,
          loading: isWordSaving,
          onClick: onWordbankButtonClick,
          children: !isWordInWordbank ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "translatableText.addToWordbank"
          }) : /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
            className: word_variants_panel_module.addedToWordbank,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              name: "checkmark",
              size: "small"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "translatableText.addedToWordbank"
            })]
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.body2Accent, word_variants_panel_module.variantsTitle),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "translationTooltip.variants.examples"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: word_variants_panel_module.variants,
        children: variants.map(variant => /* @__PURE__ */(0,jsx_runtime.jsx)(Variant, {
          variant,
          popup
        }, variant.id))
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/components/word-tooltip.tsx






















const WordTooltip = _ref => {
  let {
    selection,
    translationContext,
    wordRef,
    containerRef,
    blockKey
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [isPanelOpen, setPanelOpen] = (0,react.useState)(false);
  const [isTranslationOn, setIsTranslationOn] = (0,react.useState)(storage/* localStorageWrapper */.Y6.translation.isOn());
  const {
    selectionStartIndex
  } = (0,store/* useSelectionStore */.f)();
  const {
    data,
    isLoading
  } = useTranslateWordQuery(translationContext, selectionStartIndex);
  const [isAddedToWordbank, setIsAddedToWordbank] = (0,react.useState)(false);
  const {
    mutate: mutateDelete,
    isPending: isPendingDelete
  } = useDeleteWordFromWordbank();
  const {
    mutate: mutateSave,
    isPending: isPendingSave
  } = useSaveWordToWordbank();
  const isSaving = isPendingSave || isPendingDelete;
  (0,react.useEffect)(() => {
    if (!data) {
      return;
    }
    setIsAddedToWordbank(data.isInWordbank);
  }, [data]);
  const {
    play
  } = (0,hooks/* usePlayTextToSpeech */.l)(data?.popup, {
    enablePlayOnMount: true,
    initPlayer: (0,is_safari/* isSafariBrowser */.f)()
  });
  const handleClickSpeakerButton = () => {
    void play(data?.popup || selection);
  };
  const handleSwitchTranslation = () => {
    if (storage/* localStorageWrapper */.Y6.translation.isOn()) {
      storage/* localStorageWrapper */.Y6.translation.setOff();
    } else {
      storage/* localStorageWrapper */.Y6.translation.setOn();
    }
    setIsTranslationOn(storage/* localStorageWrapper */.Y6.translation.isOn());
  };
  const isPhrase = data?.partOfSpeechTankerKey === "translationTooltip.phrase";
  const transcription = !isPhrase && data?.transcription;
  const translation = isTranslationOn ? data?.translation : data?.definition;
  const partOfSpeech = data && data.partOfSpeechTankerKey && /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
    id: data?.partOfSpeechTankerKey
  });
  const shouldShowTranscriptionBlock = data && (data?.transcription || data?.partOfSpeechTankerKey);
  const isVariantsButtonDisabled = !data || data.variants.length === 0;
  const isAddToWordbankButtonDisabled = !data || isLoading;
  const word = !data || !data.popup ? selection : data.popup;
  const isV2 = data?.v2;
  const handleClickWordbankButton = () => {
    if (!data) {
      return;
    }
    if (!isAddedToWordbank) {
      mutateSave({
        wordId: data.wordId,
        contextId: data.contextId,
        v2: data.v2,
        params: blockKey
      }, {
        onSuccess: () => {
          setIsAddedToWordbank(true);
        },
        onError: error => {
          logger/* Logger */.Yd.captureError("Error saving word in wordbank", {
            error,
            data
          }, {
            block: "TranslationTooltipV2/Word",
            method: "handleClickWordbankButton"
          });
        }
      });
    } else {
      mutateDelete({
        termId: data.wordId.toString(),
        termType: TermType.Word
      }, {
        onSuccess: () => {
          setIsAddedToWordbank(false);
        },
        onError: error => {
          logger/* Logger */.Yd.captureError("Error deleting word from wordbank", {
            error,
            data
          }, {
            block: "TranslationTooltipV2/Word",
            method: "handleClickWordbankButton"
          });
        }
      });
    }
  };
  const handleClickVariantsButton = () => {
    setPanelOpen(true);
  };
  const buttons = /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: translation_tooltip_v2_module.buttonsBlock,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      size: "small-circle",
      appearance: "secondaryOnBlack",
      disabled: isVariantsButtonDisabled,
      onClick: handleClickVariantsButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "book",
        size: "small"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      size: "small-circle",
      appearance: "secondaryOnBlack",
      onClick: handleClickSpeakerButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "speaker",
        size: "small"
      })
    })]
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(tooltip_simple/* TooltipSimple */.w, {
    targetRef: wordRef,
    className: classnames_default()(translation_tooltip_v2_module.translationTooltip, {
      [translation_tooltip_v2_module.variantsOpen]: isPanelOpen
    }),
    tailClassName: translation_tooltip_v2_module.tail,
    containerRef,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: translation_tooltip_v2_module.container,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: translation_tooltip_v2_module.topBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(translation_tooltip_v2_module.translatableWord, typography_module/* default */.Z.headline4),
          children: word
        }), !isMobile && buttons]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(typography_module/* default */.Z.caption, translation_tooltip_v2_module.middleBlock),
        children: [!data ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "translatableText.loading"
        }) : shouldShowTranscriptionBlock && /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          children: [transcription && `[${transcription}]`, transcription && partOfSpeech && DELIMITER, partOfSpeech]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(isMobile ? typography_module/* default */.Z.caption : typography_module/* default */.Z.body2, translation_tooltip_v2_module.translation),
          children: !data ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            tagName: "span",
            id: "translatableText.loading"
          }) : translation
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: translation_tooltip_v2_module.bottomBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: translation_tooltip_v2_module.switch,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(switch_component/* Switch */.r, {
            appearance: "primaryOnBlack",
            size: "small",
            disabled: isLoading,
            checked: isTranslationOn,
            onChange: handleSwitchTranslation
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: translation_tooltip_v2_module.translate,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.captionAccent,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "translatableText.translate"
              })
            }), isV2 && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              className: translation_tooltip_v2_module.gptIcon,
              name: "yandex-gpt",
              size: "tiny"
            })]
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: translation_tooltip_v2_module.bottomButtonsBlock,
          children: [isMobile && buttons, /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "secondaryOnBlack",
            size: "small",
            className: translation_tooltip_v2_module.addToWordbankButton,
            disabled: isAddToWordbankButtonDisabled,
            loading: isSaving,
            onClick: handleClickWordbankButton,
            children: !isAddedToWordbank ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "translatableText.addToWordbank"
            }) : /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
              className: translation_tooltip_v2_module.addedToWordbank,
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
                name: "checkmark",
                size: "small"
              }), /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
                id: "translatableText.addedToWordbank"
              })]
            })
          })]
        })]
      })]
    }), !isVariantsButtonDisabled && /* @__PURE__ */(0,jsx_runtime.jsx)(WordVariantsPanel, {
      isOpen: isPanelOpen,
      isWordInWordbank: isAddedToWordbank,
      isWordSaving: isSaving,
      word: data,
      onClose: () => setPanelOpen(false),
      onWordbankButtonClick: handleClickWordbankButton
    })]
  });
};
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/types.ts
var types = __webpack_require__(1692);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip-v2/translation-tooltip-v2.tsx










const TranslationTooltipV2 = _ref => {
  let {
    selection,
    type,
    containerRef,
    wordRef,
    blockKey
  } = _ref;
  const {
    context
  } = (0,store/* useSelectionStore */.f)();
  const isWord = type === types/* TranslationType */.r.Word;
  const isPhrase = type === types/* TranslationType */.r.Highlight;
  if (!context) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: isWord ? /* @__PURE__ */(0,jsx_runtime.jsx)(WordTooltip, {
      wordRef,
      containerRef,
      selection,
      translationContext: context,
      blockKey
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_simple/* TooltipSimple */.w, {
      targetRef: wordRef,
      className: classnames_default()(translation_tooltip_v2_module.translationTooltip, {
        [translation_tooltip_v2_module.phrase]: isPhrase
      }),
      tailClassName: translation_tooltip_v2_module.tail,
      containerRef,
      children: isPhrase && /* @__PURE__ */(0,jsx_runtime.jsx)(HighlightTooltipContent, {
        selection,
        translationContext: context
      })
    })
  });
};

/***/ }),

/***/ 1692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ TranslationType)
/* harmony export */ });


var TranslationType = /* @__PURE__ */(TranslationType2 => {
  TranslationType2["Highlight"] = "highlight";
  TranslationType2["Word"] = "word";
  return TranslationType2;
})(TranslationType || {});

/***/ }),

/***/ 73766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  N: () => (/* binding */ translationTooltipRule)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
// EXTERNAL MODULE: ../ui-kit/src/markdown/regexp.ts
var regexp = __webpack_require__(30095);
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-translation-v2-enabled.ts
var use_translation_v2_enabled = __webpack_require__(3832);
// EXTERNAL MODULE: ./src/components/translatable-text/word/translatable-word.tsx + 7 modules
var translatable_word = __webpack_require__(77703);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip/translation-tooltip-rule.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const translation_tooltip_rule_module = ({"tooltip":"translation-tooltip-rule-module__tooltip--ulKa8"});
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip/translation-tooltip-rule.tsx









const translationTooltipRule = {
  tooltip: {
    order: 0,
    match: simple_markdown_default().inlineRegex(regexp/* TRANSLATION_SYNTAX_REGEXP */.Up),
    parse(capture, _, state) {
      state.key = Number(state.key || 0) + 1;
      return {
        beforeContent: capture[1],
        visibleValue: capture[2],
        punctuationMark: capture[4],
        spaces: capture[5],
        translation: capture[3],
        key: state.key
      };
    },
    react: node => {
      const {
        beforeContent,
        visibleValue,
        punctuationMark,
        spaces,
        translation,
        key
      } = node;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: translation_tooltip_rule_module.tooltip,
          children: [beforeContent, /* @__PURE__ */(0,jsx_runtime.jsx)(TranslatableWordTooltip, {
            translation,
            children: visibleValue
          }), punctuationMark]
        }, key), spaces]
      });
    }
  }
};
const TranslatableWordTooltip = _ref => {
  let {
    children,
    translation
  } = _ref;
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const handleFetchTranslation = (0,react.useCallback)(() => Promise.resolve({
    id: "",
    word: children,
    addedInWordbank: false,
    partOfSpeech: "",
    translations: [translation],
    context: ""
  }), [children, translation]);
  if (isTranslationV2Enabled) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(translatable_word/* TranslatableWord */.$, {
    fetchTranslation: handleFetchTranslation,
    hideAddToWordbankButton: true,
    children
  });
};

/***/ }),

/***/ 77703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $: () => (/* binding */ TranslatableWord)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-translation-v2-enabled.ts
var use_translation_v2_enabled = __webpack_require__(3832);
// EXTERNAL MODULE: ./src/components/selection-translation/store/store.ts
var store = __webpack_require__(9266);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/tooltip-simple/tooltip-simple.tsx + 1 modules
var tooltip_simple = __webpack_require__(45451);
;// CONCATENATED MODULE: ./src/components/translatable-text/actions-tooltip/actions-tooltip.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const actions_tooltip_module = ({"actions-tooltip":"actions-tooltip-module__actions-tooltip--tYRv1","actionsTooltip":"actions-tooltip-module__actions-tooltip--tYRv1","tail":"actions-tooltip-module__tail--BaIvZ","actions-tooltip-content":"actions-tooltip-module__actions-tooltip-content--vserX","actionsTooltipContent":"actions-tooltip-module__actions-tooltip-content--vserX"});
;// CONCATENATED MODULE: ./src/components/translatable-text/actions-tooltip/actions-tooltip.tsx






const ActionsTooltip = _ref => {
  let {
    wordRef,
    textConstants,
    onTranslateClick,
    onScrollClick,
    containerRef
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_simple/* TooltipSimple */.w, {
    targetRef: wordRef,
    className: actions_tooltip_module.actionsTooltip,
    tailClassName: actions_tooltip_module.tail,
    containerRef,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: actions_tooltip_module.actionsTooltipContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        size: "small",
        appearance: "secondaryOnBlack",
        onClick: onTranslateClick,
        children: textConstants?.translateButtonText ?? "Translate"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        size: "small",
        appearance: "secondaryOnBlack",
        onClick: onScrollClick,
        children: textConstants?.scrollButtonText ?? "Scroll"
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/use-audio-control.ts
var use_audio_control = __webpack_require__(25834);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip/translation-tooltip.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const translation_tooltip_module = ({"translation-tooltip":"translation-tooltip-module__translation-tooltip--NT0ns","translationTooltip":"translation-tooltip-module__translation-tooltip--NT0ns","translation-tooltip-content":"translation-tooltip-module__translation-tooltip-content--aTUZ3","translationTooltipContent":"translation-tooltip-module__translation-tooltip-content--aTUZ3","translatable-word":"translation-tooltip-module__translatable-word--ovDQi","translatableWord":"translation-tooltip-module__translatable-word--ovDQi","translatable-word-text":"translation-tooltip-module__translatable-word-text--Qerba","translatableWordText":"translation-tooltip-module__translatable-word-text--Qerba","translatable-word-icon":"translation-tooltip-module__translatable-word-icon--VDGUY","translatableWordIcon":"translation-tooltip-module__translatable-word-icon--VDGUY","waiting-cursor":"translation-tooltip-module__waiting-cursor--WtRU0","waitingCursor":"translation-tooltip-module__waiting-cursor--WtRU0","part-of-speech":"translation-tooltip-module__part-of-speech--lwr6I","partOfSpeech":"translation-tooltip-module__part-of-speech--lwr6I","translations":"translation-tooltip-module__translations--dzT8m","action-button":"translation-tooltip-module__action-button--spsPo","actionButton":"translation-tooltip-module__action-button--spsPo","close-icon":"translation-tooltip-module__close-icon--Ch8kk","closeIcon":"translation-tooltip-module__close-icon--Ch8kk"});
;// CONCATENATED MODULE: ./src/components/translatable-text/translation-tooltip/translation-tooltip.tsx












const TranslationTooltip = _ref => {
  let {
    word,
    partOfSpeech,
    translations,
    addedToWordbank,
    textConstants,
    hideAddToWordbankButton,
    containerRef,
    wordRef,
    onPlayTextToSpeech,
    onWordbankButtonClick,
    onClose
  } = _ref;
  const {
    canPlay
  } = (0,use_audio_control/* useAudioControl */.b)("wordbank");
  const loading = (0,react.useMemo)(() => !translations?.length, [translations?.length]);
  const [saving, setSaving] = (0,react.useState)(false);
  const [playing, setPlaying] = (0,react.useState)(false);
  const handlePlayClick = (0,react.useCallback)(async e => {
    e.stopPropagation();
    try {
      setPlaying(true);
      await onPlayTextToSpeech?.(word);
    } catch (e2) {
      console.error("[TranslationTooltip] Failed to play audio", e2);
    } finally {
      setPlaying(false);
    }
  }, [onPlayTextToSpeech, word]);
  const handleWordbankButtonClick = (0,react.useCallback)(async e => {
    e.stopPropagation();
    setSaving(true);
    const success = await onWordbankButtonClick?.();
    if (!success) {
      console.error("[TranslationTooltip] Failed to add/remove word to wordbank");
    }
    setSaving(false);
  }, [onWordbankButtonClick]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_simple/* TooltipSimple */.w, {
    targetRef: wordRef,
    className: translation_tooltip_module.translationTooltip,
    containerRef,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: translation_tooltip_module.translationTooltipContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: translation_tooltip_module.translatableWord,
        children: [onPlayTextToSpeech && /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
          type: "button",
          disabled: !canPlay || loading || playing,
          className: classnames_default()(translation_tooltip_module.translatableWordIcon, {
            [translation_tooltip_module.waitingCursor]: playing
          }),
          onClick: handlePlayClick,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            size: "medium",
            name: "speaker"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(translation_tooltip_module.translatableWordText, typography_module/* default */.Z.headline4Accent),
          children: word
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          className: translation_tooltip_module.closeIcon,
          appearance: "primary",
          size: "medium",
          iconName: "cross",
          onClick: e => {
            e.stopPropagation();
            onClose();
          }
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(translation_tooltip_module.partOfSpeech, typography_module/* default */.Z.body2),
        children: partOfSpeech ?? textConstants?.loadingText
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(translation_tooltip_module.translations, typography_module/* default */.Z.body2),
        children: translations?.join(", ") ?? textConstants?.loadingText
      }), !hideAddToWordbankButton && onWordbankButtonClick && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        className: classnames_default()(typography_module/* default */.Z.captionAccent, translation_tooltip_module.actionButton, {
          [translation_tooltip_module.waitingCursor]: saving
        }),
        size: "small",
        disabled: loading || saving,
        appearance: "secondaryOnBlack",
        onClick: handleWordbankButtonClick,
        children: addedToWordbank ? textConstants?.addedWordActionButtonText ?? "Remove from wordbank" : textConstants?.notAddedWordActionButtonText ?? "Add to wordbank"
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/translation-tooltip-v2.tsx + 17 modules
var translation_tooltip_v2 = __webpack_require__(66553);
// EXTERNAL MODULE: ./src/components/translatable-text/translation-tooltip-v2/types.ts
var types = __webpack_require__(1692);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
;// CONCATENATED MODULE: ./src/components/translatable-text/word/word.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const word_module = ({"root":"word-module__root--ad8nU","hovered":"word-module__hovered--eQA43","highlighted":"word-module__highlighted--S6vkm","active":"word-module__active--HJj1_"});
;// CONCATENATED MODULE: ./src/components/translatable-text/word/word.component.tsx








const Word = (0,react.forwardRef)((_ref, ref) => {
  let {
    onClick = function_utils/* emptyFunction */.Bi,
    onMouseEnter,
    onMouseLeave,
    children,
    typography,
    active = false,
    hovered,
    highlighted
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    ref,
    "data-hovered": hovered,
    "data-highlight": active || highlighted,
    className: classnames_default()(word_module.root, typography && typography_module/* default */.Z[typography], {
      [word_module.highlighted]: !active && highlighted,
      [word_module.hovered]: !active && !highlighted && hovered,
      [word_module.active]: active
    }),
    onClick,
    onMouseEnter,
    onMouseLeave,
    "data-translation": "word",
    children
  });
});
Word.displayName = "Word";
;// CONCATENATED MODULE: ./src/components/translatable-text/word/translatable-word.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const translatable_word_module = ({"root":"translatable-word-module__root--G7M5Q"});
;// CONCATENATED MODULE: ./src/components/translatable-text/word/translatable-word.tsx














const TranslatableWord = (0,react.memo)(_ref => {
  let {
    containerRef,
    children,
    typography,
    blockKey,
    hasActionsTooltip,
    textConstants,
    autoPlay = true,
    hideAddToWordbankButton = false,
    hovered,
    highlighted,
    highlightingNotifier,
    fetchTranslation,
    onPlayTextToSpeech,
    onAddWord,
    onDeleteWord,
    onHover,
    onLeave,
    onHighlight,
    onTranslate,
    onScroll,
    onClose
    // eslint-disable-next-line sonarjs/cognitive-complexity
  } = _ref;
  const {
    setIsTooltipVisible: setTooltipV2Active
  } = (0,store/* useSelectionStore */.f)();
  const rootRef = (0,react.useRef)(null);
  const wordRef = (0,react.useRef)(null);
  const [tooltipVisible, setTooltipVisible] = (0,react.useState)(false);
  const [showActionsTooltip, setShowActionsTooltip] = (0,react.useState)(hasActionsTooltip);
  const [translation, setTranslation] = (0,react.useState)(null);
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const fetchPromise = (0,react.useRef)(null);
  const loadTranslation = (0,react.useCallback)(async () => {
    if (!fetchPromise.current) {
      fetchPromise.current = fetchTranslation();
      await fetchPromise.current.then(translation2 => {
        setTranslation(translation2);
        if (autoPlay) {
          return onPlayTextToSpeech?.(children);
        }
      }).catch(() => {
        fetchPromise.current = null;
      });
    } else if (autoPlay) {
      return onPlayTextToSpeech?.(children);
    }
  }, [autoPlay, children, fetchTranslation, onPlayTextToSpeech]);
  const handleWordClick = (0,react.useCallback)(() => {
    const newTooltipVisible = !tooltipVisible;
    setTooltipVisible(newTooltipVisible);
    if (newTooltipVisible) {
      onHighlight?.();
      if (!showActionsTooltip && !isTranslationV2Enabled) {
        void loadTranslation();
      }
    } else {
      onClose?.();
    }
  }, [isTranslationV2Enabled, loadTranslation, onClose, onHighlight, showActionsTooltip, tooltipVisible]);
  const handleWordClickV2 = () => {
    const newTooltipVisible = !tooltipVisible;
    setTooltipVisible(newTooltipVisible);
    setTooltipV2Active(true);
    if (newTooltipVisible) {
      onHighlight?.();
    } else {
      onClose?.();
    }
  };
  const handleTranslateClick = (0,react.useCallback)(() => {
    setShowActionsTooltip(false);
    if (!isTranslationV2Enabled) {
      void loadTranslation();
      onTranslate?.();
    }
  }, [isTranslationV2Enabled, loadTranslation, onTranslate]);
  const handleScrollClick = (0,react.useCallback)(() => {
    onScroll?.();
  }, [onScroll]);
  const handleWordbankButtonClick = (0,react.useCallback)(async () => {
    if (!translation) {
      return false;
    }
    const result = translation.addedInWordbank ? await onDeleteWord?.(translation.id) : await onAddWord?.({
      termId: translation.id,
      context: translation.context
    });
    if (result) {
      setTranslation(prev => prev ? {
        ...prev,
        addedInWordbank: !translation.addedInWordbank
      } : null);
    }
    return result ?? false;
  }, [onAddWord, onDeleteWord, translation]);
  const handleClose = (0,react.useCallback)(() => {
    setTooltipVisible(false);
    setTooltipV2Active(false);
    setShowActionsTooltip(hasActionsTooltip);
    onClose?.();
  }, [hasActionsTooltip, onClose, setTooltipV2Active]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(rootRef, handleClose, {
    condition: tooltipVisible
  });
  (0,react.useEffect)(() => {
    if (tooltipVisible) {
      const stopHighlightByEsc = event => {
        if (event.code === "Escape") {
          handleClose();
        }
      };
      document.addEventListener("keydown", stopHighlightByEsc);
      return () => document.removeEventListener("keydown", stopHighlightByEsc);
    }
  }, [handleClose, tooltipVisible]);
  (0,react.useEffect)(() => highlightingNotifier?.subscribe(event => {
    switch (event.action) {
      case "translate":
        if (highlighted) {
          setTooltipVisible(true);
          setShowActionsTooltip(false);
          if (!isTranslationV2Enabled) {
            void loadTranslation();
          }
        } else {
          setTooltipVisible(false);
        }
        break;
      case "highlight":
        if (tooltipVisible) {
          setTooltipVisible(false);
        }
        break;
      case "reset":
        setTooltipVisible(false);
        break;
      case "scroll":
        rootRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        break;
      case "hover":
      case "leave":
        break;
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(event.action);
    }
  }), [highlighted, highlightingNotifier, isTranslationV2Enabled, loadTranslation, tooltipVisible]);
  const tooltip = showActionsTooltip ? /* @__PURE__ */(0,jsx_runtime.jsx)(ActionsTooltip, {
    wordRef,
    textConstants,
    onTranslateClick: handleTranslateClick,
    onScrollClick: handleScrollClick,
    containerRef
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(TranslationTooltip, {
    containerRef,
    wordRef,
    word: children,
    partOfSpeech: translation?.partOfSpeech,
    translations: translation?.translations,
    addedToWordbank: translation?.addedInWordbank ?? false,
    textConstants,
    hideAddToWordbankButton,
    onWordbankButtonClick: handleWordbankButtonClick,
    onPlayTextToSpeech,
    onClose: handleClose
  });
  const tooltipV2 = showActionsTooltip ? /* @__PURE__ */(0,jsx_runtime.jsx)(ActionsTooltip, {
    wordRef,
    textConstants,
    onTranslateClick: handleTranslateClick,
    onScrollClick: handleScrollClick,
    containerRef
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(translation_tooltip_v2/* TranslationTooltipV2 */.Q, {
    containerRef,
    wordRef,
    selection: children,
    type: types/* TranslationType */.r.Word,
    blockKey
  });
  const tooltipVersion = isTranslationV2Enabled ? tooltipV2 : tooltip;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
    ref: rootRef,
    className: translatable_word_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Word, {
      ref: wordRef,
      hovered,
      highlighted,
      active: tooltipVisible && !showActionsTooltip,
      onClick: isTranslationV2Enabled ? handleWordClickV2 : handleWordClick,
      onMouseEnter: onHover,
      onMouseLeave: onLeave,
      typography,
      children
    }), tooltipVisible && tooltipVersion]
  });
});
TranslatableWord.displayName = "TranslatableWord";

/***/ }),

/***/ 99833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  b: () => (/* binding */ Wordbank)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/index.ts + 5 modules
var useAudio = __webpack_require__(12745);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../ui-kit/src/bottom-sheet/bottom-sheet@light.component.tsx + 1 modules
var bottom_sheet_light_component = __webpack_require__(80814);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__card/types.ts


var WordbankCardType = /* @__PURE__ */(WordbankCardType2 => {
  WordbankCardType2["Dictionary"] = "dictionary";
  WordbankCardType2["TranslationEnToRu"] = "tranlationEnToRu";
  WordbankCardType2["TranslationRuToEn"] = "translationRuToEn";
  WordbankCardType2["Transcription"] = "translation";
  return WordbankCardType2;
})(WordbankCardType || {});
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(47933);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/use-audio-control.ts
var use_audio_control = __webpack_require__(25834);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__card/utils.ts


const containsAngleBrackets = inputString => /[<>]/.test(inputString);
const replaceAngleBracketsWithAsterisks = inputString => inputString.replace(/[<>]/g, "**");
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__card/wordbank-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const wordbank_card_module = ({"root":"wordbank-card-module__root--OoTYE","root-dictionary":"wordbank-card-module__root-dictionary--inB8P","rootDictionary":"wordbank-card-module__root-dictionary--inB8P","root-translator":"wordbank-card-module__root-translator--TKgAd","rootTranslator":"wordbank-card-module__root-translator--TKgAd","root-transcription":"wordbank-card-module__root-transcription--DuodA","rootTranscription":"wordbank-card-module__root-transcription--DuodA","root-expanded":"wordbank-card-module__root-expanded--xGCF4","rootExpanded":"wordbank-card-module__root-expanded--xGCF4","narrow-card-content":"wordbank-card-module__narrow-card-content--QTcY8","narrowCardContent":"wordbank-card-module__narrow-card-content--QTcY8","narrow-card-content-translator":"wordbank-card-module__narrow-card-content-translator--yZQGP","narrowCardContentTranslator":"wordbank-card-module__narrow-card-content-translator--yZQGP","speaker-button":"wordbank-card-module__speaker-button--AMKov","speakerButton":"wordbank-card-module__speaker-button--AMKov","second-column":"wordbank-card-module__second-column--NH8Dp","secondColumn":"wordbank-card-module__second-column--NH8Dp","second-column-term":"wordbank-card-module__second-column-term--eboSL","secondColumnTerm":"wordbank-card-module__second-column-term--eboSL","action-controls":"wordbank-card-module__action-controls--VMoj5","actionControls":"wordbank-card-module__action-controls--VMoj5","action-control":"wordbank-card-module__action-control--QX3sm","actionControl":"wordbank-card-module__action-control--QX3sm","secondary-text":"wordbank-card-module__secondary-text--cP0lX","secondaryText":"wordbank-card-module__secondary-text--cP0lX","context-text":"wordbank-card-module__context-text--x8PKg","contextText":"wordbank-card-module__context-text--x8PKg","context-text-translator":"wordbank-card-module__context-text-translator--tX3DG","contextTextTranslator":"wordbank-card-module__context-text-translator--tX3DG","source-link":"wordbank-card-module__source-link--bQqUB","sourceLink":"wordbank-card-module__source-link--bQqUB","source-link-content":"wordbank-card-module__source-link-content--tREjk","sourceLinkContent":"wordbank-card-module__source-link-content--tREjk","source-link-comment":"wordbank-card-module__source-link-comment--KtxOG","sourceLinkComment":"wordbank-card-module__source-link-comment--KtxOG","repetition-info":"wordbank-card-module__repetition-info--UdFkp","repetitionInfo":"wordbank-card-module__repetition-info--UdFkp","repetition-info-text":"wordbank-card-module__repetition-info-text--YuV_T","repetitionInfoText":"wordbank-card-module__repetition-info-text--YuV_T","add-date-info":"wordbank-card-module__add-date-info--SbFpn","addDateInfo":"wordbank-card-module__add-date-info--SbFpn","icon":"wordbank-card-module__icon--pQSHx","add-date-info-text":"wordbank-card-module__add-date-info-text--tinzA","addDateInfoText":"wordbank-card-module__add-date-info-text--tinzA","add-note-button":"wordbank-card-module__add-note-button--rItg2","addNoteButton":"wordbank-card-module__add-note-button--rItg2","expandable-content":"wordbank-card-module__expandable-content--P9vTl","expandableContent":"wordbank-card-module__expandable-content--P9vTl","expandable-content-hidden":"wordbank-card-module__expandable-content-hidden--elTso","expandableContentHidden":"wordbank-card-module__expandable-content-hidden--elTso","trash-button-icon":"wordbank-card-module__trash-button-icon--a2_Fg","trashButtonIcon":"wordbank-card-module__trash-button-icon--a2_Fg","mobile-action-buttons":"wordbank-card-module__mobile-action-buttons--ckTCc","mobileActionButtons":"wordbank-card-module__mobile-action-buttons--ckTCc","primary-button-mobile":"wordbank-card-module__primary-button-mobile--bb_z8","primaryButtonMobile":"wordbank-card-module__primary-button-mobile--bb_z8"});
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__card/wordbank-card.component.tsx



















const WordbankCard = _ref => {
  let {
    term,
    type = WordbankCardType.Dictionary,
    translations = [],
    isInWordbank,
    partOfSpeech = "",
    transcription = "",
    primaryButtonTitle = "",
    onPrimaryButtonClick = function_utils/* emptyPromiseFunction */._,
    expandButton = {
      opened: "",
      closed: ""
    },
    onDelete = function_utils/* emptyPromiseFunction */._,
    context = "",
    reference,
    updateDateText = "",
    onClickTextToSpeech = function_utils/* emptyFunction */.Bi,
    onClick = function_utils/* emptyFunction */.Bi,
    useNativeReferenceLink = false,
    isMobile = false,
    learned = false
  } = _ref;
  const [expanded, setExpanded] = (0,react.useState)(false);
  const [isVisibleActionControls, setIsVisibleActionControls] = (0,react.useState)(false);
  const [primaryIsLoading, setPrimaryIsLoading] = (0,react.useState)(false);
  const [deleteIsLoading, setDeleteIsLoading] = (0,react.useState)(false);
  const {
    canPlay
  } = (0,use_audio_control/* useAudioControl */.b)("wordbank");
  const highlightTermInContext = (0,react.useCallback)((term2, context2) => {
    if (containsAngleBrackets(context2)) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: replaceAngleBracketsWithAsterisks(context2)
      });
    }
    const regexpTerm = new RegExp(`${term2}\\w*`, "ig");
    const words = context2.match(regexpTerm);
    if (words) {
      words.forEach(word => {
        const regexpWord = new RegExp(`\\W${word}\\W`, "ig");
        context2 = context2.replace(regexpWord, ` **${word}** `);
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      children: context2
    });
  }, []);
  const renderDesktopActionControls = (0,react.useCallback)(() => {
    if (!isVisibleActionControls && !expanded) {
      return null;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: wordbank_card_module.actionControls,
      children: [type === WordbankCardType.Dictionary && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: classnames_default()(typography_module/* default */.Z.captionAccent, wordbank_card_module.actionControl),
          appearance: "primary",
          size: "small",
          onClick: e => {
            e.stopPropagation();
            setPrimaryIsLoading(true);
            void onPrimaryButtonClick(learned).finally(() => {
              setPrimaryIsLoading(false);
            });
          },
          disabled: primaryIsLoading,
          children: primaryIsLoading ? /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {
            size: loader_component/* LoaderSize */.gI.Small
          }) : primaryButtonTitle
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: classnames_default()(typography_module/* default */.Z.captionAccent, wordbank_card_module.actionControl),
          appearance: "tertiary",
          size: "small",
          onClick: e => {
            e.stopPropagation();
            setExpanded(prev => !prev);
          },
          children: expanded ? expandButton.opened : expandButton.closed
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          onClick: e => {
            setDeleteIsLoading(true);
            e.stopPropagation();
            return onDelete().finally(() => {
              setDeleteIsLoading(false);
            });
          },
          disabled: deleteIsLoading,
          className: wordbank_card_module.actionControl,
          appearance: "secondary",
          size: "small",
          iconName: "small-trash"
        })]
      }), type === WordbankCardType.TranslationEnToRu && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        onClick: e => {
          e.stopPropagation();
          return onDelete();
        },
        className: wordbank_card_module.actionControl,
        appearance: "floating",
        size: "small",
        iconName: isInWordbank ? "small-trash" : "plus"
      })]
    });
  }, [deleteIsLoading, primaryIsLoading, expandButton.closed, expandButton.opened, expanded, isInWordbank, isVisibleActionControls, learned, onDelete, onPrimaryButtonClick, primaryButtonTitle, type]);
  const renderMobileActionControls = (0,react.useCallback)(() => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: wordbank_card_module.mobileActionButtons,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "default",
      disabled: true,
      size: "small",
      iconName: expanded ? "chevron-up" : "chevron-down",
      onClick: e => {
        e.stopPropagation();
        setExpanded(prev => !prev);
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "secondary",
      size: "small",
      iconName: "small-trash",
      className: wordbank_card_module.trashButtonIcon,
      onClick: e => {
        setDeleteIsLoading(true);
        e.stopPropagation();
        return onDelete().finally(() => {
          setDeleteIsLoading(false);
        });
      },
      disabled: deleteIsLoading
    })]
  }), [deleteIsLoading, expanded, onDelete]);
  if (type === WordbankCardType.Transcription) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(wordbank_card_module.rootTranscription),
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.body2Accent,
          children: term
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.body2,
          children: `[${transcription}]`
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: wordbank_card_module.actionControls,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          disabled: !canPlay,
          onClick: e => {
            e.stopPropagation();
            return onClickTextToSpeech(term);
          },
          className: wordbank_card_module.actionControl,
          appearance: "secondary",
          size: "small",
          iconName: "speaker"
        })
      })]
    });
  }
  if (type === WordbankCardType.TranslationRuToEn) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      type: "button",
      className: classnames_default()(wordbank_card_module.root, wordbank_card_module.rootTranslator),
      onClick: () => onClick(term),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: wordbank_card_module.secondColumn,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: typography_module/* default */.Z.body2,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            children: term
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
            className: wordbank_card_module.secondaryText,
            children: [" ", partOfSpeech]
          })]
        })
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(wordbank_card_module.root, {
      [wordbank_card_module.rootExpanded]: expanded,
      [wordbank_card_module.rootDictionary]: type === WordbankCardType.Dictionary,
      [wordbank_card_module.rootTranslator]: type === WordbankCardType.TranslationEnToRu
    }),
    onClick: () => setExpanded(true),
    onMouseOver: () => setIsVisibleActionControls(true),
    onMouseLeave: () => setIsVisibleActionControls(false),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: classnames_default()(wordbank_card_module.narrowCardContent, {
        [wordbank_card_module.narrowCardContentTranslator]: type === WordbankCardType.TranslationEnToRu
      }),
      onClick: e => {
        e.stopPropagation();
        setExpanded(prev => !prev);
      },
      children: [type === WordbankCardType.Dictionary && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        disabled: !canPlay,
        appearance: "default",
        size: "small",
        iconName: "speaker",
        className: wordbank_card_module.speakerButton,
        onClick: e => {
          e.stopPropagation();
          return onClickTextToSpeech(term);
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: wordbank_card_module.secondColumn,
        children: [type === WordbankCardType.Dictionary && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(wordbank_card_module.secondColumnTerm, typography_module/* default */.Z.headline4Accent),
          children: term
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: typography_module/* default */.Z.body2,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            children: translations.join(", ")
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
            className: wordbank_card_module.secondaryText,
            children: [" ", partOfSpeech]
          })]
        })]
      }), isMobile ? renderMobileActionControls() : renderDesktopActionControls()]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(wordbank_card_module.expandableContent, {
        [wordbank_card_module.expandableContentHidden]: !expanded
      }),
      children: [isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        className: classnames_default()(typography_module/* default */.Z.captionAccent, wordbank_card_module.actionControl, wordbank_card_module.primaryButtonMobile),
        appearance: "primary",
        size: "small",
        onClick: e => {
          e.stopPropagation();
          setPrimaryIsLoading(true);
          void onPrimaryButtonClick(learned).then(() => {
            setPrimaryIsLoading(false);
          });
        },
        disabled: primaryIsLoading,
        children: primaryIsLoading ? /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {
          size: loader_component/* LoaderSize */.gI.Small
        }) : primaryButtonTitle
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(wordbank_card_module.contextText, typography_module/* default */.Z.body2, {
          [wordbank_card_module.contextTextTranslator]: type === WordbankCardType.TranslationEnToRu
        }),
        children: highlightTermInContext(term, context)
      }), type === WordbankCardType.Dictionary && reference && !useNativeReferenceLink && reference.link && /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
        className: wordbank_card_module.sourceLink,
        to: reference.link,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          appearance: "default",
          className: wordbank_card_module.icon,
          iconName: "chapter",
          size: "small"
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: wordbank_card_module.sourceLinkContent,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: typography_module/* default */.Z.body2Accent,
            children: reference.title
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(wordbank_card_module.secondaryText, typography_module/* default */.Z.body2, wordbank_card_module.sourceLinkComment),
            children: reference.subtitle
          })]
        })]
      }), type === WordbankCardType.Dictionary && reference && useNativeReferenceLink && reference.link && /* @__PURE__ */(0,jsx_runtime.jsxs)("a", {
        className: wordbank_card_module.sourceLink,
        href: reference.link,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          appearance: "default",
          className: wordbank_card_module.icon,
          iconName: "chapter",
          size: "small"
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: wordbank_card_module.sourceLinkContent,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: typography_module/* default */.Z.body2Accent,
            children: reference.title
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(wordbank_card_module.secondaryText, typography_module/* default */.Z.body2, wordbank_card_module.sourceLinkComment),
            children: reference.subtitle
          })]
        })]
      }), type === WordbankCardType.Dictionary && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: wordbank_card_module.addDateInfo,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          appearance: "default",
          className: wordbank_card_module.icon,
          iconName: "calendar",
          size: "small"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(wordbank_card_module.addDateInfoText, typography_module/* default */.Z.body2),
          children: updateDateText
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/wordbank-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const wordbank_popup_module = ({"wordbank-card-wrapper":"wordbank-popup-module__wordbank-card-wrapper--PL_YM","wordbankCardWrapper":"wordbank-popup-module__wordbank-card-wrapper--PL_YM","root":"wordbank-popup-module__root--tgKMk","header":"wordbank-popup-module__header--PxIIC","first-line":"wordbank-popup-module__first-line--NyOdK","firstLine":"wordbank-popup-module__first-line--NyOdK","second-line":"wordbank-popup-module__second-line--li2jZ","secondLine":"wordbank-popup-module__second-line--li2jZ","action-controls":"wordbank-popup-module__action-controls--BGV17","actionControls":"wordbank-popup-module__action-controls--BGV17","action-button":"wordbank-popup-module__action-button--iGHEp","actionButton":"wordbank-popup-module__action-button--iGHEp","action-button-active":"wordbank-popup-module__action-button-active--O7Y38","actionButtonActive":"wordbank-popup-module__action-button-active--O7Y38","cards":"wordbank-popup-module__cards--F9sZP","loader":"wordbank-popup-module__loader--NPtFp","empty-state-text":"wordbank-popup-module__empty-state-text--rcajr","emptyStateText":"wordbank-popup-module__empty-state-text--rcajr","empty-state-text-subtitle":"wordbank-popup-module__empty-state-text-subtitle--XoDCC","emptyStateTextSubtitle":"wordbank-popup-module__empty-state-text-subtitle--XoDCC","add-word-illustration-wrapper":"wordbank-popup-module__add-word-illustration-wrapper--RfumE","addWordIllustrationWrapper":"wordbank-popup-module__add-word-illustration-wrapper--RfumE","add-word-illustration":"wordbank-popup-module__add-word-illustration--2lNha","addWordIllustration":"wordbank-popup-module__add-word-illustration--2lNha","bottom-loader":"wordbank-popup-module__bottom-loader--VwbSc","bottomLoader":"wordbank-popup-module__bottom-loader--VwbSc"});
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__content/cards.tsx








function Cards(_ref) {
  let {
    wordCards,
    isMobile
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: wordCards.map(card => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: wordbank_popup_module.wordbankCardWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(WordbankCard, {
        type: WordbankCardType.Dictionary,
        id: card.id,
        term: card.term,
        translations: card.translations,
        partOfSpeech: card.partOfSpeech,
        primaryButtonTitle: card.primaryButtonTitle,
        onPrimaryButtonClick: card.onPrimaryButtonClick,
        onDelete: card.onDelete,
        expandButton: card.expandButton,
        context: card.context,
        reference: card.reference,
        updateDateText: card.updateDateText,
        onClickTextToSpeech: card.onClickTextToSpeech,
        useNativeReferenceLink: card.useNativeReferenceLink,
        learned: card.learned,
        isMobile
      })
    }, card.id))
  });
}
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__toggler/toggler.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggler_module = ({"heading-button":"toggler-module__heading-button--N8THw","headingButton":"toggler-module__heading-button--N8THw","secondary-text":"toggler-module__secondary-text--fz1cB","secondaryText":"toggler-module__secondary-text--fz1cB","children":"toggler-module__children--RYWH_","children-hidden":"toggler-module__children-hidden--X279n","childrenHidden":"toggler-module__children-hidden--X279n"});
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__toggler/toggler.component.tsx








const WordbankToggler = _ref => {
  let {
    title,
    children,
    lastElementRef
  } = _ref;
  const [hidden, setHidden] = (0,react.useState)(false);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: lastElementRef,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: toggler_module.headingButton,
      onClick: () => setHidden(prev => !prev),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, toggler_module.secondaryText),
        children: title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: toggler_module.secondaryText,
        name: hidden ? "chevron-down" : "chevron-up",
        size: "medium"
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(toggler_module.children, {
        [toggler_module.childrenHidden]: hidden
      }),
      children
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__content/grouped-cards.tsx














function GroupedCards(_ref) {
  let {
    wordCards,
    isMobile,
    lastElementRef
  } = _ref;
  const groupedByChapterCards = (0,react.useMemo)(() => {
    const grouppedList = {};
    wordCards.forEach(card => {
      const title = card.reference?.title ?? "";
      if (title in grouppedList) {
        grouppedList[title].push(card);
      } else {
        grouppedList[title] = [card];
      }
    });
    return Object.entries(grouppedList);
  }, [wordCards]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: groupedByChapterCards.map((_ref2, index) => {
      let [title, cards] = _ref2;
      const isLast = index === groupedByChapterCards.length - 1;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(WordbankToggler, {
        lastElementRef: isLast ? lastElementRef : void 0,
        title,
        children: cards.map(card => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: wordbank_popup_module.wordbankCardWrapper,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(WordbankCard, {
            type: WordbankCardType.Dictionary,
            id: card.id,
            term: card.term,
            translations: card.translations,
            partOfSpeech: card.partOfSpeech,
            primaryButtonTitle: card.primaryButtonTitle,
            onPrimaryButtonClick: card.onPrimaryButtonClick,
            onDelete: card.onDelete,
            expandButton: card.expandButton,
            context: card.context,
            reference: card.reference,
            updateDateText: card.updateDateText,
            onClickTextToSpeech: card.onClickTextToSpeech,
            useNativeReferenceLink: card.useNativeReferenceLink,
            learned: card.learned,
            isMobile
          })
        }, card.id))
      }, title);
    })
  });
}
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/__content/wordbank-content.tsx











const WordbankContent = _ref => {
  let {
    isLoading,
    wordCards,
    emptyCardsText,
    withGroupByChapter,
    wordsContainerRef,
    isMobile,
    canLoadMore,
    loadMore
  } = _ref;
  const [isLoadingMore, setIsLoadingMore] = (0,react.useState)(false);
  const loadMoreWrapper = (0,react.useCallback)(() => {
    setIsLoadingMore(true);
    void loadMore().finally(() => setIsLoadingMore(false));
  }, [loadMore]);
  const {
    inView,
    ref
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    root: wordsContainerRef?.current
  });
  (0,react.useEffect)(() => {
    if (inView && canLoadMore && !isLoadingMore) {
      loadMoreWrapper();
    }
  }, [canLoadMore, inView, isLoadingMore, loadMoreWrapper]);
  const onScroll = (0,react.useCallback)(_ref2 => {
    let {
      currentTarget
    } = _ref2;
    const toBottom = currentTarget.scrollHeight - (currentTarget.scrollTop + currentTarget.clientHeight);
    if (canLoadMore && !isLoadingMore && toBottom < 1e3) {
      loadMoreWrapper();
    }
  }, [canLoadMore, isLoadingMore, loadMoreWrapper]);
  if (isLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: wordbank_popup_module.loader,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    });
  }
  if (wordCards.length === 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: wordbank_popup_module.emptyStateText,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4Accent,
        children: emptyCardsText.title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2, wordbank_popup_module.emptyStateTextSubtitle),
        children: emptyCardsText.subtitle
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: wordbank_popup_module.addWordIllustrationWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          className: wordbank_popup_module.addWordIllustration,
          alt: "add-word-flow-illsutration",
          src: emptyCardsText.illustrationSrc
        })
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: wordbank_popup_module.cards,
    onScroll,
    ref: wordsContainerRef,
    children: [withGroupByChapter ? /* @__PURE__ */(0,jsx_runtime.jsx)(GroupedCards, {
      lastElementRef: ref,
      wordCards,
      isMobile
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(Cards, {
      isMobile,
      wordCards
    }), isLoadingMore && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: wordbank_popup_module.bottomLoader,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/wordbank-popup/wordbank-popup.component.tsx





const WordBankPopUp = _ref => {
  let {
    isLoading,
    withGroupByChapter,
    emptyCardsText,
    canLoadMore,
    loadMore,
    wordsContainerRef,
    actionsItems,
    title,
    subtitle,
    wordCards,
    onClose,
    isMobile = false,
    visible = false
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_sheet_light_component/* BottomSheetLight */.e_, {
    visible,
    actionsItems,
    title,
    subtitle,
    onClose,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(WordbankContent, {
      loadMore,
      emptyCardsText,
      wordCards,
      withGroupByChapter,
      isLoading,
      isMobile,
      wordsContainerRef,
      canLoadMore
    })
  });
};
// EXTERNAL MODULE: ./src/api/student/wordbank/constants.ts
var constants = __webpack_require__(49357);
// EXTERNAL MODULE: ./src/api/student/wordbank/wordbank.api.ts + 4 modules
var wordbank_api = __webpack_require__(23643);
// EXTERNAL MODULE: ./src/api/trainer/trainer.urls.ts
var trainer_urls = __webpack_require__(47160);
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-translation-v2-enabled.ts
var use_translation_v2_enabled = __webpack_require__(3832);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
;// CONCATENATED MODULE: ./src/components/wordbank/types.ts


var Filter = /* @__PURE__ */(Filter2 => {
  Filter2["Term"] = "term";
  Filter2["Chapter"] = "chapter";
  Filter2["Learned"] = "learned";
  return Filter2;
})(Filter || {});
;// CONCATENATED MODULE: ./src/components/wordbank/utils.ts






const loadTerms = (_ref, isV2) => {
  let {
    currentFilter,
    page
  } = _ref;
  const handler = response => {
    if ((0,Either.isRight)(response)) {
      return response.right;
    }
    throw response.left;
  };
  switch (currentFilter) {
    case Filter.Chapter:
    case Filter.Term:
      return (0,wordbank_api/* getWordbankTerms */.Gk)({
        page,
        sortBy: currentFilter,
        perPage: constants/* DEFAULT_TERMS_PER_WORDBANK_PAGE */.n
      }, isV2).then(handler);
    case Filter.Learned:
      return (0,wordbank_api/* getLearnedWordbankTerms */.s9)({
        page,
        perPage: constants/* DEFAULT_TERMS_PER_WORDBANK_PAGE */.n
      }, isV2).then(handler);
    default:
      return Promise.reject();
  }
};
;// CONCATENATED MODULE: ./src/components/wordbank/wordbank.component.tsx



























const Wordbank = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const isPopupVisible = get_url_search_params.getUrlSearchParams.wordbankPopup.isOpen(history);
  const [terms, setTerms] = (0,react.useState)([]);
  const wordsContainerRef = (0,react.useRef)(null);
  const [page, setPage] = (0,react.useState)(1);
  const [canLoadMore, setCanLoadMore] = (0,react.useState)(true);
  const [canLoadingTerms, setCanLoadingTerms] = (0,react.useState)(false);
  const [currentFilter, setCurrentFilter] = (0,react.useState)(Filter.Term);
  const [isLoading, setIsLoading] = (0,react.useState)(false);
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const [titleArgs, setTitleArgs] = (0,react.useState)({
    key: "wordbank.myWords"
  });
  const popUpRef = (0,react.useRef)(null);
  const {
    playAudioByLink
  } = (0,useAudio/* usePlayAudioByLink */.CH)({
    priority: useAudio/* Priority */.UL.Low
  });
  (0,react.useEffect)(() => {
    if (isPopupVisible && !canLoadingTerms) {
      setCanLoadingTerms(true);
    }
  }, [isPopupVisible, canLoadingTerms]);
  const deleteTerm = (0,react.useCallback)(async (id, termType) => {
    const response = await (0,wordbank_api/* deleteWordBankTerm */.zb)(id, termType);
    if ((0,Either.isRight)(response)) {
      setTerms(prev => prev.filter(term => term.id !== id));
    }
  }, []);
  const changeTermLearningStatus = (0,react.useCallback)(async (termId, newLearnedStatus, termType) => {
    const response = await (0,wordbank_api/* setTermLearnedStatus */.pd)(termId, newLearnedStatus, termType);
    if ((0,Either.isRight)(response)) {
      setTerms(prev => prev.map(term => {
        if (term.id === termId) {
          return {
            ...term,
            learned: newLearnedStatus
          };
        }
        return term;
      }));
    }
  }, []);
  const handlePlayTextToSpeech = (0,react.useCallback)(word => {
    void playAudioByLink((0,trainer_urls/* GET_TEXT_TO_SPEECH_URL */.C)(word), "wordbank");
  }, [playAudioByLink]);
  const mapTermCard = (0,react.useCallback)(responseCard => ({
    id: responseCard.id,
    term: responseCard.term,
    context: responseCard.context,
    translations: responseCard.translations,
    partOfSpeech: intl.formatMessage({
      id: responseCard.partOfSpeech
    }),
    learned: responseCard.learned,
    reference: responseCard.reference ? {
      title: responseCard.reference.title,
      subtitle: intl.formatMessage({
        id: "wordbank.openHistory"
      }),
      link: responseCard.reference.link
    } : void 0,
    primaryButtonTitle: responseCard.learned ? intl.formatMessage({
      id: "wordbank.learnAgain"
    }) : intl.formatMessage({
      id: "wordbank.learned"
    }),
    onPrimaryButtonClick: learned => changeTermLearningStatus(responseCard.id, !learned, responseCard?.termType),
    expandButton: {
      opened: intl.formatMessage({
        id: "wordbank.toggle"
      }),
      closed: intl.formatMessage({
        id: "wordbank.expand"
      })
    },
    onDelete: () => deleteTerm(responseCard.id, responseCard?.termType),
    onClickTextToSpeech: term => {
      handlePlayTextToSpeech(term);
    },
    updateDateText: intl.formatMessage({
      id: "wordbank.addDate"
    }, {
      value: (0,format/* format */.WU)(new Date(responseCard.updateDate), "dd.MM.yyyy")
    })
  }), [changeTermLearningStatus, deleteTerm, handlePlayTextToSpeech, intl]);
  const wordbankCards = (0,react.useMemo)(() => terms.map(mapTermCard), [terms, mapTermCard]);
  (0,react.useEffect)(() => {
    if (!canLoadingTerms) {
      return;
    }
    setIsLoading(true);
    loadTerms({
      currentFilter,
      page: 1
    }, isTranslationV2Enabled).then(result => {
      setTerms(result.terms);
      switch (currentFilter) {
        case Filter.Term:
        case Filter.Chapter:
          setTitleArgs({
            key: "wordbank.myWords"
          });
          break;
        case Filter.Learned:
          setTitleArgs({
            key: "wordbank.learnedCount",
            args: {
              learnedCount: result.count,
              totalCount: result.totalCount
            }
          });
          break;
        default:
          throw new unhandled_case/* UnhandledCaseError */.H(currentFilter);
      }
    }).catch(error => logger/* Logger */.Yd.captureException(error, void 0, {
      block: "wordbank",
      method: "loadTerms"
    })).finally(() => {
      setIsLoading(false);
    });
  }, [currentFilter, canLoadingTerms, isTranslationV2Enabled]);
  const titleLabel = intl.formatMessage({
    id: titleArgs.key
  }, titleArgs.args && {
    learnedCount: titleArgs.args.learnedCount,
    totalCount: titleArgs.args.totalCount
  });
  const actionItems = (0,react.useMemo)(() => {
    const afterChangeFilter = () => {
      setCanLoadMore(true);
      setPage(1);
      if (wordsContainerRef && wordsContainerRef.current) {
        wordsContainerRef.current.scrollTo(0, 0);
      }
    };
    return [{
      title: intl.formatMessage({
        id: "wordbank.byAlphabet"
      }),
      onClick: () => {
        setCurrentFilter(Filter.Term);
        afterChangeFilter();
      },
      active: currentFilter === Filter.Term
    }, {
      title: intl.formatMessage({
        id: "wordbank.byChapters"
      }),
      onClick: () => {
        afterChangeFilter();
        setCurrentFilter(Filter.Chapter);
      },
      active: currentFilter === Filter.Chapter
    }, {
      title: intl.formatMessage({
        id: "wordbank.learned"
      }),
      onClick: () => {
        afterChangeFilter();
        setCurrentFilter(Filter.Learned);
      },
      active: currentFilter === Filter.Learned
    }];
  }, [currentFilter, intl, wordsContainerRef]);
  const loadMore = () => {
    const nextPage = page + 1;
    return loadTerms({
      currentFilter,
      page: nextPage
    }, isTranslationV2Enabled).then(response => {
      setPage(nextPage);
      setTerms(prev => [...prev, ...response.terms]);
      setCanLoadMore(response.terms.length >= constants/* DEFAULT_TERMS_PER_WORDBANK_PAGE */.n);
    });
  };
  const emptyCardsText = (0,react.useMemo)(() => ({
    title: intl.formatMessage({
      id: "wordbank.emptyTitle"
    }),
    subtitle: intl.formatMessage({
      id: "wordbank.emptySubtitle"
    }),
    illustrationSrc: "https://flowstatic.s3.yandex.net/static/aloha-static/tmp/Wordbank.png"
  }), [intl]);
  const handleClosePopup = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.wordbankPopup.getCloseUrl(history));
  }, [history]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(popUpRef, handleClosePopup);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(WordBankPopUp, {
    canLoadMore,
    wordsContainerRef,
    visible: isPopupVisible,
    emptyCardsText,
    onClose: handleClosePopup,
    wordCards: wordbankCards,
    actionsItems: actionItems,
    title: titleLabel,
    isLoading,
    subtitle: intl.formatMessage({
      id: "wordbank.translator"
    }),
    withGroupByChapter: currentFilter === Filter.Chapter,
    isMobile,
    loadMore
  });
};

/***/ }),

/***/ 97030:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  S: () => (/* binding */ YaForm)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
;// CONCATENATED MODULE: ../shared/src/ya-form.utils.ts



let isInitialized = false;
const initYaFormHeightSetter = () => {
  if (isInitialized) {
    return;
  }
  function findIframe(frameElement) {
    const iframeList = document.querySelectorAll("iframe");
    for (let i = 0; i < iframeList.length; ++i) {
      if (iframeList[i].contentWindow === frameElement) {
        return iframeList[i];
      }
    }
  }
  function receiveMessage(e) {
    try {
      const data = JSON.parse(e.data);
      const height = data["iframe-height"];
      let iframe;
      if (height && (iframe = findIframe(e.source))) {
        iframe.style.height = height + "px";
      }
    } catch (err) {}
  }
  window.addEventListener("message", receiveMessage, false);
  isInitialized = true;
};
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ./src/components/markdown-strings/markdown-strings.component.tsx + 2 modules
var markdown_strings_component = __webpack_require__(59889);
;// CONCATENATED MODULE: ./src/components/ya-form/ya-form.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ya_form_module = ({"root":"ya-form-module__root--VhtQe","root-wrapper":"ya-form-module__root-wrapper--bzbYe","rootWrapper":"ya-form-module__root-wrapper--bzbYe","subtitle":"ya-form-module__subtitle--c7tDM","text":"ya-form-module__text--jhaCl","text-dir-vertical":"ya-form-module__text-dir-vertical--yWa38","textDirVertical":"ya-form-module__text-dir-vertical--yWa38","text-dir-horizontal":"ya-form-module__text-dir-horizontal--_94ub","textDirHorizontal":"ya-form-module__text-dir-horizontal--_94ub"});
;// CONCATENATED MODULE: ./src/components/ya-form/ya-form.component.tsx













const FormData = es6.type({
  message: es6.keyof({
    sent: null
  }),
  answer_key: es6.string,
  name: es6.string
});
const getFormMessageDataFromJSONString = jsonString => {
  try {
    const parsedAnnouncedIdsString = JSON.parse(jsonString);
    const checkResult = FormData.decode(parsedAnnouncedIdsString);
    if ((0,Either.isLeft)(checkResult)) {
      return null;
    }
    return checkResult.right;
  } catch {
    return null;
  }
};
const YaForm = _ref => {
  let {
    url,
    width,
    name,
    onNextBlock,
    title,
    subtitle,
    textDirection = "horizontal"
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  (0,react.useEffect)(() => {
    initYaFormHeightSetter();
  }, []);
  const handleFormMassage = (0,react.useCallback)(e => {
    const data = getFormMessageDataFromJSONString(e.data);
    if (data === null) {
      return;
    }
    if (data.message === "sent" && data.name === name) {
      onNextBlock();
    }
  }, [name, onNextBlock]);
  (0,react.useEffect)(() => {
    window.addEventListener("message", handleFormMassage, false);
    return () => {
      window.removeEventListener("message", handleFormMassage);
    };
  }, [handleFormMassage]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(ya_form_module.rootWrapper, {
      [ya_form_module.textDirVertical]: textDirection === "vertical",
      [ya_form_module.textDirHorizontal]: textDirection === "horizontal"
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: ya_form_module.text,
      children: [title && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline3,
        children: title
      }), subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(ya_form_module.subtitle, typography_module/* default */.Z.body2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: subtitle
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("iframe", {
      title: intl.formatMessage({
        id: "yaForm.iframe.title"
      }),
      className: ya_form_module.root,
      src: url,
      width,
      name,
      frameBorder: "0"
    })]
  });
};

/***/ }),

/***/ 81923:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ useIntlNotifierTexts)
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83112);



function useIntlNotifierTexts() {
  const intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  const notifierTexts = {
    bell: {
      ariaLabel: intl.formatMessage({
        id: "notifier.bell.ariaLabel"
      })
    },
    empty: {
      description: intl.formatMessage({
        id: "notifier.empty.description"
      })
    },
    notifierItem: {
      expandBtnAriaLabel: intl.formatMessage({
        id: "notifier.item.expandBtn.label"
      }),
      collapseBtnAriaLabel: intl.formatMessage({
        id: "notifier.item.collapseBtn.label"
      })
    },
    moreBtnLabel: intl.formatMessage({
      id: "notifier.moreBtn.label"
    })
  };
  return notifierTexts;
}

/***/ }),

/***/ 67512:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ useProgressPageEnabled)
/* harmony export */ });
/* harmony import */ var _yandex_langly_shared_src_entities_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45404);
/* harmony import */ var _utils_experimentDi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40826);
/* harmony import */ var _user_useUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87029);





const useProgressPageEnabled = () => {
  const user = (0,_user_useUser__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)();
  const {
    showProgressPage
  } = (0,_utils_experimentDi__WEBPACK_IMPORTED_MODULE_1__/* .useExperimentDi */ .e1)();
  const showProgressPageExperimentTurnOffFeatureFlag = (0,_yandex_langly_shared_src_entities_features__WEBPACK_IMPORTED_MODULE_0__/* .useFeatureFlag */ .ye)("showProgressPageExperimentTurnOff");
  const progressPageBusinessFeatureFlagActive = user.data?.product?.businessProductFeatureFlags?.progress_page;
  const shouldShowProgress = (showProgressPageExperimentTurnOffFeatureFlag || showProgressPage) && progressPageBusinessFeatureFlagActive;
  return {
    shouldShowProgress
  };
};

/***/ }),

/***/ 3832:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ useTranslationV2Enabled)
/* harmony export */ });
/* harmony import */ var _yandex_langly_shared_src_entities_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45404);
/* harmony import */ var _utils_experimentDi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40826);




const useTranslationV2Enabled = () => {
  const isSelectionTranslationFeatureFlagEnabled = (0,_yandex_langly_shared_src_entities_features__WEBPACK_IMPORTED_MODULE_0__/* .useFeatureFlag */ .ye)("selectionTranslation");
  const {
    translationV2: translationV2Experiment
  } = (0,_utils_experimentDi__WEBPACK_IMPORTED_MODULE_1__/* .useExperimentDi */ .e1)();
  const isTranslationV2Enabled = isSelectionTranslationFeatureFlagEnabled || translationV2Experiment;
  return {
    isTranslationV2Enabled
  };
};

/***/ }),

/***/ 61046:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  K: () => (/* binding */ useSocial),
  z: () => (/* binding */ useSocialQuery)
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(42180);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/useFetch.ts
var useFetch = __webpack_require__(29553);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ./src/api/bunker/bunker.urls.ts
var bunker_urls = __webpack_require__(63608);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../shared/src/domain/domain.ts
var domain = __webpack_require__(72765);
// EXTERNAL MODULE: ../shared/src/domain/urls.ts
var urls = __webpack_require__(92976);
;// CONCATENATED MODULE: ./src/api/bunker/social/social.mapper.ts






function resultMapper(rawResponse) {
  if ((0,domain/* isKzDomain */.k)()) {
    return rawResponse.kz.map(item => ({
      labelKey: item.labelKey,
      icon: item.iconName,
      link: (0,urls/* getExternalUrl */.Eg)(item.externalUrlKey)
    }));
  }
  return rawResponse.ru.map(item => ({
    labelKey: item.labelKey,
    icon: item.iconName,
    link: (0,urls/* getExternalUrl */.Eg)(item.externalUrlKey)
  }));
}
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/bunker/social/social.raw-model.ts




const SocialType = es6.type({
  labelKey: es6.string,
  iconName: es6.string,
  externalUrlKey: es6.keyof(urls/* ExternalUrlsDefault */.xl)
});
const RawSocial = es6.type({
  ru: es6.array(SocialType),
  kz: es6.array(SocialType)
});
;// CONCATENATED MODULE: ./src/api/bunker/social/social.api.ts






const getSocial = () => (0,http/* makeRequest */.$f)(bunker_urls/* GET_SOCIAL */.yr, {
  responseType: RawSocial,
  resultMapper: resultMapper
});
;// CONCATENATED MODULE: ./src/hooks/layout/useSocial.ts







const useSocialQuery = () => (0,useQuery/* useQuery */.a)({
  queryKey: ["layout/social"],
  queryFn: (0,un_either/* unEither */.K)(getSocial),
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false
});
const useSocial = () => {
  const socialFetcher = (0,useFetch/* useFetch */.i)(getSocial);
  (0,react.useEffect)(() => {
    socialFetcher.state === useFetch/* State */.Z.Initial && void socialFetcher.fetch();
  }, [socialFetcher]);
  return socialFetcher;
};

/***/ }),

/***/ 78873:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aJ: () => (/* binding */ ProductsContextProvider),
/* harmony export */   rn: () => (/* binding */ useProducts)
/* harmony export */ });
/* unused harmony export ProductsContext */
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52322);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87412);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61297);
/* harmony import */ var _api_student_student_api__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91514);





















const ProductsContext = (0,react__WEBPACK_IMPORTED_MODULE_15__.createContext)({
  products: /* @__PURE__ */new Map(),
  setProducts: _yandex_langly_shared_src_function_utils__WEBPACK_IMPORTED_MODULE_16__/* .emptyFunction */ .Bi
});
const ProductsContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [products, setProducts] = (0,react__WEBPACK_IMPORTED_MODULE_15__.useState)( /* @__PURE__ */new Map());
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(ProductsContext.Provider, {
    value: {
      products,
      setProducts
    },
    children
  });
};
const useProducts = () => {
  const {
    products,
    setProducts
  } = (0,react__WEBPACK_IMPORTED_MODULE_15__.useContext)(ProductsContext);
  const loadProduct = (0,react__WEBPACK_IMPORTED_MODULE_15__.useCallback)(async id => {
    const product = await (0,_api_student_student_api__WEBPACK_IMPORTED_MODULE_17__/* .getProductInfo */ .Cn)(id);
    if ((0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_18__.isLeft)(product)) {
      return null;
    }
    setProducts(prev => prev.set(product.right.id, product.right));
    return product.right;
  }, [setProducts]);
  const getProduct = (0,react__WEBPACK_IMPORTED_MODULE_15__.useCallback)(async id => {
    if (!products.has(id)) {
      return loadProduct(id);
    }
    return products.get(id) ?? null;
  }, [loadProduct, products]);
  return (0,react__WEBPACK_IMPORTED_MODULE_15__.useMemo)(() => ({
    get: getProduct,
    reload: loadProduct
  }), [getProduct, loadProduct]);
};

/***/ }),

/***/ 9784:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ useGrammarGuide)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4517);
/* harmony import */ var _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47822);






const useGrammarGuide = () => {
  const history = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useHistory */ .k6)();
  const showGrammarGuide = _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.grammarGuide.isOpen(history);
  const toggleGrammarGuideVisibility = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(() => {
    _utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.grammarGuide.isOpen(history) ? history.push(_utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.grammarGuide.getCloseUrl(history)) : history.push(_utils_url_get_url_search_params__WEBPACK_IMPORTED_MODULE_2__.getUrlSearchParams.grammarGuide.getOpenUrl(history));
  }, [history]);
  return {
    showGrammarGuide,
    toggleGrammarGuideVisibility
  };
};

/***/ }),

/***/ 74126:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _g: () => (/* binding */ useMobileApp),
/* harmony export */   nx: () => (/* binding */ PermissionStatus)
/* harmony export */ });
/* unused harmony export isUserAgentMobileApp */
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_json_parse_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67761);
/* harmony import */ var core_js_modules_esnext_json_parse_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_json_parse_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);






var PermissionStatus = /* @__PURE__ */(PermissionStatus2 => {
  PermissionStatus2["denied"] = "denied";
  PermissionStatus2["granted"] = "granted";
  PermissionStatus2["restricted"] = "restricted";
  PermissionStatus2["limited"] = "limited";
  PermissionStatus2["permanentlyDenied"] = "permanentlyDenied";
  PermissionStatus2["provisional"] = "provisional";
  return PermissionStatus2;
})(PermissionStatus || {});
const isUserAgentMobileApp = () => window.navigator.userAgent.includes("PracticumEnglishApp");
class AppmetricaNotImplementedError extends Error {
  constructor() {
    super("webview_appmetrica not implemented");
  }
}
class WebViewPermissionsNotImplementedError extends Error {
  constructor() {
    super("webview_permissions not implemented");
  }
}
const chanels = {
  sendAppmetrica: (type, payload) => {
    if (!window.webview_permissions) {
      throw new AppmetricaNotImplementedError();
    }
    const msg = JSON.stringify({
      ...payload,
      type
    });
    window.webview_appmetrica.postMessage(msg);
  },
  /**
   * Открыть настройки приложения
   *
   * Приложение может запрашивать разрешение только 1 раз и если пользователь отказал,
   * то пермишен можно предоставить только через настройки
   */
  openSettings: () => {
    if (!window.webview_permissions) {
      throw new WebViewPermissionsNotImplementedError();
    }
    const msg = JSON.stringify({
      permission: null
    });
    window.webview_permissions.postMessage(msg);
  },
  /** Request has to be done one a time (don't support multiple request at once) */
  requestPermission: permission => {
    if (!window.webview_permissions) {
      throw new WebViewPermissionsNotImplementedError();
    }
    const msg = JSON.stringify({
      permission
    });
    window.webview_permissions.postMessage(msg);
  },
  onPermissionChanged: callback => {
    if (!window.webview_permissions) {
      throw new WebViewPermissionsNotImplementedError();
    }
    permissionChangedCallbacks.push(callback);
    return () => {
      const index = permissionChangedCallbacks.findIndex(item => item === callback);
      index >= 0 && permissionChangedCallbacks.splice(index, 1);
    };
  }
};
const permissionChangedCallbacks = [];
if (window.webview_permissions) {
  window.webview_permissions.onmessage = event => {
    const {
      permission,
      status
    } = JSON.parse(event.data);
    permissionChangedCallbacks.forEach(callback => callback(permission, status));
  };
}
const useMobileApp = () => {
  const isMobileApp = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(isUserAgentMobileApp, []);
  return {
    isMobileApp,
    ...chanels
  };
};

/***/ }),

/***/ 62878:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: () => (/* binding */ useCalendarItems)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66514);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83112);
/* harmony import */ var _yandex_langly_shared_src_calendar_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3654);
/* harmony import */ var _yandex_langly_shared_src_currentBrowser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97186);
/* harmony import */ var _yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24610);
/* harmony import */ var _yandex_langly_shared_src_utils_locale__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90790);
/* harmony import */ var _api_events_events_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53536);
/* harmony import */ var _utils_experimentDi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40826);
/* harmony import */ var _utils_yandexMetrica__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11226);
/* harmony import */ var _user_useUser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87029);














const webcalLog = (action, provider) => {
  void (0,_api_events_events_api__WEBPACK_IMPORTED_MODULE_4__/* .eventPost */ .bQ)({
    type: "calendar_via_webcal",
    payload: {
      action,
      provider
    }
  });
  (0,_utils_yandexMetrica__WEBPACK_IMPORTED_MODULE_6__/* .ymGoal */ .qf)("Speaking_Calendar", {
    provider: provider + "_webcal"
  });
};
const useCalendarItems = (_ref, openWebcalInstruction) => {
  let {
    startTime,
    endTime,
    isMentor,
    chapterName,
    availableBeforeStartMin
  } = _ref;
  const intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  const {
    calendarWebcal
  } = (0,_utils_experimentDi__WEBPACK_IMPORTED_MODULE_5__/* .useExperimentDi */ .e1)();
  const userModel = (0,_user_useUser__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .aF)();
  const user = userModel?.data?.me?.user;
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => {
    let googleAction = () => {
      (0,_utils_yandexMetrica__WEBPACK_IMPORTED_MODULE_6__/* .ymGoal */ .qf)("Speaking_Calendar", {
        provider: "google"
      });
      window.open((0,_yandex_langly_shared_src_calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateGoogleCalendarLink */ .T$)(event), "_blank");
    };
    let yandexAction = () => {
      (0,_utils_yandexMetrica__WEBPACK_IMPORTED_MODULE_6__/* .ymGoal */ .qf)("Speaking_Calendar", {
        provider: "yandex"
      });
      window.open((0,_yandex_langly_shared_src_calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateYandexCalendarLink */ .eB)(event), "_blank");
    };
    let appleAction = () => {
      (0,_utils_yandexMetrica__WEBPACK_IMPORTED_MODULE_6__/* .ymGoal */ .qf)("Speaking_Calendar", {
        provider: "apple"
      });
      window.open((0,_yandex_langly_shared_src_calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateIcsCalendarLink */ .ZB)(event), "_blank");
    };
    if (calendarWebcal) {
      const userId = user?.id;
      const calendarToken = user?.calendarToken;
      if (userId && calendarToken) {
        appleAction = () => {
          webcalLog("click_provider", "apple");
          window.open((0,_yandex_langly_shared_src_calendar_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateWebcalCalendarLink */ .D$)(userId, calendarToken));
        };
        googleAction = () => {
          webcalLog("click_provider", "google");
          openWebcalInstruction("google");
        };
        yandexAction = () => {
          webcalLog("click_provider", "yandex");
          openWebcalInstruction("yandex");
        };
      }
    }
    const event = {
      name: isMentor ? intl.formatMessage({
        id: "useCalendarItems.mentorMeeting"
      }) : intl.formatMessage({
        id: "useCalendarItems.chapterMeeting"
      }, {
        chapterName
      }),
      description: intl.formatMessage({
        id: "useCalendarItems.eventDescription"
      }, {
        availableBeforeStart: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* .formatDuration */ .L)({
          minutes: availableBeforeStartMin
        }, {
          locale: _yandex_langly_shared_src_utils_locale__WEBPACK_IMPORTED_MODULE_10__/* .dateFnsLocale */ .Y
        }),
        appLink: `https://${window.location.host}${(0,_yandex_langly_shared_src_site_utils__WEBPACK_IMPORTED_MODULE_11__/* .getAppPath */ .bY)()}`
      }),
      startTime,
      endTime
    };
    const items = [{
      label: intl.formatMessage({
        id: "useCalendarItems.calendarLabelGoogle"
      }),
      action: googleAction
    }, {
      label: intl.formatMessage({
        id: "useCalendarItems.calendarLabelYandex"
      }),
      action: yandexAction
    }];
    const isIPadOrIPhoneSafari = (_yandex_langly_shared_src_currentBrowser__WEBPACK_IMPORTED_MODULE_3__/* .isIPhone */ .IN || _yandex_langly_shared_src_currentBrowser__WEBPACK_IMPORTED_MODULE_3__/* .isIPad */ .zc) && _yandex_langly_shared_src_currentBrowser__WEBPACK_IMPORTED_MODULE_3__/* .currentBrowser */ .Y6 === _yandex_langly_shared_src_currentBrowser__WEBPACK_IMPORTED_MODULE_3__/* .BrowserType */ .Aq.Safari;
    if (_yandex_langly_shared_src_currentBrowser__WEBPACK_IMPORTED_MODULE_3__/* .isMac */ .V5 || isIPadOrIPhoneSafari) {
      items.push({
        label: intl.formatMessage({
          id: "useCalendarItems.calendarLabelApple"
        }),
        action: appleAction
      });
    }
    return items;
  }, [calendarWebcal, isMentor, intl, chapterName, availableBeforeStartMin, startTime, endTime, user?.id, user?.calendarToken, openWebcalInstruction]);
};

/***/ }),

/***/ 70822:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q$: () => (/* binding */ useServerCurrentTime),
/* harmony export */   YY: () => (/* binding */ useCurrentTime)
/* harmony export */ });
/* unused harmony export useRerenderComponentEvery */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24959);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94527);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41645);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7300);
/* harmony import */ var fp_ts_Either__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18984);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _api_utils_utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11775);






const useCurrentTime = () => {
  const [time, setTime] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .startOfMinute */ .F)( /* @__PURE__ */new Date()));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    let timeoutId = null;
    const processTimeoutAndStartNew = () => {
      const now = /* @__PURE__ */new Date();
      const currentTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .startOfMinute */ .F)(now);
      setTime(time2 => (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* .isEqual */ .X)(time2, currentTime) ? time2 : currentTime);
      const nextDiffTimeout = (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* .differenceInMilliseconds */ ._)((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* .addMinutes */ .m)(currentTime, 1), now);
      timeoutId = window.setTimeout(() => {
        if (timeoutId !== null) {
          processTimeoutAndStartNew();
        }
      }, nextDiffTimeout);
    };
    processTimeoutAndStartNew();
    return () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
      timeoutId = null;
    };
  }, []);
  return time;
};
const useRerenderComponentEvery = intervalInMilliseconds => {
  const [time, setTime] = useState(() => startOfSecond( /* @__PURE__ */new Date()));
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTime(startOfSecond( /* @__PURE__ */new Date()));
    }, intervalInMilliseconds);
    return () => {
      window.clearInterval(intervalId);
    };
  }, [intervalInMilliseconds]);
  return time;
};
const useServerCurrentTime = _ref => {
  let {
    enable = true,
    updateInterval = 1e3
  } = _ref;
  const [time, setTime] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!enable) {
      return;
    }
    const fetchTime = async () => {
      const response = await (0,_api_utils_utils_api__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentTime */ .X)();
      if ((0,fp_ts_Either__WEBPACK_IMPORTED_MODULE_6__/* .isLeft */ .nM)(response)) {
        return;
      }
      setTime(response.right);
    };
    void fetchTime();
    const intervalId = window.setInterval(() => {
      void fetchTime();
    }, updateInterval);
    return () => {
      window.clearInterval(intervalId);
    };
  }, [enable, updateInterval]);
  return time;
};

/***/ }),

/***/ 64200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ useTrainerHandlers)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66176);
/* harmony import */ var _state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48819);





const useTrainerHandlers = send => {
  const handleSubmitAnswer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(_ref => {
    let {
      blockId,
      activityId,
      ...object
    } = _ref;
    if (!blockId || !activityId) {
      _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd.captureWarning("blockId or activityId is empty", {
        activityId,
        blockId
      });
      return;
    }
    send(_state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__/* .EVENTS */ .FP.SUBMIT_ANSWER, {
      data: {
        ...object,
        blockId,
        activityId,
        correct: Boolean(object.correct),
        typo: Boolean(object.typo)
      }
    });
  }, [send]);
  const handleResetAnswer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((blockId, activityId) => {
    send(_state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__/* .EVENTS */ .FP.RESET_ANSWER, {
      data: {
        answer: null,
        blockId,
        activityId,
        correct: null,
        typo: null
      }
    });
  }, [send]);
  const handlePrevActivityClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    send(_state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__/* .EVENTS */ .FP.PREV_ACTIVITY_CLICKED);
  }, [send]);
  const handleNextActivityClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    send(_state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__/* .EVENTS */ .FP.NEXT_ACTIVITY_CLICKED);
  }, [send]);
  const handlePrevBlockClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    send(_state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__/* .EVENTS */ .FP.PREV_BLOCK_CLICKED);
  }, [send]);
  const handleNextBlockClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(params => send(_state_machine_trainer_product_product_trainer_machine__WEBPACK_IMPORTED_MODULE_2__/* .EVENTS */ .FP.NEXT_BLOCK_CLICKED, {
    withScroll: params?.withScroll ?? true
  }), [send]);
  return {
    handlePrevActivityClick,
    handlePrevBlockClick,
    handleNextBlockClick,
    handleSubmitAnswer,
    handleResetAnswer,
    handleNextActivityClick
  };
};

/***/ }),

/***/ 87029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZM: () => (/* binding */ State),
  fS: () => (/* binding */ UserContextProvider),
  aF: () => (/* binding */ useUser)
});

// UNUSED EXPORTS: getUser

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/auth/index.ts + 2 modules
var auth = __webpack_require__(60980);
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/index.ts + 7 modules
var student_attributes = __webpack_require__(14325);
// EXTERNAL MODULE: ../shared/src/entities/user/index.ts + 3 modules
var entities_user = __webpack_require__(91485);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ./src/api/student/placement/placement.api.ts + 2 modules
var placement_api = __webpack_require__(50919);
// EXTERNAL MODULE: ./src/api/student/student.api.ts + 4 modules
var student_api = __webpack_require__(91514);
// EXTERNAL MODULE: ./src/api/user/authorization/api.ts + 1 modules
var api = __webpack_require__(26630);
// EXTERNAL MODULE: ./src/state-machine/user/authorization/model.ts + 1 modules
var model = __webpack_require__(55378);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/query-string/index.js
var query_string = __webpack_require__(34126);
;// CONCATENATED MODULE: ./src/utils/getParamsForMe.ts








const utmStrings = {};
const params = query_string.parse(location.search);
Object.keys(params).filter(key => key === "promo_code" || key.startsWith("utm")).forEach(key => {
  utmStrings[key] = params[key];
});
const getParamsForMe = () => utmStrings;
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ./src/hooks/products/useProducts.tsx
var useProducts = __webpack_require__(78873);
;// CONCATENATED MODULE: ./src/hooks/user/useUser.tsx
































var State = /* @__PURE__ */(State2 => {
  State2["Initial"] = `initial`;
  State2["Loading"] = "loading";
  State2["Loaded"] = "loaded";
  State2["Error"] = "error";
  return State2;
})(State || {});
const getUser = async options => {
  const meResponse = await (0,api/* getMe */.j)(getParamsForMe(), options);
  return (0,model/* meFromApiToModel */.h)(meResponse);
};
const UserContext = (0,react.createContext)({
  state: "initial" /* Initial */,
  data: null,
  functions: null
});
const UserContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [state, setState] = (0,react.useState)("initial" /* Initial */);
  const user = (0,effector_react/* useStore */.oR)(entities_user/* $me */.ul);
  const setUser = (0,effector_react/* useEvent */.zX)(entities_user/* setMe */.XM);
  const setUserRole = (0,effector_react/* useEvent */.zX)(entities_user/* setMeRole */.oi);
  const studentAttributes = (0,effector_react/* useStore */.oR)(student_attributes/* $studentAttributes */.lo);
  const setStudentAttributesEvent = (0,effector_react/* useEvent */.zX)(student_attributes/* setStudentAttributes */.JX);
  const updateStudentAttributesEvent = (0,effector_react/* useEvent */.zX)(student_attributes/* updateStudentAttributes */.DV);
  const [product, setProduct] = (0,react.useState)();
  const businessProductsFeatureFlags = (0,react.useRef)(null);
  const {
    get: getProduct
  } = (0,useProducts/* useProducts */.rn)();
  (0,react.useEffect)(() => {
    (0,entities_user/* setCurrentProductBusinessId */.rR)(product?.businessId ?? null);
    (0,entities_user/* setInitialOnboardingState */.i9)(product?.onboarding?.fsm?.initialState ?? null);
  }, [product]);
  const history = (0,react_router/* useHistory */.k6)();
  const placementProductId = get_url_search_params.getUrlSearchParams.placementProductId.get(history);
  const isUserStudent = user?.user?.role === entities_user/* UserRole */.i4.ROLE_STUDENT || user?.user?.role === entities_user/* UserRole */.i4.ROLE_DEVELOPER;
  const placeUserIntoLevelByQueryParam = (0,react.useCallback)(async function () {
    let skipRoleCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    try {
      if ((isUserStudent || skipRoleCheck) && placementProductId) {
        await (0,placement_api/* placeUserIntoLevel */.k)(placementProductId);
        updateStudentAttributesEvent({
          currentProductId: placementProductId,
          needOnboarding: false
        });
        get_url_search_params.getUrlSearchParams.placementProductId.remove(history);
      }
    } catch (e) {
      logger/* Logger */.Yd.captureError(`Error while placing student into level ${placementProductId}: ${e}`);
    }
  }, [history, isUserStudent, placementProductId, updateStudentAttributesEvent]);
  (0,react.useEffect)(() => {
    void placeUserIntoLevelByQueryParam();
  }, [placeUserIntoLevelByQueryParam]);
  const onUnAuthorize = (0,react.useCallback)(() => {
    auth/* Auth */.g.redirectToPassport();
  }, []);
  const setCurrentProduct = (0,react.useCallback)(async attributes => {
    const currentProductId = placementProductId ?? attributes.currentProductId;
    if (!currentProductId) {
      setState("loaded" /* Loaded */);
      return;
    }
    if (!businessProductsFeatureFlags.current) {
      businessProductsFeatureFlags.current = await (0,student_api/* fetchBusinessProductsFeatureFlags */.EH)();
    }
    const productResponse = await getProduct(currentProductId);
    if (!productResponse) {
      return setState("error" /* Error */);
    }
    const businessProductFeatureFlags = (0,student_api/* mapBusinessProductFeatureFlags */.aC)({
      businessProductId: attributes.businessId ?? productResponse.businessId ?? null,
      businessProductsFeatureFlagsConfig: businessProductsFeatureFlags.current ?? null
    });
    setProduct({
      ...productResponse,
      businessProductFeatureFlags,
      businessId: attributes.businessId ?? productResponse.businessId,
      syllabusId: attributes.syllabusId ?? productResponse.syllabusId,
      speakingTypeId: attributes.speakingTypeId ?? productResponse.speakingTypeId
    });
    setState("loaded" /* Loaded */);
  }, [getProduct, placementProductId]);
  const setUserAttributes = (0,react.useCallback)(async () => {
    const attributesResponse = await (0,student_attributes/* getStudentAttributes */.lB)({
      onUnAuthorize
    });
    if ((0,Either.isLeft)(attributesResponse)) {
      setState("error" /* Error */);
      return;
    }
    setStudentAttributesEvent(attributesResponse.right);
    return attributesResponse.right;
  }, [onUnAuthorize, setStudentAttributesEvent]);
  const setUserAttributesAndCurrentProduct = (0,react.useCallback)(async () => {
    const attributes = await setUserAttributes();
    if (attributes) {
      await setCurrentProduct(attributes);
    }
  }, [setCurrentProduct, setUserAttributes]);
  const fetchData = (0,react.useCallback)(async () => {
    setState("loading" /* Loading */);
    const userResponse = await getUser({
      unauthorizedHandler: onUnAuthorize
    });
    if (!userResponse.loggedIn) {
      return onUnAuthorize();
    }
    setUser(userResponse);
    await setUserAttributesAndCurrentProduct();
  }, [setUser, onUnAuthorize, setUserAttributesAndCurrentProduct]);
  const reloadMe = (0,react.useCallback)(async () => {
    setState("loading" /* Loading */);
    const userResponse = await getUser();
    setUser(userResponse);
    setState("loaded" /* Loaded */);
    return userResponse;
  }, [setUser]);
  const reloadMeInBackground = (0,react.useCallback)(async () => {
    const userResponse = await getUser();
    setUser(userResponse);
  }, [setUser]);
  const reloadAttributes = (0,react.useCallback)(async () => {
    setState("loading" /* Loading */);
    const attributesResponse = await (0,student_attributes/* getStudentAttributes */.lB)({
      onUnAuthorize
    });
    if ((0,Either.isLeft)(attributesResponse)) {
      setState("error" /* Error */);
      return null;
    }
    setStudentAttributesEvent(attributesResponse.right);
    setState("loaded" /* Loaded */);
    return attributesResponse.right;
  }, [onUnAuthorize, setStudentAttributesEvent]);
  const submitAgreements = (0,react.useCallback)(async (userAgreement, emailAgreement) => {
    try {
      await (0,api/* updateUserAttributes */.V)({
        user_agreement: userAgreement,
        email_agreement: emailAgreement
      });
      await reloadMe();
      await placeUserIntoLevelByQueryParam(true);
      setUserRole(entities_user/* UserRole */.i4.ROLE_STUDENT);
    } catch (e) {
      logger/* Logger */.Yd.captureError(`Error while submitting user agreement: ${e}`);
    }
  }, [placeUserIntoLevelByQueryParam, reloadMe, setUserRole]);
  const setOnboardingState = (0,react.useCallback)(params => {
    if (!studentAttributes) {
      return;
    }
    updateStudentAttributesEvent({
      onboardingStates: new Map([...studentAttributes.onboardingStates]).set(params.productId, params.state)
    });
  }, [studentAttributes, updateStudentAttributesEvent]);
  (0,react.useEffect)(() => {
    if (state === "initial" /* Initial */) {
      void fetchData();
    }
  }, [fetchData, state]);
  const value = (0,react.useMemo)(() => {
    if (state === "loaded" /* Loaded */) {
      if (!user || !studentAttributes) {
        return {
          state: "error" /* Error */,
          data: null,
          functions: null
        };
      }
      return {
        state: "loaded" /* Loaded */,
        data: {
          me: user,
          attributes: studentAttributes,
          product: product ?? null
        },
        functions: {
          setOnboardingState,
          reloadMe,
          reloadAttributes,
          setUserAttributesAndCurrentProduct,
          submitAgreements,
          reloadMeInBackground
        }
      };
    }
    return {
      state,
      data: null,
      functions: null
    };
  }, [product, reloadAttributes, reloadMe, setOnboardingState, setUserAttributesAndCurrentProduct, state, studentAttributes, submitAgreements, user, reloadMeInBackground]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(UserContext.Provider, {
    value,
    children
  });
};
const useUser = () => (0,react.useContext)(UserContext);

/***/ }),

/***/ 67148:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(18360);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/modern/queryClient.js + 3 modules
var queryClient = __webpack_require__(70555);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(14010);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/client.js
var client = __webpack_require__(17029);
// EXTERNAL MODULE: ../../node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(47933);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/domain/domain.ts
var domain = __webpack_require__(72765);
// EXTERNAL MODULE: ../shared/src/domain/urls.ts
var domain_urls = __webpack_require__(92976);
// EXTERNAL MODULE: ../shared/src/entities/features.ts
var features = __webpack_require__(45404);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
;// CONCATENATED MODULE: ../shared/src/location-change-processor.tsx





const LocationChangeProcessor = _ref => {
  let {
    onChange
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const prevLocationRef = (0,react.useRef)(history.location);
  (0,react.useEffect)(() => {
    const prevLocation = prevLocationRef.current;
    if (prevLocation.pathname !== history.location.pathname) {
      prevLocationRef.current = history.location;
    }
    logger/* Logger */.Yd.setPage(window.location.href);
    onChange?.(window.location);
  }, [history.location, onChange]);
  return null;
};
// EXTERNAL MODULE: ../../node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(92454);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);
;// CONCATENATED MODULE: ../shared/src/polyfills.ts



const initPolyfills = () => {
  smoothscroll_default().polyfill();
};
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/hooks/useErrorHandler.ts
var useErrorHandler = __webpack_require__(88445);
;// CONCATENATED MODULE: ../shared/src/wrappers/fetchWrapper.tsx






const FetchWrapper = _ref => {
  let {
    children,
    functions,
    suspense
  } = _ref;
  const [isLoading, setIsLoading] = (0,react.useState)(true);
  const isFetchedRef = (0,react.useRef)(false);
  const setError = (0,useErrorHandler/* useErrorHandler */.U)();
  const fetch = (0,react.useCallback)(async () => {
    isFetchedRef.current = true;
    await Promise.all(functions.map(fn => fn())).catch(setError).finally(() => setIsLoading(false));
  }, [functions, setError]);
  (0,react.useEffect)(() => {
    if (isFetchedRef.current) {
      return;
    }
    void fetch();
  }, [fetch]);
  if (isLoading) {
    return suspense();
  }
  return children;
};
// EXTERNAL MODULE: ../ui-kit/src/error-boundary/error-boundary.tsx
var error_boundary = __webpack_require__(514);
// EXTERNAL MODULE: ../shared/src/utils/reload-page.ts
var reload_page = __webpack_require__(86710);
// EXTERNAL MODULE: ../ui-kit/src/button/button-link.component.tsx
var button_link_component = __webpack_require__(66284);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/js-error-screen/js-error-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const js_error_screen_module = ({"root":"js-error-screen-module__root--GUyzz","splitter-small":"js-error-screen-module__splitter-small--y_plE","splitterSmall":"js-error-screen-module__splitter-small--y_plE","splitter-big":"js-error-screen-module__splitter-big--RCBl1","splitterBig":"js-error-screen-module__splitter-big--RCBl1","link":"js-error-screen-module__link--OxVH6"});
;// CONCATENATED MODULE: ../ui-kit/src/js-error-screen/js-error-screen.component.tsx








const JsErrorScreen = _ref => {
  let {
    rootHref,
    content
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: js_error_screen_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: typography_module/* default */.Z.headline4Accent,
      children: content.header
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: js_error_screen_module.splitterSmall
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: typography_module/* default */.Z.body2,
      children: content.body
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: js_error_screen_module.splitterBig
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      onClick: reload_page/* reloadPage */.s,
      appearance: "primary",
      children: content.reloadPageButton
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: js_error_screen_module.splitterSmall
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
      appearance: "secondary",
      useNativeTag: true,
      href: rootHref,
      children: content.goRootButton
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/global-error-boundary/global-error-boundary.tsx







function handleError(error, errorInfo) {
  logger/* Logger */.Yd.captureException(error, {
    info: errorInfo
  }, {
    block: "GlobalErrorBoundary"
  });
}
const GlobalErrorBoundary = _ref => {
  let {
    rootHref,
    children,
    errorScreenContent
  } = _ref;
  const getErrorContent = (0,react.useCallback)(() => /* @__PURE__ */(0,jsx_runtime.jsx)(JsErrorScreen, {
    rootHref,
    content: errorScreenContent
  }), [rootHref, errorScreenContent]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
    onError: handleError,
    onErrorContent: getErrorContent,
    children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/js-error-screen/content-nodes-russian-with-link.tsx



const contentNodesRussianWithLink = {
  header: "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
  body: /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: "\u0422\u0430\u043A\u043E\u0435 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442, \u043A\u043E\u0433\u0434\u0430 \u0432 \u043A\u043E\u0434\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0437\u0430\u043A\u0440\u0430\u043B\u0430\u0441\u044C \u043E\u0448\u0438\u0431\u043A\u0430 \u0438 \u0435\u0451 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430. \u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043E \u043F\u043E\u0434\u043E\u0431\u043D\u044B\u0445 \u043E\u0448\u0438\u0431\u043A\u0430\u0445 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430 \u043A\u0443\u0440\u0441\u0435 \u0412\u0435\u0431-\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430 \u0432 \u042F\u043D\u0434\u0435\u043A\u0441 \u041F\u0440\u0430\u043A\u0442\u0438\u043A\u0443\u043C\u0435, \u0430 \u043F\u043E\u043A\u0430 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u043E\u0441\u0442\u043E \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D."
  }),
  reloadPageButton: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
  goRootButton: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D"
};
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ./src/api/bunker/bunker.urls.ts
var bunker_urls = __webpack_require__(63608);
// EXTERNAL MODULE: ../shared/src/auth/index.ts + 2 modules
var auth = __webpack_require__(60980);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(88932);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(9948);
;// CONCATENATED MODULE: ../shared/src/services/notification/toast-ui.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toast_ui_module = ({"root":"toast-ui-module__root--cCdNS"});
;// CONCATENATED MODULE: ../shared/src/services/notification/toast-ui.tsx






const ToastContainerUI = () => /* @__PURE__ */(0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
  limit: 3,
  enableMultiContainer: true,
  containerId: "App",
  className: toast_ui_module.root
});
;// CONCATENATED MODULE: ../ui-kit/src/theme/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_module = ({});
// EXTERNAL MODULE: ./src/api/student/placement/placement.api.ts + 2 modules
var placement_api = __webpack_require__(50919);
// EXTERNAL MODULE: ./src/api/student/student.model.ts
var student_model = __webpack_require__(85715);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__(42670);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/deprecated-modal/deprecated-modal.component.tsx + 1 modules
var deprecated_modal_component = __webpack_require__(49159);
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
;// CONCATENATED MODULE: ../ui-kit/src/modal-bottom-mobile/modal-bottom-mobile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_bottom_mobile_module = ({"root":"modal-bottom-mobile-module__root--LrJ1z","overlay":"modal-bottom-mobile-module__overlay--TKyt3","children":"modal-bottom-mobile-module__children--EUiXK"});
;// CONCATENATED MODULE: ../ui-kit/src/modal-bottom-mobile/modal-bottom-mobile.component.tsx






const ModalBottomMobile = _ref => {
  let {
    children,
    onClose
  } = _ref;
  (0,use_block_main_scroll/* useBlockMainScroll */.K)();
  (0,useKeyPress/* useKeyPress */.K)("Escape", onClose);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: modal_bottom_mobile_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: modal_bottom_mobile_module.overlay,
      onClick: onClose
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: modal_bottom_mobile_module.children,
      children
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/utils/url.ts
var url = __webpack_require__(52702);
// EXTERNAL MODULE: ../ui-kit/src/avatar/avatar.component.tsx + 1 modules
var avatar_component = __webpack_require__(66202);
;// CONCATENATED MODULE: ./src/components/feedback-popup-header-base/feedback-popup-header-base.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_header_base_module = ({"root":"feedback-popup-header-base-module__root--cCs75","root-desktop":"feedback-popup-header-base-module__root-desktop--Fe00U","rootDesktop":"feedback-popup-header-base-module__root-desktop--Fe00U","root-mobile":"feedback-popup-header-base-module__root-mobile--UghWv","rootMobile":"feedback-popup-header-base-module__root-mobile--UghWv","header":"feedback-popup-header-base-module__header--rL3rB","header-image":"feedback-popup-header-base-module__header-image--lRprg","headerImage":"feedback-popup-header-base-module__header-image--lRprg","header-texts":"feedback-popup-header-base-module__header-texts--abBhn","headerTexts":"feedback-popup-header-base-module__header-texts--abBhn","header-caption":"feedback-popup-header-base-module__header-caption--Fahm2","headerCaption":"feedback-popup-header-base-module__header-caption--Fahm2","header-close":"feedback-popup-header-base-module__header-close--isj_Z","headerClose":"feedback-popup-header-base-module__header-close--isj_Z","body":"feedback-popup-header-base-module__body--kRJ54","footer":"feedback-popup-header-base-module__footer--qZ4cU","steps-count":"feedback-popup-header-base-module__steps-count--cOjnR","stepsCount":"feedback-popup-header-base-module__steps-count--cOjnR"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-header-base/feedback-popup-header-base.component.tsx









var FeedbackPopupHeaderImageType = /* @__PURE__ */(FeedbackPopupHeaderImageType2 => {
  FeedbackPopupHeaderImageType2[FeedbackPopupHeaderImageType2["Image"] = 0] = "Image";
  FeedbackPopupHeaderImageType2[FeedbackPopupHeaderImageType2["Avatar"] = 1] = "Avatar";
  return FeedbackPopupHeaderImageType2;
})(FeedbackPopupHeaderImageType || {});
const HeaderImage = props => {
  const {
    imageType
  } = props;
  switch (imageType) {
    case 0 /* Image */:
      {
        const {
          imageUrl
        } = props;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: feedback_popup_header_base_module.headerImage,
          style: {
            backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(imageUrl)
          }
        });
      }
    case 1 /* Avatar */:
      {
        const {
          avatarId
        } = props;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
          size: avatar_component/* AvatarSize */.D.Size48,
          avatarId
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(imageType);
  }
};
const FeedbackPopupHeaderBase = props => {
  const {
    caption,
    title
  } = props;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(HeaderImage, {
      ...props
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: feedback_popup_header_base_module.headerTexts,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(feedback_popup_header_base_module.headerCaption, typography_module/* default */.Z.caption),
        children: caption
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.body2Accent,
        children: title
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-header/types/feedback-popup-header-after-chapter/feedback-popup-header-after-chapter.component.tsx





const FeedbackPopupHeaderAfterChapter = _ref => {
  let {
    chapter
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderBase, {
    imageType: FeedbackPopupHeaderImageType.Image,
    imageUrl: chapter?.imageUrl ?? "",
    caption: intl.formatMessage({
      id: "feedbackPopupHeaderAfterChapter.caption"
    }),
    title: chapter?.title ?? ""
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-header/types/feedback-popup-header-after-mentor-speaking/feedback-popup-header-after-mentor-speaking.component.tsx





const FeedbackPopupHeaderAfterMentorSpeaking = _ref => {
  let {
    tutor
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderBase, {
    imageType: FeedbackPopupHeaderImageType.Avatar,
    avatarId: tutor?.avatar ?? "",
    caption: intl.formatMessage({
      id: "feedbackPopupHeaderAfterMentorSpeaking.caption"
    }),
    title: tutor?.name ?? ""
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-header/types/feedback-popup-header-after-speaking/feedback-popup-header-after-speaking.component.tsx





const FeedbackPopupHeaderAfterSpeaking = _ref => {
  let {
    speaking
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderBase, {
    imageType: FeedbackPopupHeaderImageType.Image,
    imageUrl: speaking?.imageUrl ?? "",
    caption: intl.formatMessage({
      id: "feedbackPopupHeaderAfterSpeaking.caption"
    }),
    title: speaking?.title ?? ""
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-header/types/feedback-popup-header-from-description/feedback-popup-header-from-description.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_header_from_description_module = ({"root":"feedback-popup-header-from-description-module__root--UErBa"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-header/types/feedback-popup-header-from-description/feedback-popup-header-from-description.component.tsx






const FeedbackPopupHeaderFromDescription = _ref => {
  let {
    description
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(feedback_popup_header_from_description_module.root, typography_module/* default */.Z.body2Accent),
    children: description.header ?? ""
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-header/feedback-popup-header.component.tsx







const FeedbackPopupHeader = _ref => {
  let {
    speakingsTutorsChapters,
    context,
    description
  } = _ref;
  switch (context.type) {
    case "after-chapter":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderAfterChapter, {
        chapter: speakingsTutorsChapters.chapters.get(context.chapter_id)
      });
    case "after-mentor-speaking":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderAfterMentorSpeaking, {
        tutor: speakingsTutorsChapters.tutors.get(context.tutor_id)
      });
    case "after-speaking":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderAfterSpeaking, {
        speaking: speakingsTutorsChapters.speakings.get(context.speaking_id)
      });
    case void 0:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeaderFromDescription, {
        description
      });
    default:
      return null;
  }
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-base/feedback-popup-base.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_base_module = ({"root":"feedback-popup-base-module__root--Fo9ly","root-desktop":"feedback-popup-base-module__root-desktop--BVc91","rootDesktop":"feedback-popup-base-module__root-desktop--BVc91","header":"feedback-popup-base-module__header--lPzj6","header-image":"feedback-popup-base-module__header-image--WTlW0","headerImage":"feedback-popup-base-module__header-image--WTlW0","header-texts":"feedback-popup-base-module__header-texts--FGagb","headerTexts":"feedback-popup-base-module__header-texts--FGagb","header-caption":"feedback-popup-base-module__header-caption--BCycP","headerCaption":"feedback-popup-base-module__header-caption--BCycP","header-close":"feedback-popup-base-module__header-close--oJebe","headerClose":"feedback-popup-base-module__header-close--oJebe","body":"feedback-popup-base-module__body--L6aHu","footer":"feedback-popup-base-module__footer--A4WI6","steps-count":"feedback-popup-base-module__steps-count--T_7A3","stepsCount":"feedback-popup-base-module__steps-count--T_7A3","actions":"feedback-popup-base-module__actions--pgu6N"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-base/feedback-popup-base.component.tsx













const Popup = _ref => {
  let {
    children,
    onClose
  } = _ref;
  const {
    isTabletOrDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  if (isTabletOrDesktop) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(deprecated_modal_component/* DeprecatedModal */.rr, {
      fullscreenContent: true,
      onClose,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(feedback_popup_base_module.root, feedback_popup_base_module.rootDesktop),
        children
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ModalBottomMobile, {
    onClose,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(feedback_popup_base_module.root),
      children
    })
  });
};
const FeedbackPopupBase = _ref2 => {
  let {
    speakingsTutorsChapters,
    description,
    context,
    currentStep,
    stepsCount,
    isNextActive,
    isFinishButton,
    children,
    onClose,
    onNext
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(Popup, {
    onClose,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: feedback_popup_base_module.header,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupHeader, {
        description,
        speakingsTutorsChapters,
        context
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: feedback_popup_base_module.headerClose,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          iconName: "cross",
          appearance: "secondary",
          size: "small",
          onClick: onClose
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: feedback_popup_base_module.body,
      children
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: feedback_popup_base_module.footer,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: stepsCount > 1 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.body2Accent,
            children: currentStep
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
            className: classnames_default()(feedback_popup_base_module.stepsCount, typography_module/* default */.Z.captionAccent),
            children: ["/", stepsCount]
          })]
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: feedback_popup_base_module.actions,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primary",
          disabled: !isNextActive,
          onClick: onNext,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: isFinishButton ? "feedbackPopupBase.done" : "feedbackPopupBase.next"
          })
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
// EXTERNAL MODULE: ../ui-kit/src/checkbox/index.ts + 7 modules
var src_checkbox = __webpack_require__(7535);
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/useAnswerForType.ts




const useAnswerForType = (answer, type) => {
  const isWrongType = answer !== null && answer.type !== type;
  (0,react.useEffect)(() => {
    if (isWrongType) {
      logger/* Logger */.Yd.unexpectedState();
    }
  }, [isWrongType]);
  if (answer === null || answer.type !== type) {
    return null;
  }
  return answer;
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-checkbox/feedback-popup-type-checkbox.component.tsx
































const OneItem = _ref => {
  let {
    children,
    id,
    isSelected,
    isDisabled,
    onClick
  } = _ref;
  const handleChange = (0,react.useCallback)(isSelected2 => {
    onClick(id, isSelected2);
  }, [id, onClick]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
    size: "small",
    checked: isSelected,
    onChange: handleChange,
    disabled: isDisabled,
    children
  });
};
const FeedbackPopupTypeCheckbox = _ref2 => {
  let {
    items,
    answer,
    answersMaxCount = 0,
    onAnswerChanged
  } = _ref2;
  const currentAnswer = useAnswerForType(answer, "checkbox");
  const currentValue = currentAnswer?.value ?? array_utils/* emptyStringArray */.sP;
  const isUseAnswersMaxCount = answersMaxCount > 0;
  (0,react.useEffect)(() => {
    if (answer === null) {
      onAnswerChanged({
        type: "checkbox",
        value: []
      });
    }
  }, [answer, onAnswerChanged]);
  const answerSet = (0,react.useMemo)(() => new Set(currentValue), [currentValue]);
  const handleClick = (0,react.useCallback)((id, isSelected) => {
    const newAnswerSet = new Set(answerSet);
    if (isSelected) {
      if (newAnswerSet.has(id) || isUseAnswersMaxCount && answerSet.size >= answersMaxCount) {
        return;
      }
      newAnswerSet.add(id);
    } else {
      newAnswerSet.delete(id);
    }
    onAnswerChanged({
      type: "checkbox",
      value: Array.from(newAnswerSet)
    });
    newAnswerSet.clear();
  }, [isUseAnswersMaxCount, answersMaxCount, answerSet, onAnswerChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: items.map(item => {
      const isSelected = answerSet.has(item.id);
      const isDisabled = isUseAnswersMaxCount ? !isSelected && answerSet.size >= answersMaxCount : false;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(OneItem, {
        id: item.id,
        isSelected,
        onClick: handleClick,
        isDisabled,
        children: item.text
      }, item.id);
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-markdown/feedback-popup-type-markdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_type_markdown_module = ({"root":"feedback-popup-type-markdown-module__root--akAsj"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-markdown/feedback-popup-type-markdown.component.tsx






const FeedbackPopupTypeMarkdown = _ref => {
  let {
    markdown,
    onAnswerChanged
  } = _ref;
  (0,react.useEffect)(() => {
    onAnswerChanged({
      type: "markdown",
      value: null
    });
  }, [onAnswerChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: feedback_popup_type_markdown_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      children: markdown
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/radio-button/index.ts + 6 modules
var radio_button = __webpack_require__(13777);
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-radio/feedback-popup-type-radio.component.tsx








const feedback_popup_type_radio_component_OneItem = _ref => {
  let {
    children,
    id,
    isSelected,
    onClick
  } = _ref;
  const handleChange = (0,react.useCallback)(isSelected2 => {
    if (isSelected2) {
      onClick(id);
    }
  }, [id, onClick]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
    size: "small",
    checked: isSelected,
    onChange: handleChange,
    children
  });
};
const FeedbackPopupTypeRadio = _ref2 => {
  let {
    items,
    answer,
    onAnswerChanged
  } = _ref2;
  const currentAnswer = useAnswerForType(answer, "radio");
  const handleClick = (0,react.useCallback)(id => {
    onAnswerChanged({
      type: "radio",
      value: id
    });
  }, [onAnswerChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)(feedback_popup_type_radio_component_OneItem, {
      id: item.id,
      isSelected: currentAnswer?.value === item.id,
      onClick: handleClick,
      children: item.text
    }, item.id))
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/rating/star-2.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* harmony default export */ const star_2 = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "44",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M21.098 1.854c.599-1.843 3.205-1.843 3.804 0l3.935 12.112a2 2 0 001.902 1.382h12.735c1.938 0 2.743 2.479 1.176 3.618L34.347 26.45a2 2 0 00-.726 2.236l3.935 12.111c.599 1.843-1.51 3.375-3.078 2.236L24.176 35.55a2 2 0 00-2.352 0l-10.302 7.485c-1.568 1.14-3.677-.393-3.078-2.236l3.935-12.111a2 2 0 00-.726-2.236L1.35 18.966c-1.567-1.14-.762-3.619 1.176-3.619H15.26a2 2 0 001.902-1.381l3.935-12.112z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/rating/rating.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const rating_module = ({"root":"rating-module__root--kS50M","item":"rating-module__item--jppEW","item-active":"rating-module__item-active--vyngW","itemActive":"rating-module__item-active--vyngW"});
;// CONCATENATED MODULE: ../ui-kit/src/rating/rating.component.tsx







const items = [0, 0, 0, 0, 0];
const OneStar = _ref => {
  let {
    rating,
    active,
    onActivate,
    onHover
  } = _ref;
  const handleActivate = (0,react.useCallback)(() => {
    onActivate(rating);
  }, [rating, onActivate]);
  const handleHover = (0,react.useCallback)(() => {
    onHover(rating);
  }, [rating, onHover]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(rating_module.item, {
      [rating_module.itemActive]: active
    }),
    onClick: handleActivate,
    onMouseEnter: handleHover,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(star_2, {})
  });
};
const Rating = _ref2 => {
  let {
    rating,
    onChange
  } = _ref2;
  const [hoverRating, setHoverRating] = (0,react.useState)(0);
  const handleLeave = (0,react.useCallback)(() => {
    setHoverRating(0);
  }, [setHoverRating]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: rating_module.root,
    onMouseLeave: handleLeave,
    children: items.map((_, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(OneStar, {
      rating: index + 1,
      active: index < rating || index < hoverRating,
      onActivate: onChange,
      onHover: setHoverRating
    }, index))
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-rate/feedback-popup-type-rate.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_type_rate_module = ({"root":"feedback-popup-type-rate-module__root--UOTXu"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-rate/feedback-popup-type-rate.component.tsx







const FeedbackPopupTypeRate = _ref => {
  let {
    answer,
    onAnswerChanged
  } = _ref;
  const currentAnswer = useAnswerForType(answer, "rate");
  const handleChange = (0,react.useCallback)(value => {
    onAnswerChanged({
      type: "rate",
      value
    });
  }, [onAnswerChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: feedback_popup_type_rate_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(Rating, {
      rating: currentAnswer?.value ?? 0,
      onChange: handleChange
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/input-depricated/input-depricated.component.tsx + 1 modules
var input_depricated_component = __webpack_require__(54157);
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-text/feedback-popup-type-text.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_type_text_module = ({"root":"feedback-popup-type-text-module__root--tvhBO"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/types/feedback-popup-type-text/feedback-popup-type-text.component.tsx







const FeedbackPopupTypeText = _ref => {
  let {
    placeholder,
    answer,
    onAnswerChanged
  } = _ref;
  const currentAnswer = useAnswerForType(answer, "text");
  (0,react.useEffect)(() => {
    if (answer === null) {
      onAnswerChanged({
        type: "text",
        value: ""
      });
    }
  }, [answer, onAnswerChanged]);
  const handleChange = (0,react.useCallback)(text => {
    onAnswerChanged({
      type: "text",
      value: text
    });
  }, [onAnswerChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: feedback_popup_type_text_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
      placeholder,
      multiline: true,
      size: input_depricated_component/* InputSize */.fz.Small,
      value: currentAnswer?.value ?? "",
      height: input_depricated_component/* InputHeight */.ac.Container,
      disableResize: true,
      onChange: handleChange
    })
  });
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-step/feedback-popup-step.component.tsx









const FeedbackPopupStep = _ref => {
  let {
    content,
    answer,
    onAnswerChanged
  } = _ref;
  const type = content.type;
  switch (type) {
    case "rate":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupTypeRate, {
        answer,
        onAnswerChanged
      });
    case "checkbox":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupTypeCheckbox, {
        items: content.items,
        answer,
        answersMaxCount: content.answersMaxCount,
        onAnswerChanged
      });
    case "radio":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupTypeRadio, {
        items: content.items,
        answer,
        onAnswerChanged
      });
    case "text":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupTypeText, {
        placeholder: content.placeholder,
        answer,
        onAnswerChanged
      });
    case "markdown":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupTypeMarkdown, {
        markdown: content.markdown,
        onAnswerChanged
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
;// CONCATENATED MODULE: ./src/components/feedback-popup-steps/getCurrentFeedbackFormState.ts




















































class GetCurrentFeedbackFromStateError extends Error {
  constructor() {
    super("Function getCurrentFeedbackFormState throws error");
  }
}
class GetCurrentFeedbackFormStateAnswerTypeWrongError extends Error {
  constructor() {
    super("Function getCurrentFeedbackFormState throws warning: answer type is wrong");
  }
}
const getPotentialNextStepId = (step, nextByOrderStepId) => {
  const stepContentType = step.content.type;
  const nextStepIds = /* @__PURE__ */new Set();
  let needToAddNextStep;
  switch (stepContentType) {
    case "text":
    case "checkbox":
    case "markdown":
      needToAddNextStep = true;
      break;
    case "rate":
      {
        needToAddNextStep = false;
        const items = step.content.items ?? {};
        for (let i = 0; i <= 5; i++) {
          const current = items[i];
          if (current === void 0) {
            needToAddNextStep = true;
          } else {
            nextStepIds.add(current.goToId);
          }
        }
        break;
      }
    case "radio":
      needToAddNextStep = false;
      step.content.items.forEach(item => {
        if (item.goToId === void 0) {
          needToAddNextStep = true;
        } else {
          nextStepIds.add(item.goToId);
        }
      });
      break;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(stepContentType);
  }
  if (needToAddNextStep) {
    nextStepIds.add(step.goToId !== void 0 ? step.goToId : nextByOrderStepId);
  }
  return Array.from(nextStepIds);
};
const createGetStepIdByAnswer = (step, nextByOrderStepId) => {
  const stepContent = step.content;
  const stepContentType = stepContent.type;
  const nextNodeIdDefault = step.goToId !== void 0 ? step.goToId : nextByOrderStepId;
  switch (stepContentType) {
    case "text":
    case "checkbox":
    case "markdown":
      return answer => {
        if (answer === null) {
          return {
            isAnswered: false
          };
        }
        if (answer.type !== stepContentType) {
          logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFormStateAnswerTypeWrongError(), {
            blockId: step.id,
            answerType: answer.type
          });
          return {
            isAnswered: false
          };
        }
        return {
          isAnswered: true,
          nextNodeId: nextNodeIdDefault
        };
      };
    case "rate":
      return answer => {
        if (answer === null) {
          return {
            isAnswered: false
          };
        }
        if (answer.type !== "rate") {
          logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFormStateAnswerTypeWrongError(), {
            blockId: step.id,
            answerType: answer.type
          });
          return {
            isAnswered: false
          };
        }
        const currentItem = (stepContent.items ?? {})[answer.value];
        return {
          isAnswered: true,
          nextNodeId: currentItem !== void 0 ? currentItem.goToId : nextNodeIdDefault
        };
      };
    case "radio":
      {
        const radioGoToMap = /* @__PURE__ */new Map();
        stepContent.items.forEach(item => {
          if (item.goToId !== void 0) {
            radioGoToMap.set(item.id, item.goToId);
          }
        });
        return answer => {
          if (answer === null) {
            return {
              isAnswered: false
            };
          }
          if (answer.type !== "radio") {
            logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFormStateAnswerTypeWrongError(), {
              blockId: step.id,
              answerType: answer.type
            });
            return {
              isAnswered: false
            };
          }
          const radioGoToResult = radioGoToMap.get(answer.value);
          return {
            isAnswered: true,
            nextNodeId: radioGoToResult !== void 0 ? radioGoToResult : nextNodeIdDefault
          };
        };
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(stepContentType);
  }
};
const convertFeedbackStepsDescriptionToNodes = description => {
  if (description.steps.length === 0) {
    logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFromStateError(), {
      type: `Empty steps list`
    });
    return null;
  }
  const nodes = new Map(description.steps.map((step, index, steps) => {
    const nextByOrderStepId = steps[index + 1]?.id ?? null;
    return [step.id, {
      step,
      getNextStepIdByAnswer: createGetStepIdByAnswer(step, nextByOrderStepId),
      potentialNextStepIds: getPotentialNextStepId(step, nextByOrderStepId)
    }];
  }));
  return {
    initialNodeId: description.steps[0].id,
    nodes
  };
};
const finishedGetStateByAnswer = () => ({
  isDone: true
});
const getMaxRemainedStepsCount = (stepId, nodes, processedNodeIds) => {
  const notProcessedNodesCount = nodes.nodes.size - processedNodeIds.size;
  const nodeWeights = /* @__PURE__ */new Map([[stepId, 1]]);
  const fifoIds = [stepId];
  while (fifoIds.length > 0) {
    const currentId = fifoIds.pop();
    if (currentId === void 0) {
      logger/* Logger */.Yd.unexpectedState();
      break;
    }
    const currentWeight = nodeWeights.get(currentId);
    if (currentWeight === void 0) {
      logger/* Logger */.Yd.unexpectedState();
      break;
    }
    if (currentWeight > notProcessedNodesCount) {
      logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFromStateError(), {
        type: `Cycle in description found. One of chain steps: ${currentId}`
      });
      break;
    }
    const node = nodes.nodes.get(currentId);
    if (node === void 0) {
      logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFromStateError(), {
        type: `Wrong node id 2: ${currentId}`
      });
      break;
    }
    node.potentialNextStepIds.forEach(nextStepId => {
      if (nextStepId === null) {
        return;
      }
      if (processedNodeIds.has(nextStepId)) {
        logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFromStateError(), {
          type: `Cycle in description found. One of chain steps: ${currentId}`
        });
        return;
      }
      const nextNodeWeight = nodeWeights.get(nextStepId) ?? 0;
      if (nextNodeWeight < currentWeight + 1) {
        nodeWeights.set(nextStepId, currentWeight + 1);
        fifoIds.push(nextStepId);
      }
    });
  }
  return Array.from(nodeWeights.values()).reduce((acc, val) => Math.max(acc, val), 0);
};
const getCurrentFeedbackFormState = (description, answers) => {
  const nodes = convertFeedbackStepsDescriptionToNodes(description);
  if (nodes === null) {
    return finishedGetStateByAnswer;
  }
  const processedNodeIds = /* @__PURE__ */new Set();
  let currentNodeId = nodes.initialNodeId;
  let currentStepIndex = 0;
  for (;;) {
    if (processedNodeIds.has(currentNodeId)) {
      logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFromStateError(), {
        type: `Cycle in description found. Step id: ${currentNodeId}`
      });
      return finishedGetStateByAnswer;
    }
    processedNodeIds.add(currentNodeId);
    currentStepIndex++;
    const currentNode = nodes.nodes.get(currentNodeId);
    if (currentNode === void 0) {
      logger/* Logger */.Yd.captureException(new GetCurrentFeedbackFromStateError(), {
        type: `Wrong node id: ${currentNodeId}`
      });
      return finishedGetStateByAnswer;
    }
    const nextStepDescription = currentNode.getNextStepIdByAnswer(answers[currentNodeId] ?? null);
    if (nextStepDescription.isAnswered) {
      if (nextStepDescription.nextNodeId === null) {
        return finishedGetStateByAnswer;
      }
      currentNodeId = nextStepDescription.nextNodeId;
      continue;
    }
    const expectedStepsCounts = new Map(currentNode.potentialNextStepIds.map(stepId => {
      if (stepId === null) {
        return [stepId, 0];
      }
      return [stepId, getMaxRemainedStepsCount(stepId, nodes, processedNodeIds)];
    }));
    const maxExpectedStepsCount = Array.from(expectedStepsCounts.values()).reduce((acc, v) => Math.max(acc, v), 0);
    return currentAnswer => {
      const nextState = currentNode.getNextStepIdByAnswer(currentAnswer);
      let isFinal;
      let expectedStepsCountNext;
      if (nextState.isAnswered) {
        isFinal = nextState.nextNodeId === null;
        const expectedCount = expectedStepsCounts.get(nextState.nextNodeId);
        if (expectedCount === void 0) {
          expectedStepsCountNext = 0;
          logger/* Logger */.Yd.unexpectedState();
        } else {
          expectedStepsCountNext = expectedCount;
        }
      } else {
        isFinal = !currentNode.potentialNextStepIds.some(id => id !== null);
        expectedStepsCountNext = maxExpectedStepsCount;
      }
      return {
        isDone: false,
        currentStepIndex,
        expectedStepsCount: currentStepIndex + expectedStepsCountNext,
        step: currentNode.step,
        isFinal
      };
    };
  }
};
;// CONCATENATED MODULE: ./src/components/feedback-popup-steps/feedback-popup-steps.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const feedback_popup_steps_module = ({"text":"feedback-popup-steps-module__text--DqwHs","additional-text":"feedback-popup-steps-module__additional-text--hPew3","additionalText":"feedback-popup-steps-module__additional-text--hPew3"});
;// CONCATENATED MODULE: ./src/components/feedback-popup-steps/feedback-popup-steps.component.tsx










const FeedbackPopupSteps = _ref => {
  let {
    speakingsTutorsChapters,
    initialAnswers,
    description,
    context,
    onAnswer,
    onFinish
  } = _ref;
  const [answers, setAnswers] = (0,react.useState)(initialAnswers);
  const [answer, setAnswer] = (0,react.useState)(null);
  const getCurrentState = (0,react.useMemo)(() => getCurrentFeedbackFormState(description, answers), [answers, description]);
  const currentState = (0,react.useMemo)(() => getCurrentState(answer), [answer, getCurrentState]);
  const handleNext = (0,react.useCallback)(() => {
    if (answer === null || currentState.isDone) {
      return;
    }
    setAnswers(answers2 => ({
      ...answers2,
      [currentState.step.id]: answer
    }));
    onAnswer(currentState.step.id, answer);
    setAnswer(null);
  }, [answer, currentState, onAnswer]);
  const handleClose = (0,react.useCallback)(() => {
    onFinish(false);
  }, [onFinish]);
  (0,react.useEffect)(() => {
    if (currentState.isDone) {
      onFinish(true);
    }
  }, [currentState.isDone, onFinish]);
  if (currentState.isDone) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(FeedbackPopupBase, {
    speakingsTutorsChapters,
    description,
    context,
    currentStep: currentState.currentStepIndex,
    stepsCount: currentState.expectedStepsCount,
    isNextActive: answer !== null,
    isFinishButton: currentState.isFinal,
    onNext: handleNext,
    onClose: handleClose,
    children: [currentState.step.text !== void 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(feedback_popup_steps_module.text, typography_module/* default */.Z.body2Accent),
      children: currentState.step.text
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupStep, {
      content: currentState.step.content,
      answer,
      onAnswerChanged: setAnswer
    }), currentState.step.additionalText !== void 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(feedback_popup_steps_module.additionalText, typography_module/* default */.Z.caption),
      children: currentState.step.additionalText
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../shared/src/models/bell/item.ts
var item = __webpack_require__(25382);
// EXTERNAL MODULE: ../shared/src/services/bell/useBellNotification.ts
var useBellNotification = __webpack_require__(53378);
// EXTERNAL MODULE: ./src/api/events/events.api.ts + 2 modules
var events_api = __webpack_require__(53536);
// EXTERNAL MODULE: ./src/api/student/student.api.ts + 4 modules
var student_api = __webpack_require__(91514);
;// CONCATENATED MODULE: ./src/components/feedback-popup/use-feedback.tsx








function useFeedback() {
  const [isSurveyLoading, setIsSurveyLoading] = (0,react.useState)(false);
  const [survey, setSurvey] = (0,react.useState)(null);
  const {
    getBellNotifications
  } = (0,useBellNotification/* useBellNotification */.C)();
  const canTakeBellNotification = !isSurveyLoading && !survey;
  const feedbackBellNotification = canTakeBellNotification ? getBellNotifications(item/* AppBellItemType */.M.Feedback)[0] : void 0;
  const handleFinish = (0,react.useCallback)(isEnded => {
    if (survey === null) {
      return;
    }
    void (0,events_api/* eventPost */.bQ)({
      type: "survey_answer",
      payload: {
        user_survey_id: survey.id,
        is_final: true,
        is_ended: isEnded
      }
    });
    setSurvey(null);
  }, [survey]);
  const handleAnswer = (0,react.useCallback)((stepId, answer) => {
    if (survey === null) {
      return;
    }
    void (0,events_api/* eventPost */.bQ)({
      type: "survey_answer",
      payload: {
        ...answer,
        is_final: false,
        user_survey_id: survey.id,
        step_id: stepId
      }
    });
  }, [survey]);
  (0,react.useEffect)(() => {
    if (!feedbackBellNotification || isSurveyLoading || survey) {
      return;
    }
    setIsSurveyLoading(true);
    void (0,student_api/* getOneActiveSurvey */.$O)().then(x => {
      if ((0,Either.isLeft)(x) || x.right === null) {
        return;
      }
      setSurvey(x.right);
    }).finally(() => {
      setIsSurveyLoading(false);
    });
    if (feedbackBellNotification) {
      feedbackBellNotification.markAsRead();
    }
  }, [feedbackBellNotification, isSurveyLoading, survey, setSurvey, setIsSurveyLoading]);
  return {
    survey,
    handleAnswer,
    handleFinish
  };
}
;// CONCATENATED MODULE: ./src/components/feedback-popup/feedback-popup.component.tsx





















const onErrorContent = () => null;
const speakingsTutorsChaptersMock = {
  chapters: /* @__PURE__ */new Map([]),
  speakings: /* @__PURE__ */new Map([]),
  tutors: /* @__PURE__ */new Map([])
};
function feedback_popup_component_handleError(error, errorInfo) {
  logger/* Logger */.Yd.captureException(error, {
    info: errorInfo
  }, {
    block: "FeedbackPopup"
  });
}
const FeedbackPopup = () => /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
  onError: feedback_popup_component_handleError,
  onErrorContent,
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupContent, {
    speakingsTutorsChapters: speakingsTutorsChaptersMock
  })
});
const FeedbackPopupContent = _ref => {
  let {
    speakingsTutorsChapters
  } = _ref;
  const {
    survey,
    handleFinish,
    handleAnswer
  } = useFeedback();
  if (survey === null) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopupSteps, {
    speakingsTutorsChapters,
    description: survey.markup,
    initialAnswers: survey.answers,
    context: survey.context,
    onFinish: handleFinish,
    onAnswer: handleAnswer
  });
};
// EXTERNAL MODULE: ./src/hooks/products/useProducts.tsx
var useProducts = __webpack_require__(78873);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../shared/src/models/webrtc/webrtc.model.ts
var webrtc_model = __webpack_require__(24144);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
;// CONCATENATED MODULE: ./src/hooks/user/useUserAttributes.tsx






var State = /* @__PURE__ */(State2 => {
  State2["Initial"] = "initial";
  State2["Loading"] = "loading";
  State2["Loaded"] = "loaded";
  return State2;
})(State || {});
const UserAttributesContext = (0,react.createContext)({
  data: null,
  reload: function_utils/* unexpectedFunction */.WK
});
const UserAttributesProvider = _ref => {
  let {
    children
  } = _ref;
  const user = (0,useUser/* useUser */.aF)();
  const value = (0,react.useMemo)(() => ({
    reload: user.functions?.reloadAttributes ?? function_utils/* emptyFunction */.Bi,
    data: user.data?.attributes ?? null
  }), [user.data?.attributes, user.functions?.reloadAttributes]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(UserAttributesContext.Provider, {
    value,
    children
  });
};
const useUserAttributes = () => (0,react.useContext)(UserAttributesContext);
// EXTERNAL MODULE: ./src/state-machine/user/authorization/model.ts + 1 modules
var model = __webpack_require__(55378);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.has-own.js
var es_object_has_own = __webpack_require__(20110);
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var utils_experimentDi = __webpack_require__(40826);
;// CONCATENATED MODULE: ./src/utils/di-injections/mergeInjectionsWithPriority.ts






























function mutateObject(obj, key, value) {
  obj[key] = value;
}
function getNormalPriorityInjections(value) {
  return {
    value,
    priority: utils_experimentDi/* DIInjectionPriority */.G8.Normal
  };
}
const getInjectionValues = injections => {
  const result = {};
  for (const [key, value] of Object.entries(injections)) {
    mutateObject(result, key, value?.value);
  }
  return result;
};
const mergeInjectionsWithPriority = (first, second) => {
  const result = {};
  const filterKeys = /* @__PURE__ */new Set();
  for (const key in first) {
    const firstObjectKey = key;
    const secondObjectKey = key;
    const resultKey = key;
    if (first && second && Object.hasOwn(first, key) && Object.hasOwn(second, key)) {
      const firstPriority = first[firstObjectKey]?.priority ?? utils_experimentDi/* DIInjectionPriority */.G8.Normal;
      const secondPriority = second[secondObjectKey]?.priority ?? utils_experimentDi/* DIInjectionPriority */.G8.Normal;
      const firstValue = first[firstObjectKey]?.value ?? void 0;
      const secondValue = second[secondObjectKey]?.value ?? void 0;
      if (secondPriority >= firstPriority) {
        mutateObject(result, resultKey, secondValue);
      } else {
        mutateObject(result, resultKey, firstValue);
      }
      filterKeys.add(key);
    } else if (second && Object.hasOwn(second, key)) {
      mutateObject(result, resultKey, second[secondObjectKey]?.value ?? void 0);
      filterKeys.add(key);
    } else if (first && Object.hasOwn(first, key)) {
      mutateObject(result, resultKey, first[firstObjectKey]?.value ?? void 0);
    }
  }
  const secondWithoutKeys = Object.keys(second).reduce((acc, key) => {
    if (filterKeys.has(key)) {
      return acc;
    }
    return {
      ...acc,
      [key]: second[key]
    };
  }, {});
  const secondInjections = getInjectionValues(secondWithoutKeys);
  return {
    ...result,
    ...secondInjections
  };
};
;// CONCATENATED MODULE: ./src/utils/di-injections/experiments.ts




















































const PRODUCTION_A2PLUS_LEVEL_IDS = ["7fc6317d-f35a-4ed3-a90f-a8d87743f3bd", "811cd610-17cc-11eb-a400-1fb32dcff35a", "f266e57e-4cfb-4981-93d2-6e4dff824290", "2e9aa96c-d90f-4c72-8334-b8fe20910fbb"];
const useExperimentsDI = experiments => {
  const userAttributes = useUserAttributes();
  return (0,react.useMemo)(() => {
    const injections = {};
    if (experiments?.[model/* ExperimentType */.s.productTrainerRepetition]) {
      injections.productTrainerRepetitionExperimentIsActive = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.disableTelemostErrorHandling]) {
      injections.disableTelemostErrorHandling = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.dashboardType9]) {
      injections.hideMentorSpeaking = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.skipTrialTest1]) {
      injections.skipTrial = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.a2PlusDisableGrammarAndLexis] && PRODUCTION_A2PLUS_LEVEL_IDS.includes(userAttributes.data?.currentProductId ?? "")) {
      injections.hideGrammarAndLexis = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.autopayByResource]) {
      injections.autopayByResource = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.appRevisionExperiment]) {
      injections.appRevisionExperiment = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.coursesSplitPay]) {
      injections.coursesSplitPay = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.disallowSpeakingSessionMultipleReschedule]) {
      injections.disallowSpeakingSessionMultipleReschedule = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.a2PlusDisableDashboardLinkOnGrammarAndLexis] && PRODUCTION_A2PLUS_LEVEL_IDS.includes(userAttributes.data?.currentProductId ?? "")) {
      injections.hideGrammarAndLexis = getNormalPriorityInjections(true);
      injections.disableGrammarAndLexisOnDashboard = getNormalPriorityInjections(true);
    }
    injections.calendarWebcal = getNormalPriorityInjections(Boolean(experiments?.[model/* ExperimentType */.s.calendarWebcal]));
    injections.enableOnlyTrainerEventExperiment = getNormalPriorityInjections(Boolean(experiments?.[model/* ExperimentType */.s.enableOnlyTrainerEventExperiment]));
    if (experiments?.[model/* ExperimentType */.s.newFilters]) {
      injections.newFilters = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.allowAccessForPacketStudents]) {
      injections.allowAccessForPacketStudents = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.resources]) {
      injections.resourcesExperiment = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.goloomCheckup]) {
      injections.goloomCheckup = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.newPurchasePage]) {
      injections.newPurchasePage = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.newPurchaseAfs]) {
      injections.newPurchaseAfs = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.newPurchasePsp]) {
      injections.newPurchasePsp = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.payWithSbp]) {
      injections.payWithSbp = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.skipMicVolumeCheck]) {
      injections.skipMicVolumeCheck = getNormalPriorityInjections(true);
    }
    injections.placementTestFunnel = getNormalPriorityInjections(Boolean(experiments?.[model/* ExperimentType */.s.placementTestFunnel]));
    injections.hideCancelButton = getNormalPriorityInjections(Boolean(experiments?.[model/* ExperimentType */.s.hideCancelButton]));
    injections.hideInternationalCardsPsp = getNormalPriorityInjections(Boolean(experiments?.[model/* ExperimentType */.s.hideInternationalCardsPsp]));
    injections.showProgressPage = getNormalPriorityInjections(Boolean(experiments?.[model/* ExperimentType */.s.showProgressPage]));
    if (experiments?.[model/* ExperimentType */.s.translationV2]) {
      injections.translationV2 = getNormalPriorityInjections(true);
    }
    if (experiments?.[model/* ExperimentType */.s.autoOnboarding]) {
      injections.autoOnboarding = getNormalPriorityInjections(true);
    }
    const a2FlippedMethodExperiment = experiments?.[model/* ExperimentType */.s.a2FlippedMethod];
    if (a2FlippedMethodExperiment) {
      injections.isMentorNotesVisible = getNormalPriorityInjections(false);
      injections.nativeSpeakerSessionIds = getNormalPriorityInjections(new Set(a2FlippedMethodExperiment.nativeSpeakingIds));
      injections.isA2PlusFlippedExperimentActive = getNormalPriorityInjections(true);
      injections.a2PlusFlippedExperimentConfig = getNormalPriorityInjections({
        trialSpeakingId: a2FlippedMethodExperiment.trialSpeakingId,
        trialChapterIds: a2FlippedMethodExperiment.trialChapterIds,
        productId: a2FlippedMethodExperiment.productId
      });
    }
    const referral = experiments?.[model/* ExperimentType */.s.referral];
    if (referral) {
      injections.referral = getNormalPriorityInjections({
        tariff_slug: referral.tariff_slug
      });
    }
    if (experiments !== null) {
      const redefinesMap = /* @__PURE__ */new Map();
      const addLevels = [];
      const partialPaymentProductsIdSet = /* @__PURE__ */new Set();
      const hideProducts = /* @__PURE__ */new Set();
      const openPageAfterPlacement = /* @__PURE__ */new Map();
      const paymentLinkRedefines = /* @__PURE__ */new Map();
      Object.values(experiments).forEach(experiment => {
        const levelRedefine = experiment.redefine_product?.[student_model/* ProductType */.kv.Level] ?? {};
        Object.entries(levelRedefine).forEach(_ref => {
          let [key, redefine] = _ref;
          redefinesMap.set(key, redefine);
        });
        experiment.add_product?.[student_model/* ProductType */.kv.Level]?.forEach(level => {
          addLevels.push(level);
        });
        experiment.partial_payment_product_ids?.forEach(id => {
          partialPaymentProductsIdSet.add(id);
        });
        experiment.hide_product?.forEach(productId => {
          hideProducts.add(productId);
        });
        if (experiment.open_page_after_placement) {
          const url = experiment.open_page_after_placement.url;
          experiment.open_page_after_placement.product_ids.forEach(productId => {
            openPageAfterPlacement.set(productId, url);
          });
        }
        const webrtcProviderFromExperiment = experiment.webrtc_provider;
        if (webrtcProviderFromExperiment) {
          if (webrtc_model/* WebrtcProviderValidator */.v.is(webrtcProviderFromExperiment)) {
            injections.webrtcProvider = getNormalPriorityInjections(webrtcProviderFromExperiment);
          } else {
            logger/* Logger */.Yd.captureError("Invalid webrtc provider from experiment", {
              provider_from_experiment: webrtcProviderFromExperiment
            });
          }
        }
        const redefineButtonLinkExperiment = experiment.redefine_payment_button_link;
        if (redefineButtonLinkExperiment) {
          const url = redefineButtonLinkExperiment.url;
          redefineButtonLinkExperiment.product_ids.forEach(productId => {
            paymentLinkRedefines.set(productId, url);
          });
        }
      });
      injections.redefinePaymentLink = getNormalPriorityInjections(paymentLinkRedefines);
      injections.levelsSelectorIdsRedefine = getNormalPriorityInjections(redefinesMap);
      injections.levelsSelectorAddLevels = getNormalPriorityInjections(addLevels);
      injections.partialPaymentProductsIdSet = getNormalPriorityInjections(partialPaymentProductsIdSet);
      injections.hideProducts = getNormalPriorityInjections(hideProducts);
      injections.openPageAfterPlacement = getNormalPriorityInjections(openPageAfterPlacement);
      const maxTimeToTutorAssignmentHours = Object.values(experiments).find(experiments2 => experiments2.max_time_to_tutor_assignment_hours !== void 0);
      if (maxTimeToTutorAssignmentHours !== void 0 && maxTimeToTutorAssignmentHours.max_time_to_tutor_assignment_hours !== void 0) {
        injections.maxTimeToTutorAssignmentHours = getNormalPriorityInjections(maxTimeToTutorAssignmentHours.max_time_to_tutor_assignment_hours);
      }
    }
    return injections;
  }, [experiments, userAttributes.data?.currentProductId]);
};
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
;// CONCATENATED MODULE: ./src/utils/di-injections/product-markup.ts







const useProductMarkupDi = product => (0,react.useMemo)(() => {
  const injections = {};
  if (!product) {
    return injections;
  }
  switch (product.main?.type) {
    case student_model/* MainPageType */.de.Beginners:
    case student_model/* MainPageType */.de.Bus:
      {
        injections.productMainType = {
          value: utils_experimentDi/* ProductMainType */.SH.General,
          priority: utils_experimentDi/* DIInjectionPriority */.G8.Primary
        };
        injections.showGuidesButton = getNormalPriorityInjections(true);
        injections.routes = getNormalPriorityInjections(studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT);
        injections.showSkipButtonInTrainer = getNormalPriorityInjections(true);
        break;
      }
    default:
      break;
  }
  if (product.layoutFeatures) {
    if (product.layoutFeatures.disableMentorNotes) {
      injections.isMentorNotesVisible = getNormalPriorityInjections(false);
    }
    injections.hideGrammarAndLexis = getNormalPriorityInjections(Boolean(product.layoutFeatures.disabledGrammarAndLexisInTrainer));
    injections.startWithSpeakingSession = getNormalPriorityInjections(Boolean(product.layoutFeatures.startWithSpeakingSession));
    injections.openStoryAfterSpeaking = getNormalPriorityInjections(Boolean(product.layoutFeatures.openStoryAfterSpeaking));
    injections.grammarAndLexisAfterSpeaking = getNormalPriorityInjections(Boolean(product.layoutFeatures.grammarAndLexisAfterSpeaking));
    injections.showGrammarGuideButtonInMenu = getNormalPriorityInjections(Boolean(product.layoutFeatures.showGrammarGuideButtonInMenu));
    injections.hideAddToWordbankButton = getNormalPriorityInjections(Boolean(product.layoutFeatures.hideAddToWordbankButton));
    injections.hideChapterDuration = getNormalPriorityInjections(Boolean(product.layoutFeatures.hideChapterDuration));
  }
  if (product.disableTrainerOutroActions === true) {
    injections.disableTrainerOutroActions = getNormalPriorityInjections(true);
  }
  if (product.notForSale) {
    injections.notForSale = getNormalPriorityInjections(true);
  }
  if (product.businessProductFeatureFlags?.resources) {
    injections.resources = getNormalPriorityInjections({
      enabled: product.businessProductFeatureFlags.resources.enabled,
      resourceTypes: product.businessProductFeatureFlags.resources.resource_types
    });
  }
  if (product.businessProductFeatureFlags?.student?.show_rescheduling_button) {
    injections.showReschedulingButton = getNormalPriorityInjections(true);
  }
  if (product.businessProductFeatureFlags?.student?.show_course_map) {
    injections.showCourseMap = getNormalPriorityInjections(true);
  }
  if (product.businessProductFeatureFlags?.student?.show_cancel_or_reschedule_reason_survey) {
    injections.showCancelOrRescheduleReasonSurvey = getNormalPriorityInjections(true);
  }
  if (product.businessProductFeatureFlags?.student?.fixed_chapters) {
    const fixedChapters = product.businessProductFeatureFlags?.student?.fixed_chapters.map(chapter => ({
      title: chapter.title,
      subtitle: chapter.subtitle,
      chapterId: chapter.chapter_id,
      image: chapter.image ?? null
    }));
    injections.fixedChapters = getNormalPriorityInjections(fixedChapters);
  }
  if (product.businessProductFeatureFlags?.auto_onboarding) {
    injections.autoOnboarding = getNormalPriorityInjections(true);
  }
  return injections;
}, [product]);
;// CONCATENATED MODULE: ./src/hooks/useDiInjections.ts






const useDiInjections = (experiments, productMarkup) => {
  const productMarkupInjections = useProductMarkupDi(productMarkup);
  const experimentInjections = useExperimentsDI(experiments);
  return (0,react.useMemo)(() => {
    if (Object.keys(experimentInjections).length !== 0 && Object.keys(productMarkupInjections).length !== 0) {
      return mergeInjectionsWithPriority(productMarkupInjections, experimentInjections);
    } else if (Object.keys(experimentInjections).length !== 0) {
      return getInjectionValues(experimentInjections);
    } else if (Object.keys(productMarkupInjections).length !== 0) {
      return getInjectionValues(productMarkupInjections);
    }
    return {};
  }, [experimentInjections, productMarkupInjections]);
};
;// CONCATENATED MODULE: ./src/hooks/useOnboardingTooltipsState.tsx





const SHOW_ONBOARDING_TOOLTIP_KEY = "flow:showOnboardingHelp";
const OnboardingTooltipStateContext = (0,react.createContext)({
  isVisible: false,
  setVisible: function_utils/* emptyFunction */.Bi
});
const OnboardingTooltipsStateProvider = _ref => {
  let {
    children
  } = _ref;
  const [isVisible, setVisible] = (0,react.useState)(false);
  const value = (0,react.useMemo)(() => ({
    isVisible,
    setVisible
  }), [isVisible]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(OnboardingTooltipStateContext.Provider, {
    value,
    children
  });
};
const useOnboardingTooltipsState = () => {
  const {
    setVisible,
    isVisible
  } = useContext(OnboardingTooltipStateContext);
  const setVisibleTooltip = useCallback(visible => {
    localStorage.setItem(SHOW_ONBOARDING_TOOLTIP_KEY, visible ? "1" : "0");
    setVisible(visible);
  }, [setVisible]);
  useEffect(() => {
    if (localStorage.getItem(SHOW_ONBOARDING_TOOLTIP_KEY) === null) {
      setVisible(true);
    } else {
      setVisible(localStorage.getItem(SHOW_ONBOARDING_TOOLTIP_KEY) === "1");
    }
  }, [setVisible]);
  return {
    setVisible: setVisibleTooltip,
    isVisible
  };
};
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInMinutes.mjs
var differenceInMinutes = __webpack_require__(34002);
// EXTERNAL MODULE: ./src/api/utils/utils.api.ts + 2 modules
var utils_api = __webpack_require__(11775);
;// CONCATENATED MODULE: ./src/utils/time.ts






const checkTime = async () => {
  const serverTime = await (0,utils_api/* getCurrentTime */.X)();
  if ((0,Either.isLeft)(serverTime)) {
    return;
  }
  const clientTime = /* @__PURE__ */new Date();
  const minutesDiff = (0,differenceInMinutes/* differenceInMinutes */.X)(clientTime, serverTime.right);
  if (minutesDiff !== 0) {
    logger/* Logger */.Yd.captureWarning("Wrong client time", {
      clientTime,
      serverTime: serverTime.right,
      minutesDiff
    }, {
      method: "checkTime"
    });
  }
};
let isTimeChecked = false;
const checkTimeOnce = () => {
  if (isTimeChecked) {
    return;
  }
  isTimeChecked = true;
  void checkTime();
};
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/provider.js + 8 modules
var provider = __webpack_require__(37940);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
;// CONCATENATED MODULE: ../shared/src/services/translations/create-use-translations.ts








var TranslationState = /* @__PURE__ */(TranslationState2 => {
  TranslationState2["Ready"] = "ready";
  TranslationState2["Preparing"] = "preparing";
  TranslationState2["Error"] = "error";
  return TranslationState2;
})(TranslationState || {});
function normalizeLanguageKeyset(languageKeyset) {
  if (!languageKeyset) {
    return languageKeyset;
  }
  return Object.fromEntries(Object.entries(languageKeyset).filter(_ref => {
    let [, value] = _ref;
    return Boolean(value);
  }));
}
function unionTranslations(props) {
  const {
    defaultLocale,
    translations,
    currentLocale,
    useAllNormalize = false
  } = props;
  if (defaultLocale !== currentLocale) {
    return {
      ...translations?.[defaultLocale],
      ...normalizeLanguageKeyset(translations?.[currentLocale])
    };
  }
  return useAllNormalize ? normalizeLanguageKeyset(translations?.[currentLocale]) : translations?.[currentLocale];
}
function unionKeysets(props) {
  const {
    defaultLocale,
    keysets,
    currentProductId,
    currentLocale
  } = props;
  if (currentProductId) {
    return {
      ...unionTranslations({
        translations: keysets?.default,
        defaultLocale,
        currentLocale
      }),
      ...unionTranslations({
        translations: keysets?.bunker,
        defaultLocale,
        currentLocale
      }),
      ...unionTranslations({
        translations: keysets?.[currentProductId],
        defaultLocale,
        currentLocale,
        useAllNormalize: true
      })
    };
  }
  return {
    ...unionTranslations({
      translations: keysets?.default,
      defaultLocale,
      currentLocale
    }),
    ...unionTranslations({
      translations: keysets?.bunker,
      defaultLocale,
      currentLocale
    })
  };
}
const createUseTranslations = params => function useTranslation() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    currentLocale: "ru",
    defaultLocale: "ru"
  };
  const {
    currentLocale = "ru",
    currentProductId,
    defaultLocale = "ru"
  } = props;
  const [requestError, setRequestError] = (0,react.useState)();
  const [unionError, setUnionError] = (0,react.useState)();
  const [keysets, setKeysets] = (0,react.useState)();
  const [translations, setTranslations] = (0,react.useState)();
  (0,react.useEffect)(() => {
    params.loadTranslations().then(messages => {
      if ((0,Either.isRight)(messages)) {
        setKeysets(messages.right);
      } else {
        throw new Error();
      }
    }).catch(() => {
      setRequestError(new Error("Load translations"));
    });
  }, []);
  (0,react.useEffect)(() => {
    if (!keysets) {
      return;
    }
    try {
      setTranslations(unionKeysets({
        keysets,
        defaultLocale,
        currentLocale,
        currentProductId
      }));
    } catch (error2) {
      setUnionError(error2);
    }
  }, [currentLocale, defaultLocale, currentProductId, keysets]);
  const error = requestError || unionError;
  if (error) {
    return {
      state: "error" /* Error */,
      error
    };
  }
  if (!translations) {
    return {
      state: "preparing" /* Preparing */
    };
  }
  return {
    state: "ready" /* Ready */,
    translations,
    currentLocale,
    defaultLocale
  };
};
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
;// CONCATENATED MODULE: ../shared/src/api/translations/translations.mappers.ts






const getKeyset = keys => {
  const result = {
    ru: {},
    en: {}
  };
  for (const key of Object.keys(keys)) {
    const langKeys = (0,object_utils/* getObjectKeys */.Z)(keys[key]);
    for (const lang of langKeys) {
      if (result[lang] !== void 0) {
        result[lang][key] = keys[key][lang];
      }
    }
  }
  return result;
};
const mapRawTranslationsResponse = response => {
  const result = {};
  if (response.keysets) {
    Object.keys(response.keysets).forEach(keysetId => {
      if (response.keysets?.[keysetId]) {
        result[keysetId] = getKeyset(response.keysets[keysetId]);
      }
    });
  }
  return result;
};
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/api/translations/translations.model.ts



const RawKeys = es6.record(es6.string, es6.type({
  ru: es6.string,
  en: es6.string
}));
const RawGetTranslationsResponse = es6.type({
  keysets: es6.record(es6.string, RawKeys)
});
;// CONCATENATED MODULE: ../shared/src/api/translations/translations.urls.ts


const GET_TRANSLATIONS_FROM_S3 = "https://flowstatic.s3.yandex.net/translations/translations_v2.json";
;// CONCATENATED MODULE: ../shared/src/api/translations/translations.api.ts






const getTranslationsFromS3 = () => (0,http/* makeSimpleRequest */.eI)(GET_TRANSLATIONS_FROM_S3, {
  responseType: RawGetTranslationsResponse,
  resultMapper: mapRawTranslationsResponse
});
;// CONCATENATED MODULE: ../shared/src/api/translations/use-translations.ts




const useTranslations = createUseTranslations({
  loadTranslations: getTranslationsFromS3
});
;// CONCATENATED MODULE: ../shared/src/api/translations/index.ts



// EXTERNAL MODULE: ../shared/src/hooks/intl-format-context.ts
var intl_format_context = __webpack_require__(93131);
;// CONCATENATED MODULE: ./src/utils/translations/intl-format-provider.tsx






const IntlFormatProvider = _ref => {
  let {
    children
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const intlFormatContextValue = (0,react.useMemo)(() => ({
    formatMessage(key) {
      return intl.formatMessage({
        id: key
      });
    }
  }), [intl]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(intl_format_context/* IntlFormatContext */.x.Provider, {
    value: intlFormatContextValue,
    children
  });
};
;// CONCATENATED MODULE: ./src/utils/translations/translations-provider.tsx







const TranslationsProvider = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const translation = useTranslations(props);
  if (translation.state === TranslationState.Error) {
    throw translation.error;
  }
  if (translation.state !== TranslationState.Ready) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(provider/* default */.Z, {
    locale: translation.currentLocale,
    defaultLocale: translation.defaultLocale,
    messages: translation.translations,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(IntlFormatProvider, {
      children
    })
  });
};
// EXTERNAL MODULE: ./src/utils/yandexMetrica.ts
var yandexMetrica = __webpack_require__(11226);
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
// EXTERNAL MODULE: ../shared/src/services/notifier/notifierService.ts
var notifierService = __webpack_require__(24223);
;// CONCATENATED MODULE: ../ui-kit/src/notifier/item/notifier-item-animation.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notifier_item_animation_module = ({"root":"notifier-item-animation-module__root--kBQz0","fade-in":"notifier-item-animation-module__fade-in--Dtf7c","fadeIn":"notifier-item-animation-module__fade-in--Dtf7c"});
;// CONCATENATED MODULE: ../ui-kit/src/notifier/empty/notifier-empty.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notifier_empty_module = ({"root":"notifier-empty-module__root--Xr1xA","width-fill":"notifier-empty-module__width-fill--ADBbz","widthFill":"notifier-empty-module__width-fill--ADBbz","description":"notifier-empty-module__description--CKUEI"});
;// CONCATENATED MODULE: ../ui-kit/src/notifier/empty/notifier-empty.component.tsx







const NotifierEmpty = _ref => {
  let {
    textConstants: {
      description
    },
    widthFill = false
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: classnames_default()(notifier_empty_module.root, notifier_item_animation_module.root, {
      [notifier_empty_module.widthFill]: widthFill
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(notifier_empty_module.description, typography_module/* default */.Z.body2),
      children: description
    })
  });
};
// EXTERNAL MODULE: ../shared/src/models/notifier/notifier.ts
var notifier = __webpack_require__(15983);
;// CONCATENATED MODULE: ../ui-kit/src/notifier/item/notifier-item.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notifier_item_module = ({"root":"notifier-item-module__root--h7XkA","can-toggle":"notifier-item-module__can-toggle--aqwor","canToggle":"notifier-item-module__can-toggle--aqwor","header":"notifier-item-module__header--LHoPW","unread-indicator":"notifier-item-module__unread-indicator--OPSIv","unreadIndicator":"notifier-item-module__unread-indicator--OPSIv","width-fill":"notifier-item-module__width-fill--DUgrD","widthFill":"notifier-item-module__width-fill--DUgrD","time":"notifier-item-module__time--BNDGP","title":"notifier-item-module__title--JQszl","description":"notifier-item-module__description--oVeMW","content":"notifier-item-module__content--MYemN","link-container":"notifier-item-module__link-container--h2tCR","linkContainer":"notifier-item-module__link-container--h2tCR"});
;// CONCATENATED MODULE: ../ui-kit/src/notifier/item/notifier-item.component.tsx











const descriptionClassName = classnames_default()(notifier_item_module.description, typography_module/* default */.Z.body2);
const NotifierItem = props => {
  const {
    notifierItem,
    isOpen,
    canToggle,
    textConstants,
    widthFill = false,
    onToggle
  } = props;
  const {
    createdAt,
    isRead
  } = notifierItem;
  const titleClassName = isOpen ? classnames_default()(notifier_item_module.title, typography_module/* default */.Z.body2Accent) : descriptionClassName;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()(notifier_item_module.root, notifier_item_animation_module.root, {
      [notifier_item_module.widthFill]: widthFill,
      [notifier_item_module.canToggle]: canToggle
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("header", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: notifier_item_module.header,
        children: [!isRead && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: notifier_item_module.unreadIndicator
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
          className: classnames_default()(notifier_item_module.time, typography_module/* default */.Z.captionAccent),
          dateTime: createdAt.iso,
          children: createdAt.label
        }), canToggle && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          size: "tiny",
          appearance: "default",
          iconName: isOpen ? "chevron-up" : "chevron-down",
          "aria-label": isOpen ? textConstants.collapseBtnAriaLabel : textConstants.expandBtnAriaLabel,
          onClick: onToggle
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: titleClassName,
        children: notifierItem.payload.title
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierItemContent, {
      ...props
    })]
  });
};
const NotifierItemContent = _ref => {
  let {
    notifierItem,
    isOpen,
    onClose
  } = _ref;
  switch (notifierItem.type) {
    case notifier/* NotifierItemContentType */.T.Plain:
      {
        const {
          description
        } = notifierItem.payload;
        if (!description || !isOpen) {
          return null;
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          inline: true,
          className: descriptionClassName,
          children: description
        });
      }
    case notifier/* NotifierItemContentType */.T.Link:
      {
        const {
          isExternal,
          label,
          description,
          href
        } = notifierItem.payload;
        const {
          isRead
        } = notifierItem;
        const showDescription = description && isOpen;
        const buttonAppearance = isRead ? "secondary" : "primary";
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [showDescription && /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            inline: true,
            className: descriptionClassName,
            children: description
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: notifier_item_module.linkContainer,
            children: isExternal ? /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
              appearance: buttonAppearance,
              href,
              useNativeTag: true,
              target: "_blank",
              size: "small",
              children: label
            }) : /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
              appearance: buttonAppearance,
              href,
              onClick: onClose,
              size: "small",
              children: label
            })
          })]
        });
      }
    default:
      {
        return null;
      }
  }
};
;// CONCATENATED MODULE: ../ui-kit/src/notifier/notifier.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notifier_module = ({"modal-overlay":"notifier-module__modal-overlay--dHTe7","modalOverlay":"notifier-module__modal-overlay--dHTe7","item":"notifier-module__item--pu3PC","item-empty":"notifier-module__item-empty--Vn3Yx","itemEmpty":"notifier-module__item-empty--Vn3Yx","item-can-open":"notifier-module__item-can-open--Y6OYJ","itemCanOpen":"notifier-module__item-can-open--Y6OYJ","item-first":"notifier-module__item-first--Jowuk","itemFirst":"notifier-module__item-first--Jowuk","root":"notifier-module__root--LIpkV","root-internal":"notifier-module__root-internal--XEOP1","rootInternal":"notifier-module__root-internal--XEOP1","btn":"notifier-module__btn--hJIVz","btn-icon":"notifier-module__btn-icon--k6MGj","btnIcon":"notifier-module__btn-icon--k6MGj"});
;// CONCATENATED MODULE: ../ui-kit/src/notifier/notifier-internal.component.tsx











const NotifierInternal = _ref => {
  let {
    notifierItems,
    textConstants: {
      empty: emptyTexts,
      notifierItem: notifierItemTexts
    },
    onClose
  } = _ref;
  const [openedNotifierItemId, setOpenedNotifierItemId] = (0,react.useState)();
  const isNotifierItemsEmpty = notifierItems.length === 0;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: notifier_module.rootInternal,
    children: isNotifierItemsEmpty ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: notifier_module.itemEmpty,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierEmpty, {
        textConstants: emptyTexts,
        widthFill: true
      })
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: notifierItems.map(notifierItem => {
        const isOpen = openedNotifierItemId === notifierItem.id;
        const canToggle = notifierService/* NotifierService */.l.canToggleNotifierItem({
          item: notifierItem
        });
        const onClickHandler = notifierService/* NotifierService */.l.getNotifierItemClickHandler({
          isItemOpen: isOpen,
          item: notifierItem,
          setOpenedNotifierItemId
        });
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(notifier_module.item, {
            [notifier_module.itemCanOpen]: canToggle
          }),
          onClick: onClickHandler,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierItem, {
            widthFill: true,
            isOpen,
            canToggle,
            notifierItem,
            textConstants: notifierItemTexts,
            onToggle: onClickHandler,
            onClose
          })
        }, notifierItem.id);
      })
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ../ui-kit/src/spoiler-button/spoiler-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spoiler_button_module = ({"root":"spoiler-button-module__root--Uzi96","icon":"spoiler-button-module__icon--rCvV_","icon-rotated":"spoiler-button-module__icon-rotated--RfGV0","iconRotated":"spoiler-button-module__icon-rotated--RfGV0","wrapper":"spoiler-button-module__wrapper--WOev1","content-container":"spoiler-button-module__content-container--JpjiJ","contentContainer":"spoiler-button-module__content-container--JpjiJ","content-container-hidden":"spoiler-button-module__content-container-hidden--HkqSt","contentContainerHidden":"spoiler-button-module__content-container-hidden--HkqSt"});
;// CONCATENATED MODULE: ../ui-kit/src/spoiler-button/spoiler-button.component.tsx








const SpoilerButton = _ref => {
  let {
    children,
    isToggledInitial = false,
    isToggle = true,
    onClick,
    textConstants
  } = _ref;
  const [isToggled, setIsToggled] = (0,react.useState)(isToggledInitial);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: spoiler_button_module.wrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: spoiler_button_module.root,
      onClick: () => {
        if (isToggle) {
          setIsToggled(prev => !prev);
        }
        onClick?.();
      },
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2Accent,
        children: textConstants.text
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(spoiler_button_module.icon, {
          [spoiler_button_module.iconRotated]: isToggled
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "chevron-down",
          size: "medium"
        })
      })]
    }), children && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(spoiler_button_module.contentContainer, {
        [spoiler_button_module.contentContainerHidden]: !isToggled
      }),
      children
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/notifier/notifier-overlay.component.tsx













const NOTIFIER_ITEMS_COUNT_FOR_COLLAPSED_LIST = 3;
const NOTIFIER_ROOT_ID = "notifierRoot";
const NotifierOverlay = _ref => {
  let {
    notifierItems,
    textConstants: {
      moreBtnLabel,
      empty: emptyTexts,
      notifierItem: notifierItemTexts
    },
    onClose
  } = _ref;
  const [isCollapsedList, setIsCollapsedList] = (0,react.useState)(true);
  const [openedNotifierItemId, setOpenedNotifierItemId] = (0,react.useState)();
  const notifierNode = (0,react.useRef)(null);
  (0,use_block_main_scroll/* useBlockMainScroll */.K)();
  let visibleNotifierItems = notifierItems;
  if (isCollapsedList) {
    visibleNotifierItems = notifierItems.slice(0, NOTIFIER_ITEMS_COUNT_FOR_COLLAPSED_LIST);
  }
  const hiddenNotifierItemsCount = isCollapsedList ? notifierItems.length - visibleNotifierItems.length : 0;
  const checkUnderlayClick = (0,react.useCallback)(event => {
    if (event.target.id !== NOTIFIER_ROOT_ID && notifierNode && notifierNode.current?.contains(event.target)) {
      return;
    }
    onClose();
  }, [onClose, notifierNode]);
  const isVisibleNotifierItemsEmpty = visibleNotifierItems.length === 0;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("aside", {
    className: notifier_module.modalOverlay,
    onClick: checkUnderlayClick,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
      id: NOTIFIER_ROOT_ID,
      className: notifier_module.root,
      ref: notifierNode,
      children: isVisibleNotifierItemsEmpty ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(notifier_module.itemFirst, notifier_module.itemEmpty),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierEmpty, {
          textConstants: emptyTexts
        })
      }) : /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [visibleNotifierItems.map((notifierItem, index) => {
          const isOpen = openedNotifierItemId === notifierItem.id;
          const canToggle = notifierService/* NotifierService */.l.canToggleNotifierItem({
            item: notifierItem
          });
          const onClickHandler = notifierService/* NotifierService */.l.getNotifierItemClickHandler({
            isItemOpen: isOpen,
            item: notifierItem,
            setOpenedNotifierItemId
          });
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(notifier_module.item, {
              [notifier_module.itemCanOpen]: canToggle,
              [notifier_module.itemFirst]: index === 0
            }),
            onClick: onClickHandler,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierItem, {
              isOpen,
              canToggle,
              notifierItem,
              textConstants: notifierItemTexts,
              onToggle: onClickHandler,
              onClose
            })
          }, notifierItem.id);
        }), Boolean(hiddenNotifierItemsCount) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: notifier_module.btn,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(SpoilerButton, {
            isToggledInitial: false,
            isToggle: false,
            textConstants: {
              text: `${moreBtnLabel} ${hiddenNotifierItemsCount}`
            },
            onClick: () => {
              setIsCollapsedList(false);
            }
          })
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/notifier/notifier.component.tsx






const Notifier = _ref => {
  let {
    mode,
    notifierItems,
    markReadNotifierItems,
    ...otherProps
  } = _ref;
  (0,react.useEffect)(() => markReadNotifierItems,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  if (mode === "overlay") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierOverlay, {
      notifierItems,
      ...otherProps
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(NotifierInternal, {
    notifierItems,
    ...otherProps
  });
};
// EXTERNAL MODULE: ../shared/src/services/bell/useBell.ts + 5 modules
var useBell = __webpack_require__(41944);
;// CONCATENATED MODULE: ../shared/src/widgets/bell/bell.tsx







const Bell = _ref => {
  let {
    notifierTexts,
    isMobile
  } = _ref;
  const {
    notifierItems,
    notifierVisible,
    hideNotifier,
    markAsReadNotifierItems,
    run,
    stop
  } = (0,useBell/* useBell */.z)();
  (0,react.useEffect)(() => {
    void run();
    return () => stop();
  }, []);
  const content = /* @__PURE__ */(0,jsx_runtime.jsx)(Notifier, {
    mode: isMobile ? "internal" : "overlay",
    notifierItems,
    textConstants: notifierTexts,
    onClose: hideNotifier,
    markReadNotifierItems: markAsReadNotifierItems
  });
  if (!isMobile) {
    return notifierVisible ? content : null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    isVisible: notifierVisible,
    onClose: hideNotifier,
    children: content
  });
};
// EXTERNAL MODULE: ./src/hooks/bell/use-notifier-texts.ts
var use_notifier_texts = __webpack_require__(81923);
;// CONCATENATED MODULE: ./src/widgets/bell/bell.component.tsx






const bell_component_Bell = () => {
  const notifierTexts = (0,use_notifier_texts/* useIntlNotifierTexts */.s)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Bell, {
    notifierTexts,
    isMobile
  });
};
// EXTERNAL MODULE: ../shared/src/entities/user/index.ts + 3 modules
var entities_user = __webpack_require__(91485);
;// CONCATENATED MODULE: ./src/hooks/user/useUserInfo.tsx




const useUserInfo = () => {
  const userContext = (0,useUser/* useUser */.aF)();
  return (0,react.useMemo)(() => {
    if (userContext.state !== useUser/* State */.ZM.Loaded) {
      return {
        me: {
          loggedIn: false,
          user: void 0
        }
      };
    }
    return {
      x: {
        me: userContext.data.me
      },
      reload: userContext.functions.reloadMe
    };
  }, [userContext.data?.me, userContext.functions?.reloadMe, userContext.state]);
};
// EXTERNAL MODULE: ../../node_modules/query-string/index.js
var query_string = __webpack_require__(34126);
;// CONCATENATED MODULE: ../shared/src/utils.ts


const isNotNull = item => item !== null;
// EXTERNAL MODULE: ../shared/src/utils/form/validations/phone.ts
var phone = __webpack_require__(24796);
;// CONCATENATED MODULE: ../ui-kit/src/block-container/block-container.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const block_container_module = ({"root":"block-container-module__root--fVkdV"});
;// CONCATENATED MODULE: ../ui-kit/src/block-container/block-container.component.tsx





const BlockContainer = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(block_container_module.root, className),
    children
  });
};
// EXTERNAL MODULE: ../ui-kit/src/dropdown-with-items/dropdown-with-items.component.tsx + 1 modules
var dropdown_with_items_component = __webpack_require__(28402);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
;// CONCATENATED MODULE: ./src/api/student/products-price/model.ts



const SpeakingSessionRaw = es6.intersection([es6.type({
  amount: es6.number,
  time_to_live: es6.number
}), es6.partial({
  referral_bonus: es6.number
})]);
const ResourcesRaw = es6.partial({
  speaking_session: SpeakingSessionRaw,
  native_speaker_session: SpeakingSessionRaw
});
const RawProductPrice = es6.intersection([es6.type({
  price: es6.number,
  discount_price: es6.number,
  product_id: es6.string,
  tariff_slug: es6.union([es6.string, es6["null"]])
}), es6.partial({
  resources: ResourcesRaw,
  is_region_ru: es6.boolean,
  sbp_discount_price: es6.number,
  sbp_discount_percentage: es6.number
}), es6.union([es6.type({
  discount_amount: es6.number
}), es6.type({
  discount_percentage: es6.number
})])]);
const RawProductsPricesResponse = es6.array(RawProductPrice);
;// CONCATENATED MODULE: ./src/api/student/products-price/product-price.ts









const getProductsPrices = (0,un_either/* unEither */.K)(_ref => {
  let {
    productIds,
    region = "RU"
  } = _ref;
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/products-price?region=${region}`, {
    method: "POST",
    body: {
      product_ids: productIds
    },
    responseType: RawProductsPricesResponse,
    resultMapper(rawResponse) {
      return rawResponse.reduce((result, rawProductPrice) => {
        const currency = region === "KZ" ? "KZT" : "RUB";
        let resourcesObj = {};
        if (rawProductPrice.resources) {
          const speakingSessionObj = {
            amount: rawProductPrice.resources.speaking_session?.amount,
            timeToLive: rawProductPrice.resources.speaking_session?.time_to_live,
            referralBonus: rawProductPrice.resources.speaking_session?.referral_bonus
          };
          const nativeSpeakerSessionObj = {
            amount: rawProductPrice.resources.native_speaker_session?.amount,
            timeToLive: rawProductPrice.resources.native_speaker_session?.time_to_live,
            referralBonus: rawProductPrice.resources.speaking_session?.referral_bonus
          };
          resourcesObj = {
            speakingSession: speakingSessionObj,
            nativeSpeakerSession: nativeSpeakerSessionObj
          };
        }
        const priceObj = {
          price: rawProductPrice.price,
          discountPrice: rawProductPrice.discount_price,
          productId: rawProductPrice.product_id,
          tariffSlug: rawProductPrice.tariff_slug,
          sbpDiscountPrice: rawProductPrice.sbp_discount_price,
          isRuRegion: rawProductPrice.is_region_ru,
          sbpDiscountPercentage: rawProductPrice.sbp_discount_percentage,
          resources: resourcesObj,
          currency
        };
        if ("discount_amount" in rawProductPrice) {
          result[rawProductPrice.product_id] = {
            ...priceObj,
            discountPolicy: "amount",
            discount: rawProductPrice.discount_amount
          };
        } else {
          result[rawProductPrice.product_id] = {
            ...priceObj,
            discountPolicy: "percentage",
            discount: rawProductPrice.discount_percentage
          };
        }
        return result;
      }, {});
    }
  });
});
;// CONCATENATED MODULE: ./src/api/student/products-price/index.ts



// EXTERNAL MODULE: ./src/app/routes/baseRoutePaths.ts
var baseRoutePaths = __webpack_require__(94506);
// EXTERNAL MODULE: ./src/components/app-page-footer/app-page-footer.component.tsx + 7 modules
var app_page_footer_component = __webpack_require__(79771);
// EXTERNAL MODULE: ./src/components/app-page-wrapper/add-page-helper-button.tsx
var add_page_helper_button = __webpack_require__(67398);
// EXTERNAL MODULE: ./src/components/main-menu/main-menu.tsx + 6 modules
var main_menu = __webpack_require__(74140);
// EXTERNAL MODULE: ./src/components/page-header/index.ts + 29 modules
var page_header = __webpack_require__(17787);
;// CONCATENATED MODULE: ../shared/src/locales.ts


const priceLocale = "ru";
;// CONCATENATED MODULE: ../shared/src/models/price/price.ts


const currencyValues = {
  RUB: "\u20BD",
  KZT: "\u20B8",
  USD: "$",
  EUR: "\u20AC"
};
;// CONCATENATED MODULE: ../shared/src/utils/price/format-price.ts




function formatPrice(_ref) {
  let {
    price,
    currency,
    postfix = ""
  } = _ref;
  const priceString = price.toLocaleString(priceLocale);
  const currencyValue = currencyValues[currency];
  return `${priceString}\u2009${currencyValue}` + (postfix ? ` ${postfix}` : "");
}
;// CONCATENATED MODULE: ../shared/src/utils/price/format-discount.ts



function formatDiscount(_ref) {
  let {
    value,
    currency,
    policy
  } = _ref;
  if (policy === "amount") {
    return formatPrice({
      price: value,
      currency
    });
  }
  return `${value}%`;
}
;// CONCATENATED MODULE: ./src/components/price/price.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const price_module = ({"values":"price-module__values--eaDbO","discount":"price-module__discount--k05SL","price":"price-module__price--C2Oxy","discount-price":"price-module__discount-price--W2wJN","discountPrice":"price-module__discount-price--W2wJN"});
;// CONCATENATED MODULE: ./src/components/price/price.tsx









const Price = _ref => {
  let {
    productPrice,
    postfix,
    size = "medium"
  } = _ref;
  if (!productPrice) {
    return null;
  }
  const {
    discountPolicy,
    price,
    discountPrice,
    discount,
    currency
  } = productPrice;
  const isMediumSize = size === "medium";
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: price_module.values,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      "data-testid": "payment-landing-price",
      className: classnames_default()(isMediumSize ? typography_module/* default */.Z.headline4Accent : typography_module/* default */.Z.headline3, price_module.discountPrice),
      children: formatPrice({
        price: discountPrice,
        currency,
        postfix
      })
    }), discount > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2, price_module.price),
        children: formatPrice({
          price,
          currency
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.captionAccent, price_module.discount),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "paymentLandingPage.priceBlock.discount",
          values: {
            discount: formatDiscount({
              value: discount,
              policy: discountPolicy,
              currency
            })
          }
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/components/promo-code-popup/promo-code-popup.component.tsx + 5 modules
var promo_code_popup_component = __webpack_require__(37042);
// EXTERNAL MODULE: ./src/components/wordbank/wordbank.component.tsx + 13 modules
var wordbank_component = __webpack_require__(99833);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ./src/components/app-page-wrapper/app-page-wrapper-types.ts
var app_page_wrapper_types = __webpack_require__(15079);
// EXTERNAL MODULE: ./src/components/app-page-wrapper/app-page-wrapper.component.tsx + 2 modules
var app_page_wrapper_component = __webpack_require__(71583);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
;// CONCATENATED MODULE: ./src/pages/purchase/utils/is-split-payment-method.ts





const isSplitPaymentMethod = () => {
  const queryParams = new URLSearchParams(location.search);
  return queryParams.get("payment-method") === "split";
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/use-send-purchase-state-to-yandex-metrika.ts




const useSendPurchaseStateToYandexMetrika = state => {
  (0,react.useEffect)(() => {
    if (state === "paid") {
      (0,yandexMetrica/* ymGoal */.qf)("Purchase_Status_Paid");
    } else if (state === "fail") {
      (0,yandexMetrica/* ymGoal */.qf)("Purchase_Status_Fail");
    }
  }, [state]);
};
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(42180);
// EXTERNAL MODULE: ../../node_modules/fp-ts/es6/Either.js + 1 modules
var es6_Either = __webpack_require__(18984);
// EXTERNAL MODULE: ../ui-kit/src/input/input.component.tsx + 1 modules
var input_component = __webpack_require__(16455);
;// CONCATENATED MODULE: ./src/pages/purchase/types.ts


var PaymentSource = /* @__PURE__ */(PaymentSource2 => {
  PaymentSource2["Trust"] = "trust";
  PaymentSource2["YaPaySplit"] = "ya_pay_split";
  PaymentSource2["Psp"] = "psp";
  return PaymentSource2;
})(PaymentSource || {});
var PaymentPlan = /* @__PURE__ */(PaymentPlan2 => {
  PaymentPlan2["Monthly"] = "monthly";
  PaymentPlan2["ResourceBased"] = "resource_based";
  return PaymentPlan2;
})(PaymentPlan || {});
// EXTERNAL MODULE: ../shared/src/event-emitter.ts
var event_emitter = __webpack_require__(1341);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/event-emitter.ts



const eventEmitter = (0,event_emitter/* createEventEmitter */.I)();
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/core/MethodType.js
var MethodType = __webpack_require__(19270);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/core/PaySystem.js
var PaySystem = __webpack_require__(36862);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/core/Bank.autogenerated.js
var Bank_autogenerated = __webpack_require__(67584);
// EXTERNAL MODULE: ../../node_modules/ramda/es/compose.js + 1 modules
var compose = __webpack_require__(97523);
// EXTERNAL MODULE: ../../node_modules/ramda/es/cond.js
var cond = __webpack_require__(6697);
// EXTERNAL MODULE: ../../node_modules/ramda/es/always.js
var always = __webpack_require__(75556);
// EXTERNAL MODULE: ../../node_modules/ramda/es/T.js
var T = __webpack_require__(94150);
// EXTERNAL MODULE: ../../node_modules/ramda/es/toLower.js + 2 modules
var toLower = __webpack_require__(3079);
// EXTERNAL MODULE: ../../node_modules/ramda/es/toString.js + 5 modules
var es_toString = __webpack_require__(39381);
// EXTERNAL MODULE: ../../node_modules/ramda/es/allPass.js
var allPass = __webpack_require__(83736);
// EXTERNAL MODULE: ../../node_modules/ramda/es/partition.js + 2 modules
var partition = __webpack_require__(80289);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/api/utils.ts




const removeSpaces = str => str.replace(/[^a-zA-Z]/g, "");
const singleSpaces = str => str.replace(/[^a-zA-Z]+/g, " ");
const contain = function (val) {
  let word = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (word) {
    const regex = new RegExp(`\\b${val}\\b`);
    return str => regex.test(str);
  }
  return str => str.includes(val);
};
const getPaySystem = (0,compose/* default */.Z)((0,cond/* default */.Z)([[contain("americanexpress", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.AmericanExpress)], [contain("discover", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.Discover)], [contain("jcb", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.JCB)], [contain("maestro", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.Maestro)], [contain("mastercard", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.Mastercard)], [contain("mastercardelite", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.MastercardElite)], [contain("mir", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.MIR)], [contain("unionpay", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.UnionPay)], [contain("uzcard", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.Uzcard)], [contain("visa", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.Visa)], [contain("visaelectron", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.VisaElectron)], [contain("humocard", true), (0,always/* default */.Z)(PaySystem/* PaySystem */.N.Humocard)], [T/* default */.Z, (0,always/* default */.Z)("Unknown")]]), (0,compose/* default */.Z)(removeSpaces, toLower/* default */.Z, es_toString/* default */.Z));
const getCardIssuer = (0,compose/* default */.Z)((0,cond/* default */.Z)([[contain("alfa"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Alfa)], [contain("bank rossiya"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Abr)], [contain("gazprom"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Gazprom)], [(0,allPass/* default */.Z)([contain("moscow"), contain("credit")]), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Mkb)], [contain("otrkitie"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Open)], [contain("promsvyaz"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Ps)], [contain("raiffeisen"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Raiffeisen)], [contain("rosbank"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Ros)], [contain("rosselkhoz"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Rshb)], [(0,allPass/* default */.Z)([contain("rus"), contain("standard")]), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Rsb)], [contain("sber"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Sber)], [contain("sovcom"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Sovcom)], [contain("tinkoff"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Tinkoff)], [contain("unicredit"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.UniCredit)], [contain("uralsib"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Uralsib)], [contain("vtb"), (0,always/* default */.Z)(Bank_autogenerated/* Bank */.B.Vtb)], [T/* default */.Z, (0,always/* default */.Z)("Unknown")]]), (0,compose/* default */.Z)(singleSpaces, toLower/* default */.Z, es_toString/* default */.Z));
const divideCardsByRegion = cards => {
  const [ruCards, otherCards] = (0,partition/* default */.Z)(card => card.region === "RU")(cards);
  return {
    ruCards,
    otherCards
  };
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/api/mappers.ts








const mapCard = card => ({
  methodId: card.method_id,
  methodType: MethodType/* MethodType */.T.BankCard,
  number: card.number,
  issuer: getCardIssuer(card.issuer),
  paySystem: getPaySystem(card.pay_system),
  region: card.region
});
const fetchBankCardsResultMapper = response => ({
  lastCard: response.data[0] && mapCard(response.data[0]),
  cards: divideCardsByRegion(response.data.map(mapCard))
});
const promoCodeErrorMessageIdMap = {
  [student_model/* ApplyPromoCodeError */.Hi.PromoCodeAlreadyUsed]: "purchasePage.promoCodePopup.promocodeAlreadyUsed",
  [student_model/* ApplyPromoCodeError */.Hi.UnknownPromoCode]: "purchasePage.promoCodePopup.promocodeIsIncorrect",
  [student_model/* ApplyPromoCodeError */.Hi.PromoCodeNotSuitableForRestrictions]: "purchasePage.promoCodePopup.promocodeUnsuitable",
  [student_model/* ApplyPromoCodeError */.Hi.RegionDoesntMatch]: "purchasePage.promoCodePopup.regionDoesntMatch",
  [student_model/* ApplyPromoCodeError */.Hi.PromocodeExpired]: "purchasePage.promoCodePopup.promocodeExpired",
  [api_model/* unexpectedError */.g]: "purchasePage.promoCodePopup.promocodeSendError"
};
const purchaseDraftResultMapper = response => {
  if (response.payment_strategy === "partial_payment") {
    return {
      purchaseId: response.purchase_id,
      paymentStrategy: response.payment_strategy,
      partialPaymentsCount: Number(response.partial_payments_count),
      productTitle: response.product_title
    };
  }
  return {
    purchaseId: response.purchase_id,
    productTitle: response.product_title,
    paymentStrategy: response.payment_strategy,
    partialPaymentsCount: null
  };
};
// EXTERNAL MODULE: ./src/api/common/product-status-raw.ts
var product_status_raw = __webpack_require__(72401);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/api/model.ts




const RawBankCard = es6.type({
  method_id: es6.string,
  number: es6.string,
  issuer: es6.string,
  pay_system: es6.string,
  region: es6.string
});
const RawBankCardResponse = es6.type({
  data: es6.array(RawBankCard)
});
const PurchaseFields = {
  purchase_id: es6.string,
  purchase_status: product_status_raw/* ProductStatusRaw */.H,
  partial_payments_count: es6.union([es6.number, es6["null"]]),
  payment_strategy: es6.union([es6.literal("full_payment"), es6.literal("partial_payment"), es6.literal("subscription")])
};
const PurchaseDraftResponse = es6.type({
  ...PurchaseFields,
  product_title: es6.string
});
const PurchaseProductResponse = es6.type({
  ...PurchaseFields,
  amount: es6.string,
  purchase_url: es6.string
});
const PurchaseStatusResponse = es6.type({
  status: product_status_raw/* ProductStatusRaw */.H,
  response_code: es6.union([es6.string, es6.undefined])
});
const RawStartPurchaseResponse = es6.type({
  product_id: es6.string,
  purchase_id: es6.string,
  status: product_status_raw/* ProductStatusRaw */.H,
  user_id: es6.string
});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/api/api.ts













const fetchLinkedCards = (0,un_either/* unEither */.K)(() => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/cards-psp`, {
  responseType: RawBankCardResponse,
  resultMapper: fetchBankCardsResultMapper
}));
async function getPromocodeStatus(_ref) {
  let {
    promocode,
    region
  } = _ref;
  if (!promocode) {
    return {
      status: input_component/* InputStatus */.Xz.Default
    };
  }
  const promoCodeResult = await (0,student_api/* applyPromoCode */.gs)(promocode, region);
  if ((0,es6_Either/* isLeft */.nM)(promoCodeResult)) {
    const id = promoCodeErrorMessageIdMap[promoCodeResult.left] ?? "";
    return {
      status: input_component/* InputStatus */.Xz.Warning,
      warningMessageId: id
    };
  }
  eventEmitter.emit("applyPromocode");
  return {
    status: input_component/* InputStatus */.Xz.Success
  };
}
const purchaseDraft = (0,un_either/* unEither */.K)(_ref2 => {
  let {
    parentProductId,
    productId,
    giftId,
    isSplitPayment
  } = _ref2;
  const body = {
    product_id: productId,
    parent_product_id: parentProductId
  };
  if (isSplitPayment) {
    body.payment_source = PaymentSource.YaPaySplit;
  } else {
    body.payment_source = PaymentSource.Psp;
  }
  if (giftId !== null) {
    body.gift_id = giftId;
  }
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/purchase_draft_v2?region=${(0,domain/* isKzDomain */.k)() ? "KZ" : "RU"}`, {
    method: "POST",
    body,
    responseType: PurchaseDraftResponse,
    resultMapper: purchaseDraftResultMapper
  });
});
const purchaseProduct = (0,un_either/* unEither */.K)(_ref3 => {
  let {
    purchaseId,
    region,
    iin,
    cardHolder,
    paymentMethodId
  } = _ref3;
  const body = {
    purchase_id: purchaseId,
    payment_method_id: paymentMethodId,
    payer_attributes: {
      iin,
      card_holder: cardHolder
    }
  };
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/purchase-product-psp?region=${region}`, {
    method: "POST",
    responseType: PurchaseProductResponse,
    body,
    resultMapper(rawResponse) {
      return {
        purchaseUrl: rawResponse.purchase_url
      };
    }
  });
});
const getPurchaseStatus = (0,un_either/* unEither */.K)(_ref4 => {
  let {
    purchaseId,
    transactionId
  } = _ref4;
  const transactionParam = transactionId ? `?transaction_id=${transactionId}` : "";
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/purchase-status/${purchaseId}${transactionParam}`, {
    method: "GET",
    responseType: PurchaseStatusResponse,
    resultMapper(rawResponse) {
      return {
        status: rawResponse.status,
        responseCode: rawResponse.response_code
      };
    }
  });
});
const startPurchase = (0,un_either/* unEither */.K)(purchaseId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/purchase_start_v2`, {
  method: "PUT",
  body: {
    purchase_id: purchaseId
  },
  responseType: RawStartPurchaseResponse
}));
// EXTERNAL MODULE: ../shared/src/services/notification/toast.ts
var toast = __webpack_require__(99990);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/api/index.ts



// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/payment-modal/store.ts



const openPaymentModal = (0,effector/* createEvent */.yM)();
const closePaymentModal = (0,effector/* createEvent */.yM)();
const $isPaymentModalOpen = (0,effector/* createStore */.MT)(false).on(openPaymentModal, () => true).on(closePaymentModal, () => false);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/payment-modal/hooks.ts











const QUERY_KEY = purchaseId => ["purchaseUrl", purchaseId];
const usePurchaseUrl = _ref => {
  let {
    purchaseId
  } = _ref;
  return (0,useQuery/* useQuery */.a)({
    enabled: false,
    queryKey: QUERY_KEY(purchaseId),
    queryFn: () => Promise.resolve({
      purchaseUrl: ""
    }),
    select: data => data.purchaseUrl,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    throwOnError: false
  });
};
const useTransactionId = _ref2 => {
  let {
    purchaseId
  } = _ref2;
  const {
    data
  } = usePurchaseUrl({
    purchaseId
  });
  if (!data) {
    return null;
  }
  const url = new URL(data);
  const params = new URLSearchParams(url.search);
  return params.get("purchase_token");
};
const useGetPurchaseUrl = () => {
  const intl = (0,useIntl/* default */.Z)();
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  return {
    getPurchaseUrl: (0,react.useCallback)(async _ref3 => {
      let {
        paymentMethodId,
        region,
        cardHolder,
        purchaseId,
        iin
      } = _ref3;
      openPaymentModal();
      try {
        await queryClient.fetchQuery({
          queryKey: QUERY_KEY(purchaseId),
          queryFn: () => purchaseProduct({
            region,
            cardHolder,
            paymentMethodId,
            purchaseId,
            iin
          })
        });
      } catch (error) {
        closePaymentModal();
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "purchasePage.paymentModal.error"
        }));
      }
    }, [intl, queryClient])
  };
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/utils/purchase.ts


const isStatusPositive = status => {
  const positiveStatuses = ["paid", "paid_manual", "paid_oplaty", "paid_contract", "paid_migration", "paid_free"];
  return positiveStatuses.includes(status);
};
const isStatusInProgress = status => status === "payment_in_progress";
const isStatusNegative = status => {
  const negativeStatuses = ["payment_declined"];
  return negativeStatuses.includes(status);
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/use-purchase-state.ts








function usePurchaseStatusQuery(_ref) {
  let {
    purchaseId,
    isSplitPayment
  } = _ref;
  const transactionId = useTransactionId({
    purchaseId
  });
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  const queryKey = (0,react.useMemo)(() => ["purchaseStatus", purchaseId], [purchaseId]);
  const result = (0,useQuery/* useQuery */.a)({
    queryKey,
    queryFn: () => {
      if (!purchaseId) {
        return;
      }
      return getPurchaseStatus({
        purchaseId,
        transactionId: isSplitPayment ? transactionId : null
      });
    },
    enabled: Boolean(purchaseId),
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchInterval: query => {
      const data = query.state.data;
      if (!data) {
        return false;
      }
      if (isStatusInProgress(data.status) || data.status === "new" && isSplitPayment) {
        return 10 * 1e3;
      }
      return false;
    }
  });
  const updateStatus = (0,react.useCallback)(() => {
    queryClient.setQueryData(queryKey, () => ({
      status: "payment_in_progress"
    }));
  }, [queryClient, queryKey]);
  return {
    ...result,
    updateStatus
  };
}
function usePurchaseState(_ref2) {
  let {
    purchaseId,
    isSplitPayment
  } = _ref2;
  const {
    data,
    isFetching
  } = usePurchaseStatusQuery({
    purchaseId,
    isSplitPayment
  });
  const [isAttributesUpdated, setIsAttributesUpdated] = (0,react.useState)(false);
  const userContext = (0,useUser/* useUser */.aF)();
  const isNeedAttributesUpdate = data && isStatusPositive(data.status) && !isAttributesUpdated;
  (0,react.useEffect)(() => {
    if (!isNeedAttributesUpdate) {
      return;
    }
    void userContext.functions?.setUserAttributesAndCurrentProduct().then(() => {
      setIsAttributesUpdated(true);
    });
  }, [isNeedAttributesUpdate, userContext.functions]);
  return (0,react.useMemo)(() => {
    if (!data?.status) {
      return {
        status: "loading"
      };
    }
    if (isStatusInProgress(data.status) || isNeedAttributesUpdate) {
      return {
        status: "in_progress"
      };
    }
    if (isStatusPositive(data.status)) {
      return {
        status: "paid"
      };
    }
    if (isStatusNegative(data.status) && !isFetching) {
      return {
        status: "fail",
        responseCode: data.responseCode
      };
    }
    return {
      status: "payment"
    };
  }, [data?.status, data?.responseCode, isFetching, isNeedAttributesUpdate]);
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/use-price.ts






function usePrice(_ref) {
  let {
    productId,
    region
  } = _ref;
  const queryData = (0,useQuery/* useQuery */.a)({
    queryKey: ["price", {
      productId,
      region
    }],
    queryFn: () => getProductsPrices({
      productIds: [productId],
      region
    }),
    enabled: Boolean(productId),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    select: data => data[productId]
  });
  (0,react.useEffect)(() => {
    const cb = () => queryData.refetch();
    eventEmitter.on("applyPromocode", cb);
    return () => {
      eventEmitter.off("applyPromocode", cb);
    };
  }, [queryData]);
  return queryData;
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/use-bound-cards.ts




function useBoundCards() {
  const {
    data,
    isLoading,
    isError
  } = (0,useQuery/* useQuery */.a)({
    queryKey: ["boundCards"],
    queryFn: fetchLinkedCards,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 2,
    throwOnError: false
  });
  return {
    cards: data?.cards,
    isLoading,
    isError
  };
}
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/use-payment-form.ts









const isKz = (0,domain/* isKzDomain */.k)();
const NEW_CARD = "new_card";
const initialState = {
  isRuCards: !isKz,
  isResident: false,
  isResidencyVisible: isKz,
  selectedCard: NEW_CARD
};
const $paymentForm = (0,effector/* createStore */.MT)(initialState);
const paymentFormApi = (0,effector/* createApi */.LC)($paymentForm, {
  reset: () => initialState,
  toggleIsRuCards: (state, region) => {
    const isRuCards = region ? region === "RU" : !state.isRuCards;
    return {
      ...state,
      isRuCards,
      isResidencyVisible: !isRuCards,
      isResident: false
    };
  },
  toggleIsResident: state => ({
    ...state,
    isResident: !state.isResident
  }),
  setSelectedCard: (state, payload) => {
    if (!payload) {
      return {
        ...state,
        selectedCard: NEW_CARD
      };
    }
    return {
      ...state,
      selectedCard: payload.methodId
    };
  }
});
const usePaymentForm = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    selectedCard,
    isRuCards,
    ...state
  } = (0,effector_react/* useStore */.oR)($paymentForm);
  const {
    cards,
    isLoading: isCardsLoading,
    isError: isErrorLoadingCards
  } = useBoundCards();
  (0,react.useEffect)(() => {
    if (cards) {
      const cardToSelect = isRuCards ? cards?.ruCards[0] : cards?.otherCards[0];
      paymentFormApi.setSelectedCard(cardToSelect);
    }
  }, [cards, isRuCards]);
  (0,react.useEffect)(() => {
    if (isErrorLoadingCards) {
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        id: "purchasePage.notify.errorLoadingCards"
      }));
    }
  }, [intl, isErrorLoadingCards]);
  return {
    ...state,
    selectedCard,
    isCardsLoading,
    isRuCards,
    isPayButtonDisabled: !selectedCard,
    cards: (isRuCards ? cards?.ruCards : cards?.otherCards) ?? []
  };
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/use-purchase-draft.ts





function usePurchaseDraft(_ref) {
  let {
    parentProductId,
    productId,
    giftId,
    isSplitPayment
  } = _ref;
  const queryKey = (0,react.useMemo)(() => ["purchaseDraft", parentProductId, productId, giftId], [giftId, parentProductId, productId]);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  const {
    data,
    refetch
  } = (0,useQuery/* useQuery */.a)({
    queryKey,
    queryFn: () => purchaseDraft({
      parentProductId,
      productId,
      giftId,
      isSplitPayment
    }),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
  const tryAgain = (0,react.useCallback)(async () => {
    queryClient.removeQueries({
      queryKey
    });
    await refetch();
  }, [queryClient, queryKey, refetch]);
  return {
    purchaseDraft: data,
    tryAgain
  };
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/hooks/index.ts








;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/screens.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const screens_module = ({"screen":"screens-module__screen--nIXyY","title":"screens-module__title--TPgnS","img":"screens-module__img--x9ssT","text-block":"screens-module__text-block--jlD7a","textBlock":"screens-module__text-block--jlD7a","error-title":"screens-module__error-title--riP8a","errorTitle":"screens-module__error-title--riP8a","buttons":"screens-module__buttons--XAZR8"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/fail-screen.tsx











function FailScreen(_ref) {
  let {
    tryAgain,
    responseCode
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: screens_module.screen,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: screens_module.img,
      alt: "",
      src: "https://flowstatic.s3.yandex.net/ui-files/unknown_error.svg"
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: screens_module.textBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
        className: classnames_default()(typography_module/* default */.Z.headline3, screens_module.errorTitle),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "purchasePage.failScreen.title"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.headline4,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: `purchasePage.failScreen.${responseCode}`,
          defaultMessage: intl.formatMessage({
            id: "purchasePage.failScreen.text"
          })
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: screens_module.buttons,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "secondary",
        onClick: () => {
          history.push(get_url_search_params.getUrlSearchParams.openHelp.getOpenUrl(history));
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "purchasePage.failScreen.support"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "primary",
        onClick: tryAgain,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "purchasePage.failScreen.tryAgain"
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/in-progress-screen.tsx








function InProgressScreen() {
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    "data-testid": "payment-in-progress-screen",
    className: screens_module.screen,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()(typography_module/* default */.Z.headline3, screens_module.title),
      children: intl.formatMessage({
        id: "purchasePage.paymentInProgress"
      }, {
        br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})]
  });
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/paid-screen/paid-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const paid_screen_module = ({"screen":"paid-screen-module__screen--RS5Yb","title":"paid-screen-module__title--ocFX4"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/paid-screen/paid-screen.tsx











function PaidScreen(_ref) {
  let {
    isGift
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const link = (0,react.useMemo)(() => ({
    textKey: isGift ? "backButton" : "purchasePage.paidScreen.link",
    href: isGift ? baseRoutePaths/* baseRoutePaths */.lQ.BUY_GIFT_CERTIFICATE : studentRoutePaths/* studentRoutePaths */.dR.INDEX
  }), [isGift]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    "data-testid": "payment-success-screen",
    className: paid_screen_module.screen,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()(typography_module/* default */.Z.headline3, paid_screen_module.title),
      children: intl.formatMessage({
        id: "purchasePage.paidScreen.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
      href: link.href,
      appearance: "primary",
      children: intl.formatMessage({
        id: link.textKey
      })
    })]
  });
}
;// CONCATENATED MODULE: ../ui-kit/src/go-back-button/go-back-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const go_back_button_module = ({"go-back-button-wrapper":"go-back-button-module__go-back-button-wrapper--CQf05","goBackButtonWrapper":"go-back-button-module__go-back-button-wrapper--CQf05","button":"go-back-button-module__button--e5VCp","with-margin-bottom":"go-back-button-module__with-margin-bottom--B9XuJ","withMarginBottom":"go-back-button-module__with-margin-bottom--B9XuJ","go-back-button-text":"go-back-button-module__go-back-button-text--IvrWW","goBackButtonText":"go-back-button-module__go-back-button-text--IvrWW"});
;// CONCATENATED MODULE: ../ui-kit/src/go-back-button/go-back-button.tsx







const GoBackButton = _ref => {
  let {
    onClick,
    text,
    withMarginBottom = true
  } = _ref;
  const handleKeyDown = event => {
    if (event.key === "Enter") {
      onClick();
    }
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(go_back_button_module.goBackButtonWrapper, typography_module/* default */.Z.captionAccent, {
      [go_back_button_module.withMarginBottom]: withMarginBottom
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      onClick,
      className: classnames_default()(go_back_button_module.button),
      role: "button",
      tabIndex: 0,
      onKeyDown: handleKeyDown,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        iconName: "simple-arrow-left-bold",
        appearance: "floating",
        size: "small"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: go_back_button_module.goBackButtonText,
        children: text
      })]
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/go-back-button/index.ts



// EXTERNAL MODULE: ../../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(80594);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(9699);
// EXTERNAL MODULE: ../shared/src/utils/form/transforms.ts
var transforms = __webpack_require__(50506);
// EXTERNAL MODULE: ../ui-kit/src/form/form.tsx + 2 modules
var form_form = __webpack_require__(73385);
// EXTERNAL MODULE: ../ui-kit/src/form/fields/text.tsx + 2 modules
var fields_text = __webpack_require__(80498);
// EXTERNAL MODULE: ../ui-kit/src/form/use-form-field.ts
var use_form_field = __webpack_require__(91824);
;// CONCATENATED MODULE: ../ui-kit/src/switch/text-switcher.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_switcher_module = ({"input-hidden":"text-switcher-module__input-hidden--kA7Dg","inputHidden":"text-switcher-module__input-hidden--kA7Dg","list":"text-switcher-module__list--xmo9L","reversed":"text-switcher-module__reversed--xqaOy","vertical":"text-switcher-module__vertical--vSfdw","checked":"text-switcher-module__checked--dTNKl","list-item":"text-switcher-module__list-item--qAX3z","listItem":"text-switcher-module__list-item--qAX3z","equals":"text-switcher-module__equals--eYOZb","selected":"text-switcher-module__selected--iCChf"});
;// CONCATENATED MODULE: ../ui-kit/src/switch/text-switcher.component.tsx









const TextSwitcher = _ref => {
  let {
    checked,
    checkedText,
    unCheckedText,
    typography = typography_module/* default */.Z.body2Accent,
    reverse = false,
    equalWidths = false,
    vertical = false,
    onChange
  } = _ref;
  const inputId = (0,react.useId)();
  const [checkedWidth, setCheckedWidth] = (0,react.useState)(0);
  const [uncheckedWidth, setUncheckedWidth] = (0,react.useState)(0);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      id: inputId,
      type: "checkbox",
      className: text_switcher_module.inputHidden,
      checked,
      onChange
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("label", {
      htmlFor: inputId,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
        className: classnames_default()(text_switcher_module.list, typography, {
          [text_switcher_module.checked]: checked,
          [text_switcher_module.reversed]: reverse,
          [text_switcher_module.vertical]: vertical
        }),
        style: {
          "--li-background-width": `${checked ? checkedWidth : uncheckedWidth}px`
        },
        children: [unCheckedText, checkedText].map((text, index) => {
          const isCheckedElement = Boolean(index);
          return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
            ref: element => {
              if (element === null) {
                return;
              }
              const width = Math.round(element.getBoundingClientRect().width);
              isCheckedElement ? setCheckedWidth(width) : setUncheckedWidth(width);
            },
            className: classnames_default()(text_switcher_module.listItem, {
              [text_switcher_module.selected]: !checked && !isCheckedElement || checked && isCheckedElement,
              [text_switcher_module.equals]: equalWidths
            }),
            children: text
          }, index);
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/box/box.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const box_module = ({"root":"box-module__root--mtRrf"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/box/box.tsx






const Box = _ref => {
  let {
    children,
    className,
    style
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    style,
    className: classnames_default()(box_module.root, typography_module/* default */.Z.body2, className),
    children
  });
};
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip_tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/hint/hint.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const hint_module = ({"root":"hint-module__root--ck2pY","info-icon":"hint-module__info-icon--Xy2Zp","infoIcon":"hint-module__info-icon--Xy2Zp","text":"hint-module__text--Qmr5P"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/hint/hint.tsx








const Hint = _ref => {
  let {
    text,
    className
  } = _ref;
  const [hintVisible, setHintVisible] = (0,react.useState)(false);
  const [spanLeft, setSpanLeft] = (0,react.useState)(0);
  const [tooltipLeft, setTooltipLeft] = (0,react.useState)(0);
  const getTooltipContainer = triggerNode => triggerNode.parentNode;
  const left = (0,react.useMemo)(() => spanLeft - tooltipLeft, [spanLeft, tooltipLeft]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    className: hint_module.root,
    style: {
      "--left": `${left}px`
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_tooltip/* Tooltip */.u, {
      onPopupAlign: element => {
        setTooltipLeft(element?.getBoundingClientRect()?.left ?? 0);
      },
      getTooltipContainer,
      tooltipOverlayClassName: hint_module.text,
      trigger: "hover",
      placement: "top",
      autoWidth: true,
      visible: hintVisible,
      onVisibleChange: () => setHintVisible(prev => !prev),
      overlay: text,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        ref: element => {
          setSpanLeft(element?.getBoundingClientRect()?.left ?? 0);
        },
        className: classnames_default()(hint_module.infoIcon, className),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "info",
          size: "small"
        })
      })
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/Theme/Theme.js
var Theme = __webpack_require__(94797);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/core/Theme.js
var core_Theme = __webpack_require__(99690);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/core/View.js
var View = __webpack_require__(19300);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/core/Size.js
var Size = __webpack_require__(56493);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/PaymentMethod/PaymentMethod@desktop.js + 1 modules
var PaymentMethod_desktop = __webpack_require__(95583);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/BankCard/cnBankCard.js
var cnBankCard = __webpack_require__(58651);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/PaySystemIcon/PaySystemIcon.js + 2 modules
var PaySystemIcon = __webpack_require__(58990);
// EXTERNAL MODULE: ../../node_modules/@yandex-int/payment-components/build/components/PaymentMethod/PaymentMethod@touch-phone.js + 1 modules
var PaymentMethod_touch_phone = __webpack_require__(54913);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/bank-card/utils.ts



const shouldShowUnbrandedIcon = (paySystem, isRuRegion) => paySystem === PaySystem/* PaySystem */.N.MIR && !isRuRegion;
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/bank-card/bank-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const bank_card_module = ({"number":"bank-card-module__number--q_X0l","icon":"bank-card-module__icon--Lw8QK","icon-unbranded-desktop":"bank-card-module__icon-unbranded-desktop--KQShv","iconUnbrandedDesktop":"bank-card-module__icon-unbranded-desktop--KQShv","icon-unbranded-mobile":"bank-card-module__icon-unbranded-mobile--jC0pK","iconUnbrandedMobile":"bank-card-module__icon-unbranded-mobile--jC0pK","icon-touch":"bank-card-module__icon-touch--Ex4y2","iconTouch":"bank-card-module__icon-touch--Ex4y2","bank-card":"bank-card-module__bank-card--a5TzC","bankCard":"bank-card-module__bank-card--a5TzC"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/bank-card/bank-card.tsx









const BankCardDesktop = _ref => {
  let {
    number,
    issuer,
    paySystem,
    view = View/* View */.G.Horizontal,
    size = Size/* Size */.$.Compact,
    className,
    PaymentMethod = PaymentMethod_desktop/* PaymentMethodDesktop */.b,
    isRuRegion,
    ...props
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(PaymentMethod, {
    ...props,
    view,
    className: (0,cnBankCard/* cnBankCard */.x)({
      view,
      size
    }, [className]),
    children: [shouldShowUnbrandedIcon(paySystem, isRuRegion) ? /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: "bank-card",
      size: "large",
      className: bank_card_module.iconUnbrandedDesktop
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(PaySystemIcon/* PaySystemIcon */.G, {
      className: bank_card_module.icon,
      paySystem
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(typography_module/* default */.Z.body2, {
        [bank_card_module.number]: view === View/* View */.G.Horizontal
      }),
      children: number.slice(-4)
    })]
  });
};
const BankCardMobile = _ref2 => {
  let {
    number,
    issuer,
    paySystem,
    view = View/* View */.G.Horizontal,
    size = Size/* Size */.$.Compact,
    className,
    PaymentMethod = PaymentMethod_touch_phone/* PaymentMethodTouchPhone */.E,
    isRuRegion,
    ...props
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(PaymentMethod, {
    ...props,
    view,
    className: classnames_default()((0,cnBankCard/* cnBankCard */.x)({
      view,
      size
    }, [className]), bank_card_module.bankCard),
    children: [shouldShowUnbrandedIcon(paySystem, isRuRegion) ? /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: "bank-card",
      size: "large",
      className: bank_card_module.iconUnbrandedMobile
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(PaySystemIcon/* PaySystemIcon */.G, {
      className: classnames_default()(bank_card_module.icon, bank_card_module.iconTouch),
      paySystem
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(typography_module/* default */.Z.body2, bank_card_module.number),
      children: number.slice(-4)
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/new-card/new-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const new_card_module = ({"new-card":"new-card-module__new-card--UAp4V","newCard":"new-card-module__new-card--UAp4V","new-card-content":"new-card-module__new-card-content--s6rtQ","newCardContent":"new-card-module__new-card-content--s6rtQ","icon":"new-card-module__icon--Vjv3S","icon-desktop":"new-card-module__icon-desktop--w1EL3","iconDesktop":"new-card-module__icon-desktop--w1EL3","icon-touch":"new-card-module__icon-touch--UW5Jc","iconTouch":"new-card-module__icon-touch--UW5Jc","new-card-touch":"new-card-module__new-card-touch--Tb0rn","newCardTouch":"new-card-module__new-card-touch--Tb0rn","title":"new-card-module__title--kX0WI"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/new-card/new-card.tsx









const NewCardDesktop = _ref => {
  let {
    view = View/* View */.G.Vertical,
    className,
    PaymentMethod = PaymentMethod_desktop/* PaymentMethodDesktop */.b,
    ...props
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentMethod, {
    ...props,
    view,
    className: classnames_default()(new_card_module.newCard, className),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: new_card_module.newCardContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: classnames_default()(new_card_module.icon, new_card_module.iconDesktop),
        name: "new-card",
        size: "large"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "purchasePage.chooseCard.newCard"
        })
      })]
    })
  });
};
const NewCardMobile = _ref2 => {
  let {
    view = View/* View */.G.Horizontal,
    className,
    PaymentMethod = PaymentMethod_touch_phone/* PaymentMethodTouchPhone */.E,
    ...props
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(PaymentMethod, {
    ...props,
    name: null,
    view,
    className: classnames_default()(new_card_module.newCardTouch, className),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: classnames_default()(new_card_module.icon, new_card_module.iconTouch),
      name: "new-card",
      size: "large"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(typography_module/* default */.Z.body2, new_card_module.title),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "purchasePage.chooseCard.newCard"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/sbp/sbp.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const sbp_module = ({"wrapper":"sbp-module__wrapper--RNpvH","wrapper-mobile":"sbp-module__wrapper-mobile--xypr2","wrapperMobile":"sbp-module__wrapper-mobile--xypr2","top-block":"sbp-module__top-block--OyTYc","topBlock":"sbp-module__top-block--OyTYc","title":"sbp-module__title--prPjL","chip":"sbp-module__chip--vtLwe","chip-mobile":"sbp-module__chip-mobile--XmemC","chipMobile":"sbp-module__chip-mobile--XmemC","icon":"sbp-module__icon--W5wHg"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/sbp/sbp-desktop.tsx









const SbpDesktop = _ref => {
  let {
    view = View/* View */.G.Vertical,
    className,
    PaymentMethod = PaymentMethod_desktop/* PaymentMethodDesktop */.b,
    discountPercentage,
    ...props
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentMethod, {
    ...props,
    view,
    className,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: sbp_module.wrapper,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: sbp_module.topBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: sbp_module.icon,
          name: "sbp",
          size: "medium"
        }), discountPercentage && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(typography_module/* default */.Z.captionAccent, sbp_module.chip),
          children: ["-", discountPercentage, "%"]
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "purchasePage.paymentMethod.sbp"
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/sbp/sbp-mobile.tsx









const SbpMobile = _ref => {
  let {
    view = View/* View */.G.Horizontal,
    className,
    PaymentMethod = PaymentMethod_touch_phone/* PaymentMethodTouchPhone */.E,
    discountPercentage,
    ...props
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(PaymentMethod, {
    ...props,
    name: null,
    view,
    className: classnames_default()(sbp_module.wrapperMobile, className),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: sbp_module.icon,
      name: "sbp",
      size: "large"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(typography_module/* default */.Z.body2, sbp_module.title),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "purchasePage.paymentMethod.sbp"
      })
    }), discountPercentage && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(typography_module/* default */.Z.captionAccent, sbp_module.chip, sbp_module.chipMobile),
      children: ["-", discountPercentage, "%"]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/carousel/carousel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const carousel_module = ({"theme-custom":"carousel-module__theme-custom--GOzFQ","themeCustom":"carousel-module__theme-custom--GOzFQ","theme-desktop":"carousel-module__theme-desktop--XqEyh","themeDesktop":"carousel-module__theme-desktop--XqEyh","theme-touch":"carousel-module__theme-touch--BtGcX","themeTouch":"carousel-module__theme-touch--BtGcX"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/carousel/carousel.tsx












const className = (0,Theme/* cnTheme */.O)({
  [core_Theme/* Theme */.Q.Light]: true
}, carousel_module.themeCustom);
const CarouselDesktopLazy = (0,react.lazy)(() => Promise.all(/* import() | choose-bank-card.carousel-desktop */[__webpack_require__.e(465), __webpack_require__.e(597), __webpack_require__.e(823)]).then(__webpack_require__.bind(__webpack_require__, 8216)));
const CarouselTouchLazy = (0,react.lazy)(() => Promise.all(/* import() | choose-bank-card.carousel-touch */[__webpack_require__.e(465), __webpack_require__.e(694)]).then(__webpack_require__.bind(__webpack_require__, 9062)));
const Carousel = _ref => {
  let {
    methodId,
    methods,
    productPrice,
    onCarouselChange
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const sbpDiscountPercentage = productPrice?.sbpDiscountPercentage;
  const isRuRegion = Boolean(productPrice?.isRuRegion);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: null,
    children: isMobile ? /* @__PURE__ */(0,jsx_runtime.jsx)(CarouselTouchLazy, {
      className: classnames_default()(className, carousel_module.themeTouch),
      methodId,
      methods,
      onCarouselChange,
      NewBankCard: NewCardMobile,
      BankCard: props => /* @__PURE__ */(0,jsx_runtime.jsx)(BankCardMobile, {
        ...props,
        isRuRegion
      }),
      FasterPaymentsSystem: props => /* @__PURE__ */(0,jsx_runtime.jsx)(SbpMobile, {
        ...props,
        discountPercentage: sbpDiscountPercentage
      })
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(CarouselDesktopLazy, {
      className: classnames_default()(className, carousel_module.themeDesktop),
      methodId,
      methods,
      onCarouselChange,
      NewBankCard: NewCardDesktop,
      BankCard: props => /* @__PURE__ */(0,jsx_runtime.jsx)(BankCardDesktop, {
        ...props,
        isRuRegion
      }),
      FasterPaymentsSystem: props => /* @__PURE__ */(0,jsx_runtime.jsx)(SbpDesktop, {
        ...props,
        discountPercentage: sbpDiscountPercentage
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/choose-bank-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const choose_bank_card_module = ({"switcher":"choose-bank-card-module__switcher--GvA35","card-holder":"choose-bank-card-module__card-holder--mDmkZ","cardHolder":"choose-bank-card-module__card-holder--mDmkZ","hint":"choose-bank-card-module__hint--HlBzm","hint-error":"choose-bank-card-module__hint-error--_DLP5","hintError":"choose-bank-card-module__hint-error--_DLP5"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/choose-bank-card/choose-bank-card.tsx















const ChooseBankCard = _ref => {
  let {
    isRussianCards,
    onCardsCountryChange,
    methodId,
    productPrice,
    methods,
    onCarouselChange
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [, {
    errorText
  }] = (0,use_form_field/* useFormField */.Y)("cardHolder");
  const handleCarouselChange = method => {
    if (method?.methodId === "new_card") {
      (0,yandexMetrica/* ymGoal */.qf)("Purchase_Form_New_Card_Choose");
    }
    onCarouselChange?.(method);
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(Box, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: choose_bank_card_module.switcher,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TextSwitcher, {
        checked: isRussianCards,
        onChange: onCardsCountryChange,
        reverse: true,
        vertical: isMobile,
        equalWidths: true,
        checkedText: intl.formatMessage({
          id: "purchasePage.chooseCard.russianCards"
        }),
        unCheckedText: intl.formatMessage({
          id: "purchasePage.chooseCard.nonRussianCards"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Carousel, {
      methods,
      methodId,
      productPrice,
      onCarouselChange: method => handleCarouselChange(method)
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: choose_bank_card_module.cardHolder,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(fields_text/* FormTextField */.X, {
        "data-testid": "cardholder-field",
        name: "cardHolder",
        label: intl.formatMessage({
          id: "purchasePage.chooseCard.cardHolder"
        }),
        placeholder: intl.formatMessage({
          id: "purchasePage.chooseCard.cardHolderPlaceholder"
        }),
        theme: input_component/* InputTheme */.RK.Grey,
        autoFocus: true,
        onClick: () => {
          (0,yandexMetrica/* ymGoal */.qf)("Purchase_Form_Full_Name_Text_Field_Click");
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(Hint, {
        text: intl.formatMessage({
          id: "purchasePage.chooseCard.cardHolderHint"
        }),
        className: classnames_default()(choose_bank_card_module.hint, {
          [choose_bank_card_module.hintError]: errorText
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/promocode/promocode.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const promocode_module = ({"block":"promocode-module__block--Css5_","promocode-input":"promocode-module__promocode-input--h3Hnu","promocodeInput":"promocode-module__promocode-input--h3Hnu"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/promocode/promocode.tsx












const validationSchema = es/* object */.Ry({
  promocode: es/* string */.Z_().trim()
}).defined();
const transformValues = {
  promocode: transforms/* formFieldTransforms */.l.tryTrim
};
const Promocode = _ref => {
  let {
    initialValue,
    status,
    warningMessage,
    onSubmit
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Box, {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(form_form/* Form */.l, {
      initialValues: {
        promocode: initialValue
      },
      validationSchema,
      transformValues,
      onSubmit,
      children: props => {
        const {
          values,
          submitForm
        } = props;
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: promocode_module.block,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: promocode_module.promocodeInput,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(fields_text/* FormTextField */.X, {
              "data-testid": "promocode-field",
              name: "promocode",
              placeholder: intl.formatMessage({
                id: "purchasePage.promocode.placeholder"
              }),
              theme: input_component/* InputTheme */.RK.Grey,
              status: values.promocode ? status : input_component/* InputStatus */.Xz.Default,
              textConstants: {
                hint: {
                  warning: warningMessage ?? intl.formatMessage({
                    id: "purchasePage.promocode.applicationWarning"
                  }),
                  success: intl.formatMessage({
                    id: "purchasePage.promocode.applicationSuccess"
                  })
                }
              },
              onChange: event => event.target.value === "" && void submitForm()
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            "data-testid": "promocode-submit-button",
            type: "submit",
            onClick: submitForm,
            appearance: "secondary",
            disabled: !values.promocode,
            children: intl.formatMessage({
              id: "purchasePage.promocode.submitButton"
            })
          })]
        });
      }
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/promocode/use-promocode.ts






const $promocode = (0,effector/* createStore */.MT)("");
const promocodeApi = (0,effector/* createApi */.LC)($promocode, {
  setPromocode: (state, payload) => payload.promocode
});
function usePromocode(region) {
  const promocode = (0,effector_react/* useStore */.oR)($promocode);
  return (0,useQuery/* useQuery */.a)({
    queryKey: ["promocode", {
      promocode,
      region
    }],
    queryFn: () => getPromocodeStatus({
      promocode,
      region
    }),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
    staleTime: Infinity,
    enabled: Boolean(promocode)
  });
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/promocode/promocode-container.tsx







function PromocodeContainer(_ref) {
  let {
    cardsRegion
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    data: promocodeData,
    isFetching: isPromocodeFetching
  } = usePromocode(cardsRegion);
  const promocodeStatus = isPromocodeFetching ? input_component/* InputStatus */.Xz.Loading : promocodeData?.status;
  const warningMessageId = promocodeData?.warningMessageId;
  const promocodeWarning = warningMessageId ? intl.formatMessage({
    id: warningMessageId
  }) : warningMessageId;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Promocode, {
    initialValue: "",
    status: promocodeStatus,
    warningMessage: promocodeWarning,
    onSubmit: promocodeApi.setPromocode
  });
}
// EXTERNAL MODULE: ../ui-kit/src/switch/switch.component.tsx + 1 modules
var switch_component = __webpack_require__(5714);
// EXTERNAL MODULE: ../ui-kit/src/form/use-form-context.ts
var use_form_context = __webpack_require__(83900);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/residency/residency.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const residency_module = ({"line":"residency-module__line--HSy8O","second-line":"residency-module__second-line--OvoGC","secondLine":"residency-module__second-line--OvoGC","hidden":"residency-module__hidden--wr0Jz","text":"residency-module__text--UNsw7","hint":"residency-module__hint--ycNjO","input":"residency-module__input--eRpav"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/residency/iin-field.tsx










const Field = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    errors,
    touched,
    setFieldValue
  } = (0,use_form_context/* useFormContext */.Gc)();
  (0,react.useEffect)(() => {
    void setFieldValue("IIN", "", false);
    return () => {
      void setFieldValue("IIN", void 0);
    };
  }, [setFieldValue]);
  const isSuccessValidate = (0,react.useMemo)(() => !errors?.IIN && touched.IIN, [errors?.IIN, touched.IIN]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: residency_module.input,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(fields_text/* FormTextField */.X, {
      "data-testid": "iin-field",
      name: "IIN",
      status: isSuccessValidate ? input_component/* InputStatus */.Xz.Success : input_component/* InputStatus */.Xz.Default,
      placeholder: intl.formatMessage({
        id: "purchasePage.residency.iinPlaceholder"
      }),
      theme: input_component/* InputTheme */.RK.Grey,
      validateOnChange: true,
      onClick: () => {
        (0,yandexMetrica/* ymGoal */.qf)("Purchase_Form_Iin_Text_Field_Click");
      }
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/residency/residency.tsx










const Residency = _ref => {
  let {
    checked,
    onChange
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(Box, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: residency_module.line,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
        className: residency_module.text,
        children: [intl.formatMessage({
          id: "purchasePage.residency.text"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(Hint, {
          text: intl.formatMessage({
            id: "purchasePage.residency.hintText"
          }),
          className: residency_module.hint
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(switch_component/* Switch */.r, {
        dataTestId: "is-resident-switch",
        checked,
        onChange
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(residency_module.line, residency_module.secondLine, {
        [residency_module.hidden]: !checked
      }),
      children: checked && /* @__PURE__ */(0,jsx_runtime.jsx)(Field, {})
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/constants.ts


const SBP_PAYMENT_METHOD = "sbp_qr";
// EXTERNAL MODULE: ../ui-kit/src/alert/alert.tsx + 2 modules
var alert_alert = __webpack_require__(11628);
// EXTERNAL MODULE: ../ui-kit/src/alert/model/model.ts
var model_model = __webpack_require__(98922);
// EXTERNAL MODULE: ../ui-kit/src/skeleton/index.ts + 1 modules
var skeleton = __webpack_require__(80735);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/amount/skeleton.tsx




const PriceSkeleton = () => /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
  width: "146px"
});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/amount/amount.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const amount_module = ({"root":"amount-module__root--hYiHV","table":"amount-module__table--lOpwM","cell":"amount-module__cell--NsxuN","table-footer":"amount-module__table-footer--ahsa_","tableFooter":"amount-module__table-footer--ahsa_","table-body":"amount-module__table-body--onGUN","tableBody":"amount-module__table-body--onGUN","discount-value":"amount-module__discount-value--rWkgW","discountValue":"amount-module__discount-value--rWkgW","info":"amount-module__info--OtcFv","button":"amount-module__button--AfUT3","with-autopay-info":"amount-module__with-autopay-info--Sj3Yw","withAutopayInfo":"amount-module__with-autopay-info--Sj3Yw","offer":"amount-module__offer--qooPL","button-text":"amount-module__button-text--jKJLw","buttonText":"amount-module__button-text--jKJLw"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/amount/amount.tsx





















const Amount = (0,react.memo)(_ref => {
  let {
    finalPrice,
    currency,
    payment,
    discount,
    referralBonus,
    button
  } = _ref;
  const {
    autopayByResource
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [isAccepted, setIsAccepted] = (0,react.useState)(true);
  const [amountButtonHeight, setAmountButtonHeight] = (0,react.useState)(0);
  const [externalUrls, setExternalUrls] = (0,react.useState)();
  (0,react.useEffect)(() => {
    void (0,bunker_api/* getExternalUrls */.Sj)().then(setExternalUrls);
  }, []);
  let urls;
  if (!externalUrls) {
    urls = (0,domain_urls/* getExternalUrls */.Sj)();
  } else if (currency === "RUB") {
    urls = externalUrls.default;
  } else {
    urls = externalUrls.kz;
  }
  const isAutopayByResource = autopayByResource && payment.strategy === "partial_payment";
  const coursePriceFormatted = (0,react.useMemo)(() => {
    if (!payment.price || !currency) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(PriceSkeleton, {});
    }
    switch (payment.strategy) {
      case "full_payment":
      case "subscription":
        return formatPrice({
          price: payment.price,
          currency
        });
      case "partial_payment":
        return intl.formatMessage({
          id: autopayByResource ? "purchasePage.amount.paymentsPerResources" : "purchasePage.amount.paymentsPerMonth"
        }, {
          price: formatPrice({
            price: payment.price,
            currency
          })
        });
      default:
        break;
    }
  }, [autopayByResource, currency, intl, payment.price, payment.strategy]);
  const discountFormatted = (0,react.useMemo)(() => {
    if (!discount || !currency) {
      return "";
    }
    return discount && discount.value > 0 ? "-" + formatDiscount({
      value: discount.value,
      policy: discount.policy,
      currency
    }) : "";
  }, [currency, discount]);
  const finalPriceFormatted = (0,react.useMemo)(() => {
    if (!finalPrice || !currency) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(PriceSkeleton, {});
    }
    return formatPrice({
      price: finalPrice,
      currency
    });
  }, [currency, finalPrice]);
  const isButtonDisabled = (0,react.useMemo)(() => !isAccepted || Boolean(button.disabled), [button.disabled, isAccepted]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(Box, {
    className: amount_module.root,
    style: {
      "--amount-button-height": `${amountButtonHeight}px`
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("table", {
      className: amount_module.table,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("tbody", {
        className: amount_module.tableBody,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.coursePriceTitle"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: coursePriceFormatted
          })]
        }), payment.strategy === "partial_payment" && /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.numberOfPaymentsTitle"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.numberOfPayments"
            }, {
              number: payment.partialPaymentsCount
            })
          })]
        }), payment.strategy === "subscription" && /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.paymentType"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.paymentGap"
            })
          })]
        }), discountFormatted && /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.discountTitle"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            "data-testid": "payment-discount",
            className: classnames_default()(amount_module.cell, amount_module.discountValue),
            children: discountFormatted
          })]
        }), referralBonus && /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "payment.referralProgram"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: classnames_default()(amount_module.cell, amount_module.discountValue),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "payment.referralBonusAmount",
              values: {
                amount: referralBonus
              }
            })
          })]
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("tfoot", {
        className: classnames_default()(amount_module.tableFooter, typography_module/* default */.Z.body1Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            className: amount_module.cell,
            children: intl.formatMessage({
              id: "purchasePage.amount.finalPriceTitle"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
            "data-testid": "payment-final-price",
            className: amount_module.cell,
            children: finalPriceFormatted
          })]
        })
      })]
    }), isAutopayByResource && /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
      className: amount_module.info,
      type: model_model/* AlertType */.N.INFO,
      text: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: intl.formatMessage({
          id: "purchasePage.amount.autopayInfo"
        })
      }),
      iconCustomProps: {
        name: "info",
        size: "medium"
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(amount_module.button, {
        [amount_module.withAutopayInfo]: isAutopayByResource
      }),
      ref: element => element && setAmountButtonHeight(element?.getBoundingClientRect()?.height ?? 0),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        "data-testid": "payment-button",
        type: "submit",
        appearance: "primary",
        disabled: isButtonDisabled,
        onClick: button.onClick,
        autoHeight: true,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: amount_module.buttonText,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
            children: intl.formatMessage({
              id: "purchasePage.payment.proceedToPayment"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
            children: finalPriceFormatted
          })]
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
      checked: isAccepted,
      onChange: setIsAccepted,
      size: "small",
      className: amount_module.offer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        wrapper: markdown_component/* Wrapper */.im.span,
        className: isMobile ? typography_module/* default */.Z.captionAccent : typography_module/* default */.Z.body2,
        children: referralBonus ? intl.formatMessage({
          id: "purchasePage.payment.userAgreementOfferAndReferral"
        }, {
          termsLink: `(${urls.lawInfo}){:target=blank}`,
          offerLink: `(${urls.offer}){:target=blank}`,
          referralLink: `(${urls.referralTerms}){:target=blank}`
        }) : intl.formatMessage({
          id: "purchasePage.payment.userAgreementAndOffer"
        }, {
          termsLink: `(${urls.lawInfo}){:target=blank}`,
          offerLink: `(${urls.offer}){:target=blank}`
        })
      })
    })]
  });
});
Amount.displayName = "Amount";
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/form/amount-container.tsx








const AmountContainer = _ref => {
  let {
    priceData,
    purchaseDraft,
    isPayButtonDisabled,
    onPurchase
  } = _ref;
  const {
    selectedCard
  } = (0,effector_react/* useStore */.oR)($paymentForm);
  const paymentInfo = (0,react.useMemo)(() => {
    const price = priceData?.price;
    const strategy = purchaseDraft.paymentStrategy;
    if (strategy === "partial_payment") {
      return {
        price,
        strategy,
        partialPaymentsCount: purchaseDraft.partialPaymentsCount
      };
    }
    return {
      price,
      strategy
    };
  }, [priceData?.price, purchaseDraft.partialPaymentsCount, purchaseDraft.paymentStrategy]);
  const referralBonus = priceData?.resources?.speakingSession?.referralBonus;
  const isSbpPaymentMethod = selectedCard === SBP_PAYMENT_METHOD;
  const sbpPrice = priceData?.sbpDiscountPrice || priceData?.discountPrice;
  const discount = (0,react.useMemo)(() => {
    if (!priceData) {
      return void 0;
    }
    if (isSbpPaymentMethod) {
      const policy = "percentage";
      return {
        value: priceData.sbpDiscountPercentage || priceData.discount,
        policy: priceData.sbpDiscountPercentage ? policy : priceData.discountPolicy
      };
    }
    return {
      value: priceData.discount,
      policy: priceData.discountPolicy
    };
  }, [isSbpPaymentMethod, priceData]);
  const button = (0,react.useMemo)(() => ({
    disabled: isPayButtonDisabled,
    onClick: onPurchase
  }), [isPayButtonDisabled, onPurchase]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Amount, {
    finalPrice: isSbpPaymentMethod ? sbpPrice : priceData?.discountPrice,
    currency: priceData?.currency,
    payment: paymentInfo,
    discount,
    referralBonus,
    button
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/form/utils.ts




const insertSbpInPaymentMethods = methods => {
  const sbpPaymentMethod = {
    methodType: MethodType/* MethodType */.T.FasterPaymentsSystem,
    methodId: SBP_PAYMENT_METHOD
  };
  return methods.length ? [...methods.slice(0, 1), sbpPaymentMethod, ...methods.slice(1)] : [sbpPaymentMethod];
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/form/form.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const form_module = ({"form":"form-module__form--e8D6A","main":"form-module__main--M5KbT","amount":"form-module__amount--IL722"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/form/purchase-form.tsx





















const PurchaseForm = _ref => {
  let {
    productId,
    purchaseDraft
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isResident,
    isRuCards,
    isResidencyVisible,
    cards,
    selectedCard,
    isPayButtonDisabled
  } = usePaymentForm();
  const {
    payWithSbp,
    hideInternationalCardsPsp
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const products = (0,useProducts/* useProducts */.rn)();
  const [paymentStrategy, setPaymentStrategy] = (0,react.useState)(void 0);
  const isFullPaymentPriceBlock = paymentStrategy === "fullPayment";
  (0,react.useEffect)(() => {
    if (productId) {
      void products.get(productId).then(data => setPaymentStrategy(data?.paymentStrategy));
    }
  }, [productId, products]);
  (0,react.useEffect)(() => () => paymentFormApi.reset(), []);
  const {
    getPurchaseUrl
  } = useGetPurchaseUrl();
  const cardsRegion = isRuCards ? "RU" : "KZ";
  const {
    data: priceData,
    isFetching: isPriceFetching
  } = usePrice({
    productId,
    region: cardsRegion
  });
  const shouldShowSbpMethod = isRuCards && isFullPaymentPriceBlock && payWithSbp && !(0,domain/* isKzDomain */.k)();
  const shouldHideInternationalCards = hideInternationalCardsPsp && !isRuCards;
  const paymentMethods = (0,react.useMemo)(() => {
    if (shouldShowSbpMethod) {
      return insertSbpInPaymentMethods(cards);
    } else if (shouldHideInternationalCards) {
      return [];
    }
    return cards;
  }, [cards, shouldHideInternationalCards, shouldShowSbpMethod]);
  (0,react.useEffect)(() => {
    if (shouldHideInternationalCards) {
      paymentFormApi.setSelectedCard();
    }
  }, [shouldHideInternationalCards]);
  const onPurchase = (0,react.useMemo)(() => lodash_debounce_default()(async _ref2 => {
    let {
      cardHolder,
      IIN
    } = _ref2;
    await getPurchaseUrl({
      region: cardsRegion,
      cardHolder,
      paymentMethodId: selectedCard === NEW_CARD ? void 0 : selectedCard,
      purchaseId: purchaseDraft.purchaseId,
      iin: IIN
    });
  }, 300), [cardsRegion, getPurchaseUrl, purchaseDraft.purchaseId, selectedCard]);
  const [amountHeight, setAmountHeight] = (0,react.useState)(0);
  const validationSchema = (0,react.useMemo)(() => {
    const schema = {
      cardHolder: es/* string */.Z_().trim().required("form.validation.required")
    };
    if (isResident) {
      schema.IIN = es/* string */.Z_().required("purchasePage.residency.iinRequiredError").length(12, "purchasePage.residency.iinLengthError").IIN("purchasePage.residency.iinError");
    }
    return es/* object */.Ry(schema).defined();
  }, [isResident]);
  const initialValues = (0,react.useMemo)(() => ({
    cardHolder: "",
    IIN: void 0
  }), []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(form_form/* Form */.l, {
    initialValues,
    transformValues: {
      cardHolder: transforms/* formFieldTransforms */.l.trim
    },
    validationSchema,
    formatMessage: msg => intl.formatMessage({
      id: msg
    }),
    onSubmit: onPurchase,
    children: _ref3 => {
      let {
        handleSubmit,
        resetForm,
        values
      } = _ref3;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: form_module.form,
        style: {
          "--amount-height": `${amountHeight}px`
        },
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
          className: form_module.main,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ChooseBankCard, {
            isRussianCards: isRuCards,
            methodId: selectedCard,
            productPrice: priceData,
            onCarouselChange: paymentFormApi.setSelectedCard,
            onCardsCountryChange: () => {
              (0,yandexMetrica/* ymGoal */.qf)("Purchase_Form_Cards_Country_Switcher_Change");
              paymentFormApi.toggleIsRuCards();
              resetForm({
                values: {
                  cardHolder: values.cardHolder
                }
              });
            },
            methods: paymentMethods
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(PromocodeContainer, {
            cardsRegion
          }), isResidencyVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(Residency, {
            checked: isResident,
            onChange: () => {
              (0,yandexMetrica/* ymGoal */.qf)("Purchase_Form_Kz_Residency_Switcher_Change");
              paymentFormApi.toggleIsResident();
            }
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("aside", {
          ref: element => {
            if (element) {
              setAmountHeight(element.getBoundingClientRect().height);
            }
          },
          className: form_module.amount,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(AmountContainer, {
            onPurchase: () => {
              (0,yandexMetrica/* ymGoal */.qf)("Purchase_Form_Purchase_Button_Click");
              handleSubmit();
            },
            isPayButtonDisabled: isPayButtonDisabled || isPriceFetching,
            purchaseDraft,
            priceData
          })
        })]
      });
    }
  });
};
// EXTERNAL MODULE: ../shared/src/constants.ts
var constants = __webpack_require__(51157);
;// CONCATENATED MODULE: ../shared/src/hooks/use-previous.tsx



function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}
// EXTERNAL MODULE: ../../node_modules/@yandex-trust-sdk/base/dist-es/index.js + 26 modules
var dist_es = __webpack_require__(86107);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/payment-modal/constants.ts


const TRUST_SDK_TESTING_URL = "https://trust-test.yandex.ru";
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/payment-modal/payment-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_modal_module = ({"frame-wrapper":"payment-modal-module__frame-wrapper--FZRBb","frameWrapper":"payment-modal-module__frame-wrapper--FZRBb","frame-wrapper-old":"payment-modal-module__frame-wrapper-old--vLFjF","frameWrapperOld":"payment-modal-module__frame-wrapper-old--vLFjF","loader-wrapper":"payment-modal-module__loader-wrapper--RABxB","loaderWrapper":"payment-modal-module__loader-wrapper--RABxB","loader":"payment-modal-module__loader--Ezezs","hidden":"payment-modal-module__hidden--xvZN9","frame":"payment-modal-module__frame--KpW9u"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/payment-modal/payment-modal-frame.tsx




















const PaymentModalFrame = _ref => {
  let {
    purchaseId,
    purchaseUrl
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isFetching
  } = usePurchaseUrl({
    purchaseId
  });
  const iframeContainerRef = (0,react.useRef)(null);
  const [isFormReady, setIsFormReady] = (0,react.useState)(false);
  const {
    updateStatus
  } = usePurchaseStatusQuery({
    purchaseId
  });
  const [loadingPhaseTranslationId, setLoadingPhaseTranslationId] = (0,react.useState)(1);
  const {
    selectedCard
  } = (0,effector_react/* useStore */.oR)($paymentForm);
  (0,react.useEffect)(() => {
    async function getPaymentFrame() {
      if (!purchaseUrl) {
        return;
      }
      const sdk = dist_es/* default */.ZP.create({
        apiHost: constants/* IS_PROD */.XK ? void 0 : TRUST_SDK_TESTING_URL
      });
      const paymentFrame2 = await sdk.paymentForm({
        url: purchaseUrl
      });
      try {
        await sdk.bindCard();
      } catch (error) {
        logger/* Logger */.Yd.captureException(error, {
          purchaseId
        }, {
          block: "PaymentModalFrame",
          method: "sdk.bindCard"
        });
      }
      paymentFrame2.on("form-ready", () => {
        if (!isFetching) {
          setIsFormReady(true);
        }
      });
      let isFormSubmit = false;
      paymentFrame2.on("form-submit", async () => {
        if (selectedCard === "sbp_qr") {
          return;
        }
        if (!isFormSubmit) {
          isFormSubmit = true;
          await startPurchase(purchaseId);
        }
      });
      paymentFrame2.on("success", () => {
        closePaymentModal();
        updateStatus();
      });
      paymentFrame2.on("error", () => {
        closePaymentModal();
        updateStatus();
      });
      if (iframeContainerRef.current) {
        paymentFrame2.mount(iframeContainerRef.current, {
          className: payment_modal_module.frame,
          title: intl.formatMessage({
            id: "purchasePage.frameTitle"
          })
        });
      }
      return paymentFrame2;
    }
    let paymentFrame;
    void getPaymentFrame().then(result => {
      paymentFrame = result;
    });
    return () => paymentFrame?.unmount();
  }, [intl, purchaseUrl, purchaseId, isFetching, updateStatus, selectedCard]);
  (0,react.useEffect)(() => {
    const LAST_LOADING_PHASE = 3;
    if (isFormReady || loadingPhaseTranslationId === LAST_LOADING_PHASE) {
      return;
    }
    const timerId = setTimeout(() => {
      setLoadingPhaseTranslationId(currentTranslationId => currentTranslationId + 1);
    }, 2e3);
    return () => {
      clearTimeout(timerId);
    };
  }, [isFormReady, loadingPhaseTranslationId]);
  const isSbpPaymentMethod = selectedCard === SBP_PAYMENT_METHOD;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isFormReady && isSbpPaymentMethod && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "purchase.paymentModalFrame.sbpAdditionalText"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()({
        [payment_modal_module.hidden]: !isFormReady
      }),
      ref: iframeContainerRef
    }), !isFormReady && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: payment_modal_module.loaderWrapper,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {
        className: payment_modal_module.loader
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
        className: typography_module/* default */.Z.headline3,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "purchasePage.paymentModal.loadingPhase" + loadingPhaseTranslationId
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/payment-modal/payment-modal.tsx















const PaymentModal = _ref => {
  let {
    purchaseId,
    overlay = "dark"
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const isPaymentModalOpen = (0,effector_react/* useStore */.oR)($isPaymentModalOpen);
  const {
    data
  } = usePurchaseUrl({
    purchaseId
  });
  const prevPurchaseUrl = usePrevious(data);
  const purchaseUrl = (0,react.useMemo)(() => {
    if (data && data !== prevPurchaseUrl) {
      return `${data}${isMobile ? "&template_tag=mobile/form" : ""}`;
    }
    return null;
  }, [data, isMobile, prevPurchaseUrl]);
  const onClose = (0,react.useCallback)(() => {
    closePaymentModal();
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    overlay,
    title: intl.formatMessage({
      id: "purchasePage.paymentModal.title"
    }),
    isVisible: isPaymentModalOpen,
    onClose,
    showCloseButton: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(payment_modal_module.frameWrapper, {
        [payment_modal_module.frameWrapperOld]: constants/* IS_PROD */.XK
      }),
      children: isPaymentModalOpen && /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentModalFrame, {
        purchaseUrl,
        purchaseId
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/constants.ts


const SPACE = " ";
const NEL = "\n";
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/purchase-content/purchase-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const purchase_content_module = ({"root":"purchase-content-module__root--ibZqx","back-button":"purchase-content-module__back-button--JEY8V","backButton":"purchase-content-module__back-button--JEY8V","container":"purchase-content-module__container--moyoN","title":"purchase-content-module__title--ngQYG","course-title":"purchase-content-module__course-title--C0vob","courseTitle":"purchase-content-module__course-title--C0vob"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/payment-screen.tsx














const PaymentScreen = _ref => {
  let {
    productId,
    purchaseDraft,
    isGift
  } = _ref;
  const {
    isMobile,
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const titleKey = (0,react.useMemo)(() => {
    if (isGift) {
      return "purchasePage.title.gift";
    }
    if (purchaseDraft.paymentStrategy === "subscription") {
      return "purchasePage.title.subscription";
    }
    return "purchasePage.title.course";
  }, [isGift, purchaseDraft.paymentStrategy]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: purchase_content_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: purchase_content_module.backButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(GoBackButton, {
        onClick: history.goBack,
        text: intl.formatMessage({
          id: "backButton"
        }),
        withMarginBottom: false
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: purchase_content_module.container,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("h1", {
        className: classnames_default()(purchase_content_module.title, typography_module/* default */.Z.headline3, {
          [typography_module/* default */.Z.headline4Accent]: isMobile
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: titleKey
        }), isDesktop ? SPACE : NEL, /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: purchase_content_module.courseTitle,
          children: purchaseDraft.productTitle
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(PurchaseForm, {
        purchaseDraft,
        productId
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentModal, {
        purchaseId: purchaseDraft.purchaseId
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/pages/auto-onboarding/index.ts + 176 modules
var auto_onboarding = __webpack_require__(3874);
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/success-screen/success-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const success_screen_module = ({"root":"success-screen-module__root--tGKha","image":"success-screen-module__image--fUiez","title":"success-screen-module__title--jP6FL","description-block":"success-screen-module__description-block--zO5vN","descriptionBlock":"success-screen-module__description-block--zO5vN","button":"success-screen-module__button--u83IT"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/success-screen/success-screen.tsx











function SuccessScreen(_ref) {
  let {
    parentProductId,
    productId
  } = _ref;
  const sendAutoOnboardingAssignEvent = (0,effector_react/* useEvent */.zX)(auto_onboarding.autoOnboardingAnalyticEvents.assignFx);
  const isAvailableAutoOnboarding = (0,auto_onboarding.useAvailableAutoOnboarding)();
  const onClickLink = () => {
    if (isAvailableAutoOnboarding) {
      sendAutoOnboardingAssignEvent({
        parentProductId,
        productId
      });
    }
  };
  const href = isAvailableAutoOnboarding ? studentRoutePaths/* studentRoutePaths */.dR.AUTO_ONBOARDING : studentRoutePaths/* studentRoutePaths */.dR.INDEX;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: success_screen_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      role: "presentation",
      className: success_screen_module.image,
      alt: "",
      src: "https://flowstatic.s3.yandex.net/ui-files/congratulations-after-bought.svg"
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("h3", {
      className: success_screen_module.title,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "beginnerOnboardingPage.starting.congratulate"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}), /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "beginnerOnboardingPage.starting.bought"
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.headline4, success_screen_module.descriptionBlock),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "beginnerOnboardingPage.starting.text2"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
      onClick: onClickLink,
      className: success_screen_module.button,
      href,
      appearance: "primary",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "purchasePage.paidScreen.link"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/purchase-content/purchase-content.tsx











function PurchaseContent(_ref) {
  let {
    productId,
    parentProductId,
    giftId,
    isSplitPayment,
    purchaseDraft,
    tryAgain,
    state
  } = _ref;
  useSendPurchaseStateToYandexMetrika(state.status);
  const isGift = Boolean(giftId);
  if (isSplitPayment && state.status === "payment") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(InProgressScreen, {});
  }
  switch (state.status) {
    case "loading":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
    case "paid":
      return isGift ? /* @__PURE__ */(0,jsx_runtime.jsx)(PaidScreen, {
        isGift: true
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(SuccessScreen, {
        parentProductId,
        productId
      });
    case "in_progress":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(InProgressScreen, {});
    case "fail":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(FailScreen, {
        responseCode: state.responseCode,
        tryAgain
      });
    case "payment":
      return purchaseDraft ? /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentScreen, {
        isGift: Boolean(giftId),
        productId,
        purchaseDraft
      }) : null;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(state);
  }
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/error-screen/error-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_screen_module = ({"screen":"error-screen-module__screen--N4tT4","title":"error-screen-module__title--Kt7wM"});
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/components/screens/error-screen/error-screen.tsx







function ErrorScreen() {
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    "data-testid": "payment-error-screen",
    className: error_screen_module.screen,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()(typography_module/* default */.Z.headline3, error_screen_module.title),
      children: intl.formatMessage({
        id: "purchasePage.errorScreen.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body2,
      children: intl.formatMessage({
        id: "purchasePage.errorScreen.text"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/purchase/new-flow-psp/purchase-page.tsx











const PurchasePage = _ref => {
  let {
    productId,
    parentProductId,
    giftId
  } = _ref;
  const isSplitPayment = isSplitPaymentMethod();
  const {
    purchaseDraft,
    tryAgain
  } = usePurchaseDraft({
    productId,
    parentProductId,
    giftId,
    isSplitPayment
  });
  const state = usePurchaseState({
    purchaseId: purchaseDraft?.purchaseId,
    isSplitPayment
  });
  const withBottomMenu = !isSplitPayment && state.status === "payment";
  const handleError = (error, errorInfo) => {
    logger/* Logger */.Yd.captureException(error, errorInfo, {
      block: "PurchasePage",
      method: "handleError"
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
      doNotWrapChildrenWithLayout: true
    },
    header: {
      hideMenuButton: true,
      hideNavigation: true,
      hideNotifierBell: true
    },
    main: {
      hideHelpButton: false,
      hideGrammarGuideButton: true
    },
    footer: {
      hideFooter: true,
      withBottomMenu
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
      onError: handleError,
      onErrorContent: () => /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorScreen, {}),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(PurchaseContent, {
        productId,
        parentProductId,
        giftId,
        isSplitPayment,
        purchaseDraft,
        tryAgain,
        state
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/purchase/purchase-page-wrapper.tsx




const PurchasePageWrapper = _ref => {
  let {
    parentProductId,
    productId,
    giftId
  } = _ref;
  if (!(parentProductId && productId)) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(PurchasePage, {
    giftId,
    parentProductId,
    productId
  });
};
;// CONCATENATED MODULE: ./src/pages/unknown-error-page/unknown-error-page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const unknown_error_page_module = ({"root":"unknown-error-page-module__root--FrkJt","reload-button-wrapper":"unknown-error-page-module__reload-button-wrapper--k7Eyc","reloadButtonWrapper":"unknown-error-page-module__reload-button-wrapper--k7Eyc"});
;// CONCATENATED MODULE: ./src/pages/unknown-error-page/unknown-error-page.page.tsx












const UnknownErrorPage = _ref => {
  let {
    errorTextForSentry,
    hasReloadButton = false
  } = _ref;
  (0,react.useEffect)(() => {
    if (errorTextForSentry === void 0) {
      logger/* Logger */.Yd.captureException("UnknownErrorPage shown");
    } else {
      logger/* Logger */.Yd.captureException(`UnknownErrorPage: ${errorTextForSentry}`);
    }
  }, [errorTextForSentry]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      contentPosition: app_page_wrapper_types/* ContentPosition */.E.Center
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: unknown_error_page_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4Accent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "unknownErrorPage.mainText"
        })
      }), hasReloadButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: unknown_error_page_module.reloadButtonWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primary",
          onClick: reload_page/* reloadPage */.s,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "unknownErrorPage.reloadButton"
          })
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/buy-gift-certificate/buy-gift-certificate.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const buy_gift_certificate_module = ({"image":"buy-gift-certificate-module__image--S3Ayo","header":"buy-gift-certificate-module__header--XCboR","header-last-line":"buy-gift-certificate-module__header-last-line--iS2TS","headerLastLine":"buy-gift-certificate-module__header-last-line--iS2TS","form":"buy-gift-certificate-module__form--Uv3sZ","error":"buy-gift-certificate-module__error--y1L7R","intro-info":"buy-gift-certificate-module__intro-info--lEYJK","introInfo":"buy-gift-certificate-module__intro-info--lEYJK","intro":"buy-gift-certificate-module__intro--IfHTr","course-info":"buy-gift-certificate-module__course-info--VVQid","courseInfo":"buy-gift-certificate-module__course-info--VVQid","old-price":"buy-gift-certificate-module__old-price--MJxyZ","oldPrice":"buy-gift-certificate-module__old-price--MJxyZ","plus-badge":"buy-gift-certificate-module__plus-badge--oT8oB","plusBadge":"buy-gift-certificate-module__plus-badge--oT8oB","course-info-header":"buy-gift-certificate-module__course-info-header--HUsaQ","courseInfoHeader":"buy-gift-certificate-module__course-info-header--HUsaQ","course-info-body":"buy-gift-certificate-module__course-info-body--OtRXf","courseInfoBody":"buy-gift-certificate-module__course-info-body--OtRXf","label":"buy-gift-certificate-module__label--eB2NF","message-wrapper":"buy-gift-certificate-module__message-wrapper--oUF3y","messageWrapper":"buy-gift-certificate-module__message-wrapper--oUF3y","message-counter":"buy-gift-certificate-module__message-counter--nDfNE","messageCounter":"buy-gift-certificate-module__message-counter--nDfNE","additional-info":"buy-gift-certificate-module__additional-info--iHEad","additionalInfo":"buy-gift-certificate-module__additional-info--iHEad","go-payment":"buy-gift-certificate-module__go-payment--_EV4v","goPayment":"buy-gift-certificate-module__go-payment--_EV4v","help-button":"buy-gift-certificate-module__help-button--PGgPk","helpButton":"buy-gift-certificate-module__help-button--PGgPk"});
;// CONCATENATED MODULE: ./src/pages/buy-gift-certificate/buy-gift-certificate.page.tsx










































const MAX_MESSAGE_LENGTH = 150;
const MAX_SIGNATURE_LENGTH = 64;
var ErrorType = /* @__PURE__ */(ErrorType2 => {
  ErrorType2[ErrorType2["Popup"] = 0] = "Popup";
  ErrorType2[ErrorType2["Page"] = 1] = "Page";
  return ErrorType2;
})(ErrorType || {});
const renderItem = item => /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
  children: item.title
});
const mapToStringDropdownId = productId => productId === null ? "null" : `_${productId}`;
const mapFromStringDropdownId = id => id === "null" ? null : id.slice(1);
const BuyGiftCertificateDropdown = _ref => {
  let {
    productId,
    products,
    onActiveItemChanged
  } = _ref;
  const items = (0,react.useMemo)(() => products.map(p => ({
    id: mapToStringDropdownId(p.id),
    title: p.title
  })), [products]);
  const handleChanged = (0,react.useCallback)(id => {
    onActiveItemChanged(mapFromStringDropdownId(id));
  }, [onActiveItemChanged]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_with_items_component/* DropdownWithItems */.MO, {
    activeItemId: mapToStringDropdownId(productId),
    items,
    theme: dropdown_with_items_component/* DropdownWithItemsTheme */.lu.Squared,
    renderItem,
    onActiveItemChanged: handleChanged
  });
};
const getSingleStringFromParsedUrl = parsed => {
  if (typeof parsed === "string") {
    return parsed;
  }
  if (Array.isArray(parsed)) {
    return parsed[0] ?? null;
  }
  return null;
};
const getProductIds = products => products.map(_ref2 => {
  let {
    id
  } = _ref2;
  return id;
}).filter(isNotNull);
const BuyGiftCertificatePage = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const location = (0,react_router/* useLocation */.TH)();
  const intl = (0,useIntl/* default */.Z)();
  const user = (0,useUser/* useUser */.aF)();
  const parsedQueryString = (0,react.useMemo)(() => query_string.parse(location.search), [location.search]);
  const [products, setProducts] = (0,react.useState)([]);
  const [prices, setPrices] = (0,react.useState)();
  const [productId, setProductId] = (0,react.useState)(null);
  const [email, setEmail] = (0,react.useState)(() => getSingleStringFromParsedUrl(parsedQueryString.email) ?? "");
  const [phoneNumber, setPhoneNumber] = (0,react.useState)("");
  const [message, setMessage] = (0,react.useState)("");
  const [signature, setSignature] = (0,react.useState)("");
  const [error, setError] = (0,react.useState)(null);
  const [isIncorrectPhone, setIsIncorrectPhone] = (0,react.useState)(false);
  const product = (0,react.useMemo)(() => products.find(item => item.id === productId) ?? null, [productId, products]);
  const priceData = (0,react.useMemo)(() => {
    if (!prices || !productId) {
      return;
    }
    return prices[productId];
  }, [productId, prices]);
  const {
    [baseRoutePaths/* BuyGiftParams */.X4.BuyPacketProductId]: buyPacketProductId,
    [baseRoutePaths/* BuyGiftParams */.X4.BuyPacketGiftId]: buyPacketGiftId,
    [baseRoutePaths/* BuyGiftParams */.X4.BuyParentProductId]: buyParentProductId
  } = (0,react_router/* useParams */.UO)();
  const currentFieldState = {
    email,
    message,
    signature
  };
  const currentStateForInitialLoading = (0,react.useRef)(currentFieldState);
  currentStateForInitialLoading.current = currentFieldState;
  (0,react.useEffect)(() => {
    void (async () => {
      const productsResponse = await (0,bunker_api/* getGiftProducts */.Ey)();
      if ((0,Either.isRight)(productsResponse) && productsResponse.right.length > 0) {
        setProducts(productsResponse.right);
        const prices2 = await getProductsPrices({
          productIds: getProductIds(productsResponse.right)
        });
        setPrices(prices2);
        const parsedCourseName = getSingleStringFromParsedUrl(parsedQueryString["course-name"]);
        const firstItemId = productsResponse.right[0].id;
        if (parsedCourseName === null) {
          setProductId(firstItemId);
        } else {
          const courseNameFromUrl = productsResponse.right.find(product2 => product2.courseUrlName === parsedCourseName);
          setProductId(courseNameFromUrl === void 0 ? firstItemId : courseNameFromUrl.id);
        }
      } else {
        setError(1 /* Page */);
      }
    })();
  }, [parsedQueryString]);
  (0,react.useEffect)(() => {
    void (async () => {
      if (!productId) {
        return;
      }
      const giftDraft = await (0,student_api/* getGiftDraft */.zr)(productId);
      if ((0,Either.isLeft)(giftDraft)) {
        return;
      }
      const currentState = currentStateForInitialLoading.current;
      if (currentState.email === "" && currentState.message === "" && currentState.signature === "") {
        setEmail(giftDraft.right.email ?? "");
        setMessage(giftDraft.right.message ?? "");
        setSignature(giftDraft.right.signature ?? "");
      }
    })();
  }, [productId]);
  const handleSubmit = (0,react.useCallback)(async event => {
    event.preventDefault();
    if (!(0,phone/* isPhoneValid */.e)(phoneNumber) && phoneNumber !== "") {
      setIsIncorrectPhone(true);
      return;
    }
    if (isIncorrectPhone) {
      setIsIncorrectPhone(false);
    }
    const response = await (0,student_api/* createGiftDraft */.VP)({
      email,
      message,
      signature,
      productId,
      phoneNumber,
      offerId: productId
    });
    if ((0,Either.isLeft)(response)) {
      setError(0 /* Popup */);
      return;
    }
    history.push(baseRoutePaths/* baseRoutePaths */.lQ.BUY_GIFT_CERTIFICATE_PAYMENT(response.right.productId, response.right.id, productId));
  }, [phoneNumber, isIncorrectPhone, email, message, signature, productId, history]);
  const handleCloseError = (0,react.useCallback)(() => {
    setError(null);
  }, []);
  if (error === 1 /* Page */) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownErrorPage, {
      hasReloadButton: true,
      errorTextForSentry: "Gift products not loaded"
    });
  }
  if (product === null) {
    return null;
  }
  if (buyPacketProductId && buyPacketGiftId) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(PurchasePageWrapper, {
      parentProductId: buyParentProductId ?? buyPacketProductId,
      productId: buyPacketProductId,
      giftId: buyPacketGiftId
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: buy_gift_certificate_module.image,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(page_header/* PageHeader */.m, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(BlockContainer, {
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(buy_gift_certificate_module.header, typography_module/* default */.Z.headline3),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "buyGiftCertificate.buyGift"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: buy_gift_certificate_module.headerLastLine,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "buyGiftCertificate.certificate"
            })
          })]
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(BlockContainer, {
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("form", {
        className: classnames_default()(buy_gift_certificate_module.form, typography_module/* default */.Z.body2),
        onSubmit: handleSubmit,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: buy_gift_certificate_module.introInfo,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.descriptionInfo"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: buy_gift_certificate_module.intro,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.description"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(BuyGiftCertificateDropdown, {
            productId,
            products,
            onActiveItemChanged: setProductId
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: buy_gift_certificate_module.courseInfo,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(typography_module/* default */.Z.headline4Accent, buy_gift_certificate_module.courseInfoHeader),
            children: product.title
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(typography_module/* default */.Z.body2, buy_gift_certificate_module.courseInfoBody),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
              children: product.description
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: typography_module/* default */.Z.body2,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(Price, {
              productPrice: priceData
            })
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.caption, buy_gift_certificate_module.label),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.emailFieldLabel"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
          required: true,
          type: "email",
          value: email,
          size: input_depricated_component/* InputSize */.fz.Small,
          onChange: setEmail
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(typography_module/* default */.Z.caption, buy_gift_certificate_module.label, {
            [buy_gift_certificate_module.error]: isIncorrectPhone
          }),
          children: [!isIncorrectPhone && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.phoneFieldLabel"
          }), isIncorrectPhone && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.incorrectFieldLabel"
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
          type: "tel",
          value: phoneNumber,
          size: input_depricated_component/* InputSize */.fz.Small,
          onChange: setPhoneNumber,
          placeholder: "+7 910 777 45 67"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.caption, buy_gift_certificate_module.label),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.messageFieldLabel"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: buy_gift_certificate_module.messageWrapper,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
            additionalPaddingBottom: true,
            maxLength: MAX_MESSAGE_LENGTH,
            multiline: true,
            disableResize: true,
            size: input_depricated_component/* InputSize */.fz.Small,
            value: message,
            onChange: setMessage
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()(buy_gift_certificate_module.messageCounter, typography_module/* default */.Z.caption),
            children: [message.length, "/", MAX_MESSAGE_LENGTH]
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.caption, buy_gift_certificate_module.label),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "buyGiftCertificate.signatureFieldLabel"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
          maxLength: MAX_SIGNATURE_LENGTH,
          value: signature,
          size: input_depricated_component/* InputSize */.fz.Small,
          onChange: setSignature
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: buy_gift_certificate_module.goPayment,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            type: "submit",
            appearance: "primary",
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "buyGiftCertificate.goPayment"
            })
          })
        })]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_footer_component/* AppPageFooter */.b, {}), /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(main_menu/* MainMenu */.l, {
        isRepetitionAvailable: false,
        currentProductId: user.data?.product?.id,
        hideEducationItems: true
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(wordbank_component/* Wordbank */.b, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(promo_code_popup_component/* PromoCodePopup */.V, {
        backPath: get_url_search_params.getUrlSearchParams.promocodePopup.getCloseUrl(history),
        customSuccessButtonTextId: "promoCodePopup.continue"
      })]
    }), error === 0 /* Popup */ && /* @__PURE__ */(0,jsx_runtime.jsx)(deprecated_modal_component/* DeprecatedModal */.rr, {
      onClose: handleCloseError,
      showSubmitButton: true,
      onSubmitButtonClick: handleCloseError,
      submitButtonLabel: intl.formatMessage({
        id: "buyGiftCertificate.errorOk"
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "buyGiftCertificate.errorMessage"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: buy_gift_certificate_module.helpButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(add_page_helper_button/* AppPageHelpButton */.C, {})
    })]
  });
};
// EXTERNAL MODULE: ./src/components/errors/not-found-error.tsx
var not_found_error = __webpack_require__(50327);
;// CONCATENATED MODULE: ./src/pages/page-404/page-404.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const page_404_module = ({"root":"page-404-module__root--Qdw3C","buttons":"page-404-module__buttons--V_llu"});
;// CONCATENATED MODULE: ./src/pages/page-404/page-404.page.tsx














const Page404 = () => {
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const handleContactSupport = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.openHelp.getOpenUrl(history));
  }, [history]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      contentPosition: app_page_wrapper_types/* ContentPosition */.E.Center,
      doNotWrapChildrenWithLayout: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: page_404_module.root,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(not_found_error/* NotFoundError */.d, {
        titleKey: "page404.mainText",
        descriptionKey: "page404.description",
        button: void 0,
        fixed: false,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: page_404_module.buttons,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
            appearance: "primary",
            href: "/",
            children: intl.formatMessage({
              id: "page404.buttonText"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "secondary",
            onClick: handleContactSupport,
            children: intl.formatMessage({
              id: "page404.supportText"
            })
          })]
        })
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/copy-button/copy-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const copy_button_module = ({"button":"copy-button-module__button--UnYfs"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/copy-button/copy-button.tsx









const CopyButton = _ref => {
  let {
    content
  } = _ref;
  const [copied, setCopied] = (0,react.useState)(false);
  let timeoutId = null;
  const copyLinkAction = () => {
    if (!content) {
      return;
    }
    void navigator.clipboard.writeText(content);
    setCopied(true);
    timeoutId = setTimeout(() => {
      setCopied(false);
    }, 1e3);
  };
  (0,react.useEffect)(() => () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
    appearance: "primary",
    disabled: copied || !content,
    onClick: copyLinkAction,
    className: copy_button_module.button,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.body2Accent,
      children: copied ? /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "referralProgramPage.copyButton.copied"
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "referralProgramPage.copyButton.text"
      })
    }), !copied && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      size: "medium",
      name: "copy"
    })]
  });
};
;// CONCATENATED MODULE: ../shared/src/utils/replace-placeholders.ts


const replacePlaceholders = (template, params) => template.replace(/{(.*?)}/g, (match, key) => params[key] ?? match);
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/sharing-buttons/sharing-buttons.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const sharing_buttons_module = ({"wrapper":"sharing-buttons-module__wrapper--mZzg9"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/sharing-buttons/sharing-buttons.tsx






const SharingButtons = _ref => {
  let {
    message,
    link
  } = _ref;
  const messageWithLink = replacePlaceholders(message || "", {
    link: link || ""
  });
  const messageForTelegram = replacePlaceholders(message || "", {
    link: ""
  });
  const encodedMessageWithLink = encodeURIComponent(messageWithLink);
  const encodedMessageForTelegram = encodeURIComponent(messageForTelegram);
  const encodedLink = encodeURIComponent(link || "");
  const shareToTelegram = () => {
    const url = `https://t.me/share/url?url=${encodedLink}&text=${encodedMessageForTelegram}`;
    window.open(url, "_blank");
  };
  const shareToWhatsApp = () => {
    const url = `https://api.whatsapp.com/send?text=${encodedMessageWithLink}`;
    window.open(url, "_blank");
  };
  const shareToVK = () => {
    const url = `https://vk.com/share.php?comment=${encodedMessageWithLink}`;
    window.open(url, "_blank");
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: sharing_buttons_module.wrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "primary",
      size: "medium",
      iconName: "telegram",
      onClick: shareToTelegram
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "primary",
      size: "medium",
      iconName: "whatsapp",
      onClick: shareToWhatsApp
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "primary",
      size: "medium",
      iconName: "vk",
      onClick: shareToVK
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/index.ts




;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/api/mappers.ts




const referralResourcesHistoryMapper = response => {
  const {
    data
  } = response;
  return {
    data: {
      history: data.history.map(_ref => {
        let {
          amount,
          created_at: createdAt,
          id,
          payload: {
            referral_id: referralId,
            tariff
          },
          reason,
          type
        } = _ref;
        return {
          id,
          createdAt,
          type,
          reason,
          amount,
          payload: {
            tariff,
            referralId
          }
        };
      }),
      pageno: data.pageno
    }
  };
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/api/model.ts



const referralResourcePayload = es6.type({
  tariff: es6.union([es6.number, es6.string, es6["null"]]),
  referral_id: es6.string
});
const referralResourcesHistory = es6.array(es6.type({
  id: es6.string,
  created_at: es6.string,
  type: es6.string,
  reason: es6.string,
  amount: es6.number,
  payload: referralResourcePayload
}));
const referralResourcesHistoryResponse = es6.type({
  data: es6.type({
    history: referralResourcesHistory,
    pageno: es6.union([es6.number, es6["null"]])
  })
});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/api/api.ts







const getReferralResourcesHistory = (0,un_either/* unEither */.K)(() => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/referral-resources-history`, {
  responseType: referralResourcesHistoryResponse,
  resultMapper: referralResourcesHistoryMapper
}));
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/empty-list/empty-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const empty_list_module = ({"wrapper":"empty-list-module__wrapper--TciWk","description":"empty-list-module__description--pgfKj"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/empty-list/empty-list.tsx








const EmptyList = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: empty_list_module.wrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.headline4Accent,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "referralProgramPage.invites.noInvites.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(empty_list_module.description, isMobile ? typography_module/* default */.Z.caption : typography_module/* default */.Z.body2),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "referralProgramPage.invites.noInvites.description",
        values: {
          br: isMobile ? null : /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
        }
      })
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/utils/locale.ts
var utils_locale = __webpack_require__(90790);
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/transactions.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const transactions_module = ({"transactions":"transactions-module__transactions--daiI1","list-heading":"transactions-module__list-heading--ziVa8","listHeading":"transactions-module__list-heading--ziVa8","transaction":"transactions-module__transaction--_4XJ2","date":"transactions-module__date--pfh8S","reason-burn":"transactions-module__reason-burn--G3wuS","reasonBurn":"transactions-module__reason-burn--G3wuS","amount-container":"transactions-module__amount-container--x7KSh","amountContainer":"transactions-module__amount-container--x7KSh","amount":"transactions-module__amount--XJRCM","amount-add":"transactions-module__amount-add--bntS0","amountAdd":"transactions-module__amount-add--bntS0","amount-subtract":"transactions-module__amount-subtract--I6zWZ","amountSubtract":"transactions-module__amount-subtract--I6zWZ","amount-burn":"transactions-module__amount-burn--EBAOu","amountBurn":"transactions-module__amount-burn--EBAOu","info":"transactions-module__info--1IjcW","info-button":"transactions-module__info-button--VgHeN","infoButton":"transactions-module__info-button--VgHeN","loader-container":"transactions-module__loader-container--OFGiG","loaderContainer":"transactions-module__loader-container--OFGiG"});
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/amount-chip.tsx







const typeToClassMap = {
  burn: transactions_module.amountBurn,
  add: transactions_module.amountAdd,
  subtract: transactions_module.amountSubtract
};
function AmountChip(_ref) {
  let {
    type,
    amount
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(transactions_module.amount, typeToClassMap[type]),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()({
        [typography_module/* default */.Z.captionAccent]: isMobile,
        [typography_module/* default */.Z.body2Accent]: !isMobile
      }),
      children: amount
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/referral-resources-list/utils.ts

































const formatDate = (dateString, locale) => {
  const date = new Date(dateString);
  return (0,format/* format */.WU)(date, "d MMMM, HH:mm", {
    locale
  });
};
const friendsCount = resourcesHistory => {
  const referralsSet = new Set(resourcesHistory.map(resource => resource.payload.referralId).filter(Boolean));
  return referralsSet.size;
};
const lessonsReceived = resourcesHistory => resourcesHistory.reduce((acc, item) => acc + (item.amount || 0), 0);
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/referral-resources-list/referral-resources-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const referral_resources_list_module = ({"title":"referral-resources-list-module__title--tRjBC","cards":"referral-resources-list-module__cards--VQIz6","card":"referral-resources-list-module__card--S4jUc","description":"referral-resources-list-module__description--HJRM0","table":"referral-resources-list-module__table--Pjc1y","table-body":"referral-resources-list-module__table-body--V6wBa","tableBody":"referral-resources-list-module__table-body--V6wBa","heading-row":"referral-resources-list-module__heading-row--JgbRf","headingRow":"referral-resources-list-module__heading-row--JgbRf","head-cell":"referral-resources-list-module__head-cell--wMIW4","headCell":"referral-resources-list-module__head-cell--wMIW4","row":"referral-resources-list-module__row--JkWeb","first-cell":"referral-resources-list-module__first-cell--WgT4K","firstCell":"referral-resources-list-module__first-cell--WgT4K","middle-cell":"referral-resources-list-module__middle-cell--KQEwv","middleCell":"referral-resources-list-module__middle-cell--KQEwv","last-cell":"referral-resources-list-module__last-cell--t0JTt","lastCell":"referral-resources-list-module__last-cell--t0JTt"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/referral-resources-list/referral-resources-list.tsx













const ReferralResourcesList = _ref => {
  let {
    resourcesHistory
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const locale = (0,utils_locale/* getDateFnsLocale */.G)(intl.locale);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(referral_resources_list_module.title, typography_module/* default */.Z.headline4Accent),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "referralProgramPage.invites.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: referral_resources_list_module.cards,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: referral_resources_list_module.card,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.headline4Accent,
          children: friendsCount(resourcesHistory)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(referral_resources_list_module.description, isMobile ? typography_module/* default */.Z.caption : typography_module/* default */.Z.body2),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "referralProgramPage.invites.friendsCount"
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: referral_resources_list_module.card,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.headline4Accent,
          children: lessonsReceived(resourcesHistory)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(referral_resources_list_module.description, isMobile ? typography_module/* default */.Z.caption : typography_module/* default */.Z.body2),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "referralProgramPage.invites.lessonsReceived"
          })
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("table", {
      className: referral_resources_list_module.table,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("thead", {
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
          className: referral_resources_list_module.headingRow,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("th", {
            className: classnames_default()(referral_resources_list_module.firstCell, referral_resources_list_module.headCell, typography_module/* default */.Z.body2),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "referralProgramPage.invites.dateColumnTitle"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("th", {
            className: classnames_default()(referral_resources_list_module.middleCell, referral_resources_list_module.headCell, typography_module/* default */.Z.body2),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "referralProgramPage.invites.typeColumnTitle"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("th", {
            className: referral_resources_list_module.lastCell
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("th", {})]
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("tbody", {
        className: referral_resources_list_module.tableBody,
        children: resourcesHistory.map(_ref2 => {
          let {
            id,
            createdAt,
            amount
          } = _ref2;
          return /* @__PURE__ */(0,jsx_runtime.jsx)("tr", {
            className: referral_resources_list_module.row,
            children: isMobile ? /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("td", {
                className: referral_resources_list_module.firstCell,
                children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                  className: typography_module/* default */.Z.captionAccent,
                  children: formatDate(createdAt, locale)
                }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                  className: typography_module/* default */.Z.caption,
                  children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "referralProgramPage.invites.type"
                  })
                })]
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
                className: referral_resources_list_module.lastCell,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(AmountChip, {
                  amount: `+${amount}`,
                  type: "add"
                })
              })]
            }) : /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
                className: referral_resources_list_module.firstCell,
                children: formatDate(createdAt, locale)
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
                className: referral_resources_list_module.middleCell,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                  id: "referralProgramPage.invites.type"
                })
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
                className: referral_resources_list_module.lastCell,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(AmountChip, {
                  amount: `+${amount}`,
                  type: "add"
                })
              })]
            })
          }, id);
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/referral-resources-history.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const referral_resources_history_module = ({"loader-wrapper":"referral-resources-history-module__loader-wrapper--UIlC9","loaderWrapper":"referral-resources-history-module__loader-wrapper--UIlC9"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/referral-resources-history/referral-resources-history.tsx









const ReferralResourcesHistory = () => {
  const [referralHistory, setReferralHistory] = (0,react.useState)();
  (0,react.useEffect)(() => {
    void getReferralResourcesHistory().then(response => setReferralHistory(response));
  }, []);
  if (referralHistory === void 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: referral_resources_history_module.loaderWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    });
  }
  return referralHistory.data.history.length ? /* @__PURE__ */(0,jsx_runtime.jsx)(ReferralResourcesList, {
    resourcesHistory: referralHistory.data.history
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyList, {});
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/steps/steps.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const steps_module = ({"wrapper":"steps-module__wrapper--hokRg","step":"steps-module__step--I9Jpl","marker":"steps-module__marker--ECdck"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/components/steps/steps.tsx








const Steps = _ref => {
  let {
    steps
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: steps_module.wrapper,
    children: steps.map((step, index) => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(steps_module.step, typography_module/* default */.Z.body2),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2Accent,
        children: `${index + 1}.`
      }), step]
    }, step))
  });
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/referral-program-page-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const referral_program_page_content_module = ({"wrapper":"referral-program-page-content-module__wrapper--cUinE","back-button":"referral-program-page-content-module__back-button--GYywZ","backButton":"referral-program-page-content-module__back-button--GYywZ","content":"referral-program-page-content-module__content--cgHQs","title":"referral-program-page-content-module__title--A2yvi","sharing-block":"referral-program-page-content-module__sharing-block--U0wCQ","sharingBlock":"referral-program-page-content-module__sharing-block--U0wCQ","terms":"referral-program-page-content-module__terms--FIRzZ"});
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page-content/referral-program-page-content.tsx




















const ReferralProgramPageContent = () => {
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const [data, setData] = (0,react.useState)();
  const {
    referral
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    referralTerms: referralProgramTermsUrl,
    mainLanding: mainLandingUrl
  } = (0,domain_urls/* getExternalUrls */.Sj)();
  const userInfo = (0,useUser/* useUser */.aF)();
  const userId = userInfo.data?.me.user?.id;
  (0,react.useEffect)(() => {
    void (0,bunker_api/* getReferralProgramContent */.gm)().then(response => setData(response));
  }, []);
  const referralLink = mainLandingUrl ? `${mainLandingUrl}?referral_program=${referral.tariff_slug}&referer_id=${userId}` : void 0;
  const {
    pageTitle,
    steps,
    sharingMessage
  } = data && referral.tariff_slug in data ? data[referral.tariff_slug] : {
    pageTitle: void 0,
    steps: void 0,
    sharingMessage: void 0
  };
  if (!data) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: referral_program_page_content_module.wrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: referral_program_page_content_module.backButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(GoBackButton, {
        onClick: history.goBack,
        text: intl.formatMessage({
          id: "backButton"
        }),
        withMarginBottom: false
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: referral_program_page_content_module.content,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(isMobile ? typography_module/* default */.Z.headline4Accent : typography_module/* default */.Z.headline3, referral_program_page_content_module.title),
        children: pageTitle
      }), steps && /* @__PURE__ */(0,jsx_runtime.jsx)(Steps, {
        steps
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: referral_program_page_content_module.sharingBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(CopyButton, {
          content: referralLink
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(SharingButtons, {
          message: sharingMessage,
          link: referralLink
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          className: classnames_default()(isMobile ? typography_module/* default */.Z.caption : typography_module/* default */.Z.body2, referral_program_page_content_module.terms),
          children: intl.formatMessage({
            id: "referralProgramPage.terms"
          }, {
            referralProgramTermsUrl
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ReferralResourcesHistory, {})]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/referral-program-page/referral-program-page.tsx






const ReferralProgramPage = () => /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
  self: {
    bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
    doNotWrapChildrenWithLayout: true,
    contentPosition: app_page_wrapper_types/* ContentPosition */.E.Center
  },
  header: {
    hideReferralProgramElements: false
  },
  main: {
    hideGrammarGuideButton: true
  },
  footer: {
    hideFooter: true
  },
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(ReferralProgramPageContent, {})
});
;// CONCATENATED MODULE: ./src/utils/url/redirect-with-params.tsx





const RedirectWithParams = _ref => {
  let {
    to,
    withRetPath = false
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const queryParams = query_string.parse(history.location.search);
  if (withRetPath) {
    const pathName = history.location.pathname;
    if (!["/", "/student"].includes(pathName)) {
      queryParams.retPath = pathName;
    }
  }
  const urlWithParams = `${to}?${query_string.stringify(queryParams)}`;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
    to: urlWithParams
  });
};
;// CONCATENATED MODULE: ./src/components/trainer/renderers/product-trainer-renderer/types.ts


var ProductRevisionTrainerUserRole = /* @__PURE__ */(ProductRevisionTrainerUserRole2 => {
  ProductRevisionTrainerUserRole2[ProductRevisionTrainerUserRole2["Student"] = 0] = "Student";
  ProductRevisionTrainerUserRole2[ProductRevisionTrainerUserRole2["Tutor"] = 1] = "Tutor";
  ProductRevisionTrainerUserRole2[ProductRevisionTrainerUserRole2["Methodologist"] = 2] = "Methodologist";
  return ProductRevisionTrainerUserRole2;
})(ProductRevisionTrainerUserRole || {});
// EXTERNAL MODULE: ../ui-kit/src/layout/layout.component.tsx + 1 modules
var layout_component = __webpack_require__(53584);
;// CONCATENATED MODULE: ./src/pages/methodologist-index/methodologist-index.page.tsx







const MethodologistIndex = () => /* @__PURE__ */(0,jsx_runtime.jsxs)(layout_component/* Layout */.A, {
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    children: "\u041F\u0440\u0438\u0432\u0435\u0442 \u041C\u0435\u0442\u043E\u0434\u0438\u0441\u0442!"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    children: "\u0422\u044B \u043C\u043E\u0436\u0435\u0448\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u043E\u043C \u0434\u043B\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0440\u043E\u043B\u0435\u0439"
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
      to: studentRoutePaths/* studentRoutePaths */.dR.INDEX,
      children: "\u0421\u0442\u0443\u0434\u0435\u043D\u0442"
    })
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("a", {
      href: (0,site_utils/* getTutorPath */.lz)(),
      children: "\u0422\u044C\u044E\u0442\u043E\u0440"
    })
  })]
});
// EXTERNAL MODULE: ../shared/src/errors/models/not-found-object-error.ts
var not_found_object_error = __webpack_require__(71134);
// EXTERNAL MODULE: ./src/components/class/platform/errors/class-error-boundary.tsx + 4 modules
var class_error_boundary = __webpack_require__(63960);
// EXTERNAL MODULE: ./src/api/speaking-session/hooks.tsx
var hooks = __webpack_require__(77525);
// EXTERNAL MODULE: ./src/api/speaking-session/speaking-session.api.ts + 2 modules
var speaking_session_api = __webpack_require__(83331);
;// CONCATENATED MODULE: ./src/pages/speaking-page/hooks/use-speaking-page.ts





function useSpeakingPage(speakingSessionId, fetchSpeakingSessionProp) {
  const fetchSpeakingSession = (0,react.useCallback)(() => {
    if (fetchSpeakingSessionProp) {
      return fetchSpeakingSessionProp();
    }
    return (0,speaking_session_api/* getSpeakingSession */.z)(speakingSessionId);
  }, [speakingSessionId, fetchSpeakingSessionProp]);
  const {
    data: experiments,
    error: experimentsError,
    isLoading: experimentsIsLoading
  } = (0,hooks/* useSpeakingSessionExperimentsQuery */.y)({
    speakingSessionId
  });
  const {
    data: speakingSession,
    error: speakingSessionError,
    isLoading: speakingSessionIsLoading
  } = (0,hooks/* useSpeakingSessionQuery */.M)({
    speakingSessionId,
    fetchSpeakingSession
  });
  if (speakingSessionError || experimentsError) {
    throw speakingSessionError ?? experimentsError;
  }
  return {
    experiments,
    speakingSession,
    loading: experimentsIsLoading || speakingSessionIsLoading
  };
}
;// CONCATENATED MODULE: ./src/pages/speaking-page/speaking-page.tsx










const TaskGuideClassLazy = (0,react.lazy)(() => Promise.all(/* import() | task-guide-class */[__webpack_require__.e(337), __webpack_require__.e(300), __webpack_require__.e(526), __webpack_require__.e(773)]).then(__webpack_require__.bind(__webpack_require__, 84750)));
const TrainerClassLazy = (0,react.lazy)(() => Promise.all(/* import() | trainer-class */[__webpack_require__.e(337), __webpack_require__.e(885), __webpack_require__.e(300), __webpack_require__.e(809), __webpack_require__.e(526), __webpack_require__.e(449)]).then(__webpack_require__.bind(__webpack_require__, 10351)));
const SpeakingPage = (0,class_error_boundary/* withClassErrorBoundary */.P)(_ref => {
  let {
    classUserRole,
    fetchSpeakingSession,
    speakingSessionId
  } = _ref;
  const user = (0,useUser/* useUser */.aF)();
  const {
    experiments,
    speakingSession,
    loading
  } = useSpeakingPage(speakingSessionId, fetchSpeakingSession);
  const userId = user.data?.me.user?.id;
  const userAvatarId = user.data?.me.user?.avatar;
  if (userId === void 0) {
    throw new not_found_object_error/* NotFoundObjectError */.m("userId");
  }
  if (userAvatarId === void 0) {
    throw new not_found_object_error/* NotFoundObjectError */.m("userAvatarId");
  }
  if (loading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
  }
  const schedulingStrategy = speakingSession?.speaking.properties?.schedulingStrategy;
  if (!schedulingStrategy) {
    throw new not_found_object_error/* NotFoundObjectError */.m("schedulingStrategy");
  }
  if (!speakingSession) {
    return null;
  }
  const props = {
    userId,
    userAvatarId,
    speakingSession,
    userRole: classUserRole,
    webrtcProvider: experiments && (0,Either.isRight)(experiments) ? experiments.right.webrtc_provider : void 0
  };
  if (schedulingStrategy === "upcoming") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {}),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideClassLazy, {
        ...props
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {}),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerClassLazy, {
      ...props
    })
  });
});
;// CONCATENATED MODULE: ./src/pages/methodologist-speaking/speaking-methodologist.page.tsx





const MethodologistSpeakingPage = () => {
  const {
    speakingSessionId
  } = (0,react_router/* useParams */.UO)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingPage, {
    speakingSessionId,
    classUserRole: "spectator"
  });
};
// EXTERNAL MODULE: ../shared/src/models/trainer/trainer.model.ts
var trainer_model = __webpack_require__(97703);
// EXTERNAL MODULE: ./src/api/student/revision/revision.api.ts + 1 modules
var revision_api = __webpack_require__(19857);
// EXTERNAL MODULE: ./src/components/trainer/renderers/one-block-renderer/types.ts
var types = __webpack_require__(56533);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../../node_modules/@xstate/react/es/useMachine.js + 1 modules
var useMachine = __webpack_require__(95640);
// EXTERNAL MODULE: ../../node_modules/immutable/dist/immutable.es.js
var immutable_es = __webpack_require__(27623);
// EXTERNAL MODULE: ./src/api/student/speaking/speaking.api.ts + 2 modules
var speaking_api = __webpack_require__(93096);
;// CONCATENATED MODULE: ./src/hooks/useSentryExtra.ts




const useSentryContext = (key, value) => {
  (0,react.useEffect)(() => {
    logger/* Logger */.Yd.setExtra(key, value);
    return () => {
      logger/* Logger */.Yd.clearExtra(key);
    };
  }, [key, value]);
};
// EXTERNAL MODULE: ./src/hooks/useTrainerHandlers.ts
var useTrainerHandlers = __webpack_require__(64200);
// EXTERNAL MODULE: ./src/state-machine/mechanic/trainer/create-trainer-mechanic-machine.ts + 1 modules
var create_trainer_mechanic_machine = __webpack_require__(18570);
// EXTERNAL MODULE: ./src/state-machine/trainer/create-trainer-machine.ts + 4 modules
var create_trainer_machine = __webpack_require__(53828);
// EXTERNAL MODULE: ./src/state-machine/trainer/product/product-trainer.machine.ts
var product_trainer_machine = __webpack_require__(48819);
// EXTERNAL MODULE: ./src/store/student-test/student-test-store.ts
var student_test_store = __webpack_require__(33870);
// EXTERNAL MODULE: ./src/utils/preload-images-activity.ts
var preload_images_activity = __webpack_require__(49396);
// EXTERNAL MODULE: ./src/utils/trainer/activity.ts
var activity = __webpack_require__(18884);
// EXTERNAL MODULE: ./src/components/class/task-guide/student-test-result/student-test-result.tsx + 7 modules
var student_test_result = __webpack_require__(92662);
// EXTERNAL MODULE: ./src/components/close-trainer-button/close-trainer-button.component.tsx + 1 modules
var close_trainer_button_component = __webpack_require__(68570);
;// CONCATENATED MODULE: ./src/components/progress-bar/progress-bar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const progress_bar_module = ({"progress-bar":"progress-bar-module__progress-bar--o_5YA","progressBar":"progress-bar-module__progress-bar--o_5YA"});
;// CONCATENATED MODULE: ./src/components/progress-bar/progress-bar.component.tsx




const ProgressBar = _ref => {
  let {
    progress
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    style: {
      transform: `scaleX(${progress / 100})`
    },
    className: progress_bar_module.progressBar
  });
};
// EXTERNAL MODULE: ./src/components/trainer-layout/trainer-layout.component.tsx + 7 modules
var trainer_layout_component = __webpack_require__(84747);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.to-reversed.js
var es_array_to_reversed = __webpack_require__(64000);
// EXTERNAL MODULE: ../../node_modules/date-fns/addSeconds.mjs
var addSeconds = __webpack_require__(36937);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfToday.mjs
var startOfToday = __webpack_require__(12303);
// EXTERNAL MODULE: ../../node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(37164);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../ui-kit/src/partial-circle/partial-circle.component.tsx



const svgStyle = {
  transform: "rotate(-90deg)"
};
const PartialCircle = _ref => {
  let {
    part,
    size,
    strokeWidth = 2
  } = _ref;
  const halfSize = size / 2;
  const strokeDasharray = `${part * Math.PI * size} ${Math.PI * size}`;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("svg", {
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`,
    style: svgStyle,
    children: part !== 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("circle", {
      r: halfSize - 1,
      cx: halfSize,
      cy: halfSize,
      fill: "none",
      stroke: "currentColor",
      strokeWidth,
      strokeLinecap: "round",
      strokeDasharray
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/side-menu/side-menu.component.tsx + 1 modules
var side_menu_component = __webpack_require__(23725);
;// CONCATENATED MODULE: ../ui-kit/src/table-of-content/table-of-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const table_of_content_module = ({"items-list":"table-of-content-module__items-list--bM_Oa","itemsList":"table-of-content-module__items-list--bM_Oa","list-item":"table-of-content-module__list-item--Jt2Zg","listItem":"table-of-content-module__list-item--Jt2Zg","list-item-link":"table-of-content-module__list-item-link--_SrIJ","listItemLink":"table-of-content-module__list-item-link--_SrIJ","circle-container":"table-of-content-module__circle-container--ob6X1","circleContainer":"table-of-content-module__circle-container--ob6X1","circle":"table-of-content-module__circle--Y_chq","circle-dark":"table-of-content-module__circle-dark--W4tDQ","circleDark":"table-of-content-module__circle-dark--W4tDQ","list-item-left-part":"table-of-content-module__list-item-left-part--roYBW","listItemLeftPart":"table-of-content-module__list-item-left-part--roYBW","list-item-text":"table-of-content-module__list-item-text--Ggr0p","listItemText":"table-of-content-module__list-item-text--Ggr0p","list-item-link-disabled":"table-of-content-module__list-item-link-disabled--K6mB2","listItemLinkDisabled":"table-of-content-module__list-item-link-disabled--K6mB2","progress-circle-container":"table-of-content-module__progress-circle-container--IGbOq","progressCircleContainer":"table-of-content-module__progress-circle-container--IGbOq"});
;// CONCATENATED MODULE: ../ui-kit/src/table-of-content/table-of-content.component.tsx













var table_of_content_component_State = /* @__PURE__ */(State2 => {
  State2["InProgress"] = "inProgress";
  State2["Finish"] = "finish";
  State2["NotStarted"] = "notStarted";
  return State2;
})(table_of_content_component_State || {});
const InProgressIcon = _ref => {
  let {
    progress
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: table_of_content_module.circleContainer,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(table_of_content_module.circle, table_of_content_module.circleDark)
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: table_of_content_module.progressCircleContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(PartialCircle, {
        strokeWidth: 1,
        part: progress,
        size: 16
      })
    })]
  });
};
const NotStartedIcon = () => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
  className: table_of_content_module.circleContainer,
  children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: table_of_content_module.circle
  })
});
const FinishIcon = () => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "checkmark",
    size: "small"
  })
});
const TableOfContent = _ref2 => {
  let {
    title,
    items,
    onClose,
    isMobile
  } = _ref2;
  const renderItemIcon = (0,react.useCallback)(item => {
    const {
      state
    } = item;
    switch (state) {
      case "notStarted" /* NotStarted */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(NotStartedIcon, {});
      case "inProgress" /* InProgress */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(InProgressIcon, {
          progress: item.progress
        });
      case "finish" /* Finish */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(FinishIcon, {});
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(state);
    }
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(side_menu_component/* SideMenu */.f, {
    title,
    onClose,
    isMobile,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: table_of_content_module.itemsList,
      children: items.map(i => {
        const disabled = i.state === "notStarted" /* NotStarted */;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
          className: table_of_content_module.listItem,
          children: /* @__PURE__ */(0,jsx_runtime.jsxs)("a", {
            href: disabled ? void 0 : i.href,
            className: classnames_default()(table_of_content_module.listItemLink, {
              [table_of_content_module.listItemLinkDisabled]: disabled
            }),
            children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: table_of_content_module.listItemLeftPart,
              children: [renderItemIcon(i), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: classnames_default()(table_of_content_module.listItemText, {
                  [typography_module/* default */.Z.body2Accent]: i.selected
                }),
                children: i.value
              })]
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              children: i.time
            })]
          })
        }, i.id);
      })
    })
  });
};
// EXTERNAL MODULE: ./src/utils/cleanFromMarkdown.tsx
var cleanFromMarkdown = __webpack_require__(4527);
;// CONCATENATED MODULE: ./src/components/trainer-table-of-content/trainer-table-of-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const trainer_table_of_content_module = ({"root":"trainer-table-of-content-module__root--YRp0c","toggle-button":"trainer-table-of-content-module__toggle-button--muGKU","toggleButton":"trainer-table-of-content-module__toggle-button--muGKU"});
;// CONCATENATED MODULE: ./src/components/trainer-table-of-content/trainer-table-of-content.component.tsx




























const MENU_QUERY_VARIABLE = "tocMenuOpen";
const TrainerTableOfContent = _ref => {
  let {
    activities,
    getTrainerLink,
    title,
    studentEvents,
    currentActivityId
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    productTrainerRepetitionExperimentIsActive
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    isMobile,
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const getItemValue = (0,react.useCallback)(activity => {
    const firstBlock = activity.blocks[0];
    const mapActivityTypeToTankerId = type => {
      switch (type) {
        case "story":
          return "trainerTableOfContent.story";
        case "lexis":
          return "trainerTableOfContent.lexis";
        case "grammar":
          return "trainerTableOfContent.grammar";
        default:
          {
            logger/* Logger */.Yd.captureException(`Unknown activity type in table of content: ${type}`);
            return "trainerTableOfContent.unknown";
          }
      }
    };
    switch (firstBlock.type) {
      case "grammar-intro":
      case "chapter-intro":
      case "intro":
      case "story-intro":
        return firstBlock.title ? (0,cleanFromMarkdown/* cleanFromMarkdown */.s)(firstBlock.title) : intl.formatMessage({
          id: mapActivityTypeToTankerId(activity.type)
        });
      default:
        return intl.formatMessage({
          id: mapActivityTypeToTankerId(activity.type)
        });
    }
  }, [intl]);
  const getTimeSpendForActivity = (0,react.useCallback)(activity => {
    const ONE_BLOCK_SPENDING_TIME_IN_SEC = Number(intl.formatMessage({
      id: "tableOfContent.ONE_BLOCK_SPENDING_TIME_IN_SEC",
      defaultMessage: "15"
    }));
    const secondsSpent = activity.blocks.length * ONE_BLOCK_SPENDING_TIME_IN_SEC;
    return (0,format/* format */.WU)((0,addSeconds/* addSeconds */.v)((0,startOfToday/* startOfToday */.I)(), secondsSpent), "m");
  }, [intl]);
  const getLocationWithMenuState = (0,react.useCallback)(open => {
    const query = new URLSearchParams(history.location.search);
    query.set(MENU_QUERY_VARIABLE, open ? "1" : "0");
    return {
      pathname: history.location.pathname,
      search: query.toString()
    };
  }, [history.location.pathname, history.location.search]);
  const tableOfContentItems = (0,react.useMemo)(() => activities.filter(a => a.blocks.length !== 0).map(a => {
    const firstBlock = a.blocks[0];
    const activityStudentEvents = studentEvents[a?.activity_id];
    const {
      search
    } = getLocationWithMenuState(isDesktop);
    const href = `${getTrainerLink(a?.activity_id)}?${search}`;
    if (!activityStudentEvents || activityStudentEvents.length === 0) {
      return {
        id: firstBlock.id ?? (0,index_browser/* nanoid */.x0)(),
        value: getItemValue(a),
        state: table_of_content_component_State.NotStarted,
        selected: a?.activity_id === currentActivityId,
        time: intl.formatMessage({
          // eslint-disable-next-line sonarjs/no-duplicate-string
          id: "trainerTableOfContent.timeSpent",
          defaultMessage: `${getTimeSpendForActivity(a)} min`
        }, {
          count: getTimeSpendForActivity(a)
        }),
        href
      };
    }
    const lastActivityBlockId = a.blocks[a.blocks.length - 1].id;
    if (lastActivityBlockId && activityStudentEvents.includes(lastActivityBlockId)) {
      return {
        id: firstBlock.id ?? (0,index_browser/* nanoid */.x0)(),
        value: getItemValue(a),
        state: table_of_content_component_State.Finish,
        selected: a?.activity_id === currentActivityId,
        time: intl.formatMessage({
          id: "trainerTableOfContent.timeSpent",
          defaultMessage: `${getTimeSpendForActivity(a)} min`
        }, {
          count: getTimeSpendForActivity(a)
        }),
        href
      };
    }
    const lastFinishedBlock = a.blocks.toReversed().find(b => {
      if (!b.id) {
        return false;
      }
      return activityStudentEvents.includes(b.id);
    });
    const lastFinishedBlockIndex = a.blocks.findIndex(b => b.id === lastFinishedBlock?.id);
    const progress = lastFinishedBlockIndex === -1 ? 0 : Number(Number(lastFinishedBlockIndex / a.blocks.length).toFixed(1));
    return {
      id: firstBlock.id ?? (0,index_browser/* nanoid */.x0)(),
      value: getItemValue(a),
      state: table_of_content_component_State.InProgress,
      progress,
      selected: a?.activity_id === currentActivityId,
      time: intl.formatMessage({
        id: "trainerTableOfContent.timeSpent",
        defaultMessage: `${getTimeSpendForActivity(a)} min`
      }, {
        count: getTimeSpendForActivity(a)
      }),
      href
    };
  }), [activities, currentActivityId, getItemValue, getLocationWithMenuState, getTimeSpendForActivity, getTrainerLink, intl, isDesktop, studentEvents]);
  const isVisible = (0,react.useMemo)(() => {
    const params = new URLSearchParams(history.location.search);
    return params.get(MENU_QUERY_VARIABLE) === "1";
  }, [history.location.search]);
  const setVisible = (0,react.useCallback)(value => {
    history.push(getLocationWithMenuState(value));
  }, [getLocationWithMenuState, history]);
  (0,react.useEffect)(() => {
    if (isVisible && isMobile) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isVisible, isMobile]);
  if (!productTrainerRepetitionExperimentIsActive) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: trainer_table_of_content_module.root,
    children: [(0,react_dom.createPortal)( /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: trainer_table_of_content_module.toggleButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "default",
        size: "medium",
        iconName: "burger-menu",
        onClick: () => setVisible(!isVisible)
      })
    }), document.body), isVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(TableOfContent, {
      isMobile,
      onClose: () => setVisible(false),
      title,
      items: tableOfContentItems
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/unknown-state-error-sender/unknown-state-error-sender.component.tsx




const UnknownStateErrorSender = _ref => {
  let {
    place,
    state
  } = _ref;
  (0,react.useEffect)(() => {
    logger/* Logger */.Yd.captureError(`UnknownState in ${place}: ${state} `);
  }, [place, state]);
  return null;
};
// EXTERNAL MODULE: ./src/components/trainer/blocks/mechanic-block/mechanic-block.models.tsx
var mechanic_block_models = __webpack_require__(67059);
// EXTERNAL MODULE: ./src/components/trainer/renderers/block-renderer/block-renderer.tsx + 251 modules
var block_renderer = __webpack_require__(74600);
// EXTERNAL MODULE: ./src/components/trainer/renderers/product-trainer-renderer/product-trainer-renderer.context.ts
var product_trainer_renderer_context = __webpack_require__(72360);
;// CONCATENATED MODULE: ./src/components/trainer/renderers/product-trainer-renderer/product-trainer-renderer.tsx












































const ProductTrainerRenderer = _ref => {
  let {
    chapterFetcher,
    mechanicBlockAlign = mechanic_block_models/* MechanicBlockAlign */.H.Center,
    onSaveProgress = function_utils/* emptyPromiseFunction */._,
    onSaveAnswer = function_utils/* emptyPromiseFunction */._,
    onInitialProgress = function_utils/* emptyPromiseFunction */._,
    onFinish = function_utils/* emptyPromiseFunction */._,
    productId,
    chapterId,
    activityId,
    eventType,
    trackConversionMetrics = false,
    onOpenActivity = function_utils/* emptyFunction */.Bi,
    userEnvironment = types/* UserEnvironment */.P.Student,
    trainerEnvironment,
    withTaskGuide = false
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    showSkipButtonInTrainer,
    disableTrainerOutroActions
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const history = (0,react_router/* useHistory */.k6)();
  const [contextValue] = (0,react.useState)({
    mechanicBlockAlign,
    trainerEnvironment,
    withTaskGuide,
    drawing: (0,features/* useFeatureFlag */.ye)("classImageDrawingEnabled")
  });
  const containerRef = (0,react.useRef)(null);
  const stateMachine = (0,react.useMemo)(
  // eslint-disable-next-line sonarjs/cognitive-complexity
  () => product_trainer_machine/* productTrainerMachine */.Ne.withContext({
    filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)(eventType.answer),
    eventType,
    chapterId,
    title: "",
    productId,
    activities: [],
    settings: {},
    currentBlocks: [],
    chapterStudentEvents: {},
    progress: 0,
    activityIndex: 0,
    blockIndex: 0,
    intl,
    mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
    scrollToBlockIndex: 0,
    isTrialChapter: false,
    completeBlocksIdSet: immutable_es/* default.Set */.ZP.Set(),
    disableGeneratedOutroActions: disableTrainerOutroActions,
    trackConversionMetrics
  }).withConfig({
    actions: {
      pushActivityIdInUrl: context => {
        const currentActivity2 = context.activities[context.activityIndex];
        if (currentActivity2) {
          onOpenActivity(currentActivity2?.activity_id);
        }
      },
      sendInitialEvent: context => {
        if (!eventType) {
          return;
        }
        if (!context.lastEvent) {
          void onInitialProgress({
            block_id: context.currentBlocks[context.blockIndex].id ?? null,
            activity_id: context.activities[context.activityIndex]?.activity_id,
            chapter_id: context.chapterId,
            product_id: context.productId,
            event_type: eventType.init
          });
        }
      },
      sendFinalEventIfNeed: context => {
        if (!(0,product_trainer_machine/* isUserFinishChapterFirstTimeGuard */.vn)(context)) {
          return context;
        }
        if (!eventType) {
          return {
            isFinalEventExist: true
          };
        }
        void onFinish({
          block_id: context.currentBlocks[context.blockIndex].id ?? null,
          activity_id: context.activities[context.activityIndex]?.activity_id,
          product_id: context.productId,
          chapter_id: context.chapterId,
          event_type: eventType.finish
        });
        return {
          isFinalEventExist: true
        };
      }
    },
    services: {
      loadChapterData: context => chapterFetcher(context.productId, context.chapterId),
      saveProgress: context => {
        if (!eventType) {
          return (0,function_utils/* emptyPromiseFunction */._)();
        }
        return onSaveProgress({
          product_id: context.productId,
          chapter_id: context.chapterId,
          activity_id: context.activities[context.activityIndex]?.activity_id ?? null,
          block_id: context.currentBlocks[context.blockIndex]?.id ?? null,
          payload: {
            progress: context.progress
          },
          event_type: eventType.progress
        });
      },
      saveAnswer: (context, event) => {
        if (!eventType) {
          return (0,function_utils/* emptyPromiseFunction */._)();
        }
        const blockId = (0,product_trainer_machine/* isEventWithAnswer */.eY)(event) ? event.data.blockId : context.currentBlocks[context.blockIndex].id || "";
        const currentBlockEvents = context.chapterStudentEvents[blockId];
        if (!currentBlockEvents) {
          return (0,function_utils/* emptyPromiseFunction */._)();
        }
        const answerEvents = currentBlockEvents.filter(e => e.event_type === eventType.answer);
        const lastEvent = answerEvents[answerEvents.length - 1];
        const answer = lastEvent?.data?.answer;
        const correct = lastEvent?.data?.correct;
        const typo = lastEvent?.data?.typo;
        const maxPossibleScore = lastEvent?.data?.maxPossibleScore;
        const rightAnswersScore = lastEvent?.data?.rightAnswersScore;
        const skill = lastEvent?.data?.skill;
        const optionDescription = lastEvent?.data?.optionDescription;
        return onSaveAnswer({
          product_id: context.productId,
          chapter_id: context.chapterId,
          activity_id: context.activities[context.activityIndex]?.activity_id ?? null,
          block_id: blockId,
          payload: {
            progress: context.progress,
            answer,
            correct,
            typo,
            maxPossibleScore,
            rightAnswersScore,
            optionDescription,
            skill
          },
          event_type: eventType.answer
        });
      }
    }
  }), [chapterFetcher, chapterId, disableTrainerOutroActions, eventType, intl, onFinish, onInitialProgress, onOpenActivity, onSaveAnswer, onSaveProgress, productId, trackConversionMetrics]);
  const [state, send] = (0,useMachine/* useMachine */.e)(stateMachine);
  const {
    activities,
    settings,
    activityIndex,
    currentBlocks: visibleBlocks,
    chapterStudentEvents,
    title
  } = state.context;
  const showSkipButton = showSkipButtonInTrainer || Boolean(settings?.showSkipButton) || [types/* UserEnvironment */.P.Methodologist, types/* UserEnvironment */.P.Tutor].includes(userEnvironment);
  const studentEventsGroupedByActivityId = (0,react.useMemo)(() => {
    const blockIds = Object.keys(chapterStudentEvents);
    return blockIds.reduce((acc, blockId) => {
      const firstBlockEvent = chapterStudentEvents[blockId][0];
      if (blockId in acc) {
        acc[firstBlockEvent?.activity_id].push(blockId);
      } else {
        acc[firstBlockEvent?.activity_id] = [blockId];
      }
      return acc;
    }, {});
  }, [chapterStudentEvents]);
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const currentActivityId = (0,react.useMemo)(() => currentActivity ? currentActivity.activity_id : null, [currentActivity]);
  const handleCloseTrainer = (0,react.useCallback)(() => {
    get_url_search_params.getUrlSearchParams.retPath.haveRetPath(history) ? get_url_search_params.getUrlSearchParams.retPath.goToRetPath(history) : history.push(baseRoutePaths/* baseRoutePaths */.lQ.INDEX);
  }, [history]);
  const handleOutroActions = (0,react.useCallback)(a => {
    switch (a.type) {
      case "SCHEDULE_SPEAKING":
        {
          return (0,speaking_api/* getChapterSpeakingId */.KN)(state.context.chapterId).then(speakingId => {
            history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
            history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(speakingId || "", history));
          });
        }
      case "SCHEDULE_MENTOR":
        {
          return (0,speaking_api/* getMentorSpeakingId */.Ao)().then(speakingId => {
            if (speakingId) {
              history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
              history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(speakingId, history));
            }
          });
        }
      case "ON_MAIN_PAGE":
        return handleCloseTrainer();
      case "NEXT_BLOCK":
        return send(product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED);
      case "OPEN_LINK":
        window.open((0,domain.kz)(a.link), "_blank");
        break;
      default:
        return;
    }
  }, [handleCloseTrainer, history, send, state.context.chapterId]);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    const blockEvents = state.context.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === eventType.answer) ?? [];
    const answerJSONString = answerEvent[answerEvent.length - 1]?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [eventType, state.context.chapterStudentEvents]);
  const {
    handleNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick,
    handleResetAnswer,
    handleSubmitAnswer,
    handleNextActivityClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  useSentryContext("chapterId", JSON.stringify(state.context.chapterId));
  useSentryContext("productId", JSON.stringify(state.context.productId));
  useSentryContext("lastEvent", JSON.stringify(state.context.lastEvent));
  (0,react.useEffect)(() => {
    if (activityId && activities.length !== 0) {
      send(product_trainer_machine/* EVENTS */.FP.SET_CURRENT_ACTIVITY, {
        data: {
          activityId
        }
      });
    }
  }, [activities.length, activityId, send]);
  (0,react.useEffect)(() => {
    if (chapterId) {
      send({
        type: product_trainer_machine/* EVENTS */.FP.UPDATE_CHAPTER_STATE,
        chapterId,
        productId
      });
    }
  }, [chapterId, productId, send]);
  const selectedTestResult = (0,student_test_store/* useStudentTestStore */.C)(state2 => state2.selectedTestResult);
  if (selectedTestResult) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(student_test_result/* StudentTestResult */.r, {
      ...selectedTestResult
    });
  }
  switch (state.value) {
    case product_trainer_machine/* STATES */.PO.ERROR:
      {
        if (state.context.error === product_trainer_machine/* ProductTrainerMachineErrors */.iR.NotFound) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownErrorPage, {});
      }
    case product_trainer_machine/* STATES */.PO.LOADING_CHAPTER_DATA:
      return null;
    case product_trainer_machine/* STATES */.PO.SAVING_ANSWER:
    case product_trainer_machine/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case product_trainer_machine/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(product_trainer_renderer_context/* ProductTrainerRendererContextComponent */.p.Provider, {
        value: contextValue,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          ref: containerRef,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
            disableHorizontalMargin: true,
            children: /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(TrainerTableOfContent, {
                activities,
                title,
                studentEvents: studentEventsGroupedByActivityId,
                currentActivityId: activityId,
                getTrainerLink: activityId2 => studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(productId, chapterId, activityId2)
              }), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
                containerRef,
                onResetAnswer: blockId => {
                  if (blockId && currentActivityId) {
                    handleResetAnswer(blockId, currentActivityId);
                  }
                },
                blocks: visibleBlocks,
                activityType: currentActivity?.type ?? "story",
                onSubmitAnswer: object => {
                  handleSubmitAnswer({
                    ...object,
                    activityId: currentActivityId
                  });
                },
                currentActivityIndex: state.context.activityIndex,
                blockIndex: state.context.blockIndex,
                onPrevActivityClick: handlePrevActivityClick,
                onNextActivityClick: handleNextActivityClick,
                onNextBlockClick: handleNextBlockClick,
                onPrevBlockClick: handlePrevBlockClick,
                mechanicMachineCreator: state.context.mechanicMachineCreator,
                onOutroActionTrigger: handleOutroActions,
                getBlockAnswerInfo,
                showPrevButton: false,
                showNextButton: true,
                showResetButton: true,
                showSkipButton,
                showSubmitButton: true,
                showAudioFooter: true,
                userEnvironment,
                showTutorInstructions: [types/* UserEnvironment */.P.Methodologist, types/* UserEnvironment */.P.Tutor].includes(userEnvironment),
                scrollToBlockIndex: state.context.scrollToBlockIndex,
                activityKey: {
                  productId,
                  chapterId,
                  activityId: currentActivityId ?? void 0
                },
                isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
              }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
                progress: state.context.progress
              })]
            })
          })
        })
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "product-trainer-renderer",
        state: state.value
      });
  }
};
;// CONCATENATED MODULE: ./src/pages/product-revision/product-revision.page.tsx











const productRevisionTrainerUserRoleToUserEnvironment = role => {
  switch (role) {
    case ProductRevisionTrainerUserRole.Student:
      return types/* UserEnvironment */.P.Student;
    case ProductRevisionTrainerUserRole.Tutor:
      return types/* UserEnvironment */.P.Tutor;
    case ProductRevisionTrainerUserRole.Methodologist:
      return types/* UserEnvironment */.P.Methodologist;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(role);
  }
};
const ProductRevisionPage = _ref => {
  let {
    userRole,
    withTaskGuide
  } = _ref;
  const {
    chapterId,
    productId,
    revisionType
  } = (0,react_router/* useParams */.UO)();
  const chapterFetcher = (0,react.useCallback)((pId, chId) => (0,revision_api/* getRevisionChapterState */.J)(chId, revisionType), [revisionType]);
  const eventType = (0,react.useMemo)(() => ({
    init: "revision_progress_init",
    answer: "revision_result",
    progress: "revision_progress",
    finish: "revision_progress_final"
  }), []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductTrainerRenderer, {
    productId,
    chapterId,
    chapterFetcher,
    userEnvironment: productRevisionTrainerUserRoleToUserEnvironment(userRole),
    trainerEnvironment: trainer_model/* TrainerEnvironment */.r$.Repetition,
    eventType,
    withTaskGuide
  });
};
;// CONCATENATED MODULE: ../shared/src/utils/makeTreeStringFromObject.js







function makePrefix(key) {
  let str = "\u251C";
  if (key) {
    str += "\u2500 ";
  } else {
    str += "\u2500\u2500\u2510";
  }
  return str;
}
function filterKeys(obj, hideFunctions) {
  const keys = [];
  for (let branch in obj) {
    if (!Object.hasOwn(obj, branch)) {
      continue;
    }
    if (hideFunctions && typeof obj[branch] === "function") {
      continue;
    }
    keys.push(branch);
  }
  return keys;
}
function growBranch(key, root, last, lastStates, showValues, hideFunctions, callback) {
  let line = "";
  let index = 0;
  let lastKey;
  let circular;
  let lastStatesCopy = lastStates.slice(0);
  if (lastStatesCopy.push([root, last]) && lastStates.length > 0) {
    lastStates.forEach(function (lastState, idx) {
      if (idx > 0) {
        line += "\u2502  ";
      }
      if (!circular && lastState[0] === root) {
        circular = true;
      }
    });
    line += makePrefix(key) + key;
    showValues && (typeof root !== "object" || root instanceof Date) && (line += ": " + root);
    circular && (line += " (circular ref.)");
    callback(line);
  }
  if (!circular && typeof root === "object") {
    const keys = filterKeys(root, hideFunctions);
    keys.forEach(function (branch) {
      lastKey = ++index === keys.length;
      growBranch(branch, root[branch], lastKey, lastStatesCopy, showValues, hideFunctions, callback);
    });
  }
}
function makeTreeStringFromObject(obj, showValues, hideFunctions) {
  let tree = "";
  growBranch(".", obj, false, [], showValues, hideFunctions, function (line) {
    tree += line + "\n";
  });
  return tree;
}
// EXTERNAL MODULE: ./src/api/student/syllabus/syllabus.api.ts + 4 modules
var syllabus_api = __webpack_require__(19905);
;// CONCATENATED MODULE: ./src/hooks/useSyllabusView.ts









const getSyllabusTreeObject = syllabus => {
  const {
    modules,
    task: tasksMap
  } = syllabus;
  const getTasks = tasks => tasks.reduce((acc, task) => {
    const taskTitle = tasksMap[task.id].text;
    if (taskTitle) {
      acc[taskTitle] = null;
    }
    return acc;
  }, {});
  const getMotherTasks = module => module.motherTasks.reduce((acc, mt) => {
    acc[mt.title] = {
      TASKS: getTasks(mt.tasks),
      LANGUAGE_INPUT: getTasks(mt.inClassTasks),
      SELF_STUDY: getTasks(mt.selfStudyTasks)
    };
    return acc;
  }, {});
  const getModules = modules2 => modules2.reduce((acc, module) => {
    acc[module.title] = getMotherTasks(module);
    return acc;
  }, {});
  return getModules(modules);
};
const useSyllabusView = syllabusId => {
  const [syllabus, setSyllabus] = (0,react.useState)(null);
  const [isLoading, setLoading] = (0,react.useState)(false);
  const [isError, setError] = (0,react.useState)(false);
  const fetchSyllabus = (0,react.useCallback)(async () => {
    setLoading(true);
    const syllabus2 = await (0,syllabus_api/* getSyllabus */.FZ)({
      syllabusId
    });
    setLoading(false);
    if ((0,Either.isLeft)(syllabus2)) {
      setError(true);
      return Promise.resolve((0,Either.left)(syllabus2.left));
    }
    setSyllabus(syllabus2.right);
  }, [syllabusId]);
  (0,react.useEffect)(() => {
    void fetchSyllabus();
  }, [fetchSyllabus]);
  const syllabusTree = (0,react.useMemo)(() => {
    if (!syllabus) {
      return null;
    }
    return makeTreeStringFromObject(getSyllabusTreeObject(syllabus));
  }, [syllabus]);
  return {
    syllabusTree,
    isLoading,
    isError
  };
};
;// CONCATENATED MODULE: ./src/pages/syllabus/syllabus.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const syllabus_module = ({"syllabus-page":"syllabus-module__syllabus-page--Md3Qo","syllabusPage":"syllabus-module__syllabus-page--Md3Qo","full-page":"syllabus-module__full-page--X6Ewe","fullPage":"syllabus-module__full-page--X6Ewe","actions":"syllabus-module__actions--rqYGu","button-icon":"syllabus-module__button-icon--rx_by","buttonIcon":"syllabus-module__button-icon--rx_by","syllabus":"syllabus-module__syllabus--OlKqk"});
;// CONCATENATED MODULE: ./src/pages/syllabus/syllabus.page.tsx












const SyllabusPage = () => {
  const {
    syllabusId
  } = (0,react_router/* useParams */.UO)();
  const {
    syllabusTree,
    isLoading,
    isError
  } = useSyllabusView(syllabusId);
  if (isLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("main", {
      className: syllabus_module.fullPage,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
        className: typography_module/* default */.Z.headline4,
        children: "Loading..."
      })
    });
  }
  if (isError) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
      className: syllabus_module.fullPage,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
        className: typography_module/* default */.Z.headline4,
        children: "Something went wrong :("
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.body2,
        children: "Check syllabus_id in URL or contact the dev-team"
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: syllabus_module.syllabusPage,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("header", {
      className: syllabus_module.actions,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
        size: "small",
        appearance: "secondary",
        onClick: () => {
          if (syllabusTree) {
            void navigator.clipboard.writeText(syllabusTree);
          }
        },
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "syllabus.copyButton"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: syllabus_module.buttonIcon,
          size: "small",
          name: "copy"
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)(button_link_component/* ButtonLink */.Z, {
        useNativeTag: true,
        size: "small",
        appearance: "secondary",
        href: (0,domain_urls/* getExternalUrl */.Eg)("textcompare"),
        target: "_blank",
        rel: "noreferrer",
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "syllabus.compareLinkText"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: syllabus_module.buttonIcon,
          size: "small",
          name: "numbered-list"
        })]
      })]
    }), syllabusTree && /* @__PURE__ */(0,jsx_runtime.jsx)("main", {
      className: syllabus_module.syllabus,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("pre", {
        children: syllabusTree
      })
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/errors/403/error-403.component.tsx + 2 modules
var error_403_component = __webpack_require__(62578);
// EXTERNAL MODULE: ./src/services/taskGuide/useTaskGuide.ts + 3 modules
var useTaskGuide = __webpack_require__(70372);
// EXTERNAL MODULE: ../shared/src/model/student/student.model.ts
var student_student_model = __webpack_require__(54938);
// EXTERNAL MODULE: ../shared/src/routes/teacher-route-paths.ts
var teacher_route_paths = __webpack_require__(64514);
;// CONCATENATED MODULE: ./src/services/taskGuide/useTaskGuideDemo.ts











const useTaskGuideDemo = syllabusId => {
  const history = (0,react_router/* useHistory */.k6)();
  const resetTestResult = (0,student_test_store/* useStudentTestStore */.C)(state => state.resetTestResult);
  const goToTask = taskId => {
    history.push(baseRoutePaths/* baseRoutePaths */.lQ.TASK_GUIDE(syllabusId, taskId));
    resetTestResult();
  };
  const openAdditionalSyllabus = additionalSyllabus => {
    const href = `${(0,site_utils/* getAppPath */.bY)()}${get_url_search_params.getUrlSearchParams.taskGuide.getTaskGuideLink(teacher_route_paths/* teacherRoutePaths */.q.INDEX, {
      syllabusId: additionalSyllabus
    }, history)}`;
    window.open(href);
  };
  return (0,useTaskGuide/* useTaskGuideWithParams */.d)({
    syllabusId,
    studentId: (0,student_student_model/* makeStudentId */.Ox)("290de425-b6f5-47a0-8dab-69b717dca201"),
    goToTask,
    openAdditionalSyllabus
  });
};
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide-app-wrapper.tsx + 63 modules
var task_guide_app_wrapper = __webpack_require__(30989);
;// CONCATENATED MODULE: ./src/pages/task-guide-page/constants.ts



const ACCEPTED_USER_ROLES = [entities_user/* UserRole */.i4.ROLE_CONTENT_MANAGER, entities_user/* UserRole */.i4.ROLE_DEVELOPER, entities_user/* UserRole */.i4.ROLE_METHODOLOGIST, entities_user/* UserRole */.i4.ROLE_SUPPORT, entities_user/* UserRole */.i4.ROLE_TUTOR];
;// CONCATENATED MODULE: ./src/pages/task-guide-page/utils.ts




const mapAcceptedUserRole = role => {
  switch (role) {
    case entities_user/* UserRole */.i4.ROLE_CONTENT_MANAGER:
    case entities_user/* UserRole */.i4.ROLE_DEVELOPER:
    case entities_user/* UserRole */.i4.ROLE_METHODOLOGIST:
    case entities_user/* UserRole */.i4.ROLE_SUPPORT:
    case entities_user/* UserRole */.i4.ROLE_TUTOR:
      return ProductRevisionTrainerUserRole.Tutor;
    default:
      return ProductRevisionTrainerUserRole.Methodologist;
  }
};
;// CONCATENATED MODULE: ./src/pages/task-guide-page/task-guide-page.tsx

















const TaskGuidePage = () => {
  const user = (0,useUser/* useUser */.aF)();
  const {
    chapterId
  } = (0,react_router/* useParams */.UO)();
  const value = (0,useTaskGuide/* useTaskGuide */.k)();
  switch (user.state) {
    case useUser/* State */.ZM.Error:
      throw new Error();
    case useUser/* State */.ZM.Initial:
    case useUser/* State */.ZM.Loading:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
    case useUser/* State */.ZM.Loaded:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(RevisionPageWithTaskGuide, {
        userRole: user.data.me.user?.role,
        chapterId,
        value
      });
    default:
      return null;
  }
};
const DemoTaskGuidePage = () => {
  const user = (0,useUser/* useUser */.aF)();
  const {
    syllabusId,
    chapterId
  } = (0,react_router/* useParams */.UO)();
  const value = useTaskGuideDemo(syllabusId);
  switch (user.state) {
    case useUser/* State */.ZM.Error:
      throw new Error();
    case useUser/* State */.ZM.Initial:
    case useUser/* State */.ZM.Loading:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
    case useUser/* State */.ZM.Loaded:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(RevisionPageWithTaskGuide, {
          userRole: user.data.me.user?.role,
          chapterId,
          value
        });
      }
    default:
      return null;
  }
};
const RevisionPageWithTaskGuide = _ref => {
  let {
    chapterId,
    userRole,
    value
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(task_guide_app_wrapper/* WithTaskGuideWrapper */.A, {
    value,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(RevisionPageWithTaskGuideContent, {
      chapterId,
      userRole
    })
  });
};
const RevisionPageWithTaskGuideContent = _ref2 => {
  let {
    chapterId,
    userRole
  } = _ref2;
  const intl = (0,useIntl/* default */.Z)();
  const selectedTestResult = (0,student_test_store/* useStudentTestStore */.C)(state => state.selectedTestResult);
  if (selectedTestResult) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(student_test_result/* StudentTestResult */.r, {
      ...selectedTestResult
    });
  }
  if (!userRole || !ACCEPTED_USER_ROLES.includes(userRole)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(error_403_component/* Error403 */.K, {
      textConstants: {
        description: intl.formatMessage({
          id: "error.403.description"
        })
      }
    });
  }
  const productRevisionTrainerUserRole = mapAcceptedUserRole(userRole);
  if (!chapterId || !productRevisionTrainerUserRole) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductRevisionPage, {
    userRole: productRevisionTrainerUserRole,
    withTaskGuide: true
  });
};
// EXTERNAL MODULE: ../../node_modules/xstate/es/index.js
var xstate_es = __webpack_require__(97386);
// EXTERNAL MODULE: ../../node_modules/xstate/es/Machine.js + 2 modules
var Machine = __webpack_require__(9875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
// EXTERNAL MODULE: ./src/state-machine/trainer.actions.ts
var trainer_actions = __webpack_require__(74819);
// EXTERNAL MODULE: ./src/state-machine/trainer.guards.ts
var trainer_guards = __webpack_require__(28532);
// EXTERNAL MODULE: ./src/state-machine/trainer/trainer.machine.consts.ts
var trainer_machine_consts = __webpack_require__(98513);
;// CONCATENATED MODULE: ./src/state-machine/trainer/trainer.machine.ts














const getAnswerDataSaverPreparator = (eventType, masteringId) => _ref => {
  let {
    currentBlocks,
    activities,
    activityIndex,
    blockIndex,
    chapterStudentEvents,
    chapterId,
    chapterInfo
  } = _ref;
  const blockId = currentBlocks[blockIndex].id ?? "undefined";
  if (blockId === "undefined") {
    logger/* Logger */.Yd.unexpectedState();
  }
  const currentBlockEvents = chapterStudentEvents[blockId];
  const answerEvents = currentBlockEvents.filter(e => e.event_type === eventType);
  const lastEvent = answerEvents[answerEvents.length - 1];
  const answer = lastEvent?.data?.answer;
  const correct = lastEvent?.data?.correct;
  const typo = lastEvent?.data?.typo;
  return {
    courseId: chapterInfo?.courseId,
    activityId: activities[activityIndex]?.activity_id,
    blockId,
    chapterId,
    userAnswer: answer && JSON.parse(answer),
    correct,
    eventType,
    masteringId,
    typo
  };
};
const getSavingProgressPreparator = (eventType, masteringId) => _ref2 => {
  let {
    progress,
    chapterInfo,
    activities,
    activityIndex,
    blockIndex,
    currentBlocks,
    chapterId
  } = _ref2;
  return {
    courseId: chapterInfo?.courseId,
    // eslint-disable-next-line camelcase
    activityId: activities[activityIndex]?.activity_id ?? null,
    blockId: currentBlocks[blockIndex]?.id ?? null,
    chapterId,
    progress,
    eventType,
    masteringId
  };
};
const updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)("trainer_result");
const trainerStatesConfig = {
  [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
    invoke: {
      src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
      data: {
        chapterId: context => context.chapterId
      },
      onDone: [{
        target: trainer_machine_consts/* STATES */.PO.ERROR,
        cond: (_, _ref3) => {
          let {
            data
          } = _ref3;
          return data.error !== void 0;
        },
        actions: [trainer_machine_consts/* ACTIONS */.aO.PROCESS_LOADING_ERROR]
      }, {
        actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.ADD_OUTRO_IF_NEED, trainer_machine_consts/* ACTIONS */.aO.CALCULATE_ACTIVITY_INDEX, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.CALCULATE_BLOCK_INDEX, (0,xstate_es/* assign */.f0)({
          blockIndex: context => {
            const {
              activities,
              activityIndex,
              blockIndex
            } = context;
            const currentActivity = activities[activityIndex];
            if (currentActivity.type === "lexis") {
              return blockIndex;
            }
            return (0,trainer_actions/* getFirstActionableBlockIndexFrom */.dj)(0)(context);
          }
        }), (0,xstate_es/* assign */.f0)({
          scrollToBlockIndex: context => {
            if (Object.keys(context.chapterStudentEvents).length !== 0) {
              return context.blockIndex;
            }
            return 0;
          }
        }), trainer_machine_consts/* ACTIONS */.aO.SEND_INITIAL_EVENT_IF_NEED, (0,xstate_es/* assign */.f0)({
          progress: trainer_actions/* getProgress */.xC
        })],
        target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
      }],
      onError: trainer_machine_consts/* STATES */.PO.ERROR
    }
  },
  [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: {
    entry: trainer_machine_consts/* ACTIONS */.aO.SEND_FINAL_EVENT_IF_NEED
  },
  [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {
    invoke: {
      src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
      data: getSavingProgressPreparator("trainer_progress"),
      onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS,
      onError: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
    }
  },
  [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {
    invoke: {
      src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
      data: getAnswerDataSaverPreparator("trainer_result"),
      onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
    }
  },
  [trainer_machine_consts/* STATES */.PO.ERROR]: {}
};
const trainerEventsConfig = {
  [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: [{
    cond: context => [trainer_guards/* isLastBlock */.zb, trainer_guards/* isNextActivityEmptyAfterFilter */.pH].every(guard => guard(context)),
    actions: [(0,xstate_es/* assign */.f0)({
      activityIndex: trainer_actions/* getNextNotEmptyActivity */.xL,
      blockIndex: 0,
      scrollToBlockIndex: 0
    }), (0,xstate_es/* assign */.f0)({
      currentBlocks: context => context.filterCurrentActivityBlocks(context)
    }), (0,xstate_es/* assign */.f0)({
      blockIndex: (0,trainer_actions/* getFirstActionableBlockIndexFrom */.dj)(0)
    }), (0,xstate_es/* assign */.f0)({
      progress: trainer_actions/* getProgress */.xC
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  }, {
    cond: trainer_guards/* isLastBlock */.zb,
    actions: [(0,xstate_es/* assign */.f0)({
      activityIndex: trainer_actions/* incrementActivityIndex */.sp,
      blockIndex: 0,
      scrollToBlockIndex: 0
    }), (0,xstate_es/* assign */.f0)({
      currentBlocks: context => context.filterCurrentActivityBlocks(context)
    }), (0,xstate_es/* assign */.f0)({
      blockIndex: (0,trainer_actions/* getFirstActionableBlockIndexFrom */.dj)(0)
    }), (0,xstate_es/* assign */.f0)({
      progress: trainer_actions/* getProgress */.xC
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  }, {
    actions: [(0,xstate_es/* assign */.f0)({
      scrollToBlockIndex: trainer_actions/* getScrollToBlockIndex */.p9
    }), (0,xstate_es/* assign */.f0)({
      blockIndex: trainer_actions/* getNextFirstActionableBlockIndex */.J0
    }), (0,xstate_es/* assign */.f0)({
      progress: trainer_actions/* getProgress */.xC
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  }],
  [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: [{
    cond: context => [trainer_guards/* isFirstBlock */.d7, trainer_guards/* notFirstActivity */.SH, trainer_guards/* isPrevActivityEmptyAfterFilter */.eR].every(guard => guard(context)),
    actions: [(0,xstate_es/* assign */.f0)({
      activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
    }), (0,xstate_es/* assign */.f0)({
      currentBlocks: context => context.filterCurrentActivityBlocks(context)
    }), (0,xstate_es/* assign */.f0)({
      blockIndex: context => context.currentBlocks.length - 1
    }), (0,xstate_es/* assign */.f0)({
      scrollToBlockIndex: context => context.blockIndex
    }), (0,xstate_es/* assign */.f0)({
      progress: trainer_actions/* getProgress */.xC
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  }, {
    cond: context => [trainer_guards/* isFirstBlock */.d7, trainer_guards/* notFirstActivity */.SH].every(guard => guard(context)),
    actions: [(0,xstate_es/* assign */.f0)({
      activityIndex: context => context.activityIndex ? context.activityIndex - 1 : 0
    }), (0,xstate_es/* assign */.f0)({
      currentBlocks: context => context.filterCurrentActivityBlocks(context)
    }), (0,xstate_es/* assign */.f0)({
      blockIndex: context => context.currentBlocks.length - 1
    }), (0,xstate_es/* assign */.f0)({
      scrollToBlockIndex: context => context.blockIndex
    }), (0,xstate_es/* assign */.f0)({
      progress: trainer_actions/* getProgress */.xC
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  }, {
    actions: [(0,xstate_es/* assign */.f0)({
      blockIndex: trainer_actions/* getPrevActionableBlockIndex */.zL
    }), (0,xstate_es/* assign */.f0)({
      scrollToBlockIndex: context => context.blockIndex
    }), (0,xstate_es/* assign */.f0)({
      progress: trainer_actions/* getProgress */.xC
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  }],
  [product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED]: {
    actions: [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  },
  [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: {
    target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER,
    actions: [trainer_machine_consts/* ACTIONS */.aO.PUSH_CHAPTER_ANSWER, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]
  },
  [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
    cond: context => context.activityIndex !== 0,
    actions: [(0,xstate_es/* assign */.f0)({
      activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
    }), (0,xstate_es/* assign */.f0)({
      currentBlocks: context => context.filterCurrentActivityBlocks(context)
    }), (0,xstate_es/* assign */.f0)({
      blockIndex: context => context.currentBlocks.length - 1,
      scrollToBlockIndex: context => context.currentBlocks.length - 1
    }), trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
    target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
  },
  [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
    actions: [(0,xstate_es/* assign */.f0)({
      chapterStudentEvents: updateStudentEvent,
      blockIndex: (context, event) => {
        const {
          blockId
        } = event.data;
        return context.currentBlocks.findIndex(b => b.id === blockId);
      },
      currentBlocks: context => context.filterCurrentActivityBlocks(context)
    })],
    target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER
  }
};
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-about-trainer-machine.ts









const services = {
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: () => Promise.resolve(),
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: async () => {
    const response = await (0,bunker_api/* getAboutChapter */.Aq)();
    return {
      chapterData: [response],
      userData: []
    };
  }
};
const guards = create_trainer_machine/* guards */.l8;
const baseTrainerActions = create_trainer_machine/* actions */.Nw;
const actions = {
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,xstate_es/* assign */.f0)((context, event) => ({
    activities: event.data.chapterData,
    chapterStudentEvents: {},
    activityIndex: 0,
    blockIndex: 0
  })),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.RESET_TRAINER]: (0,xstate_es/* assign */.f0)({
    activityIndex: 0,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX]: baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getBlockFilterAction */.XI)("class_progress"))
};
const aboutTrainerMachine = (0,Machine/* createMachine */.C)({
  id: "about-trainer",
  initial: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA,
  states: {
    [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
        onDone: [{
          actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }],
        onError: trainer_machine_consts/* STATES */.PO.ERROR
      }
    },
    [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS],
    [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {},
    [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {},
    [trainer_machine_consts/* STATES */.PO.ERROR]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.ERROR]
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER],
    [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]
  }
});
const createAboutTrainerMachine = intl => aboutTrainerMachine.withConfig({
  actions,
  services,
  guards
}).withContext({
  mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
  chapterId: "",
  chapterStudentEvents: {},
  currentBlocks: [],
  activities: [],
  progress: 0,
  blockIndex: 0,
  activityIndex: 0,
  scrollToBlockIndex: 0,
  filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("trainer_result"),
  intl
});
;// CONCATENATED MODULE: ./src/pages/about/about.page.tsx





















const AboutPage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const machine = (0,react.useMemo)(() => createAboutTrainerMachine(intl), [intl]);
  const [state, send] = (0,useMachine/* useMachine */.e)(machine);
  const history = (0,react_router/* useHistory */.k6)();
  const {
    activities,
    activityIndex,
    blockIndex,
    currentBlocks: condBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const {
    handleResetAnswer,
    handleNextBlockClick: onNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  const handleNextBlockClick = (0,react.useCallback)(() => {
    if (blockIndex >= condBlocks.length - 1 && activityIndex === activities.length - 1) {
      return history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
    }
    return onNextBlockClick();
  }, [activities.length, activityIndex, blockIndex, condBlocks.length, history, onNextBlockClick]);
  const onSubmitAnswer = (0,react.useCallback)(_ref => {
    let {
      answer,
      correct,
      typo,
      blockId
    } = _ref;
    return send(product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER, {
      data: {
        answer,
        blockId,
        // eslint-disable-next-line camelcase
        activityId: currentActivity?.activity_id,
        courseId: state.context.chapterInfo?.courseId,
        levelId: state.context.chapterInfo?.levelId,
        topicId: state.context.chapterInfo?.topicId,
        correct,
        typo
      }
    });
  }, [currentActivity, send, state.context.chapterInfo]);
  const getBlockAnswerInfo = (0,react.useCallback)(() => ({
    correct: false,
    answer: {}
  }), []);
  switch (state.value) {
    case trainer_machine_consts/* STATES */.PO.ERROR:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "error"
      });
    case trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA:
    case trainer_machine_consts/* STATES */.PO.SAVING_ANSWER:
    case trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
        oneElementPerScreen: true,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
          onResetAnswer: blockId => {
            const currentActivityId = currentActivity?.activity_id;
            if (currentActivityId) {
              handleResetAnswer(blockId, currentActivityId);
            }
          },
          onPrevActivityClick: handlePrevActivityClick,
          blocks: condBlocks,
          activityType: currentActivity?.type ?? "story",
          onSubmitAnswer,
          currentActivityIndex: state.context.activityIndex,
          blockIndex: state.context.blockIndex,
          onNextBlockClick: handleNextBlockClick,
          onPrevBlockClick: handlePrevBlockClick,
          mechanicMachineCreator: state.context.mechanicMachineCreator,
          getBlockAnswerInfo,
          showSkipButton: false,
          showPrevButton: true,
          showNextButton: true,
          showResetButton: true,
          showSubmitButton: true,
          showAudioFooter: false,
          userEnvironment: types/* UserEnvironment */.P.Student,
          isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
          progress: state.context.progress
        })]
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "about.page",
        state: state.value
      });
  }
};
;// CONCATENATED MODULE: ./src/pages/auto-placement/auto-placement.page.tsx








const AutoPlacementPage = () => {
  const params = (0,react_router/* useParams */.UO)();
  const attributes = useUserAttributes();
  const history = (0,react_router/* useHistory */.k6)();
  (0,react.useEffect)(() => {
    if (params.placementProductId !== attributes.data?.currentProductId) {
      void (0,placement_api/* placeUserIntoLevel */.k)(params.placementProductId).then(() => {
        history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
      });
    } else {
      history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
    }
  }, [attributes.data?.currentProductId, history, params.placementProductId]);
  return null;
};
;// CONCATENATED MODULE: ../ui-kit/src/go-to-link/constants.ts


const GO_TO_LINK_DIRECTION = {
  back: "back",
  forward: "forward"
};
;// CONCATENATED MODULE: ../ui-kit/src/go-to-link/go-to-link.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const go_to_link_module = ({"go-to-link-wrapper":"go-to-link-module__go-to-link-wrapper--PUL73","goToLinkWrapper":"go-to-link-module__go-to-link-wrapper--PUL73","direction-forward":"go-to-link-module__direction-forward--_jv8k","directionForward":"go-to-link-module__direction-forward--_jv8k","link":"go-to-link-module__link--z1Hnt","with-margin-bottom":"go-to-link-module__with-margin-bottom--m47sv","withMarginBottom":"go-to-link-module__with-margin-bottom--m47sv","go-back-link-text":"go-to-link-module__go-back-link-text--Urm9A","goBackLinkText":"go-to-link-module__go-back-link-text--Urm9A","go-forward-link-text":"go-to-link-module__go-forward-link-text--EjT0j","goForwardLinkText":"go-to-link-module__go-forward-link-text--EjT0j","go-back-button":"go-to-link-module__go-back-button--KibvM","goBackButton":"go-to-link-module__go-back-button--KibvM"});
;// CONCATENATED MODULE: ../ui-kit/src/go-to-link/go-to-link.tsx









const GoToLink = _ref => {
  let {
    link,
    text,
    withMarginBottom = true,
    direction = GO_TO_LINK_DIRECTION.back
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(typography_module/* default */.Z.captionAccent, go_to_link_module.goToLinkWrapper, {
      [go_to_link_module.withMarginBottom]: withMarginBottom,
      [go_to_link_module.directionForward]: direction === GO_TO_LINK_DIRECTION.forward
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
      to: link,
      className: classnames_default()(go_to_link_module.link, {
        [go_to_link_module.directionForward]: direction === GO_TO_LINK_DIRECTION.forward
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        iconName: direction === GO_TO_LINK_DIRECTION.back ? "simple-arrow-left-bold" : "simple-arrow-right-bold",
        appearance: "floating",
        size: "small",
        className: classnames_default()()
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()({
          [go_to_link_module.goBackLinkText]: direction === GO_TO_LINK_DIRECTION.back,
          [go_to_link_module.goForwardLinkText]: direction === GO_TO_LINK_DIRECTION.forward
        }),
        children: text
      })]
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/go-to-link/index.ts



;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__lesson-card/lesson-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const lesson_card_module = ({"root":"lesson-card-module__root--jixS0","first-line":"lesson-card-module__first-line--vvFNH","firstLine":"lesson-card-module__first-line--vvFNH","first-line-with-avatar":"lesson-card-module__first-line-with-avatar--kjSjw","firstLineWithAvatar":"lesson-card-module__first-line-with-avatar--kjSjw","title":"lesson-card-module__title--ywuNj","date":"lesson-card-module__date--qpiW5","duration":"lesson-card-module__duration--dHvdg","nearest-speaking-sessions":"lesson-card-module__nearest-speaking-sessions--UTMr2","nearestSpeakingSessions":"lesson-card-module__nearest-speaking-sessions--UTMr2","time-hint":"lesson-card-module__time-hint--hiVad","timeHint":"lesson-card-module__time-hint--hiVad","lesson-nearest-date":"lesson-card-module__lesson-nearest-date--PTOON","lessonNearestDate":"lesson-card-module__lesson-nearest-date--PTOON","lesson-secondary-date":"lesson-card-module__lesson-secondary-date--Wexkf","lessonSecondaryDate":"lesson-card-module__lesson-secondary-date--Wexkf","actions-container":"lesson-card-module__actions-container--cliGL","actionsContainer":"lesson-card-module__actions-container--cliGL","action-button-wrapper":"lesson-card-module__action-button-wrapper--z6ixH","actionButtonWrapper":"lesson-card-module__action-button-wrapper--z6ixH","avatar-wrapper":"lesson-card-module__avatar-wrapper--AQqCF","avatarWrapper":"lesson-card-module__avatar-wrapper--AQqCF","mobile-subtitle":"lesson-card-module__mobile-subtitle--ewV0O","mobileSubtitle":"lesson-card-module__mobile-subtitle--ewV0O","action-button":"lesson-card-module__action-button--x1Gz8","actionButton":"lesson-card-module__action-button--x1Gz8","subtitle":"lesson-card-module__subtitle--wJsm1"});
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__lesson-card/foreigner-lesson-card.component.tsx











const ForeignerLessonCard = _ref => {
  let {
    id,
    actions,
    title,
    theme,
    duration,
    date,
    tutorAvatar
  } = _ref;
  const renderActionButtons = (0,react.useCallback)(() => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: lesson_card_module.actionsContainer,
    children: actions.map(action => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: lesson_card_module.actionButtonWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
        appearance: action.type,
        size: "medium",
        onClick: action.onClick,
        disabled: action.disabled ?? false,
        className: lesson_card_module.actionButton,
        children: [action.text, action.children]
      })
    }, action.key ?? action.text))
  }), [actions]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: lesson_card_module.root,
    "data-testid": "ForeignerLessonCard " + id,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(lesson_card_module.firstLine, {
        [lesson_card_module.firstLineWithAvatar]: tutorAvatar
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [title && /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, lesson_card_module.title),
          children: title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: typography_module/* default */.Z.body2,
          children: theme
        }), duration && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(lesson_card_module.duration, typography_module/* default */.Z.captionAccent),
          children: duration
        }), date && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(lesson_card_module.date, typography_module/* default */.Z.body2Accent),
          children: date
        })]
      }), tutorAvatar && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: lesson_card_module.avatarWrapper,
        children: [typeof tutorAvatar === "string" && /* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
          size: avatar_component/* AvatarSize */.D.Size104,
          avatarId: tutorAvatar
        }), typeof tutorAvatar !== "string" && tutorAvatar]
      })]
    }), renderActionButtons()]
  });
};
;// CONCATENATED MODULE: ./src/widgets/foreigner-speakings/foreigner-speakings.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const foreigner_speakings_module = ({"foreigner-card":"foreigner-speakings-module__foreigner-card--B4dse","foreignerCard":"foreigner-speakings-module__foreigner-card--B4dse","foreigner-cards":"foreigner-speakings-module__foreigner-cards--EXbJ0","foreignerCards":"foreigner-speakings-module__foreigner-cards--EXbJ0","foreigner-lesson-rows":"foreigner-speakings-module__foreigner-lesson-rows--ieRbZ","foreignerLessonRows":"foreigner-speakings-module__foreigner-lesson-rows--ieRbZ","visible":"foreigner-speakings-module__visible--BiQgh","foreigner-lesson-row":"foreigner-speakings-module__foreigner-lesson-row--hK0k5","foreignerLessonRow":"foreigner-speakings-module__foreigner-lesson-row--hK0k5","duration":"foreigner-speakings-module__duration--PbVk9","arrow":"foreigner-speakings-module__arrow--jbk5K","up-arrow":"foreigner-speakings-module__up-arrow--c6Xad","upArrow":"foreigner-speakings-module__up-arrow--c6Xad","zero-balance-avatar":"foreigner-speakings-module__zero-balance-avatar--IxR6S","zeroBalanceAvatar":"foreigner-speakings-module__zero-balance-avatar--IxR6S","icon":"foreigner-speakings-module__icon--gmA4M"});
;// CONCATENATED MODULE: ./src/widgets/foreigner-speakings/initial-foreigner-speaking-card.component.tsx







const InitialForeignerSpeakingCard = _ref => {
  let {
    title,
    speaking,
    onSpeakingClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const speakingDurationMin = intl.formatMessage({
    id: "foreignerSpeakings.durationMin"
  }, {
    count: speaking.durationMin
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: foreigner_speakings_module.foreignerCard,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerLessonCard, {
      id: speaking.id,
      actions: [{
        onClick: () => {
          onSpeakingClick(speaking.id);
        },
        text: intl.formatMessage({
          id: "foreignerSpeakings.scheduleClass"
        }),
        type: isMobile ? "secondary" : "primary"
      }],
      title,
      theme: speaking.theme,
      duration: speakingDurationMin
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/date-fns/addMinutes.mjs
var addMinutes = __webpack_require__(7300);
// EXTERNAL MODULE: ../../node_modules/date-fns/formatDuration.mjs
var formatDuration = __webpack_require__(66514);
// EXTERNAL MODULE: ./src/components/add-to-calendar-button/add-to-calendar-button.component.tsx + 5 modules
var add_to_calendar_button_component = __webpack_require__(59602);
;// CONCATENATED MODULE: ./src/components/schedule-info-modal/schedule-info-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_info_modal_module = ({"text-block":"schedule-info-modal-module__text-block--DiXhW","textBlock":"schedule-info-modal-module__text-block--DiXhW"});
;// CONCATENATED MODULE: ./src/components/schedule-info-modal/schedule-info-modal.component.tsx













const SCHEDULE_INFO_LOCALSTORAGE_KEY = "flow:schedule-info-visited";
const ScheduleInfoModal = _ref => {
  let {
    isVisible = true,
    onClose,
    onClosed,
    title,
    startAt,
    durationMin,
    isMentorSpeaking,
    availableBeforeStartMin
  } = _ref;
  const handleClose = () => {
    localStorage.setItem(SCHEDULE_INFO_LOCALSTORAGE_KEY, "1");
    onClose();
  };
  const intl = (0,useIntl/* default */.Z)();
  const isFirstSpeaking = localStorage.getItem(SCHEDULE_INFO_LOCALSTORAGE_KEY) !== "1";
  const endTime = (0,addMinutes/* addMinutes */.m)(startAt, durationMin);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    isVisible,
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: isMentorSpeaking ? intl.formatMessage({
      id: "scheduleInfoModal.headerMentorSpeaking"
    }) : intl.formatMessage({
      id: "scheduleInfoModal.headerSpeaking"
    }),
    subtitle: intl.formatMessage({
      id: "scheduleInfoModal.headerDates"
    }, {
      startDate: (0,format/* format */.WU)(startAt, "d MMMM", {
        locale: utils_locale/* dateFnsLocale */.Y
      }),
      startTime: (0,format/* format */.WU)(startAt, "H:mm", {
        locale: utils_locale/* dateFnsLocale */.Y
      }),
      endTime: (0,format/* format */.WU)(endTime, "H:mm", {
        locale: utils_locale/* dateFnsLocale */.Y
      })
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "scheduleInfoModal.close"
      }),
      appearance: "secondary",
      onClick: handleClose
    }, /* @__PURE__ */(0,jsx_runtime.jsx)(add_to_calendar_button_component/* AddToCalendarButton */.m, {
      buttonStyle: "text",
      startTime: startAt,
      endTime,
      isMentor: isMentorSpeaking,
      chapterName: title,
      availableBeforeStartMin
    }, title)],
    onClose: handleClose,
    onClosed,
    children: isFirstSpeaking && /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      className: classnames_default()(schedule_info_modal_module.textBlock, typography_module/* default */.Z.caption),
      children: intl.formatMessage({
        id: "scheduleInfoModal.textMarkdownBlock"
      }, {
        time: (0,formatDuration/* formatDuration */.L)({
          minutes: availableBeforeStartMin
        }, {
          locale: utils_locale/* dateFnsLocale */.Y
        }),
        telemost: (0,domain_urls/* getExternalUrl */.Eg)("telemost")
      })
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/duration-icon/duration-icon.component.tsx




const getIconByDuration = durationMin => {
  if (durationMin < 30) {
    return "time-15-min";
  } else if (durationMin < 45) {
    return "time-30-min";
  } else if (durationMin < 5) {
    return "time-1-min";
  }
  return "time-45-min";
};
const DurationIcon = _ref => {
  let {
    min,
    className
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    className,
    name: getIconByDuration(min),
    size: "small"
  });
};
// EXTERNAL MODULE: ./src/api/student/speaking-session/speaking-session.api.ts + 3 modules
var speaking_session_speaking_session_api = __webpack_require__(68393);
// EXTERNAL MODULE: ./src/api/student/speaking-session/speaking-session.model.ts
var speaking_session_model = __webpack_require__(55127);
// EXTERNAL MODULE: ./src/utils/conversionsMetrics.ts + 1 modules
var conversionsMetrics = __webpack_require__(90973);
;// CONCATENATED MODULE: ./src/utils/speaking-session/use-speaking-session-creator.ts









const useSpeakingSessionCreator = _ref => {
  let {
    speakingId,
    currentProductId,
    isFirstSpeaking
  } = _ref;
  const createSpeakingInProgressRef = (0,react.useRef)(false);
  return (0,react.useCallback)(async (selectedTime, activeTutorId) => {
    if (createSpeakingInProgressRef.current) {
      return null;
    }
    createSpeakingInProgressRef.current = true;
    const lastSelectedTime = new Date(selectedTime);
    const response = await (0,speaking_session_speaking_session_api/* createSpeakingSession */.Ec)(speakingId, currentProductId ?? null, lastSelectedTime, activeTutorId === "" ? null : activeTutorId);
    createSpeakingInProgressRef.current = false;
    if ((0,Either.isRight)(response)) {
      (0,yandexMetrica/* ymGoal */.qf)("Speaking_Booked");
      if (isFirstSpeaking && currentProductId !== void 0) {
        void conversionsMetrics/* ConversionsMetrics */.l.firstSpeakingBooked(currentProductId);
      }
      return (0,Either.right)(response.right.speakingSession);
    }
    const errorType = response.left === api_model/* unexpectedError */.g ? speaking_session_model/* CreateSpeakingSessionErrorType */.H.Other : response.left.type;
    switch (errorType) {
      case speaking_session_model/* CreateSpeakingSessionErrorType */.H.NotEnoughMinutes:
      case speaking_session_model/* CreateSpeakingSessionErrorType */.H.Other:
        return (0,Either.left)({
          type: errorType
        });
      case speaking_session_model/* CreateSpeakingSessionErrorType */.H.TimeIsNotAvailable:
        return (0,Either.left)({
          type: speaking_session_model/* CreateSpeakingSessionErrorType */.H.TimeIsNotAvailable,
          lastTimeBeforeError: lastSelectedTime
        });
      default:
        return (0,Either.left)({
          type: errorType
        });
    }
  }, [speakingId, currentProductId, isFirstSpeaking]);
};
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInMilliseconds.mjs
var differenceInMilliseconds = __webpack_require__(41645);
// EXTERNAL MODULE: ../../node_modules/date-fns/isEqual.mjs
var isEqual = __webpack_require__(94527);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameHour.mjs
var isSameHour = __webpack_require__(50390);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameDay.mjs
var isSameDay = __webpack_require__(51418);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(8106);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInDays.mjs
var differenceInDays = __webpack_require__(96017);
// EXTERNAL MODULE: ../../node_modules/date-fns/addDays.mjs
var addDays = __webpack_require__(78016);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfHour.mjs
var startOfHour = __webpack_require__(24938);
// EXTERNAL MODULE: ../../node_modules/date-fns/addHours.mjs
var addHours = __webpack_require__(38769);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(71502);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMilliseconds.mjs
var addMilliseconds = __webpack_require__(87812);
// EXTERNAL MODULE: ../../node_modules/date-fns/getHours.mjs
var getHours = __webpack_require__(91253);
// EXTERNAL MODULE: ../../node_modules/date-fns/getMinutes.mjs
var getMinutes = __webpack_require__(40618);
// EXTERNAL MODULE: ../ui-kit/src/big-text-dropdown/big-text-dropdown.component.tsx + 1 modules
var big_text_dropdown_component = __webpack_require__(89008);
;// CONCATENATED MODULE: ./src/components/student-scheduler/get-error-content.tsx








const getErrorContent = (error, getNearestAvailableTime) => {
  const type = error.type;
  switch (type) {
    case speaking_session_model/* CreateSpeakingSessionErrorType */.H.NotEnoughMinutes:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.captionAccent,
            children: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438 \u043D\u0435 \u043F\u0440\u043E\u0448\u043B\u0430."
          }), " ", /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.caption,
            children: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435, \u0447\u0442\u043E \u043D\u0430 \u043A\u0430\u0440\u0442\u0435 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432, \u0438 \u0435\u0451 \u0434\u0430\u043D\u043D\u044B\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E \u043D\u0435 \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u0442, \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443 \u2014 \u0440\u0430\u0437\u0431\u0435\u0440\u0451\u043C\u0441\u044F \u0432\u043C\u0435\u0441\u0442\u0435."
          })]
        });
      }
    case speaking_session_model/* CreateSpeakingSessionErrorType */.H.TimeIsNotAvailable:
      {
        const nearestAvailableTime = getNearestAvailableTime(error.lastTimeBeforeError);
        const timeBeforeErrorString = (0,format/* format */.WU)(error.lastTimeBeforeError, "HH:mm", {
          locale: utils_locale/* dateFnsLocale */.Y
        });
        let nearestTime = null;
        if (nearestAvailableTime !== null) {
          const formatStringForNearestTime = (0,isSameDay/* isSameDay */.K)(error.lastTimeBeforeError, nearestAvailableTime) ? "HH:mm" : "d MMMM, HH:mm";
          nearestTime = (0,format/* format */.WU)(nearestAvailableTime, formatStringForNearestTime, {
            locale: utils_locale/* dateFnsLocale */.Y
          });
        }
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.captionAccent,
            children: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A."
          }), " ", /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
            className: typography_module/* default */.Z.caption,
            children: ["\u041D\u0430\u043C \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432\u0430\u0441 \u043D\u0430 ", timeBeforeErrorString, ".", " ", nearestTime !== null && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: ["\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u2014 ", nearestTime]
            })]
          })]
        });
      }
    case speaking_session_model/* CreateSpeakingSessionErrorType */.H.Other:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.captionAccent,
            children: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A."
          }), " ", /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.caption,
            children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443."
          })]
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
// EXTERNAL MODULE: ./src/hooks/useCurrentTime.ts
var useCurrentTime = __webpack_require__(70822);
;// CONCATENATED MODULE: ./src/components/student-scheduler/useScheduleSelectAvailableTimes.ts









const SLOT_MINUTES = 5;
const useScheduleSelectAvailableTimes = params => {
  const {
    activeTutorId,
    speakingId,
    availableTimeRequestTimestamp
  } = params;
  const {
    maxTimeToTutorAssignmentHours
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const [availableTimes, setAvailableTimes] = (0,react.useState)(null);
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const nearestPossibleTime = (0,react.useMemo)(() => {
    const MINUTES_ON_SELECTING_SLOT = 5;
    const hourStart = (0,startOfHour/* startOfHour */.o)(currentTime);
    const minutesDiff = (0,differenceInMinutes/* differenceInMinutes */.X)(currentTime, hourStart);
    const roundedToTimeSlotMinutes = Math.ceil((minutesDiff + 1) / SLOT_MINUTES) * SLOT_MINUTES;
    const minutesToNearest = roundedToTimeSlotMinutes + MINUTES_ON_SELECTING_SLOT;
    return (0,addMinutes/* addMinutes */.m)(hourStart, minutesToNearest).getTime();
  }, [currentTime]);
  (0,react.useEffect)(() => {
    let isActive = true;
    void (async () => {
      setAvailableTimes(null);
      if (activeTutorId === null) {
        return;
      }
      const lastTimeForHeatmap = (0,addHours/* addHours */.T)(nearestPossibleTime, maxTimeToTutorAssignmentHours);
      const response = await (0,speaking_api/* getSpeakingAvailableTime */.bs)(speakingId, new Date(nearestPossibleTime), lastTimeForHeatmap, activeTutorId === "" ? null : activeTutorId);
      if (isActive) {
        const availableTutorTimesForAllTime = response.availableTime.map(time => time.startAt);
        setAvailableTimes(availableTutorTimesForAllTime);
      }
    })();
    return () => {
      isActive = false;
    };
  }, [availableTimeRequestTimestamp, nearestPossibleTime, speakingId, activeTutorId, maxTimeToTutorAssignmentHours]);
  return {
    availableTimes,
    nearestPossibleTime
  };
};
// EXTERNAL MODULE: ./src/components/student-scheduler/schedule-select-time.module.css
var schedule_select_time_module = __webpack_require__(70666);
;// CONCATENATED MODULE: ./src/components/student-scheduler/schedule-select-time.component.tsx














































var ScheduleSelectTimeColumnMode = /* @__PURE__ */(ScheduleSelectTimeColumnMode2 => {
  ScheduleSelectTimeColumnMode2[ScheduleSelectTimeColumnMode2["TwoColumnsWithSameWidth"] = 0] = "TwoColumnsWithSameWidth";
  ScheduleSelectTimeColumnMode2[ScheduleSelectTimeColumnMode2["SpaceBetween"] = 1] = "SpaceBetween";
  return ScheduleSelectTimeColumnMode2;
})(ScheduleSelectTimeColumnMode || {});
const createNearestTimeReducer = targetTime => (a, b) => {
  const diffA = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(a, targetTime);
  const diffB = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(b, targetTime);
  const absDiffA = Math.abs(diffA);
  const absDiffB = Math.abs(diffB);
  if (absDiffA === absDiffB) {
    return diffA > diffB ? a : b;
  }
  return absDiffA < absDiffB ? a : b;
};
const ScheduleSelectTime = _ref => {
  let {
    columnMode,
    activeTutorId,
    speakingId,
    createSpeakingSessionErrorInfo,
    selectedTime,
    availableTimeRequestTimestamp,
    isMentor,
    onSelectedTimeChanged,
    onSubmitDisabledChanged,
    onSubmitButtonLabelChanged
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    availableTimes,
    nearestPossibleTime
  } = useScheduleSelectAvailableTimes({
    activeTutorId,
    speakingId,
    availableTimeRequestTimestamp
  });
  const isTimeDisabled = availableTimes === null || availableTimes.length === 0;
  (0,react.useEffect)(() => {
    availableTimes === null ? onSubmitButtonLabelChanged("studentSchedulerComponent.waiting") : onSubmitButtonLabelChanged("studentSchedulerComponent.schedule");
  }, [availableTimes, onSubmitButtonLabelChanged]);
  (0,react.useEffect)(() => {
    onSubmitDisabledChanged(isTimeDisabled);
  }, [isTimeDisabled, onSubmitDisabledChanged]);
  const getNearestHourThenDayAvailableTime = (0,react.useCallback)(newTime => {
    if (availableTimes === null || availableTimes.length === 0) {
      return null;
    }
    const hasExactTime = availableTimes.some(time => (0,isEqual/* isEqual */.X)(newTime, time));
    if (hasExactTime) {
      return newTime.getTime();
    }
    const sameHourItems = availableTimes.filter(time => (0,isSameHour/* isSameHour */.f)(newTime, time));
    if (sameHourItems.length !== 0) {
      return sameHourItems.reduce(createNearestTimeReducer(newTime)).getTime();
    }
    const sameDayItems = availableTimes.filter(time => (0,isSameDay/* isSameDay */.K)(newTime, time));
    if (sameDayItems.length !== 0) {
      return sameDayItems.reduce(createNearestTimeReducer(newTime)).getTime();
    }
    return availableTimes.reduce(createNearestTimeReducer(newTime)).getTime();
  }, [availableTimes]);
  const getNearestAvailableTime = (0,react.useCallback)(newTime => {
    if (newTime === null || availableTimes === null || availableTimes.length === 0) {
      return null;
    }
    return availableTimes.reduce(createNearestTimeReducer(newTime)).getTime();
  }, [availableTimes]);
  (0,react.useEffect)(() => {
    onSelectedTimeChanged(oldSelectedTime => {
      const newTime = getNearestAvailableTime(new Date(oldSelectedTime === null ? nearestPossibleTime : oldSelectedTime));
      if (newTime === null) {
        return oldSelectedTime;
      }
      return newTime;
    });
  }, [getNearestAvailableTime, nearestPossibleTime, onSelectedTimeChanged]);
  const dayItems = (0,react.useMemo)(() => {
    if (availableTimes === null) {
      return [];
    }
    const days = availableTimes.map(interval => (0,startOfDay/* startOfDay */.b)(interval).getTime());
    const availableDays = new Set(days);
    const items = [];
    const currentDate = (0,startOfDay/* startOfDay */.b)(nearestPossibleTime);
    const maxDay = days.reduce((a, b) => Math.max(a, b), 0);
    const daysCount = (0,differenceInDays/* differenceInDays */.j)(maxDay, currentDate) + 1;
    for (let i = 0; i < daysCount; i++) {
      const day = (0,addDays/* addDays */.E)(currentDate, i);
      items.push({
        id: i,
        isDisabled: !availableDays.has(day.getTime()),
        accentedText: (0,format/* format */.WU)(day, "dd MMMM,", {
          locale: utils_locale/* dateFnsLocale */.Y
        }),
        text: (0,format/* format */.WU)(day, "EEEEEE", {
          locale: utils_locale/* dateFnsLocale */.Y
        })
      });
    }
    return items;
  }, [availableTimes, nearestPossibleTime]);
  const hourItems = (0,react.useMemo)(() => {
    if (availableTimes === null || selectedTime === null) {
      return [];
    }
    const availableHours = availableTimes.filter(interval => (0,isSameDay/* isSameDay */.K)(interval, selectedTime)).map(interval => (0,startOfHour/* startOfHour */.o)(interval).getTime());
    const availableHoursSet = new Set(availableHours);
    const items = [];
    const startOfSelectedDay = (0,startOfDay/* startOfDay */.b)(selectedTime);
    const nearestPossibleTimeHour = (0,startOfHour/* startOfHour */.o)(nearestPossibleTime);
    for (let i = 0; i < 24; i++) {
      const hour = (0,addHours/* addHours */.T)(startOfSelectedDay, i);
      if ((0,isBefore/* isBefore */.R)(hour, nearestPossibleTimeHour)) {
        continue;
      }
      items.push({
        id: i,
        isDisabled: !availableHoursSet.has(hour.getTime()),
        accentedText: (0,format/* format */.WU)(hour, "HH", {
          locale: utils_locale/* dateFnsLocale */.Y
        })
      });
    }
    return items;
  }, [availableTimes, nearestPossibleTime, selectedTime]);
  const minuteItems = (0,react.useMemo)(() => {
    if (availableTimes === null || selectedTime === null) {
      return [];
    }
    const availableMinutes = availableTimes.filter(interval => (0,isSameHour/* isSameHour */.f)(interval, selectedTime)).map(interval => interval.getTime());
    const availableMinutesSet = new Set(availableMinutes);
    const items = [];
    const currentHour = (0,startOfHour/* startOfHour */.o)(selectedTime);
    for (let i = 0; i < 60; i += SLOT_MINUTES) {
      const minute = (0,addMinutes/* addMinutes */.m)(currentHour, i);
      if ((0,isBefore/* isBefore */.R)(minute, nearestPossibleTime)) {
        continue;
      }
      items.push({
        id: i,
        isDisabled: !availableMinutesSet.has(minute.getTime()),
        accentedText: (0,format/* format */.WU)(minute, "mm", {
          locale: utils_locale/* dateFnsLocale */.Y
        })
      });
    }
    return items;
  }, [availableTimes, nearestPossibleTime, selectedTime]);
  const handleChangeDay = (0,react.useCallback)(day => {
    onSelectedTimeChanged(oldSelectedTime => {
      if (oldSelectedTime === null) {
        return null;
      }
      const msFromStart = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(oldSelectedTime, (0,startOfDay/* startOfDay */.b)(oldSelectedTime));
      const newSelectedTime = (0,addMilliseconds/* addMilliseconds */.n)((0,addDays/* addDays */.E)((0,startOfDay/* startOfDay */.b)(nearestPossibleTime), day), msFromStart);
      return getNearestHourThenDayAvailableTime(newSelectedTime);
    });
  }, [getNearestHourThenDayAvailableTime, nearestPossibleTime, onSelectedTimeChanged]);
  const handleChangeHour = (0,react.useCallback)(hour => {
    onSelectedTimeChanged(oldSelectedTime => {
      if (oldSelectedTime === null) {
        return null;
      }
      const msFromStart = (0,differenceInMilliseconds/* differenceInMilliseconds */._)(oldSelectedTime, (0,startOfHour/* startOfHour */.o)(oldSelectedTime));
      const newSelectedTime = (0,addMilliseconds/* addMilliseconds */.n)((0,addHours/* addHours */.T)((0,startOfDay/* startOfDay */.b)(oldSelectedTime), hour), msFromStart);
      return getNearestHourThenDayAvailableTime(newSelectedTime);
    });
  }, [getNearestHourThenDayAvailableTime, onSelectedTimeChanged]);
  const handleChangeMinutes = (0,react.useCallback)(minutes => {
    onSelectedTimeChanged(oldSelectedTime => {
      if (oldSelectedTime === null) {
        return null;
      }
      const newSelectedTime = (0,addMinutes/* addMinutes */.m)((0,startOfHour/* startOfHour */.o)(oldSelectedTime), minutes);
      return getNearestHourThenDayAvailableTime(newSelectedTime);
    });
  }, [getNearestHourThenDayAvailableTime, onSelectedTimeChanged]);
  const dateTimeDropdownsClasses = classnames_default()(schedule_select_time_module/* default */.Z.dateTimeDropdowns, {
    [schedule_select_time_module/* default */.Z.dateTimeDropdownsDisabled]: isTimeDisabled
  });
  const timeForShow = selectedTime === null ? nearestPossibleTime : selectedTime;
  const showErrorAboutBusyTutor = isTimeDisabled && availableTimes;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: schedule_select_time_module/* default */.Z.dateTime,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: schedule_select_time_module/* default */.Z.dateTimeRow,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.captionAccent,
          children: intl.formatMessage({
            id: "scheduleSelectTime.date"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: dateTimeDropdownsClasses,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
            content: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
              children: (0,format/* format */.WU)(timeForShow, "dd", {
                locale: utils_locale/* dateFnsLocale */.Y
              })
            }),
            additionalContent: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()(schedule_select_time_module/* default */.Z.monthAndDayOfWeek, typography_module/* default */.Z.captionAccent),
              children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
                children: [(0,format/* format */.WU)(timeForShow, "MMMM", {
                  locale: utils_locale/* dateFnsLocale */.Y
                }), ","]
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                children: (0,format/* format */.WU)(timeForShow, "EEEE", {
                  locale: utils_locale/* dateFnsLocale */.Y
                })
              })]
            }),
            items: dayItems,
            isDisabled: isTimeDisabled,
            activeItemId: (0,differenceInDays/* differenceInDays */.j)((0,startOfDay/* startOfDay */.b)(timeForShow), (0,startOfDay/* startOfDay */.b)(nearestPossibleTime)),
            onChange: handleChangeDay
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(schedule_select_time_module/* default */.Z.dateTimeRow, {
          [schedule_select_time_module/* default */.Z.dateTimeRowRightSpaceBetween]: columnMode === 1 /* SpaceBetween */
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(schedule_select_time_module/* default */.Z.localTimeCaption, typography_module/* default */.Z.captionAccent),
          children: intl.formatMessage({
            id: "scheduleSelectTime.localTime"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: dateTimeDropdownsClasses,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
            content: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
              children: (0,format/* format */.WU)(timeForShow, "HH", {
                locale: utils_locale/* dateFnsLocale */.Y
              })
            }),
            items: hourItems,
            activeItemId: (0,getHours/* getHours */.p)(timeForShow),
            isDisabled: isTimeDisabled,
            onChange: handleChangeHour
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
            children: ":"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
            content: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
              children: (0,format/* format */.WU)(timeForShow, "mm", {
                locale: utils_locale/* dateFnsLocale */.Y
              })
            }),
            items: minuteItems,
            activeItemId: (0,getMinutes/* getMinutes */.q)(timeForShow),
            isDisabled: isTimeDisabled,
            onChange: handleChangeMinutes
          })]
        })]
      })]
    }), showErrorAboutBusyTutor && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: schedule_select_time_module/* default */.Z.errorText,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.captionAccent,
        children: isMentor ? intl.formatMessage({
          id: "scheduleSelectTime.mentorIsBusy"
        }) : intl.formatMessage({
          id: "scheduleSelectTime.trainerIsBusy"
        })
      }), " ", /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.caption,
        children: intl.formatMessage({
          id: "scheduleSelectTime.tryToChooseAnother"
        })
      })]
    }), !showErrorAboutBusyTutor && createSpeakingSessionErrorInfo !== null && availableTimes !== null && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: schedule_select_time_module/* default */.Z.errorText,
      children: getErrorContent(createSpeakingSessionErrorInfo, getNearestAvailableTime)
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/load-error/load-error.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const load_error_module = ({"root":"load-error-module__root--eHVZc"});
;// CONCATENATED MODULE: ./src/components/load-error/load-error.component.tsx






const LoadError = _ref => {
  let {
    onReload
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: load_error_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "primary",
      onClick: onReload,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "loadError.refresh"
      })
    })
  });
};
// EXTERNAL MODULE: ../shared/src/model/tutor/tutor.model.ts
var tutor_model = __webpack_require__(97953);
// EXTERNAL MODULE: ../ui-kit/src/dropdown/dropdown.component.tsx + 1 modules
var dropdown_component = __webpack_require__(34504);
;// CONCATENATED MODULE: ./src/components/student-scheduler/schedule-select-tutor-dropdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_select_tutor_dropdown_module = ({"item":"schedule-select-tutor-dropdown-module__item--W9L2S","text":"schedule-select-tutor-dropdown-module__text--KNNCK","text-blacklisted":"schedule-select-tutor-dropdown-module__text-blacklisted--xswkq","textBlacklisted":"schedule-select-tutor-dropdown-module__text-blacklisted--xswkq","item-with-checkup":"schedule-select-tutor-dropdown-module__item-with-checkup--Me1eG","itemWithCheckup":"schedule-select-tutor-dropdown-module__item-with-checkup--Me1eG","my-mentors":"schedule-select-tutor-dropdown-module__my-mentors--tu8kZ","myMentors":"schedule-select-tutor-dropdown-module__my-mentors--tu8kZ","my-mentors-text":"schedule-select-tutor-dropdown-module__my-mentors-text--t2F7r","myMentorsText":"schedule-select-tutor-dropdown-module__my-mentors-text--t2F7r","close-item":"schedule-select-tutor-dropdown-module__close-item--GGr8I","closeItem":"schedule-select-tutor-dropdown-module__close-item--GGr8I","comment-item":"schedule-select-tutor-dropdown-module__comment-item--Z_e6a","commentItem":"schedule-select-tutor-dropdown-module__comment-item--Z_e6a","checkbox":"schedule-select-tutor-dropdown-module__checkbox--x1Z5J","checkbox-not-checked":"schedule-select-tutor-dropdown-module__checkbox-not-checked--wO7Jl","checkboxNotChecked":"schedule-select-tutor-dropdown-module__checkbox-not-checked--wO7Jl","checkbox-checked":"schedule-select-tutor-dropdown-module__checkbox-checked--tiEuL","checkboxChecked":"schedule-select-tutor-dropdown-module__checkbox-checked--tiEuL"});
;// CONCATENATED MODULE: ./src/components/student-scheduler/schedule-select-tutor-dropdown.component.tsx



















const ScheduleSelectTutorDropdown = _ref => {
  let {
    activeItemId,
    items,
    isMentor,
    blacklistedSet,
    onActiveItemChanged,
    onBlacklistedChanged,
    onBlacklistChangeEnd
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isEditingBlacklist, setEditingBlacklist] = (0,react.useState)(false);
  const handleOpenBlacklist = (0,react.useCallback)(() => {
    setEditingBlacklist(true);
  }, []);
  const handleCloseBlacklist = (0,react.useCallback)(() => {
    setEditingBlacklist(false);
  }, []);
  (0,react.useEffect)(() => {
    if (!isEditingBlacklist) {
      onBlacklistChangeEnd();
    }
  }, [isEditingBlacklist, onBlacklistChangeEnd]);
  const renderItem = (0,react.useCallback)(item => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: schedule_select_tutor_dropdown_module.item,
    children: [item.id === "" ? /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      size: "medium",
      name: "user"
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
      size: avatar_component/* AvatarSize */.D.Size24,
      avatarId: item.avatar
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(schedule_select_tutor_dropdown_module.text, blacklistedSet.has(item.id) && schedule_select_tutor_dropdown_module.textBlacklisted),
      children: item.publicName
    })]
  }), [blacklistedSet]);
  const randomTutorItem = (0,react.useMemo)(() => ({
    id: (0,tutor_model/* makeTutorId */.Nr)(""),
    publicName: intl.formatMessage({
      id: isMentor ? "scheduleSelectTutor.randomCoach" : "scheduleSelectTutor.randomTutor"
    }),
    avatar: ""
  }), [intl, isMentor]);
  const randomTutorItemArray = (0,react.useMemo)(() => [randomTutorItem], [randomTutorItem]);
  const activeItem = (0,react.useMemo)(() => {
    if (activeItemId === "") {
      return randomTutorItem;
    }
    return items.find(item => item.id === activeItemId) ?? null;
  }, [activeItemId, items, randomTutorItem]);
  const renderDropdown = (0,react.useCallback)(onDropdownClose => {
    if (isEditingBlacklist) {
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: schedule_select_tutor_dropdown_module.closeItem,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            appearance: "default",
            iconName: "simple-arrow-left",
            size: "small",
            onClick: handleCloseBlacklist
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.caption, schedule_select_tutor_dropdown_module.commentItem),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: isMentor ? "scheduleSelectTutor.blacklistDescriptionMentor" : "scheduleSelectTutor.blacklistDescriptionTutor"
          })
        }), items.map(item => {
          const isBlacklisted = blacklistedSet.has(item.id);
          return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
            type: "button",
            className: schedule_select_tutor_dropdown_module.itemWithCheckup,
            onClick: () => {
              onBlacklistedChanged(item.id, !isBlacklisted);
            },
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
              size: avatar_component/* AvatarSize */.D.Size24,
              avatarId: item.avatar
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: schedule_select_tutor_dropdown_module.text,
              children: item.publicName
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()(schedule_select_tutor_dropdown_module.checkbox, {
                [schedule_select_tutor_dropdown_module.checkboxChecked]: !isBlacklisted,
                [schedule_select_tutor_dropdown_module.checkboxNotChecked]: isBlacklisted
              }),
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
                name: "checkmark",
                size: "medium"
              })
            })]
          }, item.id);
        })]
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_with_items_component/* DropdownItems */.Vs, {
        activeItemId,
        items: randomTutorItemArray,
        renderItem,
        onActiveItemChanged,
        autoHeight: false,
        onDropdownClose
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(typography_module/* default */.Z.captionAccent, schedule_select_tutor_dropdown_module.myMentors),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: schedule_select_tutor_dropdown_module.myMentorsText,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: isMentor ? "scheduleSelectTutor.myMentors" : "scheduleSelectTutor.myTutors"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          appearance: "default",
          iconName: "edit",
          size: "small",
          onClick: handleOpenBlacklist
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_with_items_component/* DropdownItems */.Vs, {
        activeItemId,
        items,
        renderItem,
        onActiveItemChanged,
        autoHeight: false,
        onDropdownClose
      })]
    });
  }, [handleCloseBlacklist, handleOpenBlacklist, isEditingBlacklist, onActiveItemChanged, onBlacklistedChanged, activeItemId, blacklistedSet, isMentor, items, randomTutorItemArray, renderItem]);
  const renderSelector = (0,react.useCallback)((isDropdownActive, onDropdownClick) => /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_with_items_component/* DropdownButton */.PS, {
    isDropdownActive,
    autoHeight: false,
    onDropdownClick,
    children: activeItem !== null && renderItem(activeItem)
  }), [activeItem, renderItem]);
  const handleDropdownActiveChanged = (0,react.useCallback)(isActive => {
    if (!isActive) {
      setEditingBlacklist(false);
    }
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_component/* Dropdown */.L, {
    renderSelector,
    renderDropdown,
    onDropdownActiveChanged: handleDropdownActiveChanged
  });
};
;// CONCATENATED MODULE: ./src/components/student-scheduler/schedule-select-tutor.component.tsx









const ScheduleSelectTutor = _ref => {
  let {
    speakingId,
    isMentor,
    activeTutorId,
    onActiveTutorIdChanged,
    onBlacklistChanged
  } = _ref;
  const [items, setItems] = (0,react.useState)(array_utils/* emptyArray */.ow);
  const [blacklistedSet, setBlacklistedSet] = (0,react.useState)(null);
  const beforeChangeBlacklistedSet = (0,react.useRef)(null);
  const [isErrorState, setErrorState] = (0,react.useState)(false);
  const loadData = (0,react.useCallback)(async () => {
    setErrorState(false);
    setBlacklistedSet(null);
    setItems(array_utils/* emptyArray */.ow);
    const tutorsResponse = await (0,speaking_api/* getSpeakingTutors */.Hv)(speakingId);
    if ((0,Either.isLeft)(tutorsResponse)) {
      setErrorState(true);
      return;
    }
    const tutors = tutorsResponse.right;
    if (tutors.suggestRandomTutorFirst) {
      onActiveTutorIdChanged("");
    } else {
      onActiveTutorIdChanged(tutors.lastTutor?.id ?? "");
    }
    setBlacklistedSet(tutors.blacklistedSet);
    if (tutors.lastTutor === null) {
      setItems(tutors.previousTutors);
    } else {
      setItems([tutors.lastTutor, ...tutors.previousTutors]);
    }
    beforeChangeBlacklistedSet.current = tutors.blacklistedSet;
  }, [onActiveTutorIdChanged, speakingId]);
  (0,react.useEffect)(() => {
    void loadData();
  }, [loadData]);
  const handleBlacklistedChanged = (0,react.useCallback)((id, isBlacklisted) => {
    if (blacklistedSet === null) {
      return;
    }
    if (isBlacklisted) {
      void (0,speaking_api/* addTutorToBlacklist */.II)(id);
    } else {
      void (0,speaking_api/* deleteTutorFromBlacklist */.lb)(id);
    }
    setBlacklistedSet(isBlacklisted ? blacklistedSet.add(id) : blacklistedSet.remove(id));
  }, [blacklistedSet]);
  const handleBlacklistChangeEnd = (0,react.useCallback)(() => {
    const oldState = beforeChangeBlacklistedSet.current;
    beforeChangeBlacklistedSet.current = blacklistedSet;
    if (oldState === null) {
      if (blacklistedSet !== null) {
        onBlacklistChanged();
      }
      return;
    }
    if (blacklistedSet === null) {
      onBlacklistChanged();
      return;
    }
    const oldCount = oldState.count();
    if (oldCount !== blacklistedSet.count() || oldCount !== oldState.intersect(blacklistedSet).count()) {
      onBlacklistChanged();
    }
  }, [blacklistedSet, onBlacklistChanged]);
  if (isErrorState) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(LoadError, {
      onReload: loadData
    });
  }
  if (activeTutorId === null || items.length === 0 || blacklistedSet === null) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleSelectTutorDropdown, {
    activeItemId: activeTutorId,
    items,
    isMentor,
    blacklistedSet,
    onActiveItemChanged: onActiveTutorIdChanged,
    onBlacklistedChanged: handleBlacklistedChanged,
    onBlacklistChangeEnd: handleBlacklistChangeEnd
  });
};
;// CONCATENATED MODULE: ./src/components/student-scheduler/student-scheduler.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const student_scheduler_module = ({"root":"student-scheduler-module__root--BdB0j","duration-text":"student-scheduler-module__duration-text--rv_ak","durationText":"student-scheduler-module__duration-text--rv_ak","duration":"student-scheduler-module__duration--FCPP1","trainer-dropdown":"student-scheduler-module__trainer-dropdown--PiDi3","trainerDropdown":"student-scheduler-module__trainer-dropdown--PiDi3"});
;// CONCATENATED MODULE: ./src/components/student-scheduler/student-scheduler.component.tsx















const StudentScheduler = _ref => {
  let {
    isMentor,
    isFirstSpeaking,
    isVisible = true,
    speakingId,
    title,
    durationMin,
    currentProductId,
    onScheduled,
    onClose,
    onClosed
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  (0,react.useEffect)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Book_Speaking");
  }, []);
  const [availableTimeRequestTimestamp, setAvailableTimeRequestTimestamp] = (0,react.useState)(Date.now());
  const [activeTutorId, setActiveTutorId] = (0,react.useState)(null);
  const [createSpeakingSessionErrorInfo, setCreateSpeakingSessionErrorInfo] = (0,react.useState)(null);
  const [selectedTime, setSelectedTime] = (0,react.useState)(null);
  const [isSubmitDisabled, setSubmitDisabled] = (0,react.useState)(true);
  const [submitButtonLabelId, setSubmitButtonLabelId] = (0,react.useState)("studentSchedulerComponent.schedule");
  const handleNeedUpdateAvailableTime = (0,react.useCallback)(() => {
    setAvailableTimeRequestTimestamp(Date.now());
  }, []);
  const createSpeaking = useSpeakingSessionCreator({
    speakingId,
    currentProductId,
    isFirstSpeaking
  });
  const handleBlacklistChanged = (0,react.useCallback)(() => {
    if (activeTutorId === "") {
      handleNeedUpdateAvailableTime();
    }
  }, [activeTutorId, handleNeedUpdateAvailableTime]);
  const handleSubmit = (0,react.useCallback)(async () => {
    if (selectedTime === null) {
      return;
    }
    const result = await createSpeaking(selectedTime, activeTutorId);
    if (result === null) {
      return;
    }
    if ((0,Either.isRight)(result)) {
      onScheduled(result.right);
    } else {
      handleNeedUpdateAvailableTime();
      setCreateSpeakingSessionErrorInfo(result.left);
    }
  }, [activeTutorId, createSpeaking, handleNeedUpdateAvailableTime, onScheduled, selectedTime]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    isVisible,
    size: modal/* ModalSize */.Cg.Small,
    title,
    titleSize: modal/* TitleSize */.Jj.Small,
    subtitle: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: student_scheduler_module.duration,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(DurationIcon, {
        min: durationMin
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: student_scheduler_module.durationText,
        children: intl.formatMessage({
          id: "studentSchedulerComponent.duration"
        }, {
          count: durationMin
        })
      })]
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "studentSchedulerComponent.cancel"
      }),
      appearance: "secondary",
      onClick: onClose
    }, {
      text: intl.formatMessage({
        id: submitButtonLabelId
      }),
      appearance: "primary",
      disabled: isSubmitDisabled,
      onClick: handleSubmit
    }],
    onClose,
    onClosed,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: student_scheduler_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(student_scheduler_module.trainerDropdown, typography_module/* default */.Z.body2Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleSelectTutor, {
          speakingId,
          isMentor,
          activeTutorId,
          onActiveTutorIdChanged: setActiveTutorId,
          onBlacklistChanged: handleBlacklistChanged
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleSelectTime, {
        columnMode: ScheduleSelectTimeColumnMode.TwoColumnsWithSameWidth,
        activeTutorId,
        availableTimeRequestTimestamp,
        speakingId,
        createSpeakingSessionErrorInfo,
        selectedTime,
        onSelectedTimeChanged: setSelectedTime,
        onSubmitDisabledChanged: setSubmitDisabled,
        onSubmitButtonLabelChanged: setSubmitButtonLabelId,
        isMentor
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/utils/constants.ts


const CLASS_AVAILABLE_BEFORE_START_MIN = 15;
const CLASS_POPUP_BEFORE_START_MIN = 5;
const ONE_MINUTE_MS = 60 * 1e3;
// EXTERNAL MODULE: ./src/pages/beginner-pages/foreigner-sessions-page/use-foreigner-sessions.ts
var use_foreigner_sessions = __webpack_require__(43408);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInSeconds.mjs
var differenceInSeconds = __webpack_require__(24656);
;// CONCATENATED MODULE: ./src/utils/speaking-session/get-is-late-speaking-session-change.ts



function getIsLateSpeakingSessionChange(params) {
  const {
    speakingSessionStartAt,
    diffInHours,
    now
  } = {
    diffInHours: 4,
    now: /* @__PURE__ */new Date(),
    ...params
  };
  const diffInSeconds = diffInHours * 60 * 60;
  return (0,differenceInSeconds/* differenceInSeconds */.c)(speakingSessionStartAt, now) < diffInSeconds;
}
// EXTERNAL MODULE: ./src/pages/resources/hooks/use-resources-zero-balance.ts
var use_resources_zero_balance = __webpack_require__(36461);
;// CONCATENATED MODULE: ./src/widgets/foreigner-speakings/use-native-resource.ts




function useNativeResource() {
  const {
    resources
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const isEnabled = resources.enabled && resources.resourceTypes.includes("native_speaker_session");
  const resourcesZeroBalance = (0,use_resources_zero_balance/* useResourcesZeroBalance */.GG)();
  return {
    isEnabled,
    isZeroBalance: isEnabled ? (0,use_resources_zero_balance/* checkZeroBalance */.Ll)(resourcesZeroBalance, "nativeSpeakingSession") : false,
    showZeroBalanceWarning: isEnabled && resourcesZeroBalance === "nativeSpeakingSession"
  };
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/shared/foreigner-session-cancel-popup.tsx


















const CancelLessonPopup = params => {
  const {
    cancelSpeakingData
  } = params;
  const history = (0,react_router/* useHistory */.k6)();
  const intl = (0,useIntl/* default */.Z)();
  const {
    isEnabled
  } = useNativeResource();
  const {
    cancelSession,
    resetCancelingSession
  } = (0,use_foreigner_sessions/* useForeignerSpeakings */.w)();
  const {
    title,
    subtitle
  } = getTexts(cancelSpeakingData.startAt, cancelSpeakingData.theme, isEnabled, intl);
  const handleClose = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.cancelSpeakingPopup.getCloseUrl(history));
  }, [history]);
  const handleCancelSession = (0,react.useCallback)(sessionId => {
    handleClose();
    cancelSession({
      sessionId
    });
  }, [cancelSession, handleClose]);
  const handleDelete = (0,react.useCallback)(async () => {
    try {
      await (0,speaking_session_speaking_session_api/* deleteSpeakingSession */.sF)(cancelSpeakingData.sessionId);
    } catch (error) {
      logger/* Logger */.Yd.captureException(error, {
        feature: "cancelForeignerSpeakingSession"
      }, {
        block: "CancelLessonPopup",
        method: "handleDelete"
      });
      return;
    }
    toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
      id: "foreignerSessionCancelPopup.cancelSuccess.title"
    }), {
      toastId: "cancelNativeLessonSuccessToast"
    });
    handleCancelSession(cancelSpeakingData.sessionId);
    const isLateCancel = getIsLateSpeakingSessionChange({
      speakingSessionStartAt: cancelSpeakingData.startAt,
      diffInHours: 3
    });
    if (isLateCancel) {
      event_emitter/* eventEmitter */.T.emit("lateSpeakingSessionChange");
    }
  }, [cancelSpeakingData.sessionId, cancelSpeakingData.startAt, handleCancelSession, intl]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    isVisible: !get_url_search_params.getUrlSearchParams.cancelSpeakingPopup.isHidden(history),
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title,
    subtitle,
    buttons: [{
      text: intl.formatMessage({
        id: "foreignerSessionCancelPopup.cancel"
      }),
      appearance: "secondary",
      onClick: handleClose
    }, {
      text: intl.formatMessage({
        id: "foreignerSessionCancelPopup.confirm"
      }),
      appearance: "primary",
      onClick: handleDelete
    }],
    onClose: handleClose,
    onClosed: resetCancelingSession
  });
};
function getTexts(startAt, theme, isNativeResourcesEnabled, intl) {
  const startAtDateString = (0,format/* format */.WU)(startAt, "d MMMM, HH:mm", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const title = intl.formatMessage({
    id: "foreignerSessionCancelPopup.title"
  }, {
    theme,
    lessonDate: startAtDateString
  });
  if (!isNativeResourcesEnabled) {
    return {
      title,
      subtitle: intl.formatMessage({
        id: "foreignerSessionCancelPopup.defaultSubtitle"
      })
    };
  }
  const isLateCancel = getIsLateSpeakingSessionChange({
    speakingSessionStartAt: startAt,
    diffInHours: 3
  });
  return {
    title,
    subtitle: isLateCancel ? intl.formatMessage({
      id: "foreignerSessionCancelPopup.lateCancelSubtitle"
    }) : intl.formatMessage({
      id: "foreignerSessionCancelPopup.notLateCancelSubtitle"
    })
  };
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/shared/foreigner-sessions-popups.tsx












const ForeignerSessionsPopups = _ref => {
  let {
    currentProductId
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const {
    schedulingSpeakingData,
    setScheduledSpeakingId,
    resetSchedulingSpeaking,
    resetScheduledSession,
    scheduledSessionData,
    cancelSpeakingData,
    scheduleSession
  } = (0,use_foreigner_sessions/* useForeignerSpeakings */.w)();
  const handleScheduled = (0,react.useCallback)(speakingSession => {
    scheduleSession({
      speakingSession
    });
    history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getCloseUrl(history));
    history.push(get_url_search_params.getUrlSearchParams.scheduledSpeakingPopup.getOpenUrl(speakingSession.speaking.id, history));
    setScheduledSpeakingId({
      speakingId: speakingSession.speaking.id
    });
  }, [history, scheduleSession, setScheduledSpeakingId]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [schedulingSpeakingData && /* @__PURE__ */(0,jsx_runtime.jsx)(StudentScheduler, {
      isVisible: !get_url_search_params.getUrlSearchParams.schedulePopup.isHidden(history),
      speakingId: schedulingSpeakingData.id,
      title: schedulingSpeakingData.theme,
      durationMin: schedulingSpeakingData.durationMin,
      isFirstSpeaking: false,
      currentProductId,
      onScheduled: handleScheduled,
      isMentor: false,
      onClose: () => history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getCloseUrl(history)),
      onClosed: resetSchedulingSpeaking
    }), scheduledSessionData && /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleInfoModal, {
      isVisible: !get_url_search_params.getUrlSearchParams.scheduledSpeakingPopup.isHidden(history),
      title: scheduledSessionData.theme,
      startAt: scheduledSessionData.startAt,
      durationMin: scheduledSessionData.durationMin,
      availableBeforeStartMin: CLASS_AVAILABLE_BEFORE_START_MIN,
      isMentorSpeaking: false,
      onClose: () => history.push(get_url_search_params.getUrlSearchParams.scheduledSpeakingPopup.getCloseUrl(history)),
      onClosed: resetScheduledSession
    }), cancelSpeakingData && /* @__PURE__ */(0,jsx_runtime.jsx)(CancelLessonPopup, {
      cancelSpeakingData
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/foreigner-sessions-page/foreigner-sessions.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const foreigner_sessions_module = ({"root":"foreigner-sessions-module__root--RWtIl","title":"foreigner-sessions-module__title--ffuID"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/foreigner-sessions-page/foreigner-sessions.page.tsx




















const ForeignerSessionsSchedulePage = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const intl = (0,useIntl/* default */.Z)();
  const user = (0,useUser/* useUser */.aF)();
  const userAttributes = user.data?.attributes ?? null;
  const {
    initialForeignerSpeakings,
    setSchedulingSpeakingId
  } = (0,use_foreigner_sessions/* useForeignerSpeakings */.w)();
  const handleOpenSchedulePopup = speakingId => {
    history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(speakingId, history));
    setSchedulingSpeakingId({
      speakingId
    });
  };
  if (!initialForeignerSpeakings || initialForeignerSpeakings.length === 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: studentRoutePaths/* studentRoutePaths */.dR.INDEX
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
      className: foreigner_sessions_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(GoToLink, {
        link: studentRoutePaths/* studentRoutePaths */.dR.INDEX,
        text: intl.formatMessage({
          id: "backButton"
        }),
        withMarginBottom: false
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, foreigner_sessions_module.title),
        children: intl.formatMessage({
          id: "foreignerSpeakings.scheduleCardTitle"
        })
      }), initialForeignerSpeakings.map(speaking => /* @__PURE__ */(0,jsx_runtime.jsx)(InitialForeignerSpeakingCard, {
        speaking,
        onSpeakingClick: handleOpenSchedulePopup
      }, speaking.id))]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerSessionsPopups, {
      currentProductId: userAttributes?.currentProductId
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/buy-course/buy-course-wrapper.tsx






function BuyCourseWrapper() {
  const {
    [studentRoutePaths/* BuyCourseParams */.zB.CourseId]: parentProductId,
    [studentRoutePaths/* BuyCourseParams */.zB.BuyPacketProductId]: productId
  } = (0,react_router/* useParams */.UO)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(PurchasePageWrapper, {
    parentProductId,
    productId,
    giftId: null
  });
}
;// CONCATENATED MODULE: ../shared/src/api/analytics/analytics.urls.ts



const SEND_ANALYTICS_DATA = `${(0,site_utils/* getAPIPath */.NZ)()}/send-analytics-log`;
;// CONCATENATED MODULE: ../shared/src/api/analytics/analytics.api.ts





const sendAnalyticsLog = (type, payload) => (0,http/* makeRequest */.$f)(SEND_ANALYTICS_DATA, {
  method: "POST",
  body: {
    type,
    payload: JSON.stringify(payload)
  },
  responseType: es6["void"]
});
;// CONCATENATED MODULE: ../shared/src/api/analytics/types.ts


var AnalyticsLogEventType = /* @__PURE__ */(AnalyticsLogEventType2 => {
  AnalyticsLogEventType2["BuyCourse"] = "click-buy-course";
  AnalyticsLogEventType2["ClickCourseCard"] = "click-on-course-card";
  AnalyticsLogEventType2["VisitCourseSelect"] = "visit-course-select-page";
  AnalyticsLogEventType2["VisitPaymentLanding"] = "visit-payment-landing-page";
  return AnalyticsLogEventType2;
})(AnalyticsLogEventType || {});
var PaymentType = /* @__PURE__ */(PaymentType2 => {
  PaymentType2["Full"] = "balance-full-payment";
  PaymentType2["Partial"] = "balance-partial-payment";
  PaymentType2["Split"] = "split-full-payment";
  return PaymentType2;
})(PaymentType || {});
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(51461);
// EXTERNAL MODULE: ../shared/src/api/bunker/bunker.raw-model.ts
var bunker_raw_model = __webpack_require__(22554);
;// CONCATENATED MODULE: ../shared/src/api/bunker/model.ts


var AnnouncementButtonActionType = /* @__PURE__ */(AnnouncementButtonActionType2 => {
  AnnouncementButtonActionType2["ExternalLink"] = "externalLink";
  AnnouncementButtonActionType2["Close"] = "close";
  return AnnouncementButtonActionType2;
})(AnnouncementButtonActionType || {});
;// CONCATENATED MODULE: ../shared/src/api/bunker/mappers.ts





const mapAnnouncementsButtonAction = data => {
  switch (data.type) {
    case "close":
      return {
        type: AnnouncementButtonActionType.Close
      };
    case "externalLink":
      return {
        type: AnnouncementButtonActionType.ExternalLink,
        href: (0,domain.kz)(data.href)
      };
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(data);
  }
};
;// CONCATENATED MODULE: ../shared/src/api/bunker/urls.ts



const GET_ANNOUNCEMENT = `${(0,site_utils/* getBunkerNodePath */.Xv)()}/flow/announcement/${ true ? "prod" : 0}`;
const GET_ANNOUNCEMENT_MARKUPS = `${(0,site_utils/* getBunkerNodePath */.Xv)()}/flow/announcements/${"production"}`;
;// CONCATENATED MODULE: ../shared/src/api/bunker/api.ts












const getAnnouncement = () => (0,http/* makeRequest */.$f)(GET_ANNOUNCEMENT, {
  responseType: bunker_raw_model/* GetAnnouncementsResponse */.rb,
  resultMapper(rawData) {
    return rawData.announcements.map(a => ({
      id: a.id,
      header: a.header,
      bodyMarkdown: (0,domain.kz)(a.bodyMarkdown),
      endAt: new Date(a.endAt),
      buttons: a.buttons.map(b => ({
        appearance: b.appearance,
        text: b.text,
        action: mapAnnouncementsButtonAction(b.action)
      }))
    }));
  }
});
const getAnnouncementMarkups = () => (0,http/* makeRequest */.$f)(GET_ANNOUNCEMENT_MARKUPS, {
  responseType: bunker_raw_model/* GetAnnouncementMarkupsResponse */._n,
  resultMapper(rawData) {
    return Object.keys(rawData).reduce((acc, announcementId) => ({
      ...acc,
      [announcementId]: {
        title: rawData[announcementId].title,
        imageSrc: rawData[announcementId].imageSrc,
        fullImageWidth: rawData[announcementId].fullImageWidth,
        description: (0,domain.kz)(rawData[announcementId].description),
        buttons: rawData[announcementId].buttons.map(b => ({
          appearance: b.appearance,
          label: b.label,
          action: mapAnnouncementsButtonAction(b.action)
        }))
      }
    }), {});
  }
});
// EXTERNAL MODULE: ../shared/src/utils/storage/index.ts + 4 modules
var storage = __webpack_require__(81597);
;// CONCATENATED MODULE: ../shared/src/widgets/bell/announcement-popup/annoncement-button.tsx







const AnnouncementButton = _ref => {
  let {
    data,
    onClose
  } = _ref;
  switch (data.action.type) {
    case AnnouncementButtonActionType.Close:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: data.appearance,
        onClick: onClose,
        children: data.text
      });
    case AnnouncementButtonActionType.ExternalLink:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
        useNativeTag: true,
        href: data.action.href,
        target: "_blank",
        appearance: data.appearance,
        onClick: onClose,
        children: data.text
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(data.action);
  }
};
;// CONCATENATED MODULE: ../shared/src/widgets/bell/announcement-popup/announcement-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const announcement_popup_module = ({"root":"announcement-popup-module__root--IaUQt","body":"announcement-popup-module__body--bxS7y","button":"announcement-popup-module__button--pu2_2"});
;// CONCATENATED MODULE: ../shared/src/widgets/bell/announcement-popup/announcement-popup.tsx










































const AnnouncementPopup = () => {
  const [announcement, setAnnouncement] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    void getAnnouncement().then(response => {
      if ((0,Either.isLeft)(response)) {
        return;
      }
      const announcementIds = response.right.map(announcement2 => announcement2.id);
      const notShownAnnouncementIdsSet = new Set(storage/* localStorageWrapper */.Y6.announcement.updateShownIdsAndGetNotShown(announcementIds));
      setAnnouncement(response.right.find(announcement2 => notShownAnnouncementIdsSet.has(announcement2.id) && (0,isAfter/* isAfter */.A)(announcement2.endAt, /* @__PURE__ */new Date())) ?? null);
    });
  }, []);
  const handleCloseAnnouncementPopup = () => {
    if (announcement === null) {
      return;
    }
    storage/* localStorageWrapper */.Y6.announcement.addShownId(announcement.id);
    setAnnouncement(null);
  };
  if (announcement === null) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(deprecated_modal_component/* DeprecatedModal */.rr, {
    fullscreenContent: true,
    onClose: handleCloseAnnouncementPopup,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: announcement_popup_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4Accent,
        children: announcement.header
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(announcement_popup_module.body, typography_module/* default */.Z.body2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          children: announcement.bodyMarkdown
        })
      }), announcement.buttons.map((button, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: announcement_popup_module.button,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(AnnouncementButton, {
          data: button,
          onClose: handleCloseAnnouncementPopup
        })
      }, index))]
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
;// CONCATENATED MODULE: ../shared/src/blocks/image-element/image-element.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const image_element_module = ({"root":"image-element-module__root--OPxLX","fit-image":"image-element-module__fit-image--zA6bI","fitImage":"image-element-module__fit-image--zA6bI"});
;// CONCATENATED MODULE: ../shared/src/blocks/image-element/image-element.component.tsx







const ImageElement = _ref => {
  let {
    src,
    width = 800,
    height = 592,
    classes = {},
    fitImage = false
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(image_element_module, classes);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(classNames.root, {
      [image_element_module.fitImage]: fitImage
    }),
    style: {
      width,
      height,
      backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(src)
    }
  });
};
;// CONCATENATED MODULE: ../shared/src/adapters/announcements/announcements.storage-adapter.ts




const announcementDomain = (0,effector/* createDomain */.Fj)("announcement");
const $announcementMeta = announcementDomain.createStore({
  currentAnnouncementId: null
});
const setCurrentAnnouncementIdFx = announcementDomain.createEvent();
$announcementMeta.on(setCurrentAnnouncementIdFx, (state, payload) => ({
  ...state,
  currentAnnouncementId: payload
}));
const useAnnouncementsStorageAdapter = () => ({
  currentAnnouncementId: (0,effector_react/* useStore */.oR)($announcementMeta).currentAnnouncementId,
  setCurrentAnnouncementId: setCurrentAnnouncementIdFx
});
;// CONCATENATED MODULE: ../shared/src/adapters/location.api-adapter.ts



const locationApiAdapter = {
  setLocation: href => {
    window.location.href = (0,domain.kz)(href);
  }
};
;// CONCATENATED MODULE: ../shared/src/services/announcements/use-announcements.ts








const createAnnouncementsService = adapters => {
  const {
    useNotificationsStorage,
    announcementMarkupsApiService,
    useAnnouncementMarkupsStorage,
    locationService
  } = adapters;
  return function useAnnouncements2() {
    const {
      notifications,
      banners
    } = useNotificationsStorage();
    const {
      markups,
      setMarkups,
      currentAnnouncementId: currentAnnouncementIdStorage,
      setCurrentAnnouncementId
    } = useAnnouncementMarkupsStorage();
    const handleMarkAsReadAnnouncement = () => {
      setCurrentAnnouncementId(null);
    };
    const handleSetLocation = href => {
      locationService.setLocation(href);
    };
    let currentAnnouncementId = currentAnnouncementIdStorage;
    const bannerAnnouncementId = banners[0]?.payload?.announcementId;
    if (!currentAnnouncementId) {
      const lastNotification = notifications.length === 0 ? null : notifications[0];
      if (lastNotification) {
        currentAnnouncementId = lastNotification.payload.announcementId;
        setCurrentAnnouncementId(currentAnnouncementId);
        lastNotification.markAsRead();
      }
    }
    const announcement = currentAnnouncementId ? markups[currentAnnouncementId] : null;
    const bannerMarkup = markups?.[bannerAnnouncementId];
    return {
      bannerMarkup,
      announcement,
      getMarkups: announcementMarkupsApiService.getMarkups,
      setMarkups,
      handleMarkAsReadAnnouncement,
      handleSetLocation
    };
  };
};
const useAnnouncements = createAnnouncementsService({
  useNotificationsStorage: () => {
    const {
      getBellNotifications
    } = (0,useBellNotification/* useBellNotification */.C)();
    return {
      notifications: getBellNotifications(item/* AppBellItemType */.M.Announcement),
      banners: getBellNotifications(item/* AppBellItemType */.M.Banner)
    };
  },
  useAnnouncementMarkupsStorage: () => {
    const [markups, setMarkups] = (0,react.useState)({});
    const {
      currentAnnouncementId,
      setCurrentAnnouncementId
    } = useAnnouncementsStorageAdapter();
    return {
      markups,
      setMarkups,
      currentAnnouncementId,
      setCurrentAnnouncementId
    };
  },
  announcementMarkupsApiService: {
    getMarkups: () => getAnnouncementMarkups()
  },
  locationService: locationApiAdapter
});
;// CONCATENATED MODULE: ../shared/src/widgets/bell/bell-announcement-popup/use-announcement.ts





const useAnnouncement = () => {
  const {
    bannerMarkup,
    announcement,
    getMarkups,
    setMarkups,
    handleMarkAsReadAnnouncement
  } = useAnnouncements();
  (0,react.useEffect)(() => {
    void getMarkups().then(r => {
      if ((0,Either.isRight)(r)) {
        setMarkups(r.right);
      }
    });
  }, [getMarkups, setMarkups]);
  return {
    bannerMarkup,
    announcement,
    handleMarkAsReadAnnouncement
  };
};
;// CONCATENATED MODULE: ../shared/src/widgets/bell/bell-announcement-popup/utils.ts



const mapAnnouncementButton = handleMarkAsReadAnnouncement => button => ({
  text: button.label,
  appearance: button.appearance,
  href: button.action.type === AnnouncementButtonActionType.ExternalLink ? button.action.href : void 0,
  onClick: handleMarkAsReadAnnouncement,
  useNativeTag: Boolean(button.action.type === AnnouncementButtonActionType.ExternalLink)
});
;// CONCATENATED MODULE: ../shared/src/widgets/bell/bell-announcement-popup/bell-announcement-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const bell_announcement_popup_module = ({"description":"bell-announcement-popup-module__description--UwcYp"});
;// CONCATENATED MODULE: ../shared/src/widgets/bell/bell-announcement-popup/bell-announcement-popup.tsx












const BellAnnouncementPopup = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    announcement,
    handleMarkAsReadAnnouncement
  } = useAnnouncement();
  if (!announcement) {
    return null;
  }
  const imageSize = isMobile ? 128 : 256;
  const fullImageWidth = announcement?.fullImageWidth;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    showCloseButton: true,
    onClose: handleMarkAsReadAnnouncement,
    headerImage: announcement.imageSrc ? /* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
      src: announcement.imageSrc,
      width: fullImageWidth ? "unset" : imageSize,
      height: imageSize
    }) : void 0,
    title: announcement.title,
    subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      inline: true,
      className: bell_announcement_popup_module.description,
      wrapper: markdown_component/* Wrapper */.im.span,
      children: announcement.description
    }),
    buttons: announcement.buttons.map(mapAnnouncementButton(handleMarkAsReadAnnouncement))
  });
};
;// CONCATENATED MODULE: ../shared/src/hocs/with-announcements.tsx





function withAnnouncements(WrappedComponent) {
  return function WithAnnouncements(props) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(WrappedComponent, {
        ...props
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(BellAnnouncementPopup, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(AnnouncementPopup, {})]
    });
  };
}
// EXTERNAL MODULE: ../shared/src/hooks/useFetch.ts
var useFetch = __webpack_require__(29553);
;// CONCATENATED MODULE: ../ui-kit/src/container/container.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const container_module = ({"root":"container-module__root--CNU0R"});
;// CONCATENATED MODULE: ../ui-kit/src/container/container.component.tsx





const Container = _ref => {
  let {
    children,
    className
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(container_module.root, className),
    children
  });
};
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
;// CONCATENATED MODULE: ./src/components/course-select-block/course-select-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_select_block_module = ({"root":"course-select-block-module__root--WFV0c","course":"course-select-block-module__course--CrryY","course-button":"course-select-block-module__course-button--aLCja","courseButton":"course-select-block-module__course-button--aLCja","course-container":"course-select-block-module__course-container--jmzjA","courseContainer":"course-select-block-module__course-container--jmzjA","course-image":"course-select-block-module__course-image--bDfld","courseImage":"course-select-block-module__course-image--bDfld","course-title":"course-select-block-module__course-title--gQOcB","courseTitle":"course-select-block-module__course-title--gQOcB","course-description":"course-select-block-module__course-description--wx7y8","courseDescription":"course-select-block-module__course-description--wx7y8","course-additional-text":"course-select-block-module__course-additional-text--sCy0y","courseAdditionalText":"course-select-block-module__course-additional-text--sCy0y"});
;// CONCATENATED MODULE: ./src/components/course-select-block/level-block.tsx








const LevelBlock = _ref => {
  let {
    onSelect,
    courseInfo
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
    className: course_select_block_module.course,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      type: "button",
      className: classnames_default()(course_select_block_module.courseButton, accessibility_module/* default */.Z.focusVisible),
      onClick: onSelect,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: course_select_block_module.courseContainer,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: course_select_block_module.courseImage,
          style: {
            backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(courseInfo.imageUrl)
          }
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(course_select_block_module.courseTitle, typography_module/* default */.Z.headline3),
            children: courseInfo.title
          }), courseInfo.description && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(course_select_block_module.courseDescription, typography_module/* default */.Z.body2),
            children: courseInfo.description
          }), courseInfo.additionalText && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(course_select_block_module.courseAdditionalText, typography_module/* default */.Z.body2),
            children: courseInfo.additionalText
          })]
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/course-select-block/course-select-block.component.tsx










const CourseSelectBlock = _ref => {
  let {
    coursesInfo,
    onSelect
  } = _ref;
  const handleSelectCourseCard = productId => {
    void sendAnalyticsLog(AnalyticsLogEventType.ClickCourseCard, {
      productId
    });
    void onSelect(productId);
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Container, {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: course_select_block_module.root,
      children: coursesInfo.map(productCard => /* @__PURE__ */(0,jsx_runtime.jsx)(LevelBlock, {
        courseInfo: productCard,
        onSelect: () => handleSelectCourseCard(productCard.id)
      }, productCard.id))
    })
  });
};
// EXTERNAL MODULE: ../shared/src/utils/is-revision-app-version/is-revision-app-version.ts + 1 modules
var is_revision_app_version = __webpack_require__(86649);
;// CONCATENATED MODULE: ./src/hooks/use-courses-cards/types.ts


var Status = /* @__PURE__ */(Status2 => {
  Status2["Initial"] = "initial";
  Status2["Loading"] = "loading";
  Status2["Loaded"] = "loaded";
  return Status2;
})(Status || {});
// EXTERNAL MODULE: ../shared/src/errors/models/unknown.ts
var unknown = __webpack_require__(99615);
;// CONCATENATED MODULE: ./src/hooks/use-courses-cards/utils.ts







const normalizeError = error => typeof error === "object" && error instanceof Error ? error : new unknown/* UnknownError */.K();
const getProductCardsFromApi = async productIds => {
  try {
    const productCards = await (0,student_api/* getProductsCards */.s6)(productIds);
    if ((0,es6_Either/* isRight */.tO)(productCards)) {
      return productCards.right;
    }
    throw productCards.left;
  } catch (error) {
    const resultError = normalizeError(error);
    logger/* Logger */.Yd.captureException(resultError);
    return null;
  }
};
;// CONCATENATED MODULE: ./src/hooks/use-courses-cards/use-courses-cards.ts





































const useCoursesCards = () => {
  const {
    levelsSelectorIdsRedefine: redefineLevels,
    levelsSelectorAddLevels: addLevels,
    hideProducts,
    appRevisionExperiment
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const [status, setStatus] = (0,react.useState)(Status.Initial);
  const [coursesCards, setCoursesCards] = (0,react.useState)(null);
  const isLoaded = (0,react.useRef)(false);
  const getLevels = (0,react.useCallback)(async () => {
    const isModerationVersion = await (0,is_revision_app_version/* isRevisionAppVersion */.Z)(bunker_api/* getAppRevisionVersion */.Q5);
    if (isModerationVersion || appRevisionExperiment) {
      const generalInGusLevels = await (0,bunker_api/* getGeneralInGus */.l4)();
      return generalInGusLevels.sort((a, b) => (b.order_priority ?? 0) - (a.order_priority ?? 0));
    }
    const defaultLevels = await (0,bunker_api/* getGeneralEnglish */.WN)();
    if ((0,es6_Either/* isLeft */.nM)(defaultLevels)) {
      return null;
    }
    const redefinedProducts = defaultLevels?.right.map(_ref => {
      let {
        id,
        order_priority: orderPriority,
        title
      } = _ref;
      return {
        id: redefineLevels.get(id) ?? id,
        title,
        order_priority: orderPriority ?? 0
      };
    });
    return addLevels.concat(redefinedProducts).filter(_ref2 => {
      let {
        id
      } = _ref2;
      return !hideProducts.has(id);
    }).sort((a, b) => {
      const orderPriorityA = a.order_priority ?? 0;
      const orderPriorityB = b.order_priority ?? 0;
      return orderPriorityB - orderPriorityA;
    });
  }, [addLevels, appRevisionExperiment, hideProducts, redefineLevels]);
  const getProductsInfo = (0,react.useCallback)(async () => {
    const levels = await getLevels();
    if (levels === null) {
      return null;
    }
    const levelIds = levels.map(_ref3 => {
      let {
        id
      } = _ref3;
      return id;
    });
    const resultSet = new Set(levelIds);
    return getProductCardsFromApi([...resultSet]);
  }, [getLevels]);
  const fetchCards = (0,react.useCallback)(async () => {
    setStatus(Status.Loading);
    const levelsProductsInfo = await getProductsInfo();
    if (!levelsProductsInfo) {
      setCoursesCards((0,es6_Either/* left */.t$)(null));
      return;
    }
    isLoaded.current = true;
    setCoursesCards((0,es6_Either/* right */.F2)(levelsProductsInfo));
  }, [getProductsInfo]);
  (0,react.useEffect)(() => {
    if (status === Status.Loading && isLoaded.current) {
      isLoaded.current = false;
      setStatus(Status.Loaded);
    }
  }, [status, coursesCards]);
  (0,react.useEffect)(() => {
    if (status === Status.Initial) {
      void fetchCards();
    }
  }, [fetchCards, status]);
  return (0,react.useMemo)(() => coursesCards, [coursesCards]);
};
;// CONCATENATED MODULE: ./src/pages/course-select-page/course-select.page.tsx





















const CourseSelectContent = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const placementFetcher = (0,useFetch/* useFetch */.i)(placement_api/* placeUserIntoLevel */.k);
  const user = (0,useUser/* useUser */.aF)();
  (0,react.useEffect)(() => {
    void sendAnalyticsLog(AnalyticsLogEventType.VisitCourseSelect, {
      page: "course-select"
    });
  }, []);
  const selectCourse = (0,react.useCallback)(async id => {
    if (placementFetcher.state !== useFetch/* State */.Z.Loading && user.state === useUser/* State */.ZM.Loaded) {
      await placementFetcher.fetch(id);
      await user.functions.setUserAttributesAndCurrentProduct();
      history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
    }
  }, [history, placementFetcher, user.functions, user.state]);
  const coursesCards = useCoursesCards();
  if (placementFetcher.state === useFetch/* State */.Z.Loading || placementFetcher.state === useFetch/* State */.Z.Loaded || coursesCards === null) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
        doNotWrapChildrenWithLayout: true
      },
      header: {
        hideNavigation: true,
        isCourseSelectPage: true
      },
      main: {
        hideGrammarGuideButton: true
      },
      footer: {
        hideFooter: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {})
    });
  }
  if ((0,Either.isLeft)(coursesCards)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
        doNotWrapChildrenWithLayout: true
      },
      header: {
        hideNavigation: true,
        isCourseSelectPage: true
      },
      main: {
        hideGrammarGuideButton: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(LoadError, {
        onReload: reload_page/* reloadPage */.s
      })
    });
  }
  if (placementFetcher.state === useFetch/* State */.Z.Error) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
        doNotWrapChildrenWithLayout: true
      },
      header: {
        hideNavigation: true,
        isCourseSelectPage: true
      },
      main: {
        hideGrammarGuideButton: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(LoadError, {
        onReload: reload_page/* reloadPage */.s
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
      doNotWrapChildrenWithLayout: true
    },
    header: {
      hideNavigation: true,
      isCourseSelectPage: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(CourseSelectBlock, {
      coursesInfo: coursesCards.right,
      onSelect: selectCourse
    })
  });
};
const CourseSelectPage = withAnnouncements(CourseSelectContent);
;// CONCATENATED MODULE: ./src/components/hint/hint.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const hint_hint_module = ({"root":"hint-module__root--kCtDH"});
;// CONCATENATED MODULE: ./src/components/hint/hint.tsx






const hint_Hint = _ref => {
  let {
    tooltip,
    className,
    children
  } = _ref;
  const [hintVisible, setHintVisible] = (0,react.useState)(false);
  const [spanLeft, setSpanLeft] = (0,react.useState)(0);
  const [tooltipLeft, setTooltipLeft] = (0,react.useState)(0);
  const getTooltipContainer = triggerNode => triggerNode.parentNode;
  const left = (0,react.useMemo)(() => spanLeft - tooltipLeft, [spanLeft, tooltipLeft]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    className: hint_hint_module.root,
    style: {
      "--left": `${left}px`
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_tooltip/* Tooltip */.u, {
      onPopupAlign: element => {
        setTooltipLeft(element?.getBoundingClientRect()?.left ?? 0);
      },
      getTooltipContainer,
      visible: hintVisible,
      onVisibleChange: () => setHintVisible(prev => !prev),
      ...tooltip,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        ref: element => {
          setSpanLeft(element?.getBoundingClientRect()?.left ?? 0);
        },
        className,
        children
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/email-agreement-checkbox/email-agreement-checkbox.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const email_agreement_checkbox_module = ({"checkbox-label":"email-agreement-checkbox-module__checkbox-label--bMh11","checkboxLabel":"email-agreement-checkbox-module__checkbox-label--bMh11","icon":"email-agreement-checkbox-module__icon--delAm","hint-text":"email-agreement-checkbox-module__hint-text--kBcMl","hintText":"email-agreement-checkbox-module__hint-text--kBcMl"});
;// CONCATENATED MODULE: ./src/components/email-agreement-checkbox/email-agreement-checkbox.component.tsx










const EmailAgreementCheckbox = _ref => {
  let {
    value,
    onChange
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(src_checkbox/* Checkbox */.X, {
    size: "small",
    onChange,
    checked: value,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "newbie.wantReceiveEmails"
    }), constants/* NBSP */.Xz, /* @__PURE__ */(0,jsx_runtime.jsx)(hint_Hint, {
      tooltip: {
        tooltipOverlayClassName: email_agreement_checkbox_module.hintText,
        trigger: "click",
        placement: "top",
        autoWidth: isMobile,
        overlay: intl.formatMessage({
          id: "newbie.wantReceiveEmailHint"
        })
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: email_agreement_checkbox_module.icon,
        name: "info",
        size: "small"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/user-agreement-checkbox/user-agreement-checkbox.component.tsx







const UserAgreementCheckbox = _ref => {
  let {
    value,
    onChange,
    disabled = false
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
    disabled,
    onChange,
    size: "small",
    checked: value,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      children: intl.formatMessage({
        id: "newbie.userAgreementAndOffer"
      }, {
        offer: (0,domain_urls/* getExternalUrl */.Eg)("offer"),
        lawInfo: (0,domain_urls/* getExternalUrl */.Eg)("lawInfo")
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/hooks/useA2PlusFlippedExperiment.ts





const useA2PlusFlippedExperiment = () => {
  const userAttributes = useUserAttributes();
  const {
    isA2PlusFlippedExperimentActive,
    a2PlusFlippedExperimentConfig
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const isCurrentStudentLevelA2Flipped = (0,react.useMemo)(() => userAttributes.data?.currentProductId === a2PlusFlippedExperimentConfig.productId, [a2PlusFlippedExperimentConfig.productId, userAttributes.data?.currentProductId]);
  const isExperimentLevel = (0,react.useCallback)(levelId => levelId === a2PlusFlippedExperimentConfig.productId, [a2PlusFlippedExperimentConfig.productId]);
  return (0,react.useMemo)(() => ({
    active: isCurrentStudentLevelA2Flipped && isA2PlusFlippedExperimentActive,
    trialSpeakingId: a2PlusFlippedExperimentConfig.trialSpeakingId,
    trialChapterIds: a2PlusFlippedExperimentConfig.trialChapterIds,
    text: {
      startStory: "a2FlippedExperiment.chapterButtons.startStory",
      scheduleSessions: "a2FlippedExperiment.chapterButtons.scheduleSession"
    },
    isExperimentLevel
  }), [a2PlusFlippedExperimentConfig.trialChapterIds, a2PlusFlippedExperimentConfig.trialSpeakingId, isA2PlusFlippedExperimentActive, isCurrentStudentLevelA2Flipped, isExperimentLevel]);
};
;// CONCATENATED MODULE: ./src/pages/newbie/newbie.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const newbie_page_module = ({"modal":"newbie-page-module__modal--ZNdI_","modal-title":"newbie-page-module__modal-title--LvI7H","modalTitle":"newbie-page-module__modal-title--LvI7H","modal-subtitle":"newbie-page-module__modal-subtitle--c5aWQ","modalSubtitle":"newbie-page-module__modal-subtitle--c5aWQ","modal-button":"newbie-page-module__modal-button--Q9YVg","modalButton":"newbie-page-module__modal-button--Q9YVg","mobile-root":"newbie-page-module__mobile-root--HCPSz","mobileRoot":"newbie-page-module__mobile-root--HCPSz"});
;// CONCATENATED MODULE: ./src/pages/newbie/newbie.page.tsx





















































const NewbiePageContent = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    skipTrial,
    openPageAfterPlacement,
    appRevisionExperiment
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const a2PlusFlippedExperiment = useA2PlusFlippedExperiment();
  const {
    get: getProduct
  } = (0,useProducts/* useProducts */.rn)();
  const history = (0,react_router/* useHistory */.k6)();
  const [userAgreement, setUserAgreement] = (0,react.useState)(!(0,domain/* isKzDomain */.k)());
  const [emailAgreement, setEmailAgreement] = (0,react.useState)(!(0,domain/* isKzDomain */.k)());
  const [newbieModalVisibility, setNewbieModalVisibility] = (0,react.useState)(user.data?.me?.user?.role === entities_user/* UserRole */.i4.ROLE_NEWBIE);
  (0,react.useEffect)(() => {
    void sendAnalyticsLog(AnalyticsLogEventType.VisitCourseSelect, {
      page: "newbie"
    });
  }, []);
  const placementFetcher = (0,useFetch/* useFetch */.i)(placement_api/* placeUserIntoLevel */.k);
  const disabled = !userAgreement || user.state !== "loaded";
  const showPromoCodePopup = get_url_search_params.getUrlSearchParams.promocodePopup.isOpen(history);
  const coursesInfo = useCoursesCards();
  (0,react.useEffect)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Start_Onboarding");
  }, []);
  const onSubmitAgreement = (0,react.useCallback)(async () => {
    if (user.state !== "loaded") {
      throw new Error(`NewbiePage: user is not loaded, userState = ${user.state}`);
    }
    await user.functions.submitAgreements(userAgreement, emailAgreement);
    conversionsMetrics/* ConversionsMetrics */.l.userAgreementAccepted();
    setNewbieModalVisibility(false);
    if (get_url_search_params.getUrlSearchParams.retPath.haveRetPath(history)) {
      get_url_search_params.getUrlSearchParams.retPath.goToRetPath(history);
    }
  }, [emailAgreement, history, user.functions, user.state, userAgreement]);
  const selectCourse = (0,react.useCallback)(
  // eslint-disable-next-line sonarjs/cognitive-complexity
  async id => {
    if (coursesInfo === null || (0,Either.isLeft)(coursesInfo)) {
      logger/* Logger */.Yd.captureException(new Error("Wrong coursesInfo state"), {
        id,
        coursesInfo
      }, {
        block: "NewbiePage",
        method: "selectCourse"
      });
      return;
    }
    const selectedLevel = coursesInfo.right.find(course => course.id === id);
    if (selectedLevel) {
      const selectedLevelId = selectedLevel.id;
      const productInfo = await getProduct(selectedLevelId);
      if (placementFetcher.state !== useFetch/* State */.Z.Loading && productInfo !== null) {
        await placementFetcher.fetch(selectedLevelId);
      }
      if (productInfo !== null) {
        const goal = productInfo.courseSelect?.onboardingYmGoal ?? null;
        if (goal !== null) {
          (0,yandexMetrica/* ymGoalCustom */.qN)(goal);
        }
      }
      if (a2PlusFlippedExperiment.isExperimentLevel(selectedLevelId)) {
        void user.functions?.reloadMe();
        return;
      }
      void conversionsMetrics/* ConversionsMetrics */.l.levelAccepted(selectedLevelId);
      if (openPageAfterPlacement.has(selectedLevelId)) {
        window.location.href = openPageAfterPlacement.get(selectedLevelId);
        return;
      }
      if (productInfo?.onboarding?.actionAfterPlacement) {
        const type = productInfo?.onboarding.actionAfterPlacement.type;
        switch (type) {
          case student_model/* ActionAfterPlacementType */.gS.OpenChapter:
            {
              window.location.href = `${(0,site_utils/* getAppPath */.bY)()}${studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(selectedLevelId, productInfo?.onboarding.actionAfterPlacement.chapterId)}`;
              return;
            }
          case student_model/* ActionAfterPlacementType */.gS.OpenDashboard:
            {
              await user.functions?.reloadMe();
              void user.functions?.setUserAttributesAndCurrentProduct();
              return;
            }
          case student_model/* ActionAfterPlacementType */.gS.OpenPaymentPage:
            {
              if (productInfo?.paymentLandingId) {
                history.push(studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING(productInfo.paymentLandingId));
                return;
              }
              history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
              return;
            }
          default:
            throw new unhandled_case/* UnhandledCaseError */.H(type);
        }
      }
      if (skipTrial) {
        window.location.href = `${(0,site_utils/* getAppPath */.bY)()}${studentRoutePaths/* studentRoutePaths */.dR.BUY_PRODUCT()}`;
        return;
      }
      const isRevisionVersion = await (0,is_revision_app_version/* isRevisionAppVersion */.Z)(bunker_api/* getAppRevisionVersion */.Q5);
      const contentData = await (0,student_api/* getAvailableContent */.A4)("DESC", Boolean(appRevisionExperiment || isRevisionVersion));
      if ((0,Either.isRight)(contentData)) {
        const firstChapter = contentData.right.currentChapters.filter(chapter => chapter.type === student_model/* ChapterItemType */.a.Chapter)[0];
        if (firstChapter && firstChapter.type === student_model/* ChapterItemType */.a.Chapter) {
          const link = `${(0,site_utils/* getAppPath */.bY)()}${studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(firstChapter.productId, firstChapter.chapterId)}`;
          window.location.href = get_url_search_params.getUrlSearchParams.openHelp.getLinkWithOpenHelp(link, history);
          return;
        }
      }
      void user.functions?.reloadMe();
    }
  }, [a2PlusFlippedExperiment, appRevisionExperiment, coursesInfo, getProduct, history, openPageAfterPlacement, placementFetcher, skipTrial, user.functions]);
  if (user.data?.attributes.currentProductId && user.data.me.user?.role !== "newbie") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: studentRoutePaths/* studentRoutePaths */.dR.INDEX
    });
  }
  if (placementFetcher.state === useFetch/* State */.Z.Loading || coursesInfo === null) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
  }
  if (placementFetcher.state === useFetch/* State */.Z.Error) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
      },
      header: {
        hideNavigation: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(LoadError, {
        onReload: reload_page/* reloadPage */.s
      })
    });
  }
  if ((0,Either.isLeft)(coursesInfo)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
      },
      header: {
        hideNavigation: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(LoadError, {
        onReload: reload_page/* reloadPage */.s
      })
    });
  }
  const content = /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(CourseSelectBlock, {
      coursesInfo: coursesInfo.right,
      onSelect: selectCourse
    }), newbieModalVisibility && /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      onClose: function_utils/* emptyFunction */.Bi,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: newbie_page_module.modal,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(newbie_page_module.modalTitle, typography_module/* default */.Z.headline4Accent),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "newbieNonSubscriptionModelPage.modalTitle"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(newbie_page_module.modalSubtitle, typography_module/* default */.Z.body2),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "newbieNonSubscriptionModelPage.modalText"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: newbie_page_module.modalButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "primary",
            disabled,
            onClick: onSubmitAgreement,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "newbieNonSubscriptionModelPage.modalButton"
            })
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(UserAgreementCheckbox, {
            onChange: setUserAgreement,
            value: userAgreement
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(EmailAgreementCheckbox, {
            value: emailAgreement,
            onChange: setEmailAgreement
          })
        })]
      })
    }), !newbieModalVisibility && showPromoCodePopup && /* @__PURE__ */(0,jsx_runtime.jsx)(promo_code_popup_component/* PromoCodePopup */.V, {
      backPath: get_url_search_params.getUrlSearchParams.promocodePopup.getCloseUrl(history),
      customSuccessButtonTextId: "promoCodePopup.continue",
      customHeaderId: "promoCodePopup.headerActivateBonus"
    })]
  });
  if (isMobile) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
      },
      header: {
        hideNavigation: true,
        hideMenuButton: true,
        hideCourseSelectButton: true
      },
      main: {
        hideGrammarGuideButton: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: newbie_page_module.mobileRoot,
        children: content
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    header: {
      hideNavigation: true,
      hideMenuButton: true,
      hideCourseSelectButton: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    children: content
  });
};
const NewbiePage = withAnnouncements(NewbiePageContent);
// EXTERNAL MODULE: ./src/components/app-help/use-app-help-button.ts
var use_app_help_button = __webpack_require__(59495);
;// CONCATENATED MODULE: ./src/pages/notes/components/error-message/error-message.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_message_module = ({"centralized-container":"error-message-module__centralized-container--Tbjrh","centralizedContainer":"error-message-module__centralized-container--Tbjrh","error-title":"error-message-module__error-title--ziKD6","errorTitle":"error-message-module__error-title--ziKD6","error-subtitle":"error-message-module__error-subtitle--eHJnq","errorSubtitle":"error-message-module__error-subtitle--eHJnq","error-actions":"error-message-module__error-actions--fokUo","errorActions":"error-message-module__error-actions--fokUo","retry-btn":"error-message-module__retry-btn--c6jmK","retryBtn":"error-message-module__retry-btn--c6jmK","empty-state-subtitle":"error-message-module__empty-state-subtitle--jjDxM","emptyStateSubtitle":"error-message-module__empty-state-subtitle--jjDxM"});
;// CONCATENATED MODULE: ./src/pages/notes/components/error-message/error-message.component.tsx









const ErrorMessage = _ref => {
  let {
    fetchNotes
  } = _ref;
  const {
    open: openHelpButton
  } = (0,use_app_help_button/* useAppHelpButton */.f)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: error_message_module.centralizedContainer,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(typography_module/* default */.Z.headline3, error_message_module.errorTitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "notesPage.errorTitle"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(typography_module/* default */.Z.headline4, error_message_module.errorSubtitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "notesPage.errorSubtitle"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: error_message_module.errorActions,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        className: error_message_module.retryBtn,
        appearance: "primary",
        onClick: fetchNotes,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "notesPage.retryButtonMessage"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "secondary",
        onClick: openHelpButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "notesPage.supportButtonMessage"
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/notes/components/error-message/no-notes-message.component.tsx







const NoNotesMessage = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
  className: error_message_module.centralizedContainer,
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    className: classnames_default()(error_message_module.errorTitle, typography_module/* default */.Z.headline4Accent),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "notesPage.noNotesMessage"
    })
  }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    className: classnames_default()(typography_module/* default */.Z.body2, error_message_module.emptyStateSubtitle),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "notesPage.emptySubtitle"
    })
  })]
});
;// CONCATENATED MODULE: ./src/pages/notes/components/note-content/note-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const note_content_module = ({"notes":"note-content-module__notes--IXm7X","note":"note-content-module__note--l_iZo","text-content":"note-content-module__text-content--alrVV","textContent":"note-content-module__text-content--alrVV","images-content":"note-content-module__images-content--XyYpZ","imagesContent":"note-content-module__images-content--XyYpZ","content":"note-content-module__content--BQ8zi"});
;// CONCATENATED MODULE: ./src/pages/notes/components/note-content/note-content.component.tsx














const ImagesViewer = (0,react.lazy)(() => Promise.all(/* import() | images-viewer */[__webpack_require__.e(497), __webpack_require__.e(866)]).then(__webpack_require__.bind(__webpack_require__, 86010)));
const NoteContent = _ref => {
  let {
    notes
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  if (!notes) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: note_content_module.notes,
    role: "tabpanel",
    children: notes.map(note => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: note_content_module.note,
      children: [note.content.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: classnames_default()(note_content_module.content, note_content_module.textContent, typography_module/* default */.Z.body1, {
          [typography_module/* default */.Z.body2]: isMobile
        }),
        children: (0,domain.kz)(note.content)
      }), note.attachments.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(note_content_module.content, note_content_module.imagesContent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(react.Suspense, {
          fallback: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {}),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(ImagesViewer, {
            textConstants: {
              imageAlt: intl.formatMessage({
                id: "notesPage.attachmentAltText"
              }),
              mobileNavText: intl.formatMessage({
                id: "imageViewer.mobileNavText"
              })
            },
            isMobile,
            urls: note.attachments.map(_ref2 => {
              let {
                url
              } = _ref2;
              return url;
            })
          })
        })
      })]
    }, note.id))
  });
};
// EXTERNAL MODULE: ../ui-kit/src/select/constants.ts
var select_constants = __webpack_require__(65866);
// EXTERNAL MODULE: ../ui-kit/src/select/select.tsx + 3 modules
var select_select = __webpack_require__(31727);
// EXTERNAL MODULE: ../../node_modules/date-fns/parse.mjs + 42 modules
var parse = __webpack_require__(23589);
;// CONCATENATED MODULE: ./src/pages/notes/components/notes-navigation/utils.ts




const formatMonth = (month, locale) => {
  const date = (0,parse/* parse */.Qc)(month, "MM/yyyy", /* @__PURE__ */new Date());
  const isCurrentYear = date.getFullYear() === ( /* @__PURE__ */new Date()).getFullYear();
  return (0,format/* format */.WU)(date, isCurrentYear ? "LLLL" : "LLLL yyyy", {
    locale: (0,utils_locale/* getDateFnsLocale */.G)(locale)
  });
};
;// CONCATENATED MODULE: ./src/pages/notes/components/notes-navigation/notes-navigation.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notes_navigation_module = ({"navigation":"notes-navigation-module__navigation--lEPg8","notes-dates":"notes-navigation-module__notes-dates--rGfGt","notesDates":"notes-navigation-module__notes-dates--rGfGt","month-select":"notes-navigation-module__month-select--KjLn9","monthSelect":"notes-navigation-module__month-select--KjLn9","noteDateBtn":"notes-navigation-module__noteDateBtn--uXUlj"});
;// CONCATENATED MODULE: ./src/pages/notes/components/notes-navigation/notes-navigation.component.tsx














const NotesNavigation = _ref => {
  let {
    notes,
    selectedMonth,
    selectedDay,
    setSelectedDay,
    setSelectedMonth
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  if (!notes || !selectedMonth || !selectedDay) {
    return null;
  }
  const months = [...notes.keys()];
  const days = [...(notes.get(selectedMonth)?.keys() ?? [])];
  const monthsOptions = months.map(month => ({
    title: formatMonth(month, intl.locale),
    value: month
  }));
  const selectMonth = val => {
    (0,yandexMetrica/* ymGoal */.qf)("notes_month_filter");
    setSelectedMonth(val);
  };
  const selectDay = val => {
    (0,yandexMetrica/* ymGoal */.qf)("notes_day_filter");
    setSelectedDay(val);
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("nav", {
    className: notes_navigation_module.navigation,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(select_select/* Select */.P, {
      className: notes_navigation_module.monthSelect,
      withoutBoxShadow: true,
      options: monthsOptions,
      onChange: selectMonth,
      value: selectedMonth,
      theme: select_constants/* SelectTheme */.n.Grey,
      trigger: /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: typography_module/* default */.Z.body2Accent,
          children: formatMonth(selectedMonth, intl.locale)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "simple-arrow-down",
          size: "small"
        })]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: notes_navigation_module.notesDates,
      role: "tablist",
      children: days.map(day => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          "aria-label": intl.formatMessage({
            id: "notesPage.selectDayAriaLabel"
          }),
          role: "tab",
          "aria-selected": selectedDay === day,
          className: notes_navigation_module.noteDateBtn,
          onClick: () => selectDay(day),
          appearance: selectedDay === day ? "primary" : "secondary",
          children: day
        })
      }, day))
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/notes/notes-page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notes_page_module = ({"layout":"notes-page-module__layout--wM9cm","back-link-container":"notes-page-module__back-link-container--a9vJg","backLinkContainer":"notes-page-module__back-link-container--a9vJg","centralized-container":"notes-page-module__centralized-container--JgkEJ","centralizedContainer":"notes-page-module__centralized-container--JgkEJ"});
;// CONCATENATED MODULE: ./src/pages/notes/components/notes/notes.component.tsx










const Notes = _ref => {
  let {
    loadingState,
    notes,
    selectedDay,
    selectedMonth,
    setSelectedMonth,
    setSelectedDay,
    currentNotes,
    isEmpty,
    error
  } = _ref;
  switch (loadingState) {
    case useFetch/* State */.Z.Initial:
    case useFetch/* State */.Z.Loading:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
    case useFetch/* State */.Z.Loaded:
      if (isEmpty) {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(NoNotesMessage, {});
      }
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: notes_page_module.layout,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(NotesNavigation, {
          notes,
          selectedMonth,
          setSelectedMonth,
          selectedDay,
          setSelectedDay
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(NoteContent, {
          notes: currentNotes
        })]
      });
    case useFetch/* State */.Z.Error:
      throw error;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(loadingState);
  }
};
;// CONCATENATED MODULE: ./src/pages/notes/use-notes.ts







const useNotes = () => {
  const [selectedMonth, setSelectedMonth] = (0,react.useState)();
  const [selectedDay, setSelectedDay] = (0,react.useState)();
  const user = (0,useUser/* useUser */.aF)();
  const userId = user.data?.me.user?.id;
  const fetcher = (0,useFetch/* useFetch */.i)(speaking_session_speaking_session_api/* getSpeakingSessionNotes */.jR);
  const notes = fetcher.data;
  const fetchNotes = (0,react.useCallback)(async () => {
    if (!userId) {
      return;
    }
    if (fetcher.state !== useFetch/* State */.Z.Loading) {
      await fetcher.fetch(userId);
    }
  }, [fetcher, userId]);
  (0,react.useEffect)(() => {
    if (fetcher.state === useFetch/* State */.Z.Initial && userId) {
      void fetcher.fetch(userId);
    }
  }, [fetcher, userId]);
  (0,react.useEffect)(() => {
    if (fetcher.data) {
      const [firstMonth] = fetcher.data.keys();
      setSelectedMonth(firstMonth);
    }
  }, [fetcher.data]);
  (0,react.useEffect)(() => {
    if (notes && selectedMonth) {
      const month = notes.get(selectedMonth);
      const [firstDay] = month.keys();
      setSelectedDay(firstDay);
    }
  }, [notes, selectedMonth]);
  return (0,react.useMemo)(() => {
    const fetcherState = fetcher.state;
    switch (fetcherState) {
      case useFetch/* State */.Z.Loading:
      case useFetch/* State */.Z.Initial:
        return {
          loadingState: fetcher.state,
          fetchNotes
        };
      case useFetch/* State */.Z.Error:
        return {
          error: fetcher.error,
          loadingState: fetcher.state,
          fetchNotes
        };
      case useFetch/* State */.Z.Loaded:
        return {
          fetchNotes,
          selectedDay,
          selectedMonth,
          setSelectedMonth,
          setSelectedDay,
          currentNotes: selectedMonth && selectedDay ? fetcher.data.get(selectedMonth)?.get(selectedDay) : void 0,
          notes: fetcher.data,
          isEmpty: !fetcher.data.size,
          loadingState: fetcher.state
        };
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(fetcherState);
    }
  }, [fetchNotes, fetcher.data, fetcher.error, fetcher.state, selectedDay, selectedMonth]);
};
;// CONCATENATED MODULE: ./src/pages/notes/notes.page.tsx

















const NotesPage = () => {
  const notes = useNotes();
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    footer: {
      hideFooter: notes.loadingState === useFetch/* State */.Z.Loading
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: notes_page_module.backLinkContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(GoToLink, {
        withMarginBottom: false,
        link: get_url_search_params.getUrlSearchParams.retPath.getRetPath(history) ?? studentRoutePaths/* studentRoutePaths */.dR.INDEX,
        text: intl.formatMessage({
          id: "backButton"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
      onError: logger/* Logger */.Yd.captureException,
      onErrorContent: () => /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorMessage, {
        fetchNotes: notes.fetchNotes
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Notes, {
        ...notes
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-onboarding-trainer-machine.ts










const ANSWER_EVENT = "onboarding_result";
const create_onboarding_trainer_machine_updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)(ANSWER_EVENT);
const create_onboarding_trainer_machine_services = {
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: create_trainer_machine/* services */.uZ[trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER],
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: async () => {
    const response = await (0,bunker_api/* getOnboardingChapterState */.Yv)();
    return {
      chapterData: response.activities,
      userData: []
    };
  }
};
const create_onboarding_trainer_machine_guards = {
  ...create_trainer_machine/* guards */.l8,
  [trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsAllNextActivitiesEmptyAfterFilterGuard */.NZ)(ANSWER_EVENT),
  [trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsNextActivityEmptyAfterFilterGuard */.b2)(ANSWER_EVENT)
};
const create_onboarding_trainer_machine_baseTrainerActions = create_trainer_machine/* actions */.Nw;
const create_onboarding_trainer_machine_actions = {
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getBlockFilterAction */.XI)(ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,xstate_es/* assign */.f0)((context, event) => ({
    activities: event.data.chapterData,
    chapterStudentEvents: {},
    activityIndex: 0,
    blockIndex: 0
  })),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: create_onboarding_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
  [trainer_machine_consts/* ACTIONS */.aO.PUSH_CHAPTER_ANSWER]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getChapterAnswerPusher */.hf)(ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: create_onboarding_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: create_onboarding_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.RESET_TRAINER]: (0,xstate_es/* assign */.f0)({
    activityIndex: 0,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX]: create_onboarding_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX_TIL_NOT_EMPTY]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getIncrementActivityIndexTilNotEmptyAssignment */.OQ)(ANSWER_EVENT))
};
const onboardingTrainerMachine = (0,Machine/* createMachine */.C)({
  id: "onboarding-trainer",
  initial: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA,
  states: {
    [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
        onDone: [{
          actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }],
        onError: trainer_machine_consts/* STATES */.PO.ERROR
      }
    },
    [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS],
    [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
        data: getSavingProgressPreparator("onboarding_progress"),
        onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS,
        onError: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
      }
    },
    [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
        data: getAnswerDataSaverPreparator(ANSWER_EVENT),
        onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS,
        onError: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
      }
    },
    [trainer_machine_consts/* STATES */.PO.ERROR]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.ERROR]
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER],
    [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), create_onboarding_trainer_machine_actions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    },
    [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
      actions: [(0,xstate_es/* assign */.f0)({
        chapterStudentEvents: create_onboarding_trainer_machine_updateStudentEvent,
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER
    }
  }
});
const createOnboardingTrainerMachine = intl => onboardingTrainerMachine.withConfig({
  actions: create_onboarding_trainer_machine_actions,
  services: create_onboarding_trainer_machine_services,
  guards: create_onboarding_trainer_machine_guards
}).withContext({
  mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
  chapterStudentEvents: {},
  currentBlocks: [],
  activities: [],
  progress: 0,
  blockIndex: 0,
  activityIndex: 0,
  scrollToBlockIndex: 0,
  filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("trainer_result"),
  intl
});
;// CONCATENATED MODULE: ./src/pages/onboarding/onboarding.page.tsx

























const ONBOARDING_ANSWER_EVENT = "onboarding_result";
const OnboardingPage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const userAttributes = useUserAttributes();
  const needOnboarding = userAttributes.data?.needOnboarding;
  const needRedirectToIndex = needOnboarding === void 0 ? false : !needOnboarding;
  const {
    levelsSelectorIdsRedefine
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const machine = (0,react.useMemo)(() => createOnboardingTrainerMachine(intl), [intl]);
  const [state, send] = (0,useMachine/* useMachine */.e)(machine);
  const history = (0,react_router/* useHistory */.k6)();
  const {
    activities,
    activityIndex,
    currentBlocks: condBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Start_Onboarding");
  }, []);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const onSubmitAnswer = (0,react.useCallback)(_ref => {
    let {
      answer,
      correct,
      typo,
      blockId
    } = _ref;
    return send(product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER, {
      data: {
        answer,
        blockId,
        // eslint-disable-next-line camelcase
        activityId: currentActivity?.activity_id,
        courseId: state.context.chapterInfo?.courseId,
        levelId: state.context.chapterInfo?.levelId,
        topicId: state.context.chapterInfo?.topicId,
        correct,
        typo
      }
    });
  }, [currentActivity, send, state.context.chapterInfo]);
  const handleOutroAction = (0,react.useCallback)(a => {
    switch (a.type) {
      case "NEXT_BLOCK":
        {
          send(product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED);
          break;
        }
      case "OPEN_CHAPTER":
        {
          if (a.goalName) {
            (0,yandexMetrica/* ymGoal */.qf)(a.goalName);
          }
          const newLevel = levelsSelectorIdsRedefine.get(a.levelId) ?? a.levelId;
          void (0,placement_api/* placeUserIntoLevel */.k)(newLevel).then(() => {
            userAttributes.reload();
          });
          break;
        }
      default:
        break;
    }
  }, [levelsSelectorIdsRedefine, send, userAttributes]);
  (0,react.useEffect)(() => {
    if (needRedirectToIndex) {
      history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
    }
  }, [history, needRedirectToIndex]);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    const blockEvents = state.context.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === ONBOARDING_ANSWER_EVENT) ?? [];
    const answerJSONString = answerEvent[answerEvent.length - 1]?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [state.context.chapterStudentEvents]);
  const {
    handleResetAnswer,
    handleNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  switch (state.value) {
    case trainer_machine_consts/* STATES */.PO.ERROR:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "error"
      });
    case trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA:
    case trainer_machine_consts/* STATES */.PO.SAVING_ANSWER:
    case trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
        oneElementPerScreen: true,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
          onResetAnswer: blockId => {
            const currentActivityId = currentActivity?.activity_id;
            if (currentActivityId) {
              handleResetAnswer(blockId, currentActivityId);
            }
          },
          onPrevActivityClick: handlePrevActivityClick,
          blocks: condBlocks,
          activityType: currentActivity?.type ?? "story",
          onSubmitAnswer,
          currentActivityIndex: state.context.activityIndex,
          blockIndex: state.context.blockIndex,
          onNextBlockClick: handleNextBlockClick,
          onPrevBlockClick: handlePrevBlockClick,
          renderType: types/* RenderType */.y.ONE_BLOCK_PER_PAGE,
          mechanicMachineCreator: state.context.mechanicMachineCreator,
          onOutroActionTrigger: handleOutroAction,
          getBlockAnswerInfo,
          showPrevButton: false,
          showNextButton: false,
          showSkipButton: false,
          showResetButton: false,
          showSubmitButton: true,
          showAudioFooter: false,
          userEnvironment: types/* UserEnvironment */.P.Student,
          isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
          progress: state.context.progress
        })]
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "onboarding.page",
        state: state.value
      });
  }
};
// EXTERNAL MODULE: ./src/api/bunker/bunker.model.ts
var bunker_model = __webpack_require__(71223);
;// CONCATENATED MODULE: ./src/components/enter-promocode-button-link/enter-promocode-button-link.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const enter_promocode_button_link_module = ({"promocode-button-content":"enter-promocode-button-link-module__promocode-button-content--P4GPU","promocodeButtonContent":"enter-promocode-button-link-module__promocode-button-content--P4GPU","promocode-button-icon":"enter-promocode-button-link-module__promocode-button-icon--s45Ti","promocodeButtonIcon":"enter-promocode-button-link-module__promocode-button-icon--s45Ti","promocode-button-text":"enter-promocode-button-link-module__promocode-button-text--EwLQW","promocodeButtonText":"enter-promocode-button-link-module__promocode-button-text--EwLQW","hide-text":"enter-promocode-button-link-module__hide-text--phTK4","hideText":"enter-promocode-button-link-module__hide-text--phTK4"});
;// CONCATENATED MODULE: ./src/components/enter-promocode-button-link/enter-promocode-button-link.component.tsx













const EnterPromoCodeButtonLink = _ref => {
  let {
    className,
    appearance,
    size = "medium",
    hideTextOnTouch = true,
    onClick
  } = _ref;
  const {
    isDesktop,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const history = (0,react_router/* useHistory */.k6)();
  const buttonSize = (0,react.useMemo)(() => {
    if (isDesktop) {
      return size;
    }
    if (size === "small") {
      if (!hideTextOnTouch) {
        return;
      }
      return "small-circle";
    }
  }, [hideTextOnTouch, isDesktop, size]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
    className,
    size: buttonSize,
    appearance,
    href: get_url_search_params.getUrlSearchParams.promocodePopup.getOpenUrl(history),
    onClick,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: enter_promocode_button_link_module.promocodeButtonContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: enter_promocode_button_link_module.promocodeButtonIcon,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          size,
          name: "tag-solid"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(enter_promocode_button_link_module.promocodeButtonText, {
          [enter_promocode_button_link_module.hideText]: hideTextOnTouch && isMobileOrTablet,
          [typography_module/* default */.Z.captionAccent]: !hideTextOnTouch
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "packetDescriptionPopup.iHavePromocode"
        })
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/components/page-header/types.ts
var page_header_types = __webpack_require__(25269);
// EXTERNAL MODULE: ./src/components/markdown-strings/markdown-strings.component.tsx + 2 modules
var markdown_strings_component = __webpack_require__(59889);
;// CONCATENATED MODULE: ./src/utils/getColor.ts


const getColor = (index, colorsMap) => {
  const colorsMapLength = Object.keys(colorsMap).length;
  return colorsMap[index % colorsMapLength];
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-about/payment-landing-about.module.ts


var iconColors = /* @__PURE__ */(iconColors2 => {
  iconColors2[iconColors2["yellow"] = 0] = "yellow";
  iconColors2[iconColors2["orange"] = 1] = "orange";
  iconColors2[iconColors2["green"] = 2] = "green";
  iconColors2[iconColors2["violet"] = 3] = "violet";
  iconColors2[iconColors2["red"] = 4] = "red";
  return iconColors2;
})(iconColors || {});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-about/payment-landing-about.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_about_module = ({"container-gap":"payment-landing-about-module__container-gap--v7rqz","containerGap":"payment-landing-about-module__container-gap--v7rqz","root":"payment-landing-about-module__root--d1AoC","root-medium-gray":"payment-landing-about-module__root-medium-gray--DtOCg","rootMediumGray":"payment-landing-about-module__root-medium-gray--DtOCg","root-white":"payment-landing-about-module__root-white--gJzET","rootWhite":"payment-landing-about-module__root-white--gJzET","left-block":"payment-landing-about-module__left-block--Z9HyK","leftBlock":"payment-landing-about-module__left-block--Z9HyK","image":"payment-landing-about-module__image--EXV9b","right-block":"payment-landing-about-module__right-block--juv56","rightBlock":"payment-landing-about-module__right-block--juv56","title":"payment-landing-about-module__title--wRGrZ","title-pink":"payment-landing-about-module__title-pink--tS3Q1","titlePink":"payment-landing-about-module__title-pink--tS3Q1","subtitle":"payment-landing-about-module__subtitle--t2AqA","info":"payment-landing-about-module__info--Oc7Gn","icon-wrapper":"payment-landing-about-module__icon-wrapper--kmgyq","iconWrapper":"payment-landing-about-module__icon-wrapper--kmgyq","icon":"payment-landing-about-module__icon--xKuQe","icon-yellow":"payment-landing-about-module__icon-yellow--ehMrN","iconYellow":"payment-landing-about-module__icon-yellow--ehMrN","icon-orange":"payment-landing-about-module__icon-orange--jSqTl","iconOrange":"payment-landing-about-module__icon-orange--jSqTl","icon-green":"payment-landing-about-module__icon-green--vaGT2","iconGreen":"payment-landing-about-module__icon-green--vaGT2","icon-violet":"payment-landing-about-module__icon-violet--un9t1","iconViolet":"payment-landing-about-module__icon-violet--un9t1","icon-red":"payment-landing-about-module__icon-red--iEGzu","iconRed":"payment-landing-about-module__icon-red--iEGzu","content-wrapper":"payment-landing-about-module__content-wrapper--HdrR3","contentWrapper":"payment-landing-about-module__content-wrapper--HdrR3","content":"payment-landing-about-module__content--XfFRs","description":"payment-landing-about-module__description--kcclM"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-about/payment-landing-about.component.tsx















const colorsMap = {
  [iconColors.yellow]: payment_landing_about_module.iconYellow,
  [iconColors.orange]: payment_landing_about_module.iconOrange,
  [iconColors.green]: payment_landing_about_module.iconGreen,
  [iconColors.violet]: payment_landing_about_module.iconViolet,
  [iconColors.red]: payment_landing_about_module.iconRed
};
const InfoBlock = _ref => {
  let {
    index,
    content,
    description
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: payment_landing_about_module.info,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: payment_landing_about_module.iconWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "play",
        size: "small",
        className: classnames_default()(payment_landing_about_module.icon, getColor(index, colorsMap))
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: payment_landing_about_module.contentWrapper,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_about_module.content, typography_module/* default */.Z.body2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: content
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: payment_landing_about_module.description,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: description
        })
      })]
    })]
  });
};
const PaymentLandingAbout = _ref2 => {
  let {
    title,
    titlePink,
    imageSrc,
    subtitle,
    infoBlocks,
    bgColor = bunker_model/* BgColors */.ps.LightGrey
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(classnames_default()(payment_landing_about_module.root, {
      [payment_landing_about_module.rootWhite]: bgColor === bunker_model/* BgColors */.ps.White,
      [payment_landing_about_module.rootMediumGray]: bgColor === bunker_model/* BgColors */.ps.MediumGrey
    })),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainer, {
      className: payment_landing_about_module.containerGap,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: payment_landing_about_module.leftBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(payment_landing_about_module.title, typography_module/* default */.Z.headline2),
          children: [title, " ", /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: payment_landing_about_module.titlePink,
            children: titlePink
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
          classes: {
            root: payment_landing_about_module.image
          },
          src: imageSrc,
          width: "100%",
          height: "250px"
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: payment_landing_about_module.rightBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: payment_landing_about_module.subtitle,
          children: subtitle
        }), infoBlocks.map((block, i) => /* @__PURE__ */(0,jsx_runtime.jsx)(InfoBlock, {
          content: block.content,
          description: block.description,
          index: i
        }, i))]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-about-extra/payment-landing-about-extra.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_about_extra_module = ({"container-gap":"payment-landing-about-extra-module__container-gap--NZ0E7","containerGap":"payment-landing-about-extra-module__container-gap--NZ0E7","root":"payment-landing-about-extra-module__root--FQMgN","title":"payment-landing-about-extra-module__title--WtHEO","content":"payment-landing-about-extra-module__content--bQ3Ip","content-item":"payment-landing-about-extra-module__content-item--F8XwK","contentItem":"payment-landing-about-extra-module__content-item--F8XwK","image":"payment-landing-about-extra-module__image--LTSRP","addition-text":"payment-landing-about-extra-module__addition-text--xxAup","additionText":"payment-landing-about-extra-module__addition-text--xxAup"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-about-extra/payment-landing-about-extra.component.tsx












const PaymentLandingAboutExtra = _ref => {
  let {
    title,
    imageSrc,
    additionText = "",
    content
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(payment_landing_about_extra_module.root),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainer, {
      className: payment_landing_about_extra_module.containerGap,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_about_extra_module.title, isMobile ? typography_module/* default */.Z.headline3 : typography_module/* default */.Z.headline2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          children: title
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: payment_landing_about_extra_module.content,
        children: content.map((contentItem, i) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: payment_landing_about_extra_module.contentItem,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            children: contentItem
          })
        }, i))
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
        classes: {
          root: payment_landing_about_extra_module.image
        },
        src: imageSrc,
        width: "100%",
        height: "200px"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: payment_landing_about_extra_module.additionText,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          children: additionText
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-advantages/payment-landing-advantages.module.ts


var bgColors = /* @__PURE__ */(bgColors2 => {
  bgColors2[bgColors2["yellow"] = 0] = "yellow";
  bgColors2[bgColors2["pink"] = 1] = "pink";
  bgColors2[bgColors2["blue"] = 2] = "blue";
  bgColors2[bgColors2["grey"] = 3] = "grey";
  bgColors2[bgColors2["green"] = 4] = "green";
  return bgColors2;
})(bgColors || {});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-advantages/payment-landing-advantages.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_advantages_module = ({"container-gap":"payment-landing-advantages-module__container-gap--LEGMs","containerGap":"payment-landing-advantages-module__container-gap--LEGMs","root":"payment-landing-advantages-module__root--DEW9F","title":"payment-landing-advantages-module__title--H7Zc5","wrapper":"payment-landing-advantages-module__wrapper--rVrcU","wrapper-yellow":"payment-landing-advantages-module__wrapper-yellow--ZVloU","wrapperYellow":"payment-landing-advantages-module__wrapper-yellow--ZVloU","wrapper-pink":"payment-landing-advantages-module__wrapper-pink--JF5Si","wrapperPink":"payment-landing-advantages-module__wrapper-pink--JF5Si","wrapper-blue":"payment-landing-advantages-module__wrapper-blue--bN7kY","wrapperBlue":"payment-landing-advantages-module__wrapper-blue--bN7kY","wrapper-grey":"payment-landing-advantages-module__wrapper-grey--ehUW1","wrapperGrey":"payment-landing-advantages-module__wrapper-grey--ehUW1","wrapper-green":"payment-landing-advantages-module__wrapper-green--bXY11","wrapperGreen":"payment-landing-advantages-module__wrapper-green--bXY11","content":"payment-landing-advantages-module__content--cFzh2","advantage":"payment-landing-advantages-module__advantage--ar8CX","mark":"payment-landing-advantages-module__mark--zEdhT","description":"payment-landing-advantages-module__description--muHVA","number":"payment-landing-advantages-module__number--fDRm6","advantage-text":"payment-landing-advantages-module__advantage-text--mNVpR","advantageText":"payment-landing-advantages-module__advantage-text--mNVpR"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-advantages/payment-landing-advantages.component.tsx













const payment_landing_advantages_component_colorsMap = {
  [bgColors.yellow]: payment_landing_advantages_module.wrapperYellow,
  [bgColors.pink]: payment_landing_advantages_module.wrapperPink,
  [bgColors.blue]: payment_landing_advantages_module.wrapperBlue,
  [bgColors.grey]: payment_landing_advantages_module.wrapperGrey,
  [bgColors.green]: payment_landing_advantages_module.wrapperGreen
};
const AdvantageBlock = _ref => {
  let {
    advantage,
    description,
    index = 0
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(payment_landing_advantages_module.wrapper, getColor(index, payment_landing_advantages_component_colorsMap)),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: payment_landing_advantages_module.content,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(payment_landing_advantages_module.advantage, typography_module/* default */.Z.headline4Accent),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: payment_landing_advantages_module.mark,
          children: "\u2022"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: advantage
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_advantages_module.description),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: description
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(payment_landing_advantages_module.number, typography_module/* default */.Z.headline2),
      children: index + 1
    })]
  });
};
const PaymentLandingAdvantages = _ref2 => {
  let {
    title,
    advantageBlocks
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(payment_landing_advantages_module.root),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainer, {
      className: payment_landing_advantages_module.containerGap,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_advantages_module.title, typography_module/* default */.Z.headline2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          children: title
        })
      }), advantageBlocks.map((block, i) => /* @__PURE__ */(0,jsx_runtime.jsx)(AdvantageBlock, {
        advantage: block.advantage,
        description: block.description,
        index: i
      }, i))]
    })
  });
};
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
;// CONCATENATED MODULE: ./src/pages/payment-landing/constants.ts


const YANDEX_PAY_SDK_URL = "https://pay.yandex.ru/sdk/v1/pay.js";
const MERCHANT_ID = "31ccc782-7030-4963-8c54-8d3aba1b25ff";
const YA_PAY_BUTTON_CONTAINER_ID_PREFIX = "split_button_container_";
const SPLIT_BLOCK_TYPE = "split-block";
;// CONCATENATED MODULE: ../shared/src/region/region.ts



const REGION = (0,domain/* isKzDomain */.k)() ? "KZ" : "RU";
;// CONCATENATED MODULE: ./src/pages/payment-landing/hooks/use-products-prices.ts





function useProductsPrices(productIds) {
  const [productsPrices, setProductsPrices] = (0,react.useState)({});
  (0,react.useEffect)(() => {
    if (!productIds.length) {
      return;
    }
    async function fetchProductsPrices() {
      try {
        const response = await getProductsPrices({
          productIds,
          region: REGION
        });
        setProductsPrices(response);
      } catch (error) {}
    }
    void fetchProductsPrices();
  }, [productIds]);
  return productsPrices;
}
;// CONCATENATED MODULE: ./src/pages/payment-landing/hooks/use-ya-pay-script.ts






const useYaPayScript = () => {
  const {
    coursesSplitPay
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const [isLoaded, setIsLoaded] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if ((0,domain/* isKzDomain */.k)() || !coursesSplitPay) {
      return;
    }
    const body = document.querySelector("body");
    const script = document.createElement("script");
    script.async = true;
    script.onload = () => setIsLoaded(true);
    if (!body) {
      return;
    }
    script.setAttribute("src", YANDEX_PAY_SDK_URL);
    body.appendChild(script);
    return () => {
      body.removeChild(script);
    };
  }, [coursesSplitPay]);
  return {
    isLoaded
  };
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/hooks/use-business-product-id.ts




const useBusinessProductId = productId => {
  const [businessProductId, setBusinessProductId] = (0,react.useState)();
  const products = (0,useProducts/* useProducts */.rn)();
  (0,react.useEffect)(() => {
    if (productId) {
      void products.get(productId).then(data => {
        setBusinessProductId(data?.businessId);
      });
    }
  }, [productId, products]);
  return {
    businessProductId
  };
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/hooks/index.ts





;// CONCATENATED MODULE: ./src/api/ya-pay/constants.ts



const PURCHASE_PRODUCT_SPLIT_API_URL = `${(0,site_utils/* getAPIPath */.NZ)()}/student/purchase-product-split`;
// EXTERNAL MODULE: ./src/api/api.utils.ts
var api_utils = __webpack_require__(11568);
;// CONCATENATED MODULE: ./src/api/ya-pay/model.ts





const PaymentStrategyRaw = (0,api_utils/* enumCodec */.h)(student_model/* PaymentStrategy */.Xu);
const RawPurchaseInfo = es6.type({
  purchase_id: es6.string,
  amount: es6.string,
  purchase_url: es6.string,
  payment_strategy: PaymentStrategyRaw,
  purchase_status: es6.string,
  partial_payments_count: es6.union([es6.number, es6["null"]])
});
;// CONCATENATED MODULE: ./src/api/ya-pay/purchase-product-split.api.ts






const getYaPayPurchaseLink = (0,un_either/* unEither */.K)(_ref => {
  let {
    productId
  } = _ref;
  return (0,http/* makeRequest */.$f)(PURCHASE_PRODUCT_SPLIT_API_URL, {
    method: "POST",
    body: {
      product_id: productId
    },
    responseType: RawPurchaseInfo,
    resultMapper(rawResponse) {
      return {
        purchaseId: rawResponse.purchase_id,
        amount: rawResponse.amount,
        purchaseUrl: rawResponse.purchase_url,
        paymentStrategy: rawResponse.payment_strategy,
        purchaseStatus: rawResponse.purchase_status,
        partialPaymentsCount: rawResponse.partial_payments_count
      };
    }
  });
});
;// CONCATENATED MODULE: ./src/api/ya-pay/index.ts



;// CONCATENATED MODULE: ./src/pages/payment-landing/utils.ts
































const createYaPayPaymentDataObject = price => {
  const paymentData = {
    // Для отладки нужно явно указать `SANDBOX` окружение,
    // для продакшена параметр можно убрать или указать `PRODUCTION`
    env:  true ? YaPay.PaymentEnv.Production : 0,
    // Версия 4 указывает на тип оплаты сервисом Яндекс Пэй
    // Пользователь производит оплату на форме Яндекс Пэй,
    // и мерчанту возвращается только результат проведения оплаты
    version: 4,
    // Код валюты в которой будете принимать платежи
    currencyCode: YaPay.CurrencyCode.Rub,
    // Идентификатор продавца, который получают при регистрации в Яндекс Пэй
    merchantId: MERCHANT_ID,
    // Сумма к оплате
    // Сумма которая будет отображена в форме зависит от суммы переданной от бэкенда
    // Эта сумма влияет на отображение доступности Сплита
    totalAmount: price ? price.toString() : "",
    // Доступные для использования методы оплаты
    // Доступные на форме способы оплаты также зависят от информации переданной от бэкенда
    // Данные передаваемые тут влияют на внешний вид кнопки или виджета
    availablePaymentMethods: [YaPay.PaymentMethodType.Split]
  };
  return paymentData;
};
const getProductsIds = (tabs, activeTabIndex) => {
  if (!tabs) {
    return [];
  }
  const ids = /* @__PURE__ */new Set();
  tabs[activeTabIndex].blocks.forEach(block => {
    if ("priceBlocks" in block) {
      block.priceBlocks.forEach(priceBlock => {
        if (priceBlock.productId) {
          ids.add(priceBlock.productId);
        }
      });
    }
  });
  return Array.from(ids);
};
const checkConditionsF = experiments => conditions => conditions.every(_ref => {
  let {
    type,
    experimentId
  } = _ref;
  return type === bunker_model/* LandingBlockConditionTypes */.b6.Experiment && Boolean(experiments[experimentId]);
});
;// CONCATENATED MODULE: ./src/pages/payment-landing/hooks/use-ya-pay-button.ts











const useYaPayButton = (isFullPaymentPriceBlock, isYaPayScriptLoaded, currentProductId, landingId, priceWithDiscount, type) => {
  const [paymentSession, setPaymentSession] = (0,react.useState)();
  const [formOpenError, setFormOpenError] = (0,react.useState)();
  const [isPaymentSessionInitialized, setIsPaymentSessionInitialized] = (0,react.useState)(false);
  const onPayButtonClick = (0,react.useCallback)(async () => {
    (0,yandexMetrica/* ymGoal */.qf)("Payment_Landing_YaPay_Button_Click");
    await sendAnalyticsLog(AnalyticsLogEventType.BuyCourse, {
      productId: currentProductId,
      landingId,
      paymentType: PaymentType.Split
    });
    const data = await getYaPayPurchaseLink({
      productId: currentProductId
    });
    return data.purchaseUrl;
  }, [currentProductId, landingId]);
  (0,react.useEffect)(() => {
    if ((0,domain/* isKzDomain */.k)() || !isFullPaymentPriceBlock || !isYaPayScriptLoaded || !YaPay || !currentProductId || type !== SPLIT_BLOCK_TYPE) {
      return;
    }
    const paymentData = createYaPayPaymentDataObject(priceWithDiscount);
    YaPay.createSession(paymentData, {
      onPayButtonClick,
      onFormOpenError: setFormOpenError
      // Обработчик на ошибки при открытии формы оплаты
    }).then(paymentSession2 => {
      setIsPaymentSessionInitialized(true);
      setPaymentSession(paymentSession2);
    }).catch(error => {
      logger/* Logger */.Yd.captureException(error);
    });
  }, [isFullPaymentPriceBlock, isYaPayScriptLoaded, priceWithDiscount, currentProductId, onPayButtonClick, type]);
  (0,react.useEffect)(() => {
    if (!paymentSession || !currentProductId) {
      return;
    }
    const buttonContainer = document.getElementById(`${YA_PAY_BUTTON_CONTAINER_ID_PREFIX}${currentProductId}`);
    if (buttonContainer) {
      paymentSession.mountButton(buttonContainer, {
        type: YaPay.ButtonType.Pay,
        theme: YaPay.ButtonTheme.Black,
        width: YaPay.ButtonWidth.Max
      });
    }
    return () => {
      paymentSession?.unmountButton(buttonContainer);
      paymentSession?.destroy();
    };
  }, [currentProductId, paymentSession]);
  return {
    isPaymentSessionInitialized,
    formOpenError
  };
};
// EXTERNAL MODULE: ../shared/src/hooks/useResizeElement.ts
var useResizeElement = __webpack_require__(28952);
// EXTERNAL MODULE: ../ui-kit/src/chip/index.ts + 2 modules
var chip = __webpack_require__(56317);
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/utils.ts




const getTotalSpeakingSessionsAmount = (speakingSessionsAmount, nativeSpeakerSessionsAmount) => {
  if (!speakingSessionsAmount && !nativeSpeakerSessionsAmount) {
    return null;
  }
  const amount = (speakingSessionsAmount || 0) + (nativeSpeakerSessionsAmount || 0);
  return amount === 0 ? null : amount;
};
const getCurrency = () => {
  const currency = REGION === "KZ" ? "KZT" : "RUB";
  return currencyValues[currency];
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/chips/constants.ts


const GAP_IN_PX = 8;
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/chips/chips.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chips_module = ({"chips-block":"chips-module__chips-block--Ogkg0","chipsBlock":"chips-module__chips-block--Ogkg0","no-overpayment":"chips-module__no-overpayment--fkNYL","noOverpayment":"chips-module__no-overpayment--fkNYL","referral":"chips-module__referral--aylKK","button":"chips-module__button--mizmr","tooltip-text":"chips-module__tooltip-text--R58dc","tooltipText":"chips-module__tooltip-text--R58dc"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/chips/chips.tsx















const Chips = _ref => {
  let {
    isFullPaymentPriceBlock,
    productPrice
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isSbpTooltipVisible, setIsSbpTooltipVisible] = (0,react.useState)(false);
  const {
    payWithSbp
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const parentRef = (0,react.useRef)(null);
  const noOverpaymentChipRef = (0,react.useRef)(null);
  const pricePerLessonChipRef = (0,react.useRef)(null);
  const sbpChipRef = (0,react.useRef)(null);
  const referralChipRef = (0,react.useRef)(null);
  const [needHideNoOverpaymentChip, setNeedHideNoOverpaymentChip] = (0,react.useState)(false);
  const [needHidePricePerLessonChip, setNeedHidePricePerLessonChip] = (0,react.useState)(false);
  const {
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  (0,useResizeElement/* useResizeElement */.n)(parentRef, args => {
    const noOverpaymentChipWidth = noOverpaymentChipRef?.current?.clientWidth || 0;
    const pricePerLessonChipWidth = pricePerLessonChipRef?.current?.clientWidth || 0;
    const sbpChipWidth = sbpChipRef?.current?.clientWidth || 0;
    const referralChipWidth = referralChipRef?.current?.clientWidth || 0;
    if (noOverpaymentChipWidth + GAP_IN_PX + pricePerLessonChipWidth + GAP_IN_PX + sbpChipWidth + GAP_IN_PX + referralChipWidth > args.width) {
      setNeedHideNoOverpaymentChip(true);
    }
    if (pricePerLessonChipWidth + GAP_IN_PX + sbpChipWidth + GAP_IN_PX + referralChipWidth > args.width) {
      setNeedHidePricePerLessonChip(true);
    }
  });
  const totalSessionsCount = getTotalSpeakingSessionsAmount(productPrice?.resources?.speakingSession?.amount, productPrice?.resources?.nativeSpeakerSession?.amount);
  const sbpDiscountPercentage = productPrice?.sbpDiscountPercentage;
  const referralBonus = productPrice?.resources?.speakingSession?.referralBonus;
  const handleSbpInfoIconClick = () => {
    setIsSbpTooltipVisible(prevState => !prevState);
  };
  const shouldShowNoOverpaymentChip = isFullPaymentPriceBlock && (!needHideNoOverpaymentChip || isMobileOrTablet);
  const shouldShowPricePerLessonChip = productPrice && totalSessionsCount && (!needHidePricePerLessonChip || isMobileOrTablet);
  const shouldShowSbpChip = isFullPaymentPriceBlock && sbpDiscountPercentage && payWithSbp && !(0,domain/* isKzDomain */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: chips_module.chipsBlock,
    ref: parentRef,
    children: [shouldShowNoOverpaymentChip && /* @__PURE__ */(0,jsx_runtime.jsx)(chip/* Chip */.A, {
      iconName: "flame",
      className: chips_module.noOverpayment,
      ref: noOverpaymentChipRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "paymentLandingPage.priceBlock.chip.noOverpayment"
      })
    }), shouldShowPricePerLessonChip && /* @__PURE__ */(0,jsx_runtime.jsx)(chip/* Chip */.A, {
      ref: pricePerLessonChipRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "paymentLandingPage.priceBlock.chip.pricePerLesson",
        values: {
          price: Math.round(productPrice.discountPrice / totalSessionsCount),
          currency: getCurrency()
        }
      })
    }), shouldShowSbpChip && /* @__PURE__ */(0,jsx_runtime.jsxs)(chip/* Chip */.A, {
      iconName: "sbp",
      ref: sbpChipRef,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "paymentLandingPage.priceBlock.chip.sbp.text",
        values: {
          sbpDiscountPercentage
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_tooltip/* Tooltip */.u, {
        overlay: intl.formatMessage({
          id: "paymentLandingPage.priceBlock.chip.sbp.tooltip"
        }),
        visible: isSbpTooltipVisible,
        placement: "top",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
          className: chips_module.button,
          type: "button",
          onClick: handleSbpInfoIconClick,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: "info",
            size: "tiny"
          })
        })
      })]
    }), referralBonus && /* @__PURE__ */(0,jsx_runtime.jsx)(chip/* Chip */.A, {
      iconName: "gift-fill",
      className: chips_module.referral,
      ref: referralChipRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "payment.referralBonusAmount",
        values: {
          amount: referralBonus
        }
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/chips/index.ts



;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/price-block-item.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const price_block_item_module = ({"root":"price-block-item-module__root--GchAF","without-payment-link":"price-block-item-module__without-payment-link--xbeXw","withoutPaymentLink":"price-block-item-module__without-payment-link--xbeXw","values":"price-block-item-module__values--CIARj","discount":"price-block-item-module__discount--vJHqE","price-wrapper":"price-block-item-module__price-wrapper--KNdjz","priceWrapper":"price-block-item-module__price-wrapper--KNdjz","discount-price":"price-block-item-module__discount-price--FCxEy","discountPrice":"price-block-item-module__discount-price--FCxEy","price":"price-block-item-module__price--L3qTB","text":"price-block-item-module__text--U1ZZE","ya-pay-text":"price-block-item-module__ya-pay-text--XVkbH","yaPayText":"price-block-item-module__ya-pay-text--XVkbH","button-wrapper":"price-block-item-module__button-wrapper--Po2SB","buttonWrapper":"price-block-item-module__button-wrapper--Po2SB","button":"price-block-item-module__button--eS8zE","yandex-pay-button-container":"price-block-item-module__yandex-pay-button-container--gw28G","yandexPayButtonContainer":"price-block-item-module__yandex-pay-button-container--gw28G"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/ya-pay-price-block-item/ya-pay-price-block-item.tsx










const YaPayPriceBlockItem = _ref => {
  let {
    text,
    productPrice,
    productId
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: price_block_item_module.root,
    "data-testid": "payment-landing-price-item",
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: price_block_item_module.priceWrapper,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Chips, {
        productPrice
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(Price, {
        productPrice,
        size: "large"
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2, price_block_item_module.text, price_block_item_module.yaPayText),
      children: text ? text : /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "paymentLandingPage.priceBlock.yandexPayContainerText"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: price_block_item_module.buttonWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        id: `${YA_PAY_BUTTON_CONTAINER_ID_PREFIX}${productId}`,
        className: price_block_item_module.yandexPayButtonContainer
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/ya-pay-price-block-item/index.ts



;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-price-block-item/price-block-item.tsx





















const PriceBlockItem = _ref => {
  let {
    type,
    buttonSrc,
    text,
    buttonText,
    productPrice,
    productId,
    landingId,
    parentProductId,
    isYaPayScriptLoaded
  } = _ref;
  const products = (0,useProducts/* useProducts */.rn)();
  const [paymentStrategy, setPaymentStrategy] = (0,react.useState)();
  const isPaymentLink = !!(productId && parentProductId);
  const href = isPaymentLink ? studentRoutePaths/* studentRoutePaths */.dR.BUY_PAYMENT(parentProductId, productId) : buttonSrc;
  const isFullPaymentPriceBlock = paymentStrategy === "fullPayment";
  const isPartialPaymentPriceBlock = paymentStrategy === "partialPayment";
  const {
    coursesSplitPay
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    businessProductId
  } = useBusinessProductId(productId);
  const {
    isPaymentSessionInitialized
  } = useYaPayButton(isFullPaymentPriceBlock, isYaPayScriptLoaded, productId, landingId, productPrice?.discountPrice, type);
  const isSplitBlock = type === SPLIT_BLOCK_TYPE;
  const shouldShowSplitBlock = coursesSplitPay && isPaymentSessionInitialized;
  (0,react.useEffect)(() => {
    if (productId) {
      void products.get(productId).then(data => setPaymentStrategy(data?.paymentStrategy));
    }
  }, [productId, products]);
  const handleClick = () => {
    if (isFullPaymentPriceBlock) {
      void sendAnalyticsLog(AnalyticsLogEventType.BuyCourse, {
        productId,
        landingId,
        paymentType: PaymentType.Full
      });
      (0,yandexMetrica/* ymGoal */.qf)("Payment_Landing_Full_Course_Button_Click");
    }
    if (isPartialPaymentPriceBlock) {
      void sendAnalyticsLog(AnalyticsLogEventType.BuyCourse, {
        productId,
        landingId,
        paymentType: PaymentType.Partial
      });
      (0,yandexMetrica/* ymGoal */.qf)("Payment_Landing_Part_Payment_Button_Click");
    }
    if (!paymentStrategy) {
      (0,yandexMetrica/* ymGoal */.qf)("Payment_Landing_Consultation_Button_Click");
    }
  };
  const splitBlock = shouldShowSplitBlock && /* @__PURE__ */(0,jsx_runtime.jsx)(YaPayPriceBlockItem, {
    text,
    productPrice,
    productId
  });
  const priceBlock = /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(price_block_item_module.root, {
      [price_block_item_module.withoutPaymentLink]: !isPaymentLink
    }),
    "data-testid": "payment-landing-price-item",
    children: [isPaymentLink && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: price_block_item_module.priceWrapper,
      children: [businessProductId !== product_model/* BusinessProductId */.HV.ProductB && /* @__PURE__ */(0,jsx_runtime.jsx)(Chips, {
        isFullPaymentPriceBlock,
        productPrice
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(Price, {
        productPrice,
        size: "large"
      })]
    }), text && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2, price_block_item_module.text),
      children: text
    }), buttonText && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: price_block_item_module.buttonWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
        appearance: "primary",
        size: "medium",
        useNativeTag: !isPaymentLink,
        href,
        className: classnames_default()(price_block_item_module.button, typography_module/* default */.Z.body2Accent),
        onClick: handleClick,
        children: buttonText
      })
    })]
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: isSplitBlock ? splitBlock : priceBlock
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-course-intro/payment-landing-course-intro.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_course_intro_module = ({"container-gap":"payment-landing-course-intro-module__container-gap--Gip_2","containerGap":"payment-landing-course-intro-module__container-gap--Gip_2","root":"payment-landing-course-intro-module__root--dwC6x","root-medium-gray":"payment-landing-course-intro-module__root-medium-gray--CmS8L","rootMediumGray":"payment-landing-course-intro-module__root-medium-gray--CmS8L","root-light-gray":"payment-landing-course-intro-module__root-light-gray--TMrQq","rootLightGray":"payment-landing-course-intro-module__root-light-gray--TMrQq","title":"payment-landing-course-intro-module__title--gr_dY","subtitle":"payment-landing-course-intro-module__subtitle--xk8Ic","text":"payment-landing-course-intro-module__text--wR2YY","prices":"payment-landing-course-intro-module__prices--PyJel","price":"payment-landing-course-intro-module__price--GwsJm","price-title":"payment-landing-course-intro-module__price-title--eFlT3","priceTitle":"payment-landing-course-intro-module__price-title--eFlT3","price-subtitle":"payment-landing-course-intro-module__price-subtitle--qW82X","priceSubtitle":"payment-landing-course-intro-module__price-subtitle--qW82X","price-btn":"payment-landing-course-intro-module__price-btn--csqqR","priceBtn":"payment-landing-course-intro-module__price-btn--csqqR"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-course-intro/payment-landing-course-intro.component.tsx













const PaymentLandingCourseIntro = _ref => {
  let {
    title,
    subtitle = "",
    text = "",
    landingId,
    priceBlocks,
    bgColor = bunker_model/* BgColors */.ps.White,
    productsPrices,
    isYaPayScriptLoaded
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(payment_landing_course_intro_module.root, {
      [payment_landing_course_intro_module.rootMediumGray]: bgColor === bunker_model/* BgColors */.ps.MediumGrey,
      [payment_landing_course_intro_module.rootLightGray]: bgColor === bunker_model/* BgColors */.ps.LightGrey
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainer, {
      className: payment_landing_course_intro_module.containerGap,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_course_intro_module.title, isMobile ? typography_module/* default */.Z.headline3 : typography_module/* default */.Z.headline2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: title
        })
      }), subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_course_intro_module.subtitle),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: subtitle
        })
      }), text && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_course_intro_module.text),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: text,
          withIndent: false
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: payment_landing_course_intro_module.prices,
        children: priceBlocks.map((block, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(PriceBlockItem, {
          type: block.blockType,
          productId: block.productId,
          parentProductId: block.parentProductId,
          landingId,
          buttonText: block.buttonText,
          buttonSrc: block.buttonSrc,
          postfix: block.postfix,
          text: block.text,
          productPrice: productsPrices[block.productId ?? ""],
          isYaPayScriptLoaded
        }, index))
      })]
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/spoiler/spoiler.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spoiler_module = ({"button":"spoiler-module__button--MYQUV","icon":"spoiler-module__icon--SX8YB","root":"spoiler-module__root--nPUuF","rotated":"spoiler-module__rotated--TkNQv","content":"spoiler-module__content--Epr3d","visible-content":"spoiler-module__visible-content--SBtOP","visibleContent":"spoiler-module__visible-content--SBtOP"});
;// CONCATENATED MODULE: ../ui-kit/src/spoiler/spoiler.component.tsx








const Spoiler = _ref => {
  let {
    buttonClassName = "",
    openedSpoilerClassName = "",
    iconClassName = "",
    icon = "arrow-down",
    className,
    title,
    children,
    initialOpened = false,
    iconSize = "large"
  } = _ref;
  const [opened, setOpened] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setOpened(initialOpened);
  }, [initialOpened]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(spoiler_module.root, className, {
      [openedSpoilerClassName]: opened
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: classnames_default()(spoiler_module.button, buttonClassName),
      onClick: () => setOpened(prevState => !prevState),
      children: [title, /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: classnames_default()(iconClassName, spoiler_module.icon, {
          [spoiler_module.rotated]: opened
        }),
        name: icon,
        size: iconSize
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(spoiler_module.content, {
        [spoiler_module.visibleContent]: opened
      }, typography_module/* default */.Z.body2),
      children
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/help-button-popup-panel/help-button-popup-panel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const help_button_popup_panel_module = ({"root":"help-button-popup-panel-module__root--rcF91"});
;// CONCATENATED MODULE: ../ui-kit/src/help-button-popup-panel/help-button-popup-panel.component.tsx




const HelpButtonPopupPanel = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: help_button_popup_panel_module.root,
    children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/support-links-popup/support-links-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const support_links_popup_module = ({"text":"support-links-popup-module__text--JLexi","list":"support-links-popup-module__list--mHs2e","link":"support-links-popup-module__link--oPe1o","label":"support-links-popup-module__label--HdCyT"});
;// CONCATENATED MODULE: ../ui-kit/src/support-links-popup/support-links-popup.component.tsx










const SupportLinksPopup = _ref => {
  let {
    text,
    items,
    onClick
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(HelpButtonPopupPanel, {
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [text && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(support_links_popup_module.text, typography_module/* default */.Z.body2),
        children: text
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
        className: support_links_popup_module.list,
        children: items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
          children: /* @__PURE__ */(0,jsx_runtime.jsxs)("a", {
            href: item.link,
            className: support_links_popup_module.link,
            target: "_blank",
            onClick,
            rel: "noreferrer",
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              name: item.icon,
              size: "medium"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()(support_links_popup_module.label, typography_module/* default */.Z.body2Accent),
              children: item.label
            })]
          })
        }, item.link))
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/hooks/layout/useSocial.ts + 3 modules
var useSocial = __webpack_require__(61046);
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-faq/payment-faq/payment-faq.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_faq_module = ({"root":"payment-faq-module__root--vVKPS","question":"payment-faq-module__question--AsgCd","footer":"payment-faq-module__footer--xdIG7","footer-title":"payment-faq-module__footer-title--frBYv","footerTitle":"payment-faq-module__footer-title--frBYv","help-button":"payment-faq-module__help-button--VYNWO","helpButton":"payment-faq-module__help-button--VYNWO","help-button-wrapper":"payment-faq-module__help-button-wrapper--NKr78","helpButtonWrapper":"payment-faq-module__help-button-wrapper--NKr78","button":"payment-faq-module__button--pxwG_","button-text":"payment-faq-module__button-text--yP5l0","buttonText":"payment-faq-module__button-text--yP5l0","button-text-hidden":"payment-faq-module__button-text-hidden--rQJbP","buttonTextHidden":"payment-faq-module__button-text-hidden--rQJbP","cross-icon":"payment-faq-module__cross-icon--QBXsK","crossIcon":"payment-faq-module__cross-icon--QBXsK","cross-icon-hidden":"payment-faq-module__cross-icon-hidden--maX5Z","crossIconHidden":"payment-faq-module__cross-icon-hidden--maX5Z"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-faq/payment-faq/payment-faq.component.tsx


















const PaymentFAQ = _ref => {
  let {
    children,
    rootClassName,
    titleClassName
  } = _ref;
  const [isOpenedHelp, setHelpOpened] = (0,react.useState)(false);
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const handleClose = (0,react.useCallback)(() => {
    setHelpOpened(false);
  }, []);
  const intl = (0,useIntl/* default */.Z)();
  const socialItems = (0,useSocial/* useSocial */.K)();
  if (socialItems.state === useFetch/* State */.Z.Error) {
    throw socialItems.error;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(payment_faq_module.root, rootClassName),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(isDesktop ? typography_module/* default */.Z.headline2 : typography_module/* default */.Z.headline4Accent, titleClassName),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "paymentFaq.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: children.map((question, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: payment_faq_module.question,
        children: question
      }, index))
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: payment_faq_module.footer,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_faq_module.footerTitle, isDesktop ? typography_module/* default */.Z.headline2 : typography_module/* default */.Z.headline4Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "paymentFaq.footerTitle"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: payment_faq_module.helpButtonWrapper,
        children: [isOpenedHelp && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: payment_faq_module.helpButton,
          children: socialItems.state === useFetch/* State */.Z.Loaded ? /* @__PURE__ */(0,jsx_runtime.jsx)(SupportLinksPopup, {
            text: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "helpButtonPopupItems.helpButtonText"
            }),
            items: socialItems.data.map(item => ({
              link: item.link,
              label: intl.formatMessage({
                id: item.labelKey
              }),
              icon: item.icon
            })),
            onClick: handleClose
          }) : /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {})
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
          appearance: "primary",
          onClick: () => {
            (0,yandexMetrica/* ymGoal */.qf)("Payment_Page_HelpButton_Clicked");
            return setHelpOpened(prev => !prev);
          },
          className: classnames_default()(payment_faq_module.button),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            className: classnames_default()(payment_faq_module.crossIcon, {
              [payment_faq_module.crossIconHidden]: !isOpenedHelp
            }),
            name: "cross",
            size: "medium"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: classnames_default()(payment_faq_module.buttonText, {
              [payment_faq_module.buttonTextHidden]: isOpenedHelp
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "paymentFaq.footerButtonText"
            })
          })]
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-faq/payment-spoiler-title/payment-spoiler-title.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_spoiler_title_module = ({"root":"payment-spoiler-title-module__root--aEQ3S"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-faq/payment-spoiler-title/payment-spoiler-title.component.tsx







const PaymentSpoilerTitle = _ref => {
  let {
    children,
    className
  } = _ref;
  const {
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
    className: classnames_default()(payment_spoiler_title_module.root, {
      [typography_module/* default */.Z.body2Accent]: isMobileOrTablet
    }, className),
    children
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-faq/payment-landing-faq.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_faq_module = ({"container-gap":"payment-landing-faq-module__container-gap--eqsJA","containerGap":"payment-landing-faq-module__container-gap--eqsJA","root":"payment-landing-faq-module__root--ej8Ms","title":"payment-landing-faq-module__title--jtyYI","spoiler-title":"payment-landing-faq-module__spoiler-title--gbaU0","spoilerTitle":"payment-landing-faq-module__spoiler-title--gbaU0"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-faq/payment-landing-faq.component.tsx













const PaymentLandingFAQ = _ref => {
  let {
    faqQuestions
  } = _ref;
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(BlockContainer, {
    className: payment_landing_faq_module.containerGap,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentFAQ, {
      rootClassName: payment_landing_faq_module.root,
      titleClassName: payment_landing_faq_module.title,
      children: faqQuestions.map(faq => /* @__PURE__ */(0,jsx_runtime.jsx)(Spoiler, {
        title: /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentSpoilerTitle, {
          className: payment_landing_faq_module.spoilerTitle,
          children: faq.question
        }),
        iconSize: isDesktop ? "large" : "medium",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          className: typography_module/* default */.Z.body2,
          children: faq.answer
        })
      }, faq.question))
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-image-block/payment-landing-image-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_image_block_module = ({"container-gap":"payment-landing-image-block-module__container-gap--Nsdkn","containerGap":"payment-landing-image-block-module__container-gap--Nsdkn","root":"payment-landing-image-block-module__root--yG3Z6","title":"payment-landing-image-block-module__title--Oqfj2","subtitle":"payment-landing-image-block-module__subtitle--YTGau","image-wrapper":"payment-landing-image-block-module__image-wrapper--Dtycs","imageWrapper":"payment-landing-image-block-module__image-wrapper--Dtycs","image":"payment-landing-image-block-module__image--Ydlyu"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-image-block/payment-landing-image-block.component.tsx








const PaymentLandingImageBlock = _ref => {
  let {
    title,
    subtitle,
    imageSrc
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(payment_landing_image_block_module.root),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainer, {
      className: payment_landing_image_block_module.containerGap,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_image_block_module.title, typography_module/* default */.Z.headline2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: title
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_image_block_module.subtitle),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: subtitle
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_image_block_module.imageWrapper),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          alt: "laptop",
          src: imageSrc,
          className: payment_landing_image_block_module.image
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-text-block/payment-landing-text-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_text_block_module = ({"container-gap":"payment-landing-text-block-module__container-gap--rGPQb","containerGap":"payment-landing-text-block-module__container-gap--rGPQb","root":"payment-landing-text-block-module__root--YiVr0","bg-medium-gray":"payment-landing-text-block-module__bg-medium-gray--IWjxq","bgMediumGray":"payment-landing-text-block-module__bg-medium-gray--IWjxq","bg-light-gray":"payment-landing-text-block-module__bg-light-gray--UNwMG","bgLightGray":"payment-landing-text-block-module__bg-light-gray--UNwMG","title":"payment-landing-text-block-module__title--PbfcB","text1":"payment-landing-text-block-module__text1--yIkW6","text2":"payment-landing-text-block-module__text2--kJJjS","separator":"payment-landing-text-block-module__separator--FEYQa"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-text-block/payment-landing-text-block.component.tsx









const PaymentLandingTextBlock = _ref => {
  let {
    isBottomSeparator,
    bgColor,
    title,
    text1,
    text2 = ""
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(payment_landing_text_block_module.root, {
      [payment_landing_text_block_module.bgMediumGray]: bgColor === bunker_model/* BgColors */.ps.MediumGrey,
      [payment_landing_text_block_module.bgLightGray]: bgColor === bunker_model/* BgColors */.ps.LightGrey
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(BlockContainer, {
      className: payment_landing_text_block_module.containerGap,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_text_block_module.title, typography_module/* default */.Z.headline2),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: title
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_text_block_module.text1),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: text1
        })
      }), text2 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(payment_landing_text_block_module.text2, typography_module/* default */.Z.caption),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_strings_component/* MarkdownStrings */.D, {
          value: text2
        })
      }), isBottomSeparator && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: payment_landing_text_block_module.separator
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/components/ya-form/ya-form.component.tsx + 2 modules
var ya_form_component = __webpack_require__(97030);
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-yandex-form/payment-landing-yandex-form.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_yandex_form_module = ({"container-gap":"payment-landing-yandex-form-module__container-gap--P_LcR","containerGap":"payment-landing-yandex-form-module__container-gap--P_LcR","root":"payment-landing-yandex-form-module__root--DVr9_"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/components/payment-landing-yandex-form/payment-landing-yandex-form.component.tsx








const PaymentLandingYandexForm = _ref => {
  let {
    yandexFormId,
    width,
    title,
    subtitle,
    textDirection: textDirectionRaw
  } = _ref;
  const textDirection = textDirectionRaw === "horizontal" ? "horizontal" : "vertical";
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: payment_landing_yandex_form_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(BlockContainer, {
      className: payment_landing_yandex_form_module.containerGap,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ya_form_component/* YaForm */.S, {
        name: "ya-form-" + yandexFormId,
        url: `${(0,domain_urls/* getExternalUrl */.Eg)("yaForm")}/u/${yandexFormId}/?iframe=1`,
        width,
        title,
        subtitle,
        onNextBlock: function_utils/* emptyFunction */.Bi,
        textDirection
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/payment-landing.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_landing_page_module = ({"help-button":"payment-landing-page-module__help-button--mndNz","helpButton":"payment-landing-page-module__help-button--mndNz","switch-block":"payment-landing-page-module__switch-block--hKkAT","switchBlock":"payment-landing-page-module__switch-block--hKkAT","promo-code":"payment-landing-page-module__promo-code--rXo8j","promoCode":"payment-landing-page-module__promo-code--rXo8j"});
;// CONCATENATED MODULE: ./src/pages/payment-landing/payment-landing.page.tsx
































const PaymentLanding = _ref => {
  let {
    landingId
  } = _ref;
  const [data, setData] = (0,react.useState)(null);
  const [activeTabIndex, setActiveTabIndex] = (0,react.useState)(0);
  const experiments = (0,utils_experimentDi/* useExperimentDi */.e1)();
  (0,react.useEffect)(() => {
    void sendAnalyticsLog(AnalyticsLogEventType.VisitPaymentLanding, {
      landingId
    });
  }, [landingId]);
  const {
    isLoaded: isYaPayScriptLoaded
  } = useYaPayScript();
  const checkConditions = checkConditionsF(experiments);
  const productIds = (0,react.useMemo)(() => getProductsIds(data?.tabs, activeTabIndex), [activeTabIndex, data?.tabs]);
  const productsPrices = useProductsPrices(productIds);
  (0,react.useEffect)(() => {
    void (0,bunker_api/* getPaymentLanding */.W0)(landingId).then(response => {
      if ((0,Either.isRight)(response)) {
        setData(response.right);
      }
    });
  }, [landingId]);
  const tabs = (0,react.useMemo)(() => data && data.tabs.length > 1 && data.tabs.map((tab, i) => /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    appearance: i === activeTabIndex ? "secondary" : "tertiary",
    size: "small",
    onClick: () => setActiveTabIndex(i),
    children: tab.title
  }, i)), [activeTabIndex, data]);
  const handleAppPageHelpButtonClick = (0,react.useCallback)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Payment_Landing_Floating_Help_Button_Click");
  }, []);
  if (!data || data.tabs.length === 0) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(page_header/* PageHeader */.m, {
      leftSideBlock: data.settings.isCloseButton ? page_header_types/* HeaderLefSideBlockContent */.c.CrossIcon : page_header_types/* HeaderLefSideBlockContent */.c.None,
      hideCourseSelectButton: !data.settings.isCourseSelectButton,
      hideMenuButton: true,
      hideNavigation: true,
      hideNotifierBell: true,
      hideReferralProgramElements: true,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: payment_landing_page_module.switchBlock,
        children: [tabs, " "]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(EnterPromoCodeButtonLink, {
        className: payment_landing_page_module.promoCode,
        appearance: "primary",
        size: "small"
      })]
    }), data.tabs[activeTabIndex].blocks.map((block, index) => {
      if (block.conditions && !checkConditions(block.conditions)) {
        return null;
      }
      switch (block.type) {
        case bunker_model/* LandingBlocksType */.Fd.YandexForm:
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingYandexForm, {
            ...block
          }, index);
        case "course-intro":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingCourseIntro, {
            title: block.title,
            subtitle: block.subtitle,
            text: block.text,
            landingId,
            priceBlocks: block.priceBlocks,
            bgColor: block.bgColor,
            productsPrices,
            isYaPayScriptLoaded
          }, index);
        case "image-block":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingImageBlock, {
            title: block.title,
            subtitle: block.subtitle,
            imageSrc: block.imageSrc
          }, index);
        case "about-block":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingAbout, {
            title: block.title,
            titlePink: block.titlePink,
            imageSrc: block.imageSrc,
            subtitle: block.subtitle,
            infoBlocks: block.infoBlocks,
            bgColor: block.bgColor
          }, index);
        case "text-block":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingTextBlock, {
            title: block.title,
            text1: block.text1,
            text2: block.text2,
            isBottomSeparator: block.isBottomSeparator,
            bgColor: block.bgColor
          }, index);
        case "advantages-block":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingAdvantages, {
            title: block.title,
            advantageBlocks: block.advantagesBlocks
          }, index);
        case "about-extra-block":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingAboutExtra, {
            title: block.title,
            imageSrc: block.imageSrc,
            additionText: block.additionText,
            content: block.content
          }, index);
        case "faq-block":
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLandingFAQ, {
            faqQuestions: block.faqQuestions
          }, index);
        default:
          return null;
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(promo_code_popup_component/* PromoCodePopup */.V, {
      backPath: studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING(landingId)
    }), data.settings.isSupportChat && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: payment_landing_page_module.helpButton,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(add_page_helper_button/* AppPageHelpButton */.C, {
        onClick: handleAppPageHelpButtonClick
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_footer_component/* AppPageFooter */.b, {})]
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/with-auth-payment-landing.component.tsx






const WithAuthPaymentLanding = () => {
  const {
    [studentRoutePaths/* StudentRoutesPaymentLandingParams */.Wl.LandingId]: landingId
  } = (0,react_router/* useParams */.UO)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLanding, {
    landingId
  });
};
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-prespeaking-trainer-machine.ts













const create_prespeaking_trainer_machine_services = {
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: () => Promise.resolve(),
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: async _ref => {
    let {
      speakingSessionId
    } = _ref;
    if (speakingSessionId === void 0) {
      logger/* Logger */.Yd.unexpectedState();
      throw new Error();
    }
    try {
      const speakingSession = await (0,speaking_session_api/* getSpeakingSession */.z)(speakingSessionId);
      const response = speakingSession.speaking.type === "chapter" ? await (0,bunker_api/* getPrespeakingChapterState */.Xc)() : await (0,bunker_api/* getPrementorChapterState */.r)();
      return {
        chapterData: response.activities,
        userData: []
      };
    } catch (e) {
      logger/* Logger */.Yd.unexpectedState();
      throw e;
    }
  }
};
const create_prespeaking_trainer_machine_updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)("trainer_result");
const create_prespeaking_trainer_machine_guards = create_trainer_machine/* guards */.l8;
const create_prespeaking_trainer_machine_actions = {
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,xstate_es/* assign */.f0)((context, event) => ({
    activities: event.data.chapterData,
    chapterStudentEvents: {},
    activityIndex: 0,
    blockIndex: 0
  })),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: create_trainer_machine/* actions */.Nw[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: create_trainer_machine/* actions */.Nw[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: create_trainer_machine/* actions */.Nw[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.RESET_TRAINER]: (0,xstate_es/* assign */.f0)({
    activityIndex: 0,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX]: create_trainer_machine/* actions */.Nw[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getBlockFilterAction */.XI)("class_progress"))
};
const prespeakingTrainerMachine = (0,Machine/* createMachine */.C)({
  id: "prespeaking-trainer",
  initial: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA,
  states: {
    [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
        onDone: [{
          actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }],
        onError: trainer_machine_consts/* STATES */.PO.ERROR
      }
    },
    [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: {},
    [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {},
    [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {},
    [trainer_machine_consts/* STATES */.PO.ERROR]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.ERROR]
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER],
    [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), create_prespeaking_trainer_machine_actions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    },
    [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
      actions: [(0,xstate_es/* assign */.f0)({
        chapterStudentEvents: create_prespeaking_trainer_machine_updateStudentEvent,
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER
    }
  }
});
const createPrespeakingTrainerMachine = (speakingSessionId, intl) => prespeakingTrainerMachine.withConfig({
  actions: create_prespeaking_trainer_machine_actions,
  services: create_prespeaking_trainer_machine_services,
  guards: create_prespeaking_trainer_machine_guards
}).withContext({
  mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
  chapterId: speakingSessionId,
  chapterStudentEvents: {},
  currentBlocks: [],
  speakingSessionId,
  activities: [],
  progress: 0,
  blockIndex: 0,
  activityIndex: 0,
  scrollToBlockIndex: 0,
  filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("trainer_result"),
  intl
});
;// CONCATENATED MODULE: ./src/pages/prespeaking/prespeaking.page.tsx





















const PrespeakingPage = () => {
  const {
    params: {
      speakingSessionId
    }
  } = (0,react_router/* useRouteMatch */.$B)();
  const intl = (0,useIntl/* default */.Z)();
  const machine = (0,react.useMemo)(() => createPrespeakingTrainerMachine(speakingSessionId, intl), [intl, speakingSessionId]);
  const [state, send] = (0,useMachine/* useMachine */.e)(machine);
  const history = (0,react_router/* useHistory */.k6)();
  const {
    activities,
    activityIndex,
    currentBlocks: condBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const onSubmitAnswer = (0,react.useCallback)(_ref => {
    let {
      answer,
      correct,
      blockId
    } = _ref;
    return send(product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER, {
      data: {
        answer,
        blockId,
        // eslint-disable-next-line camelcase
        activityId: currentActivity?.activity_id,
        courseId: state.context.chapterInfo?.courseId,
        levelId: state.context.chapterInfo?.levelId,
        topicId: state.context.chapterInfo?.topicId,
        correct
      }
    });
  },
  // eslint-disable-next-line camelcase
  [currentActivity, send, state.context.chapterInfo]);
  const handleOutroAction = (0,react.useCallback)(a => {
    switch (a.type) {
      case "NEXT_BLOCK":
        {
          send(product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED);
          break;
        }
      case "REDIRECT_TO_SPEAKING":
        {
          history.push(studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(speakingSessionId));
          break;
        }
      default:
        break;
    }
  }, [history, send, speakingSessionId]);
  const getBlockAnswerInfo = (0,react.useCallback)(() => ({
    correct: false,
    answer: {}
  }), []);
  const {
    handleResetAnswer,
    handleNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  switch (state.value) {
    case trainer_machine_consts/* STATES */.PO.ERROR:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "error"
      });
    case trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA:
    case trainer_machine_consts/* STATES */.PO.SAVING_ANSWER:
    case trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
          onResetAnswer: blockId => {
            const currentActivityId = currentActivity?.activity_id;
            if (currentActivityId) {
              handleResetAnswer(blockId, currentActivityId);
            }
          },
          onPrevActivityClick: handlePrevActivityClick,
          blocks: condBlocks,
          activityType: currentActivity?.type ?? "story",
          onSubmitAnswer,
          currentActivityIndex: state.context.activityIndex,
          blockIndex: state.context.blockIndex,
          onNextBlockClick: handleNextBlockClick,
          onPrevBlockClick: handlePrevBlockClick,
          renderType: types/* RenderType */.y.ONE_BLOCK_PER_PAGE,
          mechanicMachineCreator: state.context.mechanicMachineCreator,
          onOutroActionTrigger: handleOutroAction,
          getBlockAnswerInfo,
          showPrevButton: false,
          showNextButton: false,
          showSkipButton: false,
          showResetButton: false,
          showSubmitButton: true,
          showAudioFooter: false,
          userEnvironment: types/* UserEnvironment */.P.Student,
          isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
          progress: state.context.progress
        })]
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "prespeaking.page",
        state: state.value
      });
  }
};
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-translation-v2-enabled.ts
var use_translation_v2_enabled = __webpack_require__(3832);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.api.ts + 1 modules
var trainer_api = __webpack_require__(40116);
;// CONCATENATED MODULE: ./src/state-machine/trainer/product/product-repetition.machine.ts


















const STATES = {
  LOADING_CHAPTER_DATA: "loadingChapterData",
  SAVING_PROGRESS: "creatingProgress",
  CHAPTER_IN_PROGRESS: "chapterInProgress",
  ERROR: "error",
  IDLE: "idle",
  FORK: "fork",
  SAVING_ANSWER: "savingAnswer"
};
var ProductRepetitionMachineErrors = /* @__PURE__ */(ProductRepetitionMachineErrors2 => {
  ProductRepetitionMachineErrors2["NotFound"] = "NotFound";
  ProductRepetitionMachineErrors2["Unknown"] = "Unknown";
  return ProductRepetitionMachineErrors2;
})(ProductRepetitionMachineErrors || {});
const getTrainerOutro = intl => ({
  outroActionControls: [{
    text: intl.formatMessage({
      id: "studentRepetition.onMain"
    }),
    action: {
      type: "ON_MAIN_PAGE"
    }
  }],
  outroTitle: intl.formatMessage({
    id: "studentRepetition.success"
  }),
  outroText: intl.formatMessage({
    id: "studentRepetition.uRepeateLexis"
  }),
  outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/05ee68e0-0ec1-4851-ba1f-2060e5baaa14/trainerOutro1.svg"
});
const product_repetition_machine_guards = {
  isChapterStateLoadedCorrectly: (_, _ref) => {
    let {
      data
    } = _ref;
    return data.data.blocks !== null;
  },
  isLastActivityAndBlock: _ref2 => {
    let {
      activities,
      activityIndex,
      blockIndex,
      currentBlocks
    } = _ref2;
    return activities.length - 1 === activityIndex && blockIndex === currentBlocks.length - 1;
  },
  isLastBlock: _ref3 => {
    let {
      currentBlocks,
      blockIndex
    } = _ref3;
    return blockIndex >= currentBlocks.length - 1;
  },
  isNextActivityEmptyAfterFilter: (0,create_trainer_machine/* getIsNextActivityEmptyAfterFilterGuard */.b2)("repetition_result"),
  isPrevActivityEmptyAfterFilter: (0,create_trainer_machine/* getIsPrevActivityEmptyAfterFilterGuard */.zh)("repetition_result"),
  isAllNextActivitiesEmptyAfterResult: (0,create_trainer_machine/* getIsAllNextActivitiesEmptyAfterFilterGuard */.NZ)("repetition_result"),
  isFirstBlock: context => context.blockIndex === 0,
  isNotFirstActivity: context => context.activityIndex !== 0
};
const product_repetition_machine_actions = {
  proceedChapterState: (context, _ref4) => {
    let {
      data
    } = _ref4;
    return {
      masteringId: data.data.mastering_id,
      activities: data.data.blocks.map(block => ({
        activity_id: block?.activity_id || "",
        type: "story",
        blocks: [block]
      })),
      chapterStudentEvents: {},
      activityIndex: 0,
      blockIndex: 0
    };
  },
  addOutroIfNeed: context => {
    const activities = [...context.activities];
    const lastActivity = activities[activities.length - 1];
    const lastBlock = lastActivity.blocks[lastActivity.blocks.length - 1];
    if (lastBlock.type === "chapter-outro") {
      return {};
    }
    const trainerOutro = getTrainerOutro(context.intl);
    const outro = {
      type: "chapter-outro",
      id: context.productId || "",
      actionControls: trainerOutro.outroActionControls,
      text: trainerOutro.outroText,
      image: trainerOutro.outroImage,
      title: trainerOutro.outroTitle
    };
    lastActivity.blocks.push(outro);
    return {
      activities
    };
  },
  calculateActivityIndex: context => {
    const foundIndex = context.activities.findIndex(activity =>
    // eslint-disable-next-line camelcase
    activity.activity_id === context?.lastEvent?.activity_id);
    const activityIndex = foundIndex >= 0 ? foundIndex : 0;
    return {
      activityIndex
    };
  },
  filterCurrentActivityBlocks: (0,xstate_es/* assign */.f0)(context => {
    const action = (0,create_trainer_machine/* getBlockFilterAction */.XI)("repetition_result").currentBlocks;
    return {
      currentBlocks: action(context)
    };
  }),
  calculateBlockIndex: context => {
    const foundIndex = context.currentBlocks.findIndex(block =>
    // eslint-disable-next-line camelcase
    block.id === context?.lastEvent?.block_id);
    return {
      blockIndex: foundIndex >= 0 ? foundIndex : 0
    };
  },
  updateProgress: (0,xstate_es/* assign */.f0)(context => {
    if (context.currentBlocks.length === 0) {
      return {
        progress: 0
      };
    }
    const blockId = context.currentBlocks[context.blockIndex].id;
    const flatBlocksList = context.activities.reduce((acc, a) => [...acc, ...a.blocks], []);
    const blockIndexInAllActivities = flatBlocksList.findIndex(b => b.id === blockId);
    return {
      progress: Math.round(blockIndexInAllActivities / (flatBlocksList.length / 100))
    };
  }),
  sendFinalEventIfNeed: context => {
    if (context.isFinalEventExist) {
      return {};
    }
    if (product_repetition_machine_guards.isLastActivityAndBlock(context) || product_repetition_machine_guards.isLastBlock(context) && product_repetition_machine_guards.isNextActivityEmptyAfterFilter(context) && product_repetition_machine_guards.isAllNextActivitiesEmptyAfterResult(context)) {
      void (0,trainer_api/* createProductProgress */.mb)({
        block_id: context.currentBlocks[context.blockIndex].id,
        activity_id: context.activities[context.activityIndex]?.activity_id,
        chapter_id: null,
        product_id: context.productId,
        event_type: "repetition_progress_final"
      });
      return {
        isFinalEventExist: true
      };
    }
    return {};
  },
  incrementActivityIndexTilNotEmpty: (0,xstate_es/* assign */.f0)({
    activityIndex: context => {
      let i = context.activityIndex + 1;
      let notEmptyActivityFound = false;
      while (i < context.activities.length && !notEmptyActivityFound) {
        const filter = (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("repetition_result");
        const filteredBlocks = filter({
          ...context,
          activityIndex: i
        });
        if (filteredBlocks.length !== 0) {
          notEmptyActivityFound = true;
        } else {
          i++;
        }
      }
      return i;
    },
    blockIndex: 0
  }),
  incrementActivityIndex: (0,xstate_es/* assign */.f0)({
    activityIndex: context => context.activityIndex + 1,
    blockIndex: 0
  }),
  incrementBlockIndex: (0,xstate_es/* assign */.f0)({
    blockIndex: context => context.blockIndex + 1
  }),
  decrementActivityTilNotEmpty: (0,xstate_es/* assign */.f0)({
    activityIndex: context => {
      let i = context.activityIndex - 1;
      let notEmptyActivityFound = false;
      while (i >= 0 && !notEmptyActivityFound) {
        const filter = (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("repetition_result");
        const filteredBlocks = filter({
          ...context,
          activityIndex: i
        });
        if (filteredBlocks.length !== 0) {
          notEmptyActivityFound = true;
        } else {
          i--;
        }
      }
      return i;
    }
  }),
  setCurrentLastBlockInActivity: (0,xstate_es/* assign */.f0)({
    blockIndex: context => context.currentBlocks.length - 1
  }),
  decrementActivityIndex: (0,xstate_es/* assign */.f0)({
    activityIndex: context => context.activityIndex - 1
  }),
  decrementBlockIndex: (0,xstate_es/* assign */.f0)({
    blockIndex: _ref5 => {
      let {
        blockIndex
      } = _ref5;
      return blockIndex - 1;
    }
  }),
  pushChapterAnswer: (0,xstate_es/* assign */.f0)({
    chapterStudentEvents: (context, event) => {
      const events = {
        ...context.chapterStudentEvents
      };
      const newEvent = {
        block_id: event.data.blockId,
        data: {
          answer: JSON.stringify(event.data.answer),
          correct: event.data.correct,
          typo: event.data.typo
        },
        activity_id: event.data.activityId,
        mastering_id: context.masteringId,
        event_type: "repetition_result"
      };
      if (events[event.data.blockId]) {
        events[event.data.blockId].push(newEvent);
      } else {
        events[event.data.blockId] = [newEvent];
      }
      return events;
    }
  })
};
const product_repetition_machine_services = {
  loadChapterData: context => (0,trainer_api/* getRepetitionState */.b_)(context?.isV2)
};
const product_repetition_machine_updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)("trainer_progress");
const productRepetitionMachine = (0,Machine/* createMachine */.C)({
  id: "product-repetition",
  initial: STATES.LOADING_CHAPTER_DATA,
  states: {
    [STATES.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: product_repetition_machine_services.loadChapterData,
        onDone: [{
          target: STATES.CHAPTER_IN_PROGRESS,
          cond: product_repetition_machine_guards.isChapterStateLoadedCorrectly,
          actions: [(0,xstate_es/* assign */.f0)(product_repetition_machine_actions.proceedChapterState), (0,xstate_es/* assign */.f0)(product_repetition_machine_actions.addOutroIfNeed), (0,xstate_es/* assign */.f0)(product_repetition_machine_actions.calculateActivityIndex), product_repetition_machine_actions.filterCurrentActivityBlocks, (0,xstate_es/* assign */.f0)(product_repetition_machine_actions.calculateBlockIndex), product_repetition_machine_actions.updateProgress]
        }, {
          target: STATES.ERROR
        }],
        onError: STATES.ERROR
      }
    },
    [STATES.CHAPTER_IN_PROGRESS]: {
      entry: (0,xstate_es/* assign */.f0)(product_repetition_machine_actions.sendFinalEventIfNeed)
    },
    [STATES.SAVING_PROGRESS]: {
      invoke: {
        src: context => (0,trainer_api/* createProductProgress */.mb)({
          product_id: context.productId,
          activity_id: context.activities[context.activityIndex]?.activity_id ?? null,
          block_id: context.currentBlocks[context.blockIndex]?.id ?? null,
          chapter_id: null,
          payload: {
            progress: context.progress,
            mastering_id: context.masteringId
          },
          event_type: "repetition_progress"
        }),
        onDone: STATES.CHAPTER_IN_PROGRESS,
        onError: STATES.CHAPTER_IN_PROGRESS
      }
    },
    [STATES.SAVING_ANSWER]: {
      invoke: {
        src: context => {
          const blockId = context.currentBlocks[context.blockIndex].id;
          const currentBlockEvents = context.chapterStudentEvents[blockId];
          const answerEvents = currentBlockEvents.filter(e => e.event_type === "repetition_result");
          const lastEvent = answerEvents[answerEvents.length - 1];
          const answer = lastEvent?.data?.answer;
          const correct = lastEvent?.data?.correct;
          const typo = lastEvent?.data?.typo;
          return (0,trainer_api/* createProductProgress */.mb)({
            product_id: context.productId,
            activity_id: context.activities[context.activityIndex]?.activity_id ?? null,
            block_id: context.currentBlocks[context.blockIndex]?.id ?? null,
            payload: {
              progress: context.progress,
              answer,
              correct,
              typo,
              mastering_id: context.masteringId
            },
            event_type: "repetition_result"
          });
        },
        onDone: STATES.CHAPTER_IN_PROGRESS,
        onError: STATES.CHAPTER_IN_PROGRESS
      }
    },
    [STATES.ERROR]: {}
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: [{
      cond: (context, _ref6) => {
        let {
          withScroll
        } = _ref6;
        return Boolean(withScroll) && [trainer_guards/* isLastBlock */.zb, trainer_guards/* isNextActivityEmptyAfterFilter */.pH].every(guard => guard(context));
      },
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getNextNotEmptyActivity */.xL,
        blockIndex: 0,
        scrollToBlockIndex: 0
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: (context, _ref7) => {
        let {
          withScroll
        } = _ref7;
        return Boolean(withScroll) && (0,trainer_guards/* isLastBlock */.zb)(context);
      },
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* incrementActivityIndex */.sp,
        blockIndex: 0,
        scrollToBlockIndex: 0
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: context => !(0,trainer_guards/* isLastBlock */.zb)(context),
      actions: [(0,xstate_es/* assign */.f0)({
        blockIndex: context => context.blockIndex + 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: trainer_actions/* getScrollToBlockIndex */.p9
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: STATES.SAVING_PROGRESS
    }],
    [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: [{
      cond: context => [trainer_guards/* isFirstBlock */.d7, trainer_guards/* notFirstActivity */.SH, trainer_guards/* isPrevActivityEmptyAfterFilter */.eR].every(guard => guard(context)),
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: context => [trainer_guards/* isFirstBlock */.d7, trainer_guards/* notFirstActivity */.SH].every(guard => guard(context)),
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: context => context.activityIndex ? context.activityIndex - 1 : 0
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: STATES.SAVING_PROGRESS
    }, {
      actions: [(0,xstate_es/* assign */.f0)({
        blockIndex: context => context.blockIndex - 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: STATES.SAVING_PROGRESS
    }],
    [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), product_repetition_machine_actions.updateProgress],
      target: STATES.SAVING_PROGRESS
    },
    [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
      actions: [(0,xstate_es/* assign */.f0)({
        chapterStudentEvents: product_repetition_machine_updateStudentEvent,
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })],
      target: STATES.SAVING_ANSWER
    },
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: {
      target: STATES.SAVING_ANSWER,
      actions: [product_repetition_machine_actions.pushChapterAnswer, product_repetition_machine_actions.filterCurrentActivityBlocks]
    }
  }
}, {
  guards: {
    every: (context, event, meta) => {
      const {
        // TODO выяснить что это и работает ли
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        cond: {
          guards: guards2
        }
      } = meta;
      return guards2 && guards2.every(guard =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      guard(context, event));
    }
  }
});
;// CONCATENATED MODULE: ./src/components/trainer/renderers/product-repetition-renderer/product-repetition-renderer.tsx






























const ProductRepetitionRenderer = _ref => {
  let {
    productId
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const stateMachine = (0,react.useMemo)(() => productRepetitionMachine.withContext({
    masteringId: "",
    productId,
    activities: [],
    currentBlocks: [],
    chapterStudentEvents: {},
    progress: 0,
    activityIndex: 0,
    blockIndex: 0,
    intl,
    scrollToBlockIndex: 0,
    filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("repetition_result"),
    mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
    isV2: isTranslationV2Enabled
  }), [intl, isTranslationV2Enabled, productId]);
  const history = (0,react_router/* useHistory */.k6)();
  const [state, send] = (0,useMachine/* useMachine */.e)(stateMachine);
  const {
    activities,
    activityIndex,
    currentBlocks: visibleBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const currentActivityId = (0,react.useMemo)(() => currentActivity ? currentActivity.activity_id : null, [currentActivity]);
  const handleOutroActions = (0,react.useCallback)(a => {
    switch (a.type) {
      case "SCHEDULE_MENTOR":
        {
          return (0,speaking_api/* getMentorSpeakingId */.Ao)().then(speakingId => {
            if (speakingId) {
              history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
              history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(speakingId, history));
            }
          });
        }
      case "ON_MAIN_PAGE":
        return history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
      case "NEXT_BLOCK":
        return send(product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED);
      default:
        return;
    }
  }, [history, send]);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    const blockEvents = state.context.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === "repetition_result") ?? [];
    const answerJSONString = answerEvent[answerEvent.length - 1]?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [state.context.chapterStudentEvents]);
  useSentryContext("productId", JSON.stringify(state.context.productId));
  useSentryContext("lastEvent", JSON.stringify(state.context.lastEvent));
  const {
    handleNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick,
    handleResetAnswer,
    handleSubmitAnswer
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  switch (state.value) {
    case STATES.ERROR:
      {
        if (state.context.error === ProductRepetitionMachineErrors.NotFound) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownErrorPage, {});
      }
    case STATES.LOADING_CHAPTER_DATA:
      return null;
    case STATES.SAVING_ANSWER:
    case STATES.CHAPTER_IN_PROGRESS:
    case STATES.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
          oneElementPerScreen: ["lexis"].includes(currentActivity?.type || "lexis"),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
            onResetAnswer: blockId => {
              if (currentActivityId) {
                handleResetAnswer(blockId, currentActivityId);
              }
            },
            onPrevActivityClick: handlePrevActivityClick,
            onSubmitAnswer: object => {
              handleSubmitAnswer({
                ...object,
                activityId: currentActivityId
              });
            },
            blocks: visibleBlocks,
            activityType: currentActivity?.type ?? "story",
            currentActivityIndex: state.context.activityIndex,
            blockIndex: state.context.blockIndex,
            onNextBlockClick: handleNextBlockClick,
            onPrevBlockClick: handlePrevBlockClick,
            mechanicMachineCreator: state.context.mechanicMachineCreator,
            onOutroActionTrigger: handleOutroActions,
            getBlockAnswerInfo,
            showPrevButton: false,
            showNextButton: true,
            showSubmitButton: true,
            showResetButton: true,
            showSkipButton: false,
            showAudioFooter: true,
            userEnvironment: types/* UserEnvironment */.P.Student,
            scrollToBlockIndex: state.context.scrollToBlockIndex,
            isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
            progress: state.context.progress
          })]
        })
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "product-repetition-renderer",
        state: state.value
      });
  }
};
;// CONCATENATED MODULE: ./src/pages/product-repetition/product-repetition.page.tsx





const ProductRepetitionPage = () => {
  const {
    productId
  } = (0,react_router/* useParams */.UO)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductRepetitionRenderer, {
    productId
  });
};
;// CONCATENATED MODULE: ./src/adapters/productTrainer.api-adapter.ts



const productTrainerApiAdapter = {
  sendTrainerEvent: trainer_api/* createProductProgress */.mb
};
// EXTERNAL MODULE: ./src/adapters/syllabus/syllabus.api-adapter.ts
var syllabus_api_adapter = __webpack_require__(13162);
;// CONCATENATED MODULE: ./src/adapters/trainer.storage-adapter.ts




const useTrainerStorage = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const getSyllabusNodeId = () => get_url_search_params.getUrlSearchParams.chapterLink.getSyllabusNodeId(history);
  return {
    getSyllabusNodeId
  };
};
// EXTERNAL MODULE: ./src/models/syllabus/syllabus.model.ts
var syllabus_model = __webpack_require__(71562);
;// CONCATENATED MODULE: ./src/services/trainer/useTrainer.ts










const createTrainerService = adapters => {
  const {
    syllabusApiService,
    productTrainerApiService,
    useTrainerStorage: useTrainerStorage2
  } = adapters;
  return function useTrainer2() {
    const {
      enableOnlyTrainerEventExperiment
    } = (0,utils_experimentDi/* useExperimentDi */.e1)();
    const user = (0,useUser/* useUser */.aF)();
    const currentUserId = user.data?.me.user?.id;
    const {
      getSyllabusNodeId
    } = useTrainerStorage2();
    const changeSelfStudyState = async props => {
      const {
        params,
        event
      } = props;
      if (!currentUserId) {
        return;
      }
      const nodeId = getSyllabusNodeId();
      const resultProductEvent = await productTrainerApiService.sendTrainerEvent(params);
      if ((0,Either.isLeft)(resultProductEvent)) {
        logger/* Logger */.Yd.captureWarning("[Trainer Event] Sent event error", {
          eventParams: params,
          error: resultProductEvent.left,
          nodeId
        });
      }
      if (nodeId !== null && !enableOnlyTrainerEventExperiment) {
        const eventParams = {
          event,
          studentId: currentUserId,
          nodeId
        };
        const syllabusEventResult = await syllabusApiService.sendEvent(eventParams);
        if ((0,Either.isLeft)(syllabusEventResult)) {
          logger/* Logger */.Yd.captureWarning("[Trainer Syllabus Event] Sent event error", {
            eventParams,
            error: syllabusEventResult.left
          });
        }
      }
    };
    const startChapter = async params => changeSelfStudyState({
      params,
      event: syllabus_model/* SyllabusNodeFSMEvent */.Sx.Progress
    });
    const finishChapter = async params => changeSelfStudyState({
      params,
      event: syllabus_model/* SyllabusNodeFSMEvent */.Sx.Finish
    });
    return {
      startChapter,
      finishChapter
    };
  };
};
const useTrainer = createTrainerService({
  syllabusApiService: syllabus_api_adapter/* syllabusApi */.A,
  productTrainerApiService: productTrainerApiAdapter,
  useTrainerStorage: useTrainerStorage
});
;// CONCATENATED MODULE: ./src/pages/product-trainer/product-trainer.page.tsx














const ProductTrainerPage = () => {
  const {
    hideGrammarAndLexis
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    [studentRoutePaths/* ProductTrainerParams */.KG.ProductId]: productId,
    [studentRoutePaths/* ProductTrainerParams */.KG.ChapterId]: chapterId,
    [studentRoutePaths/* ProductTrainerParams */.KG.ActivityId]: activityId,
    [studentRoutePaths/* ProductTrainerParams */.KG.BlockId]: blockId
  } = (0,react_router/* useParams */.UO)();
  const {
    startChapter,
    finishChapter
  } = useTrainer();
  (0,react.useEffect)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Start_Chapter");
  }, [chapterId]);
  const eventType = (0,react.useMemo)(() => ({
    init: "trainer_progress_init",
    answer: "trainer_result",
    progress: "trainer_progress",
    finish: "trainer_progress_final"
  }), []);
  if (!productId || !chapterId) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownErrorPage, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductTrainerRenderer, {
    onSaveProgress: trainer_api/* createProductProgress */.mb,
    onSaveAnswer: trainer_api/* createProductProgress */.mb,
    onInitialProgress: startChapter,
    onFinish: finishChapter,
    chapterFetcher: (productId2, chapterId2) => (0,trainer_api/* getProductChapterState */.VI)(productId2, chapterId2, hideGrammarAndLexis),
    onOpenActivity: activityId2 => {
      history.push(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(productId, chapterId, activityId2));
    },
    eventType,
    productId,
    chapterId,
    activityId,
    blockId,
    trackConversionMetrics: true,
    trainerEnvironment: trainer_model/* TrainerEnvironment */.r$.Trainer
  });
};
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js
var QueryErrorResetBoundary = __webpack_require__(26441);
;// CONCATENATED MODULE: ./src/pages/resources/components/error-screen/error-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_screen_error_screen_module = ({"container":"error-screen-module__container--HCDFI","image":"error-screen-module__image--HMU1f","heading":"error-screen-module__heading--nsjgo","text":"error-screen-module__text--ba3O7","button":"error-screen-module__button--uzUdy"});
;// CONCATENATED MODULE: ./src/pages/resources/components/error-screen/error-screen.tsx









function error_screen_ErrorScreen(_ref) {
  let {
    resetErrorBoundary
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: error_screen_error_screen_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: error_screen_error_screen_module.image,
      src: "https://flowstatic.s3.yandex.net/ui-files/09_laptop.svg",
      role: "presentation",
      alt: ""
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(error_screen_error_screen_module.heading, {
        [typography_module/* default */.Z.headline3]: !isMobile,
        [typography_module/* default */.Z.headline4Accent]: isMobile
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "resources.error.heading"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(error_screen_error_screen_module.text, {
        [typography_module/* default */.Z.body1]: !isMobile,
        [typography_module/* default */.Z.body2]: isMobile
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "resources.error.text"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      onClick: resetErrorBoundary,
      className: error_screen_error_screen_module.button,
      appearance: "primary",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "resources.error.button"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/error-screen/index.ts



;// CONCATENATED MODULE: ./src/pages/resources/hooks/use-resource-types.ts





const defaultResourceType = "speaking_session";
const $selectedResourceType = (0,effector/* createStore */.MT)(defaultResourceType);
const selectedResourceTypeApi = (0,effector/* createApi */.LC)($selectedResourceType, {
  select: (_, resourceType) => resourceType
});
function useResourceTypes() {
  const {
    resources
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    resourceTypes
  } = resources;
  const selectedResourceType = (0,effector_react/* useStore */.oR)($selectedResourceType);
  return {
    resourceTypes,
    selectedResourceType,
    onSelect: selectedResourceTypeApi.select,
    hasMultipleTypes: resourceTypes.length > 1
  };
}
// EXTERNAL MODULE: ./src/pages/resources/hooks/use-resources-balance.ts
var use_resources_balance = __webpack_require__(83225);
;// CONCATENATED MODULE: ./src/pages/resources/view-model/counts.ts





const countsWeights = {
  remaining: 0,
  completed: 1,
  burned: 2,
  all: 3
};
function getCountsViewModel(_ref) {
  let {
    balance,
    selectedResourceType
  } = _ref;
  const counts = balance[selectedResourceType];
  if (!counts) {
    return {
      counts: []
    };
  }
  return {
    counts: (0,object_utils/* getObjectEntries */.J)(countsWeights).sort((_ref2, _ref3) => {
      let [, weightA] = _ref2;
      let [, weightB] = _ref3;
      return weightA - weightB;
    }).map(_ref4 => {
      let [key] = _ref4;
      return {
        count: counts[key] ?? 0,
        labelKey: `resources.counts.${key}`
      };
    })
  };
}
;// CONCATENATED MODULE: ./src/pages/resources/hooks/use-counts.ts





function useCounts() {
  const {
    selectedResourceType
  } = useResourceTypes();
  return (0,use_resources_balance/* useResourcesBalance */.U)({
    select: balance => getCountsViewModel({
      balance,
      selectedResourceType
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/hooks/index.ts




;// CONCATENATED MODULE: ./src/pages/resources/components/counts/counts.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const counts_module = ({"counts":"counts-module__counts--SI5sA","count":"counts-module__count--bMX1S","amount":"counts-module__amount--GussA","label":"counts-module__label--WLbOj"});
;// CONCATENATED MODULE: ./src/pages/resources/components/counts/skeleton.tsx









function CountsSkeleton() {
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    className: counts_module.counts,
    children: [...Array(4).keys()].map((_, index) => /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
      className: counts_module.count,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
        width: "20%",
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, counts_module.amount)
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
        width: "50%",
        className: classnames_default()(typography_module/* default */.Z.captionAccent, counts_module.label)
      })]
    }, index))
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/counts/counts.tsx












function Counts() {
  const {
    data
  } = useCounts();
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  if (!data) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(CountsSkeleton, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    className: counts_module.counts,
    children: data.counts.map(_ref => {
      let {
        count,
        labelKey
      } = _ref;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
        className: counts_module.count,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, counts_module.amount),
          children: count
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()({
            [typography_module/* default */.Z.caption]: !isDesktop,
            [typography_module/* default */.Z.body2]: isDesktop
          }, counts_module.label),
          children: intl.formatMessage({
            id: labelKey
          }, {
            count
          })
        })]
      }, labelKey);
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/counts/index.ts



// EXTERNAL MODULE: ../ui-kit/src/toggle-button-group/toggle-button-group.tsx + 3 modules
var toggle_button_group = __webpack_require__(3717);
;// CONCATENATED MODULE: ./src/pages/resources/components/select-resource-type/select-resource-type.tsx









function SelectResourceType() {
  const {
    resourceTypes,
    selectedResourceType,
    onSelect
  } = useResourceTypes();
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const values = resourceTypes.map(resourceType => ({
    id: resourceType,
    label: intl.formatMessage({
      id: `resources.types.toggle.${resourceType}`
    })
  }));
  return /* @__PURE__ */(0,jsx_runtime.jsx)(toggle_button_group/* ToggleButtonGroup */.t, {
    view: isMobile ? "vertical" : "horizontal",
    values,
    onChange: onSelect,
    selectedValueId: selectedResourceType
  });
}
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
;// CONCATENATED MODULE: ./src/pages/resources/components/reason-popup/utils.ts




function mapTitle(_ref) {
  let {
    popupState,
    intl,
    isForeigner
  } = _ref;
  const foreignerPart = isForeigner ? "_foreigner" : "";
  return intl.formatMessage({
    id: `resources.popup.${popupState.reason + foreignerPart}.title`
  }, {
    sessionStartAt: popupState.sessionStartAt && (0,format/* format */.WU)(popupState.sessionStartAt, "d MMMM HH:mm", {
      locale: (0,utils_locale/* getDateFnsLocale */.G)(intl.locale)
    })
  });
}
function mapSubtitle(_ref2) {
  let {
    popupState,
    intl
  } = _ref2;
  if (popupState.reason === "student_no_show_session") {
    return null;
  }
  return intl.formatMessage({
    id: `resources.popup.${popupState.reason}.subtitle`
  }, {
    sessionStartAt: popupState.sessionStartAt && (0,format/* format */.WU)(popupState.sessionStartAt, "d MMMM HH:mm", {
      locale: (0,utils_locale/* getDateFnsLocale */.G)(intl.locale)
    }),
    createdAt: popupState.createdAt && (0,format/* format */.WU)(popupState.createdAt, "HH:mm", {
      locale: (0,utils_locale/* getDateFnsLocale */.G)(intl.locale)
    })
  });
}
function getReasonPopupViewModel(_ref3) {
  let {
    intl,
    popupState,
    isForeigner
  } = _ref3;
  if (popupState.isVisible) {
    return {
      title: mapTitle({
        popupState,
        intl,
        isForeigner
      }),
      subtitle: mapSubtitle({
        popupState,
        intl
      }),
      isVisible: popupState.isVisible
    };
  }
  return {
    title: null,
    subtitle: null,
    isVisible: popupState.isVisible
  };
}
;// CONCATENATED MODULE: ./src/pages/resources/components/reason-popup/use-reason-popup.ts








const $popup = (0,effector/* createStore */.MT)({
  isVisible: false,
  reason: null,
  createdAt: null,
  sessionStartAt: null
});
const popupApi = (0,effector/* createApi */.LC)($popup, {
  openPopup: (_, payload) => ({
    ...payload,
    isVisible: true
  }),
  closePopup: () => $popup.defaultState
});
function useReasonPopup() {
  const popupState = (0,effector_react/* useStore */.oR)($popup);
  const {
    selectedResourceType
  } = useResourceTypes();
  const intl = (0,useIntl/* default */.Z)();
  const isForeigner = selectedResourceType === "native_speaker_session";
  const openPopup = (0,react.useCallback)(params => {
    popupApi.openPopup(params);
  }, []);
  return {
    openPopup,
    closePopup: popupApi.closePopup,
    viewModel: getReasonPopupViewModel({
      intl,
      popupState,
      isForeigner
    })
  };
}
;// CONCATENATED MODULE: ./src/pages/resources/components/reason-popup/reason-popup.tsx






function ReasonPopup() {
  const intl = (0,useIntl/* default */.Z)();
  const {
    closePopup,
    viewModel: {
      isVisible,
      title,
      subtitle
    }
  } = useReasonPopup();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    isVisible,
    size: modal/* ModalSize */.Cg.Small,
    onClose: closePopup,
    title,
    subtitle,
    buttonsBlockStretch: true,
    buttons: [{
      text: intl.formatMessage({
        id: "resources.popup.okButtonText"
      }),
      appearance: "primary",
      onClick: closePopup
    }]
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/reason-popup/index.ts




;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/skeleton.tsx





const TransactionsSkeleton = () => /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
  className: transactions_module.transactions,
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
    wrapper: _ref => {
      let {
        children
      } = _ref;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        className: transactions_module.transaction,
        children
      });
    },
    count: 10
  })
});
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/open-popup-button.tsx







function OpenPopupButton(_ref) {
  let {
    reason,
    createdAt,
    sessionStartAt
  } = _ref;
  const {
    openPopup
  } = useReasonPopup();
  const intl = (0,useIntl/* default */.Z)();
  const onClick = () => {
    openPopup({
      reason,
      createdAt,
      sessionStartAt: sessionStartAt ?? null
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
    className: transactions_module.infoButton,
    "aria-label": intl.formatMessage({
      id: "resources.popup.openButton.label"
    }),
    size: "tiny",
    iconName: "info",
    appearance: "default",
    onClick
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/transaction-item.tsx










function TransactionItem(_ref) {
  let {
    transactionItem,
    innerRef
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    amount,
    type,
    displayReasonKey,
    hasPopup,
    displayDate,
    reason,
    createdAt,
    sessionStartAt
  } = transactionItem;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const showPopupButtonMobile = isMobile && hasPopup;
  const showPopupButtonDesktop = !isMobile && hasPopup;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
    className: transactions_module.transaction,
    ref: innerRef,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: transactions_module.info,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()({
          [typography_module/* default */.Z.captionAccent]: isMobile,
          [typography_module/* default */.Z.body2]: !isMobile
        }, transactions_module.date),
        children: displayDate
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("p", {
        className: classnames_default()({
          [typography_module/* default */.Z.caption]: isMobile,
          [typography_module/* default */.Z.body2]: !isMobile,
          [transactions_module.reasonBurn]: showPopupButtonDesktop
        }),
        children: [intl.formatMessage({
          id: displayReasonKey
        }), showPopupButtonDesktop && /* @__PURE__ */(0,jsx_runtime.jsx)(OpenPopupButton, {
          reason,
          createdAt,
          sessionStartAt
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: transactions_module.amountContainer,
      children: [showPopupButtonMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(OpenPopupButton, {
        reason,
        createdAt,
        sessionStartAt
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(AmountChip, {
        amount,
        type
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/transactions-list.tsx







function TransactionsList(_ref) {
  let {
    transactions
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    className: transactions_module.transactions,
    children: transactions.map(transactionItem => /* @__PURE__ */(0,jsx_runtime.jsx)(TransactionItem, {
      transactionItem
    }, transactionItem.id))
  });
}
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js + 1 modules
var useInfiniteQuery = __webpack_require__(88716);
// EXTERNAL MODULE: ./src/pages/resources/api/index.ts + 3 modules
var api = __webpack_require__(95935);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(95790);
// EXTERNAL MODULE: ../../node_modules/date-fns/fromUnixTime.mjs
var fromUnixTime = __webpack_require__(34925);
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/utils.ts





function mapTransactionType(_ref) {
  let {
    reason,
    amount
  } = _ref;
  if (amount > 0) {
    return "add";
  }
  if (["finish_session", "success_session"].includes(reason)) {
    return "subtract";
  }
  return "burn";
}
function mapAmount(amount) {
  return amount > 0 ? `+${amount}` : `${amount}`;
}
function mapReason(reason) {
  return `resources.transactions.reason.${reason}`;
}
function mapDate(_ref2) {
  let {
    date,
    locale
  } = _ref2;
  return (0,format/* format */.WU)(date, "d MMMM, HH:mm", {
    locale
  });
}
function mapHasPopup(reason) {
  return ["student_no_show_session", "late_canceled_session", "late_rescheduled_session", "multiple_rescheduled_session", "cancel_after_reschedule"].includes(reason);
}
function getSessionStartAt(sessionStartAt) {
  switch (typeof sessionStartAt) {
    case "string":
      return (0,parseISO/* parseISO */.D)(sessionStartAt);
    case "number":
      return (0,fromUnixTime/* fromUnixTime */.K)(sessionStartAt);
    default:
      return void 0;
  }
}
function mapTransactions(_ref3) {
  let {
    transactions,
    locale
  } = _ref3;
  return transactions.map(transaction => {
    const {
      id,
      created_at: createdAt,
      reason,
      amount,
      payload
    } = transaction;
    const date = (0,parseISO/* parseISO */.D)(createdAt);
    return {
      id,
      reason,
      createdAt: date,
      sessionStartAt: getSessionStartAt(payload.session_start_at),
      displayDate: mapDate({
        date,
        locale
      }),
      displayReasonKey: mapReason(reason),
      amount: mapAmount(amount),
      type: mapTransactionType({
        reason,
        amount
      }),
      hasPopup: mapHasPopup(reason)
    };
  });
}
function getTransactionsViewModel(_ref4) {
  let {
    transactions,
    locale
  } = _ref4;
  return mapTransactions({
    transactions,
    locale
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/use-transactions.ts











const useTransactions = () => {
  const intl = (0,useIntl/* default */.Z)();
  const locale = (0,utils_locale/* getDateFnsLocale */.G)(intl.locale);
  const user = (0,useUser/* useUser */.aF)();
  const {
    selectedResourceType
  } = useResourceTypes();
  const businessProductId = user.data?.product?.businessId;
  const res = (0,useInfiniteQuery/* useInfiniteQuery */.N)({
    enabled: Boolean(businessProductId),
    queryKey: ["resourcesTransactions", businessProductId, selectedResourceType],
    queryFn: _ref => {
      let {
        pageParam
      } = _ref;
      return (0,api/* fetchTransactionHistory */.i)({
        businessProductId: (0,product_model/* makeBusinessProductId */.bX)(businessProductId),
        pageno: pageParam,
        resourceType: selectedResourceType
      });
    },
    initialPageParam: 0,
    getNextPageParam: lastPage => lastPage.pageno ?? void 0,
    staleTime: 1e3 * 60,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false
  });
  const transactionsViewModel = (0,react.useMemo)(() => res.data?.pages.flatMap(_ref2 => {
    let {
      history
    } = _ref2;
    return getTransactionsViewModel({
      transactions: history,
      locale
    });
  }), [locale, res.data?.pages]);
  return {
    ...res,
    data: transactionsViewModel
  };
};
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/transactions.tsx













const Transactions = () => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading
  } = useTransactions();
  const intl = (0,useIntl/* default */.Z)();
  const {
    ref,
    inView
  } = (0,react_intersection_observer_m/* useInView */.YD)();
  (0,react.useEffect)(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      void fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, inView, isFetchingNextPage]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: transactions_module.listHeading,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.body2,
        children: intl.formatMessage({
          id: "resources.transactionDateHeader"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.body2,
        children: intl.formatMessage({
          id: "resources.transactionTypeHeader"
        })
      })]
    }), isLoading && /* @__PURE__ */(0,jsx_runtime.jsx)(TransactionsSkeleton, {}), data && /* @__PURE__ */(0,jsx_runtime.jsx)(TransactionsList, {
      transactions: data
    }), isFetchingNextPage && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: transactions_module.loaderContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ReasonPopup, {}), hasNextPage && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/resources/components/transactions/index.ts



;// CONCATENATED MODULE: ./src/pages/resources/components/resources/resources.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const resources_module = ({"container":"resources-module__container--WWa9R","back-link-container":"resources-module__back-link-container--yREx3","backLinkContainer":"resources-module__back-link-container--yREx3","content":"resources-module__content--Bm_GO","select-container":"resources-module__select-container--VhkMs","selectContainer":"resources-module__select-container--VhkMs","counts-container":"resources-module__counts-container--TVZL5","countsContainer":"resources-module__counts-container--TVZL5","heading-container":"resources-module__heading-container--Gt1mU","headingContainer":"resources-module__heading-container--Gt1mU","list-heading":"resources-module__list-heading--BIvr4","listHeading":"resources-module__list-heading--BIvr4"});
;// CONCATENATED MODULE: ./src/pages/resources/components/resources/resources-content.tsx












const ResourcesContent = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    hasMultipleTypes
  } = useResourceTypes();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
    className: resources_module.content,
    children: [hasMultipleTypes && /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
      className: resources_module.selectContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(SelectResourceType, {})
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
      className: resources_module.countsContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Counts, {})
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: resources_module.headingContainer,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()({
          [typography_module/* default */.Z.body2Accent]: isMobile,
          [typography_module/* default */.Z.headline4Accent]: !isMobile
        }, resources_module.listHeading),
        children: intl.formatMessage({
          id: "resources.transactionHistory"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()({
          [typography_module/* default */.Z.caption]: isMobile,
          [typography_module/* default */.Z.body2]: !isMobile
        }),
        children: intl.formatMessage({
          id: "resources.transactionHistoryDescription"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Transactions, {})]
  });
};
;// CONCATENATED MODULE: ./src/pages/resources/components/resources/resources.tsx












const Resources = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    reset
  } = (0,QueryErrorResetBoundary/* useQueryErrorResetBoundary */._)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: resources_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: resources_module.backLinkContainer,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(GoToLink, {
        link: studentRoutePaths/* studentRoutePaths */.dR.INDEX,
        text: intl.formatMessage({
          id: "backButton"
        }),
        withMarginBottom: false
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
      onError: logger/* Logger */.Yd.captureException,
      onReset: reset,
      onErrorContent: _ref => {
        let {
          resetErrorBoundary
        } = _ref;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(error_screen_ErrorScreen, {
          resetErrorBoundary
        });
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesContent, {})
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/resources/resources.page.tsx









const ResourcesPage = () => {
  const {
    resources,
    resourcesExperiment,
    referral
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const isReferralExperimentActive = Boolean(referral.tariff_slug);
  if (!resources.enabled && !resourcesExperiment) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: studentRoutePaths/* studentRoutePaths */.dR.INDEX
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    main: {
      hideGrammarGuideButton: true
    },
    header: {
      hideReferralProgramElements: !isReferralExperimentActive
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(Resources, {})
  });
};
// EXTERNAL MODULE: ../shared/src/api/speaking-sessions/speaking-sessions.api.ts
var speaking_sessions_api = __webpack_require__(67145);
// EXTERNAL MODULE: ../shared/src/currentBrowser.ts
var currentBrowser = __webpack_require__(97186);
// EXTERNAL MODULE: ./src/components/controls-panel/controls-panel.tsx + 3 modules
var controls_panel = __webpack_require__(34228);
// EXTERNAL MODULE: ./src/hooks/use-mobile-app.ts
var use_mobile_app = __webpack_require__(74126);
;// CONCATENATED MODULE: ./src/pages/speaking-checkup/ui/errors/unSupportedBrowserError/unSupportedError.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const unSupportedError_module = ({"container":"unSupportedError-module__container--q16YB","subtitle":"unSupportedError-module__subtitle--sp5pQ"});
;// CONCATENATED MODULE: ./src/pages/speaking-checkup/ui/errors/unSupportedBrowserError/unSupportedBrowserError.tsx







function UnSupportedBrowserError() {
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: unSupportedError_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      className: typography_module/* default */.Z.headline4Accent,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "speakingCheckup.browserErrorTitle"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2, unSupportedError_module.subtitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "speakingCheckup.browserErrorSubtitle"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/speaking-checkup/ui/errors/index.tsx



;// CONCATENATED MODULE: ./src/pages/speaking-checkup/ui/speaking-checkup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const speaking_checkup_module = ({"root":"speaking-checkup-module__root--xyLhh","iphone-error-container":"speaking-checkup-module__iphone-error-container--SAXFj","iphoneErrorContainer":"speaking-checkup-module__iphone-error-container--SAXFj","iphone-error-container-subtitle":"speaking-checkup-module__iphone-error-container-subtitle--VD_g7","iphoneErrorContainerSubtitle":"speaking-checkup-module__iphone-error-container-subtitle--VD_g7"});
;// CONCATENATED MODULE: ./src/pages/speaking-checkup/ui/speaking-checkup.page.tsx























const HardwareGoloomCheckupLazy = (0,react.lazy)(() => Promise.all(/* import() | checkup.goloom */[__webpack_require__.e(337), __webpack_require__.e(611), __webpack_require__.e(682), __webpack_require__.e(547)]).then(__webpack_require__.bind(__webpack_require__, 26459)));
const HardwareCheckupLazy = (0,react.lazy)(() => Promise.all(/* import() | checkup.legacy */[__webpack_require__.e(611), __webpack_require__.e(682), __webpack_require__.e(588)]).then(__webpack_require__.bind(__webpack_require__, 65754)));
const SpeakingCheckupPageLayout = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: speaking_checkup_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {}), children, /* @__PURE__ */(0,jsx_runtime.jsx)(controls_panel/* ControlsPanelHelpButton */.ld, {
      isSpeaking: true
    })]
  });
};
const SpeakingCheckupPage = _ref2 => {
  let {
    speakingPath
  } = _ref2;
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    speakingSessionId
  } = (0,react_router/* useParams */.UO)();
  const {
    goloomCheckup
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const [isGoloomWebrtcProvider, setIsGoloomWebrtcProvider] = (0,react.useState)(false);
  const hideSpeakingCheckupSettingButtonFeature = (0,features/* useFeatureFlag */.ye)("hideSpeakingCheckupSettingButton");
  const settingsAvailable = hideSpeakingCheckupSettingButtonFeature && isGoloomWebrtcProvider;
  const handleOkClick = (0,react.useCallback)(checkupResult => {
    storage/* localStorageWrapper */.Y6.classInitialIsOnlyAudio.setOnlyAudio(checkupResult.onlyAudio);
    history.push(speakingPath);
  }, [history, speakingPath]);
  const isSupportedWebrtc = (0,currentBrowser/* isSupportWebRTC */.Rt)();
  (0,react.useEffect)(() => {
    void (0,speaking_sessions_api/* fetchSpeakingSessionExperiments */.bR)(speakingSessionId).then(experiments => {
      if ((0,Either.isRight)(experiments)) {
        setIsGoloomWebrtcProvider(experiments.right.webrtc_provider === webrtc_model/* WebrtcProvider */.x.Goloom);
      }
    });
  }, [speakingSessionId]);
  const {
    isMobileApp,
    requestPermission,
    onPermissionChanged,
    openSettings
  } = (0,use_mobile_app/* useMobileApp */._g)();
  const [mobilePermissions, setMobilePermissions] = (0,react.useState)({
    camera: void 0,
    microphone: void 0
  });
  (0,react.useEffect)(() => {
    if (isMobileApp) {
      if (!mobilePermissions.camera) {
        requestPermission("camera");
        return;
      }
      if (!mobilePermissions.microphone) {
        requestPermission("microphone");
      }
    }
  }, [isMobileApp, mobilePermissions, requestPermission]);
  (0,react.useEffect)(() => {
    if (isMobileApp) {
      const cleanupCallback = onPermissionChanged((permission, status) => setMobilePermissions(state => ({
        ...state,
        [permission]: status
      })));
      return () => {
        cleanupCallback();
      };
    }
  }, [isMobileApp, onPermissionChanged]);
  if (isMobileApp) {
    const isPermissionRequesting = mobilePermissions.camera === void 0 || mobilePermissions.microphone === void 0;
    if (isPermissionRequesting) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingCheckupPageLayout, {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
      });
    }
    const isPermissionNotGranted = mobilePermissions.camera !== use_mobile_app/* PermissionStatus */.nx.granted || mobilePermissions.microphone !== use_mobile_app/* PermissionStatus */.nx.granted;
    if (isPermissionNotGranted) {
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          alt: intl.formatMessage({
            id: "hardwareCheckup.micCameraImageAlt"
          }),
          className: speaking_checkup_module.headerImage,
          src: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/2896f9b5-ede4-48e1-be94-5f9762d1738f/mic_camera%201.svg"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(speaking_checkup_module.header, typography_module/* default */.Z.headline4Accent),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "hardwareCheckup.givePermission"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "secondary",
          onClick: openSettings,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "hardwareCheckup.settings"
          })
        })]
      });
    }
  }
  const CheckupComponent = goloomCheckup ? HardwareGoloomCheckupLazy : HardwareCheckupLazy;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(SpeakingCheckupPageLayout, {
    children: [isSupportedWebrtc && /* @__PURE__ */(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {}),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(CheckupComponent, {
        settingsAvailable: settingsAvailable || goloomCheckup,
        onOk: handleOkClick
      })
    }), !isSupportedWebrtc && /* @__PURE__ */(0,jsx_runtime.jsx)(UnSupportedBrowserError, {})]
  });
};
;// CONCATENATED MODULE: ./src/pages/speaking-checkup/index.tsx



// EXTERNAL MODULE: ../shared/src/entities/onboarding/index.ts + 6 modules
var onboarding = __webpack_require__(13083);
// EXTERNAL MODULE: ./src/hooks/experiments-and-features/use-progress-page-enabled.ts
var use_progress_page_enabled = __webpack_require__(67512);
;// CONCATENATED MODULE: ./src/hooks/trainer/use-repetition-availability.tsx




const useRepetitionAvailability = isV2 => (0,useQuery/* useQuery */.a)({
  queryKey: ["repetitionAvailability"],
  queryFn: () => (0,trainer_api/* getRepetitionAvailability */.Dx)(isV2),
  staleTime: Infinity,
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false
});
;// CONCATENATED MODULE: ./src/services/beginner-onboarding/beginner-onboarding.ts




function useBeginnerOnboarding() {
  const state = (0,effector_react/* useStore */.oR)(onboarding/* $currentOnboardingState */.W4);
  return {
    state
  };
}
// EXTERNAL MODULE: ../../node_modules/date-fns/subMonths.mjs
var subMonths = __webpack_require__(76094);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMonths.mjs
var addMonths = __webpack_require__(77617);
;// CONCATENATED MODULE: ./src/adapters/speaking-sessions/speaking-session.storage-adapter.ts




const speakingSessionDomain = (0,effector/* createDomain */.Fj)("speakingSession");
const $speakingSessions = speakingSessionDomain.createStore({});
const $pendingSessionsExist = speakingSessionDomain.createStore(false);
const setSpeakingSessionsFx = speakingSessionDomain.createEvent();
const pushSpeakingSessionFx = speakingSessionDomain.createEvent();
const setPendingSessionsExistFx = speakingSessionDomain.createEvent();
const setSpeakingSessionStateFx = speakingSessionDomain.createEvent();
$speakingSessions.on(setSpeakingSessionsFx, (state, payload) => payload);
$speakingSessions.on(setSpeakingSessionStateFx, (state, payload) => {
  const speakingSession = state[payload.speakingSessionId];
  return {
    ...state,
    [payload.speakingSessionId]: {
      ...speakingSession,
      state: payload.state
    }
  };
});
$speakingSessions.on(pushSpeakingSessionFx, (state, speakingSession) => ({
  ...state,
  [speakingSession.id]: {
    ...speakingSession
  }
}));
$pendingSessionsExist.on(setPendingSessionsExistFx, (state, payload) => payload);
const useSpeakingSessionStorage = () => {
  const studentSpeakingSessions = (0,effector_react/* useStore */.oR)($speakingSessions);
  const pendingSessionsExist = (0,effector_react/* useStore */.oR)($pendingSessionsExist);
  return {
    speakingSessions: studentSpeakingSessions,
    setSpeakingSessionState: setSpeakingSessionStateFx,
    setSpeakingSessions: setSpeakingSessionsFx,
    setSpeakingSession: pushSpeakingSessionFx,
    pendingSessionsExist,
    setPendingSessionsExist: setPendingSessionsExistFx
  };
};
;// CONCATENATED MODULE: ./src/services/scheduling/scheduling.ts










const useScheduling = () => {
  const {
    pendingSessionsExist,
    setPendingSessionsExist,
    setSpeakingSession,
    setSpeakingSessionState,
    setSpeakingSessions,
    speakingSessions
  } = useSpeakingSessionStorage();
  const {
    data: user
  } = (0,useUser/* useUser */.aF)();
  const speakingTypeId = user?.product?.speakingTypeId;
  const futureSpeakingSessions = (0,react.useMemo)(() => Object.values(speakingSessions).filter(speakingSession => speakingSession.speaking.typeId === speakingTypeId).sort((prev, next) => (0,isAfter/* isAfter */.A)(prev.startAt, next.startAt) ? 1 : -1), [speakingSessions, speakingTypeId]);
  const initSpeakingSessions = (0,react.useCallback)(async () => {
    const speakingSessionsResponse = await (0,speaking_session_speaking_session_api/* getStudentSpeakingSessions */.Zt)({
      from: (0,subMonths/* subMonths */.W)((0,startOfToday/* startOfToday */.I)(), 2),
      to: (0,addMonths/* addMonths */.z)((0,startOfToday/* startOfToday */.I)(), 2)
    });
    setSpeakingSessions(speakingSessionsResponse.speakingSessions);
    setPendingSessionsExist(speakingSessionsResponse.pendingSessionsExist);
  }, [setPendingSessionsExist, setSpeakingSessions]);
  return {
    setSpeakingSessions,
    setSpeakingSession,
    setSpeakingSessionState,
    initSpeakingSessions,
    speakingSessions: futureSpeakingSessions,
    pendingSessionsExist
  };
};
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__bottom-menu/bottom-menu.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const bottom_menu_module = ({"root":"bottom-menu-module__root--l86Bq","button":"bottom-menu-module__button--IsEaq","selected":"bottom-menu-module__selected--HYMG5","text":"bottom-menu-module__text--qUDIC"});
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__bottom-menu/bottom-menu.component.tsx









const BottomMenu = _ref => {
  let {
    items
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: bottom_menu_module.root,
    children: items.map(i => /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: classnames_default()(bottom_menu_module.button, {
        [bottom_menu_module.selected]: i.selected
      }),
      onClick: i.action,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: i.iconName,
        size: "small"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.caption, bottom_menu_module.text),
        children: i.text
      })]
    }, i.text))
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/bottom-menu/bottom-menu.tsx












const bottom_menu_BottomMenu = (0,react.memo)(function BottomMenu2() {
  const history = (0,react_router/* useHistory */.k6)();
  const intl = (0,useIntl/* default */.Z)();
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const isScheduleTab = Boolean((0,react_router/* useRouteMatch */.$B)(routes.SCHEDULE));
  const isResourcesTab = Boolean((0,react_router/* useRouteMatch */.$B)(routes.RESOURCES));
  const isScheduleListTab = Boolean((0,react_router/* useRouteMatch */.$B)(routes.SCHEDULE_LIST));
  const isTasksTab = Boolean((0,react_router/* useRouteMatch */.$B)(routes.TASKS));
  const isProgressTab = Boolean((0,react_router/* useRouteMatch */.$B)(routes.PROGRESS.INDEX));
  const isChatOpen = Boolean(get_url_search_params.getUrlSearchParams.openHelp.isOpen(history));
  const {
    shouldShowProgress
  } = (0,use_progress_page_enabled/* useProgressPageEnabled */.e)();
  if (isDesktop) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(BottomMenu, {
    items: [{
      selected: isScheduleTab || isResourcesTab,
      iconName: "user-solid",
      text: intl.formatMessage({
        id: "pageHeader.main"
      }),
      action: () => {
        history.push(routes.SCHEDULE);
      }
    }, {
      selected: isScheduleListTab,
      iconName: "calendar",
      text: intl.formatMessage({
        id: "pageHeader.schedule"
      }),
      action: () => {
        history.push(routes.SCHEDULE_LIST);
      }
    }, {
      selected: isTasksTab,
      iconName: "notes",
      text: intl.formatMessage({
        id: "pageHeader.tasks"
      }),
      action: () => {
        history.push(routes.TASKS);
      }
    }, shouldShowProgress ? {
      selected: isProgressTab,
      iconName: "chart",
      text: intl.formatMessage({
        id: "pageHeader.progress"
      }),
      action: () => history.push(routes.PROGRESS.SKILLS)
    } : {
      selected: isChatOpen,
      iconName: isChatOpen ? "cross" : "help-solid",
      text: isChatOpen ? intl.formatMessage({
        id: "pageHeader.closeSupport"
      }) : intl.formatMessage({
        id: "pageHeader.support"
      }),
      action: () => {
        if (isChatOpen) {
          history.push(get_url_search_params.getUrlSearchParams.openHelp.getCloseUrl(history));
        } else {
          history.push(get_url_search_params.getUrlSearchParams.openHelp.getOpenUrl(history));
        }
      }
    }]
  });
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/beginner-index-page-loading.tsx







const BeginnerIndexPageLoading = () => /* @__PURE__ */(0,jsx_runtime.jsxs)(app_page_wrapper_component/* AppPageWrapper */.I, {
  self: {
    bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
  },
  header: {
    hideNavigation: true
  },
  main: {
    hideHelpPopup: true,
    hideGrammarGuideButton: true
  },
  footer: {
    hideFooter: true
  },
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_menu_BottomMenu, {})]
});
// EXTERNAL MODULE: ./src/widgets/student-contact-info/index.ts + 6 modules
var student_contact_info = __webpack_require__(59411);
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/index.ts + 7 modules
var student_attributes = __webpack_require__(14325);
// EXTERNAL MODULE: ./src/widgets/curator-onboarding-screen-content/ui/curator-onboarding-screen-content.tsx + 1 modules
var curator_onboarding_screen_content = __webpack_require__(37260);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/curator-onboarding-screen/curator-onboarding-screen.tsx









const CuratorOnboardingScreen = _ref => {
  let {
    needCuratorOnboarding
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  if (onboardingState === student_attributes/* OnboardingFSMState */.Cv.Studying) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: routes.SCHEDULE
    });
  }
  const content = needCuratorOnboarding ? {
    title: intl.formatMessage({
      id: "autoOnboardingPage.curatorOnboardingScreen.title"
    }),
    contentFirstBlock: intl.formatMessage({
      id: "autoOnboardingPage.preCuratorOnboardingScreen.firstBlock"
    }),
    contentSecondBlock: intl.formatMessage({
      id: "autoOnboardingPage.preCuratorOnboardingScreen.secondBlock"
    }),
    contentThirdBlock: intl.formatMessage({
      id: "autoOnboardingPage.preCuratorOnboardingScreen.thirdBlock"
    }),
    imageAlt: "curator onboarding waiting",
    imageSrc: "https://flowstatic.s3.yandex.net/ui-files/autoonboarding-curator-waiting.svg"
  } : {
    title: intl.formatMessage({
      id: "onboarding.curatorScreen.title"
    }),
    contentFirstBlock: intl.formatMessage({
      id: "onboarding.curatorScreen.firstBlock"
    }),
    contentSecondBlock: intl.formatMessage({
      id: "onboarding.curatorScreen.secondBlock"
    }),
    contentThirdBlock: intl.formatMessage({
      id: "onboarding.curatorScreen.thirdBlock"
    }),
    imageAlt: "curator onboarding waiting",
    imageSrc: "https://flowstatic.s3.yandex.net/ui-files/onboarding-curator-waiting.svg"
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(curator_onboarding_screen_content/* CuratorOnboardingScreenContent */.w, {
    content
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/onboarding/__starting-info/Tutor.svg
function Tutor_extends() { Tutor_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Tutor_extends.apply(this, arguments); }

/* harmony default export */ const Tutor = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", Tutor_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#69B0CC",
    d: "M64 114.286c27.772 0 50.286-22.513 50.286-50.285 0-27.773-22.514-50.286-50.286-50.286-27.772 0-50.286 22.513-50.286 50.286 0 27.772 22.514 50.285 50.286 50.285z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M56.229 31.845a26.168 26.168 0 0138.857-2.13 27.206 27.206 0 017.899 19.958 25.548 25.548 0 01-4.612 13.87 25.86 25.86 0 01-14.295 9.764 31.04 31.04 0 01-17.349-.548c-2.889-.915-5.211-1.884-7.639-3.712a24.754 24.754 0 01-6.715-7.708c-2.898-5.513-3.356-12.182-1.756-18.212 1.6-6.03 5.152-11.433 9.692-15.699"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M78.683 72.23c1.742 8.196 1.51 17.17.238 25.453-6.569-.969-13.303.206-19.83.206l4.946-9.792c2.12-4.192 1.828-8.878 3.2-13.371a3.8 3.8 0 01.855-1.715c.662-.649 1.677-.736 2.605-.786 2.492-.142 5.486.137 7.986.005z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M44.073 57.601c-3.456-.425-8.041-.457-11.237.915-2.486 1.07-4.713 1.339-5.942 4.96-1.372 3.99 0 8.745 1.248 12.777.914 2.967 1.769 6.61 3.501 7.63 3.429 2.006 12.494 1.138 15.726-.915 2.532 3.813 1.956 4.914 5.083 9.54.796 1.18 3.47 3.082 4.896 3.123 2.565.069 5.486-3.63 6.675-5.906 2.88-5.486 3.84-11.767 4.758-17.907-2.624 4.631-5.417 10.218-9.193 13.472-6.647-10.573-11.131-25.618-8.845-38.102.26-1.422 0-2.615-.133-4.055-.178-2.236-.146-5.029-2.693-4.339-1.71.458-3.712 3.04-4.507 4.476-2.427 4.402-1.188 9.467.663 14.331z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#242424",
    d: "M100.114 61.95c2.967-.293 6.007.15 8.974-.143-2.012 14.483-5.943 26.373-10.633 40.229 2.912.315 4.64 2.843 7.552 3.159 4.818-16.914 7.638-30.473 11.84-47.118.224-.914 1.083-2.18.365-2.743-.416-.333 0 0-.535.041-4.178.302-9.76-.127-13.933.247-1.614.142-.727.823-1.372 2.286-.352.645-1.344 3.982-2.258 4.041zM30.102 83.301c-1.577 6.898-4.114 14.286-5.71 21.184-2.555.059-4.113.992-6.655 1.056 2.327-10.057 5.275-19.447 8.42-29.678-.283 1.477.915 3.507 1.829 4.686.914 1.18.187 1.06 2.126 2.743"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#242424",
    d: "M19.008 99.125c.188 2.414.22 3.804-.411 6.144 29.34-.247 58.358 0 86.948-.146.389 0-.457-6.3-2.016-6.994-2.029-.915-6.08-.915-8.288-.887-6.08.119-12.343.54-18.44.64-12.298.201-24.568.612-36.865.722-6.99.064-13.938.485-20.928.521z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M103.721 55.592l14.789-.096c-4.375 16.26-8.151 33.435-12.526 49.692M25.805 75.809l-8.068 29.714c29.152-.69 59.095.338 88.228-.352"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M30.103 83.89c-1.024 4.32-2.487 10.547-3.794 14.794 24.128-.594 49.504-.965 73.632-1.555m.173-35.179h9.39c-2.949 11.766-5.262 23.825-9.54 35.2m-42.021 6.162c-2.432 4.755-7.804 9.793-12.375 12.549 11.02.576 22.054.744 33.102.503-4.115-2.766-8.343-8.471-10.25-13.052m23.32-54.005a159.143 159.143 0 01-33.628-2.541 16.801 16.801 0 007.095 15.085A16.914 16.914 0 0091.72 49.307h.018z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M31.232 60.997c3.707-.96 5.189-.86 7.314-.992 2.126-.133 4.416-.096 6.254 1.006 1.838 1.101 2.999 3.607 1.952 5.485-.58 1.034-1.673 1.66-2.743 2.145a21.244 21.244 0 01-9.755 1.828c-.58-.027-1.29-.192-1.431-.754-.17-.659.603-1.143 1.252-1.349a14.464 14.464 0 0111.018 1.06c1.257.677 2.518 1.729 2.633 3.15a3.337 3.337 0 01-1.34 2.743 8.12 8.12 0 01-2.866 1.335 29.64 29.64 0 01-6.126 1.13c-.548.04-1.32-.152-1.248-.7a.914.914 0 01.366-.521 11.086 11.086 0 017.945-2.633c2.857.205 5.358 1.892 6.066 4.845-.379 2.985-2.514 3.923-4.571 4.928-2.057 1.006-4.407 1.372-6.71 1.536-3.05.224-6.346.041-8.792-1.792-2.445-1.833-3.529-4.886-4.343-7.812-1.312-4.69-2.125-10.103.618-14.13 1.773-2.602 4.818-4.16 7.936-4.6a20.974 20.974 0 019.412.695c-1.458-2.953-2.34-6.253-2.07-9.53.269-3.279 1.787-6.534 4.424-8.504.8-.599 1.829-1.088 2.775-.763a2.51 2.51 0 011.49 1.956c.11.855.079 1.72-.09 2.565a64.4 64.4 0 00.255 19.227c1.13 6.858 4.965 15.813 8.229 21.943m-10.88.783a18.783 18.783 0 005.723 8.686c.978.837 2.117 1.596 3.401 1.696 1.527.114 2.999-.75 3.996-1.915.996-1.166 1.6-2.606 2.19-4.023m23.986-66.023c-1.829-2.016-3.69-4.137-4.69-6.683-1.002-2.546-1.043-5.637.57-7.85 1.807-2.486 5.249-3.29 8.298-2.88 1.59.216 3.25.783 4.178 2.095a4.195 4.195 0 01.247 4.219 5.276 5.276 0 01-3.392 2.651 3.748 3.748 0 01-2.94-.292c-.854-.544-1.348-1.714-.913-2.624"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M83.163 22.448c-1.87-.988-3.753-2.044-5.211-3.58-1.458-1.536-2.455-3.657-2.194-5.742a6.254 6.254 0 012.368-4.04 8.357 8.357 0 014.425-1.688m-3.127 15.179a25.883 25.883 0 00-28.01 18.212m20.358 33.329a26.478 26.478 0 0032.15-24.786 26.862 26.862 0 00-8.64-20.668"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M79.122 75.106c.7 5.753.854 11.56.457 17.344m-4.653-8.56a48.861 48.861 0 01-1.664 13.258m8.832-67.41a91.728 91.728 0 01-16 1.372l5.723 12.498M24.549 55.926a134.785 134.785 0 01-15.246-6.742l17.545-.7c-2.217-8.777-5.276-16.722-8.517-25.17a141.268 141.268 0 0120.764 9.298c1.48-4.544 2.4-8.74 3.876-13.28l7.178 8.878"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/onboarding/__starting-info/starting-info.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const starting_info_module = ({"modal-mobile":"starting-info-module__modal-mobile--cCdtb","modalMobile":"starting-info-module__modal-mobile--cCdtb","box":"starting-info-module__box--_VNF6","text":"starting-info-module__text--yEq0C","text-mobile":"starting-info-module__text-mobile--ibeya","textMobile":"starting-info-module__text-mobile--ibeya","picture":"starting-info-module__picture--J2jSy","picture-mobile":"starting-info-module__picture-mobile--QqINa","pictureMobile":"starting-info-module__picture-mobile--QqINa","button":"starting-info-module__button--Tg7gG","button-mobile":"starting-info-module__button-mobile--F7w6Z","buttonMobile":"starting-info-module__button-mobile--F7w6Z"});
;// CONCATENATED MODULE: ../ui-kit/src/onboarding/__starting-info/starting-info.component.tsx










const Title = _ref => {
  let {
    title
  } = _ref;
  if (typeof title === "string") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      className: typography_module/* default */.Z.headline4Accent,
      children: title
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: title.map(string => /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      className: typography_module/* default */.Z.headline4Accent,
      children: string
    }, string))
  });
};
const OnboardingStartingInfo = _ref2 => {
  let {
    textConstants,
    isMobile,
    visible,
    onClick
  } = _ref2;
  const title = /* @__PURE__ */(0,jsx_runtime.jsx)(Title, {
    title: textConstants.header
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    children: visible && /* @__PURE__ */(0,jsx_runtime.jsxs)(modal/* Modal */.u_, {
      title,
      buttons: [{
        text: textConstants.buttonText,
        appearance: "primary",
        onClick
      }],
      isVisible: visible,
      onClose: onClick,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(starting_info_module.picture, {
          [starting_info_module.pictureMobile]: isMobile
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(Tutor, {})
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.body2,
        children: textConstants.text
      })]
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/picture/picture.component.tsx + 1 modules
var picture_component = __webpack_require__(33364);
;// CONCATENATED MODULE: ../ui-kit/src/onboarding/__waiting-info/waiting-info.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const waiting_info_module = ({"box":"waiting-info-module__box--YDOQS","not-visible":"waiting-info-module__not-visible--WKXDv","notVisible":"waiting-info-module__not-visible--WKXDv","picture":"waiting-info-module__picture--xlOam","picture-mobile":"waiting-info-module__picture-mobile--O_J0W","pictureMobile":"waiting-info-module__picture-mobile--O_J0W","info":"waiting-info-module__info--GXOf7","info-mobile":"waiting-info-module__info-mobile--D5YEJ","infoMobile":"waiting-info-module__info-mobile--D5YEJ","info-title":"waiting-info-module__info-title--bRS2h","infoTitle":"waiting-info-module__info-title--bRS2h","cards":"waiting-info-module__cards--RXLl0","cards-mobile":"waiting-info-module__cards-mobile--MldUq","cardsMobile":"waiting-info-module__cards-mobile--MldUq","thanks":"waiting-info-module__thanks--ZtQmR","thanks-text":"waiting-info-module__thanks-text--rybO3","thanksText":"waiting-info-module__thanks-text--rybO3"});
;// CONCATENATED MODULE: ../ui-kit/src/onboarding/__waiting-info/waiting-info.component.tsx










const OnboardingWaitingInfo = _ref => {
  let {
    textConstants,
    isMobile,
    visible
  } = _ref;
  const renderInfo = (0,react.useCallback)((title, description) => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(waiting_info_module.info, {
      [waiting_info_module.infoMobile]: isMobile
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      className: classnames_default()(typography_module/* default */.Z.headline4Accent, waiting_info_module.infoTitle),
      children: title
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body2,
      children: description
    })]
  }), [isMobile]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(waiting_info_module.box, {
      [waiting_info_module.notVisible]: !visible
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(waiting_info_module.picture, {
        [waiting_info_module.pictureMobile]: isMobile
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
        src: textConstants.imageURL
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(waiting_info_module.cards, {
        [waiting_info_module.cardsMobile]: isMobile
      }),
      children: textConstants.cardsInfo.map(cardInfo => renderInfo(cardInfo.title, cardInfo.description))
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: waiting_info_module.thanks,
      children: [typeof textConstants.thanks === "string" && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body2, waiting_info_module.thanksText),
        children: textConstants.thanks
      }), typeof textConstants.thanks !== "string" && textConstants.thanks.map(string => /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body2, waiting_info_module.thanksText),
        children: string
      }, string))]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/onboarding-page/beginner-onboarding.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const beginner_onboarding_module = ({"page":"beginner-onboarding-module__page--d57kf","page-mobile":"beginner-onboarding-module__page-mobile--jpTZZ","pageMobile":"beginner-onboarding-module__page-mobile--jpTZZ"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/onboarding-page/beginner-onboarding.page.tsx

















const BeginnerOnboarding = _ref => {
  let {
    needCuratorOnboarding = false
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  if (onboardingState === student_attributes/* OnboardingFSMState */.Cv.Studying) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: routes.SCHEDULE
    });
  }
  const isPaid = user.data?.me.user?.isCurrentProductPaid;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(beginner_onboarding_module.page, {
      [beginner_onboarding_module.pageMobile]: isMobile
    }),
    children: [needCuratorOnboarding ? /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorOnboardingScreen, {
      needCuratorOnboarding: true
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerOnboardingWaitingInfo, {
      isMobile
    }), isPaid && /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerOnboardingStartingInfo, {
      isMobile
    })]
  });
};
const BeginnerOnboardingWaitingInfo = _ref2 => {
  let {
    isMobile
  } = _ref2;
  const intl = (0,useIntl/* default */.Z)();
  const waitTextContent = {
    imageURL: "https://flowstatic.s3.yandex.net/ui-files/kids-onboarding.svg",
    cardsInfo: [{
      title: intl.formatMessage({
        id: "beginnerOnboardingPage.waiting.title1"
      }),
      description: intl.formatMessage({
        id: "beginnerOnboardingPage.waiting.description1"
      })
    }, {
      title: intl.formatMessage({
        id: "beginnerOnboardingPage.waiting.title2"
      }),
      description: intl.formatMessage({
        id: "beginnerOnboardingPage.waiting.description2"
      })
    }, {
      title: intl.formatMessage({
        id: "beginnerOnboardingPage.waiting.title3"
      }),
      description: intl.formatMessage({
        id: "beginnerOnboardingPage.waiting.description3"
      })
    }],
    thanks: [intl.formatMessage({
      id: "beginnerOnboardingPage.waiting.thanks"
    }), intl.formatMessage({
      id: "beginnerOnboardingPage.waiting.succeed"
    })]
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(OnboardingWaitingInfo, {
    textConstants: waitTextContent,
    isMobile,
    visible: true
  });
};
const BeginnerOnboardingStartingInfo = _ref3 => {
  let {
    isMobile
  } = _ref3;
  const intl = (0,useIntl/* default */.Z)();
  const [isShown, setIsShown] = (0,react.useState)(storage/* localStorageWrapper */.Y6.beginnerOnboarding.isShown());
  const hideOnboardingInfoClickHandler = (0,react.useCallback)(() => {
    storage/* localStorageWrapper */.Y6.beginnerOnboarding.setAsShown();
    setIsShown(false);
  }, []);
  if (isShown) {
    return null;
  }
  const startTextContent = {
    header: [intl.formatMessage({
      id: "beginnerOnboardingPage.starting.congratulate"
    }), intl.formatMessage({
      id: "beginnerOnboardingPage.starting.bought"
    })],
    text: intl.formatMessage({
      id: "beginnerOnboardingPage.starting.text"
    }),
    buttonText: intl.formatMessage({
      id: "beginnerOnboardingPage.starting.buttonText"
    })
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(OnboardingStartingInfo, {
    textConstants: startTextContent,
    isMobile,
    visible: true,
    onClick: hideOnboardingInfoClickHandler
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/beginner-page-onboarding.tsx
















function BeginnerPageOnboarding() {
  const isAvailableAutoOnboarding = (0,auto_onboarding.useAvailableAutoOnboarding)();
  const newOnboardingCuratorScreen = (0,features/* useFeatureFlag */.ye)("newOnboardingCuratorScreen");
  const {
    data: userData
  } = (0,useUser/* useUser */.aF)();
  const needCuratorOnboarding = Boolean(userData?.attributes.needCuratorOnboarding);
  const user = userData?.me.user;
  const currentProductBusinessId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const isKidsProduct = (0,product_model/* getIsKidsBusinessProduct */.dJ)(currentProductBusinessId);
  if (isAvailableAutoOnboarding) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: studentRoutePaths/* studentRoutePaths */.dR.AUTO_ONBOARDING
    });
  }
  if (!(user?.whatsapp || user?.telegram)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      header: {
        hideCourseSelectButton: true,
        hideNavigation: true
      },
      main: {
        hideGrammarGuideButton: true
      },
      self: {
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
        doNotWrapChildrenWithLayout: true
      },
      footer: {
        hideFooter: true
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(student_contact_info/* ContactsScreen */.H, {
        isKidsProduct
      })
    });
  }
  return newOnboardingCuratorScreen ? /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    header: {
      hideNavigation: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
      doNotWrapChildrenWithLayout: true
    },
    footer: {
      hideFooter: true
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorOnboardingScreen, {
      needCuratorOnboarding
    })
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    header: {
      hideNavigation: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerOnboarding, {
      needCuratorOnboarding
    })
  });
}
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useUnmount.js
var useUnmount = __webpack_require__(27027);
// EXTERNAL MODULE: ../shared/src/hooks/use-modal-toggle.ts
var use_modal_toggle = __webpack_require__(95812);
// EXTERNAL MODULE: ../shared/src/utils/avatar/avatar.utils.ts
var avatar_utils = __webpack_require__(63419);
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__teacher-card/teacher-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const teacher_card_module = ({"root":"teacher-card-module__root--DDVsM","title-block":"teacher-card-module__title-block--V95zg","titleBlock":"teacher-card-module__title-block--V95zg","mobile-title":"teacher-card-module__mobile-title--kJ6Bp","mobileTitle":"teacher-card-module__mobile-title--kJ6Bp","subtitle":"teacher-card-module__subtitle--TAepP","avatar":"teacher-card-module__avatar--ZFZ0D","info":"teacher-card-module__info--_ziWe","desktop-title":"teacher-card-module__desktop-title--pDyMv","desktopTitle":"teacher-card-module__desktop-title--pDyMv","modalAvatar":"teacher-card-module__modalAvatar--snidb"});
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__teacher-card/teacher-card.component.tsx








const TeacherCard = _ref => {
  let {
    textConstants,
    imageSrc,
    onClick
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(teacher_card_module.root),
    "aria-label": textConstants.ariaLabel,
    onClick,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: teacher_card_module.info,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
        src: imageSrc,
        width: 48,
        height: 48,
        fitImage: true,
        classes: {
          root: teacher_card_module.avatar
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: teacher_card_module.titleBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(teacher_card_module.subtitle, typography_module/* default */.Z.caption),
          children: textConstants.subtitle
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()(teacher_card_module.desktopTitle, typography_module/* default */.Z.headline4Accent),
          children: textConstants.title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()(teacher_card_module.mobileTitle, typography_module/* default */.Z.body2Accent),
          children: textConstants.title
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      size: "medium",
      name: "simple-arrow-right"
    })]
  });
};
;// CONCATENATED MODULE: ./src/hooks/student/use-foreigner-speakings-query.ts





const useForeignerSpeakingsQuery = businessProductId => {
  const queryKey = (0,react.useMemo)(() => ["foreignerSpeakings", businessProductId], [businessProductId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(businessProductId),
    queryKey,
    queryFn: () => {
      if (!businessProductId) {
        return null;
      }
      return (0,student_api/* getForeignerSpeakings */.wK)(businessProductId);
    },
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Date.js
var lib_Date = __webpack_require__(10589);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
// EXTERNAL MODULE: ../../node_modules/date-fns/isFuture.mjs
var isFuture = __webpack_require__(31718);
// EXTERNAL MODULE: ../../node_modules/date-fns/isPast.mjs
var isPast = __webpack_require__(47689);
;// CONCATENATED MODULE: ./src/services/student-schedule/utils.ts






function isCurrentOrFutureSpeakingSession(speakingSession) {
  const {
    speaking: {
      durationMinutes
    },
    startAt,
    state,
    approvalStatus
  } = speakingSession;
  if (![speakingSession_model/* SpeakingSessionState */.Z.Scheduled, speakingSession_model/* SpeakingSessionState */.Z.InProgress].includes(state)) {
    return false;
  }
  if (approvalStatus && approvalStatus !== speakingSession_model/* ApprovalStatus */.Kb.Assigned) {
    return false;
  }
  const endAt = (0,addMinutes/* addMinutes */.m)(startAt, durationMinutes);
  const isInFuture = (0,isFuture/* isFuture */.A)(speakingSession.startAt);
  const isLessonNow = (0,isPast/* isPast */.C)(speakingSession.startAt) && (0,isFuture/* isFuture */.A)(endAt);
  return isInFuture || isLessonNow;
}
const mapSpeakingSessionToNearestScheduled = speakingSession => ({
  id: speakingSession.id,
  tutor: speakingSession.tutor,
  startAt: speakingSession.startAt,
  get shortDateTimeString() {
    return (0,format/* format */.WU)(speakingSession.startAt, "d MMMM", {
      locale: utils_locale/* dateFnsLocale */.Y
    });
  },
  get fullDateTimeString() {
    return (0,format/* format */.WU)(speakingSession.startAt, "EEEE", {
      locale: utils_locale/* dateFnsLocale */.Y
    }) + ", " + (0,format/* format */.WU)(speakingSession.startAt, "d MMM, HH:mm", {
      locale: utils_locale/* dateFnsLocale */.Y
    }).replace(".", "").replace(/\s/gm, constants/* NBSP */.Xz);
  }
});
;// CONCATENATED MODULE: ./src/services/student-schedule/student-schedule.ts










function getStudentScheduleViewModel(_ref) {
  let {
    scheduleInfo,
    speakingSessions
  } = _ref;
  const scheduledSpeakingSessionsForShow = [];
  const completedSpeakingSessionsForShow = [];
  const nearestScheduledSpeakingSessions = [];
  const pendingSpeakingSessions = [];
  for (const speakingSession of speakingSessions) {
    if (nearestScheduledSpeakingSessions.length < 3 && isCurrentOrFutureSpeakingSession(speakingSession)) {
      nearestScheduledSpeakingSessions.push(mapSpeakingSessionToNearestScheduled(speakingSession));
    }
    if (speakingSession.approvalStatus === speakingSession_model/* ApprovalStatus */.Kb.Pending) {
      pendingSpeakingSessions.push(speakingSession);
    }
    if (speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Completed) {
      completedSpeakingSessionsForShow.push(speakingSession);
      continue;
    }
    const endOfLesson = (0,addMinutes/* addMinutes */.m)(speakingSession.startAt, speakingSession.speaking.durationMinutes);
    if (speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled && (0,isBefore/* isBefore */.R)((0,lib_Date.now)(), endOfLesson) && (!speakingSession.approvalStatus || speakingSession.approvalStatus === speakingSession_model/* ApprovalStatus */.Kb.Assigned)) {
      scheduledSpeakingSessionsForShow.push(speakingSession);
    }
  }
  const nearestScheduledSpeakingSession = nearestScheduledSpeakingSessions.length > 0 ? nearestScheduledSpeakingSessions[0] : null;
  const getNearestScheduledSpeakingSessionScheduleInfo = () => {
    if (!scheduleInfo) {
      return null;
    }
    if (nearestScheduledSpeakingSession) {
      return scheduleInfo.find(schedule => schedule.tutorId === nearestScheduledSpeakingSession.tutor?.id);
    }
    const firstPermanentTutor = scheduleInfo.find(schedule => !schedule.isReplacementTutor);
    if (firstPermanentTutor) {
      return firstPermanentTutor;
    }
    return scheduleInfo.find(schedule => schedule.isReplacementTutor);
  };
  return {
    nearestScheduledSpeakingSessionScheduleInfo: getNearestScheduledSpeakingSessionScheduleInfo(),
    scheduledSpeakingSessionsForShow,
    completedSpeakingSessionsForShow,
    nearestScheduledSpeakingSessions,
    nearestScheduledSpeakingSession,
    pendingSpeakingSessions
  };
}
// EXTERNAL MODULE: ./src/adapters/user.storage-adapter.ts
var user_storage_adapter = __webpack_require__(77137);
// EXTERNAL MODULE: ../shared/src/timezones.utils.ts
var timezones_utils = __webpack_require__(30332);
;// CONCATENATED MODULE: ./src/api/student/schedule/schedule.mapper.ts










const mapRawStudentSchedule = rawResponse => {
  const now = /* @__PURE__ */new Date();
  const availableTutors = rawResponse.data.filter(_ref => {
    let {
      end_at: endAt
    } = _ref;
    return endAt === null || (0,isAfter/* isAfter */.A)((0,fromUnixTime/* fromUnixTime */.K)(endAt), now);
  });
  if (!availableTutors.length) {
    return null;
  }
  return availableTutors.map(currentSchedule => ({
    tutorDescription: currentSchedule.tutor_description,
    tutorId: (0,tutor_model/* makeTutorId */.Nr)(currentSchedule.tutor_id),
    tutorAvatarId: currentSchedule.tutor_avatar,
    speakingSessionLink: currentSchedule.zoom_link ?? void 0,
    studentTutorSchedule: currentSchedule.week_schedule.map((schedule, weekdayIndex) => ({
      weekdayIndex,
      date: (0,timezones_utils/* convertUTCToLocal */.v$)((0,parseISO/* parseISO */.D)(schedule))
    })),
    tutorFirstName: currentSchedule.public_name,
    isReplacementTutor: currentSchedule.replacement,
    ...(currentSchedule.end_at && {
      replacementUntilDate: (0,fromUnixTime/* fromUnixTime */.K)(currentSchedule.end_at)
    })
  }));
};
// EXTERNAL MODULE: ../shared/src/api/events/events.urls.ts
var events_urls = __webpack_require__(88620);
// EXTERNAL MODULE: ../shared/src/api/schedule/schedule.raw-model.ts
var schedule_raw_model = __webpack_require__(71524);
;// CONCATENATED MODULE: ./src/api/student/schedule/schedule.api.ts









const getStudentSchedule = speakingTypeId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/schedule?speaking_type_id=${speakingTypeId}`, {
  responseType: schedule_raw_model/* StudentScheduleResponse */.dG,
  resultMapper: mapRawStudentSchedule
});
const loadStudentSchedule = async speakingTypeId => {
  if (!speakingTypeId) {
    return Promise.resolve(null);
  }
  const result = await getStudentSchedule(speakingTypeId);
  if ((0,Either.isRight)(result)) {
    return result.right;
  }
  throw result.left;
};
const changeSchedule = (studentId, businessProductId) => (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
  method: "POST",
  body: {
    type: "request_schedule_change",
    payload: {
      student_id: studentId,
      business_product_id: businessProductId
    }
  },
  responseType: es6.type({})
});
const pauseSchedule = (studentId, businessProductId) => (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
  method: "POST",
  body: {
    type: "request_schedule_pause",
    payload: {
      student_id: studentId,
      business_product_id: businessProductId
    }
  },
  responseType: es6.type({})
});
;// CONCATENATED MODULE: ./src/services/student-schedule/use-student-schedule-query.ts








const useStudentScheduleQuery = () => {
  const user = (0,user_storage_adapter/* useUserStorage */.q)();
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  const {
    speakingTypeId
  } = user;
  const queryKey = (0,react.useMemo)(() => ["sheduleInfo", speakingTypeId], [speakingTypeId]);
  const isStudentHasBeenOnboarded = onboardingState ? [student_attributes/* OnboardingFSMState */.Cv.Studying, student_attributes/* OnboardingFSMState */.Cv.Paused].includes(onboardingState) : false;
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(speakingTypeId) && isStudentHasBeenOnboarded,
    queryKey,
    queryFn: () => loadStudentSchedule(speakingTypeId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
;// CONCATENATED MODULE: ./src/services/student-schedule/use-student-schedule.ts






const useStudentSchedule = () => {
  const {
    speakingSessions
  } = useScheduling();
  const {
    data: scheduleInfo
  } = useStudentScheduleQuery();
  const viewModel = (0,react.useMemo)(() => getStudentScheduleViewModel({
    speakingSessions,
    scheduleInfo: scheduleInfo ?? null
  }), [scheduleInfo, speakingSessions]);
  return {
    scheduleInfo,
    viewModel
  };
};
;// CONCATENATED MODULE: ./src/widgets/foreigner-speakings/initial-foreigner-speaking-toggle.component.tsx

















const InitialForeignerSpeakingToggle = _ref => {
  let {
    speakings,
    onSpeakingClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const [isOpen, setIsOpen] = (0,react.useState)(false);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerLessonCard, {
      id: "InitialForeignerSpeakingToggle",
      actions: [{
        key: "ForeignerLessonButtonKey",
        onClick: () => {
          if (isMobile) {
            history.push(studentRoutePaths/* studentRoutePaths */.dR.FOREIGNER_SESSIONS);
          }
          setIsOpen(prev => !prev);
        },
        text: isOpen ? intl.formatMessage({
          id: "foreignerSpeakings.hideLessons"
        }) : intl.formatMessage({
          id: "foreignerSpeakings.chooseLesson"
        }),
        type: isOpen ? "secondary" : "primary",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: classnames_default()(foreigner_speakings_module.arrow, {
            [foreigner_speakings_module.upArrow]: isOpen
          }),
          name: "arrow-down",
          size: "medium"
        })
      }],
      title: intl.formatMessage({
        id: "foreignerSpeakings.scheduleCardTitle"
      }),
      theme: isMobile ? void 0 : intl.formatMessage({
        id: "foreignerSpeakings.schedule"
      }, {
        count: speakings.length
      }),
      duration: isMobile ? intl.formatMessage({
        id: "foreignerSpeakings.schedule"
      }, {
        count: speakings.length
      }) : void 0
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: classnames_default()(foreigner_speakings_module.foreignerLessonRows, {
        [foreigner_speakings_module.visible]: isOpen
      }),
      style: {
        "--speakings-count": `${speakings.length}`
      },
      children: speakings.map(speaking => {
        const speakingDurationMin = intl.formatMessage({
          id: "foreignerSpeakings.durationMin"
        }, {
          count: speaking.durationMin
        });
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
          className: foreigner_speakings_module.foreignerLessonRow,
          children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
              className: typography_module/* default */.Z.body2,
              children: speaking.theme
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
              className: classnames_default()(typography_module/* default */.Z.captionAccent, foreigner_speakings_module.duration),
              children: speakingDurationMin
            })]
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            onClick: () => onSpeakingClick(speaking.id),
            appearance: "secondary",
            size: "small",
            children: intl.formatMessage({
              id: "foreignerSpeakings.scheduleClass"
            })
          })]
        }, speaking.id);
      })
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.unshift.js
var es_array_unshift = __webpack_require__(62464);
;// CONCATENATED MODULE: ../ui-kit/src/link-or-nothing/link-or-nothing.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const link_or_nothing_module = ({"root":"link-or-nothing-module__root--OFvue"});
;// CONCATENATED MODULE: ../ui-kit/src/link-or-nothing/link-or-nothing.component.tsx






const LinkOrNothing = _ref => {
  let {
    children,
    to,
    target,
    useNativeTag,
    className,
    nothingElementTag,
    ariaLabel
  } = _ref;
  if (to === void 0) {
    if (nothingElementTag) {
      switch (nothingElementTag) {
        case "div":
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className,
            children
          });
        case "span":
          return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className,
            children
          });
        default:
          return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children
          });
      }
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children
    });
  }
  if (useNativeTag) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("a", {
      href: to,
      target,
      className: classnames_default()(link_or_nothing_module.root, className),
      "aria-label": ariaLabel,
      children
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
    className: classnames_default()(link_or_nothing_module.root, className),
    to,
    target,
    "aria-label": ariaLabel,
    children
  });
};
;// CONCATENATED MODULE: ./src/components/chapter-buttons-item/chapter-buttons-item.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chapter_buttons_item_module = ({"item":"chapter-buttons-item-module__item--glRS4","item-disabled":"chapter-buttons-item-module__item-disabled--eYNZ9","itemDisabled":"chapter-buttons-item-module__item-disabled--eYNZ9","item-icon-wrapper":"chapter-buttons-item-module__item-icon-wrapper--UYxyh","itemIconWrapper":"chapter-buttons-item-module__item-icon-wrapper--UYxyh","item-icon-wrapper-with-progress":"chapter-buttons-item-module__item-icon-wrapper-with-progress--mWSQS","itemIconWrapperWithProgress":"chapter-buttons-item-module__item-icon-wrapper-with-progress--mWSQS","item-text":"chapter-buttons-item-module__item-text--U2ndj","itemText":"chapter-buttons-item-module__item-text--U2ndj","item-text-completed":"chapter-buttons-item-module__item-text-completed--HPQ8A","itemTextCompleted":"chapter-buttons-item-module__item-text-completed--HPQ8A","item-icon-circle":"chapter-buttons-item-module__item-icon-circle--kaXjq","itemIconCircle":"chapter-buttons-item-module__item-icon-circle--kaXjq","item-icon":"chapter-buttons-item-module__item-icon--mF0C2","itemIcon":"chapter-buttons-item-module__item-icon--mF0C2","item-icon-small":"chapter-buttons-item-module__item-icon-small--UVZsE","itemIconSmall":"chapter-buttons-item-module__item-icon-small--UVZsE","item-icon-medium":"chapter-buttons-item-module__item-icon-medium--bCy7X","itemIconMedium":"chapter-buttons-item-module__item-icon-medium--bCy7X","item-icon-disabled":"chapter-buttons-item-module__item-icon-disabled--DRtiC","itemIconDisabled":"chapter-buttons-item-module__item-icon-disabled--DRtiC","item-icon-completed-deprecated":"chapter-buttons-item-module__item-icon-completed-deprecated--OsQeW","itemIconCompletedDeprecated":"chapter-buttons-item-module__item-icon-completed-deprecated--OsQeW","item-icon-completed-new":"chapter-buttons-item-module__item-icon-completed-new--B7arr","itemIconCompletedNew":"chapter-buttons-item-module__item-icon-completed-new--B7arr","item-icon-active":"chapter-buttons-item-module__item-icon-active--TevEu","itemIconActive":"chapter-buttons-item-module__item-icon-active--TevEu","subitem-text":"chapter-buttons-item-module__subitem-text--Aw0Cj","subitemText":"chapter-buttons-item-module__subitem-text--Aw0Cj","skip-button":"chapter-buttons-item-module__skip-button--fvJCB","skipButton":"chapter-buttons-item-module__skip-button--fvJCB","skip-button-item-icon":"chapter-buttons-item-module__skip-button-item-icon--eQ97v","skipButtonItemIcon":"chapter-buttons-item-module__skip-button-item-icon--eQ97v"});
;// CONCATENATED MODULE: ./src/components/chapter-buttons-item/chapter-buttons-item.component.tsx









var chapter_buttons_item_component_ChapterButtonsItemAppearance = /* @__PURE__ */(ChapterButtonsItemAppearance2 => {
  ChapterButtonsItemAppearance2[ChapterButtonsItemAppearance2["Deprecated"] = 0] = "Deprecated";
  ChapterButtonsItemAppearance2[ChapterButtonsItemAppearance2["New"] = 1] = "New";
  return ChapterButtonsItemAppearance2;
})(chapter_buttons_item_component_ChapterButtonsItemAppearance || {});
var ChapterButtonsItemState = /* @__PURE__ */(ChapterButtonsItemState2 => {
  ChapterButtonsItemState2[ChapterButtonsItemState2["Disabled"] = 0] = "Disabled";
  ChapterButtonsItemState2[ChapterButtonsItemState2["Active"] = 1] = "Active";
  ChapterButtonsItemState2[ChapterButtonsItemState2["Completed"] = 2] = "Completed";
  return ChapterButtonsItemState2;
})(ChapterButtonsItemState || {});
const ChapterButtonsItem = _ref => {
  let {
    iconName,
    state,
    text,
    link,
    progress = 0,
    appearance = 0 /* Deprecated */
  } = _ref;
  const isDisabled = state === 0 /* Disabled */;
  const isCompleted = state === 2 /* Completed */;
  const isActive = state === 1 /* Active */;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(LinkOrNothing, {
    to: isDisabled ? void 0 : link,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(chapter_buttons_item_module.item, {
        [chapter_buttons_item_module.itemDisabled]: isDisabled
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(chapter_buttons_item_module.itemIconWrapper, {
          [chapter_buttons_item_module.itemIconWrapperWithProgress]: progress !== 0
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(chapter_buttons_item_module.itemIconCircle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(PartialCircle, {
            size: appearance === 1 /* New */ ? 56 : 40,
            part: progress
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(chapter_buttons_item_module.itemIcon, {
            [chapter_buttons_item_module.itemIconDisabled]: isDisabled,
            [chapter_buttons_item_module.itemIconCompletedDeprecated]: isCompleted && appearance === 0 /* Deprecated */,
            [chapter_buttons_item_module.itemIconCompletedNew]: isCompleted && appearance === 1 /* New */,
            [chapter_buttons_item_module.itemIconActive]: isActive,
            [chapter_buttons_item_module.itemIconSmall]: appearance === 0 /* Deprecated */,
            [chapter_buttons_item_module.itemIconMedium]: appearance === 1 /* New */
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            size: appearance === 1 /* New */ ? "medium" : "small",
            name: iconName
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(chapter_buttons_item_module.itemText, {
          [typography_module/* default */.Z.body2Accent]: appearance === 1 /* New */,
          [chapter_buttons_item_module.itemTextCompleted]: isCompleted && appearance === 1 /* New */
        }),
        children: text
      })]
    })
  });
};
const chapter_buttons_item_component_SkipChapterButtonItem = _ref2 => {
  let {
    onClick,
    children
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
    type: "button",
    className: chapter_buttons_item_module.skipButton,
    onClick,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: chapter_buttons_item_module.item,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: chapter_buttons_item_module.itemIconWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(chapter_buttons_item_module.itemIcon, chapter_buttons_item_module.itemIconSmall, chapter_buttons_item_module.skipButtonItemIcon),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            size: "small",
            name: "skip"
          })
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: chapter_buttons_item_module.itemText,
        children
      })]
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/date-fns/isToday.mjs
var isToday = __webpack_require__(23393);
// EXTERNAL MODULE: ../shared/src/calendar.utils.ts
var calendar_utils = __webpack_require__(3654);
// EXTERNAL MODULE: ../shared/src/hooks/useWebcalInstruction.ts
var useWebcalInstruction = __webpack_require__(20967);
// EXTERNAL MODULE: ../shared/src/widgets/webcal-instruction-popup/webcal-instruction-popup.component.tsx + 1 modules
var webcal_instruction_popup_component = __webpack_require__(88675);
// EXTERNAL MODULE: ./src/hooks/useCalendarItems.ts
var useCalendarItems = __webpack_require__(62878);
;// CONCATENATED MODULE: ./src/components/speaking-actions-list/speaking-actions-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const speaking_actions_list_module = ({"main":"speaking-actions-list-module__main--gmOqF","item-button":"speaking-actions-list-module__item-button--CPTVp","itemButton":"speaking-actions-list-module__item-button--CPTVp","item-button-enabled":"speaking-actions-list-module__item-button-enabled--_dpd0","itemButtonEnabled":"speaking-actions-list-module__item-button-enabled--_dpd0","item-button-disabled":"speaking-actions-list-module__item-button-disabled--Xayih","itemButtonDisabled":"speaking-actions-list-module__item-button-disabled--Xayih","item-icon-place":"speaking-actions-list-module__item-icon-place--jTtAq","itemIconPlace":"speaking-actions-list-module__item-icon-place--jTtAq","item-icon-background":"speaking-actions-list-module__item-icon-background--q3Cl6","itemIconBackground":"speaking-actions-list-module__item-icon-background--q3Cl6","item-icon-background-disabled":"speaking-actions-list-module__item-icon-background-disabled--SM9iS","itemIconBackgroundDisabled":"speaking-actions-list-module__item-icon-background-disabled--SM9iS","item-text":"speaking-actions-list-module__item-text--XX3SW","itemText":"speaking-actions-list-module__item-text--XX3SW","right-icon":"speaking-actions-list-module__right-icon--UQ4GY","rightIcon":"speaking-actions-list-module__right-icon--UQ4GY"});
;// CONCATENATED MODULE: ./src/components/speaking-actions-list/speaking-actions-list.component.tsx


















const ButtonOrLink = _ref => {
  let {
    to,
    className,
    isDisabled,
    onClick,
    children
  } = _ref;
  if (isDisabled) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className,
      children
    });
  }
  if (to !== void 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
      className,
      onClick,
      to,
      children
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
    type: "button",
    className,
    onClick,
    children
  });
};
const ActionListItem = _ref2 => {
  let {
    text,
    isDisabled,
    icon,
    rightIcon,
    to,
    onClick
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(ButtonOrLink, {
      to,
      className: classnames_default()(speaking_actions_list_module.itemButton, isDisabled ? speaking_actions_list_module.itemButtonDisabled : speaking_actions_list_module.itemButtonEnabled),
      isDisabled,
      onClick,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: speaking_actions_list_module.itemIconPlace,
        children: icon !== void 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(speaking_actions_list_module.itemIconBackground, isDisabled && speaking_actions_list_module.itemIconBackgroundDisabled),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: icon,
            size: "small"
          })
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: speaking_actions_list_module.itemText,
        children: text
      }), rightIcon !== void 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: speaking_actions_list_module.rightIcon,
        name: rightIcon,
        size: "medium"
      })]
    })
  });
};
const SpeakingActionsList = _ref3 => {
  let {
    canJoinClass,
    canDelete,
    speakingId,
    startAt,
    endAt,
    isMentor,
    chapterName,
    availableBeforeStartMin,
    onDelete,
    isFirstSpeaking
  } = _ref3;
  const intl = (0,useIntl/* default */.Z)();
  const user = (0,useUser/* useUser */.aF)();
  const userId = user.data?.me.user?.id;
  const calendarToken = user.data?.me.user?.calendarToken;
  const [isCalendarItemsVisible, setCalendarItemsVisible] = (0,react.useState)(false);
  const {
    openWebcalInstruction,
    closeWebcalInstruction,
    webcalInstructionProvider
  } = (0,useWebcalInstruction/* useWebcalInstruction */.S)();
  const calendarItems = (0,useCalendarItems/* useCalendarItems */.Q)({
    startTime: startAt,
    endTime: endAt,
    isMentor,
    chapterName,
    availableBeforeStartMin
  }, openWebcalInstruction);
  const toggleCalendarVisible = (0,react.useCallback)(e => {
    e.preventDefault();
    setCalendarItemsVisible(visible => !visible);
  }, []);
  const handleDeleteSpeakingSession = (0,react.useCallback)(e => {
    e.preventDefault();
    onDelete();
  }, [onDelete]);
  if (!userId || !calendarToken) {
    return null;
  }
  const webcalUrl = (0,calendar_utils/* generateWebcalCalendarLink */.D$)(userId, calendarToken);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [webcalInstructionProvider && /* @__PURE__ */(0,jsx_runtime.jsx)(webcal_instruction_popup_component/* WebcalInstructionPopup */.$, {
      provider: webcalInstructionProvider,
      onClose: closeWebcalInstruction,
      webcalUrl
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("ul", {
      className: classnames_default()(speaking_actions_list_module.main, typography_module/* default */.Z.body2),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ActionListItem, {
        isDisabled: !canJoinClass,
        to: isFirstSpeaking ? studentRoutePaths/* studentRoutePaths */.dR.PRE_SPEAKING(speakingId) : studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(speakingId),
        icon: "simple-arrow-right",
        text: intl.formatMessage({
          id: "speakingActionsList.goClass"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ActionListItem, {
        onClick: toggleCalendarVisible,
        icon: "calendar",
        text: intl.formatMessage({
          id: "speakingActionsList.addToCalendar"
        }),
        rightIcon: isCalendarItemsVisible ? "chevron-up" : "chevron-down"
      }), isCalendarItemsVisible && calendarItems.map((item, index) => {
        const handleClick = e => {
          e.preventDefault();
          item.action();
        };
        return /* @__PURE__ */(0,jsx_runtime.jsx)(ActionListItem, {
          onClick: handleClick,
          text: item.label
        }, index);
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ActionListItem, {
        isDisabled: !canDelete,
        onClick: handleDeleteSpeakingSession,
        icon: "small-trash",
        text: intl.formatMessage({
          id: "speakingActionsList.cancelClass"
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/student-speaking-cancel-conformation/student-speaking-cancel-conformation-popup.component.tsx









const StudentSpeakingCancelConformationPopup = _ref => {
  let {
    isVisible = true,
    title,
    startAt,
    speakingId,
    onDeleted,
    onClose,
    onClosed
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const dateString = (0,format/* format */.WU)(startAt, "d MMMM", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const timeString = (0,format/* format */.WU)(startAt, "HH:mm", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const handleDelete = (0,react.useCallback)(async () => {
    await (0,speaking_session_speaking_session_api/* deleteSpeakingSession */.sF)(speakingId);
    onDeleted();
  }, [speakingId, onDeleted]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    isVisible,
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: intl.formatMessage({
      id: "studentSpeakingInfo.cancelClass"
    }),
    subtitle: intl.formatMessage({
      id: "studentSpeakingInfo.speakingInfo"
    }, {
      title,
      date: dateString,
      time: timeString
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "studentSpeakingInfo.notDecline"
      }),
      appearance: "secondary",
      onClick: onClose
    }, {
      text: intl.formatMessage({
        id: "studentSpeakingInfo.decline"
      }),
      appearance: "primary",
      onClick: handleDelete
    }],
    onClose,
    onClosed
  });
};
;// CONCATENATED MODULE: ./src/components/chapter-buttons-scheduled-speaking/chapter-buttons-scheduled-speaking.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chapter_buttons_scheduled_speaking_module = ({"main":"chapter-buttons-scheduled-speaking-module__main--D57Uz","main-grey":"chapter-buttons-scheduled-speaking-module__main-grey--eS9bc","mainGrey":"chapter-buttons-scheduled-speaking-module__main-grey--eS9bc","main-white":"chapter-buttons-scheduled-speaking-module__main-white--koe1i","mainWhite":"chapter-buttons-scheduled-speaking-module__main-white--koe1i","info":"chapter-buttons-scheduled-speaking-module__info--gVC48","tutor-avatar":"chapter-buttons-scheduled-speaking-module__tutor-avatar--ylq0Y","tutorAvatar":"chapter-buttons-scheduled-speaking-module__tutor-avatar--ylq0Y","date":"chapter-buttons-scheduled-speaking-module__date--GGzog","day":"chapter-buttons-scheduled-speaking-module__day--OkCdI","last-line":"chapter-buttons-scheduled-speaking-module__last-line--dbrxS","lastLine":"chapter-buttons-scheduled-speaking-module__last-line--dbrxS","tutor":"chapter-buttons-scheduled-speaking-module__tutor--oqzsU","tutor-name":"chapter-buttons-scheduled-speaking-module__tutor-name--qWXn_","tutorName":"chapter-buttons-scheduled-speaking-module__tutor-name--qWXn_"});
;// CONCATENATED MODULE: ./src/components/chapter-buttons-scheduled-speaking/chapter-buttons-scheduled-speaking.component.tsx















var CurrentState = /* @__PURE__ */(CurrentState2 => {
  CurrentState2[CurrentState2["Scheduled"] = 0] = "Scheduled";
  CurrentState2[CurrentState2["Prepare"] = 1] = "Prepare";
  CurrentState2[CurrentState2["InProgress"] = 2] = "InProgress";
  CurrentState2[CurrentState2["Done"] = 3] = "Done";
  return CurrentState2;
})(CurrentState || {});
var ChapterButtonsScheduledSpeakingColor = /* @__PURE__ */(ChapterButtonsScheduledSpeakingColor2 => {
  ChapterButtonsScheduledSpeakingColor2[ChapterButtonsScheduledSpeakingColor2["White"] = 0] = "White";
  ChapterButtonsScheduledSpeakingColor2[ChapterButtonsScheduledSpeakingColor2["Grey"] = 1] = "Grey";
  return ChapterButtonsScheduledSpeakingColor2;
})(ChapterButtonsScheduledSpeakingColor || {});
const ChapterButtonsScheduledSpeaking = _ref => {
  let {
    currentTime,
    currentState,
    title,
    startAt,
    speakingSessionId,
    durationMin,
    tutor,
    isFirstSpeaking,
    isMentor,
    color = 1 /* Grey */,
    onNeedUpdates
  } = _ref;
  const [isDeletePopupVisible, setDeletePopupVisible] = (0,react.useState)(false);
  const handleDeleted = (0,react.useCallback)(() => {
    setDeletePopupVisible(false);
    (0,yandexMetrica/* ymGoal */.qf)("Speaking_Cancelled");
    onNeedUpdates();
  }, [onNeedUpdates]);
  const handleCloseSpeakingClick = (0,react.useCallback)(() => {
    setDeletePopupVisible(false);
  }, []);
  const handleDelete = (0,react.useCallback)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Cancel_Speaking");
    setDeletePopupVisible(true);
  }, []);
  const endTime = (0,react.useMemo)(() => (0,addMinutes/* addMinutes */.m)(startAt, durationMin), [durationMin, startAt]);
  const timeToStart = (0,differenceInMinutes/* differenceInMinutes */.X)(startAt, currentTime);
  const canGoClass = timeToStart <= CLASS_AVAILABLE_BEFORE_START_MIN;
  const canDelete = currentState === 0 /* Scheduled */;
  const startTimeString = (0,format/* format */.WU)(startAt, "HH:mm", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const endTimeString = (0,format/* format */.WU)(endTime, "HH:mm", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const today = (0,isToday/* isToday */.z)(startAt);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(chapter_buttons_scheduled_speaking_module.main, {
      [chapter_buttons_scheduled_speaking_module.mainGrey]: color === 1 /* Grey */,
      [chapter_buttons_scheduled_speaking_module.mainWhite]: color === 0 /* White */
    }),
    children: [isDeletePopupVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(StudentSpeakingCancelConformationPopup, {
      title,
      startAt,
      speakingId: speakingSessionId,
      onDeleted: handleDeleted,
      onClose: handleCloseSpeakingClick
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: chapter_buttons_scheduled_speaking_module.info,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.caption,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "chapterButtonsScheduledSpeaking.youScheduleSpeaking"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: chapter_buttons_scheduled_speaking_module.date,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: chapter_buttons_scheduled_speaking_module.day,
          children: [today ? /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "chapterButtonsScheduledSpeaking.today"
          }) : (0,format/* format */.WU)(startAt, "d MMMM", {
            locale: utils_locale/* dateFnsLocale */.Y
          }), ","]
        }), " ", startTimeString, " \u2014 ", endTimeString]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: chapter_buttons_scheduled_speaking_module.lastLine,
        children: tutor !== null ? /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: chapter_buttons_scheduled_speaking_module.tutor,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: chapter_buttons_scheduled_speaking_module.tutorAvatar,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
              size: avatar_component/* AvatarSize */.D.Size32,
              avatarId: tutor.avatar
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: chapter_buttons_scheduled_speaking_module.tutorName,
            children: tutor.name
          })]
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {})
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingActionsList, {
      isFirstSpeaking,
      canJoinClass: canGoClass,
      canDelete,
      speakingId: speakingSessionId,
      startAt,
      endAt: endTime,
      isMentor,
      chapterName: title,
      availableBeforeStartMin: CLASS_AVAILABLE_BEFORE_START_MIN,
      onDelete: handleDelete
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/chapter-buttons/chapter-buttons.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chapter_buttons_module = ({"chapter-buttons-box":"chapter-buttons-module__chapter-buttons-box--zvExh","chapterButtonsBox":"chapter-buttons-module__chapter-buttons-box--zvExh","repetition-item-deprecated":"chapter-buttons-module__repetition-item-deprecated--OrbAq","repetitionItemDeprecated":"chapter-buttons-module__repetition-item-deprecated--OrbAq","repetition-item-new":"chapter-buttons-module__repetition-item-new--izzyd","repetitionItemNew":"chapter-buttons-module__repetition-item-new--izzyd","buy-button":"chapter-buttons-module__buy-button--LKZ06","buyButton":"chapter-buttons-module__buy-button--LKZ06","scheduler-item-root":"chapter-buttons-module__scheduler-item-root--pBEwM","schedulerItemRoot":"chapter-buttons-module__scheduler-item-root--pBEwM"});
;// CONCATENATED MODULE: ./src/components/chapter-buttons/chapter-buttons.component.tsx




















const getCurrentDiff = (now, timestamp) => Math.floor((0,differenceInMilliseconds/* differenceInMilliseconds */._)(now, timestamp) / ONE_MINUTE_MS);
const getCurrentState = (currentTime, startAt, durationMin) => {
  const timeFromStartMin = getCurrentDiff(currentTime, startAt);
  if (timeFromStartMin < -1) {
    return CurrentState.Scheduled;
  } else if (timeFromStartMin < 0) {
    return CurrentState.Prepare;
  } else if (timeFromStartMin < durationMin) {
    return CurrentState.InProgress;
  }
  return CurrentState.Done;
};
const ChapterButtonsTrainerItem = _ref => {
  let {
    chapter,
    disabled,
    disableLexisButton,
    disableGrammarButton,
    disableStoryButton,
    appearance
    // eslint-disable-next-line sonarjs/cognitive-complexity
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const a2PlusFlippedExperiment = useA2PlusFlippedExperiment();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    grammarAndLexisAfterSpeaking
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const getChapterLink = (0,react.useCallback)((link, chapterId) => {
    const pathName = history.location.pathname;
    return get_url_search_params.getUrlSearchParams.chapterLink.getLinkWithRetPath({
      link,
      retPath: pathName + `#${chapterId}`,
      history
    });
  }, [history]);
  const renderGrammarButton = (0,react.useCallback)(params => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()({
      [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
      [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
      iconName: "grammar",
      state: disableGrammarButton || disabled ? ChapterButtonsItemState.Disabled : ChapterButtonsItemState.Active,
      text: intl.formatMessage({
        id: "chapterButtons.revisionGrammar"
      }),
      link: disableGrammarButton ? void 0 : getChapterLink(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(params.productId, params.chapterId, "grammar"), params.chapterId),
      appearance
    })
  }), [appearance, disableGrammarButton, disabled, getChapterLink, intl]);
  const renderLexisButton = (0,react.useCallback)(params => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()({
      [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
      [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
      iconName: "vocabulary",
      state: disableLexisButton || disabled ? ChapterButtonsItemState.Disabled : ChapterButtonsItemState.Active,
      text: intl.formatMessage({
        id: "chapterButtons.revisionVocabulary"
      }),
      link: disableLexisButton || disabled ? void 0 : getChapterLink(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(params.productId, params.chapterId, "lexis"), params.chapterId),
      appearance
    })
  }), [appearance, disableLexisButton, disabled, getChapterLink, intl]);
  if (chapter.type === student_model/* ChapterItemType */.a.Mentor) {
    return null;
  }
  const hasRevision = chapter.revisionTypes.story || chapter.revisionTypes.grammar || chapter.revisionTypes.lexis || chapter.revisionTypes.test;
  const chapterStateType = chapter.chapterState.type;
  switch (chapterStateType) {
    case student_model/* ChapterStateType */.n_.NotStarted:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()({
              [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
              [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
              iconName: "simple-arrow-right",
              state: disableStoryButton || disabled ? ChapterButtonsItemState.Disabled : ChapterButtonsItemState.Active,
              text: intl.formatMessage({
                id: a2PlusFlippedExperiment.active ? a2PlusFlippedExperiment.text.startStory : "chapterButtons.startLearn"
              }),
              progress: 0,
              link: getChapterLink(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(chapter.productId, chapter.chapterId), chapter.chapterId),
              appearance
            })
          }), chapter.revisionTypes.grammar && grammarAndLexisAfterSpeaking && renderGrammarButton({
            chapterId: chapter.chapterId,
            productId: chapter.productId
          }), chapter.revisionTypes.lexis && grammarAndLexisAfterSpeaking && renderLexisButton({
            chapterId: chapter.chapterId,
            productId: chapter.productId
          })]
        });
      }
    case student_model/* ChapterStateType */.n_.Started:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()({
              [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
              [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
              iconName: "new-arrow-right",
              state: ChapterButtonsItemState.Active,
              text: intl.formatMessage({
                id: "chapterButtons.continueLearn"
              }),
              progress: chapter.chapterState.progressPercent / 100,
              link: getChapterLink(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(chapter.productId, chapter.chapterId), chapter.chapterId),
              appearance
            })
          }), chapter.revisionTypes.grammar && grammarAndLexisAfterSpeaking && renderGrammarButton({
            chapterId: chapter.chapterId,
            productId: chapter.productId
          }), chapter.revisionTypes.lexis && grammarAndLexisAfterSpeaking && renderLexisButton({
            chapterId: chapter.chapterId,
            productId: chapter.productId
          })]
        });
      }
    case student_model/* ChapterStateType */.n_.Ended:
      {
        const trainerLink = studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(chapter.productId, chapter.chapterId);
        const revisionLink = studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(chapter.productId, chapter.chapterId);
        const backToStoryText = intl.formatMessage({
          id: chapter.revisionTypes.test ? "chapterButtons.trainerTest" : "chapterButtons.trainerStory"
        });
        const repeatStoryText = intl.formatMessage({
          id: chapter.revisionTypes.test ? "chapterButtons.revisionTest" : "chapterButtons.revisionStory"
        });
        if (!hasRevision) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()({
              [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
              [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
              iconName: "checkmark",
              state: ChapterButtonsItemState.Completed,
              text: intl.formatMessage({
                id: "chapterButtons.youAreEndHistory"
              }),
              appearance
            })
          });
        }
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          children: [(chapter.revisionTypes.story || chapter.revisionTypes.test) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()({
              [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
              [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
              iconName: "vector",
              state: ChapterButtonsItemState.Active,
              text: backToStoryText,
              link: getChapterLink(trainerLink, chapter.chapterId),
              appearance
            })
          }), (chapter.revisionTypes.story || chapter.revisionTypes.test) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()({
              [chapter_buttons_module.repetitionItemDeprecated]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
              [chapter_buttons_module.repetitionItemNew]: appearance === chapter_buttons_item_component_ChapterButtonsItemAppearance.New
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
              iconName: "reset",
              state: ChapterButtonsItemState.Active,
              text: repeatStoryText,
              link: getChapterLink(revisionLink, chapter.chapterId),
              appearance
            })
          }), chapter.revisionTypes.grammar && renderGrammarButton({
            chapterId: chapter.chapterId,
            productId: chapter.productId
          }), chapter.revisionTypes.lexis && renderLexisButton({
            chapterId: chapter.chapterId,
            productId: chapter.productId
          })]
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(chapterStateType);
  }
};
const ChapterButtonsSchedulerSessionItem = _ref2 => {
  let {
    title,
    session,
    durationMin,
    isMentor,
    isFirstSpeaking,
    speakingId,
    onNeedUpdates,
    disabled,
    appearance
  } = _ref2;
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const currentState = getCurrentState(currentTime, session.startAt, durationMin);
  const isCompletedSpeakingSession = session.state === speakingSession_model/* SpeakingSessionState */.Z.Completed || currentState === CurrentState.Done;
  if (isCompletedSpeakingSession) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterScheduleItem, {
      wasCompleted: true,
      speakingId,
      isMentor,
      disabled,
      appearance
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsScheduledSpeaking, {
    currentTime,
    currentState,
    title,
    startAt: session.startAt,
    speakingSessionId: session.id,
    tutor: session.tutor,
    durationMin,
    isFirstSpeaking,
    isMentor,
    onNeedUpdates
  });
};
const ChapterScheduleItem = _ref3 => {
  let {
    speakingId,
    wasCompleted,
    isMentor,
    disabled,
    appearance
  } = _ref3;
  const intl = (0,useIntl/* default */.Z)();
  const {
    nativeSpeakerSessionIds
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const a2PlusFlippedExperiment = useA2PlusFlippedExperiment();
  const history = (0,react_router/* useHistory */.k6)();
  let textId;
  if (wasCompleted) {
    textId = isMentor ? "chapterButtons.scheduleMentorSessionAgain" : "chapterButtons.scheduleHistorySessionAgain";
  } else if (nativeSpeakerSessionIds.has(speakingId)) {
    textId = isMentor ? "chapterButtons.scheduleMentorSessionNative" : "chapterButtons.scheduleHistorySessionNative";
  } else if (a2PlusFlippedExperiment.active) {
    textId = a2PlusFlippedExperiment.text.scheduleSessions;
  } else {
    textId = isMentor ? "chapterButtons.scheduleMentorSession" : "chapterButtons.scheduleHistorySession";
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
    iconName: wasCompleted ? "reset" : "calendar",
    state: disabled ? ChapterButtonsItemState.Disabled : ChapterButtonsItemState.Active,
    text: intl.formatMessage({
      id: textId
    }),
    link: get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(speakingId, history),
    appearance
  });
};
const ChapterButtonsSchedulerItem = _ref4 => {
  let {
    chapter,
    isFirstSpeaking,
    firstMentorSpeaking,
    onNeedUpdates,
    disabled = false,
    appearance
    // eslint-disable-next-line sonarjs/cognitive-complexity
  } = _ref4;
  const intl = (0,useIntl/* default */.Z)();
  const experimentDi = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const history = (0,react_router/* useHistory */.k6)();
  if (chapter.speaking === null) {
    return null;
  }
  if (chapter.speaking.session === null) {
    const isStudentSchedulerItem = chapter.type === student_model/* ChapterItemType */.a.Chapter && chapter.chapterState.type !== student_model/* ChapterStateType */.n_.Ended && !chapter.allowSpeakingBeforeChapter;
    const isMentorSchedulerItem = chapter.type === student_model/* ChapterItemType */.a.Mentor && firstMentorSpeaking !== null && firstMentorSpeaking.id !== chapter.speaking.id && (firstMentorSpeaking.endAt === null || (0,isBefore/* isBefore */.R)(currentTime, firstMentorSpeaking.endAt));
    if (isStudentSchedulerItem) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: chapter_buttons_module.schedulerItemRoot,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
          iconName: "calendar",
          state: ChapterButtonsItemState.Disabled,
          text: intl.formatMessage({
            id: experimentDi.nativeSpeakerSessionIds.has(chapter.speaking.id) ? "chapterButtons.scheduleHistorySessionNative" : "chapterButtons.scheduleHistorySession"
          }),
          appearance
        })
      });
    }
    if (isMentorSchedulerItem) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
        iconName: "calendar",
        state: disabled ? ChapterButtonsItemState.Disabled : ChapterButtonsItemState.Active,
        text: intl.formatMessage({
          id: experimentDi.nativeSpeakerSessionIds.has(chapter.speaking.id) ? "chapterButtons.scheduleMentorSessionNative" : "chapterButtons.scheduleMentorSession"
        }),
        link: get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(chapter.speaking.id, history),
        appearance
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterScheduleItem, {
      wasCompleted: false,
      speakingId: chapter.speaking.id,
      isMentor: chapter.type === student_model/* ChapterItemType */.a.Mentor,
      disabled,
      appearance
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsSchedulerSessionItem, {
    title: chapter.title,
    session: chapter.speaking.session,
    durationMin: chapter.speaking.durationMin,
    onNeedUpdates,
    isMentor: chapter.type === student_model/* ChapterItemType */.a.Mentor,
    isFirstSpeaking,
    speakingId: chapter.speaking.id,
    disabled,
    appearance
  });
};
const ChapterButtons = _ref5 => {
  let {
    chapter,
    isFirstSpeaking,
    appearance = chapter_buttons_item_component_ChapterButtonsItemAppearance.Deprecated,
    onNeedUpdates,
    firstMentorSpeaking,
    disabled = false,
    disableGrammarButton = false,
    disableLexisButton = false,
    disableStoryButton = false,
    disableSpeakingButton = false,
    notForSale = false,
    onSkip
  } = _ref5;
  const {
    startWithSpeakingSession,
    openStoryAfterSpeaking,
    allowAccessForPacketStudents
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const isLimitedAccess = notForSale && !allowAccessForPacketStudents;
  const isTrainerItem = !(openStoryAfterSpeaking && chapter.speaking?.session?.state !== speakingSession_model/* SpeakingSessionState */.Z.Completed) || !chapter.speaking;
  const isSchedulerItemBeforeTrainerItem = startWithSpeakingSession && chapter.speaking && !isLimitedAccess;
  const isSchedulerItemAfterTrainerItem = !startWithSpeakingSession && chapter.speaking && !isLimitedAccess;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: chapter_buttons_module.chapterButtonsBox,
    children: [isSchedulerItemBeforeTrainerItem && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsSchedulerItem, {
      disabled: disableSpeakingButton || disabled,
      firstMentorSpeaking,
      chapter,
      isFirstSpeaking,
      onNeedUpdates,
      appearance
    }), isTrainerItem && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsTrainerItem, {
      chapter,
      disabled,
      disableLexisButton,
      disableGrammarButton,
      disableStoryButton,
      appearance
    }), isSchedulerItemAfterTrainerItem && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsSchedulerItem, {
      disabled: disableSpeakingButton || disabled,
      firstMentorSpeaking,
      chapter,
      isFirstSpeaking,
      onNeedUpdates,
      appearance
    }), onSkip && /* @__PURE__ */(0,jsx_runtime.jsx)(chapter_buttons_item_component_SkipChapterButtonItem, {
      onClick: onSkip,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "chapterButtons.skip"
      })
    })]
  });
};
const ChapterButtonsA2PlusFlipped = _ref6 => {
  let {
    chapter,
    isFirstSpeaking,
    onNeedUpdates,
    firstMentorSpeaking,
    disabled = false,
    appearance = ChapterButtonsItemAppearance.Deprecated,
    disableGrammarButton = false,
    disableLexisButton = false,
    disableStoryButton = false,
    disableSpeakingButton = false,
    onSkip
  } = _ref6;
  return /* @__PURE__ */jsxs("div", {
    className: styles.chapterButtonsBox,
    children: [/* @__PURE__ */jsx(ChapterButtonsSchedulerItem, {
      disabled: disableSpeakingButton,
      appearance,
      firstMentorSpeaking,
      chapter,
      isFirstSpeaking,
      onNeedUpdates
    }), /* @__PURE__ */jsx(ChapterButtonsTrainerItem, {
      disabled,
      appearance,
      chapter,
      disableLexisButton,
      disableGrammarButton,
      disableStoryButton
    }), onSkip && /* @__PURE__ */jsx(SkipChapterButtonItem, {
      onClick: onSkip,
      children: /* @__PURE__ */jsx(FormattedMessage, {
        id: "chapterButtons.skip"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/foreigner-speakings/scheduled-foreigner-speaking.component.tsx
















const ScheduledForeignerSpeaking = _ref => {
  let {
    speaking,
    onClick
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const intl = (0,useIntl/* default */.Z)();
  const currentState = getCurrentState(currentTime, speaking.startAt, speaking.durationMin);
  const timeToStart = (0,differenceInMinutes/* differenceInMinutes */.X)(speaking.startAt, currentTime);
  const canGoClass = timeToStart <= CLASS_AVAILABLE_BEFORE_START_MIN;
  const canDelete = currentState === CurrentState.Scheduled;
  const dateString = (0,format/* format */.WU)(new Date(speaking.startAt), "d MMMM", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const timeFrom = (0,format/* format */.WU)(new Date(speaking.startAt), "HH:mm", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const timeTo = (0,format/* format */.WU)(new Date((0,addMinutes/* addMinutes */.m)(speaking.startAt, speaking.durationMin)), "HH:mm", {
    locale: utils_locale/* dateFnsLocale */.Y
  });
  const speakingDateString = `${dateString}, ${timeFrom}-${timeTo}`;
  const actionButtons = [{
    onClick: () => {
      history.push(studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(speaking.sessionId));
    },
    text: intl.formatMessage({
      id: "foreignerSpeakings.enterClass"
    }),
    type: "primary",
    disabled: !canGoClass
  }];
  if (canDelete) {
    actionButtons.unshift({
      onClick: () => {
        onClick(speaking.sessionId);
      },
      text: intl.formatMessage({
        id: "foreignerSpeakings.cancelClass"
      }),
      type: "secondary",
      disabled: false
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: foreigner_speakings_module.foreignerCard,
    "data-testid": "ScheduledForeignerLessonCard",
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerLessonCard, {
      id: speaking.id,
      actions: actionButtons,
      title: speaking.tutorName,
      date: speakingDateString,
      theme: speaking.theme,
      tutorAvatar: speaking.tutorAvatar
    })
  });
};
;// CONCATENATED MODULE: ./src/widgets/foreigner-speakings/foreigner-speakings.component.tsx














const ForeignerSpeakings = _ref => {
  let {
    initialForeignerSpeakings,
    scheduledForeignerSpeakings,
    onSpeakingSchedule,
    onSessionCancel
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isZeroBalance,
    showZeroBalanceWarning
  } = useNativeResource();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: foreigner_speakings_module.foreignerCards,
    children: [scheduledForeignerSpeakings.map(speaking => /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduledForeignerSpeaking, {
      speaking,
      onClick: onSessionCancel
    }, speaking.id)), showZeroBalanceWarning && initialForeignerSpeakings.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerLessonCard, {
      id: "ZeroBalanceWarning",
      actions: [{
        text: intl.formatMessage({
          id: "foreignerSpeakings.scheduleClass"
        }),
        type: "primary",
        disabled: true,
        onClick: function_utils/* emptyFunction */.Bi
      }],
      title: intl.formatMessage({
        id: "resources.zeroBalance.titleWithForeignerTutor"
      }),
      theme: intl.formatMessage({
        id: "resources.zeroBalance.text"
      }),
      duration: intl.formatMessage({
        id: "foreignerSpeakings.assigned"
      }, {
        count: initialForeignerSpeakings.length
      }),
      tutorAvatar: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: foreigner_speakings_module.zeroBalanceAvatar,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          name: "lamp",
          size: "large",
          className: foreigner_speakings_module.icon
        })
      })
    }), !isZeroBalance && /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: initialForeignerSpeakings.length > 1 ? /* @__PURE__ */(0,jsx_runtime.jsx)(InitialForeignerSpeakingToggle, {
        speakings: initialForeignerSpeakings,
        onSpeakingClick: onSpeakingSchedule
      }) : initialForeignerSpeakings.map(speaking => /* @__PURE__ */(0,jsx_runtime.jsx)(InitialForeignerSpeakingCard, {
        speaking,
        onSpeakingClick: onSpeakingSchedule,
        title: intl.formatMessage({
          id: "foreignerSpeakings.scheduleCardTitle"
        })
      }, speaking.id))
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/hooks/app/use-did-mount.ts
var use_did_mount = __webpack_require__(73058);
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/storage.ts




























const rescheduleLessonPopupDomain = (0,effector/* createDomain */.Fj)();
const initState = {
  error: void 0,
  step: "init",
  isLoading: false,
  selectedRescheduleDate: void 0,
  rescheduleDates: /* @__PURE__ */new Map(),
  isLate: false,
  isTooManyReschedules: false
};
const $rescheduleLessonPopupState = rescheduleLessonPopupDomain.createStore(initState);
const setErrorFx = rescheduleLessonPopupDomain.createEvent();
const setLoadingFx = rescheduleLessonPopupDomain.createEvent();
const setChooseRescheduleDateFx = rescheduleLessonPopupDomain.createEvent();
const setRescheduleConfirmFx = rescheduleLessonPopupDomain.createEvent();
const setRemoveConfirmFx = rescheduleLessonPopupDomain.createEvent();
const setRescheduleSurveyFx = rescheduleLessonPopupDomain.createEvent();
const setRemoveSurveyFx = rescheduleLessonPopupDomain.createEvent();
const setOnlyRemoveSurveyFx = rescheduleLessonPopupDomain.createEvent();
const setRescheduleDatesFx = rescheduleLessonPopupDomain.createEvent();
const setInitStateFx = rescheduleLessonPopupDomain.createEvent();
const setSelectedRescheduleDateFx = rescheduleLessonPopupDomain.createEvent();
const setSelectedReasonFx = rescheduleLessonPopupDomain.createEvent();
const setIsLateFx = rescheduleLessonPopupDomain.createEvent();
const setIsTooManyReschedulesFx = rescheduleLessonPopupDomain.createEvent();
$rescheduleLessonPopupState.on(setSelectedReasonFx, (prev, reason) => ({
  ...prev,
  reason
}));
$rescheduleLessonPopupState.on(setErrorFx, (prev, error) => ({
  ...prev,
  step: "error",
  error
}));
$rescheduleLessonPopupState.on(setLoadingFx, (prev, isLoading) => ({
  ...prev,
  isLoading
}));
$rescheduleLessonPopupState.on(setRescheduleConfirmFx, prev => ({
  ...prev,
  step: "rescheduleLessonConfirm",
  error: void 0
}));
$rescheduleLessonPopupState.on(setChooseRescheduleDateFx, prev => ({
  ...prev,
  step: "loaded",
  error: void 0
}));
$rescheduleLessonPopupState.on(setRemoveConfirmFx, prev => ({
  ...prev,
  step: "removeLessonConfirm",
  error: void 0
}));
$rescheduleLessonPopupState.on(setRescheduleSurveyFx, prev => ({
  ...prev,
  step: "rescheduleLessonSurvey",
  error: void 0
}));
$rescheduleLessonPopupState.on(setRemoveSurveyFx, prev => ({
  ...prev,
  step: "removeLessonSurvey",
  error: void 0
}));
$rescheduleLessonPopupState.on(setOnlyRemoveSurveyFx, prev => ({
  ...prev,
  step: "onlyRemoveLessonSurvey",
  error: void 0
}));
$rescheduleLessonPopupState.on(setSelectedRescheduleDateFx, (prev, selectedRescheduleDate) => ({
  ...prev,
  selectedRescheduleDate
}));
$rescheduleLessonPopupState.on(setRescheduleDatesFx, (prev, rescheduleDates) => {
  let selectedRescheduleDate;
  if (rescheduleDates.size > 0) {
    const firstKey = Array.from(rescheduleDates.keys())[0];
    selectedRescheduleDate = rescheduleDates.get(firstKey)?.[0];
  }
  return {
    ...prev,
    step: "loaded",
    error: void 0,
    rescheduleDates,
    selectedRescheduleDate
  };
});
$rescheduleLessonPopupState.on(setIsLateFx, (prev, value) => ({
  ...prev,
  isLate: value
}));
$rescheduleLessonPopupState.on(setIsTooManyReschedulesFx, (prev, value) => ({
  ...prev,
  isTooManyReschedules: value
}));
$rescheduleLessonPopupState.on(setInitStateFx, _ => initState);
const useRescheduleLessonPopupStorageAdapter = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const location = (0,react_router/* useLocation */.TH)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    speakingSessions
  } = useScheduling();
  const {
    disallowSpeakingSessionMultipleReschedule
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const rescheduleLessonPopupState = (0,effector_react/* useStore */.oR)($rescheduleLessonPopupState);
  const speakingSessionIdFromQuery = get_url_search_params.getUrlSearchParams.rescheduleLessonPopup.getSpeakingSessionId(location);
  const speakingSession = (0,react.useMemo)(() => {
    if (speakingSessionIdFromQuery === null) {
      return;
    }
    return speakingSessions.find(speakingSession2 => speakingSession2.id === speakingSessionIdFromQuery);
  }, [speakingSessionIdFromQuery, speakingSessions]);
  const openPopup = (0,react.useCallback)(speakingSessionId => {
    history.push(get_url_search_params.getUrlSearchParams.rescheduleLessonPopup.getOpenPopUpPath(history, speakingSessionId));
  }, [history]);
  const closePopup = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.rescheduleLessonPopup.getClosePopUpPath(history));
    setInitStateFx();
  }, [history]);
  return (0,react.useMemo)(() => ({
    rescheduleLessonPopupState,
    speakingTypeId: speakingSession?.speaking.typeId,
    businessProductId: user.data?.product?.businessId ?? null,
    tutorId: speakingSession?.tutor?.id,
    speakingSession,
    isOpenPopUp: Boolean(speakingSessionIdFromQuery),
    speakingSessionId: speakingSessionIdFromQuery,
    openPopup,
    closePopup,
    setError: setErrorFx,
    setLoading: setLoadingFx,
    setLoaded: setRescheduleDatesFx,
    toRescheduleConfirm: setRescheduleConfirmFx,
    toRemoveConfirm: setRemoveConfirmFx,
    toRescheduleSurvey: setRescheduleSurveyFx,
    toRemoveSurvey: setRemoveSurveyFx,
    toOnlyRemoveSurvey: setOnlyRemoveSurveyFx,
    toChooseRescheduleDate: setChooseRescheduleDateFx,
    setSelectedRescheduleDate: setSelectedRescheduleDateFx,
    setSelectedReason: setSelectedReasonFx,
    disallowSpeakingSessionMultipleReschedule,
    setIsLate: setIsLateFx,
    setIsTooManyReschedules: setIsTooManyReschedulesFx
  }), [rescheduleLessonPopupState, speakingSession, user.data?.product?.businessId, speakingSessionIdFromQuery, openPopup, closePopup, disallowSpeakingSessionMultipleReschedule]);
};
// EXTERNAL MODULE: ../../node_modules/date-fns/formatISO.mjs
var formatISO = __webpack_require__(45269);
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/presenter/utils.ts

























function getRescheduleDaysMap(rescheduleDates) {
  const now = /* @__PURE__ */new Date();
  return Array.from(rescheduleDates.entries()).reduce((result, _ref) => {
    let [rescheduleDayKey, rescheduleDates2] = _ref;
    const times = rescheduleDates2.filter(time => time.getTime() > now.getTime());
    if (times && times.length > 0) {
      result.set(rescheduleDayKey, times);
    }
    return result;
  }, /* @__PURE__ */new Map());
}
function getSpeakingSessionDateTimeInterval(startAt, durationMinutes) {
  return `${localeFormat(startAt, "d MMMM, HH:mm")} - ${localeFormat((0,addMinutes/* addMinutes */.m)(startAt, durationMinutes), "HH:mm")}`;
}
function getRescheduleDays(rescheduleDates) {
  return Array.from(rescheduleDates.entries()).map(_ref2 => {
    let [rescheduleDay, dates] = _ref2;
    return {
      id: rescheduleDay,
      time: dates[0]
    };
  });
}
function getAvailableTimes(rescheduleDates, selectedDate) {
  if (!selectedDate) {
    return [];
  }
  const dates = rescheduleDates.get(selectedDate.id);
  if (!dates) {
    return [];
  }
  return dates.map(rescheduleDay => ({
    id: rescheduleDay.toISOString(),
    time: rescheduleDay
  }));
}
function localeFormat(date, formatStr) {
  return (0,format/* format */.WU)(date, formatStr, {
    locale: utils_locale/* dateFnsLocale */.Y
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/presenter/presenter.ts








function createPresenter(_ref) {
  let {
    rescheduleLessonPopupState,
    speakingSession,
    removeSurveys,
    rescheduleSurveys,
    disallowSpeakingSessionMultipleReschedule
  } = _ref;
  const {
    error,
    step,
    rescheduleDates,
    selectedRescheduleDate,
    isLoading,
    isLate: isLateFromServer,
    isTooManyReschedules
  } = rescheduleLessonPopupState;
  const isLateLocal = getIsLateSpeakingSessionChange({
    speakingSessionStartAt: speakingSession.startAt
  });
  const isLate = disallowSpeakingSessionMultipleReschedule ? isLateFromServer : isLateLocal;
  const speakingSessionDateTimeInterval = getSpeakingSessionDateTimeInterval(speakingSession.startAt, speakingSession.speaking.durationMinutes);
  switch (step) {
    case "init":
      {
        return {
          state: "init",
          isLoading
        };
      }
    case "error":
      {
        return {
          state: "error",
          isLoading,
          error: error ?? new unknown/* UnknownError */.K()
        };
      }
    case "rescheduleLessonConfirm":
      {
        if (!selectedRescheduleDate) {
          throw new not_found_object_error/* NotFoundObjectError */.m("selectedRescheduleDate");
        }
        let subtitleTranslationKey = "StudentRescheduleLessonPopup.rescheduleConfirm.notLateMessage";
        if (isLate) {
          subtitleTranslationKey = "StudentRescheduleLessonPopup.rescheduleConfirm.lateWarning";
        } else if (disallowSpeakingSessionMultipleReschedule) {
          if (isTooManyReschedules) {
            subtitleTranslationKey = "StudentRescheduleLessonPopup.rescheduleConfirm.toManyReschedulesMessage";
          } else {
            subtitleTranslationKey = "StudentRescheduleLessonPopup.rescheduleConfirm.freeReschedulesMessage";
          }
        }
        return {
          state: "rescheduleConfirm",
          isLoading,
          speakingSessionDateTimeInterval,
          selectedRescheduleDateTimeInterval: getSpeakingSessionDateTimeInterval(selectedRescheduleDate, speakingSession.speaking.durationMinutes),
          subtitleTranslationKey
        };
      }
    case "removeLessonConfirm":
      {
        let subtitleTranslationKey = "StudentRescheduleLessonPopup.cancelConfirm.notLateMessage";
        if (isLate) {
          subtitleTranslationKey = "StudentRescheduleLessonPopup.cancelConfirm.lateWarning";
        } else if (isTooManyReschedules) {
          subtitleTranslationKey = "StudentRescheduleLessonPopup.cancelConfirm.tooManyReschedules";
        }
        return {
          state: "removeConfirm",
          isLoading,
          speakingSessionDateTimeInterval,
          subtitleTranslationKey
        };
      }
    case "rescheduleLessonSurvey":
      {
        return {
          state: "rescheduleReasonSurvey",
          titleKey: rescheduleSurveys?.title ?? "StudentRescheduleLessonPopup.rescheduleSurvey.title",
          variants: rescheduleSurveys?.variants ?? [],
          isLoading
        };
      }
    case "removeLessonSurvey":
      {
        return {
          state: "removeReasonSurvey",
          titleKey: removeSurveys?.title ?? "StudentRescheduleLessonPopup.removeSurvey.title",
          variants: removeSurveys?.variants ?? [],
          isLoading
        };
      }
    case "onlyRemoveLessonSurvey":
      {
        return {
          state: "onlyRemoveReasonSurvey",
          titleKey: removeSurveys?.title ?? "StudentRescheduleLessonPopup.removeSurvey.title",
          variants: removeSurveys?.variants ?? [],
          isLoading
        };
      }
    case "loaded":
      {
        if (rescheduleDates.size === 0) {
          let descriptionTranslationKey = "StudentRescheduleLessonPopup.noAvailableSlots.lateWarning";
          if (!isLate) {
            descriptionTranslationKey = isTooManyReschedules ? "StudentRescheduleLessonPopup.noAvailableSlots.tooManyReschedules" : "StudentRescheduleLessonPopup.noAvailableSlots.notLateMessage";
          }
          return {
            state: "onlyRemove",
            isLoading,
            descriptionTranslationKey
          };
        }
        if (!selectedRescheduleDate) {
          throw new not_found_object_error/* NotFoundObjectError */.m("selectedRescheduleDate");
        }
        const rescheduleDaysMap = getRescheduleDaysMap(rescheduleDates);
        const selectedDate = {
          id: (0,formatISO/* formatISO */.c)(selectedRescheduleDate, {
            representation: "date"
          }),
          time: selectedRescheduleDate
        };
        const selectedTime = {
          id: selectedRescheduleDate.toISOString(),
          time: selectedRescheduleDate
        };
        const rescheduleDays = getRescheduleDays(rescheduleDaysMap);
        const availableTimes = getAvailableTimes(rescheduleDaysMap, selectedDate);
        return {
          state: "chooseRescheduleDate",
          isLoading,
          speakingSessionDateTimeInterval,
          rescheduleDays,
          availableTimes,
          selectedDate,
          selectedTime,
          isLate,
          isTooManyReschedules: disallowSpeakingSessionMultipleReschedule && isTooManyReschedules,
          warningDescriptionTranslationKey: isTooManyReschedules ? "StudentRescheduleLessonPopup.selectSlots.alreadyRescheduledWarningDescription" : "StudentRescheduleLessonPopup.selectSlots.lateWarning.title"
        };
      }
    default:
      {
        throw new Error(`Unknown reschedule popup step '${step}'`);
      }
  }
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/presenter/use-presenter.ts







function usePresenter() {
  const {
    rescheduleLessonPopupState,
    speakingSession,
    disallowSpeakingSessionMultipleReschedule
  } = useRescheduleLessonPopupStorageAdapter();
  const [surveys, setSurveys] = (0,react.useState)();
  (0,react.useEffect)(() => {
    void (0,bunker_api/* getStudentRescheduleLessonSurvey */.ob)().then(setSurveys);
  }, []);
  if (!speakingSession) {
    throw new not_found_object_error/* NotFoundObjectError */.m("speakingSession");
  }
  return (0,react.useMemo)(() => ({
    viewModel: createPresenter({
      rescheduleLessonPopupState,
      speakingSession,
      rescheduleSurveys: surveys?.reschedule,
      removeSurveys: surveys?.remove,
      disallowSpeakingSessionMultipleReschedule
    })
  }), [rescheduleLessonPopupState, speakingSession, surveys?.remove, surveys?.reschedule, disallowSpeakingSessionMultipleReschedule]);
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/presenter/index.ts



// EXTERNAL MODULE: ./src/adapters/date.service-adapter.ts
var date_service_adapter = __webpack_require__(87287);
;// CONCATENATED MODULE: ./src/services/cancel-lesson/adapters/api.ts





const cancelLessonApiAdapter = {
  cancelLesson: async params => {
    await (0,events_api/* postSpeakingSessionEvent */.ed)({
      speakingSessionId: params.speakingSession.id,
      studentId: params.speakingSession.student?.id ?? "",
      tutorId: params.speakingSession.tutor?.id ?? "",
      startAt: date_service_adapter/* dateServiceAdapter */.e.formatDateForBackend(params.speakingSession.startAt),
      event: speakingSession_model/* SpeakingSessionFSMEvent */.jO.Cancel,
      cancelReason: speakingSession_model/* SpeakingSessionCancelReason */.Ph.ByStudent,
      studentCancelReason: params.reason,
      businessProductId: params.businessProductId
    });
  }
};
;// CONCATENATED MODULE: ./src/services/cancel-lesson/ports/logger.ts


function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class CancelSpeakingSessionError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, CancelSpeakingSessionError.prototype);
  }
}
class NoSpeakingSessionIdError extends CancelSpeakingSessionError {
  constructor() {
    super();
    Object.setPrototypeOf(this, NoSpeakingSessionIdError.prototype);
  }
}
class NoBusinessProductIdIdError extends CancelSpeakingSessionError {
  constructor() {
    super();
    Object.setPrototypeOf(this, NoBusinessProductIdIdError.prototype);
  }
}
class SpeakingSessionAlreadyFinishedError extends CancelSpeakingSessionError {
  constructor(params) {
    super();
    _defineProperty(this, "speakingSession", void 0);
    this.speakingSession = params.speakingSession;
    Object.setPrototypeOf(this, SpeakingSessionAlreadyFinishedError.prototype);
  }
}
class CancelSpeakingSessionAPIError extends CancelSpeakingSessionError {
  constructor(params) {
    super();
    _defineProperty(this, "speakingSessionId", void 0);
    this.speakingSessionId = params.speakingSessionId;
    Object.setPrototypeOf(this, CancelSpeakingSessionAPIError.prototype);
  }
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/api.ts




const rescheduleLessonApi = {
  async rescheduleLesson(props) {
    const {
      date,
      speakingSessionId,
      reason,
      isFreeReschedule
    } = props;
    const res = await (0,speaking_session_speaking_session_api/* rescheduleLesson */.u9)({
      date,
      speakingSessionId,
      reason,
      isFreeReschedule
    });
    if ((0,es6_Either/* isRight */.tO)(res)) {
      return res.right;
    }
    throw res.left;
  },
  async getRescheduleDates(props) {
    const {
      tutorId,
      speakingTypeId,
      disallowSpeakingSessionMultipleReschedule,
      speakingSessionId
    } = props;
    const res = await (0,speaking_session_speaking_session_api/* getRescheduleDates */.RI)({
      tutorId,
      speakingTypeId,
      disallowSpeakingSessionMultipleReschedule,
      speakingSessionId
    });
    if ((0,es6_Either/* isRight */.tO)(res)) {
      return res.right;
    }
    throw res.left;
  }
};
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/reschedule-lesson-popup-service/reschedule-lesson-popup-service.ts


































const toastId = "rescheduleLessonSuccessToast";
function rescheduleLessonPopupService(props) {
  const {
    storage,
    textConstants,
    scheduleService
  } = props;
  const {
    initSpeakingSessions: refreshSpeakingSessionList,
    setSpeakingSessionState,
    setSpeakingSession
  } = scheduleService;
  const tryFn = fn => async () => {
    try {
      storage.setLoading(true);
      return await fn();
    } catch (error) {
      const processingError = reschedule_lesson_popup_service_normalizeError(error);
      logger/* Logger */.Yd.captureException(error, {
        feature: "reschedule"
      });
      storage.setError(processingError);
    } finally {
      storage.setLoading(false);
    }
  };
  const init = async () => {
    const {
      tutorId,
      speakingTypeId,
      disallowSpeakingSessionMultipleReschedule,
      speakingSessionId
    } = storage;
    if (!tutorId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("tutorId");
    }
    if (!speakingTypeId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingTypeId");
    }
    if (disallowSpeakingSessionMultipleReschedule && !speakingSessionId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingSessionId");
    }
    const rescheduleDatesResponse = await rescheduleLessonApi.getRescheduleDates({
      tutorId,
      speakingTypeId,
      disallowSpeakingSessionMultipleReschedule,
      speakingSessionId
    });
    if (rescheduleDatesResponse.version === "2") {
      storage.setIsLate(rescheduleDatesResponse.isLateReschedule);
      storage.setIsTooManyReschedules(rescheduleDatesResponse.isMultipleReschedule);
    }
    storage.setLoaded(rescheduleDatesResponse.by30MinGap);
  };
  const rescheduleLesson = async () => {
    const {
      speakingSessionId,
      speakingSession,
      rescheduleLessonPopupState: {
        selectedRescheduleDate,
        reason,
        isLate,
        isTooManyReschedules
      },
      disallowSpeakingSessionMultipleReschedule
    } = storage;
    if (!speakingSessionId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingSessionId");
    }
    if (!selectedRescheduleDate) {
      throw new not_found_object_error/* NotFoundObjectError */.m("selectedRescheduleDate");
    }
    const rescheduledSpeakingSession = await rescheduleLessonApi.rescheduleLesson({
      date: selectedRescheduleDate,
      speakingSessionId,
      reason,
      ...(disallowSpeakingSessionMultipleReschedule ? {
        isFreeReschedule: !(isLate || isTooManyReschedules)
      } : null)
    });
    storage.closePopup();
    toast/* toastNotificationService */.B.showSuccess(textConstants.rescheduleLessonSuccess, {
      toastId
    });
    if (speakingSession?.startAt && getIsLateSpeakingSessionChange({
      speakingSessionStartAt: speakingSession.startAt
    })) {
      event_emitter/* eventEmitter */.T.emit("lateSpeakingSessionChange");
    }
    await setSpeakingSession(rescheduledSpeakingSession);
    (0,yandexMetrica/* ymGoal */.qf)("Reschedule_Popup_Reschedule_Button");
  };
  const removeLesson = async () => {
    const {
      speakingSession,
      businessProductId,
      rescheduleLessonPopupState
    } = storage;
    if (!businessProductId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("businessProductId");
    }
    if (!speakingSession) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingSession");
    }
    if ((0,isBefore/* isBefore */.R)((0,addMinutes/* addMinutes */.m)(speakingSession.startAt, speakingSession.speaking.durationMinutes), /* @__PURE__ */new Date())) {
      throw new SpeakingSessionAlreadyFinishedError({
        speakingSession
      });
    }
    try {
      await cancelLessonApiAdapter.cancelLesson({
        speakingSession,
        businessProductId,
        reason: rescheduleLessonPopupState?.reason
      });
      storage.closePopup();
      toast/* toastNotificationService */.B.showSuccess(textConstants.removingLessonSuccess, {
        toastId
      });
      if (getIsLateSpeakingSessionChange({
        speakingSessionStartAt: speakingSession.startAt
      })) {
        event_emitter/* eventEmitter */.T.emit("lateSpeakingSessionChange");
      }
      await refreshSpeakingSessionList();
      await setSpeakingSessionState({
        speakingSessionId: speakingSession.id,
        state: speakingSession_model/* SpeakingSessionState */.Z.Cancelled
      });
      (0,yandexMetrica/* ymGoal */.qf)("Reschedule_Popup_Cancel_Button");
    } catch {
      throw new CancelSpeakingSessionAPIError({
        speakingSessionId: speakingSession.id
      });
    }
  };
  const openPopup = (speakingSessionId, from) => {
    storage.openPopup(speakingSessionId);
    (0,yandexMetrica/* ymGoal */.qf)(from === "main" ? "Reschedule_Button_Dashboard_Page" : "Reschedule_Button_Schedule_Page");
  };
  const closePopupWithRefresh = () => {
    refreshSpeakingSessionList();
    storage.closePopup();
    return Promise.resolve();
  };
  const removeRescheduleDate = () => {
    const {
      rescheduleDates,
      selectedRescheduleDate
    } = storage.rescheduleLessonPopupState;
    if (!selectedRescheduleDate) {
      throw new not_found_object_error/* NotFoundObjectError */.m("selectedRescheduleDate");
    }
    const dateKey = (0,formatISO/* formatISO */.c)(selectedRescheduleDate, {
      representation: "date"
    });
    const copyRescheduleDates = new Map(rescheduleDates.entries());
    const times = copyRescheduleDates.get(dateKey);
    if (!times) {
      throw new not_found_object_error/* NotFoundObjectError */.m("date to rescheduleDates");
    }
    if (times.length <= 1) {
      copyRescheduleDates.delete(dateKey);
    } else {
      const selectedRescheduleDateInt = Number(selectedRescheduleDate);
      copyRescheduleDates.set(dateKey, times.filter(time => selectedRescheduleDateInt !== Number(time)));
    }
    storage.setLoaded(copyRescheduleDates);
  };
  const toChoseRescheduleDateWithRemoval = () => {
    removeRescheduleDate();
    storage.toChooseRescheduleDate();
  };
  const checkReschedulingButtonEnable = speakingSession => speakingSession.startAt > /* @__PURE__ */new Date();
  const setSelectedDate = _ref => {
    let {
      time
    } = _ref;
    const {
      rescheduleDates,
      selectedRescheduleDate
    } = storage.rescheduleLessonPopupState;
    if (!selectedRescheduleDate) {
      throw new not_found_object_error/* NotFoundObjectError */.m("rescheduleDate");
    }
    const dateKey = (0,formatISO/* formatISO */.c)(time, {
      representation: "date"
    });
    const times = rescheduleDates.get(dateKey);
    if (!times) {
      throw new not_found_object_error/* NotFoundObjectError */.m("date to rescheduleDates");
    }
    const selectedRescheduleDateHours = selectedRescheduleDate.getHours();
    const selectedRescheduleDateMinutes = selectedRescheduleDate.getMinutes();
    const sameTime = times.find(time2 => selectedRescheduleDateHours === time2.getHours() && selectedRescheduleDateMinutes === time2.getMinutes());
    storage.setSelectedRescheduleDate(sameTime ?? time);
  };
  const setSelectedTime = _ref2 => {
    let {
      time
    } = _ref2;
    storage.setSelectedRescheduleDate(time);
  };
  return {
    isOpenPopup: Boolean(storage.speakingSession && storage.isOpenPopUp),
    init: tryFn(init),
    rescheduleLesson: tryFn(rescheduleLesson),
    removeLesson: tryFn(removeLesson),
    openPopup,
    closePopup: storage.closePopup,
    closePopupWithRefresh: tryFn(closePopupWithRefresh),
    toRemoveConfirm: storage.toRemoveConfirm,
    toRescheduleConfirm: storage.toRescheduleConfirm,
    toRemoveSurvey: storage.toRemoveSurvey,
    toOnlyRemoveSurvey: storage.toOnlyRemoveSurvey,
    toRescheduleSurvey: storage.toRescheduleSurvey,
    toChooseRescheduleDate: storage.toChooseRescheduleDate,
    setSelectedReason: storage.setSelectedReason,
    checkReschedulingButtonEnable,
    toChoseRescheduleDateWithRemoval,
    setSelectedDate,
    setSelectedTime
  };
}
function reschedule_lesson_popup_service_normalizeError(error) {
  return typeof error === "object" && error instanceof Error ? error : new unknown/* UnknownError */.K();
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/use-reschedule-lesson-popup-service.ts







const useRescheduleLessonPopupService = () => {
  const scheduleService = useScheduling();
  const rescheduleLessonPopupStorage = useRescheduleLessonPopupStorageAdapter();
  const intl = (0,useIntl/* default */.Z)();
  const {
    showReschedulingButton
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const service = rescheduleLessonPopupService({
    storage: rescheduleLessonPopupStorage,
    scheduleService,
    textConstants: {
      rescheduleLessonSuccess: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.rescheduleSuccess.title"
      }),
      removingLessonSuccess: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.cancelSuccess.title"
      })
    }
  });
  return {
    ...service,
    studentRescheduleAbility: showReschedulingButton,
    isOpenPopup: showReschedulingButton && service.isOpenPopup
  };
};
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/service/index.ts



;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/reschedule-lesson-popup-modal-content.tsx




function RescheduleLessonPopupModalContent(_ref) {
  let {
    size = modal/* ModalSize */.Cg.Small,
    buttonsBlockStretch = true,
    children,
    ...otherModalContentProps
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* ModalContent */.hz, {
    size,
    buttonsBlockStretch,
    ...otherModalContentProps,
    children
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/reschedule-lesson-description.tsx






function RescheduleLessonDescription() {
  const intl = (0,useIntl/* default */.Z)();
  const {
    disallowSpeakingSessionMultipleReschedule
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    className: typography_module/* default */.Z.body2,
    children: intl.formatMessage({
      id: disallowSpeakingSessionMultipleReschedule ? "StudentRescheduleLessonPopup.selectSlots.noMultipleRescheduleDescription" : "StudentRescheduleLessonPopup.selectSlots.notLateMessage"
    }, {
      br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
    })
  });
}
// EXTERNAL MODULE: ../ui-kit/src/beginner-scheduling/__time-selection-widget/time-selection-widget.component.tsx + 2 modules
var time_selection_widget_component = __webpack_require__(51311);
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/time-blocks/time-blocks.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const time_blocks_module = ({"time-blocks":"time-blocks-module__time-blocks--Sd49X","timeBlocks":"time-blocks-module__time-blocks--Sd49X","time-block":"time-blocks-module__time-block--PZdPa","timeBlock":"time-blocks-module__time-block--PZdPa","time-blocks-loader":"time-blocks-module__time-blocks-loader--BBhQB","timeBlocksLoader":"time-blocks-module__time-blocks-loader--BBhQB"});
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/time-blocks/time-blocks.tsx














const TimeBlocks = _ref => {
  let {
    selectedDate,
    selectedTime,
    rescheduleDays,
    availableTimes,
    setSelectedDate,
    setSelectedTime
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const width = (0,use_screen_width/* useScreenWidth */.k)();
  if (!selectedDate) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: time_blocks_module.timeBlocks,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: time_blocks_module.timeBlock,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        timeSlot: {
          label: intl.formatMessage({
            id: "StudentRescheduleLessonPopup.timeBlocks.dateSlotLabel"
          }),
          type: "date",
          date: {
            selectedTime: selectedDate,
            allTimes: rescheduleDays.map(rescheduleDay => ({
              id: rescheduleDay.id,
              isDisabled: false,
              accentedText: (0,format/* format */.WU)(rescheduleDay.time, "dd MMMM", {
                locale: utils_locale/* dateFnsLocale */.Y
              }),
              text: (0,format/* format */.WU)(rescheduleDay.time, "EEEEEE", {
                locale: utils_locale/* dateFnsLocale */.Y
              })
            })),
            onChange: id => {
              const newSelectedDate = rescheduleDays.find(rescheduleDay => rescheduleDay.id === id);
              if (newSelectedDate) {
                setSelectedDate(newSelectedDate);
              }
            }
          }
        },
        isMobile: width.isMobile
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: time_blocks_module.timeBlock,
      children: selectedTime && /* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        timeSlot: {
          label: intl.formatMessage({
            id: "StudentRescheduleLessonPopup.timeBlocks.timeSlotLabel"
          }),
          type: "fullTime",
          fullTime: {
            selectedTime,
            allTimes: availableTimes.map(availableTime => ({
              id: availableTime.id,
              isDisabled: false,
              accentedText: (0,format/* format */.WU)(availableTime.time, "HH:mm", {
                locale: utils_locale/* dateFnsLocale */.Y
              })
            })),
            onChange: id => {
              const newSelectedTime = availableTimes.find(availableTime => availableTime.id === id);
              if (newSelectedTime) {
                setSelectedTime(newSelectedTime);
              }
            }
          }
        },
        isMobile: width.isMobile
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/time-blocks/index.ts



;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/warning/warning.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const warning_module = ({"late-warning":"warning-module__late-warning--E_Apx","lateWarning":"warning-module__late-warning--E_Apx","late-warning-title":"warning-module__late-warning-title--QS3nW","lateWarningTitle":"warning-module__late-warning-title--QS3nW"});
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/warning/warning.tsx








function Warning(_ref) {
  let {
    isLate,
    isTooManyReschedules
  } = _ref;
  const {
    hideCancelButton
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  if (!(isLate || isTooManyReschedules)) {
    return null;
  }
  let descriptionTranslationId = "";
  if (isLate) {
    descriptionTranslationId = hideCancelButton ? "StudentRescheduleLessonPopup.selectSlots.lateRescheduleWarning.text" : "StudentRescheduleLessonPopup.selectSlots.lateWarning.text";
  } else if (isTooManyReschedules) {
    descriptionTranslationId = "StudentRescheduleLessonPopup.selectSlots.alreadyRescheduledWarningDescription";
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: warning_module.lateWarning,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, warning_module.lateWarningTitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "StudentRescheduleLessonPopup.selectSlots.lateWarning.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body2,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: descriptionTranslationId
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/components/warning/index.ts



;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/choose-reschedule-date.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const choose_reschedule_date_module = ({"empty-popup-loader":"choose-reschedule-date-module__empty-popup-loader--nqcAb","emptyPopupLoader":"choose-reschedule-date-module__empty-popup-loader--nqcAb"});
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/choose-reschedule-date.tsx














function ChooseRescheduleDate(_ref) {
  let {
    viewModel
  } = _ref;
  const {
    toRemoveConfirm,
    toRescheduleConfirm,
    toRescheduleSurvey,
    toRemoveSurvey,
    setSelectedDate,
    setSelectedTime
  } = useRescheduleLessonPopupService();
  const {
    showCancelOrRescheduleReasonSurvey,
    hideCancelButton
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    isLoading,
    state
  } = viewModel;
  const intl = (0,useIntl/* default */.Z)();
  const popupButtons = (0,react.useMemo)(() => {
    const cancelButton = {
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.selectSlots.cancelButtonText"
      }),
      appearance: "secondary",
      disabled: isLoading,
      onClick: showCancelOrRescheduleReasonSurvey ? toRemoveSurvey : toRemoveConfirm
    };
    const rescheduleButton = {
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.selectSlots.rescheduleButtonText"
      }),
      appearance: "primary",
      disabled: isLoading,
      onClick: showCancelOrRescheduleReasonSurvey ? toRescheduleSurvey : toRescheduleConfirm
    };
    return hideCancelButton ? [rescheduleButton] : [cancelButton, rescheduleButton];
  }, [hideCancelButton, intl, isLoading, showCancelOrRescheduleReasonSurvey, toRemoveConfirm, toRemoveSurvey, toRescheduleConfirm, toRescheduleSurvey]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
    title: intl.formatMessage({
      id: "StudentRescheduleLessonPopup.selectSlots.title"
    }, {
      fromDate: state === "chooseRescheduleDate" ? viewModel.speakingSessionDateTimeInterval : ""
    }),
    titleSize: modal/* TitleSize */.Jj.Small,
    showCloseButton: true,
    buttons: popupButtons,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: state === "chooseRescheduleDate" ? /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Warning, {
          isLate: viewModel.isLate,
          isTooManyReschedules: viewModel.isTooManyReschedules
        }), !viewModel.isLate && !viewModel.isTooManyReschedules && /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonDescription, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(TimeBlocks, {
          availableTimes: viewModel.availableTimes,
          rescheduleDays: viewModel.rescheduleDays,
          selectedDate: viewModel.selectedDate,
          selectedTime: viewModel.selectedTime,
          setSelectedDate,
          setSelectedTime
        })]
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: choose_reschedule_date_module.emptyPopupLoader,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
      })
    })
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/choose-reschedule-date/index.ts



;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/only-remove.tsx








function OnlyRemove(_ref) {
  let {
    viewModel
  } = _ref;
  const {
    descriptionTranslationKey
  } = viewModel;
  const intl = (0,useIntl/* default */.Z)();
  const {
    onClose: closePopup
  } = (0,modal/* useModalContext */.vR)();
  const {
    toRemoveConfirm,
    toOnlyRemoveSurvey
  } = useRescheduleLessonPopupService();
  const {
    showCancelOrRescheduleReasonSurvey
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
    contentPosition: modal/* ModalContentPosition */.s7.Default,
    title: intl.formatMessage({
      id: "StudentRescheduleLessonPopup.noAvailableSlots.title"
    }),
    subtitle: /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        children: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.noAvailableSlots.subtitle"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: descriptionTranslationKey,
        tagName: "p"
      })]
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.noAvailableSlots.declineButtonText"
      }),
      appearance: "secondary",
      onClick: closePopup
    }, {
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.noAvailableSlots.submitButtonText"
      }),
      appearance: "primary",
      onClick: showCancelOrRescheduleReasonSurvey ? toOnlyRemoveSurvey : toRemoveConfirm
    }]
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/remove-lesson-confirm.tsx







function RemoveLessonConfirm(_ref) {
  let {
    viewModel
  } = _ref;
  const {
    isLoading,
    speakingSessionDateTimeInterval,
    subtitleTranslationKey
  } = viewModel;
  const intl = (0,useIntl/* default */.Z)();
  const {
    removeLesson,
    toChooseRescheduleDate
  } = useRescheduleLessonPopupService();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: intl.formatMessage({
      id: "StudentRescheduleLessonPopup.cancelConfirm.title_2"
    }, {
      br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}),
      fromDate: speakingSessionDateTimeInterval
    }),
    subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: subtitleTranslationKey
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.cancelConfirm.declineButtonText"
      }),
      appearance: "secondary",
      disabled: isLoading,
      onClick: toChooseRescheduleDate
    }, {
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.cancelConfirm.submitButtonText"
      }),
      appearance: "primary",
      loading: {
        isLoading,
        loadingLabel: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.cancelConfirm.loadingButtonLabel"
        })
      },
      onClick: removeLesson
    }]
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/reschedule-confirm.tsx







function RescheduleConfirm(_ref) {
  let {
    viewModel: {
      isLoading,
      speakingSessionDateTimeInterval,
      selectedRescheduleDateTimeInterval,
      subtitleTranslationKey
    }
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    toChooseRescheduleDate,
    rescheduleLesson
  } = useRescheduleLessonPopupService();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: intl.formatMessage({
      id: "StudentRescheduleLessonPopup.rescheduleConfirm.title_2"
    }, {
      br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}),
      fromDate: speakingSessionDateTimeInterval,
      toDate: selectedRescheduleDateTimeInterval
    }),
    subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: subtitleTranslationKey,
      tagName: "p"
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.rescheduleConfirm.declineButtonText"
      }),
      appearance: "secondary",
      disabled: isLoading,
      onClick: toChooseRescheduleDate
    }, {
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.rescheduleConfirm.submitButtonText"
      }),
      appearance: "primary",
      loading: {
        isLoading,
        loadingLabel: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.rescheduleConfirm.loadingButtonLabel"
        })
      },
      onClick: rescheduleLesson
    }]
  });
}
// EXTERNAL MODULE: ./src/widgets/reschedule-lesson-popup/service/errors.ts
var errors = __webpack_require__(8490);
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/unknown-error.tsx






function UnknownError() {
  const intl = (0,useIntl/* default */.Z)();
  const {
    onClose: closePopup
  } = (0,modal/* useModalContext */.vR)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: intl.formatMessage({
      id: "StudentRescheduleLessonPopup.unknownError.title"
    }),
    subtitle: intl.formatMessage({
      id: "StudentRescheduleLessonPopup.unknownError.subtitle"
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.unknownError.submitButtonText"
      }),
      appearance: "primary",
      onClick: closePopup
    }]
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/reschedule-lesson-popup-error.tsx










function RescheduleLessonPopupError(_ref) {
  let {
    viewModel: {
      error
    }
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    onClose: closePopup
  } = (0,modal/* useModalContext */.vR)();
  const {
    closePopupWithRefresh,
    toChoseRescheduleDateWithRemoval
  } = useRescheduleLessonPopupService();
  if (error instanceof SpeakingSessionAlreadyFinishedError) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      title: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.lessonAlreadyFinished.title"
      }),
      subtitle: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.lessonAlreadyFinished.subtitle"
      }),
      buttons: [{
        text: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.lessonAlreadyFinished.submitButtonText"
        }),
        appearance: "primary",
        onClick: closePopupWithRefresh
      }]
    });
  }
  if (error instanceof errors/* RescheduleAlreadyInThePastError */.h0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      title: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.alreadyInThePastError.title"
      }),
      subtitle: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.alreadyInThePastError.subtitle"
      }),
      buttons: [{
        text: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.alreadyInThePastError.submitButtonText"
        }),
        appearance: "primary",
        onClick: closePopupWithRefresh
      }]
    });
  }
  if (error instanceof errors/* RescheduleTutorIsNotAvailableError */.QY) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      title: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.tutorIsNotAvailableError.title"
      }),
      subtitle: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.tutorIsNotAvailableError.subtitle"
      }),
      buttons: [{
        text: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.tutorIsNotAvailableError.declineButtonText"
        }),
        appearance: "secondary",
        onClick: closePopup
      }, {
        text: intl.formatMessage({
          id: "StudentRescheduleLessonPopup.tutorIsNotAvailableError.submitButtonText"
        }),
        appearance: "primary",
        onClick: toChoseRescheduleDateWithRemoval
      }]
    });
  }
  if (error instanceof errors/* SpeakingSessionRescheduleIsNotFree */.sK) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownError, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownError, {});
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/survey/survey.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const survey_module = ({"list":"survey-module__list--RtLnz"});
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/survey/survey.tsx













function Survey(_ref) {
  let {
    viewModel: {
      titleKey,
      variants,
      isLoading,
      state
    }
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [selectedVariant, setSelectedVariant] = (0,react.useState)(null);
  const {
    toRemoveConfirm,
    toRescheduleConfirm,
    toChooseRescheduleDate,
    setSelectedReason
  } = useRescheduleLessonPopupService();
  const clickNextButton = (0,react.useCallback)(() => {
    switch (state) {
      case "rescheduleReasonSurvey":
        {
          toRescheduleConfirm();
          return;
        }
      case "removeReasonSurvey":
      case "onlyRemoveReasonSurvey":
        {
          toRemoveConfirm();
          return;
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(state);
    }
  }, [state, toRemoveConfirm, toRescheduleConfirm]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupModalContent, {
    title: intl.formatMessage({
      id: titleKey
    }),
    showCloseButton: true,
    titleSize: modal/* TitleSize */.Jj.Small,
    buttonsBlockStretch: false,
    size: modal/* ModalSize */.Cg.Big,
    buttons: [{
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.survey.back"
      }),
      appearance: "secondary",
      disabled: isLoading,
      onClick: toChooseRescheduleDate
    }, {
      text: intl.formatMessage({
        id: "StudentRescheduleLessonPopup.survey.next"
      }),
      appearance: "primary",
      disabled: isLoading || selectedVariant === null,
      onClick: clickNextButton
    }],
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: survey_module.list,
      "data-testid": "reschedule-lesson-survey",
      children: variants.map((variant, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
          size: "small",
          checked: selectedVariant === index,
          onChange: () => {
            setSelectedVariant(index);
            const selectedReason = state === "onlyRemoveReasonSurvey" ? `Only remove: ${variant}` : variant;
            setSelectedReason(selectedReason);
          },
          children: variant
        })
      }, variant))
    })
  });
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/steps/survey/index.ts



;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/content.tsx











function Content() {
  const {
    viewModel
  } = usePresenter();
  switch (viewModel.state) {
    case "init":
    case "chooseRescheduleDate":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(ChooseRescheduleDate, {
          viewModel
        });
      }
    case "removeConfirm":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(RemoveLessonConfirm, {
          viewModel
        });
      }
    case "onlyRemove":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(OnlyRemove, {
          viewModel
        });
      }
    case "rescheduleConfirm":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleConfirm, {
          viewModel
        });
      }
    case "error":
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopupError, {
          viewModel
        });
      }
    case "removeReasonSurvey":
    case "rescheduleReasonSurvey":
    case "onlyRemoveReasonSurvey":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(Survey, {
        viewModel
      });
    default:
      throw new Error("error");
  }
}
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/components/content/index.ts



;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/reschedule-lesson-popup.tsx










const RescheduleLessonPopup = () => {
  const {
    init,
    closePopup
  } = useRescheduleLessonPopupService();
  (0,use_did_mount/* useDidMount */.H)(() => {
    void init();
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* TinyModal */.WR, {
    isVisible: true,
    onClose: closePopup,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
      onError: logger/* Logger */.Yd.captureException,
      onErrorContent: UnknownError,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Content, {})
    })
  });
};
;// CONCATENATED MODULE: ./src/widgets/reschedule-lesson-popup/index.ts




;// CONCATENATED MODULE: ./src/pages/resources/widgets/resources-balance/resources-balance.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const resources_balance_module = ({"text-container":"resources-balance-module__text-container--V1mtK","textContainer":"resources-balance-module__text-container--V1mtK","text-container-error":"resources-balance-module__text-container-error--O7OyT","textContainerError":"resources-balance-module__text-container-error--O7OyT","cards-container":"resources-balance-module__cards-container--C6NKu","cardsContainer":"resources-balance-module__cards-container--C6NKu","card":"resources-balance-module__card--PNrZq","link":"resources-balance-module__link--q0euu","card-link":"resources-balance-module__card-link--Wm1Uv","cardLink":"resources-balance-module__card-link--Wm1Uv","button-link":"resources-balance-module__button-link--KFJg0","buttonLink":"resources-balance-module__button-link--KFJg0","icon":"resources-balance-module__icon--ZzPb0","amount":"resources-balance-module__amount--cHyTe","type":"resources-balance-module__type--AhSTT"});
;// CONCATENATED MODULE: ./src/pages/resources/widgets/resources-balance/resources-link.tsx











function ResourcesLink(_ref) {
  let {
    variant = "button"
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  if (variant === "card") {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router_dom/* Link */.rU, {
      className: classnames_default()(resources_balance_module.card, resources_balance_module.link, resources_balance_module.cardLink),
      to: studentRoutePaths/* studentRoutePaths */.dR.RESOURCES,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: resources_balance_module.icon,
        name: "new-arrow-right",
        size: isMobile ? "medium" : "large"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()({
          [typography_module/* default */.Z.caption]: isMobile,
          [typography_module/* default */.Z.body2]: !isMobile
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "resources.balance.linkText"
        })
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
    className: classnames_default()(resources_balance_module.link, resources_balance_module.buttonLink, typography_module/* default */.Z.captionAccent),
    to: studentRoutePaths/* studentRoutePaths */.dR.RESOURCES,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "resources.balance.linkText"
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/widgets/resources-balance/error-content.tsx









function ErrorContent() {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(resources_balance_module.textContainer, resources_balance_module.textContainerError),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        className: classnames_default()({
          [typography_module/* default */.Z.body2Accent]: isMobile,
          [typography_module/* default */.Z.headline4Accent]: !isMobile
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "resources.balance.error.heading"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()({
          [typography_module/* default */.Z.caption]: isMobile,
          [typography_module/* default */.Z.body2]: !isMobile
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "resources.error.text"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesLink, {})]
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/widgets/resources-balance/resources-balance.tsx













function ResourcesBalance() {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    resourceTypes,
    hasMultipleTypes
  } = useResourceTypes();
  const {
    data
  } = (0,use_resources_balance/* useResourcesBalance */.U)();
  if (!data) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: resources_balance_module.textContainer,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()({
            [typography_module/* default */.Z.body2Accent]: isMobile,
            [typography_module/* default */.Z.headline4Accent]: !isMobile
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "resources.balance.heading"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()({
            [typography_module/* default */.Z.caption]: isMobile,
            [typography_module/* default */.Z.body2]: !isMobile
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "resources.balance.subheading"
          })
        })]
      }), hasMultipleTypes && !isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesLink, {})]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: resources_balance_module.cardsContainer,
      children: [resourceTypes.map(type => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: resources_balance_module.card,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()({
            [typography_module/* default */.Z.body2Accent]: isMobile,
            [typography_module/* default */.Z.headline4Accent]: !isMobile
          }, resources_balance_module.amount),
          "data-testid": `${type}_count`,
          children: data[type]?.remaining ?? 0
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()({
            [typography_module/* default */.Z.caption]: isMobile,
            [typography_module/* default */.Z.body2]: !isMobile
          }, resources_balance_module.type),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: `resources.types.${type}`
          })
        })]
      }, type)), !hasMultipleTypes && /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesLink, {
        variant: "card"
      })]
    }), hasMultipleTypes && isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesLink, {})]
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/widgets/resources-balance/resources-balance-wrapper.tsx







function ResourcesBalanceWrapper() {
  return /* @__PURE__ */(0,jsx_runtime.jsx)(error_boundary/* ErrorBoundary */.S, {
    onError: logger/* Logger */.Yd.captureException,
    onErrorContent: () => /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorContent, {}),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesBalance, {})
  });
}
;// CONCATENATED MODULE: ./src/pages/resources/widgets/resources-balance/index.ts



;// CONCATENATED MODULE: ./src/pages/resources/widgets/index.ts



// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/pages/purchase/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/get-student-partial-payment-info/mapper.ts



const mapPaymentPlan = rawPaymentPlan => {
  if (rawPaymentPlan === "resource_based") {
    return PaymentPlan.ResourceBased;
  }
  return PaymentPlan.Monthly;
};
const mapStudentPartialPaymentInfoResponse = response => {
  if (!("purchase_id" in response)) {
    return null;
  }
  return {
    purchaseId: response.purchase_id,
    isActive: response.is_active,
    isFinished: response.is_finished,
    cardNumber: response.card_number,
    paymentPlan: mapPaymentPlan(response.payment_plan)
  };
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/get-student-partial-payment-info/model.ts



const RawPaymentPlan = es6.union([es6.literal("monthly"), es6.literal("resource_based")]);
const RawStudentPartialPaymentInfoResponse = es6.union([es6.type({
  purchase_id: es6.string,
  is_finished: es6.boolean,
  is_active: es6.boolean,
  payment_plan: RawPaymentPlan,
  card_number: es6.string
}), es6.type({})]);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/get-student-partial-payment-info/get-student-partial-payment-info.api.ts










const getStudentPartialPaymentInfo = (0,un_either/* unEither */.K)(businessProductId => {
  const searchParams = new URLSearchParams();
  searchParams.set("business_product_id", businessProductId);
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/partial-payments-info?${searchParams}`, {
    responseType: RawStudentPartialPaymentInfoResponse,
    resultMapper: mapStudentPartialPaymentInfoResponse
  });
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/get-student-partial-payment-info/index.ts




;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/model.ts





const [$studentPartialPaymentInfo, _, resetStudentPartialPaymentInfo] = (0,makeStore/* makeStore */.n)(null);
const getStudentPartialPaymentInfoFx = (0,effector/* createEffect */.GW)(getStudentPartialPaymentInfo);
(0,effector/* sample */.UP)({
  source: getStudentPartialPaymentInfoFx.doneData,
  filter: result => result !== null,
  target: $studentPartialPaymentInfo
});
;// CONCATENATED MODULE: ./src/api/student/change-tutor/change-tutor.mappers.ts


const mapTutorChangeEvent = _ref => {
  let {
    businessProductId,
    isReplaced,
    studentId,
    tutorId
  } = _ref;
  return {
    type: "student_requested_tutor_change",
    payload: {
      student_id: studentId,
      tutor_id: tutorId,
      is_replaced: isReplaced,
      business_product_id: businessProductId
    }
  };
};
const mapTutorReselectByCurator = _ref2 => {
  let {
    reason,
    subReasons,
    comment,
    businessProductId
  } = _ref2;
  return {
    reason,
    sub_reasons: subReasons,
    comment,
    business_product_id: businessProductId
  };
};
const mapTutorReselectByStudent = data => ({
  ...mapTutorReselectByCurator(data),
  is_free_session_cancel: data.isFreeSessionCancel
});
;// CONCATENATED MODULE: ./src/api/student/change-tutor/change-tutor.model.ts


var RequestTutorReselectByStudentError = /* @__PURE__ */(RequestTutorReselectByStudentError2 => {
  RequestTutorReselectByStudentError2["sessionCancelNotFree"] = "sessionCancelNotFree";
  return RequestTutorReselectByStudentError2;
})(RequestTutorReselectByStudentError || {});
;// CONCATENATED MODULE: ./src/api/student/change-tutor/change-tutor.raw-model.ts



const RawTutorChangePossibilityResponse = es6.type({
  data: es6.type({
    student_can_change_tutor: es6.boolean
  })
});
;// CONCATENATED MODULE: ./src/api/student/change-tutor/change-tutor.api.ts












const requestTutorChange = event => (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
  method: "POST",
  body: mapTutorChangeEvent(event),
  responseType: es6.type({})
});
const requestTutorReselectByCurator = (0,un_either/* unEither */.K)(data => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/tutor/reselect-by-curator`, {
  method: "POST",
  body: mapTutorReselectByCurator(data),
  responseType: es6["void"]
}));
const requestTutorReselectByStudent = (0,un_either/* unEither */.K)(data => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/tutor/reselect-by-student`, {
  method: "POST",
  body: mapTutorReselectByStudent(data),
  /** true - было более 4х часов, false - было менее 4х часов  */
  responseType: student_attributes/* RawStudentAttributes */.jy,
  errorMapper(rawErrorContent) {
    if (rawErrorContent.code === "session_cancel_not_free") {
      return {
        code: RequestTutorReselectByStudentError.sessionCancelNotFree,
        message: rawErrorContent.message
      };
    }
    return api_model/* unexpectedError */.g;
  }
}));
const requestTutorChangePossibility = (0,un_either/* unEither */.K)(() => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/tutor_change_possibility`, {
  responseType: RawTutorChangePossibilityResponse,
  resultMapper(_ref) {
    let {
      data
    } = _ref;
    return {
      studentCanChangeTutor: data.student_can_change_tutor
    };
  }
}));
// EXTERNAL MODULE: ../../node_modules/date-fns/isWithinInterval.mjs
var isWithinInterval = __webpack_require__(97923);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/change-tutor-confirm-popup/utils.ts






const isLessonSoon = weekSchedule => {
  const now = /* @__PURE__ */new Date();
  return weekSchedule.some(lessonDate => (0,isWithinInterval/* isWithinInterval */._)(lessonDate, {
    start: now,
    end: (0,addHours/* addHours */.T)(now, 4)
  }));
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/change-tutor-confirm-popup/change-tutor-confirm-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const change_tutor_confirm_popup_module = ({"balance-cut-message":"change-tutor-confirm-popup-module__balance-cut-message--jLWdW","balanceCutMessage":"change-tutor-confirm-popup-module__balance-cut-message--jLWdW"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/change-tutor-confirm-popup/change-tutor-confirm-popup.tsx


















const ChangeTutorConfirmPopup = _ref => {
  let {
    reasons,
    comment,
    nearestSpeakingSessions,
    onClose,
    onPrevious
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isFreeSessionCancel, setIsFreeSessionCancel] = (0,react.useState)(!isLessonSoon(nearestSpeakingSessions));
  const [isConfirmButtonLoading, setIsConfirmButtonLoading] = (0,react.useState)(false);
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const handleConfirm = (0,react.useCallback)(async () => {
    if (!reasons.length || !businessProductId) {
      return;
    }
    setIsConfirmButtonLoading(true);
    try {
      await requestTutorReselectByStudent({
        reason: "student",
        subReasons: reasons,
        comment,
        isFreeSessionCancel,
        businessProductId
      });
      (0,reload_page/* reloadPage */.s)();
    } catch (error) {
      if (typeof error === "object" && error !== null && "code" in error && error.code === RequestTutorReselectByStudentError.sessionCancelNotFree) {
        setIsFreeSessionCancel(false);
      } else {
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "unknownError.title"
        }));
        logger/* Logger */.Yd.captureException(error, {
          component: "ChangeTutorConfirmPopup",
          method: "handleConfirm"
        });
      }
    } finally {
      setIsConfirmButtonLoading(false);
    }
  }, [businessProductId, comment, intl, isFreeSessionCancel, reasons]);
  const buttons = (0,react.useMemo)(() => [{
    text: intl.formatMessage({
      id: "changeTutor.confirmPopup.previous"
    }),
    appearance: "secondary",
    onClick: onPrevious
  }, {
    text: intl.formatMessage({
      id: "changeTutor.confirmPopup.confirm"
    }),
    appearance: "primary",
    onClick: handleConfirm,
    loading: {
      isLoading: isConfirmButtonLoading,
      loadingLabel: intl.formatMessage({
        id: "translatableText.loading"
      })
    }
  }], [handleConfirm, intl, isConfirmButtonLoading, onPrevious]);
  const text = (0,react.useMemo)(() => isFreeSessionCancel ? /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
    id: "changeTutor.confirmPopup.text"
  }) : /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: change_tutor_confirm_popup_module.balanceCutMessage,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.body2Accent,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "changeTutor.confirmPopup.balanceCutMessageTitle"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "changeTutor.confirmPopup.balanceCutMessage"
    })]
  }), [isFreeSessionCancel]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    title: intl.formatMessage({
      id: "changeTutor.confirmPopup.title"
    }),
    isVisible: true,
    onClose,
    showCloseButton: true,
    buttons,
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    buttonsBlockStretch: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
      type: model_model/* AlertType */.N.INFO,
      withoutIcon: true,
      text
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/change-tutor-confirm-popup/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/change-tutor-method-popup/change-tutor-method-popup.tsx













const ChangeTutorMethodPopup = _ref => {
  let {
    reasons,
    comment,
    onClose,
    onNext,
    onPrevious
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const [selectedMethod, setSelectedMethod] = (0,react.useState)("self");
  const [isNextButtonLoading, setIsNextButtonLoading] = (0,react.useState)(false);
  const handleNextButtonClick = (0,react.useCallback)(async () => {
    if (!reasons.length || !businessProductId) {
      return;
    }
    if (selectedMethod === "curator") {
      setIsNextButtonLoading(true);
      try {
        await requestTutorReselectByCurator({
          reason: "student",
          subReasons: reasons,
          comment,
          businessProductId
        });
      } catch (error) {
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "unknownError.title"
        }));
        logger/* Logger */.Yd.captureException(error, {
          component: "ChangeTutorMethodPopup",
          method: "handleNextButtonClick",
          businessProductId
        });
      } finally {
        setIsNextButtonLoading(false);
      }
    }
    onNext(selectedMethod);
  }, [businessProductId, comment, intl, onNext, reasons, selectedMethod]);
  const buttons = (0,react.useMemo)(() => [{
    text: intl.formatMessage({
      id: "changeTutor.methodPopup.previous"
    }),
    appearance: "secondary",
    onClick: onPrevious
  }, {
    text: intl.formatMessage({
      id: "changeTutor.methodPopup.next"
    }),
    appearance: "primary",
    onClick: handleNextButtonClick,
    loading: {
      isLoading: isNextButtonLoading,
      loadingLabel: intl.formatMessage({
        id: "translatableText.loading"
      })
    }
  }], [handleNextButtonClick, intl, isNextButtonLoading, onPrevious]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(modal/* Modal */.u_, {
    title: intl.formatMessage({
      id: "changeTutor.methodPopup.title"
    }),
    isVisible: true,
    onClose,
    showCloseButton: true,
    buttons,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(radio_button/* RadioButton */.E, {
      checked: selectedMethod === "self",
      position: "top",
      onChange: () => setSelectedMethod("self"),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2Accent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "changeTutor.methodPopup.optionAutoonboarding"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.body2,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "changeTutor.methodPopup.optionAutoonboardingDescription"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)(radio_button/* RadioButton */.E, {
      checked: selectedMethod === "curator",
      position: "top",
      onChange: () => setSelectedMethod("curator"),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2Accent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "changeTutor.methodPopup.optionCurator"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.body2,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "changeTutor.methodPopup.optionCuratorDescription"
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/change-tutor-method-popup/index.ts



// EXTERNAL MODULE: ../ui-kit/src/text-area/component.tsx + 2 modules
var component = __webpack_require__(22292);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/select-reason-modal/select-reason-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_reason_modal_module = ({"reasons":"select-reason-modal-module__reasons--q681g","text-area":"select-reason-modal-module__text-area--t8Tdm","textArea":"select-reason-modal-module__text-area--t8Tdm","hint":"select-reason-modal-module__hint--i9ari"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/select-reason-modal/select-reason-modal.tsx


















const SelectReasonModal = _ref => {
  let {
    reasons,
    comment,
    onChangeReason,
    onCommentChange,
    onClose,
    onNext
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const [modalContent, setModalContent] = (0,react.useState)();
  const [isNextButtonLoading, setIsNextButtonLoading] = (0,react.useState)(false);
  const [isValidForm, setIsValidForm] = (0,react.useState)(true);
  (0,react.useEffect)(() => {
    void (0,bunker_api/* getAutoTutorChangePopupContent */.x_)().then(response => {
      setModalContent(response);
    });
  }, []);
  const handleReasonChange = (id, value) => {
    setIsValidForm(true);
    onChangeReason(id, value);
  };
  const handleCommentChange = event => {
    onCommentChange(event.target.value);
  };
  const handleNextButtonClick = async () => {
    if (!reasons.length) {
      setIsValidForm(false);
      return;
    }
    if (!businessProductId) {
      return;
    }
    try {
      setIsNextButtonLoading(true);
      const {
        studentCanChangeTutor
      } = await requestTutorChangePossibility();
      if (!studentCanChangeTutor) {
        await requestTutorReselectByCurator({
          reason: "student",
          subReasons: reasons,
          comment,
          businessProductId
        });
      }
      onNext(studentCanChangeTutor);
    } catch (error) {
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        id: "unknownError.title"
      }));
      logger/* Logger */.Yd.captureException(error, {
        component: "SelectReasonModal",
        method: "handleNextButtonClick",
        businessProductId
      });
    } finally {
      setIsNextButtonLoading(false);
    }
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    title: modalContent ? modalContent.title : "",
    onClose,
    isVisible: true,
    size: modal/* ModalSize */.Cg.Big,
    showCloseButton: true,
    buttons: modalContent ? [{
      text: intl.formatMessage({
        id: "beginnerDashboardPage.autoTutorChangeModal.ChooseReasonStep.buttonText"
      }),
      appearance: "primary",
      onClick: handleNextButtonClick,
      loading: {
        isLoading: isNextButtonLoading,
        loadingLabel: intl.formatMessage({
          id: "translatableText.loading"
        })
      }
    }] : [],
    children: !modalContent ? /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {
      marginTop: 100
    }) : /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: select_reason_modal_module.reasons,
        role: "group",
        children: modalContent.reasons.map(_ref2 => {
          let {
            id,
            text
          } = _ref2;
          return /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
            size: "small",
            checked: reasons.includes(id),
            onChange: value => handleReasonChange(id, value),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              children: text
            })
          }, id);
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: select_reason_modal_module.textArea,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(component/* TextArea */.K, {
          value: comment || "",
          onChange: handleCommentChange,
          placeholder: modalContent.comment
        })
      }), !isValidForm && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: select_reason_modal_module.hint,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "beginnerDashboardPage.autoTutorChangeModal.ChooseReasonStep.hint"
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/select-reason-modal/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/index.ts





;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/components/curator-flow-confirm-modal/curator-flow-confirm-modal.tsx







const CuratorFlowConfirmModal = _ref => {
  let {
    onClose
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const buttons = (0,react.useMemo)(() => [{
    text: intl.formatMessage({
      id: "beginnerDashboardPage.autoTutorChange.CuratorFlowConfirmStep.buttonText"
    }),
    appearance: "primary",
    onClick: onClose
  }], [intl, onClose]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    title: intl.formatMessage({
      id: "beginnerDashboardPage.autoTutorChange.CuratorFlowConfirmStep.title"
    }),
    isVisible: true,
    onClose,
    buttons,
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    buttonsBlockStretch: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.body2,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "beginnerDashboardPage.autoTutorChange.CuratorFlowConfirmStep.description",
        values: {
          br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
        }
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/types.ts


var TutorChangeStep = /* @__PURE__ */(TutorChangeStep2 => {
  TutorChangeStep2[TutorChangeStep2["SelectReason"] = 0] = "SelectReason";
  TutorChangeStep2[TutorChangeStep2["SelectTutorChangeMethod"] = 1] = "SelectTutorChangeMethod";
  TutorChangeStep2[TutorChangeStep2["CuratorFlowConfirm"] = 2] = "CuratorFlowConfirm";
  TutorChangeStep2[TutorChangeStep2["AutoFlowConfirm"] = 3] = "AutoFlowConfirm";
  return TutorChangeStep2;
})(TutorChangeStep || {});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/auto-tutor-change/auto-tutor-change.tsx











const AutoTutorChange = _ref => {
  let {
    onClose,
    nearestSpeakingSessions
  } = _ref;
  const [currentStep, setCurrentStep] = (0,react.useState)(TutorChangeStep.SelectReason);
  const [reasons, setReasons] = (0,react.useState)([]);
  const [comment, setComment] = (0,react.useState)();
  const handleClose = () => {
    setCurrentStep(TutorChangeStep.SelectReason);
    setReasons([]);
    setComment(void 0);
    onClose();
  };
  const handleReasonsChange = (id, value) => {
    setReasons(prevReasons => {
      if (value) {
        return prevReasons.includes(id) ? prevReasons : [...prevReasons, id];
      }
      return prevReasons.filter(reasonId => reasonId !== id);
    });
  };
  let component;
  switch (currentStep) {
    case TutorChangeStep.SelectReason:
      component = /* @__PURE__ */(0,jsx_runtime.jsx)(SelectReasonModal, {
        reasons,
        comment,
        onChangeReason: handleReasonsChange,
        onCommentChange: setComment,
        onClose: handleClose,
        onNext: autoChangeAvailable => setCurrentStep(autoChangeAvailable ? TutorChangeStep.SelectTutorChangeMethod : TutorChangeStep.CuratorFlowConfirm)
      });
      break;
    case TutorChangeStep.SelectTutorChangeMethod:
      component = /* @__PURE__ */(0,jsx_runtime.jsx)(ChangeTutorMethodPopup, {
        reasons,
        comment,
        onClose: handleClose,
        onNext: tutorChangeMethod => setCurrentStep(tutorChangeMethod === "self" ? TutorChangeStep.AutoFlowConfirm : TutorChangeStep.CuratorFlowConfirm),
        onPrevious: () => setCurrentStep(TutorChangeStep.SelectReason)
      });
      break;
    case TutorChangeStep.AutoFlowConfirm:
      component = /* @__PURE__ */(0,jsx_runtime.jsx)(ChangeTutorConfirmPopup, {
        reasons,
        comment,
        nearestSpeakingSessions,
        onClose: handleClose,
        onPrevious: () => setCurrentStep(TutorChangeStep.SelectTutorChangeMethod)
      });
      break;
    case TutorChangeStep.CuratorFlowConfirm:
      component = /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorFlowConfirmModal, {
        onClose: handleClose
      });
      break;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(currentStep);
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: component
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/post-autopay-event.ts







const postAutopayEvent = async (purchaseId, businessProductId) => {
  const result = await (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
    method: "POST",
    body: {
      type: "zero_resources_balance_autopay",
      payload: {
        purchase_id: purchaseId,
        business_product_id: businessProductId,
        resource_type: "speaking_session"
      }
    },
    responseType: es6.type({})
  });
  if ((0,es6_Either/* isLeft */.nM)(result)) {
    throw new Error();
  }
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/switch-payment-to-resource-based/switch-payment-to-resource-based.api.ts






const switchPaymentToResourceBased = (0,un_either/* unEither */.K)(purchaseId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/partial-payments/switch-to-resource-based`, {
  method: "POST",
  body: {
    purchase_id: purchaseId
  },
  responseType: es6.voidType
}));
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/switch-payment-to-resource-based/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/create-purchase/mapper.ts




const mapPaymentStrategy = rawPaymentStrategy => {
  switch (rawPaymentStrategy) {
    case "full_payment":
      return student_model/* PaymentStrategy */.Xu.FullPayment;
    case "partial_payment":
      return student_model/* PaymentStrategy */.Xu.PartialPayment;
    case "subscription":
      return student_model/* PaymentStrategy */.Xu.Subscription;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(rawPaymentStrategy);
  }
};
const mapCreatePurchaseResponse = response => ({
  purchaseId: response.purchase_id,
  amount: response.amount,
  purchaseUrl: response.purchase_url,
  paymentStrategy: mapPaymentStrategy(response.payment_strategy),
  purchaseStatus: response.purchase_status
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/create-purchase/model.ts



const RawPaymentStrategy = es6.union([es6.literal("full_payment"), es6.literal("partial_payment"), es6.literal("subscription")]);
const RawCreatePurchaseResponse = es6.type({
  purchase_id: es6.string,
  amount: es6.string,
  purchase_url: es6.string,
  payment_strategy: RawPaymentStrategy,
  purchase_status: es6.string
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/create-purchase/create-purchase.ts







const createPurchasePsp = (0,un_either/* unEither */.K)(purchaseId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/partial-payments/create-purchase-psp`, {
  method: "POST",
  body: {
    purchase_id: purchaseId
  },
  responseType: RawCreatePurchaseResponse,
  resultMapper: mapCreatePurchaseResponse
}));
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/autopay-choose-card-modal/payment-modal/constants.ts


const LOADING_PHASE_TRANSLATION_DURATION = 2e3;
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/autopay-choose-card-modal/payment-modal/payment-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const payment_modal_payment_modal_module = ({"frame-wrapper":"payment-modal-module__frame-wrapper--fSSYm","frameWrapper":"payment-modal-module__frame-wrapper--fSSYm","frame-wrapper-old":"payment-modal-module__frame-wrapper-old--zh_HV","frameWrapperOld":"payment-modal-module__frame-wrapper-old--zh_HV","loader-wrapper":"payment-modal-module__loader-wrapper--xy_Xw","loaderWrapper":"payment-modal-module__loader-wrapper--xy_Xw","loader":"payment-modal-module__loader--FX4X0","hidden":"payment-modal-module__hidden--PSZXn","frame":"payment-modal-module__frame--aJFPD"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/autopay-choose-card-modal/payment-modal/payment-modal.tsx




















const payment_modal_PaymentModal = _ref => {
  let {
    isOpen,
    purchaseId,
    onClose,
    onSuccess,
    onFail
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [purchaseUrl, setPurchaseUrl] = (0,react.useState)();
  const {
    newPurchasePsp
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const iframeContainerRef = (0,react.useRef)(null);
  const [isFormReady, setIsFormReady] = (0,react.useState)(false);
  const {
    updateStatus,
    data
  } = usePurchaseStatusQuery({
    purchaseId
  });
  const [loadingPhaseTranslationId, setLoadingPhaseTranslationId] = (0,react.useState)(1);
  const [isPaymentProcessing, setIsPaymentProcessing] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (!purchaseId) {
      return;
    }
    createPurchasePsp(purchaseId).then(_ref2 => {
      let {
        purchaseUrl: purchaseUrl2
      } = _ref2;
      setPurchaseUrl(`${purchaseUrl2}${isMobile ? "&template_tag=mobile/form" : ""}`);
    }).catch(() => {
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        id: "purchasePage.paymentModal.error"
      }));
      onClose();
    });
  }, [intl, isMobile, newPurchasePsp, onClose, purchaseId]);
  (0,react.useEffect)(() => {
    if (isPaymentProcessing && data?.status) {
      if (isStatusPositive(data.status)) {
        setIsPaymentProcessing(false);
        onSuccess();
        onClose();
      } else if (isStatusNegative(data.status)) {
        setIsPaymentProcessing(false);
        onFail();
        onClose();
      }
    }
  }, [data?.status, isPaymentProcessing, onClose, onFail, onSuccess]);
  (0,react.useEffect)(() => {
    async function getPaymentFrame() {
      if (!purchaseUrl || !purchaseId) {
        return;
      }
      const sdk = dist_es/* default */.ZP.create({
        apiHost: constants/* IS_PROD */.XK ? void 0 : "https://trust-test.yandex.ru"
      });
      const paymentFrame2 = await sdk.paymentForm({
        url: purchaseUrl
      });
      try {
        await sdk.bindCard();
      } catch (error) {}
      paymentFrame2.on("form-ready", () => {
        setIsFormReady(true);
      });
      let isFormSubmit = false;
      paymentFrame2.on("form-submit", async () => {
        if (!isFormSubmit) {
          isFormSubmit = true;
          await startPurchase(purchaseId);
        }
      });
      paymentFrame2.on("success", () => {
        setIsPaymentProcessing(true);
        updateStatus();
      });
      paymentFrame2.on("error", () => {
        onClose();
        updateStatus();
      });
      if (iframeContainerRef.current) {
        paymentFrame2.mount(iframeContainerRef.current, {
          className: payment_modal_payment_modal_module.frame,
          title: intl.formatMessage({
            id: "purchasePage.frameTitle"
          })
        });
      }
      return paymentFrame2;
    }
    let paymentFrame;
    void getPaymentFrame().then(result => {
      paymentFrame = result;
    });
    if (isPaymentProcessing) {
      paymentFrame?.unmount();
    }
    return () => {
      paymentFrame?.unmount();
    };
  }, [intl, purchaseUrl, purchaseId, updateStatus, onClose, isPaymentProcessing]);
  (0,react.useEffect)(() => {
    const LAST_LOADING_PHASE = 3;
    if (isFormReady || loadingPhaseTranslationId === LAST_LOADING_PHASE) {
      return;
    }
    const timerId = setTimeout(() => {
      setLoadingPhaseTranslationId(currentTranslationId => currentTranslationId + 1);
    }, LOADING_PHASE_TRANSLATION_DURATION);
    return () => {
      clearTimeout(timerId);
    };
  }, [isFormReady, loadingPhaseTranslationId]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    overlay: "light",
    title: intl.formatMessage({
      id: "purchasePage.paymentModal.title"
    }),
    isVisible: isOpen,
    onClose,
    showCloseButton: true,
    children: isPaymentProcessing ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(payment_modal_payment_modal_module.frameWrapper, {
        [payment_modal_payment_modal_module.frameWrapperOld]: constants/* IS_PROD */.XK
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: payment_modal_payment_modal_module.loaderWrapper,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {
          className: payment_modal_payment_modal_module.loader
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          className: typography_module/* default */.Z.headline3,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "beginnerDashboardPage.bannerBlocks.autoPayment.checkPaymentLoader"
          })
        })]
      })
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(payment_modal_payment_modal_module.frameWrapper, {
        [payment_modal_payment_modal_module.frameWrapperOld]: constants/* IS_PROD */.XK
      }),
      children: isOpen && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()({
            [payment_modal_payment_modal_module.hidden]: !isFormReady || isPaymentProcessing
          }),
          ref: iframeContainerRef
        }), !isFormReady && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: payment_modal_payment_modal_module.loaderWrapper,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {
            className: payment_modal_payment_modal_module.loader
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
            className: typography_module/* default */.Z.headline3,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "purchasePage.paymentModal.loadingPhase" + loadingPhaseTranslationId
            })
          })]
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/autopay-choose-card-modal/autopay-choose-card-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const autopay_choose_card_modal_module = ({"buttonsBlock":"autopay-choose-card-modal-module__buttonsBlock--IEJrq"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/autopay-choose-card-modal/autopay-choose-card-modal.tsx























const AutopayChooseCardModal = _ref => {
  let {
    isVisible,
    onClose,
    onPostAutopayEvent
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const studentPartialPayment = (0,effector_react/* useStore */.oR)($studentPartialPaymentInfo);
  const {
    speakingSession
  } = (0,use_resources_zero_balance/* useResourcesBalanceRemaining */.My)();
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    isOpen: isPaymentModalOpen,
    handleOpen: openPaymentModal,
    handleClose: closePaymentModal
  } = (0,use_modal_toggle/* useModalToggle */.N)();
  const noSpeakingsLeft = speakingSession <= 0;
  const lowAmountOfSpeakingsLeft = speakingSession <= 3 && speakingSession >= 1;
  const resourceBasedPaymentPlan = studentPartialPayment?.paymentPlan === PaymentPlan.ResourceBased;
  const monthlyPaymentPlan = studentPartialPayment?.paymentPlan === PaymentPlan.Monthly;
  const monthlyPaymentPlanAndNoSpeakingsLeft = monthlyPaymentPlan && noSpeakingsLeft;
  const handleChooseCurrentCard = (0,react.useCallback)(async () => {
    if (!studentPartialPayment?.purchaseId || !businessProductId) {
      return;
    }
    if (monthlyPaymentPlan || resourceBasedPaymentPlan && lowAmountOfSpeakingsLeft) {
      try {
        await switchPaymentToResourceBased(studentPartialPayment.purchaseId);
        if (monthlyPaymentPlanAndNoSpeakingsLeft) {
          void postAutopayEvent(studentPartialPayment.purchaseId, businessProductId);
        }
        toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
          id: "beginnerDashboardPage.autopayBindCardModal.notification.switchPlan.success"
        }), {
          onClose: reload_page/* reloadPage */.s
        });
      } catch (error) {
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "beginnerDashboardPage.autopayBindCardModal.notification.switchPlan.error"
        }));
        logger/* Logger */.Yd.captureException(error, void 0, {
          type: "network",
          block: "AutopayChooseCardModal",
          method: "switchPaymentToResourceBased"
        });
      }
      onClose();
      return;
    }
    if (noSpeakingsLeft && businessProductId) {
      try {
        await postAutopayEvent(studentPartialPayment.purchaseId, businessProductId);
        onPostAutopayEvent();
      } catch (error) {
        logger/* Logger */.Yd.captureException(error, void 0, {
          type: "network",
          block: "AutopayChooseCardModal",
          method: "postAutopayEvent"
        });
      }
      onClose();
    }
  }, [businessProductId, intl, lowAmountOfSpeakingsLeft, monthlyPaymentPlan, monthlyPaymentPlanAndNoSpeakingsLeft, noSpeakingsLeft, onClose, onPostAutopayEvent, resourceBasedPaymentPlan, studentPartialPayment?.purchaseId]);
  const handleChooseNewCard = (0,react.useCallback)(async () => {
    if (monthlyPaymentPlanAndNoSpeakingsLeft) {
      await switchPaymentToResourceBased(studentPartialPayment.purchaseId);
    }
    openPaymentModal();
    onClose?.();
  }, [monthlyPaymentPlanAndNoSpeakingsLeft, onClose, openPaymentModal, studentPartialPayment?.purchaseId]);
  const handleSuccessfulPayment = () => {
    toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
      id: "beginnerDashboardPage.autopayBindCardModal.notification.bindCard.success"
    }), {
      onClose: reload_page/* reloadPage */.s
    });
  };
  const handleFailedPayment = () => {
    toast/* toastNotificationService */.B.showError(intl.formatMessage({
      id: "beginnerDashboardPage.autopayBindCardModal.notification.bindCard.error"
    }));
  };
  const modalButtons = (0,react.useMemo)(() => [{
    text: intl.formatMessage({
      id: "beginnerDashboardPage.autopayBindCardModal.useCurrentCardButton"
    }, {
      lastFourCardDigits: studentPartialPayment?.cardNumber
    }),
    appearance: "primary",
    onClick: handleChooseCurrentCard
  }, {
    text: intl.formatMessage({
      id: "beginnerDashboardPage.autopayBindCardModal.bindNewCardButton"
    }),
    appearance: "secondary",
    onClick: handleChooseNewCard
  }], [intl, studentPartialPayment?.cardNumber, handleChooseCurrentCard, handleChooseNewCard]);
  const isFailedPayment = !studentPartialPayment?.isActive && !studentPartialPayment?.isFinished && noSpeakingsLeft;
  if ((!isFailedPayment || monthlyPaymentPlan) && lowAmountOfSpeakingsLeft) {
    modalButtons.pop();
  } else if (!studentPartialPayment?.cardNumber) {
    modalButtons.shift();
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(modal/* TinyModal */.WR, {
      onClose,
      isVisible,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* ModalContent */.hz, {
        size: modal/* ModalSize */.Cg.Small,
        title: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "beginnerDashboardPage.autopayBindCardModal.title"
        }),
        subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "beginnerDashboardPage.autopayBindCardModal.text"
        }),
        contentPosition: modal/* ModalContentPosition */.s7.Center,
        showCloseButton: true,
        buttonsBlockStretch: true,
        buttons: isMobile ? modalButtons : [],
        children: !isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: autopay_choose_card_modal_module.buttonsBlock,
          children: modalButtons.map(_ref2 => {
            let {
              appearance,
              text,
              onClick
            } = _ref2;
            return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
              type: "button",
              appearance,
              onClick,
              children: text
            }, text);
          })
        })
      })
    }), isPaymentModalOpen && /* @__PURE__ */(0,jsx_runtime.jsx)(payment_modal_PaymentModal, {
      isOpen: isPaymentModalOpen,
      purchaseId: studentPartialPayment?.purchaseId,
      onClose: closePaymentModal,
      onSuccess: handleSuccessfulPayment,
      onFail: handleFailedPayment
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/banner-block/banner-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const banner_block_module = ({"container":"banner-block-module__container--vJUGI","first-block":"banner-block-module__first-block--SI4GM","firstBlock":"banner-block-module__first-block--SI4GM","text-block":"banner-block-module__text-block--NEr4p","textBlock":"banner-block-module__text-block--NEr4p","icon":"banner-block-module__icon--ad361","button":"banner-block-module__button--Xa6Tg"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/banner-block/banner-block.tsx









const BannerBlock = _ref => {
  let {
    iconName,
    title,
    subtitle,
    button,
    iconClassName
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: banner_block_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: banner_block_module.firstBlock,
      children: [iconName && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: iconName,
        size: isMobile ? "small" : "medium",
        className: classnames_default()(banner_block_module.icon, iconClassName)
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: banner_block_module.textBlock,
        children: [title && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: isMobile ? typography_module/* default */.Z.captionAccent : typography_module/* default */.Z.body2Accent,
          children: title
        }), subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: isMobile ? typography_module/* default */.Z.caption : typography_module/* default */.Z.body2,
          children: subtitle
        })]
      })]
    }), button && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: button.appearance || "secondary",
      size: "small",
      className: banner_block_module.button,
      onClick: button.onClick,
      children: button.text
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/banner-block/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/hooks/constants.ts


const CHECK_AUTOPAY_STATUS_POLLING_INTERVAL = 10 * 1e3;
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/hooks/use-partial-payment-info-query.ts





const usePartialPaymentInfoQuery = businessProductId => (0,useQuery/* useQuery */.a)({
  queryKey: ["partialPaymentInfoQuery"],
  queryFn: () => {
    if (!businessProductId) {
      return;
    }
    return getStudentPartialPaymentInfo(businessProductId);
  },
  enabled: Boolean(businessProductId),
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchInterval: CHECK_AUTOPAY_STATUS_POLLING_INTERVAL
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/hooks/use-resource-balance-query.ts





const useResourceBalanceQuery = businessProductId => (0,useQuery/* useQuery */.a)({
  queryKey: ["resourceBalanceQuery"],
  queryFn: () => {
    if (!businessProductId) {
      return;
    }
    return (0,api/* fetchResourcesBalance */.S)(businessProductId);
  },
  enabled: Boolean(businessProductId),
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchInterval: CHECK_AUTOPAY_STATUS_POLLING_INTERVAL
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/autopay-by-resource/autopay-in-progress-banner.tsx











const AutopayInProgressBanner = _ref => {
  let {
    isInProgress
  } = _ref;
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const intl = (0,useIntl/* default */.Z)();
  const {
    data: partialPaymentInfo
  } = usePartialPaymentInfoQuery(businessProductId);
  const {
    data: resourcesRemaining
  } = useResourceBalanceQuery(businessProductId);
  const [isFirstResponseData, setIsFirstResponseData] = (0,react.useState)(true);
  (0,react.useEffect)(() => {
    if (partialPaymentInfo?.isActive === void 0) {
      return;
    }
    if (isInProgress && isFirstResponseData) {
      setIsFirstResponseData(false);
      return;
    }
    if (!partialPaymentInfo?.isActive) {
      (0,reload_page/* reloadPage */.s)();
    }
  }, [isInProgress, partialPaymentInfo?.isActive]);
  (0,react.useEffect)(() => {
    if (resourcesRemaining?.speaking_session?.remaining === void 0) {
      return;
    }
    if (resourcesRemaining?.speaking_session?.remaining > 0) {
      (0,reload_page/* reloadPage */.s)();
    }
  }, [resourcesRemaining?.speaking_session?.remaining]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(BannerBlock, {
    iconName: "clock",
    title: intl.formatMessage({
      id: "beginnerDashboardPage.bannerBlocks.autoPayment.paymentInProgress.title"
    }),
    subtitle: intl.formatMessage({
      id: "beginnerDashboardPage.bannerBlocks.autoPayment.paymentInProgress.subtitle"
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/autopay-by-resource/autopay-by-resource.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const autopay_by_resource_module = ({"wrapper":"autopay-by-resource-module__wrapper--uPWWJ","icon-magic":"autopay-by-resource-module__icon-magic--i2KR0","iconMagic":"autopay-by-resource-module__icon-magic--i2KR0","icon-bell":"autopay-by-resource-module__icon-bell--CMGUv","iconBell":"autopay-by-resource-module__icon-bell--CMGUv"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/autopay-by-resource/autopay-by-resource.tsx













const AutopayByResource = _ref => {
  let {
    isAutopayInProgress,
    onButtonClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const studentPartialPayment = (0,effector_react/* useStore */.oR)($studentPartialPaymentInfo);
  const {
    resources,
    autopayByResource
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    speakingSession
  } = (0,use_resources_zero_balance/* useResourcesBalanceRemaining */.My)();
  const resourceBasedPaymentPlan = studentPartialPayment?.paymentPlan === PaymentPlan.ResourceBased;
  const monthlyPaymentPlan = studentPartialPayment?.paymentPlan === PaymentPlan.Monthly;
  const isActiveAndResourceBasedPartialPayment = studentPartialPayment?.isActive && resourceBasedPaymentPlan;
  const notActiveAndResourceBasedPartialPayment = !studentPartialPayment?.isActive && resourceBasedPaymentPlan;
  const noSpeakingsLeft = speakingSession <= 0;
  const lowAmountOfSpeakingsLeft = speakingSession <= 3 && speakingSession >= 1;
  const dontHaveLinkedCard = !!studentPartialPayment?.cardNumber;
  const isPaySoonBanner = isActiveAndResourceBasedPartialPayment && lowAmountOfSpeakingsLeft;
  const isAutopayInProgressBanner = isActiveAndResourceBasedPartialPayment && noSpeakingsLeft || isAutopayInProgress;
  const isTurnOnAutopayBanner = !isAutopayInProgress && (notActiveAndResourceBasedPartialPayment && lowAmountOfSpeakingsLeft && dontHaveLinkedCard || notActiveAndResourceBasedPartialPayment && noSpeakingsLeft || monthlyPaymentPlan && speakingSession <= 3);
  const paySoonBanner = (0,react.useMemo)(() => isPaySoonBanner && /* @__PURE__ */(0,jsx_runtime.jsx)(BannerBlock, {
    iconName: "notification-bell",
    title: intl.formatMessage({
      id: "beginnerDashboardPage.bannerBlocks.autoPayment.paySoon.title"
    }),
    subtitle: intl.formatMessage({
      id: "beginnerDashboardPage.bannerBlocks.autoPayment.paySoon.subtitle"
    }),
    iconClassName: autopay_by_resource_module.iconBell
  }), [intl, isPaySoonBanner]);
  const turnOnAutopayBanner = (0,react.useMemo)(() => isTurnOnAutopayBanner && /* @__PURE__ */(0,jsx_runtime.jsx)(BannerBlock, {
    iconName: "magic",
    title: intl.formatMessage({
      id: "beginnerDashboardPage.bannerBlocks.autoPayment.turnOn.title"
    }),
    subtitle: intl.formatMessage({
      id: "beginnerDashboardPage.bannerBlocks.autoPayment.turnOn.subtitle"
    }),
    button: {
      text: intl.formatMessage({
        id: "beginnerDashboardPage.bannerBlocks.autoPayment.turnOn.buttonText"
      }),
      onClick: onButtonClick
    },
    iconClassName: autopay_by_resource_module.iconMagic
  }), [intl, isTurnOnAutopayBanner, onButtonClick]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: autopayByResource && resources.enabled && !studentPartialPayment?.isFinished && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: autopay_by_resource_module.wrapper,
      children: [paySoonBanner, turnOnAutopayBanner, isAutopayInProgressBanner && /* @__PURE__ */(0,jsx_runtime.jsx)(AutopayInProgressBanner, {
        isInProgress: isAutopayInProgress
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/autopay-by-resource/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/bell-banner-announcement/bell-banner-announcement.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const bell_banner_announcement_module = ({"icon":"bell-banner-announcement-module__icon--DjwdF"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/bell-banner-announcement/bell-banner-announcement.tsx







const BellBannerAnnouncement = () => {
  const {
    bannerMarkup
  } = useAnnouncement();
  if (!bannerMarkup) {
    return null;
  }
  const {
    title,
    description,
    buttons
  } = bannerMarkup;
  const {
    appearance,
    label,
    action
  } = buttons[0];
  const handleBannerButtonClick = () => {
    if (action.type === AnnouncementButtonActionType.ExternalLink && action?.href) {
      window.open(action.href, "_blank");
    }
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(BannerBlock, {
    button: {
      text: label,
      appearance,
      onClick: handleBannerButtonClick
    },
    title,
    subtitle: description,
    iconName: "lightning",
    iconClassName: bell_banner_announcement_module.icon
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/pending-lessons/pending-lessons.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const pending_lessons_module = ({"icon":"pending-lessons-module__icon--m4Csj"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/pending-lessons/pending-lessons.tsx










const PendingLessons = () => {
  const {
    pendingSessionsExist
  } = useScheduling();
  const intl = (0,useIntl/* default */.Z)();
  const navigate = (0,react_router/* useHistory */.k6)();
  const handleMoveToScheduleButtonClick = () => {
    navigate.push(studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE_LIST);
  };
  if (!pendingSessionsExist) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(BannerBlock, {
    button: {
      text: intl.formatMessage({
        id: "beginnerDashboard.pendingLessonsBanner.goToSchedulePageButton.title"
      }),
      onClick: handleMoveToScheduleButtonClick
    },
    title: intl.formatMessage({
      id: "beginnerDashboard.pendingLessonsBanner.title"
    }),
    iconName: "notification-bell",
    iconClassName: pending_lessons_module.icon
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/pending-lessons/index.ts



;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/banner-blocks.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const banner_blocks_module = ({"banner-blocks":"banner-blocks-module__banner-blocks--ZwueK","bannerBlocks":"banner-blocks-module__banner-blocks--ZwueK"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/banner-blocks/banner-blocks.tsx







const BannerBlocks = _ref => {
  let {
    onButtonClick,
    isAutopayInProgress
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: banner_blocks_module.bannerBlocks,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(BellBannerAnnouncement, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(AutopayByResource, {
      isAutopayInProgress,
      onButtonClick
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(PendingLessons, {})]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/bottom-sheet/bottom-sheet@light.component.tsx + 1 modules
var bottom_sheet_light_component = __webpack_require__(80814);
;// CONCATENATED MODULE: ../ui-kit/src/course-map/toggle-button/toggle-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggle_button_module = ({"toggle-button":"toggle-button-module__toggle-button--FuWR9","toggleButton":"toggle-button-module__toggle-button--FuWR9","toggle-button-icon":"toggle-button-module__toggle-button-icon--SBL2q","toggleButtonIcon":"toggle-button-module__toggle-button-icon--SBL2q"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/toggle-button/toggle-button.tsx







const ToggleButton = _ref => {
  let {
    onClick,
    toggled,
    className,
    textConstants
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(toggle_button_module.toggleButton, typography_module/* default */.Z.body2Accent, className),
    onClick,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      children: toggled ? textConstants.hideButton : textConstants.showButton
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: toggle_button_module.toggleButtonIcon,
      name: toggled ? "simple-arrow-up" : "simple-arrow-down",
      size: "small"
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/module-tag/module-tag.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const module_tag_module = ({"content":"module-tag-module__content--AOfts","current-module":"module-tag-module__current-module--EN00Z","currentModule":"module-tag-module__current-module--EN00Z","current-module-dot":"module-tag-module__current-module-dot--xjXia","currentModuleDot":"module-tag-module__current-module-dot--xjXia"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/module-tag/module-tag.tsx





const ModuleTag = _ref => {
  let {
    color,
    className,
    text
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(module_tag_module.content, className),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: module_tag_module.currentModuleDot,
      style: {
        backgroundColor: color
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: module_tag_module.currentModule,
      style: {
        color
      },
      children: text
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/tags/tags.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tags_module = ({"tag":"tags-module__tag--oZ9jN"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/tags/tags.tsx








const Tags = _ref => {
  let {
    array,
    className,
    tagClassName,
    style
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className,
    children: Array.isArray(array) && array.map((item, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(tags_module.tag, tagClassName),
      style,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: item
      })
    }, index))
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-cards/card/card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const card_module = ({"card":"card-module__card--s3Cxn","card-current":"card-module__card-current--MRLzu","cardCurrent":"card-module__card-current--MRLzu","card-passed":"card-module__card-passed--VZwd9","cardPassed":"card-module__card-passed--VZwd9","card-name-block":"card-module__card-name-block--wYMdA","cardNameBlock":"card-module__card-name-block--wYMdA","card-tag":"card-module__card-tag--SKt0S","cardTag":"card-module__card-tag--SKt0S","current-card-block":"card-module__current-card-block--vmKO2","currentCardBlock":"card-module__current-card-block--vmKO2"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-cards/card/card.tsx









const Card = _ref => {
  let {
    module,
    moduleNumber,
    color,
    isCurrentModule,
    isPassedModule,
    textConstants
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    title,
    lexis
  } = module;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
    className: classnames_default()(card_module.card, {
      [card_module.cardCurrent]: isCurrentModule
    }, {
      [card_module.cardPassed]: isPassedModule && !isCurrentModule
    }),
    style: {
      borderColor: isCurrentModule ? color : void 0
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(typography_module/* default */.Z.body1Accent, card_module.cardNameBlock),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          style: {
            color
          },
          children: moduleNumber
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(Tags, {
        array: lexis,
        tagClassName: card_module.cardTag
      })]
    }), isCurrentModule && /* @__PURE__ */(0,jsx_runtime.jsx)(ModuleTag, {
      color,
      className: card_module.currentCardBlock,
      text: textConstants.currentModule
    }), isPassedModule && !isCurrentModule && /* @__PURE__ */(0,jsx_runtime.jsx)(ModuleTag, {
      color: "#8d8c95",
      className: card_module.currentCardBlock,
      text: intl.formatMessage({
        id: "courseMap.passedModuleTag.text"
      })
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-cards/constants.ts


const CARD_LIST_MARGIN_TOP_IN_PX = 24;
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-cards/course-map-cards.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_map_cards_module = ({"title":"course-map-cards-module__title--Iimil","narrow":"course-map-cards-module__narrow--t9gqI","cards-desktop":"course-map-cards-module__cards-desktop--Cm92b","cardsDesktop":"course-map-cards-module__cards-desktop--Cm92b","cards-tablet":"course-map-cards-module__cards-tablet--chSkj","cardsTablet":"course-map-cards-module__cards-tablet--chSkj","card-list":"course-map-cards-module__card-list--LBVJg","cardList":"course-map-cards-module__card-list--LBVJg","card-list-narrow":"course-map-cards-module__card-list-narrow--yEqen","cardListNarrow":"course-map-cards-module__card-list-narrow--yEqen","completed-cards-wrapper":"course-map-cards-module__completed-cards-wrapper--yrFkJ","completedCardsWrapper":"course-map-cards-module__completed-cards-wrapper--yrFkJ","completed-cards-wrapper-visible":"course-map-cards-module__completed-cards-wrapper-visible--m0_4o","completedCardsWrapperVisible":"course-map-cards-module__completed-cards-wrapper-visible--m0_4o","description":"course-map-cards-module__description--yt7Cv"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-cards/course-map-cards.tsx













const CourseMapCards = _ref => {
  let {
    title,
    description,
    color,
    modules,
    completedModules,
    notCompletedModules,
    textConstants,
    isNarrowContainer = false
  } = _ref;
  const [cardsExpanded, setCardsExpanded] = (0,react.useState)(false);
  const [passedListHeight, setPassedListHeight] = (0,react.useState)(0);
  const toggleExpanded = (0,react.useCallback)(() => {
    setCardsExpanded(prev => !prev);
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    "data-testid": "course-map-cards",
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(course_map_cards_module.title, typography_module/* default */.Z.headline3, {
        [course_map_cards_module.narrow]: isNarrowContainer,
        [typography_module/* default */.Z.headline4Accent]: isNarrowContainer
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: textConstants.courseOverview
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        style: {
          color
        },
        children: title
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_map_cards_module.description,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: description
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_map_cards_module.cardsDesktop,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
        className: classnames_default()(course_map_cards_module.cardList, {
          [course_map_cards_module.cardListNarrow]: isNarrowContainer
        }),
        children: modules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)(Card, {
          module,
          moduleNumber: module.moduleNumber,
          color,
          isCurrentModule: module.isCurrentModule,
          isPassedModule: module.isCompletedModule,
          textConstants
        }, module.moduleNumber))
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: course_map_cards_module.cardsTablet,
      children: [completedModules.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(ToggleButton, {
        onClick: toggleExpanded,
        toggled: cardsExpanded,
        textConstants: {
          hideButton: textConstants.buttonText.hidePassed,
          showButton: textConstants.buttonText.showPassed
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(course_map_cards_module.completedCardsWrapper, {
          [course_map_cards_module.completedCardsWrapperVisible]: cardsExpanded
        }),
        style: {
          "--completed-cards-height": `${passedListHeight}px`
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
          ref: element => {
            if (element === null) {
              return;
            }
            setPassedListHeight(element?.getBoundingClientRect().height + CARD_LIST_MARGIN_TOP_IN_PX);
          },
          className: course_map_cards_module.cardList,
          children: completedModules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)(Card, {
            module,
            moduleNumber: module.moduleNumber,
            color,
            isCurrentModule: module.isCurrentModule,
            isPassedModule: module.isCompletedModule,
            textConstants
          }, module.moduleNumber))
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
        className: course_map_cards_module.cardList,
        children: notCompletedModules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)(Card, {
          module,
          moduleNumber: module.moduleNumber,
          color,
          isCurrentModule: module.isCurrentModule,
          isPassedModule: module.isCompletedModule,
          textConstants
        }, module.moduleNumber))
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-card/program-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const program_card_module = ({"card":"program-card-module__card--bRggd","card-passed":"program-card-module__card-passed--pl4EP","cardPassed":"program-card-module__card-passed--pl4EP","card-current":"program-card-module__card-current--CEGS_","cardCurrent":"program-card-module__card-current--CEGS_","number":"program-card-module__number--_Fr8C","name-block":"program-card-module__name-block--Kdc9v","nameBlock":"program-card-module__name-block--Kdc9v","grammar-tags":"program-card-module__grammar-tags--GP6td","grammarTags":"program-card-module__grammar-tags--GP6td","item-title":"program-card-module__item-title--oXVvY","itemTitle":"program-card-module__item-title--oXVvY","item-title-first":"program-card-module__item-title-first--a_A48","itemTitleFirst":"program-card-module__item-title-first--a_A48","current-module-tag":"program-card-module__current-module-tag--PVYvw","currentModuleTag":"program-card-module__current-module-tag--PVYvw"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-card/program-card.tsx










const ProgramCard = _ref => {
  let {
    module,
    color,
    moduleNumber,
    isCurrentModule,
    isPassedModule,
    textConstants
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    title,
    description,
    grammar,
    lexis
  } = module;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(program_card_module.card, {
      [program_card_module.cardCurrent]: isCurrentModule
    }, {
      [program_card_module.cardPassed]: isPassedModule && !isCurrentModule
    }),
    style: {
      borderColor: isCurrentModule ? color : void 0
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(typography_module/* default */.Z.body1Accent, program_card_module.nameBlock),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: program_card_module.number,
        style: {
          backgroundColor: isCurrentModule ? color : void 0
        },
        children: moduleNumber
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, program_card_module.itemTitle, program_card_module.itemTitleFirst),
      children: textConstants.description
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      children: description
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, program_card_module.itemTitle),
      children: textConstants.grammar
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Tags, {
      array: grammar,
      tagClassName: program_card_module.grammarTags
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, program_card_module.itemTitle),
      children: textConstants.lexis
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Tags, {
      array: lexis,
      style: {
        backgroundColor: `${color}77`
      }
    }), isCurrentModule && /* @__PURE__ */(0,jsx_runtime.jsx)(ModuleTag, {
      color,
      text: textConstants.currentModule,
      className: program_card_module.currentModuleTag
    }), isPassedModule && !isCurrentModule && /* @__PURE__ */(0,jsx_runtime.jsx)(ModuleTag, {
      color: "#8d8c95",
      className: program_card_module.currentModuleTag,
      text: intl.formatMessage({
        id: "courseMap.passedModuleTag.text"
      })
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-cards/program-cards.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const program_cards_module = ({"cards":"program-cards-module__cards--EuZDk"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-cards/program-cards.tsx







const ProgramCards = _ref => {
  let {
    modules,
    color,
    textConstants
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: program_cards_module.cards,
      children: modules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProgramCard, {
          module,
          moduleNumber: module.moduleNumber,
          color,
          isCurrentModule: module.isCurrentModule,
          isPassedModule: module.isCompletedModule,
          textConstants
        })
      }, module.moduleNumber))
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-expanded-cards/program-expanded-cards.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const program_expanded_cards_module = ({"cards":"program-expanded-cards-module__cards--shhti","card":"program-expanded-cards-module__card--RFEFB","completed-modules-wrapper":"program-expanded-cards-module__completed-modules-wrapper--Iymbu","completedModulesWrapper":"program-expanded-cards-module__completed-modules-wrapper--Iymbu","completed-modules-wrapper-visible":"program-expanded-cards-module__completed-modules-wrapper-visible--A4Sy7","completedModulesWrapperVisible":"program-expanded-cards-module__completed-modules-wrapper-visible--A4Sy7"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-expanded-cards/program-expanded-cards.tsx










const ProgramExpandedCards = _ref => {
  let {
    completedModules,
    notCompletedModules,
    color,
    textConstants
  } = _ref;
  const [modulesExpanded, setModulesExpanded] = (0,react.useState)(false);
  const [passedListHeight, setPassedListHeight] = (0,react.useState)(0);
  const toggleExpanded = (0,react.useCallback)(() => {
    setModulesExpanded(prev => !prev);
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [completedModules.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(ToggleButton, {
      onClick: toggleExpanded,
      toggled: modulesExpanded,
      textConstants: {
        hideButton: textConstants.buttonText.hidePassed,
        showButton: textConstants.buttonText.showPassed
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(program_expanded_cards_module.completedModulesWrapper, {
        [program_expanded_cards_module.completedModulesWrapperVisible]: modulesExpanded
      }),
      style: {
        "--completed-modules-height": `${passedListHeight}px`
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
        ref: element => {
          if (element === null) {
            return;
          }
          setPassedListHeight(element?.getBoundingClientRect().height);
        },
        className: program_expanded_cards_module.cards,
        children: completedModules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
          className: program_expanded_cards_module.card,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProgramCard, {
            module,
            moduleNumber: module.moduleNumber,
            color,
            isCurrentModule: module.isCurrentModule,
            isPassedModule: module.isCompletedModule,
            textConstants
          })
        }, module.moduleNumber))
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: program_expanded_cards_module.cards,
      children: notCompletedModules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        className: program_expanded_cards_module.card,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProgramCard, {
          module,
          moduleNumber: module.moduleNumber,
          color,
          isCurrentModule: module.isCurrentModule,
          isPassedModule: module.isCompletedModule,
          textConstants
        })
      }, module.moduleNumber))
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-list/module-row/module-row.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const module_row_module = ({"row":"module-row-module__row--mqsZi","module-number":"module-row-module__module-number--OqLOa","moduleNumber":"module-row-module__module-number--OqLOa","module-number-current":"module-row-module__module-number-current--Fd1Oe","moduleNumberCurrent":"module-row-module__module-number-current--Fd1Oe","number":"module-row-module__number--uJMaF","number-passed":"module-row-module__number-passed--fgBc3","numberPassed":"module-row-module__number-passed--fgBc3","list-row":"module-row-module__list-row--SD0c1","listRow":"module-row-module__list-row--SD0c1","module-row":"module-row-module__module-row--upLb7","moduleRow":"module-row-module__module-row--upLb7","module-row-current":"module-row-module__module-row-current--dLsdb","moduleRowCurrent":"module-row-module__module-row-current--dLsdb","module-row-passed":"module-row-module__module-row-passed--JFchh","moduleRowPassed":"module-row-module__module-row-passed--JFchh","module-name-block":"module-row-module__module-name-block--OEYL7","moduleNameBlock":"module-row-module__module-name-block--OEYL7","grammar-tags":"module-row-module__grammar-tags--gGMfZ","grammarTags":"module-row-module__grammar-tags--gGMfZ"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-list/module-row/module-row.tsx









const ModuleRow = _ref => {
  let {
    module,
    color,
    moduleNumber,
    isCurrentModule,
    isPassedModule,
    textConstants
  } = _ref;
  const {
    title,
    description,
    grammar,
    lexis
  } = module;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: module_row_module.row,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(module_row_module.moduleNumber, typography_module/* default */.Z.body2Accent, {
        [module_row_module.moduleNumberCurrent]: isCurrentModule
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(module_row_module.number, {
          [module_row_module.numberPassed]: isPassedModule
        }),
        style: {
          backgroundColor: isCurrentModule ? color : void 0
        },
        children: moduleNumber
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(module_row_module.listRow, module_row_module.moduleRow, {
        [module_row_module.moduleRowCurrent]: isCurrentModule,
        [module_row_module.moduleRowPassed]: isPassedModule
      }),
      style: {
        borderColor: isCurrentModule ? color : void 0
      },
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: module_row_module.moduleNameBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: title
        }), isCurrentModule && /* @__PURE__ */(0,jsx_runtime.jsx)(ModuleTag, {
          color,
          text: textConstants.currentModule
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: description
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(Tags, {
        array: grammar,
        tagClassName: module_row_module.grammarTags
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(Tags, {
        array: lexis,
        style: {
          backgroundColor: `${color}77`
        }
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-list/program-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const program_list_module = ({"module-list-header":"program-list-module__module-list-header--pY3Hv","moduleListHeader":"program-list-module__module-list-header--pY3Hv","module-list-header-item":"program-list-module__module-list-header-item--tm8Vv","moduleListHeaderItem":"program-list-module__module-list-header-item--tm8Vv","module-list":"program-list-module__module-list--HGrGr","moduleList":"program-list-module__module-list--HGrGr","list-row":"program-list-module__list-row--TJy4U","listRow":"program-list-module__list-row--TJy4U","module":"program-list-module__module--ma6EV"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/program-list/program-list.tsx









const ProgramList = _ref => {
  let {
    modules,
    color,
    textConstants
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: program_list_module.moduleListHeader,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(program_list_module.listRow, typography_module/* default */.Z.body2Accent),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: textConstants.moduleTitle
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: textConstants.description
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: program_list_module.moduleListHeaderItem,
          children: textConstants.grammar
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: program_list_module.moduleListHeaderItem,
          children: textConstants.lexis
        })]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: program_list_module.moduleList,
      children: modules.map(module => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        className: program_list_module.module,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ModuleRow, {
          module,
          moduleNumber: module.moduleNumber,
          color,
          isCurrentModule: module.isCurrentModule,
          isPassedModule: module.isCompletedModule,
          textConstants
        })
      }, module.moduleNumber))
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-modules/course-map-modules.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_map_modules_module = ({"title":"course-map-modules-module__title--qZr8D","narrow":"course-map-modules-module__narrow--nuExz"});
;// CONCATENATED MODULE: ../ui-kit/src/course-map/course-map-modules/course-map-modules.tsx










const CourseMapModules = _ref => {
  let {
    title,
    color,
    modules,
    completedModules,
    notCompletedModules,
    textConstants,
    isNarrowContainer = false
  } = _ref;
  const {
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const renderContent = () => {
    if (isMobileOrTablet) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ProgramExpandedCards, {
        completedModules,
        notCompletedModules,
        color,
        textConstants
      });
    }
    if (isNarrowContainer) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ProgramCards, {
        modules,
        color,
        textConstants
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ProgramList, {
      modules,
      color,
      textConstants
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(course_map_modules_module.title, typography_module/* default */.Z.headline3, {
        [course_map_modules_module.narrow]: isNarrowContainer,
        [typography_module/* default */.Z.headline4Accent]: isNarrowContainer
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: textConstants.program
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        style: {
          color
        },
        children: title
      })]
    }), renderContent()]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/constants.ts


const TASKS_COMPLETED_FOR_MODULE_COUNT_AS_CURRENT = 10;
const TASKS_COMPLETED_FOR_MODULE_COUNT_AS_COMPLETED = 10;
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/utils.ts











const getLevelStringFromCourseSlug = courseSlug => {
  if (courseSlug === "a1") {
    courseSlug = "a1.1";
  }
  if (courseSlug.startsWith("bus")) {
    const parts = courseSlug.split("_");
    return parts[parts.length - 1];
  }
  return courseSlug.split(".").join("_");
};
const getCurrentModuleNumber = modules => modules.reduce((acc, _ref) => {
  let {
    module,
    count
  } = _ref;
  if (count >= TASKS_COMPLETED_FOR_MODULE_COUNT_AS_CURRENT && module > acc) {
    acc = module;
  }
  return acc;
}, 0);
const getCourseMapViewModel = (courseMap, modulesResponse, currentModule) => {
  const currentModuleNumber = currentModule || 0;
  const currentModuleName = courseMap?.modules[(currentModuleNumber || 0) - 1]?.title || "";
  const {
    completedModulesNumbers
  } = modulesResponse.reduce((acc, _ref2) => {
    let {
      module,
      count
    } = _ref2;
    if (count >= TASKS_COMPLETED_FOR_MODULE_COUNT_AS_COMPLETED) {
      acc.completedModulesNumbers.push(module);
    } else {
      acc.notCompletedModulesNumbers.push(module);
    }
    return acc;
  }, {
    completedModulesNumbers: [],
    notCompletedModulesNumbers: []
  });
  const modules = courseMap.modules.map((module, index) => {
    const moduleNumber = index + 1;
    return {
      ...module,
      moduleNumber,
      isCurrentModule: currentModuleNumber === moduleNumber,
      isCompletedModule: completedModulesNumbers.includes(moduleNumber)
    };
  });
  const completedModules = modules.filter(_ref3 => {
    let {
      isCompletedModule,
      isCurrentModule
    } = _ref3;
    return !isCurrentModule && isCompletedModule;
  });
  const notCompletedModules = modules.filter(_ref4 => {
    let {
      isCurrentModule,
      isCompletedModule
    } = _ref4;
    return !isCompletedModule || isCurrentModule;
  });
  return {
    ...courseMap,
    currentModuleName,
    modules,
    completedModules,
    notCompletedModules,
    currentModuleNumber
  };
};
const updateModules = (completedModules, notCompletedModules, currentModuleNumber) => {
  if (!currentModuleNumber) {
    return {
      completedWithPassedModules: completedModules,
      notCompletedNotPassedModules: notCompletedModules
    };
  }
  const completedWithPassedModules = [...completedModules, ...notCompletedModules.filter(module => module.moduleNumber < currentModuleNumber)].sort((a, b) => a.moduleNumber - b.moduleNumber);
  const notCompletedNotPassedModules = notCompletedModules.filter(module => module.moduleNumber >= currentModuleNumber);
  return {
    completedWithPassedModules,
    notCompletedNotPassedModules
  };
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/api.ts





const fetchCourseMap = async _ref => {
  let {
    businessProductId,
    courseLevel: {
      currentLevel,
      currentModule,
      currentCourseSlug,
      modules,
      nextLevel,
      moduleVersion
    },
    courseMapVersionsFlag
  } = _ref;
  if (businessProductId === null || currentCourseSlug === null || modules === null) {
    return null;
  }
  const level = getLevelStringFromCourseSlug(currentCourseSlug);
  const version = courseMapVersionsFlag && moduleVersion ? `_ver${moduleVersion}` : "";
  const bunkerString = `${businessProductId}_${level}${version}`;
  try {
    const result = await (0,bunker_api/* getCourseMap */.xe)(bunkerString);
    const courseMapResult = getCourseMapViewModel(result, modules, currentModule);
    return {
      ...courseMapResult,
      currentLevel
    };
  } catch (error) {
    logger/* Logger */.Yd.captureException("Course map error", {
      businessProductId,
      currentLevel,
      currentCourseSlug,
      nextLevel,
      moduleVersion,
      modules,
      error
    }, {
      method: "fetchCourseMap",
      block: "course-map"
    });
    return null;
  }
};
;// CONCATENATED MODULE: ./src/hooks/student/use-cource-map-query.ts





const useCourseMapQuery = props => {
  const {
    businessProductId,
    courseLevel,
    courseMapVersionsFlag
  } = props;
  const {
    currentLevel,
    currentCourseSlug,
    modules,
    nextLevel,
    moduleVersion
  } = courseLevel;
  const queryKey = (0,react.useMemo)(() => ["courseMap", businessProductId, currentLevel, currentCourseSlug, modules, nextLevel, moduleVersion, courseMapVersionsFlag], [businessProductId, courseMapVersionsFlag, currentCourseSlug, currentLevel, moduleVersion, modules, nextLevel]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(businessProductId) && Boolean(currentCourseSlug) && Boolean(modules),
    queryKey,
    queryFn: () => {
      if (!businessProductId) {
        return null;
      }
      return fetchCourseMap(props);
    },
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/course-map.tsx









const CourseMap = _ref => {
  let {
    businessProductId,
    courseLevel,
    isNarrowContainer
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const courseMapVersionsFlag = (0,features/* useFeatureFlag */.ye)("courseMapVersions");
  const {
    data: courseMap
  } = useCourseMapQuery({
    businessProductId,
    courseLevel,
    courseMapVersionsFlag
  });
  if (!courseMap) {
    return null;
  }
  const {
    completedModules,
    notCompletedModules,
    currentModuleNumber,
    ...restCourseMapViewModel
  } = courseMap;
  const {
    completedWithPassedModules,
    notCompletedNotPassedModules
  } = updateModules(completedModules, notCompletedModules, currentModuleNumber);
  const textConstants = {
    program: intl.formatMessage({
      id: "courseMap.program"
    }),
    courseOverview: intl.formatMessage({
      id: "courseMap.courseOverview"
    }),
    courseMap: intl.formatMessage({
      id: "courseMap.courseMap"
    }),
    moduleTitle: intl.formatMessage({
      id: "courseMap.moduleTitle"
    }),
    description: intl.formatMessage({
      id: "courseMap.description"
    }),
    grammar: intl.formatMessage({
      id: "courseMap.grammar"
    }),
    lexis: intl.formatMessage({
      id: "courseMap.lexis"
    }),
    buttonText: {
      showPassed: intl.formatMessage({
        id: "courseMap.showPassed"
      }),
      hidePassed: intl.formatMessage({
        id: "courseMap.hidePassed"
      })
    },
    currentModule: intl.formatMessage({
      id: "courseMap.moduleFromLastLesson"
    })
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(CourseMapCards, {
      completedModules: completedWithPassedModules,
      notCompletedModules: notCompletedNotPassedModules,
      currentModuleNumber,
      ...restCourseMapViewModel,
      textConstants,
      isNarrowContainer
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(CourseMapModules, {
      completedModules: completedWithPassedModules,
      notCompletedModules: notCompletedNotPassedModules,
      currentModuleNumber,
      ...restCourseMapViewModel,
      textConstants,
      isNarrowContainer
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/model.ts



const [$isCourseMapPopupOpen, setIsCourseMapPopupOpen, resetIsCourseMapPopupOpen] = (0,makeStore/* makeStore */.n)(false);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/course-map.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_map_module = ({"page":"course-map-module__page--OCvkM","widget-content":"course-map-module__widget-content--yeQZN","widgetContent":"course-map-module__widget-content--yeQZN","widget-module":"course-map-module__widget-module--JKWn6","widgetModule":"course-map-module__widget-module--JKWn6","widget-current-module":"course-map-module__widget-current-module--mpMh1","widgetCurrentModule":"course-map-module__widget-current-module--mpMh1","widget-module-number":"course-map-module__widget-module-number--PP8af","widgetModuleNumber":"course-map-module__widget-module-number--PP8af","widget-level":"course-map-module__widget-level--lMqld","widgetLevel":"course-map-module__widget-level--lMqld","widget-button":"course-map-module__widget-button--wRd6g","widgetButton":"course-map-module__widget-button--wRd6g"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/course-map-popup.tsx








const CourseMapPopup = _ref => {
  let {
    businessProductId,
    courseLevel
  } = _ref;
  const isCourseMapPopupOpen = (0,effector_react/* useStore */.oR)($isCourseMapPopupOpen);
  const resetIsCourseMapPopupOpenEvent = (0,effector_react/* useEvent */.zX)(resetIsCourseMapPopupOpen);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_sheet_light_component/* BottomSheetLight */.e_, {
    visible: isCourseMapPopupOpen,
    isFullScreen: true,
    onClose: resetIsCourseMapPopupOpenEvent,
    bgColor: bottom_sheet_light_component/* BottomSheetLightColor */.tW.Grey,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_map_module.page,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(CourseMap, {
        businessProductId,
        courseLevel
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/course-map/course-map-widget.tsx




















const CourseMapWidget = _ref => {
  let {
    courseLevel,
    className
  } = _ref;
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const history = (0,react_router/* useHistory */.k6)();
  const courseMapVersionsFlag = (0,features/* useFeatureFlag */.ye)("courseMapVersions");
  const {
    shouldShowProgress
  } = (0,use_progress_page_enabled/* useProgressPageEnabled */.e)();
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu) || product_model/* BusinessProductId */.HV.Unknown;
  const setIsCourseMapPopupOpenEvent = (0,effector_react/* useEvent */.zX)(setIsCourseMapPopupOpen);
  const {
    data: courseMap
  } = useCourseMapQuery({
    businessProductId,
    courseLevel,
    courseMapVersionsFlag
  });
  if (!courseMap) {
    return null;
  }
  const handleOpenPopup = () => {
    (0,yandexMetrica/* ymGoal */.qf)("Open_Course_Map");
    shouldShowProgress ? history.push(routes.PROGRESS.PROGRAM) : setIsCourseMapPopupOpenEvent(true);
  };
  const {
    color,
    modules,
    currentModuleNumber,
    currentModuleName
  } = courseMap;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(course_map_module.widgetContent, className),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: course_map_module.widgetModule,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(course_map_module.widgetCurrentModule, typography_module/* default */.Z.captionAccent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "courseMap.moduleFromLastLesson"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(course_map_module.widgetModuleNumber, typography_module/* default */.Z.captionAccent),
        style: {
          backgroundColor: `${color}bb`
        },
        children: [currentModuleNumber, "/", modules.length]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(course_map_module.widgetLevel, typography_module/* default */.Z.body2Accent),
      children: currentModuleName
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
      onClick: handleOpenPopup,
      className: course_map_module.widgetButton,
      appearance: "secondary",
      size: "small",
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "courseMap.courseMap"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "path",
        size: "small"
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/course-level/course-level.mapper.ts



const mapCourseLevelResponse = (_ref, businessProductId) => {
  let {
    data
  } = _ref;
  if (!data.current_course_slug) {
    logger/* Logger */.Yd.captureWarning("current_course_slug in api/student/course-level/{businessProductId} is null", {
      data,
      businessProductId
    }, {
      method: "mapCourseLevelResponse",
      block: "dashboard-page"
    });
  }
  return {
    currentLevel: data.current_level,
    currentModule: data.current_module,
    currentCourseSlug: data.current_course_slug,
    nextLevel: data.next_level,
    nextCourseSlug: data.next_course_slug,
    previousCourseSlug: data.previous_course_slug,
    moduleVersion: data.module_version,
    modules: data.modules
  };
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/course-level/course-level.raw-model.ts



const RawModule = es6.type({
  module: es6.number,
  count: es6.number
});
const RawCourseLevel = es6.type({
  current_level: es6.union([es6.string, es6["null"]]),
  current_module: es6.union([es6.number, es6["null"]]),
  current_course_slug: es6.union([es6.string, es6["null"]]),
  next_level: es6.union([es6.string, es6["null"]]),
  next_course_slug: es6.union([es6.string, es6["null"]]),
  previous_course_slug: es6.union([es6.string, es6["null"]]),
  module_version: es6.union([es6.number, es6["null"]]),
  modules: es6.array(RawModule)
});
const RawCourseLevelResponse = es6.type({
  data: RawCourseLevel
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/api/course-level/course-level.api.ts







const getCourseLevel = (0,un_either/* unEither */.K)(businessProductId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/course-level/${businessProductId}`, {
  responseType: RawCourseLevelResponse,
  resultMapper: data => mapCourseLevelResponse(data, businessProductId)
}));
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/hooks/use-course-level-query.ts





const useCourseLevelQuery = businessProductId => {
  const queryKey = (0,react.useMemo)(() => ["courseLevel", businessProductId], [businessProductId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(businessProductId),
    queryKey,
    queryFn: () => {
      if (!businessProductId) {
        return null;
      }
      return getCourseLevel(businessProductId);
    },
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
// EXTERNAL MODULE: ../shared/src/string.utils.ts
var string_utils = __webpack_require__(25680);
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__lesson-card/curator-lesson-card.component.tsx











const CuratorLessonCard = _ref => {
  let {
    actions,
    avatar,
    title,
    schedule,
    subtitle
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: lesson_card_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(lesson_card_module.firstLine, lesson_card_module.firstLineWithAvatar),
      children: [title && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, lesson_card_module.title),
          children: title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.body2, lesson_card_module.subtitle),
          children: subtitle
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, lesson_card_module.mobileSubtitle),
          children: subtitle
        })]
      }), schedule && /* @__PURE__ */(0,jsx_runtime.jsx)(Schedule, {
        schedule
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: lesson_card_module.avatarWrapper,
        children: avatar
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: lesson_card_module.actionsContainer,
      children: actions.map(action => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: lesson_card_module.actionButtonWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: action.type,
          size: "medium",
          onClick: action.onClick,
          disabled: action.disabled ?? false,
          className: lesson_card_module.actionButton,
          children: action.text
        })
      }, action.text))
    })]
  });
};
function Schedule(_ref2) {
  let {
    schedule
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("ul", {
    className: lesson_card_module.nearestSpeakingSessions,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
      className: classnames_default()(typography_module/* default */.Z.headline4Accent, lesson_card_module.lessonNearestDate),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("time", {
        children: (0,string_utils/* capitalized */.wm)(schedule[0])
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.caption, lesson_card_module.timeHint),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "lessonCard.timeHint"
        })
      })]
    }), schedule.slice(1).map(lessonDate => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, lesson_card_module.lessonSecondaryDate),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
        children: (0,string_utils/* capitalized */.wm)(lessonDate)
      })
    }, lessonDate))]
  });
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/hooks/use-schedule-management-access.ts






function useScheduleManagementAccess() {
  const schedulePauseFeature = (0,features/* useFeatureFlag */.ye)("schedulePause");
  const scheduleChangeFeature = (0,features/* useFeatureFlag */.ye)("scheduleChange");
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  return (0,react.useMemo)(() => {
    const isStudying = onboardingState === student_attributes/* OnboardingFSMState */.Cv.Studying;
    const requestPauseButton = {
      visible: schedulePauseFeature,
      disabled: !isStudying
    };
    const requestChangingScheduleButton = {
      visible: scheduleChangeFeature,
      disabled: !isStudying
    };
    return {
      controlButton: {
        visible: requestPauseButton.visible || requestChangingScheduleButton.visible,
        disabled: requestPauseButton.disabled && requestChangingScheduleButton.disabled
      },
      requestPauseButton,
      requestChangingScheduleButton
    };
  }, [onboardingState, scheduleChangeFeature, schedulePauseFeature]);
}
// EXTERNAL MODULE: ../../node_modules/date-fns/subMinutes.mjs
var subMinutes = __webpack_require__(49566);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/lesson-card/utils.ts



function isSessionStartsSoon(sessionDate, currentTime) {
  const MINUTES_BEFORE_SESSION_START = 15;
  return (0,isAfter/* isAfter */.A)(currentTime, (0,subMinutes/* subMinutes */._)(sessionDate, MINUTES_BEFORE_SESSION_START));
}
function getEnterClassButtonDisabled(_ref) {
  let {
    isZeroBalance,
    isPausedOrCancelled,
    sessionStartAt,
    currentTime,
    isTaskGuideExperiment,
    speakingSessionLink
  } = _ref;
  if (isZeroBalance) {
    if (!currentTime || !sessionStartAt) {
      return true;
    }
    return !isSessionStartsSoon(sessionStartAt, currentTime);
  }
  if (isPausedOrCancelled) {
    return true;
  }
  return !isTaskGuideExperiment && !speakingSessionLink;
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/lesson-card/hooks/use-lesson-card-actions.ts


















function useLessonCardActions() {
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  const {
    viewModel: {
      nearestScheduledSpeakingSession,
      nearestScheduledSpeakingSessionScheduleInfo: schedulerInfo
    }
  } = useStudentSchedule();
  const rescheduleLessonPopupService = useRescheduleLessonPopupService();
  const resourcesZeroBalance = (0,use_resources_zero_balance/* useResourcesZeroBalance */.GG)();
  const isZeroBalance = (0,use_resources_zero_balance/* checkZeroBalance */.Ll)(resourcesZeroBalance, "speakingSession");
  const currentTime = (0,useCurrentTime/* useServerCurrentTime */.Q$)({
    enable: isZeroBalance,
    updateInterval: 5e3
  });
  const scheduleManagementAccess = useScheduleManagementAccess();
  const isPausedOrCancelled = onboardingState === student_attributes/* OnboardingFSMState */.Cv.Paused || onboardingState === student_attributes/* OnboardingFSMState */.Cv.Cancelled;
  const speakingSessionExperiments = (0,hooks/* useSpeakingSessionExperimentsQuery */.y)({
    speakingSessionId: nearestScheduledSpeakingSession?.id
  });
  const isTaskGuideExperiment = Boolean(speakingSessionExperiments.data && (0,Either.isRight)(speakingSessionExperiments.data) && speakingSessionExperiments.data.right.class_type === "task_guide");
  const handleEnterClass = (0,react.useCallback)(() => {
    if (isTaskGuideExperiment && nearestScheduledSpeakingSession?.id) {
      history.push(studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(nearestScheduledSpeakingSession?.id));
      return;
    }
    const url = schedulerInfo?.speakingSessionLink;
    if (url) {
      window.open(url, "_blank");
    }
  }, [history, isTaskGuideExperiment, nearestScheduledSpeakingSession?.id, schedulerInfo?.speakingSessionLink]);
  return (0,react.useMemo)(() => {
    const actions = [];
    if (rescheduleLessonPopupService.studentRescheduleAbility && !isZeroBalance) {
      const isRescheduleButtonDisabled = !nearestScheduledSpeakingSession || !rescheduleLessonPopupService.checkReschedulingButtonEnable(nearestScheduledSpeakingSession);
      actions.push(scheduleManagementAccess.controlButton.visible ? {
        type: "secondary",
        text: intl.formatMessage({
          id: "BeginnerScheduleList.manageSchedule"
        }),
        onClick: () => {
          history.push(studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE_LIST);
        },
        disabled: scheduleManagementAccess.controlButton.disabled
      } : {
        type: "secondary",
        text: intl.formatMessage({
          id: "BeginnerScheduleList.rescheduleLesson"
        }),
        onClick: isRescheduleButtonDisabled ? void 0 : () => {
          const speakingSessionId = nearestScheduledSpeakingSession?.id;
          if (!speakingSessionId) {
            throw new not_found_object_error/* NotFoundObjectError */.m("speakingSessionId");
          }
          rescheduleLessonPopupService.openPopup(speakingSessionId, "main");
        },
        disabled: isRescheduleButtonDisabled
      });
    }
    const isEnterClassButtonDisabled = getEnterClassButtonDisabled({
      isZeroBalance,
      isPausedOrCancelled,
      isTaskGuideExperiment,
      speakingSessionLink: schedulerInfo?.speakingSessionLink,
      sessionStartAt: nearestScheduledSpeakingSession?.startAt,
      currentTime
    });
    actions.push({
      onClick: isEnterClassButtonDisabled ? void 0 : handleEnterClass,
      text: intl.formatMessage({
        id: "beginnerSchedulePage.enterClass"
      }),
      type: "primary",
      disabled: isEnterClassButtonDisabled
    });
    return actions;
  }, [rescheduleLessonPopupService, isZeroBalance, isPausedOrCancelled, isTaskGuideExperiment, schedulerInfo?.speakingSessionLink, nearestScheduledSpeakingSession, currentTime, handleEnterClass, intl, scheduleManagementAccess.controlButton, history]);
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/lesson-card/hooks/use-lesson-card-text.ts










function useLessonCardText() {
  const intl = (0,useIntl/* default */.Z)();
  const {
    viewModel: {
      nearestScheduledSpeakingSessions,
      nearestScheduledSpeakingSession
    }
  } = useStudentSchedule();
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  const isStudentOnPause = onboardingState === student_attributes/* OnboardingFSMState */.Cv.Paused;
  const isStudentLessonsCancelled = onboardingState === student_attributes/* OnboardingFSMState */.Cv.Cancelled;
  const resourcesZeroBalance = (0,use_resources_zero_balance/* useResourcesZeroBalance */.GG)();
  return (0,react.useMemo)(() => {
    if (resourcesZeroBalance === "all") {
      return {
        title: intl.formatMessage({
          id: "resources.zeroBalance.title"
        }),
        subtitle: intl.formatMessage({
          id: "resources.zeroBalance.text"
        })
      };
    }
    if (resourcesZeroBalance === "speakingSession") {
      return {
        title: intl.formatMessage({
          id: "resources.zeroBalance.titleWithPersonalTutor"
        }),
        subtitle: intl.formatMessage({
          id: "resources.zeroBalance.text"
        })
      };
    }
    if (isStudentOnPause) {
      return {
        title: intl.formatMessage({
          id: "lessonCard.pause.title"
        }) + " " + (nearestScheduledSpeakingSession ? intl.formatMessage({
          id: "beginnerSchedulePage.nearestScheduledSpeakingSession"
        }, {
          date: nearestScheduledSpeakingSession.shortDateTimeString
        }) : ""),
        subtitle: intl.formatMessage({
          id: "lessonCard.pause.subtitle"
        })
      };
    }
    if (isStudentLessonsCancelled) {
      return {
        title: intl.formatMessage({
          id: "beginnerSchedulePage.studentOnPause"
        })
      };
    }
    return {
      schedule: nearestScheduledSpeakingSession ? nearestScheduledSpeakingSessions.map(session => session.fullDateTimeString) : [intl.formatMessage({
        id: "beginnerSchedulePage.curatorClass"
      })]
    };
  }, [resourcesZeroBalance, isStudentOnPause, isStudentLessonsCancelled, nearestScheduledSpeakingSession, nearestScheduledSpeakingSessions, intl]);
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/lesson-card/lesson-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const lesson_card_lesson_card_module = ({"avatar":"lesson-card-module__avatar--M8qbT","zero-balance-avatar":"lesson-card-module__zero-balance-avatar--HMlbr","zeroBalanceAvatar":"lesson-card-module__zero-balance-avatar--HMlbr","icon":"lesson-card-module__icon--l69ic"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/lesson-card/lesson-card.tsx











function LessonCard(_ref) {
  let {
    tutorAvatar
  } = _ref;
  const textProps = useLessonCardText();
  const actions = useLessonCardActions();
  const resourcesZeroBalance = (0,use_resources_zero_balance/* useResourcesZeroBalance */.GG)();
  const isZeroBalance = (0,use_resources_zero_balance/* checkZeroBalance */.Ll)(resourcesZeroBalance, "speakingSession");
  const avatar = (0,react.useMemo)(() => isZeroBalance ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: lesson_card_lesson_card_module.zeroBalanceAvatar,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: "lamp",
      size: "large",
      className: lesson_card_lesson_card_module.icon
    })
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
    src: tutorAvatar,
    width: 104,
    height: 104,
    fitImage: true,
    classes: {
      root: lesson_card_lesson_card_module.avatar
    }
  }), [isZeroBalance, tutorAvatar]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorLessonCard, {
    ...textProps,
    actions,
    avatar
  });
}
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__teacher-info/teacher-info.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const teacher_info_module = ({"header":"teacher-info-module__header--UysdO","toggle":"teacher-info-module__toggle--gUP_q","title-block":"teacher-info-module__title-block--pZuCj","titleBlock":"teacher-info-module__title-block--pZuCj","subtitle":"teacher-info-module__subtitle--S8z40","avatar":"teacher-info-module__avatar--hSMBA"});
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__teacher-info/teacher-info.component.tsx










const TeacherInfoPopup = _ref => {
  let {
    tutorInfo,
    selectedTutorId,
    setSelectedTutorId,
    toggleValues,
    buttons,
    isVisible,
    onCloseAriaLabel,
    onClose
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  if (!tutorInfo) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(modal/* Modal */.u_, {
    title: toggleValues && selectedTutorId && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: teacher_info_module.toggle,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(toggle_button_group/* ToggleButtonGroup */.t, {
        view: isMobile ? "vertical" : "horizontal",
        values: toggleValues,
        selectedValueId: selectedTutorId,
        onChange: setSelectedTutorId
      })
    }),
    isVisible,
    onClose,
    closeButtonAriaLabel: onCloseAriaLabel,
    size: modal/* ModalSize */.Cg.Big,
    showCloseButton: true,
    buttons,
    buttonsBlockStretch: true,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: teacher_info_module.header,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
        src: tutorInfo.avatar,
        width: 80,
        height: 80,
        fitImage: true,
        classes: {
          root: teacher_info_module.avatar
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: teacher_info_module.titleBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(teacher_info_module.subtitle, typography_module/* default */.Z.caption),
          children: tutorInfo.subtitle
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: typography_module/* default */.Z.headline4Accent,
          children: tutorInfo.firstName
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: typography_module/* default */.Z.body2,
      children: tutorInfo.description
    })]
  });
};
;// CONCATENATED MODULE: ./src/services/change-tutor/change-tutor.ts



const useChangeTutor = () => ({
  changeTutor: requestTutorChange
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/tutor-info-popup/use-student-tutors-schedules.ts








const useStudentTutorsSchedules = intl => {
  const {
    scheduleInfo
  } = useStudentSchedule();
  if (!scheduleInfo) {
    return {};
  }
  const tutors = scheduleInfo.map(tutor => mapTutorInfo(tutor, intl));
  const toggleValues = tutors.length > 1 && tutors.map(tutor => ({
    id: tutor.id,
    label: tutor.isReplacement ? intl.formatMessage({
      id: "beginnerSchedulePage.temporaryTutor"
    }) : intl.formatMessage({
      id: "beginnerSchedulePage.permanentTutor"
    })
  }));
  return {
    tutors,
    ...(toggleValues && {
      toggleValues
    })
  };
};
function mapTutorInfo(tutor, intl) {
  return {
    id: tutor.tutorId,
    firstName: tutor.tutorFirstName,
    description: tutor.tutorDescription || intl.formatMessage({
      id: "beginnerSchedulePage.defaultTutorDescription"
    }),
    caption: tutor.isReplacementTutor ? intl.formatMessage({
      id: "beginnerSchedulePage.temporaryTutor"
    }) : intl.formatMessage({
      id: "beginnerSchedulePage.permanentTutor"
    }),
    avatar: (0,avatar_utils/* getYandexAvatarById */.m$)({
      id: tutor.tutorAvatarId,
      size: "islands-200"
    }),
    subtitle: tutor.isReplacementTutor ? intl.formatMessage({
      id: "beginnerSchedulePage.replacementTeacherCardSubtitle"
    }, {
      date: (0,format/* format */.WU)(tutor.replacementUntilDate ?? /* @__PURE__ */new Date(), "d MMMM", {
        locale: utils_locale/* dateFnsLocale */.Y
      })
    }) : intl.formatMessage({
      id: "beginnerSchedulePage.teacherCardSubtitle"
    }),
    isReplacement: tutor.isReplacementTutor
  };
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/tutor-info-popup/tutor-info-popup.tsx














const TutorInfoPopup = _ref => {
  let {
    initialTutorId,
    isVisible,
    onClose,
    onOpenAutoTutorChange
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const isAutoTutorChangeAvailable = (0,features/* useFeatureFlag */.ye)("studentAutoTutorChange");
  const {
    data: studentData,
    state
  } = (0,useUser/* useUser */.aF)();
  const {
    changeTutor
  } = useChangeTutor();
  const {
    tutors,
    toggleValues
  } = useStudentTutorsSchedules(intl);
  const [selectedTutorId, setSelectedTutorId] = (0,react.useState)(initialTutorId);
  const tutorInfo = (0,react.useMemo)(() => {
    const tutor = tutors?.find(tutor2 => tutor2.id === selectedTutorId);
    if (!tutor) {
      logger/* Logger */.Yd.captureException(new Error(`Tutor ${selectedTutorId} not found. All tutors: ${tutors}`));
      return;
    }
    return tutor;
  }, [selectedTutorId, tutors]);
  const handleChangeTutor = (0,react.useCallback)(async () => {
    if (isAutoTutorChangeAvailable) {
      onOpenAutoTutorChange();
      onClose();
      return;
    }
    if (state !== useUser/* State */.ZM.Loaded) {
      return;
    }
    const tutor = tutors?.find(tutor2 => tutor2.id === selectedTutorId);
    const studentId = studentData.me.user?.id;
    if (!tutor || !studentId) {
      logger/* Logger */.Yd.captureException(new Error(`Can't change tutor. Tutor ${selectedTutorId} not found or student not found`));
      return;
    }
    (0,yandexMetrica/* ymGoal */.qf)("allow_tutor_change_by_student_change_tutor");
    await changeTutor({
      studentId: (0,student_student_model/* makeStudentId */.Ox)(studentId),
      tutorId: tutor.id,
      businessProductId: studentData.product?.businessId,
      isReplaced: tutor.isReplacement
    });
    onClose();
  }, [onOpenAutoTutorChange, isAutoTutorChangeAvailable, state, tutors, studentData?.me.user?.id, studentData?.product?.businessId, changeTutor, onClose, selectedTutorId]);
  if (!tutors || !tutorInfo) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherInfoPopup, {
    tutorInfo,
    selectedTutorId,
    setSelectedTutorId,
    toggleValues,
    isVisible,
    onClose,
    onCloseAriaLabel: intl.formatMessage({
      id: "beginnerSchedulePage.closeTutorDescription"
    }),
    buttons: [{
      text: intl.formatMessage({
        id: "beginnerSchedulePage.changeTutorButton"
      }),
      appearance: "primary",
      onClick: handleChangeTutor
    }]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/beginner-dashboard.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const beginner_dashboard_page_module = ({"root":"beginner-dashboard-page-module__root--jke7I","content":"beginner-dashboard-page-module__content--iAQOp","teacher-info":"beginner-dashboard-page-module__teacher-info--CA8y_","teacherInfo":"beginner-dashboard-page-module__teacher-info--CA8y_","teacher-card":"beginner-dashboard-page-module__teacher-card--f32dx","teacherCard":"beginner-dashboard-page-module__teacher-card--f32dx","link-card":"beginner-dashboard-page-module__link-card--feEBp","linkCard":"beginner-dashboard-page-module__link-card--feEBp","lessons-history":"beginner-dashboard-page-module__lessons-history--wo48t","lessonsHistory":"beginner-dashboard-page-module__lessons-history--wo48t","schedule-button-wrapper":"beginner-dashboard-page-module__schedule-button-wrapper--jgGE9","scheduleButtonWrapper":"beginner-dashboard-page-module__schedule-button-wrapper--jgGE9","card":"beginner-dashboard-page-module__card--kdXQe","balance-wrapper":"beginner-dashboard-page-module__balance-wrapper--5SBFL","balanceWrapper":"beginner-dashboard-page-module__balance-wrapper--5SBFL","course-map-widget":"beginner-dashboard-page-module__course-map-widget--KidNv","courseMapWidget":"beginner-dashboard-page-module__course-map-widget--KidNv","schedule-button":"beginner-dashboard-page-module__schedule-button--uibeX","scheduleButton":"beginner-dashboard-page-module__schedule-button--uibeX"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/ui/beginner-dashboard.page.tsx






































const BeginnerDashboardPage = _ref => {
  let {
    currentProductId
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    resources,
    resourcesExperiment,
    showCourseMap,
    autopayByResource
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const [isAutopayInProgress, setIsAutopayInProgress] = (0,react.useState)(false);
  const [tutorInfoPopupVisibility, setTutorInfoPopupVisibility] = (0,react.useState)(false);
  const getStudentPartialPaymentInfo = (0,effector_react/* useEvent */.zX)(getStudentPartialPaymentInfoFx);
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    isOpen: isAutopayChooseCardModalOpen,
    handleOpen: openAutopayChooseCardModal,
    handleClose: closeAutopayChooseCardModal
  } = (0,use_modal_toggle/* useModalToggle */.N)();
  const {
    isOpen: isAutoTutorChangeVisible,
    handleOpen: openAutoTutorChange,
    handleClose: closeAutoTutorChange
  } = (0,use_modal_toggle/* useModalToggle */.N)();
  const {
    viewModel: {
      nearestScheduledSpeakingSessionScheduleInfo: schedulerInfo,
      nearestScheduledSpeakingSessions
    }
  } = useStudentSchedule();
  const nearestSpeakingSessionsStartDate = nearestScheduledSpeakingSessions.map(_ref2 => {
    let {
      startAt
    } = _ref2;
    return startAt;
  });
  const rescheduleLessonPopupService = useRescheduleLessonPopupService();
  const {
    notCompletedForeignerSpeakings,
    initialForeignerSpeakings,
    scheduledForeignerSpeakings,
    setSchedulingSpeakingId,
    setCancelingSessionId,
    setForeignerSpeakings
  } = (0,use_foreigner_sessions/* useForeignerSpeakings */.w)();
  const {
    data: foreignerSpeakings
  } = useForeignerSpeakingsQuery(businessProductId);
  (0,react.useEffect)(() => {
    if (foreignerSpeakings) {
      setForeignerSpeakings(foreignerSpeakings);
    }
  }, [foreignerSpeakings, setForeignerSpeakings]);
  (0,react.useEffect)(() => {
    autopayByResource && businessProductId && void getStudentPartialPaymentInfo(businessProductId);
  }, [businessProductId, autopayByResource, getStudentPartialPaymentInfo]);
  (0,useUnmount/* default */.Z)(() => {
    resetStudentPartialPaymentInfo();
  });
  const {
    data: courseLevel
  } = useCourseLevelQuery(businessProductId);
  const handleOpenSchedulePopup = speakingId => {
    history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getOpenUrl(speakingId, history));
    setSchedulingSpeakingId({
      speakingId
    });
  };
  const handleOpenCancelingPopup = sessionId => {
    history.push(get_url_search_params.getUrlSearchParams.cancelSpeakingPopup.getOpenUrl(sessionId, history));
    setCancelingSessionId({
      sessionId
    });
  };
  const handlePostAutopayEvent = () => {
    setIsAutopayInProgress(true);
  };
  const untilDate = (0,react.useMemo)(() => {
    const date = schedulerInfo?.replacementUntilDate;
    return date ?? /* @__PURE__ */new Date();
  }, [schedulerInfo?.replacementUntilDate]);
  const renderTutorInfo = (0,react.useCallback)(() => {
    const tutorAvatar = (0,avatar_utils/* getYandexAvatarById */.m$)({
      id: schedulerInfo?.tutorAvatarId,
      size: "islands-200"
    });
    const tutorCaption = schedulerInfo?.isReplacementTutor ? intl.formatMessage({
      id: "beginnerSchedulePage.replacementTeacherCardSubtitle"
    }, {
      date: (0,format/* format */.WU)(untilDate, "d MMMM", {
        locale: utils_locale/* dateFnsLocale */.Y
      })
    }) : intl.formatMessage({
      id: "beginnerSchedulePage.teacherCardSubtitle"
    });
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: beginner_dashboard_page_module.teacherInfo,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(LessonCard, {
        tutorAvatar
      }), schedulerInfo && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: beginner_dashboard_page_module.teacherCard,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherCard, {
            textConstants: {
              title: schedulerInfo.tutorFirstName ?? "",
              subtitle: tutorCaption,
              ariaLabel: intl.formatMessage({
                id: "beginnerSchedulePage.openTutorDescription"
              })
            },
            imageSrc: tutorAvatar,
            onClick: () => {
              (0,yandexMetrica/* ymGoal */.qf)("allow_tutor_change_by_student_open_description");
              setTutorInfoPopupVisibility(true);
            }
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(TutorInfoPopup, {
          initialTutorId: schedulerInfo.tutorId,
          isVisible: tutorInfoPopupVisibility,
          onClose: () => setTutorInfoPopupVisibility(false),
          onOpenAutoTutorChange: openAutoTutorChange
        })]
      })]
    });
  }, [schedulerInfo, intl, untilDate, tutorInfoPopupVisibility, openAutoTutorChange]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(layout_component/* Layout */.A, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: beginner_dashboard_page_module.root,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: beginner_dashboard_page_module.content,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(BannerBlocks, {
            isAutopayInProgress,
            onButtonClick: openAutopayChooseCardModal
          }), notCompletedForeignerSpeakings.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerSpeakings, {
            initialForeignerSpeakings,
            scheduledForeignerSpeakings,
            onSpeakingSchedule: handleOpenSchedulePopup,
            onSessionCancel: handleOpenCancelingPopup
          }), renderTutorInfo(), showCourseMap && courseLevel && /* @__PURE__ */(0,jsx_runtime.jsx)(CourseMapWidget, {
            courseLevel,
            className: beginner_dashboard_page_module.courseMapWidget
          }), (resources.enabled || resourcesExperiment) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: beginner_dashboard_page_module.balanceWrapper,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ResourcesBalanceWrapper, {})
          })]
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ForeignerSessionsPopups, {
        currentProductId
      })]
    }), rescheduleLessonPopupService.isOpenPopup && /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopup, {}), showCourseMap && businessProductId && courseLevel && /* @__PURE__ */(0,jsx_runtime.jsx)(CourseMapPopup, {
      businessProductId,
      courseLevel
    }), isAutoTutorChangeVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(AutoTutorChange, {
      onClose: closeAutoTutorChange,
      nearestSpeakingSessions: nearestSpeakingSessionsStartDate
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(AutopayChooseCardModal, {
      isVisible: autopayByResource && isAutopayChooseCardModalOpen,
      onClose: closeAutopayChooseCardModal,
      onPostAutopayEvent: handlePostAutopayEvent
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/dashboard-page/index.ts



;// CONCATENATED MODULE: ../ui-kit/src/box/box.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const box_box_module = ({"root":"box-module__root--gV4Oy","root-with-image":"box-module__root-with-image--ZotBQ","rootWithImage":"box-module__root-with-image--ZotBQ","root-white":"box-module__root-white--cygof","rootWhite":"box-module__root-white--cygof","root-payment":"box-module__root-payment--Qe4jh","rootPayment":"box-module__root-payment--Qe4jh","content":"box-module__content--hv2io","subtitle":"box-module__subtitle--KaT96","subtitle-payment":"box-module__subtitle-payment--AFs7H","subtitlePayment":"box-module__subtitle-payment--AFs7H","action-controls":"box-module__action-controls--j7veP","actionControls":"box-module__action-controls--j7veP","action-controls-payment":"box-module__action-controls-payment--irSpo","actionControlsPayment":"box-module__action-controls-payment--irSpo","action-control":"box-module__action-control--a40k0","actionControl":"box-module__action-control--a40k0","action-control-payment":"box-module__action-control-payment--Tlr9D","actionControlPayment":"box-module__action-control-payment--Tlr9D","loader":"box-module__loader--gubaf","image":"box-module__image--oEZPt"});
;// CONCATENATED MODULE: ../ui-kit/src/box/box.component.tsx











var BoxAppearance = /* @__PURE__ */(BoxAppearance2 => {
  BoxAppearance2[BoxAppearance2["Default"] = 0] = "Default";
  BoxAppearance2[BoxAppearance2["Payment"] = 1] = "Payment";
  return BoxAppearance2;
})(BoxAppearance || {});
var BgColors = /* @__PURE__ */(BgColors2 => {
  BgColors2["LightGrey"] = "lightGrey";
  BgColors2["White"] = "white";
  return BgColors2;
})(BgColors || {});
const box_component_Box = _ref => {
  let {
    title,
    subtitle,
    actionButtons,
    isLoading = false,
    appearance = 0 /* Default */,
    className = "",
    image = null,
    bgColor = "lightGrey" /* LightGrey */
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(box_box_module.root, className, {
      [box_box_module.rootWithImage]: Boolean(image),
      [box_box_module.rootPayment]: appearance === 1 /* Payment */,
      [box_box_module.rootWhite]: bgColor === "white" /* White */
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: box_box_module.content,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, {
            [typography_module/* default */.Z.headline4Accent]: appearance === 1 /* Payment */
          }),
          children: title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2, box_box_module.subtitle, {
            [box_box_module.subtitlePayment]: appearance === 1 /* Payment */
          }),
          children: subtitle
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(box_box_module.actionControls, {
          [box_box_module.actionControlsPayment]: appearance === 1 /* Payment */
        }),
        children: [isLoading && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: box_box_module.loader,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
        }), !isLoading && actionButtons.map(a => /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          onClick: a.onClick,
          className: classnames_default()(box_box_module.actionControl, typography_module/* default */.Z.body2Accent, {
            [box_box_module.actionControlPayment]: appearance === 1 /* Payment */
          }),
          appearance: a.appearance,
          size: "medium",
          children: a.title
        }, a.title))]
      })]
    }), image && /* @__PURE__ */(0,jsx_runtime.jsx)(ImageElement, {
      src: image,
      width: "",
      height: "",
      classes: {
        root: box_box_module.image
      }
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/education-materials-page/beginner-education-materials.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const beginner_education_materials_page_module = ({"root":"beginner-education-materials-page-module__root--P7Cuf","action-boxes":"beginner-education-materials-page-module__action-boxes--RMw_x","actionBoxes":"beginner-education-materials-page-module__action-boxes--RMw_x","action-box":"beginner-education-materials-page-module__action-box--SJyNi","actionBox":"beginner-education-materials-page-module__action-box--SJyNi"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/education-materials-page/beginner-education-materials.page.tsx
















const BeginnerEducationMaterialsPage = _ref => {
  let {
    currentProductId,
    isRepetitionAvailable
  } = _ref;
  const {
    isMentorNotesVisible,
    fixedChapters
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    isTabletOrDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const wordbankBoxActions = (0,react.useMemo)(() => {
    const actions = [];
    if (isRepetitionAvailable) {
      actions.push({
        title: intl.formatMessage({
          id: "studentIndexPageContent.repeat"
        }),
        onClick: () => {
          get_url_search_params.getUrlSearchParams.retPath.goToLinkWithRetPath({
            link: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REPETITION(currentProductId),
            history
          });
        },
        appearance: "primary"
      });
    }
    actions.push({
      title: intl.formatMessage({
        id: "studentIndexPageContent.myWordBank"
      }),
      onClick: () => {
        history.push(get_url_search_params.getUrlSearchParams.wordbankPopup.getOpenUrl(history));
      },
      appearance: isRepetitionAvailable ? "secondary" : "primary"
    });
    return actions;
  }, [currentProductId, history, intl, isRepetitionAvailable]);
  const fixedChaptersBoxes = (0,react.useMemo)(() => {
    if (fixedChapters === null) {
      return null;
    }
    return fixedChapters.map(chapter => /* @__PURE__ */(0,jsx_runtime.jsx)(box_component_Box, {
      title: chapter.title,
      subtitle: chapter.subtitle,
      actionButtons: [{
        title: intl.formatMessage({
          id: "studentIndexPageContent.watch"
        }),
        onClick: () => {
          get_url_search_params.getUrlSearchParams.retPath.goToLinkWithRetPath({
            link: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(currentProductId, chapter.chapterId),
            history
          });
        },
        appearance: "primary"
      }],
      image: chapter.image,
      className: beginner_education_materials_page_module.actionBox,
      bgColor: BgColors.White
    }, chapter.chapterId));
  }, [currentProductId, fixedChapters, history, intl]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: beginner_education_materials_page_module.root,
      children: isTabletOrDesktop && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: beginner_education_materials_page_module.actionBoxes,
        children: [wordbankBoxActions.length !== 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(box_component_Box, {
          title: intl.formatMessage({
            id: "studentIndexPageContent.wordBank"
          }),
          subtitle: intl.formatMessage({
            id: "studentIndexPageContent.letRepeatWords"
          }),
          actionButtons: wordbankBoxActions,
          className: beginner_education_materials_page_module.actionBox,
          bgColor: BgColors.White
        }), isMentorNotesVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(box_component_Box, {
          title: intl.formatMessage({
            id: "studentIndexPageContent.notes"
          }),
          subtitle: intl.formatMessage({
            id: "studentIndexPageContent.notesSubtitle"
          }),
          actionButtons: [{
            title: intl.formatMessage({
              id: "studentIndexPageContent.watch"
            }),
            onClick: () => {
              get_url_search_params.getUrlSearchParams.retPath.goToLinkWithRetPath({
                link: studentRoutePaths/* studentRoutePaths */.dR.NOTES({}),
                history
              });
            },
            appearance: "primary"
          }],
          className: beginner_education_materials_page_module.actionBox,
          bgColor: BgColors.White
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(box_component_Box, {
          title: intl.formatMessage({
            id: "studentIndexPageContent.grammarGuideTitle"
          }),
          subtitle: intl.formatMessage({
            id: "studentIndexPageContent.grammarGuideSubtitle"
          }),
          actionButtons: [{
            title: intl.formatMessage({
              id: "studentIndexPageContent.grammarGuideButton"
            }),
            onClick: () => {
              history.push(get_url_search_params.getUrlSearchParams.grammarGuide.getOpenUrl(history));
            },
            appearance: "primary"
          }],
          className: beginner_education_materials_page_module.actionBox,
          bgColor: BgColors.White
        }), fixedChaptersBoxes]
      })
    })
  });
};
// EXTERNAL MODULE: ./src/api/student/student.urls.ts
var student_urls = __webpack_require__(44328);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/api/errors.ts



var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class NoCourseProgressError extends Error {
  constructor() {
    super("NoCourseProgress");
  }
}
__publicField(NoCourseProgressError, "id", "no_course_progress_for_student");
class CourseNotFoundError extends Error {
  constructor() {
    super("CourseNotFound");
  }
}
__publicField(CourseNotFoundError, "id", "course_not_found");
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/types.ts


var Tabs = /* @__PURE__ */(Tabs2 => {
  Tabs2["Skills"] = "skills";
  Tabs2["Tests"] = "tests";
  Tabs2["Program"] = "program";
  return Tabs2;
})(Tabs || {});
var ProgressTestState = /* @__PURE__ */(ProgressTestState2 => {
  ProgressTestState2["NotAssigned"] = "not_assigned";
  ProgressTestState2["Assigned"] = "assigned";
  ProgressTestState2["InProgress"] = "in_progress";
  ProgressTestState2["Processing"] = "processing";
  ProgressTestState2["Passed"] = "passed";
  return ProgressTestState2;
})(ProgressTestState || {});
var ProgressTestType = /* @__PURE__ */(ProgressTestType2 => {
  ProgressTestType2["Oral"] = "oral";
  ProgressTestType2["Written"] = "written";
  ProgressTestType2["Unknown"] = "unknown";
  return ProgressTestType2;
})(ProgressTestType || {});
var ProgressTestGroupType = /* @__PURE__ */(ProgressTestGroupType2 => {
  ProgressTestGroupType2["Assessment"] = "assessment";
  ProgressTestGroupType2["ProgressTest"] = "progress-test";
  ProgressTestGroupType2["MidcourseTest"] = "midcourse-test";
  ProgressTestGroupType2["Exam"] = "exam";
  return ProgressTestGroupType2;
})(ProgressTestGroupType || {});
var Skills = /* @__PURE__ */(Skills2 => {
  Skills2["Lexis"] = "lexis";
  Skills2["Speaking"] = "speaking";
  Skills2["Phrases"] = "phrases";
  Skills2["Reading"] = "reading";
  Skills2["Grammar"] = "grammar";
  Skills2["Listening"] = "listening";
  return Skills2;
})(Skills || {});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/api/utils.ts













const mapCourseProgressTestsToGroups = courseProgressTests => {
  const groups = [];
  courseProgressTests.tests.forEach(test => {
    const group = groups.find(group2 => group2.type === test.groupType && group2.number === test.moduleNumber) ?? {
      type: test.groupType,
      name: test.moduleName ?? "",
      number: test.moduleNumber ?? 0,
      tests: []
    };
    if (!groups.includes(group)) {
      groups.push(group);
    }
    group.tests.push({
      id: test.id,
      state: test.state,
      type: test.testType,
      chapterId: test.chapterId,
      syllabusNodeId: test.syllabusNodeId,
      skillResults: test.skillResults,
      maxSkillScores: test.maxSkillScores,
      assignedDate: test.assignedDate ? (0,parseISO/* parseISO */.D)(test.assignedDate) : null,
      finishedDate: test.finishedDate ? (0,parseISO/* parseISO */.D)(test.finishedDate) : null,
      reportUrl: test.reportUrl
    });
  });
  return groups;
};
const extractAssessmentTest = testResults => {
  const progressTests = {};
  let assessmentTest;
  Object.values(testResults).forEach(value => {
    const tests = value.tests.find(test => test.groupType === ProgressTestGroupType.Assessment);
    if (tests) {
      assessmentTest = {
        courseName: "",
        tests: [tests]
      };
    }
  });
  Object.entries(testResults).forEach(_ref => {
    let [courseSlug, value] = _ref;
    progressTests[courseSlug] = {
      courseName: value.courseName,
      tests: value.tests.filter(test => test.groupType !== ProgressTestGroupType.Assessment)
    };
  });
  return {
    assessmentTest,
    progressTests
  };
};
const convertTestsToTestGroups = (testResults, currentCourseSlug) => {
  const groupedProgressTests = {};
  logWrongTestData(testResults, currentCourseSlug);
  const {
    assessmentTest,
    progressTests
  } = extractAssessmentTest(testResults);
  Object.entries(progressTests).forEach(_ref2 => {
    let [courseSlug, value] = _ref2;
    groupedProgressTests[courseSlug] = {
      courseName: value.courseName,
      testsGroup: mapCourseProgressTestsToGroups(value)
    };
  });
  const assessmentTestGroup = assessmentTest ? mapCourseProgressTestsToGroups(assessmentTest)[0] : void 0;
  return {
    assessmentTest: assessmentTestGroup,
    groupedProgressTests
  };
};
const logWrongTestData = (testResults, currentCourseSlug) => {
  if (currentCourseSlug && currentCourseSlug in testResults) {
    const REQUIRED_TESTS_COUNT = 22;
    const testsCount = testResults[currentCourseSlug]?.tests?.length || 0;
    if (testsCount < REQUIRED_TESTS_COUNT) {
      logger/* Logger */.Yd.captureWarning("tests count for current course less than required", {
        testResults,
        currentCourseSlug,
        testsCount
      }, {
        method: "convertTestsToTestGroups",
        block: "test-results"
      });
    }
  } else {
    logger/* Logger */.Yd.captureWarning("no tests for current course found", {
      testResults,
      currentCourseSlug
    }, {
      method: "convertTestsToTestGroups",
      block: "test-results"
    });
  }
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/api/mapper.ts










const mapTestResultResponse = _ref => {
  let {
    data
  } = _ref;
  return data;
};
const mapTestResultsResponse = (_ref2, currentCourseSlug) => {
  let {
    data
  } = _ref2;
  const result = {};
  Object.entries(data).forEach(_ref3 => {
    let [courseSlug, value] = _ref3;
    result[courseSlug] = {
      courseName: value.course_name,
      tests: value.tests.map(test => ({
        id: test.id,
        groupType: test.group_type,
        moduleName: test.module_name,
        moduleNumber: test.module_number,
        state: test.state,
        chapterId: test.chapter_id,
        syllabusNodeId: test.syllabus_node_id,
        assignedDate: test.assigned_date,
        finishedDate: test.finished_date,
        skillResults: test.skill_results,
        maxSkillScores: test.max_skill_scores,
        testType: test.test_type,
        reportUrl: test.report_url
      }))
    };
  });
  return convertTestsToTestGroups(result, currentCourseSlug);
};
const errorMapper = error => {
  if (error.code === NoCourseProgressError.id) {
    return new NoCourseProgressError();
  }
  if (error.code === CourseNotFoundError.id) {
    return new CourseNotFoundError();
  }
  return api_model/* unexpectedError */.g;
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/api/raw-model.ts




const RawProgressTestState = es6.keyof({
  [ProgressTestState.Assigned]: es6["null"],
  [ProgressTestState.InProgress]: es6["null"],
  [ProgressTestState.Passed]: es6["null"]
});
const RawProgressTestType = es6.keyof({
  [ProgressTestType.Oral]: es6["null"],
  [ProgressTestType.Written]: es6["null"],
  [ProgressTestType.Unknown]: es6["null"]
});
const RawSkill = es6.keyof({
  [Skills.Listening]: es6["null"],
  [Skills.Reading]: es6["null"],
  [Skills.Lexis]: es6["null"],
  [Skills.Phrases]: es6["null"],
  [Skills.Speaking]: es6["null"],
  [Skills.Grammar]: es6["null"]
});
const RawProgressTestGroupType = es6.keyof({
  [ProgressTestGroupType.Assessment]: es6["null"],
  [ProgressTestGroupType.ProgressTest]: es6["null"],
  [ProgressTestGroupType.MidcourseTest]: es6["null"],
  [ProgressTestGroupType.Exam]: es6["null"]
});
const RawProgressTest = es6.type({
  id: es6.string,
  group_type: RawProgressTestGroupType,
  module_name: es6.union([es6.string, es6["null"]]),
  module_number: es6.union([es6.number, es6["null"]]),
  state: RawProgressTestState,
  chapter_id: es6.union([es6.string, es6["null"]]),
  syllabus_node_id: es6.union([es6.string, es6["null"]]),
  assigned_date: es6.union([es6.string, es6["null"]]),
  finished_date: es6.union([es6.string, es6["null"]]),
  skill_results: es6.record(RawSkill, es6.number),
  max_skill_scores: es6.record(RawSkill, es6.number),
  test_type: RawProgressTestType,
  report_url: es6.union([es6.string, es6["null"]])
});
const RawCourseTestResults = es6.type({
  tests: es6.array(RawProgressTest),
  course_name: es6.string
});
const RawTestResultsData = es6.record(es6.string, RawCourseTestResults);
const RawTestResultsResponse = es6.type({
  data: RawTestResultsData
});
const RawTestResultBlock = es6.type({
  title: es6.string,
  score: es6.string,
  recommendation: es6.string
});
const RawTestResultData = es6.type({
  id: es6.string,
  blocks: es6.array(RawTestResultBlock)
});
const RawTestResultResponse = es6.type({
  data: RawTestResultData
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/api/api.ts







const getTestResult = (0,un_either/* unEither */.K)(testId => (0,http/* makeRequest */.$f)((0,student_urls/* GET_TEST_RESULT */.F7)(testId), {
  responseType: RawTestResultResponse,
  resultMapper: mapTestResultResponse
}));
const getTestResults = (0,un_either/* unEither */.K)((businessProductId, currentCourseSlug) => (0,http/* makeRequest */.$f)((0,student_urls/* GET_TEST_RESULTS */.MR)(businessProductId), {
  responseType: RawTestResultsResponse,
  resultMapper: data => mapTestResultsResponse(data, currentCourseSlug),
  errorMapper: errorMapper
}));
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/api/use-test-results-query.ts





const useTestResultsQuery = (businessProductId, currentCourseSlug) => {
  const queryKey = (0,react.useMemo)(() => ["testResults", businessProductId, currentCourseSlug], [businessProductId, currentCourseSlug]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(businessProductId) && Boolean(currentCourseSlug),
    queryKey,
    queryFn: () => {
      if (!businessProductId) {
        return;
      }
      return getTestResults(businessProductId, currentCourseSlug);
    },
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/course-program/empty-screen/empty-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const empty_screen_module = ({"container":"empty-screen-module__container--WlP7I","image":"empty-screen-module__image--yh5rT"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/course-program/empty-screen/empty-screen.tsx






const EmptyScreen = _ref => {
  let {
    title,
    subtitle,
    imageSrc,
    testId = ""
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: empty_screen_module.container,
    "data-testid": testId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: empty_screen_module.image,
      alt: "",
      src: imageSrc
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: isMobile ? typography_module/* default */.Z.headline4Accent : typography_module/* default */.Z.headline3,
      children: title
    }), subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body2,
      children: subtitle
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/course-program/course-map-content/course-program-loader.tsx







const CourseProgramLoader = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
  className: empty_screen_module.container,
  "data-testid": "course-program-loader",
  children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
    className: typography_module/* default */.Z.headline4Accent,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "progressPage.program.courseMap.loader"
    })
  })]
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/course-program/course-map-content/course-map-content.tsx











const CourseMapContent = _ref => {
  let {
    businessProductId,
    courseLevel
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const courseMapVersionsFlag = (0,features/* useFeatureFlag */.ye)("courseMapVersions");
  const {
    data: courseMap,
    isError: courseMapError,
    isLoading: courseMapLoading
  } = useCourseMapQuery({
    businessProductId,
    courseLevel,
    courseMapVersionsFlag
  });
  (0,react.useEffect)(() => {
    if (courseMapError) {
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        id: "progressPage.loadDataError"
      }), {
        toastId: "loadCourseMapDataError",
        autoClose: false
      });
    }
  }, [courseMapError, intl]);
  if (courseMapLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgramLoader, {});
  }
  if (courseMapError) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyScreen, {
      title: intl.formatMessage({
        id: "progressPage.loadDataError"
      }),
      imageSrc: "https://flowstatic.s3.yandex.net/ui-files/paint.svg",
      testId: "loading-error-screen"
    });
  }
  if (!courseMap) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyScreen, {
      title: intl.formatMessage({
        id: "progressPage.program.courseMap.emptyScreenTitle"
      }),
      imageSrc: "https://flowstatic.s3.yandex.net/ui-files/clock.svg",
      testId: ""
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(CourseMap, {
    businessProductId,
    courseLevel,
    isNarrowContainer: true
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/course-program/course-program.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_program_module = ({"container":"course-program-module__container--GQ4D0","header":"course-program-module__header--_0Erp","menu":"course-program-module__menu--nL9EK"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/course-program/course-program.tsx








const CourseProgram = _ref => {
  let {
    businessProductId,
    courseLevel
  } = _ref;
  const titleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: course_program_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      id: titleId,
      className: course_program_module.header,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: typography_module/* default */.Z.headline3,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "progressPage.program.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_program_module.menu
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(CourseMapContent, {
      businessProductId,
      courseLevel
    })]
  });
};
// EXTERNAL MODULE: ./src/widgets/task-guide/student-tests/student-tests.tsx + 5 modules
var student_tests = __webpack_require__(88008);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/toggle-tests.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggle_tests_module = ({"root":"toggle-tests-module__root--lrxNc","button":"toggle-tests-module__button--SMkN_","button-label-block":"toggle-tests-module__button-label-block--rYOBF","buttonLabelBlock":"toggle-tests-module__button-label-block--rYOBF","button-completed-icon":"toggle-tests-module__button-completed-icon--T6TuA","buttonCompletedIcon":"toggle-tests-module__button-completed-icon--T6TuA","clock-icon":"toggle-tests-module__clock-icon--NKFab","clockIcon":"toggle-tests-module__clock-icon--NKFab","tests-table":"toggle-tests-module__tests-table--k2e54","testsTable":"toggle-tests-module__tests-table--k2e54","tests-table-open":"toggle-tests-module__tests-table-open--fJp9T","testsTableOpen":"toggle-tests-module__tests-table-open--fJp9T","transition":"toggle-tests-module__transition--_sUtO","arrow-button-transform":"toggle-tests-module__arrow-button-transform--YESJU","arrowButtonTransform":"toggle-tests-module__arrow-button-transform--YESJU"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/progress-tests.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const progress_tests_module = ({"root":"progress-tests-module__root--GH37P","skeleton-item":"progress-tests-module__skeleton-item--jtL9h","skeletonItem":"progress-tests-module__skeleton-item--jtL9h","skeleton":"progress-tests-module__skeleton--piihV"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/progress-tests-skeleton.tsx







const ProgressTestsSkeleton = _ref => {
  let {
    enableAnimation
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
    theme: skeleton/* SkeletonTheme */.y.Light,
    className: progress_tests_module.skeleton,
    enableAnimation,
    wrapper: _ref2 => {
      let {
        children
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(toggle_tests_module.button, progress_tests_module.skeletonItem),
        children
      });
    },
    count: 5
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/constants.ts



const toggleButtonKeys = {
  [ProgressTestGroupType.Assessment]: "progressPage.tests.groupTypes.assessment.toggleButton.label",
  [ProgressTestGroupType.MidcourseTest]: "progressPage.tests.groupTypes.midcourse.toggleButton.label",
  [ProgressTestGroupType.ProgressTest]: "progressPage.tests.groupTypes.progressTest.toggleButton.label",
  [ProgressTestGroupType.Exam]: "progressPage.tests.groupTypes.exam.toggleButton.label"
};
const TOGGLE_BUTTON_OPEN_TEST_ID = "toggleButtonOpenTestId";
const TOGGLE_BUTTON_CLOSED_TEST_ID = "toggleButtonClosedTestId";
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/constants.ts



const buttonTextKeys = {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  [ProgressTestState.NotAssigned]: "progressPage.tests.statuses.assigned.buttonText",
  [ProgressTestState.Assigned]: "progressPage.tests.statuses.assigned.buttonText",
  /**
   * Сейчас используется внешняя платформа (VCV) для прохождения устного теста,
   * поэтому фактический статус processing невозможно оценить корректно.
   * В связи с этим до перехода на свою платформу для отображения кнопки используем аналогичную с assigned,
   * чтобы пользователь мог повторно посетить страницу с инструкциями.
   * Прежнее id: "progressPage.tests.statuses.processing.buttonText"
   */
  [ProgressTestState.Processing]: "progressPage.tests.statuses.assigned.buttonText",
  [ProgressTestState.InProgress]: "progressPage.tests.statuses.inProgress.buttonText",
  [ProgressTestState.Passed]: "progressPage.tests.statuses.completed.buttonText"
};
const buttonTestId = {
  [ProgressTestState.NotAssigned]: "progressTestButtonNotAssignedTestId",
  [ProgressTestState.Assigned]: "progressTestButtonAssignedTestId",
  [ProgressTestState.Processing]: "progressTestButtonProcessingTestId",
  [ProgressTestState.InProgress]: "progressTestButtonInProgressTestId",
  [ProgressTestState.Passed]: "progressTestButtonPassedTestId"
};
const testTypeKeys = {
  [ProgressTestType.Oral]: "progressPage.tests.types.oral",
  [ProgressTestType.Written]: "progressPage.tests.types.writing",
  [ProgressTestType.Unknown]: "progressPage.tests.types.unknown"
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/use-test-row-view-model.ts






const useTestRowViewModel = (_ref, groupType) => {
  let {
    type,
    state,
    reportUrl,
    chapterId,
    id
  } = _ref;
  const user = (0,useUser/* useUser */.aF)();
  const href = (0,react.useMemo)(() => {
    const returnPath = studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.TESTS;
    if (state === ProgressTestState.Passed && type === ProgressTestType.Oral) {
      return reportUrl ?? studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.TEST_RESULT(id);
    }
    const currentProductId = user.data?.attributes.currentProductId ?? "";
    return `${studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(currentProductId, chapterId ?? "")}?retPath=${returnPath}`;
  }, [state, type, user.data?.attributes.currentProductId, chapterId, reportUrl, id]);
  const isLinkVisible = groupType !== ProgressTestGroupType.Assessment && state !== ProgressTestState.NotAssigned;
  const isLinkDisabled = false;
  const linkAppearance = state === ProgressTestState.Assigned || state === ProgressTestState.InProgress || state === ProgressTestState.Processing ? "primary" : "secondary";
  return {
    href,
    isLinkVisible,
    isLinkDisabled,
    linkAppearance
  };
};
// EXTERNAL MODULE: ../../node_modules/date-fns/locale/ru.mjs + 6 modules
var ru = __webpack_require__(67739);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/utils.ts







function formatRawDate(date) {
  return (0,format/* format */.WU)(date, "d MMMM", {
    locale: ru.ru
  });
}
function sumSkillResults(results) {
  return Object.values(results ?? {}).reduce((sum, value) => sum + (value ?? 0), 0);
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/test-row.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const test_row_module = ({"root":"test-row-module__root--it2BD","cell":"test-row-module__cell--H6qjY","result-block":"test-row-module__result-block--JP_Us","resultBlock":"test-row-module__result-block--JP_Us","button":"test-row-module__button--ijwaj"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/test-row.tsx












const TestRow = _ref => {
  let {
    groupType,
    test
  } = _ref;
  const {
    type,
    assignedDate,
    skillResults,
    maxSkillScores,
    state,
    syllabusNodeId
  } = test;
  const {
    href,
    isLinkVisible,
    isLinkDisabled,
    linkAppearance
  } = useTestRowViewModel(test, groupType);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
    className: test_row_module.root,
    "data-syllabus-node-id": syllabusNodeId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("td", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, test_row_module.cell),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: testTypeKeys[type]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
      className: classnames_default()(typography_module/* default */.Z.body2, test_row_module.cell),
      children: assignedDate && /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
        children: formatRawDate(assignedDate)
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
      className: classnames_default()(typography_module/* default */.Z.body2Accent, test_row_module.resultBlock, test_row_module.cell),
      children: state === ProgressTestState.Passed && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        children: sumSkillResults(skillResults) + "/" + sumSkillResults(maxSkillScores)
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("td", {
      className: test_row_module.cell,
      children: isLinkVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
        appearance: linkAppearance,
        size: "small",
        className: classnames_default()(typography_module/* default */.Z.captionAccent, test_row_module.button),
        href,
        disabled: isLinkDisabled,
        target: "_self",
        "data-testid": buttonTestId[state],
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: buttonTextKeys[state]
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/tests-table-desktop.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tests_table_desktop_module = ({"table":"tests-table-desktop-module__table--zW5XJ","thead":"tests-table-desktop-module__thead--yXZTO","theadRow":"tests-table-desktop-module__theadRow--7Gv88","th":"tests-table-desktop-module__th--PLAaf","tbody":"tests-table-desktop-module__tbody--q2v6H","button":"tests-table-desktop-module__button--YedKs"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/tests-table-desktop.tsx













const TestsTableDesktop = _ref => {
  let {
    groupType,
    tests
  } = _ref;
  const showAssignmentColumn = tests.some(test => test.assignedDate);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("table", {
    className: tests_table_desktop_module.table,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("thead", {
      className: tests_table_desktop_module.thead,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("tr", {
        className: tests_table_desktop_module.theadRow,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("th", {
          className: classnames_default()(typography_module/* default */.Z.body2, tests_table_desktop_module.th),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "progressPage.tests.tableHeaders.type"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("th", {
          className: classnames_default()(typography_module/* default */.Z.body2, tests_table_desktop_module.th),
          children: showAssignmentColumn && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "progressPage.tests.tableHeaders.date"
          })
        })]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("tbody", {
      className: tests_table_desktop_module.tbody,
      children: tests.map(test => /* @__PURE__ */(0,jsx_runtime.jsx)(TestRow, {
        groupType,
        test
      }, test.syllabusNodeId))
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/test-row-mobile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const test_row_mobile_module = ({"root":"test-row-mobile-module__root--bbxr9","info-block":"test-row-mobile-module__info-block--JDrj7","infoBlock":"test-row-mobile-module__info-block--JDrj7","main":"test-row-mobile-module__main--PR1nH","description":"test-row-mobile-module__description--WCjab","assigned-label":"test-row-mobile-module__assigned-label--HJowv","assignedLabel":"test-row-mobile-module__assigned-label--HJowv"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/test-row/test-row-mobile.tsx












const TestRowMobile = _ref => {
  let {
    groupType,
    test
  } = _ref;
  const {
    type,
    assignedDate,
    skillResults,
    maxSkillScores,
    state,
    syllabusNodeId
  } = test;
  const {
    href,
    isLinkVisible,
    isLinkDisabled,
    linkAppearance
  } = useTestRowViewModel(test, groupType);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: test_row_mobile_module.root,
    "data-syllabus-node-id": syllabusNodeId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: test_row_mobile_module.infoBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: test_row_mobile_module.main,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.body2Accent,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: testTypeKeys[type]
          })
        }), state === ProgressTestState.Passed && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.body2Accent,
          children: sumSkillResults(skillResults) + "/" + sumSkillResults(maxSkillScores)
        })]
      }), assignedDate && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: test_row_mobile_module.description,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(typography_module/* default */.Z.caption, test_row_mobile_module.assignedLabel),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "progressPage.tests.tableHeaders.date"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
          className: typography_module/* default */.Z.caption,
          children: formatRawDate(assignedDate)
        })]
      })]
    }), isLinkVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
      className: typography_module/* default */.Z.captionAccent,
      appearance: linkAppearance,
      disabled: isLinkDisabled,
      href,
      target: "_self",
      "data-testid": buttonTestId[state],
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: buttonTextKeys[state]
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/tests-table-mobile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tests_table_mobile_module = ({"root":"tests-table-mobile-module__root--UXYNG"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/tests-table-mobile.tsx







const TestTableMobile = _ref => {
  let {
    groupType,
    tests
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: tests_table_mobile_module.root,
    children: tests.map(test => /* @__PURE__ */(0,jsx_runtime.jsx)(TestRowMobile, {
      groupType,
      test
    }, test.syllabusNodeId))
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/tests-table/tests-table.tsx






const TestsTable = props => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  if (isMobile) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(TestTableMobile, {
      ...props
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TestsTableDesktop, {
    ...props
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-tests/toggle-tests.tsx















const ToggleTests = _ref => {
  let {
    testsGroup: {
      type,
      tests,
      number
    }
  } = _ref;
  const isCompleted = tests.every(test => test.state === ProgressTestState.Passed);
  const [tableElementHeight, setTableElementHeight] = (0,react.useState)(0);
  const [hasTransition, setHasTransition] = (0,react.useState)(false);
  const [open, setOpen] = (0,react.useState)(false);
  const handleClick = (0,react.useCallback)(() => {
    setHasTransition(true);
    setOpen(prev => !prev);
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: toggle_tests_module.root,
    style: {
      "--tests-max-height": `${tableElementHeight}px`
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      onClick: handleClick,
      className: toggle_tests_module.button,
      "data-testid": open ? TOGGLE_BUTTON_OPEN_TEST_ID : TOGGLE_BUTTON_CLOSED_TEST_ID,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: toggle_tests_module.buttonLabelBlock,
        children: [isCompleted ? /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: toggle_tests_module.buttonCompletedIcon,
          name: "check-solid",
          size: "small"
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: toggle_tests_module.clockIcon,
          name: "clock",
          size: "small"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.body2Accent,
          children: type === ProgressTestGroupType.ProgressTest ? /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: toggleButtonKeys[type],
            values: {
              number
            }
          }) : /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: toggleButtonKeys[type]
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "simple-arrow-down",
        size: "small",
        className: classnames_default()({
          [toggle_tests_module.transition]: hasTransition,
          [toggle_tests_module.arrowButtonTransform]: open
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(toggle_tests_module.testsTable, {
        [toggle_tests_module.transition]: hasTransition,
        [toggle_tests_module.testsTableOpen]: open
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        ref: element => element && setTableElementHeight(element.getBoundingClientRect().height),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TestsTable, {
          groupType: type,
          tests
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-course-tests-group/toggle-course-tests-group.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggle_course_tests_group_module = ({"root":"toggle-course-tests-group-module__root--Zxs68","button":"toggle-course-tests-group-module__button--uqmGe","button-label-block":"toggle-course-tests-group-module__button-label-block--s_ZVD","buttonLabelBlock":"toggle-course-tests-group-module__button-label-block--s_ZVD","button-completed-icon":"toggle-course-tests-group-module__button-completed-icon--a8QTy","buttonCompletedIcon":"toggle-course-tests-group-module__button-completed-icon--a8QTy","tests-table":"toggle-course-tests-group-module__tests-table--ytYb0","testsTable":"toggle-course-tests-group-module__tests-table--ytYb0","tests-table-open":"toggle-course-tests-group-module__tests-table-open--PiQ_k","testsTableOpen":"toggle-course-tests-group-module__tests-table-open--PiQ_k","transition":"toggle-course-tests-group-module__transition--fZ3ay","arrow-button-transform":"toggle-course-tests-group-module__arrow-button-transform--ecQqN","arrowButtonTransform":"toggle-course-tests-group-module__arrow-button-transform--ecQqN"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/toggle-course-tests-group/toggle-course-tests-group.tsx










const ToggleCourseTestsGroup = _ref => {
  let {
    isCurrentCourse,
    courseName,
    testsGroups
  } = _ref;
  const [hasTransition, setHasTransition] = (0,react.useState)(false);
  const [open, setOpen] = (0,react.useState)(isCurrentCourse);
  const handleClick = (0,react.useCallback)(() => {
    setHasTransition(true);
    setOpen(prev => !prev);
  }, []);
  if (testsGroups.length === 0) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: toggle_course_tests_group_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      type: "button",
      onClick: handleClick,
      className: toggle_course_tests_group_module.button,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: toggle_course_tests_group_module.buttonLabelBlock,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.body1Accent,
          children: courseName
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(toggle_course_tests_group_module.testsTable, {
        [toggle_course_tests_group_module.transition]: hasTransition,
        [toggle_course_tests_group_module.testsTableOpen]: open
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: testsGroups.reverse().map((testsGroup, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(ToggleTests, {
          testsGroup
        }, index))
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/utils.ts










const sortTestsGroups = (_ref, _ref2) => {
  let {
    number: a
  } = _ref;
  let {
    number: b,
    type: bType
  } = _ref2;
  if (a === b) {
    return bType === ProgressTestGroupType.ProgressTest ? 1 : -1;
  }
  return a > b ? 1 : -1;
};
const sortTests = (a, b) => b.type === ProgressTestType.Oral ? 1 : -1;
const filterNotAssignedTests = progressTestGroups => progressTestGroups.filter(group => group.tests.some(test => test.state !== ProgressTestState.NotAssigned)).sort(sortTestsGroups).map(group => ({
  ...group,
  tests: group.tests.sort(sortTests)
}));
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/progress-tests.tsx


















const ProgressTests = () => {
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    data: courseLevelInfo
  } = useCourseLevelQuery(businessProductId);
  const currentLevelCourseSlug = courseLevelInfo?.currentCourseSlug;
  const {
    isLoading,
    isError,
    error,
    data: groupedTestsResults
  } = useTestResultsQuery(businessProductId, currentLevelCourseSlug);
  if (isLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressTestsSkeleton, {
      enableAnimation: true
    });
  }
  if (isError) {
    logger/* Logger */.Yd.captureError("[ProgressTests] Failed to load student test results", {
      error
    }, {
      block: "ProgressTests",
      type: "network"
    });
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressTestsSkeleton, {
      enableAnimation: false
    });
  }
  const isTestsEmpty = !groupedTestsResults || Object.values(groupedTestsResults.groupedProgressTests).every(testGroup => testGroup.testsGroup.length === 0);
  if (isTestsEmpty) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(student_tests/* StudentTestsEmpty */.l, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: progress_tests_module.root,
    children: Object.entries(groupedTestsResults.groupedProgressTests).reverse().map(_ref => {
      let [courseSlug, group] = _ref;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(ToggleCourseTestsGroup, {
        isCurrentCourse: courseSlug === currentLevelCourseSlug,
        courseName: group.courseName,
        testsGroups: filterNotAssignedTests(group.testsGroup)
      }, courseSlug);
    })
  });
};
// EXTERNAL MODULE: ../shared/src/components/text-with-links/text-with-links.tsx + 1 modules
var text_with_links = __webpack_require__(29893);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/test-result/use-module-name.ts




const useModuleName = (moduleNumber, groupType) => {
  const intl = (0,useIntl/* default */.Z)();
  if (groupType === ProgressTestGroupType.MidcourseTest) {
    return intl.formatMessage({
      id: "beginnerPage.progressTests.testResult.midcourse"
    });
  }
  if (groupType === ProgressTestGroupType.Exam) {
    return intl.formatMessage({
      id: "beginnerPage.progressTests.testResult.exam"
    });
  }
  return intl.formatMessage({
    id: "beginnerPage.progressTests.testResult.module"
  }, {
    moduleNumber
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/test-result/utils.ts


const getLevelOfTest = (testId, currentCourseSlug, groupedTestsResults) => {
  if (!groupedTestsResults?.groupedProgressTests?.[currentCourseSlug]) {
    return {};
  }
  const {
    testsGroup
  } = groupedTestsResults.groupedProgressTests[currentCourseSlug];
  for (const testGroup of testsGroup) {
    for (const test of testGroup.tests) {
      if (test.id === testId) {
        return {
          moduleNumber: testGroup.number,
          groupType: testGroup.type
        };
      }
    }
  }
  return {};
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/test-result/test.result.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const test_result_module = ({"root":"test-result-module__root--orWDC","title":"test-result-module__title--zUNWS","block":"test-result-module__block--FXbY3","block-title":"test-result-module__block-title--FkdhH","blockTitle":"test-result-module__block-title--FkdhH","block-score":"test-result-module__block-score--c3eTP","blockScore":"test-result-module__block-score--c3eTP","block-recommendation-title":"test-result-module__block-recommendation-title--QzixF","blockRecommendationTitle":"test-result-module__block-recommendation-title--QzixF"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/progress-tests/test-result/test-result.tsx



















const TestResult = () => {
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    testId
  } = (0,react_router/* useParams */.UO)();
  const [blocks, setBlocks] = (0,react.useState)();
  (0,react.useEffect)(() => {
    void getTestResult(testId).then(_ref => {
      let {
        blocks: blocks2
      } = _ref;
      return setBlocks(blocks2);
    });
  }, [testId]);
  const {
    data: courseLevelInfo
  } = useCourseLevelQuery(businessProductId);
  const {
    data: groupedTestsResults
  } = useTestResultsQuery(businessProductId, courseLevelInfo?.currentCourseSlug);
  const currentCourseSlug = courseLevelInfo?.currentCourseSlug || "";
  const {
    moduleNumber,
    groupType
  } = getLevelOfTest(testId, currentCourseSlug, groupedTestsResults);
  const moduleName = useModuleName(moduleNumber, groupType);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
    className: test_result_module.root,
    children: [moduleName && currentCourseSlug && /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      className: classnames_default()(typography_module/* default */.Z.headline3, test_result_module.title),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "beginnerPage.progressTests.testResult.title",
        values: {
          currentCourseSlug: currentCourseSlug.toUpperCase(),
          module: moduleName
        }
      })
    }), blocks && blocks.map(block => /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
      className: test_result_module.block,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, test_result_module.blockTitle),
        children: block.title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body1, test_result_module.blockScore),
        children: block.score
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("h3", {
        className: classnames_default()(typography_module/* default */.Z.body2Accent, test_result_module.blockRecommendationTitle),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "beginnerPage.progressTests.testResult.recommendation"
        }), ":"]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.body2,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(text_with_links/* TextWithLinks */.X, {
          text: block.recommendation
        })
      })]
    }, block.title))]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/circle-progress-bar/constants.ts


const SIZE = 136;
const STROKE_WIDTH = 14;
const RADIUS = (SIZE - STROKE_WIDTH) / 2;
const CIRCUMFERENCE = RADIUS * 2 * Math.PI;
;// CONCATENATED MODULE: ../ui-kit/src/circle-progress-bar/circle-progress-bar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const circle_progress_bar_module = ({"root":"circle-progress-bar-module__root--RcFTg","text":"circle-progress-bar-module__text--mSfXa","circle":"circle-progress-bar-module__circle--JKbfL","circle-fill":"circle-progress-bar-module__circle-fill--APzX_","circleFill":"circle-progress-bar-module__circle-fill--APzX_"});
;// CONCATENATED MODULE: ../ui-kit/src/circle-progress-bar/circle-progress-bar.tsx







const CircleProgressBar = _ref => {
  let {
    progressPercentage
  } = _ref;
  const offset = CIRCUMFERENCE - progressPercentage / 100 * CIRCUMFERENCE;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: circle_progress_bar_module.root,
    style: {
      "--progress": progressPercentage
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(typography_module/* default */.Z.body1Accent, circle_progress_bar_module.text),
      children: `${progressPercentage}%`
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
      width: "100%",
      height: "100%",
      viewBox: `0 0 ${SIZE} ${SIZE}`,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("circle", {
        className: circle_progress_bar_module.circle,
        strokeWidth: STROKE_WIDTH,
        fill: "transparent",
        r: RADIUS,
        cx: "50%",
        cy: "50%"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("circle", {
        className: circle_progress_bar_module.circleFill,
        strokeWidth: STROKE_WIDTH,
        fill: "transparent",
        r: RADIUS,
        cx: "50%",
        cy: "50%",
        strokeDasharray: `${CIRCUMFERENCE}`,
        strokeDashoffset: offset
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/course-progress/course-progress.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_progress_module = ({"root":"course-progress-module__root--dic9a","grey":"course-progress-module__grey--fglBC","header-without-next-course":"course-progress-module__header-without-next-course--V8Qmg","headerWithoutNextCourse":"course-progress-module__header-without-next-course--V8Qmg","next-course-wrapper":"course-progress-module__next-course-wrapper--dJ0Qq","nextCourseWrapper":"course-progress-module__next-course-wrapper--dJ0Qq","not-ready-text-wrapper":"course-progress-module__not-ready-text-wrapper--GoqRp","notReadyTextWrapper":"course-progress-module__not-ready-text-wrapper--GoqRp","info":"course-progress-module__info--SznL0","info-overlay":"course-progress-module__info-overlay--AsS2k","infoOverlay":"course-progress-module__info-overlay--AsS2k","progress-bar":"course-progress-module__progress-bar--sdjEp","progressBar":"course-progress-module__progress-bar--sdjEp","subtitle":"course-progress-module__subtitle--rt2_b","button":"course-progress-module__button--ivIno","skeleton-header-container":"course-progress-module__skeleton-header-container--URolv","skeletonHeaderContainer":"course-progress-module__skeleton-header-container--URolv","skeleton-header":"course-progress-module__skeleton-header--Vghbb","skeletonHeader":"course-progress-module__skeleton-header--Vghbb","skeleton-progress-bar":"course-progress-module__skeleton-progress-bar--N9t9h","skeletonProgressBar":"course-progress-module__skeleton-progress-bar--N9t9h","skeleton-ring":"course-progress-module__skeleton-ring--d5oI7","skeletonRing":"course-progress-module__skeleton-ring--d5oI7","skeleton-ring-inside":"course-progress-module__skeleton-ring-inside--_78lB","skeletonRingInside":"course-progress-module__skeleton-ring-inside--_78lB","skeleton-button":"course-progress-module__skeleton-button--vB6hM","skeletonButton":"course-progress-module__skeleton-button--vB6hM"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/course-progress/course-progress-hint.tsx







const CourseProgressHint = () => /* @__PURE__ */(0,jsx_runtime.jsx)(hint_Hint, {
  tooltip: {
    trigger: "hover",
    placement: "top",
    autoWidth: true,
    overlay: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: course_progress_module.infoOverlay,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "progressPage.skills.progressBar.tooltip"
      })
    })
  },
  className: course_progress_module.info,
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "info",
    size: "medium"
  })
});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/course-progress/course-progress-skeleton.tsx






const CourseProgressSkeleton = _ref => {
  let {
    enableAnimation
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: course_progress_module.root,
    "data-testid": "course-progress-skeleton",
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
      theme: skeleton/* SkeletonTheme */.y.Light,
      containerClassName: course_progress_module.skeletonHeaderContainer,
      className: course_progress_module.skeletonHeader,
      enableAnimation
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(course_progress_module.progressBar, course_progress_module.skeletonProgressBar),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: course_progress_module.skeletonRingInside
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
        theme: skeleton/* SkeletonTheme */.y.Light,
        className: course_progress_module.skeletonRing,
        enableAnimation
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_progress_module.button,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
        theme: skeleton/* SkeletonTheme */.y.Light,
        className: course_progress_module.skeletonButton,
        enableAnimation
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/course-progress/utils.ts







const countTotalTests = groupedTests => groupedTests.reduce((acc, _ref) => {
  let {
    tests
  } = _ref;
  return acc + tests.length;
}, 0);
const countCompletedTests = groupedTests => groupedTests.reduce((acc, _ref2) => {
  let {
    tests
  } = _ref2;
  return acc + tests.reduce((acc2, test) => {
    if (test.state === ProgressTestState.Passed) {
      return acc2 + 1;
    }
    return acc2;
  }, 0);
}, 0);
const countProgressPercentage = (modules, groupedTests) => {
  if (!modules || !groupedTests) {
    return 0;
  }
  const currentModuleNumber = getCurrentModuleNumber(modules);
  const percentageFromCurrentModule = currentModuleNumber === 0 ? 0 : (currentModuleNumber - 1) * 10;
  const percentageFromTestsCompletion = countCompletedTests(groupedTests) / countTotalTests(groupedTests) * 10;
  return Math.round(percentageFromCurrentModule + percentageFromTestsCompletion);
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/course-progress/course-progress.tsx





















const CourseProgress = () => {
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    data: courseLevel,
    isLoading: isCourseLevelDataLoading,
    isError
  } = useCourseLevelQuery(businessProductId);
  const noLevelData = Boolean(courseLevel?.currentCourseSlug === null);
  const {
    data: groupedTestsResults
  } = useTestResultsQuery(businessProductId, courseLevel?.currentCourseSlug);
  const currentLevelName = courseLevel?.currentLevel || "";
  const nextLevelName = courseLevel?.nextLevel || "";
  const isNextCourseAvailable = Boolean(courseLevel?.nextLevel);
  const currentLevel = courseLevel?.currentCourseSlug || "";
  const progressPercentage = countProgressPercentage(courseLevel?.modules, groupedTestsResults?.groupedProgressTests?.[currentLevel]?.testsGroup);
  const goToCourseProgram = () => history.push(routes.PROGRESS.PROGRAM);
  if (isCourseLevelDataLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgressSkeleton, {
      enableAnimation: true
    });
  }
  if (isError) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgressSkeleton, {
      enableAnimation: false
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: course_progress_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("header", {
      children: [noLevelData ? /* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
        className: classnames_default()(typography_module/* default */.Z.body1Accent, course_progress_module.headerWithoutNextCourse),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "progressPage.skills.progressBar.notReadyTitle"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(course_progress_module.grey, course_progress_module.nextCourseWrapper),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgressHint, {})
        })]
      }) : /* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
        className: classnames_default()(typography_module/* default */.Z.body1Accent, {
          [course_progress_module.headerWithoutNextCourse]: !isNextCourseAvailable
        }),
        children: [currentLevelName, isNextCourseAvailable && /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: course_progress_module.grey,
          children: [constants/* NBSP */.Xz + "\u2014", isMobile ? /* @__PURE__ */(0,jsx_runtime.jsx)("br", {}) : " "]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: classnames_default()(course_progress_module.grey, course_progress_module.nextCourseWrapper),
          children: [isNextCourseAvailable && nextLevelName, progressPercentage !== 100 && /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgressHint, {})]
        })]
      }), progressPercentage === 100 && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body2, course_progress_module.grey, course_progress_module.subtitle),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "progressPage.skills.progressBar.completedCourseSubtitle"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_progress_module.progressBar,
      children: progressPercentage === 100 ? /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        alt: "completed",
        src: "https://flowstatic.s3.yandex.net/ui-files/completed-course-image.svg"
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(CircleProgressBar, {
        progressPercentage
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "secondary",
      onClick: goToCourseProgram,
      className: course_progress_module.button,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "progressPage.skills.progressBar.buttonLabel"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/model.ts



var SkillTabs = /* @__PURE__ */(SkillTabs2 => {
  SkillTabs2["Current"] = "current";
  SkillTabs2["Prev"] = "prev";
  return SkillTabs2;
})(SkillTabs || {});
const [$selectedSkillTab, setSelectedSkillTab] = (0,makeStore/* makeStore */.n)("current" /* Current */);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills-progress/constants.ts



const SKILL_LABEL_KEY = {
  [Skills.Lexis]: "progressPage.skills.skillsProgress.lexis",
  [Skills.Speaking]: "progressPage.skills.skillsProgress.speaking",
  [Skills.Phrases]: "progressPage.skills.skillsProgress.phrases",
  [Skills.Reading]: "progressPage.skills.skillsProgress.reading",
  [Skills.Grammar]: "progressPage.skills.skillsProgress.grammar",
  [Skills.Listening]: "progressPage.skills.skillsProgress.listening"
};
const SKILL_ICON_NAME = {
  [Skills.Lexis]: "text",
  [Skills.Speaking]: "comments",
  [Skills.Phrases]: "grammar",
  [Skills.Reading]: "numbered-list",
  [Skills.Grammar]: "chapter-outline",
  [Skills.Listening]: "audio"
};
const SKILLS = [Skills.Lexis, Skills.Speaking, Skills.Phrases, Skills.Reading, Skills.Grammar, Skills.Listening];
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills-progress/skills-progress.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const skills_progress_module = ({"root":"skills-progress-module__root--ywOaW","heading-wrapper":"skills-progress-module__heading-wrapper--_xDwN","headingWrapper":"skills-progress-module__heading-wrapper--_xDwN","heading":"skills-progress-module__heading--BYohl","info":"skills-progress-module__info--lr5yd","alert":"skills-progress-module__alert--ZO0WM","alert-info":"skills-progress-module__alert-info--Ep9zt","alertInfo":"skills-progress-module__alert-info--Ep9zt","skills":"skills-progress-module__skills--TL_Ey","skill":"skills-progress-module__skill--SPS_m","icon":"skills-progress-module__icon--GWWxI","icon-wrapper":"skills-progress-module__icon-wrapper--d4waI","iconWrapper":"skills-progress-module__icon-wrapper--d4waI","progress-block":"skills-progress-module__progress-block--yEdJO","progressBlock":"skills-progress-module__progress-block--yEdJO","progress-block-label":"skills-progress-module__progress-block-label--Zsh3S","progressBlockLabel":"skills-progress-module__progress-block-label--Zsh3S","progress":"skills-progress-module__progress--yFdoD","skeleton-header":"skills-progress-module__skeleton-header--ymHA_","skeletonHeader":"skills-progress-module__skeleton-header--ymHA_","skeleton-skill":"skills-progress-module__skeleton-skill--Q0HL9","skeletonSkill":"skills-progress-module__skeleton-skill--Q0HL9"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills-progress/skills-progress-skeleton.tsx






const SkillsProgressSkeleton = _ref => {
  let {
    enableAnimation
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: skills_progress_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
      theme: skeleton/* SkeletonTheme */.y.Light,
      className: skills_progress_module.skeletonHeader,
      enableAnimation
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
      theme: skeleton/* SkeletonTheme */.y.Light,
      containerClassName: skills_progress_module.skills,
      inline: true,
      className: classnames_default()(skills_progress_module.skill, skills_progress_module.skeletonSkill),
      enableAnimation,
      count: 6
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/constants.ts





const DEFAULT_SKILL_SCORE = 0;
const MAX_SKILL_SCORE = 100;
const DEFAULT_SKILLS_SCORES = Object.fromEntries(Object.values(Skills).map(skill => [skill, DEFAULT_SKILL_SCORE]));
const MAX_SKILLS_SCORES = Object.fromEntries(Object.values(Skills).map(skill => [skill, MAX_SKILL_SCORE]));
const SKILLS_SPYDER_CHART_POSITIONS = {
  [Skills.Phrases]: "nodeTop",
  [Skills.Lexis]: "nodeTopRight",
  [Skills.Listening]: "nodeBottomRight",
  [Skills.Grammar]: "nodeBottom",
  [Skills.Reading]: "nodeBottomLeft",
  [Skills.Speaking]: "nodeTopLeft"
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/utils.ts



















const convertProgressTestOralScore = score => {
  if (score === 0) {
    return 0;
  }
  if (score >= 1 && score <= 2) {
    return 20;
  }
  if (score >= 3 && score <= 4) {
    return 40;
  }
  if (score >= 5 && score <= 6) {
    return 60;
  }
  if (score === 7) {
    return 70;
  }
  if (score >= 8 && score <= 9) {
    return 80;
  }
  if (score >= 10 && score <= 12) {
    return 100;
  }
  logger/* Logger */.Yd.captureError(
  // eslint-disable-next-line sonarjs/no-duplicate-string
  "Progress test score is out of range", {
    score
  }, {
    block: "skills",
    method: "convertProgressTestOralScore"
  });
  return 0;
};
const convertProgressTestWrittenScore = score => {
  if (score === 0) {
    return 0;
  }
  if (score === 1) {
    return 20;
  }
  if (score === 2) {
    return 50;
  }
  if (score === 3) {
    return 70;
  }
  if (score >= 4 && score <= 5) {
    return 100;
  }
  logger/* Logger */.Yd.captureError("Progress test score is out of range", {
    score
  }, {
    block: "skills",
    method: "convertProgressTestWrittenScore"
  });
  return 0;
};
const convertExamOralScore = score => {
  if (score === 0) {
    return 0;
  }
  if (score >= 1 && score <= 3) {
    return 20;
  }
  if (score >= 4 && score <= 7) {
    return 40;
  }
  if (score >= 8 && score <= 10) {
    return 60;
  }
  if (score >= 11 && score <= 12) {
    return 70;
  }
  if (score >= 13 && score <= 15) {
    return 80;
  }
  if (score >= 16 && score <= 20) {
    return 100;
  }
  logger/* Logger */.Yd.captureError("Progress test score is out of range", {
    score
  }, {
    block: "skills",
    method: "convertExamOralScore"
  });
  return 0;
};
const convertExamWrittenScore = score => {
  if (score === 0) {
    return 0;
  }
  if (score >= 1 && score <= 3) {
    return 20;
  }
  if (score >= 4 && score <= 6) {
    return 50;
  }
  if (score >= 7 && score <= 8) {
    return 70;
  }
  if (score >= 9 && score <= 10) {
    return 100;
  }
  logger/* Logger */.Yd.captureError("Progress test score is out of range", {
    score
  }, {
    block: "skills",
    method: "convertExamWrittenScore"
  });
  return 0;
};
const convertScore = (score, groupType, testType) => {
  if (groupType === ProgressTestGroupType.Assessment) {
    return score;
  }
  if (groupType === ProgressTestGroupType.ProgressTest) {
    if (testType === ProgressTestType.Oral) {
      return convertProgressTestOralScore(score);
    }
    if (testType === ProgressTestType.Written) {
      return convertProgressTestWrittenScore(score);
    }
  }
  if (groupType === ProgressTestGroupType.MidcourseTest || groupType === ProgressTestGroupType.Exam) {
    if (testType === ProgressTestType.Oral) {
      return convertExamOralScore(score);
    }
    if (testType === ProgressTestType.Written) {
      return convertExamWrittenScore(score);
    }
  }
  return score;
};
const isDefaultScores = skills => Object.values(skills).every(skill => skill === DEFAULT_SKILL_SCORE);
const mapSkillsToSpiderChart = skills => Object.entries(SKILLS_SPYDER_CHART_POSITIONS).reduce((acc, _ref) => {
  let [skill, chartPoint] = _ref;
  const key = skill;
  return {
    ...acc,
    [chartPoint]: skills[key]
  };
}, {});
const appendScores = (scores1, scores2) => Object.values(Skills).reduce((acc, skill) => ({
  ...acc,
  [skill]: (scores1[skill] ?? 0) + (scores2?.[skill] ?? 0)
}), DEFAULT_SKILLS_SCORES);
const countProgress = groups => groups.reduce((acc, group) => {
  if (group.type === ProgressTestGroupType.Assessment) {
    return group.tests[0]?.skillResults ?? DEFAULT_SKILLS_SCORES;
  }
  const result = sumTestsResults(group.tests, group.type);
  return appendScores(acc, result);
}, DEFAULT_SKILLS_SCORES);
const countMaxProgress = groups => groups.reduce((accGroups, group) => {
  if (group.type === ProgressTestGroupType.Assessment) {
    return group.tests[0]?.maxSkillScores ?? DEFAULT_SKILLS_SCORES;
  }
  SKILLS.forEach(skill => {
    accGroups[skill] = (accGroups[skill] || 0) + MAX_SKILL_SCORE;
  });
  return accGroups;
}, {
  ...DEFAULT_SKILLS_SCORES
});
const countRatioProgressToMaxScore = (progress, maxProgress, coefficientFunc) => Object.values(Skills).reduce((acc, skill) => ({
  ...acc,
  [skill]: coefficientFunc(progress[skill], maxProgress[skill])
}), DEFAULT_SKILLS_SCORES);
const sumTestsResults = (tests, groupType) => tests.reduce((testAcc, test) => {
  const convertedSkillResults = Object.entries(test.skillResults || {}).reduce((convertedSkillScoreAcc, _ref2) => {
    let [skill, score] = _ref2;
    const skillKey = skill;
    const convertedScore = convertScore(score, groupType, test.type);
    return {
      ...convertedSkillScoreAcc,
      [skillKey]: convertedScore
    };
  }, {});
  return appendScores(testAcc, convertedSkillResults);
}, DEFAULT_SKILLS_SCORES);
const hasPassedTestsInProgressTestsGroup = group => group.tests.some(test => test.state === ProgressTestState.Passed);
const getPassedTests = groups => groups.filter(hasPassedTestsInProgressTestsGroup);
const hasPassedProgressTests = groups => groups.some(hasPassedTestsInProgressTestsGroup);
const removeLastPassedTest = groups => {
  let latestFinishDate;
  groups.forEach(_ref3 => {
    let {
      tests
    } = _ref3;
    tests.forEach(_ref4 => {
      let {
        finishedDate
      } = _ref4;
      if (!finishedDate) {
        return;
      }
      if (!latestFinishDate || (0,isAfter/* isAfter */.A)(finishedDate, latestFinishDate)) {
        latestFinishDate = finishedDate;
      }
    });
  });
  if (!latestFinishDate) {
    return null;
  }
  const existingLatestFinishDate = latestFinishDate;
  return groups.reduce((acc, group) => {
    const filterLatestTestInGroup = group.tests.filter(_ref5 => {
      let {
        finishedDate
      } = _ref5;
      if (!finishedDate) {
        return true;
      }
      return !(0,isEqual/* isEqual */.X)(finishedDate, existingLatestFinishDate);
    });
    acc.push({
      ...group,
      tests: filterLatestTestInGroup
    });
    return acc;
  }, []);
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills-progress/utils.ts











const isPreviousLevelProgressMaxedOrEmpty = groups => {
  if (!groups || groups.length === 0) {
    return true;
  }
  const progress = countProgress(groups);
  const maxProgress = countMaxProgress(groups);
  return Object.entries(progress).every(_ref => {
    let [key, value] = _ref;
    return maxProgress[key] === value || DEFAULT_SKILLS_SCORES[key] === value;
  });
};
const getYellowLineSkillsProgress = (selectedSkillTab, groups) => {
  if (selectedSkillTab === SkillTabs.Current || !groups || groups.length === 0) {
    return DEFAULT_SKILLS_SCORES;
  }
  const progress = countProgress(groups);
  const maxProgress = countMaxProgress(groups);
  const coefficientFunc = (a, b) => b ? Math.round(a / b * 100) : 0;
  return countRatioProgressToMaxScore(progress, maxProgress, coefficientFunc);
};
const getGreenLineSkillsProgress = (selectedSkillTab, prevCourseSkillsProgress, groups) => {
  if (!groups || groups.length === 0) {
    return DEFAULT_SKILLS_SCORES;
  }
  const isPassedProgressTestExist = hasPassedProgressTests(groups);
  if (selectedSkillTab === SkillTabs.Prev && isDefaultScores(prevCourseSkillsProgress)) {
    return MAX_SKILLS_SCORES;
  }
  if (!isPassedProgressTestExist) {
    return DEFAULT_SKILLS_SCORES;
  }
  if (selectedSkillTab === SkillTabs.Prev) {
    return Object.values(Skills).reduce((acc, skill) => ({
      ...acc,
      [skill]: 100 - (prevCourseSkillsProgress[skill] ?? 0)
    }), DEFAULT_SKILLS_SCORES);
  }
  const progress = countProgress(groups);
  const maxProgress = countMaxProgress(groups);
  const coefficientFunc = (a, b) => b ? Math.round(a / b * 100) : 0;
  return countRatioProgressToMaxScore(progress, maxProgress, coefficientFunc);
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills-progress/skills-progress.tsx





















const SkillsProgress = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const selectedSkillTab = (0,effector_react/* useStore */.oR)($selectedSkillTab);
  const setSelectedSkillTabEvent = (0,effector_react/* useEvent */.zX)(setSelectedSkillTab);
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    data: courseLevelInfo
  } = useCourseLevelQuery(businessProductId);
  const {
    data: groupedTestsResults,
    error
  } = useTestResultsQuery(businessProductId, courseLevelInfo?.currentCourseSlug);
  const tabs = (0,react.useMemo)(() => [{
    id: SkillTabs.Prev,
    label: intl.formatMessage({
      id: "progressPage.skills.prevTabLabel"
    })
  }, {
    id: SkillTabs.Current,
    label: intl.formatMessage({
      id: "progressPage.skills.currentTabLabel"
    })
  }], [intl]);
  const currentCourseSlug = courseLevelInfo?.currentCourseSlug;
  const previousCourseSlug = courseLevelInfo?.previousCourseSlug || "";
  if (!groupedTestsResults || !currentCourseSlug) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SkillsProgressSkeleton, {
      enableAnimation: true
    });
  }
  const {
    assessmentTest,
    groupedProgressTests
  } = groupedTestsResults;
  const assessmentTestGroup = assessmentTest ? [assessmentTest] : void 0;
  const hasProgressTestsFromPreviousLevel = Boolean(previousCourseSlug) && Boolean(groupedProgressTests?.[previousCourseSlug]?.testsGroup);
  const previousLevelTestsGroup = hasProgressTestsFromPreviousLevel ? groupedProgressTests?.[previousCourseSlug]?.testsGroup : assessmentTestGroup;
  const yellowLineSkillsProgress = getYellowLineSkillsProgress(selectedSkillTab, previousLevelTestsGroup);
  const greenLineSkillsProgress = getGreenLineSkillsProgress(selectedSkillTab, yellowLineSkillsProgress, groupedProgressTests[currentCourseSlug]?.testsGroup);
  const shouldShowTabs = !isPreviousLevelProgressMaxedOrEmpty(previousLevelTestsGroup);
  if (error) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SkillsProgressSkeleton, {
      enableAnimation: false
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: skills_progress_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: skills_progress_module.headingWrapper,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: skills_progress_module.heading,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          className: typography_module/* default */.Z.body1Accent,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "progressPage.skills.skillsProgress.title"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(hint_Hint, {
          tooltip: {
            trigger: "hover",
            placement: "top",
            autoWidth: true,
            overlay: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "progressPage.skills.skillsProgress.tooltip"
            })
          },
          className: skills_progress_module.info,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: "info",
            size: "medium"
          })
        })]
      }), shouldShowTabs && /* @__PURE__ */(0,jsx_runtime.jsx)(toggle_button_group/* ToggleButtonGroup */.t, {
        values: tabs,
        selectedValueId: selectedSkillTab,
        view: isMobile ? "vertical" : "horizontal",
        onChange: setSelectedSkillTabEvent
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: skills_progress_module.skills,
      children: SKILLS.map(skill => {
        const yellowProgress = yellowLineSkillsProgress[skill];
        const greenProgress = greenLineSkillsProgress[skill];
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: skills_progress_module.skill,
          style: {
            "--yellow-progress": `${yellowProgress}%`,
            "--green-progress": `${greenProgress}%`
          },
          "data-testid": `${skill}-block`,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: skills_progress_module.iconWrapper,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              className: skills_progress_module.icon,
              size: "small",
              name: SKILL_ICON_NAME[skill]
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: skills_progress_module.progressBlock,
            children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: skills_progress_module.progressBlockLabel,
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
                className: typography_module/* default */.Z.body2Accent,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                  id: SKILL_LABEL_KEY[skill]
                })
              }), /* @__PURE__ */(0,jsx_runtime.jsxs)("p", {
                className: typography_module/* default */.Z.body2Accent,
                children: [yellowProgress + greenProgress, "%"]
              })]
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: skills_progress_module.progress
            })]
          })]
        }, skill);
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/spider-chart/constants.ts


const CHART_NODES = ["nodeTop", "nodeTopRight", "nodeBottomRight", "nodeBottom", "nodeBottomLeft", "nodeTopLeft"];
const CHART_NODE_AXES_RATIO = {
  nodeTop: {
    x: {
      a: 0,
      b: 160
    },
    y: {
      a: -175,
      b: 185
    }
  },
  nodeTopRight: {
    x: {
      a: 151,
      b: 160
    },
    y: {
      a: -87.6,
      b: 185
    }
  },
  nodeBottomRight: {
    x: {
      a: 151,
      b: 160
    },
    y: {
      a: 87.6,
      b: 185
    }
  },
  nodeBottom: {
    x: {
      a: 0,
      b: 160
    },
    y: {
      a: 175,
      b: 185
    }
  },
  nodeBottomLeft: {
    x: {
      a: -151,
      b: 160
    },
    y: {
      a: 87.6,
      b: 185
    }
  },
  nodeTopLeft: {
    x: {
      a: -151,
      b: 160
    },
    y: {
      a: -87.6,
      b: 185
    }
  }
};
;// CONCATENATED MODULE: ./src/components/spider-chart/utils.ts



const calculateChartPoints = points => {
  let result = "";
  for (let i = 0; i < CHART_NODES.length; i++) {
    const skillName = CHART_NODES[i];
    const skillProgress = points[skillName];
    result += calculateChartNodePoint(skillName, skillProgress);
  }
  return result;
};
const calculateChartNodePoint = (nodeName, nodeValue) => {
  const nodeAxesRatio = CHART_NODE_AXES_RATIO[nodeName];
  const x = nodeAxesRatio.x.a * nodeValue + nodeAxesRatio.x.b;
  const y = nodeAxesRatio.y.a * nodeValue + nodeAxesRatio.y.b;
  return `${x},${y} `;
};
;// CONCATENATED MODULE: ./src/components/spider-chart/spider-chart.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spider_chart_module = ({"svg-container":"spider-chart-module__svg-container--GE2mS","svgContainer":"spider-chart-module__svg-container--GE2mS","chart":"spider-chart-module__chart--qiumy","chart-with-labels":"spider-chart-module__chart-with-labels--_iWUd","chartWithLabels":"spider-chart-module__chart-with-labels--_iWUd","chart-border":"spider-chart-module__chart-border--z2x1y","chartBorder":"spider-chart-module__chart-border--z2x1y","chart-border-inner":"spider-chart-module__chart-border-inner--IyQyj","chartBorderInner":"spider-chart-module__chart-border-inner--IyQyj","chart-border-invisible":"spider-chart-module__chart-border-invisible--ehX9E","chartBorderInvisible":"spider-chart-module__chart-border-invisible--ehX9E","chart-body":"spider-chart-module__chart-body--xQv3n","chartBody":"spider-chart-module__chart-body--xQv3n","line":"spider-chart-module__line--d2mvo","node":"spider-chart-module__node--Wwbht","nodeTop":"spider-chart-module__nodeTop--QO04W","nodeTopRight":"spider-chart-module__nodeTopRight--F3RbR","nodeBottomRight":"spider-chart-module__nodeBottomRight--Ghakw","nodeBottom":"spider-chart-module__nodeBottom--MUwxI","nodeBottomLeft":"spider-chart-module__nodeBottomLeft--z869o","nodeTopLeft":"spider-chart-module__nodeTopLeft--vOUip","polygon":"spider-chart-module__polygon--BSNbL","chart-border-container":"spider-chart-module__chart-border-container--WXmVF","chartBorderContainer":"spider-chart-module__chart-border-container--WXmVF"});
;// CONCATENATED MODULE: ./src/components/spider-chart/spider-chart.tsx












const SpiderChart = _ref => {
  let {
    nodeLabels,
    charts = [],
    maxScoreTooltipText
  } = _ref;
  const [visibleTooltip, setvisibleTooltip] = (0,react.useState)(null);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: spider_chart_module.svgContainer,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(spider_chart_module.chart, spider_chart_module.chartWithLabels),
      children: [(0,object_utils/* getObjectEntries */.J)(nodeLabels).map(_ref2 => {
        let [chartNode, nodeLabel] = _ref2;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, spider_chart_module.node, spider_chart_module[chartNode]),
          children: nodeLabel
        }, nodeLabel);
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_tooltip/* Tooltip */.u, {
        autoWidth: true,
        align: {
          targetOffset: [0, -130]
        },
        overlay: visibleTooltip,
        placement: "top",
        visible: visibleTooltip !== null,
        showArrow: false,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("svg", {
          viewBox: "0 0 320 370",
          className: spider_chart_module.chart,
          fill: "none",
          children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("g", {
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("polygon", {
              className: spider_chart_module.chartBody,
              points: "160,10 311,97.5 311,272.5 160,360 9,272.5 9,97.5 160,10"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("polygon", {
              className: spider_chart_module.chartBody,
              points: "160,45 280.8,115 280.8,255 160,325 39.2,255 39.2,115 160,45"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("polygon", {
              className: spider_chart_module.chartBody,
              points: "160,80 250.6,132.5 250.6,237.5 160,290 69.4,237.5 69.4,132.5 160,80"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("polygon", {
              className: spider_chart_module.chartBody,
              points: "160,115 220.4,150 220.4,220 160,255 99.8,220 99.8,150 160,115"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("polygon", {
              className: spider_chart_module.chartBody,
              points: "160,150 190.2,167.5 190.2,202.5 160,220 129.8,202.5 129.8,167.5 160,150"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("line", {
              className: spider_chart_module.line,
              x1: "9",
              y1: "272.5",
              x2: "311",
              y2: "97.5"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("line", {
              className: spider_chart_module.line,
              x1: "160",
              y1: "10",
              x2: "160",
              y2: "360"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("line", {
              className: spider_chart_module.line,
              x1: "9",
              y1: "97.5",
              x2: "311",
              y2: "272.5"
            })]
          }), charts?.length && /* @__PURE__ */(0,jsx_runtime.jsxs)("g", {
            className: spider_chart_module.chartBorderContainer,
            onMouseOut: () => setvisibleTooltip(null),
            onMouseOver: () => setvisibleTooltip(maxScoreTooltipText),
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("path", {
              className: spider_chart_module.chartBorder,
              d: "M 160,10 L 311,97.5 311,272.5 160,360 9,272.5 9,97.5 160,10"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
              className: spider_chart_module.chartBorderInner,
              d: "M 160,10 L 311,97.5 311,272.5 160,360 9,272.5 9,97.5 160,10"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
              className: spider_chart_module.chartBorderInvisible,
              d: "M 160,10 L 311,97.5 311,272.5 160,360 9,272.5 9,97.5 160,10"
            })]
          }), charts.map((_ref3, index) => {
            let {
              points,
              className,
              tooltipText
            } = _ref3;
            return /* @__PURE__ */(0,jsx_runtime.jsx)("polygon", {
              className: classnames_default()(spider_chart_module.polygon, className),
              points: calculateChartPoints(points),
              onMouseOver: () => tooltipText ? setvisibleTooltip(tooltipText) : void 0,
              onMouseOut: () => setvisibleTooltip(null)
            }, `spider_chart_${index}`);
          })]
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/components/spider-chart/index.ts




;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/spider-chart/skills-spider-chart.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const skills_spider_chart_module = ({"root":"skills-spider-chart-module__root--G8_U6","spider-chart-initial":"skills-spider-chart-module__spider-chart-initial--hIrf8","spiderChartInitial":"skills-spider-chart-module__spider-chart-initial--hIrf8","spider-chart-prev-last":"skills-spider-chart-module__spider-chart-prev-last--cBhEr","spiderChartPrevLast":"skills-spider-chart-module__spider-chart-prev-last--cBhEr","spider-chart-last":"skills-spider-chart-module__spider-chart-last--V9Dk9","spiderChartLast":"skills-spider-chart-module__spider-chart-last--V9Dk9","skeleton-chart-container":"skills-spider-chart-module__skeleton-chart-container--j0NQF","skeletonChartContainer":"skills-spider-chart-module__skeleton-chart-container--j0NQF","skeleton-chart":"skills-spider-chart-module__skeleton-chart--auafs","skeletonChart":"skills-spider-chart-module__skeleton-chart--auafs"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/spider-chart/skills-spider-chart-skeleton.tsx





const SkillsSpiderChartSkeleton = _ref => {
  let {
    enableAnimation
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: skills_spider_chart_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
      theme: skeleton/* SkeletonTheme */.y.Light,
      className: skills_spider_chart_module.skeletonChart,
      containerClassName: skills_spider_chart_module.skeletonChartContainer,
      enableAnimation
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/spider-chart/constants.ts


const BASE_PROGRESS_ON_CURRENT_LEVEL_MULTIPLIER = 0.3;
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/spider-chart/utils.ts










const getSpiderChartData = (progressTests, groups) => {
  const progress = countProgress(progressTests);
  const maxProgress = countMaxProgress(groups);
  const coefficientFunc = (a, b) => b ? a / b * (1 - BASE_PROGRESS_ON_CURRENT_LEVEL_MULTIPLIER) + BASE_PROGRESS_ON_CURRENT_LEVEL_MULTIPLIER : BASE_PROGRESS_ON_CURRENT_LEVEL_MULTIPLIER;
  const skillScores = countRatioProgressToMaxScore(progress, maxProgress, coefficientFunc);
  return mapSkillsToSpiderChart(skillScores);
};
const getPreviousLevelChartPoints = (selectedSkillTab, groups) => {
  const coefficient = selectedSkillTab === SkillTabs.Prev ? 1 : BASE_PROGRESS_ON_CURRENT_LEVEL_MULTIPLIER;
  const coefficientFunc = (a, b) => b ? a / b * coefficient : 0;
  if (!groups || !groups.length || !hasPassedProgressTests(groups)) {
    const skillScores2 = countRatioProgressToMaxScore(MAX_SKILLS_SCORES, MAX_SKILLS_SCORES, coefficientFunc);
    return mapSkillsToSpiderChart(skillScores2);
  }
  const progress = countProgress(groups);
  const maxProgress = countMaxProgress(groups);
  const skillScores = countRatioProgressToMaxScore(progress, maxProgress, coefficientFunc);
  return mapSkillsToSpiderChart(skillScores);
};
const getCurrentLevelBeforeLastTestChartPoints = (selectedSkillTab, groups) => {
  if (selectedSkillTab === SkillTabs.Prev || !groups) {
    return null;
  }
  const progressTestsExcludingLastPassedTest = removeLastPassedTest(groups);
  if (!progressTestsExcludingLastPassedTest) {
    return null;
  }
  return getSpiderChartData(progressTestsExcludingLastPassedTest, groups);
};
const getCurrentLevelChartPoints = (selectedSkillTab, groups) => {
  if (!groups) {
    return null;
  }
  const isPassedProgressTestExist = hasPassedProgressTests(groups);
  if (!isPassedProgressTestExist) {
    return null;
  }
  if (selectedSkillTab === SkillTabs.Prev) {
    const scores = Object.values(Skills).reduce((acc, skill) => ({
      ...acc,
      [skill]: 1
    }), DEFAULT_SKILLS_SCORES);
    return mapSkillsToSpiderChart(scores);
  }
  const progressTests = getPassedTests(groups);
  return getSpiderChartData(progressTests, groups);
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/spider-chart/skills-spider-chart.tsx















const SkillsSpiderChart = () => {
  const intl = (0,useIntl/* default */.Z)();
  const selectedSkillTab = (0,effector_react/* useStore */.oR)($selectedSkillTab);
  const nodeLabels = (0,react.useMemo)(() => ({
    nodeTop: intl.formatMessage({
      id: "skillsSpiderChart.nodeLabels.phrases"
    }),
    nodeTopRight: intl.formatMessage({
      id: "skillsSpiderChart.nodeLabels.lexis"
    }),
    nodeBottomRight: intl.formatMessage({
      id: "skillsSpiderChart.nodeLabels.listening"
    }),
    nodeBottom: intl.formatMessage({
      id: "skillsSpiderChart.nodeLabels.grammar"
    }),
    nodeBottomLeft: intl.formatMessage({
      id: "skillsSpiderChart.nodeLabels.reading"
    }),
    nodeTopLeft: intl.formatMessage({
      id: "skillsSpiderChart.nodeLabels.speaking"
    })
  }), [intl]);
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    data: courseLevelInfo
  } = useCourseLevelQuery(businessProductId);
  const {
    data: groupedTestsResults,
    error
  } = useTestResultsQuery(businessProductId, courseLevelInfo?.currentCourseSlug);
  if (!groupedTestsResults || !courseLevelInfo?.currentCourseSlug) {
    return null;
  }
  const {
    assessmentTest,
    groupedProgressTests
  } = groupedTestsResults;
  const assessmentTestGroup = assessmentTest ? [assessmentTest] : void 0;
  const previousCourseSlug = courseLevelInfo?.previousCourseSlug || "";
  const hasProgressTestsFromPreviousLevel = Boolean(previousCourseSlug) && Boolean(groupedProgressTests?.[previousCourseSlug]?.testsGroup);
  const previousLevelTestsGroup = hasProgressTestsFromPreviousLevel ? groupedProgressTests?.[previousCourseSlug]?.testsGroup : assessmentTestGroup;
  const previousLevelChartPoints = getPreviousLevelChartPoints(selectedSkillTab, previousLevelTestsGroup);
  const currentLevelBeforeLastTestChartPoints = getCurrentLevelBeforeLastTestChartPoints(selectedSkillTab, groupedProgressTests[courseLevelInfo.currentCourseSlug]?.testsGroup);
  const currentLevelChartPoints = getCurrentLevelChartPoints(selectedSkillTab, groupedProgressTests[courseLevelInfo.currentCourseSlug]?.testsGroup);
  const charts = [];
  if (currentLevelChartPoints) {
    charts.push({
      points: currentLevelChartPoints,
      className: skills_spider_chart_module.spiderChartLast,
      tooltipText: intl.formatMessage({
        id: "skillsSpiderChart.tooltipText.lastTest"
      })
    });
  }
  if (currentLevelBeforeLastTestChartPoints) {
    charts.push({
      points: currentLevelBeforeLastTestChartPoints,
      className: skills_spider_chart_module.spiderChartPrevLast,
      tooltipText: intl.formatMessage({
        id: "skillsSpiderChart.tooltipText.prevLastTest"
      })
    });
  }
  if (previousLevelChartPoints) {
    charts.push({
      points: previousLevelChartPoints,
      className: skills_spider_chart_module.spiderChartInitial,
      tooltipText: intl.formatMessage({
        id: "skillsSpiderChart.tooltipText.initialTest"
      })
    });
  }
  const maxScoreTooltipText = selectedSkillTab === SkillTabs.Prev ? intl.formatMessage({
    id: "skillsSpiderChart.tooltipText.maxScorePrev"
  }) : intl.formatMessage({
    id: "skillsSpiderChart.tooltipText.maxScore"
  });
  if (!groupedTestsResults) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SkillsSpiderChartSkeleton, {
      enableAnimation: true
    });
  }
  if (error) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SkillsSpiderChartSkeleton, {
      enableAnimation: false
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: skills_spider_chart_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(SpiderChart, {
      nodeLabels,
      charts,
      maxScoreTooltipText
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const skills_module = ({"root":"skills-module__root--V6wII"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/ui/skills/skills.tsx













const skills_Skills = () => {
  const intl = (0,useIntl/* default */.Z)();
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    data: courseLevelInfo
  } = useCourseLevelQuery(businessProductId);
  const noLevelData = Boolean(courseLevelInfo?.currentCourseSlug === null);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: skills_module.root,
    children: [noLevelData && /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
      text: intl.formatMessage({
        id: "progressPage.skills.noAssessmentTest.message"
      }),
      type: model_model/* AlertType */.N.INFO
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgress, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(SkillsProgress, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(SkillsSpiderChart, {})]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/progress.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const progress_module = ({"root":"progress-module__root--bQYZp","menu":"progress-module__menu--K79LM","content":"progress-module__content--g2jcE","narrow-content":"progress-module__narrow-content--P78rm","narrowContent":"progress-module__narrow-content--P78rm","alert":"progress-module__alert--hmadA"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/progress.page.tsx


























const ProgressPage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const businessProductId = (0,effector_react/* useStore */.oR)(entities_user/* $currentProductBusinessId */.Wu);
  const {
    data: courseLevelInfo
  } = useCourseLevelQuery(businessProductId);
  const testResultRouteMatch = (0,react_router/* useRouteMatch */.$B)(routes.PROGRESS.TEST_RESULT(":testId"));
  useTestResultsQuery(businessProductId, courseLevelInfo?.currentCourseSlug);
  const tabs = (0,react.useMemo)(() => [{
    id: Tabs.Skills,
    label: intl.formatMessage({
      id: "progressPage.skills.tabLabel"
    }),
    route: routes.PROGRESS.SKILLS
  }, {
    id: Tabs.Tests,
    label: intl.formatMessage({
      id: "progressPage.tests.tabLabel"
    }),
    route: routes.PROGRESS.TESTS
  }, {
    id: Tabs.Program,
    label: intl.formatMessage({
      id: "progressPage.program.tabLabel"
    }),
    route: routes.PROGRESS.PROGRAM
  }], [intl, routes.PROGRESS.PROGRAM, routes.PROGRESS.SKILLS, routes.PROGRESS.TESTS]);
  const selectedTabId = (tabs.find(tab => tab.route === history.location.pathname) || tabs[0]).id;
  const handleChange = (0,react.useCallback)(id => history.push((tabs.find(tab => tab.id === id) || tabs[0]).route), [history, tabs]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
      className: progress_module.root,
      children: [testResultRouteMatch ? /* @__PURE__ */(0,jsx_runtime.jsx)(GoBackButton, {
        text: intl.formatMessage({
          id: "backButton"
        }),
        onClick: history.goBack
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: progress_module.menu,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(toggle_button_group/* ToggleButtonGroup */.t, {
          values: tabs,
          selectedValueId: selectedTabId,
          view: isDesktop ? "vertical" : "horizontal",
          stretch: true,
          onChange: handleChange
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(progress_module.content, {
          [progress_module.narrowContent]: [Tabs.Skills, Tabs.Tests].includes(selectedTabId)
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router/* Switch */.rs, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
            path: routes.PROGRESS.INDEX,
            exact: true,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
              to: routes.PROGRESS.SKILLS
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
            path: routes.PROGRESS.SKILLS,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(skills_Skills, {})
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
            path: routes.PROGRESS.TESTS,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressTests, {})
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
            path: routes.PROGRESS.PROGRAM,
            children: businessProductId && courseLevelInfo && /* @__PURE__ */(0,jsx_runtime.jsx)(CourseProgram, {
              businessProductId,
              courseLevel: courseLevelInfo
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
            path: routes.PROGRESS.TEST_RESULT(`:testId`),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(TestResult, {})
          })]
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/progress/index.ts



;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__toggle-button-schedule-row/toggle-button-schedule-row.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggle_button_schedule_row_module = ({"toggle-button":"toggle-button-schedule-row-module__toggle-button--OS_Ju","toggleButton":"toggle-button-schedule-row-module__toggle-button--OS_Ju","toggle-button-icon":"toggle-button-schedule-row-module__toggle-button-icon--vmlRO","toggleButtonIcon":"toggle-button-schedule-row-module__toggle-button-icon--vmlRO"});
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__toggle-button-schedule-row/toggle-button-schedule-row.component.tsx








const ToggleButtonScheduleRow = _ref => {
  let {
    toggled,
    onClick,
    buttonText
  } = _ref;
  const {
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(toggle_button_schedule_row_module.toggleButton, isMobileOrTablet ? typography_module/* default */.Z.captionAccent : typography_module/* default */.Z.body2Accent),
    onClick,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      children: buttonText
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: toggle_button_schedule_row_module.toggleButtonIcon,
      name: toggled ? "simple-arrow-up" : "simple-arrow-down",
      size: "small"
    })]
  });
};
;// CONCATENATED MODULE: ./src/services/cancel-lesson/adapters/logger.ts




const prefix = `[CancelLessonService]:`;
const cancelLessonLoggerAdapter = {
  error: e => {
    if (e instanceof NoSpeakingSessionIdError) {
      logger/* Logger */.Yd.captureError(`${prefix} no speaking session id when cancel speaking session`);
      return;
    }
    if (e instanceof CancelSpeakingSessionAPIError) {
      logger/* Logger */.Yd.captureError(`${prefix} api error when try to cancel speakingSession`, {
        speakingSessionId: e.speakingSessionId
      });
      return;
    }
    if (e instanceof NoBusinessProductIdIdError) {
      logger/* Logger */.Yd.captureError(`${prefix} no business product id when cancel speaking session`);
      return;
    }
    if (e instanceof SpeakingSessionAlreadyFinishedError) {
      logger/* Logger */.Yd.captureError(`${prefix}: try to cancel already finished speaking session`, {
        speakingSession: e.speakingSession
      });
    }
  }
};
;// CONCATENATED MODULE: ./src/services/cancel-lesson/adapters/storage.ts





const useCancelLessonStorageAdapter = () => {
  const history = (0,react_router/* useHistory */.k6)();
  return {
    isOpenPopUp: get_url_search_params.getUrlSearchParams.cancelLessonPopup.getSpeakingSessionId(history) !== null,
    speakingSessionId: get_url_search_params.getUrlSearchParams.cancelLessonPopup.getSpeakingSessionId(history),
    closePopUp: () => {
      history.push(get_url_search_params.getUrlSearchParams.cancelLessonPopup.closePopUp(history));
    },
    openPopUp(params) {
      history.push(get_url_search_params.getUrlSearchParams.cancelLessonPopup.openPopUp(history, params));
    }
  };
};
;// CONCATENATED MODULE: ./src/services/cancel-lesson/cancel-lesson.ts















const createCancelLessonService = adapters => {
  const {
    storage,
    api,
    logger
  } = adapters;
  const cancelLesson = async () => {
    if (!storage.speakingSession) {
      const error = new NoSpeakingSessionIdError();
      logger.error(error);
      throw error;
    }
    if (storage.businessProductId === null) {
      const error = new NoBusinessProductIdIdError();
      logger.error(error);
      throw error;
    }
    if ((0,isBefore/* isBefore */.R)((0,addMinutes/* addMinutes */.m)(storage.speakingSession.startAt, storage.speakingSession.speaking.durationMinutes), /* @__PURE__ */new Date())) {
      const error = new SpeakingSessionAlreadyFinishedError({
        speakingSession: storage.speakingSession
      });
      logger.error(error);
      await storage.refreshSpeakingSessionList();
      throw error;
    }
    try {
      await api.cancelLesson({
        speakingSession: storage.speakingSession,
        businessProductId: storage.businessProductId
      });
      storage.setSpeakingSessionState({
        speakingSessionId: storage.speakingSession.id,
        state: speakingSession_model/* SpeakingSessionState */.Z.Cancelled
      });
    } catch (e) {
      const error = new CancelSpeakingSessionAPIError({
        speakingSessionId: storage.speakingSession.id
      });
      logger.error(error);
      throw error;
    }
  };
  return {
    isOpenPopUp: storage.isOpenPopUp,
    cancelLesson,
    openPopUp: storage.openPopUp,
    closePopUp: storage.closePopUp
  };
};
const useCancelLessonService = () => {
  const {
    setSpeakingSessionState,
    initSpeakingSessions,
    speakingSessions
  } = useScheduling();
  const cancelLessonStorage = useCancelLessonStorageAdapter();
  const user = (0,useUser/* useUser */.aF)();
  const speakingSession = (0,react.useMemo)(() => {
    const speakingSessionId = cancelLessonStorage.speakingSessionId;
    if (speakingSessionId === null) {
      return null;
    }
    const ss = speakingSessions.find(speakingSession2 => speakingSession2.id === speakingSessionId);
    return ss ?? null;
  }, [cancelLessonStorage.speakingSessionId, speakingSessions]);
  const service = createCancelLessonService({
    storage: {
      ...cancelLessonStorage,
      setSpeakingSessionState: params => {
        setSpeakingSessionState({
          speakingSessionId: params.speakingSessionId,
          state: params.state
        });
      },
      refreshSpeakingSessionList: initSpeakingSessions,
      speakingSession,
      businessProductId: user.data?.product?.businessId ?? null
    },
    api: cancelLessonApiAdapter,
    logger: cancelLessonLoggerAdapter
  });
  return {
    service,
    viewModel: {
      startAt: speakingSession ? (0,format/* format */.WU)(speakingSession.startAt, "d MMMM, HH:mm", {
        locale: utils_locale/* dateFnsLocale */.Y
      }) : ""
    }
  };
};
;// CONCATENATED MODULE: ./src/widgets/cancell-lesson-popup/cancel-lesson-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const cancel_lesson_popup_module = ({"content":"cancel-lesson-popup-module__content--vc3xH","header":"cancel-lesson-popup-module__header--jCDBe","title":"cancel-lesson-popup-module__title--Hunx9","buttons":"cancel-lesson-popup-module__buttons--bXMs4","center":"cancel-lesson-popup-module__center--HCNuz"});
;// CONCATENATED MODULE: ./src/widgets/cancell-lesson-popup/cancell-lesson-popup.component.tsx











var CancelLessonPopupState = /* @__PURE__ */(CancelLessonPopupState2 => {
  CancelLessonPopupState2["Confirm"] = "confirm";
  CancelLessonPopupState2["Success"] = "success";
  CancelLessonPopupState2["UnknownError"] = "error";
  CancelLessonPopupState2["SpeakingSessionAlreadyFinishedError"] = "alreadyFinishedError";
  CancelLessonPopupState2["Loading"] = "loading";
  return CancelLessonPopupState2;
})(CancelLessonPopupState || {});
const cancell_lesson_popup_component_CancelLessonPopup = _ref => {
  let {
    isVisible
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [state, setState] = (0,react.useState)("confirm" /* Confirm */);
  const {
    service,
    viewModel
  } = useCancelLessonService();
  const speakingSessionStartAt = viewModel.startAt;
  const handleClose = (0,react.useCallback)(() => {
    service.closePopUp();
    setState("confirm" /* Confirm */);
  }, [service]);
  const handleSubmit = (0,react.useCallback)(async () => {
    try {
      setState("loading" /* Loading */);
      await service.cancelLesson();
      setState("success" /* Success */);
    } catch (e) {
      if (e instanceof SpeakingSessionAlreadyFinishedError) {
        setState("alreadyFinishedError" /* SpeakingSessionAlreadyFinishedError */);
      } else {
        setState("error" /* UnknownError */);
      }
    }
  }, [service]);
  const cancelLessonPopupContent = (0,react.useMemo)(() => {
    switch (state) {
      case "loading" /* Loading */:
        return null;
      case "confirm" /* Confirm */:
        return {
          title: intl.formatMessage({
            id: "StudentCancelLessonPopup.confirmCancelTitle"
          }, {
            lessonDate: speakingSessionStartAt,
            br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
          }),
          subtitle: intl.formatMessage({
            id: "StudentCancelLessonPopup.confirmCancelSubtitle"
          }),
          buttons: [{
            text: intl.formatMessage({
              id: "StudentCancelLessonPopup.cancel"
            }),
            appearance: "secondary",
            onClick: handleClose
          }, {
            text: intl.formatMessage({
              id: "StudentCancelLessonPopup.confirm"
            }),
            appearance: "primary",
            onClick: handleSubmit
          }]
        };
      case "success" /* Success */:
        return {
          title: intl.formatMessage({
            id: "StudentCancelLessonPopup.successTitle"
          }),
          subtitle: intl.formatMessage({
            id: "StudentCancelLessonPopup.successSubtitle"
          }),
          buttons: [{
            text: intl.formatMessage({
              id: "StudentCancelLessonPopup.successSubmit"
            }),
            appearance: "primary",
            onClick: handleClose
          }]
        };
      case "alreadyFinishedError" /* SpeakingSessionAlreadyFinishedError */:
        return {
          title: intl.formatMessage({
            id: "StudentCancelLessonPopup.lessonAlreadyFinished"
          }),
          subtitle: intl.formatMessage({
            id: "StudentCancelLessonPopup.cantCancelLesson"
          }),
          buttons: [{
            text: intl.formatMessage({
              id: "StudentCancelLessonPopup.errorSubmit"
            }),
            appearance: "primary",
            onClick: handleClose
          }]
        };
      case "error" /* UnknownError */:
        return {
          title: intl.formatMessage({
            id: "StudentCancelLessonPopup.errorTitle"
          }),
          subtitle: intl.formatMessage({
            id: "StudentCancelLessonPopup.errorSubtitle"
          }),
          buttons: [{
            text: intl.formatMessage({
              id: "StudentCancelLessonPopup.errorSubmit"
            }),
            appearance: "primary",
            onClick: handleClose
          }]
        };
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(state);
    }
  }, [handleClose, handleSubmit, intl, speakingSessionStartAt, state]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    size: modal/* ModalSize */.Cg.Small,
    contentPosition: modal/* ModalContentPosition */.s7.Center,
    title: cancelLessonPopupContent?.title || "",
    subtitle: cancelLessonPopupContent?.subtitle || "",
    buttons: cancelLessonPopupContent?.buttons || [],
    isVisible,
    onClose: handleClose,
    children: cancelLessonPopupContent === null && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: cancel_lesson_popup_module.center,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    })
  });
};
;// CONCATENATED MODULE: ./src/widgets/hint-modal/hint-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const hint_button_module = ({"content":"hint-button-module__content--f4zqo","header":"hint-button-module__header--eMXBb","title":"hint-button-module__title--qLHX9","buttons":"hint-button-module__buttons--JootR","hint-button":"hint-button-module__hint-button--vqyEC","hintButton":"hint-button-module__hint-button--vqyEC"});
;// CONCATENATED MODULE: ./src/widgets/hint-modal/hint-button.component.tsx








const HintButton = _ref => {
  let {
    className,
    scheduledCount
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isPopUpOpened, setIsPopUpOpened] = (0,react.useState)(false);
  const imageSrc = "https://flowstatic.s3.yandex.net/ui-files/curator-something-wrong.svg";
  const textConstants = {
    title: intl.formatMessage({
      id: "beginnerScheduleReplacePage.titleWithCount"
    }, {
      count: scheduledCount
    }),
    subtitle: intl.formatMessage({
      id: "beginnerScheduleReplacePage.hintSubtitle"
    }),
    buttonText: intl.formatMessage({
      id: "beginnerScheduleReplacePage.hintConfirm"
    })
  };
  const onClose = () => {
    setIsPopUpOpened(false);
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      className: hint_button_module.hintButton,
      appearance: "secondaryFloating",
      size: "medium",
      onClick: () => {
        setIsPopUpOpened(true);
      },
      children: intl.formatMessage({
        id: "beginnerScheduleReplacePage.hint"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      size: modal/* ModalSize */.Cg.Small,
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      headerImage: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        alt: "something wrong",
        src: imageSrc
      }),
      title: textConstants.title,
      subtitle: textConstants.subtitle,
      buttons: [{
        text: textConstants.buttonText,
        appearance: "primary",
        onClick: onClose
      }],
      isVisible: isPopUpOpened,
      onClose
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/utils/utils.ts


function calculateHintButtonVisibility(scheduledCount, speakingSessionRemaining) {
  const isButtonHidden = speakingSessionRemaining - scheduledCount <= 0 || scheduledCount === 0;
  return !isButtonHidden;
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/hint-button-with-resources.tsx






const HintButtonWithResources = _ref => {
  let {
    scheduledCount
  } = _ref;
  const {
    speakingSession
  } = (0,use_resources_zero_balance/* useResourcesBalanceRemaining */.My)();
  const isButtonVisible = calculateHintButtonVisibility(scheduledCount, speakingSession);
  if (!isButtonVisible) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(HintButton, {
    scheduledCount
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/schedule-list/schedule-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_list_module = ({"schedule-table":"schedule-list-module__schedule-table--bhCCx","scheduleTable":"schedule-list-module__schedule-table--bhCCx","schedule-table-top-space":"schedule-list-module__schedule-table-top-space--vI2wO","scheduleTableTopSpace":"schedule-list-module__schedule-table-top-space--vI2wO"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/schedule-list/schedule-list.tsx







const ScheduleList = (0,react.forwardRef)((_ref, ref) => {
  let {
    children,
    className
  } = _ref;
  const scheduleManagementAccess = useScheduleManagementAccess();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    ref,
    className: classnames_default()(schedule_list_module.scheduleTable, className, {
      [schedule_list_module.scheduleTableTopSpace]: scheduleManagementAccess.controlButton.visible
    }),
    children
  });
});
ScheduleList.displayName = "ScheduleList";
// EXTERNAL MODULE: ../../node_modules/date-fns/formatISODuration.mjs
var formatISODuration = __webpack_require__(94708);
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__schedule-row/schedule-row.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_row_module = ({"row":"schedule-row-module__row--wGDyZ"});
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__schedule-row/schedule-row.component.tsx






const ScheduleRow = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(schedule_row_module.row, typography_module/* default */.Z.body2),
    children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__beginner-schedule-row/beginner-schedule-row@modile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const beginner_schedule_row_modile_module = ({"root":"beginner-schedule-row@modile-module__root--e3Phr","row":"beginner-schedule-row@modile-module__row--VVLTD","row-with-actions-button":"beginner-schedule-row@modile-module__row-with-actions-button--poroa","rowWithActionsButton":"beginner-schedule-row@modile-module__row-with-actions-button--poroa","left-part":"beginner-schedule-row@modile-module__left-part--FI5eT","leftPart":"beginner-schedule-row@modile-module__left-part--FI5eT","block":"beginner-schedule-row@modile-module__block--LsfrN","center-part":"beginner-schedule-row@modile-module__center-part--bk7fB","centerPart":"beginner-schedule-row@modile-module__center-part--bk7fB","grey-text":"beginner-schedule-row@modile-module__grey-text--hpLWn","greyText":"beginner-schedule-row@modile-module__grey-text--hpLWn","button":"beginner-schedule-row@modile-module__button--Cn3Kq","root-with-shadow":"beginner-schedule-row@modile-module__root-with-shadow--PJmbO","rootWithShadow":"beginner-schedule-row@modile-module__root-with-shadow--PJmbO"});
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__beginner-schedule-row/beginner-schedule-row@mobile.component.tsx









const BeginnerScheduleRowMobile = _ref => {
  let {
    header,
    actionButtons,
    showActionButtons = false,
    withShadow,
    handleToggle
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(beginner_schedule_row_modile_module.root, {
      [beginner_schedule_row_modile_module.rootWithShadow]: withShadow
    }),
    onClick: handleToggle,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("header", {
      className: classnames_default()(typography_module/* default */.Z.caption, beginner_schedule_row_modile_module.row),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(beginner_schedule_row_modile_module.leftPart, beginner_schedule_row_modile_module.greyText),
        children: header.leftPart
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: beginner_schedule_row_modile_module.block,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, beginner_schedule_row_modile_module.centerPart),
          children: header.centerPart
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          children: header.rightPart
        })]
      })]
    }), actionButtons !== null && showActionButtons && /* @__PURE__ */(0,jsx_runtime.jsx)("footer", {
      className: classnames_default()(typography_module/* default */.Z.body2, beginner_schedule_row_modile_module.row, {
        [beginner_schedule_row_modile_module.rowWithActionsButton]: showActionButtons
      }),
      children: actionButtons.map(button => {
        if (button == null) {
          return;
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: beginner_schedule_row_modile_module.button,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: button.appearance ?? "secondary",
            size: "small",
            onClick: button.onClick,
            "aria-label": button.text,
            disabled: button.disabled,
            children: button.text
          })
        }, button.text);
      })
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__beginner-schedule-row/beginner-schedule-row.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const beginner_schedule_row_module = ({"schedule-row":"beginner-schedule-row-module__schedule-row--i4QhF","scheduleRow":"beginner-schedule-row-module__schedule-row--i4QhF","right-side":"beginner-schedule-row-module__right-side--snMlL","rightSide":"beginner-schedule-row-module__right-side--snMlL","date":"beginner-schedule-row-module__date--jJLLX","part-of-date":"beginner-schedule-row-module__part-of-date--wulV3","partOfDate":"beginner-schedule-row-module__part-of-date--wulV3","teacher-info":"beginner-schedule-row-module__teacher-info--Ykf9G","teacherInfo":"beginner-schedule-row-module__teacher-info--Ykf9G","teacher-name":"beginner-schedule-row-module__teacher-name--tt_3i","teacherName":"beginner-schedule-row-module__teacher-name--tt_3i","weekday":"beginner-schedule-row-module__weekday--c9C_x","photo":"beginner-schedule-row-module__photo--iNFhc","line":"beginner-schedule-row-module__line--jPv_H","middle-line":"beginner-schedule-row-module__middle-line--xB3UB","middleLine":"beginner-schedule-row-module__middle-line--xB3UB","green-text":"beginner-schedule-row-module__green-text--nrq1D","greenText":"beginner-schedule-row-module__green-text--nrq1D","complete":"beginner-schedule-row-module__complete--gH8oI","complete-text-block":"beginner-schedule-row-module__complete-text-block--mSzsC","completeTextBlock":"beginner-schedule-row-module__complete-text-block--mSzsC","action-buttons":"beginner-schedule-row-module__action-buttons--gcC6H","actionButtons":"beginner-schedule-row-module__action-buttons--gcC6H","action-button":"beginner-schedule-row-module__action-button--UHg3e","actionButton":"beginner-schedule-row-module__action-button--UHg3e"});
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__beginner-schedule-row/beginner-schedule-row.component.tsx
















var ScheduleRowState = /* @__PURE__ */(ScheduleRowState2 => {
  ScheduleRowState2["Completed"] = "completed";
  ScheduleRowState2["Uncompleted"] = "uncompleted";
  return ScheduleRowState2;
})(ScheduleRowState || {});
const BeginnerScheduleRow = _ref => {
  let {
    lesson,
    textConstants,
    actionButtons,
    showActionButtons,
    onRowClick
  } = _ref;
  const {
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const renderLessonButton = () => {
    const state = lesson.state;
    switch (state) {
      case "completed" /* Completed */:
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: beginner_schedule_row_module.completeTextBlock,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: "checkmark-bold",
            size: "small",
            className: beginner_schedule_row_module.complete
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(beginner_schedule_row_module.greenText, typography_module/* default */.Z.captionAccent),
            children: textConstants.completedText
          })]
        });
      case "uncompleted" /* Uncompleted */:
        if (actionButtons === null) {
          return null;
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(beginner_schedule_row_module.actionButtons),
          children: actionButtons.map(button => {
            if (button === null) {
              return null;
            }
            return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
              appearance: button.appearance ?? "secondary",
              size: "small",
              onClick: button.onClick,
              className: classnames_default()(beginner_schedule_row_module.actionButton, button.className),
              disabled: button.disabled,
              children: button.text
            }, button.text);
          })
        });
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(state);
    }
  };
  const renderContent = () => {
    const teacherPhoto = lesson.teacherInfo.photo === "" ? avatar_utils/* DEFAULT_AVATAR_URL */.jz : lesson.teacherInfo.photo;
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: beginner_schedule_row_module.date,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          style: {
            width: "60px"
          },
          className: beginner_schedule_row_module.partOfDate,
          children: lesson.number
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
          style: {
            width: "140px"
          },
          className: classnames_default()(typography_module/* default */.Z.body2Accent, beginner_schedule_row_module.partOfDate),
          dateTime: lesson.date.iso,
          children: lesson.date.label
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
          style: {
            width: "160px"
          },
          className: beginner_schedule_row_module.partOfDate,
          dateTime: lesson.time.iso,
          children: lesson.time.label
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
          style: {
            width: "116px"
          },
          className: classnames_default()(beginner_schedule_row_module.partOfDate, beginner_schedule_row_module.weekday),
          children: lesson.weekday
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: beginner_schedule_row_module.rightSide,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: beginner_schedule_row_module.teacherInfo,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: beginner_schedule_row_module.photo,
            style: {
              backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(teacherPhoto)
            }
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: beginner_schedule_row_module.teacherName,
            children: lesson.teacherInfo.name
          })]
        }), renderLessonButton()]
      })]
    });
  };
  if (isMobileOrTablet) {
    const headerLeftPart = lesson.state === "completed" /* Completed */ ? /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: "checkmark-bold",
      size: "small",
      className: beginner_schedule_row_module.complete
    }) : lesson.number;
    return /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerScheduleRowMobile, {
      header: {
        leftPart: headerLeftPart,
        centerPart: `${lesson.date.label}, ${lesson.weekdayMobile}.`,
        rightPart: lesson.time.label
      },
      actionButtons,
      showActionButtons,
      withShadow: lesson.state === "uncompleted" /* Uncompleted */,
      handleToggle: onRowClick
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleRow, {
    children: renderContent()
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/schedule-list/schedule-row/schedule-row.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_row_schedule_row_module = ({"row":"schedule-row-module__row--OxMyU"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/schedule-list/schedule-row/schedule-row.tsx


















const schedule_row_ScheduleRow = _ref => {
  let {
    speakingSession,
    rowNumber
  } = _ref;
  const {
    initSpeakingSessions
  } = useScheduling();
  const rescheduleLessonPopupService = useRescheduleLessonPopupService();
  const studentRescheduleAbility = rescheduleLessonPopupService.studentRescheduleAbility;
  const {
    service: cancelLessonService
  } = useCancelLessonService();
  const {
    isMobile,
    isTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const [areActionButtonsDisabled, setAreActionButtonSDisabled] = (0,react.useState)(false);
  const [isMobileActionButtonVisible, setIsMobileActionButtonsVisible] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    setIsMobileActionButtonsVisible(isTablet);
  }, [isTablet]);
  const handleRowClick = () => {
    if (!isMobile) {
      return;
    }
    setIsMobileActionButtonsVisible(isCurrentVisible => {
      if (isCurrentVisible) {
        return false;
      }
      if (isMobile) {
        return speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled;
      }
      return true;
    });
  };
  const handleChangeSpeakingSessionApprovalStatus = async (speakingSessionId, approvalStatus) => {
    try {
      setAreActionButtonSDisabled(true);
      await (0,student_api/* updateSpeakingSessionApprovalStatus */.Rj)(speakingSessionId, approvalStatus);
      await initSpeakingSessions();
      if (approvalStatus === "declined") {
        toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
          id: "BeginnerScheduleList.toastMessage.sessionDeclined"
        }), {
          autoClose: 3e3
        });
      } else {
        toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
          id: "BeginnerScheduleList.toastMessage.sessionAccepted"
        }), {
          autoClose: 3e3
        });
      }
    } catch (error) {
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        // eslint-disable-next-line max-len
        id: "BeginnerScheduleList.toastMessage.BeginnerScheduleList.toastMessage.sessionApprovalStatusChangeError"
      }), {
        autoClose: 3e3
      });
    } finally {
      setAreActionButtonSDisabled(false);
    }
  };
  const getActionButtons = () => {
    if (!(0,isBefore/* isBefore */.R)((0,lib_Date.now)(), speakingSession.startAt)) {
      return [];
    }
    if (speakingSession.approvalStatus === speakingSession_model/* ApprovalStatus */.Kb.Pending) {
      return [{
        appearance: "secondary",
        onClick: () => handleChangeSpeakingSessionApprovalStatus(speakingSession.id, "declined"),
        text: intl.formatMessage({
          id: "BeginnerScheduleList.DeclineLesson"
        }),
        disabled: areActionButtonsDisabled
      }, {
        appearance: "primary",
        onClick: () => handleChangeSpeakingSessionApprovalStatus(speakingSession.id, "assigned"),
        text: intl.formatMessage({
          id: "BeginnerScheduleList.AcceptLesson"
        }),
        disabled: areActionButtonsDisabled
      }];
    }
    return [studentRescheduleAbility ? {
      text: intl.formatMessage({
        id: "BeginnerScheduleList.rescheduleLesson"
      }),
      onClick: () => {
        rescheduleLessonPopupService.openPopup(speakingSession.id, "schedule");
      }
    } : {
      text: intl.formatMessage({
        id: "BeginnerScheduleList.CancelLesson"
      }),
      onClick: () => {
        cancelLessonService.openPopUp({
          speakingSessionId: speakingSession.id
        });
      }
    }];
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
    className: schedule_row_schedule_row_module.row,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerScheduleRow, {
      lesson: {
        id: speakingSession.id,
        number: String(rowNumber),
        state: speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Completed ? ScheduleRowState.Completed : ScheduleRowState.Uncompleted,
        date: {
          label: (0,format/* format */.WU)(speakingSession.startAt, "d", {
            locale: utils_locale/* dateFnsLocale */.Y
          }) + " " + (0,string_utils/* capitalized */.wm)((0,format/* format */.WU)(speakingSession.startAt, "MMMM", {
            locale: utils_locale/* dateFnsLocale */.Y
          })),
          iso: (0,formatISO/* formatISO */.c)(speakingSession.startAt)
        },
        time: {
          label: `${(0,format/* format */.WU)(speakingSession.startAt, "p", {
            locale: utils_locale/* dateFnsLocale */.Y
          })} \u2014 ${(0,format/* format */.WU)((0,addMinutes/* addMinutes */.m)(speakingSession.startAt, speakingSession.speaking.durationMinutes), "p", {
            locale: utils_locale/* dateFnsLocale */.Y
          })}`,
          iso: (0,formatISODuration/* formatISODuration */.m)({
            minutes: speakingSession.speaking.durationMinutes
          })
        },
        weekday: (0,format/* format */.WU)(speakingSession.startAt, "EEEE", {
          locale: utils_locale/* dateFnsLocale */.Y
        }),
        weekdayMobile: (0,string_utils/* capitalized */.wm)((0,format/* format */.WU)(speakingSession.startAt, "EEEEEE", {
          locale: utils_locale/* dateFnsLocale */.Y
        })),
        teacherInfo: {
          name: speakingSession.tutor?.publicName || "",
          photo: speakingSession.tutor?.avatar || ""
        }
      },
      textConstants: {
        completedText: intl.formatMessage({
          id: "beginnerScheduleReplacePage.completedText"
        }),
        uncompletedText: intl.formatMessage({
          id: "beginnerScheduleReplacePage.uncompletedText"
        })
      },
      actionButtons: getActionButtons(),
      showActionButtons: speakingSession.approvalStatus === speakingSession_model/* ApprovalStatus */.Kb.Pending || isMobileActionButtonVisible,
      onRowClick: handleRowClick
    })
  }, speakingSession.id);
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/pending-sessions-list/pending-sessions-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const pending_sessions_list_module = ({"pending-sessions-list-wrapper":"pending-sessions-list-module__pending-sessions-list-wrapper--DPeSh","pendingSessionsListWrapper":"pending-sessions-list-module__pending-sessions-list-wrapper--DPeSh","pending-sessions-list-header":"pending-sessions-list-module__pending-sessions-list-header--ql1Dw","pendingSessionsListHeader":"pending-sessions-list-module__pending-sessions-list-header--ql1Dw","schedule-list-wrapper":"pending-sessions-list-module__schedule-list-wrapper--Cqll9","scheduleListWrapper":"pending-sessions-list-module__schedule-list-wrapper--Cqll9","hidden":"pending-sessions-list-module__hidden--ClUHw","schedule-list":"pending-sessions-list-module__schedule-list--z7WdF","scheduleList":"pending-sessions-list-module__schedule-list--z7WdF","expand-button":"pending-sessions-list-module__expand-button--c2PSG","expandButton":"pending-sessions-list-module__expand-button--c2PSG","arrow-down":"pending-sessions-list-module__arrow-down--Njys_","arrowDown":"pending-sessions-list-module__arrow-down--Njys_"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/pending-sessions-list/pending-sessions-list.tsx














const PendingSessionsList = () => {
  const {
    viewModel
  } = useStudentSchedule();
  const {
    pendingSpeakingSessions
  } = viewModel;
  const [pendingSessionsListHeight, setPendingSessionsListHeight] = (0,react.useState)(0);
  const [isListExpanded, setIsListExpanded] = (0,react.useState)(true);
  if (pendingSpeakingSessions.length === 0) {
    return null;
  }
  const refCallback = element => {
    if (!element) {
      return;
    }
    setPendingSessionsListHeight(element.getBoundingClientRect().height);
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: pending_sessions_list_module.pendingSessionsListWrapper,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(pending_sessions_list_module.pendingSessionsListHeader, typography_module/* default */.Z.body2Accent),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "BeginnerScheduleList.pendingSessionsListHeader"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        onClick: () => setIsListExpanded(currentValue => !currentValue),
        appearance: "default",
        iconName: "simple-arrow-up",
        size: "small",
        className: classnames_default()(pending_sessions_list_module.expandButton, {
          [pending_sessions_list_module.arrowDown]: isListExpanded
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(pending_sessions_list_module.scheduleListWrapper, {
        [pending_sessions_list_module.hidden]: !isListExpanded
      }),
      style: {
        "--schedule-list-height": `${pendingSessionsListHeight}px`
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleList, {
        ref: refCallback,
        className: classnames_default()(pending_sessions_list_module.scheduleList),
        children: pendingSpeakingSessions.map((speakingSession, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(schedule_row_ScheduleRow, {
          speakingSession,
          rowNumber: index + 1
        }, speakingSession.id))
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/schedule-change.tsx













const ScheduleChange = () => {
  const intl = (0,useIntl/* default */.Z)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    requestChangingScheduleButton: {
      disabled
    }
  } = useScheduleManagementAccess();
  const [showConfirmation, setShowConfirmation] = (0,react.useState)(false);
  const onShow = (0,react.useCallback)(() => {
    setShowConfirmation(true);
  }, []);
  const onClose = (0,react.useCallback)(() => {
    setShowConfirmation(false);
  }, []);
  const confirmationButtons = (0,react.useMemo)(() => [{
    appearance: "secondary",
    text: intl.formatMessage({
      id: "BeginnerScheduleList.scheduleChange.dialog.cancel"
    }),
    onClick: onClose
  }, {
    appearance: "primary",
    text: intl.formatMessage({
      id: "BeginnerScheduleList.scheduleChange.dialog.ok"
    }),
    onClick: async () => {
      setShowConfirmation(false);
      const studentId = user.data?.me.user?.id;
      const businessProductId = user.data?.attributes.businessId;
      if (!studentId || !businessProductId) {
        return;
      }
      try {
        await changeSchedule((0,student_student_model/* makeStudentId */.Ox)(studentId), (0,product_model/* makeBusinessProductId */.bX)(businessProductId));
        toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
          id: "BeginnerScheduleList.scheduleChange.requestSuccess"
        }));
      } catch {
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "BeginnerScheduleList.scheduleChange.requestError"
        }));
      }
    }
  }], [intl, onClose, user]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "secondary",
      size: "small",
      onClick: onShow,
      disabled,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "BeginnerScheduleList.scheduleChange.button"
      })
    }), showConfirmation && /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      size: modal/* ModalSize */.Cg.Small,
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      title: intl.formatMessage({
        id: "BeginnerScheduleList.scheduleChange.dialog.title"
      }),
      subtitle: intl.formatMessage({
        id: "BeginnerScheduleList.scheduleChange.dialog.text"
      }),
      buttons: confirmationButtons,
      onClose
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/components/schedule-pause.tsx













const SchedulePause = () => {
  const intl = (0,useIntl/* default */.Z)();
  const user = (0,useUser/* useUser */.aF)();
  const {
    requestPauseButton: {
      disabled
    }
  } = useScheduleManagementAccess();
  const [showConfirmation, setShowConfirmation] = (0,react.useState)(false);
  const onShow = (0,react.useCallback)(() => {
    setShowConfirmation(true);
  }, []);
  const onClose = (0,react.useCallback)(() => {
    setShowConfirmation(false);
  }, []);
  const confirmationButtons = (0,react.useMemo)(() => [{
    appearance: "secondary",
    text: intl.formatMessage({
      id: "BeginnerScheduleList.schedulePause.dialog.cancel"
    }),
    onClick: onClose
  }, {
    appearance: "primary",
    text: intl.formatMessage({
      id: "BeginnerScheduleList.schedulePause.dialog.ok"
    }),
    onClick: async () => {
      setShowConfirmation(false);
      const studentId = user.data?.me.user?.id;
      const businessProductId = user.data?.attributes.businessId;
      if (!studentId || !businessProductId) {
        return;
      }
      try {
        await pauseSchedule((0,student_student_model/* makeStudentId */.Ox)(studentId), (0,product_model/* makeBusinessProductId */.bX)(businessProductId));
        toast/* toastNotificationService */.B.showSuccess(intl.formatMessage({
          id: "BeginnerScheduleList.schedulePause.requestSuccess"
        }));
      } catch {
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "BeginnerScheduleList.schedulePause.requestError"
        }));
      }
    }
  }], [intl, onClose, user]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "secondary",
      size: "small",
      onClick: onShow,
      disabled,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "BeginnerScheduleList.schedulePause.button"
      })
    }), showConfirmation && /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      size: modal/* ModalSize */.Cg.Small,
      contentPosition: modal/* ModalContentPosition */.s7.Center,
      title: intl.formatMessage({
        id: "BeginnerScheduleList.schedulePause.dialog.title"
      }),
      subtitle: intl.formatMessage({
        id: "BeginnerScheduleList.schedulePause.dialog.text"
      }),
      buttons: confirmationButtons,
      onClose
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/schedule.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_module = ({"page":"schedule-module__page--ZDV7K","back-button":"schedule-module__back-button--dOpvk","backButton":"schedule-module__back-button--dOpvk","header-buttons":"schedule-module__header-buttons--cMJj_","headerButtons":"schedule-module__header-buttons--cMJj_","row":"schedule-module__row--FRgcw","schedule-table":"schedule-module__schedule-table--tPvJp","scheduleTable":"schedule-module__schedule-table--tPvJp","schedule-table-top-space":"schedule-module__schedule-table-top-space--hg1p6","scheduleTableTopSpace":"schedule-module__schedule-table-top-space--hg1p6","bottom-buttons":"schedule-module__bottom-buttons--Qi7Ao","bottomButtons":"schedule-module__bottom-buttons--Qi7Ao"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/schedule/schedule.tsx

























const schedule_Schedule = () => {
  const {
    initSpeakingSessions
  } = useScheduling();
  const intl = (0,useIntl/* default */.Z)();
  const {
    viewModel
  } = useStudentSchedule();
  const {
    scheduledSpeakingSessionsForShow,
    completedSpeakingSessionsForShow
  } = viewModel;
  const {
    resources
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const resourcesZeroBalance = (0,use_resources_zero_balance/* useResourcesZeroBalance */.GG)();
  const isZeroBalance = (0,use_resources_zero_balance/* checkZeroBalance */.Ll)(resourcesZeroBalance, "speakingSession");
  const [completedSessionsIsShown, setCompletedSessionsIsShown] = (0,react.useState)(isZeroBalance);
  const toggleButtonText = completedSessionsIsShown ? "BeginnerScheduleList.hideCompletedSessionsButton" : "BeginnerScheduleList.showCompletedSessionsButton";
  const handleCompletedSessionsIsShown = () => setCompletedSessionsIsShown(prev => !prev);
  const {
    service: cancelLessonService
  } = useCancelLessonService();
  const rescheduleLessonPopupService = useRescheduleLessonPopupService();
  const scheduleManagementAccess = useScheduleManagementAccess();
  (0,react.useEffect)(() => {
    void initSpeakingSessions();
  }, [initSpeakingSessions]);
  (0,react.useEffect)(() => {
    const timer = setInterval(() => void initSpeakingSessions(), constants/* TIME_INTERVALS_MS */.rI.hour);
    return () => clearInterval(timer);
  }, [initSpeakingSessions]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: schedule_module.page,
        children: [scheduleManagementAccess.controlButton.visible && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: schedule_module.headerButtons,
          children: [scheduleManagementAccess.requestPauseButton.visible && /* @__PURE__ */(0,jsx_runtime.jsx)(SchedulePause, {}), scheduleManagementAccess.requestChangingScheduleButton.visible && /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleChange, {})]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(PendingSessionsList, {}), /* @__PURE__ */(0,jsx_runtime.jsxs)(ScheduleList, {
          children: [!isZeroBalance && scheduledSpeakingSessionsForShow.map((speakingSession, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(schedule_row_ScheduleRow, {
            speakingSession,
            rowNumber: index + 1
          }, speakingSession.id)), completedSpeakingSessionsForShow.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
            className: schedule_module.row,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToggleButtonScheduleRow, {
              toggled: completedSessionsIsShown,
              onClick: handleCompletedSessionsIsShown,
              buttonText: intl.formatMessage({
                id: toggleButtonText
              })
            })
          }, "toggleButton"), completedSessionsIsShown && completedSpeakingSessionsForShow.map((speakingSession, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(schedule_row_ScheduleRow, {
            speakingSession,
            rowNumber: index + 1
          }, speakingSession.id))]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: schedule_module.bottomButtons,
          children: resources.enabled && /* @__PURE__ */(0,jsx_runtime.jsx)(HintButtonWithResources, {
            scheduledCount: scheduledSpeakingSessionsForShow.length
          })
        })]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(cancell_lesson_popup_component_CancelLessonPopup, {
      isVisible: cancelLessonService.isOpenPopUp
    }), rescheduleLessonPopupService.isOpenPopup && /* @__PURE__ */(0,jsx_runtime.jsx)(RescheduleLessonPopup, {})]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/beginners-main/__task-card/task-card.component.tsx + 1 modules
var task_card_component = __webpack_require__(25874);
// EXTERNAL MODULE: ../shared/src/utils/create-polling/create-polling.ts
var create_polling = __webpack_require__(48353);
;// CONCATENATED MODULE: ../ui-kit/src/search-light/search-light.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const search_light_module = ({"root":"search-light-module__root--XeJZj","root-success":"search-light-module__root-success--AEH1s","rootSuccess":"search-light-module__root-success--AEH1s","root-error":"search-light-module__root-error--HVPBA","rootError":"search-light-module__root-error--HVPBA","root-typo":"search-light-module__root-typo--ZRnfC","rootTypo":"search-light-module__root-typo--ZRnfC","success":"search-light-module__success--XgFWB","error":"search-light-module__error--jcOW_","icon-button":"search-light-module__icon-button--JJVhg","iconButton":"search-light-module__icon-button--JJVhg","input":"search-light-module__input--D7ju3"});
;// CONCATENATED MODULE: ../ui-kit/src/search-light/search-light.component.tsx









var SearchLightStatus = /* @__PURE__ */(SearchLightStatus2 => {
  SearchLightStatus2["Success"] = "success";
  SearchLightStatus2["Error"] = "error";
  SearchLightStatus2["Default"] = "default";
  return SearchLightStatus2;
})(SearchLightStatus || {});
const searchStyleByStatusMap = {
  ["default" /* Default */]: "",
  ["success" /* Success */]: search_light_module.success,
  ["error" /* Error */]: search_light_module.error
};
const SearchLight = _ref => {
  let {
    status = "default" /* Default */,
    spellCheck = false,
    autoComplete = "off",
    value,
    onChange,
    ...inputProps
  } = _ref;
  const className = classnames_default()(searchStyleByStatusMap[status], search_light_module.root, typography_module/* default */.Z.body2);
  const handleOnChange = (0,react.useCallback)(event => {
    onChange(event.target.value);
  }, [onChange]);
  const clearValue = (0,react.useCallback)(() => {
    onChange("");
  }, [onChange]);
  const isButtonShow = Boolean(value);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      ...inputProps,
      value,
      onChange: handleOnChange,
      spellCheck,
      autoComplete,
      className: search_light_module.input,
      type: "search"
    }), isButtonShow ? /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "default",
      size: "tiny",
      iconName: "cross-bold",
      className: search_light_module.iconButton,
      onClick: clearValue,
      "aria-label": "clear button"
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: "search-light",
      size: "small",
      "aria-label": "search icon"
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/use-tasks.ts














const $tasksMap = (0,effector/* createStore */.MT)({});
const [$tasksLoading, setTasksLoading] = (0,makeStore/* makeStore */.n)(true);
const $tasks = $tasksMap.map(tasksMap => Object.values(tasksMap));
const tasksApi = (0,effector/* createApi */.LC)($tasksMap, {
  setTasks: (state, payload) => payload.reduce((acc, task) => {
    acc[task.nodeId] = task;
    return acc;
  }, {}),
  updateTask: (state, payload) => ({
    ...state,
    [payload.nodeId]: {
      ...state[payload.nodeId],
      ...payload
    }
  })
});
const useTasks = () => {
  const user = (0,useUser/* useUser */.aF)();
  const businessProductId = user?.data?.product?.businessId ?? null;
  const tasksMap = (0,effector_react/* useStore */.oR)($tasksMap);
  const tasks = (0,effector_react/* useStore */.oR)($tasks);
  const isLoading = (0,effector_react/* useStore */.oR)($tasksLoading);
  const fetchTasks = (0,react.useCallback)(async () => {
    if (businessProductId !== null) {
      try {
        const selfStudy = await (0,syllabus_api/* getSelfStudy */.bi)({
          businessProductId
        });
        tasksApi.setTasks(selfStudy);
      } finally {
        setTasksLoading(false);
      }
    }
  }, [businessProductId]);
  const handleChangeIsFavoriteState = (0,react.useCallback)(async (nodeId, isFavorite) => {
    if (!tasks.length) {
      return;
    }
    const assignedAt = tasksMap[nodeId]?.date;
    tasksApi.updateTask({
      nodeId,
      isFavorite
    });
    await (0,student_api/* setSyllabusNodeAttributes */.ej)(nodeId, isFavorite, assignedAt);
  }, [tasks.length, tasksMap]);
  return {
    fetchTasks,
    tasks,
    handleChangeIsFavoriteState,
    isLoading
  };
};
// EXTERNAL MODULE: ../../node_modules/ramda/es/sort.js
var sort = __webpack_require__(89921);
// EXTERNAL MODULE: ../../node_modules/ramda/es/descend.js
var descend = __webpack_require__(80965);
// EXTERNAL MODULE: ../../node_modules/ramda/es/prop.js + 1 modules
var prop = __webpack_require__(38114);
// EXTERNAL MODULE: ../../node_modules/ramda/es/pipe.js + 4 modules
var pipe = __webpack_require__(27239);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/use-tasks-filter.tsx









































var Filters = /* @__PURE__ */(Filters2 => {
  Filters2["UNFINISHED"] = "UNFINISHED";
  Filters2["IS_FAVORITE"] = "IS_FAVORITE";
  Filters2["ALL"] = "ALL";
  return Filters2;
})(Filters || {});
const groupTasksByDate = (lastLessonDate, tasks) => {
  const [selectedFilterTasks, otherTasks] = [tasks.selectedFilterTasks, tasks.otherTasks].map(tasks2 => tasks2.reduce((res, task) => {
    const taskAssignedDate = new Date(task.date);
    const formattedDate = (0,startOfDay/* startOfDay */.b)(taskAssignedDate).toISOString();
    if (!res[formattedDate]) {
      res[formattedDate] = {
        tasks: [],
        themes: /* @__PURE__ */new Set(),
        isLastSessionTasks: (0,isSameDay/* isSameDay */.K)(lastLessonDate, taskAssignedDate)
      };
    }
    res[formattedDate].tasks.push(task);
    if (task.theme !== "") {
      res[formattedDate].themes.add(task.theme);
    }
    return res;
  }, {}));
  return {
    selectedFilterTasks,
    otherTasks
  };
};
const getFilterPredicate = (filterBy, task) => {
  switch (filterBy) {
    case "ALL" /* ALL */:
      return true;
    case "IS_FAVORITE" /* IS_FAVORITE */:
      return task.isFavorite;
    case "UNFINISHED" /* UNFINISHED */:
      return task.state !== task_card_component/* TaskCardState */.ab.Done;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(filterBy);
  }
};
const filterTasks = (filterBy, tasks) => {
  const [selectedFilterTasks, otherTasks] = (0,partition/* default */.Z)(getFilterPredicate.bind(null, filterBy))(tasks);
  return {
    selectedFilterTasks,
    otherTasks
  };
};
function containSubstring(_ref) {
  let {
    str,
    subStr
  } = _ref;
  return str.toLowerCase().includes(subStr);
}
const searchTasks = (searchFilter, tasks) => {
  const searchFilterLowerCase = searchFilter.toLowerCase();
  return tasks.filter(task => [task.title, task.description].some(str => containSubstring({
    str,
    subStr: searchFilterLowerCase
  })));
};
const getSortedFn = (0,sort/* default */.Z)((0,descend/* default */.Z)((0,prop/* default */.Z)("date")));
const getFilterFn = (filterBy, searchValue, date) => (0,pipe/* default */.Z)(searchTasks.bind(null, searchValue), filterTasks.bind(null, filterBy), groupTasksByDate.bind(null, date));
const filtersMetricsMap = {
  ["UNFINISHED" /* UNFINISHED */]: "New_Filter_Unfinished",
  ["IS_FAVORITE" /* IS_FAVORITE */]: "New_Filter_Favorite",
  ["ALL" /* ALL */]: "New_Filter_All"
};
const filtersLabelsIdsMap = {
  ["UNFINISHED" /* UNFINISHED */]: "tasks.unfinished",
  ["IS_FAVORITE" /* IS_FAVORITE */]: "tasks.favorite",
  ["ALL" /* ALL */]: "tasks.all"
};
const titleMap = {
  ["UNFINISHED" /* UNFINISHED */]: "beginner-tasks.unfinishedEmptyMessage",
  ["IS_FAVORITE" /* IS_FAVORITE */]: "beginner-tasks.favoriteEmptyMessage",
  ["ALL" /* ALL */]: "beginner-tasks.allEmptyMessage"
};
function useTasksFilter(tasks) {
  const filterValues = ["UNFINISHED" /* UNFINISHED */, "IS_FAVORITE" /* IS_FAVORITE */, "ALL" /* ALL */].map(filter => ({
    id: filter,
    label: filtersLabelsIdsMap[filter]
  }));
  const [selectedFilterId, setSelectedFilterId] = (0,react.useState)(filterValues[0].id);
  const handleSelect = (0,react.useCallback)(filterId => {
    setSelectedFilterId(filterId);
    (0,yandexMetrica/* ymGoal */.qf)(filtersMetricsMap[filterId]);
  }, []);
  const [searchValue, setSearchValue] = (0,react.useState)("");
  const tasksMap = (0,react.useMemo)(() => {
    const sortedTasks = getSortedFn(tasks);
    const lastLessonDate = new Date(sortedTasks?.[0]?.date);
    return getFilterFn(selectedFilterId, searchValue, lastLessonDate)(sortedTasks);
  }, [tasks, selectedFilterId, searchValue]);
  const selectedFilterTasksMap = tasksMap.selectedFilterTasks;
  const otherTasksMap = (0,react.useMemo)(() => searchValue !== "" ? tasksMap.otherTasks : {}, [searchValue, tasksMap.otherTasks]);
  return {
    selectedFilterTasksMap,
    otherTasksMap,
    selectedFilterId,
    setSelectedFilterId: handleSelect,
    filterValues,
    searchValue,
    setSearchValue
  };
}
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/empty-tasks-message/empty-tasks-message.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const empty_tasks_message_module = ({"root":"empty-tasks-message-module__root--kFuhS","small-gap-root":"empty-tasks-message-module__small-gap-root--x_G4V","smallGapRoot":"empty-tasks-message-module__small-gap-root--x_G4V","reverse-root":"empty-tasks-message-module__reverse-root--i0wms","reverseRoot":"empty-tasks-message-module__reverse-root--i0wms","favorite-icon":"empty-tasks-message-module__favorite-icon--eujWh","favoriteIcon":"empty-tasks-message-module__favorite-icon--eujWh","image-container":"empty-tasks-message-module__image-container--sVRGN","imageContainer":"empty-tasks-message-module__image-container--sVRGN","small-image-container":"empty-tasks-message-module__small-image-container--YTSD8","smallImageContainer":"empty-tasks-message-module__small-image-container--YTSD8","image":"empty-tasks-message-module__image--BmQzx","description":"empty-tasks-message-module__description--OOn4A"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/empty-tasks-message/empty-tasks-picture.tsx







const EmptyTasksPicture = _ref => {
  let {
    isEmptySearch,
    isFavorite
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  if (!isEmptySearch && isFavorite) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: empty_tasks_message_module.favoriteIcon,
      name: "bookmark",
      size: "medium"
    });
  }
  const imageAlt = isEmptySearch ? intl.formatMessage({
    id: "searchImage.alt"
  }) : intl.formatMessage({
    id: "noteImage.alt"
  });
  const source = isEmptySearch ? "https://flowstatic.s3.yandex.net/ui-files/nothing_found_x2.png 772w, https://flowstatic.s3.yandex.net/ui-files/nothing_found_x3.png 1158w" : "https://flowstatic.s3.yandex.net/ui-files/note_x2.png 772w, https://flowstatic.s3.yandex.net/ui-files/note_x3.png 1158w";
  const src = isEmptySearch ? "https://flowstatic.s3.yandex.net/ui-files/nothing_found_x1.png" : "https://flowstatic.s3.yandex.net/ui-files/note_x1.png";
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(empty_tasks_message_module.imageContainer, {
      [empty_tasks_message_module.smallImageContainer]: isEmptySearch
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("picture", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("source", {
        srcSet: source
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        alt: imageAlt,
        loading: "lazy",
        decoding: "async",
        draggable: false,
        className: empty_tasks_message_module.image,
        src
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/empty-tasks-message/empty-tasks-message.component.tsx










const EmptyTasksMessage = _ref => {
  let {
    selectedFilterId,
    isEmptySearch
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const isFavorite = selectedFilterId === Filters.IS_FAVORITE;
  const isReverse = isFavorite || isEmptySearch;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(empty_tasks_message_module.root, {
      [empty_tasks_message_module.reverseRoot]: isReverse,
      [empty_tasks_message_module.smallGapRoot]: isFavorite && !isEmptySearch
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: isMobile ? typography_module/* default */.Z.headline4Accent : typography_module/* default */.Z.headline3,
        children: isEmptySearch ? intl.formatMessage({
          id: "beginner-tasks.emptySearch.title"
        }) : intl.formatMessage({
          id: titleMap[selectedFilterId]
        })
      }), isEmptySearch && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: classnames_default()(typography_module/* default */.Z.body2, empty_tasks_message_module.description),
        children: intl.formatMessage({
          id: "beginner-tasks.emptySearch.description"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyTasksPicture, {
      isEmptySearch,
      isFavorite
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/tasks/constants.ts


const TASKS_POLLING_INTERVAL = 5 * 60 * 1e3;
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/section-title/section-title.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const section_title_module = ({"subtitle":"section-title-module__subtitle--G7tOH"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/section-title/section-title.component.tsx










const SectionTitle = _ref => {
  let {
    date,
    themes,
    isLastSessionTasks = false
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const titleClass = isMobile ? typography_module/* default */.Z.headline4Accent : typography_module/* default */.Z.headline3;
  if (isLastSessionTasks) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: titleClass,
      children: intl.formatMessage({
        id: "beginner-tasks.lastLessonTitle"
      })
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: titleClass,
      children: (0,format/* format */.WU)(new Date(date), "d MMMM yyyy", {
        locale: ru.ru
      })
    }), themes.size > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(section_title_module.subtitle, typography_module/* default */.Z.body2Accent),
      children: Array.from(themes).join(" \u2022 ")
    })]
  });
};
// EXTERNAL MODULE: ./src/api/student/syllabus/syllabus.constants.ts
var syllabus_constants = __webpack_require__(48216);
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/tasks-list/tasks-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tasks_list_module = ({"page":"tasks-list-module__page--xVDcs","tasks":"tasks-list-module__tasks--p5T8Z","task-card":"tasks-list-module__task-card--D0cnu","taskCard":"tasks-list-module__task-card--D0cnu","primary-task-card":"tasks-list-module__primary-task-card--nyhFj","primaryTaskCard":"tasks-list-module__primary-task-card--nyhFj"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/tasks-list/tasks-list.component.tsx












const TasksList = _ref => {
  let {
    tasks,
    searchValue,
    onFirstButtonClick,
    onSecondButtonClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile,
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    handleChangeIsFavoriteState
  } = useTasks();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: tasks_list_module.tasks,
    children: tasks.map((card, index) => {
      const cardId = card.id ?? "";
      const lessonType = intl.formatMessage({
        id: card.lessonType
      });
      const subtitle = card.durationMin ? intl.formatMessage({
        id: "beginnerTasksPage.subtitle"
      }, {
        lessonType,
        count: card.durationMin
      }) : intl.formatMessage({
        id: syllabus_constants/* DEFAULT_SELF_STUDY_TYPE_NAME_KEY */.jc
      });
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(tasks_list_module.taskCard, {
          [tasks_list_module.primaryTaskCard]: card.type === task_card_component/* TaskCardType */.Fj.Primary
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(task_card_component/* TaskCard */.sD, {
          id: cardId,
          title: card.title,
          subtitle,
          description: card.description,
          ariaLabels: {
            taskCard: intl.formatMessage({
              id: "selfStudyCard.ariaLabel.taskCard"
            }),
            doneLabel: intl.formatMessage({
              id: "selfStudyCard.ariaLabel.doneLabel"
            }),
            addToFavoriteButton: intl.formatMessage({
              id: "selfStudyCard.ariaLabel.addToFavoriteButton"
            })
          },
          highlightedText: searchValue,
          firstButton: {
            label: intl.formatMessage({
              id: card.buttonText
            }),
            onClick: () => onFirstButtonClick({
              id: card.chapterId,
              nodeId: card.nodeId,
              state: card.state,
              anchorId: cardId
            })
          },
          secondButton: card.state === task_card_component/* TaskCardState */.ab.Done ? {
            label: intl.formatMessage({
              id: isMobile ? "beginnerTasksPage.viewTaskMobile" : "beginnerTasksPage.viewTask"
            }),
            onClick: () => onSecondButtonClick({
              id: card.chapterId,
              nodeId: card.nodeId,
              anchorId: cardId
            })
          } : void 0,
          isFavorite: card.isFavorite ?? false,
          onFavoriteButtonClick: () => {
            void handleChangeIsFavoriteState(card.nodeId ?? "", !card.isFavorite);
          },
          state: card.state,
          isDesktop,
          type: isDesktop ? card.type : task_card_component/* TaskCardType */.Fj.Default,
          image: card.image,
          anchorId: cardId
        })
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/tasks/tasks.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tasks_module = ({"page-layout":"tasks-module__page-layout--jLl7Y","pageLayout":"tasks-module__page-layout--jLl7Y","root":"tasks-module__root--P8jVR","filter-and-search":"tasks-module__filter-and-search--_7a3h","filterAndSearch":"tasks-module__filter-and-search--_7a3h","search-line":"tasks-module__search-line--jfSNN","searchLine":"tasks-module__search-line--jfSNN","tasks-wrapper":"tasks-module__tasks-wrapper--nw58k","tasksWrapper":"tasks-module__tasks-wrapper--nw58k","tasks-wrapper-other-tasks":"tasks-module__tasks-wrapper-other-tasks--Ny_36","tasksWrapperOtherTasks":"tasks-module__tasks-wrapper-other-tasks--Ny_36","tasks-wrapper-title":"tasks-module__tasks-wrapper-title--tHumi","tasksWrapperTitle":"tasks-module__tasks-wrapper-title--tHumi","section":"tasks-module__section--HQ9AY","section-title":"tasks-module__section-title--n7Hin","sectionTitle":"tasks-module__section-title--n7Hin","empty-message-container":"tasks-module__empty-message-container--GlQX4","emptyMessageContainer":"tasks-module__empty-message-container--GlQX4"});
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/tasks/tasks-section.tsx








const TasksSection = _ref => {
  let {
    tasksMap,
    searchValue,
    onFirstButtonClick,
    onSecondButtonClick
  } = _ref;
  const taskEntries = Object.entries(tasksMap);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: taskEntries.map(_ref2 => {
      let [date, {
        tasks,
        themes,
        isLastSessionTasks
      }] = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
        className: tasks_module.section,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
          className: tasks_module.sectionTitle,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(SectionTitle, {
            date,
            themes,
            isLastSessionTasks
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(TasksList, {
          searchValue,
          tasks,
          onFirstButtonClick,
          onSecondButtonClick
        })]
      }, date);
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/components/tasks/tasks.tsx





















const Tasks = _ref => {
  let {
    onFirstButtonClick,
    onSecondButtonClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    fetchTasks,
    tasks,
    isLoading
  } = useTasks();
  (0,react.useEffect)(() => {
    const tasksPolling = (0,create_polling/* createPolling */.$)(fetchTasks, {
      delay: TASKS_POLLING_INTERVAL
    });
    tasksPolling.start();
    return () => tasksPolling.stop();
  }, [fetchTasks]);
  const {
    setSelectedFilterId,
    selectedFilterId,
    selectedFilterTasksMap,
    otherTasksMap,
    filterValues,
    searchValue,
    setSearchValue
  } = useTasksFilter(tasks);
  const [searchInputValue, setSearchInputValue] = (0,react.useState)(searchValue);
  const toggleValues = filterValues.map(_ref2 => {
    let {
      id,
      label
    } = _ref2;
    return {
      id,
      label: intl.formatMessage({
        id: label
      })
    };
  });
  const selectedFilterTasksCount = Object.keys(selectedFilterTasksMap).length;
  const otherTaskCount = Object.keys(otherTasksMap).length;
  const isEmptySearch = selectedFilterTasksCount === 0 && searchValue !== "";
  const debouncedSave = (0,react.useMemo)(() => lodash_debounce_default()(setSearchValue, 300), [setSearchValue]);
  const handleChangeSearchVValue = (0,react.useCallback)(searchFilter => {
    setSearchInputValue(searchFilter);
    debouncedSave(searchFilter);
  }, [debouncedSave]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
    className: tasks_module.pageLayout,
    children: isLoading ? /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {}) : /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: tasks_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: tasks_module.filterAndSearch,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(toggle_button_group/* ToggleButtonGroup */.t, {
          values: toggleValues,
          selectedValueId: selectedFilterId,
          onChange: setSelectedFilterId
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: tasks_module.searchLine,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(SearchLight, {
            onChange: handleChangeSearchVValue,
            value: searchInputValue,
            spellCheck: true,
            placeholder: intl.formatMessage({
              id: "beginner-tasks.search.placeholder"
            })
          })
        })]
      }), selectedFilterTasksCount > 0 ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: tasks_module.tasksWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(TasksSection, {
          searchValue,
          tasksMap: selectedFilterTasksMap,
          onFirstButtonClick,
          onSecondButtonClick
        })
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: tasks_module.emptyMessageContainer,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyTasksMessage, {
          selectedFilterId,
          isEmptySearch
        })
      }), otherTaskCount > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(tasks_module.tasksWrapper, tasks_module.tasksWrapperOtherTasks),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, tasks_module.tasksWrapperTitle),
          children: intl.formatMessage({
            id: "beginner-tasks.searchSection.title"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(TasksSection, {
          searchValue,
          tasksMap: otherTasksMap,
          onFirstButtonClick,
          onSecondButtonClick
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/tasks-page/beginner-tasks.page.tsx













const BeginnerTasksPage = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const user = (0,useUser/* useUser */.aF)();
  const currentProductId = user.data?.attributes.currentProductId ?? "";
  const getChapterLink = (0,react.useCallback)((link, chapterId, syllabusNodeId) => {
    const pathName = history.location.pathname;
    const linkWithRetPath = get_url_search_params.getUrlSearchParams.chapterLink.getLinkWithRetPath({
      link,
      retPath: pathName + `#${chapterId}`,
      history
    });
    if (syllabusNodeId === null) {
      return linkWithRetPath;
    }
    return get_url_search_params.getUrlSearchParams.chapterLink.getLinkWithParams({
      link,
      params: [{
        key: "syllabusNodeId",
        value: syllabusNodeId
      }, {
        key: "retPath",
        value: pathName + `#${chapterId}`
      }],
      history
    });
  }, [history]);
  const handleTrainerOpen = (0,react.useCallback)(params => {
    const {
      id,
      anchorId,
      nodeId
    } = params;
    history.push(getChapterLink(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(currentProductId, id), anchorId, nodeId ?? null));
  }, [currentProductId, getChapterLink, history]);
  const handleRevisionOpen = (0,react.useCallback)(params => {
    const {
      id,
      anchorId,
      nodeId
    } = params;
    history.push(getChapterLink(studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(currentProductId, id), anchorId, nodeId || null));
  }, [currentProductId, getChapterLink, history]);
  const handleFirstButtonClick = (0,react.useCallback)(params => {
    const {
      id,
      state,
      anchorId,
      nodeId
    } = params;
    switch (state) {
      case task_card_component/* TaskCardState */.ab.Available:
        (0,yandexMetrica/* ymGoal */.qf)("Self_Study_Start_Button");
        handleTrainerOpen({
          id,
          anchorId,
          nodeId
        });
        break;
      case task_card_component/* TaskCardState */.ab.InProgress:
        (0,yandexMetrica/* ymGoal */.qf)("Self_Study_Continue_Button");
        handleTrainerOpen({
          id,
          anchorId,
          nodeId
        });
        break;
      case task_card_component/* TaskCardState */.ab.Done:
        (0,yandexMetrica/* ymGoal */.qf)("Self_Study_Repeat_Button");
        handleRevisionOpen({
          id,
          anchorId,
          nodeId
        });
        break;
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(state);
    }
  }, [handleRevisionOpen, handleTrainerOpen]);
  (0,react.useEffect)(() => {
    const currentLocation = window.location.href;
    const hasAnchor = currentLocation.includes("#");
    if (hasAnchor) {
      const anchorId = `${currentLocation.substring(currentLocation.indexOf("#") + 1)}`;
      const anchorEl = document.getElementById(anchorId);
      if (anchorEl) {
        const headerOffset = 32;
        const elementPosition = anchorEl.getBoundingClientRect().top;
        const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
        window.location.hash = "";
      }
    }
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Tasks, {
    onFirstButtonClick: handleFirstButtonClick,
    onSecondButtonClick: params => {
      (0,yandexMetrica/* ymGoal */.qf)("Self_Study_View_Button");
      handleTrainerOpen(params);
    }
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/beginner-index-page-content.tsx



























const BeginnerIndexPageContent = () => {
  const user = (0,useUser/* useUser */.aF)();
  const userId = user.data?.me.user?.id;
  const calendarToken = user.data?.me.user?.calendarToken;
  const {
    isMobile,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    redefinePaymentLink,
    routes,
    resources,
    calendarWebcal,
    referral
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const {
    shouldShowProgress
  } = (0,use_progress_page_enabled/* useProgressPageEnabled */.e)();
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const resourcesBalanceFetcher = (0,use_resources_balance/* useResourcesBalance */.U)({
    useErrorBoundary: false,
    refetchOnMount: "always"
  });
  const {
    state: onboardingState
  } = useBeginnerOnboarding();
  const {
    initSpeakingSessions
  } = useScheduling();
  const {
    data: isRepetitionAvailable
  } = useRepetitionAvailability(isTranslationV2Enabled);
  (0,react.useEffect)(() => {
    void initSpeakingSessions();
  }, [initSpeakingSessions]);
  const isReferralExperimentActive = Boolean(referral.tariff_slug);
  const isScheduleListRoute = (0,react_router/* useRouteMatch */.$B)(routes.SCHEDULE_LIST);
  const showCalendarButton = Boolean(userId && calendarToken && calendarWebcal && isScheduleListRoute);
  const isTasksRoute = (0,react_router/* useRouteMatch */.$B)(routes.TASKS);
  const hideHelpButton = !shouldShowProgress && isMobileOrTablet;
  if (resourcesBalanceFetcher.isFetching) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerIndexPageLoading, {});
  }
  if (resources.enabled && resourcesBalanceFetcher.isError) {
    throw resourcesBalanceFetcher.error;
  }
  if ((0,onboarding/* getIsAutoOnboarding */.sR)(onboardingState)) {
    const isPaidStudent = Object.keys(resourcesBalanceFetcher.data ?? {}).length > 0;
    if (isPaidStudent) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerPageOnboarding, {});
    }
    const currentProductId = user.data?.product?.id;
    const redirect = currentProductId ? redefinePaymentLink.get(currentProductId) : null;
    if (redirect) {
      locationApiAdapter.setLocation(redirect);
    } else if (user.data?.product?.paymentLandingId) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
        to: studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING(user.data.product.paymentLandingId)
      });
    } else {
      return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
        to: studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING("level-a")
      });
    }
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
      doNotWrapChildrenWithLayout: true
    },
    header: {
      hideReferralProgramElements: !isReferralExperimentActive
    },
    main: {
      hideHelpButton,
      hideGrammarGuideButton: !isTasksRoute,
      showCalendarButton
    },
    footer: {
      footerWithMargin: isMobile,
      withBottomMenu: isMobileOrTablet
    },
    data: {
      isRepetitionAvailable
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(react_router/* Switch */.rs, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: routes.SCHEDULE,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerDashboardPage, {
          currentProductId: user.data?.attributes.currentProductId
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: routes.TASKS,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerTasksPage, {})
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: routes.EDUCATION_MATERIALS,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerEducationMaterialsPage, {
          currentProductId: user.data?.attributes.currentProductId ?? "",
          isRepetitionAvailable: isRepetitionAvailable ?? false
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: routes.SCHEDULE_LIST,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(schedule_Schedule, {})
      }), shouldShowProgress && /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: routes.PROGRESS.INDEX,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressPage, {})
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_menu_BottomMenu, {})]
  });
};
;// CONCATENATED MODULE: ./src/pages/beginner-pages/beginner-index.page.tsx








const redirectBeginnerPages = [studentRoutePaths/* studentRoutePaths */.dR.INDEX, studentRoutePaths/* studentRoutePaths */.dR.INDEX + "/", studentRoutePaths/* studentRoutePaths */.dR.INDEX_VISIBLE_DONE, studentRoutePaths/* studentRoutePaths */.dR.INDEX_VISIBLE_ALL];
const BeginnerIndexPage = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const {
    routes
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  if (redirectBeginnerPages.includes(history.location.pathname)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: routes.SCHEDULE + history.location.search
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(BeginnerIndexPageContent, {});
};
/* harmony default export */ const beginner_index_page = (withAnnouncements(BeginnerIndexPage));
// EXTERNAL MODULE: ../shared/src/hooks/use-effect-once.ts
var use_effect_once = __webpack_require__(28504);
// EXTERNAL MODULE: ../../node_modules/ramda/es/sortBy.js
var sortBy = __webpack_require__(10463);
;// CONCATENATED MODULE: ./src/components/coming-speaking-popup/coming-speaking-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const coming_speaking_popup_module = ({"root":"coming-speaking-popup-module__root--I_Iia","start-time":"coming-speaking-popup-module__start-time--kzdZ0","startTime":"coming-speaking-popup-module__start-time--kzdZ0","info":"coming-speaking-popup-module__info--gz7Xw","info-texts":"coming-speaking-popup-module__info-texts--LsmEL","infoTexts":"coming-speaking-popup-module__info-texts--LsmEL","info-image":"coming-speaking-popup-module__info-image--g0k8_","infoImage":"coming-speaking-popup-module__info-image--g0k8_","info-title":"coming-speaking-popup-module__info-title--VB7VM","infoTitle":"coming-speaking-popup-module__info-title--VB7VM","tutor":"coming-speaking-popup-module__tutor--eGl10","tutor-avatar":"coming-speaking-popup-module__tutor-avatar--NnP3R","tutorAvatar":"coming-speaking-popup-module__tutor-avatar--NnP3R","tutor-name":"coming-speaking-popup-module__tutor-name--B28w1","tutorName":"coming-speaking-popup-module__tutor-name--B28w1","buttons":"coming-speaking-popup-module__buttons--cUNba","buttons-divider":"coming-speaking-popup-module__buttons-divider--sEvE1","buttonsDivider":"coming-speaking-popup-module__buttons-divider--sEvE1"});
;// CONCATENATED MODULE: ./src/components/coming-speaking-popup/coming-speaking-popup.component.tsx



















const ComingSpeakingPopup = _ref => {
  let {
    speakingSessions,
    isFirstSpeaking,
    onNeedUpdates
  } = _ref;
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const [isDeletePopupVisible, setDeletePopupVisible] = (0,react.useState)(false);
  const orderedSpeakings = (0,react.useMemo)(() => (0,sortBy/* default */.Z)(session => session.startAt, speakingSessions), [speakingSessions]);
  const currentSpeaking = (0,react.useMemo)(() => {
    for (const session of orderedSpeakings) {
      const differenceMin = (0,differenceInMinutes/* differenceInMinutes */.X)(currentTime, session.startAt);
      if (differenceMin < -CLASS_POPUP_BEFORE_START_MIN) {
        return null;
      }
      if (differenceMin < session.durationMin) {
        return session;
      }
    }
    return null;
  }, [currentTime, orderedSpeakings]);
  const handleDelete = (0,react.useCallback)(() => {
    setDeletePopupVisible(true);
  }, []);
  const handleCloseSpeakingClick = (0,react.useCallback)(() => {
    setDeletePopupVisible(false);
  }, []);
  const handleDeleted = (0,react.useCallback)(() => {
    setDeletePopupVisible(false);
    onNeedUpdates();
  }, [onNeedUpdates]);
  if (currentSpeaking === null) {
    return null;
  }
  const minAfterStart = (0,differenceInMinutes/* differenceInMinutes */.X)(currentTime, currentSpeaking.startAt);
  const isPopupDisplayable = [speakingSession_model/* SpeakingType */.xP.CHAPTER, speakingSession_model/* SpeakingType */.xP.MENTOR].includes(currentSpeaking.speakingType);
  if (!isPopupDisplayable) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: coming_speaking_popup_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(coming_speaking_popup_module.startTime, typography_module/* default */.Z.captionAccent),
      children: [minAfterStart < -1 && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "comingSpeakingPopup.startAfter",
        values: {
          time: -minAfterStart - 1
        }
      }), minAfterStart === -1 && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "comingSpeakingPopup.readyToStart"
      }), minAfterStart === 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "comingSpeakingPopup.goesLess1Min"
      }), minAfterStart > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "comingSpeakingPopup.goesMin",
        values: {
          time: minAfterStart
        }
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: coming_speaking_popup_module.info,
      children: [currentSpeaking.imageUrl && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: coming_speaking_popup_module.infoImage,
        style: {
          backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(currentSpeaking.imageUrl)
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: coming_speaking_popup_module.infoTexts,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(coming_speaking_popup_module.infoTitle, typography_module/* default */.Z.body2Accent),
          children: currentSpeaking.title
        }), currentSpeaking.tutor !== null && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: coming_speaking_popup_module.tutor,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: coming_speaking_popup_module.tutorAvatar,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(avatar_component/* Avatar */.q, {
              size: avatar_component/* AvatarSize */.D.Size32,
              avatarId: currentSpeaking.tutor.avatar
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(coming_speaking_popup_module.tutorName, typography_module/* default */.Z.captionAccent),
            children: currentSpeaking.tutor.name
          })]
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: coming_speaking_popup_module.buttons,
      children: [minAfterStart < -1 && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        size: "small",
        appearance: "secondaryOnBlack",
        onClick: handleDelete,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "comingSpeakingPopup.cancelClass"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: coming_speaking_popup_module.buttonsDivider
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
        size: "small",
        appearance: "primaryOnBlack",
        href: isFirstSpeaking ? studentRoutePaths/* studentRoutePaths */.dR.PRE_SPEAKING(currentSpeaking.id) : studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(currentSpeaking.id),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "comingSpeakingPopup.joinClass"
        })
      })]
    }), isDeletePopupVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(StudentSpeakingCancelConformationPopup, {
      title: currentSpeaking.title,
      startAt: currentSpeaking.startAt,
      speakingId: currentSpeaking.id,
      onDeleted: handleDeleted,
      onClose: handleCloseSpeakingClick
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/teacher-info-card/about.svg
function about_extends() { about_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return about_extends.apply(this, arguments); }

/* harmony default export */ const about = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", about_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "156",
    height: "35",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M2.5 33L15 1l3 32M8 20s6.5-.5 8.5 0m23 14c.35-11.047 1-22.5-.5-33m3.57 30.84s1.839 1.094 3.43.66c5.5-1.5 8.612-8.49 3.728-12.958-1.358-1.314-3.332-1.875-5.188-1.617-1.814.252-3.534 1.302-4.395 2.948m37.129-2.097c3.327-2.262 7.645-2.748 10.393.84a8.45 8.45 0 01-1.065 10.507 8.917 8.917 0 01-11.665 1.271c-4.636-3.795-1.982-9.702 2.337-12.618zM111.461 17l-.654 5.25a16.376 16.376 0 00.16 7.04 3.675 3.675 0 002.763 2.794 3.404 3.404 0 002.037-.553c1.52-1 2.67-2.472 3.272-4.19a25.077 25.077 0 001.193-5.265l.684-4.625c-.664 4.874-.659 10.63-.684 15.549m26.899-32a117.042 117.042 0 00-.814 22.793 14.894 14.894 0 001.23 5.97 5.586 5.586 0 004.83 3.237M142.5 19c3.401.344 6.82.344 10.239.434"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/teacher-info-card/teacher-info-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const teacher_info_card_module = ({"teacher-info-card":"teacher-info-card-module__teacher-info-card--ILo_f","teacherInfoCard":"teacher-info-card-module__teacher-info-card--ILo_f","teacher-info-card-mobile":"teacher-info-card-module__teacher-info-card-mobile--ahxqo","teacherInfoCardMobile":"teacher-info-card-module__teacher-info-card-mobile--ahxqo","teacher-avatar":"teacher-info-card-module__teacher-avatar--felu1","teacherAvatar":"teacher-info-card-module__teacher-avatar--felu1","teacher-photo":"teacher-info-card-module__teacher-photo--e9p9V","teacherPhoto":"teacher-info-card-module__teacher-photo--e9p9V","teacher-info":"teacher-info-card-module__teacher-info--FhgSs","teacherInfo":"teacher-info-card-module__teacher-info--FhgSs","teacher-info-text":"teacher-info-card-module__teacher-info-text--JaraK","teacherInfoText":"teacher-info-card-module__teacher-info-text--JaraK","error-block":"teacher-info-card-module__error-block--fzH9g","errorBlock":"teacher-info-card-module__error-block--fzH9g","button":"teacher-info-card-module__button--TSWJ1"});
;// CONCATENATED MODULE: ../ui-kit/src/teacher-info-card/teacher-info-card.component.tsx














var TeacherInfoState = /* @__PURE__ */(TeacherInfoState2 => {
  TeacherInfoState2["Loading"] = "loading";
  TeacherInfoState2["Loaded"] = "loaded";
  TeacherInfoState2["Error"] = "error";
  return TeacherInfoState2;
})(TeacherInfoState || {});
const TeacherInfoCard = _ref => {
  let {
    isMobile,
    photo,
    name,
    info,
    onClose,
    visible,
    state,
    onReload,
    textConstants
  } = _ref;
  const minHeightOfModal = 450;
  const renderContent = (0,react.useCallback)(() => {
    switch (state) {
      case "loading" /* Loading */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {
            marginTop: (minHeightOfModal - 32) / 2
          });
        }
      case "loaded" /* Loaded */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: teacher_info_card_module.teacherAvatar,
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)(about, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: teacher_info_card_module.teacherPhoto,
                style: {
                  backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(photo)
                }
              })]
            }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              className: teacher_info_card_module.teacherInfo,
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
                className: typography_module/* default */.Z.headline4Accent,
                children: name
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
                className: classnames_default()(typography_module/* default */.Z.body2, teacher_info_card_module.teacherInfoText),
                children: info
              })]
            })]
          });
        }
      case "error" /* Error */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: teacher_info_card_module.errorBlock,
            style: {
              height: minHeightOfModal
            },
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
              className: typography_module/* default */.Z.headline4Accent,
              children: textConstants.errorHeader
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
              className: classnames_default()(typography_module/* default */.Z.body2, teacher_info_card_module.teacherInfoText),
              children: textConstants.errorText
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
              appearance: "primary",
              className: teacher_info_card_module.button,
              onClick: onReload,
              children: textConstants.errorButtonText
            })]
          });
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(state);
    }
  }, [state, photo, name, info, textConstants.errorHeader, textConstants.errorText, textConstants.errorButtonText, onReload]);
  if (!isMobile) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(deprecated_modal_component/* DeprecatedModal */.rr, {
      className: teacher_info_card_module.teacherInfoCard,
      showCloseButton: true,
      onClose,
      overlayZIndex: deprecated_modal_component/* ModalOverlayZIndex */.i3.Low,
      visible,
      minHeight: minHeightOfModal,
      autoHeight: true,
      children: renderContent()
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_sheet_light_component/* BottomSheetLight */.e_, {
    headerPaddings: bottom_sheet_light_component/* HeaderPaddings */.wR.Default,
    headerWithBorder: false,
    visible: visible || false,
    onClose,
    fixed: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: teacher_info_card_module.teacherInfoCardMobile,
      children: renderContent()
    })
  });
};
// EXTERNAL MODULE: ./src/api/tutor/tutor.api.ts + 3 modules
var tutor_api = __webpack_require__(13925);
;// CONCATENATED MODULE: ./src/components/teacher-info-card/teacher-info-card.component.tsx









const teacher_info_card_component_TeacherInfoCard = _ref => {
  let {
    id
  } = _ref;
  const fetcher = (0,useFetch/* useFetch */.i)(tutor_api/* getTutorInfo */.Wt);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const handleCloseTeacherInfo = (0,react.useCallback)(() => {}, []);
  (0,react.useEffect)(() => {
    if (fetcher.state === useFetch/* State */.Z.Initial) {
      void fetcher.fetch(id);
    }
  }, [fetcher, id]);
  const onReload = (0,react.useCallback)(() => {
    if (fetcher.state !== useFetch/* State */.Z.Loading) {
      void fetcher.fetch(id);
    }
  }, [fetcher, id]);
  const fetcherState = fetcher.state;
  switch (fetcherState) {
    case useFetch/* State */.Z.Initial:
    case useFetch/* State */.Z.Loading:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherInfoCard, {
          isMobile,
          visible: true,
          onClose: handleCloseTeacherInfo,
          state: TeacherInfoState.Loading,
          textConstants: {
            errorHeader: "",
            errorText: "",
            errorButtonText: ""
          }
        });
      }
    case useFetch/* State */.Z.Error:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherInfoCard, {
          isMobile,
          visible: true,
          onClose: handleCloseTeacherInfo,
          state: TeacherInfoState.Error,
          onReload,
          textConstants: {
            errorHeader: "",
            errorText: "",
            errorButtonText: ""
          }
        });
      }
    case useFetch/* State */.Z.Loaded:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TeacherInfoCard, {
          isMobile,
          photo: fetcher.data.photo,
          name: fetcher.data.name,
          info: fetcher.data.description,
          visible: true,
          onClose: handleCloseTeacherInfo,
          state: TeacherInfoState.Loaded,
          textConstants: {
            errorHeader: "",
            errorText: "",
            errorButtonText: ""
          }
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(fetcherState);
  }
};
;// CONCATENATED MODULE: ./src/components/chapter-duration/chapter-duration.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chapter_duration_module = ({"secondary":"chapter-duration-module__secondary--2U0XL","default":"chapter-duration-module__default--bnZri"});
;// CONCATENATED MODULE: ./src/components/chapter-duration/chapter-duration.component.tsx









const DEFAULT_HISTORY_DURATION = 20;
var ChapterDurationAppearance = /* @__PURE__ */(ChapterDurationAppearance2 => {
  ChapterDurationAppearance2["Secondary"] = "secondary";
  ChapterDurationAppearance2["Primary"] = "primary";
  ChapterDurationAppearance2["Default"] = "default";
  return ChapterDurationAppearance2;
})(ChapterDurationAppearance || {});
const ChapterDuration = _ref => {
  let {
    chapter,
    appearance
  } = _ref;
  const {
    hideChapterDuration
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  if (hideChapterDuration) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()({
      [chapter_duration_module.secondary]: appearance === "secondary" /* Secondary */,
      [typography_module/* default */.Z.caption]: appearance === "secondary" /* Secondary */,
      [typography_module/* default */.Z.body2Accent]: appearance === "primary" /* Primary */,
      [typography_module/* default */.Z.body2]: appearance === "default" /* Default */,
      [chapter_duration_module["default"]]: appearance === "default" /* Default */
    }),
    children: [chapter.type === student_model/* ChapterItemType */.a.Chapter && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "chapterDuration.chapterHistory",
      values: {
        historyDurationMin: chapter.historyDurationMin ?? DEFAULT_HISTORY_DURATION
      }
    }), chapter.type === student_model/* ChapterItemType */.a.Chapter && chapter.speaking?.durationMin && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "chapterDuration.chapterSpeaking",
      values: {
        speakingDurationMin: chapter.speaking?.durationMin
      }
    }), chapter.type === student_model/* ChapterItemType */.a.Mentor && chapter.speaking?.durationMin && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
      id: "chapterDuration.mentorSpeaking",
      values: {
        speakingDurationMin: chapter.speaking?.durationMin
      }
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/chapter-info/chapter-info.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chapter_info_page_module = ({"root":"chapter-info-page-module__root--r29Mo","title":"chapter-info-page-module__title--mq1UN","info":"chapter-info-page-module__info--SD98Z","duration":"chapter-info-page-module__duration--Lp37w","description":"chapter-info-page-module__description--rIKgZ","grammar":"chapter-info-page-module__grammar--b0anj","vocabulary":"chapter-info-page-module__vocabulary--SSSDi","chapter-image-wrapper":"chapter-info-page-module__chapter-image-wrapper--uSsys","chapterImageWrapper":"chapter-info-page-module__chapter-image-wrapper--uSsys","chapter-image":"chapter-info-page-module__chapter-image--kYqTa","chapterImage":"chapter-info-page-module__chapter-image--kYqTa","action-buttons":"chapter-info-page-module__action-buttons--vCRDW","actionButtons":"chapter-info-page-module__action-buttons--vCRDW","action-buttons-title":"chapter-info-page-module__action-buttons-title--yAQIV","actionButtonsTitle":"chapter-info-page-module__action-buttons-title--yAQIV"});
;// CONCATENATED MODULE: ./src/pages/chapter-info/chapter-info.page.tsx























const ActionButtons = _ref => {
  let {
    chapter,
    isBought,
    firstMentorSpeaking,
    isFirstSpeaking,
    onNeedUpdates,
    notForSale
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: chapter_info_page_module.actionButtons,
    children: [!isBought && /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()(chapter_info_page_module.actionButtonsTitle, typography_module/* default */.Z.body2Accent),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "chapterInfo.notBought"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtons, {
      disabled: !isBought,
      chapter,
      isFirstSpeaking,
      firstMentorSpeaking,
      onNeedUpdates,
      appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New,
      notForSale
    })]
  });
};
const ChapterInfoPage = _ref2 => {
  let {
    currentPackets,
    packetId,
    chapterIndex,
    firstMentorSpeaking,
    isFirstSpeaking,
    courseTitle = "",
    onNeedUpdates,
    isRepetitionAvailable,
    notForSale = false
  } = _ref2;
  const {
    isMobile,
    isTabletOrDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const history = (0,react_router/* useHistory */.k6)();
  const [actionButtonsVisible, setActionButtonsVisible] = (0,react.useState)(false);
  const intl = (0,useIntl/* default */.Z)();
  const packetIndex = (0,react.useMemo)(() => currentPackets.findIndex(x => x.id === packetId), [currentPackets, packetId]);
  const packet = currentPackets[packetIndex];
  const isTrial = packet.price === 0;
  (0,useKeyPress/* useKeyPress */.K)("Escape", () => {
    if (isTrial) {
      history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
      return;
    }
    history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET(packetId));
  });
  const chapter = packet?.chapters[chapterIndex] ?? null;
  const isBought = packet?.isBought;
  const goBackLink = isTrial ? studentRoutePaths/* studentRoutePaths */.dR.INDEX : studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET(packetId);
  const goBackText = isTrial ? courseTitle : packet?.title;
  if (chapter === null) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      doNotWrapChildrenWithLayout: true,
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    data: {
      isRepetitionAvailable
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(Container, {
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: chapter_info_page_module.root,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: chapter_info_page_module.info,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(GoToLink, {
            link: goBackLink,
            text: goBackText
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
            className: classnames_default()(typography_module/* default */.Z.headline2, chapter_info_page_module.title),
            children: chapter.title
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(chapter_info_page_module.duration, typography_module/* default */.Z.body2Accent),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterDuration, {
              chapter,
              appearance: ChapterDurationAppearance.Primary
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(chapter_info_page_module.description, typography_module/* default */.Z.body2),
            children: chapter.description
          }), chapter.contentDescription.grammar && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: chapter_info_page_module.grammar,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.body2Accent,
              children: intl.formatMessage({
                id: "chapterInfoPage.grammar"
              })
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.body2,
              children: chapter.contentDescription.grammar
            })]
          }), chapter.contentDescription.vocabulary && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: chapter_info_page_module.vocabulary,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.body2Accent,
              children: intl.formatMessage({
                id: "chapterInfoPage.vocabulary"
              })
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.body2,
              children: chapter.contentDescription.vocabulary
            })]
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: chapter_info_page_module.chapterImageWrapper,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: chapter_info_page_module.chapterImage,
              style: {
                backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(chapter?.imageUrl)
              }
            })
          })]
        }), isTabletOrDesktop && /* @__PURE__ */(0,jsx_runtime.jsx)(ActionButtons, {
          isBought,
          chapter,
          firstMentorSpeaking,
          isFirstSpeaking,
          onNeedUpdates,
          notForSale
        }), isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)(bottom_sheet_light_component/* BottomSheetLight */.e_, {
          headerPaddings: bottom_sheet_light_component/* HeaderPaddings */.wR.Default,
          headerWithBorder: false,
          visible: actionButtonsVisible,
          actionsItems: [],
          title: "",
          subtitle: "",
          onClose: () => {
            setActionButtonsVisible(false);
          },
          appearance: bottom_sheet_light_component/* BottomSheetLightAppearance */.j9.HalfVisible,
          hiddenTitle: intl.formatMessage({
            id: "chapterInfoPage.showTasks"
          }),
          onOpen: () => {
            setActionButtonsVisible(true);
          },
          zIndex: bottom_sheet_light_component/* BottomSheetLightZIndex */.eD.Low,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(ActionButtons, {
            isBought,
            chapter,
            firstMentorSpeaking,
            isFirstSpeaking,
            onNeedUpdates,
            notForSale
          })
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/packet-chapters-list/packet-chapters-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const packet_chapters_list_module = ({"root":"packet-chapters-list-module__root--BuMY4","link":"packet-chapters-list-module__link--wVDdd","chapter":"packet-chapters-list-module__chapter--fsBBq","description":"packet-chapters-list-module__description--YV22O","chapter-duration":"packet-chapters-list-module__chapter-duration--MYRi4","chapterDuration":"packet-chapters-list-module__chapter-duration--MYRi4","chapter-title":"packet-chapters-list-module__chapter-title--K00lO","chapterTitle":"packet-chapters-list-module__chapter-title--K00lO","chapter-mentor":"packet-chapters-list-module__chapter-mentor--icGOZ","chapterMentor":"packet-chapters-list-module__chapter-mentor--icGOZ","action-button-wrapper":"packet-chapters-list-module__action-button-wrapper--API7T","actionButtonWrapper":"packet-chapters-list-module__action-button-wrapper--API7T","scheduled-speaking-block":"packet-chapters-list-module__scheduled-speaking-block--QJTM4","scheduledSpeakingBlock":"packet-chapters-list-module__scheduled-speaking-block--QJTM4","continue-button":"packet-chapters-list-module__continue-button--yLoif","continueButton":"packet-chapters-list-module__continue-button--yLoif","continue-button-text":"packet-chapters-list-module__continue-button-text--PGTAB","continueButtonText":"packet-chapters-list-module__continue-button-text--PGTAB","chapter-image-wrapper":"packet-chapters-list-module__chapter-image-wrapper--yKEmM","chapterImageWrapper":"packet-chapters-list-module__chapter-image-wrapper--yKEmM","chapter-image":"packet-chapters-list-module__chapter-image--DG56k","chapterImage":"packet-chapters-list-module__chapter-image--DG56k"});
;// CONCATENATED MODULE: ./src/components/packet-chapters-list/packet-chapters-list.component.tsx























const PacketChaptersListItemButton = _ref => {
  let {
    chapter,
    chapterLink,
    isFirstSpeaking,
    onNeedUpdates
    // eslint-disable-next-line sonarjs/cognitive-complexity
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const currentTime = (0,useCurrentTime/* useCurrentTime */.YY)();
  const {
    startWithSpeakingSession
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  switch (chapter.type) {
    case student_model/* ChapterItemType */.a.Mentor:
      {
        const isCheckedChapterButtonsItem = chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Completed;
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: packet_chapters_list_module.actionButtonWrapper,
          children: [chapter.speaking?.session === null && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterScheduleItem, {
            wasCompleted: false,
            speakingId: chapter.speaking.id,
            isMentor: chapter.type === student_model/* ChapterItemType */.a.Mentor,
            disabled: false,
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), isCheckedChapterButtonsItem && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
            iconName: "checkmark",
            state: ChapterButtonsItemState.Completed,
            text: intl.formatMessage({
              id: "packetChaptersList.finished"
            }),
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsScheduledSpeaking, {
            currentTime,
            currentState: getCurrentState(currentTime, chapter.speaking?.session.startAt, chapter.speaking?.durationMin),
            title: chapter.title,
            startAt: chapter.speaking?.session.startAt,
            speakingSessionId: chapter.speaking?.session.id,
            tutor: chapter.speaking?.session.tutor,
            durationMin: chapter.speaking?.durationMin,
            isFirstSpeaking,
            isMentor: true,
            onNeedUpdates,
            color: ChapterButtonsScheduledSpeakingColor.White
          })]
        });
      }
    case student_model/* ChapterItemType */.a.Chapter:
      {
        const isNotCompletedScheduleItem = startWithSpeakingSession && chapter.speaking?.session?.state !== speakingSession_model/* SpeakingSessionState */.Z.Completed && chapter.speaking?.session?.state !== speakingSession_model/* SpeakingSessionState */.Z.Scheduled;
        const isSimpleButtonsItem = chapter.chapterState.type === student_model/* ChapterStateType */.n_.NotStarted && (chapter.speaking?.session === null && !startWithSpeakingSession || !chapter.speaking && startWithSpeakingSession);
        const isStartedButtonsItem = chapter.speaking?.session === null || !chapter.speaking && startWithSpeakingSession;
        const isCompletedStoryWithSpeaking = chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Completed;
        const isCompletedStoryWithoutSpeaking = !chapter.speaking && startWithSpeakingSession && chapter.chapterState.type === student_model/* ChapterStateType */.n_.Ended;
        return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: packet_chapters_list_module.actionButtonWrapper,
          children: [chapter.speaking?.session !== null && chapter.speaking?.session.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsScheduledSpeaking, {
            currentTime,
            currentState: getCurrentState(currentTime, chapter.speaking?.session.startAt, chapter.speaking?.durationMin),
            title: chapter.title,
            startAt: chapter.speaking?.session.startAt,
            speakingSessionId: chapter.speaking?.session.id,
            tutor: chapter.speaking?.session.tutor,
            durationMin: chapter.speaking?.durationMin,
            isFirstSpeaking,
            isMentor: true,
            onNeedUpdates
          }), isNotCompletedScheduleItem && chapter.speaking && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterScheduleItem, {
            wasCompleted: false,
            speakingId: chapter.speaking.id,
            isMentor: false,
            disabled: false,
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), isSimpleButtonsItem && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
            iconName: "simple-arrow-right",
            state: ChapterButtonsItemState.Active,
            text: intl.formatMessage({
              id: "packetChaptersList.start"
            }),
            link: chapterLink,
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), isStartedButtonsItem && chapter.chapterState.type === student_model/* ChapterStateType */.n_.Started && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
            iconName: "new-arrow-right",
            state: ChapterButtonsItemState.Active,
            text: intl.formatMessage({
              id: "packetChaptersList.continue"
            }),
            progress: chapter.chapterState.progressPercent / 100,
            link: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(chapter.productId, chapter.chapterId),
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), chapter.chapterState.type === student_model/* ChapterStateType */.n_.Ended && chapter.speaking?.session === null && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterScheduleItem, {
            wasCompleted: false,
            speakingId: chapter.speaking.id,
            isMentor: false,
            disabled: false,
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), isCompletedStoryWithSpeaking && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
            iconName: "checkmark",
            state: ChapterButtonsItemState.Completed,
            text: intl.formatMessage({
              id: "packetChaptersList.finished"
            }),
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          }), isCompletedStoryWithoutSpeaking && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
            iconName: "checkmark",
            state: ChapterButtonsItemState.Completed,
            text: intl.formatMessage({
              id: "packetChaptersList.finished"
            }),
            appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
          })]
        });
      }
    default:
      return null;
  }
};
const PacketChaptersListItem = _ref2 => {
  let {
    chapter,
    chapterLink,
    isBought,
    isTrial,
    isFirstSpeaking,
    onNeedUpdates,
    isLimitedAccess = false
  } = _ref2;
  const getChapterDuration = () => {
    if (isLimitedAccess) {
      return null;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: packet_chapters_list_module.chapterDuration,
      children: isTrial ? /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "packetChaptersList.free"
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterDuration, {
        chapter,
        appearance: ChapterDurationAppearance.Default
      })
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(packet_chapters_list_module.chapter, {
      [packet_chapters_list_module.chapterMentor]: chapter.type === student_model/* ChapterItemType */.a.Mentor
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: packet_chapters_list_module.description,
      children: [getChapterDuration(), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(packet_chapters_list_module.chapterTitle, typography_module/* default */.Z.headline3),
        children: chapter.title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2),
        children: chapter.progress === student_model/* PacketChapterProgress */.h0.NotStarted || isLimitedAccess ? chapter.description : ""
      }), isBought && !isLimitedAccess && /* @__PURE__ */(0,jsx_runtime.jsx)(PacketChaptersListItemButton, {
        chapter,
        chapterLink,
        isFirstSpeaking,
        onNeedUpdates
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: packet_chapters_list_module.chapterImageWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: packet_chapters_list_module.chapterImage,
        style: {
          backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(chapter.imageUrl)
        }
      })
    })]
  });
};
const PacketChaptersList = _ref3 => {
  let {
    packet,
    isFirstSpeaking,
    onNeedUpdates,
    notForSale
  } = _ref3;
  const {
    allowAccessForPacketStudents
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const isLimitedAccess = notForSale && !allowAccessForPacketStudents;
  const visibleChapters = isLimitedAccess ? packet.chapters.filter(chapter => chapter.type !== student_model/* ChapterItemType */.a.Mentor && chapter.progress !== student_model/* PacketChapterProgress */.h0.NotStarted) : packet.chapters;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: packet_chapters_list_module.root,
    children: visibleChapters.map((chapter, index) => {
      const chapterLink = studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET_CHAPTER(packet.id, String(index));
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
          to: chapterLink,
          className: packet_chapters_list_module.link,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(PacketChaptersListItem, {
            chapter,
            chapterLink,
            isTrial: packet.price === 0,
            isBought: packet.isBought,
            isFirstSpeaking,
            onNeedUpdates,
            isLimitedAccess
          })
        })
      }, index);
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/course-description.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_description_module = ({"root":"course-description-module__root--E9o1c","info":"course-description-module__info--tZE3q","course-subtitle":"course-description-module__course-subtitle--BsZ7Q","courseSubtitle":"course-description-module__course-subtitle--BsZ7Q","description":"course-description-module__description--eathp","delimiter":"course-description-module__delimiter--eRdkj"});
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/delimiter/delimiter.component.tsx





const Delimiter = _ref => {
  let {
    className = ""
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(course_description_module.delimiter, className)
  });
};
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/course-subtitle/course-subtitle.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_subtitle_module = ({"announce-block":"course-subtitle-module__announce-block--PJnMB","announceBlock":"course-subtitle-module__announce-block--PJnMB","announce-block-subtitle":"course-subtitle-module__announce-block-subtitle--QaUWZ","announceBlockSubtitle":"course-subtitle-module__announce-block-subtitle--QaUWZ","announce-block-subtitle-link":"course-subtitle-module__announce-block-subtitle-link--wp1ws","announceBlockSubtitleLink":"course-subtitle-module__announce-block-subtitle-link--wp1ws"});
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/course-subtitle/course-subtitle.component.tsx





















var CourseState = /* @__PURE__ */(CourseState2 => {
  CourseState2["ReadyForPay"] = "ReadyForPay";
  CourseState2["NotForSale"] = "NotForSale";
  CourseState2["InProgress"] = "InProgress";
  CourseState2["Done"] = "Done";
  return CourseState2;
})(CourseState || {});
const getCourseState = (isCourseNotForSale, isCourseBought, isCoursePartlyBought, packetsCount, donePacketsCount) => {
  if (isCourseNotForSale) {
    return "NotForSale" /* NotForSale */;
  }
  if (isCourseBought || isCoursePartlyBought) {
    if (donePacketsCount < packetsCount) {
      return "InProgress" /* InProgress */;
    }
    if (donePacketsCount === packetsCount) {
      return "Done" /* Done */;
    }
  }
  return "ReadyForPay" /* ReadyForPay */;
};
const CourseSubtitle = _ref => {
  let {
    productInfo,
    packets,
    partlyBought
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const chaptersCount = (0,react.useMemo)(() => packets.map(packet => {
    if (packet.price === 0) {
      return 0;
    }
    return packet.chapters.filter(chapter => chapter.type === student_model/* ChapterItemType */.a.Chapter).length;
  }).reduce((acc, count) => acc + count, 0), [packets]);
  const packetsCount = (0,react.useMemo)(() => packets.reduce((acc, packet) => {
    if (packet.price !== 0) {
      return acc + 1;
    }
    return acc;
  }, 0), [packets]);
  const donePacketsCount = (0,react.useMemo)(() => packets.filter(packet => packet.price !== 0).map(packet => packet.chapters.every(chapter => chapter.progress === student_model/* PacketChapterProgress */.h0.Ended)).reduce((acc, ended) => {
    if (ended) {
      return acc + 1;
    }
    return acc;
  }, 0), [packets]);
  const courseState = getCourseState(productInfo.notForSale, productInfo.isBought, partlyBought, packetsCount, donePacketsCount);
  switch (courseState) {
    case "ReadyForPay" /* ReadyForPay */:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [packetsCount > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "courseDescription.packetsCount",
          values: {
            packetsCount
          }
        }), chaptersCount > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Delimiter, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "courseDescription.chaptersCount",
            values: {
              chaptersCount
            }
          })]
        }), productInfo.hours && productInfo.hours > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Delimiter, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "courseDescription.hours",
            values: {
              hours: productInfo.hours
            }
          })]
        })]
      });
    case "NotForSale" /* NotForSale */:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: course_subtitle_module.announceBlock,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "courseDescription.courseIsNotForSaleTitle"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("p", {
          className: classnames_default()(course_subtitle_module.announceBlockSubtitle, typography_module/* default */.Z.body2),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "courseDescription.courseIsNotForSaleSubtitlePart1"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
            className: classnames_default()(course_subtitle_module.announceBlockSubtitleLink, typography_module/* default */.Z.body2Accent),
            to: studentRoutePaths/* studentRoutePaths */.dR.COURSE_SELECT,
            children: intl.formatMessage({
              id: "courseDescription.courseIsNotForSaleSubtitlePart2"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "courseDescription.courseIsNotForSaleSubtitlePart3"
          })]
        })]
      });
    case "InProgress" /* InProgress */:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "courseDescription.courseProgress",
          values: {
            done: donePacketsCount,
            left: packetsCount - donePacketsCount
          }
        })
      });
    case "Done" /* Done */:
      if (packetsCount === 0) {
        return null;
      }
      return /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "courseDescription.courseFinished"
      });
    default:
      return null;
  }
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/index.ts



;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/price/price.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const price_price_module = ({"price-block":"price-module__price-block--CoHyf","priceBlock":"price-module__price-block--CoHyf","price":"price-module__price--lbYQb","price-center":"price-module__price-center--Z_Rof","priceCenter":"price-module__price-center--Z_Rof","discounted-price":"price-module__discounted-price--Zyp0R","discountedPrice":"price-module__discounted-price--Zyp0R","price-bottom-block":"price-module__price-bottom-block--ltneD","priceBottomBlock":"price-module__price-bottom-block--ltneD","full-price":"price-module__full-price--J7rln","fullPrice":"price-module__full-price--J7rln","buy-button":"price-module__buy-button--wCfd1","buyButton":"price-module__buy-button--wCfd1","buy-button-plus-icon":"price-module__buy-button-plus-icon--IIJMY","buyButtonPlusIcon":"price-module__buy-button-plus-icon--IIJMY","promocode":"price-module__promocode--JnN0p","promocode-icon":"price-module__promocode-icon--RkjEP","promocodeIcon":"price-module__promocode-icon--RkjEP"});
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/price/price.tsx













var PriceButtonOpenType = /* @__PURE__ */(PriceButtonOpenType2 => {
  PriceButtonOpenType2["Absolute"] = "Absolute";
  PriceButtonOpenType2["Relative"] = "Relative";
  return PriceButtonOpenType2;
})(PriceButtonOpenType || {});
const price_Price = _ref => {
  let {
    productId,
    button: {
      href,
      textId,
      onClick = function_utils/* emptyFunction */.Bi,
      openType = "Relative" /* Relative */
    },
    promocodeButtonOnClick = function_utils/* emptyFunction */.Bi
  } = _ref;
  const productIds = (0,react.useMemo)(() => [productId], [productId]);
  const priceObj = useProductsPrices(productIds);
  const priceData = priceObj[productId];
  if (!priceData) {
    return null;
  }
  const {
    price,
    discountPrice,
    currency
  } = priceData;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: price_price_module.priceBlock,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(price_price_module.price, {
        [price_price_module.priceCenter]: price <= discountPrice
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(price_price_module.discountedPrice, typography_module/* default */.Z.headline2),
        children: formatPrice({
          price: discountPrice,
          currency
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(price_price_module.priceBottomBlock),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
          appearance: "primary",
          href,
          onClick,
          className: price_price_module.buyButton,
          useNativeTag: openType === "Absolute" /* Absolute */,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: textId
          })
        }), price > discountPrice && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: price_price_module.fullPrice,
          children: formatPrice({
            price,
            currency
          })
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: price_price_module.promocode,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(EnterPromoCodeButtonLink, {
        size: "small",
        appearance: "secondary",
        hideTextOnTouch: false,
        onClick: promocodeButtonOnClick
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-description/course-description.component.tsx












const CourseDescription = _ref => {
  let {
    productInfo,
    packets,
    partlyBought,
    redefinedPaymentLink
  } = _ref;
  const canBuy = !partlyBought && !productInfo.notForSale && !productInfo.isBought;
  const handlePromoCodeButtonClick = (0,react.useCallback)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Go_To_Enter_Promo_Code_Popup_From_Course_Page");
  }, []);
  const handleGoPayment = (0,react.useCallback)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Go_To_Payment_Popup_From_Buy_Product_Page_Full");
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: course_description_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: course_description_module.info,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        className: typography_module/* default */.Z.headline2,
        children: productInfo.title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(course_description_module.courseSubtitle, typography_module/* default */.Z.body2Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(CourseSubtitle, {
          productInfo,
          packets,
          partlyBought
        })
      }), !productInfo.notForSale && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(course_description_module.description, typography_module/* default */.Z.body2),
        children: productInfo.description
      })]
    }), canBuy && /* @__PURE__ */(0,jsx_runtime.jsx)(price_Price, {
      productId: productInfo.id,
      button: {
        textId: "courseDescription.subscribe",
        href: (0,domain.kz)(redefinedPaymentLink ? redefinedPaymentLink : studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING(productInfo.paymentLandingId ?? "")),
        onClick: handleGoPayment,
        openType: redefinedPaymentLink ? PriceButtonOpenType.Absolute : PriceButtonOpenType.Relative
      },
      promocodeButtonOnClick: handlePromoCodeButtonClick
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/packet-description-counters/packet-description-counters.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const packet_description_counters_module = ({"count-accent":"packet-description-counters-module__count-accent--oKILj","countAccent":"packet-description-counters-module__count-accent--oKILj","row-item":"packet-description-counters-module__row-item--Qcozi","rowItem":"packet-description-counters-module__row-item--Qcozi","join-item":"packet-description-counters-module__join-item--sqlNq","joinItem":"packet-description-counters-module__join-item--sqlNq"});
;// CONCATENATED MODULE: ./src/components/packet-description-counters/packet-description-counters.tsx













var CountersDirection = /* @__PURE__ */(CountersDirection2 => {
  CountersDirection2[CountersDirection2["Row"] = 0] = "Row";
  CountersDirection2[CountersDirection2["Column"] = 1] = "Column";
  CountersDirection2[CountersDirection2["Join"] = 2] = "Join";
  return CountersDirection2;
})(CountersDirection || {});
const PacketDescriptionCounters = _ref => {
  let {
    chapterItems,
    direction,
    isBigCounters = false,
    isAccentCounts = true
  } = _ref;
  const counts = (0,react.useMemo)(() => {
    let chapters = 0;
    let speakings = 0;
    let mentorSessions = 0;
    chapterItems.forEach(chapter => {
      const type = chapter.type;
      switch (type) {
        case student_model/* ChapterItemType */.a.Mentor:
          {
            mentorSessions++;
            break;
          }
        case student_model/* ChapterItemType */.a.Chapter:
          {
            chapters++;
            if (chapter.hasSpeaking || chapter.speaking) {
              speakings++;
            }
            break;
          }
        default:
          throw new unhandled_case/* UnhandledCaseError */.H(type);
      }
    });
    return {
      chapters,
      speakings,
      mentorSessions
    };
  }, [chapterItems]);
  const rowItemClasses = classnames_default()({
    [packet_description_counters_module.rowItem]: direction === 0 /* Row */,
    [packet_description_counters_module.joinItem]: direction === 2 /* Join */
  });
  const countersClasses = classnames_default()({
    [typography_module/* default */.Z.headline4]: isBigCounters,
    [packet_description_counters_module.countAccent]: isAccentCounts
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [counts.chapters !== 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: rowItemClasses,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: countersClasses,
        children: counts.chapters
      }), "\xA0", /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "packetListItem.interactiveStory",
        values: {
          count: counts.chapters
        }
      }), direction === 2 /* Join */ && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        children: counts.speakings !== 0 || counts.mentorSessions !== 0 ? ", " : " "
      })]
    }), counts.speakings !== 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: rowItemClasses,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: countersClasses,
        children: counts.speakings
      }), "\xA0", /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "packetListItem.speakingSessions",
        values: {
          count: counts.speakings
        }
      }), direction === 2 /* Join */ && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        children: counts.mentorSessions !== 0 ? ", " : " "
      })]
    }), counts.mentorSessions !== 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: rowItemClasses,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: countersClasses,
        children: counts.mentorSessions
      }), "\xA0", /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "packetListItem.mentorSessions",
        values: {
          count: counts.mentorSessions
        }
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-packets-list/course-packets-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_packets_list_module = ({"root":"course-packets-list-module__root--uAXK7","packets":"course-packets-list-module__packets--xqk2W","title":"course-packets-list-module__title--zx4zk","link":"course-packets-list-module__link--izL4J","packet":"course-packets-list-module__packet--jKnuF","packet-image":"course-packets-list-module__packet-image--Q3fWN","packetImage":"course-packets-list-module__packet-image--Q3fWN","packet-info":"course-packets-list-module__packet-info--ix4Pw","packetInfo":"course-packets-list-module__packet-info--ix4Pw","packet-subtitle":"course-packets-list-module__packet-subtitle--UCHXg","packetSubtitle":"course-packets-list-module__packet-subtitle--UCHXg","packet-title":"course-packets-list-module__packet-title--StxWS","packetTitle":"course-packets-list-module__packet-title--StxWS","packet-description":"course-packets-list-module__packet-description--XJKxo","packetDescription":"course-packets-list-module__packet-description--XJKxo","action-button-wrapper":"course-packets-list-module__action-button-wrapper--hx3iQ","actionButtonWrapper":"course-packets-list-module__action-button-wrapper--hx3iQ","price-block":"course-packets-list-module__price-block--JLs8J","priceBlock":"course-packets-list-module__price-block--JLs8J","discount":"course-packets-list-module__discount--oPWR6","discount-plus-icon":"course-packets-list-module__discount-plus-icon--A1Ybk","discountPlusIcon":"course-packets-list-module__discount-plus-icon--A1Ybk"});
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-packets-list/packet-item/packet-item.tsx

















const PacketItem = _ref => {
  let {
    packet
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const doneChaptersCount = packet.chapters.reduce((acc, chapter) => {
    if (chapter.speaking !== null && chapter.speaking.session?.state === speakingSession_model/* SpeakingSessionState */.Z.Completed) {
      return acc + 1;
    }
    return acc;
  }, 0);
  const currentChapterIndex = (0,react.useMemo)(() => packet.chapters.findIndex(chapter => chapter.progress !== student_model/* PacketChapterProgress */.h0.Ended), [packet.chapters]);
  const bgImage = (0,react.useMemo)(() => {
    if (packet.imageSrc) {
      return (0,url/* convertImageUrlToCssUrl */.v)(packet.imageSrc);
    }
    if (packet.chapters[0]?.imageUrl) {
      return (0,url/* convertImageUrlToCssUrl */.v)(packet.chapters[0]?.imageUrl);
    }
    return (0,url/* convertImageUrlToCssUrl */.v)("https://flowstatic.s3.yandex.net/static/aloha-static/course-covers/pre-intermediate.svg");
  }, [packet.chapters, packet.imageSrc]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: course_packets_list_module.packetImage,
      style: {
        backgroundImage: bgImage
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: course_packets_list_module.packetInfo,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(course_packets_list_module.packetSubtitle, typography_module/* default */.Z.body2),
          children: packet.subtitle === "" && packet.price === 0 ? intl.formatMessage({
            id: "coursePacketsList.free"
          }) : packet.subtitle
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(course_packets_list_module.packetTitle, typography_module/* default */.Z.headline3),
          children: packet.title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(course_packets_list_module.packetDescription, typography_module/* default */.Z.body2),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(PacketDescriptionCounters, {
            chapterItems: packet.chapters,
            direction: CountersDirection.Join,
            isAccentCounts: false
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: course_packets_list_module.actionButtonWrapper,
        children: [packet.isBought && packet.progress === student_model/* PacketChapterProgress */.h0.NotStarted && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
          iconName: "arrow-right",
          state: ChapterButtonsItemState.Active,
          text: intl.formatMessage({
            id: "coursePacketsList.startLearning"
          }),
          link: studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET(packet.id),
          appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
        }), packet.isBought && (packet.progress === student_model/* PacketChapterProgress */.h0.Started || packet.progress === student_model/* PacketChapterProgress */.h0.Scheduled) && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
          iconName: "new-arrow-right",
          state: ChapterButtonsItemState.Active,
          text: intl.formatMessage({
            id: "coursePacketsList.continue"
          }),
          progress: doneChaptersCount / packet.chapters.length,
          link: studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET_CHAPTER(packet.id, `${currentChapterIndex}`),
          appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
        }), packet.isBought && packet.progress === student_model/* PacketChapterProgress */.h0.Ended && /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterButtonsItem, {
          iconName: "checkmark",
          state: ChapterButtonsItemState.Completed,
          text: intl.formatMessage({
            id: "coursePacketsList.ended"
          }),
          appearance: chapter_buttons_item_component_ChapterButtonsItemAppearance.New
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/course-info/components/course-packets-list/course-packets-list.component.tsx

















const CoursePacketsList = _ref => {
  let {
    productInfo,
    packets
  } = _ref;
  const {
    allowAccessForPacketStudents
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const visiblePackets = packets.filter(packet => {
    let isShownPacket = true;
    if (productInfo.notForSale) {
      isShownPacket = allowAccessForPacketStudents ? packet.isBought : packet.progress !== student_model/* PacketChapterProgress */.h0.NotStarted;
    }
    return packet.price > 0 && isShownPacket;
  });
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: course_packets_list_module.root,
    children: visiblePackets.length > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(course_packets_list_module.title, typography_module/* default */.Z.headline4Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "coursePacketsList.title"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
        className: course_packets_list_module.packets,
        "aria-label": intl.formatMessage({
          id: "coursePacketsList.title"
        }),
        children: visiblePackets.map(packet => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
          className: course_packets_list_module.packet,
          "aria-label": packet.title,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
            to: studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET(packet.id),
            className: course_packets_list_module.link,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(PacketItem, {
              packet
            })
          })
        }, packet.id))
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/course-info/course-info.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const course_info_page_module = ({"root":"course-info-page-module__root--NSoG4","current-chapter":"course-info-page-module__current-chapter--lVlTi","currentChapter":"course-info-page-module__current-chapter--lVlTi","link":"course-info-page-module__link--D9ysL","popup-button":"course-info-page-module__popup-button--CfzLy","popupButton":"course-info-page-module__popup-button--CfzLy","popup-button-content":"course-info-page-module__popup-button-content--SDcH6","popupButtonContent":"course-info-page-module__popup-button-content--SDcH6","popup-dropdown-icon":"course-info-page-module__popup-dropdown-icon--x1uLT","popupDropdownIcon":"course-info-page-module__popup-dropdown-icon--x1uLT"});
;// CONCATENATED MODULE: ./src/pages/course-info/course-info.page.tsx





















const CourseInfoPage = _ref => {
  let {
    packets,
    currentPacketIndex,
    currentChapterIndex,
    productInfo,
    partlyBought,
    redefinedPaymentLink,
    isFirstSpeaking,
    isRepetitionAvailable,
    onNeedUpdates,
    notBoughtNoTrial = false
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    allowAccessForPacketStudents
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const sortedScheduledSpeakingSessions = (0,react.useMemo)(() => {
    const scheduledSpeakingSessions = [];
    packets.forEach(packet => {
      packet.chapters.forEach((chapter, index) => {
        if (chapter.progress === student_model/* PacketChapterProgress */.h0.Scheduled) {
          scheduledSpeakingSessions.push({
            chapter,
            packetId: packet.id,
            chapterIndex: index,
            isTrial: packet.price === 0
          });
        }
      });
    });
    if (scheduledSpeakingSessions.length > 1) {
      scheduledSpeakingSessions.sort((prev, next) => {
        if (prev.chapter.speaking && next.chapter.speaking && prev.chapter.speaking.session && next.chapter.speaking.session) {
          return prev.chapter.speaking.session.startAt.getTime() - next.chapter.speaking.session.startAt.getTime();
        }
        return 1;
      });
    }
    return scheduledSpeakingSessions;
  }, [packets]);
  const chapterLink = (0,react.useMemo)(() => {
    if (sortedScheduledSpeakingSessions.length > 0) {
      return studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET_CHAPTER(sortedScheduledSpeakingSessions[0].packetId, String(sortedScheduledSpeakingSessions[0].chapterIndex));
    }
    return studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET_CHAPTER(packets[currentPacketIndex].id, String(currentChapterIndex));
  }, [currentChapterIndex, currentPacketIndex, packets, sortedScheduledSpeakingSessions]);
  if (packets === void 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
  }
  const getPacketChapter = () => {
    if (productInfo.notForSale && !allowAccessForPacketStudents) {
      return null;
    }
    if (sortedScheduledSpeakingSessions.length > 0) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: course_info_page_module.currentChapter,
        "aria-label": intl.formatMessage({
          id: "courseInfo.currentChapterAriaLabel"
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
          to: chapterLink,
          className: course_info_page_module.link,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(PacketChaptersListItem, {
            chapter: sortedScheduledSpeakingSessions[0].chapter,
            chapterLink,
            isBought: true,
            isTrial: sortedScheduledSpeakingSessions[0].isTrial,
            isFirstSpeaking,
            onNeedUpdates
          })
        })
      });
    }
    if (sortedScheduledSpeakingSessions.length === 0 && !notBoughtNoTrial) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: course_info_page_module.currentChapter,
        "aria-label": intl.formatMessage({
          id: "courseInfo.currentChapterAriaLabel"
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(react_router_dom/* Link */.rU, {
          to: chapterLink,
          className: course_info_page_module.link,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(PacketChaptersListItem, {
            chapter: packets[currentPacketIndex].chapters[currentChapterIndex],
            chapterLink,
            isBought: packets[currentPacketIndex].isBought,
            isTrial: packets[currentPacketIndex].price === 0,
            isFirstSpeaking,
            onNeedUpdates
          })
        })
      });
    }
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        doNotWrapChildrenWithLayout: true,
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
      },
      data: {
        isRepetitionAvailable
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: course_info_page_module.root,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)(Container, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(CourseDescription, {
            productInfo,
            packets,
            partlyBought,
            redefinedPaymentLink
          }), getPacketChapter(), /* @__PURE__ */(0,jsx_runtime.jsx)(CoursePacketsList, {
            productInfo,
            packets
          })]
        })
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/packet-info/components/packet-description/packet-description.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const packet_description_module = ({"root":"packet-description-module__root--phm2k","info":"packet-description-module__info--_Qflq","info-wide":"packet-description-module__info-wide--BjNPA","infoWide":"packet-description-module__info-wide--BjNPA","content-counts":"packet-description-module__content-counts--QbRai","contentCounts":"packet-description-module__content-counts--QbRai","packet-progress":"packet-description-module__packet-progress--nJEIV","packetProgress":"packet-description-module__packet-progress--nJEIV","packet-description":"packet-description-module__packet-description--uLmfh","packetDescription":"packet-description-module__packet-description--uLmfh","full-price":"packet-description-module__full-price--IuUj9","fullPrice":"packet-description-module__full-price--IuUj9","buy-button":"packet-description-module__buy-button--lso47","buyButton":"packet-description-module__buy-button--lso47","buy-button-plus-icon":"packet-description-module__buy-button-plus-icon--tJ_FD","buyButtonPlusIcon":"packet-description-module__buy-button-plus-icon--tJ_FD","delimiter":"packet-description-module__delimiter--KLW3X","price":"packet-description-module__price--b1B3q"});
;// CONCATENATED MODULE: ./src/pages/packet-info/components/packet-description/packet-description.component.tsx














const PacketDescription = _ref => {
  let {
    packet
  } = _ref;
  const chaptersCount = (0,react.useMemo)(() => packet.chapters.reduce((acc, chapter) => {
    if (chapter.type === student_model/* ChapterItemType */.a.Chapter) {
      return acc + 1;
    }
    return acc;
  }, 0), [packet.chapters]);
  const speakingsCount = (0,react.useMemo)(() => packet.chapters.reduce((acc, chapter) => {
    if (chapter.speaking && chapter.type === student_model/* ChapterItemType */.a.Chapter) {
      return acc + 1;
    }
    return acc;
  }, 0), [packet.chapters]);
  const feedbackSessionsCount = (0,react.useMemo)(() => packet.chapters.reduce((acc, chapter) => {
    if (chapter.speaking && chapter.type === student_model/* ChapterItemType */.a.Mentor) {
      return acc + 1;
    }
    return acc;
  }, 0), [packet.chapters]);
  const doneChaptersCount = (0,react.useMemo)(() => packet.chapters.reduce((acc, chapter) => {
    if (chapter.progress === student_model/* PacketChapterProgress */.h0.Ended) {
      return acc + 1;
    }
    return acc;
  }, 0), [packet.chapters]);
  const {
    isTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: packet_description_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(packet_description_module.info, {
        [packet_description_module.infoWide]: isTablet
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        className: classnames_default()(typography_module/* default */.Z.headline2),
        children: packet.title
      }), !packet.isBought && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(packet_description_module.contentCounts, typography_module/* default */.Z.body2Accent),
        children: [chaptersCount > 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "packetDescription.chaptersCount",
            values: {
              chaptersCount
            }
          })
        }), speakingsCount > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Delimiter, {
            className: packet_description_module.delimiter
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "packetDescription.speakingsCount",
              values: {
                speakingsCount
              }
            })
          })]
        }), feedbackSessionsCount > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(Delimiter, {
            className: packet_description_module.delimiter
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
              id: "packetDescription.feedbackSessionsCount",
              values: {
                feedbackSessionsCount
              }
            })
          })]
        })]
      }), packet.isBought && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(packet_description_module.packetProgress, typography_module/* default */.Z.body2Accent),
        children: [doneChaptersCount < packet.chapters.length && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "packetDescription.packetProgress",
          values: {
            done: doneChaptersCount,
            left: packet.chapters.length - doneChaptersCount
          }
        }), doneChaptersCount === packet.chapters.length && /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "packetDescription.packetFinished"
        })]
      }), packet.description && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: packet_description_module.packetDescription,
        children: packet.description
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/packet-info/packet-info.page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const packet_info_page_module = ({"root":"packet-info-page-module__root--Y6WiN"});
;// CONCATENATED MODULE: ./src/pages/packet-info/packet-info.page.tsx
















const PacketInfoPage = _ref => {
  let {
    currentPackets,
    packetId,
    productInfo,
    isFirstSpeaking,
    onNeedUpdates,
    isRepetitionAvailable
  } = _ref;
  const history = (0,react_router/* useHistory */.k6)();
  (0,useKeyPress/* useKeyPress */.K)("Escape", () => {
    history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
  });
  const packetIndex = (0,react.useMemo)(() => currentPackets.findIndex(x => x.id === packetId), [currentPackets, packetId]);
  const packet = currentPackets[packetIndex];
  if (packet === void 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
      self: {
        doNotWrapChildrenWithLayout: true,
        bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
      },
      data: {
        isRepetitionAvailable
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: packet_info_page_module.root,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)(Container, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(GoToLink, {
            link: studentRoutePaths/* studentRoutePaths */.dR.INDEX,
            text: productInfo.title ?? ""
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(PacketDescription, {
            packet
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(PacketChaptersList, {
            packet,
            isFirstSpeaking,
            onNeedUpdates,
            notForSale: productInfo.notForSale
          })]
        })
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/student-index/student-index.page.tsx






























const StudentIndexPageContent = () => {
  const user = (0,useUser/* useUser */.aF)();
  const {
    userAttributes,
    reloadAttributes
  } = (0,react.useMemo)(() => ({
    reloadAttributes: user.functions?.reloadAttributes ?? function_utils/* emptyFunction */.Bi,
    userAttributes: user.data?.attributes ?? null
  }), [user?.data?.attributes, user?.functions?.reloadAttributes]);
  const [availableContent, setAvailableContent] = (0,react.useState)(null);
  const history = (0,react_router/* useHistory */.k6)();
  const {
    redefinePaymentLink,
    appRevisionExperiment
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const currentProductId = availableContent === null || (0,Either.isLeft)(availableContent) ? null : availableContent.right.productInfo?.id;
  const redefinedPaymentLink = currentProductId && redefinePaymentLink.get(currentProductId) ? redefinePaymentLink.get(currentProductId) : null;
  const loadAvailableContent = (0,react.useCallback)(async () => {
    const isRevisionVersion = await (0,is_revision_app_version/* isRevisionAppVersion */.Z)(bunker_api/* getAppRevisionVersion */.Q5);
    const response = await (0,student_api/* getAvailableContent */.A4)("DESC", Boolean(appRevisionExperiment || isRevisionVersion));
    setAvailableContent(response);
  }, [appRevisionExperiment]);
  const coursePartlyBought = (0,react.useMemo)(() => {
    if (availableContent === null || (0,Either.isLeft)(availableContent)) {
      return false;
    }
    return availableContent.right.currentPackets.some(packet => packet.isBought && packet.price !== 0);
  }, [availableContent]);
  const currentPacketIndex = (0,react.useMemo)(() => {
    if (availableContent === null || (0,Either.isLeft)(availableContent) || !coursePartlyBought) {
      return 0;
    }
    const index = availableContent.right.currentPackets.findIndex(packet => packet.progress !== student_model/* PacketChapterProgress */.h0.Ended && packet.isBought);
    if (index === -1) {
      return availableContent.right.currentPackets.length - 1;
    }
    return index;
  }, [coursePartlyBought, availableContent]);
  const currentChapterIndex = (0,react.useMemo)(() => {
    if (availableContent === null || (0,Either.isLeft)(availableContent)) {
      return 0;
    }
    const index = availableContent.right.currentPackets[currentPacketIndex].chapters.findIndex(chapter => chapter.progress !== student_model/* PacketChapterProgress */.h0.Ended);
    if (index === -1) {
      return availableContent.right.currentPackets[currentPacketIndex].chapters.length - 1;
    }
    return index;
  }, [currentPacketIndex, availableContent]);
  (0,use_effect_once/* useEffectOnce */.q)(loadAvailableContent);
  const handleUpdate = (0,react.useCallback)(() => {
    void reloadAttributes();
    setAvailableContent(null);
    void loadAvailableContent();
  }, [loadAvailableContent, reloadAttributes]);
  const handleScheduled = (0,react.useCallback)(speakingSession => {
    handleUpdate();
    history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getCloseUrl(history));
    history.push(get_url_search_params.getUrlSearchParams.scheduledSpeakingPopup.getOpenUrl(speakingSession.id, history));
  }, [handleUpdate, history]);
  const handleClose = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.schedulePopup.getCloseUrl(history));
  }, [history]);
  const handleCloseSheduled = (0,react.useCallback)(() => {
    history.push(get_url_search_params.getUrlSearchParams.scheduledSpeakingPopup.getCloseUrl(history));
  }, [history]);
  const scheduleDialogSpeakingId = get_url_search_params.getUrlSearchParams.schedulePopup.getParam(history);
  const scheduledSpeakingSessionId = get_url_search_params.getUrlSearchParams.scheduledSpeakingPopup.getParam(history);
  const teacherId = get_url_search_params.getUrlSearchParams.teacherPopup.getParam(history);
  const scheduleDialogSpeakingData = (0,react.useMemo)(() => {
    if (scheduleDialogSpeakingId === void 0 || availableContent === null || (0,Either.isLeft)(availableContent)) {
      return null;
    }
    const chapters = availableContent.right.currentChapters;
    for (let i = 0; i < chapters.length; i++) {
      const chapter = chapters[i];
      if (chapter.speaking === null) {
        continue;
      }
      if (chapter.speaking.id === scheduleDialogSpeakingId) {
        return {
          index: i,
          speakingId: scheduleDialogSpeakingId,
          title: chapter.title,
          durationMin: chapter.speaking.durationMin,
          isMentor: chapter.type === student_model/* ChapterItemType */.a.Mentor
        };
      }
    }
    return null;
  }, [availableContent, scheduleDialogSpeakingId]);
  const scheduledSpeakingSessionData = (0,react.useMemo)(() => {
    if (scheduledSpeakingSessionId === void 0 || availableContent === null || (0,Either.isLeft)(availableContent)) {
      return null;
    }
    const chapters = availableContent.right.currentChapters;
    for (let i = 0; i < chapters.length; i++) {
      const chapter = chapters[i];
      if (chapter.speaking === null || chapter.speaking.session === null) {
        continue;
      }
      if (chapter.speaking.session.id === scheduledSpeakingSessionId) {
        return {
          index: i,
          title: chapter.title,
          startAt: chapter.speaking.session.startAt,
          durationMin: chapter.speaking.durationMin,
          isMentorSpeaking: chapter.type === student_model/* ChapterItemType */.a.Mentor
        };
      }
    }
    return null;
  }, [availableContent, scheduledSpeakingSessionId]);
  (0,react.useEffect)(() => {
    if (availableContent !== null) {
      if (scheduleDialogSpeakingData === null && scheduleDialogSpeakingId !== void 0) {
        handleClose();
      }
      if (scheduledSpeakingSessionData === null && scheduledSpeakingSessionId !== void 0) {
        handleCloseSheduled();
      }
    }
  }, [availableContent, handleClose, handleCloseSheduled, scheduleDialogSpeakingData, scheduleDialogSpeakingId, scheduledSpeakingSessionData, scheduledSpeakingSessionId]);
  if (userAttributes && !userAttributes.currentProductId) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: studentRoutePaths/* studentRoutePaths */.dR.COURSE_SELECT
    });
  }
  if (availableContent === null) {
    return null;
  }
  if ((0,Either.isLeft)(availableContent)) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownErrorPage, {
      hasReloadButton: true
    });
  }
  if (availableContent.right.productInfo === null) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownErrorPage, {
      errorTextForSentry: "ProductInfo is null"
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(react_router/* Switch */.rs, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET_CHAPTER(":packetId", ":chapterIndex"),
        render: _ref => {
          let {
            match
          } = _ref;
          const chapterIndex = Number.parseInt(match.params.chapterIndex);
          return /* @__PURE__ */(0,jsx_runtime.jsx)(ChapterInfoPage, {
            currentPackets: availableContent.right.currentPackets,
            currentPacketIndex,
            packetId: match.params.packetId,
            chapterIndex,
            firstMentorSpeaking: availableContent.right.firstMentorSpeaking,
            isFirstSpeaking: availableContent.right.isFirstSpeaking,
            courseTitle: availableContent.right.productInfo?.title,
            notForSale: availableContent.right.productInfo?.notForSale,
            onNeedUpdates: handleUpdate,
            isRepetitionAvailable: availableContent.right.isRepetitionAvailable
          });
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET(":packetId"),
        render: _ref2 => {
          let {
            match
          } = _ref2;
          return /* @__PURE__ */(0,jsx_runtime.jsx)(PacketInfoPage, {
            currentPackets: availableContent.right.currentPackets,
            packetId: match.params.packetId,
            productInfo: availableContent.right.productInfo,
            isFirstSpeaking: availableContent.right.isFirstSpeaking,
            onNeedUpdates: handleUpdate,
            isRepetitionAvailable: availableContent.right.isRepetitionAvailable
          });
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: studentRoutePaths/* studentRoutePaths */.dR.INDEX,
        render: () => /* @__PURE__ */(0,jsx_runtime.jsx)(CourseInfoPage, {
          packets: availableContent.right.currentPackets,
          currentPacketIndex,
          currentChapterIndex,
          productInfo: availableContent.right.productInfo,
          partlyBought: coursePartlyBought,
          redefinedPaymentLink,
          isFirstSpeaking: availableContent.right.isFirstSpeaking,
          onNeedUpdates: handleUpdate,
          isRepetitionAvailable: availableContent.right.isRepetitionAvailable,
          notBoughtNoTrial: availableContent.right.currentChapters.length === 0
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ComingSpeakingPopup, {
      speakingSessions: availableContent.right.availableSpeakingSessions,
      isFirstSpeaking: availableContent.right.isFirstSpeaking,
      onNeedUpdates: handleUpdate
    }), scheduleDialogSpeakingData !== null && /* @__PURE__ */(0,jsx_runtime.jsx)(StudentScheduler, {
      speakingId: scheduleDialogSpeakingData.speakingId,
      title: scheduleDialogSpeakingData.title,
      durationMin: scheduleDialogSpeakingData.durationMin,
      isFirstSpeaking: availableContent.right.isFirstSpeaking,
      currentProductId: userAttributes?.currentProductId,
      onClose: handleClose,
      onScheduled: handleScheduled,
      isMentor: scheduleDialogSpeakingData.isMentor
    }), scheduledSpeakingSessionData !== null && /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleInfoModal, {
      title: scheduledSpeakingSessionData.title,
      startAt: scheduledSpeakingSessionData.startAt,
      durationMin: scheduledSpeakingSessionData.durationMin,
      availableBeforeStartMin: CLASS_AVAILABLE_BEFORE_START_MIN,
      isMentorSpeaking: scheduledSpeakingSessionData.isMentorSpeaking,
      onClose: handleCloseSheduled
    }), teacherId && !Array.isArray(teacherId) && /* @__PURE__ */(0,jsx_runtime.jsx)(teacher_info_card_component_TeacherInfoCard, {
      id: teacherId
    })]
  });
};
const StudentIndexPage = withAnnouncements(StudentIndexPageContent);
;// CONCATENATED MODULE: ./src/pages/student-index/student-index-wrapper.page.tsx






const StudentIndexWrapper = () => {
  let StudentIndexPageComponent;
  const {
    productMainType
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  switch (productMainType) {
    case utils_experimentDi/* ProductMainType */.SH.General:
      StudentIndexPageComponent = beginner_index_page;
      break;
    case utils_experimentDi/* ProductMainType */.SH.Gus:
    default:
      StudentIndexPageComponent = StudentIndexPage;
      break;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentIndexPageComponent, {});
};
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-repetition-machine.ts

















const create_repetition_machine_ANSWER_EVENT = "repetition_result";
const create_repetition_machine_updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)(create_repetition_machine_ANSWER_EVENT);
const create_repetition_machine_services = {
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: create_trainer_machine/* services */.uZ[trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER],
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: async context => {
    const response = await (0,trainer_api/* getRepetitionState */.b_)(context.isV2);
    return {
      chapterData: response.data.blocks.map(block => ({
        activity_id: block?.activity_id,
        type: "story",
        blocks: [block]
      })),
      masteringId: response.data.mastering_id,
      userData: []
    };
  }
};
const create_repetition_machine_guards = {
  ...create_trainer_machine/* guards */.l8,
  [trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsAllNextActivitiesEmptyAfterFilterGuard */.NZ)(create_repetition_machine_ANSWER_EVENT),
  [trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsNextActivityEmptyAfterFilterGuard */.b2)(create_repetition_machine_ANSWER_EVENT)
};
const create_repetition_machine_baseTrainerActions = create_trainer_machine/* actions */.Nw;
const create_repetition_machine_actions = {
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getBlockFilterAction */.XI)(create_repetition_machine_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,xstate_es/* assign */.f0)((context, event) => ({
    masteringId: event.data.masteringId,
    activities: event.data.chapterData,
    chapterStudentEvents: {},
    activityIndex: 0,
    blockIndex: 0
  })),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: create_repetition_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
  [trainer_machine_consts/* ACTIONS */.aO.PUSH_CHAPTER_ANSWER]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getChapterAnswerPusher */.hf)(create_repetition_machine_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: create_repetition_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: create_repetition_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.RESET_TRAINER]: (0,xstate_es/* assign */.f0)({
    activityIndex: 0,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX]: create_repetition_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX_TIL_NOT_EMPTY]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getIncrementActivityIndexTilNotEmptyAssignment */.OQ)(create_repetition_machine_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_ACTIVITY_INDEX]: create_repetition_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.SET_CURRENT_LAST_BLOCK_IN_ACTIVITY]: create_repetition_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.SET_CURRENT_LAST_BLOCK_IN_ACTIVITY],
  [trainer_machine_consts/* ACTIONS */.aO.SEND_FINAL_EVENT_IF_NEED]: (context, event) => {
    if (context.isFinalEventExist) {
      return {};
    }
    const guardMeta = {};
    if ( /* eslint-disable @typescript-eslint/no-explicit-any */
    create_repetition_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_ACTIVITY_AND_BLOCK](context, event, guardMeta) || create_repetition_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_BLOCK](context, event, guardMeta) && create_repetition_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER](context, event, guardMeta) && create_repetition_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER](context, event, guardMeta)) {
      void (0,trainer_api/* createProgress */.gy)({
        block_id: context.currentBlocks[context.blockIndex].id,
        activity_id: context.activities[context.activityIndex]?.activity_id,
        event_type: "repetition_progress_final"
      });
      return {
        isFinalEventExist: true
      };
    }
    return {};
  },
  [trainer_machine_consts/* ACTIONS */.aO.ADD_OUTRO_IF_NEED]: (0,xstate_es/* assign */.f0)(context => {
    const activities = [...context.activities];
    const lastActivity = activities[activities.length - 1];
    const lastBlock = lastActivity.blocks[lastActivity.blocks.length - 1];
    if (lastBlock.type === "chapter-outro") {
      return {};
    }
    const outro = {
      type: "chapter-outro",
      id: context.chapterId || "",
      actionControls: [{
        text: context.intl.formatMessage({
          id: "studentRepetition.onMain"
        }),
        action: {
          type: "ON_MAIN_PAGE"
        }
      }],
      title: context.intl.formatMessage({
        id: "studentRepetition.success"
      }),
      text: context.intl.formatMessage({
        id: "studentRepetition.uRepeateLexis"
      }),
      image: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/05ee68e0-0ec1-4851-ba1f-2060e5baaa14/trainerOutro1.svg"
    };
    lastActivity.blocks.push(outro);
    return {
      activities
    };
  })
};
const repetitionTrainerMachine = (0,Machine/* createMachine */.C)({
  id: "repetition-trainer",
  initial: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA,
  states: {
    [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
        onDone: [{
          actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.ADD_OUTRO_IF_NEED, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }],
        onError: trainer_machine_consts/* STATES */.PO.ERROR
      }
    },
    [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS],
    [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {
      on: {
        "": {
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }
      }
    },
    [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
        data: context => getAnswerDataSaverPreparator(create_repetition_machine_ANSWER_EVENT, context.masteringId)(context),
        onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS,
        onError: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
      }
    },
    [trainer_machine_consts/* STATES */.PO.ERROR]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.ERROR]
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: [{
      cond: context => [trainer_guards/* isLastBlock */.zb, trainer_guards/* isNextActivityEmptyAfterFilter */.pH].every(guard => guard(context)),
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getNextNotEmptyActivity */.xL,
        blockIndex: 0,
        scrollToBlockIndex: 0
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    }, {
      cond: trainer_guards/* isLastBlock */.zb,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* incrementActivityIndex */.sp,
        blockIndex: 0,
        scrollToBlockIndex: 0
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    }, {
      actions: [(0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: trainer_actions/* getScrollToBlockIndex */.p9
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.blockIndex + 1
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    }],
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER],
    [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: [{
      cond: context => [trainer_guards/* isFirstBlock */.d7, trainer_guards/* notFirstActivity */.SH, trainer_guards/* isPrevActivityEmptyAfterFilter */.eR].every(guard => guard(context)),
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    }, {
      cond: context => [trainer_guards/* isFirstBlock */.d7, trainer_guards/* notFirstActivity */.SH].every(guard => guard(context)),
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: context => context.activityIndex ? context.activityIndex - 1 : 0
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    }, {
      actions: [(0,xstate_es/* assign */.f0)({
        blockIndex: context => context.blockIndex - 1
      }), (0,xstate_es/* assign */.f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate_es/* assign */.f0)({
        progress: trainer_actions/* getProgress */.xC
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    }],
    [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), create_repetition_machine_actions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    },
    [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
      actions: [(0,xstate_es/* assign */.f0)({
        chapterStudentEvents: create_repetition_machine_updateStudentEvent,
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER
    }
  }
});
const createRepetitionTrainerMachine = (intl, isV2) => repetitionTrainerMachine.withConfig({
  actions: create_repetition_machine_actions,
  services: create_repetition_machine_services,
  guards: create_repetition_machine_guards
}).withContext({
  mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
  chapterStudentEvents: {},
  currentBlocks: [],
  activities: [],
  progress: 0,
  blockIndex: 0,
  activityIndex: 0,
  scrollToBlockIndex: 0,
  filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("repetition_result"),
  intl,
  isV2
});
;// CONCATENATED MODULE: ./src/pages/student-repetition/student-repetition.page.tsx























const student_repetition_page_ONBOARDING_ANSWER_EVENT = "onboarding_result";
const StudentRepetitionPage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    isTranslationV2Enabled
  } = (0,use_translation_v2_enabled/* useTranslationV2Enabled */.L)();
  const machine = (0,react.useMemo)(() => createRepetitionTrainerMachine(intl, isTranslationV2Enabled), [intl, isTranslationV2Enabled]);
  const [state, send] = (0,useMachine/* useMachine */.e)(machine);
  const history = (0,react_router/* useHistory */.k6)();
  const {
    activities,
    activityIndex,
    currentBlocks: condBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const onSubmitAnswer = (0,react.useCallback)(_ref => {
    let {
      answer,
      correct,
      typo,
      blockId
    } = _ref;
    return send(product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER, {
      data: {
        answer,
        blockId,
        activityId: currentActivity?.activity_id,
        courseId: state.context.chapterInfo?.courseId,
        levelId: state.context.chapterInfo?.levelId,
        topicId: state.context.chapterInfo?.topicId,
        correct,
        typo
      }
    });
  }, [currentActivity, send, state.context.chapterInfo]);
  const handleOutroAction = (0,react.useCallback)(a => {
    if (a.type === "ON_MAIN_PAGE") {
      return history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
    }
  }, [history]);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    const blockEvents = state.context.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === student_repetition_page_ONBOARDING_ANSWER_EVENT) ?? [];
    const answerJSONString = answerEvent[answerEvent.length - 1]?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [state.context.chapterStudentEvents]);
  const {
    handleResetAnswer,
    handleNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  switch (state.value) {
    case trainer_machine_consts/* STATES */.PO.ERROR:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "error"
      });
    case trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA:
      return null;
    case trainer_machine_consts/* STATES */.PO.SAVING_ANSWER:
    case trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
          onResetAnswer: blockId => {
            const currentActivityId = currentActivity?.activity_id;
            if (currentActivityId) {
              handleResetAnswer(blockId, currentActivityId);
            }
          },
          onPrevActivityClick: handlePrevActivityClick,
          blocks: condBlocks,
          activityType: currentActivity?.type ?? "story",
          onSubmitAnswer,
          currentActivityIndex: state.context.activityIndex,
          blockIndex: state.context.blockIndex,
          onNextBlockClick: handleNextBlockClick,
          onPrevBlockClick: handlePrevBlockClick,
          mechanicMachineCreator: state.context.mechanicMachineCreator,
          onOutroActionTrigger: handleOutroAction,
          getBlockAnswerInfo,
          showPrevButton: true,
          showNextButton: true,
          showSkipButton: false,
          showResetButton: false,
          showSubmitButton: true,
          showAudioFooter: true,
          userEnvironment: types/* UserEnvironment */.P.Student,
          isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
          progress: state.context.progress
        })]
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "student-repetition.page",
        state: state.value
      });
  }
};
;// CONCATENATED MODULE: ./src/pages/student-speaking/student-speaking.page.tsx







const StudentSpeakingPage = () => {
  const {
    speakingSessionId
  } = (0,react_router/* useParams */.UO)();
  (0,react.useEffect)(() => {
    (0,yandexMetrica/* ymGoal */.qf)("Start_Speaking");
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingPage, {
    speakingSessionId,
    classUserRole: "student"
  });
};
;// CONCATENATED MODULE: ./src/app/routes/newbieRoutePaths.ts


const newbieRoutePaths = {
  INDEX: "/newbie"
};
;// CONCATENATED MODULE: ./src/app/routes/student.routes.config.tsx


























const anySpeakingSessionId = ":speakingSessionId";
const studentRoutesConfig = [{
  path: [studentRoutePaths/* studentRoutePaths */.dR.INDEX, studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET(":packetId"), studentRoutePaths/* studentRoutePaths */.dR.INDEX_PACKET_CHAPTER(":packetId", ":chapterIndex"), studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_INFO(`:${studentRoutePaths/* StudentIndexParams */.QU.InfoSpeakingSessionId}`), studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_SCHEDULED(`:${studentRoutePaths/* StudentIndexParams */.QU.ScheduledSpeakingSessionId}`), studentRoutePaths/* studentRoutePaths */.dR.INDEX_VISIBLE_ALL, studentRoutePaths/* studentRoutePaths */.dR.INDEX_VISIBLE_DONE],
  component: StudentIndexWrapper,
  exact: true
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.PLACE_IN_PRODUCT(`:${studentRoutePaths/* StudentIndexParams */.QU.PlacementProductId}`)],
  component: AutoPlacementPage
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.BUY_PAYMENT(`:${studentRoutePaths/* BuyCourseParams */.zB.CourseId}`, `:${studentRoutePaths/* BuyCourseParams */.zB.BuyPacketProductId}`)],
  component: BuyCourseWrapper,
  exact: true
}, {
  path: [
  // eslint-disable-next-line sonarjs/no-duplicate-string
  studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(":productId", ":chapterId", ":revisionType"), studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(":productId", ":chapterId")],
  render() {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductRevisionPage, {
      userRole: ProductRevisionTrainerUserRole.Student
    });
  }
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.SPEAKING_CHECKUP(anySpeakingSessionId),
  render(props) {
    const speakingPath = props.match.params.speakingSessionId && studentRoutePaths/* studentRoutePaths */.dR.SPEAKING(props.match.params.speakingSessionId);
    return speakingPath ? /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingCheckupPage, {
      speakingPath
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
  }
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.SPEAKING(anySpeakingSessionId),
  component: StudentSpeakingPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.PRE_SPEAKING(anySpeakingSessionId),
  component: PrespeakingPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.REPETITION,
  component: StudentRepetitionPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.ONBOARDING,
  component: OnboardingPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.COURSE_SELECT,
  component: CourseSelectPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.ABOUT,
  component: AboutPage
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.NOTES({
    speakingId: ":speakingId"
  }), studentRoutePaths/* studentRoutePaths */.dR.NOTES({})],
  component: NotesPage
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(`:${studentRoutePaths/* ProductTrainerParams */.KG.ProductId}`, `:${studentRoutePaths/* ProductTrainerParams */.KG.ChapterId}`, `:${studentRoutePaths/* ProductTrainerParams */.KG.ActivityId}`, `:${studentRoutePaths/* ProductTrainerParams */.KG.BlockId}`), studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(`:${studentRoutePaths/* ProductTrainerParams */.KG.ProductId}`, `:${studentRoutePaths/* ProductTrainerParams */.KG.ChapterId}`, `:${studentRoutePaths/* ProductTrainerParams */.KG.ActivityId}`), studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_TRAINER(`:${studentRoutePaths/* ProductTrainerParams */.KG.ProductId}`, `:${studentRoutePaths/* ProductTrainerParams */.KG.ChapterId}`)],
  component: ProductTrainerPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REPETITION(":productId"),
  component: ProductRepetitionPage
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(":productId", ":chapterId", ":revisionType"), studentRoutePaths/* studentRoutePaths */.dR.PRODUCT_REVISION(":productId", ":chapterId")],
  component: ProductRevisionPage
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING_PROMO_CODE(`:${studentRoutePaths/* StudentRoutesPaymentLandingParams */.Wl.LandingId}`), studentRoutePaths/* studentRoutePaths */.dR.PAYMENT_LANDING(`:${studentRoutePaths/* StudentRoutesPaymentLandingParams */.Wl.LandingId}`)],
  component: WithAuthPaymentLanding,
  exact: true
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.BEGINNER.SCHEDULE_LIST, studentRoutePaths/* studentRoutePaths */.dR.BUS.SCHEDULE_LIST, studentRoutePaths/* studentRoutePaths */.dR.BUS_ANALYST.SCHEDULE_LIST, studentRoutePaths/* studentRoutePaths */.dR.BUS_PRODUCT_MANAGER.SCHEDULE_LIST],
  component: () => /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
    to: studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE_LIST
  }),
  exact: true
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.BEGINNER.SCHEDULE, studentRoutePaths/* studentRoutePaths */.dR.BUS.SCHEDULE, studentRoutePaths/* studentRoutePaths */.dR.BUS_ANALYST.SCHEDULE, studentRoutePaths/* studentRoutePaths */.dR.BUS_PRODUCT_MANAGER.SCHEDULE],
  component: () => /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
    to: studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE
  }),
  exact: true
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.BEGINNER.TASKS, studentRoutePaths/* studentRoutePaths */.dR.BUS.TASKS, studentRoutePaths/* studentRoutePaths */.dR.BUS_ANALYST.TASKS, studentRoutePaths/* studentRoutePaths */.dR.BUS_PRODUCT_MANAGER.TASKS],
  component: () => /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
    to: studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.TASKS
  }),
  exact: true
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.BEGINNER.EDUCATION_MATERIALS, studentRoutePaths/* studentRoutePaths */.dR.BUS.EDUCATION_MATERIALS, studentRoutePaths/* studentRoutePaths */.dR.BUS_ANALYST.EDUCATION_MATERIALS, studentRoutePaths/* studentRoutePaths */.dR.BUS_PRODUCT_MANAGER.EDUCATION_MATERIALS],
  component: () => /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
    to: studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.EDUCATION_MATERIALS
  }),
  exact: true
}, {
  path: [studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.TASKS, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.EDUCATION_MATERIALS, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.SCHEDULE_LIST, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.INDEX, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.SKILLS, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.TESTS, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.PROGRAM, studentRoutePaths/* studentRoutePaths */.dR.ACCOUNT.PROGRESS.TEST_RESULT(":testId")],
  component: StudentIndexWrapper,
  exact: true
}, {
  path: newbieRoutePaths.INDEX,
  component: NewbiePage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.RESOURCES,
  component: ResourcesPage
}, {
  path: studentRoutePaths/* studentRoutePaths */.dR.FOREIGNER_SESSIONS,
  component: ForeignerSessionsSchedulePage
}];
;// CONCATENATED MODULE: ./src/api/cms/cms.urls.ts



const cmsUrlPefix = `${(0,site_utils/* getAPIPath */.NZ)()}/cms`;
const GET_TUTOR_ONBOARDING_CHAPTER = chapterId => `${cmsUrlPefix}/chapters/${chapterId}/trainer`;
const GET_SPEAKINGS = `${cmsUrlPefix}/speakings`;
const GET_SPEAKING = speakingId => `${cmsUrlPefix}/speakings/${speakingId}/trainer`;
;// CONCATENATED MODULE: ./src/api/cms/cms.api.ts








const getTutorOnboardingChapter = chapterId => (0,api_utils/* http */.d)(GET_TUTOR_ONBOARDING_CHAPTER(chapterId), "GET");
const getSpeakings = () => (0,api_utils/* http */.d)(GET_SPEAKINGS, "GET");
const getSpeaking = speakingId => (0,api_utils/* http */.d)(GET_SPEAKING(speakingId), "GET");
const getChapterSpeaking = async chapterId => {
  const speakings = await getSpeakings();
  const speaking = speakings.data.speakings.find(s => s.chapter_id === chapterId);
  let speakingInfo;
  if (!speaking) {
    speakingInfo = await getSpeaking(chapterId);
  } else {
    speakingInfo = await getSpeaking(speaking.id);
  }
  return (0,Either.right)({
    data: {
      id: speakingInfo.data.speaking.id,
      state: "scheduled",
      speaking: {
        id: speakingInfo.data.speaking.id,
        activities: speakingInfo.data.speaking.activities,
        title: null,
        type: "chapter",
        type_id: "",
        image_url: null,
        duration_minutes: 60,
        chapter: {
          id: chapterId,
          title: "",
          level_title: "",
          chapter_title: "",
          image_url: ""
        },
        properties: {
          scheduling_strategy: "legacy"
        }
      },
      start_at: 0,
      updated_at: 0,
      created_at: 0
    }
  });
};
// EXTERNAL MODULE: ./src/api/student/speaking/speaking.mappers.ts
var speaking_mappers = __webpack_require__(49968);
;// CONCATENATED MODULE: ./src/pages/mentor-speaking/mentor-speaking.page.tsx










const MentorSpeakingPage = () => {
  const {
    chapterId,
    tutorSpeakingId
  } = (0,react_router/* useParams */.UO)();
  const fetchSpeakingSession = (0,react.useCallback)(async () => {
    const data = await getChapterSpeaking(chapterId);
    if ((0,Either.isRight)(data)) {
      return {
        ...(0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(data.right.data),
        id: tutorSpeakingId
      };
    }
    throw api_model/* unexpectedError */.g;
  }, [chapterId, tutorSpeakingId]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingPage, {
    classUserRole: "activeSpectator",
    speakingSessionId: tutorSpeakingId,
    fetchSpeakingSession
  });
};
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-tutor-onboarding-machine.ts












const create_tutor_onboarding_machine_services = {
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: create_trainer_machine/* services */.uZ[trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER],
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: async context => {
    const response = await getTutorOnboardingChapter(context.chapterId);
    return {
      chapterData: response.data.chapter.activities,
      userData: []
    };
  }
};
const ANSWER_EVENT_TYPE = "tutor_onboarding_result";
const create_tutor_onboarding_machine_updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)(ANSWER_EVENT_TYPE);
const create_tutor_onboarding_machine_guards = {
  ...create_trainer_machine/* guards */.l8,
  [trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsAllNextActivitiesEmptyAfterFilterGuard */.NZ)(ANSWER_EVENT_TYPE),
  [trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsNextActivityEmptyAfterFilterGuard */.b2)(ANSWER_EVENT_TYPE)
};
const create_tutor_onboarding_machine_baseTrainerActions = create_trainer_machine/* actions */.Nw;
const create_tutor_onboarding_machine_actions = {
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getBlockFilterAction */.XI)(ANSWER_EVENT_TYPE)),
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,xstate_es/* assign */.f0)((context, event) => ({
    activities: event.data.chapterData,
    chapterStudentEvents: {},
    activityIndex: 0,
    blockIndex: 0
  })),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: create_tutor_onboarding_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
  [trainer_machine_consts/* ACTIONS */.aO.PUSH_CHAPTER_ANSWER]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getChapterAnswerPusher */.hf)(ANSWER_EVENT_TYPE)),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: create_tutor_onboarding_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: create_tutor_onboarding_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.RESET_TRAINER]: (0,xstate_es/* assign */.f0)({
    activityIndex: 0,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX_TIL_NOT_EMPTY]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getIncrementActivityIndexTilNotEmptyAssignment */.OQ)(ANSWER_EVENT_TYPE)),
  [trainer_machine_consts/* ACTIONS */.aO.ADD_OUTRO_IF_NEED]: (0,xstate_es/* assign */.f0)(context => {
    const activities = [...context.activities];
    const lastActivity = activities[activities.length - 1];
    const lastBlock = lastActivity.blocks[lastActivity.blocks.length - 1];
    if (lastBlock.type === "chapter-outro") {
      return {};
    }
    const outro = {
      type: "chapter-outro",
      id: context.chapterId || "",
      actionControls: [{
        text: context.intl.formatMessage({
          id: "tutorOnboarding.onMain"
        }),
        action: {
          type: "ON_MAIN_TUTOR_PAGE"
        }
      }],
      image: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/7452c5cf-217f-408f-929d-0768923c65f4/ontroTrainer.svg"
    };
    lastActivity.blocks.push(outro);
    return {
      activities
    };
  }),
  [trainer_machine_consts/* ACTIONS */.aO.SEND_FINAL_EVENT_IF_NEED]: (context, event) => {
    if (context.isFinalEventExist) {
      return {};
    }
    const guardMeta = {};
    if (create_tutor_onboarding_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_ACTIVITY_AND_BLOCK](context, event, guardMeta) || create_tutor_onboarding_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_BLOCK](context, event, guardMeta) && create_tutor_onboarding_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER](context, event, guardMeta) && create_tutor_onboarding_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER](context, event, guardMeta)) {
      void (0,trainer_api/* createProgress */.gy)({
        block_id: context.currentBlocks[context.blockIndex].id,
        activity_id: context.activities[context.activityIndex]?.activity_id,
        course_id: context.chapterInfo?.courseId || "",
        chapter_id: context.chapterId || "",
        event_type: "tutor_onboarding_progress_final"
      });
      return {
        isFinalEventExist: true
      };
    }
    return {};
  }
};
const tutorOnboardingTrainerMachine = (0,Machine/* createMachine */.C)({
  id: "tutor-onboarding-trainer",
  initial: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA,
  states: {
    [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
        onDone: [{
          actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.ADD_OUTRO_IF_NEED, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }],
        onError: trainer_machine_consts/* STATES */.PO.ERROR
      }
    },
    [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS],
    [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
        data: getSavingProgressPreparator("tutor_onboarding_progress"),
        onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS,
        onError: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
      }
    },
    [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER,
        data: getAnswerDataSaverPreparator(ANSWER_EVENT_TYPE),
        onDone: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS,
        onError: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
      }
    },
    [trainer_machine_consts/* STATES */.PO.ERROR]: trainerStatesConfig[trainer_machine_consts/* STATES */.PO.ERROR]
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER],
    [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), create_tutor_onboarding_machine_actions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    },
    [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
      actions: [(0,xstate_es/* assign */.f0)({
        chapterStudentEvents: create_tutor_onboarding_machine_updateStudentEvent,
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER
    }
  }
});
const createTutorOnboardingTrainerMachine = (chapterId, intl) => tutorOnboardingTrainerMachine.withConfig({
  actions: create_tutor_onboarding_machine_actions,
  services: create_tutor_onboarding_machine_services,
  guards: create_tutor_onboarding_machine_guards
}).withContext({
  mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
  chapterStudentEvents: {},
  currentBlocks: [],
  chapterId,
  activities: [],
  progress: 0,
  blockIndex: 0,
  activityIndex: 0,
  scrollToBlockIndex: 0,
  filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("trainer_result"),
  intl
});
;// CONCATENATED MODULE: ./src/pages/tutor-onboarding/tutor-onboarding.page.tsx



















const tutor_onboarding_page_ONBOARDING_ANSWER_EVENT = "tutor_onboarding_result";
const TutorOnboardingPage = () => {
  const {
    params: {
      chapterId
    }
  } = (0,react_router/* useRouteMatch */.$B)();
  const intl = (0,useIntl/* default */.Z)();
  const machine = (0,react.useMemo)(() => createTutorOnboardingTrainerMachine(chapterId, intl), [chapterId, intl]);
  const [state, send] = (0,useMachine/* useMachine */.e)(machine);
  const {
    activities,
    activityIndex,
    currentBlocks: condBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  const onSubmitAnswer = (0,react.useCallback)(_ref => {
    let {
      answer,
      correct,
      typo,
      blockId
    } = _ref;
    return send(product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER, {
      data: {
        answer,
        blockId,
        // eslint-disable-next-line camelcase
        activityId: currentActivity?.activity_id,
        courseId: state.context.chapterInfo?.courseId,
        levelId: state.context.chapterInfo?.levelId,
        topicId: state.context.chapterInfo?.topicId,
        correct,
        typo
      }
    });
  }, [currentActivity, send, state.context.chapterInfo]);
  const handleOutroAction = (0,react.useCallback)(a => {
    if (a.type === "ON_MAIN_TUTOR_PAGE") {
      window.location.href = (0,site_utils/* getTutorPath */.lz)();
    }
  }, []);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    const blockEvents = state.context.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === tutor_onboarding_page_ONBOARDING_ANSWER_EVENT) ?? [];
    const answerJSONString = answerEvent[answerEvent.length - 1]?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [state.context.chapterStudentEvents]);
  const {
    handleNextBlockClick,
    handleResetAnswer,
    handlePrevActivityClick,
    handlePrevBlockClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  switch (state.value) {
    case trainer_machine_consts/* STATES */.PO.ERROR:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "error"
      });
    case trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA:
      return null;
    case trainer_machine_consts/* STATES */.PO.SAVING_ANSWER:
    case trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {
          onClick: () => {
            window.location.href = (0,site_utils/* getTutorPath */.lz)();
          }
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
          onResetAnswer: blockId => {
            if (currentActivity?.activity_id) {
              handleResetAnswer(blockId, currentActivity?.activity_id);
            }
          },
          onPrevBlockClick: handlePrevBlockClick,
          onPrevActivityClick: handlePrevActivityClick,
          blocks: condBlocks,
          activityType: currentActivity?.type ?? "story",
          onSubmitAnswer,
          currentActivityIndex: state.context.activityIndex,
          blockIndex: state.context.blockIndex,
          onNextBlockClick: handleNextBlockClick,
          mechanicMachineCreator: state.context.mechanicMachineCreator,
          onOutroActionTrigger: handleOutroAction,
          getBlockAnswerInfo,
          showPrevButton: false,
          showNextButton: true,
          showSkipButton: false,
          showResetButton: false,
          showSubmitButton: true,
          showAudioFooter: true,
          userEnvironment: types/* UserEnvironment */.P.Tutor,
          isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
        })]
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "tutor-onboarding.page",
        state: state.value
      });
  }
};
;// CONCATENATED MODULE: ./src/pages/tutor-speaking/speaking-tutor.page.tsx





const TutorSpeakingPage = () => {
  const {
    speakingSessionId
  } = (0,react_router/* useParams */.UO)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingPage, {
    speakingSessionId,
    classUserRole: "tutor"
  });
};
;// CONCATENATED MODULE: ./src/app/routes/tutor.routes.tsx














const CHAPTER_ID_PARAM = ":chapterId";
const SPEAKING_SESSION_ID_PARAM = ":speakingSessionId";
const tutorRoutesConfig = [{
  path: [teacher_route_paths/* teacherRoutePaths */.q.PRODUCT_REVISION(CHAPTER_ID_PARAM), teacher_route_paths/* teacherRoutePaths */.q.INDEX],
  component: TaskGuidePage,
  exact: true
}, {
  path: teacher_route_paths/* teacherRoutePaths */.q.SPEAKING_CHECKUP(SPEAKING_SESSION_ID_PARAM),
  render(props) {
    const speakingPath = props.match.params.speakingSessionId && teacher_route_paths/* teacherRoutePaths */.q.SPEAKING(props.match.params.speakingSessionId);
    return speakingPath ? /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingCheckupPage, {
      speakingPath
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
  }
}, {
  path: teacher_route_paths/* teacherRoutePaths */.q.SPEAKING(SPEAKING_SESSION_ID_PARAM),
  component: TutorSpeakingPage
}, {
  component: TutorOnboardingPage,
  path: teacher_route_paths/* teacherRoutePaths */.q.ONBOARDING
}, {
  path: teacher_route_paths/* teacherRoutePaths */.q.PRODUCT_REVISION(CHAPTER_ID_PARAM, ":revisionType"),
  render() {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductRevisionPage, {
      userRole: ProductRevisionTrainerUserRole.Tutor
    });
  }
}, {
  path: teacher_route_paths/* teacherRoutePaths */.q.MENTOR_SPEAKING_CHECKUP(CHAPTER_ID_PARAM, ":tutorSpeakingId"),
  render(props) {
    const {
      params
    } = props.match;
    const speakingPath = params.chapterId && params.tutorSpeakingId && teacher_route_paths/* teacherRoutePaths */.q.MENTOR_SPEAKING(params.chapterId, params.tutorSpeakingId);
    return speakingPath ? /* @__PURE__ */(0,jsx_runtime.jsx)(SpeakingCheckupPage, {
      speakingPath
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(Page404, {});
  }
}, {
  component: MentorSpeakingPage,
  path: teacher_route_paths/* teacherRoutePaths */.q.MENTOR_SPEAKING(CHAPTER_ID_PARAM, ":tutorSpeakingId")
}, {
  path: teacher_route_paths/* teacherRoutePaths */.q.STUDENT_ABOUT,
  component: AboutPage
}, {
  path: [baseRoutePaths/* baseRoutePaths */.lQ.TASK_GUIDE(":syllabusId", ":chapterId"), baseRoutePaths/* baseRoutePaths */.lQ.TASK_GUIDE(":syllabusId")],
  component: DemoTaskGuidePage
}];
;// CONCATENATED MODULE: ./src/app/routes/methodologist.routes.config.tsx












const methodologistPrefix = "/methodologist";
const methodologistRoutePaths = {
  INDEX: methodologistPrefix,
  SPEAKING: `${methodologistPrefix}/speaking/:speakingSessionId`,
  PRODUCT_REVISION: (productId, chapterId, revisionType) => {
    const revisionPrefix = revisionType ? `/${revisionType}` : "";
    return `${methodologistPrefix}/product-revision/${productId}/${chapterId}${revisionPrefix}`;
  },
  SYLLABUS: `${methodologistPrefix}/syllabus/:syllabusId`
};
const methodologistRoutesConfig = [{
  path: [methodologistRoutePaths.INDEX],
  component: MethodologistIndex,
  exact: true
}, {
  path: methodologistRoutePaths.SPEAKING,
  component: MethodologistSpeakingPage,
  exact: true
}, {
  path: [
  // eslint-disable-next-line sonarjs/no-duplicate-string
  methodologistRoutePaths.PRODUCT_REVISION(":productId", ":chapterId", ":revisionType"), methodologistRoutePaths.PRODUCT_REVISION(":productId", ":chapterId")],
  render() {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ProductRevisionPage, {
      userRole: ProductRevisionTrainerUserRole.Methodologist
    });
  }
}, {
  path: methodologistRoutePaths.SYLLABUS,
  component: SyllabusPage,
  exact: true
}, {
  path: [baseRoutePaths/* baseRoutePaths */.lQ.TASK_GUIDE(":syllabusId", ":chapterId"), baseRoutePaths/* baseRoutePaths */.lQ.TASK_GUIDE(":syllabusId")],
  component: DemoTaskGuidePage
}, ...studentRoutesConfig, ...tutorRoutesConfig];
;// CONCATENATED MODULE: ./src/app/routes/newbie.routes.config.ts




const newbieRoutesConfig = [{
  path: [newbieRoutePaths.INDEX],
  component: NewbiePage,
  exact: true
}];
;// CONCATENATED MODULE: ./src/app/app.routes.config.ts







const getRoutesByRole = role => {
  switch (role) {
    case entities_user/* UserRole */.i4.ROLE_TESTER:
    case entities_user/* UserRole */.i4.ROLE_STUDENT:
      return studentRoutesConfig;
    case entities_user/* UserRole */.i4.ROLE_METHODOLOGIST:
    case entities_user/* UserRole */.i4.ROLE_DEVELOPER:
    case entities_user/* UserRole */.i4.ROLE_SUPPORT:
    case entities_user/* UserRole */.i4.ROLE_CONTENT_MANAGER:
      return methodologistRoutesConfig;
    case entities_user/* UserRole */.i4.ROLE_TUTOR:
      return tutorRoutesConfig;
    case entities_user/* UserRole */.i4.ROLE_NEWBIE:
      return newbieRoutesConfig;
    default:
      return [];
  }
};
// EXTERNAL MODULE: ../ui-kit/src/button/button.model.ts
var button_model = __webpack_require__(63517);
// EXTERNAL MODULE: ./src/api/user/authorization/api.ts + 1 modules
var authorization_api = __webpack_require__(26630);
;// CONCATENATED MODULE: ./src/hooks/use-bunker-external-urls-query.ts




const useBunkerExternalUrlsQuery = () => (0,useQuery/* useQuery */.a)({
  queryKey: ["bunkerExternalUrls"],
  queryFn: bunker_api/* getExternalUrls */.Sj,
  staleTime: Infinity,
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false
});
;// CONCATENATED MODULE: ./src/pages/settings/settings.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const settings_module = ({"root":"settings-module__root--i9DLy","message":"settings-module__message--Y6Uw7","checkboxes":"settings-module__checkboxes--ZupA2","checkboxItem":"settings-module__checkboxItem--cwJnS","notificationItem":"settings-module__notificationItem--CVPH7","saveButton":"settings-module__saveButton--lPQGW","main":"settings-module__main--PlyPB","go-back-button":"settings-module__go-back-button--Xd7Wb","goBackButton":"settings-module__go-back-button--Xd7Wb","greyText":"settings-module__greyText--_DkmK","howToChangePhone":"settings-module__howToChangePhone--JRn8Q","telegramBotQRCode":"settings-module__telegramBotQRCode--CM8XF","telegramBotQrCode":"settings-module__telegramBotQRCode--CM8XF","changeNotificationTelegram":"settings-module__changeNotificationTelegram--HyT7F"});
;// CONCATENATED MODULE: ./src/pages/settings/settings.page.tsx





























const SettingsPage = () => {
  const user = (0,useUser/* useUser */.aF)();
  if (user.state !== useUser/* State */.ZM.Loaded || !user.data.me.user) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SettingsPageContent, {
    user: user.data.me.user
  });
};
const SettingsPageContent = _ref => {
  let {
    user: {
      userAgreement,
      emailAgreement: originalEmailAgreement,
      notification,
      defaultPhone,
      telegramId,
      telegramName
    }
  } = _ref;
  const userInfo = (0,useUser/* useUser */.aF)();
  const history = (0,react_router/* useHistory */.k6)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const telegramNotification = (0,features/* useFeatureFlag */.ye)("telegramNotification");
  const externalUrls = useBunkerExternalUrlsQuery();
  const [pageState, setPageState] = (0,react.useState)("initial");
  const [emailAgreement, setEmailAgreement] = (0,react.useState)(originalEmailAgreement);
  const [selectedNotificationType, setSelectedNotificationType] = (0,react.useState)(notification);
  const [verificationCode, setVerificationCode] = (0,react.useState)("");
  const notificationTypeText = (0,react.useMemo)(() => {
    if (notification === "sms") {
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "settings.notificationType.sms"
        }), " ", /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: settings_module.greyText,
          children: defaultPhone
        })]
      });
    }
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "settings.notificationType.telegram"
      }), " ", telegramName && /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
        className: settings_module.greyText,
        children: ["@", telegramName]
      })]
    });
  }, [notification, telegramName, defaultPhone]);
  const handleGoBack = (0,react.useCallback)(() => {
    history.goBack();
  }, [history]);
  const showSubmitError = (0,react.useCallback)(() => toast/* toastNotificationService */.B.showError(intl.formatMessage({
    id: "settings.submitError"
  })), [intl]);
  const saveButtonHandler = (0,react.useCallback)(() => {
    if (userInfo.state !== useUser/* State */.ZM.Loaded) {
      return;
    }
    setPageState("saving");
    (0,authorization_api/* updateUserAttributes */.V)({
      user_agreement: userAgreement,
      email_agreement: emailAgreement
    }).then(() => void userInfo.functions?.reloadMe()).catch(() => {
      setEmailAgreement(originalEmailAgreement);
      showSubmitError();
    }).finally(() => setPageState("initial"));
  }, [emailAgreement, originalEmailAgreement, showSubmitError, userAgreement, userInfo.functions, userInfo.state]);
  const closeModal = () => {
    setSelectedNotificationType(notification);
    setVerificationCode("");
    setPageState("initial");
  };
  const showNotificationTypeModal = () => setPageState("changeNotification");
  const updateNotificationType = (0,react.useCallback)(() => {
    setPageState("saving");
    void (0,student_api/* setNotificationType */.Wv)(selectedNotificationType).then(() => void userInfo.functions?.reloadMe()).catch(() => {
      setSelectedNotificationType(notification);
      showSubmitError();
    }).finally(() => setPageState("initial"));
  }, [notification, selectedNotificationType, showSubmitError, userInfo.functions]);
  const saveNotificationType = (0,react.useCallback)(() => selectedNotificationType === "telegram" && !telegramId ? setPageState("verifyTelegram") : updateNotificationType(), [selectedNotificationType, telegramId, updateNotificationType]);
  const verifyTelegram = (0,react.useCallback)(() => {
    setPageState("saving");
    void (0,student_api/* applyTelegramCode */.kr)(verificationCode).then(() => {
      updateNotificationType();
    }).catch(() => {
      setSelectedNotificationType(notification);
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        id: "settings.submitError"
      }));
    }).finally(() => {
      setVerificationCode("");
      setPageState("initial");
    });
  }, [intl, notification, updateNotificationType, verificationCode]);
  const handleChangeTelegramCode = (0,react.useCallback)(e => setVerificationCode(e.target.value), []);
  const disableSubmitButton = pageState === "saving" || emailAgreement === originalEmailAgreement;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(app_page_wrapper_component/* AppPageWrapper */.I, {
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey
    },
    header: {
      hideNavigation: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
      className: settings_module.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: settings_module.goBackButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(GoBackButton, {
          onClick: handleGoBack,
          text: intl.formatMessage({
            id: "backButton"
          }),
          withMarginBottom: false
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: settings_module.main,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          className: classnames_default()({
            [typography_module/* default */.Z.headline2]: !isMobile,
            [typography_module/* default */.Z.headline4Accent]: isMobile
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "settings.title"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: settings_module.checkboxes,
          children: [telegramNotification && /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
            className: classnames_default()(settings_module.checkboxItem, settings_module.notificationItem),
            appearance: "tertiary",
            onClick: showNotificationTypeModal,
            children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
                className: typography_module/* default */.Z.body2Accent,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
                  id: "settings.notificationType.title"
                })
              }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
                className: typography_module/* default */.Z.body2,
                children: notificationTypeText
              })]
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              name: "arrow-right",
              size: "medium"
            })]
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: settings_module.checkboxItem,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(EmailAgreementCheckbox, {
              value: emailAgreement,
              onChange: setEmailAgreement
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: settings_module.checkboxItem,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(UserAgreementCheckbox, {
              disabled: true,
              onChange: function_utils/* emptyFunction */.Bi,
              value: userAgreement
            })
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: settings_module.saveButton,
          appearance: "primary",
          disabledAppearance: button_model/* DisabledButtonAppearance */.iL.Transparent,
          onClick: saveButtonHandler,
          disabled: disableSubmitButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "settings.saveButton"
          })
        })]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)(modal/* Modal */.u_, {
      isVisible: pageState === "changeNotification",
      onClose: closeModal,
      title: /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "settings.notificationType.modalTitle"
        })
      }),
      buttons: [{
        appearance: "primary",
        text: intl.formatMessage({
          id: "settings.saveButton"
        }),
        onClick: saveNotificationType
      }],
      showCloseButton: true,
      size: modal/* ModalSize */.Cg.Small,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
        size: "small",
        checked: selectedNotificationType === "telegram",
        onChange: () => setSelectedNotificationType("telegram"),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "settings.notificationType.telegram"
        })
      }), telegramId && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: settings_module.changeNotificationTelegram,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(input_component/* Input */.II, {
          theme: input_component/* InputTheme */.RK.Grey,
          placeholder: intl.formatMessage({
            id: "settings.notificationType.emptyTelegramNamePlaceholder"
          }),
          disabled: true,
          value: telegramName ? "@" + telegramName : ""
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "tertiary",
          disabled: selectedNotificationType === "sms",
          onClick: () => setPageState("verifyTelegram"),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "settings.notificationType.changeTelegram"
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
        size: "small",
        checked: selectedNotificationType === "sms",
        onChange: () => setSelectedNotificationType("sms"),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "settings.notificationType.sms"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: settings_module.howToChangePhone,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "settings.notificationType.howToChangePhone",
          values: {
            phone: defaultPhone
          }
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)(modal/* Modal */.u_, {
      isVisible: pageState === "verifyTelegram",
      onClose: closeModal,
      title: /* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
        className: classnames_default()(typography_module/* default */.Z.headline4Accent),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "settings.notificationType.enterVerificationCode"
        })
      }),
      subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: intl.formatMessage({
          id: "settings.notificationType.verificationCodeInstructions"
        }, {
          link: externalUrls.data?.default.telegramBot
        })
      }),
      buttons: [{
        appearance: "secondary",
        text: intl.formatMessage({
          id: "backButton"
        }),
        onClick: showNotificationTypeModal
      }, {
        appearance: "primary",
        text: intl.formatMessage({
          id: "settings.saveButton"
        }),
        disabled: !verificationCode,
        onClick: verifyTelegram
      }],
      showCloseButton: true,
      size: modal/* ModalSize */.Cg.Small,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: settings_module.telegramBotQRCode,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          src: externalUrls.data?.default.telegramBotQRCode,
          width: "110",
          height: "110",
          alt: ""
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(input_component/* Input */.II, {
        placeholder: intl.formatMessage({
          id: "settings.notificationType.enterVerificationCode"
        }),
        theme: input_component/* InputTheme */.RK.Grey,
        value: verificationCode,
        onChange: handleChangeTelegramCode
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/app/routes/base.routes.config.ts




const baseRoutesConfig = [{
  path: [baseRoutePaths/* baseRoutePaths */.lQ.SETTINGS],
  component: SettingsPage,
  exact: true
}];
;// CONCATENATED MODULE: ./src/app/app.routes.tsx























const AutoOnboardingPageLazy = (0,react.lazy)(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3874)));
const IndexRoute = () => {
  const auth = useUserInfo();
  const role = auth.x?.me.user?.role;
  const userAttributes = useUserAttributes();
  const needOnboarding = userAttributes.data?.needOnboarding ?? false;
  switch (role) {
    case entities_user/* UserRole */.i4.ROLE_DEVELOPER:
    case entities_user/* UserRole */.i4.ROLE_METHODOLOGIST:
    case entities_user/* UserRole */.i4.ROLE_STUDENT:
    case entities_user/* UserRole */.i4.ROLE_CONTENT_MANAGER:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(RedirectWithParams, {
        to: needOnboarding ? studentRoutePaths/* studentRoutePaths */.dR.COURSE_SELECT : studentRoutePaths/* studentRoutePaths */.dR.INDEX
      });
    case entities_user/* UserRole */.i4.ROLE_NEWBIE:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(RedirectWithParams, {
        to: newbieRoutePaths.INDEX,
        withRetPath: true
      });
    case entities_user/* UserRole */.i4.ROLE_TUTOR:
      window.location.href = (0,site_utils/* getTutorPath */.lz)();
      return null;
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(RedirectWithParams, {
        to: studentRoutePaths/* studentRoutePaths */.dR.INDEX
      });
  }
};
const AppRoutes = _ref => {
  let {
    role
  } = _ref;
  const routes = (0,react.useMemo)(() => [...getRoutesByRole(role), ...baseRoutesConfig], [role]);
  const canBuyGift = (0,features/* useGiftPurchaseAvailability */.g3)();
  const {
    referral
  } = (0,utils_experimentDi/* useExperimentDi */.e1)();
  const isReferralExperimentActive = Boolean(referral.tariff_slug);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(react.Suspense, {
    fallback: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {}),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router/* Switch */.rs, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: baseRoutePaths/* baseRoutePaths */.lQ.INDEX,
        exact: true,
        component: IndexRoute
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: studentRoutePaths/* studentRoutePaths */.dR.AUTO_ONBOARDING,
        component: AutoOnboardingPageLazy
      }), canBuyGift && /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: baseRoutePaths/* buyGiftCertificatePaths */.NB,
        exact: true,
        component: BuyGiftCertificatePage
      }), isReferralExperimentActive && /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        path: studentRoutePaths/* studentRoutePaths */.dR.REFERRAL_PROGRAM,
        exact: true,
        component: ReferralProgramPage
      }), routes.map(route => /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        ...route
      }, route.path.toString())), role === entities_user/* UserRole */.i4.ROLE_NEWBIE && /* @__PURE__ */(0,jsx_runtime.jsx)(RedirectWithParams, {
        to: newbieRoutePaths.INDEX,
        withRetPath: true
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
        component: Page404
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/app/app.component.tsx

























const app_component_queryClient = new queryClient/* QueryClient */.S({
  defaultOptions: {
    queries: {
      throwOnError: true,
      networkMode: "always"
    }
  }
});
const App = () => /* @__PURE__ */(0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
  client: app_component_queryClient,
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(OnboardingTooltipsStateProvider, {
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(useUser/* UserContextProvider */.fS, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(useProducts/* ProductsContextProvider */.aJ, {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(UserAttributesProvider, {
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(AppContent, {})
        })
      })
    })
  })
});
const useProductRedefineHandler = () => {
  const getRedefinedProductId = (userExperiments, userCurrentProductId) => {
    for (const experiment of Object.values(userExperiments)) {
      const redefinedCurrentProductId = experiment.redefine_product?.[student_model/* ProductType */.kv.Level]?.[userCurrentProductId];
      if (redefinedCurrentProductId) {
        return redefinedCurrentProductId;
      }
    }
    return null;
  };
  const userModel = (0,useUser/* useUser */.aF)();
  const isCurrentProductIdUpdated = (0,react.useRef)(false);
  (0,react.useEffect)(() => {
    if (!isCurrentProductIdUpdated.current) {
      const userExperiments = userModel.data?.me.user?.experiments;
      const userCurrentProductId = userModel.data?.product?.id;
      if (userExperiments && userCurrentProductId) {
        isCurrentProductIdUpdated.current = true;
        const redefinedCurrentProductId = getRedefinedProductId(userExperiments, userCurrentProductId);
        if (redefinedCurrentProductId) {
          void (0,placement_api/* placeUserIntoLevel */.k)(redefinedCurrentProductId).then(reload_page/* reloadPage */.s);
        }
      }
    }
  }, [userModel.data?.me.user?.experiments, userModel.data?.product?.id, userModel.functions]);
};
const AppContent = (0,react.memo)(function AppContent2() {
  const userModel = (0,useUser/* useUser */.aF)();
  useProductRedefineHandler();
  (0,react.useEffect)(() => {
    if (userModel.state === useUser/* State */.ZM.Loaded) {
      const user = userModel.data?.me.user;
      logger/* Logger */.Yd.setUser(user);
      if (user?.userWhoPay) {
        (0,yandexMetrica/* ymGoal */.qf)("Customer_Visit");
      }
      checkTimeOnce();
      (0,yandexMetrica/* ymSetUserId */.CL)(user?.id ?? "");
      (0,yandexMetrica/* ymSetVisitParams */.vi)();
    }
  }, [userModel.data?.me.user, userModel.state]);
  const diInjections = useDiInjections(userModel.data?.me.user?.experiments ?? null, userModel.data?.product ?? null);
  (0,react.useEffect)(() => {
    if (userModel.state === useUser/* State */.ZM.Loaded && !userModel.data.me.loggedIn) {
      auth/* Auth */.g.redirectToPassport();
    }
  }, [userModel.data?.me.loggedIn, userModel.state]);
  (0,react.useEffect)(() => {
    if (userModel.state === useUser/* State */.ZM.Loaded && userModel.data.me.user?.shouldResetCookie) {
      auth/* Auth */.g.redirectToPassportCookieReset();
    }
  }, [userModel.data?.me.user?.shouldResetCookie, userModel.state]);
  if (userModel.state !== useUser/* State */.ZM.Loaded) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
  }
  const role = userModel.data.me?.user?.role;
  if (role === void 0) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TranslationsProvider, {
    currentProductId: userModel.data?.product?.id,
    currentLocale: role === "tutor" ? "en" : "ru",
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(utils_experimentDi/* DiContextProvider */.Vs, {
      notDefaultInjections: diInjections,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(AppRoutes, {
        role
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(bell_component_Bell, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(ToastContainerUI, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(FeedbackPopup, {})]
    })
  });
});
;// CONCATENATED MODULE: ./src/app/routes/noauthRoutePaths.ts


const noAuthRoutePath = {
  PAYMENT_LANDING: landingId => `/payment-landing/${landingId}`,
  PROMO_TRAINER: chapterId => `/promo-trainer/${chapterId}`,
  CUST_DEV_TRAINER: (levelId, chapterId) => `/cust-dev/${levelId}/${chapterId}`,
  LANDING_CURATOR_REQUEST_FORM: "/landing_curator_request_form"
};
var NoAuthRoutesCustDevParams = /* @__PURE__ */(NoAuthRoutesCustDevParams2 => {
  NoAuthRoutesCustDevParams2["LevelId"] = "levelId";
  NoAuthRoutesCustDevParams2["ChapterId"] = "chapterId";
  return NoAuthRoutesCustDevParams2;
})(NoAuthRoutesCustDevParams || {});
var NoAuthRoutesPaymentLandingParams = /* @__PURE__ */(NoAuthRoutesPaymentLandingParams2 => {
  NoAuthRoutesPaymentLandingParams2["LandingId"] = "landingId";
  return NoAuthRoutesPaymentLandingParams2;
})(NoAuthRoutesPaymentLandingParams || {});
;// CONCATENATED MODULE: ./src/pages/cust-dev-trainer/cust-dev-trainer.page.tsx










const CustDevTrainerPage = () => {
  const params = (0,react_router/* useParams */.UO)();
  const diInjections = (0,react.useMemo)(() => {
    const injections = {};
    injections.disableTrainerOutroActions = true;
    injections.hideAddToWordbankButton = true;
    return injections;
  }, []);
  const eventType = (0,react.useMemo)(() => ({
    init: "cust_dev_progress_init",
    answer: "cust_dev_result",
    progress: "cust_dev_progress",
    finish: "cust_dev_progress_final"
  }), []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(utils_experimentDi/* DiContextProvider */.Vs, {
    notDefaultInjections: diInjections,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProductTrainerRenderer, {
      eventType,
      chapterFetcher: bunker_api/* getCustDevTrainerData */.k0,
      chapterId: params[NoAuthRoutesCustDevParams.ChapterId],
      productId: params[NoAuthRoutesCustDevParams.LevelId],
      trainerEnvironment: trainer_model/* TrainerEnvironment */.r$.CustDev
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/zustand/esm/react.mjs + 1 modules
var esm_react = __webpack_require__(9367);
// EXTERNAL MODULE: ../../node_modules/zustand/esm/middleware.mjs
var middleware = __webpack_require__(47832);
;// CONCATENATED MODULE: ../shared/src/validation.utils.ts


const EMAIL_VALIDATION_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$/;
const isEmailValid = email => EMAIL_VALIDATION_REGEXP.test(email);
const MIN_PHONE_LENGHT = 11;
;// CONCATENATED MODULE: ./src/api/curator-request/curator-request.ts











const UserOrderStatusModelRaw = es6.type({
  data: es6.union([es6.type({
    state: es6.literal("meeting"),
    slot: es6.string
  }), es6.type({
    state: es6.literal("new")
  }), es6.type({
    state: es6.literal("studying")
  })])
});
const getUserOrderStatus = (0,un_either/* unEither */.K)(() => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/landing/get-user-order-status`, {
  responseType: UserOrderStatusModelRaw,
  resultMapper: response => response.data.state === "meeting" ? {
    state: response.data.state,
    slot: new Date(response.data.slot)
  } : {
    state: response.data.state
  }
}));
const EducationGoalsModelRaw = es6.type({
  goals: es6.array(es6.type({
    id: es6.string,
    name: es6.string
  }))
});
const getEducationGoals = (0,un_either/* unEither */.K)(() => (0,http/* makeRequest */.$f)(bunker_urls/* GET_EDUCATION_GOALS */.du, {
  responseType: EducationGoalsModelRaw
}));
const CuratorSlotsModelRaw = es6.type({
  /** Отсортированный список из слотов в виде: %Y-%m-%dT%H:%M:%S%:z */
  data: es6.array(es6.string)
});
const getCuratorSlots = (0,un_either/* unEither */.K)(() => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/landing/get-curator-slots`, {
  responseType: CuratorSlotsModelRaw,
  resultMapper: response => response.data.map(slotString => new Date(slotString))
}));
const BookCuratorSlotModelRaw = es6.type({
  data: es6.type({
    slot: es6.string,
    state: es6.literal("meeting"),
    tim_order_id: es6.string
  })
});
class TimConnectUnavailable extends Error {}
class SlotIsAlreadyBooked extends Error {}
class AddMeetingError extends Error {}
const bookCuratorSlot = (0,un_either/* unEither */.K)(body => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/landing/book-curator-slot`, {
  method: "POST",
  body,
  responseType: UserOrderStatusModelRaw,
  resultMapper: _ref => {
    let {
      data: {
        state,
        slot,
        tim_order_id: timOrderId
      }
    } = _ref;
    return {
      state,
      slot: new Date(slot),
      timOrderId
    };
  },
  errorMapper: error => {
    switch (error?.code) {
      case "tim_connect_unavailable":
        return new TimConnectUnavailable();
      case "slot_is_already_booked":
        return new SlotIsAlreadyBooked();
      case "add_meeting_error":
        return new AddMeetingError();
      default:
        return api_model/* unexpectedError */.g;
    }
  }
}));
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/constants.ts


const INIT_MESSAGE = "CuratorRequestLandingForm_Initialized";
const REDIRECT_TO_APP_MESSAGE = "CuratorRequestLandingForm_RedirectToApplication";
const SEND_FORM_SUCCESSFUL_MESSAGE = "CuratorRequestLandingForm_SendFormSuccessful";
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/curator-request.store.tsx









const curator_request_store_initState = {
  step: "init",
  educationGoals: [],
  selectedEducationGoals: [],
  timeSlot: {
    date: null,
    isOccupied: false
  },
  curatorSlots: [],
  personalData: {
    name: "",
    phone: "+7",
    email: "",
    meetingLinkTarget: "whatsapp",
    promocode: "",
    personalDataAgreement: false,
    subscriptionAgreement: false,
    legalEntity: false,
    validation: {}
  },
  confirmedTimeSlot: null,
  error: null
};
const getNextStep = step => {
  switch (step) {
    case "educationGoal":
      return "timeSlot";
    case "timeSlot":
    default:
      return "personalData";
  }
};
const getPrevStep = step => {
  switch (step) {
    case "personalData":
      return "timeSlot";
    case "timeSlot":
    default:
      return "educationGoal";
  }
};
const sendMessage = message => {
  const mainWindow = window.top;
  if (mainWindow) {
    mainWindow.postMessage(message, "*");
  }
};
const useCuratorRequestStore = (0,esm_react/* create */.U)()((0,middleware/* devtools */.mW)((set, get) => ({
  ...curator_request_store_initState,
  init: async () => {
    set(() => ({
      step: "loading"
    }), void 0, {
      type: "initLoading"
    });
    try {
      const userOrderStatus = await getUserOrderStatus();
      sendMessage(INIT_MESSAGE);
      if (userOrderStatus.state === "meeting") {
        set(() => ({
          step: "timeSlotConfirmed",
          confirmedTimeSlot: userOrderStatus.slot
        }), void 0, {
          type: "initTimeSlotConfirmed",
          slot: userOrderStatus.slot
        });
        return;
      }
      if (userOrderStatus.state === "new") {
        try {
          set(() => ({
            step: "loading"
          }), void 0, {
            type: "educationGoalsLoading"
          });
          const {
            goals: educationGoals
          } = await getEducationGoals();
          set(() => ({
            educationGoals
          }), void 0, {
            type: "setEducationGoals",
            educationGoals
          });
        } catch (error) {
          get().setError({
            type: "educationGoalRequestError",
            originalError: error
          });
          return;
        }
        set(() => ({
          step: "educationGoal"
        }), void 0, {
          type: "initNew"
        });
        return;
      }
      if (userOrderStatus.state === "studying") {
        if (window.self !== window.top) {
          sendMessage(REDIRECT_TO_APP_MESSAGE);
        } else {
          window.location.href = (0,site_utils/* getAppPath */.bY)();
        }
        return;
      }
    } catch (error) {
      get().setError({
        type: "initError",
        originalError: error
      });
    }
  },
  next: async () => {
    const currentStep = get().step;
    const nextStep = getNextStep(currentStep);
    if (nextStep === "timeSlot" && get().timeSlot.date === null) {
      try {
        set(() => ({
          step: "loading"
        }), void 0, {
          type: "curatorSlotsLoading"
        });
        const curatorSlots = await getCuratorSlots();
        if (curatorSlots.length === 0) {
          get().setError({
            type: "curatorSlotsNotAvailable",
            error: "CuratorRequestPage.curatorSlotsNotAvailable"
          });
          return;
        }
        const selectedtimeSlot = curatorSlots[0];
        set(() => ({
          timeSlot: {
            date: selectedtimeSlot,
            isOccupied: false
          },
          curatorSlots
        }), void 0, {
          type: "setCuratorSlots",
          selectedtimeSlot,
          curatorSlots
        });
      } catch (error) {
        get().setError({
          type: "curatorSlotRequestError",
          originalError: error
        });
        return;
      }
    }
    set(() => ({
      step: nextStep
    }), void 0, {
      type: "next",
      step: nextStep
    });
  },
  prev: () => {
    const currentStep = get().step;
    const prevStep = getPrevStep(currentStep);
    set(() => ({
      step: prevStep
    }), void 0, {
      type: "prev",
      step: prevStep
    });
  },
  send: async () => {
    const personalData = get().personalData;
    const errors = validatePersonalData(personalData);
    if (Object.keys(errors).length) {
      set(() => ({
        personalData: {
          ...get().personalData,
          validation: errors
        }
      }), void 0, {
        type: "personalDataValidationError",
        errors
      });
      return;
    }
    const {
      timeSlot: {
        date: timeSlotDate
      },
      selectedEducationGoals,
      personalData: {
        name,
        email,
        phone,
        meetingLinkTarget,
        promocode,
        subscriptionAgreement,
        legalEntity
      }
    } = get();
    if (!timeSlotDate) {
      set(() => ({
        step: "timeSlot"
      }), void 0, {
        type: "timeSlotNotDefined"
      });
      return;
    }
    const sendData = {
      slot: timeSlotDate.toISOString(),
      contact_name: name.trim(),
      contact_email: email.trim(),
      contact_phone: phone.trim(),
      forms_id: "english_landing_curator",
      meeting_link_target: meetingLinkTarget,
      promo_code: promocode.trim(),
      email_agreement: subscriptionAgreement,
      legal_entity: legalEntity,
      education_goals: selectedEducationGoals
    };
    set(() => ({
      step: "loading"
    }), void 0, {
      type: "sending",
      payload: sendData
    });
    try {
      const curatorSlot = await bookCuratorSlot(sendData);
      if (curatorSlot.state === "meeting") {
        set(() => ({
          step: "timeSlotConfirmed",
          confirmedTimeSlot: curatorSlot.slot
        }), void 0, {
          type: "timeSlotConfirmed",
          slot: curatorSlot.slot
        });
        sendMessage(SEND_FORM_SUCCESSFUL_MESSAGE);
        return;
      }
      get().setError({
        type: "timeSlotConfirmedBackendError",
        originalError: curatorSlot
      });
    } catch (error) {
      if (error instanceof TimConnectUnavailable) {
        get().setError({
          type: "timeSlotConfirmedRequestError",
          originalError: error
        });
      }
      if (error instanceof SlotIsAlreadyBooked) {
        set(() => ({
          step: "timeSlot",
          timeSlot: {
            date: get().timeSlot.date,
            isOccupied: true
          }
        }), void 0, {
          type: "timeSlotConfirmed_TimeSlotOccupied"
        });
      }
      if (error instanceof AddMeetingError) {
        get().setError({
          type: "timeSlotConfirmedRequestError",
          originalError: error
        });
      }
      if (error === api_model/* unexpectedError */.g) {
        get().setError({
          type: "timeSlotConfirmedRequestError"
        });
      }
    }
  },
  selectEducationGoals: educationGoals => set(() => ({
    selectedEducationGoals: educationGoals
  }), void 0, {
    type: "selectEducationGoals",
    educationGoals
  }),
  setTimeSlot: date => set(() => ({
    timeSlot: {
      date,
      isOccupied: false
    }
  }), void 0, {
    type: "setTimeSlot",
    date
  }),
  setPersonalData: (key, value) => {
    const validation = {
      ...get().personalData.validation
    };
    delete validation[key];
    set(() => ({
      personalData: {
        ...get().personalData,
        [key]: value,
        validation
      }
    }), void 0, {
      type: "setPersonalData",
      payload: {
        key,
        value
      }
    });
  },
  setError: _ref => {
    let {
      type = "error",
      error = "CuratorRequestPage.unknownError",
      originalError
    } = _ref;
    return set(() => ({
      step: "error",
      error
    }), void 0, {
      type,
      error: String(originalError)
    });
  }
}), {
  store: "CuratorRequestLandingFormStore"
}));
const validatePersonalData = personalData => {
  const errors = {};
  if (!personalData.name) {
    errors.name = "CuratorRequestPage.personalData.name.required";
  }
  if (!personalData.phone) {
    errors.phone = "CuratorRequestPage.personalData.phone.required";
  } else if (personalData.phone.length < MIN_PHONE_LENGHT) {
    errors.phone = "CuratorRequestPage.personalData.phone.invalid";
  }
  if (!personalData.email) {
    errors.email = "CuratorRequestPage.personalData.email.required";
  } else if (!isEmailValid(personalData.email)) {
    errors.email = "CuratorRequestPage.personalData.email.invalid";
  }
  if (!personalData.personalDataAgreement) {
    errors.personalDataAgreement = "error";
  }
  return errors;
};
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/curator-request.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const curator_request_module = ({"layout":"curator-request-module__layout--gAM6q","banner":"curator-request-module__banner--wzgyX","content":"curator-request-module__content--BqVy2","step":"curator-request-module__step--BsFd0","step-header":"curator-request-module__step-header--K_61o","stepHeader":"curator-request-module__step-header--K_61o","step-description":"curator-request-module__step-description--pN6hl","stepDescription":"curator-request-module__step-description--pN6hl","step-counter":"curator-request-module__step-counter--PMFsJ","stepCounter":"curator-request-module__step-counter--PMFsJ","step-content":"curator-request-module__step-content--p5hvn","stepContent":"curator-request-module__step-content--p5hvn","action-footer":"curator-request-module__action-footer--ibNPs","actionFooter":"curator-request-module__action-footer--ibNPs","action-button":"curator-request-module__action-button--s91Jy","actionButton":"curator-request-module__action-button--s91Jy","action-primary":"curator-request-module__action-primary--QhiZM","actionPrimary":"curator-request-module__action-primary--QhiZM","time-slot-confirmed":"curator-request-module__time-slot-confirmed--FdySB","timeSlotConfirmed":"curator-request-module__time-slot-confirmed--FdySB","education-goals":"curator-request-module__education-goals--ccwMf","educationGoals":"curator-request-module__education-goals--ccwMf","personal-data":"curator-request-module__personal-data--oV2OW","personalData":"curator-request-module__personal-data--oV2OW","form-label":"curator-request-module__form-label--_Qu70","formLabel":"curator-request-module__form-label--_Qu70","form-agreement-text":"curator-request-module__form-agreement-text--Yx34z","formAgreementText":"curator-request-module__form-agreement-text--Yx34z","form-row":"curator-request-module__form-row--fwFWU","formRow":"curator-request-module__form-row--fwFWU","form-checkbox":"curator-request-module__form-checkbox--j1ZD7","formCheckbox":"curator-request-module__form-checkbox--j1ZD7","flex-grow":"curator-request-module__flex-grow--bGw4u","flexGrow":"curator-request-module__flex-grow--bGw4u","time-slot":"curator-request-module__time-slot--bIhj3","timeSlot":"curator-request-module__time-slot--bIhj3","meeting-link-selector":"curator-request-module__meeting-link-selector--PYeTb","meetingLinkSelector":"curator-request-module__meeting-link-selector--PYeTb","slot-occupied-error":"curator-request-module__slot-occupied-error--lkZSE","slotOccupiedError":"curator-request-module__slot-occupied-error--lkZSE"});
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/components/education-goals.tsx














const CuratorRequestEducationGoals = () => {
  const educationGoals = useCuratorRequestStore(state => state.educationGoals);
  const selectedEducationGoals = useCuratorRequestStore(state => state.selectedEducationGoals);
  const selectEducationGoals = useCuratorRequestStore(state => state.selectEducationGoals);
  const items = (0,react.useMemo)(() => educationGoals ? educationGoals.map(_ref => {
    let {
      id,
      name
    } = _ref;
    return {
      id,
      name,
      isSelected: selectedEducationGoals.some(goal => goal === id)
    };
  }) : [], [educationGoals, selectedEducationGoals]);
  const handleGoalClick = (0,react.useCallback)(e => {
    const clickedGoal = e.target.dataset.goal;
    if (!clickedGoal) {
      return;
    }
    const isRemoving = selectedEducationGoals.some(goal => goal === clickedGoal);
    selectEducationGoals(isRemoving ? selectedEducationGoals.filter(goal => goal !== clickedGoal) : [...selectedEducationGoals, clickedGoal]);
  }, [selectedEducationGoals, selectEducationGoals]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: curator_request_module.educationGoals,
    children: items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: item.isSelected ? "primary" : "secondary",
      role: "checkbox",
      "aria-checked": item.isSelected,
      "data-goal": item.id,
      onClick: handleGoalClick,
      children: item.name
    }, item.id))
  });
};
// EXTERNAL MODULE: ../ui-kit/src/checkbox/types.ts
var checkbox_types = __webpack_require__(16466);
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/components/personal-data.tsx


















const PersonalDataInput = _ref => {
  let {
    fieldKey,
    className
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const personalData = useCuratorRequestStore(state => state.personalData);
  const setPersonalData = useCuratorRequestStore(state => state.setPersonalData);
  const handleChange = (0,react.useCallback)(e => setPersonalData(fieldKey, e.target.value), [setPersonalData, fieldKey]);
  const validationKey = personalData.validation[fieldKey];
  const textConstants = validationKey ? {
    hint: {
      error: intl.formatMessage({
        id: validationKey
      })
    }
  } : void 0;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    className,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: curator_request_module.formLabel,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: `CuratorRequestPage.personalData.${fieldKey}.label`
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(input_component/* Input */.II, {
      value: personalData[fieldKey],
      theme: input_component/* InputTheme */.RK.Grey,
      placeholder: intl.formatMessage({
        id: `CuratorRequestPage.personalData.${fieldKey}.placeholder`
      }),
      onChange: handleChange,
      status: validationKey ? input_component/* InputStatus */.Xz.Error : input_component/* InputStatus */.Xz.Default,
      textConstants
    })]
  });
};
const CuratorRequestPersonalData = () => {
  const intl = (0,useIntl/* default */.Z)();
  const personalData = useCuratorRequestStore(state => state.personalData);
  const setPersonalData = useCuratorRequestStore(state => state.setPersonalData);
  const options = (0,react.useMemo)(() => [{
    title: intl.formatMessage({
      id: "CuratorRequestPage.personalData.meetingLinkTarget.whatsApp"
    }),
    value: "whatsapp",
    selected: personalData.meetingLinkTarget === "whatsapp"
  }, {
    title: intl.formatMessage({
      id: "CuratorRequestPage.personalData.meetingLinkTarget.email"
    }),
    value: "email",
    selected: personalData.meetingLinkTarget === "email"
  }], [personalData.meetingLinkTarget, intl]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: curator_request_module.personalData,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(PersonalDataInput, {
      fieldKey: "name"
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: curator_request_module.formRow,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(PersonalDataInput, {
        fieldKey: "phone",
        className: curator_request_module.flexGrow
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(PersonalDataInput, {
        fieldKey: "email",
        className: curator_request_module.flexGrow
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: curator_request_module.formRow,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
        className: curator_request_module.flexGrow,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: curator_request_module.formLabel,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "CuratorRequestPage.personalData.meetingLinkTarget.label"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(select_select/* Select */.P, {
          className: curator_request_module.meetingLinkSelector,
          options,
          theme: select_constants/* SelectTheme */.n.Grey,
          withoutBoxShadow: true,
          onChange: value => value && setPersonalData("meetingLinkTarget", value),
          trigger: /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
              className: typography_module/* default */.Z.body2,
              children: options.find(option => option.value === personalData.meetingLinkTarget)?.title
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              name: "simple-arrow-down",
              size: "small"
            })]
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(PersonalDataInput, {
        fieldKey: "promocode",
        className: curator_request_module.flexGrow
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
      className: curator_request_module.formCheckbox,
      checked: personalData.personalDataAgreement,
      onChange: value => setPersonalData("personalDataAgreement", value),
      status: personalData.validation.personalDataAgreement ? checkbox_types/* CheckboxStatus */.f.Error : checkbox_types/* CheckboxStatus */.f.Default,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: curator_request_module.formAgreementText,
        children: intl.formatMessage({
          id: "CuratorRequestPage.personalData.personalDataAgreement"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
      className: curator_request_module.formCheckbox,
      checked: personalData.subscriptionAgreement,
      onChange: value => setPersonalData("subscriptionAgreement", value),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: curator_request_module.formAgreementText,
        children: intl.formatMessage({
          id: "CuratorRequestPage.personalData.subscriptionAgreement"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(src_checkbox/* Checkbox */.X, {
      className: curator_request_module.formCheckbox,
      checked: personalData.legalEntity,
      onChange: value => setPersonalData("legalEntity", value),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: curator_request_module.formAgreementText,
        children: intl.formatMessage({
          id: "CuratorRequestPage.personalData.legalEntityCheck"
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/components/time-slot.tsx


















const getDateKey = date => (0,format/* format */.WU)(date, "dd MMMM", {
  locale: utils_locale/* dateFnsLocale */.Y
});
const CuratorRequestTimeSlot = () => {
  const intl = (0,useIntl/* default */.Z)();
  const timeSlot = useCuratorRequestStore(state => state.timeSlot);
  const setTimeSlot = useCuratorRequestStore(state => state.setTimeSlot);
  const curatorSlots = useCuratorRequestStore(state => state.curatorSlots);
  const slots = (0,react.useMemo)(() => curatorSlots.reduce((result, slot) => {
    const dateKey = getDateKey(slot);
    if (Object.hasOwn(result, dateKey)) {
      result[dateKey].push(slot);
    } else {
      result[dateKey] = [slot];
    }
    return result;
  }, {}), [curatorSlots]);
  const dateSlot = (0,react.useMemo)(() => {
    const selectedTimeSlot = timeSlot.date;
    if (selectedTimeSlot === null) {
      throw new Error("Time slot has to be defined");
    }
    const handleDateChange = id => {
      setTimeSlot(slots[id][0]);
    };
    return {
      label: intl.formatMessage({
        id: "CuratorRequestPage.timeSlot.date"
      }),
      type: "date",
      date: {
        selectedTime: {
          id: getDateKey(selectedTimeSlot),
          time: selectedTimeSlot
        },
        allTimes: Object.entries(slots).map(_ref => {
          let [text, [date]] = _ref;
          return {
            id: text,
            accentedText: text,
            text: (0,format/* format */.WU)(date, "EEEEEE", {
              locale: utils_locale/* dateFnsLocale */.Y
            })
          };
        }),
        onChange: handleDateChange
      }
    };
  }, [intl, slots, timeSlot, setTimeSlot]);
  const fullTimeSlot = (0,react.useMemo)(() => {
    const selectedTimeSlot = timeSlot.date;
    if (selectedTimeSlot === null) {
      throw new Error("Time slot has to be defined");
    }
    const times = slots[getDateKey(selectedTimeSlot)];
    const handleTimeChange = id => {
      setTimeSlot(new Date(id));
    };
    return {
      label: intl.formatMessage({
        id: "CuratorRequestPage.timeSlot.time"
      }),
      type: "fullTime",
      fullTime: {
        selectedTime: {
          id: selectedTimeSlot.toString(),
          time: selectedTimeSlot
        },
        allTimes: times.map(time => ({
          id: time.toString(),
          accentedText: (0,format/* format */.WU)(time, "HH:mm", {
            locale: utils_locale/* dateFnsLocale */.Y
          })
        })),
        onChange: handleTimeChange
      }
    };
  }, [intl, slots, timeSlot, setTimeSlot]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: curator_request_module.timeSlot,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        className: curator_request_module.flexGrow,
        timeSlot: dateSlot
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        className: curator_request_module.flexGrow,
        timeSlot: fullTimeSlot
      }), timeSlot.isOccupied && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: curator_request_module.slotOccupiedError,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "CuratorRequestPage.timeSlot.slotOccupiedError"
        })
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/components/time-slot-confirmed.tsx








const CuratorRequestTimeSlotConfirmed = () => {
  const intl = (0,useIntl/* default */.Z)();
  const confirmedTimeSlot = useCuratorRequestStore(state => state.confirmedTimeSlot);
  if (!confirmedTimeSlot) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: curator_request_module.timeSlotConfirmed,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      src: "https://flowstatic.s3.yandex.net/ui-files/curator-request-confirmed.svg",
      alt: "",
      height: "100",
      width: "100"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      className: curator_request_module.stepHeader,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "CuratorRequestPage.TimeSlotConfirmed.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: curator_request_module.stepDescription,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
        id: "CuratorRequestPage.TimeSlotConfirmed.subtitle"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: curator_request_module.timeSlot,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        className: curator_request_module.flexGrow,
        timeSlot: {
          label: intl.formatMessage({
            id: "CuratorRequestPage.timeSlot.date"
          }),
          type: "date",
          date: {
            selectedTime: {
              id: 1,
              time: confirmedTimeSlot
            },
            allTimes: [],
            onChange: function_utils/* emptyFunction */.Bi
          }
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        className: curator_request_module.flexGrow,
        timeSlot: {
          label: intl.formatMessage({
            id: "CuratorRequestPage.timeSlot.time"
          }),
          type: "fullTime",
          fullTime: {
            selectedTime: {
              id: 1,
              time: confirmedTimeSlot
            },
            allTimes: [],
            onChange: function_utils/* emptyFunction */.Bi
          }
        }
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/landing-curator-request-form/curator-request-page.tsx
















const CuratorRequestPage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const step = useCuratorRequestStore(state => state.step);
  const init = useCuratorRequestStore(state => state.init);
  const error = useCuratorRequestStore(state => state.error);
  (0,react.useEffect)(() => {
    init();
  }, [init]);
  const content = (0,react.useMemo)(() => {
    switch (step) {
      case "init":
      case "loading":
        return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenter */.Fz, {});
      case "timeSlotConfirmed":
        return /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorRequestTimeSlotConfirmed, {});
      case "error":
        return /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
          type: model_model/* AlertType */.N.WARNING,
          text: intl.formatMessage({
            id: error || "CuratorRequestPage.unknownError"
          })
        });
      default:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorRequestStep, {});
    }
  }, [error, intl, step]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorRequestLayout, {
    children: content
  });
};
const CuratorRequestStep = () => {
  const step = useCuratorRequestStore(state => state.step);
  const handlePrev = useCuratorRequestStore(state => state.prev);
  const handleNext = useCuratorRequestStore(state => state.next);
  const handleSend = useCuratorRequestStore(state => state.send);
  const stepNumber = {
    educationGoal: 1,
    timeSlot: 2,
    personalData: 3
  }[step] ?? "-";
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("article", {
    className: curator_request_module.step,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("header", {
      className: curator_request_module.stepHeader,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: `CuratorRequestPage.${step}.title`
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: curator_request_module.stepCounter,
        children: [stepNumber, "/3"]
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: curator_request_module.stepContent,
      children: [step !== "personalData" && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: curator_request_module.stepDescription,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: `CuratorRequestPage.${step}.subtitle`
        })
      }), step === "educationGoal" && /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorRequestEducationGoals, {}), step === "timeSlot" && /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorRequestTimeSlot, {}), step === "personalData" && /* @__PURE__ */(0,jsx_runtime.jsx)(CuratorRequestPersonalData, {})]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("footer", {
      className: curator_request_module.actionFooter,
      children: [step !== "educationGoal" && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "secondary",
        onClick: handlePrev,
        className: curator_request_module.actionButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "CuratorRequestPage.actions.prev"
        })
      }), step === "personalData" ? /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "primary",
        onClick: handleSend,
        className: curator_request_module.actionButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "CuratorRequestPage.actions.send"
        })
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        appearance: "primary",
        onClick: handleNext,
        className: classnames_default()(curator_request_module.actionButton, curator_request_module.actionPrimary),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "CuratorRequestPage.actions.next"
        })
      })]
    })]
  });
};
const CuratorRequestLayout = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: curator_request_module.layout,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: curator_request_module.banner,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(components_message/* default */.Z, {
          id: "CuratorRequestPage.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: curator_request_module.content,
      children
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/payment-landing/no-auth-payment-landing.component.tsx






const NoAuthPaymentLanding = () => {
  const {
    [NoAuthRoutesPaymentLandingParams.LandingId]: landingId
  } = (0,react_router/* useParams */.UO)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(PaymentLanding, {
    landingId
  });
};
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-promo-trainer-machine.ts













const create_promo_trainer_machine_services = {
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: create_trainer_machine/* services */.uZ[trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER],
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: async context => {
    if (context.chapterId === void 0) {
      throw new Error("Wrond chapter id");
    }
    const data = await (0,bunker_api/* getPromoTrainerData */.J1)(context.chapterId);
    if ((0,Either.isRight)(data)) {
      return {
        chapterData: data.right,
        userData: []
      };
    }
    throw new Error("Can't get chapter data");
  }
};
const create_promo_trainer_machine_ANSWER_EVENT = "__internal_promo_result";
const create_promo_trainer_machine_updateStudentEvent = (0,trainer_actions/* getStudentEventUpdater */.VL)(create_promo_trainer_machine_ANSWER_EVENT);
const create_promo_trainer_machine_guards = {
  ...create_trainer_machine/* guards */.l8,
  [trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsNextActivityEmptyAfterFilterGuard */.b2)(create_promo_trainer_machine_ANSWER_EVENT),
  [trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER]: (0,create_trainer_machine/* getIsAllNextActivitiesEmptyAfterFilterGuard */.NZ)(create_promo_trainer_machine_ANSWER_EVENT)
};
const create_promo_trainer_machine_baseTrainerActions = create_trainer_machine/* actions */.Nw;
const create_promo_trainer_machine_actions = {
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getBlockFilterAction */.XI)(create_promo_trainer_machine_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,xstate_es/* assign */.f0)((context, event) => ({
    activities: event.data.chapterData,
    chapterStudentEvents: {},
    activityIndex: 0,
    blockIndex: 0
  })),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: create_promo_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
  [trainer_machine_consts/* ACTIONS */.aO.PUSH_CHAPTER_ANSWER]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getChapterAnswerPusher */.hf)(create_promo_trainer_machine_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: create_promo_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: create_promo_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.RESET_TRAINER]: (0,xstate_es/* assign */.f0)({
    activityIndex: 0,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX_TIL_NOT_EMPTY]: (0,xstate_es/* assign */.f0)((0,create_trainer_machine/* getIncrementActivityIndexTilNotEmptyAssignment */.OQ)(create_promo_trainer_machine_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX]: create_promo_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_ACTIVITY_INDEX]: create_promo_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.DECREMENT_ACTIVITY_INDEX],
  [trainer_machine_consts/* ACTIONS */.aO.SET_CURRENT_LAST_BLOCK_IN_ACTIVITY]: create_promo_trainer_machine_baseTrainerActions[trainer_machine_consts/* ACTIONS */.aO.SET_CURRENT_LAST_BLOCK_IN_ACTIVITY],
  [trainer_machine_consts/* ACTIONS */.aO.SEND_FINAL_EVENT_IF_NEED]: (context, event) => {
    if (context.isFinalEventExist) {
      return {};
    }
    const guardMeta = {};
    if ( /* eslint-disable @typescript-eslint/no-explicit-any */
    create_promo_trainer_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_ACTIVITY_AND_BLOCK](context, event, guardMeta) || create_promo_trainer_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_BLOCK](context, event, guardMeta) && create_promo_trainer_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER](context, event, guardMeta) && create_promo_trainer_machine_guards[trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER](context, event, guardMeta)) {
      (0,yandexMetrica/* ymGoal */.qf)("Promo_Trainer_End");
      return {
        isFinalEventExist: true
      };
    }
    return {};
  }
};
const promoTrainerMachine = (0,Machine/* createMachine */.C)({
  id: "promo-trainer",
  initial: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA,
  states: {
    [trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER,
        onDone: [{
          actions: [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE, trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS, trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS],
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }],
        onError: trainer_machine_consts/* STATES */.PO.ERROR
      }
    },
    [trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS]: {
      on: {
        [product_trainer_machine/* EVENTS */.FP.REPEAT_REVISION]: {
          target: trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA
        }
      },
      entry: trainer_machine_consts/* ACTIONS */.aO.SEND_FINAL_EVENT_IF_NEED
    },
    [trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS]: {
      on: {
        "": {
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }
      }
    },
    [trainer_machine_consts/* STATES */.PO.SAVING_ANSWER]: {
      on: {
        "": {
          target: trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS
        }
      }
    },
    [trainer_machine_consts/* STATES */.PO.ERROR]: {}
  },
  on: {
    [product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.PREV_BLOCK_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.NEXT_ACTIVITY_CLICKED],
    [product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER]: trainerEventsConfig[product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER],
    [product_trainer_machine/* EVENTS */.FP.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate_es/* assign */.f0)({
        activityIndex: trainer_actions/* getPrevNotEmptyActivityIndex */.HZ
      }), (0,xstate_es/* assign */.f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate_es/* assign */.f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), create_promo_trainer_machine_actions[trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]],
      target: trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS
    },
    [product_trainer_machine/* EVENTS */.FP.RESET_ANSWER]: {
      actions: [(0,xstate_es/* assign */.f0)({
        chapterStudentEvents: create_promo_trainer_machine_updateStudentEvent,
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })],
      target: trainer_machine_consts/* STATES */.PO.SAVING_ANSWER
    }
  }
});
const getPromoTrainerMachine = (chapterId, intl) => promoTrainerMachine.withConfig({
  actions: create_promo_trainer_machine_actions,
  services: create_promo_trainer_machine_services,
  guards: create_promo_trainer_machine_guards
}).withContext({
  mechanicMachineCreator: create_trainer_mechanic_machine/* createTrainerMechanicMachine */.qN,
  chapterStudentEvents: {},
  chapterId,
  currentBlocks: [],
  activities: [],
  progress: 0,
  blockIndex: 0,
  activityIndex: 0,
  scrollToBlockIndex: 0,
  filterCurrentActivityBlocks: (0,create_trainer_machine/* getFilterBlocksByConditions */.ek)("trainer_result"),
  intl
});
;// CONCATENATED MODULE: ./src/pages/promo-trainer/promo-trainer.page.tsx
























const PROMO_TRAINER_CHAPTER_ID_PARAM = "promo_trainer_chapter_id_param";
const REVISION_ANSWER_EVENT = "__internal_promo_result";
const PromoTrainer = () => /* @__PURE__ */(0,jsx_runtime.jsx)(PromoTrainerContent, {});
const PromoTrainerContent = () => {
  const params = (0,react_router/* useParams */.UO)();
  const chapterId = params[PROMO_TRAINER_CHAPTER_ID_PARAM];
  const intl = (0,useIntl/* default */.Z)();
  const stateMachine = (0,react.useMemo)(() => getPromoTrainerMachine(chapterId, intl), [intl, chapterId]);
  const history = (0,react_router/* useHistory */.k6)();
  const [state, send] = (0,useMachine/* useMachine */.e)(stateMachine);
  const {
    activities,
    activityIndex,
    currentBlocks: condBlocks
  } = state.context;
  const currentActivity = (0,react.useMemo)(() => {
    if (activities && activities[activityIndex]) {
      return activities[activityIndex];
    }
  }, [activities, activityIndex]);
  (0,react.useEffect)(() => {
    if (activities) {
      (0,preload_images_activity/* preloadImagesForActivities */.b)(activities);
    }
  }, [activities]);
  const onSubmitAnswer = (0,react.useCallback)(_ref => {
    let {
      answer,
      correct,
      typo,
      blockId
    } = _ref;
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth"
    });
    return send(product_trainer_machine/* EVENTS */.FP.SUBMIT_ANSWER, {
      data: {
        answer,
        blockId,
        // eslint-disable-next-line camelcase
        activityId: currentActivity?.activity_id,
        courseId: state.context.chapterInfo?.courseId,
        levelId: state.context.chapterInfo?.levelId,
        topicId: state.context.chapterInfo?.topicId,
        correct,
        typo
      }
    });
  },
  // eslint-disable-next-line camelcase
  [currentActivity, send, state.context.chapterInfo]);
  const getBlockAnswerInfo = (0,react.useCallback)(blockId => {
    const blockEvents = state.context.chapterStudentEvents[blockId];
    const answerEvent = blockEvents?.filter(e => e.event_type === REVISION_ANSWER_EVENT) ?? [];
    const answerJSONString = answerEvent[answerEvent.length - 1]?.data?.answer ?? "{}";
    const correct = answerEvent[answerEvent.length - 1]?.data?.correct ?? false;
    return {
      correct,
      answer: JSON.parse(answerJSONString)
    };
  }, [state.context.chapterStudentEvents]);
  const handleOutroActions = (0,react.useCallback)(a => {
    switch (a.type) {
      case "NEXT_BLOCK":
        return send(product_trainer_machine/* EVENTS */.FP.NEXT_BLOCK_CLICKED);
      case "ON_MAIN_PAGE":
        return history.push(studentRoutePaths/* studentRoutePaths */.dR.INDEX);
      case "PROMO_LANDING":
        return window.open((0,site_utils/* getPublicPathRoot */.Cq)(), "_self");
      default:
        break;
    }
  }, [history, send]);
  const handleCloseTrainer = () => {
    window.open((0,site_utils/* getPublicPathRoot */.Cq)(), "_self");
  };
  const {
    handleResetAnswer,
    handleNextBlockClick,
    handlePrevActivityClick,
    handlePrevBlockClick
  } = (0,useTrainerHandlers/* useTrainerHandlers */.a)(send);
  switch (state.value) {
    case trainer_machine_consts/* STATES */.PO.ERROR:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        children: "error"
      });
    case trainer_machine_consts/* STATES */.PO.LOADING_CHAPTER_DATA:
      return null;
    case trainer_machine_consts/* STATES */.PO.SAVING_ANSWER:
    case trainer_machine_consts/* STATES */.PO.CHAPTER_IN_PROGRESS:
    case trainer_machine_consts/* STATES */.PO.SAVING_PROGRESS:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(layout_component/* Layout */.A, {
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)(trainer_layout_component/* TrainerLayout */.x, {
          oneElementPerScreen: currentActivity?.type === "lexis",
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(close_trainer_button_component/* CloseTrainerButton */.i, {
            onClick: handleCloseTrainer
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(block_renderer/* BlocksRender */.g, {
            onResetAnswer: blockId => {
              const currentActivityId = currentActivity?.activity_id;
              if (currentActivityId) {
                handleResetAnswer(blockId, currentActivityId);
              }
            },
            onPrevActivityClick: handlePrevActivityClick,
            blocks: condBlocks,
            activityType: currentActivity?.type ?? "story",
            onSubmitAnswer,
            currentActivityIndex: state.context.activityIndex,
            blockIndex: state.context.blockIndex,
            onNextBlockClick: handleNextBlockClick,
            onPrevBlockClick: handlePrevBlockClick,
            mechanicMachineCreator: state.context.mechanicMachineCreator,
            getBlockAnswerInfo,
            onOutroActionTrigger: handleOutroActions,
            showPrevButton: true,
            showNextButton: true,
            showSkipButton: false,
            showResetButton: true,
            showSubmitButton: true,
            showAudioFooter: true,
            userEnvironment: types/* UserEnvironment */.P.Student,
            isLastActivity: (0,activity/* isLastActivity */.e)(activityIndex, activities)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(ProgressBar, {
            progress: state.context.progress
          })]
        })
      });
    default:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(UnknownStateErrorSender, {
        place: "promo-trainer.page",
        state: state.value
      });
  }
};
;// CONCATENATED MODULE: ./src/utils/translations/with-translations.tsx




function withTranslations(Component) {
  return function WithTranslations(props) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(TranslationsProvider, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Component, {
        ...props
      })
    });
  };
}
;// CONCATENATED MODULE: ./src/app/routes/noauth.routes.config.ts








const noAuthRoutes = [{
  path: [noAuthRoutePath.PAYMENT_LANDING(`:${NoAuthRoutesPaymentLandingParams.LandingId}`)],
  component: withTranslations(NoAuthPaymentLanding),
  exact: true
}, {
  path: noAuthRoutePath.CUST_DEV_TRAINER(`:${NoAuthRoutesCustDevParams.LevelId}`, `:${NoAuthRoutesCustDevParams.ChapterId}`),
  component: withTranslations(CustDevTrainerPage),
  exact: true
}, {
  path: noAuthRoutePath.PROMO_TRAINER(`:${PROMO_TRAINER_CHAPTER_ID_PARAM}`),
  exact: true,
  component: withTranslations(PromoTrainer)
}, {
  path: noAuthRoutePath.LANDING_CURATOR_REQUEST_FORM,
  exact: true,
  component: withTranslations(CuratorRequestPage)
}];
;// CONCATENATED MODULE: ./src/index.tsx


























initPolyfills();
const src_queryClient = new queryClient/* QueryClient */.S({
  defaultOptions: {
    queries: {
      retry: false
    }
  }
});
const InitialComponent = () => {
  const baseName = (0,react.useMemo)(() => (0,site_utils/* getAppPath */.bY)(), []);
  (0,react.useEffect)(() => logger/* Logger */.Yd.setPage(window.location.href), []);
  (0,react.useEffect)(() => {
    if (baseName.startsWith("/flow") && window.location.hostname === "practicum.yandex.ru") {
      window.location.href = window.location.href.replace("/flow", "/english");
    }
  }, [baseName]);
  (0,react.useEffect)(() => {
    const handleClick = event => {
      const target = event.target;
      if (checkHTMLBaseElement(target) && target.tagName.toLowerCase() === "a" && target.href.includes(".ru")) {
        logger/* Logger */.Yd.captureWarning("[Replace url click]", {
          url: target.href
        });
      }
    };
    if ((0,domain/* isKzDomain */.k)()) {
      document.addEventListener("click", handleClick, {
        capture: true
      });
    }
    return () => document.removeEventListener("click", handleClick, {
      capture: true
    });
  }, []);
  const initialFetchFunctions = (0,react.useMemo)(() => [() => (0,domain_urls/* fetchExternalUrls */.ld)(bunker_urls/* GET_EXTERNAL_URLS */.b_), () => (0,features/* fetchFeatures */.nz)(bunker_urls/* GET_FEATURE_FLAGS */.DR)], []);
  const initialFetchSuspense = (0,react.useCallback)(() => /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {}), []);
  const handleLocationChange = (0,react.useCallback)(location => {
    (0,yandexMetrica/* ymHit */.x9)(location.toString());
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(GlobalErrorBoundary, {
    rootHref: baseName || "/",
    errorScreenContent: contentNodesRussianWithLink,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(FetchWrapper, {
      functions: initialFetchFunctions,
      suspense: initialFetchSuspense,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
        client: src_queryClient,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router_dom/* BrowserRouter */.VK, {
          basename: baseName,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(LocationChangeProcessor, {
            onChange: handleLocationChange
          }), /* @__PURE__ */(0,jsx_runtime.jsxs)(react_router/* Switch */.rs, {
            children: [noAuthRoutes.map(route => /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
              ...route
            }, route.path.toString())), /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Route */.AW, {
              component: App
            })]
          })]
        })
      })
    })
  });
};
const root = document.getElementById("root");
if (root) {
  (0,client/* createRoot */.s)(root).render( /* @__PURE__ */(0,jsx_runtime.jsx)(InitialComponent, {}));
} else {
  console.error("Root element not found");
}
function checkHTMLBaseElement(target) {
  return typeof target === "object" && target !== null && "tagName" in target && "href" in target;
}

/***/ }),

/***/ 71562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CZ: () => (/* binding */ SyllabusMotherTaskState),
/* harmony export */   Df: () => (/* binding */ getNewTaskState),
/* harmony export */   Gg: () => (/* binding */ SYLLABUS_A),
/* harmony export */   Jx: () => (/* binding */ getNewMotherTaskEvent),
/* harmony export */   Sx: () => (/* binding */ SyllabusNodeFSMEvent),
/* harmony export */   YE: () => (/* binding */ SyllabusTaskState),
/* harmony export */   bN: () => (/* binding */ getNextSyllabusTaskEvent),
/* harmony export */   ey: () => (/* binding */ getNextMotherTaskEventWithState),
/* harmony export */   ez: () => (/* binding */ getNewMotherTaskState),
/* harmony export */   p7: () => (/* binding */ SyllabusTaskStatus),
/* harmony export */   vG: () => (/* binding */ SyllabusTaskType),
/* harmony export */   vg: () => (/* binding */ SyllabusModuleNodeFSMState),
/* harmony export */   wU: () => (/* binding */ SyllabusMotherTaskType)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_every_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83511);
/* harmony import */ var core_js_modules_esnext_async_iterator_every_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_every_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80988);
/* harmony import */ var core_js_modules_esnext_iterator_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _yandex_langly_shared_src_errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79106);






const SYLLABUS_A = "6abadb67-077c-4343-9c56-b4e4b682b5f1";
var SyllabusTaskType = /* @__PURE__ */(SyllabusTaskType2 => {
  SyllabusTaskType2["Speaking"] = "tasks";
  SyllabusTaskType2["InClass"] = "inClass";
  SyllabusTaskType2["SelfStudy"] = "selfStudy";
  SyllabusTaskType2["Unknown"] = "unknown";
  return SyllabusTaskType2;
})(SyllabusTaskType || {});
var SyllabusTaskState = /* @__PURE__ */(SyllabusTaskState2 => {
  SyllabusTaskState2["Initial"] = "initial";
  SyllabusTaskState2["NotAvailable"] = "notAvailable";
  SyllabusTaskState2["InProgress"] = "inProgress";
  SyllabusTaskState2["Done"] = "done";
  SyllabusTaskState2["NotAdded"] = "notAdded";
  SyllabusTaskState2["Added"] = "added";
  SyllabusTaskState2["AddedAgain"] = "addedAgain";
  SyllabusTaskState2["DoneWithProgress"] = "doneWithProgress";
  SyllabusTaskState2["Unknown"] = "unknown";
  return SyllabusTaskState2;
})(SyllabusTaskState || {});
var SyllabusMotherTaskState = /* @__PURE__ */(SyllabusMotherTaskState2 => {
  SyllabusMotherTaskState2["Initial"] = "initial";
  SyllabusMotherTaskState2["InProgress"] = "inProgress";
  SyllabusMotherTaskState2["InLesson"] = "inLesson";
  SyllabusMotherTaskState2["Skipped"] = "skipped";
  SyllabusMotherTaskState2["Done"] = "done";
  SyllabusMotherTaskState2["Disabled"] = "disabled";
  SyllabusMotherTaskState2["Unknown"] = "unknown";
  return SyllabusMotherTaskState2;
})(SyllabusMotherTaskState || {});
var SyllabusMotherTaskType = /* @__PURE__ */(SyllabusMotherTaskType2 => {
  SyllabusMotherTaskType2["Default"] = "default";
  SyllabusMotherTaskType2["Milestone"] = "milestone";
  SyllabusMotherTaskType2["Foreigner"] = "foreigner";
  return SyllabusMotherTaskType2;
})(SyllabusMotherTaskType || {});
var SyllabusTaskStatus = /* @__PURE__ */(SyllabusTaskStatus2 => {
  SyllabusTaskStatus2["Active"] = "active";
  SyllabusTaskStatus2["Archived"] = "archived";
  SyllabusTaskStatus2["Deleted"] = "deleted";
  SyllabusTaskStatus2["Unknown"] = "unknown";
  return SyllabusTaskStatus2;
})(SyllabusTaskStatus || {});
var SyllabusNodeFSMEvent = /* @__PURE__ */(SyllabusNodeFSMEvent2 => {
  SyllabusNodeFSMEvent2["Close"] = "close";
  SyllabusNodeFSMEvent2["Finish"] = "finish";
  SyllabusNodeFSMEvent2["Open"] = "open";
  SyllabusNodeFSMEvent2["Progress"] = "progress";
  SyllabusNodeFSMEvent2["Skip"] = "skip";
  SyllabusNodeFSMEvent2["UnSkip"] = "unskip";
  SyllabusNodeFSMEvent2["Assign"] = "assign";
  SyllabusNodeFSMEvent2["Remove"] = "remove";
  SyllabusNodeFSMEvent2["AddInLesson"] = "addInLesson";
  SyllabusNodeFSMEvent2["Reset"] = "reset";
  SyllabusNodeFSMEvent2["RemoveFromLesson"] = "removeFromLesson";
  SyllabusNodeFSMEvent2["Unknown"] = "unknown";
  return SyllabusNodeFSMEvent2;
})(SyllabusNodeFSMEvent || {});
var SyllabusModuleNodeFSMState = /* @__PURE__ */(SyllabusModuleNodeFSMState2 => {
  SyllabusModuleNodeFSMState2["NoteAvailable"] = "notAvailable";
  SyllabusModuleNodeFSMState2["Available"] = "available";
  SyllabusModuleNodeFSMState2["InProgress"] = "inProgress";
  SyllabusModuleNodeFSMState2["Finished"] = "finished";
  return SyllabusModuleNodeFSMState2;
})(SyllabusModuleNodeFSMState || {});
const getNextSelfStudyEvent = task => {
  switch (task.state) {
    case "notAdded" /* NotAdded */:
      return "assign" /* Assign */;
    case "added" /* Added */:
      return "remove" /* Remove */;
    default:
      return "unknown" /* Unknown */;
  }
};
const getNextInLessonTaskEvent = task => {
  switch (task.state) {
    case "initial" /* Initial */:
      return "progress" /* Progress */;
    case "inProgress" /* InProgress */:
      return "finish" /* Finish */;
    case "done" /* Done */:
      return "reset" /* Reset */;
    default:
      return "unknown" /* Unknown */;
  }
};
const getNextSyllabusTaskEvent = params => {
  const {
    taskId,
    tasks
  } = params;
  const task = tasks[taskId];
  const type = task.type;
  switch (type) {
    case "tasks" /* Speaking */:
    case "inClass" /* InClass */:
      return getNextInLessonTaskEvent(task);
    case "selfStudy" /* SelfStudy */:
      return getNextSelfStudyEvent(task);
    default:
      throw new _yandex_langly_shared_src_errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_3__/* .UnhandledCaseError */ .H(type);
  }
};
const getFSM = (task, fsm) => {
  const type = task.type;
  switch (type) {
    case "inClass" /* InClass */:
      return fsm.inClassTask;
    case "selfStudy" /* SelfStudy */:
      return fsm.selfStudyTask;
    case "tasks" /* Speaking */:
      return fsm.speakingTask;
    default:
      throw new _yandex_langly_shared_src_errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_3__/* .UnhandledCaseError */ .H(type);
  }
};
const getNewState = (prevState, event, fsm) => {
  const transition = fsm.get(event);
  if (!transition) {
    return prevState;
  }
  const newState = transition.get(prevState);
  if (!newState) {
    return prevState;
  }
  return newState;
};
const getNewTaskState = params => {
  const {
    taskId,
    tasks,
    syllabusFsm,
    event
  } = params;
  const task = tasks[taskId];
  const fsm = getFSM(task, syllabusFsm);
  return getNewState(task.state, event, fsm);
};
const getNewMotherTaskState = params => {
  const {
    motherTasks,
    motherTaskId,
    syllabusFsm,
    event
  } = params;
  const task = motherTasks[motherTaskId];
  const fsm = syllabusFsm.motherTask;
  return getNewState(task.state, event, fsm);
};
const getNewMotherTaskEvent = _ref => {
  let {
    motherTaskId,
    motherTaskRecord,
    tasksRecord,
    taskId,
    newTaskState
  } = _ref;
  const currentTask = tasksRecord[taskId];
  const motherTask = motherTaskRecord[motherTaskId];
  if (newTaskState === "initial" /* Initial */ && currentTask.type === "tasks" /* Speaking */) {
    return "reset" /* Reset */;
  }
  if (newTaskState === "inProgress" /* InProgress */) {
    return "progress" /* Progress */;
  }
  if (newTaskState === "done" /* Done */) {
    const getFinishIfEveryTaskDoneExceptCurrent = tasks => tasks.every(_ref2 => {
      let {
        id
      } = _ref2;
      return currentTask.id === id || tasksRecord[id].state === "done";
    } /* Done */) ? "finish" /* Finish */ : null;
    if (currentTask.type === "tasks" /* Speaking */) {
      return getFinishIfEveryTaskDoneExceptCurrent(motherTask.speakingTasks);
    }
    if (!motherTask.speakingTasks.length && currentTask.type === "inClass" /* InClass */) {
      return getFinishIfEveryTaskDoneExceptCurrent(motherTask.inClassTasks);
    }
  }
  return null;
};
const getNextMotherTaskEventWithState = motherTaskState => {
  switch (motherTaskState) {
    case "inLesson" /* InLesson */:
      return "removeFromLesson" /* RemoveFromLesson */;
    case "initial" /* Initial */:
      return "addInLesson" /* AddInLesson */;
    default:
      return "unknown" /* Unknown */;
  }
};

/***/ }),

/***/ 63054:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D8: () => (/* binding */ StartingSessionError),
/* harmony export */   N4: () => (/* binding */ getNextTaskGuideState),
/* harmony export */   ld: () => (/* binding */ TaskGuideFSMState),
/* harmony export */   lt: () => (/* binding */ TaskGuideFSMEvent)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_16__);



















var TaskGuideFSMEvent = /* @__PURE__ */(TaskGuideFSMEvent2 => {
  TaskGuideFSMEvent2["Start"] = "start";
  TaskGuideFSMEvent2["Finish"] = "finish";
  TaskGuideFSMEvent2["Close"] = "close";
  TaskGuideFSMEvent2["Cancel"] = "cancel";
  TaskGuideFSMEvent2["Return"] = "return";
  TaskGuideFSMEvent2["CannotStartSession"] = "cannotStartSession";
  TaskGuideFSMEvent2["ToInitial"] = "toInitial";
  return TaskGuideFSMEvent2;
})(TaskGuideFSMEvent || {});
var TaskGuideFSMState = /* @__PURE__ */(TaskGuideFSMState2 => {
  TaskGuideFSMState2["Initial"] = "initial";
  TaskGuideFSMState2["ReminderStartingLessonState"] = "reminderStartingLessonState";
  TaskGuideFSMState2["Started"] = "started";
  TaskGuideFSMState2["StartingSessionState"] = "startingSessionState";
  TaskGuideFSMState2["SelectingSessionState"] = "selectingSessionState";
  TaskGuideFSMState2["SelectingSelfStudy"] = "selectingSelfStudy";
  TaskGuideFSMState2["CannotStartSession"] = "cannotStartSession";
  return TaskGuideFSMState2;
})(TaskGuideFSMState || {});
var StartingSessionError = /* @__PURE__ */(StartingSessionError2 => {
  StartingSessionError2["SessionCancelled"] = "sessionCancelled";
  StartingSessionError2["SessionRescheduled"] = "sessionRescheduled";
  return StartingSessionError2;
})(StartingSessionError || {});
const TASK_GUIDE_FSM_SOURCE = {
  ["start" /* Start */]: {
    ["initial" /* Initial */]: "startingSessionState" /* StartingSessionState */,
    ["startingSessionState" /* StartingSessionState */]: "started" /* Started */,
    ["selectingSessionState" /* SelectingSessionState */]: "started" /* Started */,
    ["reminderStartingLessonState" /* ReminderStartingLessonState */]: "started" /* Started */
  },
  ["finish" /* Finish */]: {
    ["started" /* Started */]: "selectingSessionState" /* SelectingSessionState */,
    ["selectingSessionState" /* SelectingSessionState */]: "selectingSelfStudy" /* SelectingSelfStudy */,
    ["selectingSelfStudy" /* SelectingSelfStudy */]: "initial" /* Initial */
  },
  ["close" /* Close */]: {
    ["startingSessionState" /* StartingSessionState */]: "initial" /* Initial */,
    ["cannotStartSession" /* CannotStartSession */]: "initial" /* Initial */
  },
  ["cancel" /* Cancel */]: {
    ["selectingSessionState" /* SelectingSessionState */]: "initial" /* Initial */
  },
  ["return" /* Return */]: {
    ["selectingSessionState" /* SelectingSessionState */]: "started" /* Started */,
    ["selectingSelfStudy" /* SelectingSelfStudy */]: "started" /* Started */
  },
  ["cannotStartSession" /* CannotStartSession */]: {
    ["startingSessionState" /* StartingSessionState */]: "cannotStartSession" /* CannotStartSession */,
    ["reminderStartingLessonState" /* ReminderStartingLessonState */]: "cannotStartSession" /* CannotStartSession */,
    ["initial" /* Initial */]: "cannotStartSession" /* CannotStartSession */
  },
  ["toInitial" /* ToInitial */]: {
    ["initial" /* Initial */]: "initial" /* Initial */,
    ["reminderStartingLessonState" /* ReminderStartingLessonState */]: "reminderStartingLessonState" /* ReminderStartingLessonState */,
    ["started" /* Started */]: "initial" /* Initial */,
    ["startingSessionState" /* StartingSessionState */]: "initial" /* Initial */,
    ["selectingSessionState" /* SelectingSessionState */]: "initial" /* Initial */,
    ["selectingSelfStudy" /* SelectingSelfStudy */]: "initial" /* Initial */,
    ["cannotStartSession" /* CannotStartSession */]: "cannotStartSession" /* CannotStartSession */
  }
};
const TASK_GUIDE_FSM = Object.entries(TASK_GUIDE_FSM_SOURCE).reduce((acc, _ref) => {
  let [event, states] = _ref;
  acc.set(event, new Map(Object.entries(states)));
  return acc;
}, /* @__PURE__ */new Map());
const getNextTaskGuideState = (prevState, event) => {
  const transition = TASK_GUIDE_FSM.get(event);
  if (!transition) {
    return prevState;
  }
  const newState = transition.get(prevState);
  if (!newState) {
    return prevState;
  }
  return newState;
};

/***/ }),

/***/ 3874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  autoOnboardingAnalyticEvents: () => (/* reexport */ autoOnboardingAnalyticEvents),
  "default": () => (/* reexport */ AutoOnboardingPage),
  useAvailableAutoOnboarding: () => (/* reexport */ useAvailableAutoOnboarding)
});

// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../shared/src/entities/features.ts
var features = __webpack_require__(45404);
// EXTERNAL MODULE: ../shared/src/entities/onboarding/model/onboarding.ts
var onboarding = __webpack_require__(79246);
// EXTERNAL MODULE: ./src/pages/resources/hooks/use-resources-zero-balance.ts
var use_resources_zero_balance = __webpack_require__(36461);
// EXTERNAL MODULE: ./src/utils/experimentDi.tsx
var experimentDi = __webpack_require__(40826);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/index.ts + 7 modules
var student_attributes = __webpack_require__(14325);
;// CONCATENATED MODULE: ./src/hooks/use-available-auto-onboarding/store.ts





const $needCuratorOnboarding = student_attributes/* $studentAttributes */.lo.map(attributes => attributes?.needCuratorOnboarding ?? false);
const $onboardingFlow = student_attributes/* $studentAttributes */.lo.map(attributes => attributes?.onboardingFlow ?? null);
// EXTERNAL MODULE: ../shared/src/entities/onboarding/index.ts + 6 modules
var entities_onboarding = __webpack_require__(13083);
;// CONCATENATED MODULE: ./src/hooks/use-available-auto-onboarding/utils.ts



const getAvailableAutoOnboarding = _ref => {
  let {
    needCuratorOnboarding,
    autoOnboardingBusinessProductFeatureFlag,
    showProgressPageExperimentTurnOffFeatureFlag,
    showProgressPageExperiment,
    onboardingFlow,
    currentAutoOnboardingFSMState,
    isUserHasAnyResources
  } = _ref;
  if (showProgressPageExperiment === true && showProgressPageExperimentTurnOffFeatureFlag === false) {
    return false;
  }
  if (needCuratorOnboarding || onboardingFlow === "curator") {
    return false;
  }
  return Boolean(autoOnboardingBusinessProductFeatureFlag) && (0,entities_onboarding/* getIsAutoOnboarding */.sR)(currentAutoOnboardingFSMState) && isUserHasAnyResources;
};
;// CONCATENATED MODULE: ./src/hooks/use-available-auto-onboarding/use-available-auto-onboarding.ts










const useAvailableAutoOnboarding = () => {
  const {
    showProgressPage: showProgressPageExperiment
  } = (0,experimentDi/* useExperimentDi */.e1)();
  const user = (0,useUser/* useUser */.aF)();
  const showProgressPageExperimentTurnOffFeatureFlag = (0,features/* useFeatureFlag */.ye)("showProgressPageExperimentTurnOff");
  const isBusinessProductFeatureFlagAutoOnboardingEnabled = user.data?.product?.businessProductFeatureFlags?.auto_onboarding;
  const onboardingFlow = (0,effector_react/* useStore */.oR)($onboardingFlow);
  const currentAutoOnboardingFSMState = (0,effector_react/* useStore */.oR)(onboarding/* $currentOnboardingState */.W4);
  const needCuratorOnboarding = (0,effector_react/* useStore */.oR)($needCuratorOnboarding);
  const isUserHasAnyResources = (0,use_resources_zero_balance/* useResourcesZeroBalance */.GG)() !== "all";
  return getAvailableAutoOnboarding({
    autoOnboardingBusinessProductFeatureFlag: isBusinessProductFeatureFlagAutoOnboardingEnabled,
    showProgressPageExperimentTurnOffFeatureFlag,
    showProgressPageExperiment,
    onboardingFlow,
    currentAutoOnboardingFSMState,
    needCuratorOnboarding,
    isUserHasAnyResources
  });
};
;// CONCATENATED MODULE: ./src/hooks/use-available-auto-onboarding/index.ts



// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/api/events/events.urls.ts
var events_urls = __webpack_require__(88620);
// EXTERNAL MODULE: ../shared/src/entities/user/index.ts + 3 modules
var user = __webpack_require__(91485);
// EXTERNAL MODULE: ../shared/src/errors/models/not-found-object-error.ts
var not_found_object_error = __webpack_require__(71134);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/model/student/student.model.ts
var student_model = __webpack_require__(54938);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/analytic/analytic.ts













function mapAutoOnboardingChangeStateEventPayload(_ref) {
  let {
    businessProductId,
    studentId,
    onboardingFlow,
    ...event
  } = _ref;
  const base = {
    business_product_id: businessProductId,
    student_id: studentId,
    onboarding_flow: onboardingFlow
  };
  switch (event.subtype) {
    case "start":
      return {
        ...base,
        subtype: event.subtype
      };
    case "assigned":
      return {
        ...base,
        subtype: event.subtype,
        parent_product_id: event.parentProductId,
        product_id: event.productId
      };
    case "finish":
      return {
        ...base,
        subtype: event.subtype,
        start_at: event.startAt.toISOString()
      };
    case "skip_step":
    case "go_to_previous_step":
    case "help":
      return {
        ...base,
        subtype: event.subtype,
        current_step: (0,student_attributes/* mapOnboardingStateToRaw */.GS)(event.currentStep)
      };
    case "finish_step":
      return {
        ...(0,student_attributes/* mapStudentAttributesToRaw */.gY)(event).attributes,
        ...base,
        subtype: event.subtype,
        current_step: (0,student_attributes/* mapOnboardingStateToRaw */.GS)(event.currentStep)
      };
    case "need_curator":
      return {
        ...(0,student_attributes/* mapStudentAttributesToRaw */.gY)(event).attributes,
        ...base,
        subtype: event.subtype,
        current_step: (0,student_attributes/* mapOnboardingStateToRaw */.GS)(event.currentStep),
        old_onboarding_flow: event.oldOnboardingFlow
      };
    case "student_seen_tutors":
      return {
        ...base,
        subtype: "student_seen_tutors",
        student_seen_tutors_ids: event.studentSeenTutorsIds
      };
    default:
      {
        throw new unhandled_case/* UnhandledCaseError */.H(event);
      }
  }
}
const postAutoOnboardingChangeStateEvent = (0,un_either/* unEither */.K)(event => (0,http/* makeRequest */.$f)(events_urls/* EVENT_POST */.g, {
  method: "POST",
  body: {
    type: "autoonboarding_change_state",
    payload: mapAutoOnboardingChangeStateEventPayload(event)
  },
  responseType: es6.type({})
}));
const postAutoOnboardingChangeWithCurrentStep = (0,effector/* attach */.ub)({
  source: {
    currentStep: entities_onboarding/* $currentOnboardingState */.W4
  },
  effect: async (_ref2, subtype) => {
    let {
      currentStep
    } = _ref2;
    if (!currentStep) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentStep");
    }
    return postAutoOnboardingChangeStateEventFxBase({
      currentStep,
      subtype
    });
  }
});
const postAutoOnboardingChangeStateEventFxBase = (0,effector/* attach */.ub)({
  source: {
    currentProductBusinessId: user/* $currentProductBusinessId */.Wu,
    me: user/* $me */.ul,
    studentAttributes: student_attributes/* $studentAttributes */.lo
  },
  effect: async (_ref3, payload) => {
    let {
      currentProductBusinessId: businessProductId,
      me,
      studentAttributes
    } = _ref3;
    if (!businessProductId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentProductBusinessId");
    }
    const userId = me?.user?.id;
    if (!userId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("userId");
    }
    if (!payload) {
      return;
    }
    return postAutoOnboardingChangeStateEvent({
      businessProductId,
      studentId: (0,student_model/* makeStudentId */.Ox)(userId),
      onboardingFlow: studentAttributes?.onboardingFlow ?? void 0,
      ...payload
    });
  }
});
const finishStepFx = postAutoOnboardingChangeStateEventFxBase.prepend(_ref4 => {
  let {
    currentStep,
    savingStudentAttributes: {
      onboardingStates,
      ...attributes
    }
  } = _ref4;
  switch (currentStep) {
    case student_attributes/* OnboardingFSMState */.Cv.Step1:
    case student_attributes/* OnboardingFSMState */.Cv.Step2:
    case student_attributes/* OnboardingFSMState */.Cv.SelectTutor:
    case student_attributes/* OnboardingFSMState */.Cv.SelectTimeSlots:
      return {
        subtype: "finish_step",
        currentStep,
        ...attributes
      };
    default:
      return null;
  }
});
const autoOnboardingAnalyticEvents = {
  needCuratorFx: postAutoOnboardingChangeStateEventFxBase.prepend(_ref5 => {
    let {
      currentStep,
      attributes,
      oldOnboardingFlow
    } = _ref5;
    return {
      subtype: "need_curator",
      oldOnboardingFlow,
      currentStep,
      ...attributes
    };
  }),
  finishFx: postAutoOnboardingChangeStateEventFxBase.prepend(startAt => ({
    subtype: "finish",
    startAt
  })),
  skipStepFx: postAutoOnboardingChangeWithCurrentStep.prepend(() => "skip_step"),
  helpFx: postAutoOnboardingChangeWithCurrentStep.prepend(() => "help"),
  goingToPreviousStepFx: postAutoOnboardingChangeWithCurrentStep.prepend(() => "go_to_previous_step"),
  startFx: postAutoOnboardingChangeStateEventFxBase.prepend(() => ({
    subtype: "start"
  })),
  assignFx: postAutoOnboardingChangeStateEventFxBase.prepend(_ref6 => {
    let {
      parentProductId,
      productId
    } = _ref6;
    return {
      subtype: "assigned",
      parentProductId,
      productId
    };
  }),
  finishStepFx,
  seenTutorsFx: postAutoOnboardingChangeStateEventFxBase.prepend(_ref7 => {
    let {
      studentSeenTutorsIds
    } = _ref7;
    return {
      subtype: "student_seen_tutors",
      studentSeenTutorsIds
    };
  })
};
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/api/model.ts
var model = __webpack_require__(20786);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../shared/src/services/notification/toast.ts
var toast = __webpack_require__(99990);
// EXTERNAL MODULE: ../shared/src/utils/reload-page.ts
var reload_page = __webpack_require__(86710);
// EXTERNAL MODULE: ./src/app/routes/studentRoutePaths.ts
var studentRoutePaths = __webpack_require__(80575);
// EXTERNAL MODULE: ./src/components/app-page-wrapper/app-page-wrapper-types.ts
var app_page_wrapper_types = __webpack_require__(15079);
// EXTERNAL MODULE: ./src/components/app-page-wrapper/app-page-wrapper.component.tsx + 2 modules
var app_page_wrapper_component = __webpack_require__(71583);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../shared/src/entities/preferences/index.ts + 5 modules
var preferences = __webpack_require__(81347);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
;// CONCATENATED MODULE: ../ui-kit/src/checkbox-list/checkbox-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const checkbox_list_module = ({"items":"checkbox-list-module__items--rmRp9"});
;// CONCATENATED MODULE: ../ui-kit/src/checkbox-list/checkbox-list.tsx









const CheckboxList = (0,react.memo)(function CheckboxList2(_ref) {
  let {
    items,
    readOnly,
    onItemClick,
    className,
    itemProps
  } = _ref;
  const {
    className: itemClass,
    ...buttonProps
  } = itemProps ?? {};
  const listClassName = classnames_default()(checkbox_list_module.items, className);
  const itemClassName = classnames_default()(itemClass);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: listClassName,
    children: items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      className: itemClassName,
      appearance: item.isSelected ? "primary" : "primaryOnBlack",
      role: "checkbox",
      readOnly,
      "aria-checked": item.isSelected,
      onClick: () => onItemClick(item.id),
      ...buttonProps,
      children: item.name
    }, item.id))
  });
});
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
;// CONCATENATED MODULE: ./src/widgets/preferences/model/preferences.ts






























const $selectedPreferences = (0,effector/* createStore */.MT)( /* @__PURE__ */new Set());
const resetSelectedPreferences = (0,effector/* createEvent */.yM)();
$selectedPreferences.reset(resetSelectedPreferences);
const submitPreferences = (0,effector/* createEvent */.yM)();
const onSubmitPreferences = (0,effector/* createEvent */.yM)();
const $preferencesViewModel = (0,effector/* combine */.$e)(preferences/* $preferences */.xK, $selectedPreferences, (preferences, selectedPreferences) => preferences.map(preference => ({
  id: preference.id,
  name: preference.name,
  isSelected: selectedPreferences.has(preference.id)
})));
const togglePreference = (0,effector/* createEvent */.yM)();
$selectedPreferences.on(togglePreference, (prev, id) => {
  const result = new Set(prev);
  const preferenceId = (0,preferences/* makePreferenceId */.r3)(id);
  if (result.has(preferenceId)) {
    result.delete(preferenceId);
    return result;
  }
  result.add(preferenceId);
  return result;
});
const preferencesGate = (0,effector_react/* createGate */.Bq)("preferences");
(0,effector/* sample */.UP)({
  clock: submitPreferences,
  source: $selectedPreferences,
  filter: preferencesGate.status,
  fn: selectedPreferences => Array.from(selectedPreferences),
  target: onSubmitPreferences
});
;// CONCATENATED MODULE: ./src/widgets/preferences/ui/preferences-block/preferences-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const preferences_block_module = ({"container":"preferences-block-module__container--MobUC","title":"preferences-block-module__title--UjrLn","subtitle":"preferences-block-module__subtitle--rwnmd","list":"preferences-block-module__list--CYSZa","item":"preferences-block-module__item--_l8RH"});
;// CONCATENATED MODULE: ./src/widgets/preferences/ui/preferences-block/preferences-block.tsx














const PreferencesBlock = _ref => {
  let {
    readOnly
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const fetchPreferences = (0,effector_react/* useEvent */.zX)(preferences/* fetchPreferencesFx */.kA);
  const togglePreferenceFn = (0,effector_react/* useEvent */.zX)(togglePreference);
  const user = (0,useUser/* useUser */.aF)();
  const businessId = user.data?.product?.businessId;
  (0,react.useEffect)(() => {
    if (businessId) {
      void fetchPreferences(businessId);
    }
  }, [fetchPreferences, businessId]);
  const preferencesViewModel = (0,effector_react/* useStore */.oR)($preferencesViewModel);
  const itemProps = (0,react.useMemo)(() => ({
    autoHeight: true,
    className: preferences_block_module.item
  }), []);
  const headerId = (0,react.useId)();
  const descriptionId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: preferences_block_module.container,
    "aria-labelledby": headerId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      id: headerId,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()(typography_module/* default */.Z.headline3, preferences_block_module.title, {
          [typography_module/* default */.Z.headline4Accent]: isMobile
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "onboarding.preferences.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      id: descriptionId,
      className: classnames_default()(typography_module/* default */.Z.body2, preferences_block_module.subtitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "onboarding.preferences.subtitle"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      role: "group",
      "aria-describedby": descriptionId,
      children: preferencesViewModel && /* @__PURE__ */(0,jsx_runtime.jsx)(CheckboxList, {
        className: preferences_block_module.list,
        items: preferencesViewModel,
        readOnly,
        onItemClick: togglePreferenceFn,
        itemProps
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/preferences/model/hydrate.ts




























const preferencesDidMount = (0,effector/* createEvent */.yM)();
(0,effector/* sample */.UP)({
  source: entities_onboarding/* $onboardingPreferences */.xV,
  clock: preferencesDidMount,
  fn: preferences => new Set(preferences),
  target: $selectedPreferences
});
;// CONCATENATED MODULE: ./src/widgets/preferences/index.ts





// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/utils/utils.ts










const selectTimeSlotsUtils = {
  getSelectedDaysWithPartsOfDay,
  getSelectedDays
};
function getSelectedDaysWithPartsOfDay(selectedPartsOfDayMap) {
  return (0,object_utils/* getObjectEntries */.J)(selectedPartsOfDayMap).filter(_ref => {
    let [_, selectedPartsOfDay] = _ref;
    return selectedPartsOfDay.some(selectedPartOfDay => selectedPartOfDay.selected);
  }).map(_ref2 => {
    let [day, selectedPartsOfDay] = _ref2;
    return {
      day,
      selectedPartsOfDay: selectedPartsOfDay.filter(selectedPartOfDay => selectedPartOfDay.selected).map(selectedPartOfDay => selectedPartOfDay.partOfDay)
    };
  });
}
function getSelectedDays(selectedPartsOfDayMap) {
  return (0,object_utils/* getObjectEntries */.J)(selectedPartsOfDayMap).filter(_ref3 => {
    let [_, selectedPartsOfDay] = _ref3;
    return selectedPartsOfDay.some(selectedPartOfDay => selectedPartOfDay.selected);
  }).map(_ref4 => {
    let [day] = _ref4;
    return day;
  });
}
// EXTERNAL MODULE: ../../node_modules/date-fns/setDay.mjs
var setDay = __webpack_require__(54661);
// EXTERNAL MODULE: ../../node_modules/date-fns/setHours.mjs
var setHours = __webpack_require__(66930);
// EXTERNAL MODULE: ../../node_modules/date-fns/addHours.mjs
var addHours = __webpack_require__(38769);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/types.ts


var Day = /* @__PURE__ */(Day2 => {
  Day2["Monday"] = "Monday";
  Day2["Tuesday"] = "Tuesday";
  Day2["Wednesday"] = "Wednesday";
  Day2["Thursday"] = "Thursday";
  Day2["Friday"] = "Friday";
  Day2["Saturday"] = "Saturday";
  Day2["Sunday"] = "Sunday";
  return Day2;
})(Day || {});
var PartOfDay = /* @__PURE__ */(PartOfDay2 => {
  PartOfDay2["Morning"] = "Morning";
  PartOfDay2["Day"] = "Day";
  PartOfDay2["Evening"] = "Evening";
  PartOfDay2["Night"] = "Night";
  return PartOfDay2;
})(PartOfDay || {});
// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/common.ts





const resetSelectTimeSlots = (0,effector/* createEvent */.yM)();
const togglePartOfDay = (0,effector/* createEvent */.yM)();
const deleteSelectedTimeSlot = (0,effector/* createEvent */.yM)();
const [$selectedDay, selectDay] = (0,makeStore/* makeStore */.n)(null);
$selectedDay.reset(resetSelectTimeSlots);
const selectTimeSlotsGate = (0,effector_react/* createGate */.Bq)("selectTimeSlots");
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/types.ts






const DAYS_INDEX_MAP = {
  [Day.Sunday]: 0,
  [Day.Monday]: 1,
  [Day.Tuesday]: 2,
  [Day.Wednesday]: 3,
  [Day.Thursday]: 4,
  [Day.Friday]: 5,
  [Day.Saturday]: 6
};
const INDEX_DAYS_MAP = Object.fromEntries((0,object_utils/* getObjectEntries */.J)(DAYS_INDEX_MAP).map(_ref => {
  let [key, value] = _ref;
  return [value, key];
}));
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/selected-parts-of-day.ts














const DAYS = [Day.Monday, Day.Tuesday, Day.Wednesday, Day.Thursday, Day.Friday, Day.Saturday, Day.Sunday];
const PART_OF_DAY = [PartOfDay.Night, PartOfDay.Morning, PartOfDay.Day, PartOfDay.Evening];
const timezoneChange = (0,effector/* createEvent */.yM)();
const $selectedPartsOfDay = (0,effector/* createStore */.MT)(getSelectedPartsOfDayMapDefault()).on(timezoneChange, currentValues => copySelectedPartsOfDayMap(currentValues)).reset(resetSelectTimeSlots);
(0,effector/* sample */.UP)({
  clock: togglePartOfDay,
  source: {
    day: $selectedDay,
    selectedPartsOfDay: $selectedPartsOfDay
  },
  fn: handleTogglePartOfDay,
  target: $selectedPartsOfDay
});
(0,effector/* sample */.UP)({
  clock: deleteSelectedTimeSlot,
  source: {
    day: $selectedDay,
    selectedPartsOfDay: $selectedPartsOfDay
  },
  fn: (_ref, _ref2) => {
    let {
      selectedPartsOfDay
    } = _ref;
    let {
      day,
      partOfDay
    } = _ref2;
    return handleTogglePartOfDay({
      day,
      selectedPartsOfDay
    }, partOfDay);
  },
  target: $selectedPartsOfDay
});
function handleTogglePartOfDay(_ref3, partOfDay) {
  let {
    day,
    selectedPartsOfDay
  } = _ref3;
  if (!day) {
    return selectedPartsOfDay;
  }
  const copySelectedPartsOfDay = {
    ...selectedPartsOfDay
  };
  copySelectedPartsOfDay[day] = copySelectedPartsOfDay[day].map(selectedPartOfDay => {
    if (selectedPartOfDay.partOfDay === partOfDay) {
      return {
        ...selectedPartOfDay,
        selected: !selectedPartOfDay.selected
      };
    }
    return selectedPartOfDay;
  });
  return copySelectedPartsOfDay;
}
function getLocalDate() {
  const LOCAL_DATE = /* @__PURE__ */new Date();
  LOCAL_DATE.setMilliseconds(0);
  LOCAL_DATE.setSeconds(0);
  LOCAL_DATE.setMinutes(0);
  LOCAL_DATE.setHours(0);
  return LOCAL_DATE;
}
function copySelectedPartsOfDayMap(currentValues) {
  const selected = (0,object_utils/* getObjectEntries */.J)(currentValues).reduce((result, _ref4) => {
    let [day, partsOfDay] = _ref4;
    result[day] = partsOfDay.reduce((partsOfDaySelected, partOfDay) => {
      partsOfDaySelected[partOfDay.partOfDay] = partOfDay.selected;
      return partsOfDaySelected;
    }, {});
    return result;
  }, {});
  const LOCAL_DATE = getLocalDate();
  return Object.fromEntries(DAYS.map(day => [day, PART_OF_DAY.map(partOfDay => mapSelectedPartOfDayDefault((0,setDay/* setDay */.v)(LOCAL_DATE, DAYS_INDEX_MAP[day]), partOfDay, selected[day][partOfDay]))]));
}
function getSelectedPartsOfDayMapDefault() {
  const LOCAL_DATE = getLocalDate();
  return Object.fromEntries(DAYS.map(day => [day, PART_OF_DAY.map(partOfDay => mapSelectedPartOfDayDefault((0,setDay/* setDay */.v)(LOCAL_DATE, DAYS_INDEX_MAP[day]), partOfDay, false))]));
}
function mapSelectedPartOfDayDefault(date, partOfDay, selected) {
  return {
    partOfDay,
    selected,
    ...getPartOfDayDateRange(date, partOfDay)
  };
}
function getPartOfDayDateRange(date, partOfDay) {
  switch (partOfDay) {
    case PartOfDay.Night:
      return {
        from: (0,setHours/* setHours */.B)(date, 0),
        to: (0,setHours/* setHours */.B)(date, 8)
      };
    case PartOfDay.Morning:
      return {
        from: (0,setHours/* setHours */.B)(date, 8),
        to: (0,setHours/* setHours */.B)(date, 11)
      };
    case PartOfDay.Day:
      return {
        from: (0,setHours/* setHours */.B)(date, 11),
        to: (0,setHours/* setHours */.B)(date, 17)
      };
    case PartOfDay.Evening:
      {
        const from = (0,setHours/* setHours */.B)(date, 17);
        return {
          from: (0,setHours/* setHours */.B)(date, 17),
          to: (0,addHours/* addHours */.T)(from, 7)
        };
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(partOfDay);
  }
}
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/form.ts












const submitSelectTimeSlots = (0,effector/* createEvent */.yM)();
const onSubmitSelectTimeSlots = (0,effector/* createEvent */.yM)();
const onInvalidSelectTimeSlots = (0,effector/* createEvent */.yM)();
const getSelectTimeSlotsValues = (0,effector/* attach */.ub)({
  source: $selectedPartsOfDay,
  effect: selectedPartsOfDay => ({
    weekSchedule: mapToDateIntervals(selectedPartsOfDay),
    isDirty: Object.values(selectedPartsOfDay).flat().some(_ref => {
      let {
        selected
      } = _ref;
      return selected;
    })
  })
});
(0,effector/* sample */.UP)({
  clock: submitSelectTimeSlots,
  source: {
    selectedPartsOfDay: $selectedPartsOfDay,
    onboardingHowManyTimes: student_attributes/* $howManyTimesPerWeek */.f2
  },
  filter: validForm,
  fn: _ref2 => {
    let {
      selectedPartsOfDay
    } = _ref2;
    return mapToDateIntervals(selectedPartsOfDay);
  },
  target: onSubmitSelectTimeSlots
});
(0,effector/* sample */.UP)({
  clock: submitSelectTimeSlots,
  source: {
    selectedPartsOfDay: $selectedPartsOfDay,
    onboardingHowManyTimes: student_attributes/* $howManyTimesPerWeek */.f2
  },
  filter: invalidForm,
  target: onInvalidSelectTimeSlots
});
function validForm(_ref3) {
  let {
    selectedPartsOfDay,
    onboardingHowManyTimes
  } = _ref3;
  const selectedDayCount = selectTimeSlotsUtils.getSelectedDays(selectedPartsOfDay).length;
  return selectedDayCount > 0 && selectedDayCount === onboardingHowManyTimes;
}
function invalidForm(props) {
  return !validForm(props);
}
function mapToDateIntervals(selectedPartsOfDayMap) {
  return Object.values(selectedPartsOfDayMap).flat().reduce((result, selectedPartOfDay) => {
    if (selectedPartOfDay.selected) {
      result.push({
        from: selectedPartOfDay.from,
        to: selectedPartOfDay.to
      });
    }
    return result;
  }, []);
}
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
// EXTERNAL MODULE: ../shared/src/hooks/use-modal-toggle.ts
var use_modal_toggle = __webpack_require__(95812);
// EXTERNAL MODULE: ../ui-kit/src/alert/alert.tsx + 2 modules
var alert_alert = __webpack_require__(11628);
// EXTERNAL MODULE: ../ui-kit/src/alert/model/model.ts
var model_model = __webpack_require__(98922);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/date-fns/set.mjs + 2 modules
var set = __webpack_require__(14103);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMilliseconds.mjs
var addMilliseconds = __webpack_require__(87812);
// EXTERNAL MODULE: ../../node_modules/date-fns/isEqual.mjs
var isEqual = __webpack_require__(94527);
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(51461);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(71502);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/hydrate.ts




















const selectTimeSlotsDidMount = (0,effector/* createEvent */.yM)();
const hydrateTimeSlots = (0,effector/* createEvent */.yM)();
(0,effector/* sample */.UP)({
  clock: selectTimeSlotsDidMount,
  source: student_attributes/* $weekSchedule */.J0,
  filter: weekSchedule => weekSchedule.length > 0,
  fn: getHydrateTimeSlots,
  target: hydrateTimeSlots
});
(0,effector/* sample */.UP)({
  source: hydrateTimeSlots,
  filter: _ref => {
    let {
      selected
    } = _ref;
    return selected;
  },
  fn: _ref2 => {
    let {
      selectedPartsOfDayMap
    } = _ref2;
    return findSelectedDay(selectedPartsOfDayMap);
  },
  target: $selectedDay
});
(0,effector/* sample */.UP)({
  source: hydrateTimeSlots,
  filter: _ref3 => {
    let {
      selected
    } = _ref3;
    return selected;
  },
  fn: _ref4 => {
    let {
      selectedPartsOfDayMap
    } = _ref4;
    return selectedPartsOfDayMap;
  },
  target: $selectedPartsOfDay
});
function getHydrateTimeSlots(weekSchedule) {
  return weekSchedule.reduce((result, dateInterval) => {
    getDaysForDateInterval(dateInterval.from).forEach(_ref5 => {
      let {
        day,
        dateDelta
      } = _ref5;
      const selectedPartsOfDayMapForDay = result.selectedPartsOfDayMap[day].map(mapSelectedPartOfDay.bind(null, dateInterval, dateDelta));
      if (!result.selected) {
        result.selected = selectedPartsOfDayMapForDay.some(selectedPartOfDay => selectedPartOfDay.selected);
      }
      result.selectedPartsOfDayMap[day] = selectedPartsOfDayMapForDay;
    });
    return result;
  }, {
    selectedPartsOfDayMap: getSelectedPartsOfDayMapDefault(),
    selected: false
  });
}
function findSelectedDay(selectedPartsOfDayMap) {
  return (0,object_utils/* getObjectEntries */.J)(selectedPartsOfDayMap).find(_ref6 => {
    let [_, partsOfDay] = _ref6;
    return partsOfDay.some(partOfDay => partOfDay.selected);
  })?.[0] ?? null;
}
function getDaysForDateInterval(from) {
  const currentDayIndex = from.getDay();
  const previousDayIndex = getPreviousDayIndex(currentDayIndex);
  return [{
    day: INDEX_DAYS_MAP[previousDayIndex],
    dateDelta: 1
  }, {
    day: INDEX_DAYS_MAP[currentDayIndex],
    dateDelta: 0
  }];
}
function getPreviousDayIndex(currentDayIndex) {
  if (currentDayIndex === 0) {
    return 6;
  }
  return currentDayIndex - 1;
}
function mapSelectedPartOfDay(dateInterval, dateDelta, selectedPartOfDay) {
  if (selectedPartOfDay.selected) {
    return selectedPartOfDay;
  }
  const normalizedDateInterval = normalizeDateIntervalByPartOfDay(dateInterval, dateDelta, selectedPartOfDay);
  if (checkCrossDateIntervalToPartOfDayBoundary(normalizedDateInterval, selectedPartOfDay) || checkIntersectionDateIntervalWithPartOfDay(normalizedDateInterval, selectedPartOfDay) || checkIncludePartOfDayToDateInterval(normalizedDateInterval, selectedPartOfDay)) {
    return {
      ...selectedPartOfDay,
      selected: true
    };
  }
  return selectedPartOfDay;
}
function convertDate(partOfDayDate, date, dateDelta) {
  return (0,set/* set */.t)(date, {
    date: partOfDayDate.getDate() + dateDelta,
    year: partOfDayDate.getFullYear(),
    month: partOfDayDate.getMonth()
  });
}
function normalizeDateIntervalByPartOfDay(dateInterval, dateDelta, selectedPartOfDay) {
  const diff = Number(dateInterval.to) - Number(dateInterval.from);
  const from = convertDate(selectedPartOfDay.from, dateInterval.from, dateDelta);
  return {
    from,
    to: (0,addMilliseconds/* addMilliseconds */.n)(from, diff)
  };
}
function checkCrossDateIntervalToPartOfDayBoundary(_ref7, selectedPartOfDay) {
  let {
    from,
    to
  } = _ref7;
  return (0,isEqual/* isEqual */.X)(from, selectedPartOfDay.from) || (0,isEqual/* isEqual */.X)(to, selectedPartOfDay.to);
}
function checkIntersectionDateIntervalWithPartOfDay(_ref8, selectedPartOfDay) {
  let {
    from,
    to
  } = _ref8;
  return (0,isAfter/* isAfter */.A)(from, selectedPartOfDay.from) && (0,isBefore/* isBefore */.R)(from, selectedPartOfDay.to) || (0,isAfter/* isAfter */.A)(to, selectedPartOfDay.from) && (0,isBefore/* isBefore */.R)(to, selectedPartOfDay.to);
}
function checkIncludePartOfDayToDateInterval(_ref9, selectedPartOfDay) {
  let {
    from,
    to
  } = _ref9;
  return (0,isAfter/* isAfter */.A)(selectedPartOfDay.from, from) && (0,isBefore/* isBefore */.R)(selectedPartOfDay.to, to);
}
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/parts-of-day.ts







const $selectTimesVisible = $selectedDay.map(selectedDay => selectedDay !== null);
const $partsOfDayViewModels = (0,effector/* combine */.$e)($selectedDay, $selectedPartsOfDay, (selectedDay, selectedPartsOfDayMap) => selectedDay ? selectedPartsOfDayMap[selectedDay] : []);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/time-slots.ts











const $selectedTimeSlotViewModels = $selectedPartsOfDay.map(selectedPartsOfDay => (0,object_utils/* getObjectEntries */.J)(selectedPartsOfDay).reduce((result, _ref) => {
  let [day, selectedPartOfDays] = _ref;
  return result.concat(selectedPartOfDays.filter(selectedPartOfDay => selectedPartOfDay.selected).map(mapSelectedTimeSlotViewModel.bind(null, day)));
}, []));
const $selectedTimeSlotsVisible = $selectedTimeSlotViewModels.map(selectedTimeSlotViewModels => selectedTimeSlotViewModels.length > 0);
function mapSelectedTimeSlotViewModel(day, selectedPartOfDay) {
  return {
    day,
    from: selectedPartOfDay.from,
    to: selectedPartOfDay.to,
    partOfDay: selectedPartOfDay.partOfDay,
    key: day + selectedPartOfDay.partOfDay
  };
}
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../shared/src/timezones.utils.ts
var timezones_utils = __webpack_require__(30332);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/constants.ts


const TIME_FORMAT = "HH:mm";
// EXTERNAL MODULE: ../shared/src/currentBrowser.ts
var currentBrowser = __webpack_require__(97186);
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/local-time-modal/local-time-modal.tsx







const LocalTimeModal = _ref => {
  let {
    isVisible,
    onClose
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const isMobileDevice = (0,currentBrowser/* checkMobileDevice */.EY)(window.navigator);
  const titleTranslationId = isMobileDevice ? "selectTimeSlots.localTimeModal.titleMobile" : "selectTimeSlots.localTimeModal.titleDesktop";
  const subtitleTranslationId = isMobileDevice ? "selectTimeSlots.localTimeModal.subtitleMobile" : "selectTimeSlots.localTimeModal.subtitleDesktop";
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* TinyModal */.WR, {
    onClose,
    isVisible,
    overlay: "dark",
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* ModalContent */.hz, {
      title: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: intl.formatMessage({
          id: titleTranslationId
        })
      }),
      subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: intl.formatMessage({
          id: subtitleTranslationId
        })
      }),
      showCloseButton: true,
      buttons: [{
        text: intl.formatMessage({
          id: "selectTimeSlots.localTimeModal.ok"
        }),
        appearance: "primary",
        onClick: onClose
      }]
    })
  });
};
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/local-time/local-time.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const local_time_module = ({"root":"local-time-module__root--FMCCu","local-time":"local-time-module__local-time--HhzIl","localTime":"local-time-module__local-time--HhzIl"});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/local-time/local-time.tsx















const LocalTime = (0,react.memo)(_ref => {
  let {
    isLocalTimeModalVisible,
    onModalOpen,
    onModalClose
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const [localTime, setLocalTime] = (0,react.useState)((0,format/* format */.WU)( /* @__PURE__ */new Date(), TIME_FORMAT));
  const currentTimeZoneRef = (0,react.useRef)((0,timezones_utils/* getCurrentIANATimezone */.Yq)());
  const timezoneChangeEvent = (0,effector_react/* useEvent */.zX)(timezoneChange);
  (0,react.useEffect)(() => {
    const intervalId = setInterval(() => {
      const newLocalTime = (0,format/* format */.WU)( /* @__PURE__ */new Date(), TIME_FORMAT);
      const newTimeZone = (0,timezones_utils/* getCurrentIANATimezone */.Yq)();
      if (newLocalTime !== localTime) {
        setLocalTime(newLocalTime);
      }
      if (newTimeZone !== currentTimeZoneRef.current) {
        timezoneChangeEvent();
        currentTimeZoneRef.current = newTimeZone;
      }
    }, 1e3);
    return () => clearInterval(intervalId);
  }, [timezoneChangeEvent, localTime]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: local_time_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "primaryOnBlack",
      size: isMobile ? "small" : "medium",
      onClick: onModalOpen,
      "aria-label": intl.formatMessage({
        id: "selectTimeSlots.localTimeChanged.ariaLabel"
      }),
      className: local_time_module.localTime,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "selectTimeSlots.localTime",
        values: {
          localTime
        }
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      "data-testid": "local-time-info-button",
      appearance: "primaryOnBlack",
      size: isMobile ? "small" : "medium",
      iconName: "info",
      onClick: onModalOpen,
      tabIndex: -1,
      "aria-hidden": "true"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(LocalTimeModal, {
      isVisible: isLocalTimeModalVisible,
      onClose: onModalClose
    })]
  });
});
LocalTime.displayName = "LocalTime";
// EXTERNAL MODULE: ../shared/src/utils/locale.ts
var locale = __webpack_require__(90790);
// EXTERNAL MODULE: ../ui-kit/src/radio-button/index.ts + 6 modules
var radio_button = __webpack_require__(13777);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/model/days.ts















const $daysViewModels = (0,effector/* combine */.$e)($selectedDay, $selectedPartsOfDay, student_attributes/* $howManyTimesPerWeek */.f2, (selectedDay, selectedPartsOfDay, onboardingHowManyTimes) => {
  const {
    daysViewModels,
    selectedCount
  } = (0,object_utils/* getObjectEntries */.J)(selectedPartsOfDay).reduce((result, _ref) => {
    let [day, selectedPartsOfDayArr] = _ref;
    const date = selectedPartsOfDayArr[0].from;
    const isActive = day === selectedDay;
    const selected = selectedPartsOfDay[day].some(partOfDay => partOfDay.selected);
    const dayViewModel = {
      day,
      date,
      isActive,
      selected: !isActive && selected,
      disabled: false
    };
    if (selected) {
      result.selectedCount += 1;
    }
    result.daysViewModels.push(dayViewModel);
    return result;
  }, {
    daysViewModels: [],
    selectedCount: 0
  });
  if (selectedCount < (onboardingHowManyTimes ?? 0)) {
    return daysViewModels;
  }
  return daysViewModels.map(daysViewModel => {
    if (daysViewModel.isActive || daysViewModel.selected) {
      return daysViewModel;
    }
    return {
      ...daysViewModel,
      disabled: true
    };
  });
});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-days/select-days.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_days_module = ({"root":"select-days-module__root--spEAQ","radio":"select-days-module__radio--VHgbO","selected":"select-days-module__selected--yYEr2","disabled":"select-days-module__disabled--zI4YD"});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-days/select-days.tsx

















const SelectDays = (0,react.memo)(_ref => {
  let {
    readOnly
  } = _ref;
  const {
    isDesktop,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const daysViewModels = (0,effector_react/* useStore */.oR)($daysViewModels);
  const selectDayEvent = (0,effector_react/* useEvent */.zX)(selectDay);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: select_days_module.root,
    children: daysViewModels.map(_ref2 => {
      let {
        day,
        date,
        isActive,
        selected,
        disabled
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
        className: classnames_default()(select_days_module.radio, {
          [select_days_module.selected]: selected,
          [select_days_module.disabled]: disabled
        }),
        appearance: "button",
        checked: isActive,
        disabled,
        readOnly,
        onChange: () => selectDayEvent(day),
        "aria-label": intl.formatMessage({
          id: "selectTimeSlots.selectDays.ariaLabel"
        }, {
          day: (0,format/* format */.WU)(date, "EEEE")
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()({
            [typography_module/* default */.Z.body1Accent]: isDesktop,
            [typography_module/* default */.Z.body2Accent]: isMobileOrTablet
          }),
          children: (0,format/* format */.WU)(date, "EEEEEE", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          })
        })
      }, day);
    })
  });
});
SelectDays.displayName = "SelectDays";
// EXTERNAL MODULE: ../ui-kit/src/checkbox/index.ts + 7 modules
var src_checkbox = __webpack_require__(7535);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-parts-of-day/select-parts-of-day.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_parts_of_day_module = ({"root":"select-parts-of-day-module__root--AUf_r","parts-of-day":"select-parts-of-day-module__parts-of-day--HX_45","partsOfDay":"select-parts-of-day-module__parts-of-day--HX_45","part-of-day":"select-parts-of-day-module__part-of-day--wQhGZ","partOfDay":"select-parts-of-day-module__part-of-day--wQhGZ","time":"select-parts-of-day-module__time--JjWlQ"});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-parts-of-day/select-parts-of-day.tsx

















const SelectPartsOfDay = (0,react.memo)(_ref => {
  let {
    readOnly
  } = _ref;
  const {
    isDesktop,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const partsOfDayViewModels = (0,effector_react/* useStore */.oR)($partsOfDayViewModels);
  const togglePartOfDayEvent = (0,effector_react/* useEvent */.zX)(togglePartOfDay);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    "data-testid": "select-parts-of-day",
    className: select_parts_of_day_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: select_parts_of_day_module.partsOfDay,
      children: partsOfDayViewModels.map(_ref2 => {
        let {
          partOfDay,
          selected,
          from,
          to
        } = _ref2;
        const partOfDayLabel = intl.formatMessage({
          id: `selectTimeSlots.selectPartsOfDay.${partOfDay.toLowerCase()}`
        });
        const time = `${(0,format/* format */.WU)(from, TIME_FORMAT)} - ${(0,format/* format */.WU)(to, TIME_FORMAT)}`;
        const label = intl.formatMessage({
          id: "selectTimeSlots.selectPartsOfDay.selectAriaLabel"
        }, {
          partOfDay: partOfDayLabel
        });
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(src_checkbox/* Checkbox */.X, {
          className: select_parts_of_day_module.partOfDay,
          appearance: "button",
          checked: selected,
          readOnly,
          onChange: () => togglePartOfDayEvent(partOfDay),
          "aria-label": label,
          "aria-description": time,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: classnames_default()({
              [typography_module/* default */.Z.body1Accent]: isDesktop,
              [typography_module/* default */.Z.caption]: isMobileOrTablet
            }),
            children: partOfDayLabel
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: classnames_default()(select_parts_of_day_module.time, typography_module/* default */.Z.caption),
            children: time
          })]
        }, partOfDay);
      })
    })
  });
});
SelectPartsOfDay.displayName = "SelectPartsOfDay";
// EXTERNAL MODULE: ../shared/src/string.utils.ts
var string_utils = __webpack_require__(25680);
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/selected-time-slots/selected-time-slots.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const selected_time_slots_module = ({"root":"selected-time-slots-module__root--bDhXm","header":"selected-time-slots-module__header--cOvkg","time-slots":"selected-time-slots-module__time-slots--YAZKC","timeSlots":"selected-time-slots-module__time-slots--YAZKC","time-slot":"selected-time-slots-module__time-slot--M9v3j","timeSlot":"selected-time-slots-module__time-slot--M9v3j"});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/selected-time-slots/selected-time-slot.tsx

















const SelectedTimeSlot = (0,react.memo)(_ref => {
  let {
    viewModel,
    readOnly
  } = _ref;
  const itemId = (0,react.useId)();
  const {
    day,
    from,
    to,
    partOfDay
  } = viewModel;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const deleteSelectedTimeSlotEvent = (0,effector_react/* useEvent */.zX)(deleteSelectedTimeSlot);
  const partIfDayLabel = (0,string_utils/* capitalized */.wm)(intl.formatMessage({
    id: `selectTimeSlots.selectPartsOfDay.${partOfDay.toLowerCase()}`
  }));
  const dayLabel = (0,string_utils/* capitalized */.wm)((0,format/* format */.WU)(from, "EEEEEE", {
    locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
  }));
  const deleteLabel = intl.formatMessage({
    id: "selectTimeSlots.selectedTimeSlots.delete"
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
    id: itemId,
    className: classnames_default()(selected_time_slots_module.timeSlot, accessibility_module/* default */.Z.focusVisible),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.captionAccent,
      children: `${dayLabel}, ${partIfDayLabel}`
    }), !isMobile && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: typography_module/* default */.Z.caption,
      children: `${(0,format/* format */.WU)(from, TIME_FORMAT)} - ${(0,format/* format */.WU)(to, TIME_FORMAT)}`
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      type: "button",
      appearance: "default",
      size: "tiny",
      iconName: "cross-bold",
      readOnly,
      onClick: () => deleteSelectedTimeSlotEvent({
        day,
        partOfDay
      }),
      "aria-label": deleteLabel,
      "aria-describedby": itemId
    })]
  });
});
SelectedTimeSlot.displayName = "SelectedTimeSlot";
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/selected-time-slots/selected-time-slots.tsx












const SelectedTimeSlots = (0,react.memo)(function SelectedTimeSlots2(_ref) {
  let {
    readOnly
  } = _ref;
  const selectedTimeSlotViewModels = (0,effector_react/* useStore */.oR)($selectedTimeSlotViewModels);
  const titleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    "data-testid": "selected-time-slots",
    className: selected_time_slots_module.root,
    "aria-labelledby": titleId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      id: titleId,
      className: selected_time_slots_module.header,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        className: typography_module/* default */.Z.body1Accent,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "selectTimeSlots.selectedTimeSlots.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
      className: selected_time_slots_module.timeSlots,
      children: selectedTimeSlotViewModels.map(selectedTimeSlotViewModel => /* @__PURE__ */(0,jsx_runtime.jsx)(SelectedTimeSlot, {
        readOnly,
        viewModel: selectedTimeSlotViewModel
      }, selectedTimeSlotViewModel.key))
    })]
  });
});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-time-slots/utils.ts







const getPartOfDaysLegend = (partsOfDayViewModels, intl) => partsOfDayViewModels.map((_ref, index) => {
  let {
    partOfDay,
    from,
    to
  } = _ref;
  const dayLabel = intl.formatMessage({
    id: `selectTimeSlots.selectPartsOfDay.${partOfDay.toLowerCase()}`
  });
  const dayLabelFormatted = index === 0 ? (0,string_utils/* capitalized */.wm)(dayLabel) : dayLabel;
  const intervalLabel = intl.formatMessage({
    id: "selectTimeSlots.partOfDayTime"
  }, {
    from: (0,format/* format */.WU)(from, TIME_FORMAT),
    to: (0,format/* format */.WU)(to, TIME_FORMAT)
  });
  return `**${dayLabelFormatted}** ${intervalLabel}`;
}).join(", ");
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-time-slots/select-time-slots.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_time_slots_module = ({"root":"select-time-slots-module__root--Ylsmd","header":"select-time-slots-module__header--tXHPM","local-time":"select-time-slots-module__local-time--tXKkY","localTime":"select-time-slots-module__local-time--tXKkY","description":"select-time-slots-module__description--P43ig","recommended-time":"select-time-slots-module__recommended-time--aGs1G","recommendedTime":"select-time-slots-module__recommended-time--aGs1G","select-days":"select-time-slots-module__select-days--FFd3j","selectDays":"select-time-slots-module__select-days--FFd3j","parts-of-day-legend":"select-time-slots-module__parts-of-day-legend--EORdD","partsOfDayLegend":"select-time-slots-module__parts-of-day-legend--EORdD","selected-time-slots":"select-time-slots-module__selected-time-slots--pD5lZ","selectedTimeSlots":"select-time-slots-module__selected-time-slots--pD5lZ"});
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/ui/select-time-slots/select-time-slots.tsx




























const SelectTimeSlots = (0,react.memo)(_ref => {
  let {
    readOnly,
    isKidsOrTeensProduct = false
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const selectTimesVisible = (0,effector_react/* useStore */.oR)($selectTimesVisible);
  const selectedTimeSlotsVisible = (0,effector_react/* useStore */.oR)($selectedTimeSlotsVisible);
  const selectTimeSlotsDidMountEvent = (0,effector_react/* useEvent */.zX)(selectTimeSlotsDidMount);
  const partsOfDayViewModels = (0,effector_react/* useStore */.oR)($partsOfDayViewModels);
  const partOfDayNotSelected = partsOfDayViewModels.every(part => !part.selected);
  (0,effector_react/* useGate */.DD)(selectTimeSlotsGate);
  (0,react.useEffect)(selectTimeSlotsDidMountEvent, [selectTimeSlotsDidMountEvent]);
  const {
    isOpen: isLocalTimeModalVisible,
    handleOpen: openLocalTimeModal,
    handleClose: closeLocalTimeModal
  } = (0,use_modal_toggle/* useModalToggle */.N)();
  const titleId = (0,react.useId)();
  const selectDaysDescId = (0,react.useId)();
  const [selectedTimeHintShown, setSelectedTimeHintShown] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (selectTimesVisible && partOfDayNotSelected && !selectedTimeHintShown && isMobile) {
      toast/* toastNotificationService */.B.showInfoMessage(intl.formatMessage({
        id: "selectTimeSlots.selectedTimeHint"
      }));
      setSelectedTimeHintShown(true);
    }
  }, [intl, isMobile, partOfDayNotSelected, selectTimesVisible, selectedTimeHintShown]);
  const isSelectTimesVisibleTooltipVisible = !isLocalTimeModalVisible && !isMobile && partOfDayNotSelected;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    "data-testid": "SelectTimeSlots",
    className: select_time_slots_module.root,
    "aria-labelledby": titleId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      id: titleId,
      className: select_time_slots_module.header,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()(typography_module/* default */.Z.headline3, {
          [typography_module/* default */.Z.headline4Accent]: isMobile
        }),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "selectTimeSlots.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
      className: select_time_slots_module.localTime,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(LocalTime, {
        isLocalTimeModalVisible,
        onModalOpen: openLocalTimeModal,
        onModalClose: closeLocalTimeModal
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: select_time_slots_module.description,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
        type: model_model/* AlertType */.N.INFO,
        text: intl.formatMessage({
          id: "selectTimeSlots.selectDaysHint"
        }, {
          br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
      className: select_time_slots_module.selectDays,
      "aria-describedby": selectDaysDescId,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(SelectDays, {
        readOnly
      })
    }), selectTimesVisible && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
        overlay: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "selectTimeSlots.selectedTimeHint"
        }),
        placement: "bottom",
        visible: isSelectTimesVisibleTooltipVisible,
        smallOverlay: true,
        autoWidth: true,
        overlayInnerStyle: {
          borderRadius: "8px"
        },
        align: {
          targetOffset: [6, 12]
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(SelectPartsOfDay, {
          readOnly
        })
      }), isKidsOrTeensProduct && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("br", {}), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(select_time_slots_module.description, isSelectTimesVisibleTooltipVisible && select_time_slots_module.recommendedTime),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
            type: model_model/* AlertType */.N.INFO,
            text: intl.formatMessage({
              id: "selectTimeSlots.GovRecommendedTime"
            })
          })
        })]
      })]
    }), isMobileOrTablet && /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      className: classnames_default()(select_time_slots_module.partsOfDayLegend, typography_module/* default */.Z.caption),
      children: getPartOfDaysLegend(partsOfDayViewModels, intl)
    }), selectedTimeSlotsVisible && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: select_time_slots_module.selectedTimeSlots,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(SelectedTimeSlots, {
        readOnly
      })
    })]
  });
});
SelectTimeSlots.displayName = "SelectTimeSlots";
;// CONCATENATED MODULE: ./src/widgets/select-time-slots/index.ts





// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
;// CONCATENATED MODULE: ../ui-kit/src/stepper/hooks/use-stepper-validation.ts



function useStepperValidation(activeStep, steps) {
  if (activeStep > steps) {
    throw new Error("activeStep > steps");
  }
  if (activeStep <= 0) {
    throw new Error("activeStep <= 0");
  }
}
;// CONCATENATED MODULE: ../ui-kit/src/stepper/step/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_module = ({"root":"styles-module__root--aFTWx","active":"styles-module__active--FxGyi"});
;// CONCATENATED MODULE: ../ui-kit/src/stepper/step/step.tsx





const StepperStep = _ref => {
  let {
    isActive = false
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(styles_module.root, {
      [styles_module.active]: isActive
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/stepper/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const stepper_styles_module = ({"root":"styles-module__root--VPeAJ"});
;// CONCATENATED MODULE: ../ui-kit/src/stepper/stepper.tsx









const Stepper = _ref => {
  let {
    activeStep,
    steps,
    className
  } = _ref;
  useStepperValidation(activeStep, steps);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(stepper_styles_module.root, className),
    children: new Array(steps).fill(0).map((_, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(StepperStep, {
      isActive: index + 1 <= activeStep
    }, index))
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/stepper/index.ts



;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/get-auto-onboarding-stepper.ts



function getAutoOnboardingStepper(currentOnboardingFSMState) {
  const currentOnboardingFSMStateIndex = entities_onboarding/* AUTO_ONBOARDING_STATES */.XX.indexOf(currentOnboardingFSMState);
  const stepsCount = entities_onboarding/* AUTO_ONBOARDING_STATES */.XX.length;
  const autoOnboardingStatesLastIndex = entities_onboarding/* AUTO_ONBOARDING_STATES */.XX.length - 1;
  if (currentOnboardingFSMStateIndex === -1 || currentOnboardingFSMStateIndex > autoOnboardingStatesLastIndex) {
    return null;
  }
  const nextStep = entities_onboarding/* AUTO_ONBOARDING_STATES */.XX[currentOnboardingFSMStateIndex + 1];
  const currentStep = entities_onboarding/* AUTO_ONBOARDING_STATES */.XX[currentOnboardingFSMStateIndex];
  const previousStep = entities_onboarding/* AUTO_ONBOARDING_STATES */.XX[currentOnboardingFSMStateIndex - 1];
  return {
    currentStepIndex: currentOnboardingFSMStateIndex + 1,
    stepsCount,
    isNextStepAllowed: Boolean(nextStep),
    nextStep: nextStep ?? null,
    isPrevStepAllowed: Boolean(previousStep),
    currentStep: currentStep ?? null,
    previousStep: previousStep ?? null,
    isLastStep: currentOnboardingFSMStateIndex === autoOnboardingStatesLastIndex
  };
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/auto-onboarding-stepper.ts






const $autoOnboardingStepper = entities_onboarding/* $currentOnboardingState */.W4.map(currentAutoOnboardingFSMState => currentAutoOnboardingFSMState && getAutoOnboardingStepper(currentAutoOnboardingFSMState));
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/auto-onboarding-stepper/auto-onboarding-stepper.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const auto_onboarding_stepper_module = ({"stepper":"auto-onboarding-stepper-module__stepper--qMzZo"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/auto-onboarding-stepper/auto-onboarding-stepper.tsx







const AutoOnboardingStepper = () => {
  const autoOnboardingStepper = (0,effector_react/* useStore */.oR)($autoOnboardingStepper);
  if (!autoOnboardingStepper) {
    return null;
  }
  const {
    currentStepIndex,
    stepsCount
  } = autoOnboardingStepper;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(Stepper, {
    steps: stepsCount,
    activeStep: currentStepIndex,
    className: auto_onboarding_stepper_module.stepper
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/help-modal.ts



const [$helpModalContent, setHelpModalContent, resetHelpModalContent] = (0,makeStore/* makeStore */.n)(null);
// EXTERNAL MODULE: ./src/utils/yandexMetrica.ts
var yandexMetrica = __webpack_require__(11226);
// EXTERNAL MODULE: ../../node_modules/ramda/es/omit.js
var omit = __webpack_require__(11944);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.flat-map.js
var esnext_async_iterator_flat_map = __webpack_require__(53593);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.flat-map.js
var esnext_iterator_flat_map = __webpack_require__(25534);
// EXTERNAL MODULE: ../shared/src/date.utils.ts + 1 modules
var date_utils = __webpack_require__(35468);
// EXTERNAL MODULE: ../shared/src/model/tutor/tutor.model.ts
var tutor_model = __webpack_require__(97953);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.group-by.js
var es_object_group_by = __webpack_require__(96357);
// EXTERNAL MODULE: ../../node_modules/ramda/es/sortBy.js
var sortBy = __webpack_require__(10463);
;// CONCATENATED MODULE: ../shared/src/utils/date/date.ts





function sortByHours(slots) {
  return (0,sortBy/* default */.Z)(slot => slot.date.getHours())(slots);
}
function sortByDays(slots) {
  return (0,sortBy/* default */.Z)(slot => normalizeDayOfWeek(slot.date.getDay()))(slots);
}
function sortDatesByDays(slots) {
  return (0,sortBy/* default */.Z)(date => normalizeDayOfWeek(date.getDay()))(slots);
}
function groupByDay(slots) {
  return Object.groupBy(slots, slot => String(slot.date.getDay()));
}
function groupSlotsByDay(slots) {
  return groupByDay(sortByHours(Object.values(slots)));
}
function sortGroupedSlotsByDay(slots) {
  const groupedSlots = groupSlotsByDay(slots);
  return (0,sortBy/* default */.Z)(_ref => {
    let [day] = _ref;
    return normalizeDayOfWeek(+day);
  })(Object.entries(groupedSlots));
}
function convertWeekDayToName(weekDay, locale) {
  const date = (0,setDay/* setDay */.v)( /* @__PURE__ */new Date(), Number(weekDay));
  return (0,format/* format */.WU)(date, "EEEE", {
    locale
  });
}
function normalizeDayOfWeek(day) {
  return day || 7;
}
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/model/tutors.ts


















const $tutorsWithSlots = (0,effector/* createStore */.MT)([]);
const [$currentTutorId, setCurrentTutorId, resetCurrentTutor] = (0,makeStore/* makeStore */.n)(null);
const $currentTutorSelectedSlots = (0,effector/* createStore */.MT)({});
const $selectedTutor = (0,effector/* createStore */.MT)(null);
const $selectStudentTutorScheduleStep = $currentTutorId.map(currentTutorId => currentTutorId ? "card" : "list");
const selectTutorGate = (0,effector_react/* createGate */.Bq)("selectTutorGate");
const resetSelectStudentTutorSchedule = (0,effector/* createEvent */.yM)();
$selectedTutor.reset(resetSelectStudentTutorSchedule);
$currentTutorId.reset(resetSelectStudentTutorSchedule);
$currentTutorSelectedSlots.reset(resetSelectStudentTutorSchedule);
$tutorsWithSlots.reset(resetSelectStudentTutorSchedule);
(0,effector/* sample */.UP)({
  source: {
    tutors: $tutorsWithSlots,
    selectedTutor: student_attributes/* $attributesSelectedTutor */.H_
  },
  fn: _ref => {
    let {
      tutors,
      selectedTutor
    } = _ref;
    if (!selectedTutor) {
      return null;
    }
    const currentWeekSelectedSlots = selectedTutor.selectedSlots.map(date_utils/* moveDateOnCurrentWeek */.CT);
    const selectedTutorWithSlots = tutors.find(tutor => tutor.info.id === selectedTutor.id);
    const availableSelectedTutorSlots = selectedTutorWithSlots ? selectedTutorWithSlots.availabilitySlots.filter(availabilitySlot => {
      const currentWeekAvailabilitySlot = (0,date_utils/* moveDateOnCurrentWeek */.CT)(availabilitySlot.date);
      return currentWeekSelectedSlots.find(slot => currentWeekAvailabilitySlot.getTime() === slot.getTime());
    }) : [];
    const isSelectedTutorSlotsAvailable = availableSelectedTutorSlots.length === selectedTutor.selectedSlots.length;
    if (!isSelectedTutorSlotsAvailable) {
      return null;
    }
    return {
      id: (0,tutor_model/* makeTutorId */.Nr)(selectedTutor.id),
      selectedSlots: availableSelectedTutorSlots.map(slot => slot.id)
    };
  },
  target: $selectedTutor
});
const $tutorViewModels = (0,effector/* combine */.$e)($tutorsWithSlots, $selectedTutor, (tutors, selectedTutor) => tutors.map(tutor => mapTutorsToVM(tutor, selectedTutor)));
const $tutorCardViewModel = (0,effector/* combine */.$e)($tutorsWithSlots, $currentTutorId, $currentTutorSelectedSlots, (tutors, currentTutorId, currentTutorSelectedSlots) => {
  const tutor = tutors.find(tutor2 => tutor2.info.id === currentTutorId);
  if (!tutor) {
    return null;
  }
  return mapTutorToCardVM(tutor, currentTutorSelectedSlots);
});
const selectCurrentTutorSlot = (0,effector/* createEvent */.yM)();
const selectOccupiedSlot = (0,effector/* createEvent */.yM)();
(0,effector/* sample */.UP)({
  clock: selectCurrentTutorSlot,
  source: $currentTutorSelectedSlots,
  fn: (currentTutorSelectedSlots, _ref2) => {
    let {
      weekDay,
      slotId
    } = _ref2;
    return {
      ...currentTutorSelectedSlots,
      [weekDay]: slotId
    };
  },
  target: $currentTutorSelectedSlots
});
(0,effector/* sample */.UP)({
  clock: setCurrentTutorId,
  source: {
    selectedTutor: $selectedTutor,
    tutorsWithSlots: $tutorsWithSlots
  },
  fn: (_ref3, currentTutorId) => {
    let {
      selectedTutor,
      tutorsWithSlots
    } = _ref3;
    if (!selectedTutor || selectedTutor?.id !== currentTutorId) {
      return {};
    }
    const tutor = tutorsWithSlots.find(tutor2 => tutor2.info.id === currentTutorId);
    return tutor?.availabilitySlots.filter(slot => selectedTutor.selectedSlots.includes(slot.id)).reduce((res, slot) => {
      res[slot.date.getDay()] = slot.id;
      return res;
    }, {}) ?? {};
  },
  target: $currentTutorSelectedSlots
});
function mapTutorsToVM(tutor, selectedTutor) {
  const isSelectedTutor = tutor.info.id === selectedTutor?.id;
  return {
    ...tutor,
    visibleSlots: sortByDays(isSelectedTutor ? tutor.availabilitySlots.filter(slot => selectedTutor.selectedSlots.includes(slot.id)) :
    // Ближайшие слоты на каждый день недели
    sortGroupedSlotsByDay(tutor.availabilitySlots).map(_ref4 => {
      let [_, value] = _ref4;
      return value[0];
    }).filter(Boolean)),
    selected: isSelectedTutor
  };
}
function mapTutorToCardVM(tutor, currentTutorSelectedSlots) {
  return {
    ...tutor,
    availabilitySlotsGroupByDay: sortGroupedSlotsByDay(tutor.availabilitySlots.flatMap(slot => {
      const weekDay = slot.date.getDay();
      return [{
        ...slot,
        selected: currentTutorSelectedSlots[weekDay] === slot.id
      }];
    }))
  };
}
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/model/submit.ts











const submitSelectTutorFromCard = (0,effector/* createEvent */.yM)();
const submitSelectTutorFromList = (0,effector/* createEvent */.yM)();
const onSubmitSelectTutor = (0,effector/* createEvent */.yM)();
const onInvalidSelectTutor = (0,effector/* createEvent */.yM)();
const onNotSelectedTutor = (0,effector/* createEvent */.yM)();
const getSelectTutorValues = (0,effector/* attach */.ub)({
  source: [$tutorsWithSlots, $currentTutorId, $currentTutorSelectedSlots],
  effect: _ref => {
    let [tutors, currentTutorId, currentTutorSelectedSlots] = _ref;
    return {
      selectedTutor: currentTutorId && Object.values(currentTutorSelectedSlots).length > 0 ? {
        id: currentTutorId,
        selectedSlots: getSelectedSlotsDates(tutors, currentTutorId, Object.values(currentTutorSelectedSlots))
      } : void 0
    };
  }
});
(0,effector/* sample */.UP)({
  clock: submitSelectTutorFromCard,
  source: {
    currentTutorSelectedSlots: $currentTutorSelectedSlots,
    currentTutorId: $currentTutorId,
    howManyTimesPerWeek: student_attributes/* $howManyTimesPerWeek */.f2,
    tutorsWithSlots: $tutorsWithSlots
  },
  filter: params => {
    const {
      currentTutorSelectedSlots,
      currentTutorId,
      howManyTimesPerWeek
    } = params;
    return currentTutorId !== null && validSelectedSlotsCount(Object.values(currentTutorSelectedSlots), howManyTimesPerWeek);
  },
  fn: _ref2 => {
    let {
      currentTutorSelectedSlots,
      currentTutorId,
      tutorsWithSlots
    } = _ref2;
    const selectedSlotsIds = Object.values(currentTutorSelectedSlots);
    const selectedSlots = getSelectedSlotsDates(tutorsWithSlots, currentTutorId, selectedSlotsIds);
    return {
      id: currentTutorId,
      selectedSlots
    };
  },
  target: onSubmitSelectTutor
});
(0,effector/* sample */.UP)({
  clock: submitSelectTutorFromCard,
  source: {
    currentTutorId: $currentTutorId,
    currentTutorSelectedSlots: $currentTutorSelectedSlots,
    howManyTimesPerWeek: student_attributes/* $howManyTimesPerWeek */.f2
  },
  filter: _ref3 => {
    let {
      currentTutorId,
      currentTutorSelectedSlots,
      howManyTimesPerWeek
    } = _ref3;
    return currentTutorId !== null && invalidSelectedSlotsCount(Object.values(currentTutorSelectedSlots), howManyTimesPerWeek);
  },
  fn: _ref4 => {
    let {
      currentTutorId,
      currentTutorSelectedSlots,
      howManyTimesPerWeek
    } = _ref4;
    return currentTutorId !== null ? getInvalidSelectedSlotsCount(Object.values(currentTutorSelectedSlots), howManyTimesPerWeek) : 0;
  },
  target: onInvalidSelectTutor
});
(0,effector/* sample */.UP)({
  clock: submitSelectTutorFromList,
  source: {
    selectedTutor: $selectedTutor,
    tutorsWithSlots: $tutorsWithSlots,
    howManyTimesPerWeek: student_attributes/* $howManyTimesPerWeek */.f2
  },
  filter: params => {
    const {
      selectedTutor,
      howManyTimesPerWeek
    } = params;
    return selectedTutor !== null && validSelectedSlotsCount(selectedTutor.selectedSlots, howManyTimesPerWeek);
  },
  fn: _ref5 => {
    let {
      selectedTutor,
      tutorsWithSlots
    } = _ref5;
    const selectedSlots = getSelectedSlotsDates(tutorsWithSlots, selectedTutor.id, selectedTutor.selectedSlots);
    return {
      id: selectedTutor.id,
      selectedSlots
    };
  },
  target: onSubmitSelectTutor
});
(0,effector/* sample */.UP)({
  clock: submitSelectTutorFromList,
  source: {
    selectedTutor: $selectedTutor,
    howManyTimesPerWeek: student_attributes/* $howManyTimesPerWeek */.f2
  },
  filter: _ref6 => {
    let {
      selectedTutor,
      howManyTimesPerWeek
    } = _ref6;
    return selectedTutor !== null && invalidSelectedSlotsCount(selectedTutor.selectedSlots, howManyTimesPerWeek);
  },
  fn: _ref7 => {
    let {
      selectedTutor,
      howManyTimesPerWeek
    } = _ref7;
    return selectedTutor !== null ? getInvalidSelectedSlotsCount(selectedTutor.selectedSlots, howManyTimesPerWeek) : 0;
  },
  target: onInvalidSelectTutor
});
(0,effector/* sample */.UP)({
  clock: submitSelectTutorFromList,
  source: {
    selectedTutor: $selectedTutor
  },
  filter: _ref8 => {
    let {
      selectedTutor
    } = _ref8;
    return selectedTutor === null;
  },
  target: onNotSelectedTutor
});
function getSelectedSlotsDates(tutors, selectedTutorId, selectedSlotsIds) {
  const selectedTutorParams = tutors.find(tutor => tutor.info.id === selectedTutorId);
  return selectedTutorParams ? selectedTutorParams.availabilitySlots.reduce((acc, slot) => {
    if (selectedSlotsIds.includes(slot.id)) {
      acc.push(slot.date);
    }
    return acc;
  }, []) : [];
}
function validSelectedSlotsCount(selectedSlots, onboardingHowManyTimes) {
  return onboardingHowManyTimes !== null && selectedSlots.length === onboardingHowManyTimes;
}
function invalidSelectedSlotsCount(selectedSlots, onboardingHowManyTimes) {
  return onboardingHowManyTimes !== null && selectedSlots.length < onboardingHowManyTimes;
}
function getInvalidSelectedSlotsCount(selectedSlots, onboardingHowManyTimes) {
  return onboardingHowManyTimes !== null ? onboardingHowManyTimes - selectedSlots.length : 0;
}
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/index.ts




// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/go-to-next-step.ts























const goToNextStepFx = (0,effector/* attach */.ub)({
  source: {
    autoOnboardingStepper: $autoOnboardingStepper,
    currentProductBusinessId: user/* $currentProductBusinessId */.Wu,
    onboardingStates: entities_onboarding/* $onboardingStates */.pR,
    studentAttributes: student_attributes/* $studentAttributes */.lo
  },
  effect: (_ref, partialStudentAttributes) => {
    let {
      autoOnboardingStepper,
      currentProductBusinessId,
      onboardingStates,
      studentAttributes
    } = _ref;
    if (!autoOnboardingStepper?.isNextStepAllowed) {
      throw new Error("Next step is not allowed");
    }
    if (!currentProductBusinessId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentProductBusinessId");
    }
    const savingStudentAttributes = {
      onboardingFlow: studentAttributes?.onboardingFlow,
      ...partialStudentAttributes,
      onboardingStates: autoOnboardingStepper.nextStep ? new Map([...onboardingStates, [currentProductBusinessId, autoOnboardingStepper.nextStep]]) : void 0
    };
    return (0,student_attributes/* saveStudentAttributesFx */.YP)(savingStudentAttributes);
  }
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/save-current-step.ts







const saveCurrentStepFx = (0,effector/* attach */.ub)({
  source: {
    autoOnboardingStepper: $autoOnboardingStepper
  },
  effect: async (_ref, savingStudentAttributes) => {
    let {
      autoOnboardingStepper
    } = _ref;
    const currentStep = autoOnboardingStepper?.currentStep;
    if (!currentStep) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentStep");
    }
    const response = await goToNextStepFx(savingStudentAttributes);
    autoOnboardingAnalyticEvents.finishStepFx({
      savingStudentAttributes,
      currentStep
    });
    return response;
  }
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/auto-onboarding-gate.ts



const autoOnboardingGate = (0,effector_react/* createGate */.Bq)("autoOnboarding");
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/utils.ts




function combineAutoOnboardingGateStatus(stepGate) {
  return (0,effector/* combine */.$e)({
    stepGateStatus: stepGate.status,
    autoOnboardingGateStatus: autoOnboardingGate.status
  }, _ref => {
    let {
      stepGateStatus,
      autoOnboardingGateStatus
    } = _ref;
    return stepGateStatus && autoOnboardingGateStatus;
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/intensity/constants.ts


const DEFAULT_HOW_MANY_TIMES_PER_WEEK = 3;
const INTENSITY_TIMES_PER_WEEK_THRESHOLD = 4;
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/constants.ts


const SPEAKING_SESSION_DURATION_BY_PRODUCT = {
  bus: {
    double: 90,
    single: 45
  },
  general: {
    double: 60,
    single: 30
  }
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/intensity/utils.ts





function preselectLessonDuration(lessonDuration, businessProductId, dirtyValue) {
  if (!businessProductId) {
    return dirtyValue ?? SPEAKING_SESSION_DURATION_BY_PRODUCT.general.double;
  }
  if ((0,product_model/* getIsBusBusinessProduct */.Se)(businessProductId)) {
    logger/* Logger */.Yd.captureWarning(`Unexpected businessProductId: ${businessProductId}`, {
      BusinessProductId: product_model/* BusinessProductId */.HV
    });
    return SPEAKING_SESSION_DURATION_BY_PRODUCT.bus.single;
  }
  if (lessonDuration === 2) {
    return SPEAKING_SESSION_DURATION_BY_PRODUCT.general.double;
  }
  return dirtyValue ?? SPEAKING_SESSION_DURATION_BY_PRODUCT.general.double;
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/intensity/intensity.ts











const intensityGate = (0,effector_react/* createGate */.Bq)("intensity");
const resetIntensity = (0,effector/* createEvent */.yM)();
const submitIntensity = (0,effector/* createEvent */.yM)();
const [$howManyTimesPerWeek, setHowManyTimesPerWeek] = (0,makeStore/* makeStore */.n)(DEFAULT_HOW_MANY_TIMES_PER_WEEK);
$howManyTimesPerWeek.reset(resetIntensity);
const [$lessonDurationSelected, setLessonDuration] = (0,makeStore/* makeStore */.n)(null);
$lessonDurationSelected.reset(resetIntensity);
const getIntensityValues = (0,effector/* attach */.ub)({
  source: [$howManyTimesPerWeek, $lessonDurationSelected],
  effect: _ref => {
    let [howManyTimesPerWeek, lessonDuration] = _ref;
    return {
      howManyTimesPerWeek,
      lessonDuration: lessonDuration ?? void 0,
      isDirty: howManyTimesPerWeek !== $howManyTimesPerWeek.defaultState || lessonDuration !== $lessonDurationSelected.defaultState
    };
  }
});
const $lessonDuration = (0,effector/* combine */.$e)($lessonDurationSelected, $howManyTimesPerWeek, user/* $currentProductBusinessId */.Wu, (lessonDurationDefault, howManyTimesPerWeek, currentProductBusinessId) => preselectLessonDuration(howManyTimesPerWeek, currentProductBusinessId, lessonDurationDefault));
(0,effector/* sample */.UP)({
  clock: submitIntensity,
  source: {
    howManyTimesPerWeek: $howManyTimesPerWeek,
    lessonDuration: $lessonDuration,
    studentAttributes: student_attributes/* $studentAttributes */.lo
  },
  filter: combineAutoOnboardingGateStatus(intensityGate),
  fn: _ref2 => {
    let {
      howManyTimesPerWeek,
      lessonDuration,
      studentAttributes
    } = _ref2;
    if (howManyTimesPerWeek !== studentAttributes?.howManyTimesPerWeek || lessonDuration !== studentAttributes.lessonDuration) {
      return {
        howManyTimesPerWeek,
        lessonDuration,
        weekSchedule: [],
        selectedTutor: null
      };
    }
    return {
      howManyTimesPerWeek,
      lessonDuration
    };
  },
  target: saveCurrentStepFx
});
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../shared/src/utils/avatar/avatar.utils.ts
var avatar_utils = __webpack_require__(63419);
// EXTERNAL MODULE: ../shared/src/api/student/onboarding/tutors.mappers.ts
var tutors_mappers = __webpack_require__(10400);
;// CONCATENATED MODULE: ../shared/src/api/onboarding/tutors/tutors.mapper.ts





const mapStudentOnboardingTutorResponseRaw = (_ref, slotDuration) => {
  let {
    tutor: {
      id,
      avatar,
      description,
      short_description: shortDescription,
      public_name: name,
      interests,
      min_assignment_time_before_session_minutes: minAssignmentTimeBeforeSessionMinutes
    },
    speaking_session_duration: speakingSessionDuration,
    intervals,
    occupied_intervals: occupiedIntervals
  } = _ref;
  const rawAvailabilitySlots = (0,tutors_mappers/* mapSplittedIntervals */.XY)(intervals, slotDuration || speakingSessionDuration, speakingSessionDuration);
  const availabilitySlots = (0,tutors_mappers/* markOccupiedSlots */.Pe)(rawAvailabilitySlots, occupiedIntervals, speakingSessionDuration, true);
  return {
    info: {
      id: (0,tutor_model/* makeTutorId */.Nr)(id),
      name,
      interests,
      avatar: avatar ?? avatar_utils/* DEFAULT_AVATAR_URL */.jz,
      description: description ?? "",
      minAssignmentTimeBeforeSessionMinutes,
      shortDescription: shortDescription || description || ""
    },
    availabilitySlots,
    speakingSessionDuration
  };
};
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ../shared/src/api/onboarding/tutors/urls.ts



const getOnboardingTutorsUrl = queryParams => `${(0,site_utils/* getAPIPath */.NZ)()}/student/student-onboarding/tutors-v2?${queryParams}`;
// EXTERNAL MODULE: ../shared/src/api/student/onboarding/tutors.raw-model.ts
var tutors_raw_model = __webpack_require__(96536);
;// CONCATENATED MODULE: ../shared/src/api/onboarding/tutors/tutors.raw-model.ts




const RawTutor = es6.type({
  id: es6.string,
  public_name: es6.string,
  min_assignment_time_before_session_minutes: es6.number,
  avatar: es6.union([es6["null"], es6.string]),
  description: es6.union([es6["null"], es6.string]),
  short_description: es6.union([es6["null"], es6.string]),
  interests: es6.array(es6.string)
});
const RawStudentOnboardingTutorWithAvailability = es6.type({
  tutor: RawTutor,
  intervals: es6.array(tutors_raw_model/* rawTutorInterval */.$D),
  occupied_intervals: es6.array(tutors_raw_model/* rawTutorOccupiedInterval */.tD),
  speaking_session_duration: es6.number,
  match_rate: es6.number
});
const StudentOnboardingTutorsResponseRaw = es6.type({
  data: es6.array(RawStudentOnboardingTutorWithAvailability)
});
;// CONCATENATED MODULE: ../shared/src/api/onboarding/tutors/index.ts





// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/double-speaking-session-tutors-not-found-error.ts



class DoubleSpeakingSessionTutorsNotFoundError extends Error {
  constructor() {
    super("Double speaking session tutors not found");
  }
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/utils.ts






const isDoubleSpeakingSessionDuration = slotDuration => Object.values(SPEAKING_SESSION_DURATION_BY_PRODUCT).some(_ref => {
  let {
    double
  } = _ref;
  return double === slotDuration;
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/tutors.ts



















































const RawDoubleSpeakingSessionTutorsNotFoundError = es6.type({
  code: es6.literal("double_speaking_session_tutors_not_found")
});
function gettingStudentOnboardingTutorsErrorMapper(error) {
  if (error.code === "double_speaking_session_tutors_not_found") {
    return new DoubleSpeakingSessionTutorsNotFoundError();
  }
  return api_model/* unexpectedError */.g;
}
const getStudentOnboardingTutors = (0,un_either/* unEither */.K)((speakingTypeId, slotDuration) => {
  const queryParams = new URLSearchParams();
  const isDoubleSpeakingSession = slotDuration ? isDoubleSpeakingSessionDuration(slotDuration) : false;
  queryParams.set("speaking_type_id", speakingTypeId);
  queryParams.set("is_double_speaking_session", isDoubleSpeakingSession.toString());
  queryParams.set("tz", (0,timezones_utils/* getCurrentIANATimezone */.Yq)());
  return (0,http/* makeRequest */.$f)(getOnboardingTutorsUrl(queryParams), {
    responseType: StudentOnboardingTutorsResponseRaw,
    errorMapper: gettingStudentOnboardingTutorsErrorMapper,
    resultMapper: response => response.data.slice(0, 8).map(tutor => mapStudentOnboardingTutorResponseRaw(tutor, slotDuration))
  });
});
const loadTutors = (0,effector/* createEvent */.yM)();
const [$tutorError, setTutorError] = (0,makeStore/* makeStore */.n)(null);
const [$tutorsState, _, resetTutorsState] = (0,makeStore/* makeStore */.n)({
  state: "loading"
});
$tutorError.reset(resetTutorsState);
const addSeenTutor = (0,effector/* createEvent */.yM)();
const resetSeenTutors = (0,effector/* createEvent */.yM)();
const $seenTutors = (0,effector/* createStore */.MT)([]).on(addSeenTutor, (seenTutors, tutorId) => [...seenTutors, tutorId]).reset(resetSeenTutors);
const saveSeenTutorsFx = (0,effector/* createEffect */.GW)(seenTutors => {
  autoOnboardingAnalyticEvents.seenTutorsFx({
    studentSeenTutorsIds: [...new Set(seenTutors)]
  });
  resetSeenTutors();
});
const getStudentOnboardingTutorsFx = (0,effector/* createEffect */.GW)(_ref => {
  let {
    speakingTypeId,
    slotDuration
  } = _ref;
  return getStudentOnboardingTutors(speakingTypeId, slotDuration);
});
(0,effector/* sample */.UP)({
  clock: loadTutors,
  source: {
    speakingTypeId: student_attributes/* $studentSpeakingTypeId */.$r,
    slotDuration: student_attributes/* $lessonDuration */.fQ
  },
  fn: _ref2 => {
    let {
      speakingTypeId,
      slotDuration
    } = _ref2;
    if (!speakingTypeId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingTypeId");
    }
    return {
      speakingTypeId,
      slotDuration: slotDuration ?? void 0
    };
  },
  target: getStudentOnboardingTutorsFx
});
(0,effector/* sample */.UP)({
  clock: getStudentOnboardingTutorsFx.failData,
  fn: error => ({
    state: "error",
    error
  }),
  target: $tutorsState
});
(0,effector/* sample */.UP)({
  clock: getStudentOnboardingTutorsFx.doneData,
  source: {
    attributesSelectedTutor: student_attributes/* $attributesSelectedTutor */.H_
  },
  filter: (_ref3, data) => {
    let {
      attributesSelectedTutor
    } = _ref3;
    if (!attributesSelectedTutor || data.length === 0) {
      return false;
    }
    return !data.some(tutor => tutor.info.id === attributesSelectedTutor.id);
  },
  fn: () => "tutorNotFound",
  target: $tutorError
});
(0,effector/* sample */.UP)({
  clock: getStudentOnboardingTutorsFx.doneData,
  source: {
    attributesSelectedTutor: student_attributes/* $attributesSelectedTutor */.H_
  },
  filter: (_ref4, data) => {
    let {
      attributesSelectedTutor
    } = _ref4;
    if (!attributesSelectedTutor || data.length === 0) {
      return false;
    }
    const selectedTutor = data.find(tutor => tutor.info.id === attributesSelectedTutor.id);
    if (!selectedTutor) {
      return false;
    }
    const isSlotsAvailable = attributesSelectedTutor.selectedSlots.every(slot => selectedTutor.availabilitySlots.some(availableSlot => availableSlot.date.getTime() === slot.getTime() && availableSlot.type === "available"));
    return !isSlotsAvailable;
  },
  fn: () => "slotNotFound",
  target: $tutorError
});
(0,effector/* sample */.UP)({
  clock: getStudentOnboardingTutorsFx.doneData,
  fn: () => ({
    state: "loaded"
  }),
  target: $tutorsState
});
(0,effector/* sample */.UP)({
  clock: getStudentOnboardingTutorsFx.doneData,
  target: $tutorsWithSlots
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/pre-curator-onboarding-screen.ts














const [$preCuratorOnboardingScreenContent, setPreCuratorOnboardingScreenContent, resetPreCuratorOnboardingScreenContent] = (0,makeStore/* makeStore */.n)(null);
async function getCurrentStepValues(currentOnboardingState) {
  switch (currentOnboardingState) {
    case student_attributes/* OnboardingFSMState */.Cv.Step2:
      {
        const {
          isDirty,
          ...values
        } = await getIntensityValues();
        return isDirty ? values : null;
      }
    case student_attributes/* OnboardingFSMState */.Cv.SelectTimeSlots:
      {
        const {
          isDirty,
          ...values
        } = await getSelectTimeSlotsValues();
        return isDirty ? values : null;
      }
    case student_attributes/* OnboardingFSMState */.Cv.SelectTutor:
      {
        return getSelectTutorValues();
      }
    default:
      return null;
  }
}
const goToCuratorOnboardingFx = (0,effector/* attach */.ub)({
  source: {
    currentOnboardingState: entities_onboarding/* $currentOnboardingState */.W4,
    seenTutors: $seenTutors,
    onboardingFlow: $onboardingFlow
  },
  effect: async _ref => {
    let {
      currentOnboardingState,
      seenTutors,
      onboardingFlow
    } = _ref;
    if (!currentOnboardingState) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentStep");
    }
    const values = await getCurrentStepValues(currentOnboardingState);
    const attributes = await (0,student_attributes/* saveStudentAttributesFx */.YP)({
      needCuratorOnboarding: true,
      onboardingFlow: "curator",
      ...(values ?? {})
    });
    const attributesPayload = (0,omit/* default */.Z)(["needCuratorOnboarding", "onboardingStates"], attributes);
    void autoOnboardingAnalyticEvents.needCuratorFx({
      currentStep: currentOnboardingState,
      attributes: attributesPayload,
      oldOnboardingFlow: onboardingFlow
    });
    if (seenTutors.length) {
      void saveSeenTutorsFx(seenTutors);
    }
    resetPreCuratorOnboardingScreenContent();
  }
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/help-modal/use-pre-curator-onboarding-screen.ts









function usePreCuratorOnboardingScreen() {
  const intl = (0,useIntl/* default */.Z)();
  const autoOnboardingStepper = (0,effector_react/* useStore */.oR)($autoOnboardingStepper);
  const setPreCuratorOnboardingScreenContentEvent = (0,effector_react/* useEvent */.zX)(setPreCuratorOnboardingScreenContent);
  return (0,react.useCallback)(() => {
    if (autoOnboardingStepper?.currentStep) {
      const onboardingStep = (0,student_attributes/* mapOnboardingStateToRaw */.GS)(autoOnboardingStepper?.currentStep);
      (0,yandexMetrica/* ymGoal */.qf)("AutoOnboarding_Step_To_Curator_Needed", {
        step: onboardingStep
      });
    }
    setPreCuratorOnboardingScreenContentEvent({
      title: intl.formatMessage({
        id: "autoOnboardingPage.preCuratorOnboardingScreen.title"
      }),
      contentFirstBlock: intl.formatMessage({
        id: "autoOnboardingPage.preCuratorOnboardingScreen.firstBlock"
      }),
      contentSecondBlock: intl.formatMessage({
        id: "autoOnboardingPage.preCuratorOnboardingScreen.secondBlock"
      }),
      contentThirdBlock: intl.formatMessage({
        id: "autoOnboardingPage.preCuratorOnboardingScreen.thirdBlock"
      }),
      imageAlt: "confirm curator onboarding",
      imageSrc: "https://flowstatic.s3.yandex.net/ui-files/autoonboarding-curator-welcome.svg"
    });
  }, [autoOnboardingStepper?.currentStep, intl, setPreCuratorOnboardingScreenContentEvent]);
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/help-modal/help-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const help_modal_module = ({"break":"help-modal-module__break--bfPsm"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/help-modal/help-modal.tsx











const HelpModal = () => {
  const helpModalContent = (0,effector_react/* useStore */.oR)($helpModalContent);
  const {
    title,
    subtitle,
    needCuratorButtonText,
    closeButtonText
  } = helpModalContent ?? {
    title: "",
    subtitle: "",
    needCuratorButtonText: "",
    closeButtonText: ""
  };
  const handleClose = (0,effector_react/* useEvent */.zX)(resetHelpModalContent);
  const postAutoOnboardingHelpEvent = (0,effector_react/* useEvent */.zX)(autoOnboardingAnalyticEvents.helpFx);
  const isVisibleModal = helpModalContent !== null;
  const goToPreCuratorOnboardingScreen = usePreCuratorOnboardingScreen();
  (0,react.useEffect)(() => {
    if (isVisibleModal) {
      void postAutoOnboardingHelpEvent();
    }
  }, [isVisibleModal, postAutoOnboardingHelpEvent]);
  const handleOnPreCuratorOnboardingScreen = (0,react.useCallback)(() => {
    goToPreCuratorOnboardingScreen();
    handleClose();
  }, [goToPreCuratorOnboardingScreen, handleClose]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* TinyModal */.WR, {
    onClose: handleClose,
    isVisible: isVisibleModal,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* ModalContent */.hz, {
      title: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: help_modal_module.break,
        children: title
      }),
      subtitle: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: help_modal_module.break,
        children: subtitle
      }),
      showCloseButton: true,
      buttons: [{
        text: needCuratorButtonText,
        appearance: "secondary",
        onClick: handleOnPreCuratorOnboardingScreen
      }, {
        text: closeButtonText,
        appearance: "primary",
        onClick: handleClose
      }]
    })
  });
};
// EXTERNAL MODULE: ./src/widgets/curator-onboarding-screen-content/ui/curator-onboarding-screen-content.tsx + 1 modules
var curator_onboarding_screen_content = __webpack_require__(37260);
// EXTERNAL MODULE: ../../node_modules/date-fns/isDate.mjs
var isDate = __webpack_require__(65890);
// EXTERNAL MODULE: ../../node_modules/date-fns/getDay.mjs
var getDay = __webpack_require__(18832);
// EXTERNAL MODULE: ../../node_modules/date-fns/addDays.mjs
var addDays = __webpack_require__(78016);
// EXTERNAL MODULE: ../../node_modules/date-fns/getHours.mjs
var getHours = __webpack_require__(91253);
// EXTERNAL MODULE: ../../node_modules/date-fns/getMinutes.mjs
var getMinutes = __webpack_require__(40618);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMinutes.mjs
var addMinutes = __webpack_require__(7300);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameDay.mjs
var isSameDay = __webpack_require__(51418);
// EXTERNAL MODULE: ../../node_modules/date-fns/setSeconds.mjs
var setSeconds = __webpack_require__(81304);
// EXTERNAL MODULE: ../../node_modules/date-fns/setMinutes.mjs
var setMinutes = __webpack_require__(35465);
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/utils/constants.ts


const DAYS_IN_WEEK = 7;
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/utils/utils.ts














const getStartAtDates = _ref => {
  let {
    selectedDates,
    now,
    tutorOccupiedDates,
    minAssignmentTimeBeforeSessionMinutes
  } = _ref;
  if (selectedDates.length === 0 || !(0,isDate/* isDate */.J)(now)) {
    return [];
  }
  const result = [];
  const MAX_DAYS_DIFF_FROM_CURRENT_DATE = 13;
  const MAX_DAYS_DIFF_FROM_FIRST_LESSON = 7;
  const selectedWeekdays = selectedDates.map(selectedDate => (0,getDay/* getDay */.w)(selectedDate)).sort();
  const firstLessonDate = getFirstLessonDate(now, selectedDates);
  const lastPossibleLessonDateFromCurrentDate = (0,addDays/* addDays */.E)(now, MAX_DAYS_DIFF_FROM_CURRENT_DATE);
  const lastPossibleLessonDateFromFirstLesson = (0,addDays/* addDays */.E)(firstLessonDate, MAX_DAYS_DIFF_FROM_FIRST_LESSON);
  const selectedDayTimeMap = selectedDates.reduce((res, date) => {
    const weekDay = (0,getDay/* getDay */.w)(date);
    if (!(weekDay in res)) {
      res[weekDay] = {
        hours: (0,getHours/* getHours */.p)(date),
        minutes: (0,getMinutes/* getMinutes */.q)(date)
      };
    }
    return res;
  }, {});
  const minAvailableStartAt = (0,addMinutes/* addMinutes */.m)(now, minAssignmentTimeBeforeSessionMinutes);
  let currentDate = firstLessonDate;
  while (currentDate < lastPossibleLessonDateFromCurrentDate && currentDate <= lastPossibleLessonDateFromFirstLesson) {
    const isDateNotOccupied = !tutorOccupiedDates.some(tutorOccupiedDate => (0,isSameDay/* isSameDay */.K)(tutorOccupiedDate, currentDate));
    if (selectedWeekdays.includes((0,getDay/* getDay */.w)(currentDate)) && isDateNotOccupied) {
      const {
        hours,
        minutes
      } = selectedDayTimeMap[(0,getDay/* getDay */.w)(currentDate)];
      const startAtDate = (0,setSeconds/* setSeconds */.O)((0,setMinutes/* setMinutes */.H)((0,setHours/* setHours */.B)(currentDate, hours), minutes), 0);
      if ((0,isAfter/* isAfter */.A)(startAtDate, minAvailableStartAt) || (0,isEqual/* isEqual */.X)(startAtDate, minAvailableStartAt)) {
        result.push(startAtDate);
      }
    }
    currentDate = (0,addDays/* addDays */.E)(currentDate, 1);
  }
  return result;
};
function getFirstLessonDate(now, selectedDates) {
  const selectedWeekdays = selectedDates.map(selectedDate => (0,getDay/* getDay */.w)(selectedDate)).sort();
  const nowWeekday = (0,getDay/* getDay */.w)(now);
  const closestLessonWeekday = selectedWeekdays.find(selectedWeekday => selectedWeekday > nowWeekday) ?? selectedWeekdays[0];
  const daysDiff = closestLessonWeekday - nowWeekday;
  const firstLessonDate = new Date(now);
  if (nowWeekday === closestLessonWeekday) {
    return (0,addDays/* addDays */.E)(firstLessonDate, DAYS_IN_WEEK);
  }
  const normalizedDaysDiff = daysDiff < 0 ? DAYS_IN_WEEK - Math.abs(daysDiff) : daysDiff;
  return (0,addDays/* addDays */.E)(firstLessonDate, normalizedDaysDiff);
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/utils.ts































const getSlotKey = slot => (0,format/* format */.WU)(slot, "eeee HH:mm");
function getSelectedOccupiedSlots(_ref) {
  let {
    selectedSlots,
    occupiedSlots
  } = _ref;
  const selectedSlotsKeys = new Set(selectedSlots.map(getSlotKey));
  return occupiedSlots.filter(slot => selectedSlotsKeys.has(getSlotKey(slot.date)));
}
function isOccupiedSlot(slot) {
  return slot.type === "occupied";
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/errors/tutor-has-occupied-slots.ts



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TutorHasOccupiedSlotsError extends Error {
  constructor(occupiedSlots) {
    super("Auto onbording tutor has occupied slots");
    _defineProperty(this, "occupiedSlots", void 0);
    this.occupiedSlots = occupiedSlots;
  }
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/errors/tutor-has-permanently-slots.ts



function tutor_has_permanently_slots_defineProperty(obj, key, value) { key = tutor_has_permanently_slots_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tutor_has_permanently_slots_toPropertyKey(t) { var i = tutor_has_permanently_slots_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function tutor_has_permanently_slots_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TutorHasPermanentlySlotsError extends Error {
  constructor(permanentlySlots) {
    super("Auto onbording tutor has permanently slots");
    tutor_has_permanently_slots_defineProperty(this, "permanentlySlots", void 0);
    this.permanentlySlots = permanentlySlots;
  }
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/errors/tutor-not-available.ts



class TutorNotAvailableError extends Error {
  constructor() {
    super("Auto onbording tutor not available");
  }
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/errors/index.ts





;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/tutor/api.ts










const getStudentOnboardingTutor = (0,un_either/* unEither */.K)(_ref => {
  let {
    speakingTypeId,
    slotDuration,
    tutorId
  } = _ref;
  const isDoubleSpeakingSession = slotDuration ? isDoubleSpeakingSessionDuration(slotDuration) : false;
  const queryParams = new URLSearchParams();
  queryParams.set("speaking_type_id", speakingTypeId);
  queryParams.set("tutor_id", tutorId);
  queryParams.set("is_double_speaking_session", isDoubleSpeakingSession.toString());
  queryParams.set("tz", (0,timezones_utils/* getCurrentIANATimezone */.Yq)());
  return (0,http/* makeRequest */.$f)(getOnboardingTutorsUrl(queryParams), {
    responseType: StudentOnboardingTutorsResponseRaw,
    resultMapper: response => {
      if (!response.data.length) {
        return null;
      }
      const [tutor] = response.data;
      return mapStudentOnboardingTutorResponseRaw(tutor, slotDuration);
    }
  });
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/tutor/tutor.ts





































const loadTutorFx = (0,effector/* attach */.ub)({
  source: {
    speakingTypeId: student_attributes/* $studentSpeakingTypeId */.$r,
    slotDuration: student_attributes/* $lessonDuration */.fQ,
    selectedTutor: student_attributes/* $attributesSelectedTutor */.H_
  },
  effect: async (_ref, tutorFromList) => {
    let {
      speakingTypeId,
      slotDuration,
      selectedTutor
    } = _ref;
    if (tutorFromList) {
      return tutorFromList;
    }
    if (!speakingTypeId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingTypeId");
    }
    if (!selectedTutor) {
      throw new not_found_object_error/* NotFoundObjectError */.m("selectedTutor");
    }
    const tutor = await getStudentOnboardingTutor({
      speakingTypeId,
      slotDuration: slotDuration ?? void 0,
      tutorId: selectedTutor.id
    });
    if (!tutor) {
      throw new TutorNotAvailableError();
    }
    const slots = new Set(tutor.availabilitySlots.map(slot => getSlotKey(slot.date)));
    const unavailableSlots = [];
    for (const slot of selectedTutor.selectedSlots) {
      if (!slots.has(getSlotKey(slot))) {
        unavailableSlots.push(slot);
      }
    }
    if (unavailableSlots.length) {
      throw new TutorHasPermanentlySlotsError(unavailableSlots);
    }
    return tutor;
  }
});
const $tutor = (0,effector/* createStore */.MT)(null);
const $occupiedSlots = $tutor.map(tutor => {
  if (!tutor) {
    return [];
  }
  return tutor.availabilitySlots.filter(isOccupiedSlot);
});
(0,effector/* sample */.UP)({
  clock: loadTutorFx.doneData,
  target: $tutor
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/start-date.ts














const $startDates = (0,effector/* combine */.$e)(student_attributes/* $attributesSelectedTutor */.H_, $occupiedSlots, $tutor, (selectedTutor, occupiedSlots, tutor) => {
  if (!selectedTutor || !selectedTutor.selectedSlots || !tutor) {
    return [];
  }
  const occupiedDates = getSelectedOccupiedSlots({
    selectedSlots: selectedTutor.selectedSlots,
    occupiedSlots
  }).map(getBusyReasonsDates).flat();
  return getStartAtDates({
    now: /* @__PURE__ */new Date(),
    selectedDates: selectedTutor.selectedSlots,
    tutorOccupiedDates: occupiedDates,
    minAssignmentTimeBeforeSessionMinutes: tutor.info.minAssignmentTimeBeforeSessionMinutes
  }).map(date => ({
    id: (0,tutor_model/* getSlotId */.Vr)(date),
    date
  }));
});
function getBusyReasonsDates(_ref) {
  let {
    busyReasons
  } = _ref;
  return Array.from(busyReasons.values()).flat();
}
const [$selectedStartDateId, setSelectedStartDateId, resetSelectedStartDateId] = (0,makeStore/* makeStore */.n)(null);
const [$finalStartDate, setFinalStartDate] = (0,makeStore/* makeStore */.n)(null);
const $selectedStartDate = (0,effector/* combine */.$e)($startDates, $selectedStartDateId, $finalStartDate, (startDates, selectedId, finalStartDate) => {
  if (finalStartDate && selectedId === null) {
    return {
      id: (0,tutor_model/* getSlotId */.Vr)(finalStartDate),
      date: finalStartDate
    };
  }
  return startDates.find(_ref2 => {
    let {
      id
    } = _ref2;
    return id === selectedId;
  }) ?? startDates[0];
});
(0,effector/* sample */.UP)({
  clock: $startDates,
  fn: startDates => startDates[0]?.date,
  target: $finalStartDate
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/confirm-onboarding/api.ts













const getChoosingTutorSlots = _ref => {
  let {
    selectedSlots,
    occupiedSlots,
    slotDuration
  } = _ref;
  const isDoubleSpeakingSession = slotDuration ? isDoubleSpeakingSessionDuration(slotDuration) : false;
  if (isDoubleSpeakingSession) {
    const minSlotDuration = 30;
    const extraSlotOffset = slotDuration ? slotDuration / 2 : minSlotDuration;
    return {
      week_schedule: selectedSlots.concat(selectedSlots.map(slot => (0,addMinutes/* addMinutes */.m)(slot, extraSlotOffset))).map(date_utils/* getDefaultBackendDateFormat */.Uw),
      occupied_slots: occupiedSlots.concat(occupiedSlots.map(occupiedSlot => (0,addMinutes/* addMinutes */.m)(occupiedSlot, extraSlotOffset))).map(date_utils/* getDefaultBackendDateFormat */.Uw)
    };
  }
  return {
    week_schedule: selectedSlots.map(date_utils/* getDefaultBackendDateFormat */.Uw),
    occupied_slots: occupiedSlots.map(date_utils/* getDefaultBackendDateFormat */.Uw)
  };
};
function errorMapper(error) {
  switch (error.code) {
    case "tutor_not_available":
      return new TutorNotAvailableError();
    case "tutor_has_permanently_slots":
      return new TutorHasPermanentlySlotsError(error.permanently_slots.map(slot => new Date(slot)));
    case "tutor_has_occupied_slots":
      return new TutorHasOccupiedSlotsError(error.occupied_slots.map(slot => new Date(slot)));
    default:
      return api_model/* unexpectedError */.g;
  }
}
const chooseTutor = (0,un_either/* unEither */.K)(_ref2 => {
  let {
    selectedSlots,
    tutorId,
    occupiedSlots,
    speakingTypeId,
    startAt,
    slotDuration
  } = _ref2;
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/student-onboarding/tutors/${tutorId}/choose-for-student`, {
    method: "POST",
    responseType: es6.type({}),
    errorMapper,
    body: {
      speaking_type_id: speakingTypeId,
      start_at: (0,date_utils/* getDefaultBackendDateFormat */.Uw)(startAt),
      ...getChoosingTutorSlots({
        selectedSlots,
        occupiedSlots,
        slotDuration
      }),
      skip_occupied_slots: false
    }
  });
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/confirm-onboarding/utils.ts









function getAbsoluteOccupiedSlots(_ref) {
  let {
    selectedSlots,
    occupiedSlots
  } = _ref;
  const selectedOccupiedSlots = getSelectedOccupiedSlots({
    selectedSlots,
    occupiedSlots
  });
  const result = [];
  selectedOccupiedSlots.forEach(slot => {
    const busyDates = Array.from(slot.busyReasons).flatMap(_ref2 => {
      let [, busyDates2] = _ref2;
      return busyDates2;
    });
    busyDates.forEach(busyDate => {
      result.push(new Date(busyDate.getFullYear(), busyDate.getMonth(), busyDate.getDate(), slot.date.getHours(), slot.date.getMinutes()));
    });
  });
  return result;
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/confirm-onboarding/confirm-onboarding.ts









const confirmOnboardingFx = (0,effector/* attach */.ub)({
  source: {
    selectedTutor: student_attributes/* $attributesSelectedTutor */.H_,
    tutorOccupiedSlots: $occupiedSlots,
    speakingTypeId: student_attributes/* $studentSpeakingTypeId */.$r,
    startAt: $finalStartDate,
    slotDuration: student_attributes/* $lessonDuration */.fQ
  },
  effect: async _ref => {
    let {
      selectedTutor,
      tutorOccupiedSlots,
      speakingTypeId,
      startAt,
      slotDuration
    } = _ref;
    if (!selectedTutor) {
      throw new not_found_object_error/* NotFoundObjectError */.m("selectedTutor");
    }
    if (!speakingTypeId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("speakingTypeId");
    }
    if (!startAt) {
      throw new not_found_object_error/* NotFoundObjectError */.m("startAt");
    }
    const {
      selectedSlots
    } = selectedTutor;
    const occupiedSlots = getAbsoluteOccupiedSlots({
      selectedSlots,
      occupiedSlots: tutorOccupiedSlots
    });
    const payload = {
      selectedSlots,
      tutorId: selectedTutor.id,
      occupiedSlots,
      speakingTypeId,
      startAt,
      slotDuration
    };
    return chooseTutor(payload).then(() => payload);
  }
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/onboarding.ts

































(0,effector/* sample */.UP)({
  source: {
    seenTutors: $seenTutors,
    gate: autoOnboardingGate.status
  },
  clock: entities_onboarding/* $currentOnboardingState */.W4,
  filter: _ref => {
    let {
      seenTutors,
      gate
    } = _ref;
    return !!seenTutors.length && gate;
  },
  fn: _ref2 => {
    let {
      seenTutors
    } = _ref2;
    return seenTutors;
  },
  target: saveSeenTutorsFx
});
const goToOnboardingStateFx = (0,effector/* attach */.ub)({
  source: {
    currentProductBusinessId: user/* $currentProductBusinessId */.Wu,
    onboardingStates: entities_onboarding/* $onboardingStates */.pR
  },
  effect: async (_ref3, onboardingState) => {
    let {
      currentProductBusinessId,
      onboardingStates
    } = _ref3;
    if (!currentProductBusinessId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentProductBusinessId");
    }
    return (0,student_attributes/* saveStudentAttributesFx */.YP)({
      onboardingStates: new Map([...onboardingStates, [currentProductBusinessId, onboardingState]])
    });
  }
});
const goToPreviousAutoOnboardingStateFx = (0,effector/* attach */.ub)({
  source: {
    autoOnboardingStepper: $autoOnboardingStepper
  },
  effect: async _ref4 => {
    let {
      autoOnboardingStepper
    } = _ref4;
    if (!autoOnboardingStepper?.isPrevStepAllowed) {
      throw new Error("Previous step is not allowed");
    }
    const previousStep = autoOnboardingStepper.previousStep;
    if (!previousStep) {
      throw new not_found_object_error/* NotFoundObjectError */.m("previousStep");
    }
    const response = goToOnboardingStateFx(previousStep);
    autoOnboardingAnalyticEvents.goingToPreviousStepFx();
    return response;
  }
});
(0,effector/* sample */.UP)({
  clock: onSubmitPreferences,
  filter: combineAutoOnboardingGateStatus(preferencesGate),
  fn: preferences => ({
    preferences
  }),
  target: saveCurrentStepFx
});
(0,effector/* sample */.UP)({
  clock: submitIntensity,
  source: {
    howManyTimesPerWeek: $howManyTimesPerWeek,
    lessonDuration: $lessonDuration,
    studentAttributes: student_attributes/* $studentAttributes */.lo
  },
  filter: _ref5 => {
    let {
      howManyTimesPerWeek,
      lessonDuration,
      studentAttributes
    } = _ref5;
    return howManyTimesPerWeek !== studentAttributes?.howManyTimesPerWeek || lessonDuration !== studentAttributes.lessonDuration;
  },
  target: resetSelectTimeSlots
});
(0,effector/* sample */.UP)({
  clock: onSubmitSelectTimeSlots,
  source: student_attributes/* $studentAttributes */.lo,
  filter: combineAutoOnboardingGateStatus(selectTimeSlotsGate),
  fn: (studentAttributes, dateIntervals) => {
    if (!(0,date_utils/* isDateIntervalsListsEqual */.SL)(dateIntervals, studentAttributes?.weekSchedule ?? [])) {
      return {
        weekSchedule: dateIntervals,
        selectedTutor: null
      };
    }
    return {
      weekSchedule: dateIntervals
    };
  },
  target: saveCurrentStepFx
});
(0,effector/* sample */.UP)({
  clock: onSubmitSelectTimeSlots,
  source: student_attributes/* $studentAttributes */.lo,
  filter: (studentAttributes, dateIntervals) => !(0,date_utils/* isDateIntervalsListsEqual */.SL)(dateIntervals, studentAttributes?.weekSchedule ?? []),
  target: resetTutorsState
});
(0,effector/* sample */.UP)({
  clock: onSubmitSelectTutor,
  filter: combineAutoOnboardingGateStatus(selectTutorGate),
  fn: selectedTutor => ({
    selectedTutor
  }),
  target: saveCurrentStepFx
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/skip-current-step.ts







const skipCurrentStepFx = (0,effector/* attach */.ub)({
  source: {
    autoOnboardingStepper: $autoOnboardingStepper
  },
  effect: async _ref => {
    let {
      autoOnboardingStepper
    } = _ref;
    const currentStep = autoOnboardingStepper?.currentStep;
    if (!currentStep) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentStep");
    }
    const response = goToNextStepFx({});
    autoOnboardingAnalyticEvents.skipStepFx();
    return response;
  }
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/saving-auto-onboarding-step.ts









const $savingAutoOnboardingStep = (0,effector/* combine */.$e)({
  autoOnboardingGateStatus: autoOnboardingGate.status,
  goingToCuratorOnboardingPending: goToCuratorOnboardingFx.pending,
  goingToNextStepPending: goToNextStepFx.pending,
  goingToPreviousStepPending: goToPreviousAutoOnboardingStateFx.pending,
  skipCurrentStePending: skipCurrentStepFx.pending,
  confirmOnboardingPending: confirmOnboardingFx.pending
}, _ref => {
  let {
    autoOnboardingGateStatus,
    goingToNextStepPending,
    confirmOnboardingPending,
    goingToCuratorOnboardingPending,
    goingToPreviousStepPending,
    skipCurrentStePending
  } = _ref;
  if (!autoOnboardingGateStatus) {
    return null;
  }
  if (goingToCuratorOnboardingPending) {
    return "needCuratorOnboarding";
  }
  if (goingToPreviousStepPending) {
    return "prev";
  }
  if (skipCurrentStePending) {
    return "skip";
  }
  if (goingToNextStepPending || confirmOnboardingPending) {
    return "next";
  }
  return null;
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/pre-curator-onboarding-screen/pre-curator-onboarding-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const pre_curator_onboarding_screen_module = ({"page":"pre-curator-onboarding-screen-module__page--wBXlh","footer":"pre-curator-onboarding-screen-module__footer--NH2MJ","button":"pre-curator-onboarding-screen-module__button--C4OIQ"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/pre-curator-onboarding-screen/pre-curator-onboarding-screen.tsx












const PreCuratorOnboardingScreen = () => {
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const loading = savingAutoOnboardingStep === "needCuratorOnboarding";
  const preCuratorOnboardingScreenContent = (0,effector_react/* useStore */.oR)($preCuratorOnboardingScreenContent);
  const curatorScreenContent = preCuratorOnboardingScreenContent ?? {
    title: "",
    contentFirstBlock: "",
    contentSecondBlock: "",
    contentThirdBlock: "",
    imageAlt: "",
    imageSrc: ""
  };
  const handleNext = (0,effector_react/* useEvent */.zX)(goToCuratorOnboardingFx);
  const handleBack = (0,effector_react/* useEvent */.zX)(resetPreCuratorOnboardingScreenContent);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    header: {
      hideCourseSelectButton: true,
      hideNavigation: true
    },
    main: {
      hideGrammarGuideButton: true
    },
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
      doNotWrapChildrenWithLayout: true
    },
    footer: {
      hideFooter: true
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: pre_curator_onboarding_screen_module.page,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(curator_onboarding_screen_content/* CuratorOnboardingScreenContent */.w, {
          content: curatorScreenContent
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: pre_curator_onboarding_screen_module.footer,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            className: pre_curator_onboarding_screen_module.button,
            appearance: "secondary",
            readOnly: loading,
            onClick: handleBack,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "autoOnboardingPage.backButton"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            className: pre_curator_onboarding_screen_module.button,
            appearance: "primary",
            loading,
            onClick: handleNext,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "autoOnboardingPage.continueButton"
            })
          })]
        })]
      })
    })
  });
};
;// CONCATENATED MODULE: ../shared/src/hooks/app/use-will-unmount.ts



const useWillUnmount = callback => {
  (0,react.useEffect)(() => callback,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
};
// EXTERNAL MODULE: ../shared/src/utils/create-polling/create-polling.ts
var create_polling = __webpack_require__(48353);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/confirm-onboarding/utils.ts



function isErrorScreen(error) {
  return error instanceof TutorNotAvailableError || error instanceof TutorHasPermanentlySlotsError;
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/confirm-onboarding/confirm-onboarding.ts
















const autoOnboardingConfirmGate = (0,effector_react/* createGate */.Bq)("autoOnboarding");
const [$confirmOnboardingError,, resetConfirmOnboardingStepError] = (0,makeStore/* makeStore */.n)(null);
const $confirmOnboardingStepError = $confirmOnboardingError.map(error => error && !isErrorScreen(error) ? error : null);
(0,effector/* sample */.UP)({
  clock: confirmOnboardingFx.failData,
  source: autoOnboardingConfirmGate.status,
  fn: (_, error) => error,
  target: $confirmOnboardingError
});
(0,effector/* sample */.UP)({
  clock: confirmOnboardingFx.doneData,
  filter: autoOnboardingConfirmGate.status,
  fn: _ref => {
    let {
      startAt
    } = _ref;
    return startAt;
  },
  target: autoOnboardingAnalyticEvents.finishFx
});
(0,effector/* sample */.UP)({
  clock: loadTutorFx.failData,
  source: autoOnboardingConfirmGate.status,
  fn: (_, error) => error,
  filter: (autoOnboardingConfirmGateStatus, error) => autoOnboardingConfirmGateStatus && error instanceof TutorHasPermanentlySlotsError || error instanceof TutorNotAvailableError,
  target: $confirmOnboardingError
});
(0,effector/* sample */.UP)({
  source: {
    error: $confirmOnboardingError
  },
  filter: _ref2 => {
    let {
      error
    } = _ref2;
    return error instanceof TutorHasOccupiedSlotsError;
  },
  fn: () => null,
  target: loadTutorFx
});
(0,effector/* sample */.UP)({
  clock: autoOnboardingConfirmGate.open,
  source: {
    tutors: $tutorsWithSlots,
    selectedTutor: $selectedTutor
  },
  fn: _ref3 => {
    let {
      tutors,
      selectedTutor
    } = _ref3;
    if (!selectedTutor || !tutors.length) {
      return null;
    }
    return tutors.find(tutor => tutor.info.id === selectedTutor.id) ?? null;
  },
  target: loadTutorFx
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/footer/footer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const footer_module = ({"footer":"footer-module__footer--O4pwv","main-buttons-block":"footer-module__main-buttons-block--KQXXx","mainButtonsBlock":"footer-module__main-buttons-block--KQXXx","button":"footer-module__button--z9ziv"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/footer/footer.tsx












const Footer = _ref => {
  let {
    onNext,
    onBack,
    onSkip,
    onDontKnowHowToChoose
  } = _ref;
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const autoOnboardingStepper = (0,effector_react/* useStore */.oR)($autoOnboardingStepper);
  const isNextStepAllowed = Boolean(autoOnboardingStepper?.isNextStepAllowed);
  const isPrevStepAllowed = Boolean(autoOnboardingStepper?.isPrevStepAllowed);
  const isLastStep = Boolean(autoOnboardingStepper?.isLastStep);
  const isNextStepLoading = savingAutoOnboardingStep === "next";
  const isPrevStepLoading = savingAutoOnboardingStep === "prev";
  const isSkipLoading = savingAutoOnboardingStep === "skip";
  const isLoading = savingAutoOnboardingStep !== null;
  const handleDontKnowHowToChoose = (0,react.useCallback)(() => {
    if (autoOnboardingStepper?.currentStep) {
      const onboardingStep = (0,student_attributes/* mapOnboardingStateToRaw */.GS)(autoOnboardingStepper?.currentStep);
      (0,yandexMetrica/* ymGoal */.qf)("AutoOnboarding_Dont_Know_How_To_Choose", {
        step: onboardingStep
      });
    }
    onDontKnowHowToChoose?.();
  }, [autoOnboardingStepper?.currentStep, onDontKnowHowToChoose]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: footer_module.footer,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: footer_module.mainButtonsBlock,
      children: [onBack && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        className: footer_module.button,
        appearance: "secondary",
        readOnly: isLoading || !isPrevStepAllowed,
        loading: isPrevStepLoading,
        onClick: onBack,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "autoOnboardingPage.backButton"
        })
      }), onNext && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        "data-testid": "onboarding-next-button",
        className: footer_module.button,
        appearance: "primary",
        readOnly: isLoading,
        loading: isNextStepLoading || !isNextStepAllowed && !isLastStep,
        onClick: onNext,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: isLastStep ? "autoOnboardingPage.finishButton" : "autoOnboardingPage.continueButton"
        })
      })]
    }), onSkip && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      className: footer_module.button,
      appearance: "tertiary",
      readOnly: isLoading || !isNextStepAllowed,
      loading: isSkipLoading,
      onClick: onSkip,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "autoOnboardingPage.skipButton"
      })
    }), onDontKnowHowToChoose && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      className: footer_module.button,
      appearance: "tertiary",
      readOnly: isLoading,
      onClick: handleDontKnowHowToChoose,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "autoOnboardingPage.dontKnowHowToChooseButton"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/footer/index.ts



;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/step-wrapper/step-wrapper.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const step_wrapper_module = ({"main":"step-wrapper-module__main--hs9os"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/step-wrapper/step-wrapper.tsx




const StepWrapper = _ref => {
  let {
    children,
    dataTestId,
    ...rest
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("main", {
    "data-testid": dataTestId,
    className: step_wrapper_module.main,
    ...rest,
    children
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/no-start-date-warning/no-start-date-warning.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const no_start_date_warning_module = ({"block":"no-start-date-warning-module__block--dSTkN","alert":"no-start-date-warning-module__alert--xZkyk"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/no-start-date-warning/no-start-date-warning.tsx








const NoStartDateWarning = () => {
  const warningBlockId = (0,react.useId)();
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: no_start_date_warning_module.block,
    "aria-labelledby": warningBlockId,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
      className: no_start_date_warning_module.alert,
      type: model_model/* AlertType */.N.INFO,
      text: intl.formatMessage({
        id: "autoOnboarding.confirmOnboardingStep.noStartDateWarning.text"
      }),
      iconCustomProps: {
        name: "warning",
        size: "medium"
      }
    })
  });
};
;// CONCATENATED MODULE: ../shared/src/utils/occupied-time-slot/occupied-time-slot.ts




























function mapBusyReasonsToDates(busyReasons) {
  return Array.from(new Set(Array.from(busyReasons.values()))).flat();
}
function getUniqueBusyDates(busyReasons) {
  return mapBusyReasonsToDates(busyReasons).sort((a, b) => a.getTime() - b.getTime()).map(date => (0,format/* format */.WU)(date, "dd.MM"));
}
;// CONCATENATED MODULE: ./src/components/slot-wrapper/slot-wrapper.tsx








const SlotWrapper = _ref => {
  let {
    children,
    slot,
    onClick
  } = _ref;
  const {
    isDesktop
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const isOccupied = slot.type === "occupied";
  const [occupiedInfoVisible, setOccupiedInfoVisible] = (0,react.useState)(false);
  const busyReason = isOccupied && intl.formatMessage({
    id: "autoOnboardingPage.selectTutorStep.occupiedSlotBusyReason"
  }, {
    dates: getUniqueBusyDates(slot.busyReasons).join(", ")
  });
  const handleClickOccupiedSlot = (0,react.useCallback)(() => busyReason && onClick(busyReason), [busyReason, onClick]);
  if (!isOccupied) {
    return children;
  }
  if (!isDesktop) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      role: "presentation",
      onClick: handleClickOccupiedSlot,
      children
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    id: slot.id,
    overlay: busyReason,
    visible: occupiedInfoVisible,
    trigger: "hover",
    placement: "top",
    autoWidth: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      onMouseEnter: () => setOccupiedInfoVisible(true),
      onMouseLeave: () => setOccupiedInfoVisible(false),
      "aria-describedby": slot.id,
      children
    })
  }, slot.id);
};
// EXTERNAL MODULE: ../../node_modules/ramda/es/indexBy.js + 2 modules
var indexBy = __webpack_require__(94344);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/schedule/model.ts












const $occupiedSlotsGrouped = $occupiedSlots.map(slots => (0,indexBy/* default */.Z)(slot => getSlotKey(slot.date), slots));
const $scheduleViewModel = (0,effector/* combine */.$e)(student_attributes/* $attributesSelectedTutor */.H_, student_attributes/* $lessonDuration */.fQ, $occupiedSlotsGrouped, (selectedTutor, lessonDuration, occupiedSlotsGrouped) => {
  if (!selectedTutor) {
    return [];
  }
  return sortDatesByDays(selectedTutor.selectedSlots).map(slot => {
    const slotKey = getSlotKey(slot);
    return {
      slot: [slot, (0,addMinutes/* addMinutes */.m)(slot, lessonDuration ?? speakingSession_model/* DEFAULT_LESSON_DURATION */.ip)],
      occupied: occupiedSlotsGrouped[slotKey]
    };
  }) ?? [];
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/schedule/schedule.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_module = ({"schedule":"schedule-module__schedule--syihz","time":"schedule-module__time--Ak6jZ","schedule-item":"schedule-module__schedule-item--lOqJ7","scheduleItem":"schedule-module__schedule-item--lOqJ7","occupied-slot":"schedule-module__occupied-slot--mmU6j","occupiedSlot":"schedule-module__occupied-slot--mmU6j"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/schedule/schedule.tsx
















const Schedule = () => {
  const intl = (0,useIntl/* default */.Z)();
  const schedule = (0,effector_react/* useStore */.oR)($scheduleViewModel);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const onOccupiedSlotClick = value => {
    toast/* toastNotificationService */.B.showInfoMessage(value, {
      toastId: value
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    role: "list",
    className: classnames_default()(typography_module/* default */.Z.body1Accent, {
      [typography_module/* default */.Z.body2Accent]: isMobile
    }, schedule_module.schedule),
    children: schedule.map(_ref => {
      let {
        slot,
        occupied
      } = _ref;
      const [from, to] = slot;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("li", {
        className: schedule_module.scheduleItem,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("time", {
          className: schedule_module.time,
          children: `${(0,format/* format */.WU)(from, "eeeeee HH:mm", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          })} - ${(0,format/* format */.WU)(to, "HH:mm", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          })}`
        }), occupied && /* @__PURE__ */(0,jsx_runtime.jsx)(SlotWrapper, {
          onClick: onOccupiedSlotClick,
          slot: occupied,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(typography_module/* default */.Z.captionAccent, schedule_module.occupiedSlot),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "onboarding.confirmStep.scheduleBlock.occupied"
            })
          })
        })]
      }, from.toISOString());
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/skeleton/index.ts + 1 modules
var skeleton = __webpack_require__(80735);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/schedule/skeleton.tsx








const ScheduleSkeleton = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()(typography_module/* default */.Z.body1Accent, {
      [typography_module/* default */.Z.body2Accent]: isMobile
    }, schedule_module.schedule),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
      width: 150,
      wrapper: _ref => {
        let {
          children
        } = _ref;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
          className: schedule_module.scheduleItem,
          children
        });
      },
      count: 3
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/start-date/start-date.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const start_date_module = ({"start-date-container":"start-date-module__start-date-container--KvmEz","startDateContainer":"start-date-module__start-date-container--KvmEz","wrapper":"start-date-module__wrapper--pRl9r","start-date":"start-date-module__start-date--F2Xro","startDate":"start-date-module__start-date--F2Xro","title":"start-date-module__title--AFX56"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/start-date/skeleton.tsx








const StartDateSkeleton = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: start_date_module.wrapper,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
      width: 250,
      containerClassName: classnames_default()(typography_module/* default */.Z.body1Accent, {
        [typography_module/* default */.Z.body2Accent]: isMobile
      }, start_date_module.startDate)
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/beginner-scheduling/__time-selection-widget/time-selection-widget.component.tsx + 2 modules
var time_selection_widget_component = __webpack_require__(51311);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/start-date/change-start-date.tsx














function ChangeStartDate(_ref) {
  let {
    readOnly
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
  const startDates = (0,effector_react/* useStore */.oR)($startDates);
  const selectedDate = (0,effector_react/* useStore */.oR)($selectedStartDate);
  const setSelectedStartDateIdEvent = (0,effector_react/* useEvent */.zX)(setSelectedStartDateId);
  const resetSelectedStartDateIdEvent = (0,effector_react/* useEvent */.zX)(resetSelectedStartDateId);
  const setFinalStartDateEvent = (0,effector_react/* useEvent */.zX)(setFinalStartDate);
  const onClose = () => setIsModalOpen(false);
  const onCancel = () => {
    resetSelectedStartDateIdEvent();
    onClose();
  };
  const onSave = () => {
    setFinalStartDateEvent(selectedDate.date);
    onClose();
  };
  const dates = startDates.map(_ref2 => {
    let {
      id,
      date
    } = _ref2;
    return {
      id,
      text: (0,format/* format */.WU)(date, "d MMMM, eeee", {
        locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
      })
    };
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      readOnly,
      onClick: () => setIsModalOpen(true),
      appearance: "secondary",
      "data-testid": "change-start-date",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "onboarding.confirmStep.startDateBlock.change"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      title: intl.formatMessage({
        id: "onboarding.confirmStep.startDateBlock.modal.title"
      }),
      subtitle: intl.formatMessage({
        id: "onboarding.confirmStep.startDateBlock.modal.subtitle"
      }),
      size: modal/* ModalSize */.Cg.Small,
      titleSize: modal/* TitleSize */.Jj.Small,
      overlay: "dark",
      showCloseButton: true,
      isVisible: isModalOpen,
      onClose,
      buttons: [{
        text: intl.formatMessage({
          id: "onboarding.confirmStep.startDateBlock.modal.cancel"
        }),
        appearance: "secondary",
        onClick: onCancel
      }, {
        text: intl.formatMessage({
          id: "onboarding.confirmStep.startDateBlock.modal.confirm"
        }),
        appearance: "primary",
        onClick: onSave
      }],
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(time_selection_widget_component/* TimeBlock */.T, {
        timeSlot: {
          label: intl.formatMessage({
            id: "onboarding.confirmStep.startDateBlock.modal.pickerLabel"
          }),
          type: "date",
          date: {
            allTimes: dates,
            onChange: setSelectedStartDateIdEvent,
            selectedTime: {
              id: selectedDate?.id,
              time: selectedDate?.date
            }
          }
        },
        isMobile: false
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/start-date/start-date.tsx













function StartDate(_ref) {
  let {
    readOnly
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const startDate = (0,effector_react/* useStore */.oR)($finalStartDate);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(start_date_module.startDateContainer),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: start_date_module.wrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
        "data-testid": "start-date",
        className: classnames_default()(typography_module/* default */.Z.body1Accent, {
          [typography_module/* default */.Z.body2Accent]: isMobile
        }, start_date_module.startDate),
        children: startDate && (0,format/* format */.WU)(startDate, "eeee, d MMMM", {
          locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ChangeStartDate, {
      readOnly
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/tutor/tutor.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tutor_module = ({"container":"tutor-module__container--JjOaL","left-block":"tutor-module__left-block--ujS4Y","leftBlock":"tutor-module__left-block--ujS4Y","avatar":"tutor-module__avatar--HY081","avatar-skeleton":"tutor-module__avatar-skeleton--Yq6_K","avatarSkeleton":"tutor-module__avatar-skeleton--Yq6_K"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/tutor/skeleton.tsx








const TutorSkeleton = () => {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: tutor_module.container,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: tutor_module.leftBlock,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
          className: tutor_module.avatarSkeleton,
          containerClassName: tutor_module.avatar,
          circle: true
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(skeleton/* Skeleton */.O, {
          width: 100,
          className: classnames_default()(typography_module/* default */.Z.body1Accent, {
            [typography_module/* default */.Z.body2Accent]: isMobile
          })
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
// EXTERNAL MODULE: ../shared/src/utils/url.ts
var url = __webpack_require__(52702);
;// CONCATENATED MODULE: ./src/components/tutor-card/tutor-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tutor_card_module = ({"card":"tutor-card-module__card--bWyOg","card-in-modal":"tutor-card-module__card-in-modal--oljdS","cardInModal":"tutor-card-module__card-in-modal--oljdS","avatar":"tutor-card-module__avatar--CL4jF","blocks":"tutor-card-module__blocks--XdKxY","block-title":"tutor-card-module__block-title--gj4ps","blockTitle":"tutor-card-module__block-title--gj4ps","description-block":"tutor-card-module__description-block--nF4Pl","descriptionBlock":"tutor-card-module__description-block--nF4Pl","description":"tutor-card-module__description--gdKip","interests":"tutor-card-module__interests--xtfZc","interest":"tutor-card-module__interest--Y11Fr"});
;// CONCATENATED MODULE: ./src/components/tutor-card/tutor-card.tsx














function TutorCard(_ref) {
  let {
    description,
    avatar,
    interests = array_utils/* emptyArray */.ow,
    inModal = false
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const hasInterests = interests.length > 0;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(tutor_card_module.card, {
      [tutor_card_module.cardInModal]: inModal
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: tutor_card_module.avatar,
      style: {
        backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)((0,avatar_utils/* getYandexAvatarById */.m$)({
          id: avatar,
          size: 200
        }))
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: tutor_card_module.blocks,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
        className: classnames_default()({
          [tutor_card_module.descriptionBlock]: hasInterests
        }),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()({
            [typography_module/* default */.Z.headline4Accent]: !isMobile,
            [typography_module/* default */.Z.body2Accent]: isMobile
          }, tutor_card_module.blockTitle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "autoOnboardingPage.selectTutorStep.tutorCard.aboutText"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
          className: classnames_default()({
            [typography_module/* default */.Z.body1]: !isMobile,
            [typography_module/* default */.Z.body2]: isMobile
          }, tutor_card_module.description),
          children: description
        })]
      }), hasInterests && /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
          className: classnames_default()({
            [typography_module/* default */.Z.headline4Accent]: !isMobile,
            [typography_module/* default */.Z.body2Accent]: isMobile
          }, tutor_card_module.blockTitle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "autoOnboardingPage.selectTutorStep.tutorCard.interests"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: tutor_card_module.interests,
          children: interests.map(interest => /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: classnames_default()({
              [typography_module/* default */.Z.body1Accent]: !isMobile,
              [typography_module/* default */.Z.body2Accent]: isMobile
            }, tutor_card_module.interest),
            children: interest
          }, interest))
        })]
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/components/tutor/tutor.tsx













function Tutor(_ref) {
  let {
    tutor,
    readOnly
  } = _ref;
  const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    avatar,
    interests,
    name,
    description
  } = tutor.info;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: tutor_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: tutor_module.leftBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        className: tutor_module.avatar,
        src: (0,avatar_utils/* getYandexAvatarById */.m$)({
          id: avatar,
          size: 68
        }),
        alt: "tutor-avatar"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()(typography_module/* default */.Z.body1Accent, {
          [typography_module/* default */.Z.body2Accent]: isMobile
        }),
        children: name
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      readOnly,
      appearance: "secondary",
      onClick: () => setIsModalOpen(true),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "onboarding.confirmStep.tutorBlock.moreInfo"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
      size: modal/* ModalSize */.Cg.Huge,
      showCloseButton: true,
      isVisible: isModalOpen,
      overlay: "dark",
      onClose: () => setIsModalOpen(false),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TutorCard, {
        inModal: true,
        description,
        avatar,
        interests
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/model.ts





const $isTutorLoaded = (0,effector/* combine */.$e)($tutor, student_attributes/* $attributesSelectedTutor */.H_, loadTutorFx.pending, (tutor, attributesSelectedTutor, loadTutorFxPending) => {
  if (!tutor || !attributesSelectedTutor || loadTutorFxPending) {
    return false;
  }
  return tutor.info.id === attributesSelectedTutor.id;
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/confirm-onboarding.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const confirm_onboarding_module = ({"title":"confirm-onboarding-module__title--qG4vx","blocks":"confirm-onboarding-module__blocks--EdWcr","block":"confirm-onboarding-module__block--wkMJy","block-title":"confirm-onboarding-module__block-title--iH13J","blockTitle":"confirm-onboarding-module__block-title--iH13J"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/confirm-onboarding.tsx




















function ConfirmOnboarding(_ref) {
  let {
    readOnly
  } = _ref;
  const headerId = (0,react.useId)();
  const tutorBlockId = (0,react.useId)();
  const scheduleBlockId = (0,react.useId)();
  const startDateBlockId = (0,react.useId)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const tutor = (0,effector_react/* useStore */.oR)($tutor);
  const isLoadedTutor = (0,effector_react/* useStore */.oR)($isTutorLoaded);
  const startDates = (0,effector_react/* useStore */.oR)($startDates);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    "aria-labelledby": headerId,
    "data-testid": "confirm-onboarding",
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      id: headerId,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()(typography_module/* default */.Z.headline3, {
          [typography_module/* default */.Z.headline4Accent]: isMobile
        }, confirm_onboarding_module.title),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "onboarding.confirmStep.title"
        })
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: confirm_onboarding_module.blocks,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
        className: confirm_onboarding_module.block,
        "aria-labelledby": tutorBlockId,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          id: tutorBlockId,
          className: classnames_default()(typography_module/* default */.Z.body2Accent, confirm_onboarding_module.blockTitle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "onboarding.confirmStep.tutorBlock.title"
          })
        }), isLoadedTutor && tutor ? /* @__PURE__ */(0,jsx_runtime.jsx)(Tutor, {
          readOnly,
          tutor
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)(TutorSkeleton, {})]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
        className: confirm_onboarding_module.block,
        "aria-labelledby": scheduleBlockId,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          id: scheduleBlockId,
          className: classnames_default()(typography_module/* default */.Z.body2Accent, confirm_onboarding_module.blockTitle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "onboarding.confirmStep.scheduleBlock.title"
          })
        }), isLoadedTutor ? /* @__PURE__ */(0,jsx_runtime.jsx)(Schedule, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(ScheduleSkeleton, {})]
      }), startDates.length ? /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
        className: confirm_onboarding_module.block,
        "aria-labelledby": startDateBlockId,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
          id: startDateBlockId,
          className: classnames_default()(typography_module/* default */.Z.body2Accent, confirm_onboarding_module.blockTitle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "onboarding.confirmStep.startDateBlock.title"
          })
        }), isLoadedTutor ? /* @__PURE__ */(0,jsx_runtime.jsx)(StartDate, {
          readOnly
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)(StartDateSkeleton, {})]
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(NoStartDateWarning, {})]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding/index.ts



;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-button/error-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_button_module = ({"button":"error-button-module__button--_08lr"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-button/error-button.tsx





const ErrorButton = _ref => {
  let {
    loading = false,
    readOnly = loading,
    description,
    appearance = "primary",
    onClick,
    children,
    testId
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    className: error_button_module.button,
    appearance,
    onClick,
    loading,
    readOnly,
    "aria-disabled": loading,
    "aria-description": description,
    "data-testid": testId,
    children
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-button-block/error-button-block.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_button_block_module = ({"buttons-block":"error-button-block-module__buttons-block--_85p2","buttonsBlock":"error-button-block-module__buttons-block--_85p2","button":"error-button-block-module__button--rw493"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-button-block/error-button-block.tsx




const ErrorButtonBlock = _ref => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: error_button_block_module.buttonsBlock,
    children
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-wrapper/error-wrapper.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_wrapper_module = ({"main":"error-wrapper-module__main--T5K77","container":"error-wrapper-module__container--nzd3M","image":"error-wrapper-module__image--oCg8I","title":"error-wrapper-module__title--T3G4W","alert":"error-wrapper-module__alert--EltEx"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-wrapper/error-wrapper.tsx









const ErrorWrapper = _ref => {
  let {
    title,
    alertText,
    children,
    testId
  } = _ref;
  const titleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("main", {
    className: error_wrapper_module.main,
    "aria-labelledby": titleId,
    "data-testid": testId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
      className: error_wrapper_module.container,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        className: error_wrapper_module.image,
        src: "https://flowstatic.s3.yandex.net/ui-files/autoonboarding-error.svg",
        alt: ""
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("header", {
        id: titleId,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, error_wrapper_module.title),
          children: title
        })
      }), alertText && /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
        className: error_wrapper_module.alert,
        type: model_model/* AlertType */.N.INFO,
        text: alertText
      })]
    }), children]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/error-with-button/error-with-button.tsx






const ErrorWithButton = _ref => {
  let {
    title,
    alertText,
    btnText,
    onClick,
    testId,
    loading = false
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorWrapper, {
    title,
    alertText,
    testId,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorButtonBlock, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorButton, {
        loading,
        description: alertText,
        onClick,
        testId: "error-button",
        children: btnText
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding-step-error/model/handle-confirm-onboarding-error.ts



const handleConfirmOnboardingError = (0,effector/* createEvent */.yM)();
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/model/confirm-onboarding-step-screen-error.ts






const $confirmOnboardingStepScreenError = $confirmOnboardingError.map(error => error && isErrorScreen(error) ? error : null);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding-step-error/model/tutor-has-permanently-slots.ts































const handleTutorHasPermanentlySlotsErrorFx = (0,effector/* attach */.ub)({
  effect: student_attributes/* saveStudentAttributesFx */.YP
});
(0,effector/* sample */.UP)({
  clock: handleConfirmOnboardingError,
  source: {
    confirmOnboardingStepError: $confirmOnboardingStepScreenError,
    currentProductBusinessId: user/* $currentProductBusinessId */.Wu,
    onboardingStates: entities_onboarding/* $onboardingStates */.pR,
    attributesSelectedTutor: student_attributes/* $attributesSelectedTutor */.H_
  },
  filter: params => {
    const {
      confirmOnboardingStepError,
      currentProductBusinessId,
      attributesSelectedTutor
    } = params;
    return confirmOnboardingStepError instanceof TutorHasPermanentlySlotsError && !!currentProductBusinessId && !!attributesSelectedTutor;
  },
  fn: _ref => {
    let {
      currentProductBusinessId,
      onboardingStates,
      confirmOnboardingStepError,
      attributesSelectedTutor
    } = _ref;
    const permanentlySlotsMap = (0,indexBy/* default */.Z)(formatSlotDate, confirmOnboardingStepError.permanentlySlots);
    const selectedSlots = attributesSelectedTutor.selectedSlots.filter(selectedSlot => !permanentlySlotsMap[formatSlotDate(selectedSlot)]);
    return {
      onboardingStates: new Map([...onboardingStates, [currentProductBusinessId, student_attributes/* OnboardingFSMState */.Cv.SelectTutor]]),
      selectedTutor: {
        ...attributesSelectedTutor,
        selectedSlots
      }
    };
  },
  target: handleTutorHasPermanentlySlotsErrorFx
});
(0,effector/* sample */.UP)({
  clock: handleTutorHasPermanentlySlotsErrorFx.done,
  source: {
    studentAttributes: student_attributes/* $studentAttributes */.lo,
    autoOnboardingConfirmGateStatus: autoOnboardingConfirmGate.status
  },
  filter: checkHandlingTutorHasPermanentlySlotsParams,
  fn: _ref2 => {
    let {
      studentAttributes
    } = _ref2;
    return (0,tutor_model/* makeTutorId */.Nr)(studentAttributes.selectedTutor.id);
  },
  target: setCurrentTutorId
});
function checkHandlingTutorHasPermanentlySlotsParams(params) {
  return params.autoOnboardingConfirmGateStatus && params.studentAttributes !== null && params.studentAttributes.selectedTutor != null;
}
function formatSlotDate(date) {
  return (0,format/* format */.WU)(date, "i.H.mm");
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding-step-error/model/tutor-not-available.ts


























const handleTutorNotAvailableErrorFx = (0,effector/* attach */.ub)({
  effect: student_attributes/* saveStudentAttributesFx */.YP
});
(0,effector/* sample */.UP)({
  clock: handleConfirmOnboardingError,
  source: {
    confirmOnboardingStepError: $confirmOnboardingStepScreenError,
    currentProductBusinessId: user/* $currentProductBusinessId */.Wu,
    onboardingStates: entities_onboarding/* $onboardingStates */.pR
  },
  filter: _ref => {
    let {
      confirmOnboardingStepError,
      currentProductBusinessId
    } = _ref;
    return confirmOnboardingStepError instanceof TutorNotAvailableError && !!currentProductBusinessId;
  },
  fn: _ref2 => {
    let {
      currentProductBusinessId,
      onboardingStates
    } = _ref2;
    if (!currentProductBusinessId) {
      throw new not_found_object_error/* NotFoundObjectError */.m("currentProductBusinessId");
    }
    return {
      onboardingStates: new Map([...onboardingStates, [currentProductBusinessId, student_attributes/* OnboardingFSMState */.Cv.SelectTutor]]),
      selectedTutor: null
    };
  },
  target: handleTutorNotAvailableErrorFx
});
(0,effector/* sample */.UP)({
  clock: handleTutorNotAvailableErrorFx.done,
  filter: autoOnboardingConfirmGate.status,
  target: resetCurrentTutor
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding-step-error/utils.ts



const getErrorTextKeys = error => {
  if (error instanceof TutorNotAvailableError) {
    return {
      title: "autoOnboardingPage.confirmStep.error.tutorNotAvailable.title",
      description: "autoOnboardingPage.confirmStep.error.tutorNotAvailable.description",
      button: "autoOnboardingPage.confirmStep.error.tutorNotAvailable.button"
    };
  }
  return {
    title: "autoOnboardingPage.confirmStep.error.permanentlySlots.title",
    description: "autoOnboardingPage.confirmStep.error.permanentlySlots.description",
    button: "autoOnboardingPage.confirmStep.error.permanentlySlots.button"
  };
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/confirm-onboarding-step-error/confirm-onboarding-step-error.tsx











function ConfirmOnboardingStepError(_ref) {
  let {
    error
  } = _ref;
  const handleTutorHasPermanentlySlotsErrorFxPending = (0,effector_react/* useStore */.oR)(handleTutorHasPermanentlySlotsErrorFx.pending);
  const handleTutorNotAvailableErrorFxPending = (0,effector_react/* useStore */.oR)(handleTutorNotAvailableErrorFx.pending);
  const handleConfirmOnboardingErrorEvent = (0,effector_react/* useEvent */.zX)(handleConfirmOnboardingError);
  const intl = (0,useIntl/* default */.Z)();
  const loading = handleTutorHasPermanentlySlotsErrorFxPending || handleTutorNotAvailableErrorFxPending;
  const {
    button,
    description,
    title
  } = getErrorTextKeys(error);
  const testId = error instanceof TutorNotAvailableError ? "confirm-tutor-not-available-error" : "confirm-tutor-has-permanently-slots-error";
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorWithButton, {
    testId,
    onClick: handleConfirmOnboardingErrorEvent,
    title: intl.formatMessage({
      id: title
    }),
    loading,
    btnText: intl.formatMessage({
      id: button
    }),
    alertText: intl.formatMessage({
      id: description
    })
  });
}
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/schedule-loading/schedule-loading.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const schedule_loading_module = ({"section":"schedule-loading-module__section--DEu_L","image":"schedule-loading-module__image--Z3AJu","message":"schedule-loading-module__message--saWSK"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/components/schedule-loading/schedule-loading.tsx










const TutorScheduleLoading = () => {
  const labelId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: schedule_loading_module.section,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: schedule_loading_module.image,
      alt: "",
      src: "https://flowstatic.s3.yandex.net/ui-files/autoonboarding-schedule-loading.svg"
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(schedule_loading_module.section, accessibility_module/* default */.Z.focusVisibleWithin),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        id: labelId,
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, schedule_loading_module.message),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "autoOnboardingPage.scheduleLoading.text"
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("progress", {
        className: accessibility_module/* default */.Z.srOnly,
        "aria-labelledby": labelId
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/confirm-onboarding/confirm-onboarding-step.tsx























const ConfirmOnboardingStep = (0,react.memo)(() => {
  const intl = (0,useIntl/* default */.Z)();
  const confirmOnboardingStepScreenError = (0,effector_react/* useStore */.oR)($confirmOnboardingStepScreenError);
  const confirmOnboardingStepError = (0,effector_react/* useStore */.oR)($confirmOnboardingStepError);
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const confirmOnboardingEvent = (0,effector_react/* useEvent */.zX)(confirmOnboardingFx);
  const loadAttributesEffect = (0,effector_react/* useEvent */.zX)(student_attributes/* loadStudentAttributesFx */.ZK);
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const readOnly = savingAutoOnboardingStep !== null;
  const startDates = (0,effector_react/* useStore */.oR)($startDates);
  const [scheduleLoading, setScheduleLoading] = (0,react.useState)(false);
  const resetConfirmOnboardingStepEvent = (0,effector_react/* useEvent */.zX)(resetConfirmOnboardingStepError);
  const goToPreCuratorOnboardingScreen = usePreCuratorOnboardingScreen();
  (0,effector_react/* useGate */.DD)(autoOnboardingConfirmGate);
  useWillUnmount(resetConfirmOnboardingStepEvent);
  (0,react.useEffect)(() => {
    const attributesPolling = (0,create_polling/* createPolling */.$)(loadAttributesEffect, {
      delay: 5e3,
      limit: 36
    });
    const unsubscribe = confirmOnboardingFx.done.watch(() => {
      attributesPolling.start();
      setScheduleLoading(true);
    });
    return () => {
      unsubscribe();
      attributesPolling.stop();
    };
  }, [loadAttributesEffect]);
  const confirmOnboarding = (0,react.useCallback)(() => {
    resetConfirmOnboardingStepEvent();
    void confirmOnboardingEvent();
  }, [confirmOnboardingEvent, resetConfirmOnboardingStepEvent]);
  (0,react.useEffect)(() => {
    if (!confirmOnboardingStepError) {
      return;
    }
    const key = confirmOnboardingStepError instanceof TutorHasOccupiedSlotsError ? "autoOnboardingPage.confirmStep.error.occupiedSlots.title" : "unknownError.title";
    toast/* toastNotificationService */.B.showError(intl.formatMessage({
      id: key
    }));
  }, [confirmOnboardingStepError, intl]);
  if (confirmOnboardingStepScreenError) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ConfirmOnboardingStepError, {
      error: confirmOnboardingStepScreenError
    });
  }
  const hasStartDates = !!startDates.length;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StepWrapper, {
      "data-testid": "confirm-onboarding-step",
      children: scheduleLoading ? /* @__PURE__ */(0,jsx_runtime.jsx)(TutorScheduleLoading, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(ConfirmOnboarding, {
        readOnly
      })
    }), !scheduleLoading && /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
      onNext: hasStartDates ? confirmOnboarding : void 0,
      onBack: goToPreviousAutoOnboardingState,
      onDontKnowHowToChoose: hasStartDates ? void 0 : goToPreCuratorOnboardingScreen
    })]
  });
});
ConfirmOnboardingStep.displayName = "ConfirmOnboardingStep";
// EXTERNAL MODULE: ./src/widgets/student-contact-info/index.ts + 6 modules
var student_contact_info = __webpack_require__(59411);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/contacts-step/contacts-step.tsx










const ContactsStep = () => {
  const nextStepEvent = (0,effector_react/* useEvent */.zX)(saveCurrentStepFx);
  const postAutoOnboardingStartEvent = (0,effector_react/* useEvent */.zX)(autoOnboardingAnalyticEvents.startFx);
  const currentProductBusinessId = (0,effector_react/* useStore */.oR)(user/* $currentProductBusinessId */.Wu);
  (0,react.useEffect)(() => void postAutoOnboardingStartEvent(), [postAutoOnboardingStartEvent]);
  const onSaveContacts = (0,react.useCallback)(() => void nextStepEvent({}), [nextStepEvent]);
  const isKidsProduct = (0,product_model/* getIsKidsBusinessProduct */.dJ)(currentProductBusinessId);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(student_contact_info/* ContactsScreen */.H, {
    onSaveContacts,
    isKidsProduct
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-long-select/model.ts








const $lessonDurationHintKey = (0,effector/* combine */.$e)($howManyTimesPerWeek, $lessonDuration, (howManyTimes, lessonDuration) => getLessonDurationHintKey({
  howManyTimes,
  lessonDuration
}));
function getLessonDurationHintKey(_ref) {
  let {
    howManyTimes,
    lessonDuration
  } = _ref;
  if (howManyTimes === 1) {
    return "intensity.lessonDuration.hint.oneLesson";
  }
  if (lessonDuration === SPEAKING_SESSION_DURATION_BY_PRODUCT.general.single) {
    return "intensity.lessonDuration.hint.thirtyMinutesLesson";
  }
  return "intensity.lessonDuration.hint.sixtyMinutesLesson";
}
const GENERAL_BUSINESS = [product_model/* BusinessProductId */.HV.ProductA, product_model/* BusinessProductId */.HV.GeneralB1, product_model/* BusinessProductId */.HV.GeneralB2, product_model/* BusinessProductId */.HV.GeneralC1];
function getBusinessLessonDurationVariants(businessProductId, howManyTimesPerWeek) {
  if (!businessProductId) {
    return [];
  }
  if ((0,product_model/* getIsBusBusinessProduct */.Se)(businessProductId)) {
    logger/* Logger */.Yd.captureWarning(`Unexpected businessProductId: ${businessProductId}`, {
      businessProductId
    });
    return [];
  }
  if (GENERAL_BUSINESS.includes(businessProductId)) {
    return [{
      value: SPEAKING_SESSION_DURATION_BY_PRODUCT.general.single,
      disabled: howManyTimesPerWeek === 2
    }, {
      value: SPEAKING_SESSION_DURATION_BY_PRODUCT.general.double,
      disabled: false
    }];
  }
  return [{
    value: SPEAKING_SESSION_DURATION_BY_PRODUCT.general.single,
    disabled: false
  }, {
    value: SPEAKING_SESSION_DURATION_BY_PRODUCT.general.double,
    disabled: false
  }];
}
const $lessonDurationVariants = (0,effector/* combine */.$e)($howManyTimesPerWeek, user/* $currentProductBusinessId */.Wu, (howManyTimesPerWeek, productType) => getBusinessLessonDurationVariants(productType, howManyTimesPerWeek));
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-long-select/how-long-select.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const how_long_select_module = ({"block":"how-long-select-module__block--gT03M","description":"how-long-select-module__description--NSBlG","checkbox":"how-long-select-module__checkbox--yv09D","checkbox-item":"how-long-select-module__checkbox-item--ZQHFr","checkboxItem":"how-long-select-module__checkbox-item--ZQHFr","disabled":"how-long-select-module__disabled--aDHyU","alert":"how-long-select-module__alert--YkvCY"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-long-select/how-long-select.tsx

















const HowLongSelect = _ref => {
  let {
    readOnly
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const howLongVariants = (0,effector_react/* useStore */.oR)($lessonDurationVariants);
  const selectedVariant = (0,effector_react/* useStore */.oR)($lessonDuration);
  const setHowLongFn = (0,effector_react/* useEvent */.zX)(setLessonDuration);
  const hintKey = (0,effector_react/* useStore */.oR)($lessonDurationHintKey);
  const howManyTimes = (0,effector_react/* useStore */.oR)($howManyTimesPerWeek);
  const titleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: how_long_select_module.block,
    "data-testid": "HowLongSelect",
    "aria-labelledby": titleId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
      id: titleId,
      className: classnames_default()({
        [typography_module/* default */.Z.headline4Accent]: isMobile
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "howLong.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: how_long_select_module.description,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "howLong.subtitle",
        tagName: "p"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: how_long_select_module.checkbox,
      role: "radiogroup",
      children: howLongVariants.map(variant => {
        const {
          value,
          disabled
        } = variant;
        const handleChange = () => setHowLongFn(value);
        const checked = value === selectedVariant;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
          name: "how-long",
          appearance: "button",
          checked,
          disabled,
          readOnly,
          onChange: handleChange,
          ariaDescription: intl.formatMessage({
            id: getLessonDurationHintKey({
              howManyTimes,
              lessonDuration: value
            })
          }),
          className: classnames_default()(how_long_select_module.checkboxItem, {
            [how_long_select_module.disabled]: disabled
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "howLong.minutes",
            values: {
              minutes: value
            }
          })
        }, value);
      })
    }), hintKey && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: how_long_select_module.alert,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
        type: model_model/* AlertType */.N.INFO,
        text: intl.formatMessage({
          id: hintKey
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-many-times-select/constants.ts


const HOW_MANY_LESSONS_PER_WEEK_GENERAL = [2, 3, 4, 5, 6, 7];
const HOW_MANY_LESSONS_PER_WEEK_BUS = [2, 3, 4, 5, 6, 7];
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-many-times-select/model.ts





function getHowManyTimesHintKey(howManyTimes) {
  switch (howManyTimes) {
    case 1:
      return "intensity.howManyTimes.hint.oneLesson";
    case 2:
      return "intensity.howManyTimes.hint.twoLessons";
    case 3:
      return "intensity.howManyTimes.hint.threeLessons";
    case 4:
      return "intensity.howManyTimes.hint.fourLessons";
    default:
      return "intensity.howManyTimes.hint.manyLessons";
  }
}
const $howManyTimesHintKey = $howManyTimesPerWeek.map(value => getHowManyTimesHintKey(value));
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-many-times-select/how-many-times-select.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const how_many_times_select_module = ({"block":"how-many-times-select-module__block--rCrkJ","checkbox":"how-many-times-select-module__checkbox--GFtz7","checkbox-item":"how-many-times-select-module__checkbox-item--_9oU6","checkboxItem":"how-many-times-select-module__checkbox-item--_9oU6","disabled":"how-many-times-select-module__disabled--gs756","alert":"how-many-times-select-module__alert--wCg9R"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/components/how-many-times-select/how-many-times-select.tsx


















const HowManyTimesSelect = _ref => {
  let {
    readOnly,
    isBusBusinessProduct
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  const howManyTimesVariants = isBusBusinessProduct ? HOW_MANY_LESSONS_PER_WEEK_BUS : HOW_MANY_LESSONS_PER_WEEK_GENERAL;
  const selectedVariant = (0,effector_react/* useStore */.oR)($howManyTimesPerWeek);
  const hintKey = (0,effector_react/* useStore */.oR)($howManyTimesHintKey);
  const setHowManyTimesFn = (0,effector_react/* useEvent */.zX)(setHowManyTimesPerWeek);
  const titleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    "data-testid": "HowManyTimesSelect",
    className: how_many_times_select_module.block,
    "aria-labelledby": titleId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
      id: titleId,
      className: classnames_default()({
        [typography_module/* default */.Z.headline4Accent]: isMobile
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "howManyTimes.title"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: how_many_times_select_module.checkbox,
      role: "radiogroup",
      children: howManyTimesVariants.map(item => {
        const handleChange = () => {
          setHowManyTimesFn(item);
        };
        return /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
          name: "how-many-times",
          appearance: "button",
          checked: item === selectedVariant,
          readOnly,
          onChange: handleChange,
          ariaDescription: intl.formatMessage({
            id: getHowManyTimesHintKey(item)
          }),
          className: how_many_times_select_module.checkboxItem,
          children: item
        }, item);
      })
    }), hintKey && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: how_many_times_select_module.alert,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
        type: model_model/* AlertType */.N.INFO,
        text: intl.formatMessage({
          id: hintKey
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/model/hydrate.ts





const intensityDidMount = (0,effector/* createEvent */.yM)();
const hydrateIntensity = (0,effector/* createEvent */.yM)();
(0,effector/* sample */.UP)({
  clock: intensityDidMount,
  source: {
    howManyTimesPerWeek: student_attributes/* $howManyTimesPerWeek */.f2,
    lessonDuration: student_attributes/* $lessonDuration */.fQ
  },
  filter: args => args.howManyTimesPerWeek !== null && args.howManyTimesPerWeek > 0,
  target: hydrateIntensity
});
(0,effector/* sample */.UP)({
  source: hydrateIntensity,
  fn: _ref => {
    let {
      howManyTimesPerWeek
    } = _ref;
    return howManyTimesPerWeek;
  },
  target: $howManyTimesPerWeek
});
(0,effector/* sample */.UP)({
  source: hydrateIntensity,
  fn: _ref2 => {
    let {
      lessonDuration
    } = _ref2;
    return lessonDuration;
  },
  target: $lessonDurationSelected
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/intensity.tsx









const Intensity = _ref => {
  let {
    readOnly,
    isBusBusinessProduct
  } = _ref;
  const intensityDidMountEvent = (0,effector_react/* useEvent */.zX)(intensityDidMount);
  (0,react.useEffect)(() => {
    intensityDidMountEvent();
  }, []);
  (0,effector_react/* useGate */.DD)(intensityGate);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(HowManyTimesSelect, {
      readOnly,
      isBusBusinessProduct
    }), !isBusBusinessProduct && /* @__PURE__ */(0,jsx_runtime.jsx)(HowLongSelect, {
      readOnly
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity/index.ts



;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/intensity/intensity-step.tsx















const IntensityStep = (0,react.memo)(() => {
  const intl = (0,useIntl/* default */.Z)();
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const setHelpModalContentEvent = (0,effector_react/* useEvent */.zX)(setHelpModalContent);
  const submitIntensityEvent = (0,effector_react/* useEvent */.zX)(submitIntensity);
  const howManyTimesPerWeek = (0,effector_react/* useStore */.oR)($howManyTimesPerWeek);
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const readOnly = savingAutoOnboardingStep !== null;
  const isBusBusinessProduct = (0,product_model/* useIsBusBusinessProduct */.x4)();
  const handleSetHelpModalContent = (0,react.useCallback)(() => {
    setHelpModalContentEvent({
      title: intl.formatMessage({
        id: "intensityModal.title"
      }),
      subtitle: intl.formatMessage({
        id: "intensityModal.text"
      }),
      needCuratorButtonText: intl.formatMessage({
        id: "onboardingHelpModal.needCuratorOnboarding"
      }),
      closeButtonText: intl.formatMessage({
        id: "onboardingHelpModal.ok"
      })
    });
  }, [intl, setHelpModalContentEvent]);
  const handleNext = (0,react.useCallback)(() => {
    if (howManyTimesPerWeek > INTENSITY_TIMES_PER_WEEK_THRESHOLD) {
      setHelpModalContentEvent({
        title: intl.formatMessage({
          id: "intensityModal.tooIntensive.title"
        }),
        subtitle: isBusBusinessProduct ? "" : intl.formatMessage({
          id: "intensityModal.tooIntensive.text"
        }),
        needCuratorButtonText: intl.formatMessage({
          id: "onboardingHelpModal.curatorOnboarding"
        }),
        closeButtonText: intl.formatMessage({
          id: "onboardingHelpModal.decreaseIntensity"
        })
      });
    } else {
      submitIntensityEvent();
    }
  }, [howManyTimesPerWeek, intl, setHelpModalContentEvent, submitIntensityEvent, isBusBusinessProduct]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StepWrapper, {
      dataTestId: "IntensityStep",
      "aria-label": intl.formatMessage({
        id: "intensityModal.mainAriaLabel"
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Intensity, {
        readOnly,
        isBusBusinessProduct
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
      onDontKnowHowToChoose: isBusBusinessProduct ? void 0 : handleSetHelpModalContent,
      onNext: handleNext,
      onBack: goToPreviousAutoOnboardingState
    })]
  });
});
IntensityStep.displayName = "IntensityStep";
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/preferences/preferences-step.tsx











const PreferencesStep = () => {
  const preferencesDidMountEvent = (0,effector_react/* useEvent */.zX)(preferencesDidMount);
  const submitPreferencesEvent = (0,effector_react/* useEvent */.zX)(submitPreferences);
  const skipAutoOnboardingStep = (0,effector_react/* useEvent */.zX)(skipCurrentStepFx);
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const readOnly = savingAutoOnboardingStep !== null;
  (0,effector_react/* useGate */.DD)(preferencesGate);
  (0,react.useEffect)(() => {
    preferencesDidMountEvent();
  }, [preferencesDidMountEvent]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StepWrapper, {
      dataTestId: "PreferencesStep",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(PreferencesBlock, {
        readOnly
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
      onBack: goToPreviousAutoOnboardingState,
      onSkip: skipAutoOnboardingStep,
      onNext: submitPreferencesEvent
    })]
  });
};
// EXTERNAL MODULE: ../shared/src/utils/storage/index.ts + 4 modules
var storage = __webpack_require__(81597);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/how-to-choose-time-slots-modal.ts



const [$howToChooseTimeSlotsModalContent, setHowToChooseTimeSlotsModalContent, resetHowToChooseTimeSlotsModalContent] = (0,makeStore/* makeStore */.n)(null);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-time-slots/how-to-choose-time-slots-modal/how-to-choose-time-slots-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const how_to_choose_time_slots_modal_module = ({"break":"how-to-choose-time-slots-modal-module__break--hneOC","video":"how-to-choose-time-slots-modal-module__video--bZKSj"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-time-slots/how-to-choose-time-slots-modal/how-to-choose-time-slots-modal.tsx












const HowToChooseTimeSlotsModal = () => {
  const intl = (0,useIntl/* default */.Z)();
  const howToChooseTimeSlotsModalContent = (0,effector_react/* useStore */.oR)($howToChooseTimeSlotsModalContent);
  const {
    hideNeedCuratorButton
  } = howToChooseTimeSlotsModalContent ?? {
    hideNeedCuratorButton: false
  };
  const goToPreCuratorOnboardingScreen = usePreCuratorOnboardingScreen();
  const handleClose = (0,effector_react/* useEvent */.zX)(resetHowToChooseTimeSlotsModalContent);
  const handleOnPreCuratorOnboardingScreen = (0,react.useCallback)(() => {
    goToPreCuratorOnboardingScreen();
    handleClose();
  }, [goToPreCuratorOnboardingScreen, handleClose]);
  const title = (0,react.useMemo)(() => /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
    className: how_to_choose_time_slots_modal_module.break,
    children: intl.formatMessage({
      id: "autoOnboardingPage.selectTimeSlotsModal.title"
    })
  }), [intl]);
  const subtitle = (0,react.useMemo)(() => /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      className: how_to_choose_time_slots_modal_module.break,
      children: intl.formatMessage({
        id: "autoOnboardingPage.selectTimeSlotsModal.videoInstruction"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
      className: how_to_choose_time_slots_modal_module.break,
      children: intl.formatMessage({
        id: "autoOnboardingPage.selectTimeSlotsModal.text"
      })
    })]
  }), [intl]);
  const buttons = (0,react.useMemo)(() => {
    const result = [];
    if (!hideNeedCuratorButton) {
      result.push({
        text: intl.formatMessage({
          id: "onboardingHelpModal.needCuratorOnboarding"
        }),
        appearance: "secondary",
        onClick: handleOnPreCuratorOnboardingScreen
      });
    }
    result.push({
      text: intl.formatMessage({
        id: "onboardingHelpModal.ok"
      }),
      appearance: "primary",
      onClick: handleClose
    });
    return result;
  }, [handleClose, handleOnPreCuratorOnboardingScreen, hideNeedCuratorButton, intl]);
  const isVisibleModal = howToChooseTimeSlotsModalContent !== null;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* TinyModal */.WR, {
    onClose: handleClose,
    isVisible: isVisibleModal,
    overlay: "dark",
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* ModalContent */.hz, {
      title,
      subtitle,
      showCloseButton: true,
      buttons
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-time-slots/select-time-slots.tsx


















const SelectTimeSlotsStep = (0,react.memo)(() => {
  const intl = (0,useIntl/* default */.Z)();
  const submitSelectTimeSlotsEvent = (0,effector_react/* useEvent */.zX)(submitSelectTimeSlots);
  const setHowToChooseTimeSlotsModalContentEvent = (0,effector_react/* useEvent */.zX)(setHowToChooseTimeSlotsModalContent);
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const readOnly = savingAutoOnboardingStep !== null;
  const currentProductBusinessId = (0,effector_react/* useStore */.oR)(user/* $currentProductBusinessId */.Wu);
  const isKidsOrTeensProduct = (0,react.useMemo)(() => (0,product_model/* getIsKidsBusinessProduct */.dJ)(currentProductBusinessId) || (0,product_model/* getIsTeensBusinessProduct */.am)(currentProductBusinessId), [currentProductBusinessId]);
  (0,react.useEffect)(() => onInvalidSelectTimeSlots.watch(() => toast/* toastNotificationService */.B.showError(intl.formatMessage({
    id: "autoOnboardingPage.selectTimeSlots.invalid"
  }))), [intl]);
  (0,react.useEffect)(() => {
    if (!storage/* localStorageWrapper */.Y6.autoonboardingHideTimeSlotsHelpModal.isShown()) {
      setHowToChooseTimeSlotsModalContentEvent({
        hideNeedCuratorButton: true
      });
      storage/* localStorageWrapper */.Y6.autoonboardingHideTimeSlotsHelpModal.setAsShown();
    }
  });
  (0,effector_react/* useGate */.DD)(selectTimeSlotsGate);
  const postAutoOnboardingHelpEvent = (0,effector_react/* useEvent */.zX)(autoOnboardingAnalyticEvents.helpFx);
  const handleSetHelpModalContent = (0,react.useCallback)(() => {
    void postAutoOnboardingHelpEvent();
    setHowToChooseTimeSlotsModalContentEvent({});
  }, [postAutoOnboardingHelpEvent, setHowToChooseTimeSlotsModalContentEvent]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StepWrapper, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(SelectTimeSlots, {
        readOnly,
        isKidsOrTeensProduct
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
      onDontKnowHowToChoose: handleSetHelpModalContent,
      onNext: submitSelectTimeSlotsEvent,
      onBack: goToPreviousAutoOnboardingState
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(HowToChooseTimeSlotsModal, {})]
  });
});
SelectTimeSlotsStep.displayName = "SelectTimeSlotsStep";
// EXTERNAL MODULE: ../shared/src/hooks/app/use-did-mount.ts
var use_did_mount = __webpack_require__(73058);
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/model/select-tutor-loading.ts




const [$isLoadingScreenVisible, setIsLoadingScreenVisible, resetIsLoadingScreenVisible] = (0,makeStore/* makeStore */.n)(true);
$isLoadingScreenVisible.reset(resetTutorsState);
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/weekday-slots/weekday-slots.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const weekday_slots_module = ({"title":"weekday-slots-module__title--QuUaS","slots":"weekday-slots-module__slots--SJM3U","occupied-slot":"weekday-slots-module__occupied-slot--lfinL","occupiedSlot":"weekday-slots-module__occupied-slot--lfinL"});
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/weekday-slots/weekday-slots.tsx




















const weekday_slots_TIME_FORMAT = "HH:mm";
const WeekdaySlots = _ref => {
  let {
    weekDay,
    slots
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const lessonDuration = (0,effector_react/* useStore */.oR)(student_attributes/* $lessonDuration */.fQ);
  const toggleSelectedTutorSlotEvent = (0,effector_react/* useEvent */.zX)(selectCurrentTutorSlot);
  const selectOccupiedSlotEvent = (0,effector_react/* useEvent */.zX)(selectOccupiedSlot);
  const titleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    "aria-labelledby": titleId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
      id: titleId,
      className: classnames_default()(isMobile ? typography_module/* default */.Z.body2Accent : typography_module/* default */.Z.body1Accent, weekday_slots_module.title),
      children: convertWeekDayToName(weekDay, (0,locale/* getDateFnsLocale */.G)(intl.locale))
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: weekday_slots_module.slots,
      role: "radiogroup",
      children: slots.map(slot => {
        const from = slot.date;
        const to = (0,addMinutes/* addMinutes */.m)(slot.date, lessonDuration ?? speakingSession_model/* DEFAULT_LESSON_DURATION */.ip);
        const isOccupied = slot.type === "occupied";
        return /* @__PURE__ */(0,jsx_runtime.jsx)(SlotWrapper, {
          onClick: selectOccupiedSlotEvent,
          slot,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(radio_button/* RadioButton */.E, {
            className: classnames_default()({
              [weekday_slots_module.occupiedSlot]: isOccupied
            }),
            appearance: "button",
            onChange: () => toggleSelectedTutorSlotEvent({
              weekDay,
              slotId: slot.id
            }),
            checked: slot.selected,
            name: weekDay,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: typography_module/* default */.Z.body2Accent,
              children: `${(0,format/* format */.WU)(from, weekday_slots_TIME_FORMAT, {
                locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
              })} - ${(0,format/* format */.WU)(to, weekday_slots_TIME_FORMAT, {
                locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
              })}`
            })
          })
        }, slot.id);
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/tutor-card-with-schedule/tutor-card-with-schedule.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tutor_card_with_schedule_module = ({"container":"tutor-card-with-schedule-module__container--gbdL6","name":"tutor-card-with-schedule-module__name--R9cQe","schedule":"tutor-card-with-schedule-module__schedule--X6UQ_","schedule-title":"tutor-card-with-schedule-module__schedule-title--SuwtX","scheduleTitle":"tutor-card-with-schedule-module__schedule-title--SuwtX","slots":"tutor-card-with-schedule-module__slots--DnSOw"});
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/tutor-card-with-schedule/tutor-card-with-schedule.tsx
















function TutorCardWithSchedule() {
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const tutor = (0,effector_react/* useStore */.oR)($tutorCardViewModel);
  if (!tutor) {
    throw new not_found_object_error/* NotFoundObjectError */.m("tutor card view model");
  }
  const {
    info: {
      name,
      description,
      avatar,
      interests
    },
    availabilitySlotsGroupByDay
  } = tutor;
  const nameId = (0,react.useId)();
  const scheduleId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: tutor_card_with_schedule_module.container,
    "aria-labelledby": nameId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
      id: nameId,
      className: classnames_default()(typography_module/* default */.Z.headline3, tutor_card_with_schedule_module.name, {
        [typography_module/* default */.Z.headline4Accent]: isMobile
      }),
      children: name
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(TutorCard, {
      description,
      avatar,
      interests
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
      className: tutor_card_with_schedule_module.schedule,
      "aria-labelledby": scheduleId,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        id: scheduleId,
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, {
          [typography_module/* default */.Z.body2Accent]: isMobile
        }, tutor_card_with_schedule_module.scheduleTitle),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "autoOnboardingPage.selectTutorStep.tutorCard.scheduleTitle"
        })
      }), availabilitySlotsGroupByDay.map(_ref => {
        let [weekDay, slots] = _ref;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: tutor_card_with_schedule_module.slots,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(WeekdaySlots, {
            weekDay,
            slots
          })
        }, weekDay);
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/tutor-card/tutor-card.tsx









const SelectStudentTutorCardContent = _ref => {
  let {
    onDontKnowHowToChoose
  } = _ref;
  const resetCurrentTutorEvent = (0,effector_react/* useEvent */.zX)(resetCurrentTutor);
  const submitSelectTutorEvent = (0,effector_react/* useEvent */.zX)(submitSelectTutorFromCard);
  const handleBack = (0,react.useCallback)(() => {
    resetCurrentTutorEvent();
  }, [resetCurrentTutorEvent]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StepWrapper, {
      dataTestId: "SelectTimeSlotsStep",
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TutorCardWithSchedule, {})
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
      onDontKnowHowToChoose,
      onNext: submitSelectTutorEvent,
      onBack: handleBack
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/tutor/tutor.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tutor_tutor_module = ({"card":"tutor-module__card--P1VfJ","card-btn":"tutor-module__card-btn--aCZ0O","cardBtn":"tutor-module__card-btn--aCZ0O","offset":"tutor-module__offset--aqp0R","card-selected":"tutor-module__card-selected--YbVOE","cardSelected":"tutor-module__card-selected--YbVOE","avatar":"tutor-module__avatar--eKbbl","main-content":"tutor-module__main-content--BmUpE","mainContent":"tutor-module__main-content--BmUpE","title":"tutor-module__title--NRtyV","block":"tutor-module__block--SA0Fl","subtitle":"tutor-module__subtitle--YW7jt","buttons":"tutor-module__buttons--EXmxf","slots":"tutor-module__slots--zZRCc","slot":"tutor-module__slot--v5pi1","button":"tutor-module__button--_mmIh","button-selected":"tutor-module__button-selected--CYIcP","buttonSelected":"tutor-module__button-selected--CYIcP"});
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/tutor/tutor.tsx





















const FROM_FORMAT = "EEEEEE HH:mm";
const TO_FORMAT = "HH:mm";
const MAX_VISIBLE_TIME_SLOTS = 4;
function SelectStudentTutor(_ref) {
  let {
    tutor: {
      info: {
        id,
        name,
        shortDescription,
        avatar
      },
      selected: tutorSelected,
      visibleSlots
    },
    onSeenTutor
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const setCurrentTutorIdEvent = (0,effector_react/* useEvent */.zX)(setCurrentTutorId);
  const lessonDuration = (0,effector_react/* useStore */.oR)(student_attributes/* $lessonDuration */.fQ);
  const openTutorCard = (0,react.useCallback)(() => {
    setCurrentTutorIdEvent(id);
  }, [id, setCurrentTutorIdEvent]);
  const titleId = (0,react.useId)();
  const {
    ref,
    inView
  } = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0.5
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onSeenTutor(id);
    }
  }, [onSeenTutor, id, inView]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    ref,
    className: classnames_default()(tutor_tutor_module.card, {
      [tutor_tutor_module.cardSelected]: tutorSelected
    }),
    "aria-labelledby": titleId,
    "data-testid": tutorSelected ? "selected-student-tutor" : "select-student-tutor",
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      "aria-hidden": "true",
      className: tutor_tutor_module.cardBtn,
      tabIndex: -1,
      type: "button",
      onClick: openTutorCard
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(tutor_tutor_module.avatar, tutor_tutor_module.offset),
      style: {
        backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)((0,avatar_utils/* getYandexAvatarById */.m$)({
          id: avatar,
          size: 100
        }))
      }
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: tutor_tutor_module.mainContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h2", {
        id: titleId,
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, tutor_tutor_module.title, tutor_tutor_module.offset),
        children: name
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(tutor_tutor_module.block, tutor_tutor_module.offset),
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("h3", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, tutor_tutor_module.subtitle),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: tutorSelected ? "selectStudentTutorSchedule.selectedSlots" : "selectStudentTutorSchedule.closestSlots"
          }), !isMobile && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [" ", /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "selectStudentTutorSchedule.closestSlotsHint",
              values: {
                duration: lessonDuration
              }
            })]
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: tutor_tutor_module.buttons,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
            className: classnames_default()(tutor_tutor_module.slots),
            role: "list",
            children: visibleSlots.slice(0, MAX_VISIBLE_TIME_SLOTS).map(slot => {
              const from = slot.date;
              const to = (0,addMinutes/* addMinutes */.m)(slot.date, lessonDuration ?? speakingSession_model/* DEFAULT_LESSON_DURATION */.ip);
              const formattedFrom = (0,format/* format */.WU)(from, FROM_FORMAT, {
                locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
              });
              const formattedTo = (0,format/* format */.WU)(to, TO_FORMAT, {
                locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
              });
              const formattedDate = isMobile ? `${formattedFrom} - ${formattedTo}` : formattedFrom;
              return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
                className: classnames_default()(typography_module/* default */.Z.body2Accent, tutor_tutor_module.slot),
                children: formattedDate
              }, slot.id);
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: "primary",
            onClick: openTutorCard,
            className: classnames_default()(tutor_tutor_module.button, {
              [tutor_tutor_module.buttonSelected]: tutorSelected
            }),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: tutorSelected ? "selectStudentTutorSchedule.changeTime" : "selectStudentTutorSchedule.chooseTime"
            })
          })]
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(tutor_tutor_module.block, tutor_tutor_module.offset),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, tutor_tutor_module.subtitle),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "autoOnboardingPage.selectTutorStep.tutorCard.aboutText"
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: typography_module/* default */.Z.body2,
          children: shortDescription
        })]
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/tutors/tutors.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tutors_module = ({"root":"tutors-module__root--pvfup"});
;// CONCATENATED MODULE: ./src/widgets/select-student-tutor-schedule/ui/tutors/tutors.tsx









function SelectStudentTutors(_ref) {
  let {
    onSeenTutor
  } = _ref;
  const tutors = (0,effector_react/* useStore */.oR)($tutorViewModels);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("article", {
    className: tutors_module.root,
    children: tutors.map(tutor => /* @__PURE__ */(0,jsx_runtime.jsx)(SelectStudentTutor, {
      onSeenTutor,
      tutor
    }, tutor.info.id))
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/tutor-list/tutor-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tutor_list_module = ({"title":"tutor-list-module__title--JXybc"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/tutor-list/tutor-list.tsx















const SelectStudentTutorsListContent = _ref => {
  let {
    onDontKnowHowToChoose
  } = _ref;
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const submitSelectTutorEvent = (0,effector_react/* useEvent */.zX)(submitSelectTutorFromList);
  const addSeenTutorEvent = (0,effector_react/* useEvent */.zX)(addSeenTutor);
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)(StepWrapper, {
      dataTestId: "SelectTutorStep",
      "aria-label": intl.formatMessage({
        id: "autoOnboardingPage.selectTutorStep.tutorList.header"
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
          className: classnames_default()(typography_module/* default */.Z.headline3, tutor_list_module.title, {
            [typography_module/* default */.Z.headline4Accent]: isMobile
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "autoOnboardingPage.selectTutorStep.tutorList.header"
          })
        })
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(SelectStudentTutors, {
        onSeenTutor: addSeenTutorEvent
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(Footer, {
      onDontKnowHowToChoose,
      onNext: submitSelectTutorEvent,
      onBack: goToPreviousAutoOnboardingState
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/content/content.tsx










const SelectTutorContent = (0,react.memo)(function SelectTutorStep() {
  const intl = (0,useIntl/* default */.Z)();
  const step = (0,effector_react/* useStore */.oR)($selectStudentTutorScheduleStep);
  const setHelpModalContentEvent = (0,effector_react/* useEvent */.zX)(setHelpModalContent);
  (0,effector_react/* useGate */.DD)(selectTutorGate);
  const handleSetHelpModalContent = (0,react.useCallback)(() => {
    setHelpModalContentEvent({
      title: intl.formatMessage({
        id: "autoOnboardingPage.selectTutorModal.title"
      }),
      subtitle: intl.formatMessage({
        id: "autoOnboardingPage.selectTutorModal.text"
      }),
      needCuratorButtonText: intl.formatMessage({
        id: "onboardingHelpModal.needCuratorOnboarding"
      }),
      closeButtonText: intl.formatMessage({
        id: "onboardingHelpModal.ok"
      })
    });
  }, [intl, setHelpModalContentEvent]);
  if (step === "card") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SelectStudentTutorCardContent, {
      onDontKnowHowToChoose: handleSetHelpModalContent
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SelectStudentTutorsListContent, {
    onDontKnowHowToChoose: handleSetHelpModalContent
  });
});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/loading/hook.ts






const LOADING_MESSAGE_TIME = 1700;
const MESSAGE_AMOUNT = 4;
const useLoadingMessage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const isVisible = (0,effector_react/* useStore */.oR)($isLoadingScreenVisible);
  const setIsLoadingScreenVisibleEvent = (0,effector_react/* useEvent */.zX)(setIsLoadingScreenVisible);
  const [messageIndex, setMessageIndex] = (0,react.useState)(1);
  (0,react.useEffect)(() => {
    if (!isVisible) {
      return;
    }
    const interval = setInterval(() => {
      if (MESSAGE_AMOUNT === messageIndex) {
        setIsLoadingScreenVisibleEvent(false);
      } else {
        setMessageIndex(prev => prev + 1);
      }
    }, LOADING_MESSAGE_TIME);
    return () => clearInterval(interval);
  }, [isVisible, messageIndex, setIsLoadingScreenVisibleEvent]);
  return {
    loadingMessage: intl.formatMessage({
      id: `onboarding.selectTutorLoading.message${messageIndex}`
    })
  };
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/loading/loading.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const loading_module = ({"section":"loading-module__section--iU12g","image":"loading-module__image--t6ceo","message":"loading-module__message--zubmC"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/loading/loading.tsx










const SelectTutorLoading = () => {
  const labelId = (0,react.useId)();
  const {
    loadingMessage
  } = useLoadingMessage();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: loading_module.section,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: loading_module.image,
      alt: "",
      src: "https://flowstatic.s3.yandex.net/ui-files/autoonboarding_tutors_loading_waiting.svg"
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(loading_module.section, accessibility_module/* default */.Z.focusVisibleWithin),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        id: labelId,
        className: classnames_default()(typography_module/* default */.Z.headline4Accent, loading_module.message),
        children: loadingMessage
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("progress", {
        className: accessibility_module/* default */.Z.srOnly,
        "aria-labelledby": labelId
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/constants.ts


const DOUBLE_SPEAKING_SESSION_ERROR_TEST_ID = "doubleSpeakingSessionError";
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/select-tutor-double-speaking-session-error.tsx






const SelectTutorDoubleSpeakingSessionError = _ref => {
  let {
    loading,
    onClick
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorWithButton, {
    title: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.doubleSpeakingSessionError.title"
    }),
    alertText: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.doubleSpeakingSessionError.alert"
    }),
    btnText: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.doubleSpeakingSessionError.button"
    }),
    onClick,
    testId: DOUBLE_SPEAKING_SESSION_ERROR_TEST_ID,
    loading
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/error-with-back-button/error-with-back-button.tsx







const ErrorWithBackButton = _ref => {
  let {
    title,
    alertText,
    btnText
  } = _ref;
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const loading = savingAutoOnboardingStep === "prev";
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorWithButton, {
    title,
    alertText,
    btnText,
    onClick: goToPreviousAutoOnboardingState,
    loading
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/select-tutor-error.tsx





const SelectTutorError = () => {
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorWithBackButton, {
    title: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.error.title"
    }),
    alertText: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.error.alert"
    }),
    btnText: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.error.updateButton"
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/components/tutors-not-found/tutors-not-found.tsx










function TutorsNotFound() {
  const intl = (0,useIntl/* default */.Z)();
  const savingAutoOnboardingStep = (0,effector_react/* useStore */.oR)($savingAutoOnboardingStep);
  const goToPreviousAutoOnboardingState = (0,effector_react/* useEvent */.zX)(goToPreviousAutoOnboardingStateFx);
  const isNeedCuratorOnboardingLoading = savingAutoOnboardingStep === "needCuratorOnboarding";
  const isGoToSelectTimeSlotsLoading = savingAutoOnboardingStep === "prev";
  const loading = isNeedCuratorOnboardingLoading || isGoToSelectTimeSlotsLoading;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorWrapper, {
    title: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.tutorsNotFound.title"
    }),
    alertText: intl.formatMessage({
      id: "autoOnboardingPage.selectTutorStep.tutorsNotFound.alert"
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorButtonBlock, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ErrorButton, {
        loading: isGoToSelectTimeSlotsLoading,
        readOnly: loading,
        description: intl.formatMessage({
          id: "autoOnboardingPage.selectTutorStep.tutorsNotFound.alert"
        }),
        onClick: goToPreviousAutoOnboardingState,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "autoOnboardingPage.selectTutorStep.tutorsNotFound.goToPreviousStep"
        })
      })
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/select-tutor/select-tutor.tsx





















const SelectTutor = (0,react.memo)(() => {
  const intl = (0,useIntl/* default */.Z)();
  const tutorsState = (0,effector_react/* useStore */.oR)($tutorsState);
  const tutorError = (0,effector_react/* useStore */.oR)($tutorError);
  const selectStudentTutors = (0,effector_react/* useStore */.oR)($tutorsWithSlots);
  const isLoadingScreenVisible = (0,effector_react/* useStore */.oR)($isLoadingScreenVisible);
  const loadTutorsEvent = (0,effector_react/* useEvent */.zX)(loadTutors);
  const setTutorErrorEvent = (0,effector_react/* useEvent */.zX)(setTutorError);
  const goToOnboardingState = (0,effector_react/* useEvent */.zX)(goToOnboardingStateFx);
  const goingToOnboardingStatePending = (0,effector_react/* useStore */.oR)(goToOnboardingStateFx.pending);
  (0,use_did_mount/* useDidMount */.H)(() => {
    if (tutorsState.state !== "loaded") {
      loadTutorsEvent();
    }
  });
  (0,react.useEffect)(() => selectOccupiedSlot.watch(value => {
    toast/* toastNotificationService */.B.showInfoMessage(value, {
      toastId: value
    });
  }), []);
  (0,react.useEffect)(() => onInvalidSelectTutor.watch(value => toast/* toastNotificationService */.B.showError(intl.formatMessage({
    id: "autoOnboardingPage.selectTutor.invalid"
  }, {
    count: value
  }))), [intl]);
  (0,react.useEffect)(() => onNotSelectedTutor.watch(() => toast/* toastNotificationService */.B.showError(intl.formatMessage({
    id: "autoOnboardingPage.selectTutor.notSelected"
  }))), [intl]);
  (0,react.useEffect)(() => {
    if (isLoadingScreenVisible || !tutorError) {
      return;
    }
    toast/* toastNotificationService */.B.showError(intl.formatMessage({
      id: tutorError === "tutorNotFound" ? "autoOnboardingPage.selectTutor.tutorNotFound" : "autoOnboardingPage.confirmStep.error.occupiedSlots.title"
    }));
    setTutorErrorEvent(null);
  }, [intl, tutorError, isLoadingScreenVisible, setTutorErrorEvent]);
  if (isLoadingScreenVisible) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(SelectTutorLoading, {});
  }
  switch (tutorsState.state) {
    case "loading":
      return /* @__PURE__ */(0,jsx_runtime.jsx)(SelectTutorLoading, {});
    case "loaded":
      return selectStudentTutors.length > 0 ? /* @__PURE__ */(0,jsx_runtime.jsx)(SelectTutorContent, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(TutorsNotFound, {});
    default:
      {
        if (tutorsState.error instanceof DoubleSpeakingSessionTutorsNotFoundError) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(SelectTutorDoubleSpeakingSessionError, {
            loading: goingToOnboardingStatePending,
            onClick: () => goToOnboardingState(student_attributes/* OnboardingFSMState */.Cv.Step2)
          });
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(SelectTutorError, {});
      }
  }
});
SelectTutor.displayName = "SelectTutor";
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/components/steps/index.ts








;// CONCATENATED MODULE: ./src/pages/auto-onboarding/auto-onboarding-page.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const auto_onboarding_page_module = ({"container":"auto-onboarding-page-module__container--XvjAA"});
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/auto-onboarding-page.tsx




























const AUTO_ONBOARDING_STATE_COMPONENTS = {
  [student_attributes/* OnboardingFSMState */.Cv.Contacts]: ContactsStep,
  [student_attributes/* OnboardingFSMState */.Cv.Step1]: PreferencesStep,
  [student_attributes/* OnboardingFSMState */.Cv.Step2]: IntensityStep,
  [student_attributes/* OnboardingFSMState */.Cv.SelectTimeSlots]: SelectTimeSlotsStep,
  [student_attributes/* OnboardingFSMState */.Cv.SelectTutor]: SelectTutor,
  [student_attributes/* OnboardingFSMState */.Cv.ConfirmOnboarding]: ConfirmOnboardingStep
};
const AutoOnboardingPage = () => {
  const intl = (0,useIntl/* default */.Z)();
  const isAvailableAutoOnboarding = useAvailableAutoOnboarding();
  const currentAutoOnboardingFSMState = (0,effector_react/* useStore */.oR)(entities_onboarding/* $currentOnboardingState */.W4);
  const preCuratorOnboardingScreenContent = (0,effector_react/* useStore */.oR)($preCuratorOnboardingScreenContent);
  const intensityWillUnmountEvent = (0,effector_react/* useEvent */.zX)(resetIntensity);
  const resetSelectTimeSlotsEvent = (0,effector_react/* useEvent */.zX)(resetSelectTimeSlots);
  const preferencesWillUnmountEvent = (0,effector_react/* useEvent */.zX)(resetSelectedPreferences);
  const resetTutorsStateEvent = (0,effector_react/* useEvent */.zX)(resetTutorsState);
  (0,effector_react/* useGate */.DD)(autoOnboardingGate);
  (0,react.useEffect)(() => {
    intensityWillUnmountEvent();
    resetSelectTimeSlotsEvent();
    preferencesWillUnmountEvent();
    resetTutorsStateEvent();
  }, []);
  const {
    isDesktop,
    isMobileOrTablet
  } = (0,use_screen_width/* useScreenWidth */.k)();
  (0,react.useEffect)(() => student_attributes/* saveStudentAttributesFx */.YP.fail.watch(_ref => {
    let {
      error
    } = _ref;
    if (error === model/* AttributesError */.c.StudentAlreadyStudying) {
      (0,reload_page/* reloadPage */.s)();
    } else {
      toast/* toastNotificationService */.B.showError(intl.formatMessage({
        id: "autoOnboardingPage.saveStudentAttributes.error"
      }));
    }
  }), [intl]);
  if (!isAvailableAutoOnboarding) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_router/* Redirect */.l_, {
      to: studentRoutePaths/* studentRoutePaths */.dR.INDEX
    });
  }
  if (preCuratorOnboardingScreenContent) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(PreCuratorOnboardingScreen, {});
  }
  const StepComponent = currentAutoOnboardingFSMState && AUTO_ONBOARDING_STATE_COMPONENTS[currentAutoOnboardingFSMState];
  return /* @__PURE__ */(0,jsx_runtime.jsx)(app_page_wrapper_component/* AppPageWrapper */.I, {
    header: {
      hideNavigation: true,
      hideEducationItems: true,
      children: isDesktop ? /* @__PURE__ */(0,jsx_runtime.jsx)(AutoOnboardingStepper, {}) : null
    },
    main: {
      hideGrammarGuideButton: true
    },
    self: {
      bgColor: app_page_wrapper_types/* BackgroundColors */.k.Grey,
      doNotWrapChildrenWithLayout: true
    },
    footer: {
      hideFooter: true
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: auto_onboarding_page_module.container,
      children: [isMobileOrTablet ? /* @__PURE__ */(0,jsx_runtime.jsx)(AutoOnboardingStepper, {}) : null, StepComponent && /* @__PURE__ */(0,jsx_runtime.jsx)(StepComponent, {}), /* @__PURE__ */(0,jsx_runtime.jsx)(HelpModal, {})]
    })
  });
};
;// CONCATENATED MODULE: ./src/pages/auto-onboarding/index.ts






/***/ }),

/***/ 43408:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: () => (/* binding */ useForeignerSpeakings)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68760);
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(280);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71502);
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31976);
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34994);
/* harmony import */ var _yandex_langly_shared_src_utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63419);
/* harmony import */ var _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85715);














const $foreignerSpeakings = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const $notCompletedForeignerSpeakings = $foreignerSpeakings.map(foreignerSpeakings => foreignerSpeakings ? foreignerSpeakings.filter(speaking => speaking.state !== _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Complete) : []);
const $initialForeignerSpeakings = $notCompletedForeignerSpeakings.map(notCompletedForeignerSpeakings => notCompletedForeignerSpeakings.filter(speaking => speaking.state === _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Initial));
const $scheduledForeignerSpeakings = $notCompletedForeignerSpeakings.map(notCompletedForeignerSpeakings => notCompletedForeignerSpeakings.filter(speaking => speaking.state === _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Scheduled).sort((speaking1, speaking2) => (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* .isBefore */ .R)(speaking1.startAt, speaking2.startAt) ? -1 : 0));
const $schedulingSpeakingId = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const $scheduledSpeakingId = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const $cancelingSessionId = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const $schedulingSpeakingData = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const $scheduledSessionData = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const $cancelingSessionData = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createStore */ .MT)(null);
const foreignerSpeakingsApi = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createApi */ .LC)($foreignerSpeakings, {
  setSpeakings: (_, payload) => payload,
  scheduleSession: (state, payload) => {
    if (state === null) {
      return null;
    }
    const {
      speakingSession
    } = payload;
    return state.map(speaking => {
      if (speaking.id === speakingSession.speaking.id && speaking.state === _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Initial) {
        return {
          ...speaking,
          sessionId: speakingSession.id,
          state: _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Scheduled,
          startAt: speakingSession.startAt,
          tutorAvatar: speakingSession.tutor?.avatar ?? _yandex_langly_shared_src_utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_AVATAR_URL */ .jz,
          tutorName: speakingSession.tutor?.publicName ?? ""
        };
      }
      return speaking;
    });
  },
  cancelSession: (state, payload) => {
    if (state === null) {
      return null;
    }
    const {
      sessionId
    } = payload;
    return state.map(speaking => {
      if (speaking.state === _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Scheduled && speaking.sessionId === sessionId) {
        return {
          id: speaking.id,
          state: _api_student_student_model__WEBPACK_IMPORTED_MODULE_8__/* .ForeignerSpeakingState */ .Em.Initial,
          theme: speaking.theme,
          durationMin: speaking.durationMin,
          tutorAvatar: _yandex_langly_shared_src_utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_AVATAR_URL */ .jz
        };
      }
      return speaking;
    });
  }
});
const schedulingSpeakingApi = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createApi */ .LC)($schedulingSpeakingId, {
  setId: (_, payload) => payload.speakingId,
  resetId: () => null
});
const scheduledSpeakingApi = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createApi */ .LC)($scheduledSpeakingId, {
  setId: (_, payload) => payload.speakingId,
  resetId: () => null
});
const cancelingSessionApi = (0,effector__WEBPACK_IMPORTED_MODULE_9__/* .createApi */ .LC)($cancelingSessionId, {
  setId: (_, payload) => payload.sessionId,
  resetId: () => null
});
(0,effector__WEBPACK_IMPORTED_MODULE_9__/* .sample */ .UP)({
  source: $initialForeignerSpeakings,
  clock: $schedulingSpeakingId,
  fn: (initialForeignerSpeakings, schedulingSpeakingId) => initialForeignerSpeakings.find(speaking => schedulingSpeakingId === speaking.id) ?? null,
  target: $schedulingSpeakingData
});
(0,effector__WEBPACK_IMPORTED_MODULE_9__/* .sample */ .UP)({
  source: $scheduledForeignerSpeakings,
  clock: $scheduledSpeakingId,
  fn: (scheduledForeignerSpeakings, scheduledSpeakingId) => scheduledForeignerSpeakings.find(speaking => scheduledSpeakingId === speaking.id) ?? null,
  target: $scheduledSessionData
});
(0,effector__WEBPACK_IMPORTED_MODULE_9__/* .sample */ .UP)({
  source: $scheduledForeignerSpeakings,
  clock: $cancelingSessionId,
  fn: (scheduledForeignerSpeakings, cancelingSessionId) => scheduledForeignerSpeakings.find(speaking => cancelingSessionId === speaking.sessionId) ?? null,
  target: $cancelingSessionData
});
function useForeignerSpeakings() {
  const notCompletedForeignerSpeakings = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)($notCompletedForeignerSpeakings);
  const initialForeignerSpeakings = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)($initialForeignerSpeakings);
  const scheduledForeignerSpeakings = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)($scheduledForeignerSpeakings);
  const schedulingSpeakingData = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)($schedulingSpeakingData);
  const scheduledSessionData = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)($scheduledSessionData);
  const cancelSpeakingData = (0,effector_react__WEBPACK_IMPORTED_MODULE_11__/* .useStore */ .oR)($cancelingSessionData);
  return {
    notCompletedForeignerSpeakings,
    initialForeignerSpeakings,
    scheduledForeignerSpeakings,
    setForeignerSpeakings: foreignerSpeakingsApi.setSpeakings,
    schedulingSpeakingData,
    scheduledSessionData,
    cancelSpeakingData,
    setSchedulingSpeakingId: schedulingSpeakingApi.setId,
    setScheduledSpeakingId: scheduledSpeakingApi.setId,
    setCancelingSessionId: cancelingSessionApi.setId,
    resetSchedulingSpeaking: schedulingSpeakingApi.resetId,
    resetScheduledSession: scheduledSpeakingApi.resetId,
    resetCancelingSession: cancelingSessionApi.resetId,
    scheduleSession: foreignerSpeakingsApi.scheduleSession,
    cancelSession: foreignerSpeakingsApi.cancelSession
  };
}

/***/ }),

/***/ 95935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  S: () => (/* reexport */ fetchResourcesBalance),
  i: () => (/* reexport */ fetchTransactionHistory)
});

// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../../node_modules/fp-ts/es6/Record.js + 5 modules
var Record = __webpack_require__(14138);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/pages/resources/api/model.ts




const resourcesCountsModel = es6.partial({
  remaining: es6.number,
  completed: es6.number,
  burned: es6.number,
  all: es6.number
});
const resourcesTypes = {
  speaking_session: null,
  native_speaker_session: null
};
const resourceTypeModel = es6.keyof(resourcesTypes);
const resourcesBalanceModel = es6.partial((0,Record/* map */.UI)(() => resourcesCountsModel)(resourcesTypes));
const resourcesBalanceResponse = es6.type({
  data: resourcesBalanceModel
});
const transactionReasonModel = es6.keyof({
  new_payment: null,
  finish_session: null,
  success_session: null,
  student_no_show_session: null,
  late_canceled_session: null,
  late_rescheduled_session: null,
  refund: null,
  correction: null,
  b2b_payment: null,
  promocode_with_free_sessions: null,
  gift_activation: null,
  migration_request: null
});
const transactionHistoryModel = es6.array(es6.type({
  id: es6.string,
  created_at: es6.string,
  type: resourceTypeModel,
  reason: transactionReasonModel,
  amount: es6.number,
  payload: es6.type({
    session_start_at: es6.union([es6.number, es6.string, es6["null"]])
  })
}));
const resourcesHistoryResponse = es6.type({
  data: es6.type({
    history: transactionHistoryModel,
    pageno: es6.union([es6.number, es6["null"]])
  })
});
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
;// CONCATENATED MODULE: ./src/pages/resources/api/urls.ts



function getTransactionHistoryUrl(businessProductId, resourceType, page) {
  const params = `business_product_id=${businessProductId}&resource_type=${resourceType}`;
  const url = `${(0,site_utils/* getAPIPath */.NZ)()}/student/resources-history?${params}`;
  if (page) {
    return `${url}&pageno=${page}`;
  }
  return url;
}
function getResourcesBalanceUrl(businessProductId) {
  return `${(0,site_utils/* getAPIPath */.NZ)()}/student/resources-balance/${businessProductId}`;
}
;// CONCATENATED MODULE: ./src/pages/resources/api/resources.ts






async function fetchResourcesBalance(businessProductId) {
  const response = await (0,http/* makeRequest */.$f)(getResourcesBalanceUrl(businessProductId), {
    responseType: resourcesBalanceResponse
  });
  if ((0,Either.isLeft)(response)) {
    throw response.left;
  }
  return response.right.data;
}
async function fetchTransactionHistory(_ref) {
  let {
    businessProductId,
    resourceType,
    pageno
  } = _ref;
  const response = await (0,http/* makeRequest */.$f)(getTransactionHistoryUrl(businessProductId, resourceType, pageno), {
    responseType: resourcesHistoryResponse
  });
  if ((0,Either.isLeft)(response)) {
    throw response.left;
  }
  return response.right.data;
}
;// CONCATENATED MODULE: ./src/pages/resources/api/index.ts




/***/ }),

/***/ 83225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ useResourcesBalance)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14010);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42180);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_event_emitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1341);
/* harmony import */ var _yandex_langly_shared_src_model_product_product_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55681);
/* harmony import */ var _hooks_user_useUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87029);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95935);








function useResourcesBalance() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const user = (0,_hooks_user_useUser__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .aF)();
  const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
  const businessProductId = user.data?.product?.businessId;
  const queryKey = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ["resourcesBalance", businessProductId], [businessProductId]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const cb = () => queryClient.invalidateQueries({
      queryKey
    });
    _yandex_langly_shared_src_event_emitter__WEBPACK_IMPORTED_MODULE_1__/* .eventEmitter */ .T.on("lateSpeakingSessionChange", cb);
    return () => {
      _yandex_langly_shared_src_event_emitter__WEBPACK_IMPORTED_MODULE_1__/* .eventEmitter */ .T.off("lateSpeakingSessionChange", cb);
    };
  }, [queryClient, queryKey]);
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)({
    enabled: Boolean(businessProductId),
    queryKey,
    queryFn: () => (0,_api__WEBPACK_IMPORTED_MODULE_4__/* .fetchResourcesBalance */ .S)((0,_yandex_langly_shared_src_model_product_product_model__WEBPACK_IMPORTED_MODULE_2__/* .makeBusinessProductId */ .bX)(businessProductId)),
    staleTime: 1e3 * 60,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...props
  });
}

/***/ }),

/***/ 36461:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GG: () => (/* binding */ useResourcesZeroBalance),
/* harmony export */   Ll: () => (/* binding */ checkZeroBalance),
/* harmony export */   My: () => (/* binding */ useResourcesBalanceRemaining)
/* harmony export */ });
/* harmony import */ var _utils_experimentDi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40826);
/* harmony import */ var _beginner_pages_foreigner_sessions_page_use_foreigner_sessions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43408);
/* harmony import */ var _use_resources_balance__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83225);





function useResourcesBalanceRemaining() {
  const {
    data
  } = (0,_use_resources_balance__WEBPACK_IMPORTED_MODULE_2__/* .useResourcesBalance */ .U)({
    select: _ref => {
      let {
        speaking_session: speakingSession,
        native_speaker_session: nativeSpeakerSession
      } = _ref;
      return {
        speakingSession: speakingSession?.remaining ?? 0,
        nativeSpeakerSession: nativeSpeakerSession?.remaining ?? 0
      };
    }
  });
  return data ?? {
    speakingSession: 0,
    nativeSpeakerSession: 0
  };
}
function useResourcesZeroBalance() {
  const {
    resources
  } = (0,_utils_experimentDi__WEBPACK_IMPORTED_MODULE_0__/* .useExperimentDi */ .e1)();
  const {
    speakingSession: speakingSessionRemaining,
    nativeSpeakerSession: nativeSpeakerSessionRemaining
  } = useResourcesBalanceRemaining();
  const {
    scheduledForeignerSpeakings
  } = (0,_beginner_pages_foreigner_sessions_page_use_foreigner_sessions__WEBPACK_IMPORTED_MODULE_1__/* .useForeignerSpeakings */ .w)();
  if (!resources.enabled) {
    return "none";
  }
  const isSpeakingSessionZeroBalance = speakingSessionRemaining <= 0;
  const isNativeSpeakerSessionResourcesEnabled = resources.resourceTypes.includes("native_speaker_session");
  if (!isNativeSpeakerSessionResourcesEnabled) {
    return isSpeakingSessionZeroBalance ? "all" : "none";
  }
  if (nativeSpeakerSessionRemaining <= 0 || nativeSpeakerSessionRemaining <= scheduledForeignerSpeakings.length) {
    return isSpeakingSessionZeroBalance ? "all" : "nativeSpeakingSession";
  }
  return isSpeakingSessionZeroBalance ? "speakingSession" : "none";
}
function checkZeroBalance(balance, checkType) {
  return ["all", checkType].includes(balance);
}

/***/ }),

/***/ 64130:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w: () => (/* binding */ taskGuideApiAdapter)
});

// EXTERNAL MODULE: ../../node_modules/date-fns/subWeeks.mjs + 1 modules
var subWeeks = __webpack_require__(73215);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfToday.mjs
var startOfToday = __webpack_require__(12303);
// EXTERNAL MODULE: ../../node_modules/date-fns/addYears.mjs
var addYears = __webpack_require__(12385);
// EXTERNAL MODULE: ../../node_modules/date-fns/getUnixTime.mjs
var getUnixTime = __webpack_require__(23568);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ./src/api/events/events.api.ts + 2 modules
var events_api = __webpack_require__(53536);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
;// CONCATENATED MODULE: ./src/api/syllabus/syllabus.mapper.ts



const mapBusinessProductSyllabus = raw => ({
  businessProductId: (0,product_model/* makeBusinessProductId */.bX)(raw.business_product_id),
  syllabusId: raw.syllabus_id,
  syllabusName: raw.syllabus_name,
  isMain: raw.is_main_syllabus
});
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ./src/api/syllabus/syllabus.raw-model.ts



const BusinessProductSyllabusRaw = es6.type({
  business_product_id: es6.string,
  syllabus_id: es6.string,
  syllabus_name: es6.string,
  is_main_syllabus: es6.boolean
});
const BusinessProductSyllabusesRaw = es6.type({
  data: es6.array(BusinessProductSyllabusRaw)
});
;// CONCATENATED MODULE: ./src/api/syllabus/syllabus.api.ts









const getBusinessProductSyllabuses = (0,un_either/* unEither */.K)(businessProductId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/syllabuses/${businessProductId}`, {
  responseType: BusinessProductSyllabusesRaw,
  resultMapper: _ref => {
    let {
      data
    } = _ref;
    return data.map(mapBusinessProductSyllabus);
  }
}));
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ./src/api/student/speaking/speaking.mappers.ts
var speaking_mappers = __webpack_require__(49968);
// EXTERNAL MODULE: ./src/api/student/speaking-session/speaking-session.raw-model.ts
var speaking_session_raw_model = __webpack_require__(21804);
// EXTERNAL MODULE: ../shared/src/api/speaking-sessions/speaking-sessions.raw-models.ts
var speaking_sessions_raw_models = __webpack_require__(55847);
;// CONCATENATED MODULE: ./src/api/tutor/speaking-sessions/speaking-sessions.model-raw.ts




const RawSpeakingSessionsResponse = es6.type({
  data: es6.type({
    speaking_sessions: es6.array(speaking_sessions_raw_models/* SpeakingSessionItemRaw */.Xj)
  })
});
const RawSpeakingSessionResponse = es6.type({
  data: speaking_sessions_raw_models/* SpeakingSessionItemRaw */.Xj
});
;// CONCATENATED MODULE: ./src/api/tutor/speaking-sessions/speaking-sessions.api.ts













const mapRawSpeakingSessions = rawResponse => rawResponse.data.speaking_sessions.reduce((acc, ss) => {
  acc[ss.id] = (0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(ss);
  return acc;
}, {});
const getSpeakingSession = sessionId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/speaking-sessions/${sessionId}`, {
  responseType: RawSpeakingSessionResponse,
  resultMapper: _ref => {
    let {
      data
    } = _ref;
    return (0,speaking_mappers/* mapRawSpeakingSessionResponse */.bH)(data);
  }
});
const getTutorSpeakingSessionsWithStudent = (0,un_either/* unEither */.K)((studentId, from, to, perPage) => {
  const perPagePrefix = perPage !== void 0 ? `&per_page=${perPage}` : "";
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/speaking-sessions?from=${from}&to=${to}${perPagePrefix}`, {
    responseType: speaking_session_raw_model/* RawStudentSpeakingSessionsResponse */.CS,
    resultMapper: response => {
      const studentSpeakingSessions = response.data.speaking_sessions.filter(speakingSession => speakingSession.student?.id === studentId);
      return mapRawSpeakingSessions({
        data: {
          speaking_sessions: studentSpeakingSessions
        }
      });
    }
  });
});
;// CONCATENATED MODULE: ./src/services/taskGuide/adapters/api.ts







const taskGuideApiAdapter = {
  getTutorSpeakingSessions(studentId) {
    const lastWeek = (0,subWeeks/* subWeeks */.t)((0,startOfToday/* startOfToday */.I)(), 1);
    const nextYear = (0,addYears/* addYears */.B)((0,startOfToday/* startOfToday */.I)(), 1);
    return getTutorSpeakingSessionsWithStudent(studentId, (0,getUnixTime/* getUnixTime */.Q)(lastWeek), (0,getUnixTime/* getUnixTime */.Q)(nextYear), "-1");
  },
  changeSpeakingSessionState(event) {
    return (0,events_api/* postSpeakingSessionEvent */.ed)(event);
  },
  async getSpeakingSession(sessionId) {
    const result = await getSpeakingSession(sessionId);
    if ((0,Either.isRight)(result)) {
      return result.right;
    }
    throw result.left;
  },
  getSyllabuses(businessProductId) {
    return getBusinessProductSyllabuses(businessProductId);
  }
};

/***/ }),

/***/ 70372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  k: () => (/* binding */ useTaskGuide),
  d: () => (/* binding */ useTaskGuideWithParams)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(9571);
;// CONCATENATED MODULE: ../shared/src/api/events/events.model.ts


var SpeakingSessionSource = /* @__PURE__ */(SpeakingSessionSource2 => {
  SpeakingSessionSource2["FromParams"] = "fromParams";
  SpeakingSessionSource2["LastInProgress"] = "lastInProgress";
  SpeakingSessionSource2["FirstScheduled"] = "lastScheduled";
  SpeakingSessionSource2["LastCompleted"] = "lastCompleted";
  SpeakingSessionSource2["GeneratedByFrontend"] = "generatedByFrontend";
  return SpeakingSessionSource2;
})(SpeakingSessionSource || {});
// EXTERNAL MODULE: ../shared/src/entities/user/index.ts + 3 modules
var entities_user = __webpack_require__(91485);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
// EXTERNAL MODULE: ../shared/src/model/student/student.model.ts
var student_model = __webpack_require__(54938);
// EXTERNAL MODULE: ../shared/src/routes/teacher-route-paths.ts
var teacher_route_paths = __webpack_require__(64514);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ./src/adapters/date.service-adapter.ts
var date_service_adapter = __webpack_require__(87287);
// EXTERNAL MODULE: ./src/adapters/syllabus/syllabus.api-adapter.ts
var syllabus_api_adapter = __webpack_require__(13162);
// EXTERNAL MODULE: ./src/api/tutor/attributes/attributes.api.ts + 3 modules
var attributes_api = __webpack_require__(48509);
;// CONCATENATED MODULE: ./src/adapters/tutorAttributes.api-adapter.ts



const tutorAttributesApiAdapter = {
  getAttributes() {
    return (0,attributes_api/* getTutorAttributes */.Y)();
  }
};
// EXTERNAL MODULE: ./src/adapters/user.storage-adapter.ts
var user_storage_adapter = __webpack_require__(77137);
// EXTERNAL MODULE: ./src/models/syllabus/syllabus.model.ts
var syllabus_model = __webpack_require__(71562);
// EXTERNAL MODULE: ./src/models/task-guide/task-guide.model.ts
var task_guide_model = __webpack_require__(63054);
// EXTERNAL MODULE: ./src/store/student-test/student-test-store.ts
var student_test_store = __webpack_require__(33870);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
// EXTERNAL MODULE: ./src/services/taskGuide/adapters/api.ts + 5 modules
var api = __webpack_require__(64130);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.group-by.js
var es_object_group_by = __webpack_require__(96357);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var isBefore = __webpack_require__(71502);
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(51461);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMinutes.mjs
var addMinutes = __webpack_require__(7300);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/ramda/es/uniqWith.js
var uniqWith = __webpack_require__(67126);
// EXTERNAL MODULE: ../shared/src/utils/storage/index.ts + 4 modules
var storage = __webpack_require__(81597);
// EXTERNAL MODULE: ../ui-kit/src/task-guide/__mother-task/types.ts
var types = __webpack_require__(93018);
// EXTERNAL MODULE: ../ui-kit/src/task-guide/__task/task-guide-task.component.tsx + 1 modules
var task_guide_task_component = __webpack_require__(95226);
// EXTERNAL MODULE: ./src/utils/speaking-session/get-consecutive-speaking-sessions.ts
var get_consecutive_speaking_sessions = __webpack_require__(59040);
;// CONCATENATED MODULE: ./src/services/taskGuide/adapters/storage.ts












































const syllabusDomain = (0,effector/* createDomain */.Fj)("syllabus");
const speakingSessionDomain = (0,effector/* createDomain */.Fj)("speakingSession");
const $speakingSessions = speakingSessionDomain.createStore({});
const $lessonState = speakingSessionDomain.createStore(task_guide_model/* TaskGuideFSMState */.ld.Initial);
const setSpeakingSession = speakingSessionDomain.createEvent();
const setSpeakingSessionState = speakingSessionDomain.createEvent();
const setLessonState = syllabusDomain.createEvent();
const nextLessonState = syllabusDomain.createEvent();
$speakingSessions.on(setSpeakingSession, (state, _ref) => {
  let {
    id,
    session
  } = _ref;
  return {
    ...state,
    [id]: session
  };
});
$speakingSessions.on(setSpeakingSessionState, (state, payload) => {
  const speakingSession = state[payload.speakingSessionId];
  return {
    ...state,
    [payload.speakingSessionId]: {
      ...speakingSession,
      state: payload.state
    }
  };
});
$lessonState.on(setLessonState, (_, newState) => newState);
$lessonState.on(nextLessonState, (state, payload) => (0,task_guide_model/* getNextTaskGuideState */.N4)(state, payload));
const $tutorSpeakingSessions = $speakingSessions.map(speakingSessions => Object.values(speakingSessions));
const findActiveSpeakingSession = (findingSpeakingSessionId, speakingSessions) => {
  if (findingSpeakingSessionId === null) {
    return void 0;
  }
  return speakingSessions.find(speakingSession => speakingSession.id === findingSpeakingSessionId && [speakingSession_model/* SpeakingSessionState */.Z.Scheduled, speakingSession_model/* SpeakingSessionState */.Z.InProgress].includes(speakingSession.state));
};
const getSelfStudyAssignmentSpeakingSession = params => {
  const {
    speakingSessions,
    speakingSessionIdFromParams
  } = params;
  const speakingSessionFromParams = findActiveSpeakingSession(speakingSessionIdFromParams, speakingSessions);
  if (speakingSessionFromParams) {
    return {
      speakingSession: speakingSessionFromParams,
      source: SpeakingSessionSource.FromParams
    };
  }
  const now = Date.now();
  const currentInProgressSpeakingSession = speakingSessions.find(ss => ss.state === speakingSession_model/* SpeakingSessionState */.Z.InProgress);
  if (currentInProgressSpeakingSession !== void 0) {
    return {
      speakingSession: currentInProgressSpeakingSession,
      source: SpeakingSessionSource.LastInProgress
    };
  }
  const lastCompletedBeginnerSpeakingSessions = speakingSessions.filter(ss => ss.state === speakingSession_model/* SpeakingSessionState */.Z.Completed && (0,isBefore/* isBefore */.R)(ss.startAt, now)).sort((ss1, ss2) => (0,isBefore/* isBefore */.R)(ss2.startAt, ss1.startAt) ? -1 : 1);
  if (lastCompletedBeginnerSpeakingSessions.length >= 1) {
    return {
      speakingSession: lastCompletedBeginnerSpeakingSessions[0],
      source: SpeakingSessionSource.LastCompleted
    };
  }
  return null;
};
const getCurrentTutorSpeakingSession = params => {
  const {
    speakingSessions,
    speakingSessionIdFromParams
  } = params;
  const currentSpeakingSessionFromParams = findActiveSpeakingSession(speakingSessionIdFromParams, speakingSessions);
  if (currentSpeakingSessionFromParams !== void 0) {
    return {
      speakingSession: currentSpeakingSessionFromParams,
      source: SpeakingSessionSource.FromParams
    };
  }
  const now = Date.now();
  const currentInProgressSpeakingSession = speakingSessions.find(ss => ss.state === speakingSession_model/* SpeakingSessionState */.Z.InProgress);
  if (currentInProgressSpeakingSession !== void 0) {
    return {
      speakingSession: currentInProgressSpeakingSession,
      source: SpeakingSessionSource.LastInProgress
    };
  }
  const currentAndFutureScheduledBeginnerSpeakingSessions = speakingSessions.filter(ss => ss.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled && (0,isAfter/* isAfter */.A)((0,addMinutes/* addMinutes */.m)(ss.startAt, ss.speaking.durationMinutes), now)).sort((ss1, ss2) => (0,isBefore/* isBefore */.R)(ss2.startAt, ss1.startAt) ? 1 : -1);
  if (currentAndFutureScheduledBeginnerSpeakingSessions.length >= 1) {
    return {
      speakingSession: currentAndFutureScheduledBeginnerSpeakingSessions[0],
      source: SpeakingSessionSource.FirstScheduled
    };
  }
  return null;
};
const $currentSpeakingSessionIdFromParams = (0,effector/* createStore */.MT)(null);
const setSpeakingSessionIdFromParams = (0,effector/* createEvent */.yM)();
$currentSpeakingSessionIdFromParams.on(setSpeakingSessionIdFromParams, (_, _ref2) => {
  let {
    speakingSessionId
  } = _ref2;
  return speakingSessionId ?? null;
});
const $currentTutorSpeakingSession = (0,effector/* combine */.$e)([$tutorSpeakingSessions, $currentSpeakingSessionIdFromParams], _ref3 => {
  let [speakingSessions, currentSpeakingSessionIdFromParams] = _ref3;
  return getCurrentTutorSpeakingSession({
    speakingSessions,
    speakingSessionIdFromParams: currentSpeakingSessionIdFromParams
  });
});
const $nextConsecutiveSpeakingSession = (0,effector/* combine */.$e)([$tutorSpeakingSessions, $currentTutorSpeakingSession], _ref4 => {
  let [speakingSessions, currentSpeakingSession] = _ref4;
  if (currentSpeakingSession === null) {
    return null;
  }
  const filteredSpeakingSessions = speakingSessions.filter(speakingSession => [speakingSession_model/* SpeakingSessionState */.Z.Scheduled, speakingSession_model/* SpeakingSessionState */.Z.InProgress].includes(speakingSession.state));
  const consecutiveSpeakingSessions = (0,get_consecutive_speaking_sessions/* getConsecutiveSpeakingSessions */.b)(filteredSpeakingSessions, currentSpeakingSession.speakingSession.id);
  const currentSpeakingSessionIndex = consecutiveSpeakingSessions.findIndex(s => s.id === currentSpeakingSession.speakingSession.id);
  return consecutiveSpeakingSessions[currentSpeakingSessionIndex + 1] ?? null;
});
const $selfStudyAssignmentSpeakingSession = (0,effector/* combine */.$e)([$tutorSpeakingSessions, $currentSpeakingSessionIdFromParams], _ref5 => {
  let [speakingSessions, currentSpeakingSessionIdFromParams] = _ref5;
  return getSelfStudyAssignmentSpeakingSession({
    speakingSessions,
    speakingSessionIdFromParams: currentSpeakingSessionIdFromParams
  });
});
(0,effector/* sample */.UP)({
  clock: [$currentTutorSpeakingSession],
  source: {
    currentTutorSpeakingSession: $currentTutorSpeakingSession,
    lessonState: $lessonState
  },
  fn: _ref6 => {
    let {
      currentTutorSpeakingSession,
      lessonState
    } = _ref6;
    if (currentTutorSpeakingSession === null) {
      return task_guide_model/* TaskGuideFSMState */.ld.Initial;
    }
    if (lessonState === task_guide_model/* TaskGuideFSMState */.ld.ReminderStartingLessonState || lessonState === task_guide_model/* TaskGuideFSMState */.ld.CannotStartSession) {
      return lessonState;
    }
    switch (currentTutorSpeakingSession.speakingSession.state) {
      case speakingSession_model/* SpeakingSessionState */.Z.InProgress:
        return task_guide_model/* TaskGuideFSMState */.ld.Started;
      case speakingSession_model/* SpeakingSessionState */.Z.Completed:
      default:
        return task_guide_model/* TaskGuideFSMState */.ld.Initial;
    }
  },
  target: $lessonState
});
const $task = syllabusDomain.createStore({});
const $motherTasksMap = syllabusDomain.createStore({});
const $module = syllabusDomain.createStore({});
const $modulesOrder = syllabusDomain.createStore([]);
const $fsm = syllabusDomain.createStore({
  module: /* @__PURE__ */new Map(),
  motherTask: /* @__PURE__ */new Map(),
  speakingTask: /* @__PURE__ */new Map(),
  selfStudyTask: /* @__PURE__ */new Map(),
  inClassTask: /* @__PURE__ */new Map()
});
const $visible = syllabusDomain.createStore(storage/* localStorageWrapper */.Y6.taskGuide.isVisible());
const $syllabusId = (0,effector/* createStore */.MT)(null);
const $motherTaskTabRecord = syllabusDomain.createStore({});
const $expandStateRecord = syllabusDomain.createStore({});
const $isLoaded = syllabusDomain.createStore(false);
const $selectedModuleId = syllabusDomain.createStore(null);
const expandMotherTaskEvent = syllabusDomain.createEvent();
const expandMotherTask = motherTaskId => {
  expandMotherTaskEvent({
    motherTaskId
  });
};
const expandMotherTasksEvent = syllabusDomain.createEvent();
const setTasksExpandState = syllabusDomain.createEvent();
const expandMotherTasks = motherTaskIds => {
  expandMotherTasksEvent({
    motherTaskIds
  });
};
const selectNavigationTabEvent = syllabusDomain.createEvent();
const selectNavigationTab = (motherTaskId, tab) => selectNavigationTabEvent({
  motherTaskId,
  tab
});
const setNewTaskState = syllabusDomain.createEvent();
const setNewMotherTaskState = syllabusDomain.createEvent();
const setSyllabus = syllabusDomain.createEvent();
const setTaskSpeakingSessionId = syllabusDomain.createEvent();
const toggleTaskGuideVisibility = syllabusDomain.createEvent();
const setSelectedModuleId = syllabusDomain.createEvent();
$visible.on(toggleTaskGuideVisibility, state => {
  const newState = !state;
  storage/* localStorageWrapper */.Y6.taskGuide.setVisibilityState(newState);
  return newState;
});
$task.on(setSyllabus, (state, payload) => payload.task);
$task.on(setNewTaskState, (state, payload) => {
  const task = state[payload.taskId];
  return {
    ...state,
    [payload.taskId]: {
      ...task,
      state: payload.state
    }
  };
});
$task.on(setTaskSpeakingSessionId, (state, payload) => {
  const task = state[payload.taskId];
  return {
    ...state,
    [payload.taskId]: {
      ...task,
      speakingSessionId: payload.speakingSessionId
    }
  };
});
$motherTasksMap.on(setSyllabus, (state, payload) => payload.motherTask);
$motherTasksMap.on(setNewMotherTaskState, (state, payload) => {
  const task = state[payload.taskId];
  return {
    ...state,
    [payload.taskId]: {
      ...task,
      state: payload.state
    }
  };
});
$module.on(setSyllabus, (state, payload) => payload.module);
$modulesOrder.on(setSyllabus, (state, payload) => payload.modules);
$fsm.on(setSyllabus, (state, payload) => payload.fsmStates);
$motherTaskTabRecord.on(selectNavigationTabEvent, (state, payload) => ({
  ...state,
  [payload.motherTaskId]: payload.tab
}));
$isLoaded.on(setSyllabus, () => true);
$expandStateRecord.on(expandMotherTaskEvent, (state, payload) => ({
  ...state,
  [payload.motherTaskId]: !state[payload.motherTaskId]
}));
$expandStateRecord.on(expandMotherTasksEvent, (state, payload) => payload.motherTaskIds.reduce((acc, id) => {
  acc[id] = true;
  return acc;
}, state));
$expandStateRecord.on(setTasksExpandState, (state, payload) => ({
  ...state,
  ...payload.record
}));
const getVisibleTasks = (navigationType, tasks) => {
  switch (navigationType) {
    case types/* NavigationTabType */.OI.SelfStudy:
      return tasks.selfStudyTasks;
    case types/* NavigationTabType */.OI.Tasks:
      return tasks.tasks;
    default:
      return tasks.inClassTasks;
  }
};
const mapSyllabusMotherTaskStateToTaskGuide = motherTaskState => {
  switch (motherTaskState) {
    case syllabus_model/* SyllabusMotherTaskState */.CZ.Disabled:
      return types/* MotherTaskState */.eQ.Disabled;
    case syllabus_model/* SyllabusMotherTaskState */.CZ.Done:
      return types/* MotherTaskState */.eQ.Done;
    case syllabus_model/* SyllabusMotherTaskState */.CZ.Initial:
      return types/* MotherTaskState */.eQ.Initial;
    case syllabus_model/* SyllabusMotherTaskState */.CZ.InProgress:
      return types/* MotherTaskState */.eQ.InProgress;
    case syllabus_model/* SyllabusMotherTaskState */.CZ.Skipped:
      return types/* MotherTaskState */.eQ.Skipped;
    case syllabus_model/* SyllabusMotherTaskState */.CZ.InLesson:
      return types/* MotherTaskState */.eQ.InClass;
    case syllabus_model/* SyllabusMotherTaskState */.CZ.Unknown:
      return types/* MotherTaskState */.eQ.Unknown;
    default:
      return types/* MotherTaskState */.eQ.Unknown;
  }
};
const mapSyllabusTaskTypeToTaskGuide = taskType => {
  switch (taskType) {
    case syllabus_model/* SyllabusTaskType */.vG.InClass:
      return types/* TaskType */.UA.InClass;
    case syllabus_model/* SyllabusTaskType */.vG.SelfStudy:
      return types/* TaskType */.UA.SelfStudy;
    case syllabus_model/* SyllabusTaskType */.vG.Speaking:
      return types/* TaskType */.UA.Tasks;
    default:
      return types/* TaskType */.UA.Unknown;
  }
};
const mapSyllabusTaskStateToTaskGuide = taskState => {
  switch (taskState) {
    case syllabus_model/* SyllabusTaskState */.YE.Added:
      return task_guide_task_component/* TaskState */.P.Added;
    case syllabus_model/* SyllabusTaskState */.YE.AddedAgain:
      return task_guide_task_component/* TaskState */.P.AddedAgain;
    case syllabus_model/* SyllabusTaskState */.YE.Done:
      return task_guide_task_component/* TaskState */.P.Done;
    case syllabus_model/* SyllabusTaskState */.YE.DoneWithProgress:
      return task_guide_task_component/* TaskState */.P.DoneWithProgress;
    case syllabus_model/* SyllabusTaskState */.YE.Initial:
      return task_guide_task_component/* TaskState */.P.Initial;
    case syllabus_model/* SyllabusTaskState */.YE.InProgress:
      return task_guide_task_component/* TaskState */.P.InProgress;
    case syllabus_model/* SyllabusTaskState */.YE.NotAdded:
      return task_guide_task_component/* TaskState */.P.NotAdded;
    case syllabus_model/* SyllabusTaskState */.YE.NotAvailable:
      return task_guide_task_component/* TaskState */.P.NotAvailable;
    case syllabus_model/* SyllabusTaskState */.YE.Unknown:
      return task_guide_task_component/* TaskState */.P.Unknown;
    default:
      return task_guide_task_component/* TaskState */.P.Unknown;
  }
};
const mapSyllabusMotherTaskTypeToTaskGuide = type => {
  switch (type) {
    case syllabus_model/* SyllabusMotherTaskType */.wU.Foreigner:
      return types/* MotherTaskType */.Dw.Foreigner;
    case syllabus_model/* SyllabusMotherTaskType */.wU.Milestone:
      return types/* MotherTaskType */.Dw.Milestone;
    default:
      return types/* MotherTaskType */.Dw.Default;
  }
};
const $orderedModules = (0,effector/* combine */.$e)($modulesOrder, $motherTasksMap, $task, $motherTaskTabRecord, $expandStateRecord).map(_ref7 => {
  let [order, motherTasksMap, task, motherTaskTabRecord, expandStateRecord] = _ref7;
  const orderedModules = order.map(module => {
    const motherTasks = module.motherTasks.map(moduleMotherTask => {
      const currentMotherTask = motherTasksMap[moduleMotherTask.id];
      const hideTaskNavigationTab = !moduleMotherTask.tasks.length;
      const selectedNavigationTabType = motherTaskTabRecord[moduleMotherTask.id] ?? (hideTaskNavigationTab ? types/* NavigationTabType */.OI.InClass : types/* NavigationTabType */.OI.Tasks);
      const visibleTasks = getVisibleTasks(selectedNavigationTabType, {
        selfStudyTasks: moduleMotherTask.selfStudyTasks,
        inClassTasks: moduleMotherTask.inClassTasks,
        tasks: moduleMotherTask.tasks
      });
      return {
        id: moduleMotherTask.id,
        expanded: expandStateRecord[currentMotherTask.id],
        selectedNavigationTabType,
        hideTaskNavigationTab,
        tasks: visibleTasks.map(t => {
          const currentTask = task[t.id];
          return {
            id: currentTask.id,
            chapterId: currentTask.chapterId ?? currentTask.taskId,
            type: mapSyllabusTaskTypeToTaskGuide(t.type),
            taskId: currentTask.taskId,
            state: mapSyllabusTaskStateToTaskGuide(currentTask.state),
            expanded: expandStateRecord[currentTask.id],
            expendedContent: currentTask.instruction,
            text: currentTask.text
          };
        }),
        type: mapSyllabusMotherTaskTypeToTaskGuide(currentMotherTask.type),
        changedAt: currentMotherTask.updatedAt,
        state: mapSyllabusMotherTaskStateToTaskGuide(currentMotherTask.state),
        title: currentMotherTask.title
      };
    });
    return {
      ...module,
      motherTasks
    };
  });
  return orderedModules;
});
const $inLessonModules = $orderedModules.map(m => m.reduce((acc, m2, index) => {
  acc.set(m2.id, {
    title: m2.title,
    id: m2.id,
    highlighted: false,
    order: index,
    tasks: m2.motherTasks
  });
  return acc;
}, /* @__PURE__ */new Map()));
$selectedModuleId.on(setSelectedModuleId, (_, payload) => payload.moduleId);
const doneMotherTaskState = [types/* MotherTaskState */.eQ.Done, types/* MotherTaskState */.eQ.Skipped];
const isDoneMotherTaskState = motherTask => doneMotherTaskState.includes(motherTask.state);
const $doneMotherTasks = $orderedModules.map(modules => {
  const doneMotherTasks = modules.reduce((acc, module) => {
    acc.push(...module.motherTasks.filter(task => isDoneMotherTaskState(task) && !acc.find(t => t.id === task.id)));
    return acc;
  }, []);
  return doneMotherTasks;
});
const $doneMotherTasksGroupedByUpdatedAt = $doneMotherTasks.map(motherTasks => {
  const grouped = Object.groupBy(motherTasks, motherTask => (0,format/* format */.WU)(motherTask.changedAt, "dd/MM/yyyy"));
  return Object.values(grouped).map(group => ({
    date: group[0].changedAt,
    motherTasks: group
  })).sort((a, b) => (0,isBefore/* isBefore */.R)(a.date, b.date) ? 1 : -1);
});
const $selfStudyTasks = (0,effector/* combine */.$e)($modulesOrder, $motherTasksMap, $task, $expandStateRecord).map(_ref8 => {
  let [order, motherTaskMap, task, expandStateRecord] = _ref8;
  return order.reduce((acc, module) => {
    const tasks = module.motherTasks.reduce((tasksAcc, motherTask) => {
      const {
        title
      } = motherTaskMap[motherTask.id];
      const mappedTasks = motherTask.selfStudyTasks.map(t => {
        const currentTask = task[t.id];
        return {
          id: currentTask.id,
          chapterId: currentTask.chapterId ?? currentTask.taskId,
          type: types/* TaskType */.UA.SelfStudy,
          taskId: currentTask.taskId,
          state: mapSyllabusTaskStateToTaskGuide(currentTask.state),
          expanded: expandStateRecord[currentTask.id],
          expendedContent: currentTask.instruction,
          text: currentTask.text,
          speakingSessionId: currentTask.type === syllabus_model/* SyllabusTaskType */.vG.SelfStudy ? currentTask.speakingSessionId : void 0,
          motherTaskTitle: title,
          motherTaskId: motherTask.id
        };
      });
      tasksAcc.push(...mappedTasks);
      return tasksAcc;
    }, []);
    acc.push(...tasks);
    return acc;
  }, []);
});
const $groupedByMotherTasks = $selfStudyTasks.map(t => {
  const groupedByMotherTasksMap = Object.groupBy(t, task => task.motherTaskId);
  return Object.values(groupedByMotherTasksMap).map(group => ({
    title: group[0].motherTaskTitle,
    tasks: uniqWith/* default */.Z((a, b) => a.id === b.id)(group)
  }));
});
const $addedTasks = $selfStudyTasks.map(tasks => {
  const filtered = tasks.filter(t => t.state === task_guide_task_component/* TaskState */.P.Added);
  return uniqWith/* default */.Z((a, b) => a.id === b.id)(filtered);
});
const $addedTasksInCurrentLesson = (0,effector/* combine */.$e)($addedTasks, $selfStudyAssignmentSpeakingSession).map(_ref9 => {
  let [tasks, speakingSession] = _ref9;
  const filtered = tasks.filter(t => t.speakingSessionId === speakingSession?.speakingSession.id);
  return uniqWith/* default */.Z((a, b) => a.id === b.id)(filtered);
});
const doneStates = [task_guide_task_component/* TaskState */.P.Done, task_guide_task_component/* TaskState */.P.DoneWithProgress];
const $completedTasks = $selfStudyTasks.map(tasks => {
  const filtered = tasks.filter(t => doneStates.includes(t.state));
  return uniqWith/* default */.Z((a, b) => a.id === b.id)(filtered);
});
const getStudentId = studentIdFromParams => {
  const currentStudentFromLocalStorage = storage/* sessionStorageWrapper */.KO.taskGuide.getCurrentStudentId();
  if (!studentIdFromParams && currentStudentFromLocalStorage) {
    return currentStudentFromLocalStorage;
  }
  if (studentIdFromParams === currentStudentFromLocalStorage) {
    return currentStudentFromLocalStorage;
  }
  if (studentIdFromParams && studentIdFromParams !== currentStudentFromLocalStorage) {
    storage/* sessionStorageWrapper */.KO.taskGuide.setCurrentUserId(studentIdFromParams);
    return studentIdFromParams;
  }
};
const getInitialTaskGuideDataFx = (0,effector/* createEffect */.GW)(async params => {
  const {
    studentId,
    getCurrentSpeakingSession
  } = params;
  const result = await api/* taskGuideApiAdapter */.w.getTutorSpeakingSessions(studentId);
  try {
    let syllabusId = syllabus_model/* SYLLABUS_A */.Gg;
    const currentSpeakingSession = getCurrentSpeakingSession({
      speakingSessions: Object.values(result),
      speakingSessionIdFromParams: null
    });
    if (currentSpeakingSession?.speakingSession.syllabusId !== void 0) {
      syllabusId = currentSpeakingSession?.speakingSession.syllabusId;
    } else {
      const attributesResult = await (0,attributes_api/* getTutorAttributes */.Y)();
      if ((0,Either.isRight)(attributesResult) && attributesResult.right.syllabusId !== void 0) {
        syllabusId = attributesResult.right.syllabusId;
      }
    }
    return {
      currentSpeakingSession,
      syllabusId,
      speakingSessionsMap: result
    };
  } catch {
    return {};
  }
});
const $syllabusIdFromParams = (0,effector/* createStore */.MT)(null);
const setSyllabusIdFromParams = (0,effector/* createEvent */.yM)();
$syllabusIdFromParams.on(setSyllabusIdFromParams, (_, _ref10) => {
  let {
    syllabusId
  } = _ref10;
  return syllabusId ?? null;
});
$speakingSessions.on(getInitialTaskGuideDataFx.done, (state, payload) => payload.result.speakingSessionsMap);
$syllabusId.on(getInitialTaskGuideDataFx.done, (state, payload) => payload.result.syllabusId);
(0,effector/* sample */.UP)({
  clock: [$currentTutorSpeakingSession, getInitialTaskGuideDataFx.done, $syllabusIdFromParams],
  source: {
    syllabusIdFromParams: $syllabusIdFromParams,
    currentTutorSpeakingSession: $currentTutorSpeakingSession,
    syllabusId: $syllabusId
  },
  fn: source => {
    const {
      syllabusIdFromParams,
      currentTutorSpeakingSession,
      syllabusId
    } = source;
    if (syllabusIdFromParams !== null) {
      return syllabusIdFromParams;
    }
    const syllabusIdFromSpeakingSession = currentTutorSpeakingSession?.speakingSession.syllabusId ?? null;
    if (syllabusIdFromSpeakingSession !== null) {
      return syllabusIdFromSpeakingSession;
    }
    if (syllabusId !== null) {
      return syllabusId;
    }
    return syllabus_model/* SYLLABUS_A */.Gg;
  },
  target: $syllabusId
});
const useTaskGuideStorage = params => {
  const selfStudyTasks = (0,effector_react/* useStore */.oR)($selfStudyTasks);
  const inLessonsModules = (0,effector_react/* useStore */.oR)($inLessonModules);
  const taskRecord = (0,effector_react/* useStore */.oR)($task);
  const motherTaskRecord = (0,effector_react/* useStore */.oR)($motherTasksMap);
  const fsm = (0,effector_react/* useStore */.oR)($fsm);
  const addedTasks = (0,effector_react/* useStore */.oR)($addedTasks);
  const completedTasks = (0,effector_react/* useStore */.oR)($completedTasks);
  const groupedByMotherTasks = (0,effector_react/* useStore */.oR)($groupedByMotherTasks);
  const doneMotherTasks = (0,effector_react/* useStore */.oR)($doneMotherTasks);
  const expandStateRecord = (0,effector_react/* useStore */.oR)($expandStateRecord);
  const doneMotherTasksGroupedByUpdatedAt = (0,effector_react/* useStore */.oR)($doneMotherTasksGroupedByUpdatedAt);
  const addedTasksInCurrentLesson = (0,effector_react/* useStore */.oR)($addedTasksInCurrentLesson);
  const isVisible = (0,effector_react/* useStore */.oR)($visible);
  const selectedModuleId = (0,effector_react/* useStore */.oR)($selectedModuleId);
  const lessonState = (0,effector_react/* useStore */.oR)($lessonState);
  const orderedModules = (0,effector_react/* useStore */.oR)($orderedModules);
  const syllabusId = (0,effector_react/* useStore */.oR)($syllabusId);
  const tutorSpeakingSessions = (0,effector_react/* useStore */.oR)($tutorSpeakingSessions);
  const currentTutorSpeakingSession = (0,effector_react/* useStore */.oR)($currentTutorSpeakingSession);
  const selfStudyAssignmentSpeakingSession = (0,effector_react/* useStore */.oR)($selfStudyAssignmentSpeakingSession);
  const nextConsecutiveSpeakingSession = (0,effector_react/* useStore */.oR)($nextConsecutiveSpeakingSession);
  const [startingSessionError, setStartingSessionError] = (0,react.useState)(null);
  (0,react.useEffect)(() => {
    setSpeakingSessionIdFromParams({
      speakingSessionId: params.speakingSessionId
    });
    setSyllabusIdFromParams({
      syllabusId: params.syllabusId
    });
  }, [params.speakingSessionId, params.syllabusId]);
  const getInitialTaskGuideData = (0,react.useCallback)(studentId => getInitialTaskGuideDataFx({
    studentId,
    getCurrentSpeakingSession: getCurrentTutorSpeakingSession
  }), []);
  return (0,react.useMemo)(() => ({
    setLessonState,
    nextLessonState,
    lessonState,
    selfStudyTasks,
    expandStateRecord,
    inLessonsModules,
    toggleTaskGuideVisibility,
    expandMotherTask,
    selectNavigationTab,
    taskRecord,
    motherTaskRecord,
    setNewMotherTaskState,
    setTasksExpandState,
    expandMotherTasks,
    fsm,
    setSyllabus,
    setNewTaskState,
    addedTasks,
    completedTasks,
    groupedByMotherTasks,
    doneMotherTasks,
    doneMotherTasksGroupedByUpdatedAt,
    addedTasksInCurrentLesson,
    setTaskSpeakingSessionId,
    isVisible,
    selectedModuleId,
    setSelectedModuleId,
    orderedModules,
    syllabusId,
    studentId: (0,student_model/* makeStudentId */.Ox)(getStudentId(params?.studentId) ?? ""),
    getInitialTaskGuideData,
    selfStudyAssignmentSpeakingSession,
    currentSpeakingSession: currentTutorSpeakingSession,
    tutorSpeakingSessions,
    setSpeakingSessionState,
    setSpeakingSession,
    nextConsecutiveSpeakingSession,
    startingSessionError,
    setStartingSessionError
  }), [addedTasks, addedTasksInCurrentLesson, completedTasks, currentTutorSpeakingSession, doneMotherTasks, doneMotherTasksGroupedByUpdatedAt, expandStateRecord, fsm, getInitialTaskGuideData, groupedByMotherTasks, inLessonsModules, isVisible, lessonState, motherTaskRecord, nextConsecutiveSpeakingSession, orderedModules, params?.studentId, selectedModuleId, selfStudyAssignmentSpeakingSession, selfStudyTasks, startingSessionError, syllabusId, taskRecord, tutorSpeakingSessions]);
};
// EXTERNAL MODULE: ./src/services/taskGuide/utils.tsx
var utils = __webpack_require__(55820);
;// CONCATENATED MODULE: ./src/services/taskGuide/useTaskGuide.ts
































const useCreateTaskGuideService = adapters => {
  const {
    storage,
    syllabusApiService,
    user,
    dateService,
    api,
    openAdditionalSyllabus,
    removeSpeakingSessionIdFromUrl,
    goToTask,
    onLessonStart,
    onNextLessonStart,
    onLessonFinish,
    onLessonCancel,
    onSelfStudyAdd
  } = adapters;
  const {
    selfStudyTasks,
    inLessonsModules,
    expandMotherTask,
    expandMotherTasks,
    selectNavigationTab,
    taskRecord,
    fsm,
    setNewTaskState,
    motherTaskRecord,
    setNewMotherTaskState,
    setSyllabus,
    completedTasks,
    addedTasks,
    groupedByMotherTasks,
    doneMotherTasks,
    setTasksExpandState,
    expandStateRecord,
    doneMotherTasksGroupedByUpdatedAt,
    addedTasksInCurrentLesson,
    setTaskSpeakingSessionId,
    toggleTaskGuideVisibility,
    isVisible,
    selectedModuleId,
    setSelectedModuleId,
    lessonState,
    setLessonState,
    nextLessonState,
    orderedModules,
    studentId,
    syllabusId,
    selfStudyAssignmentSpeakingSession,
    currentSpeakingSession,
    setSpeakingSession,
    setStartingSessionError,
    startingSessionError,
    nextConsecutiveSpeakingSession
  } = storage;
  const tutorId = (0,react.useMemo)(() => user?.id ?? "", [user?.id]);
  const currentUserRole = (0,react.useMemo)(() => user?.role, [user?.role]);
  const changeSpeakingSessionState = (0,react.useCallback)(async params => {
    if (syllabusId === null) {
      logger/* Logger */.Yd.captureError("Try to change speakingSessionState without syllabusId");
      return;
    }
    let speakingSessionData;
    const lazySpeakingSession = (0,speakingSession_model/* makeSpeakingSession */.V$)({
      id: (0,v4/* default */.Z)()
    });
    if (currentSpeakingSession !== null) {
      speakingSessionData = currentSpeakingSession;
    } else {
      speakingSessionData = {
        speakingSession: lazySpeakingSession,
        source: SpeakingSessionSource.GeneratedByFrontend
      };
    }
    if (speakingSessionData.speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Completed) {
      if (nextConsecutiveSpeakingSession) {
        speakingSessionData = {
          speakingSession: nextConsecutiveSpeakingSession,
          source: SpeakingSessionSource.FromParams
        };
      } else {
        speakingSessionData = {
          speakingSession: lazySpeakingSession,
          source: SpeakingSessionSource.GeneratedByFrontend
        };
      }
    }
    let event;
    if (params?.newEvent) {
      event = params.newEvent;
    } else {
      event = (0,speakingSession_model/* getNewSpeakingSessionEvent */.Qn)(speakingSessionData.speakingSession);
    }
    speakingSessionData.speakingSession.state = (0,speakingSession_model/* getNewSpeakingSessionState */.r1)(speakingSessionData.speakingSession, event);
    setSpeakingSession({
      id: speakingSessionData.speakingSession.id,
      session: speakingSessionData.speakingSession
    });
    const formattedStartAt = dateService.formatDateForBackend(speakingSessionData.speakingSession.startAt);
    return api.changeSpeakingSessionState({
      event,
      speakingSessionId: speakingSessionData.speakingSession.id,
      startAt: formattedStartAt,
      studentId,
      tutorId,
      businessProductId: speakingSessionData.speakingSession.speaking.properties?.businessProductId || product_model/* BusinessProductId */.HV.ProductA,
      syllabusId,
      cancelReason: params?.cancelReason,
      speakingSessionSource: speakingSessionData.source
    });
  }, [api, currentSpeakingSession, dateService, nextConsecutiveSpeakingSession, setSpeakingSession, studentId, syllabusId, tutorId]);
  const updateCurrentSpeakingSession = (0,react.useCallback)(async () => {
    if (!currentSpeakingSession) {
      return;
    }
    const isNextConsecutiveSpeakingSession = currentSpeakingSession.speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Completed && nextConsecutiveSpeakingSession;
    const {
      id
    } = isNextConsecutiveSpeakingSession ? nextConsecutiveSpeakingSession : currentSpeakingSession.speakingSession;
    try {
      const actualCurrentSession = await api.getSpeakingSession(id);
      setSpeakingSession({
        id,
        session: actualCurrentSession
      });
      return actualCurrentSession;
    } catch (e) {
      logger/* Logger */.Yd.captureException(e);
    }
  }, [api, currentSpeakingSession, nextConsecutiveSpeakingSession, setSpeakingSession]);
  const checkNextConsecutiveSpeakingSession = (0,react.useCallback)(async () => {
    if (nextConsecutiveSpeakingSession === null) {
      return;
    }
    const session = await api.getSpeakingSession(nextConsecutiveSpeakingSession.id);
    setSpeakingSession({
      id: nextConsecutiveSpeakingSession.id,
      session
    });
  }, [api, nextConsecutiveSpeakingSession, setSpeakingSession]);
  const redirectToSessionWithSameTime = (0,react.useCallback)(async _ref => {
    let {
      id,
      startAt
    } = _ref;
    const speakingSessions = await api.getTutorSpeakingSessions(studentId);
    const acitveStates = [speakingSession_model/* SpeakingSessionState */.Z.Scheduled, speakingSession_model/* SpeakingSessionState */.Z.InProgress];
    const sessionOnSameTime = Object.values(speakingSessions).find(session =>
    // exclude current session
    session.id !== id &&
    // check state
    acitveStates.includes(session.state) &&
    // at same time
    session.startAt.valueOf() === startAt.valueOf());
    if (sessionOnSameTime) {
      const sessionLink = `${(0,site_utils/* getAppPath */.bY)()}${teacher_route_paths/* teacherRoutePaths */.q.SPEAKING(sessionOnSameTime.id)}`;
      window.location.replace(sessionLink);
    }
  }, [api, studentId]);
  const checkCurrentSession = (0,react.useCallback)(async () => {
    if (!currentSpeakingSession) {
      return false;
    }
    const actualCurrentSession = await updateCurrentSpeakingSession();
    if (!actualCurrentSession) {
      return false;
    }
    if ((0,utils/* isSessionRescheduled */.t9)(actualCurrentSession)) {
      setStartingSessionError(task_guide_model/* StartingSessionError */.D8.SessionRescheduled);
      return false;
    }
    if ((0,utils/* isSessionCanceled */.Kv)(actualCurrentSession)) {
      setStartingSessionError(task_guide_model/* StartingSessionError */.D8.SessionCancelled);
      await redirectToSessionWithSameTime(actualCurrentSession);
      return false;
    }
    return true;
  }, [currentSpeakingSession, setStartingSessionError, updateCurrentSpeakingSession, redirectToSessionWithSameTime]);
  const tryStartSpeakingSession = (0,react.useCallback)(async () => {
    if ([task_guide_model/* TaskGuideFSMState */.ld.StartingSessionState, task_guide_model/* TaskGuideFSMState */.ld.ReminderStartingLessonState, task_guide_model/* TaskGuideFSMState */.ld.SelectingSessionState].includes(lessonState)) {
      const canStart = await checkCurrentSession();
      if (!canStart) {
        nextLessonState(task_guide_model/* TaskGuideFSMEvent */.lt.CannotStartSession);
        if (removeSpeakingSessionIdFromUrl) {
          removeSpeakingSessionIdFromUrl();
        }
        return Promise.resolve();
      }
    }
    nextLessonState(task_guide_model/* TaskGuideFSMEvent */.lt.Start);
    if ([task_guide_model/* TaskGuideFSMState */.ld.StartingSessionState, task_guide_model/* TaskGuideFSMState */.ld.ReminderStartingLessonState, task_guide_model/* TaskGuideFSMState */.ld.SelectingSessionState].includes(lessonState)) {
      return changeSpeakingSessionState();
    }
  }, [changeSpeakingSessionState, checkCurrentSession, lessonState, nextLessonState, removeSpeakingSessionIdFromUrl]);
  const handleStart = (0,react.useCallback)(async () => {
    await tryStartSpeakingSession();
    onLessonStart?.();
    return Promise.resolve();
  }, [tryStartSpeakingSession, onLessonStart]);
  const handleFinish = (0,react.useCallback)(async () => {
    nextLessonState(task_guide_model/* TaskGuideFSMEvent */.lt.Finish);
    if (lessonState === task_guide_model/* TaskGuideFSMState */.ld.SelectingSelfStudy) {
      onLessonFinish?.();
      return changeSpeakingSessionState();
    }
    if (lessonState === task_guide_model/* TaskGuideFSMState */.ld.SelectingSessionState) {
      onSelfStudyAdd?.();
    }
    return Promise.resolve();
  }, [nextLessonState, lessonState, onLessonFinish, changeSpeakingSessionState, onSelfStudyAdd]);
  const handleStartNextLesson = (0,react.useCallback)(async () => {
    await changeSpeakingSessionState();
    if (!nextConsecutiveSpeakingSession) {
      return;
    }
    onNextLessonStart?.(nextConsecutiveSpeakingSession);
    await tryStartSpeakingSession();
  }, [changeSpeakingSessionState, nextConsecutiveSpeakingSession, onNextLessonStart, tryStartSpeakingSession]);
  const handleClose = (0,react.useCallback)(() => {
    nextLessonState(task_guide_model/* TaskGuideFSMEvent */.lt.Close);
    return Promise.resolve();
  }, [nextLessonState]);
  const handleCancel = (0,react.useCallback)(reason => () => {
    onLessonCancel?.(reason);
    nextLessonState(task_guide_model/* TaskGuideFSMEvent */.lt.Cancel);
    return changeSpeakingSessionState({
      newEvent: speakingSession_model/* SpeakingSessionFSMEvent */.jO.Cancel,
      cancelReason: reason
    });
  }, [changeSpeakingSessionState, nextLessonState, onLessonCancel]);
  const handleReturn = (0,react.useCallback)(() => nextLessonState(task_guide_model/* TaskGuideFSMEvent */.lt.Return), [nextLessonState]);
  const resetTestResult = (0,student_test_store/* useStudentTestStore */.C)(state => state.resetTestResult);
  const handleClickTaskIcon = (0,react.useCallback)(params => {
    const event = (0,syllabus_model/* getNextSyllabusTaskEvent */.bN)({
      taskId: params.taskId,
      tasks: taskRecord
    });
    const currentTask = taskRecord[params.taskId];
    const newState = (0,syllabus_model/* getNewTaskState */.Df)({
      taskId: params.taskId,
      tasks: taskRecord,
      event,
      syllabusFsm: fsm
    });
    if (currentTask.state === syllabus_model/* SyllabusTaskState */.YE.InProgress && currentTask.type === syllabus_model/* SyllabusTaskType */.vG.SelfStudy) {
      return;
    }
    const newMotherTaskEvent = (0,syllabus_model/* getNewMotherTaskEvent */.Jx)({
      motherTaskId: params.motherTaskId,
      taskId: params.taskId,
      newTaskState: newState,
      tasksRecord: taskRecord,
      motherTaskRecord
    });
    if (newMotherTaskEvent !== null) {
      void syllabusApiService.sendEvent({
        studentId,
        tutorId,
        event: newMotherTaskEvent,
        nodeId: params.motherTaskId
      });
      const newMotherTaskState = (0,syllabus_model/* getNewMotherTaskState */.ez)({
        motherTaskId: params.motherTaskId,
        syllabusFsm: fsm,
        motherTasks: motherTaskRecord,
        event
      });
      setNewMotherTaskState({
        taskId: params.motherTaskId,
        state: newMotherTaskState
      });
      if (newMotherTaskState === syllabus_model/* SyllabusMotherTaskState */.CZ.Done) {
        expandMotherTask(params.motherTaskId);
      }
    }
    setNewTaskState({
      taskId: params.taskId,
      state: newState
    });
    let stateAttributes = {};
    if (event === syllabus_model/* SyllabusNodeFSMEvent */.Sx.Assign) {
      stateAttributes = {
        assignedAt: dateService.formatDateForBackend( /* @__PURE__ */new Date()),
        motherTaskId: params.motherTaskId,
        speakingSessionId: selfStudyAssignmentSpeakingSession?.speakingSession.id
      };
      if (selfStudyAssignmentSpeakingSession) {
        setTaskSpeakingSessionId({
          taskId: params.taskId,
          speakingSessionId: selfStudyAssignmentSpeakingSession.speakingSession.id
        });
      }
    }
    if (event === syllabus_model/* SyllabusNodeFSMEvent */.Sx.Progress && currentTask.type !== syllabus_model/* SyllabusTaskType */.vG.SelfStudy) {
      goToTask(currentTask.chapterId ?? currentTask.taskId);
      resetTestResult();
    }
    void syllabusApiService.sendEvent({
      studentId,
      tutorId,
      event,
      nodeId: params.taskId,
      attributes: stateAttributes
    });
  }, [dateService, expandMotherTask, fsm, goToTask, motherTaskRecord, selfStudyAssignmentSpeakingSession, setNewMotherTaskState, setNewTaskState, setTaskSpeakingSessionId, studentId, syllabusApiService, taskRecord, tutorId, resetTestResult]);
  const handleClickTask = (0,react.useCallback)(params => {
    const task = taskRecord[params.taskId];
    const motherTask = motherTaskRecord[params.motherTaskId];
    const shouldOpenTrainer = task.state === syllabus_model/* SyllabusTaskState */.YE.InProgress || task.type === syllabus_model/* SyllabusTaskType */.vG.SelfStudy || currentSpeakingSession === null || currentSpeakingSession.speakingSession.state !== speakingSession_model/* SpeakingSessionState */.Z.InProgress;
    if (shouldOpenTrainer) {
      goToTask(task.chapterId ?? task.taskId);
      resetTestResult();
    }
    if (!task.instruction) {
      return;
    }
    const otherMotherTasksTasksExpandState = [...motherTask.speakingTasks, ...motherTask.inClassTasks].filter(t => t.id !== params.taskId).reduce((acc, t) => {
      acc[t.id] = false;
      return acc;
    }, {});
    setTasksExpandState({
      record: {
        [params.taskId]: !expandStateRecord[params.taskId],
        ...otherMotherTasksTasksExpandState
      }
    });
  }, [currentSpeakingSession, expandStateRecord, goToTask, motherTaskRecord, resetTestResult, setTasksExpandState, taskRecord]);
  const handleSkipMotherTask = (0,react.useCallback)(params => {
    const newState = (0,syllabus_model/* getNewMotherTaskState */.ez)({
      motherTaskId: params.motherTaskId,
      syllabusFsm: fsm,
      motherTasks: motherTaskRecord,
      event: syllabus_model/* SyllabusNodeFSMEvent */.Sx.Skip
    });
    setNewMotherTaskState({
      taskId: params.motherTaskId,
      state: newState
    });
    setTasksExpandState({
      record: {
        [params.motherTaskId]: false
      }
    });
    void syllabusApiService.sendEvent({
      studentId,
      tutorId,
      event: syllabus_model/* SyllabusNodeFSMEvent */.Sx.Skip,
      nodeId: params.motherTaskId
    });
  }, [fsm, motherTaskRecord, setNewMotherTaskState, setTasksExpandState, studentId, syllabusApiService, tutorId]);
  const handleUnSkipMotherTask = (0,react.useCallback)(params => {
    const newState = (0,syllabus_model/* getNewMotherTaskState */.ez)({
      motherTaskId: params.motherTaskId,
      syllabusFsm: fsm,
      motherTasks: motherTaskRecord,
      event: syllabus_model/* SyllabusNodeFSMEvent */.Sx.UnSkip
    });
    setNewMotherTaskState({
      taskId: params.motherTaskId,
      state: newState
    });
    void syllabusApiService.sendEvent({
      studentId,
      tutorId,
      event: syllabus_model/* SyllabusNodeFSMEvent */.Sx.UnSkip,
      nodeId: params.motherTaskId
    });
  }, [fsm, motherTaskRecord, setNewMotherTaskState, studentId, syllabusApiService, tutorId]);
  const handleMotherTaskStateLabelClick = (0,react.useCallback)(params => {
    const currentMotherTask = motherTaskRecord[params.motherTaskId];
    if (!currentMotherTask) {
      return;
    }
    const event = (0,syllabus_model/* getNextMotherTaskEventWithState */.ey)(currentMotherTask.state);
    const newState = (0,syllabus_model/* getNewMotherTaskState */.ez)({
      motherTaskId: params.motherTaskId,
      syllabusFsm: fsm,
      motherTasks: motherTaskRecord,
      event
    });
    setNewMotherTaskState({
      taskId: params.motherTaskId,
      state: newState
    });
    void syllabusApiService.sendEvent({
      studentId,
      tutorId,
      event,
      nodeId: params.motherTaskId
    });
  }, [fsm, motherTaskRecord, setNewMotherTaskState, studentId, syllabusApiService, tutorId]);
  const isEnabled = (0,react.useMemo)(() => currentUserRole && [entities_user/* UserRole */.i4.ROLE_TUTOR, entities_user/* UserRole */.i4.ROLE_HR, entities_user/* UserRole */.i4.ROLE_DEVELOPER, entities_user/* UserRole */.i4.ROLE_METHODOLOGIST, entities_user/* UserRole */.i4.ROLE_SUPPORT].includes(currentUserRole), [currentUserRole]);
  const isVisibleTaskGuide = (0,react.useMemo)(() => isVisible && isEnabled, [isEnabled, isVisible]);
  return (0,react.useMemo)(() => ({
    setLessonState,
    openAdditionalSyllabus,
    lessonState,
    setSyllabus,
    studentId: (0,student_model/* makeStudentId */.Ox)(studentId),
    getSyllabus: syllabus_api_adapter/* syllabusApi */.A.getSyllabus,
    getSpeakingSessions: api.getTutorSpeakingSessions,
    currentSpeakingSession,
    selfStudyTasks,
    inLessonsModules,
    onExpandMotherTask: expandMotherTask,
    onExpandMotherTasks: expandMotherTasks,
    selectNavigationTab,
    handleUnSkipMotherTask,
    handleSkipMotherTask,
    handleClickTask,
    handleClickTaskIcon,
    completedTasks,
    addedTasks,
    addedTasksInCurrentLesson,
    groupedByMotherTasks,
    doneMotherTasks,
    getTutorAttributes: tutorAttributesApiAdapter.getAttributes,
    doneMotherTasksGroupedByUpdatedAt,
    toggleTaskGuideVisibility,
    isVisible: isVisibleTaskGuide,
    isEnabled,
    selectedModuleId,
    setSelectedModuleId,
    handleMotherTaskStateLabelClick,
    orderedModules,
    getInitialTaskGuideData: storage.getInitialTaskGuideData,
    syllabusId,
    buttonHandlers: {
      start: handleStart,
      startNextLesson: handleStartNextLesson,
      finish: handleFinish,
      close: handleClose,
      cancel: handleCancel,
      return: handleReturn
    },
    startingSessionError,
    isNextConsecutiveSpeakingSessionExist: Boolean(nextConsecutiveSpeakingSession && !(0,utils/* isSessionCanceled */.Kv)(nextConsecutiveSpeakingSession)),
    isNextConsecutiveSpeakingSessionSoon: nextConsecutiveSpeakingSession && (0,utils/* isSessionStartSoon */.cw)(nextConsecutiveSpeakingSession) && !(0,utils/* isSessionCanceled */.Kv)(nextConsecutiveSpeakingSession),
    checkNextConsecutiveSpeakingSession
  }), [addedTasks, addedTasksInCurrentLesson, api.getTutorSpeakingSessions, checkNextConsecutiveSpeakingSession, completedTasks, currentSpeakingSession, doneMotherTasks, doneMotherTasksGroupedByUpdatedAt, expandMotherTask, expandMotherTasks, groupedByMotherTasks, handleCancel, handleClickTask, handleClickTaskIcon, handleClose, handleFinish, handleMotherTaskStateLabelClick, handleReturn, handleSkipMotherTask, handleStart, handleStartNextLesson, handleUnSkipMotherTask, inLessonsModules, isEnabled, isVisibleTaskGuide, lessonState, nextConsecutiveSpeakingSession, openAdditionalSyllabus, orderedModules, selectNavigationTab, selectedModuleId, selfStudyTasks, setLessonState, setSelectedModuleId, setSyllabus, startingSessionError, storage.getInitialTaskGuideData, studentId, syllabusId, toggleTaskGuideVisibility]);
};
const useTaskGuide = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const syllabusIdFromUrl = get_url_search_params.getUrlSearchParams.taskGuide.getSyllabusId(history);
  const speakingSessionIdFromUrl = get_url_search_params.getUrlSearchParams.taskGuide.getSpeakingSessionId(history);
  const studentIdFromUrl = get_url_search_params.getUrlSearchParams.taskGuide.getStudentId(history);
  const removeSpeakingSessionIdFromUrl = () => history.replace(get_url_search_params.getUrlSearchParams.taskGuide.removeSpeakingSessionId(history));
  const resetTestResult = (0,student_test_store/* useStudentTestStore */.C)(state => state.resetTestResult);
  const goToTask = taskId => {
    history.push(get_url_search_params.getUrlSearchParams.taskGuide.getTaskGuideLink(teacher_route_paths/* teacherRoutePaths */.q.PRODUCT_REVISION(taskId), {
      syllabusId: syllabusIdFromUrl,
      studentId: studentIdFromUrl,
      speakingSessionId: speakingSessionIdFromUrl
    }, history));
    resetTestResult();
  };
  const openAdditionalSyllabus = additionalSyllabus => {
    const href = `${(0,site_utils/* getAppPath */.bY)()}${get_url_search_params.getUrlSearchParams.taskGuide.getTaskGuideLink(teacher_route_paths/* teacherRoutePaths */.q.INDEX, {
      syllabusId: additionalSyllabus
    }, history)}`;
    window.open(href);
  };
  return useTaskGuideWithParams({
    studentId: (0,student_model/* makeStudentId */.Ox)(studentIdFromUrl ?? ""),
    syllabusId: syllabusIdFromUrl,
    speakingSessionId: speakingSessionIdFromUrl,
    goToTask,
    openAdditionalSyllabus,
    removeSpeakingSessionIdFromUrl
  });
};
const useTaskGuideWithParams = _ref2 => {
  let {
    studentId,
    syllabusId,
    speakingSessionId,
    goToTask,
    openAdditionalSyllabus,
    removeSpeakingSessionIdFromUrl,
    onLessonStart,
    onNextLessonStart,
    onLessonFinish,
    onLessonCancel,
    onSelfStudyAdd
  } = _ref2;
  const taskGuideStorage = useTaskGuideStorage({
    studentId,
    syllabusId,
    speakingSessionId
  });
  const {
    user
  } = (0,user_storage_adapter/* useUserStorage */.q)();
  const params = (0,react.useMemo)(() => ({
    tutorAttributesService: tutorAttributesApiAdapter,
    storage: taskGuideStorage,
    syllabusApiService: syllabus_api_adapter/* syllabusApi */.A,
    user,
    dateService: date_service_adapter/* dateServiceAdapter */.e,
    api: api/* taskGuideApiAdapter */.w,
    removeSpeakingSessionIdFromUrl,
    goToTask,
    openAdditionalSyllabus,
    onLessonStart,
    onNextLessonStart,
    onLessonFinish,
    onLessonCancel,
    onSelfStudyAdd
  }), [user, goToTask, onLessonCancel, onLessonFinish, onLessonStart, onNextLessonStart, onSelfStudyAdd, openAdditionalSyllabus, removeSpeakingSessionIdFromUrl, taskGuideStorage]);
  return useCreateTaskGuideService(params);
};

/***/ }),

/***/ 55820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Kv: () => (/* binding */ isSessionCanceled),
/* harmony export */   cw: () => (/* binding */ isSessionStartSoon),
/* harmony export */   t9: () => (/* binding */ isSessionRescheduled)
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51461);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49566);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64306);
/* harmony import */ var _yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43055);





const isSessionStartSoon = speakingSession => {
  const MINUTES_BEFORE_START = 5;
  const currentTime = /* @__PURE__ */new Date();
  return (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* .isAfter */ .A)(currentTime, (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .subMinutes */ ._)(speakingSession.startAt, MINUTES_BEFORE_START));
};
const isSessionRescheduled = speakingSession => speakingSession.state === _yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionState */ .Z.Scheduled && (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(isSessionStartSoon(speakingSession));
const isSessionCanceled = _ref => {
  let {
    state
  } = _ref;
  return state === _yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionState */ .Z.CancelledUnbilled || state === _yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionState */ .Z.CancelledAutomatically || state === _yandex_langly_shared_src_model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingSessionState */ .Z.CancelledBilled;
};

/***/ }),

/***/ 74027:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FP: () => (/* binding */ EVENTS),
/* harmony export */   PO: () => (/* binding */ STATES),
/* harmony export */   aO: () => (/* binding */ ACTIONS),
/* harmony export */   ur: () => (/* binding */ GUARDS)
/* harmony export */ });


const GUARDS = {
  IS_CORRECT_FLAG_EXISTS: "IS_CORRECT_FLAG_EXISTS",
  IS_ANSWER_EXISTS: "IS_ANSWER_EXISTS"
};
const ACTIONS = {
  PROCEED_ANSWER: "PROCEED_ANSWER",
  SET_INITIAL_DATA: "SET_INITIAL_DATA",
  RESET_ANSWER: "RESET_ANSWER",
  SET_IN_PROGRESS: "SET_IN_PROGRESS",
  SET_NOT_IN_PROGRESS: "SET_NOT_IN_PROGRESS",
  ON_CHANGE_ANSWER: "ON_CHANGE_ANSWER"
};
const STATES = {
  INITIAL: "INITIAL",
  IDLE: "IDLE",
  ANSWERED: "ANSWERED",
  SUBMITTED: "SUBMITTED",
  ERROR: "ERROR"
};
const EVENTS = {
  ANSWER: "ANSWER",
  SUBMIT: "SUBMIT",
  RESET_ANSWER: "RESET_ANSWER",
  STAGE_ANSWER: "STAGE_ANSWER",
  SET_CORRECT_STATUS: "SET_CORRECT_STATUS",
  CHANGE_INITIAL_DATA: "CHANGE_INITIAL_DATA"
};

/***/ }),

/***/ 26350:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ isMechanicEvent),
/* harmony export */   w: () => (/* binding */ getEventError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function isMechanicEvent(event, type) {
  return event.type === type;
}
const getEventError = eventType => new Error(`Wrong event type ${eventType} passed to action`);

/***/ }),

/***/ 18570:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  qN: () => (/* binding */ createTrainerMechanicMachine)
});

// UNUSED EXPORTS: actions, guards

// EXTERNAL MODULE: ../../node_modules/xstate/es/index.js
var es = __webpack_require__(97386);
// EXTERNAL MODULE: ./src/state-machine/mechanic/mechanic.machine.consts.ts
var mechanic_machine_consts = __webpack_require__(74027);
// EXTERNAL MODULE: ./src/state-machine/mechanic/mechanic.machine.model.ts
var mechanic_machine_model = __webpack_require__(26350);
// EXTERNAL MODULE: ../../node_modules/xstate/es/Machine.js + 2 modules
var Machine = __webpack_require__(9875);
;// CONCATENATED MODULE: ./src/state-machine/mechanic/trainer/trainer-mechanic.machine.ts




const trainerMechanicMachine = (0,Machine/* createMachine */.C)({
  id: "trainerMechanic",
  initial: mechanic_machine_consts/* STATES */.PO.INITIAL,
  context: {
    initialAnswer: {},
    answer: {},
    correct: false
  },
  states: {
    [mechanic_machine_consts/* STATES */.PO.INITIAL]: {
      on: {
        "": [{
          target: mechanic_machine_consts/* STATES */.PO.SUBMITTED,
          cond: mechanic_machine_consts/* GUARDS */.ur.IS_ANSWER_EXISTS
        }, {
          target: mechanic_machine_consts/* STATES */.PO.IDLE
        }]
      }
    },
    [mechanic_machine_consts/* STATES */.PO.IDLE]: {
      on: {
        [mechanic_machine_consts/* EVENTS */.FP.ANSWER]: [{
          target: mechanic_machine_consts/* STATES */.PO.ANSWERED,
          actions: mechanic_machine_consts/* ACTIONS */.aO.PROCEED_ANSWER
        }],
        [mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER]: {
          target: mechanic_machine_consts/* STATES */.PO.IDLE,
          actions: mechanic_machine_consts/* ACTIONS */.aO.PROCEED_ANSWER
        }
      }
    },
    [mechanic_machine_consts/* STATES */.PO.ANSWERED]: {
      on: {
        [mechanic_machine_consts/* EVENTS */.FP.ANSWER]: [{
          target: mechanic_machine_consts/* STATES */.PO.ANSWERED,
          actions: mechanic_machine_consts/* ACTIONS */.aO.PROCEED_ANSWER
        }],
        [mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER]: {
          target: mechanic_machine_consts/* STATES */.PO.IDLE,
          actions: mechanic_machine_consts/* ACTIONS */.aO.PROCEED_ANSWER
        },
        [mechanic_machine_consts/* EVENTS */.FP.SUBMIT]: mechanic_machine_consts/* STATES */.PO.SUBMITTED
      }
    },
    [mechanic_machine_consts/* STATES */.PO.SUBMITTED]: {
      on: {
        [mechanic_machine_consts/* EVENTS */.FP.RESET_ANSWER]: {
          actions: mechanic_machine_consts/* ACTIONS */.aO.RESET_ANSWER,
          target: mechanic_machine_consts/* STATES */.PO.IDLE
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/state-machine/mechanic/trainer/create-trainer-mechanic-machine.ts






const actions = {
  [mechanic_machine_consts/* ACTIONS */.aO.PROCEED_ANSWER]: (0,es/* assign */.f0)({
    answer: (context, e) => {
      if (!((0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) || (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.STAGE_ANSWER))) {
        throw (0,mechanic_machine_model/* getEventError */.w)(e.type);
      }
      return e.data.answer;
    },
    correct: (context, e) => (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) ? e.data.correct : void 0,
    typo: (context, e) => (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) ? e.data.typo : void 0,
    maxPossibleScore: (_, e) => (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) ? e.data.maxPossibleScore : void 0,
    rightAnswersScore: (_, e) => (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) ? e.data.rightAnswersScore : void 0,
    optionDescription: (_, e) => (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) ? e.data.optionDescription : void 0,
    skill: (_, e) => (0,mechanic_machine_model/* isMechanicEvent */.L)(e, mechanic_machine_consts/* EVENTS */.FP.ANSWER) ? e.data.skill : void 0
  }),
  [mechanic_machine_consts/* ACTIONS */.aO.RESET_ANSWER]: (0,es/* assign */.f0)(() => ({
    answer: void 0,
    correct: void 0
  }))
};
const guards = {
  [mechanic_machine_consts/* GUARDS */.ur.IS_ANSWER_EXISTS]: context => Boolean(context.answer && Object.keys(context.answer).length > 0)
};
const createTrainerMechanicMachine = (initialAnswer, correct) => trainerMechanicMachine.withConfig({
  actions,
  guards
}).withContext({
  initialAnswer,
  answer: initialAnswer,
  correct
});

/***/ }),

/***/ 74819:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HZ: () => (/* binding */ getPrevNotEmptyActivityIndex),
/* harmony export */   J0: () => (/* binding */ getNextFirstActionableBlockIndex),
/* harmony export */   VL: () => (/* binding */ getStudentEventUpdater),
/* harmony export */   dj: () => (/* binding */ getFirstActionableBlockIndexFrom),
/* harmony export */   p9: () => (/* binding */ getScrollToBlockIndex),
/* harmony export */   sp: () => (/* binding */ incrementActivityIndex),
/* harmony export */   xC: () => (/* binding */ getProgress),
/* harmony export */   xL: () => (/* binding */ getNextNotEmptyActivity),
/* harmony export */   zL: () => (/* binding */ getPrevActionableBlockIndex)
/* harmony export */ });
/* unused harmony exports incrementBlockIndex, getCurrentBlockLastEventSaver */
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68760);
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(280);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_json_parse_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67761);
/* harmony import */ var core_js_modules_esnext_json_parse_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_json_parse_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _api_student_trainer_trainer_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40116);












const getNextNotEmptyActivity = context => {
  const {
    activities,
    activityIndex = null,
    chapterStudentEvents,
    filterCurrentActivityBlocks
  } = context;
  if (!activities || activityIndex === null || !chapterStudentEvents) {
    return 0;
  }
  let i = activityIndex + 1;
  let notEmptyActivityFound = false;
  while (i < activities.length && !notEmptyActivityFound) {
    const filteredBlocks = filterCurrentActivityBlocks({
      activities,
      chapterStudentEvents,
      activityIndex: i
    });
    if (filteredBlocks.length !== 0) {
      notEmptyActivityFound = true;
    } else {
      i++;
    }
  }
  return i;
};
const incrementActivityIndex = context => {
  const {
    activityIndex = null
  } = context;
  if (activityIndex === null) {
    return 0;
  }
  return activityIndex + 1;
};
const getPrevNotEmptyActivityIndex = context => {
  const {
    activities,
    activityIndex = null,
    chapterStudentEvents,
    filterCurrentActivityBlocks
  } = context;
  if (!activities || activityIndex === null || !chapterStudentEvents) {
    return 0;
  }
  let i = activityIndex - 1;
  let notEmptyActivityFound = false;
  while (i >= 0 && !notEmptyActivityFound) {
    const filteredBlocks = filterCurrentActivityBlocks({
      activities,
      chapterStudentEvents,
      activityIndex: i
    });
    if (filteredBlocks.length !== 0) {
      notEmptyActivityFound = true;
    } else {
      i--;
    }
  }
  return i;
};
const getProgress = context => {
  if (context.currentBlocks.length === 0) {
    return 0;
  }
  const currentblock = context.currentBlocks[context.blockIndex];
  if (!currentblock) {
    return 0;
  }
  const blockId = currentblock.id;
  const flatBlocksList = context.activities.reduce((acc, a) => acc.concat(a.blocks), []);
  const blockIndexInAllActivities = flatBlocksList.findIndex(b => b.id === blockId);
  return Math.round(blockIndexInAllActivities / (flatBlocksList.length / 100));
};
const ACTIONABLE_BLOCKS = ["illustrated-block", "text", "mechanic", "outro", "chapter-outro"];
const isSubmittedMechanicBlock = (block, chapterStudentEvents) => {
  if (block.type === "mechanic" && chapterStudentEvents && block.id) {
    const blockAnswers = chapterStudentEvents[block.id];
    if (!blockAnswers || blockAnswers.length === 0) {
      return false;
    }
    const lastAnswer = blockAnswers[blockAnswers.length - 1];
    const answerString = lastAnswer.data?.answer;
    if (!answerString) {
      return false;
    }
    const parsedAnswer = JSON.parse(answerString);
    return parsedAnswer !== void 0 && parsedAnswer !== null;
  }
  return false;
};
const getFirstActionableBlockIndexFrom = fromBlockIndexFind => context => {
  const currentActivity = context.activities[context.activityIndex];
  if (currentActivity.type === "lexis") {
    return context.blockIndex + 1;
  }
  const remainingBlocks = context.currentBlocks.slice(context.blockIndex + fromBlockIndexFind);
  const firstActionableBlock = remainingBlocks.find(block => {
    if (isSubmittedMechanicBlock(block, context.chapterStudentEvents)) {
      return false;
    }
    return ACTIONABLE_BLOCKS.includes(block.type);
  });
  const index = context.currentBlocks.findIndex(b => b.id === firstActionableBlock?.id);
  const blockBeforeActionable = index !== 0 ? context.currentBlocks[index - 1] : null;
  const isMechanicBlockBeforeSubmitted = blockBeforeActionable && isSubmittedMechanicBlock(blockBeforeActionable, context.chapterStudentEvents);
  if (["illustrated-block", "text"].includes(firstActionableBlock?.type ?? "") && !isMechanicBlockBeforeSubmitted) {
    if (context.blockIndex === index - 1) {
      return index;
    }
    if (index !== 0) {
      return index - 1;
    }
  }
  return index === -1 ? context.currentBlocks.length - 1 : index;
};
const getNextFirstActionableBlockIndex = getFirstActionableBlockIndexFrom(1);
const getPrevActionableBlockIndex = context => {
  const {
    currentBlocks,
    blockIndex,
    activities,
    activityIndex
  } = context;
  const currentActivity = activities[activityIndex];
  if (currentActivity.type === "lexis") {
    return blockIndex - 1;
  }
  const reversedCurrentBlocks = currentBlocks.slice(0, blockIndex).reverse();
  const firstPrevActionableBlock = reversedCurrentBlocks.find(b => ACTIONABLE_BLOCKS.includes(b.type));
  const index = currentBlocks.findIndex(b => b.id === firstPrevActionableBlock?.id);
  return index !== -1 ? index : 0;
};
const incrementBlockIndex = context => context.blockIndex + 1;
const getScrollToBlockIndex = context => context.blockIndex + 1;
const getStudentEventUpdater = eventType => (context, event) => {
  if (!event.data) {
    return context.chapterStudentEvents;
  }
  const events = {
    ...context.chapterStudentEvents
  };
  const newEvent = {
    block_id: event.data.blockId,
    data: {
      answer: JSON.stringify(event.data.answer),
      correct: event.data.correct,
      typo: event.data.typo
    },
    activity_id: event.data.activityId,
    event_type: eventType
  };
  if (events[event.data.blockId]) {
    events[event.data.blockId].push(newEvent);
  } else {
    events[event.data.blockId] = [newEvent];
  }
  return events;
};
const getCurrentBlockLastEventSaver = eventType => context => {
  const blockId = context.currentBlocks[context.blockIndex].id || null;
  if (blockId === null) {
    return;
  }
  const currentBlockEvents = context.chapterStudentEvents[blockId];
  if (!currentBlockEvents) {
    return;
  }
  const answerEvents = currentBlockEvents.filter(e => e.event_type === eventType);
  const lastEvent = answerEvents[answerEvents.length - 1];
  const answer = lastEvent?.data?.answer;
  const correct = lastEvent?.data?.correct;
  const typo = lastEvent?.data?.typo;
  void createProductProgress({
    product_id: context.productId,
    chapter_id: context.chapterId,
    activity_id: context.activities[context.activityIndex]?.activity_id ?? null,
    block_id: context.currentBlocks[context.blockIndex].id ?? "",
    payload: {
      progress: context.progress,
      answer,
      correct,
      typo
    },
    event_type: eventType
  });
};

/***/ }),

/***/ 28532:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Oo: () => (/* binding */ isLastActivityAndBlock),
/* harmony export */   SH: () => (/* binding */ notFirstActivity),
/* harmony export */   d7: () => (/* binding */ isFirstBlock),
/* harmony export */   eR: () => (/* binding */ isPrevActivityEmptyAfterFilter),
/* harmony export */   pH: () => (/* binding */ isNextActivityEmptyAfterFilter),
/* harmony export */   zb: () => (/* binding */ isLastBlock)
/* harmony export */ });


const isFirstBlock = context => context.blockIndex === 0;
const notFirstActivity = context => context.activityIndex !== 0;
const isPrevActivityEmptyAfterFilter = context => {
  const {
    activities,
    activityIndex = null,
    chapterStudentEvents,
    filterCurrentActivityBlocks
  } = context;
  if (!activities || activityIndex === null || !chapterStudentEvents) {
    return false;
  }
  const filteredBlocks = filterCurrentActivityBlocks({
    activities,
    activityIndex: activityIndex - 1,
    chapterStudentEvents
  });
  return filteredBlocks.length === 0;
};
const isNextActivityEmptyAfterFilter = context => {
  const {
    activities,
    activityIndex = null,
    chapterStudentEvents,
    filterCurrentActivityBlocks
  } = context;
  if (!activities || activityIndex === null || !chapterStudentEvents) {
    return false;
  }
  const filteredBlocks = filterCurrentActivityBlocks({
    activities,
    activityIndex: activityIndex + 1,
    chapterStudentEvents
  });
  return filteredBlocks.length === 0;
};
const isLastBlock = context => {
  const {
    blockIndex = null,
    currentBlocks
  } = context;
  if (!currentBlocks || blockIndex === null) {
    return false;
  }
  return blockIndex >= currentBlocks.length - 1;
};
const isLastActivityAndBlock = _ref => {
  let {
    activities,
    activityIndex,
    blockIndex,
    currentBlocks
  } = _ref;
  if (!activities) {
    return false;
  }
  return activities.length - 1 === activityIndex && blockIndex === currentBlocks.length - 1;
};

/***/ }),

/***/ 53828:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Nw: () => (/* binding */ create_trainer_machine_actions),
  XI: () => (/* binding */ getBlockFilterAction),
  hf: () => (/* binding */ getChapterAnswerPusher),
  ek: () => (/* binding */ getFilterBlocksByConditions),
  OQ: () => (/* binding */ getIncrementActivityIndexTilNotEmptyAssignment),
  NZ: () => (/* binding */ getIsAllNextActivitiesEmptyAfterFilterGuard),
  b2: () => (/* binding */ getIsNextActivityEmptyAfterFilterGuard),
  zh: () => (/* binding */ getIsPrevActivityEmptyAfterFilterGuard),
  l8: () => (/* binding */ guards),
  uZ: () => (/* binding */ create_trainer_machine_services)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/date-fns/compareAsc.mjs
var compareAsc = __webpack_require__(66339);
// EXTERNAL MODULE: ../../node_modules/xstate/es/index.js
var es = __webpack_require__(97386);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.api.ts + 1 modules
var trainer_api = __webpack_require__(40116);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/models/trainer/trainer.model.ts
var trainer_model = __webpack_require__(97703);
;// CONCATENATED MODULE: ./src/utils/getBlockConditionComparator.ts















const isFulFillsOperationCondition = (op, actualCount, expectedCount) => {
  switch (op) {
    case "=":
      {
        return actualCount === expectedCount;
      }
    case "not=":
      {
        return actualCount !== expectedCount;
      }
    case "<":
      {
        return actualCount < expectedCount;
      }
    case "<=":
      {
        return actualCount <= expectedCount;
      }
    case ">":
      {
        return actualCount > expectedCount;
      }
    case ">=":
      {
        return actualCount >= expectedCount;
      }
    default:
      {
        return false;
      }
  }
};
const countEventParams = (_ref, fn) => {
  let {
    condition,
    blocksMap,
    chapterStudentEvents,
    eventType
  } = _ref;
  const checkingBlockIds = condition["mechanic-ids"] ?? Object.keys(blocksMap);
  return checkingBlockIds.reduce((acc, blockId) => {
    const blockEvents = chapterStudentEvents[blockId] || [];
    const answerEvents = blockEvents.filter(e => e.event_type === eventType);
    if (answerEvents) {
      const event = answerEvents.length !== 0 ? answerEvents[answerEvents.length - 1] : null;
      const additionValue = fn(event);
      acc.push(additionValue);
    }
    return acc;
  }, []);
};
const getBlockConditionComparator = _ref2 => {
  let {
    chapterStudentEvents,
    blocksMap,
    eventType
  } = _ref2;
  return (
    // eslint-disable-next-line sonarjs/cognitive-complexity
    condition => {
      switch (condition.op) {
        case "=":
        case "not=":
          {
            const mechanicId = condition["mechanic-id"];
            const compareMechanicEvents = chapterStudentEvents[mechanicId] || [];
            const compareMechanicTrainerResults = compareMechanicEvents.filter(e => e.event_type === eventType);
            if (compareMechanicTrainerResults.length === 0) {
              return false;
            }
            const compareMechanicMarkup = blocksMap[mechanicId];
            const comparingMechanicAnswerJSON = compareMechanicTrainerResults[compareMechanicTrainerResults.length - 1].data?.answer;
            const comparingMechanicAnswer = comparingMechanicAnswerJSON && JSON.parse(comparingMechanicAnswerJSON) ? JSON.parse(comparingMechanicAnswerJSON) : {};
            if (Object.keys(comparingMechanicAnswer).length === 0) {
              return false;
            }
            const selectedVariantIndex = Object.keys(comparingMechanicAnswer).reduce((selectedElementIndex, key) => comparingMechanicAnswer[key] ? key : selectedElementIndex, null);
            const selectedVariant = selectedVariantIndex ? compareMechanicMarkup.output.variants[Number(selectedVariantIndex)] : null;
            if (!selectedVariant) {
              return true;
            }
            const type = selectedVariant.type;
            switch (type) {
              case trainer_model/* OptionType */.GL.Text:
                {
                  const formattedConditionText = String(condition.value);
                  const formattedAnswerText = String(selectedVariant.text);
                  if (condition.op === "=" && !formattedAnswerText.includes(formattedConditionText)) {
                    return false;
                  }
                  return !(condition.op === "not=" && formattedAnswerText.includes(formattedConditionText));
                }
              case trainer_model/* OptionType */.GL.Image:
                {
                  if (condition.op === "=" && selectedVariant.image.url !== condition.value) {
                    return false;
                  }
                  return !(condition.op === "not=" && selectedVariant.image.url === condition.value);
                }
              case trainer_model/* OptionType */.GL.Audio:
                {
                  const audioType = selectedVariant.audio.type;
                  switch (audioType) {
                    case "t2s":
                      {
                        if (condition.op === "=" && selectedVariant.audio.text !== condition.value) {
                          return false;
                        }
                        return !(condition.op === "not=" && selectedVariant.audio.text === condition.value);
                      }
                    case "voiceover":
                      {
                        if (condition.op === "=" && selectedVariant.audio.url !== condition.value) {
                          return false;
                        }
                        return !(condition.op === "not=" && selectedVariant.audio.url === condition.value);
                      }
                    default:
                      throw new unhandled_case/* UnhandledCaseError */.H(audioType);
                  }
                }
              default:
                throw new unhandled_case/* UnhandledCaseError */.H(type);
            }
          }
        case "correct":
        case "not-correct":
          {
            const compareMechanicEvents = chapterStudentEvents[condition["mechanic-id"]] || [];
            const compareMechanicTrainerResults = compareMechanicEvents.filter(e => e.event_type === eventType);
            if (!compareMechanicTrainerResults.length) {
              return false;
            }
            const correct = Boolean(compareMechanicTrainerResults[compareMechanicTrainerResults.length - 1].data?.correct);
            return condition.op === "correct" ? correct : !correct;
          }
        case "and":
        case "or":
          {
            const isSatisfiesCondition = getBlockConditionComparator({
              chapterStudentEvents,
              blocksMap,
              eventType
            });
            return condition.op === "and" ? condition.conditions.every(isSatisfiesCondition) : condition.conditions.some(isSatisfiesCondition);
          }
        case "count":
          {
            const checkingAnswerIndex = condition.answerIndex !== void 0 ? condition.answerIndex : 0;
            const operation = condition["count-op"] ?? "=";
            const results = countEventParams({
              condition,
              eventType,
              blocksMap,
              chapterStudentEvents
            }, event => {
              const lastAnswerJSON = event !== null ? event.data?.answer : "{}";
              const lastAnswer = lastAnswerJSON ? JSON.parse(lastAnswerJSON) : {};
              return lastAnswer[checkingAnswerIndex];
            });
            const count = results.filter(Boolean).length;
            return isFulFillsOperationCondition(operation, count, condition.value);
          }
        case "count-correct":
          {
            const operation = condition["count-op"] ?? "=";
            const results = countEventParams({
              condition,
              eventType,
              blocksMap,
              chapterStudentEvents
            }, event => {
              if (event === null) {
                return null;
              }
              const isLastAnswerCorrect = Boolean(event.data?.correct);
              return isLastAnswerCorrect;
            });
            if (condition["answer-required"] && results.some(res => res === null)) {
              return false;
            }
            const count = results.filter(Boolean).length;
            return isFulFillsOperationCondition(operation, count, condition.value);
          }
        default:
          return true;
      }
    }
  );
};
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/xstate/es/Machine.js + 2 modules
var Machine = __webpack_require__(9875);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ./src/api/student/trainer/trainer.model.ts
var trainer_trainer_model = __webpack_require__(92601);
;// CONCATENATED MODULE: ./src/state-machine/trainer/chapter-state-loader.machine.ts








const STATES = {
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error"
};
const ACTIONS = {
  PROCEED_CHAPTER_STATE: "proceedChapterState",
  PROCEED_ERROR: "proceedError"
};
const SERVICES = {
  LOAD_CHAPTER_STATE: "loadChapterState"
};
var ChapterStateLoaderError = /* @__PURE__ */(ChapterStateLoaderError2 => {
  ChapterStateLoaderError2["NotFound"] = "NotFound";
  ChapterStateLoaderError2["Unknown"] = "Unknown";
  return ChapterStateLoaderError2;
})(ChapterStateLoaderError || {});
const actions = {
  [ACTIONS.PROCEED_CHAPTER_STATE]: (0,es/* assign */.f0)((_context, _ref) => {
    let {
      data
    } = _ref;
    if ((0,Either.isLeft)(data)) {
      logger/* Logger */.Yd.unexpectedState();
      return {};
    }
    const dataContent = data.right;
    return {
      chapterData: dataContent.chapter_structure.activities,
      userData: dataContent.chapter_student_data,
      isSpeakingUnscheduled: dataContent.chapter_speaking_is_unscheduled,
      chapterInfo: {
        courseId: dataContent.chapter_info.course_id,
        levelId: dataContent.chapter_info.level_id,
        topicId: dataContent.chapter_info.topic_id
      }
    };
  }),
  [ACTIONS.PROCEED_ERROR]: (0,es/* assign */.f0)((_context, _ref2) => {
    let {
      data
    } = _ref2;
    if ((0,Either.isRight)(data)) {
      logger/* Logger */.Yd.unexpectedState();
      return {};
    }
    let error;
    switch (data.left) {
      case api_model/* unexpectedError */.g:
        error = "Unknown" /* Unknown */;
        break;
      case trainer_trainer_model/* ChapterStateError */.CU.InvalidSprintState:
        error = "NotFound" /* NotFound */;
        break;
      default:
        error = data.left;
        break;
    }
    return {
      error
    };
  })
};
const services = {
  [SERVICES.LOAD_CHAPTER_STATE]: context => (0,trainer_api/* getChapterState */.mL)(context.chapterId)
};
const chapterStateLoaderMachine = (0,Machine/* createMachine */.C)({
  id: "chapterStateLoader",
  initial: STATES.LOADING,
  states: {
    [STATES.LOADING]: {
      invoke: {
        src: SERVICES.LOAD_CHAPTER_STATE,
        onDone: [{
          target: STATES.LOADED,
          actions: [ACTIONS.PROCEED_CHAPTER_STATE],
          cond: (_, _ref3) => {
            let {
              data
            } = _ref3;
            return (0,Either.isRight)(data);
          }
        }, {
          target: STATES.ERROR,
          actions: [ACTIONS.PROCEED_ERROR]
        }]
      }
    },
    [STATES.LOADED]: {
      type: "final",
      data: context => context
    },
    [STATES.ERROR]: {
      type: "final",
      data: context => context
    }
  }
}).withConfig({
  actions,
  services
});
;// CONCATENATED MODULE: ./src/state-machine/trainer/progress.machine.ts




const progress_machine_STATES = {
  LOADING: "loading",
  LOADED: "loaded"
};
const progress_machine_SERVICES = {
  CREATE_PROGRESS: "createProgress"
};
const progress_machine_services = {
  [progress_machine_SERVICES.CREATE_PROGRESS]: context => (0,trainer_api/* createProgress */.gy)({
    course_id: context.courseId,
    block_id: context.blockId,
    activity_id: context.activityId,
    chapter_id: context.chapterId,
    payload: {
      correct: context.correct,
      answer: JSON.stringify(context.userAnswer),
      progress: context.progress,
      typo: context.typo,
      mastering_id: context.masteringId
    },
    event_type: context.eventType
  })
};
const progressMachine = (0,Machine/* createMachine */.C)({
  id: "chapterStateLoader",
  initial: progress_machine_STATES.LOADING,
  states: {
    [progress_machine_STATES.LOADING]: {
      invoke: {
        src: progress_machine_SERVICES.CREATE_PROGRESS,
        onDone: {
          target: progress_machine_STATES.LOADED
        },
        onError: progress_machine_STATES.LOADED
      }
    },
    [progress_machine_STATES.LOADED]: {
      type: "final"
    }
  }
}).withConfig({
  services: progress_machine_services
});
// EXTERNAL MODULE: ./src/state-machine/trainer/trainer.machine.consts.ts
var trainer_machine_consts = __webpack_require__(98513);
;// CONCATENATED MODULE: ./src/state-machine/trainer/trainer.machine.model.ts


var TrainerMachineErrors = /* @__PURE__ */(TrainerMachineErrors2 => {
  TrainerMachineErrors2["NotFound"] = "NotFound";
  TrainerMachineErrors2["Unknown"] = "Unknown";
  return TrainerMachineErrors2;
})(TrainerMachineErrors || {});
;// CONCATENATED MODULE: ./src/state-machine/trainer/create-trainer-machine.ts





















const TRAINER_EVENTS = ["trainer_progress", "trainer_progress_final", "trainer_result", "trainer_progress_init"];
const findLastEvent = function () {
  let events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let filterEvents = arguments.length > 1 ? arguments[1] : undefined;
  return events.reduce((lastEvent, event) => {
    if (event.event_type === void 0 || filterEvents !== void 0 && !filterEvents.includes(event.event_type)) {
      return lastEvent;
    }
    if (!lastEvent) {
      return event;
    }
    return (0,compareAsc/* compareAsc */.U)(Date.parse(lastEvent.created_at || ""), Date.parse(event.created_at || "")) ? event : lastEvent;
  }, void 0);
};
const proceedInitialChapterState = (event, filterEvents) => {
  const activities = event.data.chapterData;
  const chapterStudentEvents = {};
  if (event.data.userData !== void 0) {
    event.data.userData.forEach(event2 => {
      if (event2.block_id in chapterStudentEvents) {
        chapterStudentEvents[event2.block_id].push(event2);
      } else {
        chapterStudentEvents[event2.block_id] = [event2];
      }
    });
  }
  return {
    activities,
    chapterStudentEvents,
    isSpeakingUnscheduled: event.data.isSpeakingUnscheduled,
    chapterInfo: event.data.chapterInfo,
    lastEvent: findLastEvent(event.data.userData, filterEvents)
  };
};
const getChapterAnswerPusher = eventType => ({
  chapterStudentEvents: (context, event) => {
    const events = {
      ...context.chapterStudentEvents
    };
    const {
      data
    } = event;
    const newEvent = {
      block_id: data.blockId,
      data: {
        answer: JSON.stringify(data.answer),
        correct: data.correct,
        typo: data.typo
      },
      activity_id: data.activityId,
      course_id: data.courseId,
      event_type: eventType,
      level_id: data.levelId,
      topic_id: data.topicId
    };
    if (events[data.blockId]) {
      events[data.blockId].push(newEvent);
    } else {
      events[data.blockId] = [newEvent];
    }
    return events;
  }
});
const TRAINER_ANSWER_EVENT = "trainer_result";
const getFilterBlocksByConditions = eventType => context => {
  const {
    activities,
    activityIndex = null,
    chapterStudentEvents
  } = context;
  if (activityIndex === null || !activities) {
    return [];
  }
  if (activityIndex >= activities.length) {
    return [];
  }
  const allBlocksMap = activities.reduce((acc, a) => {
    for (const b of a.blocks) {
      if (b.type === "information-gap" && b.tutor && b.student) {
        acc[b.tutor.id] = b.tutor;
        acc[b.student.id] = b.student;
      }
      acc[b.id] = b;
    }
    return acc;
  }, {});
  const {
    blocks
  } = activities[activityIndex];
  const isSatisfiesCondition = getBlockConditionComparator({
    chapterStudentEvents,
    blocksMap: allBlocksMap,
    eventType
  });
  return blocks.filter(b => {
    if (b.condition) {
      return isSatisfiesCondition(b.condition);
    }
    return true;
  });
};
const getBlockFilterAction = eventType => ({
  currentBlocks: getFilterBlocksByConditions(eventType)
});
const getIncrementActivityIndexTilNotEmptyAssignment = eventType => ({
  activityIndex: context => {
    let i = context.activityIndex + 1;
    let notEmptyActivityFound = false;
    while (i < context.activities.length && !notEmptyActivityFound) {
      const filter = getFilterBlocksByConditions(eventType);
      const filteredBlocks = filter({
        ...context,
        activityIndex: i
      });
      if (filteredBlocks.length !== 0) {
        notEmptyActivityFound = true;
      } else {
        i++;
      }
    }
    return i;
  },
  blockIndex: 0
});
const getDecrementActivityIndexTilNotEmptyAssignment = eventType => ({
  activityIndex: context => {
    let i = context.activityIndex - 1;
    let notEmptyActivityFound = false;
    while (i >= 0 && !notEmptyActivityFound) {
      const filter = getFilterBlocksByConditions(eventType);
      const filteredBlocks = filter({
        ...context,
        activityIndex: i
      });
      if (filteredBlocks.length !== 0) {
        notEmptyActivityFound = true;
      } else {
        i--;
      }
    }
    return i;
  }
});
const getTrainerOutro = (isSpeakingUnscheduled, disableGeneratedOutroActions, intl) => {
  if (isSpeakingUnscheduled) {
    if (disableGeneratedOutroActions) {
      return {
        outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/05ee68e0-0ec1-4851-ba1f-2060e5baaa14/trainerOutro1.svg",
        outroActionControls: [{
          // eslint-disable-next-line sonarjs/no-duplicate-string
          text: intl.formatMessage({
            id: "trainerRenderer.onMainPage"
          }),
          separateLine: true,
          action: {
            type: "ON_MAIN_PAGE"
          }
        }]
      };
    }
    return {
      outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/05ee68e0-0ec1-4851-ba1f-2060e5baaa14/trainerOutro1.svg",
      outroActionControls: [{
        text: intl.formatMessage({
          id: "trainerRenderer.schedule"
        }),
        separateLine: true,
        action: {
          type: "SCHEDULE_SPEAKING"
        },
        type: "primary"
      }, {
        text: intl.formatMessage({
          id: "trainerRenderer.onMainPage"
        }),
        separateLine: true,
        action: {
          type: "ON_MAIN_PAGE"
        }
      }]
    };
  }
  return {
    outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/7452c5cf-217f-408f-929d-0768923c65f4/ontroTrainer.svg",
    outroActionControls: [{
      text: intl.formatMessage({
        id: "trainerRenderer.onMainPage"
      }),
      separateLine: true,
      action: {
        type: "ON_MAIN_PAGE"
      }
    }],
    outroTitle: intl.formatMessage({
      id: "trainerRenderer.chaptersFinished"
    }),
    outroText: intl.formatMessage({
      id: "trainerRenderer.repeat"
    })
  };
};
const getIsAllNextActivitiesEmptyAfterFilterGuard = event => context => {
  const filter = getFilterBlocksByConditions(event);
  let i = context.activityIndex + 1;
  let existNotEmptyActivity = false;
  while (i < context.activities.length && !existNotEmptyActivity) {
    const filteredBlocks = filter({
      ...context,
      activityIndex: i
    });
    if (filteredBlocks.length !== 0) {
      existNotEmptyActivity = true;
    } else {
      i++;
    }
  }
  return !existNotEmptyActivity;
};
const getIsNextActivityEmptyAfterFilterGuard = event => context => {
  const filter = getFilterBlocksByConditions(event);
  const filteredBlocks = filter({
    ...context,
    activityIndex: context.activityIndex + 1
  });
  return filteredBlocks.length === 0;
};
const getIsPrevActivityEmptyAfterFilterGuard = event => context => {
  const filter = getFilterBlocksByConditions(event);
  const filteredBlocks = filter({
    ...context,
    activityIndex: context.activityIndex - 1
  });
  return filteredBlocks.length === 0;
};
const defaultGuards = {
  [trainer_machine_consts/* GUARDS */.ur.IS_CHAPTER_COMPLETED]: (context, event) => {
    const lastEvent = findLastEvent(event.data.userData);
    return lastEvent?.event_type === "trainer_progress_final";
  },
  [trainer_machine_consts/* GUARDS */.ur.IS_CHAPTER_IN_PROGRESS]: (context, event) => {
    const lastEvent = findLastEvent(event.data.userData);
    return typeof lastEvent === "undefined" ||
    // eslint-disable-next-line camelcase
    lastEvent?.event_type === "trainer_progress" ||
    // eslint-disable-next-line camelcase
    lastEvent?.event_type === "trainer_result" ||
    // eslint-disable-next-line camelcase
    lastEvent?.event_type === "trainer_progress_init";
  },
  [trainer_machine_consts/* GUARDS */.ur.IS_LAST_ACTIVITY_AND_BLOCK]: _ref => {
    let {
      activities,
      currentBlocks,
      activityIndex,
      blockIndex
    } = _ref;
    return activities.length - 1 === activityIndex && blockIndex === currentBlocks.length - 1;
  },
  [trainer_machine_consts/* GUARDS */.ur.IS_LAST_BLOCK]: _ref2 => {
    let {
      currentBlocks,
      blockIndex
    } = _ref2;
    return blockIndex >= currentBlocks.length - 1;
  },
  [trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER]: getIsAllNextActivitiesEmptyAfterFilterGuard(TRAINER_ANSWER_EVENT),
  [trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER]: getIsNextActivityEmptyAfterFilterGuard(TRAINER_ANSWER_EVENT),
  [trainer_machine_consts/* GUARDS */.ur.IS_PREV_ACTIVITY_EMPTY_AFTER_FILTER]: getIsPrevActivityEmptyAfterFilterGuard(TRAINER_ANSWER_EVENT),
  [trainer_machine_consts/* GUARDS */.ur.IS_FIRST_BLOCK]: context => context.blockIndex === 0,
  [trainer_machine_consts/* GUARDS */.ur.NOT_FIRST_ACTIVITY]: context => context.activityIndex !== 0,
  [trainer_machine_consts/* GUARDS */.ur.FINAL_EVENT_DOESNT_EXIST]: context => !context.isFinalEventExist
};
const create_trainer_machine_actions = {
  [trainer_machine_consts/* ACTIONS */.aO.FILTER_CURRENT_ACTIVITY_BLOCKS]: (0,es/* assign */.f0)(getBlockFilterAction(TRAINER_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.SEND_INITIAL_EVENT_IF_NEED]: context => {
    if (!context.lastEvent) {
      void (0,trainer_api/* createProgress */.gy)({
        block_id: context.currentBlocks[context.blockIndex].id,
        activity_id: context.activities[context.activityIndex]?.activity_id,
        course_id: context.chapterInfo?.courseId || "",
        chapter_id: context.chapterId || "",
        event_type: "trainer_progress_init"
      });
    }
  },
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_TRAINER_STATE]: (0,es/* assign */.f0)((context, event) => proceedInitialChapterState(event, TRAINER_EVENTS)),
  [trainer_machine_consts/* ACTIONS */.aO.PROCEED_INITIAL_CHAPTER_STATE]: (0,es/* assign */.f0)((context, event) => {
    const activities = event.data.chapterData;
    const chapterStudentEvents = {};
    event.data.userData?.forEach(ev => {
      if (ev.block_id in chapterStudentEvents) {
        chapterStudentEvents[ev.block_id].push(ev);
      } else {
        chapterStudentEvents[ev.block_id] = [ev];
      }
    });
    return {
      activities,
      chapterStudentEvents,
      isSpeakingUnscheduled: event.data.isSpeakingUnscheduled,
      chapterInfo: event.data.chapterInfo,
      isFinalEventExist: event.data.userData?.some(ev => ev.event_type === "trainer_progress_final"),
      lastEvent: findLastEvent(event.data.userData)
    };
  }),
  [trainer_machine_consts/* ACTIONS */.aO.CALCULATE_ACTIVITY_INDEX]: (0,es/* assign */.f0)({
    activityIndex: context => {
      const foundIndex = context.activities.findIndex(activity =>
      // eslint-disable-next-line camelcase
      activity?.activity_id === context?.lastEvent?.activity_id);
      return foundIndex >= 0 ? foundIndex : 0;
    }
  }),
  [trainer_machine_consts/* ACTIONS */.aO.CALCULATE_BLOCK_INDEX]: (0,es/* assign */.f0)({
    blockIndex: context => {
      const foundIndex = context.currentBlocks.findIndex(block =>
      // eslint-disable-next-line camelcase
      block.id === context?.lastEvent?.block_id);
      return foundIndex >= 0 ? foundIndex : 0;
    }
  }),
  [trainer_machine_consts/* ACTIONS */.aO.UPDATE_PROGRESS]: (0,es/* assign */.f0)({
    progress: context => {
      if (context.currentBlocks.length === 0) {
        return 0;
      }
      const currentBlock = context.currentBlocks[context.blockIndex];
      if (!currentBlock) {
        return 0;
      }
      const blockId = currentBlock.id;
      const flatBlocksList = context.activities.reduce((acc, a) => [...acc, ...a.blocks], []);
      const blockIndexInAllActivities = flatBlocksList.findIndex(b => b.id === blockId);
      return Math.round(blockIndexInAllActivities / (flatBlocksList.length / 100));
    }
  }),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_BLOCK_INDEX]: (0,es/* assign */.f0)({
    blockIndex: context => context.blockIndex + 1
  }),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX]: (0,es/* assign */.f0)({
    activityIndex: context => context.activityIndex + 1,
    blockIndex: 0
  }),
  [trainer_machine_consts/* ACTIONS */.aO.PUSH_CHAPTER_ANSWER]: (0,es/* assign */.f0)(getChapterAnswerPusher("trainer_result")),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_BLOCK_INDEX]: (0,es/* assign */.f0)({
    blockIndex: _ref3 => {
      let {
        blockIndex
      } = _ref3;
      return blockIndex - 1;
    }
  }),
  [trainer_machine_consts/* ACTIONS */.aO.INCREMENT_ACTIVITY_INDEX_TIL_NOT_EMPTY]: (0,es/* assign */.f0)(getIncrementActivityIndexTilNotEmptyAssignment(TRAINER_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_ACTIVITY_INDEX]: (0,es/* assign */.f0)(context => ({
    activityIndex: context.activityIndex - 1
  })),
  [trainer_machine_consts/* ACTIONS */.aO.DECREMENT_ACTIVITY_TIL_NOT_EMPTY]: (0,es/* assign */.f0)(getDecrementActivityIndexTilNotEmptyAssignment(TRAINER_ANSWER_EVENT)),
  [trainer_machine_consts/* ACTIONS */.aO.SET_CURRENT_LAST_BLOCK_IN_ACTIVITY]: (0,es/* assign */.f0)(context => ({
    blockIndex: context.currentBlocks.length - 1
  })),
  [trainer_machine_consts/* ACTIONS */.aO.ADD_OUTRO_IF_NEED]: (0,es/* assign */.f0)(context => {
    const activities = [...context.activities];
    const lastActivity = activities[activities.length - 1];
    const lastBlock = lastActivity.blocks[lastActivity.blocks.length - 1];
    if (lastBlock.type === "chapter-outro") {
      return {};
    }
    const trainerOutro = getTrainerOutro(context.isSpeakingUnscheduled || true, context.disableGeneratedOutroActions ?? false, context.intl);
    const outro = {
      type: "chapter-outro",
      id: context.chapterId || "",
      actionControls: trainerOutro.outroActionControls,
      text: trainerOutro.outroText,
      image: trainerOutro.outroImage,
      title: trainerOutro.outroTitle
    };
    lastActivity.blocks.push(outro);
    return {
      activities
    };
  }),
  [trainer_machine_consts/* ACTIONS */.aO.SEND_FINAL_EVENT_IF_NEED]: (context, event) => {
    if (context.isFinalEventExist) {
      return {};
    }
    const guardMeta = {};
    if (defaultGuards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_ACTIVITY_AND_BLOCK](context, event, guardMeta) || defaultGuards[trainer_machine_consts/* GUARDS */.ur.IS_LAST_BLOCK](context, event, guardMeta) && defaultGuards[trainer_machine_consts/* GUARDS */.ur.IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER](context, event, guardMeta) && defaultGuards[trainer_machine_consts/* GUARDS */.ur.IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER](context, event, guardMeta)) {
      void (0,trainer_api/* createProgress */.gy)({
        block_id: context.currentBlocks[context.blockIndex].id,
        activity_id: context.activities[context.activityIndex]?.activity_id,
        course_id: context.chapterInfo?.courseId || "",
        chapter_id: context.chapterId || "",
        event_type: "trainer_progress_final"
      });
      return {
        isFinalEventExist: true
      };
    }
    return {};
  },
  [trainer_machine_consts/* ACTIONS */.aO.PROCESS_LOADING_ERROR]: (0,es/* assign */.f0)((_, event) => {
    switch (event.data.error) {
      case ChapterStateLoaderError.NotFound:
        return {
          error: TrainerMachineErrors.NotFound
        };
      case ChapterStateLoaderError.Unknown:
        return {
          error: TrainerMachineErrors.Unknown
        };
      default:
        logger/* Logger */.Yd.unexpectedState();
        return {
          error: TrainerMachineErrors.Unknown
        };
    }
  })
};
const create_trainer_machine_services = {
  [trainer_machine_consts/* SERVICES */.AU.CHAPTER_STATE_LOADER]: chapterStateLoaderMachine,
  [trainer_machine_consts/* SERVICES */.AU.PROGRESS_SAVER]: progressMachine
};
const guards = {
  ...defaultGuards,
  [trainer_machine_consts/* GUARDS */.ur.EVERY]: (context, event, meta) => {
    const {
      // TODO выяснить что это и убрать если не работает
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      cond: {
        guardKeys
      }
    } = meta;
    return guardKeys && guardKeys.every(guardKey => defaultGuards[guardKey](context, event, meta));
  }
};

/***/ }),

/***/ 48819:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FP: () => (/* binding */ EVENTS),
/* harmony export */   Ne: () => (/* binding */ productTrainerMachine),
/* harmony export */   PO: () => (/* binding */ STATES),
/* harmony export */   eY: () => (/* binding */ isEventWithAnswer),
/* harmony export */   iR: () => (/* binding */ ProductTrainerMachineErrors),
/* harmony export */   vn: () => (/* binding */ isUserFinishChapterFirstTimeGuard)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_every_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83511);
/* harmony import */ var core_js_modules_esnext_async_iterator_every_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_every_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_every_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80988);
/* harmony import */ var core_js_modules_esnext_iterator_every_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_every_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87412);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var xstate__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97386);
/* harmony import */ var xstate__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9875);
/* harmony import */ var _utils_conversionsMetrics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90973);
/* harmony import */ var _trainer_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74819);
/* harmony import */ var _trainer_guards__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28532);
/* harmony import */ var _create_trainer_machine__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53828);














const STATES = {
  LOADING_CHAPTER_DATA: "loadingChapterData",
  SAVING_PROGRESS: "creatingProgress",
  CHAPTER_IN_PROGRESS: "chapterInProgress",
  ERROR: "error",
  IDLE: "idle",
  FORK: "fork",
  SAVING_ANSWER: "savingAnswer"
};
var ProductTrainerMachineErrors = /* @__PURE__ */(ProductTrainerMachineErrors2 => {
  ProductTrainerMachineErrors2["NotFound"] = "NotFound";
  ProductTrainerMachineErrors2["Unknown"] = "Unknown";
  return ProductTrainerMachineErrors2;
})(ProductTrainerMachineErrors || {});
const EVENTS = {
  NEXT_BLOCK_CLICKED: "nextBlockClicked",
  SUBMIT_ANSWER: "submitAnswer",
  REPEAT_REVISION: "repeatRevision",
  PREV_BLOCK_CLICKED: "prevBlockClicker",
  SET_ACTIVITY: "setActivity",
  RESET_ANSWER: "resetAnswer",
  PREV_ACTIVITY_CLICKED: "prevActivityClicked",
  NEXT_ACTIVITY_CLICKED: "nextActivityClicked",
  SET_CURRENT_ACTIVITY: "setCurrentActivity",
  UPDATE_CHAPTER_STATE: "updateChapterState"
};
function isEventWithAnswer(event) {
  return event.type === "submitAnswer" || event.type === "resetAnswer";
}
const getTrainerOutro = (isSpeakingUnscheduled, disableGeneratedOutroActions, intl) => {
  if (isSpeakingUnscheduled) {
    if (disableGeneratedOutroActions) {
      return {
        outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/05ee68e0-0ec1-4851-ba1f-2060e5baaa14/trainerOutro1.svg",
        outroActionControls: [{
          // eslint-disable-next-line sonarjs/no-duplicate-string
          text: intl.formatMessage({
            id: "trainerRenderer.onMainPage"
          }),
          separateLine: true,
          action: {
            type: "ON_MAIN_PAGE"
          }
        }]
      };
    }
    return {
      outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/05ee68e0-0ec1-4851-ba1f-2060e5baaa14/trainerOutro1.svg",
      outroActionControls: [{
        text: intl.formatMessage({
          id: "trainerRenderer.schedule"
        }),
        separateLine: true,
        action: {
          type: "SCHEDULE_SPEAKING"
        },
        type: "primary"
      }, {
        text: intl.formatMessage({
          id: "trainerRenderer.onMainPage"
        }),
        separateLine: true,
        action: {
          type: "ON_MAIN_PAGE"
        }
      }]
    };
  }
  return {
    outroImage: "https://flowstatic.s3.yandex.net/static/aloha-static/upload/cms/images/7452c5cf-217f-408f-929d-0768923c65f4/ontroTrainer.svg",
    outroActionControls: [{
      text: intl.formatMessage({
        id: "trainerRenderer.onMainPage"
      }),
      separateLine: true,
      action: {
        type: "ON_MAIN_PAGE"
      }
    }],
    outroTitle: intl.formatMessage({
      id: "trainerRenderer.chaptersFinished"
    }),
    outroText: intl.formatMessage({
      id: "trainerRenderer.repeat"
    })
  };
};
const guards = {
  isChapterStateLoadedCorrectly: (_, _ref) => {
    let {
      data
    } = _ref;
    return (0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__.isRight)(data) && !(0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__.isLeft)(data);
  },
  isLastActivityAndBlock: _ref2 => {
    let {
      activities,
      activityIndex,
      blockIndex,
      currentBlocks
    } = _ref2;
    return activities.length - 1 === activityIndex && blockIndex === currentBlocks.length - 1;
  },
  isLastBlock: _ref3 => {
    let {
      currentBlocks,
      blockIndex
    } = _ref3;
    return blockIndex >= currentBlocks.length - 1;
  },
  isAllNextActivitiesEmptyAfterResult: context => (0,_create_trainer_machine__WEBPACK_IMPORTED_MODULE_8__/* .getIsAllNextActivitiesEmptyAfterFilterGuard */ .NZ)(context.eventType.answer)(context)
};
const isUserFinishChapterFirstTimeGuard = context => {
  if (context.isFinalEventExist) {
    return false;
  }
  return guards.isLastActivityAndBlock(context) || guards.isLastBlock(context) && (0,_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isNextActivityEmptyAfterFilter */ .pH)(context) && guards.isAllNextActivitiesEmptyAfterResult(context);
};
const actions = {
  addOutroIfNeed: context => {
    const activities = [...context.activities];
    const lastActivity = activities[activities.length - 1];
    const lastBlock = lastActivity.blocks[lastActivity.blocks.length - 1];
    if (lastBlock.type === "chapter-outro") {
      return {};
    }
    const trainerOutro = getTrainerOutro(context.isSpeakingUnscheduled || true, context.disableGeneratedOutroActions, context.intl);
    const outro = {
      type: "chapter-outro",
      id: context.chapterId || "",
      actionControls: trainerOutro.outroActionControls,
      text: trainerOutro.outroText,
      image: trainerOutro.outroImage,
      title: trainerOutro.outroTitle
    };
    lastActivity.blocks.push(outro);
    return {
      activities
    };
  },
  calculateActivityIndex: context => {
    if (context.isFinalEventExist) {
      return {
        activityIndex: 0
      };
    }
    const foundIndex = context.activities.findIndex(activity => activity?.activity_id === context?.lastEvent?.activity_id);
    const activityIndex = foundIndex >= 0 ? foundIndex : 0;
    return {
      activityIndex
    };
  },
  calculateBlockIndex: context => {
    const foundIndex = context.currentBlocks.findIndex(block => block.id === context?.lastEvent?.block_id);
    return {
      blockIndex: foundIndex >= 0 ? foundIndex : 0
    };
  },
  sendInitialEventConversionMetricsIfNeed: context => {
    if (!context.lastEvent && context.isTrialChapter) {
      void _utils_conversionsMetrics__WEBPACK_IMPORTED_MODULE_6__/* .ConversionsMetrics */ .l.firstChapterInit(context.productId);
    }
  },
  updateProgress: (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)(context => {
    if (context.currentBlocks.length === 0) {
      return {
        progress: 0
      };
    }
    const blockId = context.currentBlocks[context.blockIndex].id;
    const flatBlocksList = context.activities.reduce((acc, a) => [...acc, ...a.blocks], []);
    const blockIndexInAllActivities = flatBlocksList.findIndex(b => b.id === blockId);
    return {
      progress: Math.round(blockIndexInAllActivities / (flatBlocksList.length / 100))
    };
  }),
  sendFinalEventConversionMetricsIfNeed: context => {
    if (context.isTrialChapter) {
      void _utils_conversionsMetrics__WEBPACK_IMPORTED_MODULE_6__/* .ConversionsMetrics */ .l.firstChapterFinish(context.productId);
    }
  },
  pushChapterAnswer: (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
    chapterStudentEvents: (context, event) => {
      const events = {
        ...context.chapterStudentEvents
      };
      const newEvent = {
        block_id: event.data.blockId,
        data: {
          answer: JSON.stringify(event.data.answer),
          correct: event.data.correct,
          typo: event.data.typo,
          maxPossibleScore: event.data.maxPossibleScore,
          rightAnswersScore: event.data.rightAnswersScore,
          skill: event.data.skill,
          optionDescription: event.data.optionDescription
        },
        activity_id: event.data.activityId,
        event_type: context.eventType.answer
      };
      if (events[event.data.blockId]) {
        events[event.data.blockId].push(newEvent);
      } else {
        events[event.data.blockId] = [newEvent];
      }
      return events;
    }
  })
};
const productTrainerMachine = (0,xstate__WEBPACK_IMPORTED_MODULE_12__/* .createMachine */ .C)({
  id: "product-trainer",
  initial: STATES.LOADING_CHAPTER_DATA,
  states: {
    [STATES.LOADING_CHAPTER_DATA]: {
      invoke: {
        src: "loadChapterData",
        onDone: [{
          target: STATES.CHAPTER_IN_PROGRESS,
          cond: guards.isChapterStateLoadedCorrectly,
          actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)((context, _ref4) => {
            let {
              data
            } = _ref4;
            if ((0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_9__.isLeft)(data)) {
              return context;
            }
            return data.right;
          }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)(actions.addOutroIfNeed), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)(actions.calculateActivityIndex), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            currentBlocks: context => context.filterCurrentActivityBlocks(context)
          }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)(actions.calculateBlockIndex), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            blockIndex: context => {
              const {
                activities,
                activityIndex,
                blockIndex,
                isFinalEventExist,
                currentBlocks
              } = context;
              const currentActivity = activities[activityIndex];
              if (currentActivity.type === "lexis") {
                return blockIndex;
              }
              if (isFinalEventExist) {
                return currentBlocks.length - 1;
              }
              return (0,_trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getFirstActionableBlockIndexFrom */ .dj)(0)(context);
            }
          }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            scrollToBlockIndex: context => {
              if (context.isFinalEventExist) {
                return 0;
              }
              if (Object.keys(context.chapterStudentEvents).length !== 0) {
                return context.blockIndex;
              }
              return 0;
            }
          }), "sendInitialEvent", actions.sendInitialEventConversionMetricsIfNeed, (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
          })]
        }, {
          target: STATES.ERROR
        }],
        onError: STATES.ERROR
      }
    },
    [STATES.CHAPTER_IN_PROGRESS]: {
      entry: [context => {
        if (isUserFinishChapterFirstTimeGuard(context)) {
          actions.sendFinalEventConversionMetricsIfNeed(context);
        }
      }, "sendFinalEventIfNeed"],
      on: {
        [EVENTS.SET_CURRENT_ACTIVITY]: {
          actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            activityIndex: (context, event) => {
              if (!event.type || event.type !== EVENTS.SET_CURRENT_ACTIVITY) {
                return context.activityIndex;
              }
              return context.activities.findIndex(a => a?.activity_id === event.data.activityId);
            }
          }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            currentBlocks: context => context.filterCurrentActivityBlocks(context)
          }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
            blockIndex: context => {
              const {
                activities,
                activityIndex
              } = context;
              const currentActivity = activities[activityIndex];
              if (currentActivity.type === "lexis") {
                return 0;
              }
              if (context.isFinalEventExist) {
                return context.currentBlocks.length - 1;
              }
              return (0,_trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getFirstActionableBlockIndexFrom */ .dj)(0)(context);
            }
          })]
        }
      }
    },
    [STATES.SAVING_PROGRESS]: {
      onEntry: (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)(context => {
        const blockId = context.currentBlocks[context.blockIndex]?.id ?? null;
        if (blockId === null || context.completeBlocksIdSet.has(blockId)) {
          return {};
        }
        if (context.isTrialChapter) {
          switch (context.completeBlocksIdSet.count()) {
            case 0:
              void _utils_conversionsMetrics__WEBPACK_IMPORTED_MODULE_6__/* .ConversionsMetrics */ .l.firstProgress(context.productId);
              break;
            case 1:
              void _utils_conversionsMetrics__WEBPACK_IMPORTED_MODULE_6__/* .ConversionsMetrics */ .l.secondProgress(context.productId);
              break;
            default:
              break;
          }
        }
        return {
          completeBlocksIdSet: context.completeBlocksIdSet.add(blockId)
        };
      }),
      invoke: {
        src: "saveProgress",
        onDone: STATES.CHAPTER_IN_PROGRESS,
        onError: STATES.CHAPTER_IN_PROGRESS
      }
    },
    [STATES.SAVING_ANSWER]: {
      invoke: {
        src: "saveAnswer",
        onDone: STATES.CHAPTER_IN_PROGRESS,
        onError: STATES.CHAPTER_IN_PROGRESS
      }
    },
    [STATES.ERROR]: {}
  },
  on: {
    [EVENTS.NEXT_BLOCK_CLICKED]: [{
      cond: (context, _ref5) => {
        let {
          withScroll
        } = _ref5;
        return Boolean(withScroll) && [_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isLastBlock */ .zb, _trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isNextActivityEmptyAfterFilter */ .pH].every(guard => guard(context));
      },
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        activityIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getNextNotEmptyActivity */ .xL,
        blockIndex: 0,
        scrollToBlockIndex: 0
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: context => {
          if (context.isFinalEventExist) {
            return context.currentBlocks.length - 1;
          }
          return (0,_trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getFirstActionableBlockIndexFrom */ .dj)(0)(context);
        }
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      }), "pushActivityIdInUrl"],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: (context, _ref6) => {
        let {
          withScroll
        } = _ref6;
        return Boolean(withScroll) && (0,_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isLastBlock */ .zb)(context);
      },
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        activityIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .incrementActivityIndex */ .sp,
        blockIndex: 0,
        scrollToBlockIndex: 0
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        // eslint-disable-next-line sonarjs/no-identical-functions
        blockIndex: context => {
          if (context.isFinalEventExist) {
            return context.currentBlocks.length - 1;
          }
          return (0,_trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getFirstActionableBlockIndexFrom */ .dj)(0)(context);
        }
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      }), "pushActivityIdInUrl"],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: (context, _ref7) => {
        let {
          withScroll
        } = _ref7;
        return !withScroll && !(0,_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isLastBlock */ .zb)(context);
      },
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getNextFirstActionableBlockIndex */ .J0
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      })],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: context => !(0,_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isLastBlock */ .zb)(context),
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        scrollToBlockIndex: context => (0,_trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getScrollToBlockIndex */ .p9)(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getNextFirstActionableBlockIndex */ .J0
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      })],
      target: STATES.SAVING_PROGRESS
    }],
    [EVENTS.PREV_BLOCK_CLICKED]: [{
      cond: context => [_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isFirstBlock */ .d7, _trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .notFirstActivity */ .SH, _trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isPrevActivityEmptyAfterFilter */ .eR].every(guard => guard(context)),
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        activityIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getPrevNotEmptyActivityIndex */ .HZ
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      }), "pushActivityIdInUrl"],
      target: STATES.SAVING_PROGRESS
    }, {
      cond: context => [_trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .isFirstBlock */ .d7, _trainer_guards__WEBPACK_IMPORTED_MODULE_10__/* .notFirstActivity */ .SH].every(guard => guard(context)),
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        activityIndex: context => context.activityIndex ? context.activityIndex - 1 : 0
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      }), "pushActivityIdInUrl"],
      target: STATES.SAVING_PROGRESS
    }, {
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getPrevActionableBlockIndex */ .zL
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        scrollToBlockIndex: context => context.blockIndex
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        progress: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getProgress */ .xC
      })],
      target: STATES.SAVING_PROGRESS
    }],
    [EVENTS.PREV_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== 0,
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        activityIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getPrevNotEmptyActivityIndex */ .HZ
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: context => context.currentBlocks.length - 1,
        scrollToBlockIndex: context => context.currentBlocks.length - 1
      }), actions.updateProgress, "pushActivityIdInUrl"],
      target: STATES.SAVING_PROGRESS
    },
    [EVENTS.NEXT_ACTIVITY_CLICKED]: {
      cond: context => context.activityIndex !== context.activities.length,
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        activityIndex: _trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getNextNotEmptyActivity */ .xL
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: context => context.currentBlocks.length - 1
      }), actions.updateProgress, "pushActivityIdInUrl"],
      target: STATES.SAVING_PROGRESS
    },
    [EVENTS.RESET_ANSWER]: {
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        chapterStudentEvents: (context, event) => (0,_trainer_actions__WEBPACK_IMPORTED_MODULE_7__/* .getStudentEventUpdater */ .VL)(context.eventType.answer)(context, event)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      }), (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        blockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        },
        scrollToBlockIndex: (context, event) => {
          const {
            blockId
          } = event.data;
          return context.currentBlocks.findIndex(b => b.id === blockId);
        }
      })],
      target: STATES.SAVING_ANSWER
    },
    [EVENTS.SUBMIT_ANSWER]: {
      target: STATES.SAVING_ANSWER,
      actions: [actions.pushChapterAnswer, (0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)({
        currentBlocks: context => context.filterCurrentActivityBlocks(context)
      })]
    },
    [EVENTS.UPDATE_CHAPTER_STATE]: {
      actions: [(0,xstate__WEBPACK_IMPORTED_MODULE_11__/* .assign */ .f0)((context, ev) => ({
        productId: ev.productId,
        chapterId: ev.chapterId
      }))],
      target: STATES.LOADING_CHAPTER_DATA
    }
  }
});

/***/ }),

/***/ 98513:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AU: () => (/* binding */ SERVICES),
/* harmony export */   PO: () => (/* binding */ STATES),
/* harmony export */   aO: () => (/* binding */ ACTIONS),
/* harmony export */   ur: () => (/* binding */ GUARDS)
/* harmony export */ });


const SERVICES = {
  CHAPTER_STATE_LOADER: "chapterStateLoader",
  PROGRESS_SAVER: "progressSaver"
};
const STATES = {
  LOADING_CHAPTER_DATA: "loadingChapterData",
  SAVING_PROGRESS: "creatingProgress",
  CHAPTER_IN_PROGRESS: "chapterInProgress",
  ERROR: "error",
  IDLE: "idle",
  FORK: "fork",
  SAVING_ANSWER: "savingAnswer"
};
const ACTIONS = {
  ADD_OUTRO_IF_NEED: "addOutroIfNeed",
  PROCEED_INITIAL_CHAPTER_TRAINER_STATE: "proceedInitialChapterTrainerState",
  PROCEED_INITIAL_CHAPTER_STATE: "proceedInitialChapterState",
  INCREMENT_BLOCK_INDEX: "incrementBlockIndex",
  INCREMENT_ACTIVITY_INDEX: "incrementActivityIndex",
  PUSH_CHAPTER_ANSWER: "pushChapterAnswer",
  UPDATE_PROGRESS: "updateProgress",
  RESET_TRAINER: "resetTrainer",
  FILTER_CURRENT_ACTIVITY_BLOCKS: "filterCurrentActivityBlocks",
  CALCULATE_ACTIVITY_INDEX: "calculateActivityIndex",
  CALCULATE_BLOCK_INDEX: "calculateBlockIndex",
  DECREMENT_BLOCK_INDEX: "decrementBlockIndex",
  INCREMENT_ACTIVITY_INDEX_TIL_NOT_EMPTY: "incrementTillNotEmptyActivity",
  DECREMENT_ACTIVITY_INDEX: "decrementActivityIndex",
  DECREMENT_ACTIVITY_TIL_NOT_EMPTY: "decrementTillNotEmptyActivity",
  SET_CURRENT_LAST_BLOCK_IN_ACTIVITY: "setCurrentLastBlockInActivity",
  SEND_INITIAL_EVENT_IF_NEED: "sendInitialEventIfNeed",
  SEND_FINAL_EVENT_IF_NEED: "SEND_FINAL_EVENT_IF_NEED",
  PROCESS_LOADING_ERROR: "PROCESS_LOADING_ERROR"
};
const GUARDS = {
  IS_LAST_BLOCK: "isLastBlock",
  IS_LAST_ACTIVITY_AND_BLOCK: "isLastActivityAndBlock",
  IS_CHAPTER_IN_PROGRESS: "isChapterInProgress",
  IS_CHAPTER_COMPLETED: "isChapterCompleted",
  IS_NEXT_ACTIVITY_EMPTY_AFTER_FILTER: "isNextActivityAfterFilter",
  IS_ALL_NEXT_ACTIVITIES_EMPTY_AFTER_FILTER: "isAllNextActivitiesEmptyAfterFilter",
  IS_FIRST_BLOCK: "isFirstBlock",
  NOT_FIRST_ACTIVITY: "notFirstActivity",
  IS_PREV_ACTIVITY_EMPTY_AFTER_FILTER: "isPrevActivityEmptyAfterFilter",
  EVERY: "every",
  FINAL_EVENT_DOESNT_EXIST: "FINAL_EVENT_DOESNT_EXIST"
};

/***/ }),

/***/ 55378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  s: () => (/* binding */ ExperimentType),
  h: () => (/* binding */ meFromApiToModel)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
;// CONCATENATED MODULE: ./src/api/user/authorization/model.ts


var PayStatus = /* @__PURE__ */(PayStatus2 => {
  PayStatus2["Init"] = "init";
  PayStatus2["BindingCancel"] = "binding_cancel";
  PayStatus2["PayPending"] = "pay_pending";
  PayStatus2["PaySuccess"] = "pay_success";
  PayStatus2["PayCancel"] = "pay_cancel";
  return PayStatus2;
})(PayStatus || {});
;// CONCATENATED MODULE: ./src/state-machine/user/authorization/model.ts








var ExperimentType = /* @__PURE__ */(ExperimentType2 => {
  ExperimentType2["a1Complex"] = "a1_complex";
  ExperimentType2["a2FlippedMethod"] = "a2-flipped-method";
  ExperimentType2["a2PlusDisableDashboardLinkOnGrammarAndLexis"] = "a2_plus_disabled_dashboard_lexis";
  ExperimentType2["a2PlusDisableGrammarAndLexis"] = "a2_plus_no_lexis";
  ExperimentType2["autoOnboarding"] = "auto_onboarding";
  ExperimentType2["allowAccessForPacketStudents"] = "allow_access_for_packet_students";
  ExperimentType2["appRevisionExperiment"] = "app_revision_experiment";
  ExperimentType2["autopayByResource"] = "autopay_by_resource";
  ExperimentType2["beginnersSubscription"] = "beginners_subscription";
  ExperimentType2["calendarWebcal"] = "calendar_via_webcal";
  ExperimentType2["coursesSplitPay"] = "courses_split_pay";
  ExperimentType2["dashboardType9"] = "dashboard_type_9";
  ExperimentType2["disableTelemostErrorHandling"] = "disable_telemost_error_handling";
  ExperimentType2["disallowSpeakingSessionMultipleReschedule"] = "disallow_speaking_session_multiple_reschedule";
  ExperimentType2["enableOnlyTrainerEventExperiment"] = "student_sends_only_trainer_event";
  ExperimentType2["hideCancelButton"] = "hide_cancel_button";
  ExperimentType2["hideInternationalCardsPsp"] = "hide_international_cards_psp";
  ExperimentType2["kids"] = "kids";
  ExperimentType2["newFilters"] = "new-filters";
  ExperimentType2["newMatchPairs"] = "non_subscription_model";
  ExperimentType2["newPurchaseAfs"] = "new_purchase_afs";
  ExperimentType2["newPurchasePage"] = "new_purchase_page";
  ExperimentType2["newPurchasePsp"] = "new_purchase_psp";
  ExperimentType2["payWithSbp"] = "pay_with_sbp";
  ExperimentType2["placementTestFunnel"] = "placement-test-funnel";
  ExperimentType2["productTrainerRepetition"] = "product-trainer-repetition";
  ExperimentType2["referral"] = "referral";
  ExperimentType2["resources"] = "resources";
  ExperimentType2["goloomCheckup"] = "goloom_checkup";
  ExperimentType2["showProgressPage"] = "show_progress_page";
  ExperimentType2["skipTrialTest1"] = "skip_trial_test_1";
  ExperimentType2["translationV2"] = "translationV2";
  ExperimentType2["skipMicVolumeCheck"] = "skip_mic_volume_check";
  return ExperimentType2;
})(ExperimentType || {});
const tariffToModel = userTariff => {
  const tariff = userTariff.tariff;
  return {
    slug: userTariff.slug,
    discountPercent: tariff.discount_percent,
    price: tariff.price,
    partialPrice: tariff.partial_price,
    urlMarker: userTariff.tariff.url_marker,
    experimentId: tariff.experiment_id,
    dateFrom: userTariff.date_from,
    dateTo: userTariff.date_to,
    freePackages: tariff.free_packages,
    conditions: tariff.conditions
  };
};
const userFromApiToModel = (user, experiments) => {
  const {
    id,
    uid,
    role,
    calendar_token: calendarToken,
    default_email: defaultEmail,
    default_phone: defaultPhone,
    public_name: publicName,
    first_name: firstName,
    last_name: lastName,
    sex,
    avatar,
    timezone,
    current_product_paid: isCurrentProductPaid,
    is_paid_manual: isPaidManual,
    is_whitelisted: inWhiteList,
    is_yandexoid: isYandexoid,
    is_trial: isTrial,
    user_agreement: userAgreement,
    email_agreement: emailAgreement,
    subscription: {
      pay_status: payStatus = PayStatus.Init,
      payment_date: paymentDate = null,
      percent_discount: discount = 0
    } = {},
    need_reset,
    tariffs,
    telegram,
    whatsapp,
    notification,
    telegram_id: telegramId,
    telegram_name: telegramName
  } = user;
  return {
    id,
    uid,
    role,
    calendarToken,
    defaultEmail,
    defaultPhone,
    publicName,
    firstName,
    lastName,
    inWhiteList,
    isYandexoid,
    sex,
    avatar,
    timezone,
    isCurrentProductPaid,
    payStatus: isPaidManual ? PayStatus.PaySuccess : payStatus || PayStatus.Init,
    isTrial,
    isFirstPayment: !paymentDate,
    userAgreement,
    emailAgreement,
    userWhoPay: payStatus === PayStatus.PaySuccess,
    discount,
    tariffs: tariffs.map(tariffToModel),
    hasPlus: false,
    experiments,
    shouldResetCookie: need_reset,
    isB2b: tariffs.some(tariff => tariff.tariff.type?.toLowerCase() === "b2b"),
    telegram,
    whatsapp,
    notification,
    telegramId,
    telegramName
  };
};
const meFromApiToModel = _ref => {
  let {
    data,
    experiment_flags: experiments
  } = _ref;
  const {
    user,
    logged_in: loggedIn
  } = data;
  return {
    loggedIn,
    user: user ? userFromApiToModel(user, experiments) : void 0
  };
};

/***/ }),

/***/ 33870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ useStudentTestStore)
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9367);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47832);
/* harmony import */ var _api_tutor_test_restult_test_result_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50847);





const initialState = {
  selectedTestResultIds: [],
  selectedTestResult: null
};
const useStudentTestStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* .create */ .U)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_2__/* .devtools */ .mW)((set, get) => ({
  ...initialState,
  selectTestResult: props => {
    if (props.needNotifyTutor && !get().selectedTestResultIds.includes(props.id)) {
      void (0,_api_tutor_test_restult_test_result_api__WEBPACK_IMPORTED_MODULE_0__/* .setTestResultIsRead */ .sG)(props.id);
    }
    set(state => ({
      selectedTestResult: props,
      selectedTestResultIds: state.selectedTestResultIds.includes(props.id) ? state.selectedTestResultIds : [...state.selectedTestResultIds, props.id]
    }), void 0, "selectTestResult");
  },
  resetTestResult: () => set(() => ({
    selectedTestResult: null
  }), void 0, "resetTestResult")
}), {
  store: "StudentTestStore"
}));

/***/ }),

/***/ 4527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ cleanFromMarkdown)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48090);
/* harmony import */ var _yandex_langly_ui_kit_src_markdown_markdown_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43539);
/* harmony import */ var _components_dropdown_output_dropdown_rules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(899);
/* harmony import */ var _components_fill_the_gap_output_fill_the_gap_rule__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44199);
/* harmony import */ var _components_translatable_text_translation_tooltip_translation_tooltip_rule__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73766);








const cleanFromMarkdown = text => {
  const {
    dropdown
  } = (0,_components_dropdown_output_dropdown_rules__WEBPACK_IMPORTED_MODULE_3__/* .getDropdownRule */ .p)(0);
  const {
    fillTheGap
  } = (0,_components_fill_the_gap_output_fill_the_gap_rule__WEBPACK_IMPORTED_MODULE_4__/* .getFillTheGapRule */ .Z)();
  const rules = {
    ..._components_translatable_text_translation_tooltip_translation_tooltip_rule__WEBPACK_IMPORTED_MODULE_5__/* .translationTooltipRule */ .N,
    fillTheGap: {
      ...fillTheGap,
      react: node => node.content.rightAnswers[0]
    },
    dropdown: {
      ...dropdown,
      react: node => node.content.correct
    }
  };
  const markdown = /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yandex_langly_ui_kit_src_markdown_markdown_component__WEBPACK_IMPORTED_MODULE_2__/* .Markdown */ .UG, {
    rules,
    children: text
  });
  const htmlString = react_dom_server__WEBPACK_IMPORTED_MODULE_1__.renderToString(markdown);
  const div = document.createElement("div");
  div.innerHTML = htmlString;
  return div.textContent ?? "";
};

/***/ }),

/***/ 46760:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: () => (/* binding */ ConversionMetricsLevels)
/* harmony export */ });


var ConversionMetricsLevels = /* @__PURE__ */(ConversionMetricsLevels2 => {
  ConversionMetricsLevels2["A2"] = "a2";
  ConversionMetricsLevels2["A2Plus"] = "a2plus";
  ConversionMetricsLevels2["B1"] = "b1";
  ConversionMetricsLevels2["B2"] = "b2";
  return ConversionMetricsLevels2;
})(ConversionMetricsLevels || {});

/***/ }),

/***/ 90973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  l: () => (/* binding */ ConversionsMetrics)
});

// EXTERNAL MODULE: ../shared/src/entities/user/index.ts + 3 modules
var user = __webpack_require__(91485);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ./src/utils/conversionsMetrics.model.ts
var conversionsMetrics_model = __webpack_require__(46760);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ./src/api/bunker/bunker.api.ts + 1 modules
var bunker_api = __webpack_require__(43168);
;// CONCATENATED MODULE: ./src/utils/getConversionLevelFromLevelId.ts





let matchObject = null;
const getOrLoadMatch = () => {
  if (matchObject !== null) {
    return matchObject;
  }
  matchObject = (0,bunker_api/* getConversionLevelsMatch */.Nb)().then(result => {
    if ((0,Either.isRight)(result)) {
      return result.right;
    }
    matchObject = null;
    return null;
  });
  return matchObject;
};
const getConversionLevelFromLevelId = async levelId => {
  const matchLevels = await getOrLoadMatch();
  if (matchLevels === null) {
    logger/* Logger */.Yd.captureException("Can't load matchLevels");
    return null;
  }
  const result = matchLevels[levelId] ?? null;
  if (result === null) {
    logger/* Logger */.Yd.captureException("Can't match level");
  }
  return result;
};
// EXTERNAL MODULE: ./src/utils/yandexMetrica.ts
var yandexMetrica = __webpack_require__(11226);
;// CONCATENATED MODULE: ./src/utils/conversionsMetrics.ts







const levelAcceptedGoal = {
  [conversionsMetrics_model/* ConversionMetricsLevels */.M.A2]: "level_accepted_a2",
  [conversionsMetrics_model/* ConversionMetricsLevels */.M.A2Plus]: "level_accepted_a2plus",
  [conversionsMetrics_model/* ConversionMetricsLevels */.M.B1]: "level_accepted_b1",
  [conversionsMetrics_model/* ConversionMetricsLevels */.M.B2]: "level_accepted_b2"
};
var ConversionTargets = /* @__PURE__ */(ConversionTargets2 => {
  ConversionTargets2["FirstChapterInit"] = "1st_init_chap";
  ConversionTargets2["FirstProgress"] = "1st_progress";
  ConversionTargets2["SecondProgress"] = "2nd_progress";
  ConversionTargets2["FirstChapterFinish"] = "1st_chap";
  ConversionTargets2["FirstSpeakingBooked"] = "1st_booking";
  ConversionTargets2["FirstSpeakingEnterClass"] = "1st_speaking";
  ConversionTargets2["MadeFirstPayment"] = "1st_pay";
  return ConversionTargets2;
})(ConversionTargets || {});
const getConversionLevel = async levelId => {
  if (levelId === null) {
    logger/* Logger */.Yd.captureException("level is null");
    return null;
  }
  return getConversionLevelFromLevelId(levelId);
};
let isSendMetrics = false;
const sendConversion = async (target, levelId) => {
  if (!isSendMetrics) {
    return;
  }
  (0,yandexMetrica/* ymSendOnlyToYandexMetricsGoal */.C$)(target);
  const conversionLevel = await getConversionLevel(levelId);
  if (conversionLevel !== null) {
    (0,yandexMetrica/* ymSendOnlyToYandexMetricsGoal */.C$)(`${target}_${conversionLevel}`);
  }
};
var ConversionsMetrics;
(ConversionsMetrics2 => {
  ConversionsMetrics2.setUserRole = role => {
    isSendMetrics = [user/* UserRole */.i4.ROLE_STUDENT, user/* UserRole */.i4.ROLE_NEWBIE].includes(role);
  };
  ConversionsMetrics2.userAgreementAccepted = () => {
    (0,yandexMetrica/* ymGoal */.qf)("User_Agreement_Accepted");
  };
  ConversionsMetrics2.levelAccepted = async levelId => {
    if (!isSendMetrics) {
      return;
    }
    (0,yandexMetrica/* ymSendOnlyToYandexMetricsGoal */.C$)("level_accepted");
    const conversionLevel = await getConversionLevel(levelId);
    if (conversionLevel !== null) {
      (0,yandexMetrica/* ymSendOnlyToYandexMetricsGoal */.C$)(levelAcceptedGoal[conversionLevel]);
    }
  };
  ConversionsMetrics2.firstChapterInit = async levelId => {
    await sendConversion("1st_init_chap" /* FirstChapterInit */, levelId);
  };
  ConversionsMetrics2.firstProgress = async levelId => {
    await sendConversion("1st_progress" /* FirstProgress */, levelId);
  };
  ConversionsMetrics2.secondProgress = async levelId => {
    await sendConversion("2nd_progress" /* SecondProgress */, levelId);
  };
  ConversionsMetrics2.firstChapterFinish = async levelId => {
    await sendConversion("1st_chap" /* FirstChapterFinish */, levelId);
  };
  ConversionsMetrics2.firstSpeakingBooked = async levelId => {
    await sendConversion("1st_booking" /* FirstSpeakingBooked */, levelId);
  };
  ConversionsMetrics2.firstSpeakingEnterClass = async levelId => {
    await sendConversion("1st_speaking" /* FirstSpeakingEnterClass */, levelId);
  };
})(ConversionsMetrics || (ConversionsMetrics = {}));

/***/ }),

/***/ 40826:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G8: () => (/* binding */ DIInjectionPriority),
/* harmony export */   SH: () => (/* binding */ ProductMainType),
/* harmony export */   Vs: () => (/* binding */ DiContextProvider),
/* harmony export */   e1: () => (/* binding */ useExperimentDi)
/* harmony export */ });
/* unused harmony export DiValues */
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5875);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50509);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(74736);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(38728);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(64810);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43419);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(32825);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(94574);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(16093);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(36615);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(77829);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(33281);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(60253);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(24376);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(49225);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(79941);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(57265);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(25888);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(15840);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(32442);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(37610);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(227);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(13351);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_object_utils__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(97060);













































const levelsSelectorAddLevels = [];
var ProductMainType = /* @__PURE__ */(ProductMainType2 => {
  ProductMainType2["Gus"] = "Gus";
  ProductMainType2["General"] = "General";
  return ProductMainType2;
})(ProductMainType || {});
const defaultInjections = {
  autoOnboarding: false,
  a2PlusFlippedExperimentConfig: {
    productId: "",
    trialSpeakingId: "",
    trialChapterIds: []
  },
  allowAccessForPacketStudents: false,
  appRevisionExperiment: false,
  autopayByResource: false,
  beginnerProductIds: [],
  bell: false,
  calendarWebcal: false,
  coursesSplitPay: false,
  disableAutoScroll: false,
  disableGrammarAndLexisOnDashboard: false,
  disableTelemostErrorHandling: false,
  disableTrainerOutroActions: false,
  disallowSpeakingSessionMultipleReschedule: false,
  enableOnlyTrainerEventExperiment: false,
  fixedChapters: null,
  goloomCheckup: false,
  grammarAndLexisAfterSpeaking: false,
  hideAddToWordbankButton: false,
  hideCancelButton: false,
  hideChapterDuration: false,
  hideGrammarAndLexis: false,
  hideInternationalCardsPsp: false,
  hideLevelSelector: false,
  hideMentorSpeaking: false,
  hideProducts: /* @__PURE__ */new Set(),
  isA2PlusFlippedExperimentActive: false,
  isMentorNotesVisible: true,
  levelsSelectorIdsRedefine: /* @__PURE__ */new Map(),
  levelsSelectorAddLevels,
  maxTimeToTutorAssignmentHours: 168,
  // 1 week
  nativeSpeakerSessionIds: /* @__PURE__ */new Set(),
  newFilters: false,
  /** @deprecated */
  newPurchasePage: false,
  newPurchaseAfs: true,
  newPurchasePsp: false,
  payWithSbp: false,
  notForSale: false,
  openPageAfterPlacement: /* @__PURE__ */new Map(),
  openStoryAfterSpeaking: false,
  partialPaymentProductsIdSet: /* @__PURE__ */new Set(),
  placementTestFunnel: false,
  productMainType: "Gus" /* Gus */,
  productTrainerRepetitionExperimentIsActive: false,
  redefinePaymentLink: /* @__PURE__ */new Map(),
  referral: {
    tariff_slug: ""
  },
  resources: {
    enabled: false,
    resourceTypes: []
  },
  resourcesExperiment: false,
  routes: {},
  showCourseMap: false,
  showCancelOrRescheduleReasonSurvey: false,
  showFullSpeaking: false,
  showGuidesButton: false,
  showGrammarGuideButtonInMenu: false,
  showProgressPage: false,
  showSkipButtonInTrainer: false,
  showReschedulingButton: false,
  startWithSpeakingSession: false,
  skipTrial: false,
  translationV2: false,
  webrtcProvider: null,
  skipMicVolumeCheck: false
};
var DIInjectionPriority = /* @__PURE__ */(DIInjectionPriority2 => {
  DIInjectionPriority2[DIInjectionPriority2["Primary"] = 1] = "Primary";
  DIInjectionPriority2[DIInjectionPriority2["Normal"] = 0] = "Normal";
  return DIInjectionPriority2;
})(DIInjectionPriority || {});
const DiContext = (0,react__WEBPACK_IMPORTED_MODULE_41__.createContext)(defaultInjections);
let DiValues = (/* unused pure expression or super */ null && (defaultInjections));
const DiContextProvider = _ref => {
  let {
    notDefaultInjections,
    children
  } = _ref;
  const value = (0,_yandex_langly_shared_src_object_utils__WEBPACK_IMPORTED_MODULE_42__/* .getObjectKeys */ .Z)(defaultInjections).reduce((acc, key) => {
    const injection = notDefaultInjections?.[key] ?? defaultInjections[key];
    return {
      ...acc,
      [key]: injection
    };
  }, {});
  DiValues = value;
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_40__.jsx)(DiContext.Provider, {
    value,
    children
  });
};
const useExperimentDi = () => (0,react__WEBPACK_IMPORTED_MODULE_41__.useContext)(DiContext);

/***/ }),

/***/ 64866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C1: () => (/* binding */ required),
/* harmony export */   b: () => (/* binding */ stringEnum),
/* harmony export */   fr: () => (/* binding */ asType)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5875);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50509);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74736);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38728);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64810);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43419);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32825);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94574);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16093);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36615);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77829);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33281);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60253);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24376);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49225);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(79941);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57265);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25888);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15840);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(32442);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(37610);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(227);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(13351);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(87830);
/* harmony import */ var _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(66176);





























const asType = () => new io_ts__WEBPACK_IMPORTED_MODULE_26__.Type("asType", _input => true, input => io_ts__WEBPACK_IMPORTED_MODULE_26__.success(input), io_ts__WEBPACK_IMPORTED_MODULE_26__.identity);
const stringEnum = e => {
  const values = new Set(Object.keys(e).map(key => e[key]));
  const isFunction = input => io_ts__WEBPACK_IMPORTED_MODULE_26__.string.is(input) && values.has(input);
  return new io_ts__WEBPACK_IMPORTED_MODULE_26__.Type(`StringEnum(${Array.from(values.values()).join("|")})`, isFunction, (i, context) => isFunction(i) ? io_ts__WEBPACK_IMPORTED_MODULE_26__.success(i) : io_ts__WEBPACK_IMPORTED_MODULE_26__.failure(i, context), io_ts__WEBPACK_IMPORTED_MODULE_26__.identity);
};
const required = (item, fallback, error) => {
  if (item === void 0) {
    _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_25__/* .Logger */ .Yd.captureWarning(error);
    return fallback;
  }
  return item;
};

/***/ }),

/***/ 49396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: () => (/* binding */ preloadImagesForActivities)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97703);





















const preloadedImageUrlMap = /* @__PURE__ */new Map();
const preloadImagesForActivities = activities => {
  const imagesArray = [];
  activities.forEach(activity => {
    activity.blocks.forEach(block => {
      switch (block.type) {
        case "caption":
        case "lexis-info":
        case "intro":
        case "outro":
          if (block.image) {
            imagesArray.push(block.image);
          }
          break;
        case "image":
          imagesArray.push(block.url);
          break;
        case "mechanic":
          if (block.input && block.input.type === "image") {
            imagesArray.push(block.input.image.url);
          }
          if (block.output) {
            switch (block.output.type) {
              case "choose":
              case "condition-choose":
                block.output.variants.forEach(variant => {
                  if (variant.type === _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_18__/* .OptionType */ .GL.Image) {
                    imagesArray.push(variant.image.url);
                  }
                });
                break;
              case "match-pairs":
                block.output.pairs.forEach(pair => {
                  pair.forEach(option => {
                    if (option.type === _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_18__/* .OptionType */ .GL.Image) {
                      imagesArray.push(option.image.url);
                    }
                  });
                });
                break;
              case "put-in-bins":
                block.output.bins.forEach(bin => {
                  bin.pieces.forEach(piece => {
                    if (piece.type === _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_18__/* .OptionType */ .GL.Image) {
                      imagesArray.push(piece.image.url);
                    }
                  });
                });
                break;
              case "put-in-order":
                block.output.parts.forEach(part => {
                  if (part.type === _yandex_langly_shared_src_models_trainer_trainer_model__WEBPACK_IMPORTED_MODULE_18__/* .OptionType */ .GL.Image) {
                    imagesArray.push(part.image.url);
                  }
                });
                break;
              default:
                break;
            }
          }
          break;
        default:
          break;
      }
    });
  });
  const preloadCandidatesUrls = [];
  for (const imageUrl of imagesArray) {
    if (!preloadedImageUrlMap.has(imageUrl)) {
      preloadedImageUrlMap.set(imageUrl, true);
      preloadCandidatesUrls.push(imageUrl);
    }
  }
  if (preloadCandidatesUrls.length > 0) {
    document.head.append(...preloadCandidatesUrls.map(url => {
      const preloadImageLink = document.createElement("link");
      preloadImageLink.rel = "preload";
      preloadImageLink.as = "image";
      preloadImageLink.href = url;
      return preloadImageLink;
    }));
  }
};

/***/ }),

/***/ 59040:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: () => (/* binding */ getConsecutiveSpeakingSessions)
/* harmony export */ });
/* unused harmony export isConsecutiveSpeakingSessions */
/* harmony import */ var core_js_modules_es_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15398);
/* harmony import */ var core_js_modules_es_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71502);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7300);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34002);




function getConsecutiveSpeakingSessions(speakingSessions, speakingSessionId) {
  const sortedSpeakingSessions = speakingSessions.toSorted((a, b) => (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* .isBefore */ .R)(a.startAt, b.startAt) ? -1 : 0);
  const index = sortedSpeakingSessions.findIndex(speakingSession => speakingSession.id === speakingSessionId);
  if (index < 0) {
    return [];
  }
  const lastConsecutiveLeftSpeakingSessionIndex = getLastConsecutiveSessionIndex(sortedSpeakingSessions, index, -1);
  const lastConsecutiveRightSpeakingSessionIndex = getLastConsecutiveSessionIndex(sortedSpeakingSessions, index, 1);
  return sortedSpeakingSessions.slice(lastConsecutiveLeftSpeakingSessionIndex, lastConsecutiveRightSpeakingSessionIndex + 1);
}
function getLastConsecutiveSessionIndex(speakingSessions, startIndex, step) {
  let currIndex = startIndex;
  const speakingSessionsLength = speakingSessions.length;
  while (isValidIndex({
    index: currIndex + step,
    arrayLength: speakingSessionsLength
  }) && isConsecutiveSpeakingSessions(speakingSessions[currIndex], speakingSessions[currIndex + step])) {
    currIndex += step;
  }
  return currIndex;
}
function isValidIndex(_ref) {
  let {
    index,
    arrayLength
  } = _ref;
  return index >= 0 && index < arrayLength;
}
function isConsecutiveSpeakingSessions(ss1, ss2) {
  const ss1StartAt = ss1.startAt;
  const ss2StartAt = ss2.startAt;
  const ss1EndAt = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .addMinutes */ .m)(ss1.startAt, ss1.speaking.durationMinutes);
  const ss2EndAt = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .addMinutes */ .m)(ss2.startAt, ss2.speaking.durationMinutes);
  return Math.abs((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* .differenceInMinutes */ .X)(ss1StartAt, ss2EndAt)) < 1 || Math.abs((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* .differenceInMinutes */ .X)(ss2StartAt, ss1EndAt)) < 1;
}

/***/ }),

/***/ 41991:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ splitStringsByRegex)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_array_last_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21721);
/* harmony import */ var core_js_modules_esnext_array_last_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_array_last_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_4__);







function splitStringsByRegex(strings, regex, parser, shuffleHash) {
  let indexOfMeta = 0;
  const result = [];
  strings.forEach(str => {
    const arrayOfMeta = [];
    const regexForParsing = new RegExp(regex, "g");
    let arr;
    while ((arr = regexForParsing.exec(str)) !== null) {
      arrayOfMeta.push({
        index: indexOfMeta,
        startPosition: regexForParsing.lastIndex - arr[0].length,
        length: arr[0].length,
        metadata: parser(arr[0], indexOfMeta, shuffleHash)
      });
      indexOfMeta++;
    }
    const parsedString = [];
    let currentPosition = 0;
    let indexOfMetadata = 0;
    while (currentPosition < str.length) {
      const meta = arrayOfMeta[indexOfMetadata];
      const isMetadata = meta && meta.startPosition === currentPosition;
      if (isMetadata) {
        parsedString.push(meta.metadata);
        currentPosition += meta.length;
        indexOfMetadata++;
      } else {
        const length = meta ? meta.startPosition - currentPosition : str.length - currentPosition;
        const s = str.substr(currentPosition, length);
        parsedString.push(s);
        currentPosition += length;
      }
    }
    result.push(parsedString);
  });
  return result;
}

/***/ }),

/***/ 18884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ isLastActivity)
/* harmony export */ });


function isLastActivity(activityIndex, activities) {
  return activityIndex === (activities?.length || 1) - 1;
}

/***/ }),

/***/ 99543:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ trainerEventTypes),
/* harmony export */   z: () => (/* binding */ trainerEventType)
/* harmony export */ });


const trainerEventType = {
  progress: "trainer_progress",
  result: "trainer_result",
  progressInit: "trainer_progress_init",
  progressFinal: "trainer_progress_final"
};
const trainerEventTypes = Object.values(trainerEventType);

/***/ }),

/***/ 47822:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  getUrlSearchParams: () => (/* binding */ getUrlSearchParams)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/delete-query-param.ts + 1 modules
var delete_query_param = __webpack_require__(99883);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/get-url-search-params.ts + 1 modules
var get_url_search_params = __webpack_require__(4761);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/set-query-param.ts
var set_query_param = __webpack_require__(85960);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/set-query-param-for-link.ts
var set_query_param_for_link = __webpack_require__(76155);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/set-query-params-for-link.ts
var set_query_params_for_link = __webpack_require__(85033);
;// CONCATENATED MODULE: ./src/utils/url/constants.ts


const QUERY_PARAM_KEYS = {
  MAIN_MENU_POPUP_SEARCH: "mainMenuPopup",
  PROMO_CODE_POPUP_SEARCH: "promoCodePopup",
  WORDBANK_POPUP_SEARCH: "wordbankPopup",
  SCHEDULE_POPUP_SEARCH: "schedulePopup",
  SCHEDULED_SPEAKING_POPUP_SEARCH: "scheduledSpeakingPopup",
  CANCEL_SPEAKING_POPUP_SEARCH: "cancelSpeakingPopup",
  TEACHER_ID: "teacherInfoPopup",
  OPEN_HELP: "openHelp",
  GRAMMAR_GUIDE: "grammarGuide",
  CANCEL_LESSON_POPUP: "cancelLesson",
  RESCHEDULE_LESSON_POPUP: "rescheduleLesson",
  PLACEMENT_PRODUCT_ID: "placementProductId"
};
;// CONCATENATED MODULE: ./src/utils/url/create-simple-popup.ts






const createSimplePopup = key => ({
  isOpen(history) {
    const params = new URLSearchParams(history.location.search);
    return params.get(key) === "1";
  },
  getOpenUrl(history) {
    return (0,set_query_param/* setQueryParam */.s)(key, "1", history);
  },
  getCloseUrl(history) {
    return (0,set_query_param/* setQueryParam */.s)(key, "0", history);
  }
});
;// CONCATENATED MODULE: ./src/utils/url/get-url-search-params.ts













const getUrlSearchParams = {
  retPath: {
    getLinkWithRetPath(args) {
      const pathName = args.history.location.pathname;
      const search = args.history.location.search;
      if (!search && (!pathName || pathName === "/")) {
        return args.link;
      }
      return args.link + "?retPath=" + encodeURIComponent(pathName + search);
    },
    goToLinkWithRetPath(args) {
      const url = getUrlSearchParams.retPath.getLinkWithRetPath(args);
      args.history.push(url);
    },
    goToRetPath(history) {
      const params = new URLSearchParams(history.location.search);
      const retPath = params.get("retPath");
      if (retPath !== null) {
        return history.push(retPath);
      }
    },
    getRetPath(history) {
      const params = new URLSearchParams(history.location.search);
      const retPath = params.get("retPath");
      if (retPath !== null) {
        return retPath;
      }
    },
    haveRetPath(history) {
      const params = new URLSearchParams(history.location.search);
      return params.has("retPath");
    }
  },
  [QUERY_PARAM_KEYS.PLACEMENT_PRODUCT_ID]: {
    rawValue(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.PLACEMENT_PRODUCT_ID);
    },
    get(history) {
      const rawValue = this.rawValue(history);
      return rawValue || void 0;
    },
    remove(history) {
      history.push((0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.PLACEMENT_PRODUCT_ID, history));
    }
  },
  mainMenuPopup: createSimplePopup(QUERY_PARAM_KEYS.MAIN_MENU_POPUP_SEARCH),
  promocodePopup: createSimplePopup(QUERY_PARAM_KEYS.PROMO_CODE_POPUP_SEARCH),
  wordbankPopup: createSimplePopup(QUERY_PARAM_KEYS.WORDBANK_POPUP_SEARCH),
  grammarGuide: createSimplePopup(QUERY_PARAM_KEYS.GRAMMAR_GUIDE),
  schedulePopup: {
    getParam(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.SCHEDULE_POPUP_SEARCH);
    },
    isHidden(history) {
      const param = this.getParam(history);
      return param === "0" || param === null || param === "";
    },
    getOpenUrl(id, history) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.SCHEDULE_POPUP_SEARCH, id, history);
    },
    getCloseUrl(history) {
      return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.SCHEDULE_POPUP_SEARCH, history);
    }
  },
  scheduledSpeakingPopup: {
    getParam(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.SCHEDULED_SPEAKING_POPUP_SEARCH);
    },
    isHidden(history) {
      const param = this.getParam(history);
      return param === "0" || param === null || param === "";
    },
    getOpenUrl(id, history) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.SCHEDULED_SPEAKING_POPUP_SEARCH, id, history);
    },
    getCloseUrl(history) {
      return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.SCHEDULED_SPEAKING_POPUP_SEARCH, history);
    }
  },
  cancelSpeakingPopup: {
    getParam(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.CANCEL_SPEAKING_POPUP_SEARCH);
    },
    isHidden(history) {
      const param = this.getParam(history);
      return param === "0" || param === null || param === "";
    },
    getOpenUrl(id, history) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.CANCEL_SPEAKING_POPUP_SEARCH, id, history);
    },
    getCloseUrl(history) {
      return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.CANCEL_SPEAKING_POPUP_SEARCH, history);
    }
  },
  chapterLink: {
    getLinkWithRetPath(args) {
      return (0,set_query_param_for_link/* setQueryParamForLink */.l)("retPath", args.retPath, args.link, args.history);
    },
    getLinkWithParams(args) {
      return (0,set_query_params_for_link/* setQueryParamsForLink */.U)(args.link, args.params, args.history);
    },
    getSyllabusNodeId(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get("syllabusNodeId");
    }
  },
  teacherPopup: {
    getParam(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.TEACHER_ID);
    },
    getOpenUrl(id, history) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.TEACHER_ID, id, history);
    },
    getCloseUrl(history) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.TEACHER_ID, "", history);
    }
  },
  openHelp: {
    getParam(history) {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.OPEN_HELP);
    },
    isOpen(history) {
      const param = this.getParam(history);
      return param && param !== "0";
    },
    setParam(value, history) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.OPEN_HELP, value, history);
    },
    getOpenUrl(history) {
      return this.setParam("1", history);
    },
    getCloseUrl(history) {
      return this.setParam("0", history);
    },
    setParamForLink(value, link, history) {
      return (0,set_query_param_for_link/* setQueryParamForLink */.l)(QUERY_PARAM_KEYS.OPEN_HELP, value, link, history);
    },
    getLinkWithOpenHelp(link, history) {
      return this.setParamForLink("1", link, history);
    },
    getLinkWithCloseHelp(link, history) {
      return this.setParamForLink("0", link, history);
    }
  },
  taskGuide: get_url_search_params/* getUrlSearchParams */.r.taskGuide,
  cancelLessonPopup: {
    getSpeakingSessionId: history => {
      const params = new URLSearchParams(history.location.search);
      return params.get(QUERY_PARAM_KEYS.CANCEL_LESSON_POPUP);
    },
    openPopUp(history, params) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.CANCEL_LESSON_POPUP, params.speakingSessionId, history);
    },
    closePopUp(history) {
      return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.CANCEL_LESSON_POPUP, history);
    }
  },
  rescheduleLessonPopup: {
    getSpeakingSessionId: location => {
      const params = new URLSearchParams(location.search);
      const speakingSessionId = params.get(QUERY_PARAM_KEYS.RESCHEDULE_LESSON_POPUP);
      if (speakingSessionId !== null) {
        return speakingSessionId;
      }
    },
    getOpenPopUpPath(history, speakingSessionId) {
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.RESCHEDULE_LESSON_POPUP, speakingSessionId, history);
    },
    getClosePopUpPath(history) {
      return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.RESCHEDULE_LESSON_POPUP, history);
    }
  }
};

/***/ }),

/***/ 11226:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C$: () => (/* binding */ ymSendOnlyToYandexMetricsGoal),
/* harmony export */   CL: () => (/* binding */ ymSetUserId),
/* harmony export */   qN: () => (/* binding */ ymGoalCustom),
/* harmony export */   qf: () => (/* binding */ ymGoal),
/* harmony export */   vi: () => (/* binding */ ymSetVisitParams),
/* harmony export */   x9: () => (/* binding */ ymHit)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95850);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73631);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71399);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_5__);








const metrikaId = 58837981;
const ym = window.ym;
const ymSendOnlyToYandexMetricsGoalCustom = function (goalName) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (ym === void 0) {
    return;
  }
  ym(metrikaId, "reachGoal", goalName, params);
};
const ymSendOnlyToYandexMetricsGoal = goalName => {
  ymSendOnlyToYandexMetricsGoalCustom(goalName);
};
const ymGoalCustom = function (goalName) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ymSendOnlyToYandexMetricsGoalCustom(goalName, params);
};
const ymGoal = function (goalName) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ymGoalCustom(goalName, params);
};
const ymHit = url => {
  if (ym === void 0) {
    return;
  }
  ym(metrikaId, "hit", url);
};
const ymSetVisitParams = () => {
  if (ym === void 0) {
    return;
  }
  const queryParams = new URLSearchParams(window.location.search);
  const visitParams = {};
  queryParams.forEach((value, key) => {
    visitParams[key] = value;
  });
  ym(metrikaId, "params", visitParams);
};
const ymSetUserId = userId => {
  if (ym === void 0) {
    return;
  }
  ym(metrikaId, "setUserID", userId);
  ym(metrikaId, "userParams", {
    UserID: userId
  });
};

/***/ }),

/***/ 37260:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w: () => (/* binding */ CuratorOnboardingScreenContent)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ./src/widgets/curator-onboarding-screen-content/ui/curator-onboarding-screen-content.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const curator_onboarding_screen_content_module = ({"content":"curator-onboarding-screen-content-module__content--pkZ4H","image":"curator-onboarding-screen-content-module__image--nPUqA","title":"curator-onboarding-screen-content-module__title--rU9N9","description-block":"curator-onboarding-screen-content-module__description-block--zM_bX","descriptionBlock":"curator-onboarding-screen-content-module__description-block--zM_bX","description":"curator-onboarding-screen-content-module__description--iJCxr"});
;// CONCATENATED MODULE: ./src/widgets/curator-onboarding-screen-content/ui/curator-onboarding-screen-content.tsx







const CuratorOnboardingScreenContent = _ref => {
  let {
    content
  } = _ref;
  const {
    title,
    contentFirstBlock,
    contentSecondBlock,
    contentThirdBlock,
    imageAlt,
    imageSrc
  } = content;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: curator_onboarding_screen_content_module.content,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: curator_onboarding_screen_content_module.image,
      alt: imageAlt,
      src: imageSrc
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
      className: curator_onboarding_screen_content_module.title,
      children: title
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(typography_module/* default */.Z.headline4, curator_onboarding_screen_content_module.descriptionBlock),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: curator_onboarding_screen_content_module.description,
        children: contentFirstBlock
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: curator_onboarding_screen_content_module.description,
        children: contentSecondBlock
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        className: curator_onboarding_screen_content_module.description,
        children: contentThirdBlock
      })]
    })]
  });
};

/***/ }),

/***/ 8490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QY: () => (/* binding */ RescheduleTutorIsNotAvailableError),
/* harmony export */   h0: () => (/* binding */ RescheduleAlreadyInThePastError),
/* harmony export */   sK: () => (/* binding */ SpeakingSessionRescheduleIsNotFree)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RescheduleTutorIsNotAvailableError extends Error {
  constructor(speakingSessionId, rescheduleDate) {
    super(`Tutor is not available error when try to reschedule (${speakingSessionId})`);
    _defineProperty(this, "rescheduleDate", void 0);
    this.rescheduleDate = rescheduleDate;
  }
}
class RescheduleAlreadyInThePastError extends Error {
  constructor(speakingSessionId, rescheduleDate) {
    super(`Already in the past error when reschedule lesson (${speakingSessionId})`);
    _defineProperty(this, "rescheduleDate", void 0);
    this.rescheduleDate = rescheduleDate;
  }
}
class SpeakingSessionRescheduleIsNotFree extends Error {
  constructor(speakingSessionId, rescheduleDate) {
    super(`Unsuccessful attempt to reschedule a speaking session for free (${speakingSessionId})`);
    this.rescheduleDate = rescheduleDate;
  }
}

/***/ }),

/***/ 59411:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  H: () => (/* reexport */ ContactsScreen)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(9699);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../shared/src/services/notification/toast.ts
var toast = __webpack_require__(99990);
// EXTERNAL MODULE: ../shared/src/utils/form/transforms.ts
var transforms = __webpack_require__(50506);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/form/form.tsx + 2 modules
var form_form = __webpack_require__(73385);
// EXTERNAL MODULE: ./src/hooks/user/useUser.tsx + 1 modules
var useUser = __webpack_require__(87029);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/api/api.ts






const saveContacts = (0,un_either/* unEither */.K)(_ref => {
  let {
    whatsapp,
    telegram
  } = _ref;
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/student/contacts`, {
    method: "POST",
    responseType: es6.type({}),
    body: {
      whatsapp: whatsapp || void 0,
      telegram: telegram || void 0
    }
  });
});
// EXTERNAL MODULE: ../ui-kit/src/form/fields/text.tsx + 2 modules
var fields_text = __webpack_require__(80498);
// EXTERNAL MODULE: ../ui-kit/src/form/use-form-context.ts
var use_form_context = __webpack_require__(83900);
// EXTERNAL MODULE: ../ui-kit/src/input/input.component.tsx + 1 modules
var input_component = __webpack_require__(16455);
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/ui/contacts-form/contacts-form.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const contacts_form_module = ({"form-block":"contacts-form-module__form-block--u9TvN","formBlock":"contacts-form-module__form-block--u9TvN","form-description":"contacts-form-module__form-description--efUdj","formDescription":"contacts-form-module__form-description--efUdj","fields":"contacts-form-module__fields--x_akX","field-wrapper":"contacts-form-module__field-wrapper--p0Iq7","fieldWrapper":"contacts-form-module__field-wrapper--p0Iq7","button-wrapper":"contacts-form-module__button-wrapper--_jscr","buttonWrapper":"contacts-form-module__button-wrapper--_jscr","button":"contacts-form-module__button--TR0O_"});
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/ui/contacts-form/fields.tsx








function Fields(_ref) {
  let {
    setErrors
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    setFieldValue
  } = (0,use_form_context/* useFormContext */.Gc)();
  const clearErrors = () => {
    setErrors({});
  };
  const onTelegramChange = async e => {
    let result = e.target.value.toLocaleLowerCase();
    if (result.length > 0 && result[0] !== "@") {
      result = "@" + result;
    }
    await setFieldValue("telegram", result);
    clearErrors();
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: contacts_form_module.fields,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: contacts_form_module.fieldWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(fields_text/* FormTextField */.X, {
        errorLevel: "warning",
        onChange: clearErrors,
        label: intl.formatMessage({
          id: "onboarding.contacts.form.whatsapp.label"
        }),
        name: "whatsapp",
        placeholder: intl.formatMessage({
          id: "onboarding.contacts.form.whatsapp.placeholder"
        }),
        theme: input_component/* InputTheme */.RK.Grey
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: contacts_form_module.fieldWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(fields_text/* FormTextField */.X, {
        errorLevel: "warning",
        onChange: onTelegramChange,
        label: intl.formatMessage({
          id: "onboarding.contacts.form.telegram.label"
        }),
        placeholder: intl.formatMessage({
          id: "onboarding.contacts.form.telegram.placeholder"
        }),
        name: "telegram",
        theme: input_component/* InputTheme */.RK.Grey
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/ui/contacts-form/contacts-form.tsx

















const validationSchema = es/* object */.Ry().shape({
  whatsapp: es/* string */.Z_().when("telegram", {
    is: val => !val || val.length === 0,
    then: es/* string */.Z_().required("onboarding.contacts.form.required").phone("onboarding.contacts.form.format")
  }),
  telegram: es/* string */.Z_().when("whatsapp", {
    is: val => !val || val.length === 0,
    then: es/* string */.Z_().required("onboarding.contacts.form.required").telegram("onboarding.contacts.form.format")
  })
}, [["telegram", "whatsapp"]]);
const transformValues = {
  whatsapp: transforms/* formFieldTransforms */.l.trim,
  telegram: transforms/* formFieldTransforms */.l.trim
};
function ContactsForm(_ref) {
  let {
    onSubmit
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    functions: userFunctions,
    data: userData
  } = (0,useUser/* useUser */.aF)();
  const [isLoading, setIsLoading] = (0,react.useState)(false);
  const user = userData?.me.user;
  const initialValues = {
    whatsapp: user?.whatsapp ?? "",
    telegram: user?.telegram ?? ""
  };
  return /* @__PURE__ */(0,jsx_runtime.jsx)(form_form/* Form */.l, {
    initialValues,
    transformValues,
    validationSchema,
    formatMessage: msg => intl.formatMessage({
      id: msg
    }),
    onSubmit: async values => {
      try {
        setIsLoading(true);
        await saveContacts(values);
        await userFunctions?.reloadMeInBackground();
        onSubmit?.();
      } catch (e) {
        toast/* toastNotificationService */.B.showError(intl.formatMessage({
          id: "onboarding.contacts.errorToast"
        }));
      } finally {
        setIsLoading(false);
      }
    },
    validateOnChange: false,
    children: _ref2 => {
      let {
        submitForm,
        isValid,
        setErrors
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: contacts_form_module.formBlock,
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
            className: classnames_default()(typography_module/* default */.Z.headline4, {
              [typography_module/* default */.Z.body2]: isMobile
            }, contacts_form_module.formDescription),
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "onboarding.contacts.form.description"
            })
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(Fields, {
            setErrors
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: contacts_form_module.buttonWrapper,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            className: contacts_form_module.button,
            loading: isLoading,
            onClick: () => {
              void submitForm().then(() => {
                if (!isValid) {
                  toast/* toastNotificationService */.B.showError(intl.formatMessage({
                    id: "onboarding.contacts.errorToastRequired"
                  }));
                }
              });
            },
            type: "submit",
            appearance: "primary",
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "onboarding.contacts.form.button"
            })
          })
        })]
      });
    }
  });
}
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/ui/contacts-screen/contacts-screen.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const contacts_screen_module = ({"root":"contacts-screen-module__root--igY6L","header":"contacts-screen-module__header--uIHBY","image":"contacts-screen-module__image--z2xSg","title":"contacts-screen-module__title--oEWOg"});
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/ui/contacts-screen/contacts-screen.tsx









function ContactsScreen(_ref) {
  let {
    isKidsProduct,
    onSaveContacts
  } = _ref;
  const headerId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: contacts_screen_module.root,
    "aria-labelledby": headerId,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("header", {
      className: contacts_screen_module.header,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
        className: contacts_screen_module.image,
        role: "presentation",
        alt: "",
        src: "https://flowstatic.s3.yandex.net/ui-files/autoonboarding-curator-welcome.svg"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        id: headerId,
        className: classnames_default()(typography_module/* default */.Z.headline3, contacts_screen_module.title),
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "onboarding.contacts.title"
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(ContactsForm, {
      onSubmit: onSaveContacts
    }), isKidsProduct && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("br", {}), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "onboarding.contacts.callYourParents"
        })
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/widgets/student-contact-info/index.ts




/***/ }),

/***/ 2638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  g: () => (/* binding */ SelfStudyList)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfToday.mjs
var startOfToday = __webpack_require__(12303);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/task-guide/__task/task-guide-task.component.tsx + 1 modules
var task_guide_task_component = __webpack_require__(95226);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__self-study-popup/self-study-task.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const self_study_task_module = ({"task":"self-study-task-module__task--Xoi5F","key-helper":"self-study-task-module__key-helper--O3HGZ","keyHelper":"self-study-task-module__key-helper--O3HGZ","task-item":"self-study-task-module__task-item--Mg0P3","taskItem":"self-study-task-module__task-item--Mg0P3"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__self-study-popup/self-study-task.tsx






const SelfStudyTask = _ref => {
  let {
    task,
    index
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: self_study_task_module.task,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: self_study_task_module.keyHelper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.captionAccent,
        children: index + 1
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: self_study_task_module.taskItem,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(task_guide_task_component/* TaskGuideTask */.s, {
        ...task
      })
    })]
  }, task.text);
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__self-study-popup/self-study-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const self_study_popup_module = ({"container":"self-study-popup-module__container--hKyOB","header":"self-study-popup-module__header--Hjb70","header-title":"self-study-popup-module__header-title--jd3EJ","headerTitle":"self-study-popup-module__header-title--jd3EJ","grey-text":"self-study-popup-module__grey-text--AVy4A","greyText":"self-study-popup-module__grey-text--AVy4A","description":"self-study-popup-module__description--KiBgg","tasks":"self-study-popup-module__tasks--Pfaj_"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__self-study-popup/self-study-popup.component.tsx









const SelfStudyPopup = _ref => {
  let {
    tasks,
    header,
    date,
    description
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: self_study_popup_module.container,
    "data-testid": "self-study-popup",
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: self_study_popup_module.header,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: self_study_popup_module.headerTitle,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.headline4Accent,
          children: header
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, self_study_popup_module.greyText),
          children: date
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: self_study_popup_module.description,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(typography_module/* default */.Z.body2, self_study_popup_module.greyText),
          children: description
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: self_study_popup_module.tasks,
      children: tasks.map((task, index) => /* @__PURE__ */(0,jsx_runtime.jsx)(SelfStudyTask, {
        task,
        index
      }, task.text))
    })]
  });
};
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide-provider.tsx
var task_guide_provider = __webpack_require__(59206);
;// CONCATENATED MODULE: ./src/widgets/task-guide/__main-content-wrapper/self-study-list.tsx










const SelfStudyList = () => {
  const intl = (0,useIntl/* default */.Z)();
  const {
    addedTasksInCurrentLesson,
    handleClickTask,
    handleClickTaskIcon
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const mapTask = (0,react.useCallback)(task => ({
    onClick: () => {
      handleClickTask({
        taskId: task.id,
        motherTaskId: task.motherTaskId
      });
    },
    onClickIcon: () => {
      handleClickTaskIcon({
        taskId: task.id,
        motherTaskId: task.motherTaskId
      });
    },
    state: task.state,
    expanded: task.expanded,
    text: task.text
  }), [handleClickTask, handleClickTaskIcon]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(SelfStudyPopup, {
    tasks: addedTasksInCurrentLesson.map(mapTask),
    header: intl.formatMessage({
      id: "taskGuideMenu.selfStudy"
    }),
    description: intl.formatMessage({
      id: "taskGuide.modalDescription"
    }),
    date: (0,format/* format */.WU)((0,startOfToday/* startOfToday */.I)(), "dd LLLL yyyy")
  });
};

/***/ }),

/***/ 88008:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  s: () => (/* binding */ StudentTests),
  l: () => (/* binding */ StudentTestsEmpty)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../ui-kit/src/dropdown-with-items/dropdown-with-items.component.tsx + 1 modules
var dropdown_with_items_component = __webpack_require__(28402);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ./src/store/student-test/student-test-store.ts
var student_test_store = __webpack_require__(33870);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip_tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ./src/widgets/task-guide/student-tests/student-test-card/student-test-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const student_test_card_module = ({"block":"student-test-card-module__block--YQdpg","results":"student-test-card-module__results--q3Fjm","score":"student-test-card-module__score--NqED_","status":"student-test-card-module__status--ja2Iw","header-tooltip-icon":"student-test-card-module__header-tooltip-icon--v8w1H","headerTooltipIcon":"student-test-card-module__header-tooltip-icon--v8w1H","marker":"student-test-card-module__marker--Ag2fJ"});
;// CONCATENATED MODULE: ./src/widgets/task-guide/student-tests/student-test-card/student-test-card.tsx














const StudentTestCard = _ref => {
  let {
    id,
    name,
    scoreResult,
    maxResult,
    finishedDate,
    needNotifyTutor,
    tooltip,
    onResultClick
  } = _ref;
  const [tooltipVisible, setTooltipVisible] = (0,react.useState)(false);
  const resultClickHandler = (0,react.useCallback)(() => finishedDate && onResultClick(id), [id, finishedDate, onResultClick]);
  const score = (0,react.useMemo)(() => scoreResult && Object.values(scoreResult).length > 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(student_test_card_module.score, typography_module/* default */.Z.body2Accent),
    children: [Object.values(scoreResult).reduce((sum, score2) => sum + score2, 0), "/", Object.values(maxResult).reduce((sum, score2) => sum + score2, 0)]
  }), [maxResult, scoreResult]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: student_test_card_module.block,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("h3", {
      className: typography_module/* default */.Z.body2Accent,
      children: [name, " ", tooltip && /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip_tooltip/* Tooltip */.u, {
        autoWidth: true,
        trigger: "hover",
        fixed: true,
        placement: "top",
        overlay: tooltip,
        visible: tooltipVisible,
        onVisibleChange: setTooltipVisible,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: student_test_card_module.headerTooltipIcon,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: "info",
            size: "small"
          })
        })
      })]
    }), needNotifyTutor && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: student_test_card_module.marker
    }), score, /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(typography_module/* default */.Z.caption, student_test_card_module.status),
      children: finishedDate ? /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.tests.passed"
        }), " ", finishedDate?.toDateString()]
      }) : /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "taskGuide.tests.assigned"
      })
    }), finishedDate && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      className: student_test_card_module.results,
      appearance: "secondary",
      size: "small",
      onClick: resultClickHandler,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "taskGuide.tests.results"
      })
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/student-tests/student-tests-list/student-tests-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const student_tests_list_module = ({"root":"student-tests-list-module__root--S4WNR","tests-header-block":"student-tests-list-module__tests-header-block--oo_TY","testsHeaderBlock":"student-tests-list-module__tests-header-block--oo_TY","instruction":"student-tests-list-module__instruction--mTP6J","icon":"student-tests-list-module__icon--v94T9","paragraph":"student-tests-list-module__paragraph--LJipB","tests-date-group":"student-tests-list-module__tests-date-group--usCyf","testsDateGroup":"student-tests-list-module__tests-date-group--usCyf","date":"student-tests-list-module__date--tIqNb","tests-passed":"student-tests-list-module__tests-passed--yu3Eq","testsPassed":"student-tests-list-module__tests-passed--yu3Eq","center":"student-tests-list-module__center--Vu1OF","empty-block":"student-tests-list-module__empty-block--soRmS","emptyBlock":"student-tests-list-module__empty-block--soRmS"});
;// CONCATENATED MODULE: ./src/widgets/task-guide/student-tests/student-tests-list/student-tests-list.tsx























const StudentTestsInstruction = () => {
  const intl = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(typography_module/* default */.Z.body2, student_tests_list_module.instruction),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("details", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("summary", {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: student_tests_list_module.icon,
          name: "simple-arrow-right",
          size: "small"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.tests.instructionTitle"
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: intl.formatMessage({
          id: "taskGuide.tests.instruction"
        })
      })]
    })
  });
};
const StudentTestsList = _ref => {
  let {
    placementTest,
    tests
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const selectedTestResultIds = (0,student_test_store/* useStudentTestStore */.C)(state => state.selectedTestResultIds);
  const [filter, setFilter] = (0,react.useState)("assigned");
  const countPassedTests = (0,react.useMemo)(() => tests.filter(test => test.finishedDate).length, [tests]);
  const selectTestResult = (0,student_test_store/* useStudentTestStore */.C)(state => state.selectTestResult);
  const selectPlacementTestResultHanlder = (0,react.useCallback)(() => placementTest && selectTestResult(placementTest), [placementTest, selectTestResult]);
  const selectTestResultHanlder = (0,react.useCallback)(testId => {
    const test = tests.find(test2 => test2.id === testId);
    test && selectTestResult(test);
  }, [tests, selectTestResult]);
  const testList = (0,react.useMemo)(() => {
    const testsGroupedByDate = tests.sort((test1, test2) => test1.assignedDate.getTime() - test2.assignedDate.getTime()).reduce((result, test) => {
      const date = test.assignedDate.toDateString();
      if (!result[date]) {
        result[date] = {
          date: test.assignedDate,
          tests: []
        };
      }
      if (filter === "assigned" || filter === "passed" && test.finishedDate || filter === "newlyPassed" && test.needNotifyTutor && !selectedTestResultIds.includes(test.id)) {
        result[date].tests.push(test);
      }
      return result;
    }, {});
    return Object.values(testsGroupedByDate).map(_ref2 => {
      let {
        date,
        tests: tests2
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: student_tests_list_module.testsDateGroup,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.caption, student_tests_list_module.date),
          children: date.toDateString()
        }), tests2.map(test => /* @__PURE__ */(0,jsx_runtime.jsx)(StudentTestCard, {
          ...test,
          needNotifyTutor: test.needNotifyTutor && !selectedTestResultIds.includes(test.id),
          onResultClick: selectTestResultHanlder
        }, test.id))]
      }, date.toString());
    });
  }, [filter, selectedTestResultIds, tests, selectTestResultHanlder]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: student_tests_list_module.root,
    children: [placementTest && /* @__PURE__ */(0,jsx_runtime.jsx)(StudentTestCard, {
      ...placementTest,
      name: intl.formatMessage({
        id: "taskGuide.tests.placementTest.title"
      }),
      needNotifyTutor: placementTest.needNotifyTutor && !selectedTestResultIds.includes(placementTest.id),
      onResultClick: selectPlacementTestResultHanlder,
      tooltip: intl.formatMessage({
        id: "taskGuide.tests.placementTest.tip"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: student_tests_list_module.testsHeaderBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
        className: typography_module/* default */.Z.headline4Accent,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.tests.title"
        }), " ", /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
          className: student_tests_list_module.testsPassed,
          children: [intl.formatMessage({
            id: "taskGuide.tests.passed"
          }).toLowerCase(), " ", countPassedTests, "/", tests.length]
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_with_items_component/* DropdownWithItems */.MO, {
        activeItemId: filter,
        items: [{
          id: "assigned",
          label: intl.formatMessage({
            id: "taskGuide.tests.assigned"
          })
        }, {
          id: "passed",
          label: intl.formatMessage({
            id: "taskGuide.tests.passed"
          })
        }, {
          id: "newlyPassed",
          label: intl.formatMessage({
            id: "taskGuide.tests.newlyPassed"
          })
        }],
        renderItem: _ref3 => {
          let {
            label
          } = _ref3;
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            children: label
          });
        },
        onActiveItemChanged: setFilter,
        theme: dropdown_with_items_component/* DropdownWithItemsTheme */.lu.Squared
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentTestsInstruction, {}), testList]
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/student-tests/student-tests.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const student_tests_module = ({"root":"student-tests-module__root--zw9JM","tests-header-block":"student-tests-module__tests-header-block--awQ1o","testsHeaderBlock":"student-tests-module__tests-header-block--awQ1o","instruction":"student-tests-module__instruction--OmBl8","icon":"student-tests-module__icon--dZqay","paragraph":"student-tests-module__paragraph--JEJUN","tests-date-group":"student-tests-module__tests-date-group--DiOWI","testsDateGroup":"student-tests-module__tests-date-group--DiOWI","date":"student-tests-module__date--CgOag","tests-passed":"student-tests-module__tests-passed--0h0Qd","testsPassed":"student-tests-module__tests-passed--0h0Qd","center":"student-tests-module__center--AYer9","empty-block":"student-tests-module__empty-block--dYd7R","emptyBlock":"student-tests-module__empty-block--dYd7R"});
;// CONCATENATED MODULE: ./src/widgets/task-guide/student-tests/student-tests.tsx







const StudentTestsEmpty = () => /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
  className: student_tests_module.center,
  children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: student_tests_module.emptyBlock,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: student_tests_module.image,
      src: "https://flowstatic.s3.yandex.net/ui-files/task-guide-student-tests-empty.svg",
      alt: ""
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body1Accent,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "taskGuide.tests.empty"
      })
    })]
  })
});
const StudentTests = _ref => {
  let {
    testResults
  } = _ref;
  const {
    placementTest,
    tests
  } = testResults;
  if (!placementTest && tests.length === 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentTestsEmpty, {});
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentTestsList, {
    placementTest,
    tests
  });
};

/***/ }),

/***/ 30989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  V: () => (/* binding */ TaskGuideAppWrapper),
  A: () => (/* binding */ WithTaskGuideWrapper)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./src/models/task-guide/task-guide.model.ts
var task_guide_model = __webpack_require__(63054);
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide-provider.tsx
var task_guide_provider = __webpack_require__(59206);
// EXTERNAL MODULE: ./src/widgets/task-guide/__main-content-wrapper/self-study-list.tsx + 4 modules
var self_study_list = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/widgets/task-guide/task-guide.module.css
var task_guide_module = __webpack_require__(70057);
;// CONCATENATED MODULE: ./src/widgets/task-guide/__main-content-wrapper/main-content-wrapper.tsx










const TaskGuideMainContentWrapper = _ref => {
  let {
    children,
    className
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  const {
    buttonHandlers,
    lessonState
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  if (lessonState === task_guide_model/* TaskGuideFSMState */.ld.SelectingSelfStudy) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(className, task_guide_module/* default */.Z.assignSelfStudy),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(self_study_list/* SelfStudyList */.g, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_module/* default */.Z.finishLessonButton,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          appearance: "primary",
          size: "medium",
          onClick: buttonHandlers.finish,
          children: intl.formatMessage({
            id: "taskGuide.modalButtonText"
          })
        })
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/date-fns/addMinutes.mjs
var addMinutes = __webpack_require__(7300);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../ui-kit/src/button/button.model.ts
var button_model = __webpack_require__(63517);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/constants.ts
var constants = __webpack_require__(59496);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__menu/task-guide-menu.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_menu_module = ({"navigation-items":"task-guide-menu-module__navigation-items--rA3Yk","navigationItems":"task-guide-menu-module__navigation-items--rA3Yk","navigation-item":"task-guide-menu-module__navigation-item--Heepd","navigationItem":"task-guide-menu-module__navigation-item--Heepd","root":"task-guide-menu-module__root--Hk6BY","divider":"task-guide-menu-module__divider--t0Euu","bottom-controls":"task-guide-menu-module__bottom-controls--_F2G4","bottomControls":"task-guide-menu-module__bottom-controls--_F2G4","marker":"task-guide-menu-module__marker--smWe5"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__menu/task-guide-menu.component.tsx













var MenuItemType = /* @__PURE__ */(MenuItemType2 => {
  MenuItemType2["Icon"] = "icon";
  MenuItemType2["Text"] = "text";
  return MenuItemType2;
})(MenuItemType || {});
const TaskGuideMenu = _ref => {
  let {
    items,
    bottomLeftButtons,
    bottomRightButton
  } = _ref;
  const [tooltipVisible, setTooltipVisible] = (0,react.useState)(false);
  const handleRightButtonHover = (0,react.useCallback)(() => setTooltipVisible(true), []);
  const handleRightButtonBlur = (0,react.useCallback)(() => setTooltipVisible(false), []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: task_guide_menu_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: task_guide_menu_module.navigationItems,
      children: items.map((item, index) => {
        switch (item.type) {
          case "icon" /* Icon */:
            return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
              className: classnames_default()(task_guide_menu_module.navigationItem, item.showMarker && task_guide_menu_module.marker),
              "aria-label": item.ariaLabel,
              appearance: "secondary",
              state: item.selected ? constants/* ButtonIconState */._E.Hover : constants/* ButtonIconState */._E.Initial,
              size: "medium",
              iconName: item.iconName,
              onClick: item.action
            }, index);
          case "text" /* Text */:
            return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
              className: task_guide_menu_module.navigationItem,
              appearance: "secondary",
              size: "medium",
              state: item.selected ? button_model/* ButtonState */.BN.Hover : button_model/* ButtonState */.BN.Initial,
              onClick: item.action,
              children: item.text
            }, index);
          default:
            return null;
        }
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: task_guide_menu_module.divider
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: task_guide_menu_module.bottomControls,
      children: [bottomLeftButtons, /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
        overlay: bottomRightButton.tooltipText,
        visible: tooltipVisible && bottomRightButton.tooltipText !== void 0,
        placement: "top",
        autoWidth: true,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          onMouseEnter: handleRightButtonHover,
          onMouseLeave: handleRightButtonBlur,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: bottomRightButton.appearance,
            size: "small",
            onClick: bottomRightButton.onClick,
            disabled: bottomRightButton.isDisabled ?? false,
            children: bottomRightButton.text
          })
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/react-virtualized-auto-sizer/dist/index.esm.js
var index_esm = __webpack_require__(7688);
// EXTERNAL MODULE: ../../node_modules/react-window/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(8301);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__filter-pop-over/filter-pop-over.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const filter_pop_over_module = ({"block-for-pop-over":"filter-pop-over-module__block-for-pop-over--pH1EZ","blockForPopOver":"filter-pop-over-module__block-for-pop-over--pH1EZ","box":"filter-pop-over-module__box--OUIF7","arrow-margin":"filter-pop-over-module__arrow-margin--N59ZA","arrowMargin":"filter-pop-over-module__arrow-margin--N59ZA","expended-content":"filter-pop-over-module__expended-content--ZYXdZ","expendedContent":"filter-pop-over-module__expended-content--ZYXdZ","expended-content-white":"filter-pop-over-module__expended-content-white--tPYlm","expendedContentWhite":"filter-pop-over-module__expended-content-white--tPYlm","expended-content-medium":"filter-pop-over-module__expended-content-medium--cmDtQ","expendedContentMedium":"filter-pop-over-module__expended-content-medium--cmDtQ","expended-content-small":"filter-pop-over-module__expended-content-small--wVeVL","expendedContentSmall":"filter-pop-over-module__expended-content-small--wVeVL","line":"filter-pop-over-module__line--ytgwY","line-grey":"filter-pop-over-module__line-grey--qOsOQ","lineGrey":"filter-pop-over-module__line-grey--qOsOQ","main-line-small":"filter-pop-over-module__main-line-small--po5ZQ","mainLineSmall":"filter-pop-over-module__main-line-small--po5ZQ","main-line-medium":"filter-pop-over-module__main-line-medium--UE0Iq","mainLineMedium":"filter-pop-over-module__main-line-medium--UE0Iq","main-line-expended-state":"filter-pop-over-module__main-line-expended-state--kgXe_","mainLineExpendedState":"filter-pop-over-module__main-line-expended-state--kgXe_","expanded-line":"filter-pop-over-module__expanded-line--q3ipQ","expandedLine":"filter-pop-over-module__expanded-line--q3ipQ","expanded-line-medium":"filter-pop-over-module__expanded-line-medium--hn8sK","expandedLineMedium":"filter-pop-over-module__expanded-line-medium--hn8sK","expanded-line-small":"filter-pop-over-module__expanded-line-small--b3Ni1","expandedLineSmall":"filter-pop-over-module__expanded-line-small--b3Ni1","line-white":"filter-pop-over-module__line-white--Ny9nC","lineWhite":"filter-pop-over-module__line-white--Ny9nC"});
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__filter-pop-over/filter-pop-over.component.tsx















var Theme = /* @__PURE__ */(Theme2 => {
  Theme2["Grey"] = "grey";
  Theme2["Default"] = "white";
  return Theme2;
})(Theme || {});
var Size = /* @__PURE__ */(Size2 => {
  Size2["Small"] = "small";
  Size2["Medium"] = "medium";
  return Size2;
})(Size || {});
const FilterPopOver = _ref => {
  let {
    size = "medium" /* Medium */,
    theme = "white" /* Default */,
    variants,
    isOpen,
    selected,
    onSelect
  } = _ref;
  const selectedVariant = (0,react.useMemo)(() => variants.find(variant => variant.id === selected) ?? variants[0], [selected, variants]);
  const unselectedVariants = (0,react.useMemo)(() => variants.filter(variant => variant.id !== selected), [selected, variants]);
  const selectedVariantRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (selectedVariantRef.current) {
      selectedVariantRef.current.focus();
      selectedVariantRef.current.blur();
    }
  }, []);
  const renderVariants = (0,react.useCallback)(() => /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      ref: selectedVariantRef,
      className: classnames_default()(filter_pop_over_module.line, {
        [filter_pop_over_module.lineGrey]: theme === "grey" /* Grey */,
        [filter_pop_over_module.lineWhite]: theme === "white" /* Default */,
        [filter_pop_over_module.mainLineMedium]: size === "medium" /* Medium */,
        [filter_pop_over_module.mainLineSmall]: size === "small" /* Small */,
        [filter_pop_over_module.mainLineExpendedState]: isOpen
      }),
      onClick: event => {
        event.currentTarget.blur();
        return onSelect(selected);
      },
      "data-testid": "FilterPopOver",
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.captionAccent,
        children: selectedVariant.text
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: isOpen ? "simple-arrow-up" : "simple-arrow-down",
        size: "small",
        className: filter_pop_over_module.arrowMargin
      })]
    }), isOpen && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(filter_pop_over_module.expendedContent, {
        [filter_pop_over_module.expendedContentWhite]: theme === "white" /* Default */,
        [filter_pop_over_module.expendedContentMedium]: size === "medium" /* Medium */,
        [filter_pop_over_module.expendedContentSmall]: size === "small" /* Small */
      }),
      children: unselectedVariants.map(variant => /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classnames_default()(filter_pop_over_module.line, filter_pop_over_module.expandedLine, {
          [filter_pop_over_module.lineGrey]: theme === "grey" /* Grey */,
          [filter_pop_over_module.expandedLineMedium]: size === "medium" /* Medium */,
          [filter_pop_over_module.expandedLineSmall]: size === "small" /* Small */
        }),
        onClick: event => {
          event.currentTarget.blur();
          if (selectedVariantRef.current) {
            selectedVariantRef.current.focus();
            selectedVariantRef.current.blur();
          }
          return onSelect(variant.id);
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.captionAccent,
          children: variant.text
        })
      }, variant.id))
    })]
  }), [isOpen, onSelect, selected, selectedVariant.text, size, theme, unselectedVariants]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: filter_pop_over_module.blockForPopOver,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: filter_pop_over_module.box,
      children: renderVariants()
    })
  });
};
// EXTERNAL MODULE: ../ui-kit/src/input/input.component.tsx + 1 modules
var input_component = __webpack_require__(16455);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/constants.ts


const MENU_HEIGHT = 145;
const MODULE_SELECTOR_HEIGHT = 51;
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__self-study-list/task-guide-self-study-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_self_study_list_module = ({"task":"task-guide-self-study-list-module__task--ViUsa","grouped-tasks-container":"task-guide-self-study-list-module__grouped-tasks-container--DHKPH","groupedTasksContainer":"task-guide-self-study-list-module__grouped-tasks-container--DHKPH","group-title":"task-guide-self-study-list-module__group-title--cbxYJ","groupTitle":"task-guide-self-study-list-module__group-title--cbxYJ","header":"task-guide-self-study-list-module__header--U4dHe","with-search-bar":"task-guide-self-study-list-module__with-search-bar--cUYRC","withSearchBar":"task-guide-self-study-list-module__with-search-bar--cUYRC","search-icon-container":"task-guide-self-study-list-module__search-icon-container--Akn0D","searchIconContainer":"task-guide-self-study-list-module__search-icon-container--Akn0D","icon":"task-guide-self-study-list-module__icon--FsIm2","title":"task-guide-self-study-list-module__title--hc6YC","filter-container":"task-guide-self-study-list-module__filter-container--OcLBe","filterContainer":"task-guide-self-study-list-module__filter-container--OcLBe","nothing-found":"task-guide-self-study-list-module__nothing-found--QBXHj","nothingFound":"task-guide-self-study-list-module__nothing-found--QBXHj"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__self-study-list/task-guide-self-study-list.component.tsx






















var ListItemType = /* @__PURE__ */(ListItemType2 => {
  ListItemType2["Title"] = "title";
  ListItemType2["Task"] = "task";
  return ListItemType2;
})(ListItemType || {});
const TaskGuideSelfStudyList = _ref => {
  let {
    taskFilters,
    children,
    headerHeight
  } = _ref;
  const [selectedFilterId, setSelectedFilterId] = (0,react.useState)(0);
  const listRef = (0,react.useRef)(null);
  const [isOpen, setIsOpen] = (0,react.useState)(false);
  const handleChangeFilter = (0,react.useCallback)(id => {
    setSelectedFilterId(id);
    setIsOpen(prev => !prev);
    listRef.current?.resetAfterIndex(0);
  }, []);
  const [searchText, setSearchText] = (0,react.useState)("");
  const handleSearchChange = (0,react.useCallback)(e => {
    setSearchText(e.target.value);
    listRef.current?.resetAfterIndex(0);
  }, []);
  const [searchBarVisible, setSearchBarVisible] = (0,react.useState)(false);
  const showSearchBar = (0,react.useCallback)(() => {
    setSearchBarVisible(true);
  }, []);
  const hideSearchBar = (0,react.useCallback)(() => {
    setSearchBarVisible(false);
    setSearchText("");
    listRef.current?.resetAfterIndex(0);
  }, []);
  const listItems = (0,react.useMemo)(() => {
    const selectedFilter = taskFilters[selectedFilterId];
    return selectedFilter.groupedData.reduce((acc, group) => {
      const filteredTasks = searchText ? group.tasks.filter(task => task.text.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) : group.tasks;
      if (filteredTasks.length > 0) {
        acc.push({
          type: "title" /* Title */,
          title: group.title
        });
        acc.push(...filteredTasks.map(task => ({
          type: "task" /* Task */,
          task
        })));
      }
      return acc;
    }, []);
  }, [searchText, selectedFilterId, taskFilters]);
  const getItemSize = (0,react.useCallback)(index => {
    const item = listItems[index];
    const {
      type
    } = item;
    const MARGIN = 8;
    switch (type) {
      case "task" /* Task */:
        return 48 + MARGIN;
      case "title" /* Title */:
        return 16 + 24 + MARGIN;
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  }, [listItems]);
  const renderRaw = (0,react.useCallback)(params => {
    const item = params.data[params.index];
    const {
      type
    } = item;
    switch (type) {
      case "task" /* Task */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: task_guide_self_study_list_module.task,
              children: children({
                task: item.task
              })
            }, item.task.taskId)
          });
        }
      case "title" /* Title */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_self_study_list_module.groupTitle),
              children: item.title
            })
          });
        }
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  }, [children]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(task_guide_self_study_list_module.header, {
        [task_guide_self_study_list_module.withSearchBar]: searchBarVisible
      }),
      children: [searchBarVisible ? /* @__PURE__ */(0,jsx_runtime.jsx)(input_component/* Input */.II, {
        autoFocus: true,
        value: searchText,
        iconName: "search-light",
        placeholder: "Search on self study",
        inputSize: input_component/* InputSize */.fz.Small,
        onChange: handleSearchChange
      }) : /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: task_guide_self_study_list_module.filterContainer,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(FilterPopOver, {
            variants: taskFilters,
            onSelect: handleChangeFilter,
            selected: selectedFilterId,
            size: Size.Small,
            isOpen
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_self_study_list_module.title),
          children: "Self Study"
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_self_study_list_module.searchIconContainer,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          size: "small",
          appearance: "default",
          className: task_guide_self_study_list_module.icon,
          iconName: searchBarVisible ? "cross-bold" : "search-light",
          onClick: searchBarVisible ? hideSearchBar : showSearchBar
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      children: _ref2 => {
        let {
          height,
          width
        } = _ref2;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(dist_index_esm/* VariableSizeList */.S_, {
          ref: listRef,
          itemSize: getItemSize,
          height: height - MENU_HEIGHT - MODULE_SELECTOR_HEIGHT - headerHeight,
          itemCount: listItems.length,
          itemData: listItems,
          width,
          children: renderRaw
        });
      }
    }), listItems.length === 0 && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: task_guide_self_study_list_module.nothingFound,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
        className: typography_module/* default */.Z.body1Accent,
        children: "Nothing found"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
        className: typography_module/* default */.Z.body2,
        children: "Try to change filters or search text"
      })]
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/task-guide/__task/task-guide-task.component.tsx + 1 modules
var task_guide_task_component = __webpack_require__(95226);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/task-guide-layout.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_layout_module = ({"root":"task-guide-layout-module__root--PyEVM","header":"task-guide-layout-module__header--MlXHc","menu":"task-guide-layout-module__menu--Hrblr","menu-left-buttons":"task-guide-layout-module__menu-left-buttons--H0t6N","menuLeftButtons":"task-guide-layout-module__menu-left-buttons--H0t6N","skill":"task-guide-layout-module__skill--G47qy","content":"task-guide-layout-module__content--QQcoJ","mother-task":"task-guide-layout-module__mother-task--CqBoC","motherTask":"task-guide-layout-module__mother-task--CqBoC","progress-list":"task-guide-layout-module__progress-list--xwYwt","progressList":"task-guide-layout-module__progress-list--xwYwt"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/task-guide-layout.component.tsx







const TaskGuideLayout = _ref => {
  let {
    headerContent,
    menuItems,
    children,
    lessonStatusButton,
    hideTaskGuideButton,
    selectCourseButton,
    headerRef
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: task_guide_layout_module.root,
    children: [headerContent && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: headerRef,
      className: classnames_default()(typography_module/* default */.Z.body2, task_guide_layout_module.header),
      children: headerContent
    }), children, /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: task_guide_layout_module.menu,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideMenu, {
        items: menuItems,
        bottomLeftButtons: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: task_guide_layout_module.menuLeftButtons,
          children: [hideTaskGuideButton, selectCourseButton]
        }),
        bottomRightButton: lessonStatusButton
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/store/student-test/student-test-store.ts
var student_test_store = __webpack_require__(33870);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__class-list/class-list-types.ts


var class_list_types_ListItemType = /* @__PURE__ */(ListItemType2 => {
  ListItemType2["Title"] = "title";
  ListItemType2["Task"] = "task";
  return ListItemType2;
})(class_list_types_ListItemType || {});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/functions/get-item.ts






function getItem(item) {
  const HEADER_HEIGHT = 51;
  const MARGIN = 16;
  const MOTHER_TASK_HEIGHT = 128;
  if (item.type === class_list_types_ListItemType.Title) {
    return HEADER_HEIGHT + MARGIN;
  }
  if (item.type === class_list_types_ListItemType.Task && item.task.expanded) {
    const NOT_EXPANDED_TASK_HEIGHT = 48;
    const EXPANDED_TASK_HEIGHT = 320;
    const TASK_MARGIN = 14;
    const tasksHeight = item.task.tasks.reduce((acc, t) => {
      if (t.expanded && t.expendedContent) {
        acc += EXPANDED_TASK_HEIGHT;
      } else {
        acc += NOT_EXPANDED_TASK_HEIGHT;
      }
      acc += TASK_MARGIN;
      return acc;
    }, 0);
    const EXPANDED_MOTHER_TASK_HEIGHT = 203 + tasksHeight;
    return EXPANDED_MOTHER_TASK_HEIGHT + MARGIN;
  }
  return MOTHER_TASK_HEIGHT + MARGIN;
}
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__class-list/class-list.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const class_list_module = ({"header":"class-list-module__header--BEg7A","header-menu":"class-list-module__header-menu--LmCLF","headerMenu":"class-list-module__header-menu--LmCLF","header-item":"class-list-module__header-item--FUdJF","headerItem":"class-list-module__header-item--FUdJF","header-item-selected":"class-list-module__header-item-selected--tVTxK","headerItemSelected":"class-list-module__header-item-selected--tVTxK","header-wrapper":"class-list-module__header-wrapper--kUzd1","headerWrapper":"class-list-module__header-wrapper--kUzd1","hidden-badge":"class-list-module__hidden-badge--atdPq","hiddenBadge":"class-list-module__hidden-badge--atdPq","task":"class-list-module__task--m48ye","list-wrapper":"class-list-module__list-wrapper--nWSLW","listWrapper":"class-list-module__list-wrapper--nWSLW","header-chevron":"class-list-module__header-chevron--cDfTD","headerChevron":"class-list-module__header-chevron--cDfTD","header-title":"class-list-module__header-title--xdtq8","headerTitle":"class-list-module__header-title--xdtq8","module-title-highlighted":"class-list-module__module-title-highlighted--cQzL1","moduleTitleHighlighted":"class-list-module__module-title-highlighted--cQzL1","module-title":"class-list-module__module-title--gx_PU","moduleTitle":"class-list-module__module-title--gx_PU","empty-state-container":"class-list-module__empty-state-container--lFgPu","emptyStateContainer":"class-list-module__empty-state-container--lFgPu","empty-state-button":"class-list-module__empty-state-button--ENDk8","emptyStateButton":"class-list-module__empty-state-button--ENDk8","empty-state-text":"class-list-module__empty-state-text--pNl09","emptyStateText":"class-list-module__empty-state-text--pNl09"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__class-list/class-list.component.tsx













const ClassTasks = _ref => {
  let {
    children,
    items,
    emptyState,
    headerHeight
  } = _ref;
  const listRef = (0,react.useRef)(null);
  const getItemSize = (0,react.useCallback)(index => getItem(items[index]), [items]);
  const refreshList = index => {
    listRef.current?.resetAfterIndex(index);
  };
  const renderRaw = params => {
    const currentData = params.data[params.index];
    switch (currentData.type) {
      case class_list_types_ListItemType.Task:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: class_list_module.task,
              children: children({
                task: currentData.task,
                refreshList,
                index: params.index
              })
            })
          }, currentData.task.id);
        }
      case class_list_types_ListItemType.Title:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()(class_list_module.moduleTitle, typography_module/* default */.Z.captionAccent),
              children: currentData.title
            })
          }, `header_${currentData.title}`);
        }
      default:
        {
          return null;
        }
    }
  };
  if (items.length === 0) {
    return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: class_list_module.emptyStateContainer,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.headline3, class_list_module.emptyStateText),
        children: emptyState.textConstants.title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
        className: class_list_module.emptyStateButton,
        appearance: "primary",
        onClick: emptyState.onClickButton,
        children: emptyState.textConstants.buttonText
      })]
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
    children: _ref2 => {
      let {
        height,
        width
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(dist_index_esm/* VariableSizeList */.S_, {
        ref: listRef,
        itemSize: getItemSize,
        height: height - MENU_HEIGHT - headerHeight,
        itemCount: items.length,
        itemData: items,
        width,
        children: renderRaw
      });
    }
  });
};
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../ui-kit/src/task-guide/__mother-task/types.ts
var types = __webpack_require__(93018);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__mother-task/constants.ts



const navigationTabs = [{
  type: types/* NavigationTabType */.OI.Tasks,
  text: "Tasks"
}, {
  type: types/* NavigationTabType */.OI.InClass,
  text: "Language input"
}, {
  type: types/* NavigationTabType */.OI.SelfStudy,
  text: "Self study"
}];
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__mother-task/utils.ts



const getActionItems = state => {
  switch (state) {
    case types/* MotherTaskState */.eQ.InClass:
    case types/* MotherTaskState */.eQ.Initial:
    case types/* MotherTaskState */.eQ.InProgress:
      return {
        left: [{
          type: types/* ActionItemType */.x4.Expand
        }],
        right: [{
          type: types/* ActionItemType */.x4.Skip
        }]
      };
    case types/* MotherTaskState */.eQ.Done:
      return {
        left: [{
          type: types/* ActionItemType */.x4.Expand
        }],
        right: []
      };
    case types/* MotherTaskState */.eQ.Disabled:
      return {
        left: [{
          type: types/* ActionItemType */.x4.Expand
        }],
        right: [{
          type: types/* ActionItemType */.x4.Locked
        }]
      };
    case types/* MotherTaskState */.eQ.Skipped:
      return {
        left: [{
          type: types/* ActionItemType */.x4.Expand
        }],
        right: [{
          type: types/* ActionItemType */.x4.UnSkip
        }]
      };
    default:
      return {
        left: [],
        right: []
      };
  }
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__mother-task/task-guide-mother-task.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_mother_task_module = ({"root":"task-guide-mother-task-module__root--a256J","title-content":"task-guide-mother-task-module__title-content--Gqoso","titleContent":"task-guide-mother-task-module__title-content--Gqoso","root-done":"task-guide-mother-task-module__root-done--GiKr7","rootDone":"task-guide-mother-task-module__root-done--GiKr7","root-foreigner":"task-guide-mother-task-module__root-foreigner--HaMWB","rootForeigner":"task-guide-mother-task-module__root-foreigner--HaMWB","root-milestone":"task-guide-mother-task-module__root-milestone--QL9Sd","rootMilestone":"task-guide-mother-task-module__root-milestone--QL9Sd","title":"task-guide-mother-task-module__title--iCY37","mother-task-state-in-progress":"task-guide-mother-task-module__mother-task-state-in-progress--f0wOP","motherTaskStateInProgress":"task-guide-mother-task-module__mother-task-state-in-progress--f0wOP","mother-task-state-in-progress-foreigner":"task-guide-mother-task-module__mother-task-state-in-progress-foreigner--q0i1D","motherTaskStateInProgressForeigner":"task-guide-mother-task-module__mother-task-state-in-progress-foreigner--q0i1D","mother-task-state-in-progress-milestone":"task-guide-mother-task-module__mother-task-state-in-progress-milestone--bcJ6r","motherTaskStateInProgressMilestone":"task-guide-mother-task-module__mother-task-state-in-progress-milestone--bcJ6r","mother-task-state-done":"task-guide-mother-task-module__mother-task-state-done--nT3d1","motherTaskStateDone":"task-guide-mother-task-module__mother-task-state-done--nT3d1","mother-task-state-done-foreigner":"task-guide-mother-task-module__mother-task-state-done-foreigner--GCThR","motherTaskStateDoneForeigner":"task-guide-mother-task-module__mother-task-state-done-foreigner--GCThR","mother-task-state-done-mile-stone":"task-guide-mother-task-module__mother-task-state-done-mile-stone--gdB4b","motherTaskStateDoneMileStone":"task-guide-mother-task-module__mother-task-state-done-mile-stone--gdB4b","actions":"task-guide-mother-task-module__actions--EQnRi","close-button":"task-guide-mother-task-module__close-button--ACwFm","closeButton":"task-guide-mother-task-module__close-button--ACwFm","start-button":"task-guide-mother-task-module__start-button--frUsQ","startButton":"task-guide-mother-task-module__start-button--frUsQ","action-side-block":"task-guide-mother-task-module__action-side-block--EsFvl","actionSideBlock":"task-guide-mother-task-module__action-side-block--EsFvl","navigation-tabs":"task-guide-mother-task-module__navigation-tabs--Y8FSQ","navigationTabs":"task-guide-mother-task-module__navigation-tabs--Y8FSQ","navigation-tab":"task-guide-mother-task-module__navigation-tab--h6tnW","navigationTab":"task-guide-mother-task-module__navigation-tab--h6tnW","navigation-tab-selected":"task-guide-mother-task-module__navigation-tab-selected--JjnLz","navigationTabSelected":"task-guide-mother-task-module__navigation-tab-selected--JjnLz","tasks":"task-guide-mother-task-module__tasks--Lo5ob","task":"task-guide-mother-task-module__task--KbAMk","content":"task-guide-mother-task-module__content--yIon_","content-hidden":"task-guide-mother-task-module__content-hidden--wN7a_","contentHidden":"task-guide-mother-task-module__content-hidden--wN7a_","title-disabled":"task-guide-mother-task-module__title-disabled--qLfXC","titleDisabled":"task-guide-mother-task-module__title-disabled--qLfXC","button-with-icon":"task-guide-mother-task-module__button-with-icon--Zielp","buttonWithIcon":"task-guide-mother-task-module__button-with-icon--Zielp","button-with-icon-icon":"task-guide-mother-task-module__button-with-icon-icon--PjScC","buttonWithIconIcon":"task-guide-mother-task-module__button-with-icon-icon--PjScC","state-label-success":"task-guide-mother-task-module__state-label-success--uRXLy","stateLabelSuccess":"task-guide-mother-task-module__state-label-success--uRXLy","state-label-hidden":"task-guide-mother-task-module__state-label-hidden--o83Pg","stateLabelHidden":"task-guide-mother-task-module__state-label-hidden--o83Pg","state-label":"task-guide-mother-task-module__state-label--rHYnQ","stateLabel":"task-guide-mother-task-module__state-label--rHYnQ"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__mother-task/task-guide-mother-task.component.tsx

















const TaskGuideMotherTask = _ref => {
  let {
    id,
    state,
    onExpand = function_utils/* emptyFunction */.Bi,
    onSkip = function_utils/* emptyFunction */.Bi,
    onUnSkip = function_utils/* emptyFunction */.Bi,
    expanded = false,
    selectedNavigationTabType = types/* NavigationTabType */.OI.Tasks,
    onSelectNavigationTab,
    title,
    type = types/* MotherTaskType */.Dw.Default,
    children,
    onClickLabel,
    hideTaskNavigationTab = false
  } = _ref;
  const [isHovered, setIsHovered] = (0,react.useState)(false);
  const handleClickLabel = (0,react.useCallback)(() => onClickLabel?.(id), [id, onClickLabel]);
  const renderActionItem = (item, index) => {
    switch (item.type) {
      case types/* ActionItemType */.x4.AddInLesson:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          className: task_guide_mother_task_module.closeButton,
          appearance: "secondary",
          size: "medium",
          iconName: "plus"
        }, index);
      case types/* ActionItemType */.x4.Skip:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
          className: task_guide_mother_task_module.buttonWithIcon,
          appearance: "secondary",
          size: "medium",
          onClick: () => onSkip(id),
          children: ["Skip", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            className: task_guide_mother_task_module.buttonWithIconIcon,
            name: "skip",
            size: "medium"
          })]
        }, index) : null;
      case types/* ActionItemType */.x4.UnSkip:
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
          className: task_guide_mother_task_module.buttonWithIcon,
          appearance: "secondary",
          size: "medium",
          onClick: () => onUnSkip(id),
          children: ["Unskip", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            className: task_guide_mother_task_module.buttonWithIconIcon,
            name: "reset",
            size: "medium"
          })]
        }, index);
      case types/* ActionItemType */.x4.Locked:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: task_guide_mother_task_module.buttonWithIcon,
          appearance: "secondary",
          size: "medium",
          children: "Locked"
        }, index);
      case types/* ActionItemType */.x4.Expand:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          onClick: () => onExpand(id),
          "aria-label": expanded ? "shrink-button" : "expand-button",
          appearance: "secondary",
          size: "medium",
          iconName: expanded ? "chevron-up" : "chevron-down"
        }, index);
      case types/* ActionItemType */.x4.OpenLesson:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            size: "medium",
            appearance: "secondary",
            children: "In lesson"
          }, index);
        }
      case types/* ActionItemType */.x4.RemoveFromLesson:
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            size: "medium",
            appearance: "secondary",
            children: "In lesson"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            className: task_guide_mother_task_module.closeButton,
            appearance: "secondary",
            size: "medium",
            iconName: "cross"
          })]
        }, index);
      case types/* ActionItemType */.x4.Start:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          className: task_guide_mother_task_module.startButton,
          appearance: "primary",
          size: "medium",
          children: "Start"
        }, index);
      default:
        return null;
    }
  };
  const getInProgressLabel = () => {
    switch (type) {
      case types/* MotherTaskType */.Dw.Default:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_mother_task_module.motherTaskStateInProgress),
          children: "Review"
        });
      case types/* MotherTaskType */.Dw.Foreigner:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_mother_task_module.motherTaskStateInProgressForeigner),
          children: "Started"
        });
      case types/* MotherTaskType */.Dw.Milestone:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_mother_task_module.motherTaskStateInProgressMilestone),
          children: "Started"
        });
      default:
        return null;
    }
  };
  const getDoneLabel = () => {
    switch (type) {
      case types/* MotherTaskType */.Dw.Milestone:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_mother_task_module.motherTaskStateDoneMileStone),
          children: "Done"
        });
      case types/* MotherTaskType */.Dw.Foreigner:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_mother_task_module.motherTaskStateDoneForeigner),
          children: "Done"
        });
      case types/* MotherTaskType */.Dw.Default:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_mother_task_module.motherTaskStateDone),
          children: "Done"
        });
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  };
  const renderTaskStateLabel = () => {
    switch (state) {
      case types/* MotherTaskState */.eQ.Initial:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          size: "small",
          appearance: "secondary",
          onClick: handleClickLabel,
          className: task_guide_mother_task_module.stateLabel,
          children: "Add to class"
        }) : null;
      case types/* MotherTaskState */.eQ.InClass:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          size: "small",
          appearance: "secondary",
          onClick: handleClickLabel,
          className: classnames_default()(typography_module/* default */.Z.captionAccent, task_guide_mother_task_module.stateLabel),
          children: "Remove"
        }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(typography_module/* default */.Z.captionAccent, task_guide_mother_task_module.stateLabelSuccess, task_guide_mother_task_module.stateLabel),
          children: "In Class"
        });
      case types/* MotherTaskState */.eQ.Done:
        return getDoneLabel();
      case types/* MotherTaskState */.eQ.InProgress:
        return getInProgressLabel();
      default:
        return null;
    }
  };
  const actionItems = getActionItems(state);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    "data-syllabus-mother-task-id": id,
    onMouseOver: () => {
      if (expanded) {
        return;
      }
      setIsHovered(true);
    },
    onMouseLeave: () => {
      if (expanded) {
        return;
      }
      setIsHovered(false);
    },
    className: classnames_default()(task_guide_mother_task_module.root, {
      [task_guide_mother_task_module.rootDone]: state === types/* MotherTaskState */.eQ.Done && type === types/* MotherTaskType */.Dw.Default,
      [task_guide_mother_task_module.rootForeigner]: type === types/* MotherTaskType */.Dw.Foreigner,
      [task_guide_mother_task_module.rootMilestone]: type === types/* MotherTaskType */.Dw.Milestone
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(typography_module/* default */.Z.headline4Accent, task_guide_mother_task_module.title, {
        [task_guide_mother_task_module.titleDisabled]: state === types/* MotherTaskState */.eQ.Disabled
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(task_guide_mother_task_module.titleContent, typography_module/* default */.Z.body1Accent),
        children: title
      }), renderTaskStateLabel()]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(task_guide_mother_task_module.content, {
        [task_guide_mother_task_module.contentHidden]: !expanded
      }),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_mother_task_module.navigationTabs,
        children: navigationTabs.map(navigationTab => hideTaskNavigationTab && navigationTab.type === types/* NavigationTabType */.OI.Tasks ? null : /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: classnames_default()(task_guide_mother_task_module.navigationTab, typography_module/* default */.Z.body2Accent, {
            [task_guide_mother_task_module.navigationTabSelected]: navigationTab.type === selectedNavigationTabType
          }),
          onClick: () => onSelectNavigationTab(navigationTab.type),
          children: navigationTab.text
        }, navigationTab.text))
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_mother_task_module.tasks,
        children
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: task_guide_mother_task_module.actions,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_mother_task_module.actionSideBlock,
        children: actionItems.left.map(renderActionItem)
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_mother_task_module.actionSideBlock,
        children: actionItems.right.map(renderActionItem)
      })]
    })]
  }, id);
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-task-guide-layout-size-context.tsx



const LayoutSizeContext = (0,react.createContext)({
  headerHeight: 0
});
const useTaskGuideLayoutSizeContext = () => (0,react.useContext)(LayoutSizeContext);
;// CONCATENATED MODULE: ./src/widgets/task-guide/__class-tasks/useClassTasksViewModel.ts














const useClassTasksViewModel = () => {
  const taskGuideService = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const items = (0,react.useMemo)(() => {
    const visibleMotherTaskStates = [types/* MotherTaskState */.eQ.InClass, types/* MotherTaskState */.eQ.InProgress];
    return taskGuideService.orderedModules.reduce((acc, module) => {
      const notDoneMotherTasks = module.motherTasks.filter(motherTask => visibleMotherTaskStates.includes(motherTask.state));
      if (notDoneMotherTasks.length) {
        acc.push({
          type: class_list_types_ListItemType.Title,
          title: module.title
        }, ...notDoneMotherTasks.map(motherTask => ({
          type: class_list_types_ListItemType.Task,
          task: motherTask
        })));
      }
      return acc;
    }, []);
  }, [taskGuideService.orderedModules]);
  return {
    onExpandMotherTask: taskGuideService.onExpandMotherTask,
    selectNavigationTab: taskGuideService.selectNavigationTab,
    handleClickTask: taskGuideService.handleClickTask,
    handleSkipMotherTask: taskGuideService.handleSkipMotherTask,
    handleUnSkipMotherTask: taskGuideService.handleUnSkipMotherTask,
    handleClickTaskIcon: taskGuideService.handleClickTaskIcon,
    currentSpeakingSession: taskGuideService.currentSpeakingSession,
    handleMotherTaskStateLabelClick: taskGuideService.handleMotherTaskStateLabelClick,
    viewModel: {
      items
    }
  };
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/__class-tasks/class-tasks.component.tsx














const ClassTasksWidget = _ref => {
  let {
    onClickEmptyStateButton
  } = _ref;
  const {
    onExpandMotherTask,
    selectNavigationTab,
    handleClickTask,
    handleSkipMotherTask,
    handleUnSkipMotherTask,
    handleClickTaskIcon,
    currentSpeakingSession,
    handleMotherTaskStateLabelClick,
    viewModel
  } = useClassTasksViewModel();
  const intl = (0,useIntl/* default */.Z)();
  const {
    headerHeight
  } = useTaskGuideLayoutSizeContext();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ClassTasks, {
    headerHeight,
    items: viewModel.items,
    emptyState: {
      onClickButton: onClickEmptyStateButton,
      textConstants: {
        buttonText: intl.formatMessage({
          id: "taskGuide.classTasks.emptyState.button"
        }),
        title: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "taskGuide.classTasks.emptyState.title",
          values: {
            br: /* @__PURE__ */(0,jsx_runtime.jsx)("br", {})
          }
        })
      }
    },
    children: _ref2 => {
      let {
        task: currentData,
        refreshList,
        index
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideMotherTask, {
        id: currentData.id,
        state: currentData.state,
        title: currentData.title,
        expanded: currentData.expanded,
        selectedNavigationTabType: currentData.selectedNavigationTabType,
        type: currentData.type,
        onClickLabel: () => handleMotherTaskStateLabelClick({
          motherTaskId: currentData.id
        }),
        onSelectNavigationTab: tab => {
          selectNavigationTab(currentData.id, tab);
          refreshList(index);
        },
        onUnSkip: () => {
          handleUnSkipMotherTask({
            motherTaskId: currentData.id
          });
          refreshList(index);
        },
        onSkip: () => {
          handleSkipMotherTask({
            motherTaskId: currentData.id
          });
          refreshList(index);
        },
        onExpand: () => {
          onExpandMotherTask(currentData.id);
          refreshList(index);
        },
        hideTaskNavigationTab: currentData.hideTaskNavigationTab,
        children: currentData.tasks.map(task => {
          const isReadOnly = currentSpeakingSession?.speakingSession.state !== speakingSession_model/* SpeakingSessionState */.Z.InProgress && task.type !== types/* TaskType */.UA.SelfStudy;
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            "data-syllabus-task-id": task.id,
            className: task_guide_module/* default */.Z.task,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(task_guide_task_component/* TaskGuideTask */.s, {
              state: task.state,
              isReadOnly,
              expanded: task.expanded,
              text: task.text,
              expendedContent: task.expendedContent,
              onClick: () => {
                handleClickTask({
                  taskId: task.id,
                  motherTaskId: currentData.id
                });
                refreshList(index);
              },
              onClickIcon: () => {
                handleClickTaskIcon({
                  taskId: task.id,
                  motherTaskId: currentData.id
                });
                if (currentData.state === types/* MotherTaskState */.eQ.Initial) {
                  refreshList(0);
                }
                refreshList(index);
              }
            })
          }, task.id);
        })
      });
    }
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/__hide-button/hide-button.component.tsx








const TaskGuideHideButton = () => {
  const [tooltipVisible, setTooltipVisible] = (0,react.useState)(false);
  const {
    toggleTaskGuideVisibility
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    overlay: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
      id: "taskGuide.hideButton.hide"
    }),
    placement: "top",
    trigger: "hover",
    visible: tooltipVisible,
    onVisibleChange: setTooltipVisible,
    align: {
      points: ["bl", "tl"]
    },
    smallOverlay: true,
    autoWidth: true,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      iconName: "hide-left",
      onClick: toggleTaskGuideVisibility,
      size: "small",
      appearance: "secondary"
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/badge/badge.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const badge_module = ({"badge":"badge-module__badge--XZJBh","small":"badge-module__small--PAq1E","circle":"badge-module__circle--aeAnq","success":"badge-module__success--DjwS1","error":"badge-module__error--OjhIn","dark":"badge-module__dark--ht1Fs"});
;// CONCATENATED MODULE: ../ui-kit/src/badge/badge.component.tsx






const Badge = _ref => {
  let {
    children,
    type = "default",
    isCircle = false,
    size = "small"
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    className: classnames_default()(badge_module.badge, typography_module/* default */.Z.captionAccent, {
      [badge_module.error]: type === "error",
      [badge_module.success]: type === "success",
      [badge_module.small]: size === "small",
      [badge_module.dark]: type === "dark",
      [badge_module.circle]: isCircle
    }),
    children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__header/task-guide-header.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_header_module = ({"root":"task-guide-header-module__root--fY3f7","item":"task-guide-header-module__item--SY_6M","item-selected":"task-guide-header-module__item-selected--EzBOb","itemSelected":"task-guide-header-module__item-selected--EzBOb","content":"task-guide-header-module__content--PE67M"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__header/task-guide-header.component.tsx








const TaskGuideHeader = _ref => {
  let {
    items
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: task_guide_header_module.root,
    children: items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      type: "button",
      className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_header_module.item, {
        [task_guide_header_module.itemSelected]: item.selected
      }),
      onClick: item.onClick,
      children: item.title
    }, item.title))
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__library/task-guide-library.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_library_module = ({"header":"task-guide-library-module__header--hWGwC","header-menu":"task-guide-library-module__header-menu--gh789","headerMenu":"task-guide-library-module__header-menu--gh789","header-item":"task-guide-library-module__header-item--_cZpH","headerItem":"task-guide-library-module__header-item--_cZpH","header-item-selected":"task-guide-library-module__header-item-selected--NjyxU","headerItemSelected":"task-guide-library-module__header-item-selected--NjyxU","header-wrapper":"task-guide-library-module__header-wrapper--ICrO6","headerWrapper":"task-guide-library-module__header-wrapper--ICrO6","hidden-badge":"task-guide-library-module__hidden-badge--HuxIY","hiddenBadge":"task-guide-library-module__hidden-badge--HuxIY","task":"task-guide-library-module__task--QNEo5","list-wrapper":"task-guide-library-module__list-wrapper--YjGec","listWrapper":"task-guide-library-module__list-wrapper--YjGec","header-chevron":"task-guide-library-module__header-chevron--SXFrZ","headerChevron":"task-guide-library-module__header-chevron--SXFrZ","header-title":"task-guide-library-module__header-title--F7dhI","headerTitle":"task-guide-library-module__header-title--F7dhI","module-title-highlighted":"task-guide-library-module__module-title-highlighted--MwaN1","moduleTitleHighlighted":"task-guide-library-module__module-title-highlighted--MwaN1"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__library/task-guide-library.component.tsx





















var task_guide_library_component_ListItemType = /* @__PURE__ */(ListItemType2 => {
  ListItemType2["Title"] = "title";
  ListItemType2["Task"] = "task";
  return ListItemType2;
})(task_guide_library_component_ListItemType || {});
const TaskGuideLibrary = _ref => {
  let {
    children,
    modules,
    selectedModuleId,
    onSelect,
    headerHeight
  } = _ref;
  const listRef = (0,react.useRef)(null);
  const [isVisible, setIsVisible] = (0,react.useState)(false);
  const listItems = (0,react.useMemo)(() => {
    const selectedModule = modules.get(selectedModuleId);
    if (!selectedModule) {
      return [];
    }
    return selectedModule.tasks.map(task => ({
      type: "task" /* Task */,
      task
    }), []);
  }, [modules, selectedModuleId]);
  const getItemSize = (0,react.useCallback)(index => getItem(listItems[index]), [listItems]);
  const refreshList = (0,react.useCallback)(index => {
    listRef.current?.resetAfterIndex(index);
  }, [listRef]);
  const renderRaw = (0,react.useCallback)(params => {
    const currentData = params.data[params.index];
    switch (currentData.type) {
      case "task" /* Task */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: task_guide_library_module.task,
              children: children({
                task: currentData.task,
                refreshList,
                index: params.index
              })
            })
          }, currentData.task.id);
        }
      case "title" /* Title */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideHeader, {
              items: [{
                title: currentData.title,
                selected: true,
                onClick: function_utils/* emptyFunction */.Bi
              }]
            })
          }, `header_${currentData.title}`);
        }
      default:
        {
          return null;
        }
    }
  }, [children, refreshList]);
  const currentModuleTitle = (0,react.useMemo)(() => modules.get(selectedModuleId)?.title, [modules, selectedModuleId]);
  const trimHeight = (0,react.useMemo)(() => MENU_HEIGHT + MODULE_SELECTOR_HEIGHT + headerHeight, [headerHeight]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [isVisible && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: task_guide_library_module.headerWrapper
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: task_guide_library_module.header,
      "data-testid": "module-selector",
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
        type: "button",
        onClick: () => setIsVisible(prev => !prev),
        className: classnames_default()(task_guide_library_module.headerItem, task_guide_library_module.headerItemSelected, typography_module/* default */.Z.body2Accent),
        "data-syllabus-module-id": selectedModuleId,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(task_guide_library_module.headerTitle, {
            [task_guide_library_module.moduleTitleHighlighted]: modules.get(selectedModuleId)?.highlighted
          }),
          children: currentModuleTitle ?? "Select module"
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
          className: task_guide_library_module.headerChevron,
          name: isVisible ? "chevron-up" : "chevron-down",
          size: "small"
        })]
      }), isVisible && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_library_module.headerMenu,
        style: {
          maxHeight: `calc(100vh - ${trimHeight}px)`
        },
        children: Array.from(modules.values()).sort((a, b) => a.order - b.order).map(m => {
          const numberOfActiveTasks = m.tasks.filter(t => [types/* MotherTaskState */.eQ.InProgress, types/* MotherTaskState */.eQ.InClass].includes(t.state)).length;
          if (m.id === selectedModuleId) {
            return null;
          }
          return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
            type: "button",
            onClick: () => {
              setIsVisible(false);
              refreshList(0);
              return onSelect(m.id);
            },
            className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_library_module.headerItem),
            "data-syllabus-module-id": m.id,
            children: [numberOfActiveTasks ? /* @__PURE__ */(0,jsx_runtime.jsx)(Badge, {
              type: "dark",
              isCircle: true,
              children: numberOfActiveTasks
            }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: task_guide_library_module.hiddenBadge,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(Badge, {
                type: "default",
                isCircle: true,
                children: numberOfActiveTasks
              })
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()({
                [task_guide_library_module.moduleTitleHighlighted]: m.highlighted
              }),
              children: m.title
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: task_guide_library_module.hiddenBadge,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(Badge, {
                type: "default",
                isCircle: true,
                children: numberOfActiveTasks
              })
            })]
          }, m.id);
        })
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      children: _ref2 => {
        let {
          height,
          width
        } = _ref2;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(dist_index_esm/* VariableSizeList */.S_, {
          ref: listRef,
          itemSize: getItemSize,
          height: height - trimHeight - 16,
          itemCount: listItems.length,
          itemData: listItems,
          width,
          children: renderRaw
        });
      }
    })]
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/__library/library-tasks.component.tsx














const LibraryWidget = (0,react.memo)(function LibraryWidget2() {
  const {
    onExpandMotherTask,
    selectNavigationTab,
    handleClickTask,
    handleSkipMotherTask,
    handleUnSkipMotherTask,
    handleClickTaskIcon,
    inLessonsModules,
    currentSpeakingSession,
    selectedModuleId,
    setSelectedModuleId,
    handleMotherTaskStateLabelClick
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const {
    headerHeight
  } = useTaskGuideLayoutSizeContext();
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideLibrary, {
    onSelect: moduleId => setSelectedModuleId({
      moduleId
    }),
    modules: inLessonsModules,
    selectedModuleId: selectedModuleId || Array.from(inLessonsModules.keys())[0],
    headerHeight,
    children: _ref => {
      let {
        task: currentData,
        refreshList,
        index
      } = _ref;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideMotherTask, {
        id: currentData.id,
        state: currentData.state,
        title: currentData.title,
        expanded: currentData.expanded,
        selectedNavigationTabType: currentData.selectedNavigationTabType,
        type: currentData.type,
        onClickLabel: () => handleMotherTaskStateLabelClick({
          motherTaskId: currentData.id
        }),
        onSelectNavigationTab: tab => {
          selectNavigationTab(currentData.id, tab);
          refreshList(index);
        },
        onUnSkip: () => {
          handleUnSkipMotherTask({
            motherTaskId: currentData.id
          });
          refreshList(index);
        },
        onSkip: () => {
          handleSkipMotherTask({
            motherTaskId: currentData.id
          });
          refreshList(index);
        },
        onExpand: () => {
          onExpandMotherTask(currentData.id);
          refreshList(index);
        },
        hideTaskNavigationTab: currentData.hideTaskNavigationTab,
        children: currentData.tasks.map(task => {
          const isReadOnly = currentSpeakingSession?.speakingSession.state !== speakingSession_model/* SpeakingSessionState */.Z.InProgress && task.type !== types/* TaskType */.UA.SelfStudy;
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            "data-syllabus-task-id": task.id,
            className: task_guide_module/* default */.Z.task,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(task_guide_task_component/* TaskGuideTask */.s, {
              state: task.state,
              isReadOnly,
              expanded: task.expanded,
              text: task.text,
              expendedContent: task.expendedContent,
              onClick: () => {
                handleClickTask({
                  taskId: task.id,
                  motherTaskId: currentData.id
                });
                refreshList(index);
              },
              onClickIcon: () => {
                handleClickTaskIcon({
                  taskId: task.id,
                  motherTaskId: currentData.id
                });
                if (currentData.state === types/* MotherTaskState */.eQ.Initial) {
                  refreshList(0);
                }
                refreshList(index);
              }
            })
          }, task.id);
        })
      });
    }
  });
});
;// CONCATENATED MODULE: ../shared/src/utils/namespace-constructor.ts


function nsCtor(namespace) {
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".";
  return function (strings) {
    let key;
    if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 0) {
      key = "";
      for (let i = 0; i < strings.length; i++) {
        const value = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];
        const str = strings[i];
        key += `${str || ""}${value != null ? value : ""}`;
      }
    } else {
      [key] = strings;
    }
    return `${namespace}${separator}${key}`;
  };
}
// EXTERNAL MODULE: ../ui-kit/src/deprecated-modal/deprecated-modal.component.tsx + 1 modules
var deprecated_modal_component = __webpack_require__(49159);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../../node_modules/react-dropzone/dist/es/index.js + 4 modules
var es = __webpack_require__(23083);
// EXTERNAL MODULE: ../ui-kit/src/input-depricated/input-depricated.component.tsx + 1 modules
var input_depricated_component = __webpack_require__(54157);
// EXTERNAL MODULE: ../ui-kit/src/new-card/__content/card-content.component.tsx
var card_content_component = __webpack_require__(31533);
// EXTERNAL MODULE: ../ui-kit/src/new-card/card.component.tsx + 1 modules
var card_component = __webpack_require__(84435);
// EXTERNAL MODULE: ../ui-kit/src/picture/picture.component.tsx + 1 modules
var picture_component = __webpack_require__(33364);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__notes/__note-input/text-area/text-area.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_area_module = ({"box":"text-area-module__box--BD3i0","buttons":"text-area-module__buttons--Icokj","box-btn-hover":"text-area-module__box-btn-hover--nmn3Y","boxBtnHover":"text-area-module__box-btn-hover--nmn3Y","button":"text-area-module__button--XZ98U","files":"text-area-module__files--vdf_a"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__notes/__note-input/text-area/text-area.component.tsx














var TextAreaFileState = /* @__PURE__ */(TextAreaFileState2 => {
  TextAreaFileState2["Loaded"] = "loaded";
  TextAreaFileState2["Loading"] = "loading";
  TextAreaFileState2["Error"] = "error";
  return TextAreaFileState2;
})(TextAreaFileState || {});
const TaskGuideTextArea = _ref => {
  let {
    value,
    readOnly,
    onValueChange,
    withButtons,
    buttons,
    context,
    files,
    onFileCloseClick
  } = _ref;
  const mapCardState = fileState => {
    switch (fileState) {
      case "loaded" /* Loaded */:
        return card_content_component/* CardState */.WF.Loaded;
      case "loading" /* Loading */:
        return card_content_component/* CardState */.WF.Loading;
      case "error" /* Error */:
        return card_content_component/* CardState */.WF.Error;
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(fileState);
    }
  };
  const handleChangeValue = (0,react.useCallback)(value2 => {
    onValueChange(value2);
  }, [onValueChange]);
  const isInputVisible = readOnly ? Boolean(value) : true;
  const renderFiles = (0,react.useCallback)(() => {
    if (!files || files?.length === 0) {
      return null;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: text_area_module.files,
      children: files.map(file => {
        const handleCloseButtonClick = () => {
          if (onFileCloseClick) {
            onFileCloseClick(file.id);
          }
        };
        return /* @__PURE__ */(0,jsx_runtime.jsx)(card_component/* Card */.Zb, {
          id: file.id,
          state: mapCardState(file.state),
          appearance: {
            size: card_component/* CardSize */.Id.Small
          },
          errorText: "loading error",
          closeButton: {
            appearance: "secondaryFloating",
            onClick: handleCloseButtonClick
          },
          childrenType: card_content_component/* ChildrenType */.L5.Box,
          children: file.src ? /* @__PURE__ */(0,jsx_runtime.jsx)(picture_component/* Picture */.t, {
            src: file.src
          }) : /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            name: "notes",
            size: "medium"
          })
        }, file.id);
      })
    });
  }, [files, onFileCloseClick]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(text_area_module.box, {
      [text_area_module.boxBtnHover]: readOnly
    }),
    children: [isInputVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(input_depricated_component/* InputDeprecated */.tI, {
      size: input_depricated_component/* InputSize */.fz.Small,
      value,
      readOnly,
      onChange: handleChangeValue,
      inputStyle: input_depricated_component/* InputStyle */.x2.White,
      placeholder: context.placeholderText,
      multiline: true,
      disableResize: true,
      height: input_depricated_component/* InputHeight */.ac.Auto,
      withoutBorder: true,
      withoutPaddings: true
    }), renderFiles(), withButtons && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: text_area_module.buttons,
      children: buttons.map((button, index) => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: text_area_module.button,
        children: button
      }, index))
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__notes/__note-input/note-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const note_input_module = ({"note":"note-input-module__note--i7pl_"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__notes/__note-input/note-input.component.tsx


















const fileAccept = "image/jpeg, image/png";
const TaskGuideNoteInput = _ref => {
  let {
    attachments,
    readOnly,
    textConstants,
    onFileCloseClick,
    onCancelEditClick,
    text,
    onDrop,
    onChangeNoteText,
    isSendBtnLoading,
    isSendBtnDisabled,
    isSendBtnVisible,
    isEditBtnVisible,
    isEditBtnDisabled,
    isRemoveBtnDisabled,
    isRemoveBtnVisible,
    isCancelEditBtnVisible,
    isCancelEditBtnDisabled,
    isUploadAttachmentBtnDisabled,
    isUploadAttachmentBtnVisible,
    onEditClick,
    onSendClick,
    onRemoveClick,
    reloadFile
  } = _ref;
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps
  } = (0,es/* useDropzone */.u)({
    accept: fileAccept
  });
  const onDropHandler = (acceptedFiles2, _fileRejections) => {
    onDrop(acceptedFiles2.reduce((result, file) => {
      const isImage = file.type === "image/png" || file.type === "image/jpeg";
      if (isImage) {
        result.push({
          placeholderSrc: URL.createObjectURL(file),
          file
        });
      }
      return result;
    }, []));
  };
  const buttons = [isRemoveBtnVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    appearance: "secondary",
    size: "small",
    onClick: onRemoveClick,
    "aria-label": textConstants.removeBtnAriaLabel,
    disabled: isRemoveBtnDisabled,
    children: textConstants.removeBtnLabel
  }, "taskGuideNoteInputRemoveBtn"), isCancelEditBtnVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
    appearance: "secondary",
    size: "small",
    onClick: onCancelEditClick,
    iconName: "cross",
    disabled: isCancelEditBtnDisabled,
    "aria-label": textConstants.cancelEditBtnAriaLabel
  }, "taskGuideNoteInputCancelEditBtn"), isUploadAttachmentBtnVisible && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ...getRootProps({
      onDrop: () => {
        onDropHandler(acceptedFiles, fileRejections);
      }
    }),
    tabIndex: void 0,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      ...getInputProps(),
      "aria-label": textConstants.noteInputLabel,
      onChange: event => {
        onDropHandler(Array.from(event.currentTarget.files ?? []), []);
      },
      disabled: isUploadAttachmentBtnDisabled
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
      appearance: "secondary",
      size: "small",
      onClick: function_utils/* emptyFunction */.Bi,
      iconName: "clip",
      disabled: isUploadAttachmentBtnDisabled,
      "aria-label": textConstants.attachmentBtnAriaLabel
    })]
  }, "taskGuideNoteInputClipContainer"), isSendBtnVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    appearance: "secondary",
    size: "small",
    onClick: onSendClick,
    "aria-label": textConstants.sendBtnAriaLabel,
    disabled: isSendBtnDisabled,
    children: isSendBtnLoading ? textConstants.sendBtnLoadingLabel : textConstants.sendBtnLabel
  }, "taskGuideNoteInputSubmitBtn"), isEditBtnVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
    appearance: "secondary",
    size: "small",
    onClick: onEditClick,
    "aria-label": textConstants.editBtnAriaLabel,
    disabled: isEditBtnDisabled,
    children: textConstants.editBtnLabel
  }, "taskGuideNoteInputEditBtn")].filter(Boolean);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: note_input_module.note,
    tabIndex: void 0,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideTextArea, {
      value: text,
      onValueChange: onChangeNoteText,
      withButtons: true,
      buttons,
      readOnly,
      files: attachments,
      onFileCloseClick: fileId => {
        onFileCloseClick(fileId);
      },
      context: {
        placeholderText: textConstants.placeholder
      },
      reloadFile
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__notes/notes.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const notes_module = ({"root":"notes-module__root--WojYm","main":"notes-module__main--L_ysC","note-group":"notes-module__note-group--H0Hag","noteGroup":"notes-module__note-group--H0Hag","notes-group-title":"notes-module__notes-group-title--hsMPr","notesGroupTitle":"notes-module__notes-group-title--hsMPr","note":"notes-module__note--NFdZI","fade-in":"notes-module__fade-in--tbZVC","fadeIn":"notes-module__fade-in--tbZVC"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__notes/notes.component.tsx














const TaskGuideNotes = _ref => {
  let {
    currentEditableNoteViewModel,
    noteGroups,
    activeHeaderTab,
    textConstants,
    changeActiveTab,
    onChangeNoteText,
    onSendClick,
    onEditClick,
    onRemoveClick,
    onRemoveFileClick,
    onAttachFiles,
    reloadFile,
    onCancelEditClick,
    modals,
    headerHeight
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideHeader, {
        items: [{
          title: textConstants.studentTabLabel,
          onClick: () => {
            changeActiveTab("student");
          },
          selected: activeHeaderTab === "student"
        }, {
          title: textConstants.privateTabLabel,
          onClick: () => {
            changeActiveTab("private");
          },
          selected: activeHeaderTab === "private"
        }]
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
      children: _ref2 => {
        let {
          height,
          width
        } = _ref2;
        return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
          className: notes_module.root,
          style: {
            height: height - MENU_HEIGHT - MODULE_SELECTOR_HEIGHT - headerHeight,
            width
          },
          children: /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
            className: notes_module.main,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideNoteInput, {
              textConstants,
              readOnly: currentEditableNoteViewModel.readOnly,
              attachments: currentEditableNoteViewModel.attachments,
              text: currentEditableNoteViewModel.text,
              isSendBtnLoading: currentEditableNoteViewModel.sendBtn.isLoading,
              isSendBtnDisabled: currentEditableNoteViewModel.sendBtn.isDisabled,
              isSendBtnVisible: currentEditableNoteViewModel.sendBtn.isVisible,
              isEditBtnVisible: false,
              isEditBtnDisabled: true,
              isCancelEditBtnVisible: false,
              isCancelEditBtnDisabled: true,
              isRemoveBtnVisible: false,
              isRemoveBtnDisabled: true,
              isUploadAttachmentBtnVisible: currentEditableNoteViewModel.uploadBtn.isVisible,
              isUploadAttachmentBtnDisabled: currentEditableNoteViewModel.uploadBtn.isDisabled,
              onChangeNoteText,
              onSendClick: () => {
                onSendClick();
              },
              onEditClick: function_utils/* emptyFunction */.Bi,
              onFileCloseClick: onRemoveFileClick,
              onDrop: onAttachFiles,
              reloadFile
            }), noteGroups.map(noteGroup => /* @__PURE__ */(0,jsx_runtime.jsxs)("article", {
              className: notes_module.noteGroup,
              children: [/* @__PURE__ */(0,jsx_runtime.jsx)("header", {
                className: classnames_default()(notes_module.notesGroupTitle, typography_module/* default */.Z.headline3),
                children: noteGroup.dateLabel
              }), noteGroup.notes.map(note => /* @__PURE__ */(0,jsx_runtime.jsx)("article", {
                className: notes_module.note,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideNoteInput, {
                  textConstants,
                  readOnly: note.readOnly,
                  attachments: note.attachments,
                  text: note.text,
                  isSendBtnLoading: note.sendBtn.isLoading,
                  isSendBtnDisabled: note.sendBtn.isDisabled,
                  isSendBtnVisible: note.sendBtn.isVisible,
                  isEditBtnVisible: note.editBtn.isVisible,
                  isEditBtnDisabled: note.editBtn.isDisabled,
                  isCancelEditBtnVisible: note.cancelEditBtn.isVisible,
                  isCancelEditBtnDisabled: note.cancelEditBtn.isDisabled,
                  isRemoveBtnVisible: note.removeBtn.isVisible,
                  isRemoveBtnDisabled: note.removeBtn.isDisabled,
                  isUploadAttachmentBtnVisible: note.uploadBtn.isVisible,
                  isUploadAttachmentBtnDisabled: note.uploadBtn.isDisabled,
                  onChangeNoteText: newValue => {
                    onChangeNoteText(newValue, note.id);
                  },
                  onSendClick: onSendClick.bind({}, note.id),
                  onEditClick: onEditClick.bind({}, note.id),
                  onRemoveClick: onRemoveClick.bind({}, note.id),
                  onCancelEditClick: onCancelEditClick.bind({}, note.id, note.isDirty),
                  onFileCloseClick: fileId => {
                    onRemoveFileClick(fileId, note.id);
                  },
                  onDrop: acceptedFiles => {
                    onAttachFiles(acceptedFiles, note.id);
                  },
                  reloadFile: fileId => {
                    reloadFile(fileId, note.id);
                  }
                })
              }, note.id))]
            }, noteGroup.dateLabel))]
          })
        });
      }
    }), modals.map(modal => {
      if (modal.isVisible) {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(deprecated_modal_component/* DeprecatedModal */.rr, {
          onClose: modal.onClose,
          onSubmitButtonClick: modal.onSubmitButtonClick,
          showSubmitButton: true,
          showCancelButton: true,
          submitButtonLabel: modal.submitButtonLabel,
          cancelButtonLabel: modal.cancelButtonLabel,
          contentScrollableY: true,
          overlayZIndex: deprecated_modal_component/* ModalOverlayZIndex */.i3.High,
          isInContainer: true,
          buttonsPosition: deprecated_modal_component/* ModalFooterButtonsPosition */.nq.Center,
          children: modal.content
        }, modal.id);
      }
    })]
  });
};
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(9571);
// EXTERNAL MODULE: ../shared/src/model/student/note.ts
var student_note = __webpack_require__(49155);
// EXTERNAL MODULE: ../shared/src/utils/locale.ts
var locale = __webpack_require__(90790);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
;// CONCATENATED MODULE: ./src/api/tutor/attachments/attachments.model-raw.ts



const RawAttachment = es6.type({
  data: es6.type({
    id: es6.string,
    src: es6.string
  })
});
;// CONCATENATED MODULE: ./src/api/tutor/attachments/attachments.api.ts







const mapRawAttachmentResponse = rawResponse => {
  const rawUploadedFile = rawResponse.data;
  return {
    id: (0,student_note/* makeStudentNoteAttachmentId */.S4)(rawUploadedFile.id),
    src: rawUploadedFile.src
  };
};
const uploadAttachment = uploadedFile => {
  const formData = new FormData();
  formData.append("attachment", uploadedFile.file);
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/attachments`, {
    responseType: RawAttachment,
    resultMapper: mapRawAttachmentResponse,
    method: "POST",
    body: formData
  });
};
const removeAttachment = attachmentId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/attachments/${attachmentId}`, {
  method: "DELETE",
  responseType: es6.voidType
});
// EXTERNAL MODULE: ./src/api/common/notes/notes.map.ts
var notes_map = __webpack_require__(67527);
// EXTERNAL MODULE: ./src/api/common/notes/notes.model-raw.ts
var notes_model_raw = __webpack_require__(18284);
;// CONCATENATED MODULE: ./src/api/tutor/notes/notes.model-raw.ts




const RawStudentNoteResponse = es6.type({
  data: notes_model_raw/* RawStudentNote */.K
});
;// CONCATENATED MODULE: ./src/api/tutor/notes/notes.api.ts










const mapRawCreateStudentNote = (studentId, editableNote) => ({
  text: editableNote.text,
  attachments_ids: editableNote.attachments.map(attachment => attachment.id),
  student_id: studentId,
  type: editableNote.type
});
const mapRawUpdateStudentNote = editableNote => ({
  text: editableNote.text,
  attachments_ids: editableNote.attachments.map(attachment => attachment.id)
});
const mapRawStudentNoteResponse = rawResponse => (0,notes_map/* mapRawStudentNote */.e)(rawResponse.data);
const getStudentNotes = studentId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/student/${studentId}/notes`, {
  responseType: notes_model_raw/* RawStudentNotesResponse */.n,
  resultMapper: notes_map/* mapRawStudentNotes */.s
});
const createStudentNote = (studentId, editableNote) => {
  const rawBody = mapRawCreateStudentNote(studentId, editableNote);
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/notes`, {
    responseType: RawStudentNoteResponse,
    resultMapper: mapRawStudentNoteResponse,
    method: "POST",
    body: rawBody
  });
};
const updateStudentNote = editableNote => {
  const rawBody = mapRawUpdateStudentNote(editableNote);
  return (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/notes/${editableNote.id}`, {
    method: "PUT",
    responseType: RawStudentNoteResponse,
    resultMapper: mapRawStudentNoteResponse,
    body: rawBody
  });
};
const removeStudentNote = noteId => (0,http/* makeRequest */.$f)(`${(0,site_utils/* getAPIPath */.NZ)()}/tutor/notes/${noteId}`, {
  method: "DELETE",
  responseType: es6.voidType
});
;// CONCATENATED MODULE: ./src/adapters/task-guide/note.api-adapter.ts





const taskGuideApiAdapter = {
  async loadNotes(studentId) {
    const result = await getStudentNotes(studentId);
    if ((0,Either.isRight)(result)) {
      return result.right;
    }
    throw result.left;
  },
  async createNote(studentId, editableNote) {
    const result = await createStudentNote(studentId, editableNote);
    if ((0,Either.isRight)(result)) {
      return result.right;
    }
    throw result.left;
  },
  async updateNote(editableNote) {
    const result = await updateStudentNote(editableNote);
    if ((0,Either.isRight)(result)) {
      return result.right;
    }
    throw result.left;
  },
  async removeNote(noteId) {
    await removeStudentNote(noteId);
  },
  async removeAttachment(attachmentId) {
    await removeAttachment(attachmentId);
  },
  async uploadAttachment(uploadedFile) {
    const result = await uploadAttachment(uploadedFile);
    if ((0,Either.isRight)(result)) {
      return result.right;
    }
    throw result.left;
  }
};
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
;// CONCATENATED MODULE: ./src/models/task-guide/note.ts


var TaskGuideNoteAttachmentState = /* @__PURE__ */(TaskGuideNoteAttachmentState2 => {
  TaskGuideNoteAttachmentState2["Loaded"] = "loaded";
  TaskGuideNoteAttachmentState2["Loading"] = "loading";
  TaskGuideNoteAttachmentState2["Error"] = "error";
  return TaskGuideNoteAttachmentState2;
})(TaskGuideNoteAttachmentState || {});
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
;// CONCATENATED MODULE: ./src/services/taskGuide/note/note.service.ts












function sortTaskGuideNodeByCreatedAtDesc(notes) {
  return notes.sort((a, b) => Number(b.createdAt) - Number(a.createdAt));
}
function mapStudentNoteToTaskGuideNote(studentNote) {
  return {
    ...studentNote,
    isRemoving: false
  };
}
function checkDirtyTaskGuideNoteEditableNote(note, editableNote) {
  return note.text.trim() !== editableNote.text.trim() || note.attachments.map(attachment => attachment.id).join(" ") !== editableNote.attachments.map(attachment => attachment.id).join(" ");
}
function createTaskGuideNoteService(props) {
  const {
    taskGuideNoteApi: api,
    taskGuideNoteStorage: storage,
    errorHandler
  } = props;
  const {
    publicNotes,
    privateNotes,
    privateEditableNote,
    publicEditableNote
  } = storage;
  const currentNotes = storage.activeHeaderTab === "student" ? publicNotes : privateNotes;
  const currentEditableNote = storage.activeHeaderTab === "student" ? publicEditableNote : privateEditableNote;
  const loadNotes = async studentId => {
    try {
      storage.clear();
      const {
        publicNotes: publicNotes2,
        privateNotes: privateNotes2
      } = await api.loadNotes(studentId);
      storage.setNotes({
        publicNotes: sortTaskGuideNodeByCreatedAtDesc([...publicNotes2.map(mapStudentNoteToTaskGuideNote)]),
        privateNotes: sortTaskGuideNodeByCreatedAtDesc([...privateNotes2.map(mapStudentNoteToTaskGuideNote)])
      });
    } catch (e) {
      errorHandler.captureException(e, "loading_notes");
    }
  };
  const closeRemovingNoteDialog = () => {
    if (storage.confirmRemovingNoteId) {
      storage.setConfirmRemovingNoteId(void 0);
    }
  };
  const removeNote = async noteId => {
    closeRemovingNoteDialog();
    try {
      storage.setRemovingNote(noteId, true);
      await api.removeNote(noteId);
      storage.removeNote(noteId);
    } catch (e) {
      storage.setRemovingNote(noteId, false);
      errorHandler.captureException(e, "removing_note");
      errorHandler.showErrorToast(e);
    }
  };
  const openRemovingNoteDialog = noteId => {
    storage.setConfirmRemovingNoteId(noteId);
  };
  const closeEditingNoteDialog = () => {
    if (storage.confirmEditingNoteId) {
      storage.setConfirmEditingNoteId(void 0);
    }
  };
  const openEditingNoteDialog = noteId => {
    const editableNote = storage.editableNote;
    if (!editableNote) {
      storage.changeEditableNote(noteId);
      return;
    }
    const note = storage.publicNotes.concat(storage.privateNotes).find(note2 => note2.id === editableNote.id);
    if (!note) {
      errorHandler.captureException(new Error("Not found note"), "edit_dialog");
      return;
    }
    if (checkDirtyTaskGuideNoteEditableNote(note, editableNote)) {
      storage.setConfirmEditingNoteId(noteId);
      return;
    }
    storage.changeEditableNote(noteId);
  };
  const startCancelingEdit = (noteId, isNoteDirty) => {
    if (isNoteDirty) {
      storage.setConfirmEditingNoteId(noteId);
    } else {
      storage.clearEditableNote();
    }
  };
  const createNote = async studentId => {
    const noteType = storage.activeHeaderTab === "student" ? student_note/* StudentNoteType */.iC.Public : student_note/* StudentNoteType */.iC.Private;
    try {
      storage.setSendingCurrentEditableNote({
        noteType,
        isSending: true
      });
      const editable = noteType === student_note/* StudentNoteType */.iC.Public ? storage.publicEditableNote : storage.privateEditableNote;
      const createdNote = await api.createNote(studentId, {
        ...editable,
        text: editable.text.trim()
      });
      storage.clearCurrentEditableNote(noteType);
      storage.addNote(mapStudentNoteToTaskGuideNote(createdNote));
    } catch (e) {
      storage.setSendingCurrentEditableNote({
        noteType,
        isSending: false
      });
      errorHandler.captureException(e, "creating_note");
      errorHandler.showErrorToast(e);
    }
  };
  const updateNote = async editableNote => {
    try {
      storage.setSendingEditableNote(true);
      const changedNote = await api.updateNote({
        ...editableNote,
        text: editableNote.text.trim()
      });
      storage.clearEditableNote();
      storage.updateNote({
        ...changedNote,
        isSending: false
      });
    } catch (e) {
      storage.setSendingEditableNote(false);
      errorHandler.captureException(e, "updating_note");
      errorHandler.showErrorToast(e);
    }
  };
  const changeEditableNote = confirmEditingNoteId => {
    if (confirmEditingNoteId === storage.editableNote?.id) {
      storage.clearEditableNote();
    } else {
      storage.changeEditableNote(confirmEditingNoteId);
    }
    storage.setConfirmEditingNoteId(void 0);
  };
  const removeAttachment = (attachmentId, noteId) => {
    if (noteId) {
      storage.removeNoteAttachment({
        attachmentId,
        noteId
      });
    } else {
      const attachment = currentEditableNote.attachments.find(attachment2 => attachment2.id === attachmentId);
      if (attachment && attachment.state === TaskGuideNoteAttachmentState.Loaded) {
        void api.removeAttachment(attachmentId).catch(error => {
          errorHandler.captureException(error, "removing_attachment");
        });
      }
      storage.removeCurrentNoteAttachment({
        attachmentId,
        noteType: currentEditableNote.type
      });
    }
  };
  const uploadAttachments = (attachments, changeAttachmentStatusToStorage, addAttachmentsToStorage) => {
    addAttachmentsToStorage(attachments);
    attachments.forEach(attachment => {
      api.uploadAttachment({
        placeholderSrc: attachment.src,
        file: attachment.file
      }).then(serverAttachment => {
        changeAttachmentStatusToStorage({
          attachmentId: attachment.id,
          status: TaskGuideNoteAttachmentState.Loaded,
          serverAttachmentId: serverAttachment.id
        });
      }).catch(error => {
        changeAttachmentStatusToStorage({
          attachmentId: attachment.id,
          status: TaskGuideNoteAttachmentState.Error
        });
        errorHandler.captureException(error, "uploading_attachment");
      });
    });
  };
  const uploadAttachmentsWrapper = (attachments, noteId) => {
    if (noteId) {
      uploadAttachments(attachments, storage.changeEditableNoteAttachmentStatus, storage.addEditableNoteAttachments);
    } else {
      uploadAttachments(attachments, props1 => {
        storage.changeCurrentEditableNoteAttachmentStatus({
          ...props1,
          noteType: currentEditableNote.type
        });
      }, attachments1 => {
        storage.addCurrentEditableNoteAttachments({
          attachments: attachments1,
          noteType: currentEditableNote.type
        });
      });
    }
  };
  return {
    currentNotes,
    currentEditableNote,
    loadNotes,
    createNote,
    updateNote,
    removeNote,
    changeEditableNote,
    startCancelingEdit,
    removeAttachment,
    uploadAttachments: uploadAttachmentsWrapper,
    startRemovingNote: openRemovingNoteDialog,
    finishRemovingNote: closeRemovingNoteDialog,
    startEditingNote: openEditingNoteDialog,
    finishEditingNote: closeEditingNoteDialog
  };
}
;// CONCATENATED MODULE: ./src/adapters/task-guide/note.storage-adapter.ts














const taskGuideNotesDomain = (0,effector/* createDomain */.Fj)("syllabus");
function mapAttachment(attachment) {
  return {
    id: attachment.id,
    isExistOnServer: true,
    state: TaskGuideNoteAttachmentState.Loaded,
    src: attachment.src
  };
}
function getEmptyPublicEditableNote() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0,student_note/* makeStudentNoteId */.K7)("publicEmptyNoteId");
  let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  let attachments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return {
    id,
    text,
    type: student_note/* StudentNoteType */.iC.Public,
    isSending: false,
    attachments: attachments.map(mapAttachment)
  };
}
function getEmptyPrivateEditableNote() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0,student_note/* makeStudentNoteId */.K7)("privateEmptyNoteId");
  let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  let attachments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return {
    id,
    text,
    type: student_note/* StudentNoteType */.iC.Private,
    isSending: false,
    attachments: attachments.map(mapAttachment)
  };
}
function getNote(_ref) {
  let {
    privateNotes,
    publicNotes,
    noteId
  } = _ref;
  return privateNotes.concat(publicNotes).find(note => note.id === noteId);
}
function getNoteType(props) {
  return getNote(props)?.type ?? student_note/* StudentNoteType */.iC.Private;
}
const $taskGuideNotesStorage = taskGuideNotesDomain.createStore({
  privateNotes: [],
  publicNotes: [],
  publicEditableNote: getEmptyPublicEditableNote(),
  privateEditableNote: getEmptyPrivateEditableNote(),
  editableNote: void 0,
  confirmRemovingNoteId: void 0,
  activeHeaderTab: "student",
  confirmEditingNoteId: void 0
});
const setNotes = taskGuideNotesDomain.createEvent();
const addNote = taskGuideNotesDomain.createEvent();
const updateNote = taskGuideNotesDomain.createEvent();
const setActiveHeaderTab = taskGuideNotesDomain.createEvent();
const setConfirmRemovingNoteId = taskGuideNotesDomain.createEvent();
const removeNote = taskGuideNotesDomain.createEvent();
const clearCurrentEditableNote = taskGuideNotesDomain.createEvent();
const changeEditableNoteText = taskGuideNotesDomain.createEvent();
const setConfirmEditingNoteId = taskGuideNotesDomain.createEvent();
const clearEditableNote = taskGuideNotesDomain.createEvent();
const changeEditableNote = taskGuideNotesDomain.createEvent();
const addEditableNoteAttachments = taskGuideNotesDomain.createEvent();
const removeNoteAttachment = taskGuideNotesDomain.createEvent();
const removeCurrentNoteAttachment = taskGuideNotesDomain.createEvent();
const changeEditableNoteAttachmentStatus = taskGuideNotesDomain.createEvent();
const addCurrentEditableNoteAttachments = taskGuideNotesDomain.createEvent();
const changeCurrentEditableNoteAttachmentStatus = taskGuideNotesDomain.createEvent();
const changeCurrentEditableNoteText = taskGuideNotesDomain.createEvent();
const setSendingCurrentEditableNote = taskGuideNotesDomain.createEvent();
const setSendingEditableNote = taskGuideNotesDomain.createEvent();
const setRemovingNote = taskGuideNotesDomain.createEvent();
$taskGuideNotesStorage.on(setNotes, (state, payload) => ({
  ...state,
  privateNotes: payload.privateNotes,
  publicNotes: payload.publicNotes
}));
$taskGuideNotesStorage.on(addNote, (state, payload) => {
  const noteType = payload.type;
  return {
    ...state,
    publicNotes: noteType === student_note/* StudentNoteType */.iC.Public ? sortTaskGuideNodeByCreatedAtDesc([...state.publicNotes, payload]) : state.publicNotes,
    privateNotes: noteType === student_note/* StudentNoteType */.iC.Private ? sortTaskGuideNodeByCreatedAtDesc([...state.privateNotes, payload]) : state.privateNotes
  };
});
function mapUpdateNote(editableNote, note) {
  if (note.id !== editableNote.id) {
    return note;
  }
  return {
    ...note,
    text: editableNote.text,
    attachments: editableNote.attachments
  };
}
$taskGuideNotesStorage.on(updateNote, (state, payload) => {
  const noteType = payload.type;
  return {
    ...state,
    publicNotes: noteType === student_note/* StudentNoteType */.iC.Public ? state.publicNotes.map(mapUpdateNote.bind({}, payload)) : state.publicNotes,
    privateNotes: noteType === student_note/* StudentNoteType */.iC.Private ? state.privateNotes.map(mapUpdateNote.bind({}, payload)) : state.privateNotes
  };
});
$taskGuideNotesStorage.on(setActiveHeaderTab, (state, payload) => ({
  ...state,
  activeHeaderTab: payload
}));
$taskGuideNotesStorage.on(setConfirmRemovingNoteId, (state, payload) => ({
  ...state,
  confirmRemovingNoteId: payload
}));
function excludeNoteById(notes, noteId) {
  return notes.filter(note => note.id !== noteId);
}
$taskGuideNotesStorage.on(removeNote, (state, payload) => {
  const noteType = getNoteType({
    noteId: payload,
    publicNotes: state.publicNotes,
    privateNotes: state.privateNotes
  });
  const newState = {
    ...state
  };
  if (noteType === student_note/* StudentNoteType */.iC.Private) {
    newState.privateNotes = excludeNoteById(newState.privateNotes, payload);
  } else {
    newState.publicNotes = excludeNoteById(newState.publicNotes, payload);
  }
  return newState;
});
function mapNotesForRemovingNotes(notes, noteId, isRemoving) {
  return notes.map(note => {
    if (note.id !== noteId) {
      return note;
    }
    return {
      ...note,
      isRemoving
    };
  });
}
$taskGuideNotesStorage.on(setRemovingNote, (state, _ref2) => {
  let {
    noteId,
    isRemoving
  } = _ref2;
  const noteType = getNoteType({
    noteId,
    publicNotes: state.publicNotes,
    privateNotes: state.privateNotes
  });
  const newState = {
    ...state
  };
  if (noteType === student_note/* StudentNoteType */.iC.Private) {
    newState.privateNotes = mapNotesForRemovingNotes(newState.privateNotes, noteId, isRemoving);
  } else {
    newState.publicNotes = mapNotesForRemovingNotes(newState.publicNotes, noteId, isRemoving);
  }
  return newState;
});
$taskGuideNotesStorage.on(clearCurrentEditableNote, (state, noteType) => ({
  ...state,
  publicEditableNote: noteType === student_note/* StudentNoteType */.iC.Public ? getEmptyPublicEditableNote() : state.publicEditableNote,
  privateEditableNote: noteType === student_note/* StudentNoteType */.iC.Private ? getEmptyPrivateEditableNote() : state.privateEditableNote
}));
$taskGuideNotesStorage.on(changeEditableNote, (state, payload) => {
  const note = getNote({
    publicNotes: state.publicNotes,
    privateNotes: state.privateNotes,
    noteId: payload
  });
  return {
    ...state,
    editableNote: note ? {
      ...(note.type === student_note/* StudentNoteType */.iC.Public ? getEmptyPublicEditableNote(note.id, note.text, note.attachments) : getEmptyPrivateEditableNote(note.id, note.text, note.attachments)),
      id: payload
    } : void 0
  };
});
$taskGuideNotesStorage.on(addEditableNoteAttachments, (state, payload) => ({
  ...state,
  editableNote: state.editableNote ? {
    ...state.editableNote,
    attachments: [...state.editableNote.attachments, ...payload]
  } : void 0
}));
function mapEditableNoteAttachmentStatus(editableNote, payload) {
  return {
    ...editableNote,
    attachments: editableNote.attachments.map(attachment => {
      if (attachment.id === payload.attachmentId) {
        return {
          ...attachment,
          state: payload.status,
          id: payload.serverAttachmentId ?? attachment.id,
          isExistOnServer: Boolean(payload.serverAttachmentId)
        };
      }
      return attachment;
    })
  };
}
$taskGuideNotesStorage.on(changeEditableNoteAttachmentStatus, (state, payload) => ({
  ...state,
  editableNote: state.editableNote ? mapEditableNoteAttachmentStatus(state.editableNote, payload) : void 0
}));
$taskGuideNotesStorage.on(addCurrentEditableNoteAttachments, (state, _ref3) => {
  let {
    noteType,
    attachments
  } = _ref3;
  return {
    ...state,
    publicEditableNote: noteType === student_note/* StudentNoteType */.iC.Public ? {
      ...state.publicEditableNote,
      attachments: state.publicEditableNote.attachments.concat(attachments)
    } : state.publicEditableNote,
    privateEditableNote: noteType === student_note/* StudentNoteType */.iC.Private ? {
      ...state.privateEditableNote,
      attachments: state.privateEditableNote.attachments.concat(attachments)
    } : state.privateEditableNote
  };
});
$taskGuideNotesStorage.on(changeCurrentEditableNoteAttachmentStatus, (state, payload) => ({
  ...state,
  publicEditableNote: payload.noteType === student_note/* StudentNoteType */.iC.Public ? mapEditableNoteAttachmentStatus(state.publicEditableNote, payload) : state.publicEditableNote,
  privateEditableNote: payload.noteType === student_note/* StudentNoteType */.iC.Private ? mapEditableNoteAttachmentStatus(state.privateEditableNote, payload) : state.privateEditableNote
}));
$taskGuideNotesStorage.on(removeNoteAttachment, (state, _ref4) => {
  let {
    attachmentId,
    noteId
  } = _ref4;
  const copyState = {
    ...state
  };
  if (copyState.editableNote?.id === noteId) {
    copyState.editableNote = {
      ...copyState.editableNote,
      attachments: copyState.editableNote.attachments.filter(attachment => attachment.id !== attachmentId)
    };
    return copyState;
  }
  return copyState;
});
$taskGuideNotesStorage.on(removeCurrentNoteAttachment, (state, _ref5) => {
  let {
    attachmentId,
    noteType
  } = _ref5;
  return {
    ...state,
    publicEditableNote: noteType === student_note/* StudentNoteType */.iC.Public ? {
      ...state.publicEditableNote,
      attachments: state.publicEditableNote.attachments.filter(attachment => attachment.id !== attachmentId)
    } : state.publicEditableNote,
    privateEditableNote: noteType === student_note/* StudentNoteType */.iC.Private ? {
      ...state.privateEditableNote,
      attachments: state.privateEditableNote.attachments.filter(attachment => attachment.id !== attachmentId)
    } : state.privateEditableNote
  };
});
$taskGuideNotesStorage.on(clearEditableNote, state => ({
  ...state,
  editableNote: void 0
}));
$taskGuideNotesStorage.on(setConfirmEditingNoteId, (state, payload) => ({
  ...state,
  confirmEditingNoteId: payload
}));
$taskGuideNotesStorage.on(setSendingCurrentEditableNote, (state, _ref6) => {
  let {
    noteType,
    isSending
  } = _ref6;
  return {
    ...state,
    publicEditableNote: noteType === student_note/* StudentNoteType */.iC.Public ? {
      ...state.publicEditableNote,
      isSending
    } : state.publicEditableNote,
    privateEditableNote: noteType === student_note/* StudentNoteType */.iC.Private ? {
      ...state.privateEditableNote,
      isSending
    } : state.privateEditableNote
  };
});
$taskGuideNotesStorage.on(changeCurrentEditableNoteText, (state, _ref7) => {
  let {
    noteType,
    text
  } = _ref7;
  return {
    ...state,
    publicEditableNote: noteType === student_note/* StudentNoteType */.iC.Public ? {
      ...state.publicEditableNote,
      text
    } : state.publicEditableNote,
    privateEditableNote: noteType === student_note/* StudentNoteType */.iC.Private ? {
      ...state.privateEditableNote,
      text
    } : state.privateEditableNote
  };
});
$taskGuideNotesStorage.on(changeEditableNoteText, (state, payload) => {
  if (!state.editableNote) {
    return state;
  }
  return {
    ...state,
    editableNote: {
      ...state.editableNote,
      text: payload
    }
  };
});
$taskGuideNotesStorage.on(setSendingEditableNote, (state, payload) => {
  if (!state.editableNote) {
    return state;
  }
  return {
    ...state,
    editableNote: {
      ...state.editableNote,
      isSending: payload
    }
  };
});
const useTaskGuideNoteStorage = () => {
  const {
    privateNotes,
    privateEditableNote,
    publicEditableNote,
    confirmRemovingNoteId,
    publicNotes,
    activeHeaderTab,
    confirmEditingNoteId,
    editableNote
  } = (0,effector_react/* useStore */.oR)($taskGuideNotesStorage);
  return {
    clear: $taskGuideNotesStorage.reset,
    privateNotes,
    publicNotes,
    activeHeaderTab,
    confirmRemovingNoteId,
    setConfirmRemovingNoteId,
    addNote,
    updateNote,
    setNotes,
    setActiveHeaderTab,
    addEditableNoteAttachments,
    addCurrentEditableNoteAttachments,
    changeCurrentEditableNoteAttachmentStatus,
    changeEditableNoteAttachmentStatus,
    removeCurrentNoteAttachment,
    removeNoteAttachment,
    clearCurrentEditableNote,
    privateEditableNote,
    publicEditableNote,
    changeCurrentEditableNoteText,
    setSendingEditableNote,
    setSendingCurrentEditableNote,
    confirmEditingNoteId,
    changeEditableNoteText,
    editableNote,
    clearEditableNote,
    setConfirmEditingNoteId,
    changeEditableNote,
    removeNote,
    setRemovingNote(noteId, isRemoving) {
      setRemovingNote({
        noteId,
        isRemoving
      });
    }
  };
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
;// CONCATENATED MODULE: ./src/services/taskGuide/note/note.presenter.ts






























function groupNotes(notes, format) {
  const noteGroupMap = notes.reduce((result, note) => {
    const key = note.createdAt.toDateString();
    const notes2 = result.get(key);
    if (notes2) {
      notes2.push(note);
      result.set(key, notes2);
    } else {
      result.set(key, [note]);
    }
    return result;
  }, /* @__PURE__ */new Map());
  const currentYear = ( /* @__PURE__ */new Date()).getFullYear();
  return Array.from(noteGroupMap.entries()).map(_ref => {
    let [dateLabelIso, notes2] = _ref;
    const noteGroupDate = new Date(dateLabelIso);
    const formatStr = currentYear === noteGroupDate.getFullYear() ? "d MMMM" : "d MMMM yyyy";
    return {
      dateLabel: format(noteGroupDate, formatStr),
      notes: notes2
    };
  });
}
function validNoteVisible(note) {
  return !note.isRemoving;
}
function checkValidAttachmentsToSend(attachments) {
  return !attachments.some(attachment => attachment.state !== TextAreaFileState.Loaded);
}
function mapAttachmentState(status) {
  switch (status) {
    case TaskGuideNoteAttachmentState.Loaded:
      return TextAreaFileState.Loaded;
    case TaskGuideNoteAttachmentState.Loading:
      return TextAreaFileState.Loading;
    case TaskGuideNoteAttachmentState.Error:
      return TextAreaFileState.Error;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(status);
  }
}
function isTaskGuideEditableNoteAttachment(attachment) {
  return Boolean(typeof attachment === "object" && attachment && "state" in attachment);
}
function mapAttachmentToViewModel(attachment) {
  return {
    id: attachment.id,
    src: attachment.src,
    state: isTaskGuideEditableNoteAttachment(attachment) ? mapAttachmentState(attachment.state) : TextAreaFileState.Loaded,
    name: ""
  };
}
function mapNote(note, editableNote) {
  const isSending = Boolean(editableNote?.isSending);
  return {
    id: note.id,
    text: note.text,
    attachments: note.attachments.map(mapAttachmentToViewModel),
    readOnly: true,
    sendBtn: {
      isDisabled: false,
      isVisible: false,
      isLoading: false
    },
    uploadBtn: {
      isDisabled: false,
      isVisible: false
    },
    editBtn: {
      isDisabled: isSending,
      isVisible: true
    },
    removeBtn: {
      isDisabled: isSending,
      isVisible: true
    },
    cancelEditBtn: {
      isVisible: false,
      isDisabled: true
    },
    isDirty: false
  };
}
function mapEditableNote(note, editableNote) {
  const isDirty = checkDirtyTaskGuideNoteEditableNote(note, editableNote);
  const isEditableNoteEmpty = !editableNote.text.trim() && editableNote.attachments.length === 0;
  const attachments = editableNote.attachments.map(mapAttachmentToViewModel);
  return {
    id: note.id,
    text: editableNote.text,
    attachments,
    readOnly: editableNote.isSending,
    sendBtn: {
      isDisabled: editableNote.isSending || isEditableNoteEmpty || !checkValidAttachmentsToSend(attachments) || !isDirty,
      isVisible: true,
      isLoading: editableNote.isSending
    },
    removeBtn: {
      isDisabled: true,
      isVisible: false
    },
    uploadBtn: {
      isDisabled: editableNote.isSending,
      isVisible: true
    },
    editBtn: {
      isDisabled: true,
      isVisible: false
    },
    cancelEditBtn: {
      isVisible: true,
      isDisabled: editableNote.isSending
    },
    isDirty
  };
}
function mapNoteGroupViewModels(props) {
  const {
    notes,
    editableNote,
    format
  } = props;
  return groupNotes(notes.filter(validNoteVisible), format).map(groupNote => ({
    dateLabel: groupNote.dateLabel,
    notes: groupNote.notes.map(note => {
      if (note.id === editableNote?.id) {
        return mapEditableNote(note, editableNote);
      }
      return mapNote(note, editableNote);
    })
  }));
}
function mapCurrentEditableNoteViewModel(props) {
  const {
    note: {
      text,
      isSending,
      attachments
    }
  } = props;
  const attachmentViewModes = attachments.map(mapAttachmentToViewModel);
  const isDirty = Boolean(text.trim()) || attachmentViewModes.length > 0;
  return {
    text,
    attachments: attachmentViewModes,
    readOnly: isSending,
    sendBtn: {
      isDisabled: !isDirty || !checkValidAttachmentsToSend(attachmentViewModes) || isSending,
      isVisible: true,
      isLoading: isSending
    },
    uploadBtn: {
      isDisabled: isSending,
      isVisible: true
    }
  };
}
const taskGuideNotePresenter = {
  mapNoteGroupViewModels,
  mapCurrentEditableNoteViewModel
};
;// CONCATENATED MODULE: ./src/services/taskGuide/note/useTaskGuideNote.ts

















function useTaskGuideNote() {
  const {
    studentId
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const taskGuideNoteApi = taskGuideApiAdapter;
  const [isNotesLoading, setIsNotesLoading] = (0,react.useState)(false);
  const intl = (0,useIntl/* default */.Z)();
  const taskGuideNoteStorage = useTaskGuideNoteStorage();
  const taskGuideNoteService = createTaskGuideNoteService({
    taskGuideNoteApi,
    taskGuideNoteStorage,
    errorHandler: {
      captureException(error, part) {
        logger/* Logger */.Yd.captureException(error, {
          task_guide_note_part: part
        });
      },
      showErrorToast(error) {
        console.error("showErrorToast", error);
      }
    }
  });
  const loadNotes = (0,react.useRef)(taskGuideNoteService.loadNotes);
  (0,react.useEffect)(() => {
    setIsNotesLoading(true);
    void loadNotes.current(studentId).finally(() => {
      setIsNotesLoading(false);
    });
  }, [studentId]);
  const {
    activeHeaderTab,
    setActiveHeaderTab,
    confirmRemovingNoteId,
    confirmEditingNoteId,
    changeEditableNoteText,
    changeCurrentEditableNoteText,
    editableNote
  } = taskGuideNoteStorage;
  const currentNotes = taskGuideNoteService.currentNotes;
  const noteGroupViewModels = (0,react.useMemo)(() => taskGuideNotePresenter.mapNoteGroupViewModels({
    notes: currentNotes,
    editableNote,
    format(date, formatStr) {
      return (0,format/* format */.WU)(date, formatStr, {
        locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
      });
    }
  }), [currentNotes, editableNote, intl.locale]);
  const currentEditableNoteViewModel = (0,react.useMemo)(() => taskGuideNotePresenter.mapCurrentEditableNoteViewModel({
    note: taskGuideNoteService.currentEditableNote
  }), [taskGuideNoteService.currentEditableNote]);
  return {
    activeHeaderTab,
    isRemovingModal: Boolean(confirmRemovingNoteId),
    isEditingModal: Boolean(confirmEditingNoteId),
    setActiveHeaderTab,
    noteGroupViewModels,
    currentEditableNoteViewModel,
    isNotesLoading,
    finishRemovingNote: taskGuideNoteService.finishRemovingNote,
    startRemovingNote: taskGuideNoteService.startRemovingNote,
    finishEditingNote: taskGuideNoteService.finishEditingNote,
    startEditingNote: taskGuideNoteService.startEditingNote,
    onCancelEditClick: taskGuideNoteService.startCancelingEdit,
    uploadAttachments(uploadedFiles, noteId) {
      const attachments = uploadedFiles.map(uploadedFile => ({
        id: (0,student_note/* makeStudentNoteAttachmentId */.S4)((0,v4/* default */.Z)()),
        src: uploadedFile.placeholderSrc,
        state: TaskGuideNoteAttachmentState.Loading,
        file: uploadedFile.file,
        isExistOnServer: false
      }));
      taskGuideNoteService.uploadAttachments(attachments, noteId);
    },
    reloadAttachment(_attachmentFileId, _noteId) {},
    changeEditableNoteText(text, noteId) {
      if (noteId) {
        changeEditableNoteText(text);
        return;
      }
      changeCurrentEditableNoteText({
        text,
        noteType: taskGuideNoteService.currentEditableNote.type
      });
    },
    removeNote() {
      if (confirmRemovingNoteId) {
        void taskGuideNoteService.removeNote(confirmRemovingNoteId);
      }
    },
    sendNote(noteId) {
      if (!noteId) {
        void taskGuideNoteService.createNote(studentId);
        return;
      }
      if (editableNote) {
        void taskGuideNoteService.updateNote(editableNote);
      }
    },
    changeEditableNote() {
      if (!taskGuideNoteStorage.confirmEditingNoteId) {
        return;
      }
      taskGuideNoteService.changeEditableNote(taskGuideNoteStorage.confirmEditingNoteId);
    },
    removeAttachment(attachmentFileId, noteId) {
      const attachmentId = (0,student_note/* makeStudentNoteAttachmentId */.S4)(attachmentFileId);
      taskGuideNoteService.removeAttachment(attachmentId, noteId);
    }
  };
}
;// CONCATENATED MODULE: ./src/widgets/task-guide/__notes/notes.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const _notes_notes_module = ({"loader":"notes-module__loader--VSAXE"});
;// CONCATENATED MODULE: ./src/widgets/task-guide/__notes/notes.component.tsx










const taskGuideNoteNS = nsCtor(nsCtor("taskGuide")`notes`);
const saveBtnNS = nsCtor(taskGuideNoteNS`sendBtn`);
const editBtnNS = nsCtor(taskGuideNoteNS`editBtn`);
const removeBtnNS = nsCtor(taskGuideNoteNS`removeBtn`);
const cancelEditBtnNS = nsCtor(taskGuideNoteNS`cancelEditBtn`);
const attachmentBtnNS = nsCtor(taskGuideNoteNS`attachmentBtn`);
const noteInputNS = nsCtor(taskGuideNoteNS`noteInput`);
const tabNS = nsCtor(taskGuideNoteNS`tab`);
const removingModalNS = nsCtor(taskGuideNoteNS`removingModal`);
const editingModalNS = nsCtor(taskGuideNoteNS`editingModal`);
const notes_component_TaskGuideNotes = () => {
  const {
    noteGroupViewModels,
    currentEditableNoteViewModel,
    isNotesLoading,
    isRemovingModal,
    isEditingModal,
    activeHeaderTab,
    changeEditableNoteText,
    setActiveHeaderTab,
    removeNote,
    sendNote,
    startRemovingNote,
    finishRemovingNote,
    startEditingNote,
    finishEditingNote,
    changeEditableNote,
    onCancelEditClick,
    uploadAttachments,
    reloadAttachment,
    removeAttachment
  } = useTaskGuideNote();
  const {
    headerHeight
  } = useTaskGuideLayoutSizeContext();
  const intl = (0,useIntl/* default */.Z)();
  const textConstants = {
    sendBtnLabel: intl.formatMessage({
      id: saveBtnNS`label`
    }),
    sendBtnAriaLabel: intl.formatMessage({
      id: saveBtnNS`ariaLabel`
    }),
    sendBtnLoadingLabel: intl.formatMessage({
      id: saveBtnNS`loadingLabel`
    }),
    editBtnLabel: intl.formatMessage({
      id: editBtnNS`label`
    }),
    editBtnAriaLabel: intl.formatMessage({
      id: editBtnNS`ariaLabel`
    }),
    removeBtnLabel: intl.formatMessage({
      id: removeBtnNS`label`
    }),
    removeBtnAriaLabel: intl.formatMessage({
      id: removeBtnNS`ariaLabel`
    }),
    cancelEditBtnAriaLabel: intl.formatMessage({
      id: cancelEditBtnNS`ariaLabel`
    }),
    attachmentBtnAriaLabel: intl.formatMessage({
      id: attachmentBtnNS`ariaLabel`
    }),
    noteInputLabel: intl.formatMessage({
      id: noteInputNS`label`
    }),
    placeholder: intl.formatMessage({
      id: noteInputNS`placeholder`
    }),
    studentTabLabel: intl.formatMessage({
      id: tabNS`studentLabel`
    }),
    privateTabLabel: intl.formatMessage({
      id: tabNS`privateLabel`
    })
  };
  if (isNotesLoading) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: _notes_notes_module.loader,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideNotes, {
    headerHeight,
    currentEditableNoteViewModel,
    activeHeaderTab,
    changeActiveTab: setActiveHeaderTab,
    onCancelEditClick,
    noteGroups: noteGroupViewModels,
    textConstants,
    onChangeNoteText: changeEditableNoteText,
    onSendClick: sendNote,
    onEditClick: startEditingNote,
    onRemoveClick: startRemovingNote,
    onRemoveFileClick: removeAttachment,
    onAttachFiles: uploadAttachments,
    reloadFile: reloadAttachment,
    modals: [{
      id: "removingModal",
      onClose: finishRemovingNote,
      onSubmitButtonClick: removeNote,
      submitButtonLabel: intl.formatMessage({
        id: removingModalNS`submitBtn`
      }),
      cancelButtonLabel: intl.formatMessage({
        id: removingModalNS`cancelBtn`
      }),
      content: intl.formatMessage({
        id: removingModalNS`description`
      }),
      isVisible: isRemovingModal
    }, {
      id: "editingModal",
      onClose: finishEditingNote,
      onSubmitButtonClick: changeEditableNote,
      submitButtonLabel: intl.formatMessage({
        id: editingModalNS`submitBtn`
      }),
      cancelButtonLabel: intl.formatMessage({
        id: editingModalNS`cancelBtn`
      }),
      content: intl.formatMessage({
        id: editingModalNS`description`
      }),
      isVisible: isEditingModal
    }]
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/__popup/task-guide-popup.component.tsx











var TaskGuidePopupWrapperZIndex = /* @__PURE__ */(TaskGuidePopupWrapperZIndex2 => {
  TaskGuidePopupWrapperZIndex2[TaskGuidePopupWrapperZIndex2["Low"] = 0] = "Low";
  TaskGuidePopupWrapperZIndex2[TaskGuidePopupWrapperZIndex2["High"] = 1] = "High";
  return TaskGuidePopupWrapperZIndex2;
})(TaskGuidePopupWrapperZIndex || {});
const TaskGuidePopup = _ref => {
  let {
    title,
    fixedWidth,
    subtitle,
    buttons,
    isColumnButtons,
    dataTestId,
    onClose,
    overlayZIndex = 1 /* High */
  } = _ref;
  const [submitButtonDisabled, setSubmitButtonDisabled] = (0,react.useState)(false);
  const handleButtonClick = (0,react.useCallback)(button => () => {
    setSubmitButtonDisabled(true);
    void button.onClick().finally(() => {
      setSubmitButtonDisabled(false);
    });
  }, []);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(task_guide_module/* default */.Z.taskGuidePopupWrapper, {
        [task_guide_module/* default */.Z.taskGuidePopupWrapperZIndexHigh]: overlayZIndex === 1 /* High */,
        [task_guide_module/* default */.Z.taskGuidePopupWrapperZIndexLow]: overlayZIndex === 0 /* Low */
      }),
      onClick: onClose || function_utils/* emptyFunction */.Bi
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      "data-testid": dataTestId,
      className: task_guide_module/* default */.Z.taskGuidePopup,
      style: {
        width: fixedWidth ?? ""
      },
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4Accent,
        children: title
      }), subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2, task_guide_module/* default */.Z.subtitle),
        children: subtitle
      }), buttons && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(task_guide_module/* default */.Z.taskGuidePopupButtons, {
          [task_guide_module/* default */.Z.taskGuidePopupButtonsColumn]: isColumnButtons,
          [task_guide_module/* default */.Z.taskGuidePopupButtonsRow]: !isColumnButtons
        }),
        children: buttons.map(button => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: task_guide_module/* default */.Z.taskGuidePopupButton,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            appearance: button.appearance,
            size: "medium",
            "aria-label": button.text,
            disabled: submitButtonDisabled,
            onClick: handleButtonClick(button),
            children: button.text
          })
        }, button.text))
      })]
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/toggle-button-group/toggle-button-group.tsx + 3 modules
var toggle_button_group = __webpack_require__(3717);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__profile/profile-layout.component.tsx










const ProfileLayout = _ref => {
  let {
    headerButtons,
    children
  } = _ref;
  const groupValues = (0,react.useMemo)(() => headerButtons.map(_ref2 => {
    let {
      title,
      className
    } = _ref2;
    return {
      id: title,
      label: title,
      className
    };
  }), [headerButtons]);
  const selectedId = (0,react.useMemo)(() => headerButtons.find(item => item.selected)?.title || headerButtons[0].title, [headerButtons]);
  const changeHandler = (0,react.useCallback)(id => headerButtons.find(item => item.title === id)?.onClick(), [headerButtons]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(toggle_button_group/* ToggleButtonGroup */.t, {
      stretch: true,
      values: groupValues,
      selectedValueId: selectedId,
      onChange: changeHandler
    }), children]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__profile/profile.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const profile_module = ({"container":"profile-module__container--CCmjM","value":"profile-module__value--alAON","block":"profile-module__block--ivau9","line-block":"profile-module__line-block--iL78X","lineBlock":"profile-module__line-block--iL78X","block-title":"profile-module__block-title--QdGpH","blockTitle":"profile-module__block-title--QdGpH","input":"profile-module__input--WO3eT","footer":"profile-module__footer--BrDoj"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__profile/profile.component.tsx









const StudentProfileBlock = _ref => {
  let {
    titleId,
    values
  } = _ref;
  const isEmpty = !values || Array.isArray(values) && !values.length;
  if (isEmpty) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: profile_module.block,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(typography_module/* default */.Z.caption, profile_module.blockTitle),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: titleId
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: Array.isArray(values) ? values.map((item, i) => /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: profile_module.value,
        children: item
      }, i)) : /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: profile_module.value,
        children: values
      })
    })]
  });
};
const StudentProfile = _ref2 => {
  let {
    studentId,
    lesson,
    level,
    name,
    age,
    occupation,
    englishLearningExperience,
    purposeOfTraining,
    requestForPractice,
    interests,
    courseInterest,
    learningExperience,
    wantPractice,
    teacherAndStudySuggestions
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: profile_module.container,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: profile_module.lineBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
        titleId: "taskGuide.profile.lesson",
        values: lesson
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
        titleId: "taskGuide.profile.level",
        values: level
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.name",
      values: name
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.id",
      values: studentId
    }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: profile_module.lineBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
        titleId: "taskGuide.profile.age",
        values: age
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
        titleId: "taskGuide.profile.occupation",
        values: occupation
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.englishLearningExperience",
      values: englishLearningExperience
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.purposeOfTraining",
      values: purposeOfTraining
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.requestForPractice",
      values: requestForPractice
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: profile_module.lineBlock,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
        titleId: "taskGuide.profile.interests",
        values: interests
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.courseInterest",
      values: courseInterest
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.learningExperience",
      values: learningExperience
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.wantPractice",
      values: wantPractice
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfileBlock, {
      titleId: "taskGuide.profile.teacherAndStudySuggestions",
      values: teacherAndStudySuggestions
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: profile_module.footer
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__student-progress-list/task-guide-student-progress-list.component.tsx



















var ListElementType = /* @__PURE__ */(ListElementType2 => {
  ListElementType2["Task"] = "task";
  ListElementType2["Header"] = "header";
  return ListElementType2;
})(ListElementType || {});
const TaskGuideStudentProgress = _ref => {
  let {
    children,
    lessons,
    listRef
  } = _ref;
  const listItems = (0,react.useMemo)(() => lessons.reduce((acc, lesson, index) => {
    acc.push({
      elementType: "header" /* Header */,
      title: (0,format/* format */.WU)(lesson.date, "dd LLLL yyyy"),
      moduleIndex: index
    }, ...lesson.motherTasks.map(motherTask => ({
      ...motherTask,
      elementType: "task" /* Task */
    })));
    return acc;
  }, []), [lessons]);
  const getItemSize = (0,react.useCallback)(index => {
    const item = listItems[index];
    const HEADER_HEIGHT = 51;
    const MARGIN = 16;
    const MOTHER_TASK_HEIGHT = 128;
    if (item.elementType === "header" /* Header */) {
      return HEADER_HEIGHT + MARGIN;
    }
    if (item.elementType === "task" /* Task */ && item.expanded) {
      const TASKS_TABS_HEIGHT = 26;
      const TASKS_PADDINGS = 24 + 16;
      const EXPANDED_TASK_HEIGHT = 272;
      const EXPANDED_MOTHER_TASK_HEIGHT = MOTHER_TASK_HEIGHT + TASKS_TABS_HEIGHT + TASKS_PADDINGS + item.tasks.length * (48 + 14) + item.tasks.filter(task => task.expanded).length * EXPANDED_TASK_HEIGHT;
      return EXPANDED_MOTHER_TASK_HEIGHT + MARGIN;
    }
    return MOTHER_TASK_HEIGHT + MARGIN;
  }, [listItems]);
  const refreshList = (0,react.useCallback)(index => {
    listRef.current?.resetAfterIndex(index);
  }, [listRef]);
  const renderRaw = (0,react.useCallback)(params => {
    const currentData = params.data[params.index];
    switch (currentData.elementType) {
      case "task" /* Task */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: task_guide_layout_module.motherTask,
              children: children({
                currentData,
                refreshList,
                index: params.index
              })
            })
          }, currentData.id);
        }
      case "header" /* Header */:
        {
          return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            style: params.style,
            children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideHeader, {
              items: [{
                title: currentData.title,
                selected: true,
                onClick: function_utils/* emptyFunction */.Bi
              }]
            })
          }, `header_${currentData.title}`);
        }
      default:
        {
          return null;
        }
    }
  }, [children, refreshList]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
    className: task_guide_layout_module.progressList,
    children: _ref2 => {
      let {
        height,
        width
      } = _ref2;
      return /* @__PURE__ */(0,jsx_runtime.jsx)(dist_index_esm/* VariableSizeList */.S_, {
        ref: listRef,
        itemSize: getItemSize,
        height: height - MENU_HEIGHT,
        itemCount: listItems.length,
        itemData: listItems,
        width,
        children: renderRaw
      });
    }
  });
};
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/modern/useQuery.js
var useQuery = __webpack_require__(42180);
// EXTERNAL MODULE: ./src/api/tutor/tutor.api.ts + 3 modules
var tutor_api = __webpack_require__(13925);
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-amo-attributes-query.ts





const useStudentAMOAttributesQuery = studentId => {
  const queryKey = (0,react.useMemo)(() => ["studentAmoAttributes", studentId], [studentId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(studentId),
    queryKey,
    queryFn: () => (0,tutor_api/* getTutorStudentAmoCRMAttributes */.y7)(studentId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-student-test-results-query.ts





const useStudentTestResultsQuery = studentId => {
  const queryKey = (0,react.useMemo)(() => ["studentTestResults", studentId], [studentId]);
  return (0,useQuery/* useQuery */.a)({
    enabled: Boolean(studentId),
    queryKey,
    queryFn: () => (0,tutor_api/* getStudentTestResults */.IC)(studentId),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
// EXTERNAL MODULE: ./src/widgets/task-guide/student-tests/student-tests.tsx + 5 modules
var student_tests = __webpack_require__(88008);
;// CONCATENATED MODULE: ./src/widgets/task-guide/__student-info/types.ts


var StudentInfoTab = /* @__PURE__ */(StudentInfoTab2 => {
  StudentInfoTab2[StudentInfoTab2["Profile"] = 0] = "Profile";
  StudentInfoTab2[StudentInfoTab2["Progress"] = 1] = "Progress";
  StudentInfoTab2[StudentInfoTab2["Tests"] = 2] = "Tests";
  return StudentInfoTab2;
})(StudentInfoTab || {});
;// CONCATENATED MODULE: ./src/widgets/task-guide/__student-info/student-info-widget.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const student_info_widget_module = ({"root":"student-info-widget-module__root--hp9bN","task":"student-info-widget-module__task--rT9pE","center":"student-info-widget-module__center--pb_Q9","marker":"student-info-widget-module__marker--Io1G5"});
;// CONCATENATED MODULE: ./src/widgets/task-guide/__student-info/student-info-widget.tsx























const StudentInfoLoading = () => /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
  className: student_info_widget_module.center,
  children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
});
const StudentInfoError = _ref => {
  let {
    text
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("section", {
    className: student_info_widget_module.center,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body1Accent,
      children: text
    })
  });
};
const StudentInfoWidget = _ref2 => {
  let {
    initialTabId = StudentInfoTab.Progress,
    studentTestNeedNotify
  } = _ref2;
  const ref = (0,react.useRef)(null);
  const intl = (0,useIntl/* default */.Z)();
  const {
    selectNavigationTab,
    handleSkipMotherTask,
    handleUnSkipMotherTask,
    onExpandMotherTask,
    handleClickTaskIcon,
    handleClickTask,
    doneMotherTasksGroupedByUpdatedAt,
    studentId,
    currentSpeakingSession
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const {
    data: amoAttributesData,
    isLoading: isAmoAttributesLoading,
    isError: isAmoAttributesError,
    error: amoAttributesError
  } = useStudentAMOAttributesQuery(studentId);
  const {
    data: studentTestResultsData,
    isLoading: isStudentTestResultsLoading,
    isError: isStudentTestResultsError,
    error: studentTestResultsError
  } = useStudentTestResultsQuery(studentId);
  const studentName = currentSpeakingSession?.speakingSession.student?.publicName;
  const {
    headerHeight
  } = useTaskGuideLayoutSizeContext();
  const [tabId, setTabId] = (0,react.useState)(initialTabId);
  const headerButtons = (0,react.useMemo)(() => [{
    id: StudentInfoTab.Profile,
    title: "taskGuide.profile.title"
  }, {
    id: StudentInfoTab.Progress,
    title: "taskGuide.progress.title"
  }, {
    id: StudentInfoTab.Tests,
    title: "taskGuide.tests.title",
    className: studentTestNeedNotify ? student_info_widget_module.marker : ""
  }].map(_ref3 => {
    let {
      title,
      id,
      className
    } = _ref3;
    return {
      title: intl.formatMessage({
        id: title
      }),
      onClick: () => setTabId(id),
      selected: tabId === id,
      className
    };
  }), [tabId, intl, studentTestNeedNotify]);
  const content = (0,react.useMemo)(() => {
    switch (tabId) {
      case StudentInfoTab.Profile:
        if (isAmoAttributesLoading) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentInfoLoading, {});
        }
        if (isAmoAttributesError) {
          logger/* Logger */.Yd.captureError("[StudentInfo] Failed to load student AMO attributes", {
            error: amoAttributesError,
            studentId
          }, {
            block: "StudentInfo",
            type: "network"
          });
          return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentInfoError, {
            text: "Failed to load attributes data"
          });
        }
        return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentProfile, {
          studentId,
          name: studentName,
          ...amoAttributesData
        });
      case StudentInfoTab.Progress:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideStudentProgress, {
          lessons: doneMotherTasksGroupedByUpdatedAt,
          listRef: ref,
          children: _ref4 => {
            let {
              currentData,
              refreshList,
              index
            } = _ref4;
            return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideMotherTask, {
              id: currentData.id,
              state: currentData.state,
              title: currentData.title,
              expanded: currentData.expanded,
              selectedNavigationTabType: currentData.selectedNavigationTabType,
              onSelectNavigationTab: tab => {
                selectNavigationTab(currentData.id, tab);
                refreshList(index);
              },
              onUnSkip: () => {
                handleUnSkipMotherTask({
                  motherTaskId: currentData.id
                });
                refreshList(index);
              },
              onSkip: () => {
                handleSkipMotherTask({
                  motherTaskId: currentData.id
                });
                refreshList(index);
              },
              type: currentData.type,
              onExpand: () => {
                onExpandMotherTask(currentData.id);
                refreshList(index);
              },
              children: currentData.tasks.map(task => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: student_info_widget_module.task,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(task_guide_task_component/* TaskGuideTask */.s, {
                  state: task.state,
                  expanded: task.expanded,
                  text: task.text,
                  expendedContent: task.expendedContent,
                  onClick: () => {
                    handleClickTask({
                      taskId: task.id,
                      motherTaskId: currentData.id
                    });
                    refreshList(index);
                  },
                  onClickIcon: () => {
                    handleClickTaskIcon({
                      taskId: task.id,
                      motherTaskId: currentData.id
                    });
                    refreshList(index);
                  }
                })
              }, task.id))
            });
          }
        });
      case StudentInfoTab.Tests:
        if (isStudentTestResultsLoading) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentInfoLoading, {});
        }
        if (isStudentTestResultsError) {
          logger/* Logger */.Yd.captureError("[StudentTests] Failed to load student test results", {
            error: studentTestResultsError,
            studentId
          }, {
            block: "StudentInfo",
            type: "network"
          });
          return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentInfoError, {
            text: "Failed to load student tests data"
          });
        }
        if (studentTestResultsData) {
          return /* @__PURE__ */(0,jsx_runtime.jsx)(student_tests/* StudentTests */.s, {
            testResults: studentTestResultsData
          });
        }
        return null;
      default:
        return null;
    }
  }, [isAmoAttributesLoading, isStudentTestResultsLoading, isAmoAttributesError, isStudentTestResultsError, amoAttributesError, amoAttributesData, studentTestResultsData, studentTestResultsError, tabId, studentId, studentName, doneMotherTasksGroupedByUpdatedAt, selectNavigationTab, handleUnSkipMotherTask, handleSkipMotherTask, onExpandMotherTask, handleClickTask, handleClickTaskIcon]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
    children: _ref5 => {
      let {
        height,
        width
      } = _ref5;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: student_info_widget_module.root,
        style: {
          height: height - 80 - headerHeight,
          width
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ProfileLayout, {
          headerButtons,
          children: content
        })
      });
    }
  });
};
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var isAfter = __webpack_require__(51461);
// EXTERNAL MODULE: ./src/services/taskGuide/utils.tsx
var utils = __webpack_require__(55820);
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-speaking-session-start.ts







const START_LESSON_REMINDER_TIME_MS = 1e4;
const useSpeakingSessionStart = (speakingSession, lessonState, callback) => {
  const timeOutHandler = (0,react.useCallback)(() => {
    if (speakingSession === null) {
      return;
    }
    const currentTime = /* @__PURE__ */new Date();
    const isStarted = (0,isAfter/* isAfter */.A)(currentTime, speakingSession.startAt);
    const isFinished = (0,isAfter/* isAfter */.A)(currentTime, (0,addMinutes/* addMinutes */.m)(speakingSession.startAt, speakingSession_model/* DEFAULT_LESSON_DURATION */.ip));
    if (isStarted && !isFinished) {
      callback();
    }
  }, [callback, speakingSession]);
  (0,react.useEffect)(() => {
    let timeoutId;
    const needToShowStartLessonReminder = speakingSession !== null && lessonState !== task_guide_model/* TaskGuideFSMState */.ld.ReminderStartingLessonState && speakingSession.state === speakingSession_model/* SpeakingSessionState */.Z.Scheduled;
    if (needToShowStartLessonReminder) {
      timeoutId = setInterval(timeOutHandler, START_LESSON_REMINDER_TIME_MS);
    }
    return () => {
      if (typeof timeoutId === "number") {
        clearInterval(timeoutId);
      }
    };
  }, [lessonState, speakingSession, speakingSession?.state, timeOutHandler]);
};
const useSpeakingSessionStartDisabled = (speakingSession, callback) => {
  const isCalled = (0,react.useRef)(false);
  const inintialSpeakingSessionId = (0,react.useRef)(speakingSession?.id);
  const timeOutHandler = (0,react.useCallback)(() => {
    if (speakingSession === null) {
      return;
    }
    const isStartSoon = (0,utils/* isSessionStartSoon */.cw)(speakingSession);
    if (isStartSoon && !isCalled.current) {
      isCalled.current = true;
      callback(false);
    }
  }, [callback, speakingSession]);
  (0,react.useEffect)(() => {
    if (inintialSpeakingSessionId.current !== speakingSession?.id) {
      isCalled.current = false;
      inintialSpeakingSessionId.current = speakingSession?.id;
      callback(true);
    }
  }, [callback, speakingSession?.id]);
  (0,react.useEffect)(() => {
    let timeoutId;
    if (speakingSession !== null && [speakingSession_model/* SpeakingSessionState */.Z.Scheduled, speakingSession_model/* SpeakingSessionState */.Z.InProgress].includes(speakingSession.state)) {
      timeoutId = setInterval(timeOutHandler, 1e3);
    }
    return () => {
      if (typeof timeoutId === "number") {
        clearInterval(timeoutId);
      }
    };
  }, [speakingSession, timeOutHandler]);
  return (0,react.useCallback)(() => {
    isCalled.current = false;
    callback(true);
  }, [callback]);
};
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.flat-map.js
var esnext_async_iterator_flat_map = __webpack_require__(53593);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.flat-map.js
var esnext_iterator_flat_map = __webpack_require__(25534);
// EXTERNAL MODULE: ../ui-kit/src/dropdown-with-items/dropdown-with-items.component.tsx + 1 modules
var dropdown_with_items_component = __webpack_require__(28402);
// EXTERNAL MODULE: ../../node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(4517);
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
// EXTERNAL MODULE: ./src/services/taskGuide/adapters/api.ts + 5 modules
var api = __webpack_require__(64130);
// EXTERNAL MODULE: ./src/utils/url/get-url-search-params.ts + 2 modules
var get_url_search_params = __webpack_require__(47822);
;// CONCATENATED MODULE: ./src/widgets/task-guide/hooks/use-syllabus.ts


















const useSyllabus = () => {
  const history = (0,react_router/* useHistory */.k6)();
  const {
    currentSpeakingSession,
    syllabusId: currentSyllabus,
    openAdditionalSyllabus
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const businessProductIdFromUrl = get_url_search_params.getUrlSearchParams.taskGuide.getBusinessProductId(history) ? (0,product_model/* makeBusinessProductId */.bX)(get_url_search_params.getUrlSearchParams.taskGuide.getBusinessProductId(history)) : void 0;
  const [mainSyllabus, setMainSyllabus] = (0,react.useState)(currentSpeakingSession?.speakingSession.syllabusId);
  const [additionalSyllabuses, setAdditionalSyllabuses] = (0,react.useState)([]);
  const [syllabusesNames, setSyllabusesNames] = (0,react.useState)({});
  const isAdditionalSyllabusesEnabled = additionalSyllabuses.length > 0;
  (0,react.useEffect)(() => {
    const businessProductId = currentSpeakingSession?.speakingSession.speaking.properties?.businessProductId ?? businessProductIdFromUrl;
    if (!businessProductId) {
      return;
    }
    api/* taskGuideApiAdapter */.w.getSyllabuses(businessProductId).then(res => {
      setAdditionalSyllabuses(res.filter(value => !value.isMain).map(value => value.syllabusId));
      setMainSyllabus(res.find(value => value.isMain)?.syllabusId);
      setSyllabusesNames(res.reduce((acc, value) => {
        acc[value.syllabusId] = value.syllabusName;
        return acc;
      }, {}));
    }).catch(e => {
      logger/* Logger */.Yd.captureException(e);
    });
  }, [businessProductIdFromUrl, currentSpeakingSession?.speakingSession.speaking.properties?.businessProductId]);
  const syllabusesForSwitch = (0,react.useMemo)(() => {
    if (!isAdditionalSyllabusesEnabled || !mainSyllabus) {
      return [];
    }
    return [mainSyllabus, ...additionalSyllabuses].filter(syllabusId => syllabusId !== currentSyllabus);
  }, [additionalSyllabuses, currentSyllabus, isAdditionalSyllabusesEnabled, mainSyllabus]);
  return {
    isAdditionalSyllabusesEnabled,
    currentSyllabus,
    syllabusesForSwitch,
    syllabusesNames,
    openSyllabus: openAdditionalSyllabus
  };
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/select-syllabus-button/select-syllabus-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_syllabus_button_module = ({"root":"select-syllabus-button-module__root--i3A4A","item":"select-syllabus-button-module__item--mKbiw"});
;// CONCATENATED MODULE: ./src/widgets/task-guide/select-syllabus-button/select-syllabus-button.tsx













const renderItem = (item, isSelected) => /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
  className: classnames_default()(typography_module/* default */.Z.captionAccent, select_syllabus_button_module.item),
  children: "textKey" in item ? /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
    id: item.textKey
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(message/* default */.Z, {
    id: (isSelected ? "taskGuide.levelButtonSelector." : "taskGuide.levelButtonDropdown.") + item.syllabusName
  })
});
const TaskGuideSelectSyllabusButton = () => {
  const {
    isAdditionalSyllabusesEnabled,
    currentSyllabus,
    syllabusesForSwitch,
    syllabusesNames,
    openSyllabus
  } = useSyllabus();
  const items = (0,react.useMemo)(() => {
    const syllabuses = [...syllabusesForSwitch, currentSyllabus].flatMap(syllabusId => {
      if (syllabusId) {
        return {
          id: syllabusId,
          syllabusName: syllabusesNames[syllabusId]
        };
      }
      return [];
    });
    const textItem = {
      id: "0",
      textKey: "taskGuide.levelButtonTitle",
      disabled: true
    };
    return [textItem, ...syllabuses];
  }, [currentSyllabus, syllabusesForSwitch, syllabusesNames]);
  const handleSelect = (0,react.useCallback)(syllabusId => {
    if (currentSyllabus !== syllabusId) {
      openSyllabus(syllabusId);
    }
  }, [currentSyllabus, openSyllabus]);
  if (!isAdditionalSyllabusesEnabled || !currentSyllabus) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: select_syllabus_button_module.root,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_with_items_component/* DropdownWithItems */.MO, {
      items,
      activeItemId: currentSyllabus,
      renderItem,
      renderSelectorItem: item => renderItem(item, true),
      placement: "top",
      autoHeight: true,
      onActiveItemChanged: handleSelect
    })
  });
};
;// CONCATENATED MODULE: ./src/widgets/task-guide/task-guide.tsx

































var MenuItem = /* @__PURE__ */(MenuItem2 => {
  MenuItem2["Library"] = "inLessonTask";
  MenuItem2["SelfStudy"] = "selfStudy";
  MenuItem2["Profile"] = "profile";
  MenuItem2["Notes"] = "notes";
  MenuItem2["Class"] = "class";
  return MenuItem2;
})(MenuItem || {});
const TaskGuide = (0,react.memo)(() => {
  const [selectedMenuItem, setSelectedMenuItem] = (0,react.useState)("class" /* Class */);
  const [isStartButtonDisabled, setIsStartButtonDisabled] = (0,react.useState)(true);
  const [loadingState, setLoadingState] = (0,react.useState)(null);
  const intl = (0,useIntl/* default */.Z)();
  const headerRef = (0,react.useRef)(null);
  const {
    handleClickTask,
    handleClickTaskIcon,
    getSyllabus,
    studentId,
    setSyllabus,
    completedTasks,
    addedTasks,
    groupedByMotherTasks,
    lessonState,
    setLessonState,
    currentSpeakingSession,
    syllabusId,
    getInitialTaskGuideData,
    buttonHandlers,
    startingSessionError,
    isNextConsecutiveSpeakingSessionSoon,
    checkNextConsecutiveSpeakingSession
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  const studentTestResults = useStudentTestResultsQuery(studentId);
  const selectedTestResultIds = (0,student_test_store/* useStudentTestStore */.C)(state => state.selectedTestResultIds);
  const needNotifyTutor = (0,react.useMemo)(() => {
    const data = studentTestResults.data;
    if (data) {
      if (data.placementTest?.needNotifyTutor && !selectedTestResultIds.includes(data.placementTest.id)) {
        return true;
      }
      return data.tests && data.tests.some(test => test.needNotifyTutor && !selectedTestResultIds.includes(test.id));
    }
    return false;
  }, [selectedTestResultIds, studentTestResults.data]);
  (0,react.useEffect)(() => {
    void getInitialTaskGuideData(studentId);
  }, [getInitialTaskGuideData, studentId]);
  const loadSyllabus = (0,react.useCallback)(() => {
    if (syllabusId !== null && studentId) {
      setLoadingState("loading");
      void getSyllabus({
        studentId,
        syllabusId
      }).then(result => {
        if ((0,Either.isLeft)(result)) {
          setLoadingState("error");
          logger/* Logger */.Yd.captureError(`Syllabus ${syllabusId} loading error for student ${studentId}`);
          return;
        }
        setSyllabus(result.right);
        setLoadingState("initial");
      });
    }
  }, [getSyllabus, setSyllabus, studentId, syllabusId]);
  (0,react.useEffect)(() => {
    loadSyllabus();
  }, [loadSyllabus]);
  const menuItems = (0,react.useMemo)(() => {
    const items = Array.from([{
      type: MenuItemType.Text,
      selected: selectedMenuItem === "class" /* Class */,
      text: intl.formatMessage({
        id: "taskGuideMenu.class"
      }),
      action: () => setSelectedMenuItem("class" /* Class */)
    }, {
      type: MenuItemType.Text,
      selected: selectedMenuItem === "inLessonTask" /* Library */,
      text: intl.formatMessage({
        id: "taskGuideMenu.library"
      }),
      action: () => setSelectedMenuItem("inLessonTask" /* Library */)
    }, {
      type: MenuItemType.Text,
      selected: selectedMenuItem === "selfStudy" /* SelfStudy */,
      text: intl.formatMessage({
        id: "taskGuideMenu.selfStudy"
      }),
      action: () => setSelectedMenuItem("selfStudy" /* SelfStudy */)
    }]);
    if (studentId) {
      items.push({
        type: MenuItemType.Icon,
        selected: selectedMenuItem === "notes" /* Notes */,
        iconName: "edit",
        ariaLabel: intl.formatMessage({
          id: "taskGuide.notesTabAriaLabel"
        }),
        action: () => setSelectedMenuItem("notes" /* Notes */)
      });
    }
    items.push({
      type: MenuItemType.Icon,
      selected: selectedMenuItem === "profile" /* Profile */,
      iconName: "user",
      ariaLabel: "Open student progress",
      action: () => setSelectedMenuItem("profile" /* Profile */),
      showMarker: needNotifyTutor
    });
    return items;
  }, [intl, selectedMenuItem, studentId, needNotifyTutor]);
  (0,react.useEffect)(() => {
    document.title = `Lesson with student: ${studentId}`;
  }, [studentId]);
  const filters = (0,react.useMemo)(() => [{
    id: 0,
    text: intl.formatMessage({
      id: "taskGuide.byTasksFilter"
    }),
    groupedData: groupedByMotherTasks
  }, {
    id: 1,
    text: intl.formatMessage({
      id: "taskGuide.addedFilter"
    }),
    groupedData: [{
      title: intl.formatMessage({
        id: "taskGuide.addedFilter"
      }),
      tasks: addedTasks
    }]
  }, {
    id: 2,
    text: intl.formatMessage({
      id: "taskGuide.completedFilter"
    }),
    groupedData: [{
      title: intl.formatMessage({
        id: "taskGuide.completedFilter"
      }),
      tasks: completedTasks
    }]
  }], [addedTasks, completedTasks, groupedByMotherTasks, intl]);
  const renderInitialState = (0,react.useCallback)(() => {
    switch (selectedMenuItem) {
      case "class" /* Class */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(ClassTasksWidget, {
          onClickEmptyStateButton: () => setSelectedMenuItem("inLessonTask" /* Library */)
        });
      case "inLessonTask" /* Library */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(LibraryWidget, {});
      case "notes" /* Notes */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(notes_component_TaskGuideNotes, {});
      case "profile" /* Profile */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(StudentInfoWidget, {
          studentTestNeedNotify: needNotifyTutor
        });
      case "selfStudy" /* SelfStudy */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideSelfStudyList, {
          taskFilters: filters,
          headerHeight: headerRef.current?.offsetHeight ?? 0,
          children: _ref => {
            let {
              task
            } = _ref;
            return /* @__PURE__ */(0,jsx_runtime.jsx)(task_guide_task_component/* TaskGuideTask */.s, {
              state: task.state,
              expanded: false,
              text: task.text,
              onClick: () => {
                handleClickTask({
                  taskId: task.chapterId,
                  motherTaskId: task.motherTaskId
                });
              },
              onClickIcon: () => {
                handleClickTaskIcon({
                  motherTaskId: task.motherTaskId,
                  taskId: task.chapterId
                });
              }
            });
          }
        });
      default:
        break;
    }
  }, [selectedMenuItem, needNotifyTutor, filters, handleClickTask, handleClickTaskIcon]);
  const renderErrorState = (0,react.useCallback)(() => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: task_guide_module/* default */.Z.errorBlock,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      children: intl.formatMessage({
        id: "taskGuide.errorText"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "primary",
      size: "small",
      onClick: loadSyllabus,
      children: intl.formatMessage({
        id: "taskGuide.errorButton"
      })
    })]
  }), [intl, loadSyllabus]);
  const handleClickLessonStatusButton = (0,react.useCallback)(async () => {
    switch (lessonState) {
      case task_guide_model/* TaskGuideFSMState */.ld.SelectingSessionState:
      case task_guide_model/* TaskGuideFSMState */.ld.SelectingSelfStudy:
        return buttonHandlers.return();
      case task_guide_model/* TaskGuideFSMState */.ld.Started:
        await checkNextConsecutiveSpeakingSession();
        setSelectedMenuItem("selfStudy" /* SelfStudy */);
        return buttonHandlers.finish();
      case task_guide_model/* TaskGuideFSMState */.ld.Initial:
        return Promise.resolve(setLessonState(task_guide_model/* TaskGuideFSMState */.ld.StartingSessionState));
      default:
        break;
    }
  }, [buttonHandlers, checkNextConsecutiveSpeakingSession, lessonState, setLessonState]);
  const lessonStatusButtonText = (0,react.useMemo)(() => {
    switch (lessonState) {
      case task_guide_model/* TaskGuideFSMState */.ld.SelectingSelfStudy:
      case task_guide_model/* TaskGuideFSMState */.ld.SelectingSessionState:
        return intl.formatMessage({
          id: "taskGuide.backToLesson"
        });
      case task_guide_model/* TaskGuideFSMState */.ld.StartingSessionState:
      case task_guide_model/* TaskGuideFSMState */.ld.Initial:
        return intl.formatMessage({
          id: "taskGuide.startLesson"
        });
      case task_guide_model/* TaskGuideFSMState */.ld.Started:
        return intl.formatMessage({
          id: "taskGuide.finishLesson"
        });
      default:
        break;
    }
  }, [intl, lessonState]);
  useSpeakingSessionStart(currentSpeakingSession?.speakingSession ?? null, lessonState, () => {
    setLessonState(task_guide_model/* TaskGuideFSMState */.ld.ReminderStartingLessonState);
  });
  const resetStartButtonDisabled = useSpeakingSessionStartDisabled(currentSpeakingSession?.speakingSession ?? null, state => {
    setIsStartButtonDisabled(state);
  });
  const taskGuideHeaderText = (0,react.useMemo)(() => {
    if (!currentSpeakingSession) {
      return null;
    }
    const startAt = currentSpeakingSession.speakingSession.startAt;
    const endAt = (0,addMinutes/* addMinutes */.m)(currentSpeakingSession.speakingSession.startAt, currentSpeakingSession.speakingSession.speaking.durationMinutes);
    const time = (0,format/* format */.WU)(startAt, "HH:mm") + "\u2014" + (0,format/* format */.WU)(endAt, "HH:mm") + ", " + (0,format/* format */.WU)(startAt, "d LLL");
    return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        "aria-label": intl.formatMessage({
          id: "taskGuide.studentName"
        }),
        className: task_guide_module/* default */.Z.name,
        children: currentSpeakingSession.speakingSession.student?.publicName
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("time", {
        "aria-label": intl.formatMessage({
          id: "taskGuide.lessonTime"
        }),
        children: time
      })]
    });
  }, [currentSpeakingSession, intl]);
  const lessonStatusButtonTooltipText = (0,react.useMemo)(() => {
    if (!isStartButtonDisabled) {
      return;
    }
    if (!currentSpeakingSession) {
      return intl.formatMessage({
        id: "taskGuide.headerTextWithoutSession"
      });
    }
    return intl.formatMessage({
      id: "taskGuideMenu.tooltipText"
    });
  }, [currentSpeakingSession, intl, isStartButtonDisabled]);
  const cannotStartSessionPopupText = (0,react.useMemo)(() => {
    if (startingSessionError === task_guide_model/* StartingSessionError */.D8.SessionCancelled) {
      return intl.formatMessage({
        id: "taskGuideStartingSessionErrorPopup.sessionCancelled"
      });
    }
    if (startingSessionError === task_guide_model/* StartingSessionError */.D8.SessionRescheduled) {
      return intl.formatMessage({
        id: "taskGuideStartingSessionErrorPopup.sessionRescheduled"
      });
    }
    return "";
  }, [intl, startingSessionError]);
  const renderContent = (0,react.useCallback)(() => {
    switch (loadingState) {
      case "loading":
        return /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* LoaderCenterDelay */.f4, {});
      case "initial":
        return renderInitialState();
      case "error":
        return renderErrorState();
      default:
        break;
    }
  }, [loadingState, renderInitialState, renderErrorState]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: task_guide_module/* default */.Z.root,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideLayout, {
        headerContent: taskGuideHeaderText,
        headerRef,
        menuItems,
        hideTaskGuideButton: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideHideButton, {}),
        selectCourseButton: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideSelectSyllabusButton, {}),
        lessonStatusButton: {
          text: lessonStatusButtonText || "",
          onClick: handleClickLessonStatusButton,
          isDisabled: isStartButtonDisabled,
          appearance: lessonState === task_guide_model/* TaskGuideFSMState */.ld.Initial ? "active" : "secondary",
          tooltipText: lessonStatusButtonTooltipText
        },
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(LayoutSizeContext.Provider, {
          value: {
            headerHeight: headerRef.current?.offsetHeight ?? 0
          },
          children: renderContent()
        })
      }), lessonState === task_guide_model/* TaskGuideFSMState */.ld.ReminderStartingLessonState && /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuidePopup, {
        dataTestId: "reminder-popup",
        overlayZIndex: TaskGuidePopupWrapperZIndex.High,
        title: intl.formatMessage({
          id: "taskGuideStartingReminder.title"
        }, {
          studentName: currentSpeakingSession?.speakingSession.student?.publicName
        }),
        subtitle: intl.formatMessage({
          id: "taskGuideStartingReminder.subtitle"
        }),
        buttons: [{
          text: intl.formatMessage({
            id: "taskGuide.startLesson"
          }),
          appearance: "primary",
          onClick: buttonHandlers.start
        }]
      }), lessonState === task_guide_model/* TaskGuideFSMState */.ld.StartingSessionState && /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuidePopup, {
        overlayZIndex: TaskGuidePopupWrapperZIndex.High,
        onClose: buttonHandlers.close,
        title: intl.formatMessage({
          id: "taskGuide.startingSessionPopupText"
        }),
        buttons: [{
          text: intl.formatMessage({
            id: "taskGuide.no"
          }),
          appearance: "secondary",
          onClick: buttonHandlers.close
        }, {
          text: intl.formatMessage({
            id: "taskGuide.start"
          }),
          appearance: "primary",
          onClick: buttonHandlers.start
        }]
      }), lessonState === task_guide_model/* TaskGuideFSMState */.ld.CannotStartSession && /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuidePopup, {
        overlayZIndex: TaskGuidePopupWrapperZIndex.High,
        title: intl.formatMessage({
          id: "taskGuideStartingSessionErrorPopup.title"
        }),
        subtitle: cannotStartSessionPopupText,
        buttons: [{
          text: intl.formatMessage({
            id: "taskGuideStartingSessionErrorPopup.buttonText"
          }),
          appearance: "primary",
          onClick: () => {
            resetStartButtonDisabled();
            return buttonHandlers.close();
          }
        }]
      }), lessonState === task_guide_model/* TaskGuideFSMState */.ld.SelectingSessionState && /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuidePopup, {
        dataTestId: "selecting-session-state",
        fixedWidth: 317,
        overlayZIndex: TaskGuidePopupWrapperZIndex.Low,
        title: intl.formatMessage({
          id: "taskGuideResumePopup.title"
        }),
        isColumnButtons: true,
        buttons: [isNextConsecutiveSpeakingSessionSoon ? {
          text: intl.formatMessage({
            id: "taskGuideResumePopup.startNextLesson"
          }),
          appearance: "green",
          onClick: buttonHandlers.startNextLesson
        } : {
          text: intl.formatMessage({
            id: "taskGuideResumePopup.finishLessonAndAddSelfStudyButton"
          }),
          appearance: "green",
          onClick: buttonHandlers.finish
        }, {
          text: intl.formatMessage({
            id: "taskGuideResumePopup.studentNoShow"
          }),
          appearance: "secondary",
          onClick: buttonHandlers.cancel(speakingSession_model/* SpeakingSessionCancelReason */.Ph.StudentNoShow)
        }, {
          text: intl.formatMessage({
            id: "taskGuideResumePopup.techIssues"
          }),
          appearance: "secondary",
          onClick: buttonHandlers.cancel(speakingSession_model/* SpeakingSessionCancelReason */.Ph.TechIssues)
        }]
      })]
    })
  });
});
TaskGuide.displayName = "TaskGuide";
;// CONCATENATED MODULE: ./src/widgets/task-guide/task-guide-app-wrapper.tsx









const TaskGuideAppWrapper = _ref => {
  let {
    children
  } = _ref;
  const {
    isVisible
  } = (0,task_guide_provider/* useTaskGuideContext */.c)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: task_guide_module/* default */.Z.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(task_guide_module/* default */.Z.taskGuideContainer, {
        [task_guide_module/* default */.Z.taskGuideContainerHidden]: !isVisible
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuide, {})
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: task_guide_module/* default */.Z.containerChildren,
      children
    })]
  });
};
const WithTaskGuideWrapper = _ref2 => {
  let {
    children,
    value
  } = _ref2;
  const {
    isEnabled,
    isVisible,
    toggleTaskGuideVisibility
  } = value;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(task_guide_provider/* TaskGuideProvider */.y, {
    value,
    children: [isEnabled && !isVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
      appearance: "secondary",
      size: "small",
      className: task_guide_module/* default */.Z.toggleButton,
      onClick: toggleTaskGuideVisibility,
      children: "Task Guide"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideAppWrapper, {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskGuideMainContentWrapper, {
        className: task_guide_module/* default */.Z.mainContentWrapper,
        children
      })
    })]
  });
};

/***/ }),

/***/ 59206:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ useTaskGuideContext),
/* harmony export */   y: () => (/* binding */ TaskGuideProvider)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);




const taskGuideDefaultValue = {
  isVisible: false
};
const TaskGuideContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(taskGuideDefaultValue);
const TaskGuideProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TaskGuideContext.Provider, {
    value,
    children
  });
};
const useTaskGuideContext = () => (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(TaskGuideContext);

/***/ }),

/***/ 22554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _n: () => (/* binding */ GetAnnouncementMarkupsResponse),
/* harmony export */   ar: () => (/* binding */ businessProductsFeatureFlagsResponse),
/* harmony export */   rb: () => (/* binding */ GetAnnouncementsResponse)
/* harmony export */ });
/* unused harmony exports AnnouncementMarkup, RawTutorGuides */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87830);
/* harmony import */ var _entities_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12888);




const AnnouncementButtonActionRaw = io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_1__.literal("externalLink"),
  href: io_ts__WEBPACK_IMPORTED_MODULE_1__.string
}), io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_1__.literal("close")
})]);
const AnnouncementMarkup = io_ts__WEBPACK_IMPORTED_MODULE_1__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  title: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  description: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  buttons: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    appearance: io_ts__WEBPACK_IMPORTED_MODULE_1__.keyof({
      primary: null,
      secondary: null,
      tertiary: null
    }),
    label: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
    action: AnnouncementButtonActionRaw
  }))
}), io_ts__WEBPACK_IMPORTED_MODULE_1__.partial({
  imageSrc: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  fullImageWidth: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean
})]);
const GetAnnouncementMarkupsResponse = io_ts__WEBPACK_IMPORTED_MODULE_1__.record(io_ts__WEBPACK_IMPORTED_MODULE_1__.string, AnnouncementMarkup);
const RawTutorGuideChapter = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  cover: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  url: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  title: io_ts__WEBPACK_IMPORTED_MODULE_1__.string
});
const RawTutorGuide = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  title: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  chapters: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(RawTutorGuideChapter)
});
const RawTutorGuides = io_ts__WEBPACK_IMPORTED_MODULE_1__.array(RawTutorGuide);
const RawFixedChapter = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  title: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  subtitle: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  chapter_id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  image: io_ts__WEBPACK_IMPORTED_MODULE_1__.string
});
const businessProductFeatureFlags = io_ts__WEBPACK_IMPORTED_MODULE_1__.partial({
  student: io_ts__WEBPACK_IMPORTED_MODULE_1__.partial({
    show_rescheduling_button: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
    show_course_map: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
    show_cancel_or_reschedule_reason_survey: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
    fixed_chapters: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(RawFixedChapter)
  }),
  resources: io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    enabled: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
    resource_types: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(io_ts__WEBPACK_IMPORTED_MODULE_1__.keyof({
      speaking_session: null,
      native_speaker_session: null
    }))
  }),
  curator_resources: io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    enabled: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean
  }),
  curator_student_list: io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    index: io_ts__WEBPACK_IMPORTED_MODULE_1__.number,
    button_text: io_ts__WEBPACK_IMPORTED_MODULE_1__.string
  }),
  auto_onboarding: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
  task_guide_class_demo: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
  progress_page: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean
});
const GetAnnouncementsResponse = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  announcements: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
    id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
    header: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
    bodyMarkdown: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
    endAt: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
    buttons: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
      appearance: io_ts__WEBPACK_IMPORTED_MODULE_1__.keyof({
        primary: null,
        secondary: null,
        tertiary: null
      }),
      text: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
      action: AnnouncementButtonActionRaw
    }))
  }))
});
const businessProductsFeatureFlagsResponse = io_ts__WEBPACK_IMPORTED_MODULE_1__.record(_entities_product__WEBPACK_IMPORTED_MODULE_0__/* .BusinessId */ .W, businessProductFeatureFlags);

/***/ }),

/***/ 88620:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: () => (/* binding */ EVENT_POST)
/* harmony export */ });
/* harmony import */ var _site_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24610);



const EVENT_POST = `${(0,_site_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAPIPath */ .NZ)()}/events`;

/***/ }),

/***/ 71524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FH: () => (/* binding */ RawDayInterval),
/* harmony export */   dG: () => (/* binding */ StudentScheduleResponse)
/* harmony export */ });
/* unused harmony exports TutorScheduleModelRaw, RawISODate, mapSplittedIntervals */
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87830);





const TutorScheduleModelRaw = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  tutor_id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  tutor_avatar: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  zoom_link: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string]),
  telemost_link: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string]),
  tutor_description: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  week_schedule: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(io_ts__WEBPACK_IMPORTED_MODULE_1__.string),
  replacement: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
  paused_from: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.number]),
  paused_until: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.number]),
  speaking_id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  public_name: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  end_at: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.number])
});
const StudentScheduleResponse = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(TutorScheduleModelRaw)
});
const RawISODate = io_ts__WEBPACK_IMPORTED_MODULE_1__.string;
const RawDayInterval = io_ts__WEBPACK_IMPORTED_MODULE_1__.tuple([RawISODate, RawISODate]);
const mapSplittedIntervals = (intervals, mapper) => {
  const result = [];
  const gapMin = 5;
  for (const interval of intervals) {
    let from = parseISO(interval[0]);
    const to = parseISO(interval[1]);
    result.push(mapper(from));
    while (isBefore(from, to)) {
      from = addMinutes(from, gapMin);
      result.push(mapper(from));
    }
  }
  return result;
};

/***/ }),

/***/ 67145:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IT: () => (/* binding */ sendSpeakingFollowUp),
/* harmony export */   LL: () => (/* binding */ patchSpeakingFollowUp),
/* harmony export */   bR: () => (/* binding */ fetchSpeakingSessionExperiments),
/* harmony export */   oy: () => (/* binding */ postSpeakingFollowUp),
/* harmony export */   tI: () => (/* binding */ getSpeakingFollowUp)
/* harmony export */ });
/* unused harmony export getSpeakingSessionExperiments */
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var fp_ts_Either__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18984);
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87830);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66176);
/* harmony import */ var _site_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24610);
/* harmony import */ var _utils_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9091);
/* harmony import */ var _speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69848);
/* harmony import */ var _speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55847);













const getSpeakingFollowUp = speakingId => (0,_utils_http__WEBPACK_IMPORTED_MODULE_5__/* .makeRequest */ .$f)(`${(0,_site_utils__WEBPACK_IMPORTED_MODULE_8__/* .getAPIPath */ .NZ)()}/tutor/speaking-sessions/${speakingId}/followup`, {
  responseType: _speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_7__/* .RawTutorSpeakingSessionFollowUp */ .JN,
  resultMapper: _speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_6__/* .mapRawTutorSpeakingSessionFollowUpResponse */ .Gs
});
const postSpeakingFollowUp = (speakingId, followUp) => (0,_utils_http__WEBPACK_IMPORTED_MODULE_5__/* .makeRequest */ .$f)(`${(0,_site_utils__WEBPACK_IMPORTED_MODULE_8__/* .getAPIPath */ .NZ)()}/tutor/speaking-sessions/${speakingId}/followup`, {
  method: "POST",
  body: {
    private_content: followUp.privateContent,
    public_content: followUp.publicContent
  },
  responseType: _speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_7__/* .RawTutorSpeakingSessionFollowUp */ .JN,
  resultMapper: _speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_6__/* .mapRawTutorSpeakingSessionFollowUpResponse */ .Gs
});
const patchSpeakingFollowUp = (speakingId, followUp) => (0,_utils_http__WEBPACK_IMPORTED_MODULE_5__/* .makeRequest */ .$f)(`${(0,_site_utils__WEBPACK_IMPORTED_MODULE_8__/* .getAPIPath */ .NZ)()}/tutor/speaking-sessions/${speakingId}/followup`, {
  method: "PUT",
  body: {
    private_content: followUp.privateContent,
    public_content: followUp.publicContent
  },
  responseType: _speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_7__/* .RawTutorSpeakingSessionFollowUp */ .JN,
  resultMapper: _speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_6__/* .mapRawTutorSpeakingSessionFollowUpResponse */ .Gs
});
const sendSpeakingFollowUp = speakingId => (0,_utils_http__WEBPACK_IMPORTED_MODULE_5__/* .makeRequest */ .$f)(`${(0,_site_utils__WEBPACK_IMPORTED_MODULE_8__/* .getAPIPath */ .NZ)()}/tutor/speaking-sessions/${speakingId}/followup/send`, {
  method: "POST",
  responseType: io_ts__WEBPACK_IMPORTED_MODULE_9__.voidType
});
const getSpeakingSessionExperiments = speakingSessionId => (0,_utils_http__WEBPACK_IMPORTED_MODULE_5__/* .makeRequest */ .$f)(`${(0,_site_utils__WEBPACK_IMPORTED_MODULE_8__/* .getAPIPath */ .NZ)()}/speaking-sessions/${speakingSessionId}/experiments`, {
  responseType: _speaking_sessions_raw_models__WEBPACK_IMPORTED_MODULE_7__/* .RawSpeakingSessionExperimentsResponse */ .zq,
  resultMapper: _speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_6__/* .mapRawStudentSpeakingSessionsExperiments */ .aj
});
const fetchSpeakingSessionExperiments = async speakingSessionId => {
  if (!speakingSessionId) {
    return (0,fp_ts_Either__WEBPACK_IMPORTED_MODULE_10__/* .left */ .t$)(new Error("speakingSessionId required"));
  }
  try {
    const speakingSessionExperimentsResponse = await getSpeakingSessionExperiments(speakingSessionId);
    if ((0,fp_ts_Either__WEBPACK_IMPORTED_MODULE_10__/* .isRight */ .tO)(speakingSessionExperimentsResponse)) {
      return (0,fp_ts_Either__WEBPACK_IMPORTED_MODULE_10__/* .right */ .F2)(speakingSessionExperimentsResponse.right.reduce((acc, experiment) => ({
        ...acc,
        ...experiment.config,
        ...experiment.params
      }), {}));
    }
    const error = new Error("Speaking session experiment type is invalid");
    _logger__WEBPACK_IMPORTED_MODULE_4__/* .Logger */ .Yd.captureException(error, {
      speakingSessionId,
      info: speakingSessionExperimentsResponse.left
    });
    return (0,fp_ts_Either__WEBPACK_IMPORTED_MODULE_10__/* .left */ .t$)(error);
  } catch (error) {
    _logger__WEBPACK_IMPORTED_MODULE_4__/* .Logger */ .Yd.captureException(error, {
      speakingSessionId
    }, {
      method: "fetchSpeakingSessionExperiments"
    });
    return (0,fp_ts_Either__WEBPACK_IMPORTED_MODULE_10__/* .left */ .t$)(new Error(error?.message ?? "Speaking session experiment fetch error"));
  }
};

/***/ }),

/***/ 69848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EH: () => (/* binding */ mapRawSpeakingSessionCancelReason),
/* harmony export */   Gs: () => (/* binding */ mapRawTutorSpeakingSessionFollowUpResponse),
/* harmony export */   M7: () => (/* binding */ mapRawSpeakingSessionState),
/* harmony export */   aj: () => (/* binding */ mapRawStudentSpeakingSessionsExperiments),
/* harmony export */   u7: () => (/* binding */ mapRawSpeakingType),
/* harmony export */   z7: () => (/* binding */ mapRawSpeakingSessionApprovalStatus)
/* harmony export */ });
/* harmony import */ var _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66176);
/* harmony import */ var _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79106);
/* harmony import */ var _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43055);
/* harmony import */ var _speaking_sessions_models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44137);






const mapRawTutorSpeakingSessionFollowUpState = state => {
  switch (state) {
    case "draft":
      return _speaking_sessions_models__WEBPACK_IMPORTED_MODULE_3__/* .TutorSpeakingSessionsFollowupState */ .U.Draft;
    case "sent":
      return _speaking_sessions_models__WEBPACK_IMPORTED_MODULE_3__/* .TutorSpeakingSessionsFollowupState */ .U.Sent;
    default:
      throw new _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_1__/* .UnhandledCaseError */ .H(state);
  }
};
const mapRawTutorSpeakingSessionFollowUpResponse = response => {
  const rawFollowUp = response.data.followup;
  return {
    id: rawFollowUp.id,
    privateContent: rawFollowUp.private_content,
    publicContent: rawFollowUp.public_content,
    speakingSessionId: rawFollowUp.speaking_session_id,
    state: mapRawTutorSpeakingSessionFollowUpState(rawFollowUp.state),
    createdAt: new Date(rawFollowUp.created_at * 1e3),
    sentAt: new Date(rawFollowUp.sent_at * 1e3),
    updatedAt: new Date(rawFollowUp.updated_at * 1e3)
  };
};
const mapRawSpeakingSessionState = state => {
  switch (state) {
    case "cancelled_automatically":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.CancelledAutomatically;
    case "cancelled_billed":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.CancelledBilled;
    case "cancelled_unbilled":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.CancelledUnbilled;
    case "unbilled":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.Unbilled;
    case "cancelled":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.Cancelled;
    case "complete":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.Completed;
    case "scheduled":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.Scheduled;
    case "in_progress":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionState */ .Z.InProgress;
    default:
      throw new _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_1__/* .UnhandledCaseError */ .H(state);
  }
};
const mapRawSpeakingType = (type, tutorId) => {
  switch (type) {
    case "beginners_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.BEGINNERS_LESSON;
    case "general_b1_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.GENERAL_B1_LESSON;
    case "general_b2_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.GENERAL_B2_LESSON;
    case "general_c1_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.GENERAL_C1_LESSON;
    case "bus_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.BUS_LESSON;
    case "bus_analyst_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.BUS_ANALYST_LESSON;
    case "bus_product_manager_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.BUS_PRODUCT_MANAGER_LESSON;
    case "bus_b2b_pm_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.BUS_B2B_PM_LESSON;
    case "teens_a_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.TEENS_A_LESSON;
    case "teens_b_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.TEENS_B_LESSON;
    case "kids_new_lesson":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.KIDS_NEW_LESSON;
    case "a1_chapter":
    case "a2plus_flipped_native_speaker":
    case "bus_native_speaker":
    case "bus_analyst_native_speaker":
    case "bus_product_manager_native_speaker":
    case "bus_b2b_pm_native_speaker":
    case "general_b1_native_speaker":
    case "general_b2_native_speaker":
    case "general_c1_native_speaker":
    case "kids_new_native_speaker":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.NATIVE_SPEAKER;
    case "chapter":
    case "a2_chapter":
    case "a2_tune_1_chapter":
    case "a2plus_chapter":
    case "b1_chapter":
    case "b2_chapter":
    case "it":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.CHAPTER;
    case "sales":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.SALES;
    case "mentor":
    case "a2plus_flipped_personal_tutor":
    case "a2_tune_1_personal_tutor":
    case "b1_new_personal_tutor":
    case "b1_feedback_session":
    case "b1_new_speaking":
    case "speaking_course":
    case "draft":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.MENTOR;
    default:
      _yandex_langly_shared_src_logger__WEBPACK_IMPORTED_MODULE_0__/* .Logger */ .Yd.captureError("Unknown speaking type for tutor", {
        type,
        tutorId
      }, {
        block: "speaking-session.mapper",
        method: "mapRawSpeakingType"
      });
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingType */ .xP.UNKNOWN;
  }
};
const mapRawSpeakingSessionCancelReason = raw => {
  switch (raw) {
    case "student_no_show":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.StudentNoShow;
    case "tech_issues":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.TechIssues;
    case "late_cancel":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.LateCancellation;
    case "student_tutor_schedule_change":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.StudentTutorScheduleChange;
    case "cancel_tutor":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.CancelTutor;
    case "replace_tutor":
    case "replace_tutor_permanently":
    case "replace_tutor_temporary":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.ReplaceTutor;
    case "pending_cancel_by_student":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.PendingCancelByStudent;
    case "pending_cancel_by_tutor":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .SpeakingSessionCancelReason */ .Ph.PendingCancelByTutor;
  }
};
const mapRawStudentSpeakingSessionsExperiments = rawResponse => rawResponse.data.experiments;
const mapRawSpeakingSessionApprovalStatus = approvalStatus => {
  switch (approvalStatus) {
    case "assigned":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .ApprovalStatus */ .Kb.Assigned;
    case "pending":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .ApprovalStatus */ .Kb.Pending;
    case "declined":
      return _model_speaking_session_speakingSession_model__WEBPACK_IMPORTED_MODULE_2__/* .ApprovalStatus */ .Kb.Declined;
    default:
      return null;
  }
};

/***/ }),

/***/ 44137:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ TutorSpeakingSessionsFollowupState)
/* harmony export */ });


var TutorSpeakingSessionsFollowupState = /* @__PURE__ */(TutorSpeakingSessionsFollowupState2 => {
  TutorSpeakingSessionsFollowupState2["Sent"] = "sent";
  TutorSpeakingSessionsFollowupState2["Draft"] = "draft";
  return TutorSpeakingSessionsFollowupState2;
})(TutorSpeakingSessionsFollowupState || {});

/***/ }),

/***/ 55847:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   JN: () => (/* binding */ RawTutorSpeakingSessionFollowUp),
/* harmony export */   Xj: () => (/* binding */ SpeakingSessionItemRaw),
/* harmony export */   zq: () => (/* binding */ RawSpeakingSessionExperimentsResponse)
/* harmony export */ });
/* unused harmony exports RawSpeakingSessionState, RawSpeakingSessionApprovalStatus, RawSpeakingSessionsCancelReason, StudentRaw */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var _speaking_speaking_raw_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8456);
/* harmony import */ var _student_onboarding_tutors_raw_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96536);





const RawTutorSpeakingSessionFollowUp = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    followup: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
      id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
      private_content: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
      public_content: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
      sent_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
      created_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
      updated_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
      speaking_session_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
      state: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("sent"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("draft")])
    })
  })
});
const RawSpeakingSessionState = io_ts__WEBPACK_IMPORTED_MODULE_2__.keyof({
  cancelled_unbilled: null,
  unbilled: null,
  cancelled_billed: null,
  cancelled_automatically: null,
  cancelled: null,
  complete: null,
  scheduled: null,
  in_progress: null
});
const RawSpeakingSessionApprovalStatus = io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("assigned"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("pending"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("declined")]);
const RawSpeakingSessionsCancelReason = io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("student_no_show"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("tech_issues"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("late_cancel"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("student_tutor_schedule_change"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("replace_tutor_permanently"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("replace_tutor_temporary"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("replace_tutor"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("cancel_tutor"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("student"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("curator"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("pending_cancel_by_student"), io_ts__WEBPACK_IMPORTED_MODULE_2__.literal("pending_cancel_by_tutor")]);
const StudentRaw = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  public_name: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  avatar: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  paid: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  current_level_title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  default_email: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  timezone: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  first_name: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  last_name: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
})]);
const SpeakingSessionItemRaw = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  state: RawSpeakingSessionState,
  speaking: _speaking_speaking_raw_model__WEBPACK_IMPORTED_MODULE_0__/* .SpeakingRaw */ .p_,
  start_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  created_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  updated_at: io_ts__WEBPACK_IMPORTED_MODULE_2__.number
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  student: StudentRaw,
  tutor: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__["null"], _student_onboarding_tutors_raw_model__WEBPACK_IMPORTED_MODULE_1__/* .RawTutor */ .SX]),
  syllabus_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  archiving_enabled: io_ts__WEBPACK_IMPORTED_MODULE_2__.boolean,
  cancel_reason: RawSpeakingSessionsCancelReason,
  approval_status: RawSpeakingSessionApprovalStatus
})]);
const RawSpeakingSessionExperimentsResponse = io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
    experiments: io_ts__WEBPACK_IMPORTED_MODULE_2__.array(io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
      id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
      params: io_ts__WEBPACK_IMPORTED_MODULE_2__.record(io_ts__WEBPACK_IMPORTED_MODULE_2__.string, io_ts__WEBPACK_IMPORTED_MODULE_2__.unknown),
      config: io_ts__WEBPACK_IMPORTED_MODULE_2__.record(io_ts__WEBPACK_IMPORTED_MODULE_2__.string, io_ts__WEBPACK_IMPORTED_MODULE_2__.unknown),
      source: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
      priority: io_ts__WEBPACK_IMPORTED_MODULE_2__.number
    }))
  })
});

/***/ }),

/***/ 8456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p_: () => (/* binding */ SpeakingRaw),
/* harmony export */   xb: () => (/* binding */ RawSpeakingType)
/* harmony export */ });
/* unused harmony export ChapterRaw */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var _entities_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12888);
/* harmony import */ var _entities_student_attributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14325);





const RawSpeakingType = io_ts__WEBPACK_IMPORTED_MODULE_2__.keyof({
  a1_chapter: null,
  a2_chapter: null,
  a2_tune_1_chapter: null,
  a2_tune_1_personal_tutor: null,
  a2plus_chapter: null,
  a2plus_flipped_native_speaker: null,
  a2plus_flipped_personal_tutor: null,
  b1_chapter: null,
  b1_feedback_session: null,
  b1_new_personal_tutor: null,
  b1_new_speaking: null,
  b2_chapter: null,
  beginners_lesson: null,
  bus_analyst_lesson: null,
  bus_analyst_native_speaker: null,
  bus_b2b_pm_lesson: null,
  bus_b2b_pm_native_speaker: null,
  bus_lesson: null,
  bus_native_speaker: null,
  bus_product_manager_lesson: null,
  bus_product_manager_native_speaker: null,
  chapter: null,
  custdev: null,
  draft: null,
  general_b1_lesson: null,
  general_b1_native_speaker: null,
  general_b2_lesson: null,
  general_b2_native_speaker: null,
  general_c1_native_speaker: null,
  general_c1_lesson: null,
  it: null,
  mentor: null,
  sales: null,
  speaking_course: null,
  teens_a_lesson: null,
  teens_b_lesson: null,
  kids_new_lesson: null,
  kids_new_native_speaker: null
});
const ChapterRaw = io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__["null"], io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  level_title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  chapter_title: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  image_url: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
})]);
const SpeakingRaw = io_ts__WEBPACK_IMPORTED_MODULE_2__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_2__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  type: RawSpeakingType,
  type_id: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  duration_minutes: io_ts__WEBPACK_IMPORTED_MODULE_2__.number,
  chapter: ChapterRaw,
  title: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__["null"], io_ts__WEBPACK_IMPORTED_MODULE_2__.string]),
  image_url: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__["null"], io_ts__WEBPACK_IMPORTED_MODULE_2__.string])
}), io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
  description: io_ts__WEBPACK_IMPORTED_MODULE_2__.union([io_ts__WEBPACK_IMPORTED_MODULE_2__["null"], io_ts__WEBPACK_IMPORTED_MODULE_2__.string]),
  properties: io_ts__WEBPACK_IMPORTED_MODULE_2__.partial({
    business_product_id: _entities_product__WEBPACK_IMPORTED_MODULE_0__/* .BusinessId */ .W,
    scheduling_strategy: _entities_student_attributes__WEBPACK_IMPORTED_MODULE_1__/* .RawSchedulingStrategy */ .u9
  })
})]);

/***/ }),

/***/ 10400:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Pe: () => (/* binding */ markOccupiedSlots),
/* harmony export */   Sw: () => (/* binding */ mapRawTutor),
/* harmony export */   XY: () => (/* binding */ mapSplittedIntervals),
/* harmony export */   ZS: () => (/* binding */ mapTutorAvailableSlotsToMap),
/* harmony export */   Zc: () => (/* binding */ mapRawTutorAvailableSlots)
/* harmony export */ });
/* unused harmony exports mapRawOnboardingTutorResponse, mapRawOnboardingTutor, mapRawTutorAvailableSlotsV2, splitOccupiedIntervals */
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(45269);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(95790);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(7300);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(93802);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(51418);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(64597);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(8106);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(78016);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(94527);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(77689);
/* harmony import */ var _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(79106);
/* harmony import */ var _model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97953);
/* harmony import */ var _utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(63419);
/* harmony import */ var _utils_time_time__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(67288);
/* harmony import */ var _speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(69848);































const mapTutorAvailableSlotsToMap = props => {
  const {
    availabilitySlots,
    availability5MinSlots
  } = props;
  const reduceTimeSlotsToStudentScheduleDates = (acc, availabilitySlot) => {
    const dateISO = (0,date_fns__WEBPACK_IMPORTED_MODULE_28__/* .formatISO */ .c)(availabilitySlot.date, {
      representation: "date"
    });
    const item = acc.get(dateISO);
    if (item) {
      item.push(availabilitySlot.date);
    } else {
      acc.set(dateISO, [availabilitySlot.date]);
    }
    return acc;
  };
  const by30MinGap = availabilitySlots.reduce(reduceTimeSlotsToStudentScheduleDates, /* @__PURE__ */new Map());
  const by5MinGap = availability5MinSlots.reduce(reduceTimeSlotsToStudentScheduleDates, /* @__PURE__ */new Map());
  return {
    availabilitySlotsMap: by30MinGap,
    availability5MinSlotsMap: by5MinGap
  };
};
const mapRawOnboardingTutorResponse = rawResponse => rawResponse.data.map(mapRawOnboardingTutor);
const mapRawOnboardingTutor = rawTutorWithAvailability => {
  const {
    availabilitySlots,
    availability5MinSlots
  } = mapRawTutorAvailableSlotsV2(rawTutorWithAvailability);
  return {
    tutor: mapRawTutor(rawTutorWithAvailability.tutor),
    availabilitySlots,
    availability5MinSlots,
    matchRate: rawTutorWithAvailability.match_rate ?? 0,
    weightedUtilizationRate: rawTutorWithAvailability.weighted_utilization_rate,
    additionalStudentCount: rawTutorWithAvailability.additional_student_count,
    maxStudentCount: rawTutorWithAvailability.max_student_count,
    isFullTime: rawTutorWithAvailability.is_full_time,
    tutorQuality: rawTutorWithAvailability.tutor_quality,
    incorrectParametersReason: rawTutorWithAvailability.incorrect_parameters_reason
  };
};
const mapRawTutorAvailableSlots = rawTutorWithAvailability => {
  const intervals = rawTutorWithAvailability.available_intervals ?? [];
  const speakingSessionDuration = rawTutorWithAvailability.speaking_session_duration;
  const rawAvailabilitySlots = mapSplittedIntervals(intervals, speakingSessionDuration, speakingSessionDuration);
  const rawAvailability5MinSlots = mapSplittedIntervals(intervals, 5, speakingSessionDuration);
  return {
    availabilitySlots: rawAvailabilitySlots.map(mapDateToAvailableTimeSlot),
    availability5MinSlots: rawAvailability5MinSlots.map(mapDateToAvailableTimeSlot)
  };
};
const mapDateToAvailableTimeSlot = date => ({
  type: "available",
  date,
  id: (0,_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__/* .getSlotId */ .Vr)(date)
});
const mapRawTutorAvailableSlotsV2 = rawTutorWithAvailability => {
  const intervals = rawTutorWithAvailability.intervals ?? [];
  const occupiedIntervals = rawTutorWithAvailability.occupied_intervals ?? [];
  const speakingSessionDuration = rawTutorWithAvailability.speaking_session_duration;
  const rawAvailabilitySlots = mapSplittedIntervals(intervals, speakingSessionDuration, speakingSessionDuration);
  const rawAvailability5MinSlots = mapSplittedIntervals(intervals, 5, speakingSessionDuration);
  return {
    availabilitySlots: markOccupiedSlots(rawAvailabilitySlots, occupiedIntervals, speakingSessionDuration),
    availability5MinSlots: markOccupiedSlots(rawAvailability5MinSlots, occupiedIntervals, 5)
  };
};
const mapSplittedIntervals = (intervals, slotDuration, speakingSessionDuration) => {
  const result = [];
  const duration = slotDuration > speakingSessionDuration ? slotDuration : speakingSessionDuration;
  const distance = slotDuration > speakingSessionDuration ? speakingSessionDuration : slotDuration;
  for (const interval of intervals) {
    let from = (0,date_fns__WEBPACK_IMPORTED_MODULE_29__/* .parseISO */ .D)(interval.from);
    const to = (0,date_fns__WEBPACK_IMPORTED_MODULE_29__/* .parseISO */ .D)(interval.to);
    while ((0,date_fns__WEBPACK_IMPORTED_MODULE_30__/* .addMinutes */ .m)(from, duration) <= to) {
      result.push(from);
      from = (0,date_fns__WEBPACK_IMPORTED_MODULE_30__/* .addMinutes */ .m)(from, distance);
    }
  }
  return result;
};
function mapRawTutor(rawTutor) {
  return {
    timezone: rawTutor.timezone ?? void 0,
    description: rawTutor.description ?? void 0,
    defaultEmail: rawTutor.default_email ?? void 0,
    id: (0,_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__/* .makeTutorId */ .Nr)(rawTutor.id),
    avatar: rawTutor.avatar ?? _utils_avatar_avatar_utils__WEBPACK_IMPORTED_MODULE_25__/* .DEFAULT_AVATAR_URL */ .jz,
    publicName: rawTutor.public_name ?? "",
    minAssignmentTimeBeforeSessionMinutes: rawTutor.min_assignment_time_before_session_minutes,
    allowedSpeakingTypeNames: rawTutor.allowed_speaking_type_names?.map(speakingType => (0,_speaking_sessions_speaking_sessions_mapper__WEBPACK_IMPORTED_MODULE_27__/* .mapRawSpeakingType */ .u7)(speakingType, rawTutor.id))
  };
}
const areOverlapping = (slot, interval) => {
  if (slot.start.getDay() !== interval.start.getDay()) {
    return false;
  }
  const sameDayInterval = {
    start: (0,_utils_time_time__WEBPACK_IMPORTED_MODULE_26__/* .mergeDateAndTime */ .z)(slot.start, interval.start),
    end: (0,_utils_time_time__WEBPACK_IMPORTED_MODULE_26__/* .mergeDateAndTime */ .z)(slot.end, interval.end)
  };
  return (0,date_fns__WEBPACK_IMPORTED_MODULE_31__/* .areIntervalsOverlapping */ .i)(slot, sameDayInterval);
};
const splitOccupiedIntervals = occupiedIntervals => occupiedIntervals.reduce((acc, interval) => {
  let start = (0,date_fns__WEBPACK_IMPORTED_MODULE_29__/* .parseISO */ .D)(interval.from);
  const end = (0,date_fns__WEBPACK_IMPORTED_MODULE_29__/* .parseISO */ .D)(interval.to);
  if (start > end) {
    throw new Error("Invalid interval");
  }
  while (!(0,date_fns__WEBPACK_IMPORTED_MODULE_32__/* .isSameDay */ .K)(start, end)) {
    acc.push({
      start,
      end: (0,date_fns__WEBPACK_IMPORTED_MODULE_33__/* .endOfDay */ .i)(start),
      busyReasonType: convertBusyReasonType(interval.busy_reason_type)
    });
    start = (0,date_fns__WEBPACK_IMPORTED_MODULE_34__/* .startOfDay */ .b)((0,date_fns__WEBPACK_IMPORTED_MODULE_35__/* .addDays */ .E)(start, 1));
  }
  if (!(0,date_fns__WEBPACK_IMPORTED_MODULE_36__/* .isEqual */ .X)(start, end)) {
    acc.push({
      start,
      end,
      busyReasonType: convertBusyReasonType(interval.busy_reason_type)
    });
  }
  return acc;
}, []);
const convertBusyReasonType = busyReasonType => {
  switch (busyReasonType) {
    case "tutor_schedule":
      return _model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__/* .BusyReasonType */ .u8.TutorSchedule;
    case "speaking_session":
      return _model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__/* .BusyReasonType */ .u8.SpeakingSession;
    default:
      throw new _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_23__/* .UnhandledCaseError */ .H(busyReasonType);
  }
};
const markOccupiedSlots = function (slots, occupiedIntervals, slotDuration) {
  let ignoreTodayOccupiedState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const splitByDaysOccupiedIntervals = splitOccupiedIntervals(occupiedIntervals);
  const today = (0,date_fns__WEBPACK_IMPORTED_MODULE_37__/* .format */ .WU)( /* @__PURE__ */new Date(), "dd.MM");
  return slots.map(slotStart => {
    const slot = {
      start: slotStart,
      end: (0,date_fns__WEBPACK_IMPORTED_MODULE_30__/* .addMinutes */ .m)(slotStart, slotDuration)
    };
    const busyReasonsMap = /* @__PURE__ */new Map();
    splitByDaysOccupiedIntervals.forEach(currentInterval => {
      if (!areOverlapping(slot, currentInterval)) {
        return;
      }
      const key = (0,date_fns__WEBPACK_IMPORTED_MODULE_37__/* .format */ .WU)(currentInterval.start, "dd.MM");
      if (!ignoreTodayOccupiedState || key !== today) {
        if (!busyReasonsMap.has(currentInterval.busyReasonType)) {
          busyReasonsMap.set(currentInterval.busyReasonType, /* @__PURE__ */new Map());
        }
        const busyReasonMap = busyReasonsMap.get(currentInterval.busyReasonType);
        if (busyReasonMap && !busyReasonMap.has(key)) {
          busyReasonMap.set(key, currentInterval.start);
        }
      }
    });
    if (busyReasonsMap.size) {
      const busyReasons = new Map(Array.from(busyReasonsMap.entries()).map(_ref => {
        let [type, dateMap] = _ref;
        return [type, Array.from(dateMap.values())];
      }));
      return {
        date: slotStart,
        type: "occupied",
        busyReasons,
        id: (0,_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__/* .getSlotId */ .Vr)(slotStart)
      };
    }
    return {
      date: slotStart,
      type: "available",
      id: (0,_model_tutor_tutor_model__WEBPACK_IMPORTED_MODULE_24__/* .getSlotId */ .Vr)(slotStart)
    };
  });
};

/***/ }),

/***/ 96536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $D: () => (/* binding */ rawTutorInterval),
/* harmony export */   SX: () => (/* binding */ RawTutor),
/* harmony export */   tD: () => (/* binding */ rawTutorOccupiedInterval)
/* harmony export */ });
/* unused harmony exports RawTutorWithAvailability, RawOnboardingTutorsResponse */
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87830);
/* harmony import */ var _speaking_speaking_raw_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8456);




const RawTutor = io_ts__WEBPACK_IMPORTED_MODULE_1__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  id: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  default_email: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string]),
  public_name: io_ts__WEBPACK_IMPORTED_MODULE_1__.string,
  avatar: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string]),
  timezone: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string]),
  description: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string])
}), io_ts__WEBPACK_IMPORTED_MODULE_1__.partial({
  allowed_speaking_type_names: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(_speaking_speaking_raw_model__WEBPACK_IMPORTED_MODULE_0__/* .RawSpeakingType */ .xb),
  min_assignment_time_before_session_minutes: io_ts__WEBPACK_IMPORTED_MODULE_1__.number
})]);
const RawISODate = io_ts__WEBPACK_IMPORTED_MODULE_1__.string;
const rawTutorInterval = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  from: RawISODate,
  to: RawISODate
});
const rawTutorOccupiedInterval = io_ts__WEBPACK_IMPORTED_MODULE_1__.intersection([rawTutorInterval, io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  busy_reason_type: io_ts__WEBPACK_IMPORTED_MODULE_1__.keyof({
    tutor_schedule: null,
    speaking_session: null
  })
})]);
const RawTutorQualityType = io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__.keyof({
  black: null,
  orange: null,
  yellow: null,
  green: null,
  superior: null
}), io_ts__WEBPACK_IMPORTED_MODULE_1__["null"]]);
const RawTutorWithAvailability = io_ts__WEBPACK_IMPORTED_MODULE_1__.intersection([io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  tutor: RawTutor,
  intervals: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(rawTutorInterval),
  occupied_intervals: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(rawTutorOccupiedInterval),
  speaking_session_duration: io_ts__WEBPACK_IMPORTED_MODULE_1__.number,
  match_rate: io_ts__WEBPACK_IMPORTED_MODULE_1__.number
}), io_ts__WEBPACK_IMPORTED_MODULE_1__.partial({
  weighted_utilization_rate: io_ts__WEBPACK_IMPORTED_MODULE_1__.number,
  additional_student_count: io_ts__WEBPACK_IMPORTED_MODULE_1__.number,
  max_student_count: io_ts__WEBPACK_IMPORTED_MODULE_1__.number,
  is_full_time: io_ts__WEBPACK_IMPORTED_MODULE_1__.boolean,
  tutor_quality: RawTutorQualityType,
  incorrect_parameters_reason: io_ts__WEBPACK_IMPORTED_MODULE_1__.union([io_ts__WEBPACK_IMPORTED_MODULE_1__["null"], io_ts__WEBPACK_IMPORTED_MODULE_1__.string])
})]);
const RawOnboardingTutorsResponse = io_ts__WEBPACK_IMPORTED_MODULE_1__.type({
  data: io_ts__WEBPACK_IMPORTED_MODULE_1__.array(RawTutorWithAvailability)
});

/***/ }),

/***/ 89438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ StepAnswer),
/* harmony export */   y: () => (/* binding */ StepAnswerRaw)
/* harmony export */ });
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87830);



const RateStepAnswer = io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal("rate"),
  value: io_ts__WEBPACK_IMPORTED_MODULE_0__.number
  // [1; 5]
});
const RadioStepAnswer = io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal("radio"),
  value: io_ts__WEBPACK_IMPORTED_MODULE_0__.string
});
const TextStepAnswer = io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal("text"),
  value: io_ts__WEBPACK_IMPORTED_MODULE_0__.string
});
const CheckboxStepAnswer = io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal("checkbox"),
  value: io_ts__WEBPACK_IMPORTED_MODULE_0__.array(io_ts__WEBPACK_IMPORTED_MODULE_0__.string)
});
const MarkdownStepAnswer = io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  type: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal("markdown"),
  value: io_ts__WEBPACK_IMPORTED_MODULE_0__["null"]
});
const StepAnswer = io_ts__WEBPACK_IMPORTED_MODULE_0__.union([RateStepAnswer, RadioStepAnswer, TextStepAnswer, CheckboxStepAnswer, MarkdownStepAnswer]);
const StepAnswerRaw = io_ts__WEBPACK_IMPORTED_MODULE_0__.union([io_ts__WEBPACK_IMPORTED_MODULE_0__.intersection([StepAnswer, io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  is_final: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal(false),
  step_id: io_ts__WEBPACK_IMPORTED_MODULE_0__.string
})]), io_ts__WEBPACK_IMPORTED_MODULE_0__.type({
  is_final: io_ts__WEBPACK_IMPORTED_MODULE_0__.literal(true)
})]);

/***/ }),

/***/ 96799:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Sy: () => (/* binding */ shuffleArray),
/* harmony export */   ow: () => (/* binding */ emptyArray),
/* harmony export */   sP: () => (/* binding */ emptyStringArray)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _string_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25680);





function shuffleArray(arr, itemToString, hash) {
  return arr.map(item => ({
    numb: hash !== 0 ? hash & (0,_string_utils__WEBPACK_IMPORTED_MODULE_2__/* .stringToHash */ .xY)(itemToString(item)) : Math.random(),
    item
  })).sort((o1, o2) => o1.numb - o2.numb).map(obj => obj.item);
}
const emptyStringArray = [];
const emptyArray = [];

/***/ }),

/***/ 60980:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  g: () => (/* reexport */ Auth)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
// EXTERNAL MODULE: ../../node_modules/query-string/index.js
var query_string = __webpack_require__(34126);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/domain/urls.ts
var urls = __webpack_require__(92976);
;// CONCATENATED MODULE: ../shared/src/auth/yandex-passport.ts



const PASSPORT_ORIGIN = "flowservice";
const yaPassport = {
  getAuthUrl: _ref => {
    let {
      retPath
    } = _ref;
    const passportHost = (0,urls/* getExternalUrl */.Eg)("passport");
    return `${passportHost}/auth/list?retpath=${retPath}&origin=${PASSPORT_ORIGIN}`;
  },
  getLogoutUrl: _ref2 => {
    let {
      yandexUID,
      retPath
    } = _ref2;
    const passportHost = (0,urls/* getExternalUrl */.Eg)("passport");
    return `${passportHost}/passport?mode=logout&yu=${yandexUID}&retpath=${retPath}&origin=${PASSPORT_ORIGIN}`;
  },
  getRefreshCookieUrl: _ref3 => {
    let {
      retPath
    } = _ref3;
    const passportHost = (0,urls/* getExternalUrl */.Eg)("passport");
    return `${passportHost}/auth/update?retpath=${retPath}&origin=${PASSPORT_ORIGIN}`;
  }
};
;// CONCATENATED MODULE: ../shared/src/auth/auth.ts








const resetCookieAttemptKey = "resetCookieAttempt";
const Auth = {
  /** Перейти на страницу авторизации */
  redirectToPassport: () => {
    window.location.replace(yaPassport.getAuthUrl({
      retPath: encodeURIComponent(window.location.href)
    }));
  },
  /** Перейти на страницу обновления куки авторизации */
  redirectToPassportCookieReset: () => {
    let attempt = 0;
    const query = query_string.parse(window.location.search);
    const attemptAsString = query[resetCookieAttemptKey] || null;
    if (attemptAsString && !Array.isArray(attemptAsString)) {
      attempt = parseInt(attemptAsString, 10);
    }
    if (attempt === 3) {
      return;
    }
    const returnPath = new URL(window.location.href);
    returnPath.searchParams.set(resetCookieAttemptKey, `${attempt + 1}`);
    window.location.replace(yaPassport.getRefreshCookieUrl({
      retPath: encodeURIComponent(returnPath.href)
    }));
  },
  /**
   * Перейти на страницу выхода
   * @param returnPath
   */
  redirectToLogout: returnPath => {
    const defaultReturnPath = `${window.location.origin}${(0,site_utils/* getPublicPathRoot */.Cq)()}`;
    const matches = document && document.cookie.match(/(?:^|; )yandexuid=([^;]*)/);
    const yandexUID = matches ? decodeURIComponent(matches[1]) : void 0;
    const logoutUrl = yaPassport.getLogoutUrl({
      yandexUID,
      retPath: encodeURIComponent(returnPath ?? defaultReturnPath)
    });
    window.location.replace(logoutUrl);
  }
};
;// CONCATENATED MODULE: ../shared/src/auth/index.ts




/***/ }),

/***/ 3654:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D$: () => (/* binding */ generateWebcalCalendarLink),
/* harmony export */   T$: () => (/* binding */ generateGoogleCalendarLink),
/* harmony export */   ZB: () => (/* binding */ generateIcsCalendarLink),
/* harmony export */   eB: () => (/* binding */ generateYandexCalendarLink)
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7300);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77689);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45269);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34126);
/* harmony import */ var _domain_urls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92976);
/* harmony import */ var _site_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24610);






const formatISOShort = date => {
  const x = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .addMinutes */ .m)(date, date.getTimezoneOffset());
  return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* .format */ .WU)(x, "yyyyLLdd") + "T" + (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* .format */ .WU)(x, "HHmmss") + "Z";
};
const generateYandexCalendarLink = event => query_string__WEBPACK_IMPORTED_MODULE_0__.stringifyUrl({
  url: `${(0,_domain_urls__WEBPACK_IMPORTED_MODULE_1__/* .getExternalUrl */ .Eg)("yaCalendar")}/event`,
  query: {
    name: event.name,
    description: event.description,
    startTs: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* .formatISO */ .c)(event.startTime),
    endTs: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* .formatISO */ .c)(event.endTime)
  }
});
const generateGoogleCalendarLink = event => query_string__WEBPACK_IMPORTED_MODULE_0__.stringifyUrl({
  url: `${(0,_domain_urls__WEBPACK_IMPORTED_MODULE_1__/* .getExternalUrl */ .Eg)("googleCalendar")}/render`,
  query: {
    action: "TEMPLATE",
    text: event.name,
    details: event.description
  }
}) + `&dates=${formatISOShort(event.startTime)}/${formatISOShort(event.endTime)}`;
const generateWebcalCalendarLink = (userId, calendarToken) => `webcal://${window.location.host}${(0,_site_utils__WEBPACK_IMPORTED_MODULE_5__/* .getAPIPath */ .NZ)()}/calendar/${userId}?token=${calendarToken}`;
const generateIcsCalendarLink = event => {
  const processedDescription = event.description.split("\n").join("\\n");
  const fileContent = [`BEGIN:VCALENDAR`, `VERSION:2.0`, `BEGIN:VEVENT`, `DTSTART:${formatISOShort(event.startTime)}`, `DTEND:${formatISOShort(event.endTime)}`, `SUMMARY:${event.name}`, `DESCRIPTION:${processedDescription}`, `END:VEVENT`, `END:VCALENDAR`].join("\n");
  return encodeURI("data:text/calendar;charset=utf8," + fileContent).replace(/#/g, "%23");
};

/***/ }),

/***/ 29893:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  X: () => (/* binding */ TextWithLinks)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../shared/src/components/text-with-links/constants.ts


const URL_REGEXP = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
;// CONCATENATED MODULE: ../shared/src/components/text-with-links/text-with-links.tsx







const TextWithLinks = (0,react.memo)(_ref => {
  let {
    text
  } = _ref;
  if (!text) {
    return null;
  }
  const parts = text.split(/(\s+)/);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: parts.map((part, index) => {
      if (part.match(URL_REGEXP)) {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("a", {
          href: part,
          target: "_blank",
          rel: "noopener noreferrer",
          children: part
        }, index);
      }
      return /* @__PURE__ */(0,jsx_runtime.jsx)(react.Fragment, {
        children: part
      }, index);
    })
  });
});
TextWithLinks.displayName = "TextWithLinks";

/***/ }),

/***/ 51157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   XK: () => (/* binding */ IS_PROD),
/* harmony export */   Xz: () => (/* binding */ NBSP),
/* harmony export */   rI: () => (/* binding */ TIME_INTERVALS_MS)
/* harmony export */ });
/* unused harmony exports MILLISECONDS_IN_DAY, SECONDS_IN_DAY */


const IS_PROD = "production" === "production";
const NBSP = "\xA0";
const MILLISECONDS_IN_DAY = (/* unused pure expression or super */ null && (1e3 * 60 * 60 * 24));
const SECONDS_IN_DAY = (/* unused pure expression or super */ null && (60 * 60 * 24));
const TIME_INTERVALS_MS = {
  second: 1e3,
  minute: 60 * 1e3,
  hour: 60 * 60 * 1e3
};

/***/ }),

/***/ 97186:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Aq: () => (/* binding */ BrowserType),
/* harmony export */   EY: () => (/* binding */ checkMobileDevice),
/* harmony export */   IN: () => (/* binding */ isIPhone),
/* harmony export */   QN: () => (/* binding */ currentBrowserInfo),
/* harmony export */   Rt: () => (/* binding */ isSupportWebRTC),
/* harmony export */   V5: () => (/* binding */ isMac),
/* harmony export */   Y6: () => (/* binding */ currentBrowser),
/* harmony export */   s2: () => (/* binding */ isMobileDevice),
/* harmony export */   zc: () => (/* binding */ isIPad)
/* harmony export */ });
/* unused harmony exports checkIOS, isTouchDevice, getBrowserInfo */
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68760);
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26540);
/* harmony import */ var core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(280);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17863);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_4__);







const isMac = navigator.platform ? navigator.platform.toUpperCase().indexOf("MAC") !== -1 : false;
const isIPhone = navigator.platform === "iPhone";
const isIPad = navigator.platform === "iPad";
function checkIOS() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac");
}
const isMobileDevice = checkMobileDevice(navigator);
function checkMobileDevice(navigator2) {
  if (navigator2.userAgentData?.mobile === true) {
    return true;
  }
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  return toMatch.some(toMatchItem => navigator2.userAgent.match(toMatchItem));
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function parseBrowserVersion(_ref) {
  let {
    userAgentBrowserInfo,
    browser,
    userAgentVersion = ""
  } = _ref;
  let fullBrowserVersion;
  if (browser.name === "Safari") {
    [, fullBrowserVersion] = userAgentVersion.split("/");
  } else {
    [, fullBrowserVersion] = userAgentBrowserInfo.split("/");
  }
  const [majorBrowserVersion] = fullBrowserVersion.split(".");
  return {
    majorBrowserVersion: parseInt(majorBrowserVersion),
    fullBrowserVersion: parseFloat(fullBrowserVersion)
  };
}
const browsers = [{
  name: "YaBrowser"
}, {
  name: "Edge",
  userAgentBrowserName: "Edg"
}, {
  name: "Firefox"
}, {
  name: "Chrome",
  userAgentBrowserName: "CriOS"
}, {
  name: "Chrome"
}, {
  name: "Safari"
}];
function getBrowserInfo() {
  let userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
  const userAgentParts = userAgent.split(" ");
  for (const browser of browsers) {
    const userAgentPart = userAgentParts.find(userAgentPart2 => userAgentPart2.includes(browser.userAgentBrowserName || browser.name));
    if (userAgentPart) {
      const {
        majorBrowserVersion,
        fullBrowserVersion
      } = parseBrowserVersion({
        browser,
        userAgentBrowserInfo: userAgentPart,
        userAgentVersion: userAgentParts.find(userAgentPart2 => userAgentPart2.includes("Version/"))
      });
      return {
        browserName: browser.name,
        majorBrowserVersion,
        fullBrowserVersion
      };
    }
  }
}
const currentBrowserInfo = getBrowserInfo();
var BrowserType = /* @__PURE__ */(BrowserType2 => {
  BrowserType2[BrowserType2["Safari"] = 0] = "Safari";
  BrowserType2[BrowserType2["Chrome"] = 1] = "Chrome";
  BrowserType2[BrowserType2["Yandex"] = 2] = "Yandex";
  BrowserType2[BrowserType2["Firefox"] = 3] = "Firefox";
  return BrowserType2;
})(BrowserType || {});
const currentBrowser = (() => {
  if (navigator.userAgent.indexOf("YaBrowser") !== -1) {
    return 2 /* Yandex */;
  }
  if (navigator.userAgent.indexOf("Firefox") !== -1) {
    return 3 /* Firefox */;
  }
  if (navigator.userAgent.indexOf("Chrome") !== -1 || navigator.userAgent.indexOf("CriOS") !== -1) {
    return 1 /* Chrome */;
  }
  return 0 /* Safari */;
})();
const isSupportWebRTC = () => {
  try {
    return Boolean(navigator.mediaDevices.getUserMedia);
  } catch {
    return false;
  }
};

/***/ }),

/***/ 35468:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  eQ: () => (/* binding */ changeTimeSlotsTimeZone),
  Uw: () => (/* binding */ getDefaultBackendDateFormat),
  SL: () => (/* binding */ isDateIntervalsListsEqual),
  eH: () => (/* binding */ moveDateIntervalOnCurrentWeek),
  CT: () => (/* binding */ moveDateOnCurrentWeek)
});

// UNUSED EXPORTS: addWeekDayInterval, changeWeekDayInterval, convertDateIntervalToTZ, convertDateIntervalToTimeSlotRange, convertDateIntervalsToMap, convertDateIntervalsToTZ, convertTimeSlotRangeToDateInterval, getDateIntervalId, getDateIntervalWeekDay, getDayMonthPeriod, maxDate, mergeDateIntervals, mergeDateIntervalsMap, removeWeekDayInterval, splitDateIntervals

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.group-by.js
var es_object_group_by = __webpack_require__(96357);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.every.js
var esnext_async_iterator_every = __webpack_require__(83511);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.some.js
var esnext_async_iterator_some = __webpack_require__(26540);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.every.js
var esnext_iterator_every = __webpack_require__(80988);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(17863);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/date-fns/getDay.mjs
var date_fns_getDay = __webpack_require__(18832);
// EXTERNAL MODULE: ../../node_modules/date-fns/getHours.mjs
var getHours = __webpack_require__(91253);
// EXTERNAL MODULE: ../../node_modules/date-fns/getMinutes.mjs
var getMinutes = __webpack_require__(40618);
// EXTERNAL MODULE: ../../node_modules/date-fns/setDay.mjs
var setDay = __webpack_require__(54661);
// EXTERNAL MODULE: ../../node_modules/date-fns/setHours.mjs
var setHours = __webpack_require__(66930);
// EXTERNAL MODULE: ../../node_modules/date-fns/setMinutes.mjs
var setMinutes = __webpack_require__(35465);
// EXTERNAL MODULE: ../../node_modules/date-fns/setSeconds.mjs
var setSeconds = __webpack_require__(81304);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfWeek.mjs
var startOfWeek = __webpack_require__(62014);
// EXTERNAL MODULE: ../../node_modules/date-fns/isAfter.mjs
var date_fns_isAfter = __webpack_require__(51461);
// EXTERNAL MODULE: ../../node_modules/date-fns/subWeeks.mjs + 1 modules
var subWeeks = __webpack_require__(73215);
// EXTERNAL MODULE: ../../node_modules/date-fns/formatISO9075.mjs
var formatISO9075 = __webpack_require__(64732);
// EXTERNAL MODULE: ../../node_modules/date-fns/isSameDay.mjs
var date_fns_isSameDay = __webpack_require__(51418);
// EXTERNAL MODULE: ../../node_modules/date-fns/endOfDay.mjs
var endOfDay = __webpack_require__(64597);
// EXTERNAL MODULE: ../../node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(8106);
// EXTERNAL MODULE: ../../node_modules/date-fns/addDays.mjs
var addDays = __webpack_require__(78016);
// EXTERNAL MODULE: ../../node_modules/date-fns/isEqual.mjs
var isEqual = __webpack_require__(94527);
// EXTERNAL MODULE: ../../node_modules/date-fns/isBefore.mjs
var date_fns_isBefore = __webpack_require__(71502);
// EXTERNAL MODULE: ../../node_modules/date-fns/differenceInMinutes.mjs
var differenceInMinutes = __webpack_require__(34002);
// EXTERNAL MODULE: ../shared/src/constants.ts
var constants = __webpack_require__(51157);
// EXTERNAL MODULE: ../../node_modules/ts-brand/lib/index.js
var lib = __webpack_require__(44352);
;// CONCATENATED MODULE: ../shared/src/models/date/date.ts



var DateIntervalIdTag = /* @__PURE__ */(DateIntervalIdTag2 => {})(DateIntervalIdTag || {});
const date_makeDateIntervalId = (0,lib/* make */.Sy)();
// EXTERNAL MODULE: ../shared/src/timezones.utils.ts
var timezones_utils = __webpack_require__(30332);
;// CONCATENATED MODULE: ../shared/src/date.utils.ts


































const getDayMonthPeriod = (fromDate, toDate, locale) => {
  if (isSameDay(fromDate, toDate)) {
    return format(fromDate, "d MMMM", {
      locale
    });
  }
  const sameMonth = isSameMonth(fromDate, toDate);
  const startFormatString = sameMonth ? "d" : "d MMMM";
  const startString = format(fromDate, startFormatString, {
    locale
  });
  const endString = sameMonth ? format(toDate, "d MMMM", {
    locale
  }) : format(toDate, `d${NBSP}MMMM`, {
    locale
  });
  return `${startString} \u2013 ${endString}`;
};
const moveDateOnCurrentWeek = date => {
  const weekDay = (0,date_fns_getDay/* getDay */.w)(date);
  const hours = (0,getHours/* getHours */.p)(date);
  const minutes = (0,getMinutes/* getMinutes */.q)(date);
  return (0,setDay/* setDay */.v)((0,setHours/* setHours */.B)((0,setMinutes/* setMinutes */.H)((0,setSeconds/* setSeconds */.O)((0,startOfWeek/* startOfWeek */.z)( /* @__PURE__ */new Date(), {
    weekStartsOn: 1
  }), 0), minutes), hours), weekDay, {
    weekStartsOn: 1
  });
};
const moveDateIntervalOnCurrentWeek = dateInterval => {
  let from = moveDateOnCurrentWeek(dateInterval.from);
  const to = moveDateOnCurrentWeek(dateInterval.to);
  if ((0,date_fns_isAfter/* isAfter */.A)(from, to)) {
    from = (0,subWeeks/* subWeeks */.t)(from, 1);
  }
  return {
    from,
    to
  };
};
const getDefaultBackendDateFormat = date => (0,formatISO9075/* formatISO9075 */.X)((0,timezones_utils/* convertLocalToUTC */.K0)(date, true));
const maxDate = function () {
  for (var _len = arguments.length, dates = new Array(_len), _key = 0; _key < _len; _key++) {
    dates[_key] = arguments[_key];
  }
  return dates.reduce((max, date) => isAfter(date, max) ? date : max, /* @__PURE__ */new Date(0));
};
const IS_SAME_SLOT_INDICATOR_MIN = 5;
const convertTimeSlotRangeToDateInterval = timeSlotRange => ({
  from: timeSlotRange.from.date,
  to: timeSlotRange.to.date
});
const convertDateIntervalToTimeSlotRange = dateInterval => {
  if (!dateInterval) {
    return;
  }
  return {
    from: {
      date: dateInterval.from
    },
    to: {
      date: dateInterval.to
    }
  };
};
const splitDateIntervals = dateIntervals => dateIntervals.reduce((acc, timeSlot) => {
  let from = timeSlot.from;
  const to = timeSlot.to;
  if (from > to) {
    throw new Error("Invalid timeslot");
  }
  while (!(0,date_fns_isSameDay/* isSameDay */.K)(from, to)) {
    acc.push({
      from,
      to: (0,endOfDay/* endOfDay */.i)(from)
    });
    from = (0,startOfDay/* startOfDay */.b)((0,addDays/* addDays */.E)(from, 1));
  }
  if (!(0,isEqual/* isEqual */.X)(from, to)) {
    acc.push({
      from,
      to
    });
  }
  return acc;
}, []);
const mergeDateIntervals = dateIntervals => {
  if (dateIntervals.length < 2) {
    return dateIntervals;
  }
  const sortedSlots = dateIntervals.sort((prev, next) => (0,date_fns_isBefore/* isBefore */.R)(prev.from, next.from) ? -1 : 1);
  const result = [];
  let {
    from,
    to
  } = sortedSlots[0];
  for (let i = 1; i < sortedSlots.length; i++) {
    const {
      from: currentFrom,
      to: currentTo
    } = sortedSlots[i];
    if ((0,differenceInMinutes/* differenceInMinutes */.X)(currentFrom, to) >= IS_SAME_SLOT_INDICATOR_MIN) {
      result.push({
        from,
        to
      });
      from = currentFrom;
      to = currentTo;
    } else if ((0,date_fns_isAfter/* isAfter */.A)(currentTo, to)) {
      to = currentTo;
    }
    if (i === sortedSlots.length - 1) {
      result.push({
        from,
        to
      });
    }
  }
  return result;
};
const removeWeekDayInterval = (weekDay, dateIntervalId, currentWeekSchedule) => {
  const weekScheduleMap = convertDateIntervalsToMap(currentWeekSchedule);
  const currentWeekdayIntervals = weekScheduleMap.get(weekDay);
  if (!currentWeekdayIntervals) {
    return currentWeekSchedule;
  }
  const newWeekdayIntervals = currentWeekdayIntervals.filter(el => el.id !== dateIntervalId);
  weekScheduleMap.set(weekDay, newWeekdayIntervals);
  return mergeDateIntervalsMap(weekScheduleMap);
};
const changeWeekDayInterval = params => {
  const {
    weekDay,
    dateIntervalId,
    dateInterval,
    currentWeekSchedule
  } = params;
  const weekScheduleMap = convertDateIntervalsToMap(currentWeekSchedule);
  const currentWeekdayIntervals = weekScheduleMap.get(weekDay);
  if (!currentWeekdayIntervals) {
    return currentWeekSchedule;
  }
  const newWeekdayIntervals = currentWeekdayIntervals.map(el => {
    if (el.id === dateIntervalId) {
      return {
        ...dateInterval,
        id: getDateIntervalId(dateInterval)
      };
    }
    return el;
  }).sort((prev, next) => isBefore(prev.from, next.from) ? -1 : 1);
  weekScheduleMap.set(weekDay, newWeekdayIntervals);
  return mergeDateIntervalsMap(weekScheduleMap);
};
const addWeekDayInterval = (weekDay, dateInterval, currentWeekSchedule) => {
  const weekScheduleMap = convertDateIntervalsToMap(currentWeekSchedule);
  const currentWeekdayIntervals = weekScheduleMap.get(weekDay) ?? [];
  const newWeekdayIntervals = currentWeekdayIntervals.concat([{
    from: dateInterval.from,
    to: dateInterval.to,
    id: getDateIntervalId(dateInterval)
  }]).sort((prev, next) => isBefore(prev.from, next.from) ? -1 : 1);
  const res = weekScheduleMap.set(weekDay, newWeekdayIntervals);
  return mergeDateIntervalsMap(res);
};
const mergeDateIntervalsMap = weekDayIntervalsMap => mergeDateIntervals([...weekDayIntervalsMap.values()].flat());
const getDateIntervalId = dateInterval => makeDateIntervalId(new Date(dateInterval.from).getTime());
const getDateIntervalWeekDay = dateInterval => {
  const weekDay = getDay(dateInterval.from);
  return String(weekDay || 7);
};
const convertDateIntervalsToMap = dateIntervals => {
  const dateIntervalsWithId = splitDateIntervals(dateIntervals).map(dateInterval => ({
    from: dateInterval.from,
    to: dateInterval.to,
    id: getDateIntervalId(dateInterval)
  }));
  return new Map(Object.entries(Object.groupBy(dateIntervalsWithId, getDateIntervalWeekDay)));
};
const convertDateIntervalToTZ = (_ref, convertFunc) => {
  let {
    from,
    to
  } = _ref;
  return {
    from: convertFunc(from),
    to: convertFunc(to)
  };
};
const convertDateIntervalsToTZ = (dateIntervals, convertFunc) => dateIntervals.map(dateInterval => convertDateIntervalToTZ(dateInterval, convertFunc));
const changeTimeSlotsTimeZone = (slots, changeTZFunc) => splitDateIntervals(mergeDateIntervals(slots.map(slot => ({
  from: changeTZFunc(slot.from),
  to: changeTZFunc(slot.to)
}))));
function isDateIntervalsListsEqual(firstDateIntervals, secondDateIntervals) {
  const currentWeekFirstDateIntervals = changeTimeSlotsTimeZone(firstDateIntervals, timezones_utils/* convertLocalToUTC */.K0).map(interval => moveDateIntervalOnCurrentWeek(interval));
  const currentWeekSecondDateIntervals = changeTimeSlotsTimeZone(secondDateIntervals, timezones_utils/* convertLocalToUTC */.K0).map(interval => moveDateIntervalOnCurrentWeek(interval));
  if (currentWeekFirstDateIntervals.length !== currentWeekSecondDateIntervals.length) {
    return false;
  }
  return currentWeekFirstDateIntervals.every(interval => currentWeekSecondDateIntervals.some(secondInterval => interval.from.getTime() === secondInterval.from.getTime() && interval.to.getTime() === secondInterval.to.getTime()));
}

/***/ }),

/***/ 72765:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k: () => (/* binding */ isKzDomain),
/* harmony export */   kz: () => (/* binding */ kz)
/* harmony export */ });
/* unused harmony export createReplaceDomainRuToKzInHref */
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66176);








function isKzDomain() {
  let hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __webpack_require__.g.location.hostname;
  return hostname.endsWith(".kz");
}
function createReplaceDomainRuToKzInHref(hostname, captureWarning) {
  return (str, source) => {
    if (!isKzDomain(hostname)) {
      return str;
    }
    const result = kzReplaceUrls.reduce((result2, _ref) => {
      let [reg, replacement] = _ref;
      return result2.replaceAll(new RegExp(reg, "g"), replacement);
    }, str);
    const matches = result.match(/https?:\/\/[^\s/$.?#].[^\s]*\.ru[^\s]*\b/g) || [];
    if (matches.length) {
      matches.forEach(url => captureWarning("[Replace url]", {
        source,
        url
      }));
    }
    return result;
  };
}
const kz = createReplaceDomainRuToKzInHref(__webpack_require__.g.location.hostname, _logger__WEBPACK_IMPORTED_MODULE_5__/* .Logger */ .Yd.captureWarning);
const kzReplaceUrls = [["https://practicum.yandex.ru/english", "https://english.yandex.kz"], ["https://praktikum.yandex.ru/flow", "https://english.yandex.kz"], ["https://forms.yandex.ru", "https://forms.yandex.kz"], ["https://yandex.ru/support", "https://yandex.kz/support"], ["https://calendar.yandex.ru", "https://calendar.yandex.kz"], ["https://yandex.ru/legal/praktikum_termsofuse", "https://yandex.kz/legal/practicumkz_termsofuse"], ["https://yandex.ru/legal/practicum_offer", "https://yandex.kz/legal/practicumkz_offer"]];

/***/ }),

/***/ 92976:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Eg: () => (/* binding */ getExternalUrl),
/* harmony export */   Sj: () => (/* binding */ getExternalUrls),
/* harmony export */   ld: () => (/* binding */ fetchExternalUrls),
/* harmony export */   xl: () => (/* binding */ ExternalUrlsDefault)
/* harmony export */ });
/* unused harmony exports ExternalUrls, setExternalUrls */
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87830);
/* harmony import */ var _domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72765);





const ExternalUrlsDefault = {
  passport: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  faq: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  license: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  practicum_terms: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  offer: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  lawInfo: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  work: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  yaLogo: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  yaForm: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  yaCalendar: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  googleCalendar: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  yaBrowser: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  googleBrowser: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  telemost: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  textcompare: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  socialMail: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  socialTelegram: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  socialVK: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  socialWatsapp: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  socialFacebook: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  referralTerms: io_ts__WEBPACK_IMPORTED_MODULE_2__.string,
  mainLanding: io_ts__WEBPACK_IMPORTED_MODULE_2__.string
};
const ExternalUrls = io_ts__WEBPACK_IMPORTED_MODULE_2__.type(ExternalUrlsDefault);
const ExternalUrlsPartial = io_ts__WEBPACK_IMPORTED_MODULE_2__.partial(ExternalUrlsDefault);
let externalUrls = null;
const setExternalUrls = urlsDomain => {
  if ((0,_domain__WEBPACK_IMPORTED_MODULE_1__/* .isKzDomain */ .k)()) {
    externalUrls = Object.assign(urlsDomain.default, urlsDomain.kz);
    return;
  }
  externalUrls = urlsDomain.default;
};
const getExternalUrls = () => {
  if (!externalUrls) {
    throw new Error("Try to get external URLs before initialization");
  }
  return externalUrls;
};
const getExternalUrl = key => getExternalUrls()[key];
async function fetchExternalUrls(url) {
  const response = await fetch(url, {
    method: "GET"
  });
  const urlsDomain = await response.json();
  return setExternalUrls(urlsDomain);
}

/***/ }),

/***/ 45404:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N$: () => (/* binding */ getFeatures),
/* harmony export */   g3: () => (/* binding */ useGiftPurchaseAvailability),
/* harmony export */   nz: () => (/* binding */ fetchFeatures),
/* harmony export */   ye: () => (/* binding */ useFeatureFlag)
/* harmony export */ });
/* unused harmony exports defaultFeatures, setFeatures */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _domain_domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72765);




const defaultFeatures = {
  betweenTimeLimitByZoomFeature: false,
  buyGiftKz: false,
  callOnboardingEventAfterChooseTutor: true,
  cancelTutorButton: false,
  changeWebrtcProvider: false,
  classConsecutiveSpeakingSessions: false,
  classDrawingEnabled: false,
  classImageDrawingEnabled: false,
  courseMapVersions: false,
  disabledDrawingTools: [],
  giftsNewPayments: false,
  hideSpeakingCheckupSettingButton: false,
  hideTelemostControlsUntilConnected: false,
  newForeignerSpeakingsHandler: false,
  newMatchRateAvailable: false,
  newMatchRateForReplaceAvailable: false,
  risePricesHint: false,
  scheduleChange: false,
  schedulePause: false,
  socketQueue: false,
  studentAutoTutorChange: false,
  trainerNextButtonHideTimeout: 0,
  tutorVacationForm: false,
  scheduleSelectTimeA2: false,
  showProgressPageExperimentTurnOff: false,
  selectionTranslation: false,
  telegramNotification: false
};
let features = defaultFeatures;
function setFeatures(newFeatures) {
  features = newFeatures;
}
function getFeatures() {
  return features;
}
function getFeature(flagName, defaultValue) {
  const value = features[flagName] ?? defaultValue ?? defaultFeatures[flagName];
  return value;
}
function useFeatureFlag(flagName, defaultValue) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => getFeature(flagName, defaultValue), [defaultValue, flagName]);
}
async function fetchFeatures(featuresUrl) {
  await fetch(featuresUrl, {
    method: "GET"
  }).then(r => r.json()).then(setFeatures);
}
function useGiftPurchaseAvailability() {
  const buyGiftFeature = useFeatureFlag("buyGiftKz");
  return (0,_domain_domain__WEBPACK_IMPORTED_MODULE_1__/* .isKzDomain */ .k)() ? buyGiftFeature : true;
}

/***/ }),

/***/ 13083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  W4: () => (/* reexport */ onboarding/* $currentOnboardingState */.W4),
  xV: () => (/* reexport */ onboarding/* $onboardingPreferences */.xV),
  pR: () => (/* reexport */ onboarding/* $onboardingStates */.pR),
  XX: () => (/* reexport */ AUTO_ONBOARDING_STATES),
  Sb: () => (/* reexport */ types_OnboardingFSMEvent),
  Kd: () => (/* reexport */ RawOnboardingEvent),
  sR: () => (/* reexport */ getIsAutoOnboarding)
});

// UNUSED EXPORTS: getNextOnboardingState, postOnboardingEvent

// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/types.ts


var types_OnboardingFSMEvent = /* @__PURE__ */(OnboardingFSMEvent2 => {
  OnboardingFSMEvent2["Progress"] = "progress";
  OnboardingFSMEvent2["Reverse"] = "reverese";
  OnboardingFSMEvent2["Unpause"] = "unpause";
  OnboardingFSMEvent2["Cancel"] = "cancel";
  OnboardingFSMEvent2["Uncancel"] = "uncancel";
  OnboardingFSMEvent2["Unknown"] = "unknown";
  OnboardingFSMEvent2["SelectTutor"] = "selectTutor";
  OnboardingFSMEvent2["Pause"] = "pause";
  return OnboardingFSMEvent2;
})(types_OnboardingFSMEvent || {});
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/api/mapper.ts




const mapOnboardingEventTypeToRaw = event => {
  switch (event) {
    case OnboardingFSMEvent.Progress:
      return "progress";
    case OnboardingFSMEvent.Reverse:
      return "reverse";
    case OnboardingFSMEvent.Cancel:
      return "cancel";
    case OnboardingFSMEvent.Uncancel:
      return "uncancel";
    case OnboardingFSMEvent.Unpause:
      return "unpause";
    case OnboardingFSMEvent.Pause:
      return "pause";
    case OnboardingFSMEvent.SelectTutor:
      return "select_tutor";
    case OnboardingFSMEvent.Unknown:
      return "unknown";
    default:
      throw new UnhandledCaseError(event);
  }
};
const mapper_mapOnboardingEvent = event => ({
  type: "onboarding_change_state",
  payload: {
    business_product_id: event.businessProductId,
    student_id: event.studentId,
    subtype: mapOnboardingEventTypeToRaw(event.event)
  }
});
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/api/api.ts






const postOnboardingEvent = body => makeRequest(EVENT_POST, {
  method: "POST",
  body: mapOnboardingEvent(body),
  responseType: t.type({})
});
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/api/raw-models.ts



const RawOnboardingEvent = es6.keyof({
  progress: es6["null"],
  reverse: es6["null"],
  cancel: es6["null"],
  pause: es6["null"],
  unknown: es6["null"],
  unpause: es6["null"],
  uncancel: es6["null"],
  select_tutor: es6["null"]
});
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/index.ts + 7 modules
var student_attributes = __webpack_require__(14325);
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/constants.ts



const AUTO_ONBOARDING_STATES = [student_attributes/* OnboardingFSMState */.Cv.Contacts, student_attributes/* OnboardingFSMState */.Cv.Step1, student_attributes/* OnboardingFSMState */.Cv.Step2, student_attributes/* OnboardingFSMState */.Cv.SelectTimeSlots, student_attributes/* OnboardingFSMState */.Cv.SelectTutor, student_attributes/* OnboardingFSMState */.Cv.ConfirmOnboarding];
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/use-cases/get-is-auto-onboarding.ts




function getIsAutoOnboarding(currentState) {
  return !currentState || AUTO_ONBOARDING_STATES.includes(currentState) || currentState === student_attributes/* OnboardingFSMState */.Cv.Unknown;
}
// EXTERNAL MODULE: ../shared/src/entities/onboarding/model/onboarding.ts
var onboarding = __webpack_require__(79246);
;// CONCATENATED MODULE: ../shared/src/entities/onboarding/index.ts










/***/ }),

/***/ 79246:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W4: () => (/* binding */ $currentOnboardingState),
/* harmony export */   pR: () => (/* binding */ $onboardingStates),
/* harmony export */   xV: () => (/* binding */ $onboardingPreferences)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(31976);
/* harmony import */ var _student_attributes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14325);
/* harmony import */ var _user__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91485);





















const $onboardingStates = _student_attributes__WEBPACK_IMPORTED_MODULE_16__/* .$studentAttributes */ .lo.map(attributes => attributes?.onboardingStates ?? /* @__PURE__ */new Map());
const $onboardingPreferences = _student_attributes__WEBPACK_IMPORTED_MODULE_16__/* .$studentAttributes */ .lo.map(attributes => attributes?.preferences ?? []);
const $currentOnboardingState = (0,effector__WEBPACK_IMPORTED_MODULE_18__/* .combine */ .$e)($onboardingStates, _user__WEBPACK_IMPORTED_MODULE_17__/* .$currentProductBusinessId */ .Wu, _user__WEBPACK_IMPORTED_MODULE_17__/* .$initialOnboardingState */ .aZ, (onboardingStates, currentProductBusinessId, initialOnboardingState) => {
  const currentOnboardingState = currentProductBusinessId && onboardingStates.get(currentProductBusinessId);
  if (!currentOnboardingState && initialOnboardingState) {
    return initialOnboardingState;
  }
  return currentOnboardingState ?? null;
});

/***/ }),

/***/ 81347:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  xK: () => (/* reexport */ $preferences),
  kA: () => (/* reexport */ fetchPreferencesFx),
  r3: () => (/* reexport */ makePreferenceId)
});

// EXTERNAL MODULE: ../../node_modules/ts-brand/lib/index.js
var lib = __webpack_require__(44352);
;// CONCATENATED MODULE: ../shared/src/entities/preferences/types.ts



const makePreferenceId = (0,lib/* make */.Sy)();
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
;// CONCATENATED MODULE: ../shared/src/entities/preferences/api/mapper.ts





const mapStudentPreferences = response => Object.entries(response.data.preferences).map(_ref => {
  let [id, name] = _ref;
  return {
    id: makePreferenceId(id),
    name
  };
});
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/entities/preferences/api/types.ts



const StudentPreferencesResponseRaw = es6.type({
  data: es6.type({
    preferences: es6.record(es6.string, es6.string)
  })
});
;// CONCATENATED MODULE: ../shared/src/entities/preferences/api/api.ts







const PREFERENCES_GET = `${(0,site_utils/* getAPIPath */.NZ)()}/student/preferences`;
const getStudentPreferences = (0,un_either/* unEither */.K)(businessProductId => (0,http/* makeRequest */.$f)(`${PREFERENCES_GET}/${businessProductId}`, {
  resultMapper: mapStudentPreferences,
  responseType: StudentPreferencesResponseRaw
}));
;// CONCATENATED MODULE: ../shared/src/entities/preferences/model/preferences.ts




const $preferences = (0,effector/* createStore */.MT)([]);
const fetchPreferencesFx = (0,effector/* createEffect */.GW)(getStudentPreferences);
(0,effector/* sample */.UP)({
  source: fetchPreferencesFx.doneData,
  target: $preferences
});
;// CONCATENATED MODULE: ../shared/src/entities/preferences/index.ts





/***/ }),

/***/ 12888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  W: () => (/* reexport */ BusinessId),
  r: () => (/* reexport */ mapRawBusinessId)
});

// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/entities/product/api/raw-models.ts



const BusinessId = es6.keyof({
  packet: es6["null"],
  product_a: es6["null"],
  product_b: es6["null"],
  bus: es6["null"],
  bus_analyst: es6["null"],
  bus_product_manager: es6["null"],
  bus_b2b_product_manager: es6["null"],
  general_b1: es6["null"],
  general_b2: es6["null"],
  general_c1: es6["null"],
  teens_a: es6["null"],
  teens_b: es6["null"],
  kids_new: es6["null"],
  unknown: es6["null"]
});
// EXTERNAL MODULE: ../shared/src/model/product/product.model.ts
var product_model = __webpack_require__(55681);
;// CONCATENATED MODULE: ../shared/src/entities/product/api/mapper.ts



const mapRawBusinessId = rawBusinessId => {
  switch (rawBusinessId) {
    case "bus":
      return product_model/* BusinessProductId */.HV.Bus;
    case "bus_analyst":
      return product_model/* BusinessProductId */.HV.BusAnalyst;
    case "bus_product_manager":
      return product_model/* BusinessProductId */.HV.BusProductManager;
    case "bus_b2b_product_manager":
      return product_model/* BusinessProductId */.HV.BusB2bProductManager;
    case "product_a":
      return product_model/* BusinessProductId */.HV.ProductA;
    case "general_b1":
      return product_model/* BusinessProductId */.HV.GeneralB1;
    case "general_b2":
      return product_model/* BusinessProductId */.HV.GeneralB2;
    case "general_c1":
      return product_model/* BusinessProductId */.HV.GeneralC1;
    case "packet":
      return product_model/* BusinessProductId */.HV.Packet;
    case "teens_a":
      return product_model/* BusinessProductId */.HV.TeensA;
    case "teens_b":
      return product_model/* BusinessProductId */.HV.TeensB;
    case "kids_new":
      return product_model/* BusinessProductId */.HV.KidsNew;
    case "product_b":
      return product_model/* BusinessProductId */.HV.ProductB;
    default:
      return product_model/* BusinessProductId */.HV.Unknown;
  }
};
;// CONCATENATED MODULE: ../shared/src/entities/product/index.ts





/***/ }),

/***/ 20786:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ AttributesError)
/* harmony export */ });


var AttributesError = /* @__PURE__ */(AttributesError2 => {
  AttributesError2["StudentAlreadyStudying"] = "StudentAlreadyStudying";
  return AttributesError2;
})(AttributesError || {});

/***/ }),

/***/ 14325:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  H_: () => (/* reexport */ $attributesSelectedTutor),
  f2: () => (/* reexport */ $howManyTimesPerWeek),
  fQ: () => (/* reexport */ $lessonDuration),
  lo: () => (/* reexport */ $studentAttributes),
  $r: () => (/* reexport */ $studentSpeakingTypeId),
  J0: () => (/* reexport */ $weekSchedule),
  Cv: () => (/* reexport */ OnboardingFSMState),
  db: () => (/* reexport */ RawOnboardingState),
  u9: () => (/* reexport */ RawSchedulingStrategy),
  jy: () => (/* reexport */ RawStudentAttributes),
  u1: () => (/* reexport */ RawWeekSchedule),
  lB: () => (/* reexport */ getStudentAttributes),
  ZK: () => (/* reexport */ loadStudentAttributesFx),
  GS: () => (/* reexport */ mapOnboardingStateToRaw),
  VW: () => (/* reexport */ mapRawStudentOnboardingState),
  Yy: () => (/* reexport */ mapSchedulingStrategy),
  gY: () => (/* reexport */ mapStudentAttributesToRaw),
  YP: () => (/* reexport */ saveStudentAttributesFx),
  JX: () => (/* reexport */ setStudentAttributes),
  DV: () => (/* reexport */ updateStudentAttributes)
});

// UNUSED EXPORTS: formatSchedulingDate, getRawWeekSchedule, mapRawStudentAttributes

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../../node_modules/fp-ts/es6/Either.js + 1 modules
var Either = __webpack_require__(18984);
// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
// EXTERNAL MODULE: ./src/api/student/student.urls.ts
var student_urls = __webpack_require__(44328);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/utils/http.ts + 1 modules
var http = __webpack_require__(9091);
// EXTERNAL MODULE: ../shared/src/utils/un-either.ts
var un_either = __webpack_require__(19582);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/date-fns/formatISO9075.mjs
var date_fns_formatISO9075 = __webpack_require__(64732);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(95790);
// EXTERNAL MODULE: ../shared/src/date.utils.ts + 1 modules
var date_utils = __webpack_require__(35468);
// EXTERNAL MODULE: ../shared/src/entities/preferences/index.ts + 5 modules
var preferences = __webpack_require__(81347);
// EXTERNAL MODULE: ../shared/src/entities/product/index.ts + 2 modules
var product = __webpack_require__(12888);
// EXTERNAL MODULE: ../shared/src/model/speaking-session/speakingSession.model.ts
var speakingSession_model = __webpack_require__(43055);
// EXTERNAL MODULE: ../shared/src/timezones.utils.ts
var timezones_utils = __webpack_require__(30332);
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
;// CONCATENATED MODULE: ../shared/src/entities/student-attributes/types.ts


var OnboardingFSMState = /* @__PURE__ */(OnboardingFSMState2 => {
  OnboardingFSMState2["Contacts"] = "contacts";
  OnboardingFSMState2["Step1"] = "step1";
  OnboardingFSMState2["Step2"] = "step2";
  OnboardingFSMState2["SelectTimeSlots"] = "selectTimeSlots";
  OnboardingFSMState2["SelectTutor"] = "selectTutor";
  OnboardingFSMState2["ConfirmOnboarding"] = "confirmOnboarding";
  OnboardingFSMState2["Studying"] = "studying";
  OnboardingFSMState2["Cancelled"] = "cancelled";
  OnboardingFSMState2["Paused"] = "paused";
  OnboardingFSMState2["Unknown"] = "unknown";
  return OnboardingFSMState2;
})(OnboardingFSMState || {});
;// CONCATENATED MODULE: ../shared/src/entities/student-attributes/api/mapper.ts





























const DEFAULT_PACE_PER_WEEK = 4;
const MAX_PACE_PER_WEEK = 8;
const FLOW_RELEASE_YEAR = 2020;
const FLOW_RELEASE_MONTH = 3;
const FLOW_RELEASE_DATE = 7;
const fixTimeZone = date => {
  const timeZoneDiff = date.getTimezoneOffset() - ( /* @__PURE__ */new Date()).getTimezoneOffset();
  if (timeZoneDiff !== 0) {
    date.setTime(date.getTime() - timeZoneDiff * 60 * 1e3);
  }
  return date;
};
const formatSchedulingDate = (date, weekDayId) => {
  if (getDay(convertLocalToUTC(date)) === Number(weekDayId)) {
    return formatISO9075(fixTimeZone(setDay(convertLocalToUTC(date, true), Number(weekDayId))));
  }
  return formatISO9075(fixTimeZone(convertLocalToUTC(setDay(date, Number(weekDayId)), true)));
};
const getRawWeekSchedule = weekSchedule => {
  if (!weekSchedule) {
    return null;
  }
  return (0,date_utils/* changeTimeSlotsTimeZone */.eQ)(weekSchedule, timezones_utils/* convertLocalToUTC */.K0).map(slot => [(0,date_fns_formatISO9075/* formatISO9075 */.X)(slot.from), (0,date_fns_formatISO9075/* formatISO9075 */.X)(slot.to)]);
};
const mapOnboardingStateToRaw = onboardingState => {
  switch (onboardingState) {
    case OnboardingFSMState.Contacts:
      return "contacts";
    case OnboardingFSMState.SelectTimeSlots:
      return "select_slots";
    case OnboardingFSMState.SelectTutor:
      return "select_teacher";
    case OnboardingFSMState.ConfirmOnboarding:
      return "confirm_onboarding";
    case OnboardingFSMState.Step1:
      return "step1";
    case OnboardingFSMState.Step2:
      return "step2";
    case OnboardingFSMState.Studying:
      return "studying";
    case OnboardingFSMState.Paused:
      return "pause";
    case OnboardingFSMState.Cancelled:
      return "cancelled";
    default:
      return "cancelled";
  }
};
const mapProductOnboardingStates = onboardingStates => Array.from(onboardingStates.entries()).reduce((acc, _ref) => {
  let [key, value] = _ref;
  acc[key] = mapOnboardingStateToRaw(value);
  return acc;
}, {});
const mapSelectedTutorToRaw = selectedTutor => {
  if (selectedTutor === null || selectedTutor === void 0) {
    return selectedTutor;
  }
  return {
    id: selectedTutor.id,
    selected_slots: selectedTutor.selectedSlots.map(date_utils/* getDefaultBackendDateFormat */.Uw)
  };
};
const mapStudentAttributesToRaw = attributes => {
  const {
    weekSchedule,
    preferences,
    howManyTimesPerWeek,
    lessonDuration,
    needCuratorOnboarding,
    onboardingStates,
    selectedTutor,
    onboardingFlow
  } = attributes;
  const scheduleMap = getRawWeekSchedule(weekSchedule);
  return {
    attributes: {
      week_schedule: scheduleMap ?? void 0,
      preferences: preferences ?? void 0,
      times_per_week: howManyTimesPerWeek ?? void 0,
      lesson_duration: lessonDuration ?? void 0,
      is_curator_onboarding_needed: needCuratorOnboarding ?? void 0,
      onboarding_flow: onboardingFlow || void 0,
      product_onboarding_states: onboardingStates ? mapProductOnboardingStates(onboardingStates) : void 0,
      selected_tutor: mapSelectedTutorToRaw(selectedTutor)
    }
  };
};
const mapSchedulingStrategy = rawSchedulingStrategy => {
  switch (rawSchedulingStrategy) {
    case "legacy":
      return speakingSession_model/* SchedulingStrategy */.Tt.Legacy;
    case "upcoming":
      return speakingSession_model/* SchedulingStrategy */.Tt.Upcoming;
    default:
      return void 0;
  }
};
const mapRawWeekSchedule = rawWeekSchedule => {
  if (rawWeekSchedule === null) {
    return [];
  }
  const mappedRawWeekSchedule = rawWeekSchedule.map(schedule => {
    const actualFrom = (0,parseISO/* parseISO */.D)(schedule[0]);
    const actualTo = (0,parseISO/* parseISO */.D)(schedule[1]);
    const from = (0,timezones_utils/* convertUTCToLocal */.v$)(actualFrom);
    const to = (0,timezones_utils/* convertUTCToLocal */.v$)(actualTo);
    return {
      from,
      to
    };
  });
  return mappedRawWeekSchedule.map(date_utils/* moveDateIntervalOnCurrentWeek */.eH);
};
const mapSelectedTutor = tutor => {
  const selectedSlots = tutor.selected_slots.map(slot => (0,timezones_utils/* convertUTCToLocal */.v$)((0,parseISO/* parseISO */.D)(slot)));
  return {
    id: tutor.id,
    selectedSlots
  };
};
const mapRawStudentOnboardingState = rawState => {
  switch (rawState) {
    case "contacts":
      return OnboardingFSMState.Contacts;
    case "select_slots":
      return OnboardingFSMState.SelectTimeSlots;
    case "select_teacher":
      return OnboardingFSMState.SelectTutor;
    case "confirm_onboarding":
      return OnboardingFSMState.ConfirmOnboarding;
    case "step1":
      return OnboardingFSMState.Step1;
    case "step2":
      return OnboardingFSMState.Step2;
    case "studying":
      return OnboardingFSMState.Studying;
    case "pause":
      return OnboardingFSMState.Paused;
    case "cancelled":
      return OnboardingFSMState.Cancelled;
    default:
      return OnboardingFSMState.Unknown;
  }
};
const mapRawOnboardingStateRecord = record => {
  if (record === null) {
    return /* @__PURE__ */new Map();
  }
  return (0,object_utils/* getObjectKeys */.Z)(record).reduce((acc, id) => {
    acc.set((0,product/* mapRawBusinessId */.r)(id), mapRawStudentOnboardingState(record[id]));
    return acc;
  }, /* @__PURE__ */new Map());
};
const mapRawStudentAttributes = raw => {
  const data = raw.data;
  const chaptersPerWeek = data?.pace?.chapters_per_week;
  const currentProductId = data?.current_product_id ?? data?.level?.id ?? void 0;
  return {
    currentProductId,
    deprecatedLevel: data?.level,
    needOnboarding: currentProductId === void 0,
    chaptersPerWeekOrDefault: chaptersPerWeek ?? DEFAULT_PACE_PER_WEEK,
    businessId: (0,product/* mapRawBusinessId */.r)(data?.business_product_id ?? void 0),
    speakingTypeId: data?.speaking_type_id ? (0,speakingSession_model/* makeSpeakingTypeId */.TG)(data?.speaking_type_id) : void 0,
    syllabusId: data?.syllabus_id ?? void 0,
    onboardingStates: mapRawOnboardingStateRecord(data?.product_onboarding_states ?? null),
    weekSchedule: mapRawWeekSchedule(data?.week_schedule ?? null),
    preferences: data?.preferences ? data?.preferences.map(preferences/* makePreferenceId */.r3) : [],
    howManyTimesPerWeek: data?.times_per_week,
    lessonDuration: data?.lesson_duration,
    onboardingFlow: data?.onboarding_flow ?? null,
    needCuratorOnboarding: data?.is_curator_onboarding_needed ?? false,
    selectedTutor: data?.selected_tutor ? mapSelectedTutor(data?.selected_tutor) : null
  };
};
// EXTERNAL MODULE: ../shared/src/entities/student-attributes/api/model.ts
var model = __webpack_require__(20786);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/api/cms/entity-state.model.ts



const EntityState = es6.keyof({
  active: null,
  archived: null,
  draft: null,
  inactive: null
});
;// CONCATENATED MODULE: ../shared/src/api/cms/level.model.ts




const LevelBase = es6.type({
  id: es6.string,
  title: es6.string,
  order_priority: es6.union([es6["null"], es6.number])
});
const Level = es6.intersection([LevelBase, es6.type({
  topic_ids: es6.array(es6.string),
  state: EntityState,
  created_at: es6.number,
  updated_at: es6.number
})]);
// EXTERNAL MODULE: ../shared/src/api/schedule/schedule.raw-model.ts
var schedule_raw_model = __webpack_require__(71524);
;// CONCATENATED MODULE: ../shared/src/entities/student-attributes/api/raw-models.ts






const RawSchedulingStrategy = es6.keyof({
  legacy: es6["null"],
  upcoming: es6["null"]
});
const RawWeekSchedule = es6.array(schedule_raw_model/* RawDayInterval */.FH);
const RawOnboardingState = es6.keyof({
  contacts: es6["null"],
  step1: es6["null"],
  step2: es6["null"],
  select_teacher: es6["null"],
  confirm_onboarding: es6["null"],
  select_slots: es6["null"],
  pause: es6["null"],
  cancelled: es6["null"],
  studying: es6["null"]
});
const RawOnboardingStateRecord = es6.record(product/* BusinessId */.W, RawOnboardingState);
const RawSelectedTutor = es6.type({
  id: es6.string,
  selected_slots: es6.array(es6.string)
});
const RawPostAttributesBody = es6.type({
  attributes: es6.partial({
    week_schedule: RawWeekSchedule,
    preferences: es6.array(es6.string),
    times_per_week: es6.number,
    lesson_duration: es6.number,
    is_curator_onboarding_needed: es6.boolean,
    onboarding_flow: es6.union([es6.literal("auto"), es6.literal("curator"), es6.literal("auto_reselect")]),
    product_onboarding_states: RawOnboardingStateRecord,
    selected_tutor: es6.union([RawSelectedTutor, es6["null"]])
  })
});
const Pace = es6.partial({
  chapters_per_week: es6.number
});
const RawStudentAttributes = es6.type({
  data: es6.union([es6["null"], es6.partial({
    level: Level,
    current_product_id: es6.union([es6.string, es6["null"]]),
    pace: Pace,
    business_product_id: product/* BusinessId */.W,
    speaking_type_id: es6.string,
    syllabus_id: es6.string,
    product_onboarding_states: RawOnboardingStateRecord,
    week_schedule: RawWeekSchedule,
    preferences: es6.array(es6.string),
    times_per_week: es6.number,
    lesson_duration: es6.number,
    onboarding_flow: es6.union([es6.literal("auto"), es6.literal("curator"), es6.literal("auto_reselect")]),
    is_curator_onboarding_needed: es6.boolean,
    selected_tutor: es6.union([RawSelectedTutor, es6["null"]])
  })])
});
;// CONCATENATED MODULE: ../shared/src/entities/student-attributes/api/api.ts









const getStudentAttributes = options => (0,http/* makeRequest */.$f)(student_urls/* ATTRIBUTES */.N0, {
  responseType: RawStudentAttributes,
  resultMapper: mapRawStudentAttributes,
  unauthorizedHandler: options?.onUnAuthorize
});
const postStudentAttributes = (0,un_either/* unEither */.K)(body => {
  const rawBody = mapStudentAttributesToRaw(body);
  return (0,http/* makeRequest */.$f)(student_urls/* ATTRIBUTES */.N0, {
    responseType: RawStudentAttributes,
    resultMapper: mapRawStudentAttributes,
    body: rawBody,
    method: "POST",
    errorMapper(rawError) {
      if (rawError.code === "student_already_studying") {
        return model/* AttributesError */.c.StudentAlreadyStudying;
      }
      return api_model/* unexpectedError */.g;
    }
  });
});
;// CONCATENATED MODULE: ../shared/src/entities/student-attributes/model/student-attributes.ts








const [$studentAttributes, setStudentAttributes] = (0,makeStore/* makeStore */.n)(null);
const $weekSchedule = $studentAttributes.map(attributes => attributes?.weekSchedule ?? []);
const $attributesSelectedTutor = $studentAttributes.map(attributes => attributes?.selectedTutor ?? null);
const $howManyTimesPerWeek = $studentAttributes.map(attributes => attributes?.howManyTimesPerWeek ?? null);
const $lessonDuration = $studentAttributes.map(attributes => attributes?.lessonDuration ?? null);
const $studentSpeakingTypeId = $studentAttributes.map(attributes => attributes?.speakingTypeId);
const updateStudentAttributes = (0,effector/* createEvent */.yM)();
(0,effector/* sample */.UP)({
  clock: updateStudentAttributes,
  source: $studentAttributes,
  filter: prev => prev !== null,
  fn: (prev, payload) => ({
    ...prev,
    ...payload
  }),
  target: $studentAttributes
});
const loadStudentAttributesFx = (0,effector/* createEffect */.GW)(async () => {
  const result = await getStudentAttributes();
  if ((0,Either/* isLeft */.nM)(result)) {
    throw result.left;
  }
  return result.right;
});
(0,effector/* sample */.UP)({
  clock: loadStudentAttributesFx.doneData,
  target: $studentAttributes
});
const saveStudentAttributesFx = (0,effector/* createEffect */.GW)(async studentAttributes => postStudentAttributes(studentAttributes));
(0,effector/* sample */.UP)({
  clock: saveStudentAttributesFx.doneData,
  source: $studentAttributes,
  filter: studentAttributes => studentAttributes !== null,
  fn: (studentAttributes, newStudentAttributes) => ({
    ...newStudentAttributes,
    businessId: studentAttributes.businessId,
    speakingTypeId: studentAttributes.speakingTypeId,
    syllabusId: studentAttributes.syllabusId
  }),
  target: $studentAttributes
});
;// CONCATENATED MODULE: ../shared/src/entities/student-attributes/index.ts








/***/ }),

/***/ 91485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Wu: () => (/* reexport */ $currentProductBusinessId),
  aZ: () => (/* reexport */ $initialOnboardingState),
  ul: () => (/* reexport */ $me),
  i4: () => (/* reexport */ UserRole),
  rR: () => (/* reexport */ setCurrentProductBusinessId),
  i9: () => (/* reexport */ setInitialOnboardingState),
  XM: () => (/* reexport */ setMe),
  oi: () => (/* reexport */ setMeRole)
});

// EXTERNAL MODULE: ../shared/src/utils/makeStore.ts
var makeStore = __webpack_require__(76780);
;// CONCATENATED MODULE: ../shared/src/entities/user/model/product.ts



const [$currentProductBusinessId, setCurrentProductBusinessId] = (0,makeStore/* makeStore */.n)(null);
const [$initialOnboardingState, setInitialOnboardingState] = (0,makeStore/* makeStore */.n)(null);
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
;// CONCATENATED MODULE: ../shared/src/entities/user/model/me.ts




const [$me, setMe] = (0,makeStore/* makeStore */.n)(null);
const setMeRole = (0,effector/* createEvent */.yM)();
$me.on(setMeRole, (me, role) => {
  if (!me?.user) {
    return me;
  }
  return {
    ...me,
    user: {
      ...me.user,
      role
    }
  };
});
;// CONCATENATED MODULE: ../shared/src/entities/user/types/user-role.ts


var UserRole = /* @__PURE__ */(UserRole2 => {
  UserRole2["ROLE_ANONYMOUS"] = "anonymous";
  UserRole2["ROLE_BACKEND_SERVICE"] = "backend_service";
  UserRole2["ROLE_CANDIDATE_TUTOR"] = "candidate_tutor";
  UserRole2["ROLE_CONTENT_MANAGER"] = "content_manager";
  UserRole2["ROLE_DEVELOPER"] = "developer";
  UserRole2["ROLE_HR"] = "hr";
  UserRole2["ROLE_METHODOLOGIST"] = "methodologist";
  UserRole2["ROLE_STUDENT"] = "student";
  UserRole2["ROLE_SUPPORT"] = "support";
  UserRole2["ROLE_TESTER"] = "tester";
  UserRole2["ROLE_TUTOR"] = "tutor";
  UserRole2["ROLE_NEWBIE"] = "newbie";
  return UserRole2;
})(UserRole || {});
;// CONCATENATED MODULE: ../shared/src/entities/user/index.ts






/***/ }),

/***/ 83734:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ ForbiddenError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



class ForbiddenError extends Error {
  constructor() {
    super("Forbidden");
  }
}

/***/ }),

/***/ 71134:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   m: () => (/* binding */ NotFoundObjectError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



class NotFoundObjectError extends Error {
  constructor(objectName) {
    super(`Not found '${objectName}'`);
    this.name = "NotFoundObjectError";
  }
}

/***/ }),

/***/ 79106:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ UnhandledCaseError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



class UnhandledCaseError extends Error {
  constructor(param) {
    super(`Unhandled case ${param}`);
  }
}

/***/ }),

/***/ 99615:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ UnknownError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



class UnknownError extends Error {
  constructor() {
    super("Unknown error");
    this.name = "UnknownError";
  }
}

/***/ }),

/***/ 1341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: () => (/* binding */ createEventEmitter),
/* harmony export */   T: () => (/* binding */ eventEmitter)
/* harmony export */ });
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10161);
/* harmony import */ var eventemitter3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(eventemitter3__WEBPACK_IMPORTED_MODULE_0__);



const eventEmitterInstance = new eventemitter3__WEBPACK_IMPORTED_MODULE_0__.EventEmitter();
function createEventEmitter() {
  return new eventemitter3__WEBPACK_IMPORTED_MODULE_0__.EventEmitter();
}
const eventEmitter = createEventEmitter();

/***/ }),

/***/ 61297:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bi: () => (/* binding */ emptyFunction),
/* harmony export */   WK: () => (/* binding */ unexpectedFunction),
/* harmony export */   _: () => (/* binding */ emptyPromiseFunction)
/* harmony export */ });
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66176);



const emptyFunction = () => void 0;
const emptyPromiseFunction = () => Promise.resolve();
const unexpectedFunction = () => {
  _logger__WEBPACK_IMPORTED_MODULE_0__/* .Logger */ .Yd.unexpectedState();
};

/***/ }),

/***/ 52856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ getComponentSize)
/* harmony export */ });
/* harmony import */ var react_dom_server__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48090);



const getComponentSize = component => {
  const componentString = (0,react_dom_server__WEBPACK_IMPORTED_MODULE_0__.renderToStaticMarkup)(component);
  const div = document.createElement("div");
  div.innerHTML = componentString;
  div.style.display = "inline-block";
  div.style.position = "fixed";
  div.style.top = "-1000px";
  div.style.left = "-1000px";
  document.body.appendChild(div);
  const width = div.offsetWidth;
  const height = div.offsetHeight;
  document.body.removeChild(div);
  return {
    width,
    height
  };
};

/***/ }),

/***/ 73058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: () => (/* binding */ useDidMount)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const useDidMount = callback => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    callback();
  }, []);
};

/***/ }),

/***/ 93131:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ useIntlFormatContext),
/* harmony export */   x: () => (/* binding */ IntlFormatContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_errors_models_not_found_object_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71134);




const IntlFormatContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function useIntlFormatContext() {
  const intlFormatContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(IntlFormatContext);
  if (!intlFormatContext) {
    throw new _yandex_langly_shared_src_errors_models_not_found_object_error__WEBPACK_IMPORTED_MODULE_1__/* .NotFoundObjectError */ .m("IntlFormatContext");
  }
  return intlFormatContext;
}

/***/ }),

/***/ 77062:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ useBlockMainScroll),
/* harmony export */   j: () => (/* binding */ MainScrollBlocker)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



let requestsCount = 0;
const useBlockMainScroll = () => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (requestsCount === 0) {
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.scrollbarGutter = "stable";
    }
    requestsCount++;
    return () => {
      requestsCount--;
      if (requestsCount === 0) {
        document.documentElement.style.overflow = "";
      }
    };
  });
};
const MainScrollBlocker = () => {
  useBlockMainScroll();
  return null;
};

/***/ }),

/***/ 75621:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   b: () => (/* binding */ useClickOutsideRef)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const useClickOutsideRef = (ref, callback, options) => {
  const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
  // подход с contains не работает, если ref рендерится в портале
  event => {
    if (ref.current && !ref.current.contains(event.target)) {
      callback();
    }
  }, [callback, ref]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (options?.condition ?? true) {
      document.addEventListener(options?.triggerType || "mousedown", handleClick);
      return () => {
        document.removeEventListener(options?.triggerType || "mousedown", handleClick);
      };
    }
  }, [handleClick, options?.condition, options?.triggerType]);
};

/***/ }),

/***/ 28504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: () => (/* binding */ useEffectOnce)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const useEffectOnce = fn => {
  const isCalled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!isCalled.current) {
      isCalled.current = true;
      fn();
    }
  }, [fn]);
};

/***/ }),

/***/ 95812:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ useModalToggle)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const useModalToggle = () => {
  const [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  return {
    isOpen,
    handleOpen,
    handleClose
  };
};

/***/ }),

/***/ 75177:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  k: () => (/* reexport */ useScreenWidth)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
// EXTERNAL MODULE: ../../node_modules/use-subscription/index.js
var use_subscription = __webpack_require__(36718);
;// CONCATENATED MODULE: ../shared/src/hooks/use-screen-width/constants.ts


const SCREEN_WIDTH_OPTIONS = {
  maxMobileWidthPx: 720,
  maxTabletWidthPx: 1024
};
;// CONCATENATED MODULE: ../shared/src/hooks/use-screen-width/use-screen-width.ts






























const useScreenWidthHook = options => {
  let sizeSubscription = null;
  const createSizeSubscription = () => {
    const mobileMedia = window.matchMedia(`(max-width: ${options.maxMobileWidthPx}px)`);
    const tabletMedia = window.matchMedia(`(max-width: ${options.maxTabletWidthPx}px)`);
    const changeSizeSubscribers = /* @__PURE__ */new Set();
    const notifySubscribers = () => changeSizeSubscribers.forEach(s => s());
    mobileMedia.addEventListener("change", notifySubscribers);
    tabletMedia.addEventListener("change", notifySubscribers);
    const createState = (isMobile, isTablet, isDesktop) => ({
      isMobile,
      isTablet,
      isDesktop,
      isMobileOrTablet: isMobile || isTablet,
      isTabletOrDesktop: isTablet || isDesktop
    });
    const MOBILE = createState(true, false, false);
    const TABLET = createState(false, true, false);
    const DESKTOP = createState(false, false, true);
    const getCurrentState = () => {
      if (mobileMedia.matches) {
        return MOBILE;
      }
      if (tabletMedia.matches) {
        return TABLET;
      }
      return DESKTOP;
    };
    return {
      getCurrentValue: () => getCurrentState(),
      subscribe: callback => {
        changeSizeSubscribers.add(callback);
        return () => changeSizeSubscribers.delete(callback);
      }
    };
  };
  return () => {
    if (sizeSubscription === null) {
      sizeSubscription = createSizeSubscription();
    }
    return (0,use_subscription.useSubscription)(sizeSubscription);
  };
};
const useScreenWidth = useScreenWidthHook(SCREEN_WIDTH_OPTIONS);
;// CONCATENATED MODULE: ../shared/src/hooks/use-screen-width/index.ts




/***/ }),

/***/ 64829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  t: () => (/* binding */ AudioItem)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/audio-element.ts









function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class AudioElement extends Audio {
  constructor(_ref) {
    let {
      src
    } = _ref;
    super(src);
    _defineProperty(this, "errorHandlers", []);
  }
  get playing() {
    return !this.paused;
  }
  async play() {
    return super.play().catch(error => {
      this.errorHandlers.forEach(handler => handler(error));
    });
  }
  on(event, callback) {
    if (event === "error") {
      this.errorHandlers.push(callback);
    }
    this.addEventListener(mapEventType(event), callback);
    return () => this.off(event, callback);
  }
  off(event, callback) {
    if (event === "error") {
      this.errorHandlers = this.errorHandlers.filter(handler => handler !== callback);
    }
    this.removeEventListener(mapEventType(event), callback);
  }
}
function mapEventType(eventType) {
  switch (eventType) {
    case "play":
      return "playing";
    case "end":
      return "ended";
    case "load":
    case "pause":
    case "error":
      return eventType;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(eventType);
  }
}
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/interface.ts
var useAudio_interface = __webpack_require__(55645);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/audio-item.ts



function audio_item_defineProperty(obj, key, value) { key = audio_item_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function audio_item_toPropertyKey(t) { var i = audio_item_toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function audio_item_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


class AudioItem extends AudioElement {
  constructor(src) {
    let priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : useAudio_interface/* Priority */.U.Normal;
    let type = arguments.length > 2 ? arguments[2] : undefined;
    super({
      src
    });
    audio_item_defineProperty(this, "type", void 0);
    audio_item_defineProperty(this, "priority", void 0);
    this.type = type;
    this.priority = priority;
  }
}

/***/ }),

/***/ 5511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ audioPlayer)
/* harmony export */ });
/* unused harmony export DEFAULT_VOLUME_LEVEL */
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5875);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50509);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74736);
/* harmony import */ var core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_v2_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38728);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64810);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43419);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32825);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94574);
/* harmony import */ var core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_v2_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16093);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36615);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_v2_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(77829);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33281);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_v2_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(60253);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(24376);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_v2_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49225);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(79941);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57265);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(25888);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(15840);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(32442);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_v2_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(37610);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(227);
/* harmony import */ var core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_v2_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(13351);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(66176);
/* harmony import */ var _errors_audio_play_priority_error__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(72403);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(55645);





























function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



const logger = _logger__WEBPACK_IMPORTED_MODULE_27__/* .ClientLogger */ .q$.create("AudioPlayer");
const DEFAULT_VOLUME_LEVEL = 0.5;
class AudioPlayer {
  constructor() {
    _defineProperty(this, "volume", DEFAULT_VOLUME_LEVEL);
    _defineProperty(this, "playbackRate", 1);
    _defineProperty(this, "audio", null);
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "subscribers", /* @__PURE__ */new Set());
    _defineProperty(this, "subscription", {
      getCurrentValue: () => this.currentAudio,
      subscribe: callback => {
        this.subscribers.add(callback);
        return () => this.subscribers.delete(callback);
      }
    });
  }
  isInitialized() {
    return this.initialized;
  }
  initialize() {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
  }
  get currentAudio() {
    return this.audio;
  }
  set currentAudio(value) {
    this.audio = value;
  }
  setCurrentAudio(audio) {
    this.currentAudio = audio;
    this.notifySubscribers();
  }
  notifySubscribers() {
    this.subscribers.forEach(subscriber => subscriber());
  }
  canPlayAudio(audio) {
    if (audio.priority === _interface__WEBPACK_IMPORTED_MODULE_29__/* .Priority */ .U.Low && this.currentAudio?.playing && this.currentAudio.priority !== _interface__WEBPACK_IMPORTED_MODULE_29__/* .Priority */ .U.Low) {
      logger.debug("can't play low priority audio, because another audio is playing", {
        currentAudio: {
          src: this.currentAudio.src,
          priority: this.currentAudio.priority
        }
      });
      return false;
    }
    return true;
  }
  setVolume(value) {
    logger.debug("setVolume", value);
    this.volume = value;
    if (this.currentAudio) {
      this.currentAudio.volume = value;
    }
  }
  setPlaybackRate(value) {
    logger.debug("setPlaybackRate", value);
    this.playbackRate = value;
    if (this.currentAudio) {
      this.currentAudio.playbackRate = value;
    }
  }
  async playAudio(audio, options) {
    this.initialize();
    logger.debug("playAudio", {
      src: audio.src,
      priority: audio.priority
    });
    if (!this.canPlayAudio(audio)) {
      throw new _errors_audio_play_priority_error__WEBPACK_IMPORTED_MODULE_28__/* .AudioPlayPriorityError */ .Z({
        priority: audio.priority
      });
    }
    if (this.currentAudio?.playing && this.currentAudio?.src !== audio.src) {
      await this.stopAudio(this.currentAudio);
    }
    if (this.currentAudio !== audio) {
      this.setCurrentAudio(audio);
    }
    return new Promise((resolve, reject) => {
      const unsubscribe = () => {
        audio.off("play", onPlay);
        audio.off("error", onPlayError);
        audio.off("load", onLoad);
      };
      function onPlay() {
        logger.debug("onPlay");
        unsubscribe();
        resolve();
      }
      function onLoad() {
        logger.debug("onLoad");
        unsubscribe();
        resolve();
      }
      function onPlayError(e) {
        logger.debug("onPlayError", e);
        unsubscribe();
        reject(e);
      }
      audio.on("play", onPlay);
      audio.on("error", onPlayError);
      audio.on("load", onLoad);
      audio.volume = this.volume;
      audio.playbackRate = this.playbackRate;
      if (options?.time !== void 0) {
        audio.currentTime = options.time;
      }
      if (audio.playing) {
        logger.debug("audio is already playing");
        unsubscribe();
        resolve();
      } else {
        void audio.play();
      }
    });
  }
  async pauseAudio(audio) {
    logger.debug("pauseAudio", {
      src: audio.src
    });
    audio.pause();
    await Promise.resolve();
  }
  seekAudio(audio, time) {
    logger.debug("seekAudio", {
      src: audio.src,
      time
    });
    audio.currentTime = time;
  }
  async stopAudio(audio) {
    const item = audio ?? this.currentAudio;
    logger.debug("stopAudio", {
      src: item?.src
    });
    if (!item || !item.playing) {
      return;
    }
    item.pause();
    item.currentTime = 0;
    await Promise.resolve();
  }
}
const audioPlayer = new AudioPlayer();

/***/ }),

/***/ 99713:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ audioSynchronizer)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(9571);
/* harmony import */ var _errors_models_not_found_object_error__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71134);
/* harmony import */ var _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79106);
/* harmony import */ var _event_emitter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1341);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(66176);
/* harmony import */ var _audio_item__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(64829);
/* harmony import */ var _audio_player__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(5511);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(55645);

















function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








const SYNCHRONIZATION_TIMEOUT = 15e3;
const logger = _logger__WEBPACK_IMPORTED_MODULE_18__/* .ClientLogger */ .q$.create("AudioSynchronizer");
class AudioSynchronizer {
  constructor() {
    _defineProperty(this, "syncEnabled", false);
    _defineProperty(this, "_sendMessage", () => {
      throw new Error("AudioSynchronizer.sendMessage is not initialized");
    });
    /**
     * Метод обратного вызова, вызываемый при необходимости подтверждения синхронизации
     * @param onConfirmed - метод обратного вызова, вызываемый после подтверждении синхронизации
     * @info Необходимо переопределить извне
     */
    _defineProperty(this, "onConfirmationRequired", () => {
      throw new Error("AudioSynchronizer.onConfirmationRequired is not initialized");
    });
    _defineProperty(this, "requests", /* @__PURE__ */new Map());
  }
  /**
   * Метод отправки сообщения синхронизации
   * @info Необходимо переопределить извне
   */
  get sendMessage() {
    return this._sendMessage;
  }
  set sendMessage(fn) {
    this._sendMessage = message => {
      logger.debug("sendMessage", {
        message
      });
      fn(message);
    };
  }
  async playAudio(audio, options) {
    logger.debug("playAudio", {
      src: audio.src,
      priority: audio.priority,
      syncEnabled: this.syncEnabled
    });
    if (!_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.canPlayAudio(audio)) {
      return;
    }
    await _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.stopAudio();
    if (this.syncEnabled) {
      await this.sendRequest({
        type: "start_audio",
        requestId: (0,uuid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(),
        payload: {
          src: audio.src,
          priority: audio.priority,
          time: options?.time,
          type: audio.type
        }
      });
    }
    await _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.playAudio(audio, options);
  }
  async pauseAudio(audio) {
    logger.debug("pauseAudio", {
      src: audio.src,
      syncEnabled: this.syncEnabled
    });
    await _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.pauseAudio(audio);
    if (this.syncEnabled) {
      await this.sendRequest({
        type: "pause_audio",
        requestId: (0,uuid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(),
        payload: {
          src: audio.src
        }
      });
    }
  }
  async seekAudio(audio, time) {
    logger.debug("seekAudio", {
      src: audio.src,
      time,
      syncEnabled: this.syncEnabled
    });
    _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.seekAudio(audio, time);
    if (this.syncEnabled) {
      await this.sendRequest({
        type: "seek_audio",
        requestId: (0,uuid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(),
        payload: {
          src: audio.src,
          time
        }
      });
    }
  }
  async stopAudio(audio) {
    logger.debug("stopAudio", {
      syncEnabled: this.syncEnabled
    });
    await _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.stopAudio(audio);
    if (this.syncEnabled) {
      await this.sendRequest({
        type: "stop_audio",
        requestId: (0,uuid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)()
      });
    }
  }
  setVolume(value) {
    _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.setVolume(value);
  }
  async setPlaybackRate(value) {
    logger.debug("setPlaybackRate", {
      value,
      syncEnabled: this.syncEnabled
    });
    _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.setPlaybackRate(value);
    if (this.syncEnabled) {
      await this.sendRequest({
        type: "change_playback_rate",
        requestId: (0,uuid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(),
        payload: {
          value
        }
      });
    }
  }
  async close() {
    if (this.syncEnabled) {
      await this.sendRequest({
        type: "close_player",
        requestId: (0,uuid__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)()
      });
    }
  }
  async sendRequest(message) {
    const {
      requestId,
      type
    } = message;
    this.sendMessage(message);
    return new Promise((resolve, reject) => {
      this.requests.set(requestId, {
        resolve,
        reject
      });
      setTimeout(() => {
        if (this.requests.has(requestId)) {
          logger.warn(`Timeout for ${type} request reached, but no response received`, {
            requestId
          });
          reject();
        }
      }, SYNCHRONIZATION_TIMEOUT);
    });
  }
  onMessage(message) {
    logger.info("onMessage", message);
    const {
      type
    } = message;
    switch (type) {
      case "start_audio":
        {
          const sendAudioStartedResponse = () => {
            this.sendMessage({
              type: "audio_started",
              responseId: message.requestId
            });
          };
          this.onPlayRequested(message).then(sendAudioStartedResponse).catch(() => this.onConfirmationRequired(sendAudioStartedResponse));
          break;
        }
      case "pause_audio":
        this.onPauseRequested(message);
        this.sendMessage({
          type: "audio_paused",
          responseId: message.requestId
        });
        break;
      case "seek_audio":
        this.onSeekRequested(message);
        this.sendMessage({
          type: "audio_seeked",
          responseId: message.requestId
        });
        break;
      case "stop_audio":
        this.onStopRequested();
        this.sendMessage({
          type: "audio_stopped",
          responseId: message.requestId
        });
        break;
      case "change_playback_rate":
        this.onChangePlaybackRateRequested(message);
        this.sendMessage({
          type: "playback_rate_changed",
          responseId: message.requestId
        });
        break;
      case "close_player":
        this.onClosePlayerRequested();
        this.sendMessage({
          type: "payer_closed",
          responseId: message.requestId
        });
        break;
      case "audio_started":
      case "audio_paused":
      case "audio_seeked":
      case "audio_stopped":
      case "playback_rate_changed":
      case "payer_closed":
        {
          const promise = this.requests.get(message.responseId);
          if (promise) {
            promise.resolve();
            this.requests.delete(message.responseId);
          } else {
            logger.warn(`Received '${type}' message, but no request found`, {
              responseId: message.responseId
            });
          }
          break;
        }
      default:
        throw new _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_16__/* .UnhandledCaseError */ .H(type);
    }
  }
  async onPlayRequested(_ref) {
    let {
      payload: {
        src,
        priority,
        time,
        type
      }
    } = _ref;
    logger.debug("onPlayRequested", {
      src,
      priority
    });
    if (_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio?.src !== src) {
      const audio = new _audio_item__WEBPACK_IMPORTED_MODULE_19__/* .AudioItem */ .t(src, priority ?? _interface__WEBPACK_IMPORTED_MODULE_21__/* .Priority */ .U.Normal, type);
      audio.currentTime = time ?? 0;
      await _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.playAudio(audio);
    } else {
      if (time !== void 0) {
        _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.seekAudio(_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio, time);
      }
      await _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.playAudio(_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio);
    }
  }
  onPauseRequested(_ref2) {
    let {
      payload: {
        src
      }
    } = _ref2;
    logger.debug("onPauseRequested", {
      src
    });
    if (_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio?.playing) {
      void _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.pauseAudio(_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio);
    } else {
      logger.debug("Pause requested, but no audio is playing");
    }
  }
  onSeekRequested(_ref3) {
    let {
      payload: {
        src,
        time
      }
    } = _ref3;
    logger.debug("onSeekRequested", {
      src
    });
    if (time === void 0) {
      throw new _errors_models_not_found_object_error__WEBPACK_IMPORTED_MODULE_15__/* .NotFoundObjectError */ .m("time");
    }
    if (_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio?.src === src) {
      _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.seekAudio(_audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio, time);
    } else {
      logger.debug("Seek audio requested, but another audio is playing", {
        current: _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.currentAudio?.src,
        requested: src
      });
    }
  }
  onChangePlaybackRateRequested(_ref4) {
    let {
      payload: {
        value
      }
    } = _ref4;
    logger.debug("onChangePlaybackRateRequested", {
      value
    });
    _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.setPlaybackRate(value);
  }
  onStopRequested() {
    logger.debug("onStopRequested");
    void _audio_player__WEBPACK_IMPORTED_MODULE_20__/* .audioPlayer */ .e.stopAudio();
  }
  onClosePlayerRequested() {
    logger.debug("onClosePlayerRequested");
    _event_emitter__WEBPACK_IMPORTED_MODULE_17__/* .eventEmitter */ .T.emit("hideAudioPlayer");
  }
}
const audioSynchronizer = new AudioSynchronizer();

/***/ }),

/***/ 72403:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ AudioPlayPriorityError)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class AudioPlayPriorityError extends Error {
  constructor(_ref) {
    let {
      priority
    } = _ref;
    super("Can't play audio because of priority");
    _defineProperty(this, "priority", void 0);
    this.priority = priority;
  }
}

/***/ }),

/***/ 12745:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D8: () => (/* reexport */ AudioPlayerContext),
  UL: () => (/* reexport */ useAudio_interface/* Priority */.U),
  el: () => (/* reexport */ audio_player/* audioPlayer */.e),
  a_: () => (/* reexport */ audio_synchronizer/* audioSynchronizer */.a),
  GH: () => (/* reexport */ useAudioHandler),
  sJ: () => (/* reexport */ useCurrentAudio),
  gc: () => (/* reexport */ useCurrentAudioEvents),
  CH: () => (/* reexport */ usePlayAudioByLink)
});

// UNUSED EXPORTS: AudioItem, useAudio

// EXTERNAL MODULE: ../shared/src/hooks/useAudio/audio-item.ts + 1 modules
var audio_item = __webpack_require__(64829);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/audio-player.ts
var audio_player = __webpack_require__(5511);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/audio-player-context.ts




const AudioPlayerContext = (0,react.createContext)(audio_player/* audioPlayer */.e);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/audio-synchronizer.ts
var audio_synchronizer = __webpack_require__(99713);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/interface.ts
var useAudio_interface = __webpack_require__(55645);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/errors/audio-play-priority-error.ts
var audio_play_priority_error = __webpack_require__(72403);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/errors/audio-player-error.ts



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class AudioPlayerError extends Error {
  constructor(message, src, cause) {
    super(message);
    /** The source of audio */
    _defineProperty(this, "src", void 0);
    /** The reason of error (inner error) */
    _defineProperty(this, "cause", void 0);
    this.src = src;
    this.cause = cause;
  }
}
// EXTERNAL MODULE: ../shared/src/hooks/useAudio/use-audio-control.ts
var use_audio_control = __webpack_require__(25834);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/use-subscription/index.js
var use_subscription = __webpack_require__(36718);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/use-current-audio.ts








const useCurrentAudioEvents = options => {
  const {
    filter,
    onLoad,
    onPlay,
    onPause,
    onEnd,
    onChange
  } = options;
  const currentAudio = useCurrentAudio();
  (0,react.useEffect)(() => {
    onChange?.(currentAudio);
  }, [onChange, currentAudio]);
  (0,react.useEffect)(() => {
    if (!currentAudio) {
      return;
    }
    if (filter && !filter(currentAudio)) {
      return;
    }
    const onLoadUnsubscribe = currentAudio?.on?.("load", () => onLoad?.());
    const onPlayUnsubscribe = currentAudio?.on?.("play", () => onPlay?.());
    const onPauseUnsubscribe = currentAudio?.on?.("pause", () => onPause?.());
    const onEndUnsubscribe = currentAudio?.on?.("end", () => onEnd?.());
    return () => {
      onLoadUnsubscribe?.();
      onPlayUnsubscribe?.();
      onPauseUnsubscribe?.();
      onEndUnsubscribe?.();
    };
  }, [currentAudio, filter, onLoad, onPlay, onPause, onEnd]);
};
const useCurrentAudio = () => (0,use_subscription.useSubscription)(audio_player/* audioPlayer */.e.subscription);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/use-audio.ts












const use_audio_logger = logger/* ClientLogger */.q$.create("useAudio");
const useAudio = (src, type, options) => {
  const [waiting, setWaiting] = (0,react.useState)(false);
  const [playing, setPlaying] = (0,react.useState)(false);
  const audio = (0,react.useRef)(null);
  const autoPlay = options?.autoPlay ?? false;
  const priority = options?.priority ?? useAudio_interface/* Priority */.U.Normal;
  const audioControlSettings = (0,use_audio_control/* useAudioControl */.b)(type);
  const player = (0,react.useContext)(AudioPlayerContext);
  (0,react.useEffect)(() => {
    use_audio_logger.debug("create audio", {
      src,
      priority,
      type
    });
    audio.current = new audio_item/* AudioItem */.t(src, priority, type);
  }, [priority, src, type]);
  (0,react.useEffect)(() => {
    if (autoPlay && audio.current) {
      use_audio_logger.debug("auto play audio", {
        src: audio.current.src
      });
      audio_player/* audioPlayer */.e.playAudio(audio.current).catch(e => use_audio_logger.debug("failed to auto play audio", {
        src: audio.current?.src,
        error: e
      }));
    }
  }, [autoPlay]);
  useCurrentAudioEvents((0,react.useMemo)(() => ({
    filter: audio2 => audio2.src === src,
    onPlay: () => setPlaying(true),
    onPause: () => setPlaying(false),
    onEnd: () => setPlaying(false),
    onChange: audio2 => {
      if (audio2?.src !== src) {
        setPlaying(false);
      }
    }
  }), [src]));
  const withWaiting = (0,react.useCallback)(async (fn, name) => {
    if (!audio.current) {
      return;
    }
    try {
      setWaiting(true);
      await fn(audio.current);
    } catch (e) {
      if (e instanceof audio_play_priority_error/* AudioPlayPriorityError */.Z) {
        return;
      }
      use_audio_logger.debug(`Failed to ${name}, src: ${src}`);
      if (options?.onError) {
        options?.onError(new AudioPlayerError(`Failed to ${name}`, src, e));
      }
    } finally {
      setWaiting(false);
    }
  }, [options, src]);
  const play = (0,react.useCallback)(async () => {
    await withWaiting(item => player.playAudio(item), "play audio");
  }, [player, withWaiting]);
  const playFromStart = (0,react.useCallback)(async () => {
    await withWaiting(item => player.playAudio(item, {
      time: 0
    }), "play from start");
  }, [player, withWaiting]);
  const pause = (0,react.useCallback)(async () => {
    if (audio.current) {
      await player.pauseAudio(audio.current).catch(() => use_audio_logger.debug("Failed to pause audio"));
    }
  }, [player]);
  return (0,react.useMemo)(() => ({
    play,
    playFromStart,
    pause,
    waiting,
    playing,
    ...audioControlSettings
  }), [audioControlSettings, pause, play, playFromStart, playing, waiting]);
};
const usePlayAudioByLink = _ref => {
  let {
    priority
  } = _ref;
  const playAudioByLink = (0,react.useCallback)(async (src, type, initPlayer) => {
    try {
      const audioElement = new audio_item/* AudioItem */.t(src, priority, type);
      await audio_player/* audioPlayer */.e.playAudio(audioElement);
    } catch (e) {
      if (e instanceof audio_play_priority_error/* AudioPlayPriorityError */.Z || initPlayer) {
        return;
      }
      use_audio_logger.debug(`Failed to play audio by link, src: ${src}`);
      logger/* Logger */.Yd.captureException(new AudioPlayerError("Failed to play audio by link", src, e));
    }
  }, [priority]);
  return (0,react.useMemo)(() => ({
    playAudioByLink
  }), [playAudioByLink]);
};
// EXTERNAL MODULE: ../shared/src/services/notification/toast.ts
var toast = __webpack_require__(99990);
// EXTERNAL MODULE: ../shared/src/hooks/intl-format-context.ts
var intl_format_context = __webpack_require__(93131);
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/use-audio-handler.ts








function useAudioHandler(src, type, options) {
  const {
    formatMessage
  } = (0,intl_format_context/* useIntlFormatContext */.L)();
  const handleError = (0,react.useCallback)(error => {
    if (error instanceof AudioPlayerError) {
      toast/* toastNotificationService */.B.showError(formatMessage("audio.loadingFailed"));
      logger/* Logger */.Yd.captureException(error, {
        src: error.src
      });
    }
  }, [formatMessage]);
  return useAudio(src, type, {
    ...options,
    onError: handleError
  });
}
;// CONCATENATED MODULE: ../shared/src/hooks/useAudio/index.ts











/***/ }),

/***/ 55645:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ Priority)
/* harmony export */ });


var Priority = /* @__PURE__ */(Priority2 => {
  Priority2[Priority2["Low"] = 0] = "Low";
  Priority2[Priority2["Normal"] = 1] = "Normal";
  Priority2[Priority2["Primary"] = 2] = "Primary";
  return Priority2;
})(Priority || {});

/***/ }),

/***/ 25834:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O: () => (/* binding */ AudioControlContext),
/* harmony export */   b: () => (/* binding */ useAudioControl)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const AudioControlContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  checkAudioControl: () => ({
    canPlay: true,
    canChangeSpeed: true,
    canPause: true,
    canSeek: true,
    canClose: true
  })
});
function useAudioControl(type) {
  const {
    checkAudioControl
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AudioControlContext);
  if (!type) {
    return {
      canPlay: false,
      canChangeSpeed: false,
      canPause: false,
      canSeek: false,
      canClose: false
    };
  }
  return checkAudioControl(type);
}

/***/ }),

/***/ 67015:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ useDigitKeyPress)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2784);

















const codeToDigitMapping = /* @__PURE__ */new Map();
for (let i = 0; i <= 9; i++) {
  codeToDigitMapping.set(`Digit${i}`, i);
  codeToDigitMapping.set(`Numpad${i}`, i);
}
const useDigitKeyPress = function (callback) {
  let disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const handleKeyClick = (0,react__WEBPACK_IMPORTED_MODULE_14__.useCallback)(e => {
    const digit = codeToDigitMapping.get(e.code);
    if (digit === void 0) {
      return;
    }
    callback(digit);
  }, [callback]);
  (0,react__WEBPACK_IMPORTED_MODULE_14__.useEffect)(() => {
    if (!disabled) {
      document.addEventListener("keydown", handleKeyClick);
      return () => document.removeEventListener("keydown", handleKeyClick);
    }
  }, [disabled, handleKeyClick]);
};

/***/ }),

/***/ 88445:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ useErrorHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function useErrorHandler(givenError) {
  const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  if (givenError != null) {
    throw givenError;
  }
  if (error != null) {
    throw error;
  }
  return setError;
}

/***/ }),

/***/ 29553:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ State),
/* harmony export */   i: () => (/* binding */ useFetch)
/* harmony export */ });
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87412);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79106);
/* harmony import */ var _model_api_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30199);






var State = /* @__PURE__ */(State2 => {
  State2["Initial"] = "initial";
  State2["Loading"] = "loading";
  State2["Loaded"] = "loaded";
  State2["Error"] = "error";
  return State2;
})(State || {});
const useFetch = fetchFunction => {
  const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("initial" /* Initial */);
  const isLoading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  const fetchData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function () {
    setError(null);
    if (state === "loading" /* Loading */) {
      return (0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__.left)(null);
    }
    setState("loading" /* Loading */);
    isLoading.current = true;
    const response = await fetchFunction(...arguments);
    isLoading.current = false;
    if ((0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_3__.isRight)(response)) {
      setData(response.right);
    } else {
      setError(response.left);
    }
    return response;
  }, [fetchFunction, state]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (state === "loading" /* Loading */ && !isLoading.current && error !== null) {
      setState("error" /* Error */);
    }
  }, [error, state]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (state === "loading" /* Loading */ && !isLoading.current && data !== null) {
      setState("loaded" /* Loaded */);
    }
  }, [data, state]);
  switch (state) {
    case "initial" /* Initial */:
      {
        return {
          state,
          data: null,
          fetch: fetchData,
          error: null
        };
      }
    case "loading" /* Loading */:
      return {
        data: null,
        state,
        fetch: null,
        error: null
      };
    case "loaded" /* Loaded */:
      {
        if (data !== null) {
          return {
            state: "loaded" /* Loaded */,
            data,
            fetch: fetchData,
            error: null
          };
        }
        return {
          state: "error" /* Error */,
          data: null,
          fetch: fetchData,
          error: _model_api_model__WEBPACK_IMPORTED_MODULE_2__/* .unexpectedError */ .g
        };
      }
    case "error" /* Error */:
      if (error !== null) {
        return {
          data: null,
          error,
          state,
          fetch: fetchData
        };
      }
      return {
        data: null,
        error: _model_api_model__WEBPACK_IMPORTED_MODULE_2__/* .unexpectedError */ .g,
        state,
        fetch: fetchData
      };
    default:
      throw new _errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_1__/* .UnhandledCaseError */ .H(state);
  }
};

/***/ }),

/***/ 30803:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ useKeyPress)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44936);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44000);
/* harmony import */ var core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85744);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);







const extendKeyNameWithSynonyms = keyName => {
  const keys = typeof keyName === "string" ? [keyName] : keyName;
  const extendedList = [];
  keys.forEach(key => {
    if (key === "Enter") {
      extendedList.push("NumpadEnter");
    }
  });
  return [...keys, ...extendedList];
};
const useKeyPress = function (keyName, callback) {
  let disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const handleKeyClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(e => {
    const extendedKeyName = extendKeyNameWithSynonyms(keyName);
    const targetType = e.target.type;
    const isCurrentKeyPressed = code => {
      if (e.code !== code) {
        return false;
      }
      return extendedKeyName.includes(code);
    };
    const isTextOrTextarea = ["text", "textarea"].includes(targetType);
    if (isTextOrTextarea && ["Space", "Backspace"].includes(e.code)) {
      return false;
    }
    if (targetType === "textarea" && e.code === "Enter") {
      return false;
    }
    if (isCurrentKeyPressed("Backspace") && !isTextOrTextarea) {
      e.preventDefault();
    }
    if (isCurrentKeyPressed("Space") && !isTextOrTextarea) {
      e.preventDefault();
    }
    if (extendedKeyName.includes(e.code)) {
      callback(e);
    }
  }, [callback, keyName]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(() => {
    if (!disabled) {
      document.addEventListener("keydown", handleKeyClick);
      return () => document.removeEventListener("keydown", handleKeyClick);
    }
  }, [disabled, handleKeyClick]);
};

/***/ }),

/***/ 28952:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ useResizeElement)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function useResizeElement(ref, callback) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const element = ref?.current;
    if (!element) {
      return;
    }
    const observer = new ResizeObserver(() => {
      const rect = element.getBoundingClientRect();
      callback(rect);
    });
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [callback, ref]);
}

/***/ }),

/***/ 20967:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: () => (/* binding */ useWebcalInstruction)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



const useWebcalInstruction = () => {
  const [provider, setProvider] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const open = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(provider2 => {
    setProvider(provider2);
  }, []);
  const onClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setProvider(null);
  }, []);
  return {
    openWebcalInstruction: open,
    closeWebcalInstruction: onClose,
    webcalInstructionProvider: provider
  };
};

/***/ }),

/***/ 66176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  q$: () => (/* reexport */ ClientLogger),
  Yd: () => (/* reexport */ logger_Logger),
  jS: () => (/* reexport */ captureCaptureIoTsError)
});

// UNUSED EXPORTS: ErrorLogUtils

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/io-ts-reporters/target/src/index.js
var src = __webpack_require__(41936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.flat-map.js
var esnext_async_iterator_flat_map = __webpack_require__(53593);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.flat-map.js
var esnext_iterator_flat_map = __webpack_require__(25534);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
;// CONCATENATED MODULE: ../shared/src/logger/client-logger.ts









function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const WRITE_LOGS_TO_CONSOLE = "production" !== "production";
var LogLevel = /* @__PURE__ */(LogLevel2 => {
  LogLevel2[LogLevel2["debug"] = 0] = "debug";
  LogLevel2[LogLevel2["info"] = 1] = "info";
  LogLevel2[LogLevel2["warn"] = 2] = "warn";
  return LogLevel2;
})(LogLevel || {});
const CONSOLE_LOG_LEVEL = {
  [0 /* debug */]: console.debug,
  [1 /* info */]: console.log,
  [2 /* warn */]: console.warn
};
class Logger {
  constructor(name, options) {
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "logs", []);
    this.name = name;
    this.options = {
      disabled: options?.disabled ?? false,
      level: options?.level ?? 0 /* debug */
    };
  }
  storeLog(level, args) {
    this.logs.push({
      level,
      date: /* @__PURE__ */new Date(),
      // TODO: maybe better to use 'flatted' to avoid error with circular structures
      message: args.map(arg => JSON.stringify(arg)).join(" ")
    });
  }
  debug() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    this.sendLog(0 /* debug */, ...args);
  }
  info() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    this.sendLog(1 /* info */, ...args);
  }
  log() {
    this.info(...arguments);
  }
  warn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    this.sendLog(2 /* warn */, ...args);
  }
  sendLog(logLevel) {
    if (this.options.disabled || this.options.level > logLevel) {
      return;
    }
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    this.storeLog(logLevel, args);
    if (ClientLogger.useConsole) {
      CONSOLE_LOG_LEVEL[logLevel](`[${this.name}]`, ...args);
    }
  }
}
class ClientLogger {
  /**
   * Создать новый логгер
   * @param name название
   * @param options параметры
   * @returns логгер
   */
  static create(name, options) {
    const logger = new Logger(name, options);
    this.loggers.push(logger);
    return logger;
  }
  /**
   * Получить все логи
   * @returns логи, отсортированные по времени (сначала новые)
   */
  static getAllLogs() {
    const logs = this.loggers.flatMap(logger => logger.logs.map(log => ({
      loggerName: logger.name,
      ...log
    })));
    logs.sort((a, b) => b.date.getTime() - a.date.getTime());
    return logs;
  }
}
__publicField(ClientLogger, "loggers", []);
__publicField(ClientLogger, "useConsole", WRITE_LOGS_TO_CONSOLE);
;// CONCATENATED MODULE: ../shared/src/logger/error-log.utils.ts




const logErrorRaw = window.Ya?.Rum?.logError;
const updateErrorsRaw = window.Ya?.Rum?.updateErrors;
const updateAdditionalRaw = window.Ya?.Rum?.updateAdditional;
const logEventStringRaw = window.Ya?.Rum?.logEventString;
function logError(options, error, settings) {
  switch (options.level) {
    case void 0:
    case "trace":
    case "debug":
      console.debug(options.message, options.additional, error);
      break;
    case "info":
      console.log(options.message, options.additional, error);
      break;
    case "warn":
      console.warn(options.message, options.additional, error);
      break;
    case "error":
    case "critical":
      console.error(options.message, options.additional, error);
      break;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(options.level);
  }
  logErrorRaw?.(options, error, settings);
}
var ErrorLogUtils;
(ErrorLogUtils2 => {
  function wrongTime(minutesDiff) {
    logError({
      message: `Wrong client time`,
      level: "warn",
      additional: {
        minutesDiff
      }
    });
  }
  ErrorLogUtils2.wrongTime = wrongTime;
  function captureError(message, additionalData, options) {
    logError({
      ...options,
      level: "error",
      message,
      additional: {
        data: additionalData
      }
    });
  }
  ErrorLogUtils2.captureError = captureError;
  function captureWarning(message, additionalData, options) {
    logError({
      ...options,
      level: "warn",
      message,
      additional: {
        data: additionalData
      }
    });
  }
  ErrorLogUtils2.captureWarning = captureWarning;
  function captureException(error, additionalData, options) {
    logError({
      ...options,
      level: "error",
      message: error.message,
      additional: {
        name: error.name,
        stack: error.stack,
        data: additionalData,
        logs: ClientLogger.getAllLogs().slice(0, 10)
      }
    }, error);
  }
  ErrorLogUtils2.captureException = captureException;
  function sendEvent(name) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    let options = arguments.length > 2 ? arguments[2] : undefined;
    logEventStringRaw?.(name, value, options);
  }
  ErrorLogUtils2.sendEvent = sendEvent;
  function updateErrorConfig(params) {
    updateErrorsRaw?.(params);
  }
  ErrorLogUtils2.updateErrorConfig = updateErrorConfig;
  function updateAdditional(params) {
    updateAdditionalRaw?.(params);
  }
  ErrorLogUtils2.updateAdditional = updateAdditional;
})(ErrorLogUtils || (ErrorLogUtils = {}));
;// CONCATENATED MODULE: ../shared/src/logger/logger.ts





var logger_Logger;
(Logger2 => {
  Logger2.setPlatform = platform => {
    ErrorLogUtils.updateErrorConfig({
      platform
    });
  };
  Logger2.setUser = user => {
    (0, Logger2.setExtras)({
      userId: user?.id ?? null
    });
    (0, Logger2.setLoggedIn)(!!user?.id);
    if (user?.role) {
      (0, Logger2.setExtras)({
        role: user.role
      });
    }
    if (user?.experiments) {
      (0, Logger2.setExperiments)(Object.keys(user.experiments));
    }
    const yandexuid = (0,site_utils/* getCookie */.ej)("yandexuid");
    if (yandexuid) {
      (0, Logger2.setYandexuid)(yandexuid);
    }
  };
  Logger2.setPage = page => {
    ErrorLogUtils.updateErrorConfig({
      page
    });
  };
  Logger2.setExperiments = experiments => {
    ErrorLogUtils.updateErrorConfig({
      experiments
    });
  };
  Logger2.setYandexuid = yandexuid => {
    ErrorLogUtils.updateErrorConfig({
      yandexuid
    });
  };
  Logger2.setLoggedIn = loggedIn => {
    ErrorLogUtils.updateErrorConfig({
      loggedin: loggedIn
    });
  };
  Logger2.setExtra = (key, value) => {
    ErrorLogUtils.updateAdditional({
      [key]: value
    });
  };
  Logger2.setExtras = extras => {
    ErrorLogUtils.updateAdditional(extras);
  };
  Logger2.clearExtra = key => {
    ErrorLogUtils.updateAdditional({
      [key]: null
    });
  };
  Logger2.sendEvent = function (name, value) {
    let additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    ErrorLogUtils.sendEvent(name, value, {
      additional
    });
  };
  Logger2.captureError = (errorMessage, additionalData, options) => {
    ErrorLogUtils.captureError(errorMessage, additionalData, options);
  };
  Logger2.captureWarning = (errorMessage, additionalData, options) => {
    ErrorLogUtils.captureWarning(errorMessage, additionalData, options);
  };
  Logger2.captureException = (exception, additionalData, options) => {
    if (exception instanceof Error) {
      ErrorLogUtils.captureException(exception, additionalData, options);
    } else if (typeof exception === "string") {
      ErrorLogUtils.captureError(exception, additionalData, options);
    } else {
      ErrorLogUtils.captureError(`captureException: Unexpected exception type: ${typeof exception}`, additionalData, options);
    }
  };
  Logger2.unexpectedState = additionalData => {
    (0, Logger2.captureException)(new Error("Unexpected state"), additionalData);
  };
  Logger2.tryCatch = (action, additionalData, options) => {
    try {
      action();
    } catch (exception) {
      (0, Logger2.captureException)(exception, additionalData, options);
    }
  };
})(logger_Logger || (logger_Logger = {}));
;// CONCATENATED MODULE: ../shared/src/logger/capture-io-ts-error.ts





const MAX_SIZE = 5e3;
const captureCaptureIoTsError = (place, ioTsResult) => {
  const items = src["default"].report(ioTsResult, {
    truncateLongTypes: true
  });
  const cuttedItems = [];
  let size = 0;
  for (const item of items) {
    size += item.length;
    if (size > MAX_SIZE) {
      if (cuttedItems.length === 0) {
        cuttedItems.push(item.slice(0, MAX_SIZE));
      }
      break;
    }
    cuttedItems.push(item);
  }
  if (size > MAX_SIZE) {
    cuttedItems.push("and more...");
  }
  logger_Logger.captureWarning(place, items);
};
;// CONCATENATED MODULE: ../shared/src/logger/index.ts







/***/ }),

/***/ 30199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: () => (/* binding */ unexpectedError)
/* harmony export */ });


const unexpectedError = Symbol("Unexpected error");

/***/ }),

/***/ 55681:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HV: () => (/* binding */ BusinessProductId),
/* harmony export */   Hd: () => (/* binding */ makeProductId),
/* harmony export */   Se: () => (/* binding */ getIsBusBusinessProduct),
/* harmony export */   am: () => (/* binding */ getIsTeensBusinessProduct),
/* harmony export */   bX: () => (/* binding */ makeBusinessProductId),
/* harmony export */   dJ: () => (/* binding */ getIsKidsBusinessProduct),
/* harmony export */   x4: () => (/* binding */ useIsBusBusinessProduct)
/* harmony export */ });
/* unused harmony exports BUS_BUSINESS_PRODUCTS, KIDS_BUSINESS_PRODUCTS, TEENS_BUSINESS_PRODUCTS */
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34994);
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44352);
/* harmony import */ var _entities_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91485);





const makeProductId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();
var BusinessProductId = /* @__PURE__ */(BusinessProductId2 => {
  BusinessProductId2["Bus"] = "bus";
  BusinessProductId2["BusAnalyst"] = "bus_analyst";
  BusinessProductId2["BusProductManager"] = "bus_product_manager";
  BusinessProductId2["BusB2bProductManager"] = "bus_b2b_product_manager";
  BusinessProductId2["ProductA"] = "product_a";
  BusinessProductId2["ProductB"] = "product_b";
  BusinessProductId2["GeneralB1"] = "general_b1";
  BusinessProductId2["GeneralB2"] = "general_b2";
  BusinessProductId2["GeneralC1"] = "general_c1";
  BusinessProductId2["Packet"] = "packet";
  BusinessProductId2["TeensA"] = "teens_a";
  BusinessProductId2["TeensB"] = "teens_b";
  BusinessProductId2["KidsNew"] = "kids_new";
  BusinessProductId2["Unknown"] = "unknown";
  return BusinessProductId2;
})(BusinessProductId || {});
const BUS_BUSINESS_PRODUCTS = ["bus" /* Bus */, "bus_analyst" /* BusAnalyst */, "bus_product_manager" /* BusProductManager */, "bus_b2b_product_manager" /* BusB2bProductManager */];
const getIsBusBusinessProduct = productBusinessId => productBusinessId !== null && BUS_BUSINESS_PRODUCTS.includes(productBusinessId);
const makeBusinessProductId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();
const useIsBusBusinessProduct = () => {
  const currentProductBusinessId = (0,effector_react__WEBPACK_IMPORTED_MODULE_2__/* .useStore */ .oR)(_entities_user__WEBPACK_IMPORTED_MODULE_1__/* .$currentProductBusinessId */ .Wu);
  return getIsBusBusinessProduct(currentProductBusinessId);
};
const KIDS_BUSINESS_PRODUCTS = ["kids_new" /* KidsNew */];
const getIsKidsBusinessProduct = productBusinessId => productBusinessId !== null && KIDS_BUSINESS_PRODUCTS.includes(productBusinessId);
const TEENS_BUSINESS_PRODUCTS = ["teens_a" /* TeensA */, "teens_b" /* TeensB */];
const getIsTeensBusinessProduct = productBusinessId => productBusinessId !== null && TEENS_BUSINESS_PRODUCTS.includes(productBusinessId);

/***/ }),

/***/ 43055:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Kb: () => (/* binding */ ApprovalStatus),
/* harmony export */   Ph: () => (/* binding */ SpeakingSessionCancelReason),
/* harmony export */   Qn: () => (/* binding */ getNewSpeakingSessionEvent),
/* harmony export */   TG: () => (/* binding */ makeSpeakingTypeId),
/* harmony export */   Tt: () => (/* binding */ SchedulingStrategy),
/* harmony export */   V$: () => (/* binding */ makeSpeakingSession),
/* harmony export */   Z: () => (/* binding */ SpeakingSessionState),
/* harmony export */   ip: () => (/* binding */ DEFAULT_LESSON_DURATION),
/* harmony export */   jO: () => (/* binding */ SpeakingSessionFSMEvent),
/* harmony export */   r1: () => (/* binding */ getNewSpeakingSessionState),
/* harmony export */   xP: () => (/* binding */ SpeakingType)
/* harmony export */ });
/* unused harmony exports makeTimeSlotId, makeWeekDayId, weekDays, canSelectTutor, SelectingTimeSlotsState, getSelectingTimeSlotsState, RescheduleSpeakingSessionErrorType */
/* harmony import */ var core_js_modules_es_object_group_by_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96357);
/* harmony import */ var core_js_modules_es_object_group_by_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_group_by_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26540);
/* harmony import */ var core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_some_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17863);
/* harmony import */ var core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_some_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(77689);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(78016);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(62014);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(44589);
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(44352);



























const DEFAULT_LESSON_DURATION = 30;
const makeSpeakingTypeId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_22__/* .make */ .Sy)();
var SpeakingType = /* @__PURE__ */(SpeakingType2 => {
  SpeakingType2["CHAPTER"] = "chapter";
  SpeakingType2["MENTOR"] = "mentor";
  SpeakingType2["SALES"] = "sales";
  SpeakingType2["NATIVE_SPEAKER"] = "nativeSpeaker";
  SpeakingType2["BEGINNERS_LESSON"] = "beginnersLesson";
  SpeakingType2["BUS_LESSON"] = "busLesson";
  SpeakingType2["BUS_ANALYST_LESSON"] = "busAnalystLesson";
  SpeakingType2["BUS_PRODUCT_MANAGER_LESSON"] = "busProductManagerLesson";
  SpeakingType2["BUS_B2B_PM_LESSON"] = "busB2bPmLesson";
  SpeakingType2["GENERAL_B1_LESSON"] = "generalB1Lesson";
  SpeakingType2["GENERAL_B2_LESSON"] = "generalB2Lesson";
  SpeakingType2["GENERAL_C1_LESSON"] = "generalC1Lesson";
  SpeakingType2["TEENS_A_LESSON"] = "teensALesson";
  SpeakingType2["TEENS_B_LESSON"] = "teensBLesson";
  SpeakingType2["KIDS_NEW_LESSON"] = "kidsNewLesson";
  SpeakingType2["UNKNOWN"] = "unknown";
  return SpeakingType2;
})(SpeakingType || {});
var SpeakingSessionState = /* @__PURE__ */(SpeakingSessionState2 => {
  SpeakingSessionState2["CancelledUnbilled"] = "cancelledUnbilled";
  SpeakingSessionState2["Unbilled"] = "unbilled";
  SpeakingSessionState2["CancelledBilled"] = "cancelledBilled";
  SpeakingSessionState2["CancelledAutomatically"] = "cancelledAutomatically";
  SpeakingSessionState2["Cancelled"] = "cancelled";
  SpeakingSessionState2["Completed"] = "complete";
  SpeakingSessionState2["Scheduled"] = "scheduled";
  SpeakingSessionState2["InProgress"] = "inProgress";
  return SpeakingSessionState2;
})(SpeakingSessionState || {});
var SchedulingStrategy = /* @__PURE__ */(SchedulingStrategy2 => {
  SchedulingStrategy2["Legacy"] = "legacy";
  SchedulingStrategy2["Upcoming"] = "upcoming";
  return SchedulingStrategy2;
})(SchedulingStrategy || {});
var SpeakingSessionCancelReason = /* @__PURE__ */(SpeakingSessionCancelReason2 => {
  SpeakingSessionCancelReason2["StudentNoShow"] = "studentNoShow";
  SpeakingSessionCancelReason2["TechIssues"] = "techIssues";
  SpeakingSessionCancelReason2["LateCancellation"] = "lateCancellation";
  SpeakingSessionCancelReason2["StudentTutorScheduleChange"] = "studentTutorScheduleChange";
  SpeakingSessionCancelReason2["ReplaceTutor"] = "replaceTutor";
  SpeakingSessionCancelReason2["CancelTutor"] = "cancelTutor";
  SpeakingSessionCancelReason2["ByStudent"] = "byStudent";
  SpeakingSessionCancelReason2["ByCurator"] = "byCurator";
  SpeakingSessionCancelReason2["Empty"] = "empty";
  SpeakingSessionCancelReason2["PendingCancelByStudent"] = "pendingCancelByStudent";
  SpeakingSessionCancelReason2["PendingCancelByTutor"] = "pendingCancelByTutor";
  return SpeakingSessionCancelReason2;
})(SpeakingSessionCancelReason || {});
var ApprovalStatus = /* @__PURE__ */(ApprovalStatus2 => {
  ApprovalStatus2["Assigned"] = "assigned";
  ApprovalStatus2["Pending"] = "pending";
  ApprovalStatus2["Declined"] = "declined";
  return ApprovalStatus2;
})(ApprovalStatus || {});
const makeSpeakingSession = params => {
  const now = /* @__PURE__ */new Date();
  return {
    id: params.id,
    state: "scheduled" /* Scheduled */,
    speaking: {
      durationMinutes: 30,
      type: "beginnersLesson" /* BEGINNERS_LESSON */,
      typeId: makeSpeakingTypeId(""),
      id: ""
    },
    startAt: now,
    student: {
      id: "",
      publicName: "",
      avatar: ""
    },
    createdAt: now,
    updatedAt: now,
    approvalStatus: null
  };
};
var SpeakingSessionFSMEvent = /* @__PURE__ */(SpeakingSessionFSMEvent2 => {
  SpeakingSessionFSMEvent2["Start"] = "start";
  SpeakingSessionFSMEvent2["Stop"] = "stop";
  SpeakingSessionFSMEvent2["Unknown"] = "unknown";
  SpeakingSessionFSMEvent2["Cancel"] = "cancel";
  SpeakingSessionFSMEvent2["ScheduleCancelledLesson"] = "scheduleCancelledLesson";
  return SpeakingSessionFSMEvent2;
})(SpeakingSessionFSMEvent || {});
const makeTimeSlotId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_22__/* .make */ .Sy)();
const makeWeekDayId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_22__/* .make */ .Sy)();
const speakingSessionFSM = ( /* @__PURE__ */new Map()).set("start" /* Start */, ( /* @__PURE__ */new Map()).set("scheduled" /* Scheduled */, "inProgress" /* InProgress */)).set("stop" /* Stop */, ( /* @__PURE__ */new Map()).set("inProgress" /* InProgress */, "complete" /* Completed */)).set("cancel" /* Cancel */, ( /* @__PURE__ */new Map()).set("inProgress" /* InProgress */, "cancelledBilled" /* CancelledBilled */));
const getNewSpeakingSessionEvent = speakingSession => {
  switch (speakingSession.state) {
    case "scheduled" /* Scheduled */:
      return "start" /* Start */;
    case "inProgress" /* InProgress */:
      return "stop" /* Stop */;
    default:
      return "unknown" /* Unknown */;
  }
};
const getNewSpeakingSessionState = (speakingSession, event) => {
  const transition = speakingSessionFSM.get(event);
  if (!transition) {
    return speakingSession.state;
  }
  const newState = transition.get(speakingSession.state);
  if (!newState) {
    return speakingSession.state;
  }
  return newState;
};
const weekDays = new Array(7).fill(null).map((_, index) => {
  const day = (0,date_fns__WEBPACK_IMPORTED_MODULE_23__/* .format */ .WU)((0,date_fns__WEBPACK_IMPORTED_MODULE_24__/* .addDays */ .E)((0,date_fns__WEBPACK_IMPORTED_MODULE_25__/* .startOfWeek */ .z)( /* @__PURE__ */new Date(), {
    weekStartsOn: 1
  }), index), "cccc", {
    locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_26__/* .enUS */ ._
  });
  return {
    id: makeWeekDayId(String(index + 1)),
    label: day[0].toUpperCase() + day.slice(1),
    isoDayOfWeek: index + 1
  };
});
const MIN_COUNT_TIME_SLOTS_TO_SELECT_TUTOR = 1;
const canSelectTutor = params => {
  if (params.tutorId !== params.selectedTutorId) {
    return false;
  }
  const selectedTutorTimeSlots = params.selectedTimeSlotIds.filter(id => params.tutorTimeSlots.has(id));
  return selectedTutorTimeSlots.length >= MIN_COUNT_TIME_SLOTS_TO_SELECT_TUTOR;
};
var SelectingTimeSlotsState = /* @__PURE__ */(SelectingTimeSlotsState2 => {
  SelectingTimeSlotsState2["ZeroTimeSlots"] = "zeroTimeSlots";
  SelectingTimeSlotsState2["Ok"] = "ok";
  SelectingTimeSlotsState2["ToManyInOneDay"] = "toManyInOneDay";
  return SelectingTimeSlotsState2;
})(SelectingTimeSlotsState || {});
const getSelectingTimeSlotsState = timeSlots => {
  if (timeSlots.length < MIN_COUNT_TIME_SLOTS_TO_SELECT_TUTOR) {
    return "zeroTimeSlots" /* ZeroTimeSlots */;
  }
  const groupedByWeekDay = Object.groupBy(timeSlots, timeSlot => format(timeSlot.date, "EEEE"));
  const MAX_LESSONS_PER_DAY = 3;
  if (Object.values(groupedByWeekDay).some(slots => slots.length >= MAX_LESSONS_PER_DAY)) {
    return "toManyInOneDay" /* ToManyInOneDay */;
  }
  return "ok" /* Ok */;
};
var RescheduleSpeakingSessionErrorType = /* @__PURE__ */(RescheduleSpeakingSessionErrorType2 => {
  RescheduleSpeakingSessionErrorType2[RescheduleSpeakingSessionErrorType2["TutorIsNotAvailable"] = 0] = "TutorIsNotAvailable";
  RescheduleSpeakingSessionErrorType2[RescheduleSpeakingSessionErrorType2["InvalidStartTime"] = 1] = "InvalidStartTime";
  RescheduleSpeakingSessionErrorType2[RescheduleSpeakingSessionErrorType2["ForbiddenOperation"] = 2] = "ForbiddenOperation";
  RescheduleSpeakingSessionErrorType2[RescheduleSpeakingSessionErrorType2["SpeakingSessionNotFound"] = 3] = "SpeakingSessionNotFound";
  RescheduleSpeakingSessionErrorType2[RescheduleSpeakingSessionErrorType2["Other"] = 4] = "Other";
  return RescheduleSpeakingSessionErrorType2;
})(RescheduleSpeakingSessionErrorType || {});

/***/ }),

/***/ 49155:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K7: () => (/* binding */ makeStudentNoteId),
/* harmony export */   S4: () => (/* binding */ makeStudentNoteAttachmentId),
/* harmony export */   iC: () => (/* binding */ StudentNoteType)
/* harmony export */ });
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44352);



var StudentNoteType = /* @__PURE__ */(StudentNoteType2 => {
  StudentNoteType2["Private"] = "private";
  StudentNoteType2["Public"] = "public";
  return StudentNoteType2;
})(StudentNoteType || {});
var StudentNoteTag = /* @__PURE__ */(StudentNoteTag2 => {})(StudentNoteTag || {});
const makeStudentNoteId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();
var StudentNoteAttachmentTag = /* @__PURE__ */(StudentNoteAttachmentTag2 => {})(StudentNoteAttachmentTag || {});
const makeStudentNoteAttachmentId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();

/***/ }),

/***/ 54938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ox: () => (/* binding */ makeStudentId)
/* harmony export */ });
/* unused harmony exports TrainingStatus, PaymentStatus */
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44352);



const makeStudentId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();
var TrainingStatus = /* @__PURE__ */(TrainingStatus2 => {
  TrainingStatus2["Studying"] = "studying";
  TrainingStatus2["WaitingForTeacher"] = "waitingForTeacher";
  TrainingStatus2["Paused"] = "pause";
  TrainingStatus2["Cancelled"] = "cancelled";
  return TrainingStatus2;
})(TrainingStatus || {});
var PaymentStatus = /* @__PURE__ */(PaymentStatus2 => {
  PaymentStatus2["Paid"] = "paid";
  PaymentStatus2["NonPaid"] = "nonPaid";
  return PaymentStatus2;
})(PaymentStatus || {});

/***/ }),

/***/ 97953:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Nr: () => (/* binding */ makeTutorId),
/* harmony export */   Vr: () => (/* binding */ getSlotId),
/* harmony export */   u8: () => (/* binding */ BusyReasonType)
/* harmony export */ });
/* unused harmony export makeEmptyTutorRescheduleDatesVariants */
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61601);
/* harmony import */ var core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_delete_all_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35068);
/* harmony import */ var core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_emplace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21027);
/* harmony import */ var core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_every_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35788);
/* harmony import */ var core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86023);
/* harmony import */ var core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7935);
/* harmony import */ var core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_find_key_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13418);
/* harmony import */ var core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9185);
/* harmony import */ var core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_key_of_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48813);
/* harmony import */ var core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_keys_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5228);
/* harmony import */ var core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_map_values_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46085);
/* harmony import */ var core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_merge_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27886);
/* harmony import */ var core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_reduce_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94734);
/* harmony import */ var core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_some_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73919);
/* harmony import */ var core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_map_update_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44352);

















const makeTutorId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_14__/* .make */ .Sy)();
var BusyReasonType = /* @__PURE__ */(BusyReasonType2 => {
  BusyReasonType2["TutorSchedule"] = "tutor_schedule";
  BusyReasonType2["SpeakingSession"] = "speaking_session";
  return BusyReasonType2;
})(BusyReasonType || {});
const getSlotId = date => String(date.getTime());
const makeEmptyTutor = () => ({
  id: makeTutorId(""),
  avatar: "",
  publicName: ""
});
function makeEmptyTutorRescheduleDatesVariants() {
  return {
    tutor: makeEmptyTutor(),
    by5MinGap: /* @__PURE__ */new Map(),
    by30MinGap: /* @__PURE__ */new Map(),
    availabilitySlots: [],
    availability5MinSlots: [],
    version: "1"
  };
}

/***/ }),

/***/ 25382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   M: () => (/* binding */ AppBellItemType),
/* harmony export */   s: () => (/* binding */ makeAppBellItemId)
/* harmony export */ });
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44352);



var AppBellItemType = /* @__PURE__ */(AppBellItemType2 => {
  AppBellItemType2["Announcement"] = "announcement";
  AppBellItemType2["Feedback"] = "feedback";
  AppBellItemType2["Referral"] = "referral";
  AppBellItemType2["Banner"] = "banner";
  return AppBellItemType2;
})(AppBellItemType || {});
var AppBellItemTag = /* @__PURE__ */(AppBellItemTag2 => {})(AppBellItemTag || {});
const makeAppBellItemId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();

/***/ }),

/***/ 15983:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ NotifierItemContentType),
/* harmony export */   y: () => (/* binding */ makeNotifierItemId)
/* harmony export */ });
/* harmony import */ var ts_brand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44352);



var NotifierItemContentType = /* @__PURE__ */(NotifierItemContentType2 => {
  NotifierItemContentType2["Plain"] = "plain";
  NotifierItemContentType2["Link"] = "link";
  return NotifierItemContentType2;
})(NotifierItemContentType || {});
var NotifierItemTag = /* @__PURE__ */(NotifierItemTag2 => {})(NotifierItemTag || {});
const makeNotifierItemId = (0,ts_brand__WEBPACK_IMPORTED_MODULE_0__/* .make */ .Sy)();

/***/ }),

/***/ 97703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GL: () => (/* binding */ OptionType),
/* harmony export */   IA: () => (/* binding */ ArrayOfString),
/* harmony export */   r$: () => (/* binding */ TrainerEnvironment)
/* harmony export */ });
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87830);



const ArrayOfString = io_ts__WEBPACK_IMPORTED_MODULE_0__.union([io_ts__WEBPACK_IMPORTED_MODULE_0__.string, io_ts__WEBPACK_IMPORTED_MODULE_0__.array(io_ts__WEBPACK_IMPORTED_MODULE_0__.string)]);
var OptionType = /* @__PURE__ */(OptionType2 => {
  OptionType2["Audio"] = "audio";
  OptionType2["Image"] = "image";
  OptionType2["Text"] = "text";
  return OptionType2;
})(OptionType || {});
var TrainerEnvironment = /* @__PURE__ */(TrainerEnvironment2 => {
  TrainerEnvironment2["CustDev"] = "cust-dev";
  TrainerEnvironment2["Repetition"] = "product-repetition";
  TrainerEnvironment2["Trainer"] = "product-trainer";
  return TrainerEnvironment2;
})(TrainerEnvironment || {});

/***/ }),

/***/ 24144:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: () => (/* binding */ WebrtcProviderValidator),
/* harmony export */   x: () => (/* binding */ WebrtcProvider)
/* harmony export */ });
/* harmony import */ var io_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87830);



var WebrtcProvider = /* @__PURE__ */(WebrtcProvider2 => {
  WebrtcProvider2["Goloom"] = "GOLOOM";
  WebrtcProvider2["Telemost"] = "TELEMOST";
  WebrtcProvider2["TelemostExternal"] = "TELEMOST_EXTERNAL";
  return WebrtcProvider2;
})(WebrtcProvider || {});
const WebrtcProviderValidator = io_ts__WEBPACK_IMPORTED_MODULE_0__.keyof({
  ["GOLOOM" /* Goloom */]: null,
  ["TELEMOST" /* Telemost */]: null,
  ["TELEMOST_EXTERNAL" /* TelemostExternal */]: null
});

/***/ }),

/***/ 97060:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: () => (/* binding */ getObjectEntries),
/* harmony export */   Z: () => (/* binding */ getObjectKeys)
/* harmony export */ });


function getObjectKeys(obj) {
  return Object.keys(obj);
}
function getObjectEntries(obj) {
  return Object.entries(obj);
}

/***/ }),

/***/ 85087:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: () => (/* binding */ TEACHER_PREFIX)
/* harmony export */ });


const TEACHER_PREFIX = "/teacher";

/***/ }),

/***/ 64514:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   q: () => (/* binding */ teacherRoutePaths)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85087);



const teacherRoutePaths = {
  INDEX: `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}`,
  SPEAKING_CHECKUP: speakingSessionId => `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/speaking-checkup/${speakingSessionId}`,
  SPEAKING: speakingSessionId => `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/speaking/${speakingSessionId}`,
  ONBOARDING: `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/onboarding/:chapterId`,
  PRODUCT_REVISION: (chapterId, type) => {
    const revisionPrefix = type ? `/${type}` : "";
    return `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/revision/${chapterId}${revisionPrefix}`;
  },
  MENTOR_SPEAKING_CHECKUP: (chapterId, tutorSpeakingId) => `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/mentor-speaking-checkup/${chapterId}/${tutorSpeakingId}`,
  MENTOR_SPEAKING: (chapterId, tutorSpeakingId) => `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/mentor-speaking/${chapterId}/${tutorSpeakingId}`,
  STUDENT_ABOUT: `${_constants__WEBPACK_IMPORTED_MODULE_0__/* .TEACHER_PREFIX */ .o}/student-about`
};

/***/ }),

/***/ 41944:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  z: () => (/* binding */ useBell)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.filter.js
var esnext_async_iterator_filter = __webpack_require__(82596);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(36199);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/site.utils.ts
var site_utils = __webpack_require__(24610);
// EXTERNAL MODULE: ../../node_modules/date-fns/parseISO.mjs
var parseISO = __webpack_require__(95790);
// EXTERNAL MODULE: ../../node_modules/date-fns/isThisYear.mjs + 1 modules
var isThisYear = __webpack_require__(98810);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../shared/src/domain/domain.ts
var domain = __webpack_require__(72765);
// EXTERNAL MODULE: ../shared/src/models/bell/item.ts
var item = __webpack_require__(25382);
// EXTERNAL MODULE: ../shared/src/models/notifier/notifier.ts
var notifier = __webpack_require__(15983);
// EXTERNAL MODULE: ../shared/src/utils/locale.ts
var utils_locale = __webpack_require__(90790);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/adapters/bell/bell.model.ts



const AppBellItemDtoTypeCommon = es6.type({
  id: es6.string
});
const BellFeedbackItemDto = es6.intersection([AppBellItemDtoTypeCommon, es6.type({
  type: es6.literal("feedback")
})]);
const BellAnnouncementItemDto = es6.intersection([AppBellItemDtoTypeCommon, es6.type({
  type: es6.literal("announcement"),
  payload: es6.type({
    announcement_id: es6.string
  })
})]);
const BellReferralItemDto = es6.intersection([AppBellItemDtoTypeCommon, es6.type({
  type: es6.literal("referral"),
  payload: es6.type({
    announcement_id: es6.string
  })
})]);
const BellBannerItemDto = es6.intersection([AppBellItemDtoTypeCommon, es6.type({
  type: es6.literal("banner"),
  payload: es6.type({
    announcement_id: es6.string
  })
})]);
const AppBellItemDto = es6.union([BellFeedbackItemDto, BellAnnouncementItemDto, BellReferralItemDto, BellBannerItemDto]);
const NotifierItemDtoTypeCommon = es6.type({
  created_at: es6.string,
  id: es6.string,
  is_read: es6.boolean,
  payload: es6.type({
    title: es6.string
  })
});
const PlainNotifierItemDto = es6.intersection([NotifierItemDtoTypeCommon, es6.type({
  type: es6.literal("plain"),
  payload: es6.partial({
    description: es6.string
  })
})]);
const LinkNotifierItemDto = es6.intersection([NotifierItemDtoTypeCommon, es6.type({
  type: es6.literal("link"),
  payload: es6.intersection([es6.type({
    label: es6.string,
    href: es6.string
  }), es6.partial({
    description: es6.string
  })])
})]);
const BellNotifierItemDto = es6.union([PlainNotifierItemDto, LinkNotifierItemDto]);
const GetNotifierItemsBellEventMessage = es6.type({
  type: es6.literal("get_notifier_items"),
  data: es6.type({
    items: es6.array(es6.union([es6.type({
      type: es6.string
    }), BellNotifierItemDto]))
  })
});
const GetAppItemsBellEventMessage = es6.type({
  type: es6.literal("get_app_items"),
  data: es6.type({
    items: es6.array(es6.union([es6.type({
      type: es6.string
    }), AppBellItemDto]))
  })
});
const GetAnnouncementItemsBellEventMessage = es6.type({
  type: es6.literal("get_announcement_items"),
  data: es6.type({
    items: es6.array(es6.union([es6.type({
      type: es6.string
    }), AppBellItemDto]))
  })
});
const ErrorEventMessage = es6.type({
  type: es6.literal("error"),
  data: es6.type({
    error_message: es6.string
  })
});
;// CONCATENATED MODULE: ../shared/src/adapters/bell/bell.api.mapper.ts









const mapBellAppItemDtoToModel = dto => {
  if (!AppBellItemDto.is(dto)) {
    logger/* Logger */.Yd.captureError(`Unknown app item with type "${dto.type}"`);
    return null;
  }
  if (dto.type === "feedback") {
    return {
      type: item/* AppBellItemType */.M.Feedback,
      id: (0,item/* makeAppBellItemId */.s)(dto.id),
      isRead: false
    };
  }
  if (dto.type === "announcement") {
    return {
      type: item/* AppBellItemType */.M.Announcement,
      id: (0,item/* makeAppBellItemId */.s)(dto.id),
      isRead: false,
      payload: {
        announcementId: dto.payload.announcement_id
      }
    };
  }
  if (dto.type === "referral") {
    return {
      type: item/* AppBellItemType */.M.Referral,
      id: (0,item/* makeAppBellItemId */.s)(dto.id),
      isRead: false,
      payload: {
        announcementId: dto.payload.announcement_id
      }
    };
  }
  if (dto.type === "banner") {
    return {
      type: item/* AppBellItemType */.M.Banner,
      id: (0,item/* makeAppBellItemId */.s)(dto.id),
      isRead: false,
      payload: {
        announcementId: dto.payload.announcement_id
      }
    };
  }
  return null;
};
const mapNotifierItemDtoDateNumberToModel = function (dateIso) {
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils_locale/* dateFnsLocale */.Y;
  const date = (0,parseISO/* parseISO */.D)(dateIso);
  const thisYear = (0,isThisYear/* isThisYear */.X)(date);
  return {
    label: (0,format/* format */.WU)(date, "d MMMM" + (thisYear ? "" : " yyyy") + ", H:mm", {
      locale
    }),
    iso: date.toISOString(),
    timestamp: date.getTime()
  };
};
const mapNotifierItemDtoToModel = dto => {
  if (!BellNotifierItemDto.is(dto)) {
    logger/* Logger */.Yd.captureError(`Unknown notifier item with type "${dto.type}"`);
    return null;
  }
  if (dto.type === "plain") {
    return {
      type: notifier/* NotifierItemContentType */.T.Plain,
      isRead: dto.is_read,
      id: (0,notifier/* makeNotifierItemId */.y)(dto.id),
      createdAt: mapNotifierItemDtoDateNumberToModel(dto.created_at),
      payload: {
        title: dto.payload.title,
        description: dto.payload.description
      }
    };
  }
  if (dto.type === "link") {
    return {
      type: notifier/* NotifierItemContentType */.T.Link,
      isRead: dto.is_read,
      id: (0,notifier/* makeNotifierItemId */.y)(dto.id),
      createdAt: mapNotifierItemDtoDateNumberToModel(dto.created_at),
      payload: {
        title: dto.payload.title,
        label: dto.payload.label,
        href: (0,domain.kz)(dto.payload.href),
        description: dto.payload.description,
        isExternal: !dto.payload.href.startsWith("/")
      }
    };
  }
  return null;
};
const bellApiMappers = {
  mapBellAppItemDtoToModel,
  mapNotifierItemDtoToModel
};
;// CONCATENATED MODULE: ../shared/src/adapters/bell/bell.api-adapter.ts













const WEB_SOCKET_RECONNECTION_ATTEMPTS_COUNT_DEFAULT = 3;
let webSocket;
let webSocketReconnectionAttemptsCount = WEB_SOCKET_RECONNECTION_ATTEMPTS_COUNT_DEFAULT;
function finishConnect(target) {
  if (target === "onOpen") {
    webSocketReconnectionAttemptsCount = WEB_SOCKET_RECONNECTION_ATTEMPTS_COUNT_DEFAULT;
  }
}
function isWebsocketOpen(webSocket2) {
  return webSocket2?.readyState === 1;
}
function isWebsocketConnecting(webSocket2) {
  return webSocket2?.readyState === 0;
}
function reconnect(start, onEndAttempts) {
  if (isWebsocketConnecting(webSocket)) {
    return;
  }
  if (webSocketReconnectionAttemptsCount > 0) {
    webSocketReconnectionAttemptsCount--;
    start();
  } else if (webSocketReconnectionAttemptsCount === 0) {
    onEndAttempts();
  }
}
function hasEventMessage(event) {
  return typeof event.message === "string";
}
function captureBellError(errorMessage, additionalData) {
  const bellAdditionalData = additionalData && {
    bell: additionalData
  };
  logger/* Logger */.Yd.captureError(`[Bell] ${errorMessage}`, bellAdditionalData);
}
function createBellApiAdapter() {
  let isClosingByApp = false;
  webSocketReconnectionAttemptsCount = WEB_SOCKET_RECONNECTION_ATTEMPTS_COUNT_DEFAULT;
  return {
    start(props) {
      return new Promise((resolve, reject) => {
        webSocket = new WebSocket(`${(0,site_utils/* getBellWebsocketUrl */.P9)()}/pubsub`);
        webSocket.onopen = () => {
          finishConnect("onOpen");
          resolve();
          const connectRequest = {
            type: "connect"
          };
          webSocket?.send(JSON.stringify(connectRequest));
        };
        webSocket.onmessage = createHandleOnmessage(props);
        webSocket.onerror = event => {
          finishConnect("onError");
          reconnect(() => {
            void this.start(props);
          }, () => {
            captureBellError("webSocket couldn't connect", hasEventMessage(event) ? {
              errorMessage: event.message
            } : void 0);
            reject(event);
          });
        };
        webSocket.onclose = event => {
          finishConnect("onClose");
          if (!event.wasClean) {
            captureBellError(`webSocket was closed by not clean ${isClosingByApp ? "" : "(before stop bell)"}`, {
              closeCode: event.code
            });
            reject(event);
          }
        };
      });
    },
    markAsReadNotifierItems(notifierItemsIds) {
      const request = {
        type: "mark_as_read",
        data: {
          items_ids: notifierItemsIds
        }
      };
      if (isWebsocketOpen(webSocket)) {
        webSocket?.send(JSON.stringify(request));
        return;
      }
      captureBellError("attempt to send to a not open webSocket", {
        webSocketReadyState: webSocket?.readyState
      });
    },
    stop() {
      isClosingByApp = true;
      webSocket?.close();
    }
  };
}
function createHandleOnmessage(props) {
  const {
    onGetNewAppBellItems,
    onGetNewBellNotifierItems
  } = props;
  return event => {
    try {
      const {
        data: eventData
      } = event;
      const eventDataObject = JSON.parse(eventData);
      if (GetNotifierItemsBellEventMessage.is(eventDataObject)) {
        onGetNewBellNotifierItems((eventDataObject.data.items || []).map(bellApiMappers.mapNotifierItemDtoToModel).filter(item => Boolean(item)));
        return;
      }
      if (GetAppItemsBellEventMessage.is(eventDataObject)) {
        onGetNewAppBellItems((eventDataObject.data.items || []).map(bellApiMappers.mapBellAppItemDtoToModel).filter(item => Boolean(item)));
        return;
      }
      if (ErrorEventMessage.is(eventDataObject)) {
        const {
          data: {
            error_message: errorMessage
          }
        } = eventDataObject;
        captureBellError("error message", {
          errorMessage
        });
        return;
      }
      captureBellError("unknown message", {
        messageType: event.type
      });
    } catch (error) {
      captureBellError("handle message", {
        errorMessage: error instanceof Error ? error.message : "unknown",
        messageType: error
      });
    }
  };
}
// EXTERNAL MODULE: ../../node_modules/effector/effector.mjs
var effector = __webpack_require__(31976);
// EXTERNAL MODULE: ../../node_modules/effector-react/effector-react.mjs
var effector_react = __webpack_require__(34994);
;// CONCATENATED MODULE: ../shared/src/adapters/bell/bell.storage-adapter.ts




const bellDomain = (0,effector/* createDomain */.Fj)("bell");
const $appBellItems = bellDomain.createStore([]);
const $notifierItems = bellDomain.createStore([]);
const $notifier = bellDomain.createStore({
  notifierVisible: false,
  isNotifierInit: false
});
const setAppBellItems = bellDomain.createEvent();
const setNotifierItems = bellDomain.createEvent();
const setNotifierVisible = bellDomain.createEvent();
const setIsNotifierInit = bellDomain.createEvent();
$appBellItems.on(setAppBellItems, (state, payload) => payload);
$notifierItems.on(setNotifierItems, (state, payload) => payload);
$notifier.on(setNotifierVisible, (state, payload) => ({
  ...state,
  notifierVisible: payload
}));
$notifier.on(setIsNotifierInit, (state, payload) => ({
  ...state,
  isNotifierInit: payload
}));
const useBellStorageAdapter = () => {
  const notifier = (0,effector_react/* useStore */.oR)($notifier);
  return {
    appBellItems: (0,effector_react/* useStore */.oR)($appBellItems),
    notifierItems: (0,effector_react/* useStore */.oR)($notifierItems),
    ...notifier,
    setAppBellItems,
    setNotifierItems,
    setNotifierVisible,
    setIsNotifierInit
  };
};
// EXTERNAL MODULE: ../shared/src/services/notifier/notifierService.ts
var notifierService = __webpack_require__(24223);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
;// CONCATENATED MODULE: ../shared/src/services/bell/bell.ts
































function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class BellApplicationService {
  constructor(_ref) {
    let {
      bellStorage,
      bellApi,
      notifierService
    } = _ref;
    _defineProperty(this, "bellStorage", void 0);
    _defineProperty(this, "bellApi", void 0);
    _defineProperty(this, "notifierService", void 0);
    this.bellStorage = bellStorage;
    this.bellApi = bellApi;
    this.notifierService = notifierService;
    this.hideNotifier = this.hideNotifier.bind(this);
    this.showNotifier = this.showNotifier.bind(this);
    this.markAsReadNotifierItems = this.markAsReadNotifierItems.bind(this);
    this.onGetNewBellNotifierItems = this.onGetNewBellNotifierItems.bind(this);
    this.onGetNewAppBellItems = this.onGetNewAppBellItems.bind(this);
    this.getBellItemsByType = this.getBellItemsByType.bind(this);
    this.markAsReadAppBellItem = this.markAsReadAppBellItem.bind(this);
    this.markAsReadAppBellItems = this.markAsReadAppBellItems.bind(this);
    this.run = this.run.bind(this);
    this.stop = this.stop.bind(this);
    this.setBellStorage = this.setBellStorage.bind(this);
  }
  get hasNewNotifierItems() {
    return this.notifierService.hasNewNotifierItems;
  }
  get notifierItems() {
    return this.bellStorage.notifierItems;
  }
  get appBellItems() {
    return this.bellStorage.appBellItems;
  }
  get notifierVisible() {
    return this.bellStorage.notifierVisible;
  }
  get notifierBellVisible() {
    return this.bellStorage.isNotifierInit;
  }
  setBellStorage(bellStorage) {
    this.bellStorage = bellStorage;
    this.notifierService.setStorage(bellStorage);
  }
  hideNotifier() {
    this.bellStorage.setNotifierVisible(false);
  }
  showNotifier() {
    this.bellStorage.setNotifierVisible(true);
  }
  async run() {
    await this.bellApi.start({
      onGetNewAppBellItems: this.onGetNewAppBellItems,
      onGetNewBellNotifierItems: this.onGetNewBellNotifierItems
    });
    this.bellStorage.setIsNotifierInit(true);
  }
  stop() {
    this.bellApi.stop();
    this.bellStorage.setIsNotifierInit(false);
  }
  getBellItemsByType(bellItemType) {
    return this.appBellItems.filter(appBellItem => appBellItem.type === bellItemType && !appBellItem.isRead);
  }
  markAsReadAppBellItem(appBellItemId) {
    this.markAsReadAppBellItems([appBellItemId]);
  }
  markAsReadAppBellItems(appBellItemsIds) {
    const {
      items,
      notReadItemsIds
    } = this.markAsReadItems(this.appBellItems, appBellItemsIds);
    if (notReadItemsIds.length > 0) {
      this.bellStorage.setAppBellItems(items);
      this.bellApi.markAsReadNotifierItems(notReadItemsIds);
    }
  }
  markAsReadNotifierItems() {
    const {
      items,
      notReadItemsIds
    } = this.markAsReadItems(this.notifierItems);
    if (notReadItemsIds.length > 0) {
      this.notifierService.setNotifierItems(items);
      this.bellApi.markAsReadNotifierItems(notReadItemsIds);
    }
  }
  markAsReadItems(items, notReadItemsIds) {
    const isUseNotReadItemsIds = Boolean(notReadItemsIds);
    const _notReadItemsIds = new Set(notReadItemsIds || []);
    const changedItems = items.reduce((result, notifierItem) => {
      if (notifierItem.isRead || isUseNotReadItemsIds && !_notReadItemsIds.has(notifierItem.id)) {
        result.push(notifierItem);
      } else {
        _notReadItemsIds.add(notifierItem.id);
        result.push({
          ...notifierItem,
          isRead: true
        });
      }
      return result;
    }, []);
    return {
      items: changedItems,
      notReadItemsIds: Array.from(_notReadItemsIds)
    };
  }
  onGetNewBellNotifierItems(newBellNotifierItems) {
    this.notifierService.setNotifierItems(newBellNotifierItems);
  }
  onGetNewAppBellItems(newAppBellItems) {
    this.bellStorage.setAppBellItems(newAppBellItems);
  }
}
;// CONCATENATED MODULE: ../shared/src/services/bell/useBell.ts







const useBell = () => {
  const bellStorageAdapter = useBellStorageAdapter();
  const notifierApplicationService = (0,react.useRef)(new BellApplicationService({
    bellStorage: bellStorageAdapter,
    notifierService: new notifierService/* NotifierService */.l(bellStorageAdapter),
    bellApi: createBellApiAdapter()
  }));
  notifierApplicationService.current.setBellStorage(bellStorageAdapter);
  return notifierApplicationService.current;
};

/***/ }),

/***/ 53378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: () => (/* binding */ useBellNotification)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _useBell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41944);






const useBellNotification = () => {
  const {
    getBellItemsByType,
    markAsReadAppBellItem
  } = (0,_useBell__WEBPACK_IMPORTED_MODULE_3__/* .useBell */ .z)();
  const getBellNotifications = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(bellItemType => getBellItemsByType(bellItemType).map(bellItem => ({
    ...bellItem,
    markAsRead() {
      markAsReadAppBellItem(bellItem.id);
    }
  })), [getBellItemsByType, markAsReadAppBellItem]);
  return {
    getBellNotifications
  };
};

/***/ }),

/***/ 99990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ toastNotificationService)
/* harmony export */ });
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88932);



const toastNotificationService = {
  showError(errorMessage, options) {
    react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am.error(errorMessage, mergeOptions({
      position: "top-right",
      autoClose: 3e3,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: void 0,
      transition: react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .Slide */ .Mi,
      theme: "dark",
      containerId: "App"
    }, options));
  },
  showSuccess(message, options) {
    react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am.success(message, mergeOptions({
      position: "top-right",
      autoClose: 2e3,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: void 0,
      transition: react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .Slide */ .Mi,
      theme: "dark",
      containerId: "App"
    }, options));
  },
  showInfoMessage(message, options) {
    react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .toast */ .Am.info(message, mergeOptions({
      position: "top-right",
      autoClose: 5e3,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: void 0,
      transition: react_toastify__WEBPACK_IMPORTED_MODULE_0__/* .Slide */ .Mi,
      theme: "dark",
      containerId: "App"
    }, options));
  }
};
function mergeOptions(defaultOptions, options) {
  return {
    ...defaultOptions,
    ...options
  };
}

/***/ }),

/***/ 24223:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ NotifierService)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15398);
/* harmony import */ var core_js_modules_es_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_to_sorted_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_4__);







function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class NotifierService {
  constructor(notifierStorage) {
    _defineProperty(this, "notifierStorage", void 0);
    this.notifierStorage = notifierStorage;
  }
  static canToggleNotifierItem(_ref) {
    let {
      item
    } = _ref;
    return Boolean(item.payload.description);
  }
  static isNotRead(notifierItem) {
    return !notifierItem.isRead;
  }
  static getNotifierItemClickHandler(props) {
    const {
      item,
      isItemOpen,
      setOpenedNotifierItemId
    } = props;
    const canToggle = NotifierService.canToggleNotifierItem({
      item
    });
    if (canToggle) {
      return () => {
        setOpenedNotifierItemId(isItemOpen ? void 0 : item.id);
      };
    }
    return void 0;
  }
  get hasNewNotifierItems() {
    return this.notifierItems.filter(NotifierService.isNotRead).length > 0;
  }
  get hasNotifierItems() {
    return this.notifierItems.length > 0;
  }
  get notifierItems() {
    return this.notifierStorage.notifierItems;
  }
  get notifierVisible() {
    return this.notifierStorage.notifierVisible;
  }
  setStorage(notifierStorage) {
    this.notifierStorage = notifierStorage;
  }
  setNotifierItems(notifierItems) {
    this.notifierStorage.setNotifierItems(notifierItems.toSorted((a, b) => b.createdAt.timestamp - a.createdAt.timestamp));
  }
}

/***/ }),

/***/ 24610:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $2: () => (/* binding */ getSiteUrl),
/* harmony export */   Cq: () => (/* binding */ getPublicPathRoot),
/* harmony export */   NZ: () => (/* binding */ getAPIPath),
/* harmony export */   P9: () => (/* binding */ getBellWebsocketUrl),
/* harmony export */   W_: () => (/* binding */ getSyncWebsocketUrl),
/* harmony export */   Xv: () => (/* binding */ getBunkerNodePath),
/* harmony export */   bY: () => (/* binding */ getAppPath),
/* harmony export */   ej: () => (/* binding */ getCookie),
/* harmony export */   lz: () => (/* binding */ getTutorPath)
/* harmony export */ });
/* unused harmony exports getCmsPath, getBunkerApiPath, trimDomain */


const getSiteUrl = () => `${location.protocol}//${location.host}`;
function getCookie(name) {
  const matches = document.cookie.match(
  // eslint-disable-next-line no-useless-escape
  new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : void 0;
}
const getPublicPathRoot = () => {
  if (window.location.pathname.startsWith("/english")) {
    return "/english";
  }
  if (window.location.pathname.startsWith("/flow")) {
    return "/flow";
  }
  if (window.location.pathname.match("^/preview/[^/]+/.*")) {
    return `/preview/${window.location.pathname.split("/")[2]}`;
  }
  return "";
};
const getApplicationPath = destination => `${getPublicPathRoot()}/${destination}`;
const getAppPath = () => getApplicationPath("app");
const getTutorPath = () => getApplicationPath("tutor");
const getCmsPath = () => getApplicationPath("cms");
const getWebsocketRootUrl = () => {
  const protocolPrefix = window.location.protocol === "https:" ? "wss:" : "ws:";
  const {
    host
  } = window.location;
  return `${protocolPrefix}//${host}${getPublicPathRoot()}`;
};
const getSyncWebsocketUrl = () => `${getWebsocketRootUrl()}/ws`;
const getBellWebsocketUrl = () => `${getWebsocketRootUrl()}/notifications/ws`;
const getAPIPath = () => `${getPublicPathRoot()}/api`;
const getBunkerApiPath = () => `${getPublicPathRoot()}/bunker/v1`;
const getBunkerNodePath = () => `${getBunkerApiPath()}/cat?node=`;
function trimDomain(url) {
  let newUrl = url?.replace(/^https:\/\/[^\/]+/, "");
  if (newUrl?.startsWith("/english") && getPublicPathRoot() !== "/english") {
    newUrl = newUrl.replace("/english", getPublicPathRoot());
  }
  return newUrl;
}

/***/ }),

/***/ 25680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ee: () => (/* binding */ splitBySentences),
/* harmony export */   WM: () => (/* binding */ A_CHAR_CODE),
/* harmony export */   YU: () => (/* binding */ escape),
/* harmony export */   gx: () => (/* binding */ replace),
/* harmony export */   mN: () => (/* binding */ splitBySentencesWithList),
/* harmony export */   t4: () => (/* binding */ isEnglishWord),
/* harmony export */   wm: () => (/* binding */ capitalized),
/* harmony export */   xY: () => (/* binding */ stringToHash)
/* harmony export */ });
/* harmony import */ var sbd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14946);
/* harmony import */ var simple_markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24031);
/* harmony import */ var simple_markdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(simple_markdown__WEBPACK_IMPORTED_MODULE_1__);




const A_CHAR_CODE = 65;
const stringToHash = str => {
  let hash = 0;
  if (str.length === 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash;
};
const splitBySentencesWithList = text => {
  const textStartWithListMatch = simple_markdown__WEBPACK_IMPORTED_MODULE_1___default().defaultRules.list.match(text, {}, "") !== null;
  if (textStartWithListMatch) {
    return text.split("\n");
  }
  return splitBySentences(text, {
    newline_boundaries: true
  });
};
const splitBySentences = (text, options) => sbd__WEBPACK_IMPORTED_MODULE_0__.sentences(text, {
  preserve_whitespace: true,
  ...options
});
const replace = (initialText, oldValue, newValue, times) => {
  let result = initialText;
  for (let i = 0; i <= times - 1; i++) {
    result = result.replace(oldValue, newValue);
  }
  return result;
};
const escape = string => string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
const isEnglishWord = word => Boolean(word.match(/[A-z]+/));
function capitalized(str) {
  if (!str[0]) {
    return "";
  }
  return str[0].toUpperCase() + str.slice(1);
}

/***/ }),

/***/ 30332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K0: () => (/* binding */ convertLocalToUTC),
/* harmony export */   Yq: () => (/* binding */ getCurrentIANATimezone),
/* harmony export */   v$: () => (/* binding */ convertUTCToLocal)
/* harmony export */ });
/* unused harmony exports convertMoscowToLocal, convertLocalToMoscow, convertLocalToMoscowTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49566);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7300);
/* harmony import */ var date_fns_tz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59755);




const convertUTCToLocal = function (date) {
  let usePassedDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const referenceDate = usePassedDate ? date : /* @__PURE__ */new Date();
  const timeZoneOffset = referenceDate.getTimezoneOffset();
  const dateStringInUTC = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* .subMinutes */ ._)(date, timeZoneOffset).toISOString();
  return (0,date_fns_tz__WEBPACK_IMPORTED_MODULE_0__/* .toZonedTime */ .zW)(dateStringInUTC, getCurrentIANATimezone());
};
const convertLocalToUTC = function (date) {
  let usePassedDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const referenceDate = usePassedDate ? date : /* @__PURE__ */new Date();
  const timeZoneOffset = referenceDate.getTimezoneOffset();
  return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* .addMinutes */ .m)(date, timeZoneOffset);
};
const convertMoscowToLocal = date => {
  const utc = fromZonedTime(date, "Europe/Moscow");
  return toZonedTime(utc, getCurrentIANATimezone());
};
const convertLocalToMoscow = date => {
  const dateStringInUTC = date.toISOString();
  return toZonedTime(dateStringInUTC, "Europe/Moscow");
};
const convertLocalToMoscowTimestamp = value => {
  const date = new Date(value * 1e3);
  return convertLocalToMoscow(date);
};
function getCurrentIANATimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/***/ }),

/***/ 63419:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   jz: () => (/* binding */ DEFAULT_AVATAR_URL),
/* harmony export */   m$: () => (/* binding */ getYandexAvatarById)
/* harmony export */ });
/* unused harmony exports DEFAULT_AVATAR_SIZE, DEFAULT_AVATAR_ID, getAvatarSizesField */
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68760);
/* harmony import */ var core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83039);
/* harmony import */ var core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(280);
/* harmony import */ var core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_find_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27591);
/* harmony import */ var core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_map_js__WEBPACK_IMPORTED_MODULE_4__);







const AVATAR_HOST = "https://avatars.mds.yandex.net/get-yapic";
const AVATAR_SIZES = {
  28: "islands-small",
  34: "islands-34",
  42: "islands-middle",
  50: "islands-50",
  56: "islands-retina-small",
  68: "islands-68",
  75: "islands-75",
  84: "islands-retina-middle",
  100: "islands-retina-50",
  200: "islands-200"
};
const DEFAULT_AVATAR_SIZE = 68;
const SORTED_SIZE_FIELDS = Object.keys(AVATAR_SIZES).map(avatarSize => +avatarSize).sort((a, b) => a - b);
const DEFAULT_AVATAR_ID = "0/0-0";
const DEFAULT_AVATAR_URL = `${AVATAR_HOST}/${DEFAULT_AVATAR_ID}/${AVATAR_SIZES[getAvatarSizesField(DEFAULT_AVATAR_SIZE)]}`;
const getYandexAvatarById = params => {
  const {
    size,
    id
  } = params;
  if (!id || id === DEFAULT_AVATAR_ID) {
    return DEFAULT_AVATAR_URL;
  }
  const image = new Image();
  const avatarUrl = id.startsWith("http") ? id : `${AVATAR_HOST}/${id || DEFAULT_AVATAR_ID}/${AVATAR_SIZES[getAvatarSizesField(size)]}`;
  image.src = avatarUrl;
  return image.onerror ? DEFAULT_AVATAR_URL : avatarUrl;
};
function getAvatarSizesField(size) {
  let devicePixelRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.devicePixelRatio;
  const sizeField = mapAvatarSizeToNumber(size) * devicePixelRatio;
  return SORTED_SIZE_FIELDS.find(sortedSizeField => sortedSizeField >= sizeField) || SORTED_SIZE_FIELDS[SORTED_SIZE_FIELDS.length - 1] || DEFAULT_AVATAR_SIZE;
}
function mapAvatarSizeToNumber(size) {
  if (typeof size === "string") {
    const avatarSize = Object.entries(AVATAR_SIZES).find(_ref => {
      let [, value] = _ref;
      return value === size;
    });
    return avatarSize ? +avatarSize[0] : DEFAULT_AVATAR_SIZE;
  }
  return size ?? DEFAULT_AVATAR_SIZE;
}

/***/ }),

/***/ 48353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: () => (/* binding */ createPolling)
/* harmony export */ });


function createPolling(fn, _ref) {
  let {
    delay,
    limit,
    delayMultiplier = 1
  } = _ref;
  let timeoutId = null;
  let callCount = 0;
  let currentDelay = delay;
  const callFunction = () => {
    if (limit !== void 0 && callCount >= limit) {
      stop();
      return;
    }
    fn();
    callCount++;
    if (callCount > 1) {
      currentDelay *= delayMultiplier;
    }
    timeoutId = window.setTimeout(callFunction, currentDelay);
  };
  const start = () => {
    if (timeoutId) {
      return;
    }
    callFunction();
  };
  const stop = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  return {
    start,
    stop
  };
}

/***/ }),

/***/ 50506:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ formFieldTransforms)
/* harmony export */ });
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66176);
/* harmony import */ var _validations_phone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24796);




const formFieldTransforms = {
  trim(value) {
    return value.trim();
  },
  tryTrim(value) {
    return value?.trim();
  },
  phone(value) {
    let captureText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _logger__WEBPACK_IMPORTED_MODULE_0__/* .Logger */ .Yd.captureException;
    const phoneResult = (0,_validations_phone__WEBPACK_IMPORTED_MODULE_1__/* .getPhoneValidationResult */ .R)(value);
    if (phoneResult.isValid) {
      return phoneResult.phoneNumber;
    }
    captureText("Phone is invalid");
    return value;
  }
};

/***/ }),

/***/ 24796:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: () => (/* binding */ getPhoneValidationResult),
/* harmony export */   e: () => (/* binding */ isPhoneValid)
/* harmony export */ });
/* harmony import */ var phone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27657);
/* harmony import */ var phone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(phone__WEBPACK_IMPORTED_MODULE_0__);



const getPhoneValidationResult = phoneNumber => {
  const phoneRuResult = (0,phone__WEBPACK_IMPORTED_MODULE_0__.phone)(phoneNumber, {
    country: "RU",
    strictDetection: true
  });
  if (phoneRuResult.isValid) {
    return phoneRuResult;
  }
  return (0,phone__WEBPACK_IMPORTED_MODULE_0__.phone)(phoneNumber, {
    strictDetection: true
  });
};
const isPhoneValid = phoneNumber => {
  const phoneResult = getPhoneValidationResult(phoneNumber);
  return phoneResult.isValid;
};

/***/ }),

/***/ 9091:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $f: () => (/* binding */ makeRequest),
  eI: () => (/* binding */ makeSimpleRequest)
});

// UNUSED EXPORTS: getAdditionForJsonParseError

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(9571);
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
// EXTERNAL MODULE: ../shared/src/auth/index.ts + 2 modules
var auth = __webpack_require__(60980);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
// EXTERNAL MODULE: ../shared/src/model/api.model.ts
var api_model = __webpack_require__(30199);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
;// CONCATENATED MODULE: ../shared/src/promise.utils.ts



const infinitePromise = new Promise(function_utils/* emptyFunction */.Bi);
;// CONCATENATED MODULE: ../shared/src/utils/http.ts











const RawErrorContent = es6.type({
  code: es6.string
});
const RawError = es6.type({
  error: RawErrorContent
});
const defaultErrorMapper = () => api_model/* unexpectedError */.g;
const maxAttempts = 2;
function mapBody(body) {
  if (body === void 0) {
    return void 0;
  }
  if (body instanceof FormData) {
    return body;
  }
  return JSON.stringify(body);
}
function getContentType(body) {
  if (body === void 0 || body instanceof FormData) {
    return void 0;
  }
  return "application/json";
}
function createErrorLogger(requestId) {
  return (errorMessage, additionalData) => {
    const additional = checkErrorObject(additionalData) ? {
      errorMessage: additionalData.message,
      error: additionalData
    } : additionalData;
    logger/* Logger */.Yd.captureError(errorMessage, {
      requestId,
      additional
    });
  };
}
const makeRequest = async (url, options) => {
  const requestId = (0,v4/* default */.Z)();
  const headers = {
    "X-Request-ID": requestId
  };
  const method = options.method ?? "GET";
  const contentType = getContentType(options.body);
  if (contentType) {
    headers["Content-Type"] = contentType;
  }
  const requestOptions = {
    method,
    body: mapBody(options.body),
    credentials: "same-origin",
    headers
  };
  return makeSimpleRequest(url, options, requestOptions, requestId);
};
const makeSimpleRequest = async function (url, options, requestOptions) {
  let requestId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  const method = options.method ?? "GET";
  const captureError = createErrorLogger(requestId);
  const makeFetch = async function () {
    let attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let logs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : array_utils/* emptyArray */.ow;
    if (attempt >= maxAttempts) {
      captureError(`makeRequest(${url}) retry fail`, logs);
      return (0,Either.left)(null);
    }
    const retryFetch = message => makeFetch(attempt + 1, [...logs, `Attempt ${attempt}: ` + message]);
    let response2;
    try {
      response2 = await fetch(url, requestOptions);
    } catch (error) {
      if (error instanceof TypeError) {
        return retryFetch(`Fetch error: ${error.message}`);
      }
      captureError(`makeRequest(${url}) fetch()`, error);
      return (0,Either.left)(null);
    }
    switch (response2.status) {
      case 401:
        options.unauthorizedHandler ? options.unauthorizedHandler() : auth/* Auth */.g.redirectToPassport();
        return infinitePromise;
      case 504:
        if (method === "GET" || options.retry) {
          return retryFetch(`Code 504(${method})`);
        }
        captureError(`makeRequest(${url}) 504(${method})`);
        return (0,Either.left)(null);
      default:
        if (attempt !== 0) {
          captureError(`makeRequest(${url}) retry helps`, logs);
        }
        return (0,Either.right)(response2);
    }
  };
  const fetchResponseEither = await makeFetch();
  if ((0,Either.isLeft)(fetchResponseEither)) {
    return (0,Either.left)(api_model/* unexpectedError */.g);
  }
  const response = fetchResponseEither.right;
  let responseJson;
  try {
    const contentType = response.headers.get("Content-Type");
    if (contentType?.includes("application/json")) {
      responseJson = await response.json();
    } else {
      throw new Error("content-type not application/json");
    }
  } catch (error) {
    let addition;
    try {
      addition = await getAdditionForJsonParseError(response, error);
    } catch (additionError) {
      addition = {
        additionParseError: additionError
      };
    }
    captureError(`makeRequest(${url}) .json()`, addition);
    return (0,Either.left)(api_model/* unexpectedError */.g);
  }
  if (response.ok) {
    const validateResult2 = options.responseType.validate(responseJson, []);
    if ((0,Either.isLeft)(validateResult2)) {
      (0,logger/* captureCaptureIoTsError */.jS)(`makeRequest(${url}) response validate`, validateResult2);
      if (options.throwValidationError) {
        return (0,Either.left)(new Error(`IO-TS validations error (${url})`));
      }
    }
    if (options.resultMapper !== void 0) {
      try {
        return (0,Either.right)(options.resultMapper(responseJson));
      } catch (e) {
        captureError(`makeRequest(${url}) resultMapper`, e);
        return (0,Either.left)(api_model/* unexpectedError */.g);
      }
    }
    return (0,Either.right)(responseJson);
  }
  const validateResult = RawError.validate(responseJson, []);
  if ((0,Either.isLeft)(validateResult)) {
    (0,logger/* captureCaptureIoTsError */.jS)(`makeRequest(${url}) error validate`, validateResult);
    return (0,Either.left)(api_model/* unexpectedError */.g);
  }
  try {
    const {
      errorMapper = defaultErrorMapper
    } = options;
    const error = errorMapper(validateResult.right.error);
    if (error === api_model/* unexpectedError */.g) {
      captureError(`makeRequest(${url}) code ${response.status} unexpected error`, validateResult.right.error);
    }
    return (0,Either.left)(error);
  } catch (e) {
    captureError(`makeRequest(${url}) errorMapper`, e);
    return (0,Either.left)(api_model/* unexpectedError */.g);
  }
};
async function getAdditionForJsonParseError(response, error) {
  const responseContentType = response.headers.get("Content-Type");
  const responseStatus = response.status;
  const result = {
    responseContentType,
    responseStatus,
    responseText: void 0,
    responseTextErrorMessage: void 0,
    jsonParseErrorMessage: getParseJsonResponseErrorMessage(error)
  };
  const responseText = await tryParseTextForResponse(response);
  if (typeof responseText === "string") {
    result.responseText = responseText.substring(0, 1e3);
  } else {
    result.responseTextErrorMessage = responseText.message;
  }
  return result;
}
function getParseJsonResponseErrorMessage(error) {
  if (typeof error === "string") {
    return error;
  }
  if (checkErrorObject(error)) {
    return error.message;
  }
  return "Unknown error";
}
async function tryParseTextForResponse(response) {
  try {
    return await response.text();
  } catch (error) {
    return checkErrorObject(error) ? error : new Error("Can't parse response text");
  }
}
function checkErrorObject(error) {
  return typeof error === "object" && error !== null && error instanceof Error;
}

/***/ }),

/***/ 86649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ isRevisionAppVersion)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../shared/src/logger/index.ts + 4 modules
var logger = __webpack_require__(66176);
;// CONCATENATED MODULE: ../shared/src/utils/is-revision-app-version/constants.ts


const APP_VERSION_REGEXP = /PracticumEnglishApp\s*\(platform:\s*(android|iOS),\s*ver:\s*([0-9]+\.[0-9]+\.[0-9]+)(?:\+([0-9]+))?\)/i;
;// CONCATENATED MODULE: ../shared/src/utils/is-revision-app-version/is-revision-app-version.ts






const isRevisionAppVersion = async configVersionPromise => {
  const userAgent = navigator.userAgent;
  const appVersion = extractAppVersionFromUserAgent(userAgent);
  if (!appVersion || appVersion.platform === "android") {
    return false;
  }
  let configVersion = null;
  try {
    configVersion = await configVersionPromise();
    if (!configVersion) {
      return false;
    }
    const comparisonResult = compareVersions(appVersion, configVersion);
    return comparisonResult >= 0;
  } catch (error) {
    logger/* Logger */.Yd.captureException("Error detecting app versions", {
      userAgent,
      configVersion
    });
  }
};
const extractAppVersionFromUserAgent = userAgent => {
  const match = userAgent.match(APP_VERSION_REGEXP);
  if (!match) {
    return null;
  }
  return {
    platform: match[1].toLowerCase(),
    version: match[2],
    build: match[3] ? parseInt(match[3], 10) : 0
  };
};
const compareVersions = (version1, version2) => {
  const [major1, minor1, patch1] = version1.version.split(".").map(Number);
  const [major2, minor2, patch2] = version2.version.split(".").map(Number);
  if (major1 > major2) {
    return 1;
  }
  if (major1 < major2) {
    return -1;
  }
  if (minor1 > minor2) {
    return 1;
  }
  if (minor1 < minor2) {
    return -1;
  }
  if (patch1 > patch2) {
    return 1;
  }
  if (patch1 < patch2) {
    return -1;
  }
  if (version1.build > version2.build) {
    return 1;
  }
  if (version1.build < version2.build) {
    return -1;
  }
  return 0;
};

/***/ }),

/***/ 66415:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ isSafariBrowser)
/* harmony export */ });


const isSafariBrowser = () => "safari" in window;

/***/ }),

/***/ 90790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: () => (/* binding */ getDateFnsLocale),
/* harmony export */   Y: () => (/* binding */ dateFnsLocale)
/* harmony export */ });
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67739);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44589);



const dateFnsLocale = date_fns_locale__WEBPACK_IMPORTED_MODULE_0__.ru;
const getDateFnsLocale = locale => {
  if (locale === "ru") {
    return date_fns_locale__WEBPACK_IMPORTED_MODULE_0__.ru;
  }
  return date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* .enUS */ ._;
};

/***/ }),

/***/ 76780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ makeStore)
/* harmony export */ });
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31976);



function makeStore(defaultValue, domain) {
  const $store = domain ? domain.createStore(defaultValue) : (0,effector__WEBPACK_IMPORTED_MODULE_0__/* .createStore */ .MT)(defaultValue);
  const setEvent = domain ? domain.createEvent() : (0,effector__WEBPACK_IMPORTED_MODULE_0__/* .createEvent */ .yM)();
  const resetEvent = domain ? domain.createEvent() : (0,effector__WEBPACK_IMPORTED_MODULE_0__/* .createEvent */ .yM)();
  $store.on(setEvent, (_, value) => value);
  $store.reset(resetEvent);
  return [$store, setEvent, resetEvent];
}

/***/ }),

/***/ 99883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  h: () => (/* binding */ deleteQueryParam)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
;// CONCATENATED MODULE: ../shared/src/utils/query-params-utils/clear-query-param-for-link.ts








const clearQueryParamForLink = (keys, link, history) => {
  const query = new URLSearchParams(history.location.search);
  if (Array.isArray(keys)) {
    keys.forEach(key => {
      query.delete(key);
    });
  } else {
    query.delete(keys);
  }
  return link + "?" + query.toString();
};
;// CONCATENATED MODULE: ../shared/src/utils/query-params-utils/delete-query-param.ts



const deleteQueryParam = (keys, history) => clearQueryParamForLink(keys, history.location.pathname, history);

/***/ }),

/***/ 4761:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  r: () => (/* binding */ getUrlSearchParams)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(95850);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(73631);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(71399);
;// CONCATENATED MODULE: ../shared/src/utils/query-params-utils/constants.ts


const QUERY_PARAM_KEYS = {
  TASK_GUIDE_STUDENT: "taskGuideStudent",
  SYLLABUS_QUERY_KEY: "taskGuideSyllabus",
  TASK_GUIDE_SPEAKING_SESSION_ID: "taskGuideSpeakingSessionId",
  TASK_GUIDE_BUSINESS_PRODUCT_ID: "taskGuideBusinessProductId",
  BEGINNER_ONBOARDING_SELECT_TIME_SLOT_WEEK_DAY_ID: "beginnerOnboardingSelectTimeSlotWeekDayId"
};
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/delete-query-param.ts + 1 modules
var delete_query_param = __webpack_require__(99883);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/set-query-param.ts
var set_query_param = __webpack_require__(85960);
// EXTERNAL MODULE: ../shared/src/utils/query-params-utils/set-query-params-for-link.ts
var set_query_params_for_link = __webpack_require__(85033);
;// CONCATENATED MODULE: ../shared/src/utils/query-params-utils/get-url-search-params.ts










const getUrlSearchParams = {
  taskGuide: {
    getStudentId(history) {
      const params = new URLSearchParams(history.location.search);
      const studentId = params.get(QUERY_PARAM_KEYS.TASK_GUIDE_STUDENT);
      if (studentId !== null) {
        return studentId;
      }
    },
    getSyllabusId(history) {
      const params = new URLSearchParams(history.location.search);
      const syllabusId = params.get(QUERY_PARAM_KEYS.SYLLABUS_QUERY_KEY);
      if (syllabusId !== null) {
        return syllabusId;
      }
    },
    getBusinessProductId(history) {
      const params = new URLSearchParams(history.location.search);
      const businessProductId = params.get(QUERY_PARAM_KEYS.TASK_GUIDE_BUSINESS_PRODUCT_ID);
      if (businessProductId !== null) {
        return businessProductId;
      }
    },
    getSpeakingSessionId(history) {
      const params = new URLSearchParams(history.location.search);
      const speakingSessionId = params.get(QUERY_PARAM_KEYS.TASK_GUIDE_SPEAKING_SESSION_ID);
      if (speakingSessionId !== null) {
        return speakingSessionId;
      }
    },
    removeSpeakingSessionId(history) {
      return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.TASK_GUIDE_SPEAKING_SESSION_ID, history);
    },
    getTaskGuideLink(link, urlParams, history) {
      const params = [];
      if (urlParams.studentId) {
        params.push({
          key: QUERY_PARAM_KEYS.TASK_GUIDE_STUDENT,
          value: urlParams.studentId
        });
      }
      if (urlParams.syllabusId) {
        params.push({
          key: QUERY_PARAM_KEYS.SYLLABUS_QUERY_KEY,
          value: urlParams.syllabusId
        });
      }
      if (urlParams.speakingSessionId) {
        params.push({
          key: QUERY_PARAM_KEYS.TASK_GUIDE_SPEAKING_SESSION_ID,
          value: urlParams.speakingSessionId
        });
      }
      if (urlParams.businessProductId) {
        params.push({
          key: QUERY_PARAM_KEYS.TASK_GUIDE_BUSINESS_PRODUCT_ID,
          value: urlParams.businessProductId
        });
      }
      return (0,set_query_params_for_link/* setQueryParamsForLink */.U)(link, params, history);
    }
  },
  beginnerOnboardingSlotSelection: {
    getWeekDayTimeSlot(history) {
      const params = new URLSearchParams(history.location.search);
      const weekDayId = params.get(QUERY_PARAM_KEYS.BEGINNER_ONBOARDING_SELECT_TIME_SLOT_WEEK_DAY_ID);
      if (weekDayId !== null) {
        return weekDayId;
      }
      return null;
    },
    setEditingWeekDayId(history, weekDayId) {
      if (weekDayId === null) {
        return (0,delete_query_param/* deleteQueryParam */.h)(QUERY_PARAM_KEYS.BEGINNER_ONBOARDING_SELECT_TIME_SLOT_WEEK_DAY_ID, history);
      }
      return (0,set_query_param/* setQueryParam */.s)(QUERY_PARAM_KEYS.BEGINNER_ONBOARDING_SELECT_TIME_SLOT_WEEK_DAY_ID, weekDayId ?? "", history);
    }
  }
};

/***/ }),

/***/ 76155:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   l: () => (/* binding */ setQueryParamForLink)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95850);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73631);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71399);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2__);





const setQueryParamForLink = (key, value, link, history) => {
  const query = new URLSearchParams(history.location.search);
  query.set(key, value);
  return link + "?" + query.toString();
};

/***/ }),

/***/ 85960:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ setQueryParam)
/* harmony export */ });
/* harmony import */ var _set_query_param_for_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76155);



const setQueryParam = (key, value, history) => (0,_set_query_param_for_link__WEBPACK_IMPORTED_MODULE_0__/* .setQueryParamForLink */ .l)(key, value, history.location.pathname, history);

/***/ }),

/***/ 85033:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ setQueryParamsForLink)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95850);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73631);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71399);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2__);





const setQueryParamsForLink = (link, queryParams, history) => {
  const query = new URLSearchParams(history.location.search);
  for (const param of queryParams) {
    query.set(param.key, param.value);
  }
  return link + "?" + query.toString();
};

/***/ }),

/***/ 86710:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ reloadPage)
/* harmony export */ });


const reloadPage = () => {
  document.location.reload();
};

/***/ }),

/***/ 81597:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Y6: () => (/* reexport */ localStorageWrapper),
  KO: () => (/* reexport */ sessionStorageWrapper)
});

// UNUSED EXPORTS: LocalStorageKeys, SessionStorageKeys

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.for-each.js
var esnext_async_iterator_for_each = __webpack_require__(44000);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(85744);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.json.parse.js
var esnext_json_parse = __webpack_require__(67761);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.add-all.js
var esnext_set_add_all = __webpack_require__(5875);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.delete-all.js
var esnext_set_delete_all = __webpack_require__(50509);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.v2.js
var esnext_set_difference_v2 = __webpack_require__(74736);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.difference.js
var esnext_set_difference = __webpack_require__(38728);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.every.js
var esnext_set_every = __webpack_require__(64810);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.filter.js
var esnext_set_filter = __webpack_require__(43419);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.find.js
var esnext_set_find = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.v2.js
var esnext_set_intersection_v2 = __webpack_require__(94574);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.intersection.js
var esnext_set_intersection = __webpack_require__(16093);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.v2.js
var esnext_set_is_disjoint_from_v2 = __webpack_require__(36615);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-disjoint-from.js
var esnext_set_is_disjoint_from = __webpack_require__(77829);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.v2.js
var esnext_set_is_subset_of_v2 = __webpack_require__(33281);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-subset-of.js
var esnext_set_is_subset_of = __webpack_require__(60253);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.v2.js
var esnext_set_is_superset_of_v2 = __webpack_require__(24376);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.is-superset-of.js
var esnext_set_is_superset_of = __webpack_require__(49225);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.join.js
var esnext_set_join = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.map.js
var esnext_set_map = __webpack_require__(57265);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.reduce.js
var esnext_set_reduce = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.some.js
var esnext_set_some = __webpack_require__(15840);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.v2.js
var esnext_set_symmetric_difference_v2 = __webpack_require__(32442);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.symmetric-difference.js
var esnext_set_symmetric_difference = __webpack_require__(37610);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.v2.js
var esnext_set_union_v2 = __webpack_require__(227);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.set.union.js
var esnext_set_union = __webpack_require__(13351);
// EXTERNAL MODULE: ../../node_modules/fp-ts/lib/Either.js
var Either = __webpack_require__(87412);
// EXTERNAL MODULE: ../../node_modules/io-ts/es6/index.js
var es6 = __webpack_require__(87830);
;// CONCATENATED MODULE: ../shared/src/utils/storage/constants.ts


var LocalStorageKeys = /* @__PURE__ */(LocalStorageKeys2 => {
  LocalStorageKeys2["HardwareCheckupRequested"] = "hardware-checkup-requested";
  LocalStorageKeys2["ClassInitialIsOnlyAudio"] = "class-initial-is-only-audio";
  LocalStorageKeys2["ShownAnnouncementIds"] = "shown-announcement-ids";
  LocalStorageKeys2["GrammarGuidesTooltip"] = "grammarGuidesTooltip";
  LocalStorageKeys2["A2FlippedSkipButtonClicked"] = "a2FlippedSkipButtonClicked";
  LocalStorageKeys2["BeginnerPurchases"] = "beginnerPurchases";
  LocalStorageKeys2["BeginnersBetaTooltip"] = "beginnersBetaTooltip";
  LocalStorageKeys2["MatchPairsExperiment"] = "matchPairsExperiment";
  LocalStorageKeys2["BeginnerOnboarding"] = "beginnerOnboarding";
  LocalStorageKeys2["BeginnerCuratorInfo"] = "beginnerCuratorInfo";
  LocalStorageKeys2["TaskGuideCurrentStudent"] = "taskGuideCurrentStudent";
  LocalStorageKeys2["TaskGuideIsVisibleFlag"] = "taskGuideIsVisible";
  LocalStorageKeys2["KidsBetaNotification"] = "kidsBetaNotification";
  LocalStorageKeys2["AutoonboardingHideTimeSlotsHelpModal"] = "autoonboardingHideTimeSlotsHelpModal";
  LocalStorageKeys2["Translation"] = "translation";
  return LocalStorageKeys2;
})(LocalStorageKeys || {});
var SessionStorageKeys = /* @__PURE__ */(SessionStorageKeys2 => {
  SessionStorageKeys2["TaskGuideCurrentStudent"] = "taskGuideCurrentStudent";
  SessionStorageKeys2["TaskGuideTutorSyllabus"] = "taskGuideTutorSyllabus";
  SessionStorageKeys2["BeginnerAllTasksCurrentVariantIndex"] = "beginnerAllTasksCurrentVariantIndex";
  return SessionStorageKeys2;
})(SessionStorageKeys || {});
;// CONCATENATED MODULE: ../shared/src/utils/storage/utils.ts






const getShownAnnouncedIdsList = () => {
  const announcedIdsString = localStorage.getItem(LocalStorageKeys.ShownAnnouncementIds);
  if (announcedIdsString === null) {
    return null;
  }
  try {
    const parsedAnnouncedIdsString = JSON.parse(announcedIdsString);
    const checkResult = es6.array(es6.string).decode(parsedAnnouncedIdsString);
    if ((0,Either.isLeft)(checkResult)) {
      return null;
    }
    return checkResult.right;
  } catch {
    return null;
  }
};
const createSimpleFlag = function (key) {
  let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "shown";
  return {
    isShown() {
      return localStorage.getItem(key) === value;
    },
    setAsShown() {
      return localStorage.setItem(key, value);
    }
  };
};
;// CONCATENATED MODULE: ../shared/src/utils/storage/local-storage-wrapper.ts


































const localStorageWrapper = {
  hardwareCheckupRequested: {
    isRequested() {
      return localStorage.getItem(LocalStorageKeys.HardwareCheckupRequested) === "yes";
    },
    setRequested() {
      localStorage.setItem(LocalStorageKeys.HardwareCheckupRequested, "yes");
    }
  },
  classInitialIsOnlyAudio: {
    isOnlyAudio() {
      return localStorage.getItem(LocalStorageKeys.ClassInitialIsOnlyAudio) === "yes";
    },
    setOnlyAudio(isOnlyAudio) {
      if (isOnlyAudio) {
        localStorage.setItem(LocalStorageKeys.ClassInitialIsOnlyAudio, "yes");
      } else {
        localStorage.removeItem(LocalStorageKeys.ClassInitialIsOnlyAudio);
      }
    }
  },
  announcement: {
    updateShownIdsAndGetNotShown(activeIds) {
      const shownIds = getShownAnnouncedIdsList();
      if (shownIds === null) {
        return activeIds ?? null;
      }
      const shownIdsSet = new Set(shownIds);
      const newActiveIds = [];
      const newShownIds = [];
      activeIds.forEach(id => {
        if (shownIdsSet.has(id)) {
          newShownIds.push(id);
        } else {
          newActiveIds.push(id);
        }
      });
      if (newShownIds.length !== shownIds.length) {
        if (newShownIds.length === 0) {
          localStorage.removeItem(LocalStorageKeys.ShownAnnouncementIds);
        } else {
          localStorage.setItem(LocalStorageKeys.ShownAnnouncementIds, JSON.stringify(newShownIds));
        }
      }
      return newActiveIds ?? null;
    },
    addShownId(id) {
      const shownIds = getShownAnnouncedIdsList();
      if (shownIds === null) {
        localStorage.setItem(LocalStorageKeys.ShownAnnouncementIds, JSON.stringify([id]));
        return;
      }
      if (shownIds.indexOf(id) === -1) {
        localStorage.setItem(LocalStorageKeys.ShownAnnouncementIds, JSON.stringify([...shownIds, id]));
      }
    }
  },
  grammarGuidesTooltip: createSimpleFlag(LocalStorageKeys.GrammarGuidesTooltip, "yes"),
  a2PlusFlippedSkipButton: createSimpleFlag(LocalStorageKeys.A2FlippedSkipButtonClicked, "yes"),
  beginnersPurchasedProducts: {
    get() {
      const purchasesJSON = localStorage.getItem(LocalStorageKeys.BeginnerPurchases);
      if (purchasesJSON === null) {
        return [];
      }
      try {
        const purchases = JSON.parse(purchasesJSON);
        const checkResult = es6.array(es6.string).decode(purchases);
        if ((0,Either.isLeft)(checkResult)) {
          return [];
        }
        return checkResult.right;
      } catch {
        return [];
      }
    },
    set(productIds) {
      const purchasedProducts = this.get();
      const productsSet = new Set(productIds.concat(purchasedProducts));
      localStorage.setItem(LocalStorageKeys.BeginnerPurchases, JSON.stringify(Array.from(productsSet)));
    }
  },
  beginnersBetaInfo: createSimpleFlag(LocalStorageKeys.BeginnersBetaTooltip, "yes"),
  beginnerOnboarding: createSimpleFlag(LocalStorageKeys.BeginnerOnboarding),
  kidsBetaNotification: createSimpleFlag(LocalStorageKeys.KidsBetaNotification),
  matchPairsExperiment: {
    isEnabled() {
      return localStorage.getItem(LocalStorageKeys.MatchPairsExperiment) === "1";
    }
  },
  beginnerCuratorInfo: {
    getParam() {
      return localStorage.getItem(LocalStorageKeys.BeginnerCuratorInfo);
    },
    isOpened() {
      return localStorage.getItem(LocalStorageKeys.BeginnerCuratorInfo) === "opened";
    },
    setClosed() {
      return localStorage.setItem(LocalStorageKeys.BeginnerCuratorInfo, "closed");
    },
    setOpened() {
      return localStorage.setItem(LocalStorageKeys.BeginnerCuratorInfo, "opened");
    }
  },
  taskGuide: {
    getCurrentStudentId() {
      return localStorage.getItem(LocalStorageKeys.TaskGuideCurrentStudent);
    },
    setCurrentUserId(id) {
      return localStorage.setItem(LocalStorageKeys.TaskGuideCurrentStudent, id);
    },
    isVisible() {
      return localStorage.getItem(LocalStorageKeys.TaskGuideIsVisibleFlag) === "1";
    },
    setVisibilityState(newState) {
      localStorage.setItem(LocalStorageKeys.TaskGuideIsVisibleFlag, newState ? "1" : "0");
    }
  },
  autoonboardingHideTimeSlotsHelpModal: createSimpleFlag(LocalStorageKeys.AutoonboardingHideTimeSlotsHelpModal, "yes"),
  translation: {
    isOn() {
      return localStorage.getItem(LocalStorageKeys.Translation) === "yes";
    },
    setOn() {
      localStorage.setItem(LocalStorageKeys.Translation, "yes");
    },
    setOff() {
      localStorage.removeItem(LocalStorageKeys.Translation);
    }
  }
};
;// CONCATENATED MODULE: ../shared/src/utils/storage/session-storage-wrapper.ts



const sessionStorageWrapper = {
  taskGuide: {
    getCurrentStudentId() {
      return sessionStorage.getItem(SessionStorageKeys.TaskGuideCurrentStudent);
    },
    setCurrentUserId(id) {
      return sessionStorage.setItem(SessionStorageKeys.TaskGuideCurrentStudent, id);
    },
    getSyllabusId() {
      return sessionStorage.getItem(SessionStorageKeys.TaskGuideTutorSyllabus);
    },
    setSyllabusId(id) {
      return sessionStorage.setItem(SessionStorageKeys.TaskGuideTutorSyllabus, id);
    }
  },
  beginnerAllTasksCurrentVariantIndex: {
    getItem() {
      return sessionStorage.getItem(SessionStorageKeys.BeginnerAllTasksCurrentVariantIndex);
    },
    get() {
      return Number(sessionStorage.getItem(SessionStorageKeys.BeginnerAllTasksCurrentVariantIndex) ?? 0);
    },
    set(index) {
      return sessionStorage.setItem(SessionStorageKeys.BeginnerAllTasksCurrentVariantIndex, String(index));
    }
  }
};
;// CONCATENATED MODULE: ../shared/src/utils/storage/index.ts






/***/ }),

/***/ 67288:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ convertSecondsToPlayerLabel),
/* harmony export */   z: () => (/* binding */ mergeDateAndTime)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82596);
/* harmony import */ var core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_filter_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36199);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14103);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91253);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40618);






function convertSecondsToPlayerLabel(value) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    useMilliseconds = false,
    separate = ":"
  } = params;
  const date = new Date(value * 1e3);
  const milliseconds = date.getUTCMilliseconds();
  const seconds = date.getUTCSeconds();
  const minutes = date.getUTCMinutes();
  const hours = date.getUTCHours();
  return [hours ? hours.toString() : void 0, hours ? minutes.toString().padStart(2, "0") : minutes.toString(), seconds.toString().padStart(2, "0"), milliseconds && useMilliseconds ? milliseconds.toString() : void 0].filter(Boolean).join(separate);
}
const mergeDateAndTime = (date, time) => (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* .set */ .t)(date, {
  hours: (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* .getHours */ .p)(time),
  minutes: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* .getMinutes */ .q)(time)
});

/***/ }),

/***/ 19582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ unEither)
/* harmony export */ });
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87412);
/* harmony import */ var fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_0__);



function unEither(func) {
  return function () {
    return func(...arguments).then(result => {
      if ((0,fp_ts_lib_Either__WEBPACK_IMPORTED_MODULE_0__.isLeft)(result)) {
        throw result.left;
      }
      return result.right;
    });
  };
}

/***/ }),

/***/ 52702:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: () => (/* binding */ convertImageUrlToCssUrl)
/* harmony export */ });


function convertImageUrlToCssUrl(imageUrl) {
  if (!imageUrl) {
    return void 0;
  }
  const decodeUrlStr = decodeURI(imageUrl);
  return `url("${decodeUrlStr === imageUrl ? encodeURI(imageUrl) : imageUrl}")`;
}

/***/ }),

/***/ 88675:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $: () => (/* binding */ WebcalInstructionPopup)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/modal/index.ts + 7 modules
var modal = __webpack_require__(80388);
// EXTERNAL MODULE: ../shared/src/domain/urls.ts
var urls = __webpack_require__(92976);
;// CONCATENATED MODULE: ../shared/src/widgets/webcal-instruction-popup/webcal-instruction-popup.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const webcal_instruction_popup_module = ({"image":"webcal-instruction-popup-module__image--rnETg","image-loading":"webcal-instruction-popup-module__image-loading--AQogl","imageLoading":"webcal-instruction-popup-module__image-loading--AQogl","instruction":"webcal-instruction-popup-module__instruction--iwA1P","loader":"webcal-instruction-popup-module__loader--zPIgb"});
;// CONCATENATED MODULE: ../shared/src/widgets/webcal-instruction-popup/webcal-instruction-popup.component.tsx










const INSTRUCTIONS = {
  google: {
    image: "google-calendar.jpg",
    name: "Google",
    instruction: "CalendarWebcalOnboarding.instruction_google",
    resourceName: "googleCalendar"
  },
  yandex: {
    image: "yandex-calendar.jpg",
    name: "Yandex",
    instruction: "CalendarWebcalOnboarding.instruction_yandex",
    resourceName: "yaCalendar"
  },
  apple: {
    image: "",
    name: "",
    instruction: "",
    resourceName: ""
  }
  // no instruction for apple
};
const WebcalInstructionPopup = _ref => {
  let {
    provider,
    onClose,
    webcalUrl
  } = _ref;
  const [copied, setCopied] = (0,react.useState)(false);
  const [imageLoaded, setImageLoaded] = (0,react.useState)(false);
  const intl = (0,useIntl/* default */.Z)();
  const instruction = INSTRUCTIONS[provider];
  let timeoutId = null;
  (0,react.useEffect)(() => () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);
  const copyLinkAction = () => {
    void navigator.clipboard.writeText(webcalUrl);
    setCopied(true);
    timeoutId = setTimeout(() => {
      setCopied(false);
    }, 1e3);
  };
  const instructionMarkdown = intl.formatMessage({
    id: instruction.instruction
  }, {
    webcalUrl,
    calendar: instruction.resourceName ? (0,urls/* getExternalUrl */.Eg)(instruction.resourceName) : ""
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(modal/* Modal */.u_, {
    onClose,
    showCloseButton: imageLoaded,
    title: imageLoaded ? intl.formatMessage({
      id: "CalendarWebcalOnboarding.header"
    }, {
      calendarName: instruction.name
    }) : "",
    headerImage: /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      className: imageLoaded ? webcal_instruction_popup_module.image : webcal_instruction_popup_module.imageLoading,
      src: `https://flowstatic.s3.yandex.net/onboarding/${instruction.image}`,
      alt: intl.formatMessage({
        id: "CalendarWebcalOnboarding.ImageAlt"
      }),
      onLoad: () => setImageLoaded(true)
    }),
    buttons: imageLoaded ? [{
      text: intl.formatMessage({
        id: copied ? "CalendarWebcalOnboarding.copiedLink" : "CalendarWebcalOnboarding.copyLink"
      }),
      disabled: copied,
      appearance: "primary",
      onClick: copyLinkAction
    }] : [],
    children: imageLoaded ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: webcal_instruction_popup_module.instruction,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        children: instructionMarkdown
      })
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: webcal_instruction_popup_module.loader,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {})
    })
  });
};

/***/ }),

/***/ 11628:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  b: () => (/* binding */ Alert)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/src/hooks/intl-format-context.ts
var intl_format_context = __webpack_require__(93131);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/alert/model/model.ts
var model = __webpack_require__(98922);
;// CONCATENATED MODULE: ../ui-kit/src/alert/lib/utils/get-icon-name.ts



function getIconName(type) {
  if (type === model/* AlertType */.N.INFO) {
    return "wave-star";
  }
  if (type === model/* AlertType */.N.WARNING) {
    return "warning";
  }
  return "warning";
}
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/alert/alert.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const alert_module = ({"root":"alert-module__root--_M3es","info":"alert-module__info--RahqS","warning":"alert-module__warning--ZLZ1b"});
;// CONCATENATED MODULE: ../ui-kit/src/alert/alert.tsx










const Alert = _ref => {
  let {
    className,
    text,
    type,
    iconCustomProps,
    withoutIcon = false,
    id
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    formatMessage
  } = (0,intl_format_context/* useIntlFormatContext */.L)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    id,
    className: classnames_default()(alert_module.root, alert_module[type], className),
    role: "alert",
    children: [!withoutIcon && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: getIconName(type),
      size: "medium",
      alt: formatMessage(`alert.alt.${type}`),
      ...iconCustomProps
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(typography_module/* default */.Z.body2, {
        [typography_module/* default */.Z.caption]: isMobile
      }),
      children: text
    })]
  });
};

/***/ }),

/***/ 98922:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ AlertType)
/* harmony export */ });


var AlertType = /* @__PURE__ */(AlertType2 => {
  AlertType2["WARNING"] = "warning";
  AlertType2["INFO"] = "info";
  return AlertType2;
})(AlertType || {});

/***/ }),

/***/ 66202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  q: () => (/* binding */ Avatar),
  D: () => (/* binding */ AvatarSize)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/utils/avatar/avatar.utils.ts
var avatar_utils = __webpack_require__(63419);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ../ui-kit/src/avatar/avatar.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const avatar_module = ({"root":"avatar-module__root--iKYzJ","image":"avatar-module__image--oxb6u","crown":"avatar-module__crown--c7mHd","image-size24":"avatar-module__image-size24--R72l0","imageSize24":"avatar-module__image-size24--R72l0","image-size32":"avatar-module__image-size32--GCcmA","imageSize32":"avatar-module__image-size32--GCcmA","image-size40":"avatar-module__image-size40--BEWPt","imageSize40":"avatar-module__image-size40--BEWPt","image-size48":"avatar-module__image-size48--l8cpt","imageSize48":"avatar-module__image-size48--l8cpt","image-size64":"avatar-module__image-size64--kJYaP","imageSize64":"avatar-module__image-size64--kJYaP","image-size104":"avatar-module__image-size104--FO92e","imageSize104":"avatar-module__image-size104--FO92e"});
;// CONCATENATED MODULE: ../ui-kit/src/avatar/avatar.component.tsx








var AvatarSize = /* @__PURE__ */(AvatarSize2 => {
  AvatarSize2[AvatarSize2["Size24"] = 0] = "Size24";
  AvatarSize2[AvatarSize2["Size32"] = 1] = "Size32";
  AvatarSize2[AvatarSize2["Size40"] = 2] = "Size40";
  AvatarSize2[AvatarSize2["Size48"] = 3] = "Size48";
  AvatarSize2[AvatarSize2["Size64"] = 4] = "Size64";
  AvatarSize2[AvatarSize2["Size104"] = 5] = "Size104";
  return AvatarSize2;
})(AvatarSize || {});
const getSizeClass = size => {
  switch (size) {
    case 0 /* Size24 */:
      return avatar_module.imageSize24;
    case 1 /* Size32 */:
      return avatar_module.imageSize32;
    case 2 /* Size40 */:
      return avatar_module.imageSize40;
    case 3 /* Size48 */:
      return avatar_module.imageSize48;
    case 4 /* Size64 */:
      return avatar_module.imageSize64;
    case 5 /* Size104 */:
      return avatar_module.imageSize104;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(size);
  }
};
const getSizeAvatarSize = size => {
  switch (size) {
    case 0 /* Size24 */:
      return 50;
    case 1 /* Size32 */:
      return 68;
    case 2 /* Size40 */:
      return 84;
    case 3 /* Size48 */:
    case 4 /* Size64 */:
    case 5 /* Size104 */:
      return 200;
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(size);
  }
};
const Avatar = _ref => {
  let {
    avatarId,
    size,
    onClick,
    hasPlus,
    className,
    ...rest
  } = _ref;
  const sizeClass = getSizeClass(size);
  const avatarSize = getSizeAvatarSize(size);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(avatar_module.root, sizeClass, className),
    onClick,
    ...rest,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("img", {
      alt: "user avatar",
      className: avatar_module.image,
      src: (0,avatar_utils/* getYandexAvatarById */.m$)({
        id: avatarId,
        size: avatarSize
      })
    }), hasPlus && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: avatar_module.crown,
      name: "ya-plus-crown",
      size: "large"
    })]
  });
};

/***/ }),

/***/ 51311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  T: () => (/* binding */ TimeBlock)
});

// UNUSED EXPORTS: TimeSelectionWidget

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/date-fns/format.mjs + 4 modules
var format = __webpack_require__(77689);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/utils/locale.ts
var locale = __webpack_require__(90790);
// EXTERNAL MODULE: ../ui-kit/src/big-text-dropdown/big-text-dropdown.component.tsx + 1 modules
var big_text_dropdown_component = __webpack_require__(89008);
// EXTERNAL MODULE: ../ui-kit/src/bottom-sheet/bottom-sheet@light.component.tsx + 1 modules
var bottom_sheet_light_component = __webpack_require__(80814);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/deprecated-modal/deprecated-modal.component.tsx + 1 modules
var deprecated_modal_component = __webpack_require__(49159);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__time-selection-widget/types.ts


var TimeFormatEnum = /* @__PURE__ */(TimeFormatEnum2 => {
  TimeFormatEnum2[TimeFormatEnum2["Day"] = 0] = "Day";
  TimeFormatEnum2[TimeFormatEnum2["Hour"] = 1] = "Hour";
  TimeFormatEnum2[TimeFormatEnum2["Minutes"] = 2] = "Minutes";
  TimeFormatEnum2[TimeFormatEnum2["FullTime"] = 3] = "FullTime";
  return TimeFormatEnum2;
})(TimeFormatEnum || {});
var types_ContentPositionEnum = /* @__PURE__ */(ContentPositionEnum2 => {
  ContentPositionEnum2["Default"] = "Default";
  ContentPositionEnum2["Centered"] = "Centered";
  return ContentPositionEnum2;
})(types_ContentPositionEnum || {});
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__time-selection-widget/time-selection-widget.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const time_selection_widget_module = ({"root":"time-selection-widget-module__root--AC1hl","subtitle":"time-selection-widget-module__subtitle--ld6XB","subtitle-centered":"time-selection-widget-module__subtitle-centered--lrK2Y","subtitleCentered":"time-selection-widget-module__subtitle-centered--lrK2Y","icon":"time-selection-widget-module__icon--lQmnZ","title":"time-selection-widget-module__title--p4tU3","caption":"time-selection-widget-module__caption--HzlPA","time-block":"time-selection-widget-module__time-block--a_bLv","timeBlock":"time-selection-widget-module__time-block--a_bLv","time-block-centered":"time-selection-widget-module__time-block-centered--ahLEL","timeBlockCentered":"time-selection-widget-module__time-block-centered--ahLEL","slot":"time-selection-widget-module__slot--Hd63y","time-slot":"time-selection-widget-module__time-slot--ju8pL","timeSlot":"time-selection-widget-module__time-slot--ju8pL","month-and-day-of-week":"time-selection-widget-module__month-and-day-of-week--rr5F_","monthAndDayOfWeek":"time-selection-widget-module__month-and-day-of-week--rr5F_","loader":"time-selection-widget-module__loader--nJzbg","buttons":"time-selection-widget-module__buttons--Iro4X","button":"time-selection-widget-module__button--L4oMr","description":"time-selection-widget-module__description--Rd24e","avatar-block":"time-selection-widget-module__avatar-block--gHmAX","avatarBlock":"time-selection-widget-module__avatar-block--gHmAX","avatar-image":"time-selection-widget-module__avatar-image--n7d3H","avatarImage":"time-selection-widget-module__avatar-image--n7d3H","mobile-root":"time-selection-widget-module__mobile-root--Fi_54","mobileRoot":"time-selection-widget-module__mobile-root--Fi_54"});
;// CONCATENATED MODULE: ../ui-kit/src/beginner-scheduling/__time-selection-widget/time-selection-widget.component.tsx




















const TimeSlot = _ref => {
  let {
    selectedTime,
    allTimes,
    onChange,
    timeFormat
  } = _ref;
  const intl = (0,useIntl/* default */.Z)();
  switch (timeFormat) {
    case TimeFormatEnum.Day:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
        "data-testid": "time-selection-widget-day-dropdown",
        content: /* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
          className: typography_module/* default */.Z.headline2,
          children: [(0,format/* format */.WU)(selectedTime.time, "dd", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
            type: "hidden",
            value: selectedTime.time.toISOString(),
            "data-testid": "time-selection-widget-day-dropdown-date-value"
          })]
        }),
        additionalContent: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          "data-testid": "month-weekday",
          className: classnames_default()(time_selection_widget_module.monthAndDayOfWeek, typography_module/* default */.Z.captionAccent),
          children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            "data-testid": "month",
            children: [(0,format/* format */.WU)(selectedTime.time, "MMMM", {
              locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
            }), ","]
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            "data-testid": "weekday",
            children: (0,format/* format */.WU)(selectedTime.time, "EEEE", {
              locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
            })
          })]
        }),
        items: allTimes,
        activeItemId: selectedTime.id,
        onChange
      });
    case TimeFormatEnum.Hour:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
        "data-testid": "time-selection-widget-hour-dropdown",
        content: /* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
          className: typography_module/* default */.Z.headline2,
          children: [(0,format/* format */.WU)(selectedTime.time, "HH", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
            type: "hidden",
            value: selectedTime.time.toISOString(),
            "data-testid": "time-selection-widget-day-dropdown-hour-value"
          })]
        }),
        items: allTimes,
        activeItemId: selectedTime.id,
        onChange
      });
    case TimeFormatEnum.Minutes:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
        "data-testid": "time-selection-widget-minutes-dropdown",
        content: /* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
          className: typography_module/* default */.Z.headline2,
          children: [(0,format/* format */.WU)(selectedTime.time, "mm", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
            type: "hidden",
            value: selectedTime.time.toISOString(),
            "data-testid": "time-selection-widget-day-dropdown-minutes-value"
          })]
        }),
        items: allTimes,
        activeItemId: selectedTime.id,
        onChange
      });
    case TimeFormatEnum.FullTime:
      return /* @__PURE__ */(0,jsx_runtime.jsx)(big_text_dropdown_component/* BigTextDropdown */.B, {
        "data-testid": "time-selection-widget-full-time-dropdown",
        content: /* @__PURE__ */(0,jsx_runtime.jsxs)("h2", {
          className: typography_module/* default */.Z.headline2,
          children: [(0,format/* format */.WU)(selectedTime.time, "HH:mm", {
            locale: (0,locale/* getDateFnsLocale */.G)(intl.locale)
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
            type: "hidden",
            value: selectedTime.time.toISOString(),
            "data-testid": "time-selection-widget-day-dropdown-full-time-value"
          })]
        }),
        items: allTimes,
        activeItemId: selectedTime.id,
        onChange
      });
    default:
      return null;
  }
};
const TimeBlock = _ref2 => {
  let {
    timeSlot,
    isMobile = false,
    className
  } = _ref2;
  const timeFont = (0,react.useMemo)(() => {
    if (isMobile) {
      return typography_module/* default */.Z.headline3;
    }
    return typography_module/* default */.Z.headline2;
  }, [isMobile]);
  const type = timeSlot.type;
  switch (type) {
    case "time":
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(time_selection_widget_module.slot, className),
        "data-testid": "time-selection-widget-time",
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.captionAccent,
          children: timeSlot.label
        }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(time_selection_widget_module.timeSlot, timeFont),
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TimeSlot, {
            ...timeSlot.hours,
            timeFormat: TimeFormatEnum.Hour
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
            className: typography_module/* default */.Z.headline2,
            children: ":"
          }), /* @__PURE__ */(0,jsx_runtime.jsx)(TimeSlot, {
            ...timeSlot.minutes,
            timeFormat: TimeFormatEnum.Minutes
          })]
        })]
      });
    case "date":
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(time_selection_widget_module.slot, className),
        "data-testid": "time-selection-widget-date",
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.captionAccent,
          children: timeSlot.label
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: timeFont,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TimeSlot, {
            ...timeSlot.date,
            timeFormat: TimeFormatEnum.Day
          })
        })]
      });
    case "fullTime":
      return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(time_selection_widget_module.slot, className),
        "data-testid": "time-selection-widget-full-time",
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: typography_module/* default */.Z.captionAccent,
          children: timeSlot.label
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(time_selection_widget_module.timeSlot, timeFont),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TimeSlot, {
            ...timeSlot.fullTime,
            timeFormat: TimeFormatEnum.FullTime
          })
        })]
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(type);
  }
};
const TimeSelectionWidget = _ref3 => {
  let {
    className,
    textContent,
    showCloseButton,
    avatarUrl,
    iconName,
    isTimeSlotsLoading,
    firstTimeSlot,
    secondTimeSlot,
    contentPosition = ContentPositionEnum.Default,
    buttons,
    visible = true,
    onClose,
    isMobile = false
  } = _ref3;
  const renderTitleBlock = useCallback(() => /* @__PURE__ */jsxs(Fragment, {
    children: [textContent.subtitle && /* @__PURE__ */jsxs("div", {
      className: cn(styles.subtitle, typography.body2Accent, {
        [styles.subtitleCentered]: contentPosition === ContentPositionEnum.Centered
      }),
      children: [iconName && /* @__PURE__ */jsx(Icon, {
        className: styles.icon,
        name: iconName,
        size: "small"
      }), /* @__PURE__ */jsx("h2", {
        className: typography.body2Accent,
        children: textContent.subtitle
      })]
    }), textContent.avatarText && /* @__PURE__ */jsxs("div", {
      className: styles.avatarBlock,
      children: [avatarUrl && /* @__PURE__ */jsx("img", {
        src: avatarUrl,
        alt: "tutor avatar",
        className: styles.avatarImage
      }), /* @__PURE__ */jsx("span", {
        className: typography.body2,
        children: textContent.avatarText
      })]
    }), textContent.title && /* @__PURE__ */jsx("h1", {
      className: cn(typography.body1Accent, styles.title),
      children: textContent.title
    }), textContent.caption && /* @__PURE__ */jsx("div", {
      className: cn(typography.caption, styles.caption),
      children: textContent.caption
    })]
  }), [avatarUrl, iconName, textContent.avatarText, textContent.caption, textContent.subtitle, textContent.title, contentPosition]);
  const renderTimeBlock = useCallback(() => {
    if (isTimeSlotsLoading) {
      return /* @__PURE__ */jsx("div", {
        className: styles.loader,
        children: /* @__PURE__ */jsx(Loader, {})
      });
    }
    return /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsxs("div", {
        className: cn(styles.timeBlock, {
          [styles.timeBlockCentered]: contentPosition === ContentPositionEnum.Centered
        }),
        children: [firstTimeSlot && /* @__PURE__ */jsx(TimeBlock, {
          timeSlot: firstTimeSlot,
          isMobile
        }), secondTimeSlot && /* @__PURE__ */jsx(TimeBlock, {
          timeSlot: secondTimeSlot,
          isMobile
        })]
      }), textContent.description && /* @__PURE__ */jsx("div", {
        className: cn(styles.description, typography.caption),
        children: textContent.description
      }), textContent.timeSlotPlaceholder && /* @__PURE__ */jsx("div", {
        className: typography.body2,
        children: textContent.timeSlotPlaceholder
      })]
    });
  }, [isTimeSlotsLoading, contentPosition, firstTimeSlot, isMobile, secondTimeSlot, textContent.description, textContent.timeSlotPlaceholder]);
  const renderButtonsBlock = useCallback(() => /* @__PURE__ */jsx("div", {
    className: styles.buttons,
    "data-testid": "time-selection-widget-buttons",
    children: buttons.map(button => /* @__PURE__ */jsx(Button, {
      className: styles.button,
      appearance: button.appearance,
      disabled: button.disabled,
      size: "medium",
      onClick: button.onClick,
      children: button.label
    }, button.label))
  }), [buttons]);
  if (isMobile) {
    return /* @__PURE__ */jsx(BottomSheetLight, {
      onClose,
      visible,
      children: /* @__PURE__ */jsxs("div", {
        className: styles.mobileRoot,
        children: [/* @__PURE__ */jsxs("div", {
          children: [renderTitleBlock(), renderTimeBlock()]
        }), renderButtonsBlock()]
      })
    });
  }
  return /* @__PURE__ */jsxs(DeprecatedModal, {
    onClose,
    className: cn(styles.root, className),
    autoHeight: true,
    visible,
    overlayZIndex: ModalOverlayZIndex.Low,
    showCloseButton,
    closeButtonAriaLabel: textContent.closeButtonAriaLabel,
    children: [renderTitleBlock(), renderTimeBlock(), renderButtonsBlock()]
  });
};

/***/ }),

/***/ 25874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  sD: () => (/* binding */ TaskCard),
  ab: () => (/* binding */ TaskCardState),
  Fj: () => (/* binding */ TaskCardType)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/mark.js/dist/mark.js
var mark = __webpack_require__(46755);
var mark_default = /*#__PURE__*/__webpack_require__.n(mark);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../shared/src/utils/url.ts
var url = __webpack_require__(52702);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__task-card/task-card.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_card_module = ({"task-card":"task-card-module__task-card--sh1g_","taskCard":"task-card-module__task-card--sh1g_","main-content":"task-card-module__main-content--x80f1","mainContent":"task-card-module__main-content--x80f1","highlighted-text":"task-card-module__highlighted-text--XIbSa","highlightedText":"task-card-module__highlighted-text--XIbSa","subtitle":"task-card-module__subtitle--AyVWo","description":"task-card-module__description--UOEnH","footer":"task-card-module__footer--GqGqu","footer-buttons":"task-card-module__footer-buttons--kapJQ","footerButtons":"task-card-module__footer-buttons--kapJQ","footer-button":"task-card-module__footer-button--bxf5D","footerButton":"task-card-module__footer-button--bxf5D","image":"task-card-module__image--AZOpY","done":"task-card-module__done--VHfwt","text-indent":"task-card-module__text-indent--Zpc0q","textIndent":"task-card-module__text-indent--Zpc0q","green-button":"task-card-module__green-button--i2Nrf","greenButton":"task-card-module__green-button--i2Nrf","hidden":"task-card-module__hidden--e_T3Q","none":"task-card-module__none--iIirV","text":"task-card-module__text--hyvNT","favorite":"task-card-module__favorite--zMJOs"});
;// CONCATENATED MODULE: ../ui-kit/src/beginners-main/__task-card/task-card.component.tsx















var TaskCardState = /* @__PURE__ */(TaskCardState2 => {
  TaskCardState2["Available"] = "available";
  TaskCardState2["Done"] = "done";
  TaskCardState2["InProgress"] = "inProgress";
  return TaskCardState2;
})(TaskCardState || {});
var TaskCardType = /* @__PURE__ */(TaskCardType2 => {
  TaskCardType2["Default"] = "default";
  TaskCardType2["Primary"] = "primary";
  return TaskCardType2;
})(TaskCardType || {});
const TaskCard = props => {
  const {
    anchorId,
    highlightedText,
    title,
    subtitle,
    description,
    ariaLabels,
    isFavorite,
    onFavoriteButtonClick,
    type,
    image,
    isDesktop
  } = props;
  const [isHovered, setHovered] = (0,react.useState)(false);
  const titleRef = (0,react.useRef)(null);
  const descriptionRef = (0,react.useRef)(null);
  const isButtonVisible = (0,react.useMemo)(() => {
    switch (type) {
      case "primary" /* Primary */:
        return true;
      case "default" /* Default */:
        return isHovered || !isDesktop;
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(type);
    }
  }, [isHovered, isDesktop, type]);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  const subtitleFont = isDesktop ? typography_module/* default */.Z.captionAccent : typography_module/* default */.Z.caption;
  (0,react.useEffect)(() => {
    if (descriptionRef.current && titleRef.current) {
      const titleMarkInstance = new (mark_default())(titleRef.current);
      const descriptionMarkInstance = new (mark_default())(descriptionRef.current);
      titleMarkInstance.unmark();
      descriptionMarkInstance.unmark();
      if (highlightedText) {
        const options = {
          separateWordSearch: false,
          className: task_card_module.highlightedText
        };
        titleMarkInstance.mark(highlightedText, options);
        descriptionMarkInstance.mark(highlightedText, options);
      }
    }
  }, [highlightedText]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    id: anchorId,
    "aria-label": ariaLabels.taskCard,
    className: task_card_module.taskCard,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: task_card_module.mainContent,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: task_card_module.text,
        children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("h4", {
            ref: titleRef,
            className: typography_module/* default */.Z.headline4Accent,
            children: title
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
            className: classnames_default()(subtitleFont, task_card_module.subtitle),
            children: subtitle
          })]
        }), description && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          ref: descriptionRef,
          className: classnames_default()(typography_module/* default */.Z.body2, task_card_module.description),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
            wrapper: markdown_component/* Wrapper */.im.fragment,
            children: description
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: task_card_module.footer,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: task_card_module.footerButtons,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(TaskCardButtons, {
            isHovered,
            isVisible: isButtonVisible,
            ...props
          })
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(task_card_module.favorite, {
            [task_card_module.hidden]: !isButtonVisible && !isFavorite
          }),
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
            appearance: "secondary",
            size: isDesktop ? "medium" : "small",
            iconName: isFavorite ? "bookmark-filled" : "bookmark",
            onClick: onFavoriteButtonClick,
            "aria-label": ariaLabels.addToFavoriteButton
          })
        })]
      })]
    }), type === "primary" /* Primary */ && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: task_card_module.image,
      style: {
        backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(image)
      }
    })]
  });
};
const TaskCardButtons = _ref => {
  let {
    state,
    ariaLabels,
    firstButton,
    secondButton,
    isDesktop,
    isVisible
  } = _ref;
  const [isTooltipVisible, setIsTooltipVisible] = (0,react.useState)(false);
  switch (state) {
    case "done" /* Done */:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [isDesktop ? /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: classnames_default()(task_card_module.done, {
                [task_card_module.hidden]: isVisible
              }),
              "aria-label": ariaLabels.doneLabel,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
                name: "checkmark",
                size: "medium"
              })
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
              autoWidth: true,
              placement: "top",
              trigger: "hover",
              visible: isTooltipVisible,
              overlay: firstButton.label,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
                "aria-label": firstButton.label,
                className: classnames_default()(task_card_module.footerButton, {
                  [task_card_module.hidden]: !isVisible
                }),
                appearance: "secondary",
                size: "medium",
                iconName: "reset",
                onClick: firstButton.onClick,
                onMouseOver: () => setIsTooltipVisible(true),
                onMouseOut: () => setIsTooltipVisible(false)
              }, firstButton.label)
            })]
          }) : /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
            "aria-label": firstButton.label,
            size: "small",
            appearance: "green",
            onClick: firstButton.onClick,
            className: task_card_module.greenButton,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              name: "checkmark-bold",
              size: "small"
            }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
              className: task_card_module.textIndent,
              children: firstButton.label
            })]
          }), secondButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
            "aria-label": secondButton.label,
            className: classnames_default()({
              [task_card_module.footerButton]: isDesktop,
              [task_card_module.hidden]: !isVisible
            }),
            size: isDesktop ? "medium" : "small",
            appearance: "secondary",
            onClick: secondButton.onClick,
            children: secondButton.label
          }, secondButton.label)]
        });
      }
    case "available" /* Available */:
    case "inProgress" /* InProgress */:
      {
        const isButtonHidden = !isVisible && state !== "inProgress" /* InProgress */;
        const isSecondaryButton = !isDesktop && state === "available" /* Available */;
        return /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          "aria-label": firstButton.label,
          size: isDesktop ? "medium" : "small",
          appearance: isSecondaryButton ? "secondary" : "primary",
          onClick: firstButton.onClick,
          className: classnames_default()(task_card_module.footerButton, {
            [task_card_module.hidden]: isButtonHidden
          }),
          children: firstButton.label
        });
      }
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(state);
  }
};

/***/ }),

/***/ 89008:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  B: () => (/* binding */ BigTextDropdown)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/select/select.tsx + 3 modules
var select_select = __webpack_require__(31727);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/big-text-dropdown/big-text-dropdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const big_text_dropdown_module = ({"root":"big-text-dropdown-module__root--l5gVb","button":"big-text-dropdown-module__button--gDAVP","column":"big-text-dropdown-module__column--BAm5r","bottom-place":"big-text-dropdown-module__bottom-place--nQ1JL","bottomPlace":"big-text-dropdown-module__bottom-place--nQ1JL","bottom-place-disabled":"big-text-dropdown-module__bottom-place-disabled--LpVO6","bottomPlaceDisabled":"big-text-dropdown-module__bottom-place-disabled--LpVO6","additional-content":"big-text-dropdown-module__additional-content--fsqXv","additionalContent":"big-text-dropdown-module__additional-content--fsqXv","item":"big-text-dropdown-module__item--PgCki","item-disabled":"big-text-dropdown-module__item-disabled--xCppW","itemDisabled":"big-text-dropdown-module__item-disabled--xCppW","checkbox-place":"big-text-dropdown-module__checkbox-place--ZZv_D","checkboxPlace":"big-text-dropdown-module__checkbox-place--ZZv_D","menu":"big-text-dropdown-module__menu--MxgDg"});
;// CONCATENATED MODULE: ../ui-kit/src/big-text-dropdown/big-text-dropdown.component.tsx










function ListItem(_ref) {
  let {
    item,
    active
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: big_text_dropdown_module.item,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2Accent,
        children: item.accentedText
      }), item.text && item.accentedText && /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "\xA0"
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: typography_module/* default */.Z.body2,
        children: item.text
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: big_text_dropdown_module.checkboxPlace,
      children: active && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        name: "checkmark",
        size: "medium"
      })
    })]
  });
}
function BigTextDropdown(_ref2) {
  let {
    onChange,
    content,
    additionalContent,
    isDisabled,
    items,
    activeItemId,
    ...rest
  } = _ref2;
  const bottomPlaceClasses = classnames_default()(big_text_dropdown_module.bottomPlace, {
    [big_text_dropdown_module.bottomPlaceDisabled]: isDisabled
  });
  return /* @__PURE__ */(0,jsx_runtime.jsx)(select_select/* Select */.P, {
    className: big_text_dropdown_module.root,
    menuClassName: big_text_dropdown_module.menu,
    disabled: isDisabled,
    onChange,
    value: activeItemId,
    options: items.map(item => ({
      value: item.id,
      disabled: item.isDisabled,
      title: /* @__PURE__ */(0,jsx_runtime.jsx)(ListItem, {
        item,
        active: item.id === activeItemId
      }),
      selected: item.id === activeItemId
    })),
    trigger: /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: big_text_dropdown_module.button,
      tabIndex: -1,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: big_text_dropdown_module.column,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          children: content
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: bottomPlaceClasses,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
            size: "medium",
            name: "chevron-down"
          })
        })]
      }), /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: big_text_dropdown_module.column,
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: big_text_dropdown_module.additionalContent,
          children: additionalContent
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: bottomPlaceClasses
        })]
      })]
    }),
    ...rest
  });
}

/***/ }),

/***/ 80814:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  e_: () => (/* binding */ BottomSheetLight),
  j9: () => (/* binding */ BottomSheetLightAppearance),
  tW: () => (/* binding */ BottomSheetLightColor),
  eD: () => (/* binding */ BottomSheetLightZIndex),
  wR: () => (/* binding */ HeaderPaddings)
});

// UNUSED EXPORTS: BottomSheetLightShadow

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/bottom-sheet/bottom-sheet@light.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const bottom_sheet_light_module = ({"root":"bottom-sheet@light-module__root--nzHFb","root-with-visible-overflow":"bottom-sheet@light-module__root-with-visible-overflow--LB8KM","rootWithVisibleOverflow":"bottom-sheet@light-module__root-with-visible-overflow--LB8KM","root-hidden":"bottom-sheet@light-module__root-hidden--_B1jk","rootHidden":"bottom-sheet@light-module__root-hidden--_B1jk","root-grey":"bottom-sheet@light-module__root-grey--FLOPP","rootGrey":"bottom-sheet@light-module__root-grey--FLOPP","root-with-large-shadow":"bottom-sheet@light-module__root-with-large-shadow--yWksy","rootWithLargeShadow":"bottom-sheet@light-module__root-with-large-shadow--yWksy","root-with-huge-shadow":"bottom-sheet@light-module__root-with-huge-shadow--BtHH_","rootWithHugeShadow":"bottom-sheet@light-module__root-with-huge-shadow--BtHH_","root-half-visible":"bottom-sheet@light-module__root-half-visible--pDijh","rootHalfVisible":"bottom-sheet@light-module__root-half-visible--pDijh","root-auto-top":"bottom-sheet@light-module__root-auto-top--e6edv","rootAutoTop":"bottom-sheet@light-module__root-auto-top--e6edv","root-full-screen":"bottom-sheet@light-module__root-full-screen--dE4MF","rootFullScreen":"bottom-sheet@light-module__root-full-screen--dE4MF","header":"bottom-sheet@light-module__header--sjHF5","header-large-paddings":"bottom-sheet@light-module__header-large-paddings--nCbdR","headerLargePaddings":"bottom-sheet@light-module__header-large-paddings--nCbdR","header-with-border":"bottom-sheet@light-module__header-with-border--m3KyL","headerWithBorder":"bottom-sheet@light-module__header-with-border--m3KyL","first-line":"bottom-sheet@light-module__first-line--QGk6f","firstLine":"bottom-sheet@light-module__first-line--QGk6f","fixed-header":"bottom-sheet@light-module__fixed-header--A6sjx","fixedHeader":"bottom-sheet@light-module__fixed-header--A6sjx","fixed-close-button":"bottom-sheet@light-module__fixed-close-button--jqUSc","fixedCloseButton":"bottom-sheet@light-module__fixed-close-button--jqUSc","second-line":"bottom-sheet@light-module__second-line--N_2u0","secondLine":"bottom-sheet@light-module__second-line--N_2u0","action-controls":"bottom-sheet@light-module__action-controls--tNckL","actionControls":"bottom-sheet@light-module__action-controls--tNckL","action-button":"bottom-sheet@light-module__action-button--Nv0o6","actionButton":"bottom-sheet@light-module__action-button--Nv0o6","action-button-active":"bottom-sheet@light-module__action-button-active--eaEAw","actionButtonActive":"bottom-sheet@light-module__action-button-active--eaEAw","cards":"bottom-sheet@light-module__cards--lmpPM","loader":"bottom-sheet@light-module__loader--fqlIa","empty-state-text":"bottom-sheet@light-module__empty-state-text--r6ipw","emptyStateText":"bottom-sheet@light-module__empty-state-text--r6ipw","wrapper":"bottom-sheet@light-module__wrapper--Vn7wJ","wrapper-low":"bottom-sheet@light-module__wrapper-low--KuUJY","wrapperLow":"bottom-sheet@light-module__wrapper-low--KuUJY","wrapper-hidden":"bottom-sheet@light-module__wrapper-hidden--ZV3VS","wrapperHidden":"bottom-sheet@light-module__wrapper-hidden--ZV3VS","wrapper-half-visible":"bottom-sheet@light-module__wrapper-half-visible--HP12E","wrapperHalfVisible":"bottom-sheet@light-module__wrapper-half-visible--HP12E","fade":"bottom-sheet@light-module__fade--zfBTw","fade-hidden":"bottom-sheet@light-module__fade-hidden--Bg1sw","fadeHidden":"bottom-sheet@light-module__fade-hidden--Bg1sw","half-visible-block":"bottom-sheet@light-module__half-visible-block--fg5yh","halfVisibleBlock":"bottom-sheet@light-module__half-visible-block--fg5yh","half-visible-content":"bottom-sheet@light-module__half-visible-content--ITfa1","halfVisibleContent":"bottom-sheet@light-module__half-visible-content--ITfa1","half-visible-icon":"bottom-sheet@light-module__half-visible-icon--nYpMk","halfVisibleIcon":"bottom-sheet@light-module__half-visible-icon--nYpMk","wordbank-card-wrapper":"bottom-sheet@light-module__wordbank-card-wrapper--m9Qj6","wordbankCardWrapper":"bottom-sheet@light-module__wordbank-card-wrapper--m9Qj6"});
;// CONCATENATED MODULE: ../ui-kit/src/bottom-sheet/bottom-sheet@light.component.tsx

















var BottomSheetLightAppearance = /* @__PURE__ */(BottomSheetLightAppearance2 => {
  BottomSheetLightAppearance2[BottomSheetLightAppearance2["Hidden"] = 0] = "Hidden";
  BottomSheetLightAppearance2[BottomSheetLightAppearance2["HalfVisible"] = 1] = "HalfVisible";
  return BottomSheetLightAppearance2;
})(BottomSheetLightAppearance || {});
var HeaderPaddings = /* @__PURE__ */(HeaderPaddings2 => {
  HeaderPaddings2["Default"] = "default";
  HeaderPaddings2["Large"] = "large";
  return HeaderPaddings2;
})(HeaderPaddings || {});
var BottomSheetLightZIndex = /* @__PURE__ */(BottomSheetLightZIndex2 => {
  BottomSheetLightZIndex2[BottomSheetLightZIndex2["Default"] = 0] = "Default";
  BottomSheetLightZIndex2[BottomSheetLightZIndex2["Low"] = 1] = "Low";
  return BottomSheetLightZIndex2;
})(BottomSheetLightZIndex || {});
var BottomSheetLightColor = /* @__PURE__ */(BottomSheetLightColor2 => {
  BottomSheetLightColor2[BottomSheetLightColor2["Grey"] = 0] = "Grey";
  BottomSheetLightColor2[BottomSheetLightColor2["White"] = 1] = "White";
  return BottomSheetLightColor2;
})(BottomSheetLightColor || {});
var BottomSheetLightShadow = /* @__PURE__ */(BottomSheetLightShadow2 => {
  BottomSheetLightShadow2[BottomSheetLightShadow2["Large"] = 0] = "Large";
  BottomSheetLightShadow2[BottomSheetLightShadow2["Huge"] = 1] = "Huge";
  return BottomSheetLightShadow2;
})(BottomSheetLightShadow || {});
const BottomSheetLight = _ref => {
  let {
    visible = false,
    actionsItems = array_utils/* emptyArray */.ow,
    children,
    subtitle,
    onClose,
    title,
    headerPaddings = "default" /* Default */,
    headerWithBorder = false,
    appearance = 0 /* Hidden */,
    hiddenTitle = "",
    zIndex = 0 /* Default */,
    onOpen = function_utils/* emptyFunction */.Bi,
    fixed = false,
    height = "",
    bgColor = 1 /* White */,
    shadow = 0 /* Large */,
    isVisibleOverflow = false,
    isFullScreen = false
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const rootShadowStyle = (0,react.useMemo)(() => {
    if (!visible) {
      return null;
    } else if (shadow === 0 /* Large */) {
      return bottom_sheet_light_module.rootWithLargeShadow;
    }
    return bottom_sheet_light_module.rootWithHugeShadow;
  }, [shadow, visible]);
  return react_dom.createPortal( /* @__PURE__ */(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [visible && /* @__PURE__ */(0,jsx_runtime.jsx)(use_block_main_scroll/* MainScrollBlocker */.j, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()({
        [bottom_sheet_light_module.fadeHidden]: !visible
      }, bottom_sheet_light_module.fade)
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(bottom_sheet_light_module.wrapper, {
        [bottom_sheet_light_module.wrapperHidden]: !visible,
        [bottom_sheet_light_module.wrapperHalfVisible]: appearance === 1 /* HalfVisible */ && !visible,
        [bottom_sheet_light_module.wrapperLow]: zIndex === 1 /* Low */
      }),
      onClick: () => {
        if (visible) {
          onClose();
        }
      },
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(bottom_sheet_light_module.root, rootShadowStyle, {
          [bottom_sheet_light_module.rootHidden]: !visible,
          [bottom_sheet_light_module.rootGrey]: bgColor === 0 /* Grey */,
          [bottom_sheet_light_module.rootHalfVisible]: appearance === 1 /* HalfVisible */ && !visible,
          [bottom_sheet_light_module.rootAutoTop]: height !== "",
          [bottom_sheet_light_module.rootWithVisibleOverflow]: isVisibleOverflow,
          [bottom_sheet_light_module.rootFullScreen]: isFullScreen
        }),
        style: {
          height
        },
        onClick: event => event.stopPropagation(),
        children: [visible && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()(bottom_sheet_light_module.header, {
            [bottom_sheet_light_module.headerLargePaddings]: headerPaddings === "large" /* Large */,
            [bottom_sheet_light_module.headerWithBorder]: headerWithBorder
          }),
          children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()(bottom_sheet_light_module.firstLine, {
              [bottom_sheet_light_module.fixedHeader]: fixed
            }),
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: typography_module/* default */.Z.body2Accent,
              children: subtitle
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
              appearance: "secondary",
              size: isMobile ? "small" : "medium",
              iconName: "cross",
              onClick: onClose,
              className: classnames_default()({
                [bottom_sheet_light_module.fixedCloseButton]: fixed
              })
            })]
          }), title && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(typography_module/* default */.Z.headline3, bottom_sheet_light_module.secondLine),
            children: title
          }), actionsItems.length !== 0 && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: bottom_sheet_light_module.actionControls,
            children: actionsItems.map(a => /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
              appearance: "secondary",
              size: "small",
              className: classnames_default()(typography_module/* default */.Z.captionAccent, bottom_sheet_light_module.actionButton, {
                [bottom_sheet_light_module.actionButtonActive]: a.active
              }),
              onClick: a.onClick,
              children: a.title
            }, a.title))
          })]
        }), visible && children, !visible && appearance === 1 /* HalfVisible */ && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: bottom_sheet_light_module.halfVisibleBlock,
          onClick: onOpen,
          children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
            className: bottom_sheet_light_module.halfVisibleContent,
            children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: typography_module/* default */.Z.body2Accent,
              children: hiddenTitle
            }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
              name: "arrow-up",
              size: "medium",
              className: bottom_sheet_light_module.halfVisibleIcon
            })]
          })
        })]
      })
    })]
  }), document.body);
};

/***/ }),

/***/ 41200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: () => (/* binding */ ButtonIcon)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _helpers_use_merge_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17034);
/* harmony import */ var _icons_icon_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48670);
/* harmony import */ var _loader_loader_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41178);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59496);
/* harmony import */ var _accessibility_accessibility_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98493);
/* harmony import */ var _button_icon_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83500);











const ButtonIcon = (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((_ref, ref) => {
  let {
    appearance = "default",
    size = "medium",
    iconSize = size === "tiny" ? "small" : size,
    iconName,
    className,
    state = _constants__WEBPACK_IMPORTED_MODULE_6__/* .ButtonIconState */ ._E.Initial,
    loading,
    readOnly,
    classes = {},
    ...props
  } = _ref;
  const classNames = (0,_helpers_use_merge_classes__WEBPACK_IMPORTED_MODULE_3__/* .useMergeClasses */ .E)(_button_icon_module_css__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, classes);
  const classNameCombined = classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _constants__WEBPACK_IMPORTED_MODULE_6__/* .sizeClasses */ .ag[size], _constants__WEBPACK_IMPORTED_MODULE_6__/* .appearanceClasses */ .xW[appearance], classNames.buttonIcon, {
    [classNames.secondaryHover]: appearance === "secondary" && state === _constants__WEBPACK_IMPORTED_MODULE_6__/* .ButtonIconState */ ._E.Hover,
    [classNames.active]: state === _constants__WEBPACK_IMPORTED_MODULE_6__/* .ButtonIconState */ ._E.Active,
    [classNames.readOnly]: readOnly,
    [_accessibility_accessibility_module_css__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.focusVisible]: true
  });
  if (loading) {
    const loaderSize = size === "tiny" || size === "small" ? _loader_loader_component__WEBPACK_IMPORTED_MODULE_5__/* .LoaderSize */ .gI.Small : _loader_loader_component__WEBPACK_IMPORTED_MODULE_5__/* .LoaderSize */ .gI.Default;
    return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: classNameCombined,
      children: /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loader_loader_component__WEBPACK_IMPORTED_MODULE_5__/* .Loader */ .aN, {
        size: loaderSize,
        isCurrentColor: true
      })
    });
  }
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
    ref,
    className: classNameCombined,
    type: "button",
    ...props,
    "aria-disabled": readOnly,
    children: /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_icon_component__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .J, {
      name: iconName,
      size: iconSize
    })
  });
});
ButtonIcon.displayName = "ButtonIcon";

/***/ }),

/***/ 59496:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _E: () => (/* binding */ ButtonIconState),
/* harmony export */   ag: () => (/* binding */ sizeClasses),
/* harmony export */   xW: () => (/* binding */ appearanceClasses)
/* harmony export */ });
/* harmony import */ var _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83500);



var ButtonIconState = /* @__PURE__ */(ButtonIconState2 => {
  ButtonIconState2["Initial"] = "initial";
  ButtonIconState2["Hover"] = "hover";
  ButtonIconState2["Active"] = "active";
  return ButtonIconState2;
})(ButtonIconState || {});
const sizeClasses = {
  large: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconLarge,
  medium: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconMedium,
  small: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconSmall,
  tiny: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconTiny
};
const appearanceClasses = {
  default: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconDefault,
  floating: [_button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconDefault, _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconFloating],
  primary: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconPrimary,
  primaryOnBlack: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconPrimaryOnBlack,
  primaryFloating: [_button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconPrimary, _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconFloating],
  secondary: _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconSecondary,
  secondaryFloating: [_button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconSecondary, _button_icon_module_css__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.buttonIconFloating]
};

/***/ }),

/***/ 66284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ ButtonLink)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47933);
/* harmony import */ var _yandex_langly_shared_src_domain_domain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72765);
/* harmony import */ var _useButtonClasses__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77679);






const ButtonLink = _ref => {
  let {
    appearance,
    size,
    children,
    className,
    disabled,
    useNativeTag = false,
    ...props
  } = _ref;
  const classes = (0,_useButtonClasses__WEBPACK_IMPORTED_MODULE_2__/* .useButtonClasses */ .B)({
    appearance,
    size,
    disabled,
    className
  });
  if (props.href === void 0) {
    return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
      className: classes,
      ...props,
      children
    });
  }
  if (useNativeTag) {
    return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
      className: classes,
      ...props,
      href: (0,_yandex_langly_shared_src_domain_domain__WEBPACK_IMPORTED_MODULE_1__.kz)(props.href),
      children
    });
  }
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
    className: classes,
    to: (0,_yandex_langly_shared_src_domain_domain__WEBPACK_IMPORTED_MODULE_1__.kz)(props.href),
    ...props,
    children
  });
};

/***/ }),

/***/ 60667:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ Button)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _loader_loader_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41178);
/* harmony import */ var _button_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63517);
/* harmony import */ var _useButtonClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77679);
/* harmony import */ var _button_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56995);







const Button = _ref => {
  let {
    appearance,
    size,
    children,
    className,
    disabled,
    readOnly,
    disabledAppearance,
    theme = _button_model__WEBPACK_IMPORTED_MODULE_2__/* .Theme */ .Q2.Default,
    autoHeight,
    state = _button_model__WEBPACK_IMPORTED_MODULE_2__/* .ButtonState */ .BN.Initial,
    hideFocus,
    loading = false,
    ...props
  } = _ref;
  const classes = (0,_useButtonClasses__WEBPACK_IMPORTED_MODULE_3__/* .useButtonClasses */ .B)({
    appearance,
    size,
    disabled,
    readOnly,
    disabledAppearance,
    hideFocus,
    className,
    theme,
    autoHeight,
    state,
    loading
  });
  const loaderSize = size === "medium" && theme !== _button_model__WEBPACK_IMPORTED_MODULE_2__/* .Theme */ .Q2.Narrow ? _loader_loader_component__WEBPACK_IMPORTED_MODULE_1__/* .LoaderSize */ .gI.Default : _loader_loader_component__WEBPACK_IMPORTED_MODULE_1__/* .LoaderSize */ .gI.Small;
  const handleClick = event => {
    if (loading) {
      return;
    }
    props.onClick?.(event);
  };
  let content = children;
  if (loading) {
    content = /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: [/* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: _button_module_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.hidden,
        children
      }), /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loader_loader_component__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aN, {
        className: _button_module_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.loader,
        size: loaderSize,
        isCurrentColor: true
      })]
    });
  }
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
    type: "button",
    className: classes,
    "aria-label": loading ? "\u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : void 0,
    ...props,
    disabled,
    "aria-disabled": disabled || readOnly,
    onClick: handleClick,
    children: content
  });
};

/***/ }),

/***/ 63517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BN: () => (/* binding */ ButtonState),
/* harmony export */   Q2: () => (/* binding */ Theme),
/* harmony export */   iL: () => (/* binding */ DisabledButtonAppearance)
/* harmony export */ });
/* unused harmony exports ButtonAppearance, ButtonSize */


const ButtonAppearance = {
  Primary: "primary",
  PrimaryOnBlack: "primaryOnBlack",
  Secondary: "secondary",
  SecondaryOnBlack: "secondaryOnBlack",
  SecondaryFloating: "secondaryFloating",
  Tertiary: "tertiary",
  TertiaryOnBlack: "tertiaryOnBlack",
  Green: "green",
  Active: "active",
  Occupied: "occupied",
  Red: "red"
};
const ButtonSize = {
  Medium: "medium",
  Small: "small",
  SmallCircle: "small-circle"
};
var Theme = /* @__PURE__ */(Theme2 => {
  Theme2["Default"] = "default";
  Theme2["Narrow"] = "narrow";
  return Theme2;
})(Theme || {});
var ButtonState = /* @__PURE__ */(ButtonState2 => {
  ButtonState2["Initial"] = "initial";
  ButtonState2["Selected"] = "selected";
  ButtonState2["Hover"] = "hover";
  ButtonState2["Activated"] = "activated";
  return ButtonState2;
})(ButtonState || {});
var DisabledButtonAppearance = /* @__PURE__ */(DisabledButtonAppearance2 => {
  DisabledButtonAppearance2["Default"] = "default";
  DisabledButtonAppearance2["Transparent"] = "transparent";
  return DisabledButtonAppearance2;
})(DisabledButtonAppearance || {});

/***/ }),

/***/ 77679:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ useButtonClasses)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _button_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63517);
/* harmony import */ var _accessibility_accessibility_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98493);
/* harmony import */ var _button_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56995);






const useButtonClasses = _ref => {
  let {
    className,
    size,
    appearance,
    disabled = false,
    readOnly = false,
    disabledAppearance,
    hideFocus = false,
    theme,
    state,
    autoHeight = false,
    loading
  } = _ref;
  return classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, {
    [_accessibility_accessibility_module_css__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.focusVisible]: !hideFocus,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.button]: true,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonDisabled]: disabled,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonReadOnly]: readOnly,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonPrimary]: appearance === "primary",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonPrimaryOnBlack]: appearance === "primaryOnBlack",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSecondary]: appearance === "secondary",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSecondaryOnBlack]: appearance === "secondaryOnBlack",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSecondaryFloating]: appearance === "secondaryFloating",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonTertiary]: appearance === "tertiary",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonTertiaryOnBlack]: appearance === "tertiaryOnBlack",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonGreen]: appearance === "green",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonOccupied]: appearance === "occupied",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonActive]: appearance === "active",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonRed]: appearance === "red",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSmall]: size === "small",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSmallCircle]: size === "small-circle",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonAlreadySelected]: state === _button_model__WEBPACK_IMPORTED_MODULE_1__/* .ButtonState */ .BN.Selected,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonNarrow]: theme === _button_model__WEBPACK_IMPORTED_MODULE_1__/* .Theme */ .Q2.Narrow,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonAutoHeight]: autoHeight === true,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonDisabledTransparent]: disabled && disabledAppearance === _button_model__WEBPACK_IMPORTED_MODULE_1__/* .DisabledButtonAppearance */ .iL.Transparent,
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSecondaryHover]: state === _button_model__WEBPACK_IMPORTED_MODULE_1__/* .ButtonState */ .BN.Hover && appearance === "secondary",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonSecondaryActivated]: state === _button_model__WEBPACK_IMPORTED_MODULE_1__/* .ButtonState */ .BN.Activated && appearance === "secondary",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonOccupiedActivated]: state === _button_model__WEBPACK_IMPORTED_MODULE_1__/* .ButtonState */ .BN.Activated && appearance === "occupied",
    [_button_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.buttonLoading]: loading
  });
};

/***/ }),

/***/ 7535:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  X: () => (/* reexport */ Checkbox)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/constants.ts


const CHECKBOX_SIZE = {
  SMALL: "small",
  LARGE: "large"
};
const CHECKBOX_APPEARANCE = {
  CHECKBOX: "checkbox",
  BUTTON: "button"
};
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/components/button-appearance/button-appearance.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const button_appearance_module = ({"input":"button-appearance-module__input--_vwNv","label":"button-appearance-module__label--ytsaF typography-module__body2-accent--gV8P4","disabled":"button-appearance-module__disabled--AO0jB","checked":"button-appearance-module__checked--rWZo6","read-only":"button-appearance-module__read-only--MAIsI","readOnly":"button-appearance-module__read-only--MAIsI"});
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/components/button-appearance/button-appearance.tsx








const ButtonAppearance = _ref => {
  let {
    children,
    className,
    disabled,
    checked,
    readOnly,
    // TODO SERVICEL-9077: Добавить размеры для чекбокса-кнопки
    size,
    onChange,
    ...rest
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    className: classnames_default()(button_appearance_module.label, className, accessibility_module/* default */.Z.focusVisibleWithin, {
      [button_appearance_module.disabled]: disabled,
      [button_appearance_module.checked]: checked,
      [button_appearance_module.readOnly]: readOnly
    }),
    children: [typeof children === "string" ? /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()({
        [typography_module/* default */.Z.headline4]: size === CHECKBOX_SIZE.LARGE,
        [typography_module/* default */.Z.body2]: size === CHECKBOX_SIZE.SMALL
      }),
      children
    }) : children, /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      className: classnames_default()(button_appearance_module.input, accessibility_module/* default */.Z.srOnly),
      type: "checkbox",
      checked,
      disabled,
      readOnly,
      onChange,
      "aria-disabled": disabled || readOnly,
      ...rest
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/checkbox/types.ts
var types = __webpack_require__(16466);
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/components/checkbox-appearance/checkbox-appearance.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const checkbox_appearance_module = ({"input":"checkbox-appearance-module__input--nDtau","checkbox":"checkbox-appearance-module__checkbox--EBe65","checkbox-icon":"checkbox-appearance-module__checkbox-icon--vfcKW","checkboxIcon":"checkbox-appearance-module__checkbox-icon--vfcKW","root":"checkbox-appearance-module__root--i2MVx","read-only":"checkbox-appearance-module__read-only--_xIHf","readOnly":"checkbox-appearance-module__read-only--_xIHf","large":"checkbox-appearance-module__large--_5Qli","small":"checkbox-appearance-module__small--pTc9x","body2":"checkbox-appearance-module__body2--EEyAW","disabled":"checkbox-appearance-module__disabled--tbXxJ","root-checked":"checkbox-appearance-module__root-checked--Np4x6","rootChecked":"checkbox-appearance-module__root-checked--Np4x6","title":"checkbox-appearance-module__title--s9h5O","error":"checkbox-appearance-module__error--ohGdU"});
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/components/checkbox-appearance/checkbox-appearance.tsx









const CheckboxAppearance = _ref => {
  let {
    children,
    className,
    disabled,
    checked,
    readOnly,
    size,
    status,
    onChange
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    className: classnames_default()(checkbox_appearance_module.root, className, {
      [checkbox_appearance_module.disabled]: disabled,
      [checkbox_appearance_module.readOnly]: readOnly,
      [checkbox_appearance_module.rootChecked]: checked,
      [checkbox_appearance_module.large]: size === CHECKBOX_SIZE.LARGE,
      [checkbox_appearance_module.small]: size === CHECKBOX_SIZE.SMALL
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      className: checkbox_appearance_module.input,
      type: "checkbox",
      checked,
      disabled,
      readOnly,
      onChange,
      "aria-disabled": disabled || readOnly
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(checkbox_appearance_module.checkbox, {
        [checkbox_appearance_module.error]: status === types/* CheckboxStatus */.f.Error
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: checkbox_appearance_module.checkboxIcon,
        name: "checkmark",
        size: "small"
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(checkbox_appearance_module.title, {
        [typography_module/* default */.Z.headline4]: size === CHECKBOX_SIZE.LARGE,
        [typography_module/* default */.Z.body2]: size === CHECKBOX_SIZE.SMALL
      }),
      children
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/components/index.ts




;// CONCATENATED MODULE: ../ui-kit/src/checkbox/checkbox.tsx






const Checkbox = _ref => {
  let {
    className,
    children,
    appearance = CHECKBOX_APPEARANCE.CHECKBOX,
    size = CHECKBOX_SIZE.LARGE,
    checked = false,
    disabled = false,
    readOnly = false,
    status = types/* CheckboxStatus */.f.Default,
    onChange,
    ...rest
  } = _ref;
  const handleChange = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };
  if (appearance === CHECKBOX_APPEARANCE.BUTTON) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ButtonAppearance, {
      className,
      disabled,
      checked,
      readOnly,
      size,
      onChange: handleChange,
      ...rest,
      children
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(CheckboxAppearance, {
    className,
    disabled,
    checked,
    readOnly,
    size,
    status,
    onChange: handleChange,
    ...rest,
    children
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/checkbox/index.ts




/***/ }),

/***/ 16466:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: () => (/* binding */ CheckboxStatus)
/* harmony export */ });


var CheckboxStatus = /* @__PURE__ */(CheckboxStatus2 => {
  CheckboxStatus2["Default"] = "default";
  CheckboxStatus2["Error"] = "error";
  return CheckboxStatus2;
})(CheckboxStatus || {});

/***/ }),

/***/ 56317:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* reexport */ Chip)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/chip/chip.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const chip_module = ({"container":"chip-module__container--xoCA0","left":"chip-module__left--tBGlL","right":"chip-module__right--jACqr","without-icon":"chip-module__without-icon--kjG2w","withoutIcon":"chip-module__without-icon--kjG2w","icon":"chip-module__icon--CGLgw"});
;// CONCATENATED MODULE: ../ui-kit/src/chip/chip.tsx








const Chip = (0,react.forwardRef)((_ref, ref) => {
  let {
    className,
    iconName,
    iconPosition = "left",
    iconCustomProps,
    children
  } = _ref;
  const icon = iconName && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    className: classnames_default()(chip_module.icon, chip_module[iconPosition]),
    name: iconName,
    size: "small",
    ...iconCustomProps
  });
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref,
    className: classnames_default()(chip_module.container, chip_module[iconPosition], {
      [chip_module.withoutIcon]: !iconName
    }, className),
    children: [icon, /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: typography_module/* default */.Z.body2,
      children
    })]
  });
});
Chip.displayName = "Chip";
;// CONCATENATED MODULE: ../ui-kit/src/chip/index.ts




/***/ }),

/***/ 49159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  rr: () => (/* binding */ DeprecatedModal),
  nq: () => (/* binding */ ModalFooterButtonsPosition),
  i3: () => (/* binding */ ModalOverlayZIndex)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/deprecated-modal/deprecated-modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const deprecated_modal_module = ({"modal-overlay":"deprecated-modal-module__modal-overlay--uPRJn","modalOverlay":"deprecated-modal-module__modal-overlay--uPRJn","overlay-in-container":"deprecated-modal-module__overlay-in-container--WQIqu","overlayInContainer":"deprecated-modal-module__overlay-in-container--WQIqu","modal-overlay-high":"deprecated-modal-module__modal-overlay-high--PzUL3","modalOverlayHigh":"deprecated-modal-module__modal-overlay-high--PzUL3","modal-overlay-low":"deprecated-modal-module__modal-overlay-low--s2lT3","modalOverlayLow":"deprecated-modal-module__modal-overlay-low--s2lT3","modal":"deprecated-modal-module__modal--aUokf","modal-header":"deprecated-modal-module__modal-header--GpZ67","modalHeader":"deprecated-modal-module__modal-header--GpZ67","modal-subtitle":"deprecated-modal-module__modal-subtitle--ZLowZ","modalSubtitle":"deprecated-modal-module__modal-subtitle--ZLowZ","modal-content":"deprecated-modal-module__modal-content--Tq97a","modalContent":"deprecated-modal-module__modal-content--Tq97a","modal-content-with-auto-height":"deprecated-modal-module__modal-content-with-auto-height--HIBYp","modalContentWithAutoHeight":"deprecated-modal-module__modal-content-with-auto-height--HIBYp","modal-content-without-header":"deprecated-modal-module__modal-content-without-header--NdFOZ","modalContentWithoutHeader":"deprecated-modal-module__modal-content-without-header--NdFOZ","modal-footer":"deprecated-modal-module__modal-footer--l3w3r","modalFooter":"deprecated-modal-module__modal-footer--l3w3r","modal-footer-right":"deprecated-modal-module__modal-footer-right--NY0hK","modalFooterRight":"deprecated-modal-module__modal-footer-right--NY0hK","modal-footer-center":"deprecated-modal-module__modal-footer-center--k9owG","modalFooterCenter":"deprecated-modal-module__modal-footer-center--k9owG","modal-footer-flex-row":"deprecated-modal-module__modal-footer-flex-row--pnuna","modalFooterFlexRow":"deprecated-modal-module__modal-footer-flex-row--pnuna","model-content-scrollable-y":"deprecated-modal-module__model-content-scrollable-y--HVi4j","modelContentScrollableY":"deprecated-modal-module__model-content-scrollable-y--HVi4j","splitter":"deprecated-modal-module__splitter--QdQ9o","fullscreen-content":"deprecated-modal-module__fullscreen-content--To47x","fullscreenContent":"deprecated-modal-module__fullscreen-content--To47x","full-screen-modal":"deprecated-modal-module__full-screen-modal--Rpwvi","fullScreenModal":"deprecated-modal-module__full-screen-modal--Rpwvi","close-icon":"deprecated-modal-module__close-icon--ZEC5P","closeIcon":"deprecated-modal-module__close-icon--ZEC5P","hidden":"deprecated-modal-module__hidden--odM96"});
;// CONCATENATED MODULE: ../ui-kit/src/deprecated-modal/deprecated-modal.component.tsx











var ModalOverlayZIndex = /* @__PURE__ */(ModalOverlayZIndex2 => {
  ModalOverlayZIndex2[ModalOverlayZIndex2["High"] = 0] = "High";
  ModalOverlayZIndex2[ModalOverlayZIndex2["Low"] = 1] = "Low";
  return ModalOverlayZIndex2;
})(ModalOverlayZIndex || {});
var ModalFooterButtonsPosition = /* @__PURE__ */(ModalFooterButtonsPosition2 => {
  ModalFooterButtonsPosition2[ModalFooterButtonsPosition2["Right"] = 0] = "Right";
  ModalFooterButtonsPosition2[ModalFooterButtonsPosition2["Center"] = 1] = "Center";
  ModalFooterButtonsPosition2[ModalFooterButtonsPosition2["FlexRow"] = 2] = "FlexRow";
  return ModalFooterButtonsPosition2;
})(ModalFooterButtonsPosition || {});
const DeprecatedModal = _ref => {
  let {
    onClose = function_utils/* emptyFunction */.Bi,
    onSubmitButtonClick,
    onEditButtonClick,
    showCancelButton = false,
    showEditButton = false,
    showSubmitButton = false,
    submitButtonLabel = "Submit",
    isSubmitButtonDisabled = false,
    cancelButtonLabel = "Cancel",
    editButtonLabel = "Edit",
    header,
    subtitle,
    contentScrollableY = false,
    children,
    fullscreenContent = false,
    showCloseButton = false,
    closeButtonAriaLabel,
    fullScreenModal = false,
    className = "",
    overlayClassName = "",
    buttonsPosition = 0 /* Right */,
    overlayZIndex = 0 /* High */,
    visible = true,
    minHeight,
    autoHeight = false,
    isInContainer = false
  } = _ref;
  (0,useKeyPress/* useKeyPress */.K)("Escape", onClose);
  (0,use_block_main_scroll/* useBlockMainScroll */.K)();
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    "data-testid": "deprecated-modal",
    className: classnames_default()(deprecated_modal_module.modalOverlay, overlayClassName, {
      [deprecated_modal_module.modalOverlayHigh]: overlayZIndex === 0 /* High */,
      [deprecated_modal_module.modalOverlayLow]: overlayZIndex === 1 /* Low */,
      [deprecated_modal_module.hidden]: !visible,
      [deprecated_modal_module.overlayInContainer]: isInContainer
    }),
    onClick: onClose,
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(deprecated_modal_module.modal, className, {
        [deprecated_modal_module.modalContentWithAutoHeight]: autoHeight,
        [deprecated_modal_module.fullscreenContent]: fullscreenContent,
        [deprecated_modal_module.fullScreenModal]: fullScreenModal,
        [deprecated_modal_module.hidden]: !visible
      }),
      style: {
        minHeight: minHeight ? minHeight + "px" : 0
      },
      onClick: event => event.stopPropagation(),
      children: [header && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(deprecated_modal_module.modalHeader, typography_module/* default */.Z.headline4Accent),
        children: header
      }), subtitle && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(deprecated_modal_module.modalSubtitle, typography_module/* default */.Z.body2),
        children: subtitle
      }), showCloseButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        className: deprecated_modal_module.closeIcon,
        onClick: onClose,
        appearance: "default",
        size: "medium",
        iconName: "cross",
        "aria-label": closeButtonAriaLabel
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(deprecated_modal_module.modalContent, {
          [deprecated_modal_module.modelContentScrollableY]: contentScrollableY,
          [deprecated_modal_module.modalContentWithoutHeader]: header === void 0
        }),
        children
      }), (showCancelButton || showSubmitButton) && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(deprecated_modal_module.modalFooter, {
          [deprecated_modal_module.modalFooterRight]: buttonsPosition === 0 /* Right */,
          [deprecated_modal_module.modalFooterCenter]: buttonsPosition === 1 /* Center */,
          [deprecated_modal_module.modalFooterFlexRow]: buttonsPosition === 2 /* FlexRow */
        }),
        children: [showCancelButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          onClick: onClose,
          appearance: "secondary",
          children: cancelButtonLabel
        }), showCancelButton && showSubmitButton && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: deprecated_modal_module.splitter
        }), showEditButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          onClick: onEditButtonClick,
          appearance: "secondary",
          children: editButtonLabel
        }), showEditButton && showSubmitButton && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: deprecated_modal_module.splitter
        }), showSubmitButton && /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
          onClick: onSubmitButtonClick,
          appearance: "primary",
          disabled: isSubmitButtonDisabled,
          children: submitButtonLabel
        })]
      })]
    })
  });
};

/***/ }),

/***/ 28402:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  PS: () => (/* binding */ DropdownButton),
  Vs: () => (/* binding */ DropdownItems),
  MO: () => (/* binding */ DropdownWithItems),
  lu: () => (/* binding */ DropdownWithItemsTheme)
});

// UNUSED EXPORTS: Item

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/dropdown/dropdown.component.tsx + 1 modules
var dropdown_component = __webpack_require__(34504);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
;// CONCATENATED MODULE: ../ui-kit/src/dropdown-with-items/dropdown-with-items.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const dropdown_with_items_module = ({"button":"dropdown-with-items-module__button--OpumK","button-theme-rounded":"dropdown-with-items-module__button-theme-rounded--JVwDm","buttonThemeRounded":"dropdown-with-items-module__button-theme-rounded--JVwDm","button-theme-squared":"dropdown-with-items-module__button-theme-squared--YxNo7","buttonThemeSquared":"dropdown-with-items-module__button-theme-squared--YxNo7","button-height-auto":"dropdown-with-items-module__button-height-auto--UIhJo","buttonHeightAuto":"dropdown-with-items-module__button-height-auto--UIhJo","button-content":"dropdown-with-items-module__button-content--UP7IO","buttonContent":"dropdown-with-items-module__button-content--UP7IO","button-dropdown-active":"dropdown-with-items-module__button-dropdown-active--QAJIJ","buttonDropdownActive":"dropdown-with-items-module__button-dropdown-active--QAJIJ","dropdown-icon":"dropdown-with-items-module__dropdown-icon--nqxq3","dropdownIcon":"dropdown-with-items-module__dropdown-icon--nqxq3","list":"dropdown-with-items-module__list--K9XlE","item":"dropdown-with-items-module__item--fxYOk","item-height-auto":"dropdown-with-items-module__item-height-auto--VYA3B","itemHeightAuto":"dropdown-with-items-module__item-height-auto--VYA3B","item-content":"dropdown-with-items-module__item-content--PTMcu","itemContent":"dropdown-with-items-module__item-content--PTMcu","check-icon":"dropdown-with-items-module__check-icon--P4yaN","checkIcon":"dropdown-with-items-module__check-icon--P4yaN"});
;// CONCATENATED MODULE: ../ui-kit/src/dropdown-with-items/dropdown-with-items.component.tsx













var DropdownWithItemsTheme = /* @__PURE__ */(DropdownWithItemsTheme2 => {
  DropdownWithItemsTheme2[DropdownWithItemsTheme2["Rounded"] = 0] = "Rounded";
  DropdownWithItemsTheme2[DropdownWithItemsTheme2["Squared"] = 1] = "Squared";
  return DropdownWithItemsTheme2;
})(DropdownWithItemsTheme || {});
const getButtonStylesForTheme = theme => {
  switch (theme) {
    case 0 /* Rounded */:
    default:
      return dropdown_with_items_module.buttonThemeRounded;
    case 1 /* Squared */:
      return dropdown_with_items_module.buttonThemeSquared;
  }
};
const themeToDropdownListThemeMapper = {
  [0 /* Rounded */]: dropdown_component/* DropdownListTheme */.w.Rounded,
  [1 /* Squared */]: dropdown_component/* DropdownListTheme */.w.Squared
};
function DropdownWithItems(props) {
  const {
    autoHeight = false,
    renderItem,
    renderSelectorItem,
    theme = 0 /* Rounded */,
    activeItemId,
    items,
    placement
  } = props;
  const activeItem = (0,react.useMemo)(() => items.find(item => item.id === activeItemId) ?? null, [activeItemId, items]);
  const renderDropdown = (0,react.useCallback)(onDropdownClose => /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownItems, {
    ...props,
    autoHeight,
    onDropdownClose
  }), [autoHeight, props]);
  const renderSelector = (0,react.useCallback)((isDropdownActive, onDropdownClick) => /* @__PURE__ */(0,jsx_runtime.jsx)(DropdownButton, {
    isDropdownActive,
    autoHeight,
    onDropdownClick,
    theme,
    children: activeItem !== null && (renderSelectorItem ?? renderItem)(activeItem)
  }), [activeItem, autoHeight, renderItem, renderSelectorItem, theme]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(dropdown_component/* Dropdown */.L, {
    listTheme: themeToDropdownListThemeMapper[theme],
    renderSelector,
    renderDropdown,
    placement
  });
}
const DropdownButton = _ref => {
  let {
    isDropdownActive,
    autoHeight,
    onDropdownClick,
    children,
    theme = 0 /* Rounded */
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(dropdown_with_items_module.button, getButtonStylesForTheme(theme), {
      [dropdown_with_items_module.buttonDropdownActive]: isDropdownActive,
      [dropdown_with_items_module.buttonHeightAuto]: autoHeight
    }),
    onClick: onDropdownClick,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: dropdown_with_items_module.buttonContent,
      children
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: dropdown_with_items_module.dropdownIcon,
      name: isDropdownActive ? "chevron-up" : "chevron-down",
      size: "medium"
    })]
  });
};
function DropdownItems(_ref2) {
  let {
    onActiveItemChanged,
    onDropdownClose,
    activeItemId,
    autoHeight,
    items,
    renderItem
  } = _ref2;
  const handleItemClick = (0,react.useCallback)(id => {
    onActiveItemChanged(id);
    onDropdownClose();
  }, [onActiveItemChanged, onDropdownClose]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    className: dropdown_with_items_module.list,
    children: items.map(item => /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(Item, {
        id: item.id,
        autoHeight,
        isChecked: item.id === activeItemId,
        onItemClick: handleItemClick,
        disabled: item.disabled,
        children: renderItem(item)
      })
    }, item.id))
  });
}
const Item = _ref3 => {
  let {
    id,
    autoHeight,
    isChecked,
    children,
    onItemClick,
    disabled = false
  } = _ref3;
  const handleItemClick = (0,react.useCallback)(() => {
    onItemClick(id);
  }, [id, onItemClick]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(dropdown_with_items_module.item, {
      [dropdown_with_items_module.itemHeightAuto]: autoHeight
    }),
    onClick: handleItemClick,
    disabled,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: dropdown_with_items_module.itemContent,
      children
    }), isChecked && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      className: "checkIcon",
      size: "medium",
      name: "checkmark"
    })]
  });
};

/***/ }),

/***/ 34504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  L: () => (/* binding */ Dropdown),
  w: () => (/* binding */ DropdownListTheme)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
;// CONCATENATED MODULE: ../ui-kit/src/dropdown/dropdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const dropdown_module = ({"root":"dropdown-module__root--YrmXU","dropdown":"dropdown-module__dropdown--F_WmO","top-position":"dropdown-module__top-position--fWMQV","topPosition":"dropdown-module__top-position--fWMQV","dropdown-theme-rounded":"dropdown-module__dropdown-theme-rounded--iVh3Z","dropdownThemeRounded":"dropdown-module__dropdown-theme-rounded--iVh3Z","dropdown-theme-squared":"dropdown-module__dropdown-theme-squared--BI7cI","dropdownThemeSquared":"dropdown-module__dropdown-theme-squared--BI7cI","no-padding":"dropdown-module__no-padding--q2Zbk","noPadding":"dropdown-module__no-padding--q2Zbk","left12":"dropdown-module__left12--JBfiU"});
;// CONCATENATED MODULE: ../ui-kit/src/dropdown/dropdown.component.tsx








var DropdownListTheme = /* @__PURE__ */(DropdownListTheme2 => {
  DropdownListTheme2[DropdownListTheme2["Rounded"] = 1] = "Rounded";
  DropdownListTheme2[DropdownListTheme2["Squared"] = 2] = "Squared";
  DropdownListTheme2[DropdownListTheme2["NoPadding"] = 4] = "NoPadding";
  DropdownListTheme2[DropdownListTheme2["Left12"] = 8] = "Left12";
  return DropdownListTheme2;
})(DropdownListTheme || {});
const getListThemeClasses = theme => {
  const classes = [];
  if (theme & 1 /* Rounded */) {
    classes.push(dropdown_module.dropdownThemeRounded);
  }
  if (theme & 2 /* Squared */) {
    classes.push(dropdown_module.dropdownThemeSquared);
  }
  if (theme & 4 /* NoPadding */) {
    classes.push(dropdown_module.noPadding);
  }
  if (theme & 8 /* Left12 */) {
    classes.push(dropdown_module.left12);
  }
  return classes;
};
const Dropdown = _ref => {
  let {
    listTheme = 1 /* Rounded */,
    placement = "bottom",
    className,
    onDropdownActiveChanged,
    renderSelector,
    renderDropdown
  } = _ref;
  const [isDropdownActive, setDropdownActive] = (0,react.useState)(false);
  const rootRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (onDropdownActiveChanged !== void 0) {
      onDropdownActiveChanged(isDropdownActive);
    }
  }, [isDropdownActive, onDropdownActiveChanged]);
  const handleDropdownClick = (0,react.useCallback)(() => {
    setDropdownActive(isActive => !isActive);
  }, []);
  const handleDropdownClose = (0,react.useCallback)(() => {
    setDropdownActive(false);
  }, []);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(rootRef, handleDropdownClose);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: rootRef,
    className: dropdown_module.root,
    children: [renderSelector(isDropdownActive, handleDropdownClick), isDropdownActive && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(dropdown_module.dropdown, ...getListThemeClasses(listTheme), className, {
        [dropdown_module.topPosition]: placement === "top"
      }),
      children: renderDropdown(handleDropdownClose)
    })]
  });
};

/***/ }),

/***/ 514:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: () => (/* binding */ ErrorBoundary)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80978);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "resetErrorBoundary", () => {
      const {
        hasError
      } = this.state;
      if (hasError) {
        this.props.onReset?.();
        this.setState({
          hasError: false
        });
      }
    });
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      onError
    } = this.props;
    onError(error, errorInfo);
  }
  render() {
    const {
      children,
      onErrorContent
    } = this.props;
    const {
      hasError,
      error
    } = this.state;
    if (hasError) {
      return onErrorContent({
        resetErrorBoundary: this.resetErrorBoundary,
        error
      });
    }
    return children;
  }
}

/***/ }),

/***/ 62578:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  K: () => (/* binding */ Error403)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../ui-kit/src/errors/403/error-403.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* harmony default export */ const error_403 = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "267",
    height: "267",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "267",
    height: "267",
    fill: "#3A3A3A",
    rx: "133.5"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M85.129 62.29a32.92 32.92 0 0115.582 14.32c3.807 7.008 4.962 15.298 9.332 21.986 1.867 2.873 4.51 5.512 7.888 6.129.271 3.645-1.484 7.591-4.46 9.706m-.001 0c1.254 6.896.853 16.142-2.214 22.447s-19.502 27.62-44.2 18.009M51.248 115.91c-2.39-1.542-5.863-1.389-8.366 0a10.074 10.074 0 00-4.745 6.378c-1.524 5.949 2.192 12.628 8.466 15.194a12.968 12.968 0 005.02 1.038c4.51-.045 8.7-3.41 9.15-7.374"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M78.53 157.729a65.673 65.673 0 00-5.768 5.836m-49.801-21.284a13.2 13.2 0 01-7-1.511c-1.804-.965-3.418-2.363-5.353-3.071-1.935-.708-4.47-.487-5.584 1.249"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M61.812 155.965c.74 2.819 3.157 4.961 5.804 6.147 2.647 1.187 5.602 1.552 8.488 1.949 15.718 2.147 31.63 5.466 45.277 13.553 13.648 8.086 24.806 21.684 26.479 37.461m12.435-45.129a33.549 33.549 0 011.479 31.147m27.056-26.862c2.021 2.214 2.968 5.214 3.459 8.172a34.509 34.509 0 01-3.432 21.523m4.448-7.131c1.118 1.804 2.625 3.32 3.996 4.934 3.928 4.623 6.869 10.374 6.787 16.453"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M162.618 195.37a26.257 26.257 0 00-15.073 9.864m-1.024 3.585c18.694 3.157 38.701 7.41 57.567 9.345m.153.384v9.769m-50.179-7.884c8.497 1.826 41.682 6.057 50.179 7.884M84.223 161.824l179.404 19.975m-175.084-24.07l175.083 18.595M82.107 45.512V35.138L265.07 52.277m-117.44 57.18c3.608 6.417 8.032 12.425 13.53 17.3 5.498 4.876 12.142 8.597 19.331 10.157m5.845 1.723a38.7 38.7 0 0120.323 15.334m-58.654-51.086a98.771 98.771 0 0023.259 22.136m-20.391-25.175a124.633 124.633 0 0024.684 17.269m-21.969-19.624a159.518 159.518 0 0026.317 9.738M156.953 93.36a330.234 330.234 0 0025.257 4.487m-16.954-7.139c3.157.541 5.313 3.608 8.321 4.776m-5.056-10.08c8.737 1.56 15.416 4.109 23.629 7.464m13.318 6.842a24.16 24.16 0 016.264 5.696m14.298 20.607a71.72 71.72 0 0118.42 29.794m-71.486-83.122c-4.262 4.822-10.725 12.8-13.625 18.726m-10.541 22.542a64.089 64.089 0 00-6.801 26.723m30.214-72.469a7.669 7.669 0 003.003 3.608 23.172 23.172 0 004.272 2.093 4.15 4.15 0 001.195.351c.31.044.626-.035.879-.22.51-.452.311-1.268 0-1.859-.947-1.71-2.53-2.963-4.122-4.095-1.132-.803-2.436-1.759-3.825-2.034-1.389-.275-1.777 1.073-1.402 2.156z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M171.971 66.412l-3.788-2.255a12.31 12.31 0 01-2.215-1.56 4.096 4.096 0 01-1.317-2.319 1.168 1.168 0 01.163-.902 1.195 1.195 0 011.096-.302c1.168.144 2.173.875 3.053 1.646a43.907 43.907 0 014.677 5.038m-1.637 1.253a28.02 28.02 0 00-6.657-2.173c-1.15-.235-2.517-.348-3.315.51a1.056 1.056 0 00-.325.834c.077.586.754.848 1.326.996 2.954.754 5.945 1.466 8.989 1.56m.46.533a16.403 16.403 0 00-8.01 3.55 2.017 2.017 0 00-.83 1.163.54.54 0 00.072.393.708.708 0 00.627.18c3.22-.171 6.544-1.993 9.363-3.558m.19-.005c-1.087 2.625-2.07 5.363-2.066 8.204-.015.29.029.58.131.853a.824.824 0 00.65.514 1.159 1.159 0 00.861-.51c1.723-1.994 2.417-4.659 2.986-7.216m.446.135a18.257 18.257 0 00.645 7.148 5.07 5.07 0 00.713 1.593 2.083 2.083 0 001.448.879.65.65 0 00.424-.081.795.795 0 00.266-.51c.586-2.566-.027-5.24-.645-7.802m.469.013a22.208 22.208 0 002.891 5.742 4.922 4.922 0 001.741 1.695c.56.248 1.157.4 1.768.451a.597.597 0 00.333 0 .523.523 0 00.235-.338c.234-.78-.117-1.6-.496-2.322a23.092 23.092 0 00-4.569-6.003m-.298-1.236c3.401.586 6.95 1.294 9.638 3.463.344.255.648.559.902.902a.94.94 0 01.194.524.736.736 0 01-.451.627 1.832 1.832 0 01-.812.108 9.638 9.638 0 01-4.316-1.326 48.837 48.837 0 01-5.141-3.676m-8.2-7.193a1.457 1.457 0 01-.369-.718 10.022 10.022 0 01.987-7.811 1.67 1.67 0 01.451-.56.623.623 0 01.686-.035.8.8 0 01.266.374c.349.919.525 1.894.519 2.877.109 2.255.08 4.514-.086 6.766m.284.675a31.002 31.002 0 011.231-3.197c1.069-2.372 2.639-4.767 5.097-5.62a.703.703 0 01.478-.044c.266.103.324.45.315.73a8.222 8.222 0 01-1.087 3.378 54.386 54.386 0 01-3.427 5.832m-.09.537c2.34-2.431 4.83-4.962 8.059-5.936.451-.13.965-.212 1.29.104.325.316.217 1.01-.086 1.439-.343.438-.752.82-1.213 1.132a40.56 40.56 0 01-6.765 4.104m-.023.6a18.982 18.982 0 0110.68-3.36c.844 0 1.872.19 2.138.988.266.798-.564 1.664-1.38 2.065-1.588.776-3.374 1.042-5.128 1.295l-5.033.726m22.559 35.729a12.324 12.324 0 00-2.106 7.279c.031.902.343 2.034 1.236 2.224a.657.657 0 00.514-.077.899.899 0 00.279-.613 8.034 8.034 0 00.14-3.058c-.216-1.006-.902-1.976-1.93-2.188-1.285-.266-2.508.79-3.067 1.976a5.74 5.74 0 00.595 5.782c1.236 1.642 3.243 2.467 4.961 3.608a15.082 15.082 0 016.161 8.42 9.06 9.06 0 01.307 4.15 5.113 5.113 0 01-2.223 3.418 4.678 4.678 0 01-3.929.348 6.197 6.197 0 01-3.103-2.531c-1.069-1.655-1.393-3.937-.293-5.574.113-.171.492-.217.415-.027m9.269-10.906a21.231 21.231 0 002.2 5.39 8.668 8.668 0 004.348 3.73c.23.101.484.132.731.09.451-.117.654-.618.78-1.06 1.479-5.159 0-10.761-2.48-15.528-.821-1.579-4.096-5.755-6.112-3.265-2.016 2.489-.234 8.023.533 10.643zm7.884-16.358a39.448 39.448 0 006.26 19.02 25.21 25.21 0 01-2.485-18.469c.451-1.805 1.33-3.757 3.094-4.33.96-.311 2.088.397 2.593 1.276.78 1.353.392 3.117-.37 4.51m1.926-8.555a39.511 39.511 0 006.26 19.019 25.26 25.26 0 01-2.485-18.492c.451-1.804 1.331-3.757 3.094-4.33.965-.31 2.088.397 2.593 1.277.785 1.353.393 3.116-.369 4.487m4.18-12.254a17.139 17.139 0 001.93 11.136c.28.6.731 1.103 1.295 1.448.902.45 2.016.094 2.706-.605a5.99 5.99 0 001.353-2.611 23.022 23.022 0 00.649-10.482c1.89 10.658 5.453 21.076 5.913 31.892.086 1.997.059 4.059-.55 5.944-.609 1.885-1.867 3.685-3.694 4.51a2.815 2.815 0 01-1.353.293c-1.47-.122-2.223-1.804-2.489-3.265-1.051-5.751.708-11.632 2.882-17.057 2.255-5.593 5.155-11.24 10.116-14.654m-.817-22.447a126.77 126.77 0 00-.821 17.193"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M260.84 97.802a7.315 7.315 0 00.18 2.409m.324 3.581l.05.721a1.146 1.146 0 11.193-.243c.132-.256.162-.552.086-.83m-116.997 20.138c.14-1.597.275-3.238-.176-4.776-.902-3.081-3.861-5.034-5.687-7.668-3.157-4.55-2.571-10.887 0-15.785"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M138.809 95.322c.383 3.545 2.255 6.765 2.913 10.269.483 2.472 1.606 8.119 1.488 10.649m17.657-28.152a11.045 11.045 0 00-.451-4.57m-2.255-5.403c0 1.596.406 3.166 1.182 4.56.212.352.609.722.978.546a.75.75 0 00.343-.451 3.579 3.579 0 00-.126-1.966c-.541-2.007-1.123-4.655-2.255-6.396-.393.997-.167 2.625-.122 3.707zm45.698 13.395c-.289-4.104.586-8.23 2.043-12.082 1.456-3.852 3.477-7.46 5.552-11.014m-3.189 21.789a56.792 56.792 0 015.755-9.02m-41.341 57.959a17.724 17.724 0 00-4.988 2.345 44.528 44.528 0 00-14.847 15.56m24.219-13.868a42.974 42.974 0 00-7.559 9.137m52.534-81.124c-1.605 3.91.352 8.917 4.186 10.703 3.833 1.786 8.921.072 10.892-3.671a9.03 9.03 0 00.261-7.564c-1.353-3.197-3.942-5.466-7.432-5.015-3.342.433-6.59 2.327-7.907 5.547z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M226.062 76.961a4.156 4.156 0 003.789 1.614 4.16 4.16 0 003.323-2.435m-6.134-6.562a4.689 4.689 0 00-.135 1.276m5.2-1.398a4.22 4.22 0 000 1.209m-118.999 74.859c-.848 4.14 2.007 8.691 6.102 9.737 4.095 1.047 8.781-1.592 10.021-5.633a9.006 9.006 0 00-1.141-7.482c-1.903-2.891-4.889-4.641-8.235-3.545-3.216 1.046-6.053 3.513-6.747 6.923z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M118.13 150.44a4.158 4.158 0 006.842-2.133m-7.258-5.3c-.022.43.013.861.104 1.281m4.858-2.363c.023.404.104.804.239 1.186m115.595 14.906c-2.787 2.093-3.532 6.414-1.601 9.309 1.93 2.896 6.237 3.834 9.205 2.043a7.409 7.409 0 003.391-5.2c.42-2.81-.451-5.511-3.089-6.675-2.53-1.132-5.615-1.177-7.906.523z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M238.889 163.777a3.413 3.413 0 005.349 2.44m-1.534-7.208a4.025 4.025 0 00-.636.839m4.253 1.209c-.211.26-.386.548-.518.857M84.223 40.532l180.847 17.68M107.702 37.533v5.471m12.876-4.284v5.285m139.892 16.71a25.138 25.138 0 001.853 2.706"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M262.751 60.503a11.263 11.263 0 00-3.283 2.968m-154.644 9.142a92.677 92.677 0 0141.913-13.936m1.046-4.104a5.234 5.234 0 00-.189 4.636 5.117 5.117 0 003.635 2.869c.52.112 1.06.1 1.574-.037a3.481 3.481 0 001.182-.662 5.16 5.16 0 001.623-5.602c-1.177-3.175-6.03-4.42-7.825-1.204zm-43.057 18.09c3.157 6.17 3.978 13.26 6.363 19.772m4.015 7.898a169.764 169.764 0 0133.555-14.46"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M104.834 72.807a722.003 722.003 0 0131.088 8.06c3.424-7.465 7.722-13.81 13.797-19.335m-32.036 37.475a499.907 499.907 0 0014.085-19.047m8.209-3.36c4.248 1.42 13.823 5.033 17.954 6.765M149.8 57.68l1.411-2.8 1.453 4.96M79.906 46.838V31.115l186.49 16.855m-5.665 95.096c-.704.451-1.592.938-2.296 1.353a37.295 37.295 0 003.468 4.442c-.739.415-1.425.605-1.966 1.263-1.006-1.574-2.129-3.274-3.157-4.848a18.314 18.314 0 00-2.255 2.354l-1.71-7.762c2.458.907 5.498 2.309 7.916 3.198zM227.726 263.59a61.605 61.605 0 0124.291-25.784m-8.889 12.782a92.94 92.94 0 0117.91-14.302m-12.575 18.356a168.84 168.84 0 0116.236-13.864m-8.14 18.613a472.134 472.134 0 009.66-9.642"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M225.276 259.784a51.63 51.63 0 0112.859-15.844 10.271 10.271 0 012.85-1.804 3.977 3.977 0 011.658-.304 3.974 3.974 0 011.635.407M89.969 9.575a18.13 18.13 0 00-16.196 4.857c-3.017-.74-5.724-3.711-8.74-4.447a1.041 1.041 0 00-.731.023 1.132 1.132 0 00-.452.618L60.6 18.59"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F7F7F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M89.968 9.575c.577-.69 1.998-1.664 2.575-2.354m5.35.018l4.099 6.48a31.45 31.45 0 0110.428.74c.185.03.359.108.505.226.451.451-.126 1.173-.663 1.524L104.969 21a22.452 22.452 0 016.201-.487c2.071.203 4.154.979 5.57 2.503a66.722 66.722 0 01-8.303 3.468c2.37.006 4.72.432 6.941 1.259m-54.91-3.758a33.486 33.486 0 00-10.108 5.52c3.338-.618 6.766-1.24 10.108-.65a23.454 23.454 0 00-8.15 5.386c-.451.45-.902 1.118-.573 1.66a14.135 14.135 0 018.344-1.304 35.827 35.827 0 00-6.07 6.567m18.955-16.101c-.559.992.086 2.205.713 3.157.307.45.681.965 1.227 1.037.947.127 1.497-1.087 1.443-2.043-.068-1.222-.708-2.508-1.858-2.936-.681-.252-1.71.122-1.588.834m19.366-3.301a6.224 6.224 0 00-.406 2.255c0 .758.555 1.57 1.308 1.56.902 0 1.38-1.019 1.574-1.88.194-.862.253-1.99-.42-2.63-.671-.64-1.731-.374-2.056.718m-8.993 8.492a3.016 3.016 0 01-.343-.992 1.06 1.06 0 01.334-.952c.478-.379 1.236-.058 1.551.451a2.706 2.706 0 011.317-1.407 1.417 1.417 0 011.755.487c.32.573.08 1.3.284 1.922m-17.977 5.209a10.062 10.062 0 00-7.735 1.637m6.585 2.823a8.433 8.433 0 00-4.51 3.239m28.599 92.417a16.429 16.429 0 014.311-3.049M65.208 17.779a6.58 6.58 0 01.726-2.86c.292.309.524.668.686 1.06a1.073 1.073 0 001 .645m25.956-6.251c.296-.495.655-.95 1.07-1.353l1.018 2.111M209.843 175.81c15.041 4.027 38.62 10.4 53.783 15.199M27.034 143.422a108.203 108.203 0 0126.781 9.3c1.976.992 4.2 2.49 4.154 4.7m65.473 106.831c3.69-4.135 8.849-6.711 14.149-8.321 5.299-1.61 10.824-2.345 16.268-3.382 2.047-.393 4.244-.902 5.574-2.526 1.245-1.511 1.416-3.689.902-5.584-.514-1.894-1.569-3.576-2.629-5.227m1.137 13.995l1.646 7.311M7.618 98.826a48.26 48.26 0 00-1.353 14.604m3.689-3.707a25.567 25.567 0 00.793 10.824m5.133-3.735a21.162 21.162 0 001.962 11.659 4.613 4.613 0 012.075-4.627 33.497 33.497 0 005.412 11.298m-6.386-28.536c.127 1.51.025 3.031-.302 4.51m5.741 1.836a18.705 18.705 0 011.208 4.235m2.72 6.95l.452 2.431-.451-2.431zm4.538-5.741l.694 2.611-.694-2.611zm23.876-60.608c3.563-1.551 7.301-2.642 11.031-3.73 4.51-1.316 9.17-2.647 13.842-2.137.668.072 1.461.288 1.655.933a44.613 44.613 0 00-7.811 5.097 10.26 10.26 0 019.498-.19M15.19 73.154c8.691-13.079 24.012-21.477 39.69-21.779m-2.318 58.009a19.47 19.47 0 016.521 7.699 20.79 20.79 0 01-.266-6.409.844.844 0 01.771.424c-.157-7.595-.239-15.55 3.22-22.32"
  }));
});
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/errors/403/error-403.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const error_403_module = ({"root":"error-403-module__root--zWwDd","header":"error-403-module__header--ooQDi","description":"error-403-module__description--pDY2g","image":"error-403-module__image--AKorQ"});
;// CONCATENATED MODULE: ../ui-kit/src/errors/403/error-403.component.tsx







const Error403 = _ref => {
  let {
    textConstants: {
      description
    }
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: error_403_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(error_403_module.header, typography_module/* default */.Z.headline2),
      children: "403"
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(error_403_module.description, typography_module/* default */.Z.headline4),
      children: description
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(error_403, {
      className: error_403_module.image,
      width: "267px",
      height: "267px"
    })]
  });
};

/***/ }),

/***/ 6734:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  b: () => (/* binding */ DefaultError)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/errors/default-error/default-error.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const default_error_module = ({"root":"default-error-module__root--ToVSK","fixed":"default-error-module__fixed--GNFAU","content":"default-error-module__content--pKk4f","main-content":"default-error-module__main-content--X3ilR","mainContent":"default-error-module__main-content--X3ilR","image":"default-error-module__image--n9FFK","title":"default-error-module__title--YB_7b","title-mobile":"default-error-module__title-mobile--DYWdE","titleMobile":"default-error-module__title-mobile--DYWdE","description":"default-error-module__description--QV6bq","children":"default-error-module__children--qk2Oe","button":"default-error-module__button--iwZDW"});
;// CONCATENATED MODULE: ../ui-kit/src/errors/default-error/default-error.component.tsx






const DefaultError = _ref => {
  let {
    imageUrl,
    textConstants,
    children,
    fixed = true
  } = _ref;
  const {
    title,
    description
  } = textConstants;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(default_error_module.root, {
      [default_error_module.fixed]: fixed
    }),
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: default_error_module.content,
      children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: default_error_module.mainContent,
        children: [imageUrl && /* @__PURE__ */(0,jsx_runtime.jsx)("img", {
          alt: "error",
          src: imageUrl,
          className: default_error_module.image
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          className: classnames_default()(typography_module/* default */.Z.headline3, default_error_module.title),
          children: title
        }), /* @__PURE__ */(0,jsx_runtime.jsx)("h3", {
          className: classnames_default()(typography_module/* default */.Z.headline4Accent, default_error_module.titleMobile),
          children: title
        }), description && /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(typography_module/* default */.Z.body1, default_error_module.description),
          children: description
        })]
      }), children && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: default_error_module.children,
        children
      })]
    })
  });
};

/***/ }),

/***/ 80498:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  X: () => (/* binding */ FormTextField)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/input/input.component.tsx + 1 modules
var input_component = __webpack_require__(16455);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/form/control/control.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const control_module = ({"form-control":"control-module__form-control--xkOCA","formControl":"control-module__form-control--xkOCA","label-container":"control-module__label-container--U2d2T","labelContainer":"control-module__label-container--U2d2T","helper-text":"control-module__helper-text--tKLND","helperText":"control-module__helper-text--tKLND","error-color":"control-module__error-color--Xlr5K","errorColor":"control-module__error-color--Xlr5K"});
;// CONCATENATED MODULE: ../ui-kit/src/form/control/control.tsx






function FormControl(_ref) {
  let {
    id,
    label,
    errorText,
    helperText,
    children
  } = _ref;
  const labelId = label && id ? `${id}-label` : void 0;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("section", {
    className: control_module.formControl,
    children: [label && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(control_module.labelContainer, typography_module/* default */.Z.caption),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("label", {
        id: labelId,
        htmlFor: id,
        children: label
      })
    }), children({
      labelId
    }), (errorText || helperText) && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(control_module.helperText, typography_module/* default */.Z.caption, {
        [control_module.errorColor]: Boolean(errorText)
      }),
      children: errorText || helperText
    })]
  });
}
// EXTERNAL MODULE: ../ui-kit/src/form/use-form-field.ts
var use_form_field = __webpack_require__(91824);
;// CONCATENATED MODULE: ../ui-kit/src/form/fields/text.tsx







const FormTextField = _ref => {
  let {
    name: fieldName,
    multiline,
    hiddenError,
    label,
    helperText,
    onChange,
    onBlur,
    validateOnChange,
    errorLevel = "error",
    ...inputProps
  } = _ref;
  const [field, meta] = (0,use_form_field/* useFormField */.Y)(fieldName, {
    validateOnChange
  });
  const {
    errorText
  } = meta;
  const {
    onChange: onChangeField,
    onBlur: onBlurField
  } = field;
  const onChangeHandler = (0,react.useCallback)(event => {
    onChangeField(event);
    onChange?.(event);
  }, [onChangeField, onChange]);
  const onBlurHandler = (0,react.useCallback)(event => {
    onBlurField(event);
    onBlur?.(event);
  }, [onBlurField, onBlur]);
  const errorStatus = errorLevel === "error" ? input_component/* InputStatus */.Xz.Error : input_component/* InputStatus */.Xz.Warning;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(FormControl, {
    id: fieldName,
    label,
    errorText: hiddenError ? void 0 : errorText,
    helperText,
    children: _ref2 => {
      let {
        labelId
      } = _ref2;
      const mergedInputProps = {
        ...inputProps,
        ...field,
        "aria-labelledby": labelId,
        id: fieldName,
        status: errorText ? errorStatus : inputProps.status,
        onBlur: onBlurHandler,
        onChange: onChangeHandler
      };
      return /* @__PURE__ */(0,jsx_runtime.jsx)(input_component/* Input */.II, {
        ...mergedInputProps
      });
    }
  });
};

/***/ }),

/***/ 73385:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  l: () => (/* binding */ Form)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 21 modules
var formik_esm = __webpack_require__(66256);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/object.utils.ts
var object_utils = __webpack_require__(97060);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(9699);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(80978);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
;// CONCATENATED MODULE: ../shared/src/utils/form/validations/iin.ts





function validateINN(identificationNumber) {
  const INNumbers = getNumberList(identificationNumber);
  const isValidSequence = validateSequence(INNumbers);
  if (!isValidSequence) {
    return false;
  }
  let result;
  try {
    result = parseIIN(INNumbers);
  } catch (e) {
    result = false;
  }
  return result;
}
function getNumberList(numbers) {
  return numbers.split("").map(n => parseInt(n, 10));
}
function inRange(needle, min, max) {
  return needle >= min && needle <= max;
}
function validateSequence(numbers) {
  const standartSequence = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const alternativeSequence = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
  let controlDigit;
  if (numbers.length !== 12) {
    return false;
  }
  controlDigit = standartSequence.reduce((accumulator, currentValue, index) => accumulator + currentValue * numbers[index]) % 11;
  if (controlDigit === 10) {
    controlDigit = alternativeSequence.reduce((accumulator, currentValue, index) => accumulator + currentValue * numbers[index]) % 11;
  }
  return controlDigit < 10;
}
function parseIIN(numbers) {
  let year = "";
  const month = parseInt(`${numbers[2]}${numbers[3]}`, 10) - 1;
  if (!inRange(month, 0, 11)) {
    throw new Error("invalid month");
  }
  const day = parseInt(`${numbers[4]}${numbers[5]}`, 10);
  if (!inRange(numbers[6], 0, 6)) {
    throw new Error("invalid sex or epoch");
  }
  switch (numbers[6]) {
    case 0:
    case 1:
    case 2:
      {
        year = `18${numbers[0]}${numbers[1]}`;
        break;
      }
    case 3:
    case 4:
      {
        year = `19${numbers[0]}${numbers[1]}`;
        break;
      }
    case 5:
    case 6:
      {
        year = `20${numbers[0]}${numbers[1]}`;
        break;
      }
    default:
      break;
  }
  const isLeapYear = parseInt(year, 10) % 4 === 0;
  if (!inRange(day, 1, 31) || isLeapYear && month === 1 && !inRange(day, 1, 29)) {
    throw new Error("invalid day");
  }
  return true;
}
// EXTERNAL MODULE: ../shared/src/utils/form/validations/phone.ts
var phone = __webpack_require__(24796);
;// CONCATENATED MODULE: ../shared/configs/yup.ts





es/* addMethod */.kM(es/* string */.Z_, "phone", function (message) {
  return this.test("phone", message, function (value) {
    const {
      createError
    } = this;
    if (value && (0,phone/* isPhoneValid */.e)(value)) {
      return true;
    }
    return createError({
      message
    });
  });
});
es/* addMethod */.kM(es/* string */.Z_, "IIN", function (message) {
  return this.test("IIN", message, function (value) {
    const {
      createError
    } = this;
    if (value && validateINN(value)) {
      return true;
    }
    return createError({
      message
    });
  });
});
es/* addMethod */.kM(es/* string */.Z_, "telegram", function (message) {
  return this.test("telegram", message, function (value) {
    const {
      createError
    } = this;
    if (value && ((0,phone/* isPhoneValid */.e)(value) || /^@[a-z0-9_]{5,}$/.test(value))) {
      return true;
    }
    return createError({
      message
    });
  });
});
function setFormValidationTextConstants(textConstants) {
  const {
    required,
    notType
  } = textConstants;
  es/* setLocale */.i_({
    mixed: {
      required,
      notType
    }
  });
}
setFormValidationTextConstants({
  required: "Required",
  notType: "Invalid type"
});
// EXTERNAL MODULE: ../ui-kit/src/form/use-form-context.ts
var use_form_context = __webpack_require__(83900);
;// CONCATENATED MODULE: ../ui-kit/src/form/form.tsx











function Form(_ref) {
  let {
    onSubmit,
    transformValues,
    formatMessage,
    children,
    ...otherProps
  } = _ref;
  const [globalError, setGlobalError] = (0,react.useState)(null);
  const [formContext, setFormContext] = (0,react.useState)(use_form_context/* formContextDefaultValue */.Xy);
  (0,react.useEffect)(() => {
    setFormContext({
      globalError,
      formatMessage,
      setGlobalError
    });
  }, [globalError, formatMessage, setGlobalError]);
  const mixinOnSubmit = (0,react.useCallback)((values, actions) => {
    const valuesForSubmit = transformValues ? (0,object_utils/* getObjectKeys */.Z)(values).reduce((result, key) => {
      const transformValue = transformValues[key];
      result[key] = transformValue ? transformValue(values[key]) : values[key];
      return result;
    }, {}) : values;
    return onSubmit(valuesForSubmit, {
      ...actions,
      setGlobalError
    });
  }, [onSubmit, transformValues]);
  const onResetHandler = (0,react.useCallback)(() => {
    setGlobalError(null);
  }, [setGlobalError]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
    ...otherProps,
    onSubmit: mixinOnSubmit,
    onReset: onResetHandler,
    children: props => /* @__PURE__ */(0,jsx_runtime.jsx)(use_form_context/* FormContextComponent */.HC.Provider, {
      value: formContext,
      children: children({
        ...props,
        globalError,
        setGlobalError
      })
    })
  });
}

/***/ }),

/***/ 83900:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Gc: () => (/* binding */ useFormContext),
/* harmony export */   HC: () => (/* binding */ FormContextComponent),
/* harmony export */   Xy: () => (/* binding */ formContextDefaultValue)
/* harmony export */ });
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66256);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);




const formContextDefaultValue = {
  setGlobalError: () => console.error("Not implemented"),
  globalError: null
};
const FormContextComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(formContextDefaultValue);
const useFormContext = () => {
  const formContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(FormContextComponent);
  return {
    ...formContext,
    ...(0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormikContext */ .u6)()
  };
};

/***/ }),

/***/ 91824:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Y: () => (/* binding */ useFormField)
/* harmony export */ });
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66256);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _use_form_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83900);





const useFormField = (fieldName, options) => {
  const {
    setGlobalError,
    formatMessage,
    globalError,
    submitCount
  } = (0,_use_form_context__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)();
  const [field, meta, helper] = (0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useField */ .U$)(fieldName);
  const {
    error,
    touched,
    value,
    initialValue
  } = meta;
  const isDirtyField = value !== initialValue;
  const isErrorVisible = submitCount > 0 || options?.validateOnChange ? touched || isDirtyField : false;
  const errorKey = isErrorVisible ? error : "";
  const errorText = errorKey && formatMessage ? formatMessage(errorKey) : errorKey;
  const onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(value2 => {
    if (globalError) {
      setGlobalError(null);
    }
    field.onChange(value2);
  }, [field, globalError, setGlobalError]);
  return [{
    ...field,
    onChange
  }, {
    errorText,
    ...meta
  }, {
    setGlobalError,
    ...helper
  }];
};

/***/ }),

/***/ 17034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: () => (/* binding */ useMergeClasses)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);







function mergeClasses(obj1, obj2) {
  return Object.keys(obj1).reduce((acc, key) => ({
    ...acc,
    [key]: classnames__WEBPACK_IMPORTED_MODULE_3___default()(obj1[key], obj2[key])
  }), obj1);
}
function useMergeClasses(baseClassesMap, newClassesMap) {
  return (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(() => mergeClasses(baseClassesMap, newClassesMap), [baseClassesMap, newClassesMap]);
}

/***/ }),

/***/ 72416:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  wn: () => (/* binding */ HotKey),
  cu: () => (/* binding */ HotKeyContentType),
  wu: () => (/* binding */ HotKeyState)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/hot-key/hot-key.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const hot_key_module = ({"hotkey":"hot-key-module__hotkey--uMGOQ","default":"hot-key-module__default--JhT94","success":"hot-key-module__success--DsGkg","error":"hot-key-module__error--N7TK0","selected":"hot-key-module__selected--Pt2DX","warning":"hot-key-module__warning--syNG8"});
;// CONCATENATED MODULE: ../ui-kit/src/hot-key/hot-key.component.tsx







var HotKeyState = /* @__PURE__ */(HotKeyState2 => {
  HotKeyState2["Default"] = "default";
  HotKeyState2["Success"] = "success";
  HotKeyState2["Error"] = "error";
  HotKeyState2["Selected"] = "selected";
  HotKeyState2["Warning"] = "warning";
  return HotKeyState2;
})(HotKeyState || {});
var HotKeyContentType = /* @__PURE__ */(HotKeyContentType2 => {
  HotKeyContentType2["Check"] = "check";
  HotKeyContentType2["Cross"] = "cross";
  HotKeyContentType2["Exclamation"] = "exclamation";
  HotKeyContentType2["Text"] = "text";
  return HotKeyContentType2;
})(HotKeyContentType || {});
const hotKeyMapper = text => ({
  check: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "checkmark-bold",
    size: "tiny"
  }),
  cross: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "cross-bold",
    size: "tiny"
  }),
  exclamation: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "exclamation-mark",
    size: "tiny"
  }),
  text: text || ""
});
const HotKey = _ref => {
  let {
    state,
    contentType,
    text
  } = _ref;
  const hotKeyContent = hotKeyMapper(text);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(hot_key_module.hotkey, hot_key_module[state], typography_module/* default */.Z.captionAccent),
    children: hotKeyContent[contentType]
  });
};

/***/ }),

/***/ 48670:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: () => (/* binding */ Icon)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _icons_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33370);




const Icon = _ref => {
  let {
    name,
    size,
    className,
    alt,
    role
  } = _ref;
  const SpecifiedIcon = _icons_model__WEBPACK_IMPORTED_MODULE_1__/* .icons */ .c[name];
  const iconSize = _icons_model__WEBPACK_IMPORTED_MODULE_1__/* .ICON_SIZE_MAP */ .S[size];
  return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SpecifiedIcon, {
    className,
    style: {
      minWidth: iconSize,
      minHeight: iconSize
    },
    width: iconSize,
    height: iconSize,
    role,
    alt
  });
};

/***/ }),

/***/ 33370:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  S: () => (/* binding */ ICON_SIZE_MAP),
  c: () => (/* binding */ icons)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/add-comment.svg
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* harmony default export */ const add_comment = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M12 7H6a1 1 0 00-1 1v8a1 1 0 001 1h3.032a1 1 0 01.768.36l1.432 1.718a1 1 0 001.536 0L14.2 17.36a1 1 0 01.768-.36H18a1 1 0 001-1v-2m0-10v6m-3-3h6"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-down.svg
function arrow_down_extends() { arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_extends.apply(this, arguments); }

/* harmony default export */ const arrow_down = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M4 13l12 8 12-8"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-left.svg
function arrow_left_extends() { arrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_left_extends.apply(this, arguments); }

/* harmony default export */ const arrow_left = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M19 12H5m0 0l7-7m-7 7l7 7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-right-bold.svg
function arrow_right_bold_extends() { arrow_right_bold_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_bold_extends.apply(this, arguments); }

/* harmony default export */ const arrow_right_bold = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_right_bold_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M5 12h14m0 0l-7-7m7 7l-7 7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-right.svg
function arrow_right_extends() { arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_extends.apply(this, arguments); }

/* harmony default export */ const arrow_right = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M13 25l8-9-8-9"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-up-small.svg
function arrow_up_small_extends() { arrow_up_small_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_up_small_extends.apply(this, arguments); }

/* harmony default export */ const arrow_up_small = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_up_small_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M3 10.5l5-5 5 5"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-up.svg
function arrow_up_extends() { arrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_up_extends.apply(this, arguments); }

/* harmony default export */ const arrow_up = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M3 15l9-6 9 6"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/arrow-with-line-right.svg
function arrow_with_line_right_extends() { arrow_with_line_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_with_line_right_extends.apply(this, arguments); }

/* harmony default export */ const arrow_with_line_right = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_with_line_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M5 12h14m0 0l-7-7m7 7l-7 7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/audio.svg
function audio_extends() { audio_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return audio_extends.apply(this, arguments); }

/* harmony default export */ const audio = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", audio_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "2",
    height: "4.444",
    y: "5.778",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "2",
    height: "14.222",
    x: "3.556",
    y: ".889",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "2",
    height: "8",
    x: "7.111",
    y: "4",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "2",
    height: "14.222",
    x: "10.667",
    y: ".889",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "2",
    height: "4.444",
    x: "14",
    y: "5.778",
    fill: "currentColor",
    rx: "1"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/badge-crown.svg
function badge_crown_extends() { badge_crown_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_crown_extends.apply(this, arguments); }

/* harmony default export */ const badge_crown = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", badge_crown_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M5.4 15a.4.4 0 01-.4-.4V7.708a.4.4 0 01.634-.324l3.37 2.438a.4.4 0 00.57-.106l2.1-3.218a.4.4 0 01.665-.009l2.24 3.237a.4.4 0 00.57.092l3.21-2.412a.4.4 0 01.641.32V14.6a.4.4 0 01-.4.4H5.4z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.684",
    d: "M6 17h12"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/badge-star-filled.svg
function badge_star_filled_extends() { badge_star_filled_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_star_filled_extends.apply(this, arguments); }

/* harmony default export */ const badge_star_filled = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", badge_star_filled_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M11.283 2.738a1 1 0 011.434 0l1.35 1.39a1 1 0 00.888.288l1.909-.33a1 1 0 011.16.842l.276 1.918a1 1 0 00.549.755l1.738.855a1 1 0 01.443 1.364l-.904 1.713a1 1 0 000 .934l.904 1.713a1 1 0 01-.443 1.364l-1.738.855a1 1 0 00-.549.755l-.276 1.918a1 1 0 01-1.16.843l-1.909-.33a1 1 0 00-.888.288l-1.35 1.39a1 1 0 01-1.434 0l-1.35-1.39a1 1 0 00-.888-.289l-1.909.33a1 1 0 01-1.16-.842L5.7 17.154a1 1 0 00-.549-.755l-1.738-.855a1 1 0 01-.443-1.364l.904-1.713a1 1 0 000-.934L2.97 9.82a1 1 0 01.443-1.364L5.15 7.6a1 1 0 00.549-.755l.276-1.918a1 1 0 011.16-.843l1.909.33a1 1 0 00.888-.288l1.35-1.39z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/badge-with-exclamation-mark.svg
function badge_with_exclamation_mark_extends() { badge_with_exclamation_mark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return badge_with_exclamation_mark_extends.apply(this, arguments); }

/* harmony default export */ const badge_with_exclamation_mark = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", badge_with_exclamation_mark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M11.283 2.738a1 1 0 011.434 0l1.35 1.39a1 1 0 00.888.288l1.909-.33a1 1 0 011.16.842l.276 1.918a1 1 0 00.549.755l1.738.855a1 1 0 01.443 1.364l-.904 1.713a1 1 0 000 .934l.904 1.713a1 1 0 01-.443 1.364l-1.738.855a1 1 0 00-.549.755l-.276 1.918a1 1 0 01-1.16.843l-1.909-.33a1 1 0 00-.888.288l-1.35 1.39a1 1 0 01-1.434 0l-1.35-1.39a1 1 0 00-.888-.289l-1.909.33a1 1 0 01-1.16-.842L5.7 17.154a1 1 0 00-.549-.755l-1.738-.855a1 1 0 01-.443-1.364l.904-1.713a1 1 0 000-.934L2.97 9.82a1 1 0 01.443-1.364L5.15 7.6a1 1 0 00.549-.755l.276-1.918a1 1 0 011.16-.843l1.909.33a1 1 0 00.888-.288l1.35-1.39z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M12.956 8l-.204 5.916h-1.308L11.252 8h1.704zm-.852 8.688c-.152 0-.296-.028-.432-.084a1.198 1.198 0 01-.36-.228 1.247 1.247 0 01-.228-.348A1.007 1.007 0 0111 15.62c0-.144.028-.28.084-.408.056-.128.132-.24.228-.336.104-.096.224-.172.36-.228a1.123 1.123 0 011.2.228.996.996 0 01.324.744c0 .144-.028.28-.084.408a1.13 1.13 0 01-.24.348 1.052 1.052 0 01-.348.228 1.036 1.036 0 01-.42.084z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/bank-card.svg
function bank_card_extends() { bank_card_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bank_card_extends.apply(this, arguments); }

/* harmony default export */ const bank_card = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", bank_card_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "24",
    height: "19",
    x: "4",
    y: "6",
    fill: "currentColor",
    rx: "5"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M6 18h20v2H6zm3-6h4v2H9z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/book.svg
function book_extends() { book_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return book_extends.apply(this, arguments); }

/* harmony default export */ const book = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", book_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.364 12.714c-2.176 0-4.279.409-5.728 1.286H7.364c-1.454-.88-3.243-1.286-5.728-1.286H1V3.156l.558-.07c2.419-.304 4.94.206 6.476 1.418 1.696-1.183 3.929-1.73 6.408-1.418l.558.07v9.558h-.636zM8.636 5.652H7.364v6.421h1.272V5.652z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/bookmark-filled.svg
function bookmark_filled_extends() { bookmark_filled_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bookmark_filled_extends.apply(this, arguments); }

/* harmony default export */ const bookmark_filled = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", bookmark_filled_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M5 6c0-1.4 0-2.1.272-2.635a2.5 2.5 0 011.093-1.093C6.9 2 7.6 2 9 2h6c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093C19 3.9 19 4.6 19 6v13.208c0 1.056 0 1.583-.217 1.856a1 1 0 01-.778.378c-.349.002-.764-.324-1.593-.976L12 17l-4.411 3.466c-.83.652-1.245.978-1.594.976a1 1 0 01-.778-.378C5 20.791 5 20.264 5 19.208V6z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/bookmark.svg
function bookmark_extends() { bookmark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bookmark_extends.apply(this, arguments); }

/* harmony default export */ const bookmark = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", bookmark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.795 2h-7.59c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 00-.945.945C5.116 3.686 5 4.09 5 5.205v15.237a1 1 0 001.618.787L12 17l5.382 4.229A1 1 0 0019 20.442V5.205c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 00-.945-.945C17.314 2.116 16.91 2 15.795 2zm-5.03 13.427L7 18.385V5.205c0-.427.019-.694.049-.849a.353.353 0 01.049-.134.275.275 0 01.124-.124.353.353 0 01.134-.049c.155-.03.422-.049.849-.049h7.59c.427 0 .694.019.849.049.06.012.074.017.134.049a.275.275 0 01.125.124c.031.06.036.073.048.134.03.155.049.422.049.849v13.18l-3.764-2.958a2 2 0 00-2.472 0z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/burger-menu.svg
function burger_menu_extends() { burger_menu_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return burger_menu_extends.apply(this, arguments); }

/* harmony default export */ const burger_menu = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", burger_menu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M2 6h12M2 10h6"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/calendar-with-badge.svg
function calendar_with_badge_extends() { calendar_with_badge_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_with_badge_extends.apply(this, arguments); }

/* harmony default export */ const calendar_with_badge = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", calendar_with_badge_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 2a1 1 0 00-1 1v1.001c-.961.014-1.34.129-1.721.333a2.272 2.272 0 00-.945.945C3.116 5.686 3 6.09 3 7.205v10.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h11.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926V7.205c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 00-.945-.945C19.34 4.13 18.961 4.015 18 4V3a1 1 0 00-2 0v1H8V3a1 1 0 00-1-1zM5 9v8.795c0 .427.019.694.049.849.012.06.017.074.049.134.027.054.07.098.124.125.06.031.073.036.134.048.155.03.422.049.849.049h11.59c.427 0 .694-.019.849-.049a.352.352 0 00.134-.049.275.275 0 00.125-.124.352.352 0 00.048-.134c.03-.155.049-.422.049-.849L19.004 9H5zm8.75 4a.75.75 0 00-.75.75v2.5c0 .414.336.75.75.75h2.5a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "17",
    cy: "7",
    r: "6",
    fill: "#E05151",
    stroke: "#fff",
    strokeWidth: "2"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/calendar.svg
function calendar_extends() { calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_extends.apply(this, arguments); }

/* harmony default export */ const calendar = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", calendar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 2a1 1 0 00-1 1v1.001c-.961.014-1.34.129-1.721.333a2.272 2.272 0 00-.945.945C3.116 5.686 3 6.09 3 7.205v10.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h11.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926V7.205c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 00-.945-.945C19.34 4.13 18.961 4.015 18 4V3a1 1 0 00-2 0v1H8V3a1 1 0 00-1-1zM5 9v8.795c0 .427.019.694.049.849.012.06.017.074.049.134.027.054.07.098.124.125.06.031.073.036.134.048.155.03.422.049.849.049h11.59c.427 0 .694-.019.849-.049a.352.352 0 00.134-.049.275.275 0 00.125-.124.352.352 0 00.048-.134c.03-.155.049-.422.049-.849L19.004 9H5zm8.75 4a.75.75 0 00-.75.75v2.5c0 .414.336.75.75.75h2.5a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chapter-outline.svg
function chapter_outline_extends() { chapter_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chapter_outline_extends.apply(this, arguments); }

/* harmony default export */ const chapter_outline = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chapter_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M2.667 2.067v11.2a1.4 1.4 0 001.4 1.4h8.4a1.4 1.4 0 001.4-1.4v-11.2a1.4 1.4 0 00-1.4-1.4h-8.4a1.4 1.4 0 00-1.4 1.4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M5.267 5.083V.667h3v4.416a.25.25 0 01-.423.181l-.905-.862a.25.25 0 00-.345 0l-.905.862a.25.25 0 01-.422-.18z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chapter.svg
function chapter_extends() { chapter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chapter_extends.apply(this, arguments); }

/* harmony default export */ const chapter = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chapter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 2.004a1 1 0 010-2h10a1 1 0 110 2H3zm9.5 1h-9a1.5 1.5 0 00-1.5 1.5v7a1.5 1.5 0 001.5 1.5h9a1.5 1.5 0 001.5-1.5v-7a1.5 1.5 0 00-1.5-1.5zm-8.5 8v-6h8v6H4zm-2 4a1 1 0 001 1h10a1 1 0 000-2H3a1 1 0 00-1 1z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chart.svg
function chart_extends() { chart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chart_extends.apply(this, arguments); }

/* harmony default export */ const chart = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "5",
    x: "1",
    y: "10",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "9",
    x: "6",
    y: "6",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "13",
    x: "11",
    y: "2",
    fill: "currentColor",
    rx: "1"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chat-off.svg
function chat_off_extends() { chat_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_off_extends.apply(this, arguments); }

/* harmony default export */ const chat_off = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chat_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.012 8H8a2 2 0 00-2 2v10c0 .555.226 1.058.592 1.42L20.012 8zM12 23.988v1.805a.5.5 0 00.854.353L17 22h7a2 2 0 002-2V9.988l-14 14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M7 25L26 6"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chat-outline.svg
function chat_outline_extends() { chat_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_outline_extends.apply(this, arguments); }

/* harmony default export */ const chat_outline = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chat_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.136 20.915c.078.054.17.084.266.085 2.724.03 4.721-.496 5.985-1.643.68.143 1.387.218 2.113.218 5.247 0 9.5-3.934 9.5-8.787C22 5.933 17.747 2 12.5 2S3 5.934 3 10.787c0 2.25.914 4.303 2.418 5.858-.128 1.27-.593 2.483-1.398 3.64-.15.216-.1.48.116.63zM10.8 17.42a1.875 1.875 0 00-1.646.446c-.503.457-1.566 1.088-2.563 1.28.468-.679.714-1.669.786-2.38a1.875 1.875 0 00-.518-1.491C5.663 14.038 5 12.463 5 10.797 5 7.077 8.327 4 12.5 4S20 7.077 20 10.797c0 3.72-3.327 6.797-7.5 6.797-.579 0-1.148-.06-1.7-.175v.001z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chat.svg
function chat_extends() { chat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_extends.apply(this, arguments); }

/* harmony default export */ const chat = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chat_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 10.787c0 4.854-4.253 8.788-9.5 8.788a10.222 10.222 0 01-2.684-.355c-1.881 1.241-4.233 1.617-5.485 1.73-.286.027-.434-.347-.24-.559.595-.65 1.431-1.803 1.715-3.368C4.073 15.43 3 13.225 3 10.787 3 5.934 7.253 2 12.5 2S22 5.934 22 10.787z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/check-outline.svg
function check_outline_extends() { check_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_outline_extends.apply(this, arguments); }

/* harmony default export */ const check_outline = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", check_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 100-16.001A8 8 0 0012 20zm4.66-11.749a1 1 0 00-1.41.094l-4.517 5.158-1.996-2.178a1 1 0 00-1.474 1.35l2.373 2.59a1.5 1.5 0 002.119.094l.06-.058.055-.06 4.884-5.579a1 1 0 00-.093-1.41l-.001-.001z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/check-solid.svg
function check_solid_extends() { check_solid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_solid_extends.apply(this, arguments); }

/* harmony default export */ const check_solid = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", check_solid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-4.836-4.247a1 1 0 00-1.411.083l-5.267 5.925-2.251-2.44a1 1 0 00-1.47 1.357l2.626 2.845a1.5 1.5 0 002.12.085l.053-.052a2.13 2.13 0 00.05-.054l5.633-6.338a1 1 0 00-.083-1.411z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/checkmark-bold.svg
function checkmark_bold_extends() { checkmark_bold_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkmark_bold_extends.apply(this, arguments); }

/* harmony default export */ const checkmark_bold = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", checkmark_bold_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M4.731 7.318A1 1 0 003.27 8.682l1.46-1.364zM6.8 11l-.731.682a1 1 0 001.487-.027L6.8 11zm5.956-5.345a1 1 0 10-1.512-1.31l1.512 1.31zM3.269 8.682l2.8 3 1.462-1.364-2.8-3L3.27 8.682zm4.287 2.973l5.2-6-1.512-1.31-5.2 6 1.512 1.31z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/checkmark.svg
function checkmark_extends() { checkmark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkmark_extends.apply(this, arguments); }

/* harmony default export */ const checkmark = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", checkmark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M19.716 4.386a1 1 0 011.572 1.236L10.665 19.136a1.499 1.499 0 01-2.324.042l-5.104-6.032a1 1 0 111.526-1.292l4.708 5.564L19.716 4.386z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chevron-down.svg
function chevron_down_extends() { chevron_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_down_extends.apply(this, arguments); }

/* harmony default export */ const chevron_down = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chevron_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M17.586 9H6.414c-.89 0-1.337 1.077-.707 1.707l5.94 5.94a.5.5 0 00.707 0l5.939-5.94c.63-.63.184-1.707-.707-1.707z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chevron-up.svg
function chevron_up_extends() { chevron_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_up_extends.apply(this, arguments); }

/* harmony default export */ const chevron_up = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chevron_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M6.414 16h11.172c.89 0 1.337-1.077.707-1.707l-5.94-5.94a.5.5 0 00-.707 0l-5.939 5.94c-.63.63-.184 1.707.707 1.707z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/chrome-browser.svg
function chrome_browser_extends() { chrome_browser_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chrome_browser_extends.apply(this, arguments); }

/* harmony default export */ const chrome_browser = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chrome_browser_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#EF3F36",
    d: "M11.97.002s7.072-.316 10.823 6.768H11.367S9.211 6.7 7.37 9.307c-.529 1.094-1.097 2.221-.46 4.442-.919-1.552-4.88-8.425-4.88-8.425S4.823.282 11.969.002z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#FCD900",
    d: "M22.426 17.986s-3.264 6.264-11.293 5.955l5.714-9.86s1.14-1.825-.205-4.718c-.685-1.005-1.382-2.056-3.63-2.616 1.808-.016 9.76 0 9.76 0s2.98 4.933-.346 11.24z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#61BC5B",
    d: "M1.563 18.036s-3.813-5.948.473-12.722c.988 1.71 5.71 9.859 5.71 9.859s1.019 1.897 4.204 2.18c1.213-.088 2.476-.164 4.09-1.821-.89 1.568-4.88 8.422-4.88 8.422s-5.781.105-9.597-5.918z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#5AB055",
    d: "M11.13 24l1.606-6.682s1.766-.139 3.248-1.757c-.92 1.612-4.855 8.44-4.855 8.44z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M6.586 12.075c0-2.946 2.397-5.335 5.354-5.335 2.956 0 5.354 2.39 5.354 5.335 0 2.946-2.398 5.335-5.354 5.335-2.957-.004-5.354-2.39-5.354-5.335z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "url(#a)",
    d: "M7.482 12.075a4.45 4.45 0 014.458-4.441c2.46 0 4.457 1.987 4.457 4.441a4.45 4.45 0 01-4.457 4.442c-2.46 0-4.458-1.99-4.458-4.442z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#EACA05",
    d: "M22.77 6.75l-6.617 1.935s-1-1.46-3.145-1.935c1.862-.01 9.762 0 9.762 0z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#DF3A32",
    d: "M6.78 13.505c-.928-1.604-4.75-8.181-4.75-8.181l4.9 4.83s-.502 1.032-.314 2.508l.166.843z"
  }), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "a",
    x1: "11.939",
    x2: "11.939",
    y1: "7.696",
    y2: "16.25",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#86BBE5"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: "1",
    stopColor: "#1072BA"
  }))));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/circle-filled.svg
function circle_filled_extends() { circle_filled_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return circle_filled_extends.apply(this, arguments); }

/* harmony default export */ const circle_filled = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", circle_filled_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "currentColor"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/class-dialogue.svg
function class_dialogue_extends() { class_dialogue_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return class_dialogue_extends.apply(this, arguments); }

/* harmony default export */ const class_dialogue = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", class_dialogue_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "10",
    height: "5",
    x: "3",
    y: "2",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "10",
    height: "5",
    x: "3",
    y: "9",
    fill: "currentColor",
    rx: "1"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/class-planning.svg
function class_planning_extends() { class_planning_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return class_planning_extends.apply(this, arguments); }

/* harmony default export */ const class_planning = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", class_planning_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M10 1.462c0-.255.207-.462.461-.462h4.078c.254 0 .461.207.461.462v2.076a.462.462 0 01-.461.462H10.46a.462.462 0 01-.46-.462V1.462z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8 3H3a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1V6"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/class-training.svg
function class_training_extends() { class_training_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return class_training_extends.apply(this, arguments); }

/* harmony default export */ const class_training = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", class_training_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M10 1.462c0-.255.207-.462.461-.462h4.078c.254 0 .461.207.461.462v2.076a.462.462 0 01-.461.462H10.46a.462.462 0 01-.46-.462V1.462zm0 4c0-.255.207-.462.461-.462h4.078c.254 0 .461.207.461.462v2.076a.462.462 0 01-.461.462H10.46a.462.462 0 01-.46-.462V5.462z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8 3H3a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1v-2"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/clip.svg
function clip_extends() { clip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clip_extends.apply(this, arguments); }

/* harmony default export */ const clip = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", clip_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M11.719 11.238a.95.95 0 111.343 1.344l-1.414 1.414A6 6 0 013.163 5.51l3.995-3.995a4.35 4.35 0 016.152 6.15l-3.996 3.997a2.7 2.7 0 11-3.818-3.82L9.032 4.31a.95.95 0 011.343 1.343L6.84 9.188a.8.8 0 101.13 1.13l3.996-3.994A2.45 2.45 0 008.5 2.859L4.506 6.854a4.1 4.1 0 005.798 5.799l1.415-1.415z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/clock.svg
function clock_extends() { clock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clock_extends.apply(this, arguments); }

/* harmony default export */ const clock = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", clock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 0a10 10 0 100 20 10 10 0 000-20zM4.343 4.343a8 8 0 1111.314 11.314A8 8 0 014.343 4.343zm6.907 5.14L11 4.007 9 4l-.25 6.518 3.566 3.181 1.313-1.313-2.379-2.904z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/collapse.svg
function collapse_extends() { collapse_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return collapse_extends.apply(this, arguments); }

/* harmony default export */ const collapse = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", collapse_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.013 9.334v-.291a10 10 0 001.763-1.404l2.944-2.944a1 1 0 00-1.414-1.414l-2.933 2.932a9.996 9.996 0 00-1.41 1.775h-.296l.09-.39c.17-.738.256-1.493.256-2.25V4.49a1 1 0 10-2 0v4.994a1.5 1.5 0 001.5 1.5l5 .003a1 1 0 000-2h-.861a10 10 0 00-2.25.256l-.39.09zm-6.975 6.678a10 10 0 01-1.41 1.775L4.695 20.72a1 1 0 01-1.414-1.414l2.944-2.944a9.993 9.993 0 011.763-1.404v-.29l-.39.09a10 10 0 01-2.25.255h-.86a1 1 0 010-2l5 .003a1.5 1.5 0 011.5 1.5v4.997a1 1 0 11-2 0v-.86a10 10 0 01.256-2.25l.09-.39h-.296z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/comments.svg
function comments_extends() { comments_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return comments_extends.apply(this, arguments); }

/* harmony default export */ const comments = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", comments_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 11.25c-.767 0-1.5-.13-2.174-.37-.75.518-1.762.77-3.037.758a.2.2 0 01-.155-.324c.523-.668.809-1.316.859-1.943A5.406 5.406 0 010 5.625C0 2.437 2.686 0 6 0s6 2.438 6 5.625c0 3.188-2.686 5.625-6 5.625zm7.5-5.625c0 3.321-2.295 6.024-5.437 6.858a5.88 5.88 0 002.437.52c.703 0 1.375-.12 1.993-.34.68.47 1.597.702 2.749.695a.2.2 0 00.157-.322c-.467-.604-.722-1.189-.767-1.756A4.955 4.955 0 0016 7.846c0-2.018-1.175-3.708-2.902-4.56.26.729.402 1.515.402 2.339z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/connected.svg
function connected_extends() { connected_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return connected_extends.apply(this, arguments); }

/* harmony default export */ const connected = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", connected_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M16.84 14.16l-.486.486a.5.5 0 01-.708 0L9.354 8.354a.5.5 0 010-.708l.486-.486a5.935 5.935 0 015.173-1.658 4.24 4.24 0 013.485 3.485 5.935 5.935 0 01-1.658 5.173zM7.16 9.84l.486-.486a.5.5 0 01.708 0l6.292 6.292a.5.5 0 010 .708l-.486.486a5.935 5.935 0 01-5.173 1.658 4.24 4.24 0 01-3.485-3.485A5.935 5.935 0 017.16 9.84z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M16 8l5-5M3 21l5-5"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/copy.svg
function copy_extends() { copy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return copy_extends.apply(this, arguments); }

/* harmony default export */ const copy = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", copy_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.056 5.664H3.835v7.776h6.22V5.665zm1.555 0v7.776c0 .859-.697 1.555-1.556 1.555h-6.22A1.555 1.555 0 012.28 13.44V5.665c0-.86.696-1.556 1.555-1.556h6.22c.872 0 1.556.712 1.556 1.556z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.165 2.555h-6.22V4.11h3.11c.902 0 1.555.63 1.555 1.555v4.666h1.555V2.555zm1.555 0v7.776c0 .859-.696 1.555-1.555 1.555h-3.11V5.665H5.389v-3.11A1.555 1.555 0 016.944 1h6.22c.873 0 1.556.712 1.556 1.555z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/cross-bold.svg
function cross_bold_extends() { cross_bold_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cross_bold_extends.apply(this, arguments); }

/* harmony default export */ const cross_bold = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", cross_bold_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M3.5 12.5l9-9m0 9l-9-9"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/cross.svg
function cross_extends() { cross_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cross_extends.apply(this, arguments); }

/* harmony default export */ const cross = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", cross_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M5.5 5.5l13 13m-13 0l13-13"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/cursor.svg
function cursor_extends() { cursor_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cursor_extends.apply(this, arguments); }

/* harmony default export */ const cursor = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", cursor_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.822 2.717l8.666 5.716a.26.26 0 01.114.135c.016.046.02.107.004.172a.298.298 0 01-.088.147.263.263 0 01-.165.062l-3.295.229a1.64 1.64 0 00-1.385.97L6.33 13.166a.263.263 0 01-.115.134.297.297 0 01-.169.032.297.297 0 01-.16-.062.264.264 0 01-.088-.153l-2.406-10.1a.282.282 0 01.429-.3z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/draw-crossed.svg
function draw_crossed_extends() { draw_crossed_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return draw_crossed_extends.apply(this, arguments); }

/* harmony default export */ const draw_crossed = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", draw_crossed_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5.493 12.58l.557-2.283c.068-.277.21-.53.411-.73l5.339-5.34a.777.777 0 011.099 0l6.873 6.874a.777.777 0 010 1.1l-5.338 5.338a1.553 1.553 0 01-.73.41l-2.283.558m-5.928-5.928l5.928 5.928m-5.928-5.928l-1.459 5.978c-.207.85.56 1.616 1.409 1.409l5.978-1.46"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#E05151",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M4.328 4.331l15.338 15.338"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/draw.svg
function draw_extends() { draw_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return draw_extends.apply(this, arguments); }

/* harmony default export */ const draw = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", draw_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5.623 12.86l.632-2.587a2 2 0 01.528-.94l6.068-6.068a1 1 0 011.415 0l7.813 7.814a1 1 0 010 1.414l-6.068 6.068a2 2 0 01-.94.529l-2.587.631m-6.86-6.86l-.285 1.163-1.346 5.514a1.5 1.5 0 001.813 1.813l5.514-1.346 1.164-.284m-6.86-6.86l6.86 6.86"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/edit.svg
function edit_extends() { edit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return edit_extends.apply(this, arguments); }

/* harmony default export */ const edit = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", edit_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M14.793 7.368l-8.36 8.36c-.18.18-.324.391-.425.625L4.28 19.52l3.365-1.53c.233-.101.445-.245.624-.424l8.36-8.362c-.226-.375-.5-.72-.813-1.024a5.086 5.086 0 00-1.023-.812zm1.446-1.446c.335.237.665.519.991.844a7.7 7.7 0 01.845.992l1.471-1.471a.5.5 0 00.11-.542c-.107-.262-.298-.537-.582-.822-.285-.284-.56-.475-.822-.582a.5.5 0 00-.542.11l-1.471 1.47zM4.17 15.564c.2-.467.488-.891.848-1.25L16.296 3.036a2.5 2.5 0 012.708-.55c.526.215 1.02.558 1.484 1.022.464.465.808.959 1.02 1.484A2.5 2.5 0 0120.96 7.7L9.684 18.98c-.36.36-.783.646-1.25.847l-3.442 1.48a1.75 1.75 0 01-2.3-2.298l1.478-3.445z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/enter.svg
function enter_extends() { enter_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return enter_extends.apply(this, arguments); }

/* harmony default export */ const enter = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", enter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M18 9h3a2 2 0 012 2v6a2 2 0 01-2 2H8m0 0l4-4m-4 4l4 4"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/exclamation-mark.svg
function exclamation_mark_extends() { exclamation_mark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return exclamation_mark_extends.apply(this, arguments); }

/* harmony default export */ const exclamation_mark = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", exclamation_mark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M8 9.6a.8.8 0 01-.8-.8V4a.8.8 0 111.6 0v4.8a.8.8 0 01-.8.8zm-1.2 2a1.2 1.2 0 112.4 0 1.2 1.2 0 01-2.4 0z",
    fill: "currentColor"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/external-link.svg
function external_link_extends() { external_link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return external_link_extends.apply(this, arguments); }

/* harmony default export */ const external_link = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", external_link_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M7.076 3.504a1.02 1.02 0 00-1.02-1.02H4.04A2.04 2.04 0 002 4.524v7.14a2.04 2.04 0 002.04 2.04h7.14a2.04 2.04 0 002.04-2.04V9.626a1.02 1.02 0 00-2.04 0v1.984c0 .03-.025.054-.055.054H4.69a.65.65 0 01-.649-.649v-5.67a.82.82 0 01.82-.82h1.196a1.02 1.02 0 001.02-1.02z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M9.613 2.485h3.607m0 0v3.607m0-3.607L9.012 6.693"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/eye.svg
function eye_extends() { eye_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return eye_extends.apply(this, arguments); }

/* harmony default export */ const eye = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", eye_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M0 8.003c0-1.8 2.857-6 8-6s8 4.2 8 6c0 1.8-2.857 6-8 6s-8-4.2-8-6zm2 0c0 .362.546 1.377 1.44 2.217 1.193 1.12 2.75 1.783 4.56 1.783 1.81 0 3.367-.663 4.56-1.783.894-.84 1.44-1.855 1.44-2.217 0-.362-.546-1.377-1.44-2.218C11.366 4.665 9.81 4.003 8 4.003c-1.81 0-3.367.663-4.56 1.782C2.547 6.625 2 7.641 2 8.003zm8.3 0a2.3 2.3 0 11-4.6 0 2.3 2.3 0 014.6 0z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/facebook.svg
function facebook_extends() { facebook_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return facebook_extends.apply(this, arguments); }

/* harmony default export */ const facebook = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", facebook_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3c-4.97 0-9 3.73-9 8.333 0 2.623 1.309 4.962 3.354 6.49V21l3.064-1.682a9.672 9.672 0 002.582.349c4.97 0 9-3.731 9-8.334C21 6.731 16.97 3 12 3zm.894 11.222l-2.292-2.444-4.472 2.444L11.05 9l2.348 2.444L17.814 9l-4.92 5.222z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/filters.svg
function filters_extends() { filters_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return filters_extends.apply(this, arguments); }

/* harmony default export */ const filters = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", filters_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "14",
    height: "2",
    x: "1",
    y: "4",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "14",
    height: "2",
    x: "1",
    y: "10",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "6",
    cy: "5",
    r: "2",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2",
    fill: "currentColor"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/flame-big.svg
function flame_big_extends() { flame_big_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return flame_big_extends.apply(this, arguments); }

/* harmony default export */ const flame_big = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", flame_big_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 21"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 6C7.433 4.325 9 1.5 10 0h1c1.796 1.796 3.688 4.157 4.93 6.314C17.164 8.46 18 10.76 18 13c0 4.583-3.5 8-7 8l-.5-1c1.5-.5 2.5-2 2.5-4 0-2.64-2.58-5.55-4-7-1.42 1.45-4 4.5-4 7 0 2 1.5 3.5 2.5 4L7 21c-3.5 0-7-3.417-7-8C0 8.657 2.476 5.032 4 3h1l1.5 3z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/flame.svg
function flame_extends() { flame_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return flame_extends.apply(this, arguments); }

/* harmony default export */ const flame = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", flame_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.707 10.26h.04a5.707 5.707 0 002.927-2.94v2.906a4.667 4.667 0 01-2.807 4.293h-.046c-.565.24-1.173.36-1.787.354a4.413 4.413 0 01-1.727-.347l-.173-.073a4.56 4.56 0 01-2.8-4.233v-.12a3.593 3.593 0 011.073-2.514l.12-.113a12.994 12.994 0 002.587-3.587l.913-1.866s.947 1.333 1.827 2.666a3.62 3.62 0 01-.813 4.907h-.08a.5.5 0 00.04.666.373.373 0 00.273.087c.148-.006.294-.035.433-.087zm-.293 3.333h.047v-.007a3.687 3.687 0 002.206-3.353 5.24 5.24 0 01-1.52.933l-.086.034c-.251.097-.518.15-.787.153a1.334 1.334 0 01-.98-.38 1.5 1.5 0 01-.12-2c.058-.073.125-.138.2-.193h.047a2.62 2.62 0 00.6-3.574c-.287-.426-.574-.853-.84-1.233l-.167.347a14 14 0 01-2.787 3.82l-.12.113a2.6 2.6 0 00-.773 1.806v.127a3.567 3.567 0 002.187 3.334l.173.073a3.48 3.48 0 002.72 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M9.414 13.593h.047v-.007a3.687 3.687 0 002.206-3.353 5.24 5.24 0 01-1.52.933l-.086.034c-.251.097-.518.15-.787.153a1.334 1.334 0 01-.98-.38 1.5 1.5 0 01-.12-2c.058-.073.125-.138.2-.193h.047a2.62 2.62 0 00.6-3.574c-.287-.426-.574-.853-.84-1.233l-.167.347a14 14 0 01-2.787 3.82l-.12.113a2.6 2.6 0 00-.773 1.806v.127a3.567 3.567 0 002.187 3.334l.173.073a3.48 3.48 0 002.72 0z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/gift-fill.svg
function gift_fill_extends() { gift_fill_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gift_fill_extends.apply(this, arguments); }

/* harmony default export */ const gift_fill = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", gift_fill_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.858 6.5c-.358 0-1.16-.437-1.546-.842a2.22 2.22 0 010-3.03 1.973 1.973 0 012.887 0c.346.363.581.87.8 1.428.218-.559.453-1.065.799-1.428a1.973 1.973 0 012.886 0 2.22 2.22 0 010 3.03c-.383.403-1.18.838-1.54.842.765.002 1.19.022 1.533.171a2.2 2.2 0 011.16 1.218c.163.413.163.938.163 1.986l-.713.452c0 1.329 0 1.994-.259 2.495a2.2 2.2 0 01-.863.906c-.477.272-1.094.272-2.45.272V7.25H7.286V14c-1.335 0-2.003 0-2.5-.301a2.2 2.2 0 01-.784-.824c-.288-.522-.288-1.223-.288-2.625L3 9.875c0-1.048 0-1.573.163-1.986a2.2 2.2 0 011.16-1.218c.344-.15.768-.168 1.535-.17zm-.535-1.902c.37.388 1.099.79 1.954 1.142-.336-.898-.719-1.664-1.088-2.052a.592.592 0 00-.866 0 .666.666 0 000 .91zm5.351 0c-.37.388-1.099.79-1.954 1.142.335-.898.718-1.664 1.088-2.052a.592.592 0 01.866 0c.24.251.24.659 0 .91z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/gift.svg
function gift_extends() { gift_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return gift_extends.apply(this, arguments); }

/* harmony default export */ const gift = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", gift_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.752 8H12l1.678-3.356c.804-1.608 3.053-1.73 4.025-.217C18.695 5.97 17.587 8 15.753 8zM8.5 8H12l-1.764-3.023c-.775-1.33-2.697-1.33-3.472 0C5.982 6.317 6.948 8 8.5 8z"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "14",
    height: "12",
    x: "5",
    y: "8",
    stroke: "currentColor",
    strokeWidth: "2",
    rx: "2"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12 8v12"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/grammar.svg
function grammar_extends() { grammar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return grammar_extends.apply(this, arguments); }

/* harmony default export */ const grammar = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", grammar_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M7.494 6.93c0 .463-.068.916-.203 1.36a6.438 6.438 0 01-.55 1.243 8.312 8.312 0 01-.722 1.1c-.27.327-.53.616-.781.867H2.924c.385-.386.723-.82 1.012-1.302a6.46 6.46 0 00.723-1.706c-.52-.135-.906-.376-1.157-.723a2.105 2.105 0 01-.376-1.215c0-.579.193-1.06.579-1.447.385-.405.906-.607 1.562-.607.674 0 1.214.212 1.62.636.404.425.607 1.022.607 1.794zm5.582 0c0 .463-.067.916-.202 1.36a6.44 6.44 0 01-.55 1.243 8.317 8.317 0 01-.723 1.1c-.27.327-.53.616-.78.867H8.505c.386-.386.723-.82 1.013-1.302a6.5 6.5 0 00.723-1.706c-.54-.135-.936-.376-1.186-.723a2.105 2.105 0 01-.376-1.215c0-.579.193-1.06.578-1.447.386-.405.916-.607 1.591-.607.656 0 1.186.212 1.591.636.424.425.636 1.022.636 1.794z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/handline.svg
function handline_extends() { handline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return handline_extends.apply(this, arguments); }

/* harmony default export */ const handline = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", handline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M1 11.81c.392.514 3.175 2.547 3.803 2.135.784-.514-3.803-6.768-1.45-6.253 2.353.514 5.22 6.08 6.397 4.535 1.177-1.544-5.731-10.12-3.77-11.15C7.547.254 12.646 6.224 15 9.313"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/handset.svg
function handset_extends() { handset_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return handset_extends.apply(this, arguments); }

/* harmony default export */ const handset = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", handset_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M9.001 16C2.814 9.813 3.111 5.134 5.94 3.012c.216-.162.429-.32.628-.467a1.483 1.483 0 012.1.353l1.579 2.272a1.5 1.5 0 01-.251 1.99L8.477 8.474c-.38.329-.566.828-.396 1.301.317.88 1.084 2.433 2.898 4.246 1.814 1.814 3.366 2.581 4.246 2.898.473.17.972-.015 1.301-.396l1.314-1.518a1.5 1.5 0 011.99-.25l2.276 1.58a1.48 1.48 0 01.355 2.096l-.47.633C19.868 21.892 15.187 22.187 9 16z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/heart-outline.svg
function heart_outline_extends() { heart_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_outline_extends.apply(this, arguments); }

/* harmony default export */ const heart_outline = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", heart_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 19"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#242424",
    fillRule: "evenodd",
    d: "M10.509 18.86C16.78 15.154 20 11.22 20 7c0-6.002-6.749-7.89-10-3.898C6.749-.89 0 .998 0 7c0 4.22 3.219 8.153 9.491 11.86a1 1 0 001.018 0zm.402-13.448C12.677 1.51 18 2.542 18 7c0 3.253-2.616 6.55-8 9.834C4.617 13.549 2 10.254 2 7c0-4.459 5.323-5.49 7.089-1.588a1 1 0 001.822 0z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/heart-solid.svg
function heart_solid_extends() { heart_solid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_solid_extends.apply(this, arguments); }

/* harmony default export */ const heart_solid = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", heart_solid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 18"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#242424",
    d: "M10.39 17.87a.696.696 0 01-.78 0C7.764 16.637 0 11.15 0 5.973c0-6.68 7.85-7.75 10-3.25 2.15-4.5 10-3.43 10 3.25 0 5.178-7.764 10.664-9.61 11.895v.002z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/help-solid.svg
function help_solid_extends() { help_solid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return help_solid_extends.apply(this, arguments); }

/* harmony default export */ const help_solid = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", help_solid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 11.237c0 5.379-4.7 9.738-10.5 9.738-1.002.001-2-.131-2.967-.394-2.079 1.376-4.678 1.792-6.062 1.918-.316.03-.48-.385-.265-.62.657-.72 1.581-1.998 1.895-3.732-1.915-1.765-3.101-4.209-3.101-6.91C1.5 5.859 6.2 1.5 12 1.5s10.5 4.36 10.5 9.737zM10.142 8.052c-.306.454-.392 1.057-.392 1.583a.75.75 0 01-1.5 0c0-.633.093-1.597.647-2.42.591-.879 1.614-1.465 3.185-1.465 1.601 0 2.69.69 3.247 1.691.53.95.528 2.094.17 2.953-.208.5-.574.863-.92 1.139a11.09 11.09 0 01-.777.546l-.26.173c-.672.46-.945.77-.945 1.215a.75.75 0 01-1.5 0c0-1.29.931-1.997 1.6-2.454.121-.082.233-.156.339-.226.225-.149.421-.278.609-.428.26-.207.402-.38.47-.542a1.977 1.977 0 00-.097-1.646c-.261-.47-.812-.921-1.936-.921-1.154 0-1.671.402-1.94.802zm1.604 7.448a.73.73 0 00-.746.746.738.738 0 00.746.754.74.74 0 00.754-.754.731.731 0 00-.754-.746z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/help.svg
function help_extends() { help_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return help_extends.apply(this, arguments); }

/* harmony default export */ const help = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", help_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M7.917 9.035c0-1.552.508-4.202 4.377-4.202 3.87 0 4.653 3.058 3.87 4.834-.784 1.776-4.205 2.18-4.205 4.506"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.503 17.947c0-.85.646-1.462 1.461-1.462.832 0 1.477.612 1.477 1.462 0 .848-.646 1.477-1.477 1.477a1.443 1.443 0 01-1.461-1.477z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/hide-left.svg
function hide_left_extends() { hide_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hide_left_extends.apply(this, arguments); }

/* harmony default export */ const hide_left = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", hide_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.53 4.53a.75.75 0 00-1.06-1.06l-4 4-.53.53.53.53 4 4a.75.75 0 001.06-1.06L6.81 8.75H15a.75.75 0 000-1.5H6.81l2.72-2.72zM.25 4a.75.75 0 011.5 0v8a.75.75 0 01-1.5 0V4z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/info-solid.svg
function info_solid_extends() { info_solid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return info_solid_extends.apply(this, arguments); }

/* harmony default export */ const info_solid = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", info_solid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.696-3.534c.63 0 1.332-.288 2.196-1.458l.911-1.22a.335.335 0 00-.074-.472.38.38 0 00-.505.06l-1.475 1.679a.24.24 0 01-.279.061.21.21 0 01-.12-.244l1.858-7.446a.5.5 0 00-.575-.613l-3.35.613a.35.35 0 00-.276.258l-.086.334a.25.25 0 00.243.312h1.73l-1.476 5.922c-.054.234-.144.63-.144.918 0 .666.396 1.296 1.422 1.296zm1.83-10.536c.702 0 1.242-.414 1.386-1.044.036-.144.054-.306.054-.414 0-.504-.396-.972-1.134-.972-.702 0-1.242.414-1.386 1.044a1.87 1.87 0 00-.054.414c0 .504.396.972 1.134.972z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/info.svg
function info_extends() { info_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return info_extends.apply(this, arguments); }

/* harmony default export */ const info = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", info_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M8 16A8 8 0 118 0a8 8 0 010 16zm0-2A6 6 0 108 1.999 6 6 0 008 14z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.588 4.592c0 .405.319.748.883.748.552 0 .957-.306 1.08-.797.024-.098.037-.209.037-.295 0-.404-.32-.748-.884-.748-.54 0-.957.307-1.08.797a1.288 1.288 0 00-.036.295zM6.224 11.53c0 .466.27.969 1.092.969.467 0 1.006-.196 1.595-1.055l.56-.812a.258.258 0 00-.411-.31l-.934 1.143a.151.151 0 01-.265-.131l1.118-4.65a.5.5 0 00-.573-.61l-2.082.368a.35.35 0 00-.28.265l-.037.155a.25.25 0 00.244.307h.943l-.86 3.698c-.048.172-.11.466-.11.663z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/lamp.svg
function lamp_extends() { lamp_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lamp_extends.apply(this, arguments); }

/* harmony default export */ const lamp = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", lamp_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M21.333 19.933c-.913.913-1.2 3.109-1.291 4.402-.039.55-.49.998-1.042.998h-5.966c-.565 0-1.022-.467-1.048-1.032-.06-1.284-.305-3.42-1.252-4.368C5.467 14.667 5.755 9.045 9.4 5.4a9.333 9.333 0 0113.2 0c3.645 3.645 4 9.267-1.267 14.533z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M14.668 28h2.667"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/lightning.svg
function lightning_extends() { lightning_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lightning_extends.apply(this, arguments); }

/* harmony default export */ const lightning = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", lightning_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M3.584 9.388H7.44l-1.993 5.196c-.318.818.53 1.254 1.079.597L12.8 7.663a.754.754 0 00.2-.496c0-.329-.254-.561-.584-.561H8.56l1.993-5.19c.313-.818-.53-1.254-1.079-.597l-6.28 7.518A.725.725 0 003 8.833c0 .329.248.555.584.555z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/line.svg
function line_extends() { line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return line_extends.apply(this, arguments); }

/* harmony default export */ const line = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M3 12l9.192-9.192"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/loader.svg
function loader_extends() { loader_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loader_extends.apply(this, arguments); }

/* harmony default export */ const loader = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", loader_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M15 8a7 7 0 11-7-7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/loading.svg
function loading_extends() { loading_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loading_extends.apply(this, arguments); }

/* harmony default export */ const loading = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", loading_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("g", {
    stroke: "#BDBCC5"
  }, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M3 8a5 5 0 005 5m5-5a5 5 0 00-5-5"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    strokeWidth: "1.5",
    d: "M14.3 8.25L13 10.5l-1.299-2.25H14.3zm-12.599-.5l1.3-2.25 1.298 2.25H1.701z"
  })));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/lock-filled.svg
function lock_filled_extends() { lock_filled_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_filled_extends.apply(this, arguments); }

/* harmony default export */ const lock_filled = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", lock_filled_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.667 10.2V9S18.584 3 12 3 5.333 9 5.333 9v1.2H4v8.4S4 21 6.667 21h10.666S20 21.076 20 18.6v-8.4h-1.333zM16 10.2H8V9s0-3.6 4-3.6S16 9 16 9v1.2z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/lock.svg
function lock_extends() { lock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lock_extends.apply(this, arguments); }

/* harmony default export */ const lock = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", lock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a5 5 0 015 5v2.001c.961.014 1.34.129 1.721.333.407.218.727.537.945.945.218.407.334.812.334 1.926v4.59c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 01-.945.945c-.407.218-.811.334-1.926.334h-9.59c-1.115 0-1.519-.116-1.926-.334a2.272 2.272 0 01-.945-.945C4.116 19.314 4 18.91 4 17.795v-4.59c0-1.114.116-1.519.334-1.926.218-.408.538-.727.945-.945.381-.204.76-.319 1.721-.333V8a5 5 0 015-5zm-5.644 9.049c.155-.03.422-.049.849-.049h9.59c.427 0 .694.019.849.049.06.012.074.017.134.049.054.026.098.07.125.124.031.06.036.073.048.134.03.155.049.422.049.849v4.59c0 .427-.019.694-.049.849a.352.352 0 01-.049.134.275.275 0 01-.124.125.352.352 0 01-.134.048c-.155.03-.422.049-.849.049h-9.59c-.427 0-.694-.019-.849-.049a.352.352 0 01-.134-.049.275.275 0 01-.124-.124.353.353 0 01-.049-.134c-.03-.155-.049-.422-.049-.849v-4.59c0-.427.019-.694.049-.849a.353.353 0 01.049-.134.275.275 0 01.124-.124.352.352 0 01.134-.049zM15 8v2H9V8a3 3 0 116 0z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/magic.svg
function magic_extends() { magic_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return magic_extends.apply(this, arguments); }

/* harmony default export */ const magic = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", magic_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8.648 15.233a4 4 0 00-2.538-2.538L2.869 11.62c-.914-.303-.914-1.596 0-1.899l3.24-1.074A4 4 0 008.65 6.11l1.073-3.241c.303-.914 1.596-.914 1.899 0l1.074 3.24a4 4 0 002.538 2.54l3.241 1.073c.914.303.914 1.596 0 1.899l-3.24 1.074a4 4 0 00-2.54 2.538l-1.073 3.241c-.303.914-1.596.914-1.899 0l-1.074-3.24zm14.037 3.943a2.667 2.667 0 00-1.874-1.874l-2.448-.665c-.656-.178-.656-1.109 0-1.287l2.448-.665a2.667 2.667 0 001.874-1.874l.665-2.448c.178-.656 1.109-.656 1.287 0l.665 2.448a2.667 2.667 0 001.874 1.874l2.448.665c.656.178.656 1.109 0 1.287l-2.448.665a2.667 2.667 0 00-1.874 1.874l-.665 2.448c-.178.656-1.109.656-1.287 0l-.665-2.448zm-8.845 6.049c.457.124.814.48.938.937l.58 2.137c.178.656 1.108.656 1.287 0l.58-2.137c.124-.456.48-.813.937-.937l2.137-.58c.656-.178.656-1.109 0-1.287l-2.137-.58a1.333 1.333 0 01-.937-.938l-.58-2.136c-.178-.656-1.109-.656-1.287 0l-.58 2.136a1.334 1.334 0 01-.938.938l-2.136.58c-.656.178-.656 1.108 0 1.287l2.136.58z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/mail.svg
function mail_extends() { mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }

/* harmony default export */ const mail = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", mail_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.272 6.365C2 6.9 2 7.6 2 9v6c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092C3.9 19 4.6 19 6 19h12c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.092-1.092C22 17.1 22 16.4 22 15V9c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.093C20.1 5 19.4 5 18 5H6c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093zM4.647 7h14.706a.5.5 0 01.278.916l-7.075 4.732a1 1 0 01-1.112 0L4.369 7.916A.5.5 0 014.647 7z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/menu-dots.svg
function menu_dots_extends() { menu_dots_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_dots_extends.apply(this, arguments); }

/* harmony default export */ const menu_dots = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", menu_dots_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "12",
    cy: "6",
    r: "2",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "12",
    cy: "18",
    r: "2",
    fill: "currentColor"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/mic-off.svg
function mic_off_extends() { mic_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mic_off_extends.apply(this, arguments); }

/* harmony default export */ const mic_off = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", mic_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 12c0 .825-.143 1.617-.405 2.352l-1.645-1.644c.033-.232.05-.468.05-.708a1 1 0 012 0zm-2.808 5.606l3.1 3.1a1 1 0 101.415-1.413l-16-16a1 1 0 00-1.414 1.414L9 10.414V12a3 3 0 004.293 2.708l1.464 1.464A4.999 4.999 0 017 12a1 1 0 00-2 0 7 7 0 006 6.93V21a1 1 0 002 0v-2.07a6.964 6.964 0 003.192-1.324zM15 5v5.757l-5.991-5.99a3 3 0 015.99.233z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/mic-on.svg
function mic_on_extends() { mic_on_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mic_on_extends.apply(this, arguments); }

/* harmony default export */ const mic_on = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", mic_on_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3zM5 12a1 1 0 112 0 5 5 0 1010 0 1 1 0 012 0 7.001 7.001 0 01-6 6.93V21a1 1 0 01-2 0v-2.07A7.001 7.001 0 015 12z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/minus.svg
function minus_extends() { minus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_extends.apply(this, arguments); }

/* harmony default export */ const minus = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", minus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M2 8h12"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/new-arrow-right.svg
function new_arrow_right_extends() { new_arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return new_arrow_right_extends.apply(this, arguments); }

/* harmony default export */ const new_arrow_right = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", new_arrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M5 12h14m0 0l-7-7m7 7l-7 7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/new-card.svg
function new_card_extends() { new_card_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return new_card_extends.apply(this, arguments); }

/* harmony default export */ const new_card = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", new_card_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.833 9a4 4 0 00-4-4h-20a4 4 0 00-4 4v2.058h28V9zm-26 1.058h24V9a2 2 0 00-2-2h-20a2 2 0 00-2 2v1.058zm-2 1V22a4 4 0 004 4h20a4 4 0 004-4V11.058h-28zm2 1h24V22a2 2 0 01-2 2h-20a2 2 0 01-2-2v-9.942z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "6",
    height: "2",
    x: "20.833",
    y: "20",
    fill: "currentColor",
    rx: "1"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/not-connected.svg
function not_connected_extends() { not_connected_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return not_connected_extends.apply(this, arguments); }

/* harmony default export */ const not_connected = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", not_connected_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M22.22 4.592l.924.154a5 5 0 014.11 4.11l.154.924a7 7 0 01-1.955 6.1l-1.1 1.1a.5.5 0 01-.707 0L15.02 8.354a.5.5 0 010-.707l1.1-1.1a7 7 0 016.1-1.955zM9.78 27.408l-.924-.154a5 5 0 01-4.11-4.11l-.154-.924a7 7 0 011.955-6.1l1.1-1.1a.5.5 0 01.707 0l8.626 8.626a.5.5 0 010 .707l-1.1 1.1a7 7 0 01-6.1 1.955z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "3",
    d: "M25.333 6.667L28 4M4 28l2.667-2.667"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.589 18.59a.5.5 0 010 .707l-2.98 2.98-1.886-1.886 2.98-2.98a.5.5 0 01.707 0l1.179 1.178zm-4-4a.5.5 0 010 .707l-2.98 2.98-1.886-1.886 2.98-2.98a.5.5 0 01.707 0l1.179 1.178z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/note-outline-draft.svg
function note_outline_draft_extends() { note_outline_draft_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return note_outline_draft_extends.apply(this, arguments); }

/* harmony default export */ const note_outline_draft = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", note_outline_draft_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.89 14h-3.685c-.427 0-.694.019-.85.049a.353.353 0 00-.133.049.274.274 0 00-.125.124.35.35 0 00-.048.134c-.03.155-.05.422-.05.849v3.684c.136-.047.266-.109.39-.184.154-.095.312-.235 1.071-.994l2.251-2.25c.76-.76.9-.918.994-1.073.075-.122.138-.252.185-.388zM12 19H7c-.733 0-1.163-.002-1.48-.027a1.74 1.74 0 01-.264-.037.5.5 0 01-.192-.192 1.728 1.728 0 01-.037-.265C5.002 18.163 5 17.733 5 17V7c0-.733.002-1.163.027-1.48.013-.16.03-.237.037-.264a.5.5 0 01.192-.192c.027-.007.105-.024.265-.037C5.837 5.002 6.267 5 7 5h10c.733 0 1.163.002 1.48.027.16.013.237.03.264.037a.5.5 0 01.192.192c.007.027.023.105.037.265.025.316.027.746.027 1.479v5h-3.795c-1.114 0-1.519.116-1.926.334a2.272 2.272 0 00-.945.945c-.218.407-.334.812-.334 1.926V19zm5-16c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093C21 4.9 21 5.6 21 7v5.349c0 .978 0 1.468-.11 1.928-.099.408-.26.798-.48 1.156-.247.404-.593.75-1.285 1.442l-2.25 2.25c-.692.692-1.038 1.038-1.442 1.286a4.04 4.04 0 01-1.156.479c-.46.11-.95.11-1.928.11H7c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 01-1.093-1.092C3 19.1 3 18.4 3 17V7c0-1.4 0-2.1.272-2.635a2.5 2.5 0 011.093-1.093C4.9 3 5.6 3 7 3h10z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 8a1 1 0 011-1h8a1 1 0 110 2H8a1 1 0 01-1-1z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/notes-thin.svg
function notes_thin_extends() { notes_thin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notes_thin_extends.apply(this, arguments); }

/* harmony default export */ const notes_thin = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", notes_thin_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.556 11h-3.685c-.427 0-.694.019-.85.049a.353.353 0 00-.133.049.274.274 0 00-.125.124.352.352 0 00-.048.134c-.03.155-.05.422-.05.849v3.684c.136-.047.266-.109.39-.184.154-.095.312-.235 1.071-.994l2.251-2.25c.76-.76.9-.918.994-1.073.075-.122.138-.252.185-.388zm-6.89 5h-5c-.733 0-1.163-.002-1.48-.027a1.74 1.74 0 01-.264-.037.5.5 0 01-.192-.192 1.728 1.728 0 01-.037-.265c-.025-.316-.027-.746-.027-1.479V4c0-.733.002-1.163.027-1.48.013-.16.03-.237.037-.264a.5.5 0 01.192-.192c.027-.007.105-.024.265-.037C3.503 2.002 3.933 2 4.666 2h10c.733 0 1.163.002 1.48.027.16.013.237.03.264.037a.5.5 0 01.192.192c.007.027.023.105.037.265.025.316.027.746.027 1.479v5h-3.795c-1.114 0-1.519.116-1.926.334a2.272 2.272 0 00-.945.945c-.218.407-.334.812-.334 1.926V16zm5-16c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093c.273.535.273 1.235.273 2.635v5.349c0 .978 0 1.468-.11 1.928-.099.408-.26.798-.48 1.156-.247.404-.593.75-1.285 1.442l-2.25 2.25c-.692.692-1.038 1.038-1.442 1.286a4.04 4.04 0 01-1.156.479c-.46.11-.95.11-1.928.11H4.666c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 01-1.093-1.092C.666 16.1.666 15.4.666 14V4c0-1.4 0-2.1.272-2.635A2.5 2.5 0 012.031.272C2.566 0 3.266 0 4.666 0h10z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.666 5a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/notes.svg
function notes_extends() { notes_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notes_extends.apply(this, arguments); }

/* harmony default export */ const notes = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", notes_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M9 7a1 1 0 01-1-1V3H4v10h8V7H9zm4.707-1.293a1 1 0 01.293.707V13a2 2 0 01-2 2H4a2 2 0 01-2-2V3a2 2 0 012-2h4.172a2 2 0 011.414.586l4.121 4.121z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/notification-bell-unread.svg
function notification_bell_unread_extends() { notification_bell_unread_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notification_bell_unread_extends.apply(this, arguments); }

/* harmony default export */ const notification_bell_unread = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", notification_bell_unread_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.66.582a.563.563 0 01.371-.077l.573.08a.563.563 0 01.484.526l.032.544a1.127 1.127 0 00.45.838l.206.153a4.195 4.195 0 011.942 3.663l-.106 3.672a2.536 2.536 0 00.714 1.839l.234.242a1.126 1.126 0 01.235 1.206l-.015.038a.99.99 0 01-1.056.61l-2.074-.292a2.253 2.253 0 01-4.46-.627l-3.83-.538a.991.991 0 01-.85-.878l-.004-.04a1.127 1.127 0 01.56-1.095l.292-.168a2.534 2.534 0 001.192-1.57l.91-3.56a4.195 4.195 0 012.876-2.985l.24-.091a1.127 1.127 0 00.665-.681l.18-.515a.563.563 0 01.24-.294zm2.45 9.357c-.024.83.079 1.6 1.027 2.377l-8.775-1.233c1.13-.486 1.438-1.198 1.643-2.003l.91-3.56a2.693 2.693 0 015.301.745l-.105 3.674z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M9.031.505l-.014.1.014-.1zm-.37.077L8.607.497l.052.085zm.943.003l.014-.099-.014.1zm.336.176l.074-.067L9.94.76zm.148.35l-.1.005.1-.005zm.032.544l.1-.006-.1.006zm.133.47l.088-.048-.088.047zm.318.368l-.06.08.06-.08zm.205.153l-.06.08.007.005.053-.085zm1.455 1.575l.089-.047-.089.047zm.487 2.088l-.1-.003.1.003zm-.106 3.672l.1.003-.1-.003zm.714 1.839l.072-.07-.072.07zm.234.242l.072-.07-.072.07zm.297.568l.098-.02-.098.02zm-.062.638l-.093-.037.093.037zm-.015.038l.093.037-.093-.037zm-1.056.61l-.014.098.013-.098zm-2.074-.292l.014-.099-.096-.014-.017.096.099.017zm-.382.922l-.082-.058.082.058zm-.804.7l-.046-.09.046.09zm-2.07 0l.046-.09-.046.09zm-.803-.7l.081-.058-.081.058zm-.393-.99l.1-.014-.1.014zm-.008-.559l.1.011.01-.096-.096-.014-.014.1zm-3.83-.538l.013-.1-.014.1zm-.576-.293l.072-.07-.072.07zm-.273-.585l.1-.01v-.001l-.1.01zm-.005-.04l-.1.01v.001l.1-.01zm.117-.63l-.089-.046.09.046zm.443-.465l.05.087-.05-.087zm.292-.168l-.05-.087.05.087zm.755-.664l.08.06-.08-.06zm.437-.905l.097.024-.097-.024zm.91-3.561l.097.024-.097-.024zm1.044-1.873l.072.07-.072-.07zm1.832-1.112l.029.096.007-.003-.036-.093zm.24-.091l.036.093-.035-.093zm.408-.267l-.071-.07.071.07zm.257-.414l.095.033-.095-.033zm.18-.515L8.327.843l.094.033zm3.716 11.44l-.014.1.353.049-.276-.226-.063.077zM11.11 9.939l.1.003-.1-.003zm-7.748 1.144l-.039-.092-.328.141.354.05.013-.099zM5.005 9.08l.097.025-.097-.025zm.91-3.56l.098.024-.097-.025zm1.11-1.571l.056.083-.056-.083zm1.875-.43l.014-.1-.014.1zm2.316 2.746l-.1-.003.1.003zM9.046.406a.663.663 0 00-.438.09l.104.171a.463.463 0 01.305-.062l.028-.199zm.572.08l-.573-.08-.028.199.573.08.028-.199zm.396.208a.663.663 0 00-.396-.208L9.59.684a.463.463 0 01.276.145l.148-.135zm.174.411a.663.663 0 00-.175-.411l-.147.135a.46.46 0 01.122.287l.2-.011zm.032.544l-.032-.544-.2.012.032.544.2-.012zm.12.428a1.027 1.027 0 01-.12-.428l-.2.012c.01.179.06.353.144.51l.177-.094zm.29.336a1.026 1.026 0 01-.29-.336l-.176.094c.085.158.203.295.347.402l.12-.16zm.206.153l-.206-.153-.12.16.207.154.12-.16zm1.484 1.608a4.294 4.294 0 00-1.49-1.612l-.107.169c.598.38 1.088.91 1.42 1.537l.177-.094zm.498 2.138a4.294 4.294 0 00-.498-2.138l-.177.094c.332.626.496 1.329.475 2.038l.2.006zm-.106 3.672l.106-3.672-.2-.006-.106 3.673.2.005zm.164.953a2.432 2.432 0 01-.164-.953l-.2-.005c-.01.351.05.702.177 1.03l.187-.072zm.522.813a2.434 2.434 0 01-.522-.813l-.187.072c.128.328.32.628.565.88l.144-.139zm.234.242l-.234-.242-.144.14.234.241.144-.14zm.323.619a1.227 1.227 0 00-.323-.62l-.144.14c.139.143.232.323.27.518l.197-.038zm-.067.695c.089-.22.112-.462.067-.695l-.196.038c.038.195.018.397-.057.582l.186.075zm-.015.037l.015-.038-.186-.074-.015.038.186.074zm-1.163.671a1.09 1.09 0 001.163-.67l-.186-.076a.89.89 0 01-.95.548l-.027.198zm-2.074-.29l2.074.29.027-.197-2.073-.292-.028.198zm-.286.88c.203-.288.34-.617.398-.963l-.197-.034a2.153 2.153 0 01-.365.881l.164.116zm-.84.73c.334-.173.622-.423.84-.73l-.164-.116c-.199.281-.462.51-.768.668l.092.178zm-1.08.263c.375 0 .746-.09 1.08-.263l-.092-.178a2.15 2.15 0 01-.989.241v.2zm-1.082-.263a2.35 2.35 0 001.081.263v-.2c-.344 0-.683-.083-.989-.24l-.092.177zm-.839-.73c.217.307.505.557.84.73l.091-.178a2.153 2.153 0 01-.768-.668l-.163.116zm-.41-1.035c.052.373.193.728.41 1.035l.163-.116a2.152 2.152 0 01-.375-.946l-.198.027zm-.008-.583c-.022.194-.019.39.008.583l.198-.027a2.153 2.153 0 01-.007-.534l-.2-.022zm-3.746-.428l3.831.538.028-.198-3.83-.538-.029.198zm-.633-.323c.17.176.392.289.633.323l.028-.198a.891.891 0 01-.517-.264l-.144.14zm-.3-.644c.025.243.13.47.3.644l.144-.139a.891.891 0 01-.246-.526l-.199.021zm-.005-.039l.004.04.2-.022-.005-.04-.2.022zm.127-.687c-.108.212-.152.45-.127.687l.199-.021a1.03 1.03 0 01.106-.575l-.178-.09zm.482-.505a1.227 1.227 0 00-.482.505l.178.091c.09-.177.23-.324.403-.423l-.1-.173zm.292-.169l-.292.169.1.173.292-.168-.1-.174zm.725-.638a2.434 2.434 0 01-.725.638l.1.174c.305-.176.572-.41.784-.69l-.159-.122zm.42-.87c-.08.316-.223.612-.42.87l.16.121c.212-.28.367-.6.454-.94l-.194-.05zm.91-3.56l-.91 3.56.194.05.91-3.56-.194-.05zm1.069-1.917a4.295 4.295 0 00-1.069 1.917l.194.05a4.095 4.095 0 011.019-1.828l-.144-.14zm1.876-1.14a4.307 4.307 0 00-1.876 1.14l.144.139a4.095 4.095 0 011.789-1.086l-.057-.192zm.233-.088l-.24.091.07.187.241-.09-.07-.188zm.372-.243c-.105.107-.232.19-.372.243l.071.187c.167-.063.319-.162.444-.29l-.143-.14zm.234-.377c-.05.141-.13.27-.234.377l.143.14c.125-.128.22-.282.28-.451l-.19-.066zm.18-.515l-.18.515.189.066.18-.514-.189-.067zm.281-.346a.663.663 0 00-.28.346l.188.067a.463.463 0 01.196-.243l-.104-.17zM12.2 12.239c-.462-.38-.713-.752-.847-1.126-.135-.375-.155-.76-.143-1.171l-.2-.006c-.012.42.007.834.155 1.245.148.413.423.814.909 1.212l.127-.154zm-8.85-1.057l8.774 1.233.028-.198-8.775-1.233-.027.198zm1.56-2.126c-.102.398-.227.763-.46 1.087-.232.322-.576.611-1.126.848l.079.184c.579-.25.954-.56 1.21-.915.254-.355.387-.749.49-1.155l-.193-.05zm.91-3.561l-.91 3.56.193.05.91-3.56-.193-.05zm1.15-1.63c-.57.383-.98.964-1.15 1.63l.194.05A2.593 2.593 0 017.08 4.031l-.111-.166zm1.945-.445a2.793 2.793 0 00-1.944.446l.111.166a2.593 2.593 0 011.805-.414l.028-.198zm1.745.965a2.793 2.793 0 00-1.745-.965l-.028.198c.632.089 1.21.408 1.62.896l.153-.13zm.657 1.883a2.793 2.793 0 00-.657-1.883l-.152.129a2.6 2.6 0 01.61 1.748l.2.006zm-.106 3.673l.106-3.673-.2-.006-.105 3.674.2.005z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#FF8643",
    d: "M12 8a4 4 0 100-8 4 4 0 000 8z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/notification-bell.svg
function notification_bell_extends() { notification_bell_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notification_bell_extends.apply(this, arguments); }

/* harmony default export */ const notification_bell = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", notification_bell_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("mask", {
    id: "a",
    width: "14",
    height: "17",
    x: ".5",
    y: "-.5",
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M.5-.5h14v17H.5z"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8.66.582a.563.563 0 01.371-.077l.573.08a.563.563 0 01.484.526l.032.544a1.127 1.127 0 00.45.838l.206.153a4.195 4.195 0 011.942 3.663l-.106 3.672a2.536 2.536 0 00.714 1.839l.234.242a1.126 1.126 0 01.235 1.206l-.015.038a.99.99 0 01-1.056.61l-2.074-.292a2.253 2.253 0 01-4.46-.627l-3.83-.538a.991.991 0 01-.85-.878l-.004-.04a1.127 1.127 0 01.56-1.095l.292-.168a2.534 2.534 0 001.192-1.57l.91-3.56a4.195 4.195 0 012.876-2.985l.24-.091a1.127 1.127 0 00.665-.681l.18-.515a.563.563 0 01.24-.294zm2.45 9.357c-.024.83.079 1.6 1.027 2.377l-8.775-1.233c1.13-.486 1.438-1.198 1.643-2.003l.91-3.56a2.693 2.693 0 015.301.745l-.105 3.674z",
    clipRule: "evenodd"
  })), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.66.582a.563.563 0 01.371-.077l.573.08a.563.563 0 01.484.526l.032.544a1.127 1.127 0 00.45.838l.206.153a4.195 4.195 0 011.942 3.663l-.106 3.672a2.536 2.536 0 00.714 1.839l.234.242a1.126 1.126 0 01.235 1.206l-.015.038a.99.99 0 01-1.056.61l-2.074-.292a2.253 2.253 0 01-4.46-.627l-3.83-.538a.991.991 0 01-.85-.878l-.004-.04a1.127 1.127 0 01.56-1.095l.292-.168a2.534 2.534 0 001.192-1.57l.91-3.56a4.195 4.195 0 012.876-2.985l.24-.091a1.127 1.127 0 00.665-.681l.18-.515a.563.563 0 01.24-.294zm2.45 9.357c-.024.83.079 1.6 1.027 2.377l-8.775-1.233c1.13-.486 1.438-1.198 1.643-2.003l.91-3.56a2.693 2.693 0 015.301.745l-.105 3.674z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M9.031.505l-.014.1.014-.1zm-.37.077l.051.085L8.66.582zm.943.003l.014-.099-.014.1zm.336.176l.074-.067L9.94.76zm.148.35l-.1.005.1-.005zm.032.544l.1-.006-.1.006zm.133.47l.088-.048-.088.047zm.318.368l-.06.08.06-.08zm.205.153l-.06.08.007.005.053-.085zm1.455 1.575l.089-.047-.089.047zm.487 2.088l-.1-.003.1.003zm-.106 3.672l.1.003-.1-.003zm.17.992l-.093.036.094-.036zm.544.847l.072-.07-.072.07zm.234.242l-.072.07.072-.07zm.297.568l.098-.02-.098.02zm-.062.638l-.093-.037.093.037zm-.015.038l.093.037-.093-.037zm-1.056.61l-.014.098.013-.098zm-2.074-.292l.014-.099-.096-.014-.017.096.099.017zm-.382.922l-.082-.058.082.058zm-.804.7l-.046-.09.046.09zm-2.07 0l.046-.09-.046.09zm-.803-.7l.081-.058-.081.058zm-.393-.99l.1-.014-.1.014zm-.008-.559l.1.011.01-.096-.096-.014-.014.1zm-3.83-.538l.013-.1-.014.1zm-.576-.293l-.072.07.072-.07zm-.273-.585l.1-.01v-.001l-.1.01zm-.005-.04l-.1.01v.001l.1-.01zm.117-.63l.09.045-.09-.045zm.443-.465l.05.087-.05-.087zm.292-.168l-.05-.087.05.087zm.755-.664l-.08-.06.08.06zm.437-.905l.097.024-.097-.024zm.91-3.561l.097.024-.097-.024zm1.044-1.873l.072.07-.072-.07zm1.832-1.112l.029.096.007-.003-.036-.093zm.24-.091l.036.093-.035-.093zm.408-.267l-.071-.07.071.07zm.257-.414l.095.033-.095-.033zm.18-.515L8.327.843l.094.033zm3.716 11.44l-.014.1.353.049-.276-.226-.063.077zM11.11 9.939l.1.003-.1-.003zm-7.748 1.144l-.039-.092-.328.141.354.05.013-.099zM5.005 9.08l.097.025-.097-.025zm.91-3.56l.098.024-.097-.025zm1.11-1.571l.056.083-.056-.083zm1.875-.43l.014-.1-.014.1zm1.683.93l.076-.064-.076.064zm.633 1.816l-.1-.003.1.003zM9.046.406a.663.663 0 00-.438.09l.104.171a.463.463 0 01.305-.062l.028-.199zm.572.08l-.573-.08-.028.199.573.08.028-.199zm.396.208a.663.663 0 00-.396-.208L9.59.684a.463.463 0 01.276.145l.148-.135zm.174.411a.663.663 0 00-.175-.411l-.147.135a.46.46 0 01.122.287l.2-.011zm.032.544l-.032-.544-.2.012.032.544.2-.012zm.12.428a1.027 1.027 0 01-.12-.428l-.2.012c.01.179.06.353.144.51l.177-.094zm.29.336a1.026 1.026 0 01-.29-.336l-.176.094c.085.158.203.295.347.402l.12-.16zm.206.153l-.206-.153-.12.16.207.154.12-.16zm1.484 1.608a4.294 4.294 0 00-1.49-1.612l-.107.169c.598.38 1.088.91 1.42 1.537l.177-.094zm.498 2.138a4.294 4.294 0 00-.498-2.138l-.177.094c.332.626.496 1.329.475 2.038l.2.006zm-.106 3.672l.106-3.672-.2-.006-.106 3.673.2.005zm.164.953a2.432 2.432 0 01-.164-.953l-.2-.005c-.01.351.05.702.177 1.03l.187-.072zm.522.813a2.434 2.434 0 01-.522-.813l-.187.072c.128.328.32.628.565.88l.144-.139zm.234.242l-.234-.242-.144.14.234.241.144-.14zm.323.619a1.227 1.227 0 00-.323-.62l-.144.14c.139.143.232.323.27.518l.197-.038zm-.067.695c.089-.22.112-.462.067-.695l-.196.038c.038.195.018.397-.057.582l.186.075zm-.015.037l.015-.038-.186-.074-.015.038.186.074zm-1.163.671a1.09 1.09 0 001.163-.67l-.186-.076a.89.89 0 01-.95.548l-.027.198zm-2.074-.29l2.074.29.027-.197-2.073-.292-.028.198zm-.286.88c.203-.288.34-.617.398-.963l-.197-.034a2.153 2.153 0 01-.365.881l.164.116zm-.84.73c.334-.173.622-.423.84-.73l-.164-.116c-.199.281-.462.51-.768.668l.092.178zm-1.08.263c.375 0 .746-.09 1.08-.263l-.092-.178a2.15 2.15 0 01-.989.241v.2zm-1.082-.263a2.35 2.35 0 001.081.263v-.2c-.344 0-.683-.083-.989-.24l-.092.177zm-.839-.73c.217.307.505.557.84.73l.091-.178a2.153 2.153 0 01-.768-.668l-.163.116zm-.41-1.035c.052.373.193.728.41 1.035l.163-.116a2.152 2.152 0 01-.375-.946l-.198.027zm-.008-.583c-.022.194-.019.39.008.583l.198-.027a2.153 2.153 0 01-.007-.534l-.2-.022zm-3.746-.428l3.831.538.028-.198-3.83-.538-.029.198zm-.633-.323c.17.176.392.289.633.323l.028-.198a.891.891 0 01-.517-.264l-.144.14zm-.3-.644c.025.243.13.47.3.644l.144-.139a.891.891 0 01-.246-.526l-.199.021zm-.005-.039l.004.04.2-.022-.005-.04-.2.022zm.127-.687c-.108.212-.152.45-.127.687l.199-.021a1.03 1.03 0 01.106-.575l-.178-.09zm.482-.505a1.227 1.227 0 00-.482.505l.178.091c.09-.177.23-.324.403-.423l-.1-.173zm.292-.169l-.292.169.1.173.292-.168-.1-.174zm.725-.638a2.434 2.434 0 01-.725.638l.1.174c.305-.176.572-.41.784-.69l-.159-.122zm.42-.87c-.08.316-.223.612-.42.87l.16.121c.212-.28.367-.6.454-.94l-.194-.05zm.91-3.56l-.91 3.56.194.05.91-3.56-.194-.05zm1.069-1.917a4.295 4.295 0 00-1.069 1.917l.194.05a4.095 4.095 0 011.019-1.828l-.144-.14zm1.876-1.14a4.307 4.307 0 00-1.876 1.14l.144.139a4.095 4.095 0 011.789-1.086l-.057-.192zm.233-.088l-.24.091.07.187.241-.09-.07-.188zm.372-.243c-.105.107-.232.19-.372.243l.071.187c.167-.063.319-.162.444-.29l-.143-.14zm.234-.377c-.05.141-.13.27-.234.377l.143.14c.125-.128.22-.282.28-.451l-.19-.066zm.18-.515l-.18.515.189.066.18-.514-.189-.067zm.281-.346a.663.663 0 00-.28.346l.188.067a.463.463 0 01.196-.243l-.104-.17zM12.2 12.239c-.462-.38-.713-.752-.847-1.126-.135-.375-.155-.76-.143-1.171l-.2-.006c-.012.42.007.834.155 1.245.148.413.423.814.909 1.212l.127-.154zm-8.85-1.057l8.774 1.233.028-.198-8.775-1.233-.027.198zm1.56-2.126c-.102.398-.227.763-.46 1.087-.232.322-.576.611-1.126.848l.079.184c.579-.25.954-.56 1.21-.915.254-.355.387-.749.49-1.155l-.193-.05zm.91-3.561l-.91 3.56.193.05.91-3.56-.193-.05zm1.15-1.63c-.57.383-.98.964-1.15 1.63l.194.05A2.593 2.593 0 017.08 4.031l-.111-.166zm1.945-.445a2.793 2.793 0 00-1.944.446l.111.166a2.593 2.593 0 011.805-.414l.028-.198zm1.745.965a2.793 2.793 0 00-1.745-.965l-.028.198c.632.089 1.21.408 1.62.896l.153-.13zm.657 1.883a2.793 2.793 0 00-.657-1.883l-.152.129a2.6 2.6 0 01.61 1.748l.2.006zm-.106 3.673l.106-3.673-.2-.006-.105 3.674.2.005z",
    mask: "url(#a)"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/numbered-list.svg
function numbered_list_extends() { numbered_list_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return numbered_list_extends.apply(this, arguments); }

/* harmony default export */ const numbered_list = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", numbered_list_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M7 5h6M3 9h12M3 13h8"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 2v5H2.286V3.667L1 4.5V3.25L2.286 2H4z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/palette.svg
function palette_extends() { palette_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return palette_extends.apply(this, arguments); }

/* harmony default export */ const palette = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", palette_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 6.352c0 2.517-2.086 4.558-4.66 4.558H7.51c-.929-.037-1.402 1.634-.162 1.869 1.06.201 1.058.913 1.056 1.215v.029c0 .4-.305 1.087-1.373.977-3.31-.34-4.877-2.556-5.661-4.345-.784-1.79-.262-4.815 1.001-6.561 1.263-1.747 4.051-3.26 6.772-3.08 2.056.137 3.84 1.366 4.463 2.086A4.497 4.497 0 0115 6.352zm-4.172-.569a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM7.751 4.648a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM3.738 9.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/parameters.svg
function parameters_extends() { parameters_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return parameters_extends.apply(this, arguments); }

/* harmony default export */ const parameters = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", parameters_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "20",
    height: "2",
    x: "2",
    y: "7",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "20",
    height: "2",
    x: "2",
    y: "15",
    fill: "currentColor",
    rx: "1"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "3",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "3",
    fill: "currentColor"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/path.svg
function path_extends() { path_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return path_extends.apply(this, arguments); }

/* harmony default export */ const path = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", path_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M10.5 1.01l3.49 1.988h.002L13.99 3 10.5 4.99V1.01zm-3 1.489a.5.5 0 110 1h-3a2 2 0 000 4h7a3 3 0 110 6h-4a.5.5 0 010-1h4a2 2 0 000-4h-7a3 3 0 110-6h3zm-4.5 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/pause.svg
function pause_extends() { pause_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pause_extends.apply(this, arguments); }

/* harmony default export */ const pause = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", pause_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/react.createElement("rect", {
    width: "6",
    height: "24",
    x: "7",
    y: "4",
    rx: "1.5"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "6",
    height: "24",
    x: "19",
    y: "4",
    rx: "1.5"
  })));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/payment.svg
function payment_extends() { payment_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return payment_extends.apply(this, arguments); }

/* harmony default export */ const payment = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", payment_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5h16a2 2 0 012 2v1H2V7a2 2 0 012-2zm-2 5v7a2 2 0 002 2h16a2 2 0 002-2v-7H2z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/pencil.svg
function pencil_extends() { pencil_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pencil_extends.apply(this, arguments); }

/* harmony default export */ const pencil = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", pencil_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M14.717 6.738l.335.202c.41.246.785.544 1.118.887.343.333.641.71.888 1.12l.202.334-.277.277-8.36 8.362a2.518 2.518 0 01-.774.527l-3.361 1.528-1.15.523a1.246 1.246 0 001.457.35l3.442-1.48c.409-.176.78-.427 1.094-.741l11.276-11.28a2 2 0 00.439-2.167c-.183-.452-.484-.89-.91-1.318l-5.42 2.876zm0 0l-.277.277-8.36 8.359a2.5 2.5 0 00-.52.759L3.841 19.28l-.595 1.09m11.47-13.633L3.247 20.372m0 0a1.25 1.25 0 01-.095-1.166l1.478-3.444-1.383 4.61zm12.22-14.384l.42-.42 1.47-1.47-1.89 1.89zm0 0l.484.342m-.484-.342l.484.342m0 0c.309.219.617.482.926.79.309.308.572.618.79.927l.343.484.42-.42 1.47-1.47-3.949-.31zM5.372 14.668a3.501 3.501 0 00-.742 1.093l.742-1.093zm0 0L16.65 3.39M5.372 14.668L16.65 3.39m0 0a2 2 0 011.017-.546m-1.017.546l1.017-.546m0 0a2 2 0 011.15.106m-1.15-.106l1.15.106m0 0c.453.185.892.486 1.318.911l-1.319-.91zM19.9 6.64a1 1 0 00.22-1.083c-.139-.34-.375-.67-.691-.987l-.001-.001c-.318-.316-.646-.552-.986-.69l-.001-.001a1 1 0 00-1.084.22L19.9 6.64z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/play.svg
function play_extends() { play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return play_extends.apply(this, arguments); }

/* harmony default export */ const play = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", play_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M28.6 14.614a1.6 1.6 0 010 2.772L9.4 28.47A1.6 1.6 0 017 27.085V4.915a1.6 1.6 0 012.4-1.386l19.2 11.085z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/playing.svg
function playing_extends() { playing_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return playing_extends.apply(this, arguments); }

/* harmony default export */ const playing = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", playing_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "4",
    x: "8",
    y: "22",
    fill: "currentColor",
    rx: "2"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "10",
    x: "15",
    y: "19",
    fill: "currentColor",
    rx: "2"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "16",
    x: "22",
    y: "16",
    fill: "currentColor",
    rx: "2"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "10",
    x: "29",
    y: "19",
    fill: "currentColor",
    rx: "2"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "4",
    height: "4",
    x: "36",
    y: "22",
    fill: "currentColor",
    rx: "2"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/plus-small.svg
function plus_small_extends() { plus_small_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_small_extends.apply(this, arguments); }

/* harmony default export */ const plus_small = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", plus_small_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 5a1 1 0 10-2 0v6H5a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6V5z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/plus.svg
function plus_extends() { plus_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_extends.apply(this, arguments); }

/* harmony default export */ const plus = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", plus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M2 8h12m-6 6V2"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/redo.svg
function redo_extends() { redo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return redo_extends.apply(this, arguments); }

/* harmony default export */ const redo = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", redo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M6.445 13a4.656 4.656 0 01-2.3-1.51 4.991 4.991 0 01-1.108-2.589 5.077 5.077 0 01.455-2.796 4.804 4.804 0 011.866-2.061 4.516 4.516 0 012.647-.631c.923.068 1.806.42 2.537 1.012L13 6.415m0 0L12.586 3M13 6.415l-3.269.432"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/refresh.svg
function refresh_extends() { refresh_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return refresh_extends.apply(this, arguments); }

/* harmony default export */ const refresh = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", refresh_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.181a.75.75 0 011.177-.616l4.432 3.068a.75.75 0 010 1.234l-4.432 3.068A.75.75 0 0112 8.32V6a7 7 0 107 7 1 1 0 012 0 9 9 0 11-9-9V2.181z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/reset.svg
function reset_extends() { reset_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return reset_extends.apply(this, arguments); }

/* harmony default export */ const svg_reset = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", reset_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M6 13a6 6 0 106-6H8.011m0 0L11 4.011M8.011 7L11 9.989"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/sbp.svg
function sbp_extends() { sbp_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sbp_extends.apply(this, arguments); }

/* harmony default export */ const sbp = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", sbp_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 29"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#874691",
    d: "M7.758 14.497L3.993 16.68.5 22.762l14.25-8.265H7.757z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#DA1844",
    d: "M18.512 8.265l-3.765 2.183-3.493 6.082 14.244-8.265h-6.986z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#F9B229",
    d: "M14.747 6.082L11.254 0v29l3.493-6.082V6.082z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#F07F1A",
    d: "M11.254 0l3.493 6.082 3.765 2.183h6.986L11.254 0z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#72B22C",
    d: "M11.254 12.47V29l3.493-6.082v-4.371l-3.493-6.077z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#00743E",
    d: "M18.512 20.735l-3.765 2.183L11.254 29l14.244-8.265h-6.986z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#5F5A94",
    d: "M.5 6.232v16.53l3.493-6.082v-4.365L.5 6.232z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#0D90CD",
    d: "M11.256 12.47v.005L.5 6.232l3.493 6.083 14.52 8.42H25.5L11.256 12.47z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/search-light.svg
function search_light_extends() { search_light_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_light_extends.apply(this, arguments); }

/* harmony default export */ const search_light = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", search_light_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M2.5 13.5L5 11"
  }), /*#__PURE__*/react.createElement("circle", {
    cx: "8.5",
    cy: "7.5",
    r: "4.5",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/search.svg
function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }

/* harmony default export */ const search = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 17c1.71 0 3.287-.573 4.55-1.537l4.743 4.744a1 1 0 001.414-1.414l-4.744-4.744A7.5 7.5 0 109.5 17zM15 9.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/send.svg
function send_extends() { send_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return send_extends.apply(this, arguments); }

/* harmony default export */ const send = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", send_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M7.77 10.395a1.5 1.5 0 01-1.634.145L1.494 8.064c-.766-.409-.683-1.532.135-1.824L18.809.104a.85.85 0 011.087 1.086L13.76 18.37c-.292.818-1.415.9-1.824.134L9.46 13.862a1.5 1.5 0 01.145-1.632l5.455-6.94c.183-.232-.119-.534-.351-.35l-6.94 5.454.001.001z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/settings.svg
function settings_extends() { settings_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return settings_extends.apply(this, arguments); }

/* harmony default export */ const settings = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", settings_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.052 13.03l3-1.885c.08-.66.252-1.29.502-1.88L3.9 6.135A10.058 10.058 0 016.135 3.9l3.13 1.655a6.953 6.953 0 011.88-.503l1.884-3a9.936 9.936 0 013.053.816l.132 3.542c.52.393.983.856 1.375 1.376l3.543.132c.424.948.705 1.975.816 3.052l-3 1.885c-.08.66-.252 1.29-.503 1.88l1.655 3.13a10.055 10.055 0 01-2.235 2.235l-3.13-1.655c-.59.251-1.22.423-1.88.503l-1.885 3a9.935 9.935 0 01-3.052-.817l-.133-3.541a7.043 7.043 0 01-1.375-1.376l-3.542-.132a9.935 9.935 0 01-.816-3.053zM12 15a3 3 0 100-6 3 3 0 000 6z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/shapes.svg
function shapes_extends() { shapes_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shapes_extends.apply(this, arguments); }

/* harmony default export */ const shapes = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", shapes_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M4 9a4 4 0 004 4v2a6 6 0 115.917-7h-2.043A4.002 4.002 0 004 9z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 11a2 2 0 012-2h8a2 2 0 012 2v7a2 2 0 01-2 2h-8a2 2 0 01-2-2v-7zm2 0h8v7h-8v-7z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/simple-arrow-down.svg
function simple_arrow_down_extends() { simple_arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return simple_arrow_down_extends.apply(this, arguments); }

/* harmony default export */ const simple_arrow_down = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", simple_arrow_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M3 5.5l5 5 5-5"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/simple-arrow-left-bold.svg
function simple_arrow_left_bold_extends() { simple_arrow_left_bold_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return simple_arrow_left_bold_extends.apply(this, arguments); }

/* harmony default export */ const simple_arrow_left_bold = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", simple_arrow_left_bold_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M10 3L5 8l5 5"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/simple-arrow-left.svg
function simple_arrow_left_extends() { simple_arrow_left_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return simple_arrow_left_extends.apply(this, arguments); }

/* harmony default export */ const simple_arrow_left = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", simple_arrow_left_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M14 5l-7 7 7 7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/simple-arrow-right-bold.svg
function simple_arrow_right_bold_extends() { simple_arrow_right_bold_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return simple_arrow_right_bold_extends.apply(this, arguments); }

/* harmony default export */ const simple_arrow_right_bold = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", simple_arrow_right_bold_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M6 3l5 5-5 5"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/simple-arrow-right.svg
function simple_arrow_right_extends() { simple_arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return simple_arrow_right_extends.apply(this, arguments); }

/* harmony default export */ const simple_arrow_right = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", simple_arrow_right_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M10 5l7 7-7 7"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/simple-arrow-up.svg
function simple_arrow_up_extends() { simple_arrow_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return simple_arrow_up_extends.apply(this, arguments); }

/* harmony default export */ const simple_arrow_up = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", simple_arrow_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "16",
    strokeWidth: "2",
    d: "M3 10.5l5-5 5 5"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/skip.svg
function skip_extends() { skip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return skip_extends.apply(this, arguments); }

/* harmony default export */ const skip = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", skip_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M8 16l4 3 4-3m-4 3v-7"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M12 10l-.854.854a.5.5 0 00-.146.353V12h2v-.793a.5.5 0 00-.146-.353L12 10z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M14 9l-4-4m0 4l4-4"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/small-trash.svg
function small_trash_extends() { small_trash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return small_trash_extends.apply(this, arguments); }

/* harmony default export */ const small_trash = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", small_trash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 3.003a3 3 0 013-3h2a3 3 0 013 3h2a1 1 0 110 2h-.654l-.74 9.615a1.5 1.5 0 01-1.495 1.385H4.889a1.5 1.5 0 01-1.496-1.385l-.74-9.615H2a1 1 0 010-2h2zm7.34 2H4.66l.692 9h5.296l.692-9zm-4.34-3a1 1 0 00-1 1h4a1 1 0 00-1-1H7z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/solid-speaking-notes.svg
function solid_speaking_notes_extends() { solid_speaking_notes_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return solid_speaking_notes_extends.apply(this, arguments); }

/* harmony default export */ const solid_speaking_notes = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", solid_speaking_notes_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#242424",
    fillRule: "evenodd",
    d: "M18.89 14h-3.685c-.427 0-.694.019-.85.049a.353.353 0 00-.133.049.274.274 0 00-.125.124.35.35 0 00-.048.134c-.03.155-.05.422-.05.849v3.684c.136-.047.266-.109.39-.184.154-.095.312-.235 1.071-.994l2.251-2.25c.76-.76.9-.918.994-1.073.075-.122.138-.252.185-.388zM17 3c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093C21 4.9 21 5.6 21 7v5.349c0 .978 0 1.468-.11 1.928-.099.408-.26.798-.48 1.156-.247.404-.593.75-1.285 1.442l-2.25 2.25c-.692.692-1.038 1.038-1.442 1.286a4.04 4.04 0 01-1.156.479c-.46.11-.95.11-1.928.11H7c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 01-1.093-1.092C3 19.1 3 18.4 3 17V7c0-1.4 0-2.1.272-2.635a2.5 2.5 0 011.093-1.093C4.9 3 5.6 3 7 3h10z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speaker-off.svg
function speaker_off_extends() { speaker_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speaker_off_extends.apply(this, arguments); }

/* harmony default export */ const speaker_off = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speaker_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M3.625 5.375H2a1 1 0 00-1 1v3.25a1 1 0 001 1h1.625l2.668 2.668c.63.63 1.707.184 1.707-.707V3.414c0-.89-1.077-1.337-1.707-.707L3.625 5.375z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M10.5 9.5l3-3m-3 0l3 3"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speaker.svg
function speaker_extends() { speaker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speaker_extends.apply(this, arguments); }

/* harmony default export */ const speaker = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speaker_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M9.962 4.475a5.25 5.25 0 010 7.425M12.437 2a8.75 8.75 0 010 12.374"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M3.625 5.375H2a1 1 0 00-1 1v3.25a1 1 0 001 1h1.625l2.668 2.668c.63.63 1.707.184 1.707-.707V3.414c0-.89-1.077-1.337-1.707-.707L3.625 5.375z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speaking-notes.svg
function speaking_notes_extends() { speaking_notes_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speaking_notes_extends.apply(this, arguments); }

/* harmony default export */ const speaking_notes = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speaking_notes_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M18.89 14h-3.685c-.427 0-.694.019-.85.049a.353.353 0 00-.133.049.274.274 0 00-.125.124.35.35 0 00-.048.134c-.03.155-.05.422-.05.849v3.684c.136-.047.266-.109.39-.184.154-.095.312-.235 1.071-.994l2.251-2.25c.76-.76.9-.918.994-1.073.075-.122.138-.252.185-.388zM12 19H7c-.733 0-1.163-.002-1.48-.027a1.74 1.74 0 01-.264-.037.5.5 0 01-.192-.192 1.728 1.728 0 01-.037-.265C5.002 18.163 5 17.733 5 17V7c0-.733.002-1.163.027-1.48.013-.16.03-.237.037-.264a.5.5 0 01.192-.192c.027-.007.105-.024.265-.037C5.837 5.002 6.267 5 7 5h10c.733 0 1.163.002 1.48.027.16.013.237.03.264.037a.5.5 0 01.192.192c.007.027.023.105.037.265.025.316.027.746.027 1.479v5h-3.795c-1.114 0-1.519.116-1.926.334a2.272 2.272 0 00-.945.945c-.218.407-.334.812-.334 1.926V19zm-6.756-.067h.003-.003zm-.177-.177v-.003.003zm.177-13.689h.003-.003zm13.51 0h.002-.003.001zm.179.177v.003-.003zM17 3c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093C21 4.9 21 5.6 21 7v5.349c0 .978 0 1.468-.11 1.928-.099.408-.26.798-.48 1.156-.247.404-.593.75-1.285 1.442l-2.25 2.25c-.692.692-1.038 1.038-1.442 1.286a4.04 4.04 0 01-1.156.479c-.46.11-.95.11-1.928.11H7c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 01-1.093-1.092C3 19.1 3 18.4 3 17V7c0-1.4 0-2.1.272-2.635a2.5 2.5 0 011.093-1.093C4.9 3 5.6 3 7 3h10z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speed-05x.svg
function speed_05x_extends() { speed_05x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speed_05x_extends.apply(this, arguments); }

/* harmony default export */ const speed_05x = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speed_05x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M7.864 12.019H6.863v-3.99L5.4 9.093v-.945L6.975 7h.889v5.019zM13.983 17H10.7v-.924c.42-.313.775-.59 1.064-.833.294-.243.53-.464.707-.665.177-.2.306-.39.385-.567a1.34 1.34 0 00.119-.553c0-.233-.07-.415-.21-.546-.135-.135-.327-.203-.574-.203-.247 0-.485.054-.714.161-.224.107-.436.25-.637.427v-.882c.196-.15.408-.268.637-.357a2.31 2.31 0 01.854-.14c.247 0 .474.035.679.105.205.065.38.163.525.294.15.13.264.292.343.483.08.187.119.399.119.637 0 .233-.047.455-.14.665-.089.21-.226.422-.413.637a5.77 5.77 0 01-.7.679c-.285.233-.62.492-1.008.777h2.247V17z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.203 17l5.455-10h1.139L7.342 17H6.203z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16 10l4 4m-4 0l4-4"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speed-075x.svg
function speed_075x_extends() { speed_075x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speed_075x_extends.apply(this, arguments); }

/* harmony default export */ const speed_075x = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speed_075x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.203 17l5.455-10h1.139L7.342 17H6.203z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M16 10l4 4m-4 0l4-4"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M13.231 15.866V17h-.805v-1.134h-2.1v-.588l1.96-3.297h.945v3.227h.61v.658h-.61zm-.805-.658v-2.226l-1.337 2.226h1.337zm-3.691-4.65c0 .233-.044.443-.133.63-.088.182-.214.34-.378.476-.158.13-.352.231-.58.301a2.48 2.48 0 01-.743.105c-.336 0-.62-.04-.854-.119a2.194 2.194 0 01-.574-.294v-.784c.15.126.336.243.56.35.229.107.502.161.82.161.33 0 .583-.075.755-.224.178-.15.266-.355.266-.616 0-.266-.081-.464-.245-.595-.163-.135-.417-.203-.763-.203H6.25v-.707h.651c.238 0 .432-.063.581-.189.154-.13.231-.315.231-.553a.622.622 0 00-.217-.504c-.144-.126-.352-.189-.623-.189-.284 0-.527.051-.728.154a3.26 3.26 0 00-.56.364v-.777a2.43 2.43 0 01.567-.308c.22-.084.49-.126.812-.126.243 0 .462.033.658.098s.362.156.497.273c.136.117.24.257.315.42.075.163.112.343.112.539a1.134 1.134 0 01-.294.77 1.16 1.16 0 01-.308.231 1.34 1.34 0 01-.357.119c.154.019.299.06.434.126.14.06.262.142.364.245.108.098.192.217.252.357.066.14.098.296.098.469z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speed-125x.svg
function speed_125x_extends() { speed_125x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speed_125x_extends.apply(this, arguments); }

/* harmony default export */ const speed_125x = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speed_125x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.203 17l5.455-10h1.139l-5.455 10H9.203z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M19 10l4 4m-4 0l4-4"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M6.03 17H4.763V8.576L2 10.696V9.287L4.97 7h1.06v10zm10.201-1.134V17h-.805v-1.134h-2.1v-.588l1.96-3.297h.945v3.227h.61v.658h-.61zm-.805-.658v-2.226l-1.337 2.226h1.337zM10.888 12h-.84V7.905L8.62 8.969v-.84l1.54-1.148h.728V12z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speed-1x.svg
function speed_1x_extends() { speed_1x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speed_1x_extends.apply(this, arguments); }

/* harmony default export */ const speed_1x = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speed_1x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M13 10l4 4m-4 0l4-4"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M10.03 17H8.763V8.576L6 10.696V9.287L8.97 7h1.06v10z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/speed-2x.svg
function speed_2x_extends() { speed_2x_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return speed_2x_extends.apply(this, arguments); }

/* harmony default export */ const speed_2x = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", speed_2x_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M15 10l4 4m-4 0l4-4"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M12.81 17h-6.4v-1.33a79.862 79.862 0 002.198-1.82 16.011 16.011 0 001.54-1.47c.401-.448.7-.873.896-1.274.196-.41.294-.835.294-1.274 0-.55-.168-.994-.504-1.33-.327-.345-.807-.518-1.442-.518a2.94 2.94 0 00-1.484.392 5.016 5.016 0 00-1.232.994V7.956A4.28 4.28 0 017.88 7.13c.448-.205.966-.308 1.554-.308a4.2 4.2 0 011.386.21c.41.14.751.336 1.022.588.28.252.49.555.63.91.15.355.224.747.224 1.176 0 .541-.107 1.05-.322 1.526a5.61 5.61 0 01-.924 1.428c-.41.476-.92.97-1.526 1.484a60.523 60.523 0 01-2.058 1.652h4.942V17z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/star.svg
function star_extends() { star_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return star_extends.apply(this, arguments); }

/* harmony default export */ const star = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "32",
    height: "32",
    fill: "#fff",
    rx: "16"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M14 4h4v24h-4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M28 14v4H4v-4z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M23.07 6.1l2.83 2.828-16.971 16.97L6.1 23.07z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M25.9 23.071L23.07 25.9 6.101 8.93 8.929 6.1z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/tag-solid.svg
function tag_solid_extends() { tag_solid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tag_solid_extends.apply(this, arguments); }

/* harmony default export */ const tag_solid = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", tag_solid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.678 11.422a2.5 2.5 0 000 3.536l6.364 6.364a2.5 2.5 0 003.536 0l7.69-7.69A2.5 2.5 0 0021 11.864V4.5A1.5 1.5 0 0019.5 3h-7.365a2.5 2.5 0 00-1.768.732l-7.69 7.69zM14.988 7C13.878 7 13 7.832 13 8.988c0 1.157.878 2.012 1.988 2.012C16.12 11 17 10.145 17 8.988 17 7.832 16.12 7 14.988 7z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/tag.svg
function tag_extends() { tag_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return tag_extends.apply(this, arguments); }

/* harmony default export */ const tag = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", tag_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.94 11.63l7.689-7.69a1.5 1.5 0 011.06-.44h7.366a.5.5 0 01.5.5v7.364a1.502 1.502 0 01-.44 1.06v.001l-7.69 7.69a1.5 1.5 0 01-2.121 0L3.94 13.75a1.5 1.5 0 010-2.122zM14.542 7.5c-.127 0-.237-.002-.339-.005h-.018c-.09-.002-.192-.005-.282-.003h-.016c-.13.001-.588.005-.943.342-.369.35-.386.82-.39.958l-.001.014c-.005.11-.003.269-.001.43l.002.252-.002.254a9.81 9.81 0 000 .432l.001.013c.005.142.022.599.37.948.353.352.813.365.952.369h.013c.093.003.24 0 .386-.001l.268-.003.275.003c.148.002.296.004.39.001h.014c.14-.004.596-.016.949-.36.359-.349.377-.81.383-.956v-.011c.006-.115.004-.279.002-.443l-.002-.246.002-.243c.002-.164.004-.328-.001-.443V8.79c-.007-.142-.026-.617-.405-.966a1.23 1.23 0 00-.578-.293 1.928 1.928 0 00-.378-.04c-.092 0-.195.002-.288.004h-.017c-.105.003-.217.005-.346.005z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/telegram.svg
function telegram_extends() { telegram_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return telegram_extends.apply(this, arguments); }

/* harmony default export */ const telegram = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", telegram_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M2.302 11.442c2.046-1.088 4.33-1.997 6.464-2.91 3.671-1.496 7.357-2.966 11.08-4.334.725-.233 2.026-.461 2.154.576-.07 1.467-.357 2.927-.555 4.386-.5 3.209-1.079 6.406-1.643 9.605-.194 1.065-1.576 1.617-2.46.935-2.124-1.386-4.265-2.759-6.362-4.177-.688-.675-.05-1.643.563-2.125 1.75-1.665 3.606-3.08 5.264-4.832.448-1.044-.874-.165-1.31.105-2.396 1.595-4.733 3.287-7.258 4.688-1.29.686-2.794.1-4.084-.283-1.156-.463-2.85-.928-1.853-1.633z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/text.svg
function text_extends() { text_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return text_extends.apply(this, arguments); }

/* harmony default export */ const svg_text = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", text_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M3 4.048V2h5m5 2.048V2H8m0 0v12m0 0h1.923M8 14H6.077"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/thumb-down.svg
function thumb_down_extends() { thumb_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return thumb_down_extends.apply(this, arguments); }

/* harmony default export */ const thumb_down = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", thumb_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M18.012 11.98v.959h5.802V1.922h-5.802v1.197m0 8.862c-1.692 1.038-4.945 3.574-5.319 5.269-.483 2.193-.483 1.99-.725 3.63-.11.749-1.436.93-1.934.721-.484-.202-1.21-.759-.967-3.154.193-1.916.725-4.311.967-5.27H3.506c-.644.001-1.692-.44-1.692-1.399 0-.958.806-1.437 1.45-1.676-.483-.16-.967-.685-.967-1.475 0-.92.887-1.437 1.21-1.676-.484-.719-.92-2.3 1.208-2.874-.901-.895-.338-2.395 1.209-2.395h6.098a7.51 7.51 0 013.118.704c.837.383 1.67.733 1.905.733h.967m0 8.862V3.119"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/thumb-up.svg
function thumb_up_extends() { thumb_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return thumb_up_extends.apply(this, arguments); }

/* harmony default export */ const thumb_up = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", thumb_up_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M7.351 11.18v-.959H1.55V21.24h5.802v-1.2m0-8.862c1.693-1.037 4.945-3.574 5.319-5.269.483-2.193.483-1.99.725-3.63.11-.749 1.436-.93 1.934-.72.484.201 1.21.758.967 3.153-.193 1.916-.725 4.311-.967 5.27h6.528c.645-.001 1.692.44 1.692 1.399 0 .958-.806 1.437-1.45 1.676.483.16.967.685.967 1.475 0 .92-.887 1.437-1.21 1.676.484.719.92 2.3-1.208 2.875.901.895.338 2.395-1.209 2.395h-6.098a7.51 7.51 0 01-3.118-.705c-.837-.383-1.67-.733-1.905-.733h-.967m0-8.862v8.862"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/time-1-min.svg
function time_1_min_extends() { time_1_min_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return time_1_min_extends.apply(this, arguments); }

/* harmony default export */ const time_1_min = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", time_1_min_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "#242424",
    strokeWidth: "2"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#E05151",
    fillRule: "evenodd",
    d: "M8.905 6.755A.5.5 0 018 6.461V3.5c0-.276.224-.503.5-.475a5 5 0 012.02.657c.239.139.287.454.125.677l-1.74 2.396z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/time-15-min.svg
function time_15_min_extends() { time_15_min_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return time_15_min_extends.apply(this, arguments); }

/* harmony default export */ const time_15_min = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", time_15_min_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8 3.5c0-.276.224-.503.5-.475a5 5 0 014.475 4.476c.028.275-.199.499-.475.499h-4a.5.5 0 01-.5-.5v-4z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/time-30-min.svg
function time_30_min_extends() { time_30_min_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return time_30_min_extends.apply(this, arguments); }

/* harmony default export */ const time_30_min = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", time_30_min_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8 3.5c0-.276.224-.503.5-.475a5 5 0 010 9.95c-.276.028-.5-.199-.5-.475v-9z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/time-45-min.svg
function time_45_min_extends() { time_45_min_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return time_45_min_extends.apply(this, arguments); }

/* harmony default export */ const time_45_min = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", time_45_min_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8 3.5c0-.276.224-.503.5-.475a5 5 0 11-5.475 5.474C2.997 8.224 3.224 8 3.5 8h4a.5.5 0 00.5-.5v-4z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/translate.svg
function translate_extends() { translate_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return translate_extends.apply(this, arguments); }

/* harmony default export */ const translate = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", translate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.7 8.372a3.228 3.228 0 00-1.752-1.678c.107-.484.173-.977.197-1.472h-1.443a7.18 7.18 0 01-.146 1.092 7.898 7.898 0 00-3.61.418 20.402 20.402 0 01-.266-2.099c4.327-.237 6.88-1.227 6.998-1.274l-.555-1.257c-.026.011-2.443.94-6.5 1.169 0-.942-.037-.937.015-1.257L5.192 2c-.024.266-.018.539-.013 1.314h-.133a35.2 35.2 0 01-2.776-.117L2 4.583c.424.036 1.72.1 2.887.1h.357c.067.891.186 1.777.357 2.654-1.915 1.077-3.434 3.179-2.66 4.886.152.347.395.648.706.875.31.227.677.37 1.062.417.14.02.281.03.422.029.826 0 1.771-.316 2.673-.856.324.472.696.912 1.11 1.312l.99-.995a7.402 7.402 0 01-.955-1.154c.24-.205.466-.424.678-.657a9.919 9.919 0 001.928-3.154c.363.185.65.483.816.846.576 1.36-.257 2.933-1.032 3.615l.979 1.005c1.282-1.138 2.176-3.265 1.382-5.134zM4.917 12.16a.793.793 0 01-.4-.149.758.758 0 01-.26-.332c-.356-.788.417-2.07 1.678-2.924.272.956.65 1.88 1.129 2.757-.778.474-1.559.73-2.147.648zm3.609-1.86a6.65 6.65 0 01-.317.322 12.428 12.428 0 01-.97-2.531c.765-.3 1.581-.46 2.406-.472.172-.001.344.007.515.025A8.556 8.556 0 018.526 10.3z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/trash-outline.svg
function trash_outline_extends() { trash_outline_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trash_outline_extends.apply(this, arguments); }

/* harmony default export */ const trash_outline = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", trash_outline_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 3.003a3 3 0 013-3h2a3 3 0 013 3h2a1 1 0 110 2h-.654l-.74 9.615a1.5 1.5 0 01-1.495 1.385H4.889a1.5 1.5 0 01-1.496-1.385l-.74-9.615H2a1 1 0 010-2h2zm7.34 2H4.66l.692 9h5.296l.692-9zm-4.34-3a1 1 0 00-1 1h4a1 1 0 00-1-1H7z",
    clipRule: "evenodd"
  })), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/trash.svg
function trash_extends() { trash_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trash_extends.apply(this, arguments); }

/* harmony default export */ const trash = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", trash_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 6h14M8.25 6C8.5 3 9.49 2.5 12 2.5s3.5.5 3.75 3.5M6.5 6l.907 13.6A1.5 1.5 0 008.903 21h6.194a1.5 1.5 0 001.496-1.4L17.5 6"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.75",
    d: "M10.25 9.5l.267 8m3.233-8l-.267 8"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/undo.svg
function undo_extends() { undo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return undo_extends.apply(this, arguments); }

/* harmony default export */ const undo = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", undo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M9.555 13a4.656 4.656 0 002.3-1.51 4.988 4.988 0 001.108-2.589 5.078 5.078 0 00-.455-2.796 4.803 4.803 0 00-1.866-2.061 4.515 4.515 0 00-2.647-.631 4.562 4.562 0 00-2.537 1.012L3 6.415m0 0L3.414 3M3 6.415l3.269.432"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user-big.svg
function user_big_extends() { user_big_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_big_extends.apply(this, arguments); }

/* harmony default export */ const user_big = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_big_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M13.759 13.516a.885.885 0 01-.01 1.227.85.85 0 01-1.204.011C11.579 13.77 10.08 13.26 8 13.26s-3.579.51-4.545 1.495a.85.85 0 01-1.204-.01.884.884 0 01-.01-1.228C3.564 12.165 5.5 11.508 8 11.508c2.5 0 4.435.658 5.759 2.008zm-5.758-3.059c-2.258 0-3.865-2.357-3.865-5.105C4.136 2.752 5.506 1 8.001 1c2.494 0 3.863 1.751 3.863 4.352 0 2.748-1.606 5.105-3.863 5.105zm0-1.751c1.122 0 2.146-1.398 2.146-3.354 0-1.76-.722-2.6-2.146-2.6-1.425 0-2.148.842-2.148 2.6 0 1.955 1.026 3.354 2.148 3.354z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user-outline-error.svg
function user_outline_error_extends() { user_outline_error_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_outline_error_extends.apply(this, arguments); }

/* harmony default export */ const user_outline_error = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_outline_error_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    d: "M9.574 16.51c2.833 0 4.942.728 6.362 2.144a.5.5 0 01-.71.708c-1.257-1.253-3.157-1.851-5.652-1.851-2.494 0-4.395.598-5.652 1.85a.503.503 0 01-.848-.357.5.5 0 01.138-.35c1.42-1.417 3.529-2.145 6.362-2.145zm.001-2.202c-1.13 0-2.12-.574-2.842-1.539-.726-.97-1.167-2.32-1.167-3.795 0-1.401.377-2.515 1.04-3.272C7.26 4.954 8.242 4.5 9.576 4.5c1.332 0 2.313.454 2.968 1.202.662.756 1.038 1.87 1.038 3.272 0 1.475-.44 2.826-1.166 3.795-.722.965-1.71 1.54-2.84 1.54zm0-1.001c.87 0 1.633-.529 2.156-1.297.527-.773.848-1.833.848-3.036 0-1.063-.22-1.944-.748-2.564-.54-.636-1.327-.908-2.256-.908-.93 0-1.716.272-2.257.908-.527.62-.748 1.502-.748 2.564 0 1.203.321 2.262.848 3.036.524.768 1.287 1.297 2.157 1.297z"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M18 10.034l2.568 2.567m0 0l2.567 2.568m-2.567-2.568l-2.53 2.53m2.53-2.53L23.169 10"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user-outline-ok.svg
function user_outline_ok_extends() { user_outline_ok_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_outline_ok_extends.apply(this, arguments); }

/* harmony default export */ const user_outline_ok = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_outline_ok_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    d: "M9.574 16.51c2.833 0 4.942.728 6.362 2.144a.5.5 0 01-.71.708c-1.257-1.253-3.157-1.851-5.652-1.851-2.494 0-4.395.598-5.652 1.85a.503.503 0 01-.848-.357.5.5 0 01.138-.35c1.42-1.417 3.529-2.145 6.362-2.145zm.001-2.202c-1.13 0-2.12-.574-2.842-1.539-.726-.97-1.167-2.32-1.167-3.795 0-1.401.377-2.515 1.04-3.272C7.26 4.954 8.242 4.5 9.576 4.5c1.332 0 2.313.454 2.968 1.202.662.756 1.038 1.87 1.038 3.272 0 1.475-.44 2.826-1.166 3.795-.722.965-1.71 1.54-2.84 1.54zm0-1.001c.87 0 1.633-.529 2.156-1.297.527-.773.848-1.833.848-3.036 0-1.063-.22-1.944-.748-2.564-.54-.636-1.327-.908-2.256-.908-.93 0-1.716.272-2.257.908-.527.62-.748 1.502-.748 2.564 0 1.203.321 2.262.848 3.036.524.768 1.287 1.297 2.157 1.297z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.795 11.22a.724.724 0 000-1.01.69.69 0 00-.99 0L18.8 13.275l-1.605-1.638a.69.69 0 00-.99 0 .725.725 0 000 1.01l2.1 2.143a.69.69 0 00.99 0l3.5-3.572z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user-solid-error.svg
function user_solid_error_extends() { user_solid_error_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_solid_error_extends.apply(this, arguments); }

/* harmony default export */ const user_solid_error = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_solid_error_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-2 0 27 20"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.195 13.536a1 1 0 01-1.414 0l-2.121-2.122-2.121 2.122a1 1 0 11-1.415-1.415L18.246 10l-2.122-2.121a1 1 0 011.415-1.415l2.12 2.122 2.122-2.122a1 1 0 111.415 1.415L21.073 10l2.121 2.121a1 1 0 010 1.415zM3.24 5.638c0 3.558 1.977 6.612 4.756 6.612s4.754-3.054 4.754-6.612C12.75 2.079 11.065 0 7.996 0c-3.07 0-4.757 2.08-4.757 5.638zM.282 18.994C1.308 19.664 3.881 20 8 20s6.691-.335 7.717-1.005a.625.625 0 00.281-.566c-.19-2.786-2.858-4.179-8.003-4.179-5.147 0-7.811 1.393-7.994 4.18a.625.625 0 00.282.564z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user-solid-ok.svg
function user_solid_ok_extends() { user_solid_ok_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_solid_ok_extends.apply(this, arguments); }

/* harmony default export */ const user_solid_ok = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_solid_ok_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-2 0 27 20"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.736 8.618a.983.983 0 000-1.34.868.868 0 00-1.272 0L18.6 11.345l-2.064-2.172a.868.868 0 00-1.272 0 .983.983 0 000 1.34l2.7 2.843c.351.37.92.37 1.272 0l4.5-4.738zM3.24 5.638c0 3.558 1.977 6.612 4.756 6.612s4.754-3.054 4.754-6.612C12.75 2.079 11.065 0 7.996 0c-3.07 0-4.757 2.08-4.757 5.638zM.282 18.994C1.308 19.664 3.881 20 8 20s6.691-.335 7.717-1.005a.625.625 0 00.281-.566c-.19-2.786-2.858-4.179-8.003-4.179-5.147 0-7.811 1.393-7.994 4.18a.625.625 0 00.282.564z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user-solid.svg
function user_solid_extends() { user_solid_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_solid_extends.apply(this, arguments); }

/* harmony default export */ const user_solid = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_solid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 7.063C16.5 10.258 14.571 13 12 13c-2.57 0-4.5-2.742-4.5-5.938C7.5 3.868 9.16 2 12 2s4.5 1.867 4.5 5.063zM4.102 20.142C4.487 20.6 6.145 22 12 22c5.855 0 7.513-1.4 7.898-1.857a.415.415 0 00.09-.317C19.9 18.944 19.106 15 12 15c-7.106 0-7.9 3.944-7.989 4.826a.416.416 0 00.091.317v-.001z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/user.svg
function user_extends() { user_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_extends.apply(this, arguments); }

/* harmony default export */ const user = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M18.707 18.293a1 1 0 01-1.414 1.414C16.168 18.582 14.422 18 12 18s-4.168.582-5.293 1.707a1 1 0 01-1.414-1.414C6.834 16.75 9.088 16 12 16s5.165.751 6.707 2.293zM12.001 14.8c-2.63 0-4.501-2.692-4.501-5.83C7.5 6 9.096 4 12.001 4 14.906 4 16.5 6 16.5 8.97c0 3.138-1.87 5.83-4.499 5.83zm0-2c1.307 0 2.499-1.596 2.499-3.83 0-2.009-.84-2.97-2.499-2.97-1.66 0-2.501.962-2.501 2.97 0 2.233 1.194 3.83 2.501 3.83z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/vector.svg
function vector_extends() { vector_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vector_extends.apply(this, arguments); }

/* harmony default export */ const vector = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", vector_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M5.374 18.265l-.147.235H4.025l.142-.612.09-.39A9.5 9.5 0 004.5 15.36v-.86a.5.5 0 00-1 0v4.997a1 1 0 001 1l5 .003a.5.5 0 000-1h-.86c-.72 0-1.437.081-2.138.243l-.39.09-.612.142v-1.197l.235-.147a9.5 9.5 0 001.674-1.334l2.94-2.94a.5.5 0 00-.706-.707l-2.93 2.928-1.339 1.687zm0 0a9.5 9.5 0 011.34-1.686l-1.34 1.686zM18.5 4.654v-.629l-.612.142-.39.09a9.5 9.5 0 01-2.137.243H14.5a.5.5 0 010-1l5 .003a1 1 0 011 1v4.994a.5.5 0 01-1 0V8.64c0-.72.081-1.437.243-2.138l.09-.39.142-.612h-1.202l-.147.235a9.49 9.49 0 01-1.34 1.687l-2.929 2.928a.5.5 0 01-.707-.707l2.94-2.94a9.5 9.5 0 011.675-1.334l.235-.147v-.568z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/video-off.svg
function video_off_extends() { video_off_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return video_off_extends.apply(this, arguments); }

/* harmony default export */ const video_off = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", video_off_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.4 5H6c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093C2 6.9 2 7.6 2 9v6c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092C3.9 19 4.6 19 6 19h6c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.092-1.092C16 17.1 16 16.4 16 15v-.4L6.4 5zm15.422 12.594a.986.986 0 00.178-.569V6.98a1 1 0 00-1.593-.805L16 9.42V9c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.093C14.1 5 13.4 5 12 5H9.228l12.587 12.587a.234.234 0 01.007.007z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2",
    d: "M2 2l18 18"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/video-on.svg
function video_on_extends() { video_on_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return video_on_extends.apply(this, arguments); }

/* harmony default export */ const video_on = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", video_on_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.272 6.365C2 6.9 2 7.6 2 9v6c0 1.4 0 2.1.272 2.635a2.5 2.5 0 001.093 1.092C3.9 19 4.6 19 6 19h6c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 001.092-1.092C16 17.1 16 16.4 16 15v-.42l4.407 3.25A1 1 0 0022 17.025V6.98a1 1 0 00-1.593-.805L16 9.42V9c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 00-1.092-1.093C14.1 5 13.4 5 12 5H6c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/vk.svg
function vk_extends() { vk_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vk_extends.apply(this, arguments); }

/* harmony default export */ const vk = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", vk_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.506 6.833c.155-.47 0-.812-.69-.812h-2.29c-.579 0-.846.3-1.001.62 0 0-1.179 2.733-2.825 4.505-.534.512-.778.683-1.067.683-.156 0-.356-.17-.356-.64V6.81c0-.555-.178-.811-.667-.811h-3.603c-.356 0-.579.256-.579.512 0 .534.823.662.912 2.157v3.246c0 .704-.133.832-.422.832-.779 0-2.67-2.754-3.803-5.893C5.892 6.234 5.67 6 5.09 6H2.778C2.111 6 2 6.299 2 6.62c0 .576.778 3.48 3.625 7.323 1.89 2.626 4.582 4.036 7.006 4.036 1.468 0 1.646-.32 1.646-.854v-1.986c0-.64.133-.747.6-.747.334 0 .934.17 2.291 1.43C18.725 17.317 18.992 18 19.86 18h2.291c.667 0 .979-.32.8-.94-.2-.619-.956-1.515-1.934-2.583-.534-.598-1.335-1.26-1.58-1.58-.333-.427-.244-.598 0-.982-.022 0 2.78-3.801 3.07-5.082z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/vocabulary.svg
function vocabulary_extends() { vocabulary_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vocabulary_extends.apply(this, arguments); }

/* harmony default export */ const vocabulary = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", vocabulary_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M4.054 3.595H6.15l3.054 8.689H7.459l-.74-2.109H3.206l-.739 2.109H1l3.054-8.689zm2.169 5.138l-1.26-3.587-1.249 3.587h2.509zm7.504 3.551a6.87 6.87 0 01-.073-.473 17.328 17.328 0 00-.048-.52 2 2 0 01-.255.399 1.81 1.81 0 01-.375.364c-.154.104-.336.19-.546.254-.202.065-.44.097-.715.097-.266 0-.52-.036-.763-.11a1.831 1.831 0 01-.63-.338 1.67 1.67 0 01-.424-.57 1.883 1.883 0 01-.158-.8c0-.67.263-1.187.788-1.55.525-.364 1.272-.546 2.242-.546h.775v-.279c0-.388-.1-.65-.303-.788-.194-.145-.509-.218-.945-.218-.436 0-.836.057-1.2.17a6.4 6.4 0 00-.957.376V6.419a5.583 5.583 0 011.054-.376 5.5 5.5 0 011.406-.17c.824 0 1.466.174 1.927.521.468.348.703.901.703 1.66v3.466c.008.09.012.182.012.279l.024.279c.008.08.016.15.024.206h-1.563zm-1.503-1.079c.275 0 .497-.056.667-.17a1.485 1.485 0 00.594-.86c.04-.153.06-.262.06-.327v-.376h-.715c-.5 0-.868.085-1.103.255a.775.775 0 00-.339.666c0 .259.073.46.218.606.154.138.36.206.618.206z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/warning.svg
function warning_extends() { warning_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return warning_extends.apply(this, arguments); }

/* harmony default export */ const warning = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", warning_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8 1.6a6.4 6.4 0 100 12.8A6.4 6.4 0 008 1.6zM0 8a8 8 0 1116 0A8 8 0 010 8z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8 9.6a.8.8 0 01-.8-.8V4a.8.8 0 111.6 0v4.8a.8.8 0 01-.8.8zm-1.2 2a1.2 1.2 0 112.4 0 1.2 1.2 0 01-2.4 0z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/wave-star.svg
function wave_star_extends() { wave_star_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wave_star_extends.apply(this, arguments); }

/* harmony default export */ const wave_star = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", wave_star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M11.404 1.114a2 2 0 013.192 0l1.06 1.406a2 2 0 002.045.744l1.716-.395a2 2 0 012.446 2.052l-.091 1.758a2 2 0 001.088 1.885l1.568.8a2 2 0 01.554 3.144l-1.2 1.289a2 2 0 00-.377 2.142l.686 1.621a2 2 0 01-1.596 2.765l-1.747.216a2 2 0 00-1.667 1.399l-.516 1.683a2 2 0 01-3 1.092l-1.477-.958a2 2 0 00-2.176 0l-1.477.958a2 2 0 01-3-1.092l-.516-1.683a2 2 0 00-1.667-1.399l-1.747-.216a2 2 0 01-1.596-2.765l.686-1.62a2 2 0 00-.378-2.143l-1.2-1.289a2 2 0 01.555-3.144l1.568-.8a2 2 0 001.088-1.885l-.09-1.758A2 2 0 016.582 2.87l1.716.395a2 2 0 002.044-.744l1.06-1.406z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/waves.svg
function waves_extends() { waves_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return waves_extends.apply(this, arguments); }

/* harmony default export */ const waves = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", waves_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.717 1.057a.969.969 0 00-.588.495l-.107.21v20.49l.108.213a.986.986 0 001.091.513.963.963 0 00.668-.528l.104-.222V1.786l-.102-.219a.938.938 0 00-.61-.513c-.242-.073-.324-.072-.564.003zM6.575 5.113c-.225.111-.45.368-.517.588-.071.238-.071 12.374 0 12.612.067.222.295.48.521.59.385.186.956.06 1.206-.268.248-.326.237-.026.237-6.628 0-6.593.01-6.302-.234-6.623-.258-.339-.822-.465-1.213-.271zm9.967.018a.968.968 0 00-.488.603c-.09.301-.09 12.245 0 12.546a.941.941 0 00.513.61c.53.246 1.097.045 1.339-.474l.1-.216V5.815l-.1-.216a1.055 1.055 0 00-.53-.52c-.222-.093-.601-.07-.834.052zM1.708 9.049c-.31.099-.588.402-.67.733-.033.13-.044.867-.035 2.332.013 2.107.014 2.146.106 2.317.13.241.402.476.622.535.427.115.892-.07 1.126-.45l.13-.21V9.707l-.13-.21a.972.972 0 00-.784-.475 1.35 1.35 0 00-.365.027zm19.86.071a1.02 1.02 0 00-.52.622c-.028.105-.04.948-.031 2.364l.012 2.2.13.21c.234.38.7.565 1.126.45.22-.059.493-.294.622-.535.092-.172.093-.195.093-2.424s0-2.251-.093-2.424c-.278-.519-.838-.712-1.338-.463z",
    clipRule: "evenodd"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/webrtc-hided-view.svg
function webrtc_hided_view_extends() { webrtc_hided_view_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return webrtc_hided_view_extends.apply(this, arguments); }

/* harmony default export */ const webrtc_hided_view = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", webrtc_hided_view_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M2.88 7.36a.64.64 0 01.64-.64h8.96a.64.64 0 01.64.64v1.28a.64.64 0 01-.64.64H3.52a.64.64 0 01-.64-.64V7.36z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/webrtc-horizontal-view.svg
function webrtc_horizontal_view_extends() { webrtc_horizontal_view_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return webrtc_horizontal_view_extends.apply(this, arguments); }

/* harmony default export */ const webrtc_horizontal_view = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", webrtc_horizontal_view_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M0 5.28C0 4.573.573 4 1.28 4h4.8c.707 0 1.28.573 1.28 1.28v5.44A1.28 1.28 0 016.08 12h-4.8A1.28 1.28 0 010 10.72V5.28zm8.64 0c0-.707.573-1.28 1.28-1.28h4.8c.707 0 1.28.573 1.28 1.28v5.44A1.28 1.28 0 0114.72 12h-4.8a1.28 1.28 0 01-1.28-1.28V5.28z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/webrtc-poster.svg
function webrtc_poster_extends() { webrtc_poster_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return webrtc_poster_extends.apply(this, arguments); }

/* harmony default export */ const webrtc_poster = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", webrtc_poster_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 32 40"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M25 10.126C25 16.516 21.142 22 16 22c-5.142 0-9-5.484-9-11.876C7 3.736 10.32 0 16 0s9 3.734 9 10.126zM.204 36.284C.974 37.2 4.29 40 16 40c11.71 0 15.026-2.8 15.796-3.714a.833.833 0 00.18-.634C31.8 33.888 30.212 26 16 26 1.788 26 .2 33.888.022 35.652a.832.832 0 00.182.634v-.002z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/webrtc-speaker-view.svg
function webrtc_speaker_view_extends() { webrtc_speaker_view_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return webrtc_speaker_view_extends.apply(this, arguments); }

/* harmony default export */ const webrtc_speaker_view = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", webrtc_speaker_view_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M3 6.28C3 5.573 3.573 5 4.28 5h7.44c.707 0 1.28.573 1.28 1.28v3.44A1.28 1.28 0 0111.72 11H4.28A1.28 1.28 0 013 9.72V6.28z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/webrtc-vertical-view.svg
function webrtc_vertical_view_extends() { webrtc_vertical_view_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return webrtc_vertical_view_extends.apply(this, arguments); }

/* harmony default export */ const webrtc_vertical_view = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", webrtc_vertical_view_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M2.56 3.28c0-.707.573-1.28 1.28-1.28h8.32c.707 0 1.28.573 1.28 1.28v2.8a1.28 1.28 0 01-1.28 1.28H3.84a1.28 1.28 0 01-1.28-1.28v-2.8zm0 6.64c0-.707.573-1.28 1.28-1.28h8.32c.707 0 1.28.573 1.28 1.28v2.8A1.28 1.28 0 0112.16 14H3.84a1.28 1.28 0 01-1.28-1.28v-2.8z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/whatsapp.svg
function whatsapp_extends() { whatsapp_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return whatsapp_extends.apply(this, arguments); }

/* harmony default export */ const whatsapp = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", whatsapp_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M19.077 4.928A9.927 9.927 0 0012.011 2c-5.506 0-9.987 4.479-9.989 9.985a9.962 9.962 0 001.333 4.992L2 22l5.233-1.237a9.98 9.98 0 004.773 1.216h.004c5.505 0 9.986-4.48 9.989-9.985a9.922 9.922 0 00-2.922-7.066zm-2.179 10.626c-.208.583-1.227 1.145-1.685 1.186-.458.042-.887.207-2.995-.624-2.537-1-4.139-3.601-4.263-3.767-.125-.167-1.019-1.353-1.019-2.581s.645-1.832.874-2.081a.916.916 0 01.666-.312c.166 0 .333 0 .478.006.178.007.375.016.562.431.222.494.707 1.728.769 1.853.062.125.104.271.021.437-.083.166-.125.27-.249.416-.125.146-.262.325-.374.437-.125.124-.255.26-.11.509.146.25.646 1.067 1.388 1.728.954.85 1.757 1.113 2.007 1.239.25.125.395.104.541-.063.146-.166.624-.728.79-.978.166-.25.333-.208.562-.125.229.083 1.456.687 1.705.812.25.125.416.187.478.291.062.103.062.603-.146 1.186z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/ya-plus-crown.svg
function ya_plus_crown_extends() { ya_plus_crown_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ya_plus_crown_extends.apply(this, arguments); }

/* harmony default export */ const ya_plus_crown = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", ya_plus_crown_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), /*#__PURE__*/react.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "20",
    stroke: "#4434FF",
    strokeWidth: "2"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#FC0",
    strokeWidth: "2",
    d: "M21 41a20 20 0 0020-20"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#F80",
    strokeWidth: "2",
    d: "M41 21A20 20 0 0021 1"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/ya-plus-simple.svg
function ya_plus_simple_extends() { ya_plus_simple_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ya_plus_simple_extends.apply(this, arguments); }

/* harmony default export */ const ya_plus_simple = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", ya_plus_simple_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M14.429.246A12.053 12.053 0 0012 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12c0-.21-.005-.42-.016-.628h-8.7l-1.687 8.02H10.4l1.687-8.02H4.552l.636-3.024h7.536L14.429.246z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M23.434 8.348h-7.513l1.486-7.064a12.035 12.035 0 016.027 7.064z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/yandex-browser.svg
function yandex_browser_extends() { yandex_browser_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return yandex_browser_extends.apply(this, arguments); }

/* harmony default export */ const yandex_browser = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", yandex_browser_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 597 597"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M6 298.5C6 136.957 136.957 6 298.5 6S591 136.957 591 298.5 460.043 591 298.5 591 6 460.043 6 298.5z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M329.895 328.696v187.817c0 3.382-14.656 6.088-31.342 6.314-16.009-.226-31.342-2.932-31.342-6.314V328.696L112.754 177.63c-2.48-2.48 5.412-14.205 17.588-26.38 12.176-12.175 24.127-20.067 26.382-17.587l141.604 138.214 141.604-138.214c2.48-2.48 14.205 5.412 26.381 17.587 12.177 12.175 20.294 23.9 18.039 26.38L329.895 328.696z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#07F",
    fillRule: "evenodd",
    d: "M329.895 328.696v187.817c0 3.382-14.656 6.088-31.342 6.314-16.009-.226-31.342-2.932-31.342-6.314V328.696L112.754 177.63c-2.48-2.48 5.412-14.205 17.588-26.38 12.176-12.175 24.127-20.067 26.382-17.587l141.604 138.214 141.604-138.214c2.48-2.48 14.205 5.412 26.381 17.587 12.177 12.175 20.294 23.9 18.039 26.38L329.895 328.696z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#F33",
    fillRule: "evenodd",
    d: "M329.895 328.696v187.817c0 3.382-14.656 6.088-31.342 6.314-16.009-.226-31.342-2.932-31.342-6.314V328.696L112.754 177.63c-2.48-2.48 5.412-14.205 17.588-26.38 12.176-12.175 24.127-20.067 26.382-17.587l141.604 138.214 141.604-138.214c2.48-2.48 14.205 5.412 26.381 17.587 12.177 12.175 20.294 23.9 18.039 26.38L329.895 328.696z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#EAEAEA",
    d: "M298.5 585C140.27 585 12 456.73 12 298.5H0C0 463.357 133.643 597 298.5 597v-12zM585 298.5C585 456.73 456.73 585 298.5 585v12C463.357 597 597 463.357 597 298.5h-12zM298.5 12C456.73 12 585 140.27 585 298.5h12C597 133.643 463.357 0 298.5 0v12zm0-12C133.643 0 0 133.643 0 298.5h12C12 140.27 140.27 12 298.5 12V0z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/yandex-gpt.svg
function yandex_gpt_extends() { yandex_gpt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return yandex_gpt_extends.apply(this, arguments); }

/* harmony default export */ const yandex_gpt = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", yandex_gpt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "78",
    height: "12",
    fill: "none"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M4.514 0A4.507 4.507 0 000 4.5C0 6.985 2.021 9 4.514 9a4.507 4.507 0 004.514-4.5c0-2.485-2.02-4.5-4.514-4.5zm4.514 10.5c0 .828.674 1.5 1.505 1.5.83 0 1.505-.672 1.505-1.5 0-.829-.674-1.5-1.505-1.5-.831 0-1.505.671-1.505 1.5zM61.19 8.34c-.366.285-.83.427-1.394.427-.35 0-.675-.059-.977-.178a2.205 2.205 0 01-.786-.522 2.453 2.453 0 01-.524-.843 3.369 3.369 0 01-.179-1.14c0-.46.068-.875.203-1.247.143-.372.341-.688.595-.95.262-.26.576-.459.941-.593a3.519 3.519 0 011.263-.214 4.74 4.74 0 011.453.214c.445.142.842.328 1.191.558v-1.71a4.555 4.555 0 00-1.191-.427 6.368 6.368 0 00-1.513-.167c-.738 0-1.401.111-1.989.333a4.155 4.155 0 00-1.489.926c-.413.396-.73.875-.953 1.437-.214.562-.321 1.19-.321 1.888 0 .633.103 1.207.31 1.721.206.507.492.942.857 1.306a3.87 3.87 0 001.334.843c.516.19 1.084.285 1.703.285.604 0 1.144-.099 1.62-.297a3.413 3.413 0 001.203-.819 3.55 3.55 0 00.739-1.27 4.816 4.816 0 00.262-1.627v-.82h-4.181v1.497h2.477c-.063.641-.281 1.104-.655 1.389zM17.436 1.655l1.93 3.515 1.941-3.515h1.644L20.14 6.75v3.408h-1.75V6.654l-2.824-4.999h1.87z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.665 5.288c-.326 0-.64.032-.941.095a6.123 6.123 0 00-.87.25V4.208c.294-.095.62-.17.977-.226a6.542 6.542 0 011.12-.095c.484 0 .909.052 1.274.155.365.095.671.257.917.487.247.221.43.51.548.866.127.357.19.792.19 1.306v3.456h-1.607a2.205 2.205 0 01-.012-.262v-.344c-.183.222-.417.4-.703.534-.286.127-.631.19-1.036.19-.31 0-.596-.043-.858-.13a2.095 2.095 0 01-.667-.368 1.71 1.71 0 01-.44-.594 1.976 1.976 0 01-.155-.796c0-.348.063-.649.19-.902.127-.261.302-.475.524-.641.23-.174.5-.3.81-.38.31-.087.652-.13 1.025-.13.262 0 .5.02.714.059.215.04.401.09.56.154-.024-.459-.167-.784-.429-.974-.254-.19-.63-.285-1.131-.285zm.333 3.824c.405 0 .707-.123.906-.368a1.49 1.49 0 00.321-.89v-.286a3.106 3.106 0 00-.429-.13 2.428 2.428 0 00-.56-.06c-.365 0-.655.075-.869.226-.214.15-.322.38-.322.688 0 .254.084.456.25.606.175.143.41.214.703.214z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M31.018 5.728c.238-.261.548-.392.93-.392.356 0 .638.119.845.356.206.238.31.626.31 1.164v3.3h1.667V6.453c0-.459-.056-.85-.167-1.175a2.03 2.03 0 00-.476-.796 1.775 1.775 0 00-.715-.451 2.639 2.639 0 00-.881-.143c-.46 0-.846.084-1.156.25-.31.158-.552.356-.726.593h-.024l-.048-.724h-1.572v6.15h1.656V6.892c0-.522.119-.91.357-1.163z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.58 7.176c0-.538.084-1.009.25-1.413.175-.411.402-.756.68-1.033.278-.277.595-.486.953-.629a3.026 3.026 0 011.107-.214 2.714 2.714 0 011.859.701V1.655h1.667v8.502h-1.584l-.036-.82c-.23.301-.52.535-.87.7-.349.16-.738.238-1.167.238-.373 0-.734-.063-1.084-.19a2.641 2.641 0 01-.905-.593 2.938 2.938 0 01-.631-.962c-.159-.388-.238-.84-.238-1.354zm4.741-.878a1.488 1.488 0 00-.357-.546 1.425 1.425 0 00-.512-.345 1.568 1.568 0 00-1.203 0c-.19.08-.358.198-.5.356a1.71 1.71 0 00-.346.558 2.027 2.027 0 00-.13.749c0 .277.043.526.13.748.087.221.203.407.346.558.142.15.31.265.5.344a1.568 1.568 0 001.203 0c.198-.08.37-.194.512-.344.15-.15.27-.337.357-.558.096-.222.143-.475.143-.76 0-.285-.047-.539-.143-.76zm4.588 3.752c.413.15.881.225 1.405.225a5.12 5.12 0 001.334-.166c.413-.119.747-.269 1-.451V8.352a2.822 2.822 0 01-.905.427c-.357.095-.71.143-1.06.143-.571 0-1.02-.127-1.346-.38a1.852 1.852 0 01-.63-.998h4.204c.063-.585.036-1.104-.084-1.555a2.813 2.813 0 00-.547-1.152 2.333 2.333 0 00-.93-.7 2.87 2.87 0 00-1.203-.25 3.38 3.38 0 00-1.226.226c-.382.15-.72.364-1.013.641a3.168 3.168 0 00-.69 1.01c-.168.395-.25.842-.25 1.341 0 .467.074.899.225 1.294a2.9 2.9 0 00.668.998c.285.277.635.494 1.048.653zm.274-4.548c.246-.23.547-.344.905-.344.373 0 .667.119.881.356.215.238.334.534.358.89h-2.645c.088-.38.254-.68.5-.902z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M53.107 6.963l2.156 3.194h-1.894l-1.382-2.043-1.417 2.043h-1.608l2.191-3.147-2.013-3.004h1.882l1.251 1.852 1.263-1.852h1.596l-2.025 2.957z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M67.425 1.655c.54 0 1.025.056 1.453.166.437.103.806.266 1.108.487.31.222.544.507.703.855.167.348.25.764.25 1.247 0 .49-.087.914-.262 1.27-.175.357-.42.653-.739.89a3.31 3.31 0 01-1.107.523c-.43.111-.894.166-1.394.166H66.33v2.898h-1.74V1.655h2.835zm.048 4.108c.548 0 .973-.106 1.274-.32.302-.222.453-.558.453-1.01 0-.443-.155-.763-.465-.961-.301-.206-.726-.309-1.274-.309h-1.132v2.6h1.144z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M77.998 1.655H71.16v1.508h2.549v6.994h1.75V3.163h2.538V1.655z"
  }));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/svg/yandex-plus-circle.svg
function yandex_plus_circle_extends() { yandex_plus_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return yandex_plus_circle_extends.apply(this, arguments); }

/* harmony default export */ const yandex_plus_circle = (_ref => {
  let {
    styles = {},
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", yandex_plus_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/react.createElement("rect", {
    width: "16",
    height: "16",
    fill: "url(#a)",
    rx: "8"
  }), /*#__PURE__*/react.createElement("rect", {
    width: "16",
    height: "16",
    fill: "url(#b)",
    rx: "8"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.374 10.822l.74-3.527h3.276a5.375 5.375 0 11-3.724-4.426l-.678 3.25h-3.36l-.251 1.176h3.36l-.757 3.527h1.394zm1.563-7.363l-.555 2.66h2.715a5.392 5.392 0 00-2.16-2.66z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("radialGradient", {
    id: "a",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "rotate(-45 19.314 8) scale(22.6274 34.24632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: ".076",
    stopColor: "#48CCE0"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: ".308",
    stopColor: "#428BEB"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: ".648",
    stopColor: "#505ADD"
  })), /*#__PURE__*/react.createElement("radialGradient", {
    id: "b",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(-15.8049 0 0 -44.8359 16 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: ".029",
    stopColor: "#FCAB14"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: ".192",
    stopColor: "#FA6641"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: ".402",
    stopColor: "#BE40C0"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: "1",
    stopColor: "#505ADD",
    stopOpacity: "0"
  }))));
});
;// CONCATENATED MODULE: ../ui-kit/src/icons/icons.model.ts









































































































































































const ICON_SIZE_MAP = {
  tiny: "12px",
  small: "16px",
  medium: "24px",
  large: "32px",
  "extra-large": "48px",
  huge: "64px"
};
const icons = {
  "add-comment": add_comment,
  "arrow-down": arrow_down,
  "arrow-left": arrow_left,
  "arrow-right": arrow_right,
  "arrow-right-bold": arrow_right_bold,
  "arrow-up": arrow_up,
  "arrow-up-small": arrow_up_small,
  "arrow-with-line-right": arrow_with_line_right,
  audio: audio,
  "badge-crown": badge_crown,
  "badge-star-filled": badge_star_filled,
  "badge-with-exclamation-mark": badge_with_exclamation_mark,
  "bank-card": bank_card,
  book: book,
  bookmark: bookmark,
  "bookmark-filled": bookmark_filled,
  "burger-menu": burger_menu,
  calendar: calendar,
  "calendar-with-badge": calendar_with_badge,
  chapter: chapter,
  "chapter-outline": chapter_outline,
  chart: chart,
  chat: chat,
  "chat-off": chat_off,
  "chat-outline": chat_outline,
  "check-outline": check_outline,
  "check-solid": check_solid,
  checkmark: checkmark,
  "checkmark-bold": checkmark_bold,
  "chevron-down": chevron_down,
  "chevron-up": chevron_up,
  "chrome-browser": chrome_browser,
  "circle-filled": circle_filled,
  "class-dialogue": class_dialogue,
  "class-planning": class_planning,
  "class-training": class_training,
  clip: clip,
  clock: clock,
  collapse: collapse,
  comments: comments,
  connected: connected,
  copy: copy,
  cross: cross,
  "cross-bold": cross_bold,
  cursor: cursor,
  draw: draw,
  "draw-crossed": draw_crossed,
  edit: edit,
  enter: enter,
  "exclamation-mark": exclamation_mark,
  "external-link": external_link,
  eye: eye,
  facebook: facebook,
  filters: filters,
  flame: flame,
  "flame-big": flame_big,
  gift: gift,
  "gift-fill": gift_fill,
  grammar: grammar,
  handline: handline,
  handset: handset,
  "heart-outline": heart_outline,
  "heart-solid": heart_solid,
  help: help,
  "help-solid": help_solid,
  "hide-left": hide_left,
  info: info,
  "info-solid": info_solid,
  lamp: lamp,
  lightning: lightning,
  line: line,
  loader: loader,
  loading: loading,
  lock: lock,
  "lock-filled": lock_filled,
  magic: magic,
  mail: mail,
  "menu-dots": menu_dots,
  "mic-off": mic_off,
  "mic-on": mic_on,
  minus: minus,
  "new-arrow-right": new_arrow_right,
  "new-card": new_card,
  "not-connected": not_connected,
  "note-outline-draft": note_outline_draft,
  notes: notes,
  "notes-thin": notes_thin,
  "notification-bell": notification_bell,
  "notification-bell-unread": notification_bell_unread,
  "numbered-list": numbered_list,
  palette: palette,
  parameters: parameters,
  path: path,
  pause: pause,
  payment: payment,
  pencil: pencil,
  play: play,
  playing: playing,
  plus: plus,
  "plus-small": plus_small,
  redo: redo,
  refresh: refresh,
  reset: svg_reset,
  sbp: sbp,
  search: search,
  "search-light": search_light,
  send: send,
  settings: settings,
  shapes: shapes,
  "simple-arrow-down": simple_arrow_down,
  "simple-arrow-left": simple_arrow_left,
  "simple-arrow-left-bold": simple_arrow_left_bold,
  "simple-arrow-right": simple_arrow_right,
  "simple-arrow-right-bold": simple_arrow_right_bold,
  "simple-arrow-up": simple_arrow_up,
  skip: skip,
  "small-trash": small_trash,
  "solid-speaking-notes": solid_speaking_notes,
  speaker: speaker,
  "speaker-off": speaker_off,
  "speaking-notes": speaking_notes,
  "speed-1x": speed_1x,
  "speed-2x": speed_2x,
  "speed-0.5x": speed_05x,
  "speed-0.75x": speed_075x,
  "speed-1.25x": speed_125x,
  star: star,
  tag: tag,
  "tag-solid": tag_solid,
  telegram: telegram,
  text: svg_text,
  "thumb-down": thumb_down,
  "thumb-up": thumb_up,
  "time-1-min": time_1_min,
  "time-15-min": time_15_min,
  "time-30-min": time_30_min,
  "time-45-min": time_45_min,
  translate: translate,
  trash: trash,
  "trash-outline": trash_outline,
  undo: undo,
  user: user,
  "user-big": user_big,
  "user-outline-error": user_outline_error,
  "user-outline-ok": user_outline_ok,
  "user-solid": user_solid,
  "user-solid-error": user_solid_error,
  "user-solid-ok": user_solid_ok,
  vector: vector,
  "video-off": video_off,
  "video-on": video_on,
  vk: vk,
  vocabulary: vocabulary,
  warning: warning,
  "wave-star": wave_star,
  waves: waves,
  "webrtc-hided-view": webrtc_hided_view,
  "webrtc-horizontal-view": webrtc_horizontal_view,
  "webrtc-poster": webrtc_poster,
  "webrtc-speaker-view": webrtc_speaker_view,
  "webrtc-vertical-view": webrtc_vertical_view,
  whatsapp: whatsapp,
  "ya-plus-crown": ya_plus_crown,
  "ya-plus-simple": ya_plus_simple,
  "yandex-browser": yandex_browser,
  "yandex-gpt": yandex_gpt,
  "yandex-plus-circle": yandex_plus_circle
};

/***/ }),

/***/ 54157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  tI: () => (/* binding */ InputDeprecated),
  ac: () => (/* binding */ InputHeight),
  fz: () => (/* binding */ InputSize),
  x2: () => (/* binding */ InputStyle)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 4 modules
var react_textarea_autosize_browser_esm = __webpack_require__(92814);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/input-depricated/input-depricated.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_depricated_module = ({"input":"input-depricated-module__input--wtJQy","default-input":"input-depricated-module__default-input--xRezm","defaultInput":"input-depricated-module__default-input--xRezm","white-input":"input-depricated-module__white-input--x0wWW","whiteInput":"input-depricated-module__white-input--x0wWW","input-without-border":"input-depricated-module__input-without-border--mQCGc","inputWithoutBorder":"input-depricated-module__input-without-border--mQCGc","input-disable-resize":"input-depricated-module__input-disable-resize--mkkhf","inputDisableResize":"input-depricated-module__input-disable-resize--mkkhf","input-additional-padding-bottom":"input-depricated-module__input-additional-padding-bottom--kwv6i","inputAdditionalPaddingBottom":"input-depricated-module__input-additional-padding-bottom--kwv6i","input-without-paddings":"input-depricated-module__input-without-paddings--VH2SB","inputWithoutPaddings":"input-depricated-module__input-without-paddings--VH2SB","input-container-height":"input-depricated-module__input-container-height--BGB21","inputContainerHeight":"input-depricated-module__input-container-height--BGB21"});
;// CONCATENATED MODULE: ../ui-kit/src/input-depricated/input-depricated.component.tsx









var InputSize = /* @__PURE__ */(InputSize2 => {
  InputSize2[InputSize2["Small"] = 0] = "Small";
  return InputSize2;
})(InputSize || {});
const getFontClass = size => {
  if (size === 0 /* Small */) {
    return typography_module/* default */.Z.body2;
  }
};
var InputHeight = /* @__PURE__ */(InputHeight2 => {
  InputHeight2[InputHeight2["Auto"] = 0] = "Auto";
  InputHeight2[InputHeight2["Container"] = 1] = "Container";
  return InputHeight2;
})(InputHeight || {});
var InputStyle = /* @__PURE__ */(InputStyle2 => {
  InputStyle2[InputStyle2["Default"] = 0] = "Default";
  InputStyle2[InputStyle2["White"] = 1] = "White";
  return InputStyle2;
})(InputStyle || {});
const InputDeprecated = _ref => {
  let {
    type,
    multiline,
    height = 0 /* Auto */,
    autoFocus,
    size,
    value,
    maxLength,
    disableResize,
    additionalPaddingBottom,
    required,
    placeholder,
    readOnly,
    onChange,
    inputStyle = 0 /* Default */,
    withoutBorder,
    withoutPaddings = false
  } = _ref;
  const className = classnames_default()(getFontClass(size), input_depricated_module.input, {
    [input_depricated_module.defaultInput]: inputStyle === 0 /* Default */,
    [input_depricated_module.whiteInput]: inputStyle === 1 /* White */,
    [input_depricated_module.inputWithoutBorder]: withoutBorder,
    [input_depricated_module.inputWithoutPaddings]: withoutPaddings,
    [input_depricated_module.inputDisableResize]: disableResize,
    [input_depricated_module.inputAdditionalPaddingBottom]: additionalPaddingBottom,
    [input_depricated_module.inputContainerHeight]: height === 1 /* Container */
  });
  const handleChange = (0,react.useCallback)(e => {
    onChange(e.target.value);
  }, [onChange]);
  const commonParams = {
    maxLength,
    autoFocus,
    className,
    value,
    required,
    placeholder,
    readOnly,
    onChange: handleChange
  };
  if (multiline) {
    switch (height) {
      case 0 /* Auto */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(react_textarea_autosize_browser_esm/* default */.Z, {
          ...commonParams,
          minRows: 1
        });
      case 1 /* Container */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)("textarea", {
          ...commonParams
        });
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(height);
    }
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
    ...commonParams,
    type
  });
};

/***/ }),

/***/ 86198:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  o: () => (/* binding */ InputWithAutoWidth)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/array.utils.ts
var array_utils = __webpack_require__(96799);
// EXTERNAL MODULE: ../shared/src/getComponentSize.ts
var getComponentSize = __webpack_require__(52856);
// EXTERNAL MODULE: ../ui-kit/src/medium-input/medium-input.component.tsx + 1 modules
var medium_input_component = __webpack_require__(30355);
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/thin-input/thin-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const thin_input_module = ({"input-root":"thin-input-module__input-root--K8Z3M","inputRoot":"thin-input-module__input-root--K8Z3M","input-root-with-icon":"thin-input-module__input-root-with-icon--VnwQC","inputRootWithIcon":"thin-input-module__input-root-with-icon--VnwQC"});
;// CONCATENATED MODULE: ../ui-kit/src/thin-input/thin-input.component.tsx







const ThinInput = _ref => {
  let {
    classes = {},
    ...props
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(thin_input_module, classes);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(medium_input_component/* MediumInput */.m, {
    classes: {
      root: classNames.inputRoot,
      rootWithIcon: thin_input_module.inputRootWithIcon
    },
    fontStyle: typography_module/* default */.Z.body1,
    ...props
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/input-with-auto-width/input-with-auto-width.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_with_auto_width_module = ({"text-sizer":"input-with-auto-width-module__text-sizer--t4Ijj","textSizer":"input-with-auto-width-module__text-sizer--t4Ijj"});
;// CONCATENATED MODULE: ../ui-kit/src/input-with-auto-width/input-with-auto-width.component.tsx
















const ADDITIONAL_WIDTH = 2;
const INPUT_OFFSETS = 2 * (2 + 16);
const ICON_OFFSET = 4;
const EMPTY_INPUT_WIDTH = 80 - INPUT_OFFSETS - ADDITIONAL_WIDTH;
const InputWithAutoWidth = _ref => {
  let {
    value,
    placeholder,
    expectedValues = array_utils/* emptyStringArray */.sP,
    style,
    ...props
  } = _ref;
  const placeholderWidth = (0,react.useMemo)(() => placeholder === void 0 ? 0 : getTextWidth(placeholder, props.fontStyle), [placeholder, props.fontStyle]);
  const expectedValuesWidth = (0,react.useMemo)(() => expectedValues.map(v => getTextWidth(v, props.fontStyle)).reduce((a, b) => Math.max(a, b), 0), [expectedValues, props.fontStyle]);
  const valueWidth = (0,react.useMemo)(() => value === void 0 ? 0 : getTextWidth(value, props.fontStyle), [props.fontStyle, value]);
  const iconWidth = props.icon === void 0 ? 0 : (0,getComponentSize/* getComponentSize */.Z)(props.icon).width + ICON_OFFSET;
  const maxContentWidth = Math.max(placeholderWidth, expectedValuesWidth);
  const [emptyValueWidth, setEmptyValueWidth] = (0,react.useState)(maxContentWidth ? maxContentWidth : EMPTY_INPUT_WIDTH);
  const width = (0,react.useMemo)(() => (valueWidth > emptyValueWidth ? valueWidth : emptyValueWidth) + iconWidth + INPUT_OFFSETS + ADDITIONAL_WIDTH, [emptyValueWidth, iconWidth, valueWidth]);
  const cmpStyle = (0,react.useMemo)(() => ({
    ...(style ?? {}),
    width: `min(${width}px, 100%)`,
    maxWidth: "100%"
  }), [style, width]);
  const handleBlur = (0,react.useCallback)(() => {
    setEmptyValueWidth(prev => valueWidth ? 0 : prev);
  }, [valueWidth]);
  (0,react.useEffect)(() => {
    if (valueWidth === 0 && emptyValueWidth === 0) {
      setEmptyValueWidth(maxContentWidth ? maxContentWidth : EMPTY_INPUT_WIDTH);
    }
  }, [emptyValueWidth, maxContentWidth, valueWidth]);
  (0,react.useEffect)(() => {
    if (props.disabled) {
      handleBlur();
    }
  }, [handleBlur, props.disabled]);
  if (props.height === "thin") {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ThinInput, {
      onBlur: handleBlur,
      value,
      placeholder,
      style: cmpStyle,
      ...props
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(medium_input_component/* MediumInput */.m, {
    onBlur: handleBlur,
    value,
    placeholder,
    style: cmpStyle,
    ...props
  });
};
const getTextWidth = function (text) {
  let fontStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : typography_module/* default */.Z.body1;
  return (0,getComponentSize/* getComponentSize */.Z)( /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(input_with_auto_width_module.textSizer, fontStyle),
    children: text
  })).width;
};

/***/ }),

/***/ 16455:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  II: () => (/* binding */ Input),
  fz: () => (/* binding */ InputSize),
  Xz: () => (/* binding */ InputStatus),
  RK: () => (/* binding */ InputTheme)
});

// UNUSED EXPORTS: InputType

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.delete-all.js
var esnext_map_delete_all = __webpack_require__(61601);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.emplace.js
var esnext_map_emplace = __webpack_require__(35068);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.every.js
var esnext_map_every = __webpack_require__(21027);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.filter.js
var esnext_map_filter = __webpack_require__(35788);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find.js
var esnext_map_find = __webpack_require__(86023);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.find-key.js
var esnext_map_find_key = __webpack_require__(7935);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.includes.js
var esnext_map_includes = __webpack_require__(13418);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.key-of.js
var esnext_map_key_of = __webpack_require__(9185);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-keys.js
var esnext_map_map_keys = __webpack_require__(48813);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.map-values.js
var esnext_map_map_values = __webpack_require__(5228);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.merge.js
var esnext_map_merge = __webpack_require__(46085);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.reduce.js
var esnext_map_reduce = __webpack_require__(27886);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.some.js
var esnext_map_some = __webpack_require__(94734);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.map.update.js
var esnext_map_update = __webpack_require__(73919);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/loader/loader.component.tsx + 2 modules
var loader_component = __webpack_require__(41178);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/input/input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const input_module = ({"input-wrapper":"input-module__input-wrapper--lOSUg","inputWrapper":"input-module__input-wrapper--lOSUg","input-wrapper-small":"input-module__input-wrapper-small--PCpsA","inputWrapperSmall":"input-module__input-wrapper-small--PCpsA","root":"input-module__root--bZwVH","root-small":"input-module__root-small--OPsZK","rootSmall":"input-module__root-small--OPsZK","root-light":"input-module__root-light--Eqr4z","rootLight":"input-module__root-light--Eqr4z","root-error":"input-module__root-error--QkBgT","rootError":"input-module__root-error--QkBgT","root-warning":"input-module__root-warning--jaqCX","rootWarning":"input-module__root-warning--jaqCX","root-success":"input-module__root-success--WuCu5","rootSuccess":"input-module__root-success--WuCu5","root-grey":"input-module__root-grey--Zls3e","rootGrey":"input-module__root-grey--Zls3e","root-with-icon":"input-module__root-with-icon--rT1bQ","rootWithIcon":"input-module__root-with-icon--rT1bQ","root-with-start-icon":"input-module__root-with-start-icon--gF9gp","rootWithStartIcon":"input-module__root-with-start-icon--gF9gp","start-icon-wrapper":"input-module__start-icon-wrapper--MbayU","startIconWrapper":"input-module__start-icon-wrapper--MbayU","icon-wrapper":"input-module__icon-wrapper--uVxKp","iconWrapper":"input-module__icon-wrapper--uVxKp","icon-success":"input-module__icon-success--F2j8R","iconSuccess":"input-module__icon-success--F2j8R","icon-warning":"input-module__icon-warning--aZm3Y","iconWarning":"input-module__icon-warning--aZm3Y","hint":"input-module__hint--F4Gt6","hint-error":"input-module__hint-error--FQetA","hintError":"input-module__hint-error--FQetA","hint-warning":"input-module__hint-warning--wzo7t","hintWarning":"input-module__hint-warning--wzo7t"});
;// CONCATENATED MODULE: ../ui-kit/src/input/input.component.tsx























var InputSize = /* @__PURE__ */(InputSize2 => {
  InputSize2["Medium"] = "medium";
  InputSize2["Small"] = "small";
  return InputSize2;
})(InputSize || {});
var InputTheme = /* @__PURE__ */(InputTheme2 => {
  InputTheme2["Default"] = "light";
  InputTheme2["Grey"] = "grey";
  return InputTheme2;
})(InputTheme || {});
var InputType = /* @__PURE__ */(InputType2 => {
  InputType2["Default"] = "text";
  InputType2["Number"] = "number";
  InputType2["Email"] = "email";
  InputType2["Tel"] = "tel";
  return InputType2;
})(InputType || {});
var InputStatus = /* @__PURE__ */(InputStatus2 => {
  InputStatus2["Default"] = "default";
  InputStatus2["Success"] = "success";
  InputStatus2["Error"] = "error";
  InputStatus2["Warning"] = "warning";
  InputStatus2["Loading"] = "loading";
  return InputStatus2;
})(InputStatus || {});
const iconNames = /* @__PURE__ */new Map([["success" /* Success */, "checkmark-bold"], ["warning" /* Warning */, "warning"]]);
const Input = _ref => {
  let {
    inputSize = "medium" /* Medium */,
    type = "text" /* Default */,
    placeholder,
    disabled = false,
    textConstants,
    status = "default" /* Default */,
    autoFocus = false,
    theme = "light" /* Default */,
    iconName,
    ...inputProps
  } = _ref;
  const inputRef = (0,react.useRef)(null);
  const inputIcon = iconNames.get(status);
  const hintText = textConstants?.hint?.[status];
  (0,react.useEffect)(() => {
    if (autoFocus) {
      inputRef.current?.focus({
        preventScroll: true
      });
    }
  }, [autoFocus]);
  (0,react.useEffect)(() => {
    if (disabled && inputRef.current) {
      inputRef.current.blur();
    }
  }, [disabled]);
  const renderIcon = () => {
    if (status === "loading" /* Loading */) {
      return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: input_module.iconWrapper,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(loader_component/* Loader */.aN, {
          size: loader_component/* LoaderSize */.gI.Small
        })
      });
    }
    if (!inputIcon) {
      return;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: input_module.iconWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: classnames_default()({
          [input_module.iconSuccess]: status === "success" /* Success */,
          [input_module.iconWarning]: status === "warning" /* Warning */
        }),
        name: inputIcon,
        size: "small"
      })
    });
  };
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(input_module.inputWrapper, {
      [input_module.inputWrapperSmall]: inputSize === "small" /* Small */
    }),
    children: [iconName && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: input_module.startIconWrapper,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        size: "small",
        name: iconName
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      ...inputProps,
      value: inputProps.value ?? "",
      type,
      spellCheck: false,
      placeholder,
      autoComplete: "off",
      className: classnames_default()(input_module.root, typography_module/* default */.Z.body2, {
        [input_module.rootSmall]: inputSize === "small" /* Small */,
        [input_module.rootError]: status === "error" /* Error */,
        [input_module.rootWarning]: status === "warning" /* Warning */,
        [input_module.rootWithIcon]: inputIcon,
        [input_module.rootWithStartIcon]: Boolean(iconName),
        [input_module.rootLight]: theme === "light" /* Default */,
        [input_module.rootGrey]: theme === "grey" /* Grey */
      }),
      disabled,
      ref: inputRef
    }), renderIcon(), hintText && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(input_module.hint, typography_module/* default */.Z.caption, {
        [input_module.hintError]: status === "error" /* Error */,
        [input_module.hintWarning]: status === "warning" /* Warning */
      }),
      children: hintText
    })]
  });
};

/***/ }),

/***/ 53584:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ Layout)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui-kit/src/layout/layout.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const layout_module = ({"root":"layout-module__root--lhKZX","content":"layout-module__content--ofxuC","content-without-horizontal-margin":"layout-module__content-without-horizontal-margin--L8zRM","contentWithoutHorizontalMargin":"layout-module__content-without-horizontal-margin--L8zRM"});
;// CONCATENATED MODULE: ../ui-kit/src/layout/layout.component.tsx





const Layout = _ref => {
  let {
    disableHorizontalMargin,
    className,
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(layout_module.root, className),
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(layout_module.content, {
        [layout_module.contentWithoutHorizontalMargin]: disableHorizontalMargin
      }),
      children
    })
  });
};

/***/ }),

/***/ 41178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  aN: () => (/* binding */ Loader),
  Fz: () => (/* binding */ LoaderCenter),
  f4: () => (/* binding */ LoaderCenterDelay),
  Wv: () => (/* binding */ LoaderDelay),
  gI: () => (/* binding */ LoaderSize)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/app/use-did-mount.ts
var use_did_mount = __webpack_require__(73058);
;// CONCATENATED MODULE: ../shared/src/hocs/withRenderDelay.tsx





function withRenderDelay(WrappedComponent) {
  return function WithRenderDelay(props) {
    let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    const [visible, setVisible] = (0,react.useState)(false);
    (0,use_did_mount/* useDidMount */.H)(() => {
      const timerId = setTimeout(() => setVisible(true), delay);
      return () => clearTimeout(timerId);
    });
    if (!visible) {
      return null;
    }
    return /* @__PURE__ */(0,jsx_runtime.jsx)(WrappedComponent, {
      ...props
    });
  };
}
;// CONCATENATED MODULE: ../ui-kit/src/loader/loader.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const loader_module = ({"root":"loader-module__root--E5806","rotation":"loader-module__rotation--r68Hd","circle":"loader-module__circle--aMVyD","circle-current-color":"loader-module__circle-current-color--hcsZd","circleCurrentColor":"loader-module__circle-current-color--hcsZd","loader-center-wrapper":"loader-module__loader-center-wrapper--XNW6K","loaderCenterWrapper":"loader-module__loader-center-wrapper--XNW6K"});
;// CONCATENATED MODULE: ../ui-kit/src/loader/loader.component.tsx







var LoaderSize = /* @__PURE__ */(LoaderSize2 => {
  LoaderSize2["Default"] = "medium";
  LoaderSize2["Small"] = "small";
  return LoaderSize2;
})(LoaderSize || {});
const Loader = _ref => {
  let {
    size = "medium" /* Default */,
    isCurrentColor = false,
    className
  } = _ref;
  const circleClassName = isCurrentColor ? loader_module.circleCurrentColor : loader_module.circle;
  switch (size) {
    case "medium" /* Default */:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("svg", {
        "data-testid": "loader",
        className: classnames_default()(loader_module.root, className),
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
          d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2",
          className: circleClassName,
          strokeWidth: "2",
          strokeLinecap: "round"
        })
      });
    case "small" /* Small */:
      return /* @__PURE__ */(0,jsx_runtime.jsx)("svg", {
        "data-testid": "loader",
        className: classnames_default()(loader_module.root, className),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */(0,jsx_runtime.jsx)("path", {
          d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1",
          className: circleClassName,
          strokeWidth: "2",
          strokeLinecap: "round"
        })
      });
    default:
      throw new unhandled_case/* UnhandledCaseError */.H(size);
  }
};
const LoaderCenter = _ref2 => {
  let {
    marginTop,
    className
  } = _ref2;
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(loader_module.loaderCenterWrapper, className),
    style: {
      marginTop: marginTop ?? 250
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(Loader, {})
  });
};
const LoaderDelay = withRenderDelay(Loader);
const LoaderCenterDelay = withRenderDelay(LoaderCenter);

/***/ }),

/***/ 43539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  fB: () => (/* binding */ CustomSimpleMarkdown),
  UG: () => (/* binding */ Markdown),
  im: () => (/* binding */ Wrapper)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
// EXTERNAL MODULE: ../ui-kit/src/markdown/rules/link-rule.tsx
var link_rule = __webpack_require__(2510);
// EXTERNAL MODULE: ../ui-kit/src/markdown/rules/spoiler-rule.tsx + 3 modules
var spoiler_rule = __webpack_require__(1225);
// EXTERNAL MODULE: ../ui-kit/src/markdown/rules/target-blank-link-rule.tsx
var target_blank_link_rule = __webpack_require__(86524);
;// CONCATENATED MODULE: ../ui-kit/src/markdown/markdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const markdown_module = ({"root":"markdown-module__root--O5jJU"});
;// CONCATENATED MODULE: ../ui-kit/src/markdown/markdown.component.tsx










const CustomSimpleMarkdown = (simple_markdown_default());
var Wrapper = /* @__PURE__ */(Wrapper2 => {
  Wrapper2["span"] = "span";
  Wrapper2["div"] = "div";
  Wrapper2["fragment"] = "fragment";
  return Wrapper2;
})(Wrapper || {});
const Markdown = _ref => {
  let {
    wrapper = "div" /* div */,
    children,
    rules,
    className,
    inline,
    internalState = {},
    isDarkMode = false
  } = _ref;
  const extendedRules = (0,react.useMemo)(() => ({
    ...(simple_markdown_default()).defaultRules,
    targetBlankLink: (0,target_blank_link_rule/* targetBlankLinkRule */.S)({
      isDarkMode
    }),
    link: (0,link_rule/* linkRule */.t)({
      isDarkMode
    }),
    spoiler: spoiler_rule/* spoilerRule */.h,
    ...rules
  }), [isDarkMode, rules]);
  const parser = (0,react.useMemo)(() => simple_markdown_default().parserFor(extendedRules), [extendedRules]);
  const reactOutput = (0,react.useMemo)(() => CustomSimpleMarkdown.reactFor(CustomSimpleMarkdown.ruleOutput(extendedRules, "react")), [extendedRules]);
  switch (wrapper) {
    case "div" /* div */:
    default:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(className, markdown_module.root),
          children: reactOutput(parser(children, {
            inline,
            ...internalState
          }))
        });
      }
    case "span" /* span */:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(className, markdown_module.root),
          children: reactOutput(parser(children, {
            inline,
            ...internalState
          }))
        });
      }
    case "fragment" /* fragment */:
      {
        return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: reactOutput(parser(children, {
            inline,
            ...internalState
          }))
        });
      }
  }
};

/***/ }),

/***/ 30095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: () => (/* binding */ TARGET_BLANK_LINK),
/* harmony export */   EM: () => (/* binding */ EM),
/* harmony export */   Up: () => (/* binding */ TRANSLATION_SYNTAX_REGEXP),
/* harmony export */   Zj: () => (/* binding */ LINK),
/* harmony export */   fU: () => (/* binding */ DEL),
/* harmony export */   jV: () => (/* binding */ STRONG),
/* harmony export */   lD: () => (/* binding */ TEXT),
/* harmony export */   qQ: () => (/* binding */ SPOILER_REGEXP),
/* harmony export */   vk: () => (/* binding */ WORD)
/* harmony export */ });
/* unused harmony exports SPACES, PUNCTUATION_MARKS_AFTER_WORD, PUNCTUATION_MARKS_BEFORE_WORD */


const SPACES = /[\s\u00a0]*/;
const PUNCTUATION_MARKS_AFTER_WORD = /[\u201c\u201d\u0022\u00bb\u2019\/)'°$,.!?%:;-]*/;
const PUNCTUATION_MARKS_BEFORE_WORD = new RegExp(SPACES.source + /[({|~'°#@$№\/\[\u201c\u0022\u00ab\u2019\u2014]*/.source);
const TEXT = /^[\s\S]+?(?=[^\s0-9\u00c0-\uffff!?"#$%&'()+-.,;:=~@^\\\/|\]]|\n\n| {2,}\n|\w+:\S|$)/;
const EM = new RegExp(
// only match _s surrounding words.
`^\\b_((?:__|\\\\[\\s\\S]|[^\\\\_])+?)_\\b|^(${PUNCTUATION_MARKS_BEFORE_WORD.source})\\*(?=\\S)((?:\\*\\*|\\\\[\\s\\S]|\\s+(?:\\\\[\\s\\S]|[^\\s\\*\\\\]|\\*\\*)|[^\\s\\*\\\\])+?)\\*(?!\\*)(${PUNCTUATION_MARKS_AFTER_WORD.source})(${SPACES.source})`);
const STRONG = new RegExp("^(" + PUNCTUATION_MARKS_BEFORE_WORD.source + ")" + /\*\*((?:\\[\s\S]|[^\\])+?)\*\*(?!\*)/.source + `(${PUNCTUATION_MARKS_AFTER_WORD.source})(${SPACES.source})`);
const DEL = new RegExp("^(" + PUNCTUATION_MARKS_BEFORE_WORD.source + ")" + /~~(?=\S)((?:\\[\s\S]|~(?!~)|[^\s~]|\s(?!~~))+?)~~/.source + `(${PUNCTUATION_MARKS_AFTER_WORD.source})(${SPACES.source})`);
const ENGLISH_SYMBOLS = "[A-Za-z\xE4]+";
const WORD = new RegExp("^(" + PUNCTUATION_MARKS_BEFORE_WORD.source + ")(" + ENGLISH_SYMBOLS + "['\u2019]*" + ENGLISH_SYMBOLS + "|" + ENGLISH_SYMBOLS + `)(${PUNCTUATION_MARKS_AFTER_WORD.source})(${SPACES.source})`);
const TRANSLATION_SYNTAX_REGEXP = new RegExp("^(" + PUNCTUATION_MARKS_BEFORE_WORD.source + ")" + /\[([^|]+)\|([^|]+)]/.source + `(${PUNCTUATION_MARKS_AFTER_WORD.source})(${SPACES.source})`);
const TARGET_BLANK_LINK = new RegExp("^(" + PUNCTUATION_MARKS_BEFORE_WORD.source + `)(\\[.*?])(\\(.*?\\))(\\{:.*?=.*?})(${PUNCTUATION_MARKS_AFTER_WORD.source})(${SPACES.source})`);
const LINK = /(\[.*])(\(.*\))/;
const SPOILER_REGEXP = /^!>(?:[^\n]*?\n)+?(?:\n+)*(?=!<\n)!<\n/;

/***/ }),

/***/ 2510:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: () => (/* binding */ linkRule)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var simple_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24031);
/* harmony import */ var simple_markdown__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(simple_markdown__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _link_rule_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77373);






const linkRule = _ref => {
  let {
    isDarkMode
  } = _ref;
  return {
    order: (simple_markdown__WEBPACK_IMPORTED_MODULE_2___default().defaultRules).link.order,
    match: (simple_markdown__WEBPACK_IMPORTED_MODULE_2___default().defaultRules).link.match,
    parse: (simple_markdown__WEBPACK_IMPORTED_MODULE_2___default().defaultRules).link.parse,
    react: (node, output, state) => {
      const {
        target,
        content,
        title
      } = node;
      const href = (0,simple_markdown__WEBPACK_IMPORTED_MODULE_2__.sanitizeUrl)(target);
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href || void 0,
        title,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_link_rule_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.link, _link_rule_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.linkText, {
          [_link_rule_module_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.darkMode]: isDarkMode
        }),
        children: output(content, state)
      }, href);
    }
  };
};

/***/ }),

/***/ 1225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  h: () => (/* binding */ spoilerRule)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/simple-markdown/simple-markdown.js
var simple_markdown = __webpack_require__(24031);
var simple_markdown_default = /*#__PURE__*/__webpack_require__.n(simple_markdown);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/text-spoiler/text-spoiler.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_spoiler_module = ({"root":"text-spoiler-module__root--Wmaj8","summary":"text-spoiler-module__summary--zHcHM","icon":"text-spoiler-module__icon--M6Xv5","text":"text-spoiler-module__text--TomgI","text-without-title":"text-spoiler-module__text-without-title--r5Vnl","textWithoutTitle":"text-spoiler-module__text-without-title--r5Vnl"});
;// CONCATENATED MODULE: ../ui-kit/src/text-spoiler/text-spoiler.component.tsx







const TextSpoiler = _ref => {
  let {
    title,
    children
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("details", {
    className: text_spoiler_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("summary", {
      className: classnames_default()(typography_module/* default */.Z.body1Accent, text_spoiler_module.summary),
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
        className: text_spoiler_module.icon,
        name: "chevron-down",
        size: "medium"
      }), title]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: classnames_default()(text_spoiler_module.text, {
        [text_spoiler_module.textWithoutTitle]: !title
      }),
      children
    })]
  });
};
// EXTERNAL MODULE: ../ui-kit/src/markdown/regexp.ts
var regexp = __webpack_require__(30095);
;// CONCATENATED MODULE: ../ui-kit/src/markdown/rules/spoiler-rule.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const spoiler_rule_module = ({"spoiler":"spoiler-rule-module__spoiler--G7gqF"});
;// CONCATENATED MODULE: ../ui-kit/src/markdown/rules/spoiler-rule.tsx







const spoilerRule = {
  order: (simple_markdown_default()).defaultRules.paragraph.order - 0.5,
  match: simple_markdown_default().blockRegex(regexp/* SPOILER_REGEXP */.qQ),
  parse(capture, parser, state) {
    const content = capture[0].replace(/^!>/, "").replace(/\n!<\n$/, "").split("\n");
    const innerContent = content.slice(1).join("\n");
    const title = content[0].replace(/^!/, "");
    const innerItems = (0,simple_markdown.parseBlock)(parser, innerContent, state);
    return {
      title,
      innerItems
    };
  },
  react(node, output, state) {
    const {
      title,
      innerItems
    } = node;
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: spoiler_rule_module.spoiler,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(TextSpoiler, {
        title,
        children: output(innerItems, state)
      })
    });
  }
};

/***/ }),

/***/ 86524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: () => (/* binding */ targetBlankLinkRule)
/* harmony export */ });
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32930);
/* harmony import */ var core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_async_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75183);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19259);
/* harmony import */ var core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_reduce_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2784);
/* harmony import */ var simple_markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24031);
/* harmony import */ var simple_markdown__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(simple_markdown__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _yandex_langly_ui_kit_src_icons_icons_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33370);
/* harmony import */ var _regexp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30095);
/* harmony import */ var _link_rule_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77373);












const targetBlankLinkRule = _ref => {
  let {
    isDarkMode
  } = _ref;
  return {
    order: (simple_markdown__WEBPACK_IMPORTED_MODULE_6___default().defaultRules).link.order - 1,
    match: simple_markdown__WEBPACK_IMPORTED_MODULE_6___default().inlineRegex(_regexp__WEBPACK_IMPORTED_MODULE_8__/* .TARGET_BLANK_LINK */ .$6),
    parse(capture) {
      return {
        beforeContent: capture[1],
        text: capture[2].replace("[", "").replace("]", ""),
        url: capture[3].replace("(", "").replace(")", ""),
        attr: capture[4].replace("{", "").replace("}", "").split(":").reduce((acc, item) => {
          const [key, value] = item.split("=");
          return {
            ...acc,
            [key]: value
          };
        }, {}),
        afterContent: capture[5] + capture[6]
      };
    },
    react: node => {
      const {
        beforeContent,
        text,
        url,
        attr,
        afterContent
      } = node;
      const isTargetBlank = attr.target === "blank" || attr.target === "_blank";
      const ExternalLinkIcon = _yandex_langly_ui_kit_src_icons_icons_model__WEBPACK_IMPORTED_MODULE_7__/* .icons */ .c["external-link"];
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
        children: [beforeContent, /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
          ...attr,
          href: url,
          className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(_link_rule_module_css__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.link, {
            [_link_rule_module_css__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.darkMode]: isDarkMode
          }),
          children: [/* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: _link_rule_module_css__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.linkText,
            children: text
          }), isTargetBlank && /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ExternalLinkIcon, {
            className: _link_rule_module_css__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.externalLinkIcon
          })]
        }), afterContent]
      }, url);
    }
  };
};

/***/ }),

/***/ 30355:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  m: () => (/* binding */ MediumInput),
  _: () => (/* binding */ MediumInputStatus)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 4 modules
var react_textarea_autosize_browser_esm = __webpack_require__(92814);
// EXTERNAL MODULE: ../shared/src/errors/models/unhandled-case.ts
var unhandled_case = __webpack_require__(79106);
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/medium-input/medium-input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const medium_input_module = ({"relative-container":"medium-input-module__relative-container--JHXYS","relativeContainer":"medium-input-module__relative-container--JHXYS","root":"medium-input-module__root--jxzJh","root-with-icon":"medium-input-module__root-with-icon--_Qizp","rootWithIcon":"medium-input-module__root-with-icon--_Qizp","root-success":"medium-input-module__root-success--C6Gni","rootSuccess":"medium-input-module__root-success--C6Gni","root-error":"medium-input-module__root-error--jCjnb","rootError":"medium-input-module__root-error--jCjnb","root-typo":"medium-input-module__root-typo--VwiFd","rootTypo":"medium-input-module__root-typo--VwiFd","root-selected":"medium-input-module__root-selected--fGgiN","rootSelected":"medium-input-module__root-selected--fGgiN","icon":"medium-input-module__icon--z9oH3"});
;// CONCATENATED MODULE: ../ui-kit/src/medium-input/medium-input.component.tsx










var MediumInputStatus = /* @__PURE__ */(MediumInputStatus2 => {
  MediumInputStatus2["Success"] = "success";
  MediumInputStatus2["Error"] = "error";
  MediumInputStatus2["Typo"] = "typo";
  MediumInputStatus2["Default"] = "default";
  MediumInputStatus2["Selected"] = "selected";
  return MediumInputStatus2;
})(MediumInputStatus || {});
const MediumInput = _ref => {
  let {
    placeholder,
    classes = {},
    disabled = false,
    status = "default" /* Default */,
    autoFocus = false,
    isMultiline = false,
    fontStyle = typography_module/* default */.Z.headline4,
    icon,
    style,
    ...inputProps
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(medium_input_module, classes);
  const inputRef = (0,react.useRef)(null);
  const statusesMapper = status2 => {
    switch (status2) {
      case "success" /* Success */:
        return classNames.rootSuccess;
      case "error" /* Error */:
        return classNames.rootError;
      case "selected" /* Selected */:
        return classNames.rootSelected;
      case "typo" /* Typo */:
        return classNames.rootTypo;
      case "default" /* Default */:
        return classNames.root;
      default:
        throw new unhandled_case/* UnhandledCaseError */.H(status2);
    }
  };
  (0,react.useEffect)(() => {
    if (autoFocus) {
      inputRef.current?.focus({
        preventScroll: true
      });
    }
  }, [autoFocus]);
  (0,react.useEffect)(() => {
    if (disabled && inputRef.current) {
      inputRef.current.blur();
    }
  }, [disabled]);
  const textareaRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (disabled) {
      textareaRef.current?.blur();
    }
  }, [disabled]);
  if (isMultiline) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)(react_textarea_autosize_browser_esm/* default */.Z, {
      spellCheck: false,
      minRows: 1,
      autoComplete: "off",
      placeholder,
      className: classnames_default()(classNames.root, fontStyle, statusesMapper(status)),
      disabled,
      ref: textareaRef,
      value: String(inputProps.value ?? ""),
      onChange: inputProps.onChange
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    style,
    className: medium_input_module.relativeContainer,
    children: [icon && /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: medium_input_module.icon,
      children: icon
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      ...inputProps,
      style,
      value: inputProps.value || "",
      type: "text",
      spellCheck: false,
      placeholder,
      autoComplete: "off",
      className: classnames_default()(classNames.root, fontStyle, statusesMapper(status), {
        [classNames.rootWithIcon]: icon
      }),
      disabled,
      ref: inputRef
    })]
  });
};

/***/ }),

/***/ 80388:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  u_: () => (/* reexport */ Modal),
  hz: () => (/* reexport */ ModalContent),
  s7: () => (/* reexport */ ModalContentPosition),
  Cg: () => (/* reexport */ ModalSize),
  WR: () => (/* reexport */ TinyModal),
  Jj: () => (/* reexport */ TitleSize),
  vR: () => (/* reexport */ useModalContext)
});

// UNUSED EXPORTS: ModalContentButton, ModalContentProps, ModalProps

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/focus-trap-react/dist/focus-trap-react.js
var focus_trap_react = __webpack_require__(79553);
var focus_trap_react_default = /*#__PURE__*/__webpack_require__.n(focus_trap_react);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
// EXTERNAL MODULE: ../ui-kit/src/button/button-link.component.tsx
var button_link_component = __webpack_require__(66284);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
;// CONCATENATED MODULE: ../ui-kit/src/modal/constants.ts


var ModalSize = /* @__PURE__ */(ModalSize2 => {
  ModalSize2["Small"] = "small";
  ModalSize2["Big"] = "big";
  ModalSize2["Huge"] = "huge";
  return ModalSize2;
})(ModalSize || {});
var ModalContentPosition = /* @__PURE__ */(ModalContentPosition2 => {
  ModalContentPosition2["Default"] = "default";
  ModalContentPosition2["Center"] = "center";
  return ModalContentPosition2;
})(ModalContentPosition || {});
var TitleSize = /* @__PURE__ */(TitleSize2 => {
  TitleSize2["Small"] = "small";
  TitleSize2["Big"] = "big";
  return TitleSize2;
})(TitleSize || {});
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
;// CONCATENATED MODULE: ../ui-kit/src/modal/modal-context.ts




const ModalContext = (0,react.createContext)({
  onClose: function_utils/* emptyFunction */.Bi
});
const useModalContext = () => (0,react.useContext)(ModalContext);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.object.has-own.js
var es_object_has_own = __webpack_require__(20110);
;// CONCATENATED MODULE: ../ui-kit/src/modal/utils.ts



const checkButtonType = button => typeof button === "object" && button !== null && Object.hasOwn(button, "text") && Object.hasOwn(button, "appearance");
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/modal/modal.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const modal_module = ({"overlay":"modal-module__overlay--r8GTM","narrow-overlay":"modal-module__narrow-overlay--MXAUX","narrowOverlay":"modal-module__narrow-overlay--MXAUX","dark-overlay":"modal-module__dark-overlay--Jhils","darkOverlay":"modal-module__dark-overlay--Jhils","modal":"modal-module__modal--NFo2d","mobile":"modal-module__mobile--R9EC1","modal-scrollable":"modal-module__modal-scrollable--HiEYO","modalScrollable":"modal-module__modal-scrollable--HiEYO","scroll":"modal-module__scroll--AQggl","small":"modal-module__small--XVO9M","big":"modal-module__big--tYxTM","huge":"modal-module__huge--bKdcR","center":"modal-module__center--gidAh","top-space":"modal-module__top-space--XfH2S","topSpace":"modal-module__top-space--XfH2S","close-icon":"modal-module__close-icon--x0V8W","closeIcon":"modal-module__close-icon--x0V8W","image":"modal-module__image--L5jPm","title":"modal-module__title--R8jz_","subtitle":"modal-module__subtitle--GCRiM","subtitle-with-big-margin":"modal-module__subtitle-with-big-margin--xb0rQ","subtitleWithBigMargin":"modal-module__subtitle-with-big-margin--xb0rQ","modal-content":"modal-module__modal-content--UNZeT","modalContent":"modal-module__modal-content--UNZeT","buttons":"modal-module__buttons--_4uKb","button":"modal-module__button--UeZBf","stretch-buttons":"modal-module__stretch-buttons--ZZK6s","stretchButtons":"modal-module__stretch-buttons--ZZK6s","modal-overflow-auto":"modal-module__modal-overflow-auto--NVsvK","modalOverflowAuto":"modal-module__modal-overflow-auto--NVsvK","top-shadow":"modal-module__top-shadow--A7Acp","topShadow":"modal-module__top-shadow--A7Acp"});
;// CONCATENATED MODULE: ../ui-kit/src/modal/modal-content.tsx


















const ModalContent = (0,react.memo)(_ref => {
  let {
    size = ModalSize.Big,
    contentPosition = ModalContentPosition.Default,
    buttonsBlockStretch = false,
    headerImage,
    title = null,
    titleSize = TitleSize.Big,
    subtitle = null,
    buttons = null,
    showCloseButton = false,
    closeButtonAriaLabel = "Close",
    children
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const {
    onClose
  } = useModalContext();
  const [buttonsHeight, setButtonsHeight] = (0,react.useState)(0);
  const titleFont = titleSize === TitleSize.Small ? typography_module/* default */.Z.body1Accent : typography_module/* default */.Z.headline4Accent;
  const isScrollable = (0,react.useMemo)(() => size === ModalSize.Huge, [size]);
  const [scrolled, setScrolled] = (0,react.useState)(false);
  const handleScroll = (0,react.useCallback)(e => {
    const top = e.currentTarget.scrollTop;
    setScrolled(top > 0);
  }, []);
  const stopPropagation = (0,react.useCallback)(event => event.stopPropagation(), []);
  const isCloseButtonVisible = showCloseButton || isMobile;
  const titleId = (0,react.useId)();
  const descriptionId = (0,react.useId)();
  const childrenId = (0,react.useId)();
  const dialogRef = (0,react.useRef)(null);
  const overflowAuto = window.innerHeight - (dialogRef.current?.clientHeight || 0) < 50;
  return /* @__PURE__ */(0,jsx_runtime.jsx)((focus_trap_react_default()), {
    focusTrapOptions: {
      initialFocus: false,
      allowOutsideClick: true
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": titleId,
      "aria-describedby": [descriptionId, childrenId].join(),
      "data-testid": "modal",
      className: classnames_default()(modal_module.modal, modal_module[size], {
        [modal_module.modalScrollable]: isScrollable,
        [modal_module.center]: contentPosition === ModalContentPosition.Center,
        [modal_module.modalOverflowAuto]: overflowAuto,
        [modal_module.mobile]: isMobile
      }),
      onClick: stopPropagation,
      onScroll: handleScroll,
      style: {
        "--buttons-height": `${buttonsHeight}px`
      },
      ref: dialogRef,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(ScrollableContainer, {
        isScrollable,
        children: [isCloseButtonVisible && /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: modal_module.topSpace
          }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: modal_module.topShadow
          })]
        }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
          onClick: onClose,
          className: classnames_default()(modal_module.closeIcon, {
            [accessibility_module/* default */.Z.showOnlyFocused]: !isCloseButtonVisible
          }),
          appearance: scrolled ? "floating" : "secondary",
          size: "small",
          iconName: "cross",
          "aria-label": closeButtonAriaLabel
        }), headerImage && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          className: modal_module.image,
          children: headerImage
        }), title !== null && /* @__PURE__ */(0,jsx_runtime.jsx)("h1", {
          id: titleId,
          className: classnames_default()(titleFont, modal_module.title),
          children: title
        }), subtitle !== null && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          id: descriptionId,
          className: classnames_default()(typography_module/* default */.Z.body2, modal_module.subtitle, {
            [modal_module.subtitleWithBigMargin]: !children
          }),
          children: subtitle
        }), children && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          id: childrenId,
          className: classnames_default()({
            [modal_module.modalContent]: buttons
          }),
          children
        }), buttons !== null && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
          ref: element => {
            if (element === null) {
              return;
            }
            setButtonsHeight(element?.getBoundingClientRect().height);
          },
          className: classnames_default()(modal_module.buttons, {
            [modal_module.stretchButtons]: buttonsBlockStretch
          }),
          children: buttons.map((button, index) => {
            if (!checkButtonType(button)) {
              return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: modal_module.button,
                children: button
              }, `button${index}`);
            }
            if (button.href) {
              return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
                className: modal_module.button,
                children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_link_component/* ButtonLink */.Z, {
                  appearance: button.appearance,
                  target: "_blank",
                  href: button.href,
                  onClick: onClose,
                  useNativeTag: button.useNativeTag,
                  children: button.text
                })
              }, button.text);
            }
            return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
              className: modal_module.button,
              children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_component/* Button */.z, {
                size: "medium",
                ...button,
                loading: button.loading?.isLoading ?? false,
                children: button.text
              })
            }, button.text);
          })
        })]
      })
    })
  });
});
const ScrollableContainer = (0,react.memo)(function ScrollableContainer2(_ref2) {
  let {
    isScrollable,
    children
  } = _ref2;
  return isScrollable ? /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    className: modal_module.scroll,
    children
  }) : /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children
  });
});
ModalContent.displayName = "ModalContent";
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/react-transition-group/esm/CSSTransition.js + 7 modules
var CSSTransition = __webpack_require__(65274);
// EXTERNAL MODULE: ../shared/src/hooks/use-block-main-scroll.ts
var use_block_main_scroll = __webpack_require__(77062);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
;// CONCATENATED MODULE: ../ui-kit/src/modal/tiny-modal.tsx











const TinyModal = _ref => {
  let {
    isVisible = true,
    onClose,
    onClosed,
    isNarrow = false,
    children,
    overlay = "light"
  } = _ref;
  (0,useKeyPress/* useKeyPress */.K)("Escape", onClose);
  const modalContextValue = (0,react.useMemo)(() => ({
    onClose
  }), [onClose]);
  return (0,react_dom.createPortal)( /* @__PURE__ */(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
    in: isVisible,
    appear: true,
    unmountOnExit: true,
    onExited: onClosed,
    timeout: {
      enter: 0,
      exit: 300
    },
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [isVisible && /* @__PURE__ */(0,jsx_runtime.jsx)(use_block_main_scroll/* MainScrollBlocker */.j, {}), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        role: "presentation",
        className: classnames_default()(modal_module.overlay, {
          [modal_module.narrowOverlay]: isNarrow,
          [modal_module.darkOverlay]: overlay === "dark"
        }),
        onClick: onClose,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ModalContext.Provider, {
          value: modalContextValue,
          children
        })
      })]
    })
  }), document.body);
};
;// CONCATENATED MODULE: ../ui-kit/src/modal/modal.tsx





const Modal = _ref => {
  let {
    isVisible = true,
    isNarrow = false,
    onClose,
    onClosed,
    overlay,
    ...contentProps
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(TinyModal, {
    overlay,
    isVisible,
    isNarrow,
    onClose,
    onClosed,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ModalContent, {
      ...contentProps
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/modal/index.ts









/***/ }),

/***/ 31533:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L5: () => (/* binding */ ChildrenType),
/* harmony export */   WF: () => (/* binding */ CardState),
/* harmony export */   aY: () => (/* binding */ CardContent)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _yandex_langly_shared_src_errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79106);
/* harmony import */ var _yandex_langly_shared_src_string_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25680);
/* harmony import */ var _loader_loader_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41178);
/* harmony import */ var _markdown_markdown_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43539);
/* harmony import */ var _typography_typography_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11060);
/* harmony import */ var _card_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18367);











var CardState = /* @__PURE__ */(CardState2 => {
  CardState2["Loaded"] = "loaded";
  CardState2["Loading"] = "loading";
  CardState2["Error"] = "error";
  return CardState2;
})(CardState || {});
var ChildrenType = /* @__PURE__ */(ChildrenType2 => {
  ChildrenType2["Text"] = "text";
  ChildrenType2["Box"] = "box";
  return ChildrenType2;
})(ChildrenType || {});
const CardContent = _ref => {
  let {
    state,
    childrenType,
    children,
    errorText,
    isMobile
  } = _ref;
  const fontStyle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (isMobile) {
      return {
        contentFont: _typography_typography_module_css__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.body1
      };
    }
    return {
      contentFont: _typography_typography_module_css__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.body2
    };
  }, [isMobile]);
  const textLang = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => {
    if (childrenType === "text" /* Text */ && (0,_yandex_langly_shared_src_string_utils__WEBPACK_IMPORTED_MODULE_4__/* .isEnglishWord */ .t4)(typeof children === "string" ? children : "")) {
      return "en";
    }
    return "ru";
  }, [children, childrenType]);
  const loadedChildren = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(() => typeof children === "string" ? /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_markdown_markdown_component__WEBPACK_IMPORTED_MODULE_6__/* .Markdown */ .UG, {
    wrapper: _markdown_markdown_component__WEBPACK_IMPORTED_MODULE_6__/* .Wrapper */ .im.fragment,
    children
  }) : children, [children]);
  switch (state) {
    case "loaded" /* Loaded */:
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_card_module_css__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.content, fontStyle.contentFont),
        lang: textLang,
        children: loadedChildren
      });
    case "loading" /* Loading */:
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: _card_module_css__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.center,
        children: /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
          className: _card_module_css__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.centerContent,
          children: /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loader_loader_component__WEBPACK_IMPORTED_MODULE_5__/* .Loader */ .aN, {})
        })
      });
    case "error" /* Error */:
      {
        return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
          className: _card_module_css__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.center,
          children: /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_typography_typography_module_css__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.captionAccent, _card_module_css__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.centerContent),
            children: errorText
          })
        });
      }
    default:
      throw new _yandex_langly_shared_src_errors_models_unhandled_case__WEBPACK_IMPORTED_MODULE_3__/* .UnhandledCaseError */ .H(state);
  }
};

/***/ }),

/***/ 84435:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  tv: () => (/* binding */ BgColor),
  kf: () => (/* binding */ BorderColor),
  Zb: () => (/* binding */ Card),
  Id: () => (/* binding */ CardSize),
  r0: () => (/* binding */ CardTheme)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(44936);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.reduce.js
var esnext_async_iterator_reduce = __webpack_require__(32930);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.reduce.js
var esnext_iterator_reduce = __webpack_require__(19259);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/new-card/__content/card-content.component.tsx
var card_content_component = __webpack_require__(31533);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/new-card/card.module.css
var card_module = __webpack_require__(18367);
;// CONCATENATED MODULE: ../ui-kit/src/new-card/__options/card-options.component.tsx







const CardOptions = _ref => {
  let {
    closeButton,
    index,
    childrenType,
    isLoaded
  } = _ref;
  if (!index && !closeButton) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(card_module/* default */.Z.options, {
      [card_module/* default */.Z.optionsWithMargin]: childrenType === card_content_component/* ChildrenType */.L5.Text && isLoaded
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()({
        [card_module/* default */.Z.indexFloating]: childrenType === card_content_component/* ChildrenType */.L5.Box
      }),
      children: index
    }), closeButton && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(card_module/* default */.Z.close, {
        [card_module/* default */.Z.closeFloating]: childrenType === card_content_component/* ChildrenType */.L5.Box || !isLoaded
      }),
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: closeButton.appearance ?? "default",
        size: "tiny",
        iconName: "cross",
        onClick: closeButton.onClick
      })
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/new-card/card.component.tsx












var CardSize = /* @__PURE__ */(CardSize2 => {
  CardSize2["Small"] = "small";
  CardSize2["Medium"] = "medium";
  CardSize2["Large"] = "large";
  return CardSize2;
})(CardSize || {});
var BorderColor = /* @__PURE__ */(BorderColor2 => {
  BorderColor2["Grey"] = "borderGrey";
  BorderColor2["Green"] = "borderGreen";
  BorderColor2["Red"] = "borderRed";
  BorderColor2["Black"] = "borderBlack";
  return BorderColor2;
})(BorderColor || {});
var BgColor = /* @__PURE__ */(BgColor2 => {
  BgColor2["Grey"] = "grey";
  BgColor2["White"] = "white";
  return BgColor2;
})(BgColor || {});
var CardTheme = /* @__PURE__ */(CardTheme2 => {
  CardTheme2[CardTheme2["WithoutPadding"] = 1] = "WithoutPadding";
  CardTheme2[CardTheme2["Adaptive"] = 2] = "Adaptive";
  CardTheme2[CardTheme2["SmallHeight"] = 4] = "SmallHeight";
  CardTheme2[CardTheme2["WhiteHover"] = 8] = "WhiteHover";
  CardTheme2[CardTheme2["CursorPointer"] = 16] = "CursorPointer";
  return CardTheme2;
})(CardTheme || {});
const cardThemeStyleMap = {
  [1 /* WithoutPadding */]: card_module/* default */.Z.withoutPadding,
  [2 /* Adaptive */]: card_module/* default */.Z.adaptiveCard,
  [4 /* SmallHeight */]: card_module/* default */.Z.smallHeight,
  [8 /* WhiteHover */]: card_module/* default */.Z.whiteHover,
  [16 /* CursorPointer */]: card_module/* default */.Z.pointer
};
const borderColorStyleMap = {
  ["borderGrey" /* Grey */]: card_module/* default */.Z.borderGrey,
  ["borderBlack" /* Black */]: card_module/* default */.Z.borderBlack,
  ["borderGreen" /* Green */]: card_module/* default */.Z.borderGreen,
  ["borderRed" /* Red */]: card_module/* default */.Z.borderRed
};
const bgColorStyleMap = {
  ["white" /* White */]: card_module/* default */.Z.backgroundWhite,
  ["grey" /* Grey */]: card_module/* default */.Z.backgroundGrey
};
const cardSizeStyleMap = {
  ["small" /* Small */]: card_module/* default */.Z.small,
  ["medium" /* Medium */]: card_module/* default */.Z.medium,
  ["large" /* Large */]: card_module/* default */.Z.large
};
const getCardThemeClasses = themeValue => Object.entries(cardThemeStyleMap).reduce((classes, _ref) => {
  let [theme, style] = _ref;
  if (themeValue & parseInt(theme)) {
    classes.push(style);
  }
  return classes;
}, []);
const Card = _ref2 => {
  let {
    id,
    state = card_content_component/* CardState */.WF.Loaded,
    appearance: {
      size = "large" /* Large */,
      borderColor,
      bgColor,
      haveShadow = true
    },
    index,
    closeButton,
    children,
    childrenType = card_content_component/* ChildrenType */.L5.Text,
    errorText,
    onCardClick,
    cardTheme,
    isMobile = false
  } = _ref2;
  const sizeStyle = (0,react.useMemo)(() => {
    if (size === "large" /* Large */ && isMobile) {
      return cardSizeStyleMap["medium" /* Medium */];
    }
    return cardSizeStyleMap[size];
  }, [isMobile, size]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(card_module/* default */.Z.card, bgColor && bgColorStyleMap[bgColor], borderColor && borderColorStyleMap[borderColor], sizeStyle, ...(cardTheme ? getCardThemeClasses(cardTheme) : []), {
      [card_module/* default */.Z.boxCard]: childrenType === card_content_component/* ChildrenType */.L5.Box,
      [card_module/* default */.Z.errorCard]: state === card_content_component/* CardState */.WF.Error,
      [card_module/* default */.Z.withoutShadow]: !haveShadow
    }),
    role: "presentation",
    onClick: onCardClick?.bind({}, id),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(CardOptions, {
      index,
      closeButton,
      childrenType,
      isLoaded: state === card_content_component/* CardState */.WF.Loaded
    }), /* @__PURE__ */(0,jsx_runtime.jsx)(card_content_component/* CardContent */.aY, {
      state,
      childrenType,
      errorText,
      isMobile,
      children
    })]
  });
};

/***/ }),

/***/ 33364:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  t: () => (/* binding */ Picture)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../shared/src/utils/url.ts
var url = __webpack_require__(52702);
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
;// CONCATENATED MODULE: ../ui-kit/src/picture/picture.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const picture_module = ({"root":"picture-module__root--uQRun"});
;// CONCATENATED MODULE: ../ui-kit/src/picture/picture.component.tsx






const Picture = _ref => {
  let {
    src,
    classes = {}
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(picture_module, classes);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    style: {
      backgroundImage: (0,url/* convertImageUrlToCssUrl */.v)(src)
    },
    className: classNames.root
  });
};

/***/ }),

/***/ 13777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  E: () => (/* reexport */ RadioButton)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/components/button-appearance/button-appearance.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const button_appearance_module = ({"input":"button-appearance-module__input--aIvUZ","label":"button-appearance-module__label--WFF5Z typography-module__body2-accent--gV8P4","disabled":"button-appearance-module__disabled--TsWlg","checked":"button-appearance-module__checked--DkZg9","read-only":"button-appearance-module__read-only--tYFpb","readOnly":"button-appearance-module__read-only--tYFpb"});
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/components/button-appearance/button-appearance.tsx






const ButtonAppearance = _ref => {
  let {
    className,
    children,
    name,
    checked,
    disabled,
    readOnly,
    handleChange,
    ariaDescription
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    className: classnames_default()(accessibility_module/* default */.Z.focusVisibleWithin, button_appearance_module.label, className, {
      [button_appearance_module.disabled]: disabled,
      [button_appearance_module.checked]: checked,
      [button_appearance_module.readOnly]: readOnly
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      className: classnames_default()(button_appearance_module.input, accessibility_module/* default */.Z.srOnly),
      name,
      type: "radio",
      checked,
      disabled,
      readOnly,
      onChange: handleChange,
      "aria-description": ariaDescription,
      "aria-disabled": disabled || readOnly
    }), children]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/constants.ts


const RADIO_BUTTON_APPEARANCE = {
  RADIO: "radio",
  BUTTON: "button"
};
const RADIO_BUTTON_SIZE = {
  LARGE: "large",
  SMALL: "small"
};
const RADIO_BUTTON_POSITION = {
  TOP: "top",
  CENTER: "center"
};
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/components/radio-appearance/radio-appearance.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const radio_appearance_module = ({"radio-circle":"radio-appearance-module__radio-circle--skIQB","radioCircle":"radio-appearance-module__radio-circle--skIQB","top":"radio-appearance-module__top--ihGGz","root":"radio-appearance-module__root--ZRWIn","large":"radio-appearance-module__large--J1dU0","small":"radio-appearance-module__small--LX6m2","disabled":"radio-appearance-module__disabled--ho0lX","checked":"radio-appearance-module__checked--KxAZK","read-only":"radio-appearance-module__read-only--AP4l2","readOnly":"radio-appearance-module__read-only--AP4l2","label":"radio-appearance-module__label--jzXJn","input":"radio-appearance-module__input--hv6JV","title":"radio-appearance-module__title--e46E6"});
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/components/radio-appearance/radio-appearance.tsx








const RadioAppearance = _ref => {
  let {
    children,
    className,
    name,
    value,
    size = RADIO_BUTTON_SIZE.LARGE,
    checked,
    disabled,
    readOnly,
    position = RADIO_BUTTON_POSITION.CENTER,
    ariaDescription,
    handleChange
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(radio_appearance_module.root, className, radio_appearance_module[size], {
      [radio_appearance_module.disabled]: disabled,
      [radio_appearance_module.checked]: checked,
      [radio_appearance_module.readOnly]: readOnly,
      [radio_appearance_module.top]: position === RADIO_BUTTON_POSITION.TOP
    }),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("label", {
      className: radio_appearance_module.label,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)("input", {
        className: classnames_default()(radio_appearance_module.input, accessibility_module/* default */.Z.srOnly),
        type: "radio",
        checked,
        onChange: handleChange,
        disabled,
        readOnly,
        name,
        value,
        "aria-description": ariaDescription,
        "aria-disabled": disabled || readOnly
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(radio_appearance_module.radioCircle, {
        [radio_appearance_module.top]: position === RADIO_BUTTON_POSITION.TOP && size === RADIO_BUTTON_SIZE.LARGE
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
      className: classnames_default()(radio_appearance_module.title, typography_module/* default */.Z[size === "large" ? "headline4" : "body2"]),
      children
    })]
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/radio-button.tsx







const RadioButton = _ref => {
  let {
    children,
    className,
    checked = false,
    name,
    value,
    appearance = RADIO_BUTTON_APPEARANCE.RADIO,
    size = RADIO_BUTTON_SIZE.LARGE,
    disabled = false,
    readOnly = false,
    position = RADIO_BUTTON_POSITION.CENTER,
    onChange,
    ariaDescription
  } = _ref;
  const handleChange = (0,react.useCallback)(e => {
    if (e.target.checked) {
      onChange(e.target.checked);
    }
  }, [onChange]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: appearance === RADIO_BUTTON_APPEARANCE.RADIO ? /* @__PURE__ */(0,jsx_runtime.jsx)(RadioAppearance, {
      className,
      size,
      name,
      value,
      checked,
      disabled,
      readOnly,
      position,
      handleChange,
      ariaDescription,
      children
    }) : /* @__PURE__ */(0,jsx_runtime.jsx)(ButtonAppearance, {
      className,
      size,
      name,
      value,
      checked,
      disabled,
      readOnly,
      handleChange,
      ariaDescription,
      children
    })
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/radio-button/index.ts




/***/ }),

/***/ 65866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ SelectSize),
/* harmony export */   n: () => (/* binding */ SelectTheme)
/* harmony export */ });


var SelectSize = /* @__PURE__ */(SelectSize2 => {
  SelectSize2["Medium"] = "medium";
  SelectSize2["Small"] = "small";
  return SelectSize2;
})(SelectSize || {});
var SelectTheme = /* @__PURE__ */(SelectTheme2 => {
  SelectTheme2["White"] = "white";
  SelectTheme2["Grey"] = "grey";
  return SelectTheme2;
})(SelectTheme || {});

/***/ }),

/***/ 48036:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  v: () => (/* binding */ Menu)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/useDigitKeyPress.ts
var useDigitKeyPress = __webpack_require__(67015);
// EXTERNAL MODULE: ../shared/src/hooks/useKeyPress.ts
var useKeyPress = __webpack_require__(30803);
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
// EXTERNAL MODULE: ../ui-kit/src/markdown/markdown.component.tsx + 1 modules
var markdown_component = __webpack_require__(43539);
// EXTERNAL MODULE: ../ui-kit/src/select/constants.ts
var constants = __webpack_require__(65866);
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/select/menu/menu.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const menu_module = ({"root":"menu-module__root--Yl1oa","medium":"menu-module__medium--zUTro typography-module__body2-accent--gV8P4","small":"menu-module__small--pUaQn typography-module__caption-accent--pNZIZ","root-item":"menu-module__root-item--sBrBX","rootItem":"menu-module__root-item--sBrBX","root-item-active":"menu-module__root-item-active--Exhc8","rootItemActive":"menu-module__root-item-active--Exhc8","root-item-disabled":"menu-module__root-item-disabled--w2zps","rootItemDisabled":"menu-module__root-item-disabled--w2zps","root-item-with-small-padding":"menu-module__root-item-with-small-padding--Wf4ed","rootItemWithSmallPadding":"menu-module__root-item-with-small-padding--Wf4ed","label":"menu-module__label--jEtOC"});
;// CONCATENATED MODULE: ../ui-kit/src/select/menu/menu.tsx















function Menu(_ref) {
  let {
    classes = {},
    options,
    value,
    onChange,
    size = constants/* SelectSize */.h.Medium,
    showLabels,
    className,
    ...props
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(menu_module, classes);
  const selectedIndex = (0,react.useMemo)(() => options.findIndex(option => option.value === value), [options, value]);
  const [activeIndex, setActiveIndex] = (0,react.useState)(selectedIndex);
  const onArrowDownClick = (0,react.useCallback)(() => {
    setActiveIndex(activeIndex >= options.length - 1 ? 0 : activeIndex + 1);
  }, [activeIndex, options.length]);
  (0,useKeyPress/* useKeyPress */.K)("ArrowDown", onArrowDownClick);
  const onArrowUpClick = (0,react.useCallback)(() => {
    setActiveIndex(activeIndex <= 0 ? options.length - 1 : activeIndex - 1);
  }, [activeIndex, options.length]);
  (0,useKeyPress/* useKeyPress */.K)("ArrowUp", onArrowUpClick);
  const onEnterClick = (0,react.useCallback)(() => {
    if (onChange !== void 0) {
      onChange(options[activeIndex].value);
    }
  }, [onChange, options, activeIndex]);
  (0,useKeyPress/* useKeyPress */.K)("Enter", onEnterClick);
  const onEscClick = (0,react.useCallback)(() => {
    if (onChange !== void 0) {
      onChange(value);
    }
  }, [onChange, value]);
  (0,useKeyPress/* useKeyPress */.K)("Escape", onEscClick);
  const onClick = (0,react.useCallback)(index => {
    setActiveIndex(index);
    if (onChange !== void 0) {
      onChange(options[index].value);
    }
  }, [onChange, options]);
  const onDigitPress = (0,react.useCallback)(index => {
    setActiveIndex(index - 1);
    if (onChange !== void 0) {
      onChange(options[index - 1].value);
    }
  }, [onChange, options]);
  const onActivate = (0,react.useCallback)(index => {
    setActiveIndex(index);
  }, [setActiveIndex]);
  (0,useDigitKeyPress/* useDigitKeyPress */.K)(onDigitPress);
  const listId = (0,react.useId)();
  (0,react.useEffect)(() => {
    const activeButton = document.querySelector(`#${listId.replaceAll(":", "\\:")} button[data-index="${activeIndex}"]`);
    if (activeButton instanceof HTMLElement) {
      activeButton.focus();
    }
  }, [activeIndex, listId]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("ul", {
    id: listId,
    className: classnames_default()(classNames.root, className, {
      [classNames.small]: size === constants/* SelectSize */.h.Small,
      [classNames.medium]: size === constants/* SelectSize */.h.Medium
    }),
    ...props,
    children: options.map((option, index) => {
      const isActive = index === activeIndex;
      const isDisabled = option.disabled;
      const handleClick = () => {
        if (option.disabled) {
          return;
        }
        onClick(index);
      };
      const handleActive = () => {
        onActivate(index);
      };
      const title = typeof option.title === "string" ? /* @__PURE__ */(0,jsx_runtime.jsx)(markdown_component/* Markdown */.UG, {
        wrapper: markdown_component/* Wrapper */.im.fragment,
        children: option.title
      }) : option.title;
      return /* @__PURE__ */(0,jsx_runtime.jsx)("li", {
        className: classnames_default()(menu_module.rootItem, {
          [menu_module.rootItemActive]: isActive,
          [menu_module.rootItemDisabled]: isDisabled,
          [menu_module.rootItemWithSmallPadding]: showLabels
        }),
        role: "option",
        "aria-selected": option.selected,
        children: /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
          disabled: isDisabled,
          onClick: handleClick,
          onMouseOver: handleActive,
          onFocus: handleActive,
          className: accessibility_module/* default */.Z.focusVisible,
          type: "button",
          "data-index": index,
          children: [showLabels && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(menu_module.label, typography_module/* default */.Z.captionAccent),
            children: index + 1
          }), title]
        })
      }, option.value);
    })
  });
}

/***/ }),

/***/ 31727:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  P: () => (/* binding */ Select)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.find.js
var esnext_async_iterator_find = __webpack_require__(68760);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(75183);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.find.js
var esnext_iterator_find = __webpack_require__(280);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/select/constants.ts
var constants = __webpack_require__(65866);
// EXTERNAL MODULE: ../ui-kit/src/select/menu/menu.tsx + 1 modules
var menu = __webpack_require__(48036);
;// CONCATENATED MODULE: ../ui-kit/src/select/types.ts


var SelectStatus = /* @__PURE__ */(SelectStatus2 => {
  SelectStatus2["Default"] = "default";
  SelectStatus2["Success"] = "success";
  SelectStatus2["Error"] = "error";
  return SelectStatus2;
})(SelectStatus || {});
;// CONCATENATED MODULE: ../ui-kit/src/select/utils.ts


function isCustomSelectProps(props) {
  return "trigger" in props;
}
// EXTERNAL MODULE: ../ui-kit/src/accessibility/accessibility.module.css
var accessibility_module = __webpack_require__(98493);
;// CONCATENATED MODULE: ../ui-kit/src/select/select.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const select_module = ({"root":"select-module__root--X0Csz","disabled":"select-module__disabled--PoCsw","without-box-shadow":"select-module__without-box-shadow--wmIeT","withoutBoxShadow":"select-module__without-box-shadow--wmIeT","theme-white":"select-module__theme-white--CiTSn","themeWhite":"select-module__theme-white--CiTSn","theme-grey":"select-module__theme-grey--EZStp","themeGrey":"select-module__theme-grey--EZStp","small":"select-module__small--Hde0F","medium":"select-module__medium--G7KgF","container":"select-module__container--guwF4","input":"select-module__input--Yw80k","menu":"select-module__menu--idlyH","error":"select-module__error--P1Sn2","success":"select-module__success--cULDJ","title":"select-module__title--uDqHb"});
;// CONCATENATED MODULE: ../ui-kit/src/select/select.tsx
















const testId = "data-testid";
function Select(componentProps) {
  const {
    options,
    value,
    onChange,
    onTrigger,
    type = SelectStatus.Default,
    theme = constants/* SelectTheme */.n.White,
    size = constants/* SelectSize */.h.Medium,
    menuClassName,
    className,
    disabled = false,
    withoutBoxShadow = false,
    placeholder: placeholderFromProps,
    ...props
  } = componentProps;
  const wrapperRef = (0,react.useRef)(null);
  const selectedOption = (0,react.useMemo)(() => options.find(option => option.value === value), [options, value]);
  const [dropdownOpen, setDropdownOpen] = (0,react.useState)(false);
  const triggerDropdown = (0,react.useCallback)(checked => {
    onTrigger?.(checked);
    if (!disabled) {
      setDropdownOpen(checked);
    }
  }, [disabled, onTrigger]);
  const onButtonClick = (0,react.useCallback)(() => {
    triggerDropdown(!dropdownOpen);
  }, [dropdownOpen, triggerDropdown]);
  const handleOutsideClick = (0,react.useCallback)(() => {
    triggerDropdown(false);
  }, [triggerDropdown]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(wrapperRef, handleOutsideClick);
  const onSelectChange = (0,react.useCallback)(newValue => {
    if (newValue !== value) {
      onChange(newValue);
    }
    triggerDropdown(false);
  }, [onChange, value, triggerDropdown]);
  const {
    placeholder: placeholderRaw
  } = !isCustomSelectProps(componentProps) ? componentProps : {
    placeholder: ""
  };
  const placeholder = (typeof placeholderRaw === "number" ? placeholderRaw.toString() : placeholderRaw) || "...";
  const title = (0,react.useMemo)(() => selectedOption ? selectedOption.title : placeholder, [selectedOption, placeholder]);
  const {
    trigger
  } = isCustomSelectProps(componentProps) ? componentProps : {
    trigger: null
  };
  const defaultTrigger = /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("p", {
      className: select_module.title,
      children: title
    }), type === SelectStatus.Default && /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
      name: dropdownOpen ? "chevron-up" : "chevron-down",
      className: select_module.title,
      size
    })]
  });
  const triggerId = (0,react.useId)();
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref: wrapperRef,
    role: "listbox",
    className: classnames_default()(select_module.root, accessibility_module/* default */.Z.focusVisibleWithin, {
      [select_module.success]: type === SelectStatus.Success,
      [select_module.error]: type === SelectStatus.Error,
      [select_module.small]: size === constants/* SelectSize */.h.Small,
      [select_module.medium]: size === constants/* SelectSize */.h.Medium,
      [select_module.themeWhite]: theme === constants/* SelectTheme */.n.White,
      [select_module.themeGrey]: theme === constants/* SelectTheme */.n.Grey,
      [select_module.withoutBoxShadow]: withoutBoxShadow,
      [select_module.disabled]: disabled
    }, className),
    ...props,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      id: triggerId,
      className: select_module.container,
      children: (isCustomSelectProps(componentProps) ? trigger : null) || defaultTrigger
    }), type === SelectStatus.Default && /* @__PURE__ */(0,jsx_runtime.jsx)("button", {
      className: select_module.input,
      onClick: onButtonClick,
      type: "button",
      "aria-haspopup": "listbox",
      "aria-labelledby": triggerId,
      "aria-expanded": dropdownOpen,
      "data-testid": props[testId] + "--button"
    }), dropdownOpen && /* @__PURE__ */(0,jsx_runtime.jsx)(menu/* Menu */.v, {
      className: classnames_default()(select_module.menu, menuClassName),
      options,
      onChange: onSelectChange,
      value,
      size,
      "data-testid": props[testId] + "--menu"
    })]
  });
}

/***/ }),

/***/ 23725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  f: () => (/* binding */ SideMenu)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-click-outside-ref.ts
var use_click_outside_ref = __webpack_require__(75621);
// EXTERNAL MODULE: ../ui-kit/src/button-icon/button-icon.component.tsx
var button_icon_component = __webpack_require__(41200);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/side-menu/side-menu.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const side_menu_module = ({"root":"side-menu-module__root--x_Jlb","header":"side-menu-module__header--tLQkX","items-list":"side-menu-module__items-list--yixVC","itemsList":"side-menu-module__items-list--yixVC"});
;// CONCATENATED MODULE: ../ui-kit/src/side-menu/side-menu.component.tsx








const MARGIN = 10;
const SideMenu = _ref => {
  let {
    children,
    onClose,
    title,
    isMobile
  } = _ref;
  const [height, setHeight] = (0,react.useState)(isMobile ? window.innerHeight : 680);
  const ref = (0,react.useRef)(null);
  const handleResize = (0,react.useCallback)(() => {
    if (isMobile) {
      setHeight(window.innerHeight);
    }
  }, [isMobile]);
  (0,react.useEffect)(() => {
    window.onresize = handleResize;
    return () => {
      window.onresize = null;
    };
  }, [handleResize]);
  (0,use_click_outside_ref/* useClickOutsideRef */.b)(ref, onClose);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
    ref,
    style: {
      height: height - MARGIN
    },
    className: side_menu_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: side_menu_module.header,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: typography_module/* default */.Z.headline4Accent,
        children: title
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(button_icon_component/* ButtonIcon */.E, {
        appearance: "default",
        size: "medium",
        iconName: "cross",
        onClick: onClose
      })]
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: side_menu_module.itemsList,
      children
    })]
  });
};

/***/ }),

/***/ 80735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O: () => (/* reexport */ Skeleton),
  y: () => (/* reexport */ SkeletonTheme)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(14080);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(10142);
;// CONCATENATED MODULE: ../ui-kit/src/skeleton/skeleton.tsx





var SkeletonTheme = /* @__PURE__ */(SkeletonTheme2 => {
  SkeletonTheme2["Default"] = "default";
  SkeletonTheme2["Light"] = "light";
  return SkeletonTheme2;
})(SkeletonTheme || {});
function Skeleton(props) {
  const {
    theme
  } = props;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(dist/* default */.Z, {
    containerTestId: "skeleton",
    baseColor: theme === "light" /* Light */ ? "#f7f7f8" : void 0,
    highlightColor: theme === "light" /* Light */ ? "#ffffff" : void 0,
    ...props
  });
}
;// CONCATENATED MODULE: ../ui-kit/src/skeleton/index.ts




/***/ }),

/***/ 5714:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  r: () => (/* binding */ Switch)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui-kit/src/switch/switch.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const switch_module = ({"root":"switch-module__root--oqyU_","small":"switch-module__small--V7fQz","medium":"switch-module__medium--xyFi7","primary":"switch-module__primary--rHFnn","primary-on-black":"switch-module__primary-on-black--QPMaR","primaryOnBlack":"switch-module__primary-on-black--QPMaR","checked":"switch-module__checked--bkCpl","input":"switch-module__input--KoeOK","thumb":"switch-module__thumb--qyVHj"});
;// CONCATENATED MODULE: ../ui-kit/src/switch/switch.component.tsx





const Switch = _ref => {
  let {
    appearance = "primary",
    size = "medium",
    disabled,
    checked = false,
    onChange,
    dataTestId
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    "data-testid": dataTestId,
    className: classnames_default()(switch_module.root, {
      [switch_module.checked]: checked
    }, switch_module[size], switch_module[appearance]),
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("input", {
      className: switch_module.input,
      type: "checkbox",
      checked,
      onChange,
      disabled
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(switch_module.thumb, switch_module[size], switch_module[appearance])
    })]
  });
};

/***/ }),

/***/ 93018:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Dw: () => (/* binding */ MotherTaskType),
/* harmony export */   OI: () => (/* binding */ NavigationTabType),
/* harmony export */   UA: () => (/* binding */ TaskType),
/* harmony export */   eQ: () => (/* binding */ MotherTaskState),
/* harmony export */   x4: () => (/* binding */ ActionItemType)
/* harmony export */ });


var ActionItemType = /* @__PURE__ */(ActionItemType2 => {
  ActionItemType2["Start"] = "start";
  ActionItemType2["Expand"] = "expand";
  ActionItemType2["AddInLesson"] = "addInLesson";
  ActionItemType2["RemoveFromLesson"] = "removeFromLesson";
  ActionItemType2["OpenLesson"] = "openLesson";
  ActionItemType2["Skip"] = "skip";
  ActionItemType2["Locked"] = "locked";
  ActionItemType2["UnSkip"] = "unSkip";
  return ActionItemType2;
})(ActionItemType || {});
var NavigationTabType = /* @__PURE__ */(NavigationTabType2 => {
  NavigationTabType2["Tasks"] = "tasks";
  NavigationTabType2["InClass"] = "inClass";
  NavigationTabType2["SelfStudy"] = "selfStudy";
  return NavigationTabType2;
})(NavigationTabType || {});
var MotherTaskType = /* @__PURE__ */(MotherTaskType2 => {
  MotherTaskType2["Default"] = "default";
  MotherTaskType2["Foreigner"] = "foreigner";
  MotherTaskType2["Milestone"] = "milestone";
  return MotherTaskType2;
})(MotherTaskType || {});
var MotherTaskState = /* @__PURE__ */(MotherTaskState2 => {
  MotherTaskState2["Initial"] = "initial";
  MotherTaskState2["InProgress"] = "inProgress";
  MotherTaskState2["InClass"] = "inClass";
  MotherTaskState2["Skipped"] = "skipped";
  MotherTaskState2["Done"] = "done";
  MotherTaskState2["Disabled"] = "disabled";
  MotherTaskState2["Unknown"] = "unknown";
  return MotherTaskState2;
})(MotherTaskState || {});
var TaskType = /* @__PURE__ */(TaskType2 => {
  TaskType2["Tasks"] = "tasks";
  TaskType2["InClass"] = "inClass";
  TaskType2["SelfStudy"] = "selfStudy";
  TaskType2["Unknown"] = "unknown";
  return TaskType2;
})(TaskType || {});

/***/ }),

/***/ 95226:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  s: () => (/* binding */ TaskGuideTask),
  P: () => (/* binding */ TaskState)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/icons/icon.component.tsx
var icon_component = __webpack_require__(48670);
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__task/task-guide-task.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const task_guide_task_module = ({"root":"task-guide-task-module__root--IBfO2","root-header":"task-guide-task-module__root-header--_m0jD","rootHeader":"task-guide-task-module__root-header--_m0jD","root-header-title":"task-guide-task-module__root-header-title--_qEPb","rootHeaderTitle":"task-guide-task-module__root-header-title--_qEPb","root-selected":"task-guide-task-module__root-selected--QR9Vo","rootSelected":"task-guide-task-module__root-selected--QR9Vo","root-add":"task-guide-task-module__root-add--kt20C","rootAdd":"task-guide-task-module__root-add--kt20C","empty-icon":"task-guide-task-module__empty-icon--QEpyn","emptyIcon":"task-guide-task-module__empty-icon--QEpyn","success-icon":"task-guide-task-module__success-icon--Xjgys","successIcon":"task-guide-task-module__success-icon--Xjgys","icon":"task-guide-task-module__icon--TTIQW","text-with-icon":"task-guide-task-module__text-with-icon--ioUE5","textWithIcon":"task-guide-task-module__text-with-icon--ioUE5","text-with-icon-icon":"task-guide-task-module__text-with-icon-icon--_qyGx","textWithIconIcon":"task-guide-task-module__text-with-icon-icon--_qyGx","text-with-icon-default":"task-guide-task-module__text-with-icon-default--dKr89","textWithIconDefault":"task-guide-task-module__text-with-icon-default--dKr89","text-with-icon-green":"task-guide-task-module__text-with-icon-green--pYl1E","textWithIconGreen":"task-guide-task-module__text-with-icon-green--pYl1E","text-with-icon-border-green":"task-guide-task-module__text-with-icon-border-green--K9Asw","textWithIconBorderGreen":"task-guide-task-module__text-with-icon-border-green--K9Asw","text-with-icon-border-red":"task-guide-task-module__text-with-icon-border-red--yHIZA","textWithIconBorderRed":"task-guide-task-module__text-with-icon-border-red--yHIZA","root-expended-content":"task-guide-task-module__root-expended-content--scj9S","rootExpendedContent":"task-guide-task-module__root-expended-content--scj9S","root-expended-content-item":"task-guide-task-module__root-expended-content-item--W7ZJU","rootExpendedContentItem":"task-guide-task-module__root-expended-content-item--W7ZJU","root-expended-content-hidden":"task-guide-task-module__root-expended-content-hidden--DrWFK","rootExpendedContentHidden":"task-guide-task-module__root-expended-content-hidden--DrWFK","button-icon-wrapper":"task-guide-task-module__button-icon-wrapper--pV5yU","buttonIconWrapper":"task-guide-task-module__button-icon-wrapper--pV5yU"});
;// CONCATENATED MODULE: ../ui-kit/src/task-guide/__task/task-guide-task.component.tsx








var TaskState = /* @__PURE__ */(TaskState2 => {
  TaskState2["Initial"] = "initital";
  TaskState2["NotAvailable"] = "notAvailable";
  TaskState2["InProgress"] = "inProgress";
  TaskState2["Done"] = "done";
  TaskState2["NotAdded"] = "notAdded";
  TaskState2["Added"] = "added";
  TaskState2["AddedAgain"] = "addedAgain";
  TaskState2["DoneWithProgress"] = "doneWithProgress";
  TaskState2["Unknown"] = "unknown";
  return TaskState2;
})(TaskState || {});
const EmptyIcon = () => /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
  className: task_guide_task_module.emptyIcon
});
const AddIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconDefault),
  children: ["Add", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "plus",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const AddedIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconDefault),
  children: ["Added", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "clip",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const AddedAgainIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconDefault),
  children: ["Added again", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "reset",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const RemoveIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconDefault),
  children: ["Remove", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "small-trash",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const StartIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconDefault),
  children: ["Start", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "arrow-right",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const InProgressIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconGreen),
  children: ["In progress", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "path",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const DoneIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconBorderGreen),
  children: ["Done", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "checkmark",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const DoneWithProgressIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconGreen),
  children: ["Done", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "checkmark",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const UndoneIcon = () => /* @__PURE__ */(0,jsx_runtime.jsxs)("span", {
  className: classnames_default()(task_guide_task_module.textWithIcon, typography_module/* default */.Z.captionAccent, task_guide_task_module.textWithIconBorderRed),
  children: ["Undone", /* @__PURE__ */(0,jsx_runtime.jsx)(icon_component/* Icon */.J, {
    name: "cross",
    size: "small",
    className: task_guide_task_module.textWithIconIcon
  })]
});
const TaskGuideTask = _ref => {
  let {
    state,
    text,
    onClick,
    expanded,
    expendedContent,
    isReadOnly,
    onClickIcon
  } = _ref;
  const [isHovered, setIsHovered] = (0,react.useState)(false);
  const renderReadOnlyIcon = (0,react.useCallback)(() => {
    switch (state) {
      case "inProgress" /* InProgress */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(InProgressIcon, {});
      case "doneWithProgress" /* DoneWithProgress */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(DoneWithProgressIcon, {});
      case "done" /* Done */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(DoneIcon, {});
      default:
        return null;
    }
  }, [state]);
  const renderIcon = (0,react.useCallback)(() => {
    switch (state) {
      case "notAdded" /* NotAdded */:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsx)(AddIcon, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyIcon, {});
      case "added" /* Added */:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsx)(RemoveIcon, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(AddedIcon, {});
      case "done" /* Done */:
        return isHovered ? /* @__PURE__ */(0,jsx_runtime.jsx)(UndoneIcon, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(DoneIcon, {});
      case "addedAgain" /* AddedAgain */:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsx)(RemoveIcon, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(AddedAgainIcon, {});
      case "doneWithProgress" /* DoneWithProgress */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(DoneWithProgressIcon, {});
      case "initital" /* Initial */:
        return isHovered || expanded ? /* @__PURE__ */(0,jsx_runtime.jsx)(StartIcon, {}) : /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyIcon, {});
      case "inProgress" /* InProgress */:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(InProgressIcon, {});
      default:
        return /* @__PURE__ */(0,jsx_runtime.jsx)(EmptyIcon, {});
    }
  }, [expanded, isHovered, state]);
  const handleMouseOver = (0,react.useCallback)(() => setIsHovered(true), []);
  const handleMouseLeave = (0,react.useCallback)(() => setIsHovered(false), []);
  const handleClick = (0,react.useCallback)(e => {
    if (isReadOnly) {
      return;
    }
    e.stopPropagation();
    return onClickIcon();
  }, [isReadOnly, onClickIcon]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(task_guide_task_module.root),
    children: [/* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(task_guide_task_module.rootHeader),
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave,
      onClick,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(typography_module/* default */.Z.body2Accent, task_guide_task_module.rootHeaderTitle),
        children: text
      }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: task_guide_task_module.buttonIconWrapper,
        onClick: handleClick,
        children: isReadOnly ? renderReadOnlyIcon() : renderIcon()
      })]
    }), expendedContent && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(task_guide_task_module.rootExpendedContent, {
        [task_guide_task_module.rootExpendedContentHidden]: !expanded
      }),
      children: expendedContent?.map(content => /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(task_guide_task_module.rootExpendedContentItem, typography_module/* default */.Z.body2),
        children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
          className: typography_module/* default */.Z.body2Accent,
          children: content.title
        }), " ", content.text]
      }, content.title))
    })]
  });
};

/***/ }),

/***/ 22292:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  K: () => (/* binding */ TextArea)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui-kit/src/text-area/utils/utils.ts


function calculateDownBorder(valueLength, maxLength) {
  if (valueLength <= maxLength) {
    return valueLength;
  }
  return maxLength - valueLength;
}
function isOverTyped(valueLength, maxLength) {
  return valueLength > maxLength;
}
;// CONCATENATED MODULE: ../ui-kit/src/text-area/styles.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const styles_module = ({"root":"styles-module__root--SMvbH","borders-block":"styles-module__borders-block--mmpaX","bordersBlock":"styles-module__borders-block--mmpaX","textarea":"styles-module__textarea--AiN7U","overTyped":"styles-module__overTyped--QIFV4"});
;// CONCATENATED MODULE: ../ui-kit/src/text-area/component.tsx






function TextArea(_ref) {
  let {
    maxLength,
    value,
    ...otherProps
  } = _ref;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("label", {
    className: styles_module.root,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("textarea", {
      className: styles_module.textarea,
      value,
      ...otherProps
    }), maxLength && /* @__PURE__ */(0,jsx_runtime.jsxs)("div", {
      className: styles_module.bordersBlock,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        className: classnames_default()({
          [styles_module.overTyped]: isOverTyped(value?.length || 0, maxLength)
        }),
        children: calculateDownBorder(value?.length || 0, maxLength)
      }), "/", /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
        children: maxLength
      })]
    })]
  });
}

/***/ }),

/***/ 5426:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  I: () => (/* binding */ Color),
  A: () => (/* binding */ TextButton)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../ui-kit/src/helpers/use-merge-classes.ts
var use_merge_classes = __webpack_require__(17034);
// EXTERNAL MODULE: ../ui-kit/src/hot-key/hot-key.component.tsx + 1 modules
var hot_key_component = __webpack_require__(72416);
;// CONCATENATED MODULE: ../ui-kit/src/text-button/__hotKey/hotKey.component.tsx




const TextButtonHotKey = _ref => {
  let {
    state,
    contentType,
    text
  } = _ref;
  if (!state || !contentType) {
    return null;
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)(hot_key_component/* HotKey */.wn, {
    state,
    contentType,
    text
  });
};
;// CONCATENATED MODULE: ../ui-kit/src/text-button/text-button.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const text_button_module = ({"button":"text-button-module__button--IjoYu","compact":"text-button-module__compact--GrlH_","thin":"text-button-module__thin--b_BeQ","without-children":"text-button-module__without-children--oqeG3","withoutChildren":"text-button-module__without-children--oqeG3","center":"text-button-module__center--iOh7G","translucent-background":"text-button-module__translucent-background--kYgxt","translucentBackground":"text-button-module__translucent-background--kYgxt","button-text-with-margin":"text-button-module__button-text-with-margin--RiuHV","buttonTextWithMargin":"text-button-module__button-text-with-margin--RiuHV","transparent-button":"text-button-module__transparent-button--cnmh5","transparentButton":"text-button-module__transparent-button--cnmh5","shadow":"text-button-module__shadow--fJIUY","hard-grey":"text-button-module__hard-grey--a4Sn8","hardGrey":"text-button-module__hard-grey--a4Sn8","light-black":"text-button-module__light-black--UMJrD","lightBlack":"text-button-module__light-black--UMJrD","lightest-black":"text-button-module__lightest-black--TW9bU","lightestBlack":"text-button-module__lightest-black--TW9bU","green":"text-button-module__green--tjfPX","red":"text-button-module__red--zaqUA","transparent-border":"text-button-module__transparent-border--pt0ma","transparentBorder":"text-button-module__transparent-border--pt0ma"});
;// CONCATENATED MODULE: ../ui-kit/src/text-button/__text-button-content/text-button-content.component.tsx





const TextButtonContent = _ref => {
  let {
    textWithMargin,
    isTransparentText,
    children
  } = _ref;
  if (isTransparentText) {
    return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      className: text_button_module.center,
      children
    });
  }
  return /* @__PURE__ */(0,jsx_runtime.jsx)("span", {
    className: classnames_default()({
      [text_button_module.buttonTextWithMargin]: textWithMargin
    }),
    children
  });
};
// EXTERNAL MODULE: ../ui-kit/src/typography/typography.module.css
var typography_module = __webpack_require__(11060);
;// CONCATENATED MODULE: ../ui-kit/src/text-button/text-button.component.tsx










var Color = /* @__PURE__ */(Color2 => {
  Color2["hardGrey"] = "hardGrey";
  Color2["lightBlack"] = "lightBlack";
  Color2["lightestBlack"] = "lightestBlack";
  Color2["Red"] = "red";
  Color2["Green"] = "green";
  Color2["Transparent"] = "transparent";
  return Color2;
})(Color || {});
const buttonColorStyleMap = {
  hardGrey: text_button_module.hardGrey,
  lightBlack: text_button_module.lightBlack,
  lightestBlack: text_button_module.lightestBlack,
  red: text_button_module.red,
  green: text_button_module.green,
  transparent: text_button_module.transparentBorder
};
const TextButton = _ref => {
  let {
    shadow = true,
    color = "transparent" /* Transparent */,
    hotKeyState,
    hotKeyContentType = hot_key_component/* HotKeyContentType */.cu.Text,
    hotKeyText = 1,
    transparentText = true,
    withoutChildren = false,
    children,
    classes = {},
    size = "regular",
    ...props
  } = _ref;
  const classNames = (0,use_merge_classes/* useMergeClasses */.E)(text_button_module, classes);
  const hasHotKey = Boolean(hotKeyContentType && hotKeyState) || false;
  return /* @__PURE__ */(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: classnames_default()(classNames.button, size === "regular" ? typography_module/* default */.Z.body1 : typography_module/* default */.Z.caption, buttonColorStyleMap[color], {
      [classNames.compact]: size === "compact",
      [classNames.shadow]: shadow,
      [classNames.withoutChildren]: withoutChildren,
      [classNames.transparentButton]: transparentText
    }),
    ...props,
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)(TextButtonHotKey, {
      state: hotKeyState,
      contentType: hotKeyContentType,
      text: hotKeyText
    }), !withoutChildren && /* @__PURE__ */(0,jsx_runtime.jsx)(TextButtonContent, {
      textWithMargin: hasHotKey,
      isTransparentText: transparentText,
      children
    })]
  });
};

/***/ }),

/***/ 3717:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  t: () => (/* binding */ ToggleButtonGroup)
});

// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.async-iterator.map.js
var esnext_async_iterator_map = __webpack_require__(83039);
// EXTERNAL MODULE: ../../node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(27591);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../ui-kit/src/button/button.component.tsx
var button_component = __webpack_require__(60667);
// EXTERNAL MODULE: ../ui-kit/src/tooltip/tooltip.tsx + 1 modules
var tooltip = __webpack_require__(37587);
;// CONCATENATED MODULE: ../ui-kit/src/toggle-button-group/toggle-button-group.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const toggle_button_group_module = ({"button-group":"toggle-button-group-module__button-group--kCALN","buttonGroup":"toggle-button-group-module__button-group--kCALN","button-group-stretched":"toggle-button-group-module__button-group-stretched--n85KK","buttonGroupStretched":"toggle-button-group-module__button-group-stretched--n85KK","button-group-vertical":"toggle-button-group-module__button-group-vertical--c4Xy7","buttonGroupVertical":"toggle-button-group-module__button-group-vertical--c4Xy7","button-group-floating":"toggle-button-group-module__button-group-floating--rWTbP","buttonGroupFloating":"toggle-button-group-module__button-group-floating--rWTbP","button-selected":"toggle-button-group-module__button-selected--mrHu1","buttonSelected":"toggle-button-group-module__button-selected--mrHu1","children":"toggle-button-group-module__children--oRWAO","button":"toggle-button-group-module__button--oVxBQ"});
;// CONCATENATED MODULE: ../ui-kit/src/toggle-button-group/toggle-button.tsx








const ToggleButton = _ref => {
  let {
    value,
    isSelected,
    appearance,
    onChange,
    className
  } = _ref;
  const {
    id,
    label,
    disabled,
    tooltipText,
    children
  } = value;
  const [isTooltipVisible, setIsTooltipVisible] = (0,react.useState)(false);
  const showTooltip = (0,react.useCallback)(() => setIsTooltipVisible(Boolean(tooltipText)), [tooltipText]);
  const hideTooltip = (0,react.useCallback)(() => setIsTooltipVisible(false), []);
  const handleClick = (0,react.useCallback)(() => onChange(id), [id, onChange]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(tooltip/* Tooltip */.u, {
    autoWidth: true,
    overlay: tooltipText,
    visible: isTooltipVisible,
    align: {
      targetOffset: [0, 8]
    },
    placement: "top",
    children: /* @__PURE__ */(0,jsx_runtime.jsxs)(button_component/* Button */.z, {
      size: "small",
      "aria-label": label,
      "aria-selected": isSelected,
      appearance,
      className: classnames_default()(toggle_button_group_module.button, className, {
        [toggle_button_group_module.buttonSelected]: isSelected
      }),
      "data-testid": "ToggleButton",
      disabled,
      onClick: handleClick,
      onMouseEnter: showTooltip,
      onMouseLeave: hideTooltip,
      children: [label, children && /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
        className: toggle_button_group_module.children,
        children
      })]
    })
  }, id);
};
;// CONCATENATED MODULE: ../ui-kit/src/toggle-button-group/utils.ts


function mapButtonAppearance(appearance) {
  return appearance === "floating" ? "secondary" : "secondaryFloating";
}
;// CONCATENATED MODULE: ../ui-kit/src/toggle-button-group/toggle-button-group.tsx









const ToggleButtonGroup = _ref => {
  let {
    appearance = "default",
    values,
    selectedValueId,
    view = "horizontal",
    stretch = false,
    onChange
  } = _ref;
  const selectedButtonAppearance = mapButtonAppearance(appearance);
  return /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
    "data-testid": "ToggleButtonGroup",
    className: classnames_default()(toggle_button_group_module.buttonGroup, {
      [toggle_button_group_module.buttonGroupStretched]: stretch,
      [toggle_button_group_module.buttonGroupFloating]: appearance === "floating",
      [toggle_button_group_module.buttonGroupVertical]: view === "vertical"
    }),
    children: values.map(value => /* @__PURE__ */(0,jsx_runtime.jsx)(ToggleButton, {
      value,
      isSelected: selectedValueId === value.id,
      appearance: selectedValueId === value.id ? selectedButtonAppearance : "tertiary",
      onChange,
      className: value.className
    }, value.id))
  });
};

/***/ }),

/***/ 45451:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w: () => (/* binding */ TooltipSimple)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../shared/src/hooks/use-screen-width/index.ts + 2 modules
var use_screen_width = __webpack_require__(75177);
;// CONCATENATED MODULE: ../ui-kit/src/tooltip-simple/tooltip-simple.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tooltip_simple_module = ({"tooltip":"tooltip-simple-module__tooltip--pUuPb","tooltip-mobile":"tooltip-simple-module__tooltip-mobile--DKZ71","tooltipMobile":"tooltip-simple-module__tooltip-mobile--DKZ71","tail":"tooltip-simple-module__tail--DlS2n","fixed":"tooltip-simple-module__fixed--GuQDd","tail-top":"tooltip-simple-module__tail-top--fE58P","tailTop":"tooltip-simple-module__tail-top--fE58P","tail-bottom":"tooltip-simple-module__tail-bottom--NI3Ns","tailBottom":"tooltip-simple-module__tail-bottom--NI3Ns"});
;// CONCATENATED MODULE: ../ui-kit/src/tooltip-simple/tooltip-simple.tsx







const TOOLTIP_TAIL_HEIGHT = 10;
const HORIZONTAL_PADDING = 16;
const TooltipSimple = _ref => {
  let {
    className,
    tailClassName,
    children,
    targetRef,
    placement: preferredPlacement = "top",
    containerRef,
    fixed = false
  } = _ref;
  const {
    isMobile
  } = (0,use_screen_width/* useScreenWidth */.k)();
  const tooltipRef = (0,react.useRef)(null);
  const tooltipTailRef = (0,react.useRef)(null);
  const leftContainerBorder = (0,react.useMemo)(() => containerRef?.current?.getBoundingClientRect().left || 0, [containerRef]);
  const updatePosition = (0,react.useCallback)(() => {
    if (!targetRef.current || !tooltipRef.current || !tooltipTailRef.current) {
      return;
    }
    const word = targetRef.current.getBoundingClientRect();
    const tooltip = tooltipRef.current.getBoundingClientRect();
    const tooltipTail = tooltipTailRef.current.getBoundingClientRect();
    const {
      bottom,
      top,
      left,
      placement,
      tailLeft,
      tailTop
    } = (fixed ? calcFixedTooltipPosition : calcTooltipPosition)({
      word,
      tooltip,
      tooltipTail,
      leftContainerBorder,
      preferredPlacement,
      isMobile
    });
    tooltipRef.current.style.left = left;
    tooltipRef.current.style.top = top;
    tooltipRef.current.style.bottom = bottom;
    tooltipTailRef.current.style.left = tailLeft;
    tooltipTailRef.current.style.top = tailTop;
    tooltipTailRef.current.classList.toggle(tooltip_simple_module.tailTop, placement === "top");
    tooltipTailRef.current.classList.toggle(tooltip_simple_module.tailBottom, placement !== "top");
  }, [isMobile, fixed, leftContainerBorder, preferredPlacement, targetRef]);
  (0,react.useLayoutEffect)(() => {
    updatePosition();
  }, [updatePosition]);
  (0,react.useEffect)(() => {
    if (!tooltipRef.current) {
      return;
    }
    const observer = new ResizeObserver(updatePosition);
    observer.observe(tooltipRef.current);
    if (fixed) {
      addEventListener("resize", updatePosition);
      addEventListener("scroll", updatePosition);
    }
    return () => {
      observer.disconnect();
      if (fixed) {
        removeEventListener("scroll", updatePosition);
        removeEventListener("resize", updatePosition);
      }
    };
  }, [fixed, updatePosition]);
  return /* @__PURE__ */(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: tooltipTailRef,
      className: classnames_default()(tooltip_simple_module.tail, tailClassName, {
        [tooltip_simple_module.fixed]: fixed
      })
    }), /* @__PURE__ */(0,jsx_runtime.jsx)("div", {
      ref: tooltipRef,
      className: classnames_default()(tooltip_simple_module.tooltip, className, {
        [tooltip_simple_module.tooltipMobile]: isMobile,
        [tooltip_simple_module.fixed]: fixed
      }),
      children
    })]
  });
};
const calcTooltipPosition = _ref2 => {
  let {
    word,
    tooltip,
    leftContainerBorder,
    preferredPlacement
  } = _ref2;
  let left = (word.width - tooltip.width) / 2;
  if (word.left + left < leftContainerBorder + HORIZONTAL_PADDING) {
    left = leftContainerBorder + HORIZONTAL_PADDING - word.left;
  }
  if (word.left + left + tooltip.width > window.innerWidth - HORIZONTAL_PADDING) {
    left = window.innerWidth - word.left - tooltip.width - HORIZONTAL_PADDING;
  }
  let placement = preferredPlacement;
  if (word.top - tooltip.height - TOOLTIP_TAIL_HEIGHT < 0) {
    placement = "bottom";
  }
  if (word.bottom + TOOLTIP_TAIL_HEIGHT + tooltip.height > window.innerHeight) {
    placement = "top";
  }
  const offset = `${-tooltip.height - TOOLTIP_TAIL_HEIGHT}px`;
  const isPlacementTop = placement === "top";
  const tailLeft = `${word.width / 2}px`;
  return {
    placement,
    left: `${left}px`,
    top: isPlacementTop ? offset : "",
    bottom: isPlacementTop ? "" : offset,
    tailLeft,
    tailTop: ""
  };
};
const calcFixedTooltipPosition = _ref3 => {
  let {
    word,
    tooltip,
    tooltipTail,
    leftContainerBorder,
    preferredPlacement,
    isMobile
  } = _ref3;
  let left = HORIZONTAL_PADDING;
  if (!isMobile) {
    left = word.left + (word.width - tooltip.width) / 2;
    if (left < leftContainerBorder + HORIZONTAL_PADDING) {
      left = HORIZONTAL_PADDING;
    }
    if (left + tooltip.width > window.innerWidth - HORIZONTAL_PADDING) {
      left = window.innerWidth - tooltip.width - HORIZONTAL_PADDING;
    }
  }
  let placement = preferredPlacement;
  if (word.top - tooltip.height - TOOLTIP_TAIL_HEIGHT < 0) {
    placement = "bottom";
  }
  if (word.bottom + TOOLTIP_TAIL_HEIGHT + tooltip.height > window.innerHeight) {
    placement = "top";
  }
  const top = placement === "top" ? `${word.top - tooltip.height - TOOLTIP_TAIL_HEIGHT}px` : `${word.top + word.height + TOOLTIP_TAIL_HEIGHT}px`;
  return {
    placement,
    left: `${left}px`,
    top,
    bottom: "",
    tailLeft: `${word.left + word.width / 2}px`,
    tailTop: placement === "top" ? `${word.top - tooltipTail.height}px` : `${word.top + word.height}px`
  };
};

/***/ }),

/***/ 37587:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  u: () => (/* binding */ Tooltip)
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/rc-tooltip/es/index.js + 67 modules
var es = __webpack_require__(81891);
// EXTERNAL MODULE: ../shared/src/function.utils.ts
var function_utils = __webpack_require__(61297);
;// CONCATENATED MODULE: ../ui-kit/src/tooltip/tooltip.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const tooltip_module = ({"overlay":"tooltip-module__overlay--t7mWd","auto-width":"tooltip-module__auto-width--Zwct5","autoWidth":"tooltip-module__auto-width--Zwct5","small-overlay":"tooltip-module__small-overlay--pfyCw","smallOverlay":"tooltip-module__small-overlay--pfyCw","fixed-overlay":"tooltip-module__fixed-overlay--OG3h6","fixedOverlay":"tooltip-module__fixed-overlay--OG3h6"});
;// CONCATENATED MODULE: ../ui-kit/src/tooltip/tooltip.tsx








const Tooltip = _ref => {
  let {
    children,
    overlay = "",
    tooltipOverlayClassName = "",
    onVisibleChange = function_utils/* emptyFunction */.Bi,
    visible = false,
    placement,
    fixed,
    align,
    trigger = "click",
    autoWidth = false,
    smallOverlay = false,
    showArrow = true,
    ...props
  } = _ref;
  const isTextOverlay = typeof overlay === "string";
  return /* @__PURE__ */(0,jsx_runtime.jsx)(es/* default */.Z, {
    ...props,
    visible,
    onVisibleChange,
    trigger,
    overlay,
    placement,
    overlayClassName: classnames_default()(tooltip_module.overlay, tooltipOverlayClassName, {
      [tooltip_module.fixedOverlay]: fixed,
      [tooltip_module.autoWidth]: autoWidth,
      [tooltip_module.smallOverlay]: smallOverlay || isTextOverlay
    }),
    align,
    destroyTooltipOnHide: true,
    showArrow,
    children
  });
};

/***/ }),

/***/ 39910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"elements":"dropdown-output-module__elements--vZiFi","text":"dropdown-output-module__text--E0mpZ","markdown-text":"dropdown-output-module__markdown-text--JqsNc","markdownText":"dropdown-output-module__markdown-text--JqsNc","dropdown-wrapper":"dropdown-output-module__dropdown-wrapper--NpzZu","dropdownWrapper":"dropdown-output-module__dropdown-wrapper--NpzZu","sentence-text":"dropdown-output-module__sentence-text--SCCFv","sentenceText":"dropdown-output-module__sentence-text--SCCFv"});

/***/ }),

/***/ 70550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"input-wrapper":"fill-the-gap-output-module__input-wrapper--ytY5i","inputWrapper":"fill-the-gap-output-module__input-wrapper--ytY5i","feedback-text":"fill-the-gap-output-module__feedback-text--UkL_J","feedbackText":"fill-the-gap-output-module__feedback-text--UkL_J","right-answer-feedback":"fill-the-gap-output-module__right-answer-feedback--B3fcT","rightAnswerFeedback":"fill-the-gap-output-module__right-answer-feedback--B3fcT","custom-feedback-content":"fill-the-gap-output-module__custom-feedback-content--sDqV9","customFeedbackContent":"fill-the-gap-output-module__custom-feedback-content--sDqV9","feedback-content":"fill-the-gap-output-module__feedback-content--Ui4qI","feedbackContent":"fill-the-gap-output-module__feedback-content--Ui4qI","audio-button":"fill-the-gap-output-module__audio-button--eetmE","audioButton":"fill-the-gap-output-module__audio-button--eetmE","markdown-text":"fill-the-gap-output-module__markdown-text--OatSj","markdownText":"fill-the-gap-output-module__markdown-text--OatSj"});

/***/ }),

/***/ 70666:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"date-time-dropdowns":"schedule-select-time-module__date-time-dropdowns--yE9o5","dateTimeDropdowns":"schedule-select-time-module__date-time-dropdowns--yE9o5","date-time-dropdowns-disabled":"schedule-select-time-module__date-time-dropdowns-disabled--qM4Y9","dateTimeDropdownsDisabled":"schedule-select-time-module__date-time-dropdowns-disabled--qM4Y9","date-time":"schedule-select-time-module__date-time--Eq7NV","dateTime":"schedule-select-time-module__date-time--Eq7NV","date-time-row":"schedule-select-time-module__date-time-row--AeGs8","dateTimeRow":"schedule-select-time-module__date-time-row--AeGs8","date-time-row-right-space-between":"schedule-select-time-module__date-time-row-right-space-between--DJrX0","dateTimeRowRightSpaceBetween":"schedule-select-time-module__date-time-row-right-space-between--DJrX0","local-time-caption":"schedule-select-time-module__local-time-caption--swI4O","localTimeCaption":"schedule-select-time-module__local-time-caption--swI4O","month-and-day-of-week":"schedule-select-time-module__month-and-day-of-week--boyG2","monthAndDayOfWeek":"schedule-select-time-module__month-and-day-of-week--boyG2","error-text":"schedule-select-time-module__error-text--Gz4h8","errorText":"schedule-select-time-module__error-text--Gz4h8"});

/***/ }),

/***/ 70057:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"root":"task-guide-module__root--vRTmc","task-guide-container":"task-guide-module__task-guide-container--IIiEW","taskGuideContainer":"task-guide-module__task-guide-container--IIiEW","with-open-task-guide":"task-guide-module__with-open-task-guide--DpjlE","withOpenTaskGuide":"task-guide-module__with-open-task-guide--DpjlE","task-guide-container-hidden":"task-guide-module__task-guide-container-hidden--Nyo1j","taskGuideContainerHidden":"task-guide-module__task-guide-container-hidden--Nyo1j","container-children":"task-guide-module__container-children--qncUf","containerChildren":"task-guide-module__container-children--qncUf","name":"task-guide-module__name--rep7l","task":"task-guide-module__task--xDWfr","assign-self-study":"task-guide-module__assign-self-study--z7z7C","assignSelfStudy":"task-guide-module__assign-self-study--z7z7C","main-content-wrapper":"task-guide-module__main-content-wrapper--P8QEr","mainContentWrapper":"task-guide-module__main-content-wrapper--P8QEr","finish-lesson-button":"task-guide-module__finish-lesson-button--M5M1h","finishLessonButton":"task-guide-module__finish-lesson-button--M5M1h","toggle-button":"task-guide-module__toggle-button--Kssbr","toggleButton":"task-guide-module__toggle-button--Kssbr","error-block":"task-guide-module__error-block--AkJAO","errorBlock":"task-guide-module__error-block--AkJAO","task-guide-popup":"task-guide-module__task-guide-popup--Q18M2","taskGuidePopup":"task-guide-module__task-guide-popup--Q18M2","task-guide-popup-wrapper":"task-guide-module__task-guide-popup-wrapper--rCPfw","taskGuidePopupWrapper":"task-guide-module__task-guide-popup-wrapper--rCPfw","task-guide-popup-wrapper-z-index-low":"task-guide-module__task-guide-popup-wrapper-z-index-low--h1bBh","taskGuidePopupWrapperZIndexLow":"task-guide-module__task-guide-popup-wrapper-z-index-low--h1bBh","task-guide-popup-wrapper-z-index-high":"task-guide-module__task-guide-popup-wrapper-z-index-high--No3Yv","taskGuidePopupWrapperZIndexHigh":"task-guide-module__task-guide-popup-wrapper-z-index-high--No3Yv","subtitle":"task-guide-module__subtitle--VJwSb","task-guide-popup-buttons":"task-guide-module__task-guide-popup-buttons--ojJdJ","taskGuidePopupButtons":"task-guide-module__task-guide-popup-buttons--ojJdJ","task-guide-popup-buttons-row":"task-guide-module__task-guide-popup-buttons-row--NJFYL","taskGuidePopupButtonsRow":"task-guide-module__task-guide-popup-buttons-row--NJFYL","task-guide-popup-buttons-column":"task-guide-module__task-guide-popup-buttons-column--BHbrN","taskGuidePopupButtonsColumn":"task-guide-module__task-guide-popup-buttons-column--BHbrN","task-guide-popup-button":"task-guide-module__task-guide-popup-button--TiAp1","taskGuidePopupButton":"task-guide-module__task-guide-popup-button--TiAp1"});

/***/ }),

/***/ 98493:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"sr-only":"accessibility-module__sr-only--dv3wd","srOnly":"accessibility-module__sr-only--dv3wd","show-only-focused":"accessibility-module__show-only-focused--fGtec","showOnlyFocused":"accessibility-module__show-only-focused--fGtec","focus-visible":"accessibility-module__focus-visible--mCYta","focusVisible":"accessibility-module__focus-visible--mCYta","focus-visible-within":"accessibility-module__focus-visible-within--RiUvX","focusVisibleWithin":"accessibility-module__focus-visible-within--RiUvX"});

/***/ }),

/***/ 83500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"button-icon":"button-icon-module__button-icon--PoOVa","buttonIcon":"button-icon-module__button-icon--PoOVa","read-only":"button-icon-module__read-only--OJcbY","readOnly":"button-icon-module__read-only--OJcbY","button-icon-large":"button-icon-module__button-icon-large--tJnnN","buttonIconLarge":"button-icon-module__button-icon-large--tJnnN","button-icon-medium":"button-icon-module__button-icon-medium--G2HA3","buttonIconMedium":"button-icon-module__button-icon-medium--G2HA3","button-icon-small":"button-icon-module__button-icon-small--D89_t","buttonIconSmall":"button-icon-module__button-icon-small--D89_t","button-icon-tiny":"button-icon-module__button-icon-tiny--rcjfu","buttonIconTiny":"button-icon-module__button-icon-tiny--rcjfu","button-icon-default":"button-icon-module__button-icon-default--PInia","buttonIconDefault":"button-icon-module__button-icon-default--PInia","active":"button-icon-module__active--DY_A3","button-icon-primary":"button-icon-module__button-icon-primary--fAF1i","buttonIconPrimary":"button-icon-module__button-icon-primary--fAF1i","button-icon-secondary":"button-icon-module__button-icon-secondary--S7QMZ","buttonIconSecondary":"button-icon-module__button-icon-secondary--S7QMZ","secondary-hover":"button-icon-module__secondary-hover--XKUNj","secondaryHover":"button-icon-module__secondary-hover--XKUNj","button-icon-floating":"button-icon-module__button-icon-floating--zsRxP","buttonIconFloating":"button-icon-module__button-icon-floating--zsRxP","button-icon-primary-on-black":"button-icon-module__button-icon-primary-on-black--N5R5Z","buttonIconPrimaryOnBlack":"button-icon-module__button-icon-primary-on-black--N5R5Z","button-disabled":"button-icon-module__button-disabled--UWpk2","buttonDisabled":"button-icon-module__button-disabled--UWpk2","inverse-colors":"button-icon-module__inverse-colors--KWdFl","inverseColors":"button-icon-module__inverse-colors--KWdFl"});

/***/ }),

/***/ 56995:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"button":"button-module__button--_Dzo4 typography-module__body2-accent--gV8P4","button-small-circle":"button-module__button-small-circle--CVy2O typography-module__caption-accent--pNZIZ","buttonSmallCircle":"button-module__button-small-circle--CVy2O typography-module__caption-accent--pNZIZ","button-small":"button-module__button-small--HjN1e typography-module__caption-accent--pNZIZ","buttonSmall":"button-module__button-small--HjN1e typography-module__caption-accent--pNZIZ","button-disabled":"button-module__button-disabled--ho8zm","buttonDisabled":"button-module__button-disabled--ho8zm","button-loading":"button-module__button-loading--aWX6U","buttonLoading":"button-module__button-loading--aWX6U","button-read-only":"button-module__button-read-only--NatAK","buttonReadOnly":"button-module__button-read-only--NatAK","button-auto-height":"button-module__button-auto-height--bawMe","buttonAutoHeight":"button-module__button-auto-height--bawMe","button-narrow":"button-module__button-narrow--u7bLb","buttonNarrow":"button-module__button-narrow--u7bLb","button-already-selected":"button-module__button-already-selected--tGP4m","buttonAlreadySelected":"button-module__button-already-selected--tGP4m","button-primary":"button-module__button-primary--M8fM9","buttonPrimary":"button-module__button-primary--M8fM9","button-disabled-transparent":"button-module__button-disabled-transparent--P2PRX","buttonDisabledTransparent":"button-module__button-disabled-transparent--P2PRX","button-primary-on-black":"button-module__button-primary-on-black--xTB2y","buttonPrimaryOnBlack":"button-module__button-primary-on-black--xTB2y","button-secondary":"button-module__button-secondary--i5vjr","buttonSecondary":"button-module__button-secondary--i5vjr","button-secondary-activated":"button-module__button-secondary-activated--nWIyc","buttonSecondaryActivated":"button-module__button-secondary-activated--nWIyc","button-secondary-hover":"button-module__button-secondary-hover--V0f6i","buttonSecondaryHover":"button-module__button-secondary-hover--V0f6i","button-secondary-on-black":"button-module__button-secondary-on-black--Dcx0m","buttonSecondaryOnBlack":"button-module__button-secondary-on-black--Dcx0m","button-secondary-floating":"button-module__button-secondary-floating--ycujU","buttonSecondaryFloating":"button-module__button-secondary-floating--ycujU","button-tertiary":"button-module__button-tertiary--GQoHc","buttonTertiary":"button-module__button-tertiary--GQoHc","button-tertiary-on-black":"button-module__button-tertiary-on-black--ingmJ","buttonTertiaryOnBlack":"button-module__button-tertiary-on-black--ingmJ","button-green":"button-module__button-green--gHyw6","buttonGreen":"button-module__button-green--gHyw6","button-occupied":"button-module__button-occupied--Ai79r","buttonOccupied":"button-module__button-occupied--Ai79r","button-occupied-activated":"button-module__button-occupied-activated--UbSft","buttonOccupiedActivated":"button-module__button-occupied-activated--UbSft","button-active":"button-module__button-active--rB9hV","buttonActive":"button-module__button-active--rB9hV","button-red":"button-module__button-red--MZR8Z","buttonRed":"button-module__button-red--MZR8Z","hidden":"button-module__hidden--rZMJX","loader":"button-module__loader--BBVMj"});

/***/ }),

/***/ 77373:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"link":"link-rule-module__link--P7V_G","dark-mode":"link-rule-module__dark-mode--hHnDL","darkMode":"link-rule-module__dark-mode--hHnDL","link-text":"link-rule-module__link-text--D7eJb","linkText":"link-rule-module__link-text--D7eJb","external-link-icon":"link-rule-module__external-link-icon--IEinp","externalLinkIcon":"link-rule-module__external-link-icon--IEinp"});

/***/ }),

/***/ 18367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"card":"card-module__card--zHAVe","background-white":"card-module__background-white--bRggj","backgroundWhite":"card-module__background-white--bRggj","background-grey":"card-module__background-grey--rZk0J","backgroundGrey":"card-module__background-grey--rZk0J","border-none":"card-module__border-none--TeMHI","borderNone":"card-module__border-none--TeMHI","border-grey":"card-module__border-grey--bgclv","borderGrey":"card-module__border-grey--bgclv","border-green":"card-module__border-green--TaH9J","borderGreen":"card-module__border-green--TaH9J","border-red":"card-module__border-red--QvUlT","borderRed":"card-module__border-red--QvUlT","border-black":"card-module__border-black--QLwj2","borderBlack":"card-module__border-black--QLwj2","error-card":"card-module__error-card--yEvct","errorCard":"card-module__error-card--yEvct","center":"card-module__center--xklXQ","center-content":"card-module__center-content--jaO9p","centerContent":"card-module__center-content--jaO9p","small":"card-module__small--dKa_B","medium":"card-module__medium--qoRuZ","large":"card-module__large--uomAs","without-shadow":"card-module__without-shadow--Fywa_","withoutShadow":"card-module__without-shadow--Fywa_","options":"card-module__options--sHNMQ","options-with-margin":"card-module__options-with-margin--vKkKI","optionsWithMargin":"card-module__options-with-margin--vKkKI","index-floating":"card-module__index-floating--NPff3","indexFloating":"card-module__index-floating--NPff3","close":"card-module__close--Z6b8O","close-floating":"card-module__close-floating--BI9dS","closeFloating":"card-module__close-floating--BI9dS","content":"card-module__content--hJ7oG","box-card":"card-module__box-card--W5b0R","boxCard":"card-module__box-card--W5b0R","adaptive-card":"card-module__adaptive-card--nIdFR","adaptiveCard":"card-module__adaptive-card--nIdFR","small-height":"card-module__small-height--egkES","smallHeight":"card-module__small-height--egkES","pointer":"card-module__pointer--cxmYv","white-hover":"card-module__white-hover--x5rgk","whiteHover":"card-module__white-hover--x5rgk","without-padding":"card-module__without-padding--g5HPV","withoutPadding":"card-module__without-padding--g5HPV"});

/***/ }),

/***/ 11060:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"headline1":"typography-module__headline1--RoKdk","headline2":"typography-module__headline2--D4f_N","headline3":"typography-module__headline3--_hzLK","headline4":"typography-module__headline4--XnyRN","headline4-accent":"typography-module__headline4-accent--wlxGj","headline4Accent":"typography-module__headline4-accent--wlxGj","body1":"typography-module__body1--anduT","body1-accent":"typography-module__body1-accent--Bs2t2","body1Accent":"typography-module__body1-accent--Bs2t2","body2":"typography-module__body2--PZ3FP","body2-accent":"typography-module__body2-accent--gV8P4","body2Accent":"typography-module__body2-accent--gV8P4","caption":"typography-module__caption--wMHTf","caption-accent":"typography-module__caption-accent--pNZIZ","captionAccent":"typography-module__caption-accent--pNZIZ","caption-accent-italic":"typography-module__caption-accent-italic--EA6Rj","captionAccentItalic":"typography-module__caption-accent-italic--EA6Rj","headline4-mechanic":"typography-module__headline4-mechanic--PI_nV","headline4Mechanic":"typography-module__headline4-mechanic--PI_nV"});

/***/ }),

/***/ 24642:
/***/ ((module) => {

"use strict";
module.exports = ort-wasm-simd-threaded.wasm;

/***/ }),

/***/ 90795:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 95582:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 18657:
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/chunk prefetch function */
/******/ 	(() => {
/******/ 		__webpack_require__.F = {};
/******/ 		__webpack_require__.E = (chunkId) => {
/******/ 			Object.keys(__webpack_require__.F).map((key) => {
/******/ 				__webpack_require__.F[key](chunkId);
/******/ 			});
/******/ 		}
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "js/" + ({"280":"task-guide-class.tutor-content","449":"trainer-class","453":"webrtc.goloom-client","547":"checkup.goloom","571":"task-guide-class.student-content","588":"checkup.legacy","694":"choose-bank-card.carousel-touch","773":"task-guide-class","823":"choose-bank-card.carousel-desktop","866":"images-viewer"}[chunkId] || chunkId) + "." + {"280":"965109c6976b5dcf3a78","300":"27c5f3603145918d2f4b","337":"e8adf8976a0502c24769","444":"22951968b06cf19aeb5d","449":"632f0c230ed3da415179","453":"790ae42a7dea0ef7516f","465":"f6e55860a1aec01e4e12","497":"a9186002be121abc7d2c","526":"568371102d0b7096aa47","547":"71ed9c5f29acbe23a0cf","571":"1cefde4c4a14d11aba3e","588":"a59718f7cd18c4c1d1ee","597":"2224f855c5bbf4b3a806","611":"5ef83fb2caa7d787249d","682":"6f4b9ebba07a58e4c62e","694":"108ff17407c40239d3f5","773":"c9b98b094c7369abbcfe","809":"e532b1a1cfc6939cc5e2","823":"df0194af4c77c75771f8","866":"17d4cfab7270d6ed64f3","885":"b7ab865aa2f250518fd5"}[chunkId] + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "css/" + ({"280":"task-guide-class.tutor-content","449":"trainer-class","453":"webrtc.goloom-client","547":"checkup.goloom","571":"task-guide-class.student-content","588":"checkup.legacy","694":"choose-bank-card.carousel-touch","773":"task-guide-class","866":"images-viewer"}[chunkId] || chunkId) + "." + {"280":"965109c6976b5dcf3a78","449":"632f0c230ed3da415179","453":"790ae42a7dea0ef7516f","465":"f6e55860a1aec01e4e12","547":"71ed9c5f29acbe23a0cf","571":"1cefde4c4a14d11aba3e","588":"a59718f7cd18c4c1d1ee","597":"2224f855c5bbf4b3a806","694":"108ff17407c40239d3f5","773":"c9b98b094c7369abbcfe","809":"e532b1a1cfc6939cc5e2","866":"17d4cfab7270d6ed64f3"}[chunkId] + ".css";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@yandex-langly/app:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "https://flowstatic.s3.yandex.net/static/v2/production/app/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/css loading */
/******/ 	(() => {
/******/ 		if (typeof document === "undefined") return;
/******/ 		var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
/******/ 			var linkTag = document.createElement("link");
/******/ 		
/******/ 			linkTag.rel = "stylesheet";
/******/ 			linkTag.type = "text/css";
/******/ 			var onLinkComplete = (event) => {
/******/ 				// avoid mem leaks.
/******/ 				linkTag.onerror = linkTag.onload = null;
/******/ 				if (event.type === 'load') {
/******/ 					resolve();
/******/ 				} else {
/******/ 					var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 					var realHref = event && event.target && event.target.href || fullhref;
/******/ 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
/******/ 					err.code = "CSS_CHUNK_LOAD_FAILED";
/******/ 					err.type = errorType;
/******/ 					err.request = realHref;
/******/ 					if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
/******/ 					reject(err);
/******/ 				}
/******/ 			}
/******/ 			linkTag.onerror = linkTag.onload = onLinkComplete;
/******/ 			linkTag.href = fullhref;
/******/ 		
/******/ 			if (oldTag) {
/******/ 				oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
/******/ 			} else {
/******/ 				document.head.appendChild(linkTag);
/******/ 			}
/******/ 			return linkTag;
/******/ 		};
/******/ 		var findStylesheet = (href, fullhref) => {
/******/ 			var existingLinkTags = document.getElementsByTagName("link");
/******/ 			for(var i = 0; i < existingLinkTags.length; i++) {
/******/ 				var tag = existingLinkTags[i];
/******/ 				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
/******/ 				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
/******/ 			}
/******/ 			var existingStyleTags = document.getElementsByTagName("style");
/******/ 			for(var i = 0; i < existingStyleTags.length; i++) {
/******/ 				var tag = existingStyleTags[i];
/******/ 				var dataHref = tag.getAttribute("data-href");
/******/ 				if(dataHref === href || dataHref === fullhref) return tag;
/******/ 			}
/******/ 		};
/******/ 		var loadStylesheet = (chunkId) => {
/******/ 			return new Promise((resolve, reject) => {
/******/ 				var href = __webpack_require__.miniCssF(chunkId);
/******/ 				var fullhref = __webpack_require__.p + href;
/******/ 				if(findStylesheet(href, fullhref)) return resolve();
/******/ 				createStylesheet(chunkId, fullhref, null, resolve, reject);
/******/ 			});
/******/ 		}
/******/ 		// object to store loaded CSS chunks
/******/ 		var installedCssChunks = {
/******/ 			179: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.miniCss = (chunkId, promises) => {
/******/ 			var cssChunks = {"280":1,"449":1,"453":1,"465":1,"547":1,"571":1,"588":1,"597":1,"694":1,"773":1,"809":1,"866":1};
/******/ 			if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
/******/ 			else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
/******/ 				promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
/******/ 					installedCssChunks[chunkId] = 0;
/******/ 				}, (e) => {
/******/ 					delete installedCssChunks[chunkId];
/******/ 					throw e;
/******/ 				}));
/******/ 			}
/******/ 		};
/******/ 		
/******/ 		// no hmr
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		__webpack_require__.b = document.baseURI || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			179: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.F.j = (chunkId) => {
/******/ 			if((!__webpack_require__.o(installedChunks, chunkId) || installedChunks[chunkId] === undefined) && true) {
/******/ 				installedChunks[chunkId] = null;
/******/ 				var link = document.createElement('link');
/******/ 		
/******/ 				if (__webpack_require__.nc) {
/******/ 					link.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				link.rel = "prefetch";
/******/ 				link.as = "script";
/******/ 				link.href = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 				document.head.appendChild(link);
/******/ 			}
/******/ 		};
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk_yandex_langly_app"] = self["webpackChunk_yandex_langly_app"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/chunk prefetch trigger */
/******/ 	(() => {
/******/ 		var chunkToChildrenMap = {
/******/ 			"280": [
/******/ 				453
/******/ 			],
/******/ 			"449": [
/******/ 				453
/******/ 			],
/******/ 			"571": [
/******/ 				453
/******/ 			]
/******/ 		};
/******/ 		__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
/******/ 			var chunks = chunkToChildrenMap[chunkId];
/******/ 			Array.isArray(chunks) && chunks.map(__webpack_require__.E);
/******/ 		}));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/startup prefetch */
/******/ 	(() => {
/******/ 		__webpack_require__.O(0, [179], () => {
/******/ 			__webpack_require__.E(497);
/******/ 			__webpack_require__.E(866);
/******/ 		}, 5);
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [393], () => (__webpack_require__(67148)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;